module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "fb15");
/******/ })
/************************************************************************/
/******/ ({

/***/ "00ee":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};

test[TO_STRING_TAG] = 'z';

module.exports = String(test) === '[object z]';


/***/ }),

/***/ "0157":
/***/ (function(module, exports, __webpack_require__) {

var isSameHour = __webpack_require__("662a")

/**
 * @category Hour Helpers
 * @summary Is the given date in the same hour as the current date?
 *
 * @description
 * Is the given date in the same hour as the current date?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in this hour
 *
 * @example
 * // If now is 25 September 2014 18:30:15.500,
 * // is 25 September 2014 18:00:00 in this hour?
 * var result = isThisHour(new Date(2014, 8, 25, 18))
 * //=> true
 */
function isThisHour (dirtyDate) {
  return isSameHour(new Date(), dirtyDate)
}

module.exports = isThisHour


/***/ }),

/***/ "0158":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("9408");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("8ee95748", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "01ba":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><rect x=\"5\" y=\"5\" width=\"17\" height=\"17\" rx=\"1\" fill=\"#D5EAFD\" stroke=\"#079CB2\" stroke-width=\"2\"></rect><rect x=\"2\" y=\"2\" width=\"16\" height=\"16\" rx=\"1\" fill=\"white\" stroke=\"#079CB2\" stroke-width=\"2\"></rect><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M11.4985 9.25C11.4985 8.42157 10.827 7.75 9.99854 7.75C9.17012 7.75 8.49854 8.42157 8.49854 9.25V9.75C8.49854 10.5784 9.17012 11.25 9.99854 11.25C10.827 11.25 11.4985 10.5784 11.4985 9.75V9.25ZM9 12C7.89543 12 7 12.8954 7 14V15H13V14C13 12.8954 12.1046 12 11 12H9Z\" fill=\"#079CB2\"></path><path d=\"M3 4H17V6H3V4Z\" fill=\"#079CB2\"></path><path d=\"M5 3H7V5H5V3Z\" fill=\"#079CB2\"></path><path d=\"M8.99854 3H10.9985V5H8.99854V3Z\" fill=\"#079CB2\"></path></svg>";

/***/ }),

/***/ "01cc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpSingleStackBarChart_vue_vue_type_style_index_0_id_4e37b43b_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("5d1f");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpSingleStackBarChart_vue_vue_type_style_index_0_id_4e37b43b_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpSingleStackBarChart_vue_vue_type_style_index_0_id_4e37b43b_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "020a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c662cfac-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/avatar-icon/PpAvatarIcon.vue?vue&type=template&id=b11fa4ce&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-avatar',_vm._g({staticClass:"pp-avatar-icon",class:{'pp-avatar-icon--disabled' : _vm.disabled && _vm.image},attrs:{"color":_vm.avatarColor,"size":_vm.iconSize}},_vm.$listeners),[(_vm.loading)?_c('pp-loader'):(_vm.hideAvatarLetters)?_c('v-img',{attrs:{"alt":_vm.name,"src":_vm.image},on:{"error":_vm.imageError}}):_c('div',{staticClass:"pp-avatar-icon__initials text-uppercase font-weight-bold d-flex",class:("pp-avatar-icon__initials--" + _vm.size + " " + (_vm.isPractice||_vm.isUnread ? 'white--text' : 'grey--text text--darken-2')),attrs:{"aria-hidden":"true"}},[(!_vm.name)?_c('i',{staticClass:"pp-icon-patient d-inline-flex"}):[_vm._v(" "+_vm._s(_vm.initials)+" ")]],2)],1)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/avatar-icon/PpAvatarIcon.vue?vue&type=template&id=b11fa4ce&scoped=true&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("4de4");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("4160");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.index-of.js
var es_array_index_of = __webpack_require__("c975");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__("a15b");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("d81d");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__("fb6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("b0c0");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("b64b");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__("ac1f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.replace.js
var es_string_replace = __webpack_require__("5319");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.split.js
var es_string_split = __webpack_require__("1276");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.trim.js
var es_string_trim = __webpack_require__("498a");

// EXTERNAL MODULE: ./src/styles/colors.scss
var colors = __webpack_require__("1c98");
var colors_default = /*#__PURE__*/__webpack_require__.n(colors);

// EXTERNAL MODULE: ./src/components/avatar-icon/constants.js
var constants = __webpack_require__("2ee3");

// EXTERNAL MODULE: ./src/components/loader/PpLoader.vue + 4 modules
var PpLoader = __webpack_require__("d888");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/avatar-icon/PpAvatarIcon.vue?vue&type=script&lang=js&












//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var PpAvatarIconvue_type_script_lang_js_ = ({
  name: 'PpAvatarIcon',
  components: {
    'pp-loader': PpLoader["default"]
  },
  props: {
    name: {
      type: String,
      default: ''
    },

    /**
     * Breakpoint size class for avatar icon & text initials.
     * Must be one of these: xxs, xs, sm, md, lg xl, xxl
     */
    size: {
      type: String,
      default: 'lg',
      validator: function validator(value) {
        if (!value) {
          return true;
        }

        return Object.keys(constants["a" /* SIZES */]).indexOf(value) !== -1;
      }
    },

    /**
     * Image URL of avatar, will use initials of name if no image given
     */
    image: {
      type: String,
      default: ''
    },

    /**
     * Adjusts the background to teal
     */
    isPractice: {
      type: Boolean,
      default: false
    },

    /**
     * Adjusts background to blue (takes priority over isPractice or isPatient)
     */
    isUnread: {
      type: Boolean,
      default: false
    },

    /**
     * If it is false then display 2 letters initials
     */
    showOneInitial: {
      type: Boolean,
      default: false
    },

    /**
     * If image present will make the image greyscale
     */
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      isImageError: false,
      iconSizes: constants["a" /* SIZES */]
    };
  },
  computed: {
    iconSize: function iconSize() {
      return this.iconSizes[this.size];
    },
    avatarColor: function avatarColor() {
      if (this.disabled) {
        return colors_default.a.synapse4;
      }

      if (this.isUnread) {
        return colors_default.a.holistic;
      }

      if (this.isPractice) {
        return colors_default.a.growth2;
      }

      return colors_default.a.care1;
    },
    initials: function initials() {
      var initials = this.name;

      if (!initials) {
        return '';
      }

      if (this.showOneInitial) {
        return initials.charAt(0);
      } // Remove prefixes


      var prefixes = ['Dr.', 'Ms.', 'Mr.', 'Mrs.'];
      prefixes.forEach(function (prefix) {
        initials = initials.replace(prefix, '');
      }); // Remove spaces and get just first two letters

      return initials.trim().split(' ').filter(function (n) {
        return n;
      }).map(function (n) {
        return n[0];
      }).join('').slice(0, 2);
    },
    hideAvatarLetters: function hideAvatarLetters() {
      return this.image && !this.isImageError;
    }
  },
  methods: {
    imageError: function imageError() {
      this.isImageError = true;
    }
  }
});
// CONCATENATED MODULE: ./src/components/avatar-icon/PpAvatarIcon.vue?vue&type=script&lang=js&
 /* harmony default export */ var avatar_icon_PpAvatarIconvue_type_script_lang_js_ = (PpAvatarIconvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/avatar-icon/PpAvatarIcon.vue?vue&type=style&index=0&id=b11fa4ce&lang=scss&scoped=true&
var PpAvatarIconvue_type_style_index_0_id_b11fa4ce_lang_scss_scoped_true_ = __webpack_require__("48be");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// EXTERNAL MODULE: ./node_modules/vuetify-loader/lib/runtime/installComponents.js
var installComponents = __webpack_require__("6544");
var installComponents_default = /*#__PURE__*/__webpack_require__.n(installComponents);

// EXTERNAL MODULE: ./node_modules/vuetify/lib/components/VAvatar/VAvatar.js
var VAvatar = __webpack_require__("8212");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/components/VImg/VImg.js + 2 modules
var VImg = __webpack_require__("adda");

// CONCATENATED MODULE: ./src/components/avatar-icon/PpAvatarIcon.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  avatar_icon_PpAvatarIconvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "b11fa4ce",
  null
  
)

/* harmony default export */ var PpAvatarIcon = __webpack_exports__["default"] = (component.exports);

/* vuetify-loader */



installComponents_default()(component, {VAvatar: VAvatar["a" /* default */],VImg: VImg["a" /* default */]})


/***/ }),

/***/ "027e":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><rect x=\"1\" y=\"4\" width=\"22\" height=\"16\" rx=\"3\" fill=\"white\" stroke=\"#1F3A3E\" stroke-width=\"2\"></rect><rect x=\"2\" y=\"8\" width=\"20\" height=\"3\" fill=\"#DFE4E5\"></rect><rect x=\"4\" y=\"15\" width=\"6\" height=\"2\" rx=\"1\" fill=\"#1F3A3E\"></rect></svg>";

/***/ }),

/***/ "0280":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("736a");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("b2041b60", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "02f0":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("4f09");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("457c21dd", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "0366":
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__("1c0b");

// optional / simple context binding
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 0: return function () {
      return fn.call(that);
    };
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ "03ad":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpInputSelect_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("8c44");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpInputSelect_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpInputSelect_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "03e4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpInputColor_vue_vue_type_style_index_1_id_0d1c1272_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("5a63");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpInputColor_vue_vue_type_style_index_1_id_0d1c1272_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpInputColor_vue_vue_type_style_index_1_id_0d1c1272_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "0481":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var flattenIntoArray = __webpack_require__("a2bf");
var toObject = __webpack_require__("7b0b");
var toLength = __webpack_require__("50c4");
var toInteger = __webpack_require__("a691");
var arraySpeciesCreate = __webpack_require__("65f0");

// `Array.prototype.flat` method
// https://tc39.es/ecma262/#sec-array.prototype.flat
$({ target: 'Array', proto: true }, {
  flat: function flat(/* depthArg = 1 */) {
    var depthArg = arguments.length ? arguments[0] : undefined;
    var O = toObject(this);
    var sourceLen = toLength(O.length);
    var A = arraySpeciesCreate(O, 0);
    A.length = flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
    return A;
  }
});


/***/ }),

/***/ "0538":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__("1c0b");
var isObject = __webpack_require__("861d");

var slice = [].slice;
var factories = {};

var construct = function (C, argsLength, args) {
  if (!(argsLength in factories)) {
    for (var list = [], i = 0; i < argsLength; i++) list[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func
    factories[argsLength] = Function('C,a', 'return new C(' + list.join(',') + ')');
  } return factories[argsLength](C, args);
};

// `Function.prototype.bind` method implementation
// https://tc39.es/ecma262/#sec-function.prototype.bind
module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = slice.call(arguments, 1);
  var boundFunction = function bound(/* args... */) {
    var args = partArgs.concat(slice.call(arguments));
    return this instanceof boundFunction ? construct(fn, args.length, args) : fn.apply(that, args);
  };
  if (isObject(fn.prototype)) boundFunction.prototype = fn.prototype;
  return boundFunction;
};


/***/ }),

/***/ "0539":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M11.9996 18.1543L17.2921 20.9337C17.6596 21.1267 18.0888 20.8146 18.0186 20.4055L17.008 14.5196L21.2886 10.3516C21.5861 10.0619 21.4221 9.55679 21.0111 9.49714L15.0949 8.63842L12.4486 3.28234C12.2648 2.91036 11.7344 2.91036 11.5506 3.28234L8.90425 8.63842L2.98804 9.49714C2.57707 9.55679 2.41305 10.0619 2.71059 10.3516L6.99122 14.5196L5.98058 20.4055C5.91034 20.8146 6.33959 21.1267 6.70705 20.9337L11.9996 18.1543Z\" fill=\"white\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M11.9993 18.1543L6.70673 20.9337C6.33927 21.1266 5.91002 20.8146 5.98026 20.4055L6.9909 14.5196L2.71027 10.3516C2.41273 10.0619 2.57675 9.55678 2.98772 9.49713L8.90392 8.63841L11.5502 3.28233C11.734 2.91035 12.2645 2.91035 12.4483 3.28233L15.0946 8.63841L21.0108 9.49713C21.4218 9.55678 21.5858 10.0619 21.2883 10.3516L17.0076 14.5196L18.0183 20.4055C18.0885 20.8146 17.6593 21.1266 17.2918 20.9337L11.9993 18.1543ZM19.1605 15.2195L19.9927 20.0665C20.3439 22.1118 18.1977 23.6722 16.3604 22.7073L11.9993 20.4171L7.63816 22.7073C5.80086 23.6722 3.65461 22.1118 4.0058 20.0665L4.83805 15.2195L1.3127 11.787C-0.174971 10.3384 0.645106 7.81281 2.69995 7.51456L7.57422 6.80707L9.75416 2.39493C10.6731 0.53502 13.3254 0.535028 14.2444 2.39493L16.4243 6.80707L21.2986 7.51456C23.3534 7.81281 24.1735 10.3384 22.6858 11.787L19.1605 15.2195Z\" fill=\"#688083\"></path><path d=\"M11.9996 15.6793L15.0334 17.2801C15.2167 17.3768 15.4314 17.2212 15.3965 17.0169L14.8169 13.625L17.273 11.222C17.421 11.0773 17.3391 10.8258 17.1343 10.7959L13.7408 10.301L12.224 7.21637C12.1324 7.03013 11.8669 7.03012 11.7753 7.21637L10.2585 10.301L6.865 10.7959C6.66023 10.8258 6.57833 11.0773 6.72625 11.222L9.18244 13.625L8.60281 17.0169C8.56789 17.2212 8.78256 17.3768 8.96591 17.2801L11.9996 15.6793Z\" fill=\"#DFE4E5\"></path></svg>";

/***/ }),

/***/ "0569":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpIdleTime_vue_vue_type_style_index_0_id_7f0189c6_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("8d94");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpIdleTime_vue_vue_type_style_index_0_id_7f0189c6_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpIdleTime_vue_vue_type_style_index_0_id_7f0189c6_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "057f":
/***/ (function(module, exports, __webpack_require__) {

var toIndexedObject = __webpack_require__("fc6a");
var nativeGetOwnPropertyNames = __webpack_require__("241c").f;

var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return nativeGetOwnPropertyNames(it);
  } catch (error) {
    return windowNames.slice();
  }
};

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]'
    ? getWindowNames(it)
    : nativeGetOwnPropertyNames(toIndexedObject(it));
};


/***/ }),

/***/ "05cb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c662cfac-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/image/PpImage.vue?vue&type=template&id=29196306&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pp-image"},[_c('img',{staticClass:"pp-image__img rounded-lg",attrs:{"alt":_vm.name,"src":_vm.source}}),_c('div',{staticClass:"pp-image__overlay text-right pa-3"},[_c('pp-button',{staticClass:"mr-5",attrs:{"download":_vm.name,"href":_vm.source,"icon":"download","type":"secondary"}}),_c('pp-button',{attrs:{"text":"View","type":"secondary"},on:{"click":_vm.showPreview}})],1),_c('pp-dialog',{attrs:{"full-screen":true,"hide-primary-button":true,"hide-secondary-button":true,"max-width":1000,"title":_vm.name,"value":_vm.showDialog,"primary-button-text":"Download"},on:{"close":_vm.hideDialog},scopedSlots:_vm._u([{key:"body",fn:function(){return [_c('div',{staticClass:"image-zoom-area"},[_c('img',{staticClass:"image-zoom-area__img mx-auto d-block",style:(("--zoom-level:" + _vm.zoomValue)),attrs:{"alt":_vm.name,"src":_vm.source}})])]},proxy:true},{key:"secondary-action",fn:function(){return [_c('v-slider',{staticClass:"image-zoom-slider mr-auto d-flex align-center hidden-sm-and-down",attrs:{"max":10,"min":1,"step":.1,"hide-details":""},scopedSlots:_vm._u([{key:"prepend",fn:function(){return [_c('pp-button',{attrs:{"type":"icon","icon":"subtract"},on:{"click":_vm.zoomOut}})]},proxy:true},{key:"append",fn:function(){return [_c('pp-button',{attrs:{"type":"icon","icon":"plus"},on:{"click":_vm.zoomIn}})]},proxy:true}]),model:{value:(_vm.zoomValue),callback:function ($$v) {_vm.zoomValue=$$v},expression:"zoomValue"}}),_c('pp-button',{attrs:{"download":_vm.name,"href":_vm.source,"text":"Download","type":"primary"}})]},proxy:true}])})],1)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/image/PpImage.vue?vue&type=template&id=29196306&scoped=true&

// EXTERNAL MODULE: ./src/components/button/PpButton.vue + 5 modules
var PpButton = __webpack_require__("251c");

// EXTERNAL MODULE: ./src/components/dialog/PpDialog.vue + 5 modules
var PpDialog = __webpack_require__("bdf9");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/image/PpImage.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var PpImagevue_type_script_lang_js_ = ({
  name: 'PpImage',
  components: {
    'pp-button': PpButton["default"],
    'pp-dialog': PpDialog["default"]
  },
  props: {
    /** The source of the image */
    source: {
      type: String,
      required: true
    },

    /** Name of the image */
    name: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      showDialog: false,
      zoomValue: 1
    };
  },
  methods: {
    showPreview: function showPreview() {
      this.showDialog = true;
    },
    zoomIn: function zoomIn() {
      this.zoomValue++;
    },
    zoomOut: function zoomOut() {
      this.zoomValue--;
    },
    hideDialog: function hideDialog() {
      this.zoomValue = 1;
      this.showDialog = false;
    }
  }
});
// CONCATENATED MODULE: ./src/components/image/PpImage.vue?vue&type=script&lang=js&
 /* harmony default export */ var image_PpImagevue_type_script_lang_js_ = (PpImagevue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/image/PpImage.vue?vue&type=style&index=0&id=29196306&lang=scss&scoped=true&
var PpImagevue_type_style_index_0_id_29196306_lang_scss_scoped_true_ = __webpack_require__("fcdc");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// EXTERNAL MODULE: ./node_modules/vuetify-loader/lib/runtime/installComponents.js
var installComponents = __webpack_require__("6544");
var installComponents_default = /*#__PURE__*/__webpack_require__.n(installComponents);

// EXTERNAL MODULE: ./node_modules/vuetify/lib/components/VSlider/VSlider.js
var VSlider = __webpack_require__("ba0d");

// CONCATENATED MODULE: ./src/components/image/PpImage.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  image_PpImagevue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "29196306",
  null
  
)

/* harmony default export */ var PpImage = __webpack_exports__["default"] = (component.exports);

/* vuetify-loader */


installComponents_default()(component, {VSlider: VSlider["a" /* default */]})


/***/ }),

/***/ "062a":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.v-avatar{align-items:center;border-radius:50%;display:inline-flex;justify-content:center;line-height:normal;position:relative;text-align:center;vertical-align:middle;overflow:hidden}.v-avatar .v-icon,.v-avatar .v-image,.v-avatar .v-responsive__content,.v-avatar img,.v-avatar svg{border-radius:inherit;display:inline-flex;height:inherit;width:inherit}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "06c5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _unsupportedIterableToArray; });
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("a630");
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("fb6a");
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("b0c0");
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("d3b7");
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("25f0");
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("3ca3");
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_esm_arrayLikeToArray__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("6b75");







function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return Object(_babel_runtime_helpers_esm_arrayLikeToArray__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Object(_babel_runtime_helpers_esm_arrayLikeToArray__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])(o, minLen);
}

/***/ }),

/***/ "06cf":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var propertyIsEnumerableModule = __webpack_require__("d1e7");
var createPropertyDescriptor = __webpack_require__("5c6c");
var toIndexedObject = __webpack_require__("fc6a");
var toPrimitive = __webpack_require__("c04e");
var has = __webpack_require__("5135");
var IE8_DOM_DEFINE = __webpack_require__("0cfb");

var nativeGetOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
exports.f = DESCRIPTORS ? nativeGetOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return nativeGetOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (has(O, P)) return createPropertyDescriptor(!propertyIsEnumerableModule.f.call(O, P), O[P]);
};


/***/ }),

/***/ "06e8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c662cfac-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/panel/PpPanel.vue?vue&type=template&id=bcc9c6b0&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pp-panel pa-5 rounded-lg"},[(_vm.title)?_c('div',{staticClass:"d-block text-h2 pb-5"},[_vm._v(" "+_vm._s(_vm.title)+" "),(_vm.subtitle)?_c('div',{staticClass:"pp-panel__subtitle d-inline text-body-1 py-0 pl-5"},[_vm._v(" "+_vm._s(_vm.subtitle)+" ")]):_vm._e()]):_vm._e(),_vm._t("body")],2)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/panel/PpPanel.vue?vue&type=template&id=bcc9c6b0&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/panel/PpPanel.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * Create a display panel with a background
 */
/* harmony default export */ var PpPanelvue_type_script_lang_js_ = ({
  name: 'PpPanel',
  props: {
    title: {
      type: String,
      default: ''
    },
    subtitle: {
      type: String,
      default: ''
    }
  }
});
// CONCATENATED MODULE: ./src/components/panel/PpPanel.vue?vue&type=script&lang=js&
 /* harmony default export */ var panel_PpPanelvue_type_script_lang_js_ = (PpPanelvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/panel/PpPanel.vue?vue&type=style&index=0&id=bcc9c6b0&lang=scss&scoped=true&
var PpPanelvue_type_style_index_0_id_bcc9c6b0_lang_scss_scoped_true_ = __webpack_require__("3709");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/panel/PpPanel.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  panel_PpPanelvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "bcc9c6b0",
  null
  
)

/* harmony default export */ var PpPanel = __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "0784":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpMultiCard_vue_vue_type_style_index_0_id_74fb8428_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ec3f");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpMultiCard_vue_vue_type_style_index_0_id_74fb8428_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpMultiCard_vue_vue_type_style_index_0_id_74fb8428_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "0789":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "c", function() { return /* binding */ VFabTransition; });
__webpack_require__.d(__webpack_exports__, "d", function() { return /* binding */ VFadeTransition; });
__webpack_require__.d(__webpack_exports__, "e", function() { return /* binding */ VScaleTransition; });
__webpack_require__.d(__webpack_exports__, "f", function() { return /* binding */ VSlideXTransition; });
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ VExpandTransition; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* binding */ VExpandXTransition; });

// UNUSED EXPORTS: VCarouselTransition, VCarouselReverseTransition, VTabTransition, VTabReverseTransition, VMenuTransition, VDialogTransition, VDialogBottomTransition, VDialogTopTransition, VScrollXTransition, VScrollXReverseTransition, VScrollYTransition, VScrollYReverseTransition, VSlideXReverseTransition, VSlideYTransition, VSlideYReverseTransition

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("99af");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/util/mergeData.js
var mergeData = __webpack_require__("d9f7");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/transitions/createTransition.js



function mergeTransitions() {
  var _Array;

  var dest = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  for (var _len = arguments.length, transitions = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    transitions[_key - 1] = arguments[_key];
  }

  /* eslint-disable-next-line no-array-constructor */
  return (_Array = Array()).concat.apply(_Array, [dest].concat(transitions));
}

function createSimpleTransition(name) {
  var origin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top center 0';
  var mode = arguments.length > 2 ? arguments[2] : undefined;
  return {
    name: name,
    functional: true,
    props: {
      group: {
        type: Boolean,
        default: false
      },
      hideOnLeave: {
        type: Boolean,
        default: false
      },
      leaveAbsolute: {
        type: Boolean,
        default: false
      },
      mode: {
        type: String,
        default: mode
      },
      origin: {
        type: String,
        default: origin
      }
    },
    render: function render(h, context) {
      var tag = "transition".concat(context.props.group ? '-group' : '');
      var data = {
        props: {
          name: name,
          mode: context.props.mode
        },
        on: {
          beforeEnter: function beforeEnter(el) {
            el.style.transformOrigin = context.props.origin;
            el.style.webkitTransformOrigin = context.props.origin;
          }
        }
      };

      if (context.props.leaveAbsolute) {
        data.on.leave = mergeTransitions(data.on.leave, function (el) {
          return el.style.position = 'absolute';
        });
      }

      if (context.props.hideOnLeave) {
        data.on.leave = mergeTransitions(data.on.leave, function (el) {
          return el.style.display = 'none';
        });
      }

      return h(tag, Object(mergeData["a" /* default */])(context.data, data), context.children);
    }
  };
}
function createJavascriptTransition(name, functions) {
  var mode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'in-out';
  return {
    name: name,
    functional: true,
    props: {
      mode: {
        type: String,
        default: mode
      }
    },
    render: function render(h, context) {
      return h('transition', Object(mergeData["a" /* default */])(context.data, {
        props: {
          name: name
        },
        on: functions
      }), context.children);
    }
  };
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("ade3");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/util/helpers.js
var helpers = __webpack_require__("80d2");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/transitions/expand-transition.js


/* harmony default export */ var expand_transition = (function () {
  var expandedParentClass = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var x = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var sizeProperty = x ? 'width' : 'height';
  var offsetProperty = "offset".concat(Object(helpers["G" /* upperFirst */])(sizeProperty));
  return {
    beforeEnter: function beforeEnter(el) {
      el._parent = el.parentNode;
      el._initialStyle = Object(defineProperty["a" /* default */])({
        transition: el.style.transition,
        overflow: el.style.overflow
      }, sizeProperty, el.style[sizeProperty]);
    },
    enter: function enter(el) {
      var initialStyle = el._initialStyle;
      el.style.setProperty('transition', 'none', 'important'); // Hide overflow to account for collapsed margins in the calculated height

      el.style.overflow = 'hidden';
      var offset = "".concat(el[offsetProperty], "px");
      el.style[sizeProperty] = '0';
      void el.offsetHeight; // force reflow

      el.style.transition = initialStyle.transition;

      if (expandedParentClass && el._parent) {
        el._parent.classList.add(expandedParentClass);
      }

      requestAnimationFrame(function () {
        el.style[sizeProperty] = offset;
      });
    },
    afterEnter: resetStyles,
    enterCancelled: resetStyles,
    leave: function leave(el) {
      el._initialStyle = Object(defineProperty["a" /* default */])({
        transition: '',
        overflow: el.style.overflow
      }, sizeProperty, el.style[sizeProperty]);
      el.style.overflow = 'hidden';
      el.style[sizeProperty] = "".concat(el[offsetProperty], "px");
      void el.offsetHeight; // force reflow

      requestAnimationFrame(function () {
        return el.style[sizeProperty] = '0';
      });
    },
    afterLeave: afterLeave,
    leaveCancelled: afterLeave
  };

  function afterLeave(el) {
    if (expandedParentClass && el._parent) {
      el._parent.classList.remove(expandedParentClass);
    }

    resetStyles(el);
  }

  function resetStyles(el) {
    var size = el._initialStyle[sizeProperty];
    el.style.overflow = el._initialStyle.overflow;
    if (size != null) el.style[sizeProperty] = size;
    delete el._initialStyle;
  }
});
// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/transitions/index.js

 // Component specific transitions

var VCarouselTransition = createSimpleTransition('carousel-transition');
var VCarouselReverseTransition = createSimpleTransition('carousel-reverse-transition');
var VTabTransition = createSimpleTransition('tab-transition');
var VTabReverseTransition = createSimpleTransition('tab-reverse-transition');
var VMenuTransition = createSimpleTransition('menu-transition');
var VFabTransition = createSimpleTransition('fab-transition', 'center center', 'out-in'); // Generic transitions

var VDialogTransition = createSimpleTransition('dialog-transition');
var VDialogBottomTransition = createSimpleTransition('dialog-bottom-transition');
var VDialogTopTransition = createSimpleTransition('dialog-top-transition');
var VFadeTransition = createSimpleTransition('fade-transition');
var VScaleTransition = createSimpleTransition('scale-transition');
var VScrollXTransition = createSimpleTransition('scroll-x-transition');
var VScrollXReverseTransition = createSimpleTransition('scroll-x-reverse-transition');
var VScrollYTransition = createSimpleTransition('scroll-y-transition');
var VScrollYReverseTransition = createSimpleTransition('scroll-y-reverse-transition');
var VSlideXTransition = createSimpleTransition('slide-x-transition');
var VSlideXReverseTransition = createSimpleTransition('slide-x-reverse-transition');
var VSlideYTransition = createSimpleTransition('slide-y-transition');
var VSlideYReverseTransition = createSimpleTransition('slide-y-reverse-transition'); // Javascript transitions

var VExpandTransition = createJavascriptTransition('expand-transition', expand_transition());
var VExpandXTransition = createJavascriptTransition('expand-x-transition', expand_transition('', true));
/* harmony default export */ var transitions = ({
  $_vuetify_subcomponents: {
    VCarouselTransition: VCarouselTransition,
    VCarouselReverseTransition: VCarouselReverseTransition,
    VDialogTransition: VDialogTransition,
    VDialogBottomTransition: VDialogBottomTransition,
    VDialogTopTransition: VDialogTopTransition,
    VFabTransition: VFabTransition,
    VFadeTransition: VFadeTransition,
    VMenuTransition: VMenuTransition,
    VScaleTransition: VScaleTransition,
    VScrollXTransition: VScrollXTransition,
    VScrollXReverseTransition: VScrollXReverseTransition,
    VScrollYTransition: VScrollYTransition,
    VScrollYReverseTransition: VScrollYReverseTransition,
    VSlideXTransition: VSlideXTransition,
    VSlideXReverseTransition: VSlideXReverseTransition,
    VSlideYTransition: VSlideYTransition,
    VSlideYReverseTransition: VSlideYReverseTransition,
    VTabReverseTransition: VTabReverseTransition,
    VTabTransition: VTabTransition,
    VExpandTransition: VExpandTransition,
    VExpandXTransition: VExpandXTransition
  }
});

/***/ }),

/***/ "07ac":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var $values = __webpack_require__("6f53").values;

// `Object.values` method
// https://tc39.es/ecma262/#sec-object.values
$({ target: 'Object', stat: true }, {
  values: function values(O) {
    return $values(O);
  }
});


/***/ }),

/***/ "07bf":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("37da");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("a4f899c8", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "0830":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.v-color-picker__canvas{position:relative;overflow:hidden;contain:strict}.v-color-picker__canvas-dot{position:absolute;top:0;left:0;width:15px;height:15px;background:transparent;border-radius:50%;box-shadow:0 0 0 1.5px #fff,inset 0 0 1px 1.5px rgba(0,0,0,.3)}.v-color-picker__canvas-dot--disabled{box-shadow:0 0 0 1.5px hsla(0,0%,100%,.7),inset 0 0 1px 1.5px rgba(0,0,0,.3)}.v-color-picker__canvas:hover .v-color-picker__canvas-dot{will-change:transform}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "0834":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><rect x=\"4\" y=\"5\" width=\"16\" height=\"3\" fill=\"#D5EAFD\"></rect><rect x=\"4\" y=\"10\" width=\"16\" height=\"10\" fill=\"white\"></rect><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8 5C8 5.55228 7.55228 6 7 6C6.44772 6 6 5.55228 6 5H4V8H20V5H18C18 5.55228 17.5523 6 17 6C16.4477 6 16 5.55228 16 5H8ZM20 10H4V20H20V10ZM18 3C18 2.44772 17.5523 2 17 2C16.4477 2 16 2.44772 16 3H8C8 2.44772 7.55228 2 7 2C6.44772 2 6 2.44772 6 3H4C2.89543 3 2 3.89543 2 5V20C2 21.1046 2.89543 22 4 22H20C21.1046 22 22 21.1046 22 20V5C22 3.89543 21.1046 3 20 3H18ZM7 14V12H9V14H7ZM11 14H13V12H11V14ZM15 14V12H17V14H15ZM7 16V18H9V16H7ZM13 18H11V16H13V18Z\" fill=\"#079CB2\"></path></svg>";

/***/ }),

/***/ "0918":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("ae05");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("0cc2b594", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "0968":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("3e35");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("326a1ce0", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "0978":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("c8d5")

/**
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of a day
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * var result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */
function startOfDay (dirtyDate) {
  var date = parse(dirtyDate)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = startOfDay


/***/ }),

/***/ "09f6":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.v-menu{display:none}.v-menu--attached{display:inline}.v-menu__content{position:absolute;display:inline-block;max-width:80%;overflow-y:auto;overflow-x:hidden;contain:content;will-change:transform;box-shadow:0 5px 5px -3px transparent,0 8px 10px 1px transparent,0 3px 14px 2px rgba(0,0,0,.12);border-radius:5px}.v-menu__content--active{pointer-events:none}.v-menu__content--auto .v-list-item{transition-property:transform,opacity;transition-duration:.3s;transition-timing-function:cubic-bezier(.25,.8,.25,1)}.v-menu__content--fixed{position:fixed}.v-menu__content>.card{contain:content;-webkit-backface-visibility:hidden;backface-visibility:hidden}.v-menu>.v-menu__content{max-width:none}.v-menu-transition-enter .v-list-item{min-width:0;pointer-events:none}.v-menu-transition-enter-to .v-list-item{transition-delay:.1s}.v-menu-transition-leave-active,.v-menu-transition-leave-to{pointer-events:none}.v-menu-transition-enter,.v-menu-transition-leave-to{opacity:0}.v-menu-transition-enter-active,.v-menu-transition-leave-active{transition:all .3s cubic-bezier(.25,.8,.25,1)}.v-menu-transition-enter.v-menu__content--auto{transition:none!important}.v-menu-transition-enter.v-menu__content--auto .v-list-item{opacity:0;transform:translateY(-15px)}.v-menu-transition-enter.v-menu__content--auto .v-list-item--active{opacity:1;transform:none!important;pointer-events:auto}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "0a90":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpCalendarNav_vue_vue_type_style_index_0_id_595f5f79_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("77ff");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpCalendarNav_vue_vue_type_style_index_0_id_595f5f79_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpCalendarNav_vue_vue_type_style_index_0_id_595f5f79_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "0b4c":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.v-progress-circular{position:relative;display:inline-flex;vertical-align:middle;justify-content:center;align-items:center}.v-progress-circular>svg{width:100%;height:100%;margin:auto;position:absolute;top:0;bottom:0;left:0;right:0;z-index:0}.v-progress-circular--indeterminate>svg{-webkit-animation:progress-circular-rotate 1.4s linear infinite;animation:progress-circular-rotate 1.4s linear infinite;transform-origin:center center;transition:all .2s ease-in-out}.v-progress-circular--indeterminate .v-progress-circular__overlay{-webkit-animation:progress-circular-dash 1.4s ease-in-out infinite;animation:progress-circular-dash 1.4s ease-in-out infinite;stroke-linecap:round;stroke-dasharray:80,200;stroke-dashoffset:0px}.v-progress-circular__info{align-items:center;display:flex;justify-content:center}.v-progress-circular__underlay{stroke:hsla(0,0%,60.4%,.4);z-index:1}.v-progress-circular__overlay{stroke:currentColor;z-index:2;transition:all .6s ease-in-out}@-webkit-keyframes progress-circular-dash{0%{stroke-dasharray:1,200;stroke-dashoffset:0px}50%{stroke-dasharray:100,200;stroke-dashoffset:-15px}to{stroke-dasharray:100,200;stroke-dashoffset:-125px}}@keyframes progress-circular-dash{0%{stroke-dasharray:1,200;stroke-dashoffset:0px}50%{stroke-dasharray:100,200;stroke-dashoffset:-15px}to{stroke-dasharray:100,200;stroke-dashoffset:-125px}}@-webkit-keyframes progress-circular-rotate{to{transform:rotate(1turn)}}@keyframes progress-circular-rotate{to{transform:rotate(1turn)}}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "0bc6":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("52b4");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("0b8deffe", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "0c25":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpRichTextEditor_vue_vue_type_style_index_1_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("9134");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpRichTextEditor_vue_vue_type_style_index_1_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpRichTextEditor_vue_vue_type_style_index_1_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "0cb2":
/***/ (function(module, exports, __webpack_require__) {

var toObject = __webpack_require__("7b0b");

var floor = Math.floor;
var replace = ''.replace;
var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d\d?)/g;

// https://tc39.es/ecma262/#sec-getsubstitution
module.exports = function (matched, str, position, captures, namedCaptures, replacement) {
  var tailPos = position + matched.length;
  var m = captures.length;
  var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
  if (namedCaptures !== undefined) {
    namedCaptures = toObject(namedCaptures);
    symbols = SUBSTITUTION_SYMBOLS;
  }
  return replace.call(replacement, symbols, function (match, ch) {
    var capture;
    switch (ch.charAt(0)) {
      case '$': return '$';
      case '&': return matched;
      case '`': return str.slice(0, position);
      case "'": return str.slice(tailPos);
      case '<':
        capture = namedCaptures[ch.slice(1, -1)];
        break;
      default: // \d\d?
        var n = +ch;
        if (n === 0) return match;
        if (n > m) {
          var f = floor(n / 10);
          if (f === 0) return match;
          if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
          return match;
        }
        capture = captures[n - 1];
    }
    return capture === undefined ? '' : capture;
  });
};


/***/ }),

/***/ "0cc0":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.i, "@import url(https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css);"]);
exports.push([module.i, "@import url(https://cdn-prd.patientpop.com/pp-icon-font/v1.6.0/pp-icon-font.css);"]);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.pp-check-list[data-v-f6ec1c2a]{list-style:none}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "0ccb":
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-string-pad-start-end
var toLength = __webpack_require__("50c4");
var repeat = __webpack_require__("1148");
var requireObjectCoercible = __webpack_require__("1d80");

var ceil = Math.ceil;

// `String.prototype.{ padStart, padEnd }` methods implementation
var createMethod = function (IS_END) {
  return function ($this, maxLength, fillString) {
    var S = String(requireObjectCoercible($this));
    var stringLength = S.length;
    var fillStr = fillString === undefined ? ' ' : String(fillString);
    var intMaxLength = toLength(maxLength);
    var fillLen, stringFiller;
    if (intMaxLength <= stringLength || fillStr == '') return S;
    fillLen = intMaxLength - stringLength;
    stringFiller = repeat.call(fillStr, ceil(fillLen / fillStr.length));
    if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
    return IS_END ? S + stringFiller : stringFiller + S;
  };
};

module.exports = {
  // `String.prototype.padStart` method
  // https://tc39.es/ecma262/#sec-string.prototype.padstart
  start: createMethod(false),
  // `String.prototype.padEnd` method
  // https://tc39.es/ecma262/#sec-string.prototype.padend
  end: createMethod(true)
};


/***/ }),

/***/ "0cfb":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var fails = __webpack_require__("d039");
var createElement = __webpack_require__("cc12");

// Thank's IE8 for his funny defineProperty
module.exports = !DESCRIPTORS && !fails(function () {
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});


/***/ }),

/***/ "0d24":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.i, "@import url(https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css);"]);
exports.push([module.i, "@import url(https://cdn-prd.patientpop.com/pp-icon-font/v1.6.0/pp-icon-font.css);"]);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.input-time[data-v-3acf988e]{flex-basis:100px;flex-grow:1}.time-range[data-v-3acf988e]{display:flex;flex-flow:row}.time-range__time[data-v-3acf988e]{width:100%}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "0d3b":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");
var wellKnownSymbol = __webpack_require__("b622");
var IS_PURE = __webpack_require__("c430");

var ITERATOR = wellKnownSymbol('iterator');

module.exports = !fails(function () {
  var url = new URL('b?a=1&b=2&c=3', 'http://a');
  var searchParams = url.searchParams;
  var result = '';
  url.pathname = 'c%20d';
  searchParams.forEach(function (value, key) {
    searchParams['delete']('b');
    result += key + value;
  });
  return (IS_PURE && !url.toJSON)
    || !searchParams.sort
    || url.href !== 'http://a/c%20d?a=1&c=3'
    || searchParams.get('c') !== '3'
    || String(new URLSearchParams('?a=1')) !== 'a=1'
    || !searchParams[ITERATOR]
    // throws in Edge
    || new URL('https://a@b').username !== 'a'
    || new URLSearchParams(new URLSearchParams('a=b')).get('a') !== 'b'
    // not punycoded in Edge
    || new URL('http://тест').host !== 'xn--e1aybc'
    // not escaped in Chrome 62-
    || new URL('http://a#б').hash !== '#%D0%B1'
    // fails in Chrome 66-
    || result !== 'a1c3'
    // throws in Safari
    || new URL('http://x', undefined).host !== 'x';
});


/***/ }),

/***/ "0d3e":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("c8d5")

/**
 * @category Common Helpers
 * @summary Compare the two dates and return -1, 0 or 1.
 *
 * @description
 * Compare the two dates and return 1 if the first date is after the second,
 * -1 if the first date is before the second or 0 if dates are equal.
 *
 * @param {Date|String|Number} dateLeft - the first date to compare
 * @param {Date|String|Number} dateRight - the second date to compare
 * @returns {Number} the result of the comparison
 *
 * @example
 * // Compare 11 February 1987 and 10 July 1989:
 * var result = compareAsc(
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * )
 * //=> -1
 *
 * @example
 * // Sort the array of dates:
 * var result = [
 *   new Date(1995, 6, 2),
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * ].sort(compareAsc)
 * //=> [
 * //   Wed Feb 11 1987 00:00:00,
 * //   Mon Jul 10 1989 00:00:00,
 * //   Sun Jul 02 1995 00:00:00
 * // ]
 */
function compareAsc (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var timeLeft = dateLeft.getTime()
  var dateRight = parse(dirtyDateRight)
  var timeRight = dateRight.getTime()

  if (timeLeft < timeRight) {
    return -1
  } else if (timeLeft > timeRight) {
    return 1
  } else {
    return 0
  }
}

module.exports = compareAsc


/***/ }),

/***/ "0d59":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpSideNav_vue_vue_type_style_index_0_id_6534d2f9_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ad51");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpSideNav_vue_vue_type_style_index_0_id_6534d2f9_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpSideNav_vue_vue_type_style_index_0_id_6534d2f9_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "0d7d":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.i, "@import url(https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css);"]);
exports.push([module.i, "@import url(https://cdn-prd.patientpop.com/pp-icon-font/v1.6.0/pp-icon-font.css);"]);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.pp-single-stack-bar-chart[data-v-4e37b43b]{border-radius:3px;height:.875rem;overflow:hidden}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "0dac":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.theme--light.v-navigation-drawer{background-color:#fff}.theme--light.v-navigation-drawer:not(.v-navigation-drawer--floating) .v-navigation-drawer__border{background-color:#d6d6d6}.theme--light.v-navigation-drawer .v-divider{border-color:#d6d6d6}.theme--dark.v-navigation-drawer{background-color:#363636}.theme--dark.v-navigation-drawer:not(.v-navigation-drawer--floating) .v-navigation-drawer__border{background-color:hsla(0,0%,100%,.12)}.theme--dark.v-navigation-drawer .v-divider{border-color:hsla(0,0%,100%,.12)}.v-navigation-drawer{-webkit-overflow-scrolling:touch;display:flex;flex-direction:column;left:0;max-width:100%;overflow:hidden;pointer-events:auto;top:0;transition-duration:.2s;transition-timing-function:cubic-bezier(.4,0,.2,1);will-change:transform;transition-property:transform,visibility,width}.v-navigation-drawer:not([data-booted=true]){transition:none!important}.v-navigation-drawer.v-navigation-drawer--right:after{left:0;right:auto}.v-navigation-drawer .v-list:not(.v-select-list){background:inherit}.v-navigation-drawer__border{position:absolute;right:0;top:0;height:100%;width:1px}.v-navigation-drawer__content{height:100%;overflow-y:auto;overflow-x:hidden}.v-navigation-drawer__image{border-radius:inherit;height:100%;position:absolute;top:0;bottom:0;z-index:-1;contain:strict;width:100%}.v-navigation-drawer__image .v-image{border-radius:inherit}.v-navigation-drawer--bottom.v-navigation-drawer--is-mobile{max-height:50%;top:auto;bottom:0;min-width:100%}.v-navigation-drawer--right{left:auto;right:0}.v-navigation-drawer--right>.v-navigation-drawer__border{right:auto;left:0}.v-navigation-drawer--absolute{z-index:1}.v-navigation-drawer--fixed{z-index:6}.v-navigation-drawer--absolute{position:absolute}.v-navigation-drawer--clipped:not(.v-navigation-drawer--temporary):not(.v-navigation-drawer--is-mobile){z-index:4}.v-navigation-drawer--fixed{position:fixed}.v-navigation-drawer--floating:after{display:none}.v-navigation-drawer--mini-variant{overflow:hidden}.v-navigation-drawer--mini-variant .v-list-item>:first-child{margin-left:0;margin-right:0}.v-navigation-drawer--mini-variant .v-list-item>:not(:first-child){position:absolute!important;height:1px;width:1px;overflow:hidden;clip:rect(1px,1px,1px,1px);white-space:nowrap;display:initial}.v-navigation-drawer--mini-variant .v-list-group--no-action .v-list-group__items,.v-navigation-drawer--mini-variant .v-list-group--sub-group{display:none}.v-navigation-drawer--mini-variant.v-navigation-drawer--custom-mini-variant .v-list-item{justify-content:center}.v-navigation-drawer--temporary{z-index:7}.v-navigation-drawer--mobile{z-index:6}.v-navigation-drawer--close{visibility:hidden}.v-navigation-drawer--is-mobile:not(.v-navigation-drawer--close),.v-navigation-drawer--temporary:not(.v-navigation-drawer--close){box-shadow:0 8px 10px -5px transparent,0 16px 24px 2px transparent,0 6px 30px 5px rgba(0,0,0,.12)}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "0e90":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.theme--light.v-label{color:var(--pp-text-secondary,#2b2b2b)}.theme--light.v-label--is-disabled{color:var(--pp-text-disabled,#f6f6f6)}.theme--dark.v-label{color:hsla(0,0%,100%,.7)}.theme--dark.v-label--is-disabled{color:hsla(0,0%,100%,.5)}.v-label{font-size:14px;line-height:1;min-height:8px;transition:.3s cubic-bezier(.25,.8,.5,1)}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "0ea5":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M3 3H21V15H17L15 16L12 18.5L9 16L6.5 15H3V3Z\" fill=\"#DFE4E5\"></path><path d=\"M8 15H4L3 16V20L4 21H20L21 20V16L20 15H16L14 17L12 18L10 17L8 15Z\" fill=\"white\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2 4.82C2 3.2615 3.12 2 4.5035 2H19.4965C20.878 2 22 3.265 22 4.82V19.18C22 20.7385 20.88 22 19.4965 22H4.5035C3.122 22 2 20.735 2 19.18V4.82ZM16.4985 16C16.1015 16 15.6005 16.361 15.475 16.737L15.4225 16.8955C15.0245 18.0885 13.7595 19 12.5015 19H11.4985C10.2405 19 8.9755 18.0885 8.5775 16.895L8.525 16.737C8.3995 16.361 7.899 16 7.5015 16H4V19.4985C4 19.776 4.225 20 4.5035 20H19.4965C19.776 20 20 19.776 20 19.4985V16H16.4985ZM20 14V4.5C20 4.2265 19.7735 4 19.4965 4H4.5035C4.43755 3.99954 4.37215 4.01213 4.31108 4.03705C4.25002 4.06197 4.19448 4.09873 4.14768 4.1452C4.10088 4.19168 4.06374 4.24695 4.03839 4.30785C4.01305 4.36874 4 4.43404 4 4.5V14H7.5015C8.7595 14 10.0245 14.9115 10.4225 16.105L10.475 16.263C10.6005 16.639 11.1015 17 11.4985 17H12.5015C12.899 17 13.3995 16.639 13.525 16.263L13.5775 16.1045C13.9755 14.9115 15.2405 14 16.4985 14H20ZM8.5 8.5C8.23478 8.5 7.98043 8.39464 7.79289 8.20711C7.60536 8.01957 7.5 7.76522 7.5 7.5C7.5 7.23478 7.60536 6.98043 7.79289 6.79289C7.98043 6.60536 8.23478 6.5 8.5 6.5H15.5C15.7652 6.5 16.0196 6.60536 16.2071 6.79289C16.3946 6.98043 16.5 7.23478 16.5 7.5C16.5 7.76522 16.3946 8.01957 16.2071 8.20711C16.0196 8.39464 15.7652 8.5 15.5 8.5H8.5ZM8.5 11.5C8.23478 11.5 7.98043 11.3946 7.79289 11.2071C7.60536 11.0196 7.5 10.7652 7.5 10.5C7.5 10.2348 7.60536 9.98043 7.79289 9.79289C7.98043 9.60536 8.23478 9.5 8.5 9.5H15.5C15.7652 9.5 16.0196 9.60536 16.2071 9.79289C16.3946 9.98043 16.5 10.2348 16.5 10.5C16.5 10.7652 16.3946 11.0196 16.2071 11.2071C16.0196 11.3946 15.7652 11.5 15.5 11.5H8.5Z\" fill=\"#1F3A3E\"></path></svg>";

/***/ }),

/***/ "0fd9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("99af");
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("4160");
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("caad");
/* harmony import */ var core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("e260");
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_reduce_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("13d5");
/* harmony import */ var core_js_modules_es_array_reduce_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_map_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("4ec9");
/* harmony import */ var core_js_modules_es_map_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_map_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("b64b");
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("d3b7");
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("ac1f");
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("2532");
/* harmony import */ var core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("3ca3");
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("5319");
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("159b");
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("ddb0");
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("ade3");
/* harmony import */ var _home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("5530");
/* harmony import */ var _src_components_VGrid_VGrid_sass__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("4b85");
/* harmony import */ var _src_components_VGrid_VGrid_sass__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(_src_components_VGrid_VGrid_sass__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("8bbf");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _util_mergeData__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("d9f7");
/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("80d2");



















 // no xs

var breakpoints = ['sm', 'md', 'lg', 'xl'];
var ALIGNMENT = ['start', 'end', 'center'];

function makeProps(prefix, def) {
  return breakpoints.reduce(function (props, val) {
    props[prefix + Object(_util_helpers__WEBPACK_IMPORTED_MODULE_19__[/* upperFirst */ "G"])(val)] = def();
    return props;
  }, {});
}

var alignValidator = function alignValidator(str) {
  return [].concat(ALIGNMENT, ['baseline', 'stretch']).includes(str);
};

var alignProps = makeProps('align', function () {
  return {
    type: String,
    default: null,
    validator: alignValidator
  };
});

var justifyValidator = function justifyValidator(str) {
  return [].concat(ALIGNMENT, ['space-between', 'space-around']).includes(str);
};

var justifyProps = makeProps('justify', function () {
  return {
    type: String,
    default: null,
    validator: justifyValidator
  };
});

var alignContentValidator = function alignContentValidator(str) {
  return [].concat(ALIGNMENT, ['space-between', 'space-around', 'stretch']).includes(str);
};

var alignContentProps = makeProps('alignContent', function () {
  return {
    type: String,
    default: null,
    validator: alignContentValidator
  };
});
var propMap = {
  align: Object.keys(alignProps),
  justify: Object.keys(justifyProps),
  alignContent: Object.keys(alignContentProps)
};
var classMap = {
  align: 'align',
  justify: 'justify',
  alignContent: 'align-content'
};

function breakpointClass(type, prop, val) {
  var className = classMap[type];

  if (val == null) {
    return undefined;
  }

  if (prop) {
    // alignSm -> Sm
    var breakpoint = prop.replace(type, '');
    className += "-".concat(breakpoint);
  } // .align-items-sm-center


  className += "-".concat(val);
  return className.toLowerCase();
}

var cache = new Map();
/* harmony default export */ __webpack_exports__["a"] = (vue__WEBPACK_IMPORTED_MODULE_17___default.a.extend({
  name: 'v-row',
  functional: true,
  props: Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_15__[/* default */ "a"])(Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_15__[/* default */ "a"])(Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_15__[/* default */ "a"])({
    tag: {
      type: String,
      default: 'div'
    },
    dense: Boolean,
    noGutters: Boolean,
    align: {
      type: String,
      default: null,
      validator: alignValidator
    }
  }, alignProps), {}, {
    justify: {
      type: String,
      default: null,
      validator: justifyValidator
    }
  }, justifyProps), {}, {
    alignContent: {
      type: String,
      default: null,
      validator: alignContentValidator
    }
  }, alignContentProps),
  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;
    // Super-fast memoization based on props, 5x faster than JSON.stringify
    var cacheKey = '';

    for (var prop in props) {
      cacheKey += String(props[prop]);
    }

    var classList = cache.get(cacheKey);

    if (!classList) {
      (function () {
        var _classList$push;

        classList = []; // Loop through `align`, `justify`, `alignContent` breakpoint props

        var type;

        for (type in propMap) {
          propMap[type].forEach(function (prop) {
            var value = props[prop];
            var className = breakpointClass(type, prop, value);
            if (className) classList.push(className);
          });
        }

        classList.push((_classList$push = {
          'no-gutters': props.noGutters,
          'row--dense': props.dense
        }, Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_14__[/* default */ "a"])(_classList$push, "align-".concat(props.align), props.align), Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_14__[/* default */ "a"])(_classList$push, "justify-".concat(props.justify), props.justify), Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_14__[/* default */ "a"])(_classList$push, "align-content-".concat(props.alignContent), props.alignContent), _classList$push));
        cache.set(cacheKey, classList);
      })();
    }

    return h(props.tag, Object(_util_mergeData__WEBPACK_IMPORTED_MODULE_18__[/* default */ "a"])(data, {
      staticClass: 'row',
      class: classList
    }), children);
  }
}));

/***/ }),

/***/ "107f":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.i, "@import url(https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css);"]);
exports.push([module.i, "@import url(https://cdn-prd.patientpop.com/pp-icon-font/v1.6.0/pp-icon-font.css);"]);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}iframe[data-v-fee8366c]{border:none}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "10c8":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("c8d5")

/**
 * @category Year Helpers
 * @summary Get the year of the given date.
 *
 * @description
 * Get the year of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the year
 *
 * @example
 * // Which year is 2 July 2014?
 * var result = getYear(new Date(2014, 6, 2))
 * //=> 2014
 */
function getYear (dirtyDate) {
  var date = parse(dirtyDate)
  var year = date.getFullYear()
  return year
}

module.exports = getYear


/***/ }),

/***/ "10d2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _VSheet__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("8dd9");


/* harmony default export */ __webpack_exports__["a"] = (_VSheet__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]);

/***/ }),

/***/ "10e1":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><rect x=\"4\" y=\"6\" width=\"16\" height=\"2\" fill=\"#DFE4E5\"></rect><rect x=\"4\" y=\"10\" width=\"16\" height=\"10\" fill=\"white\"></rect><path d=\"M7 14V12H11V14H7Z\" fill=\"#688083\"></path><path d=\"M15 18V16H11V18H15Z\" fill=\"#688083\"></path><path d=\"M11 12H13V14H11V12Z\" fill=\"#688083\"></path><path d=\"M17 16H15V18H17V16Z\" fill=\"#688083\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M6 4V3C6 2.44772 6.44772 2 7 2C7.55228 2 8 2.44772 8 3V4H16V3C16 2.44772 16.4477 2 17 2C17.5523 2 18 2.44772 18 3V4H19.4963C20.8809 4 22 5.11672 22 6.50524V19.4948C22 20.8809 20.8878 22 19.4963 22H4.50371C3.11907 22 2 20.8833 2 19.4948V6.50524C2 5.11911 3.11219 4 4.50371 4H6ZM19.4963 6C19.7773 6 20 6.22223 20 6.50524V8H4V6.50524C4 6.22091 4.21954 6 4.50371 6H19.4963ZM4 10V19.4948C4 19.7778 4.2227 20 4.50371 20H19.4963C19.7805 20 20 19.7791 20 19.4948V10H4Z\" fill=\"#688083\"></path></svg>";

/***/ }),

/***/ "110a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpFormMessage_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("7873");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpFormMessage_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpFormMessage_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "110d":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("d6d2");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("e93927d4", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "110d0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpLoadingIcon_vue_vue_type_style_index_0_id_18424fb7_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("b178");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpLoadingIcon_vue_vue_type_style_index_0_id_18424fb7_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpLoadingIcon_vue_vue_type_style_index_0_id_18424fb7_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "1138":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.i, "@import url(https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css);"]);
exports.push([module.i, "@import url(https://cdn-prd.patientpop.com/pp-icon-font/v1.6.0/pp-icon-font.css);"]);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.tox .tox-dialog-wrap .tox-dialog input{background:#e9efee;border:2px solid transparent;border-radius:5px}.tox .tox-dialog-wrap .tox-dialog input:hover{background-color:#eef7f9}.tox .tox-dialog-wrap .tox-dialog input:focus{background-color:#fff;border:2px solid #417e86}.tox .tox-dialog-wrap .tox-dialog__footer-end{justify-content:space-between;width:100%}.tox .tox-dialog-wrap .tox-dialog__footer-end .tox-button{background:#ff8d6e;border:none;border-radius:20px;color:#004852;font-weight:400}.tox .tox-dialog-wrap .tox-dialog__footer-end .tox-button:active,.tox .tox-dialog-wrap .tox-dialog__footer-end .tox-button:focus{background:#ff8d6e;color:#004852;outline:3px solid #004852}.tox .tox-dialog-wrap .tox-dialog__footer-end .tox-button:hover{background:#ffaf95;color:#004852}.tox .tox-dialog-wrap .tox-dialog__footer-end .tox-button--secondary{background:#fff;outline:1px solid #d6d6d6}.tox .tox-dialog-wrap .tox-dialog__footer-end .tox-button--secondary:hover{background:#f6f6f6}.tox .tox-dialog-wrap .tox-dialog__footer-end .tox-button--secondary:active,.tox .tox-dialog-wrap .tox-dialog__footer-end .tox-button--secondary:focus{background:#fff;color:#004852}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "1148":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toInteger = __webpack_require__("a691");
var requireObjectCoercible = __webpack_require__("1d80");

// `String.prototype.repeat` method implementation
// https://tc39.es/ecma262/#sec-string.prototype.repeat
module.exports = ''.repeat || function repeat(count) {
  var str = String(requireObjectCoercible(this));
  var result = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError('Wrong number of repetitions');
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) result += str;
  return result;
};


/***/ }),

/***/ "11a8":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.i, "@import url(https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css);"]);
exports.push([module.i, "@import url(https://cdn-prd.patientpop.com/pp-icon-font/v1.6.0/pp-icon-font.css);"]);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}th.active.asc .pp-data-table-sort-icon:after,th.active.desc .pp-data-table-sort-icon:after,th.active .pp-data-table-sort-icon:after{background-color:#fff!important;height:48%!important;opacity:.5!important;margin-left:4px}th.active .pp-data-table-sort-icon:after{height:100%!important}th.active.desc .pp-data-table-sort-icon{transform:none!important}th.active.asc .pp-data-table-sort-icon:after{top:55%!important}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "1276":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fixRegExpWellKnownSymbolLogic = __webpack_require__("d784");
var isRegExp = __webpack_require__("44e7");
var anObject = __webpack_require__("825a");
var requireObjectCoercible = __webpack_require__("1d80");
var speciesConstructor = __webpack_require__("4840");
var advanceStringIndex = __webpack_require__("8aa5");
var toLength = __webpack_require__("50c4");
var callRegExpExec = __webpack_require__("14c3");
var regexpExec = __webpack_require__("9263");
var fails = __webpack_require__("d039");

var arrayPush = [].push;
var min = Math.min;
var MAX_UINT32 = 0xFFFFFFFF;

// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
var SUPPORTS_Y = !fails(function () { return !RegExp(MAX_UINT32, 'y'); });

// @@split logic
fixRegExpWellKnownSymbolLogic('split', 2, function (SPLIT, nativeSplit, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'.split(/(b)*/)[1] == 'c' ||
    'test'.split(/(?:)/, -1).length != 4 ||
    'ab'.split(/(?:ab)*/).length != 2 ||
    '.'.split(/(.?)(.?)/).length != 4 ||
    '.'.split(/()()/).length > 1 ||
    ''.split(/.?/).length
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = String(requireObjectCoercible(this));
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (separator === undefined) return [string];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) {
        return nativeSplit.call(string, separator, lim);
      }
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = regexpExec.call(separatorCopy, string)) {
        lastIndex = separatorCopy.lastIndex;
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          if (match.length > 1 && match.index < string.length) arrayPush.apply(output, match.slice(1));
          lastLength = match[0].length;
          lastLastIndex = lastIndex;
          if (output.length >= lim) break;
        }
        if (separatorCopy.lastIndex === match.index) separatorCopy.lastIndex++; // Avoid an infinite loop
      }
      if (lastLastIndex === string.length) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output.length > lim ? output.slice(0, lim) : output;
    };
  // Chakra, V8
  } else if ('0'.split(undefined, 0).length) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : nativeSplit.call(this, separator, limit);
    };
  } else internalSplit = nativeSplit;

  return [
    // `String.prototype.split` method
    // https://tc39.es/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = requireObjectCoercible(this);
      var splitter = separator == undefined ? undefined : separator[SPLIT];
      return splitter !== undefined
        ? splitter.call(separator, O, limit)
        : internalSplit.call(String(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (regexp, limit) {
      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== nativeSplit);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (SUPPORTS_Y ? 'y' : 'g');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = SUPPORTS_Y ? q : 0;
        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
        var e;
        if (
          z === null ||
          (e = min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          A.push(S.slice(p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            A.push(z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      A.push(S.slice(p));
      return A;
    }
  ];
}, !SUPPORTS_Y);


/***/ }),

/***/ "129f":
/***/ (function(module, exports) {

// `SameValue` abstract operation
// https://tc39.es/ecma262/#sec-samevalue
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};


/***/ }),

/***/ "12fd":
/***/ (function(module, exports, __webpack_require__) {

var addMonths = __webpack_require__("6665")

/**
 * @category Month Helpers
 * @summary Subtract the specified number of months from the given date.
 *
 * @description
 * Subtract the specified number of months from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be subtracted
 * @returns {Date} the new date with the months subtracted
 *
 * @example
 * // Subtract 5 months from 1 February 2015:
 * var result = subMonths(new Date(2015, 1, 1), 5)
 * //=> Mon Sep 01 2014 00:00:00
 */
function subMonths (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addMonths(dirtyDate, -amount)
}

module.exports = subMonths


/***/ }),

/***/ "132d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("7db0");
/* harmony import */ var core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("caad");
/* harmony import */ var core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_index_of_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("c975");
/* harmony import */ var core_js_modules_es_array_index_of_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("fb6a");
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_some_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("45fc");
/* harmony import */ var core_js_modules_es_array_some_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("a9e3");
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("2532");
/* harmony import */ var core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_string_trim_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("498a");
/* harmony import */ var core_js_modules_es_string_trim_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_trim_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_string_small_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("c96a");
/* harmony import */ var core_js_modules_es_string_small_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_small_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("5530");
/* harmony import */ var _src_components_VIcon_VIcon_sass__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("4804");
/* harmony import */ var _src_components_VIcon_VIcon_sass__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_src_components_VIcon_VIcon_sass__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _mixins_binds_attrs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("7e2b");
/* harmony import */ var _mixins_colorable__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("a9ad");
/* harmony import */ var _mixins_sizeable__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("af2b");
/* harmony import */ var _mixins_themeable__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("7560");
/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("80d2");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("8bbf");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("58df");










 // Mixins




 // Util

 // Types



var SIZE_MAP;

(function (SIZE_MAP) {
  SIZE_MAP["xSmall"] = "12px";
  SIZE_MAP["small"] = "16px";
  SIZE_MAP["default"] = "24px";
  SIZE_MAP["medium"] = "28px";
  SIZE_MAP["large"] = "36px";
  SIZE_MAP["xLarge"] = "40px";
})(SIZE_MAP || (SIZE_MAP = {}));

function isFontAwesome5(iconType) {
  return ['fas', 'far', 'fal', 'fab', 'fad'].some(function (val) {
    return iconType.includes(val);
  });
}

function isSvgPath(icon) {
  return /^[mzlhvcsqta]\s*[-+.0-9][^mlhvzcsqta]+/i.test(icon) && /[\dz]$/i.test(icon) && icon.length > 4;
}

var VIcon = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_17__[/* default */ "a"])(_mixins_binds_attrs__WEBPACK_IMPORTED_MODULE_11__[/* default */ "a"], _mixins_colorable__WEBPACK_IMPORTED_MODULE_12__[/* default */ "a"], _mixins_sizeable__WEBPACK_IMPORTED_MODULE_13__[/* default */ "a"], _mixins_themeable__WEBPACK_IMPORTED_MODULE_14__[/* default */ "a"]
/* @vue/component */
).extend({
  name: 'v-icon',
  props: {
    dense: Boolean,
    disabled: Boolean,
    left: Boolean,
    right: Boolean,
    size: [Number, String],
    tag: {
      type: String,
      required: false,
      default: 'i'
    }
  },
  computed: {
    medium: function medium() {
      return false;
    },
    hasClickListener: function hasClickListener() {
      return Boolean(this.listeners$.click || this.listeners$['!click']);
    }
  },
  methods: {
    getIcon: function getIcon() {
      var iconName = '';
      if (this.$slots.default) iconName = this.$slots.default[0].text.trim();
      return Object(_util_helpers__WEBPACK_IMPORTED_MODULE_15__[/* remapInternalIcon */ "C"])(this, iconName);
    },
    getSize: function getSize() {
      var sizes = {
        xSmall: this.xSmall,
        small: this.small,
        medium: this.medium,
        large: this.large,
        xLarge: this.xLarge
      };
      var explicitSize = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_15__[/* keys */ "y"])(sizes).find(function (key) {
        return sizes[key];
      });
      return explicitSize && SIZE_MAP[explicitSize] || Object(_util_helpers__WEBPACK_IMPORTED_MODULE_15__[/* convertToUnit */ "g"])(this.size);
    },
    // Component data for both font icon and SVG wrapper span
    getDefaultData: function getDefaultData() {
      return {
        staticClass: 'v-icon notranslate',
        class: {
          'v-icon--disabled': this.disabled,
          'v-icon--left': this.left,
          'v-icon--link': this.hasClickListener,
          'v-icon--right': this.right,
          'v-icon--dense': this.dense
        },
        attrs: Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])({
          'aria-hidden': !this.hasClickListener,
          disabled: this.hasClickListener && this.disabled,
          type: this.hasClickListener ? 'button' : undefined
        }, this.attrs$),
        on: this.listeners$
      };
    },
    getSvgWrapperData: function getSvgWrapperData() {
      var fontSize = this.getSize();

      var wrapperData = Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])({}, this.getDefaultData()), {}, {
        style: fontSize ? {
          fontSize: fontSize,
          height: fontSize,
          width: fontSize
        } : undefined
      });

      this.applyColors(wrapperData);
      return wrapperData;
    },
    applyColors: function applyColors(data) {
      data.class = Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])({}, data.class), this.themeClasses);
      this.setTextColor(this.color, data);
    },
    renderFontIcon: function renderFontIcon(icon, h) {
      var newChildren = [];
      var data = this.getDefaultData();
      var iconType = 'material-icons'; // Material Icon delimiter is _
      // https://material.io/icons/

      var delimiterIndex = icon.indexOf('-');
      var isMaterialIcon = delimiterIndex <= -1;

      if (isMaterialIcon) {
        // Material icon uses ligatures.
        newChildren.push(icon);
      } else {
        iconType = icon.slice(0, delimiterIndex);
        if (isFontAwesome5(iconType)) iconType = '';
      }

      data.class[iconType] = true;
      data.class[icon] = !isMaterialIcon;
      var fontSize = this.getSize();
      if (fontSize) data.style = {
        fontSize: fontSize
      };
      this.applyColors(data);
      return h(this.hasClickListener ? 'button' : this.tag, data, newChildren);
    },
    renderSvgIcon: function renderSvgIcon(icon, h) {
      var svgData = {
        class: 'v-icon__svg',
        attrs: {
          xmlns: 'http://www.w3.org/2000/svg',
          viewBox: '0 0 24 24',
          role: 'img',
          'aria-hidden': true
        }
      };
      var size = this.getSize();

      if (size) {
        svgData.style = {
          fontSize: size,
          height: size,
          width: size
        };
      }

      return h(this.hasClickListener ? 'button' : 'span', this.getSvgWrapperData(), [h('svg', svgData, [h('path', {
        attrs: {
          d: icon
        }
      })])]);
    },
    renderSvgIconComponent: function renderSvgIconComponent(icon, h) {
      var data = {
        class: {
          'v-icon__component': true
        }
      };
      var size = this.getSize();

      if (size) {
        data.style = {
          fontSize: size,
          height: size,
          width: size
        };
      }

      this.applyColors(data);
      var component = icon.component;
      data.props = icon.props;
      data.nativeOn = data.on;
      return h(this.hasClickListener ? 'button' : 'span', this.getSvgWrapperData(), [h(component, data)]);
    }
  },
  render: function render(h) {
    var icon = this.getIcon();

    if (typeof icon === 'string') {
      if (isSvgPath(icon)) {
        return this.renderSvgIcon(icon, h);
      }

      return this.renderFontIcon(icon, h);
    }

    return this.renderSvgIconComponent(icon, h);
  }
});
/* harmony default export */ __webpack_exports__["a"] = (vue__WEBPACK_IMPORTED_MODULE_16___default.a.extend({
  name: 'v-icon',
  $_wrapperFor: VIcon,
  functional: true,
  render: function render(h, _ref) {
    var data = _ref.data,
        children = _ref.children;
    var iconName = ''; // Support usage of v-text and v-html

    if (data.domProps) {
      iconName = data.domProps.textContent || data.domProps.innerHTML || iconName; // Remove nodes so it doesn't
      // overwrite our changes

      delete data.domProps.textContent;
      delete data.domProps.innerHTML;
    }

    return h(VIcon, data, iconName ? [iconName] : children);
  }
}));

/***/ }),

/***/ "13d5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $reduce = __webpack_require__("d58f").left;
var arrayMethodIsStrict = __webpack_require__("a640");
var arrayMethodUsesToLength = __webpack_require__("ae40");
var CHROME_VERSION = __webpack_require__("2d00");
var IS_NODE = __webpack_require__("605d");

var STRICT_METHOD = arrayMethodIsStrict('reduce');
var USES_TO_LENGTH = arrayMethodUsesToLength('reduce', { 1: 0 });
// Chrome 80-82 has a critical bug
// https://bugs.chromium.org/p/chromium/issues/detail?id=1049982
var CHROME_BUG = !IS_NODE && CHROME_VERSION > 79 && CHROME_VERSION < 83;

// `Array.prototype.reduce` method
// https://tc39.es/ecma262/#sec-array.prototype.reduce
$({ target: 'Array', proto: true, forced: !STRICT_METHOD || !USES_TO_LENGTH || CHROME_BUG }, {
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "1403":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.theme--light.v-date-picker-table .v-date-picker-table--date__week,.theme--light.v-date-picker-table th{color:var(--pp-text-disabled,#f6f6f6)}.theme--dark.v-date-picker-table .v-date-picker-table--date__week,.theme--dark.v-date-picker-table th{color:hsla(0,0%,100%,.5)}.v-date-picker-table{position:relative;padding:0 12px;height:242px}.v-date-picker-table table{transition:.3s cubic-bezier(.25,.8,.5,1);top:0;table-layout:fixed;width:100%}.v-date-picker-table td,.v-date-picker-table th{text-align:center;position:relative}.v-date-picker-table th{font-size:12px}.v-date-picker-table--date .v-btn{height:32px;width:32px}.v-date-picker-table .v-btn{z-index:auto;margin:0;font-size:12px}.v-date-picker-table .v-btn.v-btn--active{color:#fff}.v-date-picker-table--month td{width:33.333333%;height:56px;vertical-align:middle;text-align:center}.v-date-picker-table--month td .v-btn{margin:0 auto;max-width:140px;min-width:40px;width:100%}.v-date-picker-table--date th{padding:8px 0;font-weight:600}.v-date-picker-table--date td{width:45px}.v-date-picker-table__events{height:8px;left:0;position:absolute;text-align:center;white-space:pre;width:100%}.v-date-picker-table__events>div{border-radius:50%;display:inline-block;height:8px;margin:0 1px;width:8px}.v-date-picker-table--date .v-date-picker-table__events{bottom:6px}.v-date-picker-table--month .v-date-picker-table__events{bottom:8px}.v-date-picker-table__current .v-date-picker-table__events{margin-bottom:-1px}.v-date-picker-table--disabled{pointer-events:none}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "145e":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("c8d5")

/**
 * @category Second Helpers
 * @summary Return the end of a second for the given date.
 *
 * @description
 * Return the end of a second for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of a second
 *
 * @example
 * // The end of a second for 1 December 2014 22:15:45.400:
 * var result = endOfSecond(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:45.999
 */
function endOfSecond (dirtyDate) {
  var date = parse(dirtyDate)
  date.setMilliseconds(999)
  return date
}

module.exports = endOfSecond


/***/ }),

/***/ "1464":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.i, "@import url(https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css);"]);
exports.push([module.i, "@import url(https://cdn-prd.patientpop.com/pp-icon-font/v1.6.0/pp-icon-font.css);"]);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.pp-page-header[data-v-1ca6b76c]{background:#fff;border-bottom:1px solid #d6d6d6;margin-left:-1em;position:sticky;top:0;width:calc(100% + 2em);z-index:3}@media(min-width:960px){.pp-page-header[data-v-1ca6b76c]{margin-left:-.75em;min-height:77px;top:0}}@media(min-width:1488px){.pp-page-header--not-full-width[data-v-1ca6b76c]{--left-margin:calc(-50vw + 9.42857rem - var(--pp-main-width, 1188px)*-0.5 - 0.25em - 7px);margin-left:calc(var(--left-margin) - 1px);width:calc(100% + var(--left-margin)*-2)}}.pp-page-header__mobile[data-v-1ca6b76c]{border-bottom:1px solid #d6d6d6;font-size:1.291rem;font-weight:600;height:64px;letter-spacing:-.02em;width:100%}@media print{.pp-page-header__mobile[data-v-1ca6b76c]{display:none!important}}.pp-page-header__title-area[data-v-1ca6b76c]{max-width:100vw}@media(min-width:960px){.pp-page-header__title-area[data-v-1ca6b76c]{max-width:calc(100vw - 350px)}}@media print{.pp-page-header__actions-area[data-v-1ca6b76c],.pp-page-header__title-area .pp-button[data-v-1ca6b76c]{display:none!important}}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "146f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpNavList_vue_vue_type_style_index_0_id_6a452a5c_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("8885");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpNavList_vue_vue_type_style_index_0_id_6a452a5c_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpNavList_vue_vue_type_style_index_0_id_6a452a5c_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "14c3":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("c6b6");
var regexpExec = __webpack_require__("9263");

// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }

  if (classof(R) !== 'RegExp') {
    throw TypeError('RegExp#exec called on incompatible receiver');
  }

  return regexpExec.call(R, S);
};



/***/ }),

/***/ "1586":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// NAMESPACE OBJECT: ./src/components/status-banner/constants.js
var constants_namespaceObject = {};
__webpack_require__.r(constants_namespaceObject);
__webpack_require__.d(constants_namespaceObject, "INFO", function() { return INFO; });
__webpack_require__.d(constants_namespaceObject, "SUCCESS", function() { return SUCCESS; });
__webpack_require__.d(constants_namespaceObject, "WARNING", function() { return WARNING; });
__webpack_require__.d(constants_namespaceObject, "ERROR", function() { return ERROR; });
__webpack_require__.d(constants_namespaceObject, "ALERT", function() { return ALERT; });
__webpack_require__.d(constants_namespaceObject, "PENDING", function() { return PENDING; });

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c662cfac-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/status-banner/PpStatusBanner.vue?vue&type=template&id=112baaea&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showBanner)?_c('div',{staticClass:"pp-status-banner d-flex align-center",class:(_vm.status + " " + (_vm.small ? 'pa-2' : 'pa-5')),attrs:{"role":_vm.dismissable ? 'button' : null},on:{"click":_vm.dismissBanner}},[_c('i',{staticClass:"text-h3 mr-2 mt-1",class:("pp-icon-" + _vm.statusIcon + " " + _vm.status + "--text")}),_c('div',{staticClass:"text-h6"},[_vm._t("text",[_vm._v(" "+_vm._s(_vm.text)+" ")])],2),(_vm.loading)?_c('pp-loader',{staticClass:"pp-status-banner__loader",attrs:{"size":24,"width":2,"color":"secondary"}}):_vm._e()],1):_vm._e()}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/status-banner/PpStatusBanner.vue?vue&type=template&id=112baaea&scoped=true&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.index-of.js
var es_array_index_of = __webpack_require__("c975");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.values.js
var es_object_values = __webpack_require__("07ac");

// EXTERNAL MODULE: ./src/components/loader/PpLoader.vue + 4 modules
var PpLoader = __webpack_require__("d888");

// CONCATENATED MODULE: ./src/components/status-banner/constants.js
var INFO = 'info';
var SUCCESS = 'success';
var WARNING = 'warning';
var ERROR = 'error';
var ALERT = 'alert';
var PENDING = 'pending';
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/status-banner/PpStatusBanner.vue?vue&type=script&lang=js&


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var PpStatusBannervue_type_script_lang_js_ = ({
  name: 'PpStatusBanner',
  components: {
    'pp-loader': PpLoader["default"]
  },
  props: {
    status: {
      type: String,
      validator: function validator(value) {
        return Object.values(constants_namespaceObject).indexOf(value) !== -1;
      },
      required: true
    },
    text: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    },

    /**
     * Make it smaller with less padding
     */
    small: {
      type: Boolean,
      default: false
    },

    /**
     * Make the banner hide on click
     */
    dismissable: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      showBanner: true
    };
  },
  computed: {
    statusIcon: function statusIcon() {
      switch (this.status) {
        case INFO:
          return 'info';

        case PENDING:
          return 'info';

        case SUCCESS:
          return 'check-circle';

        case ALERT:
          return 'alert';

        case WARNING:
          return 'warning';

        case ERROR:
          return 'minus-circle';

        default:
          return 'warning';
      }
    }
  },
  methods: {
    dismissBanner: function dismissBanner() {
      if (this.dismissable) {
        this.showBanner = false;
      }
    }
  }
});
// CONCATENATED MODULE: ./src/components/status-banner/PpStatusBanner.vue?vue&type=script&lang=js&
 /* harmony default export */ var status_banner_PpStatusBannervue_type_script_lang_js_ = (PpStatusBannervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/status-banner/PpStatusBanner.vue?vue&type=style&index=0&id=112baaea&scoped=true&lang=scss&
var PpStatusBannervue_type_style_index_0_id_112baaea_scoped_true_lang_scss_ = __webpack_require__("7001");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/status-banner/PpStatusBanner.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  status_banner_PpStatusBannervue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "112baaea",
  null
  
)

/* harmony default export */ var PpStatusBanner = __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "158b":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("c8d5")
var setMonth = __webpack_require__("3814")

/**
 * @category Quarter Helpers
 * @summary Set the year quarter to the given date.
 *
 * @description
 * Set the year quarter to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} quarter - the quarter of the new date
 * @returns {Date} the new date with the quarter setted
 *
 * @example
 * // Set the 2nd quarter to 2 July 2014:
 * var result = setQuarter(new Date(2014, 6, 2), 2)
 * //=> Wed Apr 02 2014 00:00:00
 */
function setQuarter (dirtyDate, dirtyQuarter) {
  var date = parse(dirtyDate)
  var quarter = Number(dirtyQuarter)
  var oldQuarter = Math.floor(date.getMonth() / 3) + 1
  var diff = quarter - oldQuarter
  return setMonth(date, date.getMonth() + diff * 3)
}

module.exports = setQuarter


/***/ }),

/***/ "159b":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var DOMIterables = __webpack_require__("fdbc");
var forEach = __webpack_require__("17c2");
var createNonEnumerableProperty = __webpack_require__("9112");

for (var COLLECTION_NAME in DOMIterables) {
  var Collection = global[COLLECTION_NAME];
  var CollectionPrototype = Collection && Collection.prototype;
  // some Chrome versions have non-configurable methods on DOMTokenList
  if (CollectionPrototype && CollectionPrototype.forEach !== forEach) try {
    createNonEnumerableProperty(CollectionPrototype, 'forEach', forEach);
  } catch (error) {
    CollectionPrototype.forEach = forEach;
  }
}


/***/ }),

/***/ "15fd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ _objectWithoutProperties; });

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("a4d3");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.index-of.js
var es_array_index_of = __webpack_require__("c975");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("b64b");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js


function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js



function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ }),

/***/ "166a":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("9a87");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("194f0206", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "1681":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("57e3");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("02d338a9", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "16b7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("a9e3");
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("8bbf");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_1__);


/**
 * Delayable
 *
 * @mixin
 *
 * Changes the open or close delay time for elements
 */

/* harmony default export */ __webpack_exports__["a"] = (vue__WEBPACK_IMPORTED_MODULE_1___default.a.extend().extend({
  name: 'delayable',
  props: {
    openDelay: {
      type: [Number, String],
      default: 0
    },
    closeDelay: {
      type: [Number, String],
      default: 0
    }
  },
  data: function data() {
    return {
      openTimeout: undefined,
      closeTimeout: undefined
    };
  },
  methods: {
    /**
     * Clear any pending delay timers from executing
     */
    clearDelay: function clearDelay() {
      clearTimeout(this.openTimeout);
      clearTimeout(this.closeTimeout);
    },

    /**
     * Runs callback after a specified delay
     */
    runDelay: function runDelay(type, cb) {
      var _this = this;

      this.clearDelay();
      var delay = parseInt(this["".concat(type, "Delay")], 10);
      this["".concat(type, "Timeout")] = setTimeout(cb || function () {
        _this.isActive = {
          open: true,
          close: false
        }[type];
      }, delay);
    }
  }
}));

/***/ }),

/***/ "16c9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c662cfac-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/info-card/PpInfoCard.vue?vue&type=template&id=16df49b6&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pa-5 pa-sm-7 mb-5 pp-info-card",class:{'pp-info-card--with-status':_vm.status, 'elevation-2 rounded-lg': _vm.showHeader},style:(_vm.statusCssVar)},[(_vm.showHeader)?_c('div',{staticClass:"pp-info-card__header mx-n5 mx-sm-n7 px-5 px-sm-7 pb-sm-7 pb-5 mb-5"},[_vm._t("header",[(_vm.header)?_c('h3',{staticClass:"text-h3"},[_vm._v(" "+_vm._s(_vm.header)+" ")]):_vm._e()])],2):_vm._e(),_vm._t("content")],2)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/info-card/PpInfoCard.vue?vue&type=template&id=16df49b6&scoped=true&

// EXTERNAL MODULE: ./src/styles/colors.scss
var colors = __webpack_require__("1c98");
var colors_default = /*#__PURE__*/__webpack_require__.n(colors);

// CONCATENATED MODULE: ./src/components/info-card/constants.js
var SUCCESS = 'success';
var ERROR = 'error';
var WARNING = 'warning';
var ALERT = 'alert';
var PENDING = 'pending';
var INFO = 'info';
var DISABLED = 'disabled';
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/info-card/PpInfoCard.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/**
 * Card for showing info that shows shadow on hover
 */

/* harmony default export */ var PpInfoCardvue_type_script_lang_js_ = ({
  name: 'PpInfoCard',
  props: {
    header: {
      type: String,
      default: ''
    },
    status: {
      type: String,
      default: ''
    }
  },
  computed: {
    showHeader: function showHeader() {
      return this.$slots.header || this.header;
    },
    statusCssVar: function statusCssVar() {
      if (!this.status) {
        return '';
      }

      var color = '';

      switch (this.status) {
        case SUCCESS:
          color = colors_default.a.vigor;
          break;

        case ERROR:
          color = colors_default.a.firstAid;
          break;

        case WARNING:
          color = colors_default.a.energize;
          break;

        case ALERT:
          color = colors_default.a.vitality1;
          break;

        case PENDING:
          color = colors_default.a.holistic;
          break;

        case INFO:
          color = colors_default.a.systole;
          break;

        case DISABLED:
          color = colors_default.a.synapse4;
          break;
      }

      return "--status-color:".concat(color);
    }
  }
});
// CONCATENATED MODULE: ./src/components/info-card/PpInfoCard.vue?vue&type=script&lang=js&
 /* harmony default export */ var info_card_PpInfoCardvue_type_script_lang_js_ = (PpInfoCardvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/info-card/PpInfoCard.vue?vue&type=style&index=0&id=16df49b6&lang=scss&scoped=true&
var PpInfoCardvue_type_style_index_0_id_16df49b6_lang_scss_scoped_true_ = __webpack_require__("855b");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/info-card/PpInfoCard.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  info_card_PpInfoCardvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "16df49b6",
  null
  
)

/* harmony default export */ var PpInfoCard = __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "17b3":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("676d");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("16256089", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "17b6":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("5ce8");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("635cbbbe", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "17c2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $forEach = __webpack_require__("b727").forEach;
var arrayMethodIsStrict = __webpack_require__("a640");
var arrayMethodUsesToLength = __webpack_require__("ae40");

var STRICT_METHOD = arrayMethodIsStrict('forEach');
var USES_TO_LENGTH = arrayMethodUsesToLength('forEach');

// `Array.prototype.forEach` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.foreach
module.exports = (!STRICT_METHOD || !USES_TO_LENGTH) ? function forEach(callbackfn /* , thisArg */) {
  return $forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
} : [].forEach;


/***/ }),

/***/ "17cd":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("c8d5")
var differenceInCalendarMonths = __webpack_require__("b2e9")
var compareAsc = __webpack_require__("0d3e")

/**
 * @category Month Helpers
 * @summary Get the number of full months between the given dates.
 *
 * @description
 * Get the number of full months between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of full months
 *
 * @example
 * // How many full months are between 31 January 2014 and 1 September 2014?
 * var result = differenceInMonths(
 *   new Date(2014, 8, 1),
 *   new Date(2014, 0, 31)
 * )
 * //=> 7
 */
function differenceInMonths (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)

  var sign = compareAsc(dateLeft, dateRight)
  var difference = Math.abs(differenceInCalendarMonths(dateLeft, dateRight))
  dateLeft.setMonth(dateLeft.getMonth() - sign * difference)

  // Math.abs(diff in full months - diff in calendar months) === 1 if last calendar month is not full
  // If so, result must be decreased by 1 in absolute value
  var isLastMonthNotFull = compareAsc(dateLeft, dateRight) === -sign
  return sign * (difference - isLastMonthNotFull)
}

module.exports = differenceInMonths


/***/ }),

/***/ "1800":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("4de4");
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("8bbf");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_1__);

// Types

/* @vue/component */

/* harmony default export */ __webpack_exports__["a"] = (vue__WEBPACK_IMPORTED_MODULE_1___default.a.extend({
  name: 'v-list-item-action',
  functional: true,
  render: function render(h, _ref) {
    var data = _ref.data,
        _ref$children = _ref.children,
        children = _ref$children === void 0 ? [] : _ref$children;
    data.staticClass = data.staticClass ? "v-list-item__action ".concat(data.staticClass) : 'v-list-item__action';
    var filteredChild = children.filter(function (VNode) {
      return VNode.isComment === false && VNode.text !== ' ';
    });
    if (filteredChild.length > 1) data.staticClass += ' v-list-item__action--stack';
    return h('div', data, children);
  }
}));

/***/ }),

/***/ "184d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c662cfac-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/upload-file/PpUploadFile.vue?vue&type=template&id=6d3d1270&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pp-dialog',{attrs:{"value":_vm.value,"title":_vm.title,"max-width":540,"content-class":"pp-upload-file","primary-button-text":_vm.primaryButtonText,"hide-secondary-button":_vm.hideSecondaryButton || _vm.hideButtons,"hide-primary-button":_vm.hidePrimaryButton || _vm.hideButtons,"hide-close-button":_vm.hideButtons,"secondary-button-text":"Cancel"},on:{"close":_vm.onClose,"confirm":_vm.onPrimaryButtonClick},scopedSlots:_vm._u([{key:"body",fn:function(){return [(_vm.showHeader)?_vm._t("header",[(_vm.isInitial)?_c('p',[_vm._v(" If you are unsure of how to format this file, "),_c('a',{staticClass:"upload-file__template",attrs:{"href":_vm.downloadUrl || 'javascript:void(0)'},on:{"click":function($event){return _vm.$emit('download-template')}}},[_vm._v("download our template")]),_vm._v(". ")]):(_vm.isUploading)?_c('p',[_vm._v(" Do not close this window if you wish to proceed. ")]):_vm._e()]):_vm._e(),_c('pp-input-file',{attrs:{"file-types":_vm.fileTypes,"status":_vm.status,"error-message":_vm.errorMessage,"max-size":_vm.maxSize,"multiple":_vm.multiple,"img-url":_vm.imgUrl,"header-text":_vm.inputFileHeader,"content-text":_vm.inputFileContent,"show-progress":_vm.showProgress,"upload-progress":_vm.uploadProgress},on:{"error":_vm.getErrorMessage,"files-selected":_vm.uploadFile}}),(_vm.showFooter)?_vm._t("footer",[(_vm.isInitial)?_c('p',{staticClass:"mt-3 text-center"},[_vm._v(" Need help? "),_c('span',{staticClass:"upload-file__learn-more",attrs:{"id":_vm.pendoGuide}},[_vm._v("Learn more about "+_vm._s(_vm.title))]),_vm._v(". ")]):_vm._e()]):_vm._e()]},proxy:true}],null,true)})}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/upload-file/PpUploadFile.vue?vue&type=template&id=6d3d1270&scoped=true&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.index-of.js
var es_array_index_of = __webpack_require__("c975");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__("a9e3");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.values.js
var es_object_values = __webpack_require__("07ac");

// EXTERNAL MODULE: ./src/components/dialog/PpDialog.vue + 5 modules
var PpDialog = __webpack_require__("bdf9");

// EXTERNAL MODULE: ./src/components/input/file/PpInputFile.vue + 4 modules
var PpInputFile = __webpack_require__("b9b8");

// EXTERNAL MODULE: ./src/components/input/file/constants.js
var constants = __webpack_require__("6e1e");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/upload-file/PpUploadFile.vue?vue&type=script&lang=js&



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var PpUploadFilevue_type_script_lang_js_ = ({
  name: 'PpUploadFile',
  components: {
    'pp-dialog': PpDialog["default"],
    'pp-input-file': PpInputFile["default"]
  },
  props: {
    /**
     * This field is the url containing the template content
     */
    downloadUrl: {
      type: String,
      default: ''
    },

    /**
     * This field is to display the error message in the format of the error's header and content
     */
    errorMessage: {
      type: Object,
      default: function _default() {
        return {
          header: '',
          content: ''
        };
      }
    },

    /**
     * This field is number of maximum bytes for files (default to 1Mb)
     */
    maxSize: {
      type: Number,
      default: 1048576
    },

    /**
     * This field is used to determine whether to upload multiple files
     */
    multiple: {
      type: Boolean,
      default: false
    },

    /**
     * Array file types, ex: .json, .csv
     */
    fileTypes: {
      type: Array,
      required: true
    },

    /**
     * Current status for file upload
     * init is default state
     */
    status: {
      type: String,
      default: constants["b" /* UPLOAD_FILE_STATUS */].INIT,
      validator: function validator(value) {
        return Object.values(constants["b" /* UPLOAD_FILE_STATUS */]).indexOf(value) !== -1;
      }
    },

    /**
     * Dialog title
     */
    title: {
      type: String,
      default: ''
    },

    /**
     * This is used to determine if the dialog will show or not
     */
    value: {
      type: Boolean,
      required: true
    },

    /**
     * This field is used to set the url of the file image to display
     */
    imgUrl: {
      type: String,
      default: ''
    },

    /**
     * This field is used to determine if the header should be shown or not
     */
    showHeader: {
      type: Boolean,
      default: true
    },

    /**
     * This field is used to determine if the footer should be shown or not
     */
    showFooter: {
      type: Boolean,
      default: true
    },

    /**
     * This field is used to set the input file header text
     */
    inputFileHeader: {
      type: String,
      default: null
    },

    /**
     * This field is used to set the input file content text
     */
    inputFileContent: {
      type: String,
      default: null
    },

    /**
     * This field is used to determine if the upload progress should be shown or not
     */
    showProgress: {
      type: Boolean,
      default: false
    },

    /**
     * This field is used to set the upload progress
     */
    uploadProgress: {
      type: Number,
      default: 0
    },

    /**
     * This field is used to determine if the buttons should be hidden or not
     */
    hideButtons: {
      type: Boolean,
      default: false
    },

    /**
     * This field is used to set the pendo guide id for the default footer
     */
    pendoGuide: {
      type: String,
      default: ''
    }
  },
  computed: {
    isUploading: function isUploading() {
      return this.status === constants["b" /* UPLOAD_FILE_STATUS */].UPLOADING;
    },
    isInitial: function isInitial() {
      return this.status === constants["b" /* UPLOAD_FILE_STATUS */].INIT;
    },
    hideSecondaryButton: function hideSecondaryButton() {
      return this.status === constants["b" /* UPLOAD_FILE_STATUS */].COMPLETE;
    },
    hidePrimaryButton: function hidePrimaryButton() {
      return this.status === constants["b" /* UPLOAD_FILE_STATUS */].INIT || this.status === constants["b" /* UPLOAD_FILE_STATUS */].UPLOADING;
    },
    primaryButtonText: function primaryButtonText() {
      var buttonText = '';

      switch (this.status) {
        case constants["b" /* UPLOAD_FILE_STATUS */].COMPLETE:
          buttonText = 'Okay';
          break;

        case constants["b" /* UPLOAD_FILE_STATUS */].INIT:
        case constants["b" /* UPLOAD_FILE_STATUS */].UPLOADING:
          buttonText = '';
          break;

        default:
          buttonText = 'Go back';
          break;
      }

      return buttonText;
    }
  },
  methods: {
    onPrimaryButtonClick: function onPrimaryButtonClick() {
      if (this.status === constants["b" /* UPLOAD_FILE_STATUS */].ERROR) {
        this.$emit('go-back');
        return;
      }

      this.$emit('confirm');
    },
    onClose: function onClose() {
      this.$emit('close');
    },
    getErrorMessage: function getErrorMessage(error) {
      this.$emit('error', error);
    },
    uploadFile: function uploadFile(files) {
      if (files.length === 0) return;
      this.$emit('files-selected', files);
    }
  }
});
// CONCATENATED MODULE: ./src/components/upload-file/PpUploadFile.vue?vue&type=script&lang=js&
 /* harmony default export */ var upload_file_PpUploadFilevue_type_script_lang_js_ = (PpUploadFilevue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/upload-file/PpUploadFile.vue?vue&type=style&index=0&id=6d3d1270&scoped=true&lang=scss&
var PpUploadFilevue_type_style_index_0_id_6d3d1270_scoped_true_lang_scss_ = __webpack_require__("3658");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/upload-file/PpUploadFile.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  upload_file_PpUploadFilevue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "6d3d1270",
  null
  
)

/* harmony default export */ var PpUploadFile = __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "1883":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.i, "@import url(https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css);"]);
exports.push([module.i, "@import url(https://cdn-prd.patientpop.com/pp-icon-font/v1.6.0/pp-icon-font.css);"]);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}[data-v-3a33170c] .v-autocomplete:not(.v-input--is-focused).v-select--chips input{max-height:-webkit-max-content;max-height:-moz-max-content;max-height:max-content}[data-v-3a33170c] .v-input .v-input__icon--clear{margin-right:.7em;margin-top:.2em}[data-v-3a33170c] .v-input .v-input__append-inner{height:100%;margin-top:0;position:relative}[data-v-3a33170c] .v-input .v-chip{background-color:#fff;border:1px solid rgba(0,0,0,.12);border-radius:20px;color:#9a9a9a;margin:2px 3px}[data-v-3a33170c] .v-input .v-chip:first-of-type{margin-left:-.25em}[data-v-3a33170c] .v-input .v-chip__content{color:#067889;font-weight:600}[data-v-3a33170c] .v-input .v-chip__close:before{color:#545454;content:\"×\";font-size:15px;font-weight:600;height:18px}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "18a5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var createHTML = __webpack_require__("857a");
var forcedStringHTMLMethod = __webpack_require__("af03");

// `String.prototype.anchor` method
// https://tc39.es/ecma262/#sec-string.prototype.anchor
$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('anchor') }, {
  anchor: function anchor(name) {
    return createHTML(this, 'a', 'name', name);
  }
});


/***/ }),

/***/ "18b7":
/***/ (function(module, exports, __webpack_require__) {

var addMinutes = __webpack_require__("72b7")

/**
 * @category Minute Helpers
 * @summary Subtract the specified number of minutes from the given date.
 *
 * @description
 * Subtract the specified number of minutes from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of minutes to be subtracted
 * @returns {Date} the new date with the mintues subtracted
 *
 * @example
 * // Subtract 30 minutes from 10 July 2014 12:00:00:
 * var result = subMinutes(new Date(2014, 6, 10, 12, 0), 30)
 * //=> Thu Jul 10 2014 11:30:00
 */
function subMinutes (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addMinutes(dirtyDate, -amount)
}

module.exports = subMinutes


/***/ }),

/***/ "19aa":
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name) {
  if (!(it instanceof Constructor)) {
    throw TypeError('Incorrect ' + (name ? name + ' ' : '') + 'invocation');
  } return it;
};


/***/ }),

/***/ "19cf":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><mask id=\"path-1-inside-1_109_494\" fill=\"white\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5 1C2.79086 1 1 2.79086 1 5V16C1 18.2091 2.79086 20 5 20H8.68629L11.2929 22.6066C11.6834 22.9971 12.3166 22.9971 12.7071 22.6066L15.3137 20H19C21.2091 20 23 18.2091 23 16V5C23 2.79086 21.2091 1 19 1H5Z\"></path></mask><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5 1C2.79086 1 1 2.79086 1 5V16C1 18.2091 2.79086 20 5 20H8.68629L11.2929 22.6066C11.6834 22.9971 12.3166 22.9971 12.7071 22.6066L15.3137 20H19C21.2091 20 23 18.2091 23 16V5C23 2.79086 21.2091 1 19 1H5Z\" fill=\"white\"></path><path d=\"M8.68629 20L10.1005 18.5858L9.51472 18H8.68629V20ZM11.2929 22.6066L12.7071 21.1924L11.2929 22.6066ZM12.7071 22.6066L11.2929 21.1924L12.7071 22.6066ZM15.3137 20V18H14.4853L13.8995 18.5858L15.3137 20ZM3 5C3 3.89543 3.89543 3 5 3V-1C1.68629 -1 -1 1.68629 -1 5H3ZM3 16V5H-1V16H3ZM5 18C3.89543 18 3 17.1046 3 16H-1C-1 19.3137 1.68629 22 5 22V18ZM8.68629 18H5V22H8.68629V18ZM12.7071 21.1924L10.1005 18.5858L7.27208 21.4142L9.87868 24.0208L12.7071 21.1924ZM11.2929 21.1924C11.6834 20.8019 12.3166 20.8019 12.7071 21.1924L9.87868 24.0208C11.0503 25.1924 12.9497 25.1924 14.1213 24.0208L11.2929 21.1924ZM13.8995 18.5858L11.2929 21.1924L14.1213 24.0208L16.7279 21.4142L13.8995 18.5858ZM19 18H15.3137V22H19V18ZM21 16C21 17.1046 20.1046 18 19 18V22C22.3137 22 25 19.3137 25 16H21ZM21 5V16H25V5H21ZM19 3C20.1046 3 21 3.89543 21 5H25C25 1.68629 22.3137 -1 19 -1V3ZM5 3H19V-1H5V3Z\" fill=\"#688083\" mask=\"url(#path-1-inside-1_109_494)\"></path><path d=\"M12.8517 7.71186L12.8518 7.7117C13.8007 6.76277 15.3393 6.76275 16.2883 7.71172L16.2883 7.71173C17.1655 8.58893 17.2411 9.98617 16.4635 10.953C15.5441 12.096 14.9149 12.7252 13.7718 13.6446L13.7717 13.6446L12 15.0697L10.2282 13.6446C10.2282 13.6446 10.2282 13.6446 10.2282 13.6446C9.08516 12.7252 8.45595 12.096 7.53653 10.9529C6.75893 9.98618 6.83449 8.58896 7.71176 7.71173L7.71177 7.71172C8.66073 6.76276 10.1992 6.76276 11.1482 7.71172L11.2929 7.85639L11.9998 8.56335L12.7069 7.85653L12.8517 7.71186Z\" fill=\"#DFE4E5\" stroke=\"#688083\" stroke-width=\"2\"></path></svg>";

/***/ }),

/***/ "1a75":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.i, "@import url(https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css);"]);
exports.push([module.i, "@import url(https://cdn-prd.patientpop.com/pp-icon-font/v1.6.0/pp-icon-font.css);"]);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.pp-page-container[data-v-3662bbc0]{height:100%;overflow:auto}.pp-page-container--with-footer[data-v-3662bbc0]{height:calc(100% - 60px)}header+.pp-page-container--with-footer[data-v-3662bbc0]{height:calc(100% - 118px)}@media(min-width:600px){.page-container-loading[data-v-3662bbc0]{left:calc(50% + var(--pp-side-nav-width, 300px)/2)}}header[data-v-3662bbc0]{height:auto}footer[data-v-3662bbc0]{background:#fff;border-top:1px solid #d6d6d6;bottom:0;height:60px;position:fixed;width:100vw;z-index:5}@media(min-width:960px){footer[data-v-3662bbc0]{width:calc(100vw - var(--pp-side-nav-width, 300px))}}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "1a84":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("c8d5")

/**
 * @category Common Helpers
 * @summary Return the earliest of the given dates.
 *
 * @description
 * Return the earliest of the given dates.
 *
 * @param {...(Date|String|Number)} dates - the dates to compare
 * @returns {Date} the earliest of the dates
 *
 * @example
 * // Which of these dates is the earliest?
 * var result = min(
 *   new Date(1989, 6, 10),
 *   new Date(1987, 1, 11),
 *   new Date(1995, 6, 2),
 *   new Date(1990, 0, 1)
 * )
 * //=> Wed Feb 11 1987 00:00:00
 */
function min () {
  var dirtyDates = Array.prototype.slice.call(arguments)
  var dates = dirtyDates.map(function (dirtyDate) {
    return parse(dirtyDate)
  })
  var earliestTimestamp = Math.min.apply(null, dates)
  return new Date(earliestTimestamp)
}

module.exports = min


/***/ }),

/***/ "1a9d":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("225f");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("5bb9fd94", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "1abc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _VOverlay__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("a797");


/* harmony default export */ __webpack_exports__["a"] = (_VOverlay__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]);

/***/ }),

/***/ "1b2c":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("0e90");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("8f384d76", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "1b8f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpInputDateRangeMonthLayout_vue_vue_type_style_index_0_id_92c47fd6_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1f2f");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpInputDateRangeMonthLayout_vue_vue_type_style_index_0_id_92c47fd6_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpInputDateRangeMonthLayout_vue_vue_type_style_index_0_id_92c47fd6_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "1baa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("5530");
/* harmony import */ var _src_components_VList_VListItemGroup_sass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("899c");
/* harmony import */ var _src_components_VList_VListItemGroup_sass__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_src_components_VList_VListItemGroup_sass__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _VItemGroup_VItemGroup__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("604c");
/* harmony import */ var _mixins_colorable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("a9ad");
/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("58df");

// Styles
 // Extensions

 // Mixins

 // Utilities


/* harmony default export */ __webpack_exports__["a"] = (Object(_util_mixins__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(_VItemGroup_VItemGroup__WEBPACK_IMPORTED_MODULE_2__[/* BaseItemGroup */ "a"], _mixins_colorable__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"]).extend({
  name: 'v-list-item-group',
  provide: function provide() {
    return {
      isInGroup: true,
      listItemGroup: this
    };
  },
  computed: {
    classes: function classes() {
      return Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({}, _VItemGroup_VItemGroup__WEBPACK_IMPORTED_MODULE_2__[/* BaseItemGroup */ "a"].options.computed.classes.call(this)), {}, {
        'v-list-item-group': true
      });
    }
  },
  methods: {
    genData: function genData() {
      return this.setTextColor(this.color, Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({}, _VItemGroup_VItemGroup__WEBPACK_IMPORTED_MODULE_2__[/* BaseItemGroup */ "a"].options.methods.genData.call(this)), {}, {
        attrs: {
          role: 'listbox'
        }
      }));
    }
  }
}));

/***/ }),

/***/ "1baf":
/***/ (function(module, exports, __webpack_require__) {

var startOfWeek = __webpack_require__("c7ce")

/**
 * @category Week Helpers
 * @summary Are the given dates in the same week?
 *
 * @description
 * Are the given dates in the same week?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @param {Object} [options] - the object with options
 * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Boolean} the dates are in the same week
 *
 * @example
 * // Are 31 August 2014 and 4 September 2014 in the same week?
 * var result = isSameWeek(
 *   new Date(2014, 7, 31),
 *   new Date(2014, 8, 4)
 * )
 * //=> true
 *
 * @example
 * // If week starts with Monday,
 * // are 31 August 2014 and 4 September 2014 in the same week?
 * var result = isSameWeek(
 *   new Date(2014, 7, 31),
 *   new Date(2014, 8, 4),
 *   {weekStartsOn: 1}
 * )
 * //=> false
 */
function isSameWeek (dirtyDateLeft, dirtyDateRight, dirtyOptions) {
  var dateLeftStartOfWeek = startOfWeek(dirtyDateLeft, dirtyOptions)
  var dateRightStartOfWeek = startOfWeek(dirtyDateRight, dirtyOptions)

  return dateLeftStartOfWeek.getTime() === dateRightStartOfWeek.getTime()
}

module.exports = isSameWeek


/***/ }),

/***/ "1be4":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("d066");

module.exports = getBuiltIn('document', 'documentElement');


/***/ }),

/***/ "1c0b":
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') {
    throw TypeError(String(it) + ' is not a function');
  } return it;
};


/***/ }),

/***/ "1c4c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpDataTable_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cc40");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpDataTable_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpDataTable_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "1c75":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><mask id=\"path-1-inside-1_167_195\" fill=\"white\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5 1C2.79086 1 1 2.79086 1 5V16C1 18.2091 2.79086 20 5 20H8.68629L11.2929 22.6066C11.6834 22.9971 12.3166 22.9971 12.7071 22.6066L15.3137 20H19C21.2091 20 23 18.2091 23 16V5C23 2.79086 21.2091 1 19 1H5Z\"></path></mask><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5 1C2.79086 1 1 2.79086 1 5V16C1 18.2091 2.79086 20 5 20H8.68629L11.2929 22.6066C11.6834 22.9971 12.3166 22.9971 12.7071 22.6066L15.3137 20H19C21.2091 20 23 18.2091 23 16V5C23 2.79086 21.2091 1 19 1H5Z\" fill=\"white\"></path><path d=\"M8.68629 20L10.1005 18.5858L9.51472 18H8.68629V20ZM11.2929 22.6066L12.7071 21.1924L11.2929 22.6066ZM12.7071 22.6066L11.2929 21.1924L12.7071 22.6066ZM15.3137 20V18H14.4853L13.8995 18.5858L15.3137 20ZM3 5C3 3.89543 3.89543 3 5 3V-1C1.68629 -1 -1 1.68629 -1 5H3ZM3 16V5H-1V16H3ZM5 18C3.89543 18 3 17.1046 3 16H-1C-1 19.3137 1.68629 22 5 22V18ZM8.68629 18H5V22H8.68629V18ZM12.7071 21.1924L10.1005 18.5858L7.27208 21.4142L9.87868 24.0208L12.7071 21.1924ZM11.2929 21.1924C11.6834 20.8019 12.3166 20.8019 12.7071 21.1924L9.87868 24.0208C11.0503 25.1924 12.9497 25.1924 14.1213 24.0208L11.2929 21.1924ZM13.8995 18.5858L11.2929 21.1924L14.1213 24.0208L16.7279 21.4142L13.8995 18.5858ZM19 18H15.3137V22H19V18ZM21 16C21 17.1046 20.1046 18 19 18V22C22.3137 22 25 19.3137 25 16H21ZM21 5V16H25V5H21ZM19 3C20.1046 3 21 3.89543 21 5H25C25 1.68629 22.3137 -1 19 -1V3ZM5 3H19V-1H5V3Z\" fill=\"#079CB2\" mask=\"url(#path-1-inside-1_167_195)\"></path><path d=\"M12.8517 7.71186L12.8518 7.7117C13.8007 6.76277 15.3393 6.76275 16.2883 7.71172L16.2883 7.71173C17.1655 8.58893 17.2411 9.98617 16.4635 10.953C15.5441 12.096 14.9149 12.7252 13.7718 13.6446L13.7717 13.6446L12 15.0697L10.2282 13.6446C10.2282 13.6446 10.2282 13.6446 10.2282 13.6446C9.08516 12.7252 8.45595 12.096 7.53653 10.9529C6.75893 9.98618 6.83449 8.58896 7.71176 7.71173L7.71177 7.71172C8.66073 6.76276 10.1992 6.76276 11.1482 7.71172L11.2929 7.85639L11.9998 8.56335L12.7069 7.85653L12.8517 7.71186Z\" fill=\"#D5EAFD\" stroke=\"#079CB2\" stroke-width=\"2\"></path></svg>";

/***/ }),

/***/ "1c7e":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");

var ITERATOR = wellKnownSymbol('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR] = function () {
    return this;
  };
  // eslint-disable-next-line no-throw-literal
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

module.exports = function (exec, SKIP_CLOSING) {
  if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};


/***/ }),

/***/ "1c87":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("99af");
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("cca6");
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ac1f");
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("5319");
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_string_trim_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("498a");
/* harmony import */ var core_js_modules_es_string_trim_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_trim_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_string_link_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("9911");
/* harmony import */ var core_js_modules_es_string_link_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_link_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("ade3");
/* harmony import */ var _home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("5530");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("8bbf");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _directives_ripple__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("5607");
/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("80d2");








 // Directives

 // Utilities


/* harmony default export */ __webpack_exports__["a"] = (vue__WEBPACK_IMPORTED_MODULE_8___default.a.extend({
  name: 'routable',
  directives: {
    Ripple: _directives_ripple__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"]
  },
  props: {
    activeClass: String,
    append: Boolean,
    disabled: Boolean,
    exact: {
      type: Boolean,
      default: undefined
    },
    exactActiveClass: String,
    link: Boolean,
    href: [String, Object],
    to: [String, Object],
    nuxt: Boolean,
    replace: Boolean,
    ripple: {
      type: [Boolean, Object],
      default: null
    },
    tag: String,
    target: String
  },
  data: function data() {
    return {
      isActive: false,
      proxyClass: ''
    };
  },
  computed: {
    classes: function classes() {
      var classes = {};
      if (this.to) return classes;
      if (this.activeClass) classes[this.activeClass] = this.isActive;
      if (this.proxyClass) classes[this.proxyClass] = this.isActive;
      return classes;
    },
    computedRipple: function computedRipple() {
      var _this$ripple;

      return (_this$ripple = this.ripple) != null ? _this$ripple : !this.disabled && this.isClickable;
    },
    isClickable: function isClickable() {
      if (this.disabled) return false;
      return Boolean(this.isLink || this.$listeners.click || this.$listeners['!click'] || this.$attrs.tabindex);
    },
    isLink: function isLink() {
      return this.to || this.href || this.link;
    },
    styles: function styles() {
      return {};
    }
  },
  watch: {
    $route: 'onRouteChange'
  },
  methods: {
    click: function click(e) {
      this.$emit('click', e);
    },
    generateRouteLink: function generateRouteLink() {
      var _data;

      var exact = this.exact;
      var tag;
      var data = (_data = {
        attrs: {
          tabindex: 'tabindex' in this.$attrs ? this.$attrs.tabindex : undefined
        },
        class: this.classes,
        style: this.styles,
        props: {},
        directives: [{
          name: 'ripple',
          value: this.computedRipple
        }]
      }, Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])(_data, this.to ? 'nativeOn' : 'on', Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])({}, this.$listeners), {}, {
        click: this.click
      })), Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])(_data, "ref", 'link'), _data);

      if (typeof this.exact === 'undefined') {
        exact = this.to === '/' || this.to === Object(this.to) && this.to.path === '/';
      }

      if (this.to) {
        // Add a special activeClass hook
        // for component level styles
        var activeClass = this.activeClass;
        var exactActiveClass = this.exactActiveClass || activeClass;

        if (this.proxyClass) {
          activeClass = "".concat(activeClass, " ").concat(this.proxyClass).trim();
          exactActiveClass = "".concat(exactActiveClass, " ").concat(this.proxyClass).trim();
        }

        tag = this.nuxt ? 'nuxt-link' : 'router-link';
        Object.assign(data.props, {
          to: this.to,
          exact: exact,
          activeClass: activeClass,
          exactActiveClass: exactActiveClass,
          append: this.append,
          replace: this.replace
        });
      } else {
        tag = this.href && 'a' || this.tag || 'div';
        if (tag === 'a' && this.href) data.attrs.href = this.href;
      }

      if (this.target) data.attrs.target = this.target;
      return {
        tag: tag,
        data: data
      };
    },
    onRouteChange: function onRouteChange() {
      var _this = this;

      if (!this.to || !this.$refs.link || !this.$route) return;
      var activeClass = "".concat(this.activeClass, " ").concat(this.proxyClass || '').trim();
      var path = "_vnode.data.class.".concat(activeClass);
      this.$nextTick(function () {
        /* istanbul ignore else */
        if (Object(_util_helpers__WEBPACK_IMPORTED_MODULE_10__[/* getObjectValueByPath */ "p"])(_this.$refs.link, path)) {
          _this.toggle();
        }
      });
    },
    toggle: function toggle() {}
  }
}));

/***/ }),

/***/ "1c98":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("8312");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("54247528", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "1cc2":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("7ecb");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("f8fb9fb2", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "1cc6":
/***/ (function(module, exports, __webpack_require__) {

var addMilliseconds = __webpack_require__("ec1f")

var MILLISECONDS_IN_HOUR = 3600000

/**
 * @category Hour Helpers
 * @summary Add the specified number of hours to the given date.
 *
 * @description
 * Add the specified number of hours to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of hours to be added
 * @returns {Date} the new date with the hours added
 *
 * @example
 * // Add 2 hours to 10 July 2014 23:00:00:
 * var result = addHours(new Date(2014, 6, 10, 23, 0), 2)
 * //=> Fri Jul 11 2014 01:00:00
 */
function addHours (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addMilliseconds(dirtyDate, amount * MILLISECONDS_IN_HOUR)
}

module.exports = addHours


/***/ }),

/***/ "1cdc":
/***/ (function(module, exports, __webpack_require__) {

var userAgent = __webpack_require__("342f");

module.exports = /(iphone|ipod|ipad).*applewebkit/i.test(userAgent);


/***/ }),

/***/ "1d29":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c662cfac-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/multi-card/PpMultiCard.vue?vue&type=template&id=74fb8428&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-wrap justify-center justify-md-start",style:(("--pp-multi-card-width:" + _vm.width))},_vm._l((_vm.items),function(item,i){return _c('div',_vm._g({key:("item-" + i),staticClass:"pp-card pb-4 mx-4 my-4",class:{'pp-card__bg': !item.headerImage},attrs:{"draggable":item.isDraggable},on:{"click":function($event){return _vm.$emit('item-clicked', item.id)}}},_vm.$listeners),[(item.isDraggable)?_c('div',{staticClass:"pp-card__drag"},[_vm._m(0,true)]):_vm._e(),_c('div',{staticClass:"pp-card__image-container d-flex align-center justify-center",class:{'pp-card__image-container--bg': !item.headerImage}},[(_vm.icon && !item.headerImage || _vm.tile && item.initials)?_c('v-avatar',{staticClass:"pp-card__avatar",class:{ 'rounded-lg' : _vm.tile },attrs:{"size":64,"color":item.avatarColor}},[(_vm.icon)?_c('i',{staticClass:"pp-card__avatar__icon d-flex",class:("pp-icon-" + _vm.icon)}):(item.initials)?_c('span',{staticClass:"white--text text-h2"},[_vm._v(" "+_vm._s(item.initials)+" ")]):_vm._e()]):_vm._e(),(item.headerImage)?_c('img',{staticClass:"pp-card__image",attrs:{"alt":item.title,"src":item.headerImage}}):_vm._e()],1),_c('div',{staticClass:"pp-card__body px-4 pt-3"},[_c('p',{staticClass:"pp-card__title text-h6 font-weight-bold"},[_vm._v(" "+_vm._s(item.title)+" ")]),_c('div',{staticClass:"pp-card__subtitle-container d-flex align-center mt-1"},[(item.subtitle)?_c('p',{staticClass:"pp-card__subtitle"},[_vm._v(" "+_vm._s(item.subtitle)+" ")]):_vm._e(),(item.chipText)?_c('pp-status-chip',{staticClass:"pp-card__status-chip",attrs:{"text":item.chipText,"status":item.chipStatus}}):_vm._e()],1)])])}),0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pp-card__drag-icon"},[_c('div',{staticClass:"pp-card__drag-nibs"}),_c('div',{staticClass:"pp-card__drag-nibs"}),_c('div',{staticClass:"pp-card__drag-nibs"})])}]


// CONCATENATED MODULE: ./src/components/multi-card/PpMultiCard.vue?vue&type=template&id=74fb8428&scoped=true&

// EXTERNAL MODULE: ./src/components/statusChip/PpStatusChip.vue + 4 modules
var PpStatusChip = __webpack_require__("e921");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/multi-card/PpMultiCard.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var PpMultiCardvue_type_script_lang_js_ = ({
  name: 'PpMultiCard',
  components: {
    PpStatusChip: PpStatusChip["default"]
  },
  props: {
    /**
     * Sets the width of the card
     */
    width: {
      type: String,
      default: '240px'
    },

    /**
     * Items for card's list. Expected props: 'title', 'subtitle', 'id', 'headerImage', 'isDraggable', 'chipText' and 'chipStatus'
     */
    items: {
      type: Array,
      required: true
    },

    /**
     * Set icon for all cards
     */
    icon: {
      type: String,
      default: null
    },

    /**
     * Set avatar shape to be a tile
     */
    tile: {
      type: Boolean,
      default: false
    }
  }
});
// CONCATENATED MODULE: ./src/components/multi-card/PpMultiCard.vue?vue&type=script&lang=js&
 /* harmony default export */ var multi_card_PpMultiCardvue_type_script_lang_js_ = (PpMultiCardvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/multi-card/PpMultiCard.vue?vue&type=style&index=0&id=74fb8428&lang=scss&scoped=true&
var PpMultiCardvue_type_style_index_0_id_74fb8428_lang_scss_scoped_true_ = __webpack_require__("0784");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// EXTERNAL MODULE: ./node_modules/vuetify-loader/lib/runtime/installComponents.js
var installComponents = __webpack_require__("6544");
var installComponents_default = /*#__PURE__*/__webpack_require__.n(installComponents);

// EXTERNAL MODULE: ./node_modules/vuetify/lib/components/VAvatar/VAvatar.js
var VAvatar = __webpack_require__("8212");

// CONCATENATED MODULE: ./src/components/multi-card/PpMultiCard.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  multi_card_PpMultiCardvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "74fb8428",
  null
  
)

/* harmony default export */ var PpMultiCard = __webpack_exports__["default"] = (component.exports);

/* vuetify-loader */


installComponents_default()(component, {VAvatar: VAvatar["a" /* default */]})


/***/ }),

/***/ "1d80":
/***/ (function(module, exports) {

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on " + it);
  return it;
};


/***/ }),

/***/ "1da1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _asyncToGenerator; });
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("d3b7");
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("e6cf");
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_1__);



function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

/***/ }),

/***/ "1da9":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M3 2C1.897 2 1 2.99556 1 4.22222V19.7778C1 21.0033 1.897 22 3 22H21C22.103 22 23 21.0033 23 19.7778V4.22222C23 2.99556 22.103 2 21 2H3Z\" fill=\"#688083\"></path><rect x=\"3\" y=\"6\" width=\"18\" height=\"14\" fill=\"#DFE4E5\"></rect><rect width=\"9\" height=\"14\" transform=\"matrix(-1 0 0 1 12 6)\" fill=\"white\"></rect><path d=\"M13.7262 13.0758L16.3421 15.7438C18.8103 18.2592 20.3477 20.5127 19.9325 20.9318C19.5157 21.3509 17.2789 19.802 14.7821 17.3162C14.0686 16.6067 13.3948 15.936 12.7955 15.3395C12.5611 15.1061 12.3381 14.8841 12.1285 14.6755C11.9808 14.5282 12.02 14.3498 12.2024 14.2496C12.6658 13.9937 13.0479 13.6118 13.3019 13.1494C13.4022 12.9657 13.58 12.927 13.7262 13.0758Z\" fill=\"#688083\"></path><path d=\"M11.2631 10.1998C11.9926 10.3737 12.5209 11.0722 12.5209 11.8231C12.5209 12.7084 11.7703 13.4661 10.8441 13.4661C9.28854 13.4661 8.2372 10.7836 8.01488 9.41775C7.94328 8.98043 8.13395 8.8802 8.50399 9.1467C9.27218 9.69813 10.2663 9.94836 11.0189 10.1378C11.1036 10.1591 11.1852 10.1797 11.2631 10.1998Z\" fill=\"#688083\"></path></svg>";

/***/ }),

/***/ "1dde":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");
var wellKnownSymbol = __webpack_require__("b622");
var V8_VERSION = __webpack_require__("2d00");

var SPECIES = wellKnownSymbol('species');

module.exports = function (METHOD_NAME) {
  // We can't use this feature detection in V8 since it causes
  // deoptimization and serious performance degradation
  // https://github.com/zloirock/core-js/issues/677
  return V8_VERSION >= 51 || !fails(function () {
    var array = [];
    var constructor = array.constructor = {};
    constructor[SPECIES] = function () {
      return { foo: 1 };
    };
    return array[METHOD_NAME](Boolean).foo !== 1;
  });
};


/***/ }),

/***/ "1de1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpInputTimeRange_vue_vue_type_style_index_0_id_3acf988e_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("fc18");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpInputTimeRange_vue_vue_type_style_index_0_id_3acf988e_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpInputTimeRange_vue_vue_type_style_index_0_id_3acf988e_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "1e7c":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("b688");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("7f991985", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "1e94":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.theme--light.v-slider .v-slider__thumb,.theme--light.v-slider .v-slider__track-background,.theme--light.v-slider .v-slider__track-fill{background:rgba(0,0,0,.26)}.theme--dark.v-slider .v-slider__thumb,.theme--dark.v-slider .v-slider__track-background,.theme--dark.v-slider .v-slider__track-fill{background:hsla(0,0%,100%,.2)}.v-slider{cursor:default;display:flex;align-items:center;position:relative;flex:1;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.v-slider input{cursor:default;padding:0;width:100%;display:none}.v-slider__track-container{position:absolute;border-radius:0}.v-slider__thumb-container,.v-slider__track-background,.v-slider__track-fill{position:absolute;transition:.3s cubic-bezier(.25,.8,.5,1)}.v-slider__thumb-container{outline:none;top:50%}.v-slider__thumb-container:hover .v-slider__thumb:before{transform:scale(1)}.v-slider__thumb{width:12px;height:12px;left:-6px;top:50%;transform:translateY(-50%);-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.v-slider__thumb,.v-slider__thumb:before{position:absolute;border-radius:50%;transition:.3s cubic-bezier(.25,.8,.5,1)}.v-slider__thumb:before{content:\"\";color:inherit;width:36px;height:36px;background:currentColor;opacity:.3;left:-12px;top:-12px;transform:scale(.1);pointer-events:none}.v-slider__tick,.v-slider__ticks-container{position:absolute}.v-slider__tick{opacity:0;background-color:rgba(0,0,0,.5);transition:.3s cubic-bezier(.25,.8,.5,1);border-radius:0}.v-slider__tick--filled{background-color:hsla(0,0%,100%,.5)}.v-application--is-ltr .v-slider__tick:first-child .v-slider__tick-label{transform:none}.v-application--is-rtl .v-slider__tick:first-child .v-slider__tick-label{transform:translateX(100%)}.v-application--is-ltr .v-slider__tick:last-child .v-slider__tick-label{transform:translateX(-100%)}.v-application--is-rtl .v-slider__tick:last-child .v-slider__tick-label{transform:none}.v-slider__tick-label{position:absolute;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;white-space:nowrap}.v-slider__thumb-label-container{top:0}.v-slider__thumb-label,.v-slider__thumb-label-container{position:absolute;left:0;transition:.3s cubic-bezier(.25,.8,.25,1)}.v-slider__thumb-label{display:flex;align-items:center;justify-content:center;font-size:.75rem;color:#fff;width:32px;height:32px;border-radius:50% 50% 0;bottom:100%;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.v-slider--horizontal{min-height:32px;margin-left:8px;margin-right:8px}.v-slider--horizontal .v-slider__track-container{width:100%;height:2px;left:0;top:50%;transform:translateY(-50%)}.v-slider--horizontal .v-slider__track-background,.v-slider--horizontal .v-slider__track-fill{height:100%}.v-slider--horizontal .v-slider__ticks-container{left:0;height:2px;width:100%}.v-application--is-ltr .v-slider--horizontal .v-slider__tick:first-child .v-slider__tick-label,.v-application--is-rtl .v-slider--horizontal .v-slider__tick:first-child .v-slider__tick-label{transform:translateX(0)}.v-application--is-ltr .v-slider--horizontal .v-slider__tick:last-child .v-slider__tick-label{transform:translateX(-100%)}.v-application--is-rtl .v-slider--horizontal .v-slider__tick:last-child .v-slider__tick-label{transform:translateX(100%)}.v-slider--horizontal .v-slider__tick .v-slider__tick-label{top:8px}.v-application--is-ltr .v-slider--horizontal .v-slider__tick .v-slider__tick-label{transform:translateX(-50%)}.v-application--is-rtl .v-slider--horizontal .v-slider__tick .v-slider__tick-label{transform:translateX(50%)}.v-slider--horizontal .v-slider__thumb-label{transform:translateY(-20%) translateY(-12px) translateX(-50%) rotate(45deg)}.v-slider--horizontal .v-slider__thumb-label>*{transform:rotate(-45deg)}.v-slider--vertical{min-height:150px;margin-top:12px;margin-bottom:12px}.v-slider--vertical .v-slider__track-container{height:100%;width:2px;left:50%;top:0;transform:translateX(-50%)}.v-slider--vertical .v-slider__track-background,.v-slider--vertical .v-slider__track-fill{width:100%}.v-slider--vertical .v-slider__thumb-container{left:50%}.v-slider--vertical .v-slider__ticks-container{top:0;width:2px;height:100%;left:50%;transform:translateX(-50%)}.v-application--is-ltr .v-slider--vertical .v-slider__tick .v-slider__tick-label,.v-application--is-ltr .v-slider--vertical .v-slider__tick:first-child .v-slider__tick-label,.v-application--is-ltr .v-slider--vertical .v-slider__tick:last-child .v-slider__tick-label{transform:translateY(-50%);left:12px}.v-application--is-rtl .v-slider--vertical .v-slider__tick .v-slider__tick-label,.v-application--is-rtl .v-slider--vertical .v-slider__tick:first-child .v-slider__tick-label,.v-application--is-rtl .v-slider--vertical .v-slider__tick:last-child .v-slider__tick-label{transform:translateY(-50%);right:12px}.v-slider--vertical .v-slider__thumb-label>*{transform:rotate(-135deg)}.v-slider__thumb-container--focused .v-slider__thumb:before{transform:scale(1)}.v-slider--active .v-slider__tick{opacity:1}.v-slider__thumb-container--active .v-slider__thumb:before{transform:scale(1.5)!important}.v-slider--disabled{pointer-events:none}.v-slider--disabled .v-slider__thumb{width:8px;height:8px;left:-4px}.v-slider--disabled .v-slider__thumb:before{display:none}.v-slider__ticks-container--always-show .v-slider__tick{opacity:1}.v-input__slider.v-input--is-readonly>.v-input__control{pointer-events:none}.v-application--is-ltr .v-input__slider .v-input__slot .v-label{margin-left:0;margin-right:12px}.v-application--is-ltr .v-input__slider--inverse-label .v-input__slot .v-label,.v-application--is-rtl .v-input__slider .v-input__slot .v-label{margin-right:0;margin-left:12px}.v-application--is-rtl .v-input__slider--inverse-label .v-input__slot .v-label{margin-left:0;margin-right:12px}.v-input__slider--vertical{align-items:center}.v-application--is-ltr .v-input__slider--vertical{flex-direction:column-reverse}.v-application--is-rtl .v-input__slider--vertical{flex-direction:column}.v-input__slider--vertical .v-input__append-outer,.v-input__slider--vertical .v-input__prepend-outer,.v-input__slider--vertical .v-input__slot{margin:0}.v-input__slider--vertical .v-messages{display:none}.v-input--has-state .v-slider__track-background{opacity:.4}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "1ef8":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("c302");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("e14d447c", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "1f09":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("f44b");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("27539a63", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "1f2f":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("b626");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("521a4a91", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "1fd7":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M9 10H22L21.5 19L13.4715 20.5439C10.9347 21.0318 8.6077 19.023 8.71991 16.4422L9 10Z\" fill=\"white\"></path><path d=\"M3 2C2.44772 2 2 2.44772 2 3V13C2 13.5523 2.44772 14 3 14H7V11C7 9.34315 8.34315 8 10 8H18V3C18 2.44772 17.5523 2 17 2H3Z\" fill=\"#DFE4E5\"></path><path d=\"M13 13H11V15H13V13Z\" fill=\"#1F3A3E\"></path><path d=\"M16 13H14V15H16V13Z\" fill=\"#1F3A3E\"></path><path d=\"M17 13H19V15H17V13Z\" fill=\"#1F3A3E\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M17 1H3C1.89543 1 1 1.89543 1 3V13C1 14.1046 1.89543 15 3 15H7V17C7 18.5977 8.24892 19.9037 9.82373 19.9949L9.999 20L10 22.0005C10 22.1704 10.0433 22.3376 10.1258 22.4861C10.3941 22.9689 11.0029 23.1429 11.4856 22.8746L16.659 20H20C21.6569 20 23 18.6569 23 17V11C23 9.34315 21.6569 8 20 8H19V3C19 1.89543 18.1046 1 17 1ZM7 11V13H3V4.49959L8.07206 8.70142C7.41664 9.25174 7 10.0772 7 11ZM9.99663 10C9.44589 10.0018 9 10.4488 9 11V17C9 17.5301 9.41451 17.9678 9.88181 17.9958L11.998 18.0572L11.9992 20.3013L16.1407 18H20C20.5523 18 21 17.5523 21 17V11C21 10.4477 20.5523 10 20 10L9.99663 10ZM17 4.31709L12.7033 8H17V4.31709ZM15.4634 3H4.32487L9.98903 7.69234L15.4634 3Z\" fill=\"#1F3A3E\"></path></svg>";

/***/ }),

/***/ "207f":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("2ba3");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("1687f9c0", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "2093":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c662cfac-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/notification/PpNotification.vue?vue&type=template&id=b4d17398&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"slide-fade"}},[(_vm.show)?_c('v-row',{staticClass:"notification",class:{ 'notification--light': _vm.light }},[_c('i',{staticClass:"notification__icon",class:("pp-icon-" + _vm.icon + " notification__icon--" + (_vm.notification.status) + " notification__icon--" + _vm.iconSize),attrs:{"aria-hidden":"true"}}),_c('v-col',{staticClass:"notification__content"},[(_vm.showTitle)?_c('h4',[_vm._v(" "+_vm._s(_vm.notification.title)+" ")]):_vm._e(),_c('p',{staticClass:"notification__message",class:{ 'notification__message--no-title': !_vm.showTitle },domProps:{"innerHTML":_vm._s(_vm.notification.message)}})]),_c('pp-button',{staticClass:"notification__close",attrs:{"absolute":"","bottom":"","icon":"close","type":"icon"},on:{"click":function($event){_vm.show = false}}})],1):_vm._e()],1)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/notification/PpNotification.vue?vue&type=template&id=b4d17398&scoped=true&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.index-of.js
var es_array_index_of = __webpack_require__("c975");

// EXTERNAL MODULE: ./src/components/button/PpButton.vue + 5 modules
var PpButton = __webpack_require__("251c");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/notification/PpNotification.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var PpNotificationvue_type_script_lang_js_ = ({
  name: 'PpNotification',
  components: {
    'pp-button': PpButton["default"]
  },
  props: {
    /**
     * Should be an object with properties: <br>
     *  - title: String <br>
     *  - message: String | Html, <br>
     *  - status: 'success' | 'warning' | 'error', <br>
     *  - duration: Number
     */
    notification: {
      type: Object,
      default: function _default() {
        return {
          message: 'Message',
          status: 'error',
          duration: 3500
        };
      },
      validator: function validator(value) {
        return ['success', 'warning', 'error'].indexOf(value.status) !== -1;
      },
      required: true
    },

    /**
     * Sets the notification light theme
     */
    light: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      show: false
    };
  },
  computed: {
    icon: function icon() {
      var _this$notification;

      switch ((_this$notification = this.notification) === null || _this$notification === void 0 ? void 0 : _this$notification.status) {
        case 'success':
          return 'check';

        case 'warning':
          return 'clock';

        default:
          return 'info-circle';
      }
    },
    showTitle: function showTitle() {
      var _this$notification2;

      return !!((_this$notification2 = this.notification) !== null && _this$notification2 !== void 0 && _this$notification2.title);
    },
    iconSize: function iconSize() {
      return this.showTitle ? 'medium' : 'small';
    }
  },
  watch: {
    notification: {
      immediate: true,
      deep: true,
      handler: function handler(notification) {
        var _this = this;

        if (notification.message) {
          this.show = true;
          setTimeout(function () {
            _this.show = false;
          }, notification.duration);
        }
      }
    }
  }
});
// CONCATENATED MODULE: ./src/components/notification/PpNotification.vue?vue&type=script&lang=js&
 /* harmony default export */ var notification_PpNotificationvue_type_script_lang_js_ = (PpNotificationvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/notification/PpNotification.vue?vue&type=style&index=0&id=b4d17398&lang=scss&scoped=true&
var PpNotificationvue_type_style_index_0_id_b4d17398_lang_scss_scoped_true_ = __webpack_require__("c6f2");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// EXTERNAL MODULE: ./node_modules/vuetify-loader/lib/runtime/installComponents.js
var installComponents = __webpack_require__("6544");
var installComponents_default = /*#__PURE__*/__webpack_require__.n(installComponents);

// EXTERNAL MODULE: ./node_modules/vuetify/lib/components/VGrid/VCol.js
var VCol = __webpack_require__("62ad");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/components/VGrid/VRow.js
var VRow = __webpack_require__("0fd9");

// CONCATENATED MODULE: ./src/components/notification/PpNotification.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  notification_PpNotificationvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "b4d17398",
  null
  
)

/* harmony default export */ var PpNotification = __webpack_exports__["default"] = (component.exports);

/* vuetify-loader */



installComponents_default()(component, {VCol: VCol["a" /* default */],VRow: VRow["a" /* default */]})


/***/ }),

/***/ "2096":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.i, "@import url(https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css);"]);
exports.push([module.i, "@import url(https://cdn-prd.patientpop.com/pp-icon-font/v1.6.0/pp-icon-font.css);"]);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.pp-conversation[data-v-6ca91290]{display:flex;flex-direction:column;height:100%}.pp-conversation__messages[data-v-6ca91290]{border-bottom:1px solid #d6d6d6;border-top:1px solid #d6d6d6;display:flex;flex-direction:column-reverse;flex-grow:1;overflow:auto}.pp-conversation__messages__empty[data-v-6ca91290]{height:100%}.pp-conversation__messages__empty img[data-v-6ca91290]{width:4em}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "20b1":
/***/ (function(module, exports, __webpack_require__) {

var startOfDay = __webpack_require__("0978")

/**
 * @category Day Helpers
 * @summary Is the given date tomorrow?
 *
 * @description
 * Is the given date tomorrow?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is tomorrow
 *
 * @example
 * // If today is 6 October 2014, is 7 October 14:00:00 tomorrow?
 * var result = isTomorrow(new Date(2014, 9, 7, 14, 0))
 * //=> true
 */
function isTomorrow (dirtyDate) {
  var tomorrow = new Date()
  tomorrow.setDate(tomorrow.getDate() + 1)
  return startOfDay(dirtyDate).getTime() === startOfDay(tomorrow).getTime()
}

module.exports = isTomorrow


/***/ }),

/***/ "20cf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c662cfac-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/input/image-upload/PpInputImageUpload.vue?vue&type=template&id=7bed88e3&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pp-input-image-upload"},[_c('div',{staticClass:"d-flex pp-input-image-upload__container"},[_c('div',{staticClass:"pp-input-image-upload__wrapper d-flex align-center flex-column rounded-lg",class:_vm.imageState,style:({'width': _vm.inputWidth}),on:{"drop":function($event){$event.preventDefault();return _vm.fileChange($event)},"dragleave":function($event){$event.preventDefault();return _vm.leavingFile($event)},"dragover":function($event){$event.preventDefault();return _vm.draggingFile($event)},"mouseenter":function($event){!_vm.isError ? _vm.showDeleteOverlay = true : false},"mouseleave":function($event){!_vm.isError ? _vm.showDeleteOverlay = false : true}}},[_c('label',{staticClass:"pp-input-image-upload__label font-weight-bold d-flex align-center flex-column justify-center"},[(!_vm.isUploading)?_c('i',{staticClass:"d-flex text-h1 pp-input-image-upload__action-icon",class:!_vm.isError ? 'pp-input-image-upload__action-icon--add pp-icon-add-img' : 'pp-input-image-upload__action-icon--alert pp-icon-alert',attrs:{"aria-hidden":"true"}}):_vm._e(),(_vm.isError && !_vm.isUploading)?_c('span',{staticClass:"d-flex flex-column align-center"},[_vm._v(" "+_vm._s(_vm.errorMessage.title)+" "),_c('span',{staticClass:"blue--text"},[_vm._v(_vm._s(_vm.errorMessage.description))])]):(!_vm.isUploading)?_c('span',{staticClass:"d-flex flex-column align-center"},[_c('span',{staticClass:"pp-input-image-upload__label"},[_vm._v("Upload")])]):_vm._e(),_c('input',{staticClass:"pp-input-image-upload__input",attrs:{"accept":_vm.formats,"type":"file"},domProps:{"value":_vm.inputValue},on:{"change":_vm.fileChange}}),(_vm.internalImageUrl && !_vm.isError)?_c('img',{staticClass:"pp-input-image-upload__image rounded-lg",attrs:{"src":_vm.internalImageUrl,"alt":_vm.imageAlt}}):_vm._e(),(_vm.isUploading)?_c('pp-loader',{attrs:{"size":30}}):_vm._e()],1),(_vm.showOverlay)?_c('div',{staticClass:"pp-input-image-upload__delete-overlay rounded-lg"},[_c('pp-button',{staticClass:"pp-input-image-upload__delete-button red",attrs:{"type":"secondary","icon":"delete"},on:{"click":_vm.clearFile}})],1):_vm._e()]),(_vm.showInputText)?_c('div',{staticClass:"flex-grow-1 ml-5"},[_c('span',{staticClass:"pp-input-image-upload__description"},[_vm._v(" Image Description ")]),_c('pp-input-text',_vm._b({staticClass:"flex-grow-1 mt-2",attrs:{"placeholder":_vm.placeholder,"hint":("Image size should be between " + _vm.minWidth + " x " + _vm.minHeight + " and " + _vm.maxWidth + " x " + _vm.maxHeight),"persistent-hint":true},on:{"change":_vm.updateDescriptionValue},model:{value:(_vm.$attrs.description),callback:function ($$v) {_vm.$set(_vm.$attrs, "description", $$v)},expression:"$attrs.description"}},'pp-input-text',_vm.inputAttrs,false))],1):_vm._e()]),(_vm.showHelperText)?_c('p',{staticClass:"pp-input-image-upload__specs mt-3"},[_vm._v(" Image size should be between "+_vm._s(_vm.minWidth)+" x "+_vm._s(_vm.minHeight)+" and "+_vm._s(_vm.maxWidth)+" x "+_vm._s(_vm.maxHeight)+" ")]):_vm._e()])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/input/image-upload/PpInputImageUpload.vue?vue&type=template&id=7bed88e3&scoped=true&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("caad");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.index-of.js
var es_array_index_of = __webpack_require__("c975");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__("e260");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__("a9e3");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("d3b7");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("2532");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__("3ca3");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.trim.js
var es_string_trim = __webpack_require__("498a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__("ddb0");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.url.js
var web_url = __webpack_require__("2b3d");

// EXTERNAL MODULE: ./src/components/button/PpButton.vue + 5 modules
var PpButton = __webpack_require__("251c");

// EXTERNAL MODULE: ./src/components/loader/PpLoader.vue + 4 modules
var PpLoader = __webpack_require__("d888");

// EXTERNAL MODULE: ./src/components/input/text/PpInputText.vue + 4 modules
var PpInputText = __webpack_require__("ac90");

// CONCATENATED MODULE: ./src/components/input/image-upload/constants.js
var UPLOADING = 'uploading';
var COMPLETE = 'complete';
var ERROR = 'error';
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/input/image-upload/PpInputImageUpload.vue?vue&type=script&lang=js&










//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var PpInputImageUploadvue_type_script_lang_js_ = ({
  name: 'PpInputImageUpload',
  components: {
    'pp-button': PpButton["default"],
    'pp-loader': PpLoader["default"],
    'pp-input-text': PpInputText["default"]
  },
  model: {
    prop: 'inputImage',
    event: 'change'
  },
  props: {
    /**
     * The image File selected. This prop will be used for v-model
     */
    inputImage: {
      type: File,
      default: null
    },

    /**
     * A url of an image to display inside the preview box
     */
    imageUrl: {
      type: String,
      default: null
    },

    /**
     * A list of allowable file formats to be used with this component.
     * Each string should correspond with File.type
     */
    formats: {
      type: Array,
      default: function _default() {
        return ['image/jpg', 'image/jpeg', 'image/png'];
      }
    },

    /**
     * Sets the limit min width of the image
     */
    minWidth: {
      type: Number,
      default: 0
    },

    /**
     * Sets the limit max width of the image
     */
    maxWidth: {
      type: Number,
      default: 1000
    },

    /**
     * Sets the limit min height of the image
     */
    minHeight: {
      type: Number,
      default: 0
    },

    /**
     * Sets the limit max height of the image
     */
    maxHeight: {
      type: Number,
      default: 600
    },

    /**
     * Toggle on and off the remove button icon from input
     */
    showRemove: {
      type: Boolean,
      default: true
    },

    /**
     * Toggle on and off the helper text below the input
     */
    showHelperText: {
      type: Boolean,
      default: true
    },

    /**
     * Status of Image Upload: ['', UPLOADING, COMPLETE, ERROR]
     * empty is default state
     */
    status: {
      type: String,
      default: '',
      validator: function validator(value) {
        return ['', UPLOADING, COMPLETE, ERROR].indexOf(value) !== -1;
      }
    },

    /**
     * Sets the alt value for image
     */
    imageAlt: {
      type: String,
      default: ''
    },

    /**
     * Sets red bg on image input. Not related to `isError` STATUS.
     */
    showImageError: {
      type: Boolean,
      default: false
    },

    /**
     * Sets the width of the image input
     */
    inputWidth: {
      type: String,
      default: '160px'
    },

    /**
     * Toggle on/of input text with description on the right
     */
    showInputText: {
      type: Boolean,
      default: false
    },

    /**
     * Add placeholder text into description input
     */
    placeholder: {
      type: String,
      default: 'Image description goes here...'
    },
    inputAttrs: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      inputValue: '',
      // used to allow the clearing of the input
      internalImageUrl: null,
      isDragging: false,
      showDeleteOverlay: false,
      internalStatus: '',
      errorMessage: {
        title: 'Image larger',
        description: 'than expected'
      }
    };
  },
  computed: {
    isUploading: function isUploading() {
      return this.internalStatus === UPLOADING;
    },
    isComplete: function isComplete() {
      return this.internalStatus === COMPLETE;
    },
    isError: function isError() {
      return this.internalStatus === ERROR;
    },
    showOverlay: function showOverlay() {
      return this.internalImageUrl && this.showDeleteOverlay && !this.isError && this.showRemove;
    },
    imageState: function imageState() {
      if (this.showImageError) {
        return 'pp-input-image-upload--image-error';
      }

      if (this.internalImageUrl && !this.isError) {
        return 'pp-input-image-upload--thumbnail';
      }

      if (this.isError) {
        return 'pp-input-image-upload--error';
      }

      if (this.isDragging) {
        return 'pp-input-image-upload--dragging';
      }

      return null;
    }
  },
  watch: {
    status: {
      immediate: true,
      handler: function handler(newValue) {
        this.internalStatus = newValue;
      }
    }
  },
  created: function created() {
    if (this.imageUrl) {
      this.internalStatus = COMPLETE;
      this.internalImageUrl = this.imageUrl;
    }
  },
  methods: {
    clearFile: function clearFile() {
      this.$emit('clear', this.internalImageUrl);
      this.internalImageUrl = null;
      this.clearStatus();
    },
    getInputImage: function getInputImage(e) {
      var _e$target, _e$target$files, _e$dataTransfer, _e$dataTransfer$files, _e$originalEvent, _e$originalEvent$data;

      if ((_e$target = e.target) !== null && _e$target !== void 0 && (_e$target$files = _e$target.files) !== null && _e$target$files !== void 0 && _e$target$files.length) {
        return e.target.files[0];
      } else if ((_e$dataTransfer = e.dataTransfer) !== null && _e$dataTransfer !== void 0 && (_e$dataTransfer$files = _e$dataTransfer.files) !== null && _e$dataTransfer$files !== void 0 && _e$dataTransfer$files.length) {
        return e.dataTransfer.files[0];
      }

      return e === null || e === void 0 ? void 0 : (_e$originalEvent = e.originalEvent) === null || _e$originalEvent === void 0 ? void 0 : (_e$originalEvent$data = _e$originalEvent.dataTransfer) === null || _e$originalEvent$data === void 0 ? void 0 : _e$originalEvent$data.files[0];
    },
    setImage: function setImage(inputImage) {
      var _this = this;

      this.setThumbnail(inputImage);
      var reader = new FileReader();
      reader.readAsDataURL(inputImage);

      reader.onload = function (evt) {
        var img = new Image();

        img.onload = function () {
          if (img.width > _this.maxWidth || img.height > _this.maxHeight) {
            _this.handleError('Image exceeds maximum dimensions');

            _this.errorMessage = {
              title: 'Image larger',
              description: 'than expected'
            };
          } else if (img.width < _this.minWidth || img.height < _this.minHeight) {
            _this.handleError('Image below minimum dimensions');

            _this.errorMessage = {
              title: 'Image smaller',
              description: 'than expected'
            };
          }
        };

        _this.$emit('change', inputImage);

        img.src = evt.target.result;

        _this.clearStatus();
      };
    },
    setThumbnail: function setThumbnail(inputImage) {
      if (typeof inputImage === 'string') {
        this.internalImageUrl = inputImage;
        return;
      }

      this.internalImageUrl = URL.createObjectURL(inputImage);
    },
    fileChange: function fileChange(e) {
      var inputImage = this.getInputImage(e);

      if (!inputImage) {
        return;
      }

      if (!this.formats.includes(inputImage.type)) {
        this.handleError("Image type ".concat(inputImage.type, " not supported"));
        this.errorMessage = {
          title: 'Image type',
          description: 'not supported'
        };
        return;
      }

      this.setImage(inputImage);
    },
    clearStatus: function clearStatus() {
      this.internalStatus = '';
    },
    handleError: function handleError(message) {
      this.internalStatus = ERROR;
      this.$emit('error', message);
    },
    leavingFile: function leavingFile() {
      this.isDragging = false;
    },
    draggingFile: function draggingFile() {
      this.isDragging = true;
    },
    updateDescriptionValue: function updateDescriptionValue(event) {
      this.$emit('input', event.trim());
    }
  }
});
// CONCATENATED MODULE: ./src/components/input/image-upload/PpInputImageUpload.vue?vue&type=script&lang=js&
 /* harmony default export */ var image_upload_PpInputImageUploadvue_type_script_lang_js_ = (PpInputImageUploadvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/input/image-upload/PpInputImageUpload.vue?vue&type=style&index=0&id=7bed88e3&lang=scss&scoped=true&
var PpInputImageUploadvue_type_style_index_0_id_7bed88e3_lang_scss_scoped_true_ = __webpack_require__("abdf");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/input/image-upload/PpInputImageUpload.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  image_upload_PpInputImageUploadvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "7bed88e3",
  null
  
)

/* harmony default export */ var PpInputImageUpload = __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "20f6":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("4c51");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("36265086", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "2102":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("9a42");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("121ebf32", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "210b":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("a493");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("b8b8db44", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "21be":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("99af");
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("caad");
/* harmony import */ var core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("2532");
/* harmony import */ var core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("2909");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("8bbf");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("80d2");






/* @vue/component */

/* harmony default export */ __webpack_exports__["a"] = (vue__WEBPACK_IMPORTED_MODULE_4___default.a.extend().extend({
  name: 'stackable',
  data: function data() {
    return {
      stackElement: null,
      stackExclude: null,
      stackMinZIndex: 0,
      isActive: false
    };
  },
  computed: {
    activeZIndex: function activeZIndex() {
      if (typeof window === 'undefined') return 0;
      var content = this.stackElement || this.$refs.content; // Return current zindex if not active

      var index = !this.isActive ? Object(_util_helpers__WEBPACK_IMPORTED_MODULE_5__[/* getZIndex */ "u"])(content) : this.getMaxZIndex(this.stackExclude || [content]) + 2;
      if (index == null) return index; // Return max current z-index (excluding self) + 2
      // (2 to leave room for an overlay below, if needed)

      return parseInt(index);
    }
  },
  methods: {
    getMaxZIndex: function getMaxZIndex() {
      var exclude = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var base = this.$el; // Start with lowest allowed z-index or z-index of
      // base component's element, whichever is greater

      var zis = [this.stackMinZIndex, Object(_util_helpers__WEBPACK_IMPORTED_MODULE_5__[/* getZIndex */ "u"])(base)]; // Convert the NodeList to an array to
      // prevent an Edge bug with Symbol.iterator
      // https://github.com/vuetifyjs/vuetify/issues/2146

      var activeElements = [].concat(Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(document.getElementsByClassName('v-menu__content--active')), Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(document.getElementsByClassName('v-dialog__content--active'))); // Get z-index for all active dialogs

      for (var index = 0; index < activeElements.length; index++) {
        if (!exclude.includes(activeElements[index])) {
          zis.push(Object(_util_helpers__WEBPACK_IMPORTED_MODULE_5__[/* getZIndex */ "u"])(activeElements[index]));
        }
      }

      return Math.max.apply(Math, zis);
    }
  }
}));

/***/ }),

/***/ "21dd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return viewport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return weekCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getDayIndexInMonth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getDayCell; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isValidISO8601; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getISO8601String; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return isoStringToDate; });
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("fb6a");
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("a9e3");
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ac1f");
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_string_split_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("1276");
/* harmony import */ var core_js_modules_es_string_split_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("9ede");
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("340b");
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(date_fns__WEBPACK_IMPORTED_MODULE_5__);






var viewport = function viewport() {
  var e = window;
  var a = 'inner';

  if (!('innerWidth' in window)) {
    a = 'client';
    e = document.documentElement || document.body;
  }

  return {
    width: e[a + 'Width'],
    height: e[a + 'Height']
  };
};
function weekCount(year, monthNumber) {
  var firstOfMonth = new Date(year, monthNumber, 1);
  var lastOfMonth = new Date(year, monthNumber + 1, 0);
  var used = firstOfMonth.getDay() + lastOfMonth.getDate();
  return Math.ceil(used / 7);
}
function getDayIndexInMonth(week, day, startMonthDay) {
  var date = _constants__WEBPACK_IMPORTED_MODULE_4__[/* NUM_OF_DAYS */ "h"] * (week - 1) + day;
  return date - startMonthDay;
}
function getDayCell(week, day, startMonthDay, endMonthDate) {
  var result = getDayIndexInMonth(week, day, startMonthDay);
  return result > 0 && result <= endMonthDate ? result : '';
}
function isValidISO8601(str) {
  if (!str) {
    return false;
  }

  var year = str.slice(0, 4);
  var month = Number(str.slice(5, 7));
  var day = Number(str.slice(8, 10));
  return !isNaN(year) && !isNaN(month) && !isNaN(day) && month > 0 && month < 13 && day > 0 && day < 32;
}
function getISO8601String(date) {
  return Object(date_fns__WEBPACK_IMPORTED_MODULE_5__["format"])(date, _constants__WEBPACK_IMPORTED_MODULE_4__[/* ISO_8601 */ "f"]);
}
function isoStringToDate(isoString) {
  var dateParts = isoString.split(/\D+/);
  return new Date(parseInt(dateParts[0]), parseInt(dateParts[1] - 1), parseInt(dateParts[2]));
}

/***/ }),

/***/ "225f":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.i, "@import url(https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css);"]);
exports.push([module.i, "@import url(https://cdn-prd.patientpop.com/pp-icon-font/v1.6.0/pp-icon-font.css);"]);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.slide-fade-enter-active[data-v-b4d17398],.slide-fade-leave-active[data-v-b4d17398]{transition:all .3s ease}.slide-fade-enter[data-v-b4d17398],.slide-fade-leave-to[data-v-b4d17398]{opacity:0;transform:translateY(3em)}.notification[data-v-b4d17398]{--notification-bg:#2b2b2b;--notification-border:none;--title-color:#fff;--message-color:#fff;background:var(--notification-bg);border:var(--notification-border);border-radius:5px;bottom:1em;box-shadow:0 3px 6px rgba(74,84,114,.2);color:var(--title-color);margin:0;max-width:55%;min-height:3.5em;min-width:20ch;padding:1em;position:fixed;right:1em;z-index:1000}@media(max-width:600px){.notification[data-v-b4d17398]{max-width:100%}}.notification--light[data-v-b4d17398]{--notification-bg:#fff;--notification-border:1px solid #d6d6d6;--title-color:#2b2b2b;--message-color:#545454}.notification__icon[data-v-b4d17398]{align-items:center;border-radius:50%;color:#fff;display:flex;justify-content:center;margin-right:1em}.notification__icon--success[data-v-b4d17398]{background:#3fa266}.notification__icon--warning[data-v-b4d17398]{background:#fcde73}.notification__icon--error[data-v-b4d17398]{background:#d83b4d}.notification__icon--medium[data-v-b4d17398]{height:2.5em;margin-top:.3em;width:2.5em}.notification__icon--small[data-v-b4d17398]{height:1.5em;width:1.5em}.notification__icon--small[data-v-b4d17398]:before{font-size:.75rem}.notification__content[data-v-b4d17398]{padding:0;padding-right:2.5em}.notification__message[data-v-b4d17398]{color:var(--message-color);margin-bottom:0}.notification__message--no-title[data-v-b4d17398]{color:var(--title-color);font-weight:700}.notification__message[data-v-b4d17398]  a{color:#079cb2}.notification__close[data-v-b4d17398]{font-size:.6em;right:1em;top:1em;--active-icon:#545454}.notification__close[data-v-b4d17398]  i:before{font-weight:700!important}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "2266":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("825a");
var isArrayIteratorMethod = __webpack_require__("e95a");
var toLength = __webpack_require__("50c4");
var bind = __webpack_require__("0366");
var getIteratorMethod = __webpack_require__("35a1");
var iteratorClose = __webpack_require__("2a62");

var Result = function (stopped, result) {
  this.stopped = stopped;
  this.result = result;
};

module.exports = function (iterable, unboundFunction, options) {
  var that = options && options.that;
  var AS_ENTRIES = !!(options && options.AS_ENTRIES);
  var IS_ITERATOR = !!(options && options.IS_ITERATOR);
  var INTERRUPTED = !!(options && options.INTERRUPTED);
  var fn = bind(unboundFunction, that, 1 + AS_ENTRIES + INTERRUPTED);
  var iterator, iterFn, index, length, result, next, step;

  var stop = function (condition) {
    if (iterator) iteratorClose(iterator);
    return new Result(true, condition);
  };

  var callFn = function (value) {
    if (AS_ENTRIES) {
      anObject(value);
      return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
    } return INTERRUPTED ? fn(value, stop) : fn(value);
  };

  if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod(iterable);
    if (typeof iterFn != 'function') throw TypeError('Target is not iterable');
    // optimisation for array iterators
    if (isArrayIteratorMethod(iterFn)) {
      for (index = 0, length = toLength(iterable.length); length > index; index++) {
        result = callFn(iterable[index]);
        if (result && result instanceof Result) return result;
      } return new Result(false);
    }
    iterator = iterFn.call(iterable);
  }

  next = iterator.next;
  while (!(step = next.call(iterator)).done) {
    try {
      result = callFn(step.value);
    } catch (error) {
      iteratorClose(iterator);
      throw error;
    }
    if (typeof result == 'object' && result && result instanceof Result) return result;
  } return new Result(false);
};


/***/ }),

/***/ "2299":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("c8d5")

/**
 * @category Second Helpers
 * @summary Return the start of a second for the given date.
 *
 * @description
 * Return the start of a second for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of a second
 *
 * @example
 * // The start of a second for 1 December 2014 22:15:45.400:
 * var result = startOfSecond(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:45.000
 */
function startOfSecond (dirtyDate) {
  var date = parse(dirtyDate)
  date.setMilliseconds(0)
  return date
}

module.exports = startOfSecond


/***/ }),

/***/ "22c4":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.i, "@import url(https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css);"]);
exports.push([module.i, "@import url(https://cdn-prd.patientpop.com/pp-icon-font/v1.6.0/pp-icon-font.css);"]);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.pp-chart-horizontal-slide__progress[data-v-624fcc47]{height:.75rem;position:relative;width:100%;background-color:#d6d6d6;border:0;border-radius:3px}.pp-chart-horizontal-slide__progress[data-v-624fcc47]::-webkit-progress-bar{background-color:#d6d6d6;border:0;border-radius:3px}.pp-chart-horizontal-slide__progress[data-v-624fcc47]::-webkit-progress-value{background-color:var(--pp-slide-chart-color);border:0;border-radius:3px 0 0 3px}.pp-chart-horizontal-slide__progress[data-v-624fcc47]::-moz-progress-bar{background-color:var(--pp-slide-chart-color);border:0;border-radius:3px 0 0 3px}.pp-chart-horizontal-slide__marker[data-v-624fcc47]:before{border-left:5px solid transparent;border-right:5px solid transparent;border-top:8px solid #2b2b2b;content:\"\";height:10px;margin-left:calc(var(--pp-slide-chart-margin-left)*100% - 4px);position:absolute;top:0;width:5px}.pp-chart-horizontal-slide__marker[data-v-624fcc47]:after{background:#2b2b2b;content:\"\";height:.75rem;margin-left:calc(var(--pp-slide-chart-margin-left)*100%);position:absolute;top:.3625rem;width:2px}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "22da":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _VProgressCircular__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("490a");


/* harmony default export */ __webpack_exports__["a"] = (_VProgressCircular__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]);

/***/ }),

/***/ "231c":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("c8d5")

/**
 * @category Second Helpers
 * @summary Get the seconds of the given date.
 *
 * @description
 * Get the seconds of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the seconds
 *
 * @example
 * // Get the seconds of 29 February 2012 11:45:05.123:
 * var result = getSeconds(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 5
 */
function getSeconds (dirtyDate) {
  var date = parse(dirtyDate)
  var seconds = date.getSeconds()
  return seconds
}

module.exports = getSeconds


/***/ }),

/***/ "234b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c662cfac-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/shortcut/edit/PpShortcutEdit.vue?vue&type=template&id=15904b24&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pp-dialog',{attrs:{"attach":_vm.attach,"disable-primary-button":!_vm.isFormValid,"is-form":true,"loading":_vm.loading,"max-width":500,"prepend-title-icon":_vm.titleIcon,"title":(_vm.titleAction + " Shortcut"),"value":_vm.$attrs.value,"primary-button-text":"Save","secondary-button-text":"Cancel"},on:{"close":function($event){return _vm.closeDialog($event)},"confirm":_vm.saveShortcut},scopedSlots:_vm._u([{key:"body",fn:function(){return [_c('pp-input-text',{attrs:{"counter":40,"error-messages":_vm.titleErrorMessages,"validate-on-blur":true,"label":"Title"},on:{"blur":_vm.getErrorMessagesTitle,"focus":_vm.resetTitleValidation},model:{value:(_vm.shortcutToEdit.title),callback:function ($$v) {_vm.$set(_vm.shortcutToEdit, "title", $$v)},expression:"shortcutToEdit.title"}}),_c('pp-input-textarea',{attrs:{"error-messages":_vm.contentErrorMessages,"validate-on-blur":true,"label":"Content"},on:{"blur":_vm.getErrorMessagesContent,"focus":_vm.resetContentValidation},model:{value:(_vm.shortcutToEdit.content),callback:function ($$v) {_vm.$set(_vm.shortcutToEdit, "content", $$v)},expression:"shortcutToEdit.content"}})]},proxy:true}])})}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/shortcut/edit/PpShortcutEdit.vue?vue&type=template&id=15904b24&

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__("5530");

// EXTERNAL MODULE: ./src/components/dialog/PpDialog.vue + 5 modules
var PpDialog = __webpack_require__("bdf9");

// EXTERNAL MODULE: ./src/components/input/text/PpInputText.vue + 4 modules
var PpInputText = __webpack_require__("ac90");

// EXTERNAL MODULE: ./src/components/input/textarea/PpInputTextarea.vue + 5 modules
var PpInputTextarea = __webpack_require__("d696");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/shortcut/edit/PpShortcutEdit.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var PpShortcutEditvue_type_script_lang_js_ = ({
  name: 'PpShortcutEdit',
  components: {
    'pp-dialog': PpDialog["default"],
    'pp-input-text': PpInputText["default"],
    'pp-input-textarea': PpInputTextarea["default"]
  },
  props: {
    shortcut: {
      type: Object,
      default: function _default() {
        return {
          title: '',
          content: ''
        };
      }
    },

    /** Used to show custom error message from parent component */
    customErrorMessage: {
      type: String,
      default: ''
    },
    saving: {
      type: Boolean,
      default: false
    },

    /** Attach dialog to HTML element eg .pp-composer **/
    attach: {
      type: [String, Boolean],
      default: false
    }
  },
  data: function data() {
    return {
      titleErrorMessages: [],
      contentErrorMessages: [],
      isSaving: false,
      originalShortcut: {},
      shortcutToEdit: {
        id: '',
        title: '',
        content: ''
      }
    };
  },
  computed: {
    loading: function loading() {
      return this.isSaving || this.saving;
    },
    titleIcon: function titleIcon() {
      return this.shortcutToEdit.id ? 'edit' : 'plus';
    },
    titleAction: function titleAction() {
      return this.shortcutToEdit.id ? 'Edit' : 'Add';
    },
    isFormValid: function isFormValid() {
      if (!this.shortcutToEdit.title) {
        return false;
      } else if (!this.shortcutToEdit.content) {
        return false;
      } else {
        return this.shortcutToEdit.title.length <= 40;
      }
    }
  },
  watch: {
    saving: {
      handler: function handler(val) {
        if (val === false) {
          this.isSaving = val;

          if (!this.customErrorMessage) {
            this.closeDialog();
          }
        }
      }
    },
    customErrorMessage: {
      immediate: true,
      handler: function handler(val) {
        // if no custom error on change, then clear the validation
        if (!val) {
          this.resetTitleValidation();
        } else {
          this.titleErrorMessages = [val];
          this.$ppAnalytics.trackEvent({
            category: 'shortcuts',
            action: this.titleAction.toLowerCase(),
            label: "error: ".concat(val)
          });
        }
      }
    },
    shortcut: {
      immediate: true,
      handler: function handler(val) {
        this.shortcutToEdit = Object(objectSpread2["a" /* default */])({}, val);
      }
    }
  },
  methods: {
    closeDialog: function closeDialog(e) {
      this.shortcutToEdit = Object(objectSpread2["a" /* default */])({}, this.shortcut);

      if (e !== 'key-escape') {
        this.$ppAnalytics.trackEvent({
          category: 'shortcuts',
          action: this.titleAction.toLowerCase(),
          label: 'close'
        });
        this.$emit('input', false);
      }
    },
    saveShortcut: function saveShortcut() {
      this.isSaving = true;
      this.$ppAnalytics.trackEvent({
        category: 'shortcuts',
        action: this.titleAction.toLowerCase(),
        label: 'save'
      });
      this.$emit('save', this.shortcutToEdit);
    },
    resetTitleValidation: function resetTitleValidation() {
      this.titleErrorMessages = [];
    },
    resetContentValidation: function resetContentValidation() {
      this.contentErrorMessages = [];
    },
    getErrorMessagesTitle: function getErrorMessagesTitle() {
      if (!this.shortcutToEdit.title) {
        this.titleErrorMessages = ['Title is required'];
        return false;
      }

      if (this.shortcutToEdit.title.length > 40) {
        this.titleErrorMessages = ['Title must be less than 40'];
        return false;
      }

      return true;
    },
    getErrorMessagesContent: function getErrorMessagesContent() {
      if (!this.shortcutToEdit.content) {
        this.contentErrorMessages = ['Content is required'];
        return false;
      }

      return true;
    }
  }
});
// CONCATENATED MODULE: ./src/components/shortcut/edit/PpShortcutEdit.vue?vue&type=script&lang=js&
 /* harmony default export */ var edit_PpShortcutEditvue_type_script_lang_js_ = (PpShortcutEditvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/shortcut/edit/PpShortcutEdit.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  edit_PpShortcutEditvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var PpShortcutEdit = __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "23b5":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("34ea");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("64ccae48", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "23c7":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.v-color-picker__edit{margin-top:8px;display:flex}.v-color-picker__input{width:100%;display:flex;flex-wrap:wrap;justify-content:center;text-align:center}.v-application--is-ltr .v-color-picker__input:not(:last-child){margin-right:4px}.v-application--is-rtl .v-color-picker__input:not(:last-child){margin-left:4px}.v-color-picker__input input{border-radius:5px;margin-bottom:8px;min-width:0;outline:none;text-align:center;width:100%;height:28px}.v-color-picker__input span{font-size:.75rem}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "23cb":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("a691");

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function (index, length) {
  var integer = toInteger(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};


/***/ }),

/***/ "23e7":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var getOwnPropertyDescriptor = __webpack_require__("06cf").f;
var createNonEnumerableProperty = __webpack_require__("9112");
var redefine = __webpack_require__("6eeb");
var setGlobal = __webpack_require__("ce4e");
var copyConstructorProperties = __webpack_require__("e893");
var isForced = __webpack_require__("94ca");

/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
*/
module.exports = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global;
  } else if (STATIC) {
    target = global[TARGET] || setGlobal(TARGET, {});
  } else {
    target = (global[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.noTargetGet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty === typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    // extend global
    redefine(target, key, sourceProperty, options);
  }
};


/***/ }),

/***/ "241c":
/***/ (function(module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__("ca84");
var enumBugKeys = __webpack_require__("7839");

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};


/***/ }),

/***/ "24b2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("a9e3");
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("80d2");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("8bbf");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_2__);

// Helpers
 // Types


/* harmony default export */ __webpack_exports__["a"] = (vue__WEBPACK_IMPORTED_MODULE_2___default.a.extend({
  name: 'measurable',
  props: {
    height: [Number, String],
    maxHeight: [Number, String],
    maxWidth: [Number, String],
    minHeight: [Number, String],
    minWidth: [Number, String],
    width: [Number, String]
  },
  computed: {
    measurableStyles: function measurableStyles() {
      var styles = {};
      var height = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_1__[/* convertToUnit */ "g"])(this.height);
      var minHeight = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_1__[/* convertToUnit */ "g"])(this.minHeight);
      var minWidth = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_1__[/* convertToUnit */ "g"])(this.minWidth);
      var maxHeight = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_1__[/* convertToUnit */ "g"])(this.maxHeight);
      var maxWidth = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_1__[/* convertToUnit */ "g"])(this.maxWidth);
      var width = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_1__[/* convertToUnit */ "g"])(this.width);
      if (height) styles.height = height;
      if (minHeight) styles.minHeight = minHeight;
      if (minWidth) styles.minWidth = minWidth;
      if (maxHeight) styles.maxHeight = maxHeight;
      if (maxWidth) styles.maxWidth = maxWidth;
      if (width) styles.width = width;
      return styles;
    }
  }
}));

/***/ }),

/***/ "24e5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpInputTextarea_vue_vue_type_style_index_0_id_62f2f138_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("17b6");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpInputTextarea_vue_vue_type_style_index_0_id_62f2f138_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpInputTextarea_vue_vue_type_style_index_0_id_62f2f138_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "24f3":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.theme--light.v-divider{border-color:#d6d6d6}.theme--dark.v-divider{border-color:hsla(0,0%,100%,.12)}.v-divider{display:block;flex:1 1 0px;max-width:100%;height:0;max-height:0;border:solid;border-width:thin 0 0 0;transition:inherit}.v-divider--inset:not(.v-divider--vertical){max-width:calc(100% - 72px)}.v-application--is-ltr .v-divider--inset:not(.v-divider--vertical){margin-left:72px}.v-application--is-rtl .v-divider--inset:not(.v-divider--vertical){margin-right:72px}.v-divider--vertical{align-self:stretch;border:solid;border-width:0 thin 0 0;display:inline-flex;height:inherit;min-height:100%;max-height:100%;max-width:0;width:0;vertical-align:text-bottom}.v-divider--vertical.v-divider--inset{margin-top:8px;min-height:0;max-height:calc(100% - 16px)}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "24fb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
// eslint-disable-next-line func-names
module.exports = function (useSourceMap) {
  var list = []; // return the list of modules as css string

  list.toString = function toString() {
    return this.map(function (item) {
      var content = cssWithMappingToString(item, useSourceMap);

      if (item[2]) {
        return "@media ".concat(item[2], " {").concat(content, "}");
      }

      return content;
    }).join('');
  }; // import a list of modules into the list
  // eslint-disable-next-line func-names


  list.i = function (modules, mediaQuery, dedupe) {
    if (typeof modules === 'string') {
      // eslint-disable-next-line no-param-reassign
      modules = [[null, modules, '']];
    }

    var alreadyImportedModules = {};

    if (dedupe) {
      for (var i = 0; i < this.length; i++) {
        // eslint-disable-next-line prefer-destructuring
        var id = this[i][0];

        if (id != null) {
          alreadyImportedModules[id] = true;
        }
      }
    }

    for (var _i = 0; _i < modules.length; _i++) {
      var item = [].concat(modules[_i]);

      if (dedupe && alreadyImportedModules[item[0]]) {
        // eslint-disable-next-line no-continue
        continue;
      }

      if (mediaQuery) {
        if (!item[2]) {
          item[2] = mediaQuery;
        } else {
          item[2] = "".concat(mediaQuery, " and ").concat(item[2]);
        }
      }

      list.push(item);
    }
  };

  return list;
};

function cssWithMappingToString(item, useSourceMap) {
  var content = item[1] || ''; // eslint-disable-next-line prefer-destructuring

  var cssMapping = item[3];

  if (!cssMapping) {
    return content;
  }

  if (useSourceMap && typeof btoa === 'function') {
    var sourceMapping = toComment(cssMapping);
    var sourceURLs = cssMapping.sources.map(function (source) {
      return "/*# sourceURL=".concat(cssMapping.sourceRoot || '').concat(source, " */");
    });
    return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
  }

  return [content].join('\n');
} // Adapted from convert-source-map (MIT)


function toComment(sourceMap) {
  // eslint-disable-next-line no-undef
  var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
  var data = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(base64);
  return "/*# ".concat(data, " */");
}

/***/ }),

/***/ "2507":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("c8d5")

/**
 * @category Weekday Helpers
 * @summary Is the given date Monday?
 *
 * @description
 * Is the given date Monday?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is Monday
 *
 * @example
 * // Is 22 September 2014 Monday?
 * var result = isMonday(new Date(2014, 8, 22))
 * //=> true
 */
function isMonday (dirtyDate) {
  return parse(dirtyDate).getDay() === 1
}

module.exports = isMonday


/***/ }),

/***/ "251c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c662cfac-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/button/PpButton.vue?vue&type=template&id=c5417a2a&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',_vm._g(_vm._b({class:_vm.cssClass,attrs:{"type":_vm.submit ? 'submit' : 'button',"aria-label":_vm.useAriaLabel}},'v-btn',_vm.attributes,false),_vm.$listeners),[(_vm.showPrependIcon)?_c('i',{staticClass:"mr-2 d-inline-flex pp-button__embed-icon",class:_vm.prependIconClass}):(_vm.isAdd)?_c('i',{staticClass:"pp-icon-plus d-flex rounded-circle white pa-2 mx-2 primary--text"}):_vm._e(),(!_vm.isIcon)?[_vm._t("text",[_vm._v(" "+_vm._s(_vm.text)+" ")])]:_vm._e(),(_vm.icon)?_c('i',{staticClass:"d-flex",class:_vm.iconClass}):_vm._e(),(_vm.showAppendIcon)?_c('i',{staticClass:"ml-2 d-inline-flex pp-button__embed-icon",class:_vm.appendIconClass}):_vm._e()],2)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/button/PpButton.vue?vue&type=template&id=c5417a2a&scoped=true&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("99af");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.index-of.js
var es_array_index_of = __webpack_require__("c975");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__("5530");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("ade3");

// EXTERNAL MODULE: ./src/styles/colors.scss
var colors = __webpack_require__("1c98");
var colors_default = /*#__PURE__*/__webpack_require__.n(colors);

// CONCATENATED MODULE: ./src/components/button/constants.js


var _ATTRIBUTES;

 // Button types

var PRIMARY = 'primary';
var SECONDARY = 'secondary';
var TERTIARY = 'tertiary';
var CAUTION = 'caution';
var PLAIN = 'plain';
var ICON = 'icon';
var ADD = 'add';
var HOVER = 'hover';
var WARNING = 'warning';
var POSITIVE = 'positive'; // Button Type Attributes

var ATTRIBUTES = (_ATTRIBUTES = {}, Object(defineProperty["a" /* default */])(_ATTRIBUTES, PRIMARY, {
  color: 'primary',
  depressed: ''
}), Object(defineProperty["a" /* default */])(_ATTRIBUTES, PLAIN, {
  color: colors_default.a.practice,
  plain: ''
}), Object(defineProperty["a" /* default */])(_ATTRIBUTES, SECONDARY, {
  outlined: ''
}), Object(defineProperty["a" /* default */])(_ATTRIBUTES, TERTIARY, {
  text: '',
  depressed: ''
}), Object(defineProperty["a" /* default */])(_ATTRIBUTES, CAUTION, {
  color: colors_default.a.firstAid,
  dark: true
}), Object(defineProperty["a" /* default */])(_ATTRIBUTES, ICON, {
  ripple: false,
  icon: ''
}), Object(defineProperty["a" /* default */])(_ATTRIBUTES, ADD, {
  ripple: false,
  color: 'white',
  block: '',
  depressed: ''
}), Object(defineProperty["a" /* default */])(_ATTRIBUTES, HOVER, {
  outlined: ''
}), Object(defineProperty["a" /* default */])(_ATTRIBUTES, POSITIVE, {
  color: colors_default.a.vigor,
  dark: true
}), Object(defineProperty["a" /* default */])(_ATTRIBUTES, WARNING, {
  color: colors_default.a.energize
}), _ATTRIBUTES);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/button/PpButton.vue?vue&type=script&lang=js&



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var PpButtonvue_type_script_lang_js_ = ({
  name: 'PpButton',
  props: {
    /**
     * Type of button: [primary, secondary, tertiary, icon, add, hover, positive, warning]
     * (If type==icon will need an icon prop)
     */
    type: {
      type: String,
      validator: function validator(value) {
        return [PRIMARY, SECONDARY, TERTIARY, PLAIN, CAUTION, ICON, ADD, HOVER, POSITIVE, WARNING].indexOf(value) !== -1;
      },
      required: true
    },

    /**
     * Button Label for primary/secondary/tertiary
     */
    text: {
      type: String,
      default: null
    },

    /**
     * Prop used for buttons with type === 'icon'
     * This prop should not be used for primary, secondary or tertiary buttons - use `prependIcon` or `appendIcon` instead
     * pulls from pp-font icon
     */
    icon: {
      type: String,
      default: null
    },

    /**
     * If present will on the left of the text for primary/secondary/tertiary
     * pulls from pp-font icon
     */
    prependIcon: {
      type: String,
      default: null
    },

    /**
     * If present will on the right of the text for primary/secondary/tertiary
     * pulls from pp-font icon
     */
    appendIcon: {
      type: String,
      default: null
    },

    /**
     * Determine if button is submit or normal button
     */
    submit: {
      type: Boolean,
      default: false
    },

    /**
     * Add custom aria-label to button
     */
    ariaLabel: {
      type: String,
      default: null
    }
  },
  data: function data() {
    return {
      outlined: this.$attrs.outlined
    };
  },
  computed: {
    iconAddingAllowed: function iconAddingAllowed() {
      return [PRIMARY, SECONDARY, TERTIARY, PLAIN, CAUTION, HOVER, POSITIVE, WARNING].indexOf(this.type) !== -1;
    },
    isIcon: function isIcon() {
      return this.type === ICON;
    },
    isAdd: function isAdd() {
      return this.type === ADD;
    },
    iconClass: function iconClass() {
      return "".concat(this.getIconClass(this.icon));
    },
    showPrependIcon: function showPrependIcon() {
      return this.iconAddingAllowed && this.prependIcon;
    },
    showAppendIcon: function showAppendIcon() {
      return this.iconAddingAllowed && this.appendIcon;
    },
    prependIconClass: function prependIconClass() {
      return this.getIconClass(this.prependIcon);
    },
    appendIconClass: function appendIconClass() {
      return this.getIconClass(this.appendIcon);
    },
    attributes: function attributes() {
      return Object(objectSpread2["a" /* default */])(Object(objectSpread2["a" /* default */])({}, this.$attrs), ATTRIBUTES[this.type]);
    },
    cssClass: function cssClass() {
      var baseClass = 'pp-button';
      var outlineClass = this.outlined ? " ".concat(baseClass, "--").concat(this.type, "--outlined") : '';
      var withIconClass = this.icon && this.type !== ICON ? ' v-btn--fab v-btn--round' : '';
      return "".concat(baseClass, " ").concat(baseClass, "--").concat(this.type).concat(outlineClass).concat(withIconClass);
    },
    useAriaLabel: function useAriaLabel() {
      return this.ariaLabel || this.icon || null;
    }
  },
  mounted: function mounted() {
    if (this.type === ICON && !this.icon) {
      console.error('Buttons with "icon" type require an icon prop');
    }

    if (this.type === ICON && (this.prependIcon || this.appendIcon)) {
      console.warn('Buttons with "icon" type will not render appended or prepended icons');
    }

    if (this.type === ICON && this.text) {
      console.warn('Buttons with "icon" type will not render text');
    }

    if (this.type === ADD && (this.icon || this.prependIcon || this.appendIcon)) {
      console.warn('Buttons with "add" type will not render icons passed via props');
    }
  },
  methods: {
    getIconClass: function getIconClass(icon) {
      return icon ? "pp-icon-".concat(icon) : null;
    }
  }
});
// CONCATENATED MODULE: ./src/components/button/PpButton.vue?vue&type=script&lang=js&
 /* harmony default export */ var button_PpButtonvue_type_script_lang_js_ = (PpButtonvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/button/PpButton.vue?vue&type=style&index=0&id=c5417a2a&lang=scss&scoped=true&
var PpButtonvue_type_style_index_0_id_c5417a2a_lang_scss_scoped_true_ = __webpack_require__("8d24");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// EXTERNAL MODULE: ./node_modules/vuetify-loader/lib/runtime/installComponents.js
var installComponents = __webpack_require__("6544");
var installComponents_default = /*#__PURE__*/__webpack_require__.n(installComponents);

// EXTERNAL MODULE: ./node_modules/vuetify/lib/components/VBtn/VBtn.js
var VBtn = __webpack_require__("8336");

// CONCATENATED MODULE: ./src/components/button/PpButton.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  button_PpButtonvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "c5417a2a",
  null
  
)

/* harmony default export */ var PpButton = __webpack_exports__["default"] = (component.exports);

/* vuetify-loader */


installComponents_default()(component, {VBtn: VBtn["a" /* default */]})


/***/ }),

/***/ "2532":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var notARegExp = __webpack_require__("5a34");
var requireObjectCoercible = __webpack_require__("1d80");
var correctIsRegExpLogic = __webpack_require__("ab13");

// `String.prototype.includes` method
// https://tc39.es/ecma262/#sec-string.prototype.includes
$({ target: 'String', proto: true, forced: !correctIsRegExpLogic('includes') }, {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~String(requireObjectCoercible(this))
      .indexOf(notARegExp(searchString), arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "2587":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("85c7");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("6660e97e", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "2598":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c662cfac-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/page-header/PpPageHeader.vue?vue&type=template&id=1ca6b76c&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"mb-5 d-flex align-center flex-wrap pp-page-header",class:{'pp-page-header--not-full-width' : !_vm.fullWidth}},[(_vm.mobileTitle)?_c('div',{staticClass:"pp-page-header__mobile d-flex d-md-none align-center pl-15"},[_vm._v(" "+_vm._s(_vm.mobileTitle)+" ")]):_vm._e(),_c('div',{staticClass:"pa-5 px-md-5 py-md-0 align-center mb-md-0 pp-page-header__title-area",class:_vm.hideTitleOnMobile ? 'd-none d-md-flex' : 'd-flex'},[_vm._t("title",[(_vm.backButton)?_c('pp-button',{staticClass:"mr-2",attrs:{"data-testid":"page-header-back-btn","type":"secondary","icon":"arrow--back"},on:{"click":_vm.goBack}}):_vm._e(),_c('h1',{staticClass:"text-h1 text-truncate mb-0"},[_vm._v(" "+_vm._s(_vm.title)+" "),(_vm.subtitle)?_c('span',{staticClass:"text-h6 d-block"},[_vm._v(" "+_vm._s(_vm.subtitle)+" ")]):_vm._e()])])],2),_vm._t("topNav"),(_vm.showActions)?_c('div',{staticClass:"pa-5 text-right flex-grow-1 align-center page-header__actions-area"},[_vm._t("actions",[(_vm.headerCtaText)?_c('pp-button',{attrs:{"type":"primary","prepend-icon":_vm.headerCtaIcon,"text":_vm.headerCtaText},on:{"click":function($event){return _vm.$emit('cta')}}}):_vm._e()])],2):_vm._e()],2)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/page-header/PpPageHeader.vue?vue&type=template&id=1ca6b76c&scoped=true&

// EXTERNAL MODULE: ./src/components/button/PpButton.vue + 5 modules
var PpButton = __webpack_require__("251c");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/page-header/PpPageHeader.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var PpPageHeadervue_type_script_lang_js_ = ({
  name: 'PpPageHeader',
  components: {
    'pp-button': PpButton["default"]
  },
  props: {
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      default: ''
    },

    /**
     * The `mobileTitle` prop is optional.
     * If UI case doesn't require to display title in mobile mode may not pass value to `mobileTitle` props,
     * will not render corresponding HTML element
     */
    mobileTitle: {
      type: String,
      default: ''
    },
    headerCtaText: {
      type: String,
      default: ''
    },
    headerCtaIcon: {
      type: String,
      default: 'plus'
    },

    /**
     * Show the back button
     */
    backButton: {
      type: Boolean,
      default: false
    },

    /**
     * Will default to going back one on route
     */
    backActionDefault: {
      type: Boolean,
      default: true
    },

    /**
     * On mobile hide title area
     */
    hideTitleOnMobile: {
      type: Boolean,
      default: false
    },

    /**
     * if full width container is being used
     */
    fullWidth: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    showActions: function showActions() {
      return this.headerCtaText || this.$slots.actions;
    }
  },
  methods: {
    goBack: function goBack() {
      this.$emit('back'); // default go back one on route

      if (this.backActionDefault) {
        this.$router.go(-1);
      }
    }
  }
});
// CONCATENATED MODULE: ./src/components/page-header/PpPageHeader.vue?vue&type=script&lang=js&
 /* harmony default export */ var page_header_PpPageHeadervue_type_script_lang_js_ = (PpPageHeadervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/page-header/PpPageHeader.vue?vue&type=style&index=0&id=1ca6b76c&lang=scss&scoped=true&
var PpPageHeadervue_type_style_index_0_id_1ca6b76c_lang_scss_scoped_true_ = __webpack_require__("9141");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/page-header/PpPageHeader.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  page_header_PpPageHeadervue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "1ca6b76c",
  null
  
)

/* harmony default export */ var PpPageHeader = __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "25a8":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("ceca");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("36f3a950", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "25ba":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("4f6e");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("4f05f4c4", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "25f0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefine = __webpack_require__("6eeb");
var anObject = __webpack_require__("825a");
var fails = __webpack_require__("d039");
var flags = __webpack_require__("ad6d");

var TO_STRING = 'toString';
var RegExpPrototype = RegExp.prototype;
var nativeToString = RegExpPrototype[TO_STRING];

var NOT_GENERIC = fails(function () { return nativeToString.call({ source: 'a', flags: 'b' }) != '/a/b'; });
// FF44- RegExp#toString has a wrong name
var INCORRECT_NAME = nativeToString.name != TO_STRING;

// `RegExp.prototype.toString` method
// https://tc39.es/ecma262/#sec-regexp.prototype.tostring
if (NOT_GENERIC || INCORRECT_NAME) {
  redefine(RegExp.prototype, TO_STRING, function toString() {
    var R = anObject(this);
    var p = String(R.source);
    var rf = R.flags;
    var f = String(rf === undefined && R instanceof RegExp && !('flags' in RegExpPrototype) ? flags.call(R) : rf);
    return '/' + p + '/' + f;
  }, { unsafe: true });
}


/***/ }),

/***/ "2626":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var getBuiltIn = __webpack_require__("d066");
var definePropertyModule = __webpack_require__("9bf2");
var wellKnownSymbol = __webpack_require__("b622");
var DESCRIPTORS = __webpack_require__("83ab");

var SPECIES = wellKnownSymbol('species');

module.exports = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn(CONSTRUCTOR_NAME);
  var defineProperty = definePropertyModule.f;

  if (DESCRIPTORS && Constructor && !Constructor[SPECIES]) {
    defineProperty(Constructor, SPECIES, {
      configurable: true,
      get: function () { return this; }
    });
  }
};


/***/ }),

/***/ "26d5":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("c8d5")

/**
 * @category Year Helpers
 * @summary Are the given dates in the same year?
 *
 * @description
 * Are the given dates in the same year?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same year
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same year?
 * var result = isSameYear(
 *   new Date(2014, 8, 2),
 *   new Date(2014, 8, 25)
 * )
 * //=> true
 */
function isSameYear (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)
  return dateLeft.getFullYear() === dateRight.getFullYear()
}

module.exports = isSameYear


/***/ }),

/***/ "271a":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("c8d5")

/**
 * @category Hour Helpers
 * @summary Return the end of an hour for the given date.
 *
 * @description
 * Return the end of an hour for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of an hour
 *
 * @example
 * // The end of an hour for 2 September 2014 11:55:00:
 * var result = endOfHour(new Date(2014, 8, 2, 11, 55))
 * //=> Tue Sep 02 2014 11:59:59.999
 */
function endOfHour (dirtyDate) {
  var date = parse(dirtyDate)
  date.setMinutes(59, 59, 999)
  return date
}

module.exports = endOfHour


/***/ }),

/***/ "2739":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.v-autocomplete.v-input>.v-input__control>.v-input__slot{cursor:text}.v-autocomplete input{align-self:center}.v-autocomplete.v-select.v-input--is-focused input{min-width:64px}.v-autocomplete:not(.v-input--is-focused).v-select--chips input{max-height:0;padding:0}.v-autocomplete--is-selecting-index input{opacity:0}.v-autocomplete.v-text-field--enclosed:not(.v-text-field--solo):not(.v-text-field--single-line):not(.v-text-field--outlined) .v-select__slot>input{margin-top:24px}.v-autocomplete.v-text-field--enclosed:not(.v-text-field--solo):not(.v-text-field--single-line):not(.v-text-field--outlined).v-input--dense .v-select__slot>input{margin-top:20px}.v-autocomplete:not(.v-input--is-disabled).v-select.v-text-field input{pointer-events:inherit}.v-autocomplete__content.v-menu__content,.v-autocomplete__content.v-menu__content .v-card{border-radius:0}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "2774":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4 19.9999V14.9999H5C5.265 14.9999 5.52 14.8939 5.707 14.7069L7 13.4139L9.293 15.7069C9.481 15.8949 9.735 15.9999 10 15.9999C10.019 15.9999 10.036 15.9989 10.056 15.9979C10.34 15.9819 10.603 15.8469 10.781 15.6239L14.083 11.4969L17.293 14.7069C17.684 15.0969 18.316 15.0969 18.707 14.7069L20.414 12.9999H19.998L19.997 19.9999H4Z\" fill=\"#DFE4E5\"></path><path d=\"M3 3H20V13.5L14 11L10 14L7 13L3 14V3Z\" fill=\"white\"></path><rect x=\"3\" y=\"3\" width=\"18\" height=\"18\" rx=\"2\" stroke=\"#688083\" stroke-width=\"2\"></rect><path d=\"M5 15.0007H4V13.0007H4.586L6.293 11.2937C6.684 10.9017 7.316 10.9017 7.707 11.2937L9.917 13.5027L13.219 9.37574C13.397 9.15274 13.66 9.01774 13.944 9.00174C14.229 8.98474 14.506 9.09274 14.707 9.29374L18 12.5857L19.293 11.2937C19.48 11.1057 19.735 11.0007 19.998 11.0007L20.0073 13.4017L18.707 14.7077C18.316 15.0977 17.684 15.0977 17.293 14.7077L14.083 11.4977L10.781 15.6247C10.603 15.8477 10.34 15.9827 10.056 15.9987C10.036 15.9997 10.019 16.0007 10 16.0007C9.735 16.0007 9.481 15.8957 9.293 15.7077L7 13.4147L5.707 14.7077C5.52 14.8947 5.265 15.0007 5 15.0007Z\" fill=\"#688083\"></path></svg>";

/***/ }),

/***/ "27a1":
/***/ (function(module, exports, __webpack_require__) {

var getISOYear = __webpack_require__("8964")
var setISOYear = __webpack_require__("9706")

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Add the specified number of ISO week-numbering years to the given date.
 *
 * @description
 * Add the specified number of ISO week-numbering years to the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of ISO week-numbering years to be added
 * @returns {Date} the new date with the ISO week-numbering years added
 *
 * @example
 * // Add 5 ISO week-numbering years to 2 July 2010:
 * var result = addISOYears(new Date(2010, 6, 2), 5)
 * //=> Fri Jun 26 2015 00:00:00
 */
function addISOYears (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return setISOYear(dirtyDate, getISOYear(dirtyDate) + amount)
}

module.exports = addISOYears


/***/ }),

/***/ "284e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c662cfac-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/tooltip/PpTooltip.vue?vue&type=template&id=7931791d&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',_vm._b({scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('div',_vm._g(_vm._b({},'div',attrs,false),on),[_vm._t("default")],2)]}}],null,true)},'v-tooltip',_vm.attributes,false),[_vm._t("content",[_c('span',[_vm._v(_vm._s(_vm.text))])])],2)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/tooltip/PpTooltip.vue?vue&type=template&id=7931791d&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.index-of.js
var es_array_index_of = __webpack_require__("c975");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__("5530");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("ade3");

// CONCATENATED MODULE: ./src/components/tooltip/constants.js


var _ATTRIBUTES;

// Tooltip Position
var BOTTOM = 'bottom';
var TOP = 'top';
var RIGHT = 'right';
var LEFT = 'left';
var ATTRIBUTES = (_ATTRIBUTES = {}, Object(defineProperty["a" /* default */])(_ATTRIBUTES, BOTTOM, {
  bottom: ''
}), Object(defineProperty["a" /* default */])(_ATTRIBUTES, TOP, {
  top: ''
}), Object(defineProperty["a" /* default */])(_ATTRIBUTES, RIGHT, {
  right: ''
}), Object(defineProperty["a" /* default */])(_ATTRIBUTES, LEFT, {
  left: ''
}), _ATTRIBUTES);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/tooltip/PpTooltip.vue?vue&type=script&lang=js&


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var PpTooltipvue_type_script_lang_js_ = ({
  name: 'PpTooltip',
  props: {
    text: {
      type: String,
      required: true
    },
    position: {
      default: BOTTOM,
      type: String,
      validator: function validator(value) {
        return [BOTTOM, TOP, RIGHT, LEFT].indexOf(value) !== -1;
      }
    }
  },
  computed: {
    attributes: function attributes() {
      return Object(objectSpread2["a" /* default */])(Object(objectSpread2["a" /* default */])({}, this.$attrs), ATTRIBUTES[this.position]);
    }
  }
});
// CONCATENATED MODULE: ./src/components/tooltip/PpTooltip.vue?vue&type=script&lang=js&
 /* harmony default export */ var tooltip_PpTooltipvue_type_script_lang_js_ = (PpTooltipvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// EXTERNAL MODULE: ./node_modules/vuetify-loader/lib/runtime/installComponents.js
var installComponents = __webpack_require__("6544");
var installComponents_default = /*#__PURE__*/__webpack_require__.n(installComponents);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__("a9e3");

// EXTERNAL MODULE: ./node_modules/vuetify/src/components/VTooltip/VTooltip.sass
var VTooltip = __webpack_require__("9734");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/mixins/activatable/index.js
var activatable = __webpack_require__("4ad4");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/mixins/colorable/index.js
var colorable = __webpack_require__("a9ad");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/mixins/delayable/index.js
var delayable = __webpack_require__("16b7");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/mixins/dependent/index.js
var dependent = __webpack_require__("b848");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/mixins/detachable/index.js
var detachable = __webpack_require__("75eb");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/mixins/menuable/index.js
var menuable = __webpack_require__("f573");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/mixins/toggleable/index.js
var toggleable = __webpack_require__("f2e7");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/util/helpers.js
var helpers = __webpack_require__("80d2");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/util/console.js + 32 modules
var console = __webpack_require__("d9bd");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/util/mixins.js
var mixins = __webpack_require__("58df");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VTooltip/VTooltip.js


 // Mixins







 // Helpers




/* @vue/component */

/* harmony default export */ var VTooltip_VTooltip = (Object(mixins["a" /* default */])(colorable["a" /* default */], delayable["a" /* default */], dependent["a" /* default */], detachable["a" /* default */], menuable["a" /* default */], toggleable["a" /* default */]).extend({
  name: 'v-tooltip',
  props: {
    closeDelay: {
      type: [Number, String],
      default: 0
    },
    disabled: Boolean,
    fixed: {
      type: Boolean,
      default: true
    },
    openDelay: {
      type: [Number, String],
      default: 0
    },
    openOnHover: {
      type: Boolean,
      default: true
    },
    tag: {
      type: String,
      default: 'span'
    },
    transition: String
  },
  data: function data() {
    return {
      calculatedMinWidth: 0,
      closeDependents: false
    };
  },
  computed: {
    calculatedLeft: function calculatedLeft() {
      var _this$dimensions = this.dimensions,
          activator = _this$dimensions.activator,
          content = _this$dimensions.content;
      var unknown = !this.bottom && !this.left && !this.top && !this.right;
      var activatorLeft = this.attach !== false ? activator.offsetLeft : activator.left;
      var left = 0;

      if (this.top || this.bottom || unknown) {
        left = activatorLeft + activator.width / 2 - content.width / 2;
      } else if (this.left || this.right) {
        left = activatorLeft + (this.right ? activator.width : -content.width) + (this.right ? 10 : -10);
      }

      if (this.nudgeLeft) left -= parseInt(this.nudgeLeft);
      if (this.nudgeRight) left += parseInt(this.nudgeRight);
      return "".concat(this.calcXOverflow(left, this.dimensions.content.width), "px");
    },
    calculatedTop: function calculatedTop() {
      var _this$dimensions2 = this.dimensions,
          activator = _this$dimensions2.activator,
          content = _this$dimensions2.content;
      var activatorTop = this.attach !== false ? activator.offsetTop : activator.top;
      var top = 0;

      if (this.top || this.bottom) {
        top = activatorTop + (this.bottom ? activator.height : -content.height) + (this.bottom ? 10 : -10);
      } else if (this.left || this.right) {
        top = activatorTop + activator.height / 2 - content.height / 2;
      }

      if (this.nudgeTop) top -= parseInt(this.nudgeTop);
      if (this.nudgeBottom) top += parseInt(this.nudgeBottom);
      return "".concat(this.calcYOverflow(top + this.pageYOffset), "px");
    },
    classes: function classes() {
      return {
        'v-tooltip--top': this.top,
        'v-tooltip--right': this.right,
        'v-tooltip--bottom': this.bottom,
        'v-tooltip--left': this.left,
        'v-tooltip--attached': this.attach === '' || this.attach === true || this.attach === 'attach'
      };
    },
    computedTransition: function computedTransition() {
      if (this.transition) return this.transition;
      return this.isActive ? 'scale-transition' : 'fade-transition';
    },
    offsetY: function offsetY() {
      return this.top || this.bottom;
    },
    offsetX: function offsetX() {
      return this.left || this.right;
    },
    styles: function styles() {
      return {
        left: this.calculatedLeft,
        maxWidth: Object(helpers["g" /* convertToUnit */])(this.maxWidth),
        minWidth: Object(helpers["g" /* convertToUnit */])(this.minWidth),
        opacity: this.isActive ? 0.9 : 0,
        top: this.calculatedTop,
        zIndex: this.zIndex || this.activeZIndex
      };
    }
  },
  beforeMount: function beforeMount() {
    var _this = this;

    this.$nextTick(function () {
      _this.value && _this.callActivate();
    });
  },
  mounted: function mounted() {
    if (Object(helpers["t" /* getSlotType */])(this, 'activator', true) === 'v-slot') {
      Object(console["b" /* consoleError */])("v-tooltip's activator slot must be bound, try '<template #activator=\"data\"><v-btn v-on=\"data.on>'", this);
    }
  },
  methods: {
    activate: function activate() {
      // Update coordinates and dimensions of menu
      // and its activator
      this.updateDimensions(); // Start the transition

      requestAnimationFrame(this.startTransition);
    },
    deactivate: function deactivate() {
      this.runDelay('close');
    },
    genActivatorListeners: function genActivatorListeners() {
      var _this2 = this;

      var listeners = activatable["a" /* default */].options.methods.genActivatorListeners.call(this);

      listeners.focus = function (e) {
        _this2.getActivator(e);

        _this2.runDelay('open');
      };

      listeners.blur = function (e) {
        _this2.getActivator(e);

        _this2.runDelay('close');
      };

      listeners.keydown = function (e) {
        if (e.keyCode === helpers["x" /* keyCodes */].esc) {
          _this2.getActivator(e);

          _this2.runDelay('close');
        }
      };

      return listeners;
    },
    genActivatorAttributes: function genActivatorAttributes() {
      return {
        'aria-haspopup': true,
        'aria-expanded': String(this.isActive)
      };
    },
    genTransition: function genTransition() {
      var content = this.genContent();
      if (!this.computedTransition) return content;
      return this.$createElement('transition', {
        props: {
          name: this.computedTransition
        }
      }, [content]);
    },
    genContent: function genContent() {
      var _class;

      return this.$createElement('div', this.setBackgroundColor(this.color, {
        staticClass: 'v-tooltip__content',
        class: (_class = {}, Object(defineProperty["a" /* default */])(_class, this.contentClass, true), Object(defineProperty["a" /* default */])(_class, "menuable__content__active", this.isActive), Object(defineProperty["a" /* default */])(_class, 'v-tooltip__content--fixed', this.activatorFixed), _class),
        style: this.styles,
        attrs: this.getScopeIdAttrs(),
        directives: [{
          name: 'show',
          value: this.isContentActive
        }],
        ref: 'content'
      }), this.getContentSlot());
    }
  },
  render: function render(h) {
    var _this3 = this;

    return h(this.tag, {
      staticClass: 'v-tooltip',
      class: this.classes
    }, [this.showLazyContent(function () {
      return [_this3.genTransition()];
    }), this.genActivator()]);
  }
}));
// CONCATENATED MODULE: ./src/components/tooltip/PpTooltip.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  tooltip_PpTooltipvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var PpTooltip = __webpack_exports__["default"] = (component.exports);

/* vuetify-loader */


installComponents_default()(component, {VTooltip: VTooltip_VTooltip})


/***/ }),

/***/ "2877":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
        injectStyles.call(
          this,
          (options.functional ? this.parent : this).$root.$options.shadowRoot
        )
      }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ "2909":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ _toConsumableArray; });

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js
var arrayLikeToArray = __webpack_require__("6b75");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithoutHoles.js

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return Object(arrayLikeToArray["a" /* default */])(arr);
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("a4d3");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__("e01a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.iterator.js
var es_symbol_iterator = __webpack_require__("d28b");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.from.js
var es_array_from = __webpack_require__("a630");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__("e260");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("d3b7");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__("3ca3");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__("ddb0");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArray.js








function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__("06c5");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableSpread.js
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js




function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || Object(unsupportedIterableToArray["a" /* default */])(arr) || _nonIterableSpread();
}

/***/ }),

/***/ "297c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("a9e3");
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("8bbf");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _components_VProgressLinear__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("37c6");



/**
 * Loadable
 *
 * @mixin
 *
 * Used to add linear progress bar to components
 * Can use a default bar with a specific color
 * or designate a custom progress linear bar
 */

/* @vue/component */

/* harmony default export */ __webpack_exports__["a"] = (vue__WEBPACK_IMPORTED_MODULE_1___default.a.extend().extend({
  name: 'loadable',
  props: {
    loading: {
      type: [Boolean, String],
      default: false
    },
    loaderHeight: {
      type: [Number, String],
      default: 2
    }
  },
  methods: {
    genProgress: function genProgress() {
      if (this.loading === false) return null;
      return this.$slots.progress || this.$createElement(_components_VProgressLinear__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"], {
        props: {
          absolute: true,
          color: this.loading === true || this.loading === '' ? this.color || 'primary' : this.loading,
          height: this.loaderHeight,
          indeterminate: true
        }
      });
    }
  }
}));

/***/ }),

/***/ "298f":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.theme--light.v-progress-linear{color:var(--pp-text-primary,#2b2b2b)}.theme--dark.v-progress-linear{color:var(--pp-primary-button-text-color,#004852)}.v-progress-linear{background:transparent;overflow:hidden;position:relative;transition:.2s cubic-bezier(.4,0,.6,1);width:100%}.v-progress-linear__buffer{height:inherit;left:0;position:absolute;top:0;transition:inherit;width:100%}.v-progress-linear--reverse .v-progress-linear__buffer{left:auto;right:0}.v-progress-linear__background{bottom:0;left:0;position:absolute;top:0;transition:inherit}.v-progress-linear--reverse .v-progress-linear__background{left:auto;right:0}.v-progress-linear__content{align-items:center;display:flex;height:100%;left:0;justify-content:center;position:absolute;top:0;width:100%}.v-progress-linear--reverse .v-progress-linear__content{left:auto;right:0}.v-progress-linear__determinate{height:inherit;left:0;position:absolute;transition:inherit}.v-progress-linear--reverse .v-progress-linear__determinate{left:auto;right:0}.v-progress-linear .v-progress-linear__indeterminate .long,.v-progress-linear .v-progress-linear__indeterminate .short{background-color:inherit;bottom:0;height:inherit;left:0;position:absolute;right:auto;top:0;width:auto;will-change:left,right}.v-progress-linear .v-progress-linear__indeterminate--active .long{-webkit-animation-name:indeterminate-ltr;animation-name:indeterminate-ltr;-webkit-animation-duration:2.2s;animation-duration:2.2s;-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite}.v-progress-linear .v-progress-linear__indeterminate--active .short{-webkit-animation-name:indeterminate-short-ltr;animation-name:indeterminate-short-ltr;-webkit-animation-duration:2.2s;animation-duration:2.2s;-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite}.v-progress-linear--reverse .v-progress-linear__indeterminate .long,.v-progress-linear--reverse .v-progress-linear__indeterminate .short{left:auto;right:0}.v-progress-linear--reverse .v-progress-linear__indeterminate--active .long{-webkit-animation-name:indeterminate-rtl;animation-name:indeterminate-rtl}.v-progress-linear--reverse .v-progress-linear__indeterminate--active .short{-webkit-animation-name:indeterminate-short-rtl;animation-name:indeterminate-short-rtl}.v-progress-linear__stream{-webkit-animation:stream-ltr .25s linear infinite;animation:stream-ltr .25s linear infinite;border-color:currentColor;border-top:4px dotted;bottom:0;left:auto;right:-8px;opacity:.3;pointer-events:none;position:absolute;top:calc(50% - 2px);transition:inherit}.v-progress-linear--reverse .v-progress-linear__stream{-webkit-animation:stream-rtl .25s linear infinite;animation:stream-rtl .25s linear infinite;left:-8px;right:auto}.v-progress-linear__wrapper{overflow:hidden;position:relative;transition:inherit}.v-progress-linear--absolute,.v-progress-linear--fixed{left:0;z-index:1}.v-progress-linear--absolute{position:absolute}.v-progress-linear--fixed{position:fixed}.v-progress-linear--reactive .v-progress-linear__content{pointer-events:none}.v-progress-linear--rounded{border-radius:5px}.v-progress-linear--striped .v-progress-linear__determinate{background-image:linear-gradient(135deg,hsla(0,0%,100%,.25) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.25) 0,hsla(0,0%,100%,.25) 75%,transparent 0,transparent);background-size:40px 40px;background-repeat:repeat}.v-progress-linear--query .v-progress-linear__indeterminate--active .long{-webkit-animation-name:query-ltr;animation-name:query-ltr;-webkit-animation-duration:2s;animation-duration:2s;-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite}.v-progress-linear--query .v-progress-linear__indeterminate--active .short{-webkit-animation-name:query-short-ltr;animation-name:query-short-ltr;-webkit-animation-duration:2s;animation-duration:2s;-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite}.v-progress-linear--query.v-progress-linear--reverse .v-progress-linear__indeterminate--active .long{-webkit-animation-name:query-rtl;animation-name:query-rtl}.v-progress-linear--query.v-progress-linear--reverse .v-progress-linear__indeterminate--active .short{-webkit-animation-name:query-short-rtl;animation-name:query-short-rtl}@-webkit-keyframes indeterminate-ltr{0%{left:-90%;right:100%}60%{left:-90%;right:100%}to{left:100%;right:-35%}}@keyframes indeterminate-ltr{0%{left:-90%;right:100%}60%{left:-90%;right:100%}to{left:100%;right:-35%}}@-webkit-keyframes indeterminate-rtl{0%{left:100%;right:-90%}60%{left:100%;right:-90%}to{left:-35%;right:100%}}@keyframes indeterminate-rtl{0%{left:100%;right:-90%}60%{left:100%;right:-90%}to{left:-35%;right:100%}}@-webkit-keyframes indeterminate-short-ltr{0%{left:-200%;right:100%}60%{left:107%;right:-8%}to{left:107%;right:-8%}}@keyframes indeterminate-short-ltr{0%{left:-200%;right:100%}60%{left:107%;right:-8%}to{left:107%;right:-8%}}@-webkit-keyframes indeterminate-short-rtl{0%{left:100%;right:-200%}60%{left:-8%;right:107%}to{left:-8%;right:107%}}@keyframes indeterminate-short-rtl{0%{left:100%;right:-200%}60%{left:-8%;right:107%}to{left:-8%;right:107%}}@-webkit-keyframes query-ltr{0%{right:-90%;left:100%}60%{right:-90%;left:100%}to{right:100%;left:-35%}}@keyframes query-ltr{0%{right:-90%;left:100%}60%{right:-90%;left:100%}to{right:100%;left:-35%}}@-webkit-keyframes query-rtl{0%{right:100%;left:-90%}60%{right:100%;left:-90%}to{right:-35%;left:100%}}@keyframes query-rtl{0%{right:100%;left:-90%}60%{right:100%;left:-90%}to{right:-35%;left:100%}}@-webkit-keyframes query-short-ltr{0%{right:-200%;left:100%}60%{right:107%;left:-8%}to{right:107%;left:-8%}}@keyframes query-short-ltr{0%{right:-200%;left:100%}60%{right:107%;left:-8%}to{right:107%;left:-8%}}@-webkit-keyframes query-short-rtl{0%{right:100%;left:-200%}60%{right:-8%;left:107%}to{right:-8%;left:107%}}@keyframes query-short-rtl{0%{right:100%;left:-200%}60%{right:-8%;left:107%}to{right:-8%;left:107%}}@-webkit-keyframes stream-ltr{to{transform:translateX(-8px)}}@keyframes stream-ltr{to{transform:translateX(-8px)}}@-webkit-keyframes stream-rtl{to{transform:translateX(8px)}}@keyframes stream-rtl{to{transform:translateX(8px)}}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "2a37":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.v-list.accent>.v-list-item,.v-list.error>.v-list-item,.v-list.info>.v-list-item,.v-list.primary>.v-list-item,.v-list.secondary>.v-list-item,.v-list.success>.v-list-item,.v-list.warning>.v-list-item{color:var(--pp-primary-button-text-color,#004852)}.theme--light.v-list{background:var(--cards-color,#fff);color:var(--pp-text-primary,#2b2b2b)}.theme--light.v-list .v-list--disabled{color:var(--pp-text-disabled,#f6f6f6)}.theme--light.v-list .v-list-group--active:after,.theme--light.v-list .v-list-group--active:before{background:#d6d6d6}.theme--dark.v-list{background:#1e1e1e;color:var(--pp-primary-button-text-color,#004852)}.theme--dark.v-list .v-list--disabled{color:hsla(0,0%,100%,.5)}.theme--dark.v-list .v-list-group--active:after,.theme--dark.v-list .v-list-group--active:before{background:hsla(0,0%,100%,.12)}.v-sheet.v-list{border-radius:0}.v-sheet.v-list:not(.v-sheet--outlined){box-shadow:0 0 0 0 transparent,0 0 0 0 transparent,0 0 0 0 rgba(0,0,0,.12)}.v-sheet.v-list.v-sheet--shaped{border-radius:0}.v-list{display:block;padding:var(--pp-list-padding,8px);position:static;transition:box-shadow .28s cubic-bezier(.4,0,.2,1);will-change:box-shadow}.v-list--disabled{pointer-events:none}.v-list--flat .v-list-item:before{display:none}.v-list--dense .v-subheader{font-size:.75rem;height:40px;padding:0 8px}.v-list--nav .v-list-item:not(:last-child):not(:only-child),.v-list--rounded .v-list-item:not(:last-child):not(:only-child){margin-bottom:8px}.v-list--nav.v-list--dense .v-list-item:not(:last-child):not(:only-child),.v-list--nav .v-list-item--dense:not(:last-child):not(:only-child),.v-list--rounded.v-list--dense .v-list-item:not(:last-child):not(:only-child),.v-list--rounded .v-list-item--dense:not(:last-child):not(:only-child){margin-bottom:4px}.v-list--nav{padding-left:8px;padding-right:8px}.v-list--nav .v-list-item{padding:0 8px}.v-list--nav .v-list-item,.v-list--nav .v-list-item:before{border-radius:5px}.v-application--is-ltr .v-list.v-sheet--shaped .v-list-item,.v-application--is-ltr .v-list.v-sheet--shaped .v-list-item:before,.v-application--is-ltr .v-list.v-sheet--shaped .v-list-item>.v-ripple__container{border-bottom-right-radius:16px!important;border-top-right-radius:16px!important}.v-application--is-rtl .v-list.v-sheet--shaped .v-list-item,.v-application--is-rtl .v-list.v-sheet--shaped .v-list-item:before,.v-application--is-rtl .v-list.v-sheet--shaped .v-list-item>.v-ripple__container{border-bottom-left-radius:16px!important;border-top-left-radius:16px!important}.v-application--is-ltr .v-list.v-sheet--shaped.v-list--two-line .v-list-item,.v-application--is-ltr .v-list.v-sheet--shaped.v-list--two-line .v-list-item:before,.v-application--is-ltr .v-list.v-sheet--shaped.v-list--two-line .v-list-item>.v-ripple__container{border-bottom-right-radius:42.6666666667px!important;border-top-right-radius:42.6666666667px!important}.v-application--is-rtl .v-list.v-sheet--shaped.v-list--two-line .v-list-item,.v-application--is-rtl .v-list.v-sheet--shaped.v-list--two-line .v-list-item:before,.v-application--is-rtl .v-list.v-sheet--shaped.v-list--two-line .v-list-item>.v-ripple__container{border-bottom-left-radius:42.6666666667px!important;border-top-left-radius:42.6666666667px!important}.v-application--is-ltr .v-list.v-sheet--shaped.v-list--three-line .v-list-item,.v-application--is-ltr .v-list.v-sheet--shaped.v-list--three-line .v-list-item:before,.v-application--is-ltr .v-list.v-sheet--shaped.v-list--three-line .v-list-item>.v-ripple__container{border-bottom-right-radius:58.6666666667px!important;border-top-right-radius:58.6666666667px!important}.v-application--is-rtl .v-list.v-sheet--shaped.v-list--three-line .v-list-item,.v-application--is-rtl .v-list.v-sheet--shaped.v-list--three-line .v-list-item:before,.v-application--is-rtl .v-list.v-sheet--shaped.v-list--three-line .v-list-item>.v-ripple__container{border-bottom-left-radius:58.6666666667px!important;border-top-left-radius:58.6666666667px!important}.v-application--is-ltr .v-list.v-sheet--shaped{padding-right:8px}.v-application--is-rtl .v-list.v-sheet--shaped{padding-left:8px}.v-list--rounded{padding:8px}.v-list--rounded .v-list-item,.v-list--rounded .v-list-item:before,.v-list--rounded .v-list-item>.v-ripple__container{border-radius:16px!important}.v-list--rounded.v-list--two-line .v-list-item,.v-list--rounded.v-list--two-line .v-list-item:before,.v-list--rounded.v-list--two-line .v-list-item>.v-ripple__container{border-radius:42.6666666667px!important}.v-list--rounded.v-list--three-line .v-list-item,.v-list--rounded.v-list--three-line .v-list-item:before,.v-list--rounded.v-list--three-line .v-list-item>.v-ripple__container{border-radius:58.6666666667px!important}.v-list--subheader{padding-top:0}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "2a62":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("825a");

module.exports = function (iterator) {
  var returnMethod = iterator['return'];
  if (returnMethod !== undefined) {
    return anObject(returnMethod.call(iterator)).value;
  }
};


/***/ }),

/***/ "2a80":
/***/ (function(module, exports, __webpack_require__) {

var isSameQuarter = __webpack_require__("9aaa")

/**
 * @category Quarter Helpers
 * @summary Is the given date in the same quarter as the current date?
 *
 * @description
 * Is the given date in the same quarter as the current date?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in this quarter
 *
 * @example
 * // If today is 25 September 2014, is 2 July 2014 in this quarter?
 * var result = isThisQuarter(new Date(2014, 6, 2))
 * //=> true
 */
function isThisQuarter (dirtyDate) {
  return isSameQuarter(new Date(), dirtyDate)
}

module.exports = isThisQuarter


/***/ }),

/***/ "2a9c":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("c8d5")

/**
 * @category Year Helpers
 * @summary Get the number of calendar years between the given dates.
 *
 * @description
 * Get the number of calendar years between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar years
 *
 * @example
 * // How many calendar years are between 31 December 2013 and 11 February 2015?
 * var result = differenceInCalendarYears(
 *   new Date(2015, 1, 11),
 *   new Date(2013, 11, 31)
 * )
 * //=> 2
 */
function differenceInCalendarYears (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)

  return dateLeft.getFullYear() - dateRight.getFullYear()
}

module.exports = differenceInCalendarYears


/***/ }),

/***/ "2af0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpComposer_vue_vue_type_style_index_0_id_3ef68c2a_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2587");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpComposer_vue_vue_type_style_index_0_id_3ef68c2a_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpComposer_vue_vue_type_style_index_0_id_3ef68c2a_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "2af1":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var sign = __webpack_require__("f748");

// `Math.sign` method
// https://tc39.es/ecma262/#sec-math.sign
$({ target: 'Math', stat: true }, {
  sign: sign
});


/***/ }),

/***/ "2b19":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var is = __webpack_require__("129f");

// `Object.is` method
// https://tc39.es/ecma262/#sec-object.is
$({ target: 'Object', stat: true }, {
  is: is
});


/***/ }),

/***/ "2b3d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// TODO: in core-js@4, move /modules/ dependencies to public entries for better optimization by tools like `preset-env`
__webpack_require__("3ca3");
var $ = __webpack_require__("23e7");
var DESCRIPTORS = __webpack_require__("83ab");
var USE_NATIVE_URL = __webpack_require__("0d3b");
var global = __webpack_require__("da84");
var defineProperties = __webpack_require__("37e8");
var redefine = __webpack_require__("6eeb");
var anInstance = __webpack_require__("19aa");
var has = __webpack_require__("5135");
var assign = __webpack_require__("60da");
var arrayFrom = __webpack_require__("4df4");
var codeAt = __webpack_require__("6547").codeAt;
var toASCII = __webpack_require__("5fb2");
var setToStringTag = __webpack_require__("d44e");
var URLSearchParamsModule = __webpack_require__("9861");
var InternalStateModule = __webpack_require__("69f3");

var NativeURL = global.URL;
var URLSearchParams = URLSearchParamsModule.URLSearchParams;
var getInternalSearchParamsState = URLSearchParamsModule.getState;
var setInternalState = InternalStateModule.set;
var getInternalURLState = InternalStateModule.getterFor('URL');
var floor = Math.floor;
var pow = Math.pow;

var INVALID_AUTHORITY = 'Invalid authority';
var INVALID_SCHEME = 'Invalid scheme';
var INVALID_HOST = 'Invalid host';
var INVALID_PORT = 'Invalid port';

var ALPHA = /[A-Za-z]/;
var ALPHANUMERIC = /[\d+-.A-Za-z]/;
var DIGIT = /\d/;
var HEX_START = /^(0x|0X)/;
var OCT = /^[0-7]+$/;
var DEC = /^\d+$/;
var HEX = /^[\dA-Fa-f]+$/;
// eslint-disable-next-line no-control-regex
var FORBIDDEN_HOST_CODE_POINT = /[\u0000\u0009\u000A\u000D #%/:?@[\\]]/;
// eslint-disable-next-line no-control-regex
var FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT = /[\u0000\u0009\u000A\u000D #/:?@[\\]]/;
// eslint-disable-next-line no-control-regex
var LEADING_AND_TRAILING_C0_CONTROL_OR_SPACE = /^[\u0000-\u001F ]+|[\u0000-\u001F ]+$/g;
// eslint-disable-next-line no-control-regex
var TAB_AND_NEW_LINE = /[\u0009\u000A\u000D]/g;
var EOF;

var parseHost = function (url, input) {
  var result, codePoints, index;
  if (input.charAt(0) == '[') {
    if (input.charAt(input.length - 1) != ']') return INVALID_HOST;
    result = parseIPv6(input.slice(1, -1));
    if (!result) return INVALID_HOST;
    url.host = result;
  // opaque host
  } else if (!isSpecial(url)) {
    if (FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT.test(input)) return INVALID_HOST;
    result = '';
    codePoints = arrayFrom(input);
    for (index = 0; index < codePoints.length; index++) {
      result += percentEncode(codePoints[index], C0ControlPercentEncodeSet);
    }
    url.host = result;
  } else {
    input = toASCII(input);
    if (FORBIDDEN_HOST_CODE_POINT.test(input)) return INVALID_HOST;
    result = parseIPv4(input);
    if (result === null) return INVALID_HOST;
    url.host = result;
  }
};

var parseIPv4 = function (input) {
  var parts = input.split('.');
  var partsLength, numbers, index, part, radix, number, ipv4;
  if (parts.length && parts[parts.length - 1] == '') {
    parts.pop();
  }
  partsLength = parts.length;
  if (partsLength > 4) return input;
  numbers = [];
  for (index = 0; index < partsLength; index++) {
    part = parts[index];
    if (part == '') return input;
    radix = 10;
    if (part.length > 1 && part.charAt(0) == '0') {
      radix = HEX_START.test(part) ? 16 : 8;
      part = part.slice(radix == 8 ? 1 : 2);
    }
    if (part === '') {
      number = 0;
    } else {
      if (!(radix == 10 ? DEC : radix == 8 ? OCT : HEX).test(part)) return input;
      number = parseInt(part, radix);
    }
    numbers.push(number);
  }
  for (index = 0; index < partsLength; index++) {
    number = numbers[index];
    if (index == partsLength - 1) {
      if (number >= pow(256, 5 - partsLength)) return null;
    } else if (number > 255) return null;
  }
  ipv4 = numbers.pop();
  for (index = 0; index < numbers.length; index++) {
    ipv4 += numbers[index] * pow(256, 3 - index);
  }
  return ipv4;
};

// eslint-disable-next-line max-statements
var parseIPv6 = function (input) {
  var address = [0, 0, 0, 0, 0, 0, 0, 0];
  var pieceIndex = 0;
  var compress = null;
  var pointer = 0;
  var value, length, numbersSeen, ipv4Piece, number, swaps, swap;

  var char = function () {
    return input.charAt(pointer);
  };

  if (char() == ':') {
    if (input.charAt(1) != ':') return;
    pointer += 2;
    pieceIndex++;
    compress = pieceIndex;
  }
  while (char()) {
    if (pieceIndex == 8) return;
    if (char() == ':') {
      if (compress !== null) return;
      pointer++;
      pieceIndex++;
      compress = pieceIndex;
      continue;
    }
    value = length = 0;
    while (length < 4 && HEX.test(char())) {
      value = value * 16 + parseInt(char(), 16);
      pointer++;
      length++;
    }
    if (char() == '.') {
      if (length == 0) return;
      pointer -= length;
      if (pieceIndex > 6) return;
      numbersSeen = 0;
      while (char()) {
        ipv4Piece = null;
        if (numbersSeen > 0) {
          if (char() == '.' && numbersSeen < 4) pointer++;
          else return;
        }
        if (!DIGIT.test(char())) return;
        while (DIGIT.test(char())) {
          number = parseInt(char(), 10);
          if (ipv4Piece === null) ipv4Piece = number;
          else if (ipv4Piece == 0) return;
          else ipv4Piece = ipv4Piece * 10 + number;
          if (ipv4Piece > 255) return;
          pointer++;
        }
        address[pieceIndex] = address[pieceIndex] * 256 + ipv4Piece;
        numbersSeen++;
        if (numbersSeen == 2 || numbersSeen == 4) pieceIndex++;
      }
      if (numbersSeen != 4) return;
      break;
    } else if (char() == ':') {
      pointer++;
      if (!char()) return;
    } else if (char()) return;
    address[pieceIndex++] = value;
  }
  if (compress !== null) {
    swaps = pieceIndex - compress;
    pieceIndex = 7;
    while (pieceIndex != 0 && swaps > 0) {
      swap = address[pieceIndex];
      address[pieceIndex--] = address[compress + swaps - 1];
      address[compress + --swaps] = swap;
    }
  } else if (pieceIndex != 8) return;
  return address;
};

var findLongestZeroSequence = function (ipv6) {
  var maxIndex = null;
  var maxLength = 1;
  var currStart = null;
  var currLength = 0;
  var index = 0;
  for (; index < 8; index++) {
    if (ipv6[index] !== 0) {
      if (currLength > maxLength) {
        maxIndex = currStart;
        maxLength = currLength;
      }
      currStart = null;
      currLength = 0;
    } else {
      if (currStart === null) currStart = index;
      ++currLength;
    }
  }
  if (currLength > maxLength) {
    maxIndex = currStart;
    maxLength = currLength;
  }
  return maxIndex;
};

var serializeHost = function (host) {
  var result, index, compress, ignore0;
  // ipv4
  if (typeof host == 'number') {
    result = [];
    for (index = 0; index < 4; index++) {
      result.unshift(host % 256);
      host = floor(host / 256);
    } return result.join('.');
  // ipv6
  } else if (typeof host == 'object') {
    result = '';
    compress = findLongestZeroSequence(host);
    for (index = 0; index < 8; index++) {
      if (ignore0 && host[index] === 0) continue;
      if (ignore0) ignore0 = false;
      if (compress === index) {
        result += index ? ':' : '::';
        ignore0 = true;
      } else {
        result += host[index].toString(16);
        if (index < 7) result += ':';
      }
    }
    return '[' + result + ']';
  } return host;
};

var C0ControlPercentEncodeSet = {};
var fragmentPercentEncodeSet = assign({}, C0ControlPercentEncodeSet, {
  ' ': 1, '"': 1, '<': 1, '>': 1, '`': 1
});
var pathPercentEncodeSet = assign({}, fragmentPercentEncodeSet, {
  '#': 1, '?': 1, '{': 1, '}': 1
});
var userinfoPercentEncodeSet = assign({}, pathPercentEncodeSet, {
  '/': 1, ':': 1, ';': 1, '=': 1, '@': 1, '[': 1, '\\': 1, ']': 1, '^': 1, '|': 1
});

var percentEncode = function (char, set) {
  var code = codeAt(char, 0);
  return code > 0x20 && code < 0x7F && !has(set, char) ? char : encodeURIComponent(char);
};

var specialSchemes = {
  ftp: 21,
  file: null,
  http: 80,
  https: 443,
  ws: 80,
  wss: 443
};

var isSpecial = function (url) {
  return has(specialSchemes, url.scheme);
};

var includesCredentials = function (url) {
  return url.username != '' || url.password != '';
};

var cannotHaveUsernamePasswordPort = function (url) {
  return !url.host || url.cannotBeABaseURL || url.scheme == 'file';
};

var isWindowsDriveLetter = function (string, normalized) {
  var second;
  return string.length == 2 && ALPHA.test(string.charAt(0))
    && ((second = string.charAt(1)) == ':' || (!normalized && second == '|'));
};

var startsWithWindowsDriveLetter = function (string) {
  var third;
  return string.length > 1 && isWindowsDriveLetter(string.slice(0, 2)) && (
    string.length == 2 ||
    ((third = string.charAt(2)) === '/' || third === '\\' || third === '?' || third === '#')
  );
};

var shortenURLsPath = function (url) {
  var path = url.path;
  var pathSize = path.length;
  if (pathSize && (url.scheme != 'file' || pathSize != 1 || !isWindowsDriveLetter(path[0], true))) {
    path.pop();
  }
};

var isSingleDot = function (segment) {
  return segment === '.' || segment.toLowerCase() === '%2e';
};

var isDoubleDot = function (segment) {
  segment = segment.toLowerCase();
  return segment === '..' || segment === '%2e.' || segment === '.%2e' || segment === '%2e%2e';
};

// States:
var SCHEME_START = {};
var SCHEME = {};
var NO_SCHEME = {};
var SPECIAL_RELATIVE_OR_AUTHORITY = {};
var PATH_OR_AUTHORITY = {};
var RELATIVE = {};
var RELATIVE_SLASH = {};
var SPECIAL_AUTHORITY_SLASHES = {};
var SPECIAL_AUTHORITY_IGNORE_SLASHES = {};
var AUTHORITY = {};
var HOST = {};
var HOSTNAME = {};
var PORT = {};
var FILE = {};
var FILE_SLASH = {};
var FILE_HOST = {};
var PATH_START = {};
var PATH = {};
var CANNOT_BE_A_BASE_URL_PATH = {};
var QUERY = {};
var FRAGMENT = {};

// eslint-disable-next-line max-statements
var parseURL = function (url, input, stateOverride, base) {
  var state = stateOverride || SCHEME_START;
  var pointer = 0;
  var buffer = '';
  var seenAt = false;
  var seenBracket = false;
  var seenPasswordToken = false;
  var codePoints, char, bufferCodePoints, failure;

  if (!stateOverride) {
    url.scheme = '';
    url.username = '';
    url.password = '';
    url.host = null;
    url.port = null;
    url.path = [];
    url.query = null;
    url.fragment = null;
    url.cannotBeABaseURL = false;
    input = input.replace(LEADING_AND_TRAILING_C0_CONTROL_OR_SPACE, '');
  }

  input = input.replace(TAB_AND_NEW_LINE, '');

  codePoints = arrayFrom(input);

  while (pointer <= codePoints.length) {
    char = codePoints[pointer];
    switch (state) {
      case SCHEME_START:
        if (char && ALPHA.test(char)) {
          buffer += char.toLowerCase();
          state = SCHEME;
        } else if (!stateOverride) {
          state = NO_SCHEME;
          continue;
        } else return INVALID_SCHEME;
        break;

      case SCHEME:
        if (char && (ALPHANUMERIC.test(char) || char == '+' || char == '-' || char == '.')) {
          buffer += char.toLowerCase();
        } else if (char == ':') {
          if (stateOverride && (
            (isSpecial(url) != has(specialSchemes, buffer)) ||
            (buffer == 'file' && (includesCredentials(url) || url.port !== null)) ||
            (url.scheme == 'file' && !url.host)
          )) return;
          url.scheme = buffer;
          if (stateOverride) {
            if (isSpecial(url) && specialSchemes[url.scheme] == url.port) url.port = null;
            return;
          }
          buffer = '';
          if (url.scheme == 'file') {
            state = FILE;
          } else if (isSpecial(url) && base && base.scheme == url.scheme) {
            state = SPECIAL_RELATIVE_OR_AUTHORITY;
          } else if (isSpecial(url)) {
            state = SPECIAL_AUTHORITY_SLASHES;
          } else if (codePoints[pointer + 1] == '/') {
            state = PATH_OR_AUTHORITY;
            pointer++;
          } else {
            url.cannotBeABaseURL = true;
            url.path.push('');
            state = CANNOT_BE_A_BASE_URL_PATH;
          }
        } else if (!stateOverride) {
          buffer = '';
          state = NO_SCHEME;
          pointer = 0;
          continue;
        } else return INVALID_SCHEME;
        break;

      case NO_SCHEME:
        if (!base || (base.cannotBeABaseURL && char != '#')) return INVALID_SCHEME;
        if (base.cannotBeABaseURL && char == '#') {
          url.scheme = base.scheme;
          url.path = base.path.slice();
          url.query = base.query;
          url.fragment = '';
          url.cannotBeABaseURL = true;
          state = FRAGMENT;
          break;
        }
        state = base.scheme == 'file' ? FILE : RELATIVE;
        continue;

      case SPECIAL_RELATIVE_OR_AUTHORITY:
        if (char == '/' && codePoints[pointer + 1] == '/') {
          state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
          pointer++;
        } else {
          state = RELATIVE;
          continue;
        } break;

      case PATH_OR_AUTHORITY:
        if (char == '/') {
          state = AUTHORITY;
          break;
        } else {
          state = PATH;
          continue;
        }

      case RELATIVE:
        url.scheme = base.scheme;
        if (char == EOF) {
          url.username = base.username;
          url.password = base.password;
          url.host = base.host;
          url.port = base.port;
          url.path = base.path.slice();
          url.query = base.query;
        } else if (char == '/' || (char == '\\' && isSpecial(url))) {
          state = RELATIVE_SLASH;
        } else if (char == '?') {
          url.username = base.username;
          url.password = base.password;
          url.host = base.host;
          url.port = base.port;
          url.path = base.path.slice();
          url.query = '';
          state = QUERY;
        } else if (char == '#') {
          url.username = base.username;
          url.password = base.password;
          url.host = base.host;
          url.port = base.port;
          url.path = base.path.slice();
          url.query = base.query;
          url.fragment = '';
          state = FRAGMENT;
        } else {
          url.username = base.username;
          url.password = base.password;
          url.host = base.host;
          url.port = base.port;
          url.path = base.path.slice();
          url.path.pop();
          state = PATH;
          continue;
        } break;

      case RELATIVE_SLASH:
        if (isSpecial(url) && (char == '/' || char == '\\')) {
          state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
        } else if (char == '/') {
          state = AUTHORITY;
        } else {
          url.username = base.username;
          url.password = base.password;
          url.host = base.host;
          url.port = base.port;
          state = PATH;
          continue;
        } break;

      case SPECIAL_AUTHORITY_SLASHES:
        state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
        if (char != '/' || buffer.charAt(pointer + 1) != '/') continue;
        pointer++;
        break;

      case SPECIAL_AUTHORITY_IGNORE_SLASHES:
        if (char != '/' && char != '\\') {
          state = AUTHORITY;
          continue;
        } break;

      case AUTHORITY:
        if (char == '@') {
          if (seenAt) buffer = '%40' + buffer;
          seenAt = true;
          bufferCodePoints = arrayFrom(buffer);
          for (var i = 0; i < bufferCodePoints.length; i++) {
            var codePoint = bufferCodePoints[i];
            if (codePoint == ':' && !seenPasswordToken) {
              seenPasswordToken = true;
              continue;
            }
            var encodedCodePoints = percentEncode(codePoint, userinfoPercentEncodeSet);
            if (seenPasswordToken) url.password += encodedCodePoints;
            else url.username += encodedCodePoints;
          }
          buffer = '';
        } else if (
          char == EOF || char == '/' || char == '?' || char == '#' ||
          (char == '\\' && isSpecial(url))
        ) {
          if (seenAt && buffer == '') return INVALID_AUTHORITY;
          pointer -= arrayFrom(buffer).length + 1;
          buffer = '';
          state = HOST;
        } else buffer += char;
        break;

      case HOST:
      case HOSTNAME:
        if (stateOverride && url.scheme == 'file') {
          state = FILE_HOST;
          continue;
        } else if (char == ':' && !seenBracket) {
          if (buffer == '') return INVALID_HOST;
          failure = parseHost(url, buffer);
          if (failure) return failure;
          buffer = '';
          state = PORT;
          if (stateOverride == HOSTNAME) return;
        } else if (
          char == EOF || char == '/' || char == '?' || char == '#' ||
          (char == '\\' && isSpecial(url))
        ) {
          if (isSpecial(url) && buffer == '') return INVALID_HOST;
          if (stateOverride && buffer == '' && (includesCredentials(url) || url.port !== null)) return;
          failure = parseHost(url, buffer);
          if (failure) return failure;
          buffer = '';
          state = PATH_START;
          if (stateOverride) return;
          continue;
        } else {
          if (char == '[') seenBracket = true;
          else if (char == ']') seenBracket = false;
          buffer += char;
        } break;

      case PORT:
        if (DIGIT.test(char)) {
          buffer += char;
        } else if (
          char == EOF || char == '/' || char == '?' || char == '#' ||
          (char == '\\' && isSpecial(url)) ||
          stateOverride
        ) {
          if (buffer != '') {
            var port = parseInt(buffer, 10);
            if (port > 0xFFFF) return INVALID_PORT;
            url.port = (isSpecial(url) && port === specialSchemes[url.scheme]) ? null : port;
            buffer = '';
          }
          if (stateOverride) return;
          state = PATH_START;
          continue;
        } else return INVALID_PORT;
        break;

      case FILE:
        url.scheme = 'file';
        if (char == '/' || char == '\\') state = FILE_SLASH;
        else if (base && base.scheme == 'file') {
          if (char == EOF) {
            url.host = base.host;
            url.path = base.path.slice();
            url.query = base.query;
          } else if (char == '?') {
            url.host = base.host;
            url.path = base.path.slice();
            url.query = '';
            state = QUERY;
          } else if (char == '#') {
            url.host = base.host;
            url.path = base.path.slice();
            url.query = base.query;
            url.fragment = '';
            state = FRAGMENT;
          } else {
            if (!startsWithWindowsDriveLetter(codePoints.slice(pointer).join(''))) {
              url.host = base.host;
              url.path = base.path.slice();
              shortenURLsPath(url);
            }
            state = PATH;
            continue;
          }
        } else {
          state = PATH;
          continue;
        } break;

      case FILE_SLASH:
        if (char == '/' || char == '\\') {
          state = FILE_HOST;
          break;
        }
        if (base && base.scheme == 'file' && !startsWithWindowsDriveLetter(codePoints.slice(pointer).join(''))) {
          if (isWindowsDriveLetter(base.path[0], true)) url.path.push(base.path[0]);
          else url.host = base.host;
        }
        state = PATH;
        continue;

      case FILE_HOST:
        if (char == EOF || char == '/' || char == '\\' || char == '?' || char == '#') {
          if (!stateOverride && isWindowsDriveLetter(buffer)) {
            state = PATH;
          } else if (buffer == '') {
            url.host = '';
            if (stateOverride) return;
            state = PATH_START;
          } else {
            failure = parseHost(url, buffer);
            if (failure) return failure;
            if (url.host == 'localhost') url.host = '';
            if (stateOverride) return;
            buffer = '';
            state = PATH_START;
          } continue;
        } else buffer += char;
        break;

      case PATH_START:
        if (isSpecial(url)) {
          state = PATH;
          if (char != '/' && char != '\\') continue;
        } else if (!stateOverride && char == '?') {
          url.query = '';
          state = QUERY;
        } else if (!stateOverride && char == '#') {
          url.fragment = '';
          state = FRAGMENT;
        } else if (char != EOF) {
          state = PATH;
          if (char != '/') continue;
        } break;

      case PATH:
        if (
          char == EOF || char == '/' ||
          (char == '\\' && isSpecial(url)) ||
          (!stateOverride && (char == '?' || char == '#'))
        ) {
          if (isDoubleDot(buffer)) {
            shortenURLsPath(url);
            if (char != '/' && !(char == '\\' && isSpecial(url))) {
              url.path.push('');
            }
          } else if (isSingleDot(buffer)) {
            if (char != '/' && !(char == '\\' && isSpecial(url))) {
              url.path.push('');
            }
          } else {
            if (url.scheme == 'file' && !url.path.length && isWindowsDriveLetter(buffer)) {
              if (url.host) url.host = '';
              buffer = buffer.charAt(0) + ':'; // normalize windows drive letter
            }
            url.path.push(buffer);
          }
          buffer = '';
          if (url.scheme == 'file' && (char == EOF || char == '?' || char == '#')) {
            while (url.path.length > 1 && url.path[0] === '') {
              url.path.shift();
            }
          }
          if (char == '?') {
            url.query = '';
            state = QUERY;
          } else if (char == '#') {
            url.fragment = '';
            state = FRAGMENT;
          }
        } else {
          buffer += percentEncode(char, pathPercentEncodeSet);
        } break;

      case CANNOT_BE_A_BASE_URL_PATH:
        if (char == '?') {
          url.query = '';
          state = QUERY;
        } else if (char == '#') {
          url.fragment = '';
          state = FRAGMENT;
        } else if (char != EOF) {
          url.path[0] += percentEncode(char, C0ControlPercentEncodeSet);
        } break;

      case QUERY:
        if (!stateOverride && char == '#') {
          url.fragment = '';
          state = FRAGMENT;
        } else if (char != EOF) {
          if (char == "'" && isSpecial(url)) url.query += '%27';
          else if (char == '#') url.query += '%23';
          else url.query += percentEncode(char, C0ControlPercentEncodeSet);
        } break;

      case FRAGMENT:
        if (char != EOF) url.fragment += percentEncode(char, fragmentPercentEncodeSet);
        break;
    }

    pointer++;
  }
};

// `URL` constructor
// https://url.spec.whatwg.org/#url-class
var URLConstructor = function URL(url /* , base */) {
  var that = anInstance(this, URLConstructor, 'URL');
  var base = arguments.length > 1 ? arguments[1] : undefined;
  var urlString = String(url);
  var state = setInternalState(that, { type: 'URL' });
  var baseState, failure;
  if (base !== undefined) {
    if (base instanceof URLConstructor) baseState = getInternalURLState(base);
    else {
      failure = parseURL(baseState = {}, String(base));
      if (failure) throw TypeError(failure);
    }
  }
  failure = parseURL(state, urlString, null, baseState);
  if (failure) throw TypeError(failure);
  var searchParams = state.searchParams = new URLSearchParams();
  var searchParamsState = getInternalSearchParamsState(searchParams);
  searchParamsState.updateSearchParams(state.query);
  searchParamsState.updateURL = function () {
    state.query = String(searchParams) || null;
  };
  if (!DESCRIPTORS) {
    that.href = serializeURL.call(that);
    that.origin = getOrigin.call(that);
    that.protocol = getProtocol.call(that);
    that.username = getUsername.call(that);
    that.password = getPassword.call(that);
    that.host = getHost.call(that);
    that.hostname = getHostname.call(that);
    that.port = getPort.call(that);
    that.pathname = getPathname.call(that);
    that.search = getSearch.call(that);
    that.searchParams = getSearchParams.call(that);
    that.hash = getHash.call(that);
  }
};

var URLPrototype = URLConstructor.prototype;

var serializeURL = function () {
  var url = getInternalURLState(this);
  var scheme = url.scheme;
  var username = url.username;
  var password = url.password;
  var host = url.host;
  var port = url.port;
  var path = url.path;
  var query = url.query;
  var fragment = url.fragment;
  var output = scheme + ':';
  if (host !== null) {
    output += '//';
    if (includesCredentials(url)) {
      output += username + (password ? ':' + password : '') + '@';
    }
    output += serializeHost(host);
    if (port !== null) output += ':' + port;
  } else if (scheme == 'file') output += '//';
  output += url.cannotBeABaseURL ? path[0] : path.length ? '/' + path.join('/') : '';
  if (query !== null) output += '?' + query;
  if (fragment !== null) output += '#' + fragment;
  return output;
};

var getOrigin = function () {
  var url = getInternalURLState(this);
  var scheme = url.scheme;
  var port = url.port;
  if (scheme == 'blob') try {
    return new URL(scheme.path[0]).origin;
  } catch (error) {
    return 'null';
  }
  if (scheme == 'file' || !isSpecial(url)) return 'null';
  return scheme + '://' + serializeHost(url.host) + (port !== null ? ':' + port : '');
};

var getProtocol = function () {
  return getInternalURLState(this).scheme + ':';
};

var getUsername = function () {
  return getInternalURLState(this).username;
};

var getPassword = function () {
  return getInternalURLState(this).password;
};

var getHost = function () {
  var url = getInternalURLState(this);
  var host = url.host;
  var port = url.port;
  return host === null ? ''
    : port === null ? serializeHost(host)
    : serializeHost(host) + ':' + port;
};

var getHostname = function () {
  var host = getInternalURLState(this).host;
  return host === null ? '' : serializeHost(host);
};

var getPort = function () {
  var port = getInternalURLState(this).port;
  return port === null ? '' : String(port);
};

var getPathname = function () {
  var url = getInternalURLState(this);
  var path = url.path;
  return url.cannotBeABaseURL ? path[0] : path.length ? '/' + path.join('/') : '';
};

var getSearch = function () {
  var query = getInternalURLState(this).query;
  return query ? '?' + query : '';
};

var getSearchParams = function () {
  return getInternalURLState(this).searchParams;
};

var getHash = function () {
  var fragment = getInternalURLState(this).fragment;
  return fragment ? '#' + fragment : '';
};

var accessorDescriptor = function (getter, setter) {
  return { get: getter, set: setter, configurable: true, enumerable: true };
};

if (DESCRIPTORS) {
  defineProperties(URLPrototype, {
    // `URL.prototype.href` accessors pair
    // https://url.spec.whatwg.org/#dom-url-href
    href: accessorDescriptor(serializeURL, function (href) {
      var url = getInternalURLState(this);
      var urlString = String(href);
      var failure = parseURL(url, urlString);
      if (failure) throw TypeError(failure);
      getInternalSearchParamsState(url.searchParams).updateSearchParams(url.query);
    }),
    // `URL.prototype.origin` getter
    // https://url.spec.whatwg.org/#dom-url-origin
    origin: accessorDescriptor(getOrigin),
    // `URL.prototype.protocol` accessors pair
    // https://url.spec.whatwg.org/#dom-url-protocol
    protocol: accessorDescriptor(getProtocol, function (protocol) {
      var url = getInternalURLState(this);
      parseURL(url, String(protocol) + ':', SCHEME_START);
    }),
    // `URL.prototype.username` accessors pair
    // https://url.spec.whatwg.org/#dom-url-username
    username: accessorDescriptor(getUsername, function (username) {
      var url = getInternalURLState(this);
      var codePoints = arrayFrom(String(username));
      if (cannotHaveUsernamePasswordPort(url)) return;
      url.username = '';
      for (var i = 0; i < codePoints.length; i++) {
        url.username += percentEncode(codePoints[i], userinfoPercentEncodeSet);
      }
    }),
    // `URL.prototype.password` accessors pair
    // https://url.spec.whatwg.org/#dom-url-password
    password: accessorDescriptor(getPassword, function (password) {
      var url = getInternalURLState(this);
      var codePoints = arrayFrom(String(password));
      if (cannotHaveUsernamePasswordPort(url)) return;
      url.password = '';
      for (var i = 0; i < codePoints.length; i++) {
        url.password += percentEncode(codePoints[i], userinfoPercentEncodeSet);
      }
    }),
    // `URL.prototype.host` accessors pair
    // https://url.spec.whatwg.org/#dom-url-host
    host: accessorDescriptor(getHost, function (host) {
      var url = getInternalURLState(this);
      if (url.cannotBeABaseURL) return;
      parseURL(url, String(host), HOST);
    }),
    // `URL.prototype.hostname` accessors pair
    // https://url.spec.whatwg.org/#dom-url-hostname
    hostname: accessorDescriptor(getHostname, function (hostname) {
      var url = getInternalURLState(this);
      if (url.cannotBeABaseURL) return;
      parseURL(url, String(hostname), HOSTNAME);
    }),
    // `URL.prototype.port` accessors pair
    // https://url.spec.whatwg.org/#dom-url-port
    port: accessorDescriptor(getPort, function (port) {
      var url = getInternalURLState(this);
      if (cannotHaveUsernamePasswordPort(url)) return;
      port = String(port);
      if (port == '') url.port = null;
      else parseURL(url, port, PORT);
    }),
    // `URL.prototype.pathname` accessors pair
    // https://url.spec.whatwg.org/#dom-url-pathname
    pathname: accessorDescriptor(getPathname, function (pathname) {
      var url = getInternalURLState(this);
      if (url.cannotBeABaseURL) return;
      url.path = [];
      parseURL(url, pathname + '', PATH_START);
    }),
    // `URL.prototype.search` accessors pair
    // https://url.spec.whatwg.org/#dom-url-search
    search: accessorDescriptor(getSearch, function (search) {
      var url = getInternalURLState(this);
      search = String(search);
      if (search == '') {
        url.query = null;
      } else {
        if ('?' == search.charAt(0)) search = search.slice(1);
        url.query = '';
        parseURL(url, search, QUERY);
      }
      getInternalSearchParamsState(url.searchParams).updateSearchParams(url.query);
    }),
    // `URL.prototype.searchParams` getter
    // https://url.spec.whatwg.org/#dom-url-searchparams
    searchParams: accessorDescriptor(getSearchParams),
    // `URL.prototype.hash` accessors pair
    // https://url.spec.whatwg.org/#dom-url-hash
    hash: accessorDescriptor(getHash, function (hash) {
      var url = getInternalURLState(this);
      hash = String(hash);
      if (hash == '') {
        url.fragment = null;
        return;
      }
      if ('#' == hash.charAt(0)) hash = hash.slice(1);
      url.fragment = '';
      parseURL(url, hash, FRAGMENT);
    })
  });
}

// `URL.prototype.toJSON` method
// https://url.spec.whatwg.org/#dom-url-tojson
redefine(URLPrototype, 'toJSON', function toJSON() {
  return serializeURL.call(this);
}, { enumerable: true });

// `URL.prototype.toString` method
// https://url.spec.whatwg.org/#URL-stringification-behavior
redefine(URLPrototype, 'toString', function toString() {
  return serializeURL.call(this);
}, { enumerable: true });

if (NativeURL) {
  var nativeCreateObjectURL = NativeURL.createObjectURL;
  var nativeRevokeObjectURL = NativeURL.revokeObjectURL;
  // `URL.createObjectURL` method
  // https://developer.mozilla.org/en-US/docs/Web/API/URL/createObjectURL
  // eslint-disable-next-line no-unused-vars
  if (nativeCreateObjectURL) redefine(URLConstructor, 'createObjectURL', function createObjectURL(blob) {
    return nativeCreateObjectURL.apply(NativeURL, arguments);
  });
  // `URL.revokeObjectURL` method
  // https://developer.mozilla.org/en-US/docs/Web/API/URL/revokeObjectURL
  // eslint-disable-next-line no-unused-vars
  if (nativeRevokeObjectURL) redefine(URLConstructor, 'revokeObjectURL', function revokeObjectURL(url) {
    return nativeRevokeObjectURL.apply(NativeURL, arguments);
  });
}

setToStringTag(URLConstructor, 'URL');

$({ global: true, forced: !USE_NATIVE_URL, sham: !DESCRIPTORS }, {
  URL: URLConstructor
});


/***/ }),

/***/ "2b57":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("c8d5")

/**
 * @category Weekday Helpers
 * @summary Is the given date Sunday?
 *
 * @description
 * Is the given date Sunday?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is Sunday
 *
 * @example
 * // Is 21 September 2014 Sunday?
 * var result = isSunday(new Date(2014, 8, 21))
 * //=> true
 */
function isSunday (dirtyDate) {
  return parse(dirtyDate).getDay() === 0
}

module.exports = isSunday


/***/ }),

/***/ "2b64":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M3 2C1.897 2 1 2.99556 1 4.22222V19.7778C1 21.0033 1.897 22 3 22H21C22.103 22 23 21.0033 23 19.7778V4.22222C23 2.99556 22.103 2 21 2H3Z\" fill=\"#1F3A3E\"></path><rect x=\"3\" y=\"6\" width=\"18\" height=\"14\" fill=\"#DFE4E5\"></rect><rect width=\"9\" height=\"14\" transform=\"matrix(-1 0 0 1 12 6)\" fill=\"white\"></rect><path d=\"M13.7262 13.0758L16.3421 15.7438C18.8103 18.2592 20.3477 20.5127 19.9325 20.9318C19.5157 21.3509 17.2789 19.802 14.7821 17.3162C14.0686 16.6067 13.3948 15.936 12.7955 15.3395C12.5611 15.1061 12.3381 14.8841 12.1285 14.6755C11.9808 14.5282 12.02 14.3498 12.2024 14.2496C12.6658 13.9937 13.0479 13.6118 13.3019 13.1494C13.4022 12.9657 13.58 12.927 13.7262 13.0758Z\" fill=\"#1F3A3E\"></path><path d=\"M11.2631 10.1998C11.9926 10.3737 12.5209 11.0722 12.5209 11.8231C12.5209 12.7084 11.7703 13.4661 10.8441 13.4661C9.28854 13.4661 8.2372 10.7836 8.01488 9.41775C7.94328 8.98043 8.13395 8.8802 8.50399 9.1467C9.27218 9.69813 10.2663 9.94836 11.0189 10.1378C11.1036 10.1591 11.1852 10.1797 11.2631 10.1998Z\" fill=\"#1F3A3E\"></path></svg>";

/***/ }),

/***/ "2b67":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("c8d5")

/**
 * @category Common Helpers
 * @summary Is the given date in the future?
 *
 * @description
 * Is the given date in the future?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in the future
 *
 * @example
 * // If today is 6 October 2014, is 31 December 2014 in the future?
 * var result = isFuture(new Date(2014, 11, 31))
 * //=> true
 */
function isFuture (dirtyDate) {
  return parse(dirtyDate).getTime() > new Date().getTime()
}

module.exports = isFuture


/***/ }),

/***/ "2ba3":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.i, "@import url(https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css);"]);
exports.push([module.i, "@import url(https://cdn-prd.patientpop.com/pp-icon-font/v1.6.0/pp-icon-font.css);"]);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.pp-masked-data[data-v-1effbcc5]:hover{color:#079cb2;cursor:pointer}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "2bb3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpCheckList_vue_vue_type_style_index_0_id_f6ec1c2a_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2c23");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpCheckList_vue_vue_type_style_index_0_id_f6ec1c2a_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpCheckList_vue_vue_type_style_index_0_id_f6ec1c2a_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "2bfd":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("2739");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("45ef5b0a", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "2c23":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("0cc0");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("17d31362", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "2c3a":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.theme--light.v-color-picker .v-color-picker__input input{border:thin solid #d6d6d6;color:var(--pp-text-primary,#2b2b2b)}.theme--light.v-color-picker span{color:var(--pp-text-secondary,#2b2b2b)}.theme--light.v-color-picker .v-color-picker__color,.theme--light.v-color-picker .v-color-picker__dot{background-color:hsla(0,0%,100%,0)}.theme--dark.v-color-picker .v-color-picker__input input{border:thin solid hsla(0,0%,100%,.12);color:var(--pp-primary-button-text-color,#004852)}.theme--dark.v-color-picker span{color:hsla(0,0%,100%,.7)}.theme--dark.v-color-picker .v-color-picker__color,.theme--dark.v-color-picker .v-color-picker__dot{background-color:hsla(0,0%,100%,.12)}.v-color-picker{align-self:flex-start;border-radius:5px;contain:content;box-shadow:0 3px 1px -2px transparent,0 2px 2px 0 transparent,0 1px 5px 0 rgba(0,0,0,.12)}.v-color-picker__controls{display:flex;flex-direction:column;padding:8px 0}.v-color-picker--flat,.v-color-picker--flat .v-color-picker__track:not(.v-input--is-disabled) .v-slider__thumb{box-shadow:0 0 0 0 transparent,0 0 0 0 transparent,0 0 0 0 rgba(0,0,0,.12)}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "2c64":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("72ce");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("0854597a", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "2ca0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var getOwnPropertyDescriptor = __webpack_require__("06cf").f;
var toLength = __webpack_require__("50c4");
var notARegExp = __webpack_require__("5a34");
var requireObjectCoercible = __webpack_require__("1d80");
var correctIsRegExpLogic = __webpack_require__("ab13");
var IS_PURE = __webpack_require__("c430");

var nativeStartsWith = ''.startsWith;
var min = Math.min;

var CORRECT_IS_REGEXP_LOGIC = correctIsRegExpLogic('startsWith');
// https://github.com/zloirock/core-js/pull/702
var MDN_POLYFILL_BUG = !IS_PURE && !CORRECT_IS_REGEXP_LOGIC && !!function () {
  var descriptor = getOwnPropertyDescriptor(String.prototype, 'startsWith');
  return descriptor && !descriptor.writable;
}();

// `String.prototype.startsWith` method
// https://tc39.es/ecma262/#sec-string.prototype.startswith
$({ target: 'String', proto: true, forced: !MDN_POLYFILL_BUG && !CORRECT_IS_REGEXP_LOGIC }, {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = String(requireObjectCoercible(this));
    notARegExp(searchString);
    var index = toLength(min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return nativeStartsWith
      ? nativeStartsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),

/***/ "2cf4":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var fails = __webpack_require__("d039");
var bind = __webpack_require__("0366");
var html = __webpack_require__("1be4");
var createElement = __webpack_require__("cc12");
var IS_IOS = __webpack_require__("1cdc");
var IS_NODE = __webpack_require__("605d");

var location = global.location;
var set = global.setImmediate;
var clear = global.clearImmediate;
var process = global.process;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;

var run = function (id) {
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};

var runner = function (id) {
  return function () {
    run(id);
  };
};

var listener = function (event) {
  run(event.data);
};

var post = function (id) {
  // old engines have not location.origin
  global.postMessage(id + '', location.protocol + '//' + location.host);
};

// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!set || !clear) {
  set = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(undefined, args);
    };
    defer(counter);
    return counter;
  };
  clear = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (IS_NODE) {
    defer = function (id) {
      process.nextTick(runner(id));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(runner(id));
    };
  // Browsers with MessageChannel, includes WebWorkers
  // except iOS - https://github.com/zloirock/core-js/issues/624
  } else if (MessageChannel && !IS_IOS) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = bind(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (
    global.addEventListener &&
    typeof postMessage == 'function' &&
    !global.importScripts &&
    location && location.protocol !== 'file:' &&
    !fails(post)
  ) {
    defer = post;
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in createElement('script')) {
    defer = function (id) {
      html.appendChild(createElement('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(runner(id), 0);
    };
  }
}

module.exports = {
  set: set,
  clear: clear
};


/***/ }),

/***/ "2d00":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var userAgent = __webpack_require__("342f");

var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  version = match[0] + match[1];
} else if (userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = match[1];
  }
}

module.exports = version && +version;


/***/ }),

/***/ "2d23":
/***/ (function(module, exports, __webpack_require__) {

var isSameWeek = __webpack_require__("1baf")

/**
 * @category Week Helpers
 * @summary Is the given date in the same week as the current date?
 *
 * @description
 * Is the given date in the same week as the current date?
 *
 * @param {Date|String|Number} date - the date to check
 * @param {Object} [options] - the object with options
 * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Boolean} the date is in this week
 *
 * @example
 * // If today is 25 September 2014, is 21 September 2014 in this week?
 * var result = isThisWeek(new Date(2014, 8, 21))
 * //=> true
 *
 * @example
 * // If today is 25 September 2014 and week starts with Monday
 * // is 21 September 2014 in this week?
 * var result = isThisWeek(new Date(2014, 8, 21), {weekStartsOn: 1})
 * //=> false
 */
function isThisWeek (dirtyDate, dirtyOptions) {
  return isSameWeek(new Date(), dirtyDate, dirtyOptions)
}

module.exports = isThisWeek


/***/ }),

/***/ "2d96":
/***/ (function(module, exports) {

function buildDistanceInWordsLocale () {
  var distanceInWordsLocale = {
    lessThanXSeconds: {
      one: 'less than a second',
      other: 'less than {{count}} seconds'
    },

    xSeconds: {
      one: '1 second',
      other: '{{count}} seconds'
    },

    halfAMinute: 'half a minute',

    lessThanXMinutes: {
      one: 'less than a minute',
      other: 'less than {{count}} minutes'
    },

    xMinutes: {
      one: '1 minute',
      other: '{{count}} minutes'
    },

    aboutXHours: {
      one: 'about 1 hour',
      other: 'about {{count}} hours'
    },

    xHours: {
      one: '1 hour',
      other: '{{count}} hours'
    },

    xDays: {
      one: '1 day',
      other: '{{count}} days'
    },

    aboutXMonths: {
      one: 'about 1 month',
      other: 'about {{count}} months'
    },

    xMonths: {
      one: '1 month',
      other: '{{count}} months'
    },

    aboutXYears: {
      one: 'about 1 year',
      other: 'about {{count}} years'
    },

    xYears: {
      one: '1 year',
      other: '{{count}} years'
    },

    overXYears: {
      one: 'over 1 year',
      other: 'over {{count}} years'
    },

    almostXYears: {
      one: 'almost 1 year',
      other: 'almost {{count}} years'
    }
  }

  function localize (token, count, options) {
    options = options || {}

    var result
    if (typeof distanceInWordsLocale[token] === 'string') {
      result = distanceInWordsLocale[token]
    } else if (count === 1) {
      result = distanceInWordsLocale[token].one
    } else {
      result = distanceInWordsLocale[token].other.replace('{{count}}', count)
    }

    if (options.addSuffix) {
      if (options.comparison > 0) {
        return 'in ' + result
      } else {
        return result + ' ago'
      }
    }

    return result
  }

  return {
    localize: localize
  }
}

module.exports = buildDistanceInWordsLocale


/***/ }),

/***/ "2e90":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpCard_vue_vue_type_style_index_0_id_34bf26aa_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("b13b");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpCard_vue_vue_type_style_index_0_id_34bf26aa_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpCard_vue_vue_type_style_index_0_id_34bf26aa_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "2e94":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M7.5 16.5L5 18.5L6 19.5L7.5 21L9 21.5H12H14L16.5 21L18 20L18.5 18.5L18 17H16.5L13.5 16L11 16.5H7.5Z\" fill=\"#D5EAFD\"></path><path d=\"M6.5 16.5L3.5 17.5L2.5 15.5L2 14V11L2.5 8.5L4.5 5.5L7 3.5L11.5 2.5L15.5 3L18.5 5L21.5 10V13.5L21 17L20 17.5L19 18L18 17.5L15.5 16.5C15 16.3333 13.9 16 13.5 16C13.1 16 12.3333 15.6667 12 15.5L12.5 14.5L14 13.5L14.5 12.1875V9L13.5 7.5L12 7L10.5 7.5L9.5 9L9 10.5L9.5 13L10.5 14L12 14.5L11.5 16H10.5H9.5L8 16.5H6.5Z\" fill=\"white\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M1 12C1 18.0751 5.92487 23 12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12ZM17.9647 18.7398C16.3767 20.1462 14.2881 21 12 21C9.71194 21 7.6233 20.1462 6.03532 18.7398C6.32801 17.6874 8.43062 17 12 17C15.5694 17 17.672 17.6873 17.9647 18.7398ZM19.3995 17.1246C18.274 15.6381 15.6294 15 12 15C8.3706 15 5.72596 15.6381 4.60051 17.1246C3.59138 15.6703 3 13.9042 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 13.9042 20.4086 15.6703 19.3995 17.1246ZM8 10C8 7.75576 9.5791 6 12 6C14.4142 6 16 7.92158 16 10.2C16 13.4796 14.2181 15 12 15C9.76086 15 8 13.4274 8 10Z\" fill=\"#079CB2\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M10 10C10 12.2693 10.8182 13 12 13C13.1777 13 14 12.2984 14 10.2C14 8.95042 13.2157 8 12 8C10.7337 8 10 8.81582 10 10Z\" fill=\"#D5EAFD\"></path></svg>";

/***/ }),

/***/ "2eb6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c662cfac-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/conversation/PpConversation.vue?vue&type=template&id=6ca91290&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pp-conversation"},[_vm._t("header"),_c('section',{staticClass:"pp-conversation__messages mb-5"},[(_vm.loading)?_c('pp-loading-icon'):[(_vm.messages.length === 0 || !_vm.messages)?[_c('div',{staticClass:"d-flex align-center justify-center flex-column pp-conversation__messages__empty"},[_c('img',{attrs:{"src":"https://ui-cdn.patientpop.com/assets/img/no-messages.svg","alt":"No Messages"}}),_c('div',{staticClass:"text-h2"},[_vm._v(" No Messages ")])])]:_vm._e(),_vm._l((_vm.messages.slice().reverse()),function(message){return [_c('pp-message',{key:message.messageId,attrs:{"attachment-data":message.attachmentData,"is-from-practice":message.isFromPractice,"name":message.isFromPractice ? _vm.practiceName : _vm.patientName,"status":message.status,"text":message.text,"timestamp":message.timestamp,"source":message.messageType,"attachment-uuid":message.attachmentUUID}})]})]],2),_vm._t("footer")],2)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/conversation/PpConversation.vue?vue&type=template&id=6ca91290&scoped=true&

// EXTERNAL MODULE: ./src/components/message/PpMessage.vue + 5 modules
var PpMessage = __webpack_require__("fdc0");

// EXTERNAL MODULE: ./src/components/loading-icon/PpLoadingIcon.vue + 4 modules
var PpLoadingIcon = __webpack_require__("efbd");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/conversation/PpConversation.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var PpConversationvue_type_script_lang_js_ = ({
  name: 'PpConversation',
  components: {
    'pp-message': PpMessage["default"],
    'pp-loading-icon': PpLoadingIcon["default"]
  },
  props: {
    messages: {
      type: Array,
      required: true
    },
    patientName: {
      type: String,
      required: true
    },
    practiceName: {
      type: String,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  }
});
// CONCATENATED MODULE: ./src/components/conversation/PpConversation.vue?vue&type=script&lang=js&
 /* harmony default export */ var conversation_PpConversationvue_type_script_lang_js_ = (PpConversationvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/conversation/PpConversation.vue?vue&type=style&index=0&id=6ca91290&lang=scss&scoped=true&
var PpConversationvue_type_style_index_0_id_6ca91290_lang_scss_scoped_true_ = __webpack_require__("58d5");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/conversation/PpConversation.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  conversation_PpConversationvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "6ca91290",
  null
  
)

/* harmony default export */ var PpConversation = __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "2ee3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SIZES; });
/**
 * Restrict size for the avatar,
 * with every avatar size 20px & 24px, 28px, 36px, 48px, 60px and 96px
 * text size will respectively be 10px, 12px, 14px, 16px, 20px, 24px
 */
var SIZES = {
  xxs: 20,
  xs: 24,
  sm: 28,
  md: 36,
  lg: 48,
  xl: 60,
  xxl: 96,
  xxxl: 156
};

/***/ }),

/***/ "2f1a":
/***/ (function(module, exports, __webpack_require__) {

var startOfWeek = __webpack_require__("c7ce")

var MILLISECONDS_IN_MINUTE = 60000
var MILLISECONDS_IN_WEEK = 604800000

/**
 * @category Week Helpers
 * @summary Get the number of calendar weeks between the given dates.
 *
 * @description
 * Get the number of calendar weeks between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @param {Object} [options] - the object with options
 * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Number} the number of calendar weeks
 *
 * @example
 * // How many calendar weeks are between 5 July 2014 and 20 July 2014?
 * var result = differenceInCalendarWeeks(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 6, 5)
 * )
 * //=> 3
 *
 * @example
 * // If the week starts on Monday,
 * // how many calendar weeks are between 5 July 2014 and 20 July 2014?
 * var result = differenceInCalendarWeeks(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 6, 5),
 *   {weekStartsOn: 1}
 * )
 * //=> 2
 */
function differenceInCalendarWeeks (dirtyDateLeft, dirtyDateRight, dirtyOptions) {
  var startOfWeekLeft = startOfWeek(dirtyDateLeft, dirtyOptions)
  var startOfWeekRight = startOfWeek(dirtyDateRight, dirtyOptions)

  var timestampLeft = startOfWeekLeft.getTime() -
    startOfWeekLeft.getTimezoneOffset() * MILLISECONDS_IN_MINUTE
  var timestampRight = startOfWeekRight.getTime() -
    startOfWeekRight.getTimezoneOffset() * MILLISECONDS_IN_MINUTE

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_WEEK)
}

module.exports = differenceInCalendarWeeks


/***/ }),

/***/ "2f8f":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("c8d5")

/**
 * @category Year Helpers
 * @summary Set the year to the given date.
 *
 * @description
 * Set the year to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} year - the year of the new date
 * @returns {Date} the new date with the year setted
 *
 * @example
 * // Set year 2013 to 1 September 2014:
 * var result = setYear(new Date(2014, 8, 1), 2013)
 * //=> Sun Sep 01 2013 00:00:00
 */
function setYear (dirtyDate, dirtyYear) {
  var date = parse(dirtyDate)
  var year = Number(dirtyYear)
  date.setFullYear(year)
  return date
}

module.exports = setYear


/***/ }),

/***/ "2fff":
/***/ (function(module, exports, __webpack_require__) {

var startOfISOYear = __webpack_require__("4497")

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Are the given dates in the same ISO week-numbering year?
 *
 * @description
 * Are the given dates in the same ISO week-numbering year?
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same ISO week-numbering year
 *
 * @example
 * // Are 29 December 2003 and 2 January 2005 in the same ISO week-numbering year?
 * var result = isSameISOYear(
 *   new Date(2003, 11, 29),
 *   new Date(2005, 0, 2)
 * )
 * //=> true
 */
function isSameISOYear (dirtyDateLeft, dirtyDateRight) {
  var dateLeftStartOfYear = startOfISOYear(dirtyDateLeft)
  var dateRightStartOfYear = startOfISOYear(dirtyDateRight)

  return dateLeftStartOfYear.getTime() === dateRightStartOfYear.getTime()
}

module.exports = isSameISOYear


/***/ }),

/***/ "301d":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("3e60");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("26b7e6d6", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "305c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c662cfac-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/check-list/PpCheckList.vue?vue&type=template&id=f6ec1c2a&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"pp-check-list pa-0 ma-0 mb-5"},_vm._l((_vm.items),function(item,i){return _c('li',{key:i,staticClass:"d-flex align-center pb-2 text-h6"},[_c('i',{staticClass:"d-inline-flex  mr-3 text-h3 pp-icon-check-circle success--text"}),_vm._v(" "+_vm._s(item)+" ")])}),0)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/check-list/PpCheckList.vue?vue&type=template&id=f6ec1c2a&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/check-list/PpCheckList.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * Create bullet list using check mark as the bullet
 */
/* harmony default export */ var PpCheckListvue_type_script_lang_js_ = ({
  name: 'PpCheckList',
  props: {
    items: {
      type: Array,
      required: true
    }
  }
});
// CONCATENATED MODULE: ./src/components/check-list/PpCheckList.vue?vue&type=script&lang=js&
 /* harmony default export */ var check_list_PpCheckListvue_type_script_lang_js_ = (PpCheckListvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/check-list/PpCheckList.vue?vue&type=style&index=0&id=f6ec1c2a&lang=scss&scoped=true&
var PpCheckListvue_type_style_index_0_id_f6ec1c2a_lang_scss_scoped_true_ = __webpack_require__("2bb3");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/check-list/PpCheckList.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  check_list_PpCheckListvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "f6ec1c2a",
  null
  
)

/* harmony default export */ var PpCheckList = __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "30d1":
/***/ (function(module, exports, __webpack_require__) {

var startOfDay = __webpack_require__("0978")

/**
 * @category Day Helpers
 * @summary Is the given date today?
 *
 * @description
 * Is the given date today?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is today
 *
 * @example
 * // If today is 6 October 2014, is 6 October 14:00:00 today?
 * var result = isToday(new Date(2014, 9, 6, 14, 0))
 * //=> true
 */
function isToday (dirtyDate) {
  return startOfDay(dirtyDate).getTime() === startOfDay(new Date()).getTime()
}

module.exports = isToday


/***/ }),

/***/ "3194":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpRichTextEditor_vue_vue_type_style_index_0_id_233fd1d2_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("110d");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpRichTextEditor_vue_vue_type_style_index_0_id_233fd1d2_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpRichTextEditor_vue_vue_type_style_index_0_id_233fd1d2_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "31b3":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_1488_315)\"><circle cx=\"12\" cy=\"12\" r=\"10\" fill=\"white\" stroke=\"#079CB2\" stroke-width=\"2\"></circle><circle cx=\"12\" cy=\"12\" r=\"7\" fill=\"#D5EAFD\"></circle><path d=\"M11.125 16.0908C11.125 16.5929 11.5169 17 12.0003 17C12.4837 17 12.8756 16.5929 12.8756 16.0908C12.8756 15.5886 12.4837 15.1815 12.0003 15.1815C11.5169 15.1815 11.125 15.5886 11.125 16.0908Z\" fill=\"#079CB2\"></path><path d=\"M11.125 14.2738H12.875C12.875 13.5479 12.9847 13.4149 13.7038 13.0413C14.9535 12.392 15.5 11.7295 15.5 10.1823C15.5 8.20075 13.9988 7 12 7C10.067 7 8.5 8.6283 8.5 10.6369H10.25C10.25 9.63261 11.0335 8.81846 12 8.81846C13.1175 8.81846 13.75 9.32436 13.75 10.1823C13.75 10.9082 13.6403 11.0412 12.9212 11.4148C11.6715 12.0641 11.125 12.7266 11.125 14.2738Z\" fill=\"#079CB2\"></path></g><defs><clipPath id=\"clip0_1488_315\"><rect width=\"24\" height=\"24\" fill=\"white\"></rect></clipPath></defs></svg>";

/***/ }),

/***/ "31ce":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("7ed6");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("6e2b0cc2", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "3206":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return inject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return provide; });
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("99af");
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ade3");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("8bbf");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _util_console__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("d9bd");





function generateWarning(child, parent) {
  return function () {
    return Object(_util_console__WEBPACK_IMPORTED_MODULE_3__[/* consoleWarn */ "c"])("The ".concat(child, " component must be used inside a ").concat(parent));
  };
}

function inject(namespace, child, parent) {
  var defaultImpl = child && parent ? {
    register: generateWarning(child, parent),
    unregister: generateWarning(child, parent)
  } : null;
  return vue__WEBPACK_IMPORTED_MODULE_2___default.a.extend({
    name: 'registrable-inject',
    inject: Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])({}, namespace, {
      default: defaultImpl
    })
  });
}
function provide(namespace) {
  var self = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return vue__WEBPACK_IMPORTED_MODULE_2___default.a.extend({
    name: 'registrable-provide',
    provide: function provide() {
      return Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])({}, namespace, self ? this : {
        register: this.register,
        unregister: this.unregister
      });
    }
  });
}

/***/ }),

/***/ "324e":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><rect x=\"3\" y=\"4\" width=\"18\" height=\"19\" rx=\"3\" fill=\"white\"></rect><rect x=\"8\" y=\"3\" width=\"8\" height=\"3\" fill=\"#DFE4E5\"></rect><path d=\"M6.71 4C6.90441 3.55503 7.22412 3.17626 7.63014 2.9099C8.03615 2.64355 8.51092 2.50112 8.9965 2.5H9.2075C9.40223 2.05382 9.72299 1.67421 10.1304 1.40774C10.5378 1.14128 11.0142 0.99957 11.501 1H12.499C12.9856 1.00008 13.4616 1.14202 13.8687 1.40843C14.2759 1.67484 14.5966 2.05417 14.7915 2.5H15.0035C15.4894 2.50036 15.9646 2.64246 16.3709 2.9089C16.7772 3.17534 17.097 3.55453 17.291 4H18.5C18.8284 4 19.1536 4.0647 19.4569 4.1904C19.7603 4.3161 20.036 4.50033 20.2681 4.73259C20.5003 4.96484 20.6844 5.24056 20.81 5.54399C20.9356 5.84741 21.0001 6.17261 21 6.501V20.499C20.9997 21.1621 20.7363 21.7979 20.2675 22.2668C19.7988 22.7358 19.1631 22.9995 18.5 23H5.5C5.17161 23 4.84644 22.9353 4.54306 22.8096C4.23968 22.6839 3.96404 22.4997 3.73188 22.2674C3.49972 22.0352 3.31559 21.7594 3.19001 21.456C3.06444 21.1526 2.99987 20.8274 3 20.499V6.501C3.00026 5.83795 3.26371 5.20212 3.73246 4.73317C4.20122 4.26423 4.83695 4.00053 5.5 4H6.71ZM6.551 6H5.5C5.225 6 5 6.225 5 6.501V20.499C4.99987 20.5647 5.0127 20.6299 5.03777 20.6907C5.06284 20.7514 5.09965 20.8067 5.14609 20.8532C5.19253 20.8997 5.2477 20.9367 5.30843 20.9618C5.36915 20.987 5.43425 21 5.5 21H18.5C18.775 21 19 20.775 19 20.499V6.501C19.0001 6.43526 18.9873 6.37013 18.9622 6.30935C18.9372 6.24857 18.9003 6.19334 18.8539 6.1468C18.8075 6.10027 18.7523 6.06335 18.6916 6.03816C18.6308 6.01297 18.5657 6 18.5 6H17.449C17.2155 7.14 16.2065 8 15.004 8H8.996C7.789 8 6.7835 7.14 6.551 6ZM10 4.5H8.9965C8.86404 4.50223 8.73777 4.55642 8.64489 4.65088C8.55202 4.74535 8.49998 4.87253 8.5 5.005V5.495C8.5 5.775 8.724 6 8.9965 6H15.0035C15.273 6 15.5 5.7725 15.5 5.495V5.005C15.5 4.725 15.276 4.5 15.0035 4.5H14C13.7348 4.5 13.4804 4.39464 13.2929 4.20711C13.1054 4.01957 13 3.76522 13 3.5C13 3.225 12.775 3 12.499 3H11.501C11.4352 2.99974 11.37 3.01248 11.3092 3.0375C11.2484 3.06253 11.1931 3.09933 11.1465 3.1458C11.0999 3.19227 11.063 3.24748 11.0379 3.30827C11.0127 3.36906 10.9999 3.43422 11 3.5C11 3.76522 10.8946 4.01957 10.7071 4.20711C10.5196 4.39464 10.2652 4.5 10 4.5Z\" fill=\"#688083\"></path><path d=\"M9 11C9 11.5523 8.55228 12 8 12C7.44772 12 7 11.5523 7 11C7 10.4477 7.44772 10 8 10C8.55228 10 9 10.4477 9 11Z\" fill=\"#688083\"></path><path d=\"M9 14C9 14.5523 8.55228 15 8 15C7.44772 15 7 14.5523 7 14C7 13.4477 7.44772 13 8 13C8.55228 13 9 13.4477 9 14Z\" fill=\"#688083\"></path><path d=\"M9 17C9 17.5523 8.55228 18 8 18C7.44772 18 7 17.5523 7 17C7 16.4477 7.44772 16 8 16C8.55228 16 9 16.4477 9 17Z\" fill=\"#688083\"></path><path d=\"M10 11C10 10.4477 10.4477 10 11 10H16C16.5523 10 17 10.4477 17 11C17 11.5523 16.5523 12 16 12H11C10.4477 12 10 11.5523 10 11Z\" fill=\"#688083\"></path><path d=\"M10 14C10 13.4477 10.4477 13 11 13H16C16.5523 13 17 13.4477 17 14C17 14.5523 16.5523 15 16 15H11C10.4477 15 10 14.5523 10 14Z\" fill=\"#688083\"></path><path d=\"M10 17C10 16.4477 10.4477 16 11 16H16C16.5523 16 17 16.4477 17 17C17 17.5523 16.5523 18 16 18H11C10.4477 18 10 17.5523 10 17Z\" fill=\"#688083\"></path></svg>";

/***/ }),

/***/ "326d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _VMenu__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("e449");


/* harmony default export */ __webpack_exports__["a"] = (_VMenu__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]);

/***/ }),

/***/ "32cd":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.v-date-picker-title{display:flex;justify-content:space-between;flex-direction:column;flex-wrap:wrap;line-height:1}.v-application--is-ltr .v-date-picker-title .v-picker__title__btn{text-align:left}.v-application--is-rtl .v-date-picker-title .v-picker__title__btn{text-align:right}.v-date-picker-title__year{align-items:center;display:inline-flex;font-size:14px;font-weight:500;margin-bottom:8px}.v-date-picker-title__date{font-size:34px;text-align:left;font-weight:500;position:relative;overflow:hidden;padding-bottom:8px;margin-bottom:-8px}.v-date-picker-title__date>div{position:relative}.v-date-picker-title--disabled{pointer-events:none}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "3408":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("062a");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("4be95aec", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "340b":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
  addDays: __webpack_require__("8946"),
  addHours: __webpack_require__("1cc6"),
  addISOYears: __webpack_require__("27a1"),
  addMilliseconds: __webpack_require__("ec1f"),
  addMinutes: __webpack_require__("72b7"),
  addMonths: __webpack_require__("6665"),
  addQuarters: __webpack_require__("f5dd"),
  addSeconds: __webpack_require__("af1b"),
  addWeeks: __webpack_require__("7a83"),
  addYears: __webpack_require__("fcb3"),
  areRangesOverlapping: __webpack_require__("eaa5"),
  closestIndexTo: __webpack_require__("7fd8"),
  closestTo: __webpack_require__("4f67"),
  compareAsc: __webpack_require__("0d3e"),
  compareDesc: __webpack_require__("c873"),
  differenceInCalendarDays: __webpack_require__("d420"),
  differenceInCalendarISOWeeks: __webpack_require__("82dc"),
  differenceInCalendarISOYears: __webpack_require__("f9ff"),
  differenceInCalendarMonths: __webpack_require__("b2e9"),
  differenceInCalendarQuarters: __webpack_require__("fb36"),
  differenceInCalendarWeeks: __webpack_require__("2f1a"),
  differenceInCalendarYears: __webpack_require__("2a9c"),
  differenceInDays: __webpack_require__("3bc7"),
  differenceInHours: __webpack_require__("d2ed"),
  differenceInISOYears: __webpack_require__("b3f5"),
  differenceInMilliseconds: __webpack_require__("e785"),
  differenceInMinutes: __webpack_require__("6570"),
  differenceInMonths: __webpack_require__("17cd"),
  differenceInQuarters: __webpack_require__("8301"),
  differenceInSeconds: __webpack_require__("e13a"),
  differenceInWeeks: __webpack_require__("ee91"),
  differenceInYears: __webpack_require__("6fcc"),
  distanceInWords: __webpack_require__("366b"),
  distanceInWordsStrict: __webpack_require__("bb7c"),
  distanceInWordsToNow: __webpack_require__("6254"),
  eachDay: __webpack_require__("c4c2"),
  endOfDay: __webpack_require__("9744"),
  endOfHour: __webpack_require__("271a"),
  endOfISOWeek: __webpack_require__("4175"),
  endOfISOYear: __webpack_require__("861d4"),
  endOfMinute: __webpack_require__("3ac3"),
  endOfMonth: __webpack_require__("d6f8"),
  endOfQuarter: __webpack_require__("3691"),
  endOfSecond: __webpack_require__("145e"),
  endOfToday: __webpack_require__("7443"),
  endOfTomorrow: __webpack_require__("6f4e"),
  endOfWeek: __webpack_require__("7494"),
  endOfYear: __webpack_require__("d975"),
  endOfYesterday: __webpack_require__("e51d"),
  format: __webpack_require__("70f2"),
  getDate: __webpack_require__("b60f"),
  getDay: __webpack_require__("c2b5"),
  getDayOfYear: __webpack_require__("580f"),
  getDaysInMonth: __webpack_require__("5416"),
  getDaysInYear: __webpack_require__("dddf"),
  getHours: __webpack_require__("5d95"),
  getISODay: __webpack_require__("84b9"),
  getISOWeek: __webpack_require__("81fc"),
  getISOWeeksInYear: __webpack_require__("3b7b"),
  getISOYear: __webpack_require__("8964"),
  getMilliseconds: __webpack_require__("8c81"),
  getMinutes: __webpack_require__("c589"),
  getMonth: __webpack_require__("7338"),
  getOverlappingDaysInRanges: __webpack_require__("6337"),
  getQuarter: __webpack_require__("b8f9"),
  getSeconds: __webpack_require__("231c"),
  getTime: __webpack_require__("902e"),
  getYear: __webpack_require__("10c8"),
  isAfter: __webpack_require__("a431"),
  isBefore: __webpack_require__("6b8f"),
  isDate: __webpack_require__("a735"),
  isEqual: __webpack_require__("abd4"),
  isFirstDayOfMonth: __webpack_require__("353e"),
  isFriday: __webpack_require__("a852"),
  isFuture: __webpack_require__("2b67"),
  isLastDayOfMonth: __webpack_require__("3eee"),
  isLeapYear: __webpack_require__("acc4"),
  isMonday: __webpack_require__("2507"),
  isPast: __webpack_require__("a935"),
  isSameDay: __webpack_require__("fd39"),
  isSameHour: __webpack_require__("662a"),
  isSameISOWeek: __webpack_require__("ccce"),
  isSameISOYear: __webpack_require__("2fff"),
  isSameMinute: __webpack_require__("f564"),
  isSameMonth: __webpack_require__("5a60"),
  isSameQuarter: __webpack_require__("9aaa"),
  isSameSecond: __webpack_require__("c6ae"),
  isSameWeek: __webpack_require__("1baf"),
  isSameYear: __webpack_require__("26d5"),
  isSaturday: __webpack_require__("48a6"),
  isSunday: __webpack_require__("2b57"),
  isThisHour: __webpack_require__("0157"),
  isThisISOWeek: __webpack_require__("cc64"),
  isThisISOYear: __webpack_require__("97af"),
  isThisMinute: __webpack_require__("3ef9"),
  isThisMonth: __webpack_require__("9bb9"),
  isThisQuarter: __webpack_require__("2a80"),
  isThisSecond: __webpack_require__("e620"),
  isThisWeek: __webpack_require__("2d23"),
  isThisYear: __webpack_require__("f66d"),
  isThursday: __webpack_require__("5a38"),
  isToday: __webpack_require__("30d1"),
  isTomorrow: __webpack_require__("20b1"),
  isTuesday: __webpack_require__("7606"),
  isValid: __webpack_require__("7eea"),
  isWednesday: __webpack_require__("c980"),
  isWeekend: __webpack_require__("9ad8"),
  isWithinRange: __webpack_require__("f56a"),
  isYesterday: __webpack_require__("c4f9"),
  lastDayOfISOWeek: __webpack_require__("5292"),
  lastDayOfISOYear: __webpack_require__("de13"),
  lastDayOfMonth: __webpack_require__("eca2"),
  lastDayOfQuarter: __webpack_require__("ce3d"),
  lastDayOfWeek: __webpack_require__("cb96"),
  lastDayOfYear: __webpack_require__("b8a7"),
  max: __webpack_require__("95ea"),
  min: __webpack_require__("1a84"),
  parse: __webpack_require__("c8d5"),
  setDate: __webpack_require__("957f"),
  setDay: __webpack_require__("b78a"),
  setDayOfYear: __webpack_require__("9530"),
  setHours: __webpack_require__("6f00"),
  setISODay: __webpack_require__("fa76"),
  setISOWeek: __webpack_require__("e73d"),
  setISOYear: __webpack_require__("9706"),
  setMilliseconds: __webpack_require__("d473"),
  setMinutes: __webpack_require__("8aed"),
  setMonth: __webpack_require__("3814"),
  setQuarter: __webpack_require__("158b"),
  setSeconds: __webpack_require__("9113"),
  setYear: __webpack_require__("2f8f"),
  startOfDay: __webpack_require__("0978"),
  startOfHour: __webpack_require__("fbaf"),
  startOfISOWeek: __webpack_require__("b4c7"),
  startOfISOYear: __webpack_require__("4497"),
  startOfMinute: __webpack_require__("e96b"),
  startOfMonth: __webpack_require__("942b"),
  startOfQuarter: __webpack_require__("4399"),
  startOfSecond: __webpack_require__("2299"),
  startOfToday: __webpack_require__("3cae"),
  startOfTomorrow: __webpack_require__("8148"),
  startOfWeek: __webpack_require__("c7ce"),
  startOfYear: __webpack_require__("a4b7"),
  startOfYesterday: __webpack_require__("693a"),
  subDays: __webpack_require__("e2ff"),
  subHours: __webpack_require__("fb98"),
  subISOYears: __webpack_require__("df35"),
  subMilliseconds: __webpack_require__("badb"),
  subMinutes: __webpack_require__("18b7"),
  subMonths: __webpack_require__("12fd"),
  subQuarters: __webpack_require__("d4ae"),
  subSeconds: __webpack_require__("83f0"),
  subWeeks: __webpack_require__("e1ca"),
  subYears: __webpack_require__("8902")
}


/***/ }),

/***/ "3410":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var fails = __webpack_require__("d039");
var toObject = __webpack_require__("7b0b");
var nativeGetPrototypeOf = __webpack_require__("e163");
var CORRECT_PROTOTYPE_GETTER = __webpack_require__("e177");

var FAILS_ON_PRIMITIVES = fails(function () { nativeGetPrototypeOf(1); });

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES, sham: !CORRECT_PROTOTYPE_GETTER }, {
  getPrototypeOf: function getPrototypeOf(it) {
    return nativeGetPrototypeOf(toObject(it));
  }
});



/***/ }),

/***/ "342f":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("d066");

module.exports = getBuiltIn('navigator', 'userAgent') || '';


/***/ }),

/***/ "34ea":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.i, "@import url(https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css);"]);
exports.push([module.i, "@import url(https://cdn-prd.patientpop.com/pp-icon-font/v1.6.0/pp-icon-font.css);"]);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.pp-link[data-v-cd6c2852]{color:#079cb2;text-decoration:none}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "34ef":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _VChip__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cc20");


/* harmony default export */ __webpack_exports__["a"] = (_VChip__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]);

/***/ }),

/***/ "353e":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("c8d5")

/**
 * @category Month Helpers
 * @summary Is the given date the first day of a month?
 *
 * @description
 * Is the given date the first day of a month?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is the first day of a month
 *
 * @example
 * // Is 1 September 2014 the first day of a month?
 * var result = isFirstDayOfMonth(new Date(2014, 8, 1))
 * //=> true
 */
function isFirstDayOfMonth (dirtyDate) {
  return parse(dirtyDate).getDate() === 1
}

module.exports = isFirstDayOfMonth


/***/ }),

/***/ "359a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c662cfac-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/input/rich-text-editor/PpRichTextEditor.vue?vue&type=template&id=233fd1d2&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rich-text-editor",class:{ 'rich-text-editor--focus': _vm.isFocused, 'rich-text-editor--error': _vm.isErrorState }},[(_vm.label)?_c('pp-input-label',{attrs:{"label":_vm.label,"optional":_vm.optional},on:{"click":function($event){_vm.isFocused = true}}}):_vm._e(),_c('editor',_vm._g(_vm._b({attrs:{"api-key":_vm.apiKey,"init":_vm.init,"toolbar":_vm.toolbar,"plugins":_vm.plugins,"initial-value":_vm.initialValue,"disabled":_vm.disabled},on:{"onFocus":function($event){_vm.isFocused = true},"onBlur":function($event){_vm.isFocused = false}}},'editor',_vm.$attrs,false),_vm.$listeners)),(_vm.isErrorState)?_c('div',{staticClass:"rich-text-editor-error--text mt-2",attrs:{"role":"alert"}},[_vm._v(" "+_vm._s(_vm.errorMessages)+" ")]):_vm._e()],1)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/input/rich-text-editor/PpRichTextEditor.vue?vue&type=template&id=233fd1d2&scoped=true&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("d3b7");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.promise.js
var es_promise = __webpack_require__("e6cf");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__("ac1f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.replace.js
var es_string_replace = __webpack_require__("5319");

// EXTERNAL MODULE: ./node_modules/regenerator-runtime/runtime.js
var runtime = __webpack_require__("96cf");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("1da1");

// CONCATENATED MODULE: ./node_modules/@tinymce/tinymce-vue/lib/es2015/main/ts/Utils.js
/**
 * Copyright (c) 2018-present, Ephox, Inc.
 *
 * This source code is licensed under the Apache 2 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
var validEvents = [
    'onActivate',
    'onAddUndo',
    'onBeforeAddUndo',
    'onBeforeExecCommand',
    'onBeforeGetContent',
    'onBeforeRenderUI',
    'onBeforeSetContent',
    'onBeforePaste',
    'onBlur',
    'onChange',
    'onClearUndos',
    'onClick',
    'onContextMenu',
    'onCopy',
    'onCut',
    'onDblclick',
    'onDeactivate',
    'onDirty',
    'onDrag',
    'onDragDrop',
    'onDragEnd',
    'onDragGesture',
    'onDragOver',
    'onDrop',
    'onExecCommand',
    'onFocus',
    'onFocusIn',
    'onFocusOut',
    'onGetContent',
    'onHide',
    'onInit',
    'onKeyDown',
    'onKeyPress',
    'onKeyUp',
    'onLoadContent',
    'onMouseDown',
    'onMouseEnter',
    'onMouseLeave',
    'onMouseMove',
    'onMouseOut',
    'onMouseOver',
    'onMouseUp',
    'onNodeChange',
    'onObjectResizeStart',
    'onObjectResized',
    'onObjectSelected',
    'onPaste',
    'onPostProcess',
    'onPostRender',
    'onPreProcess',
    'onProgressState',
    'onRedo',
    'onRemove',
    'onReset',
    'onSaveContent',
    'onSelectionChange',
    'onSetAttrib',
    'onSetContent',
    'onShow',
    'onSubmit',
    'onUndo',
    'onVisualAid'
];
var isValidKey = function (key) { return validEvents.map(function (event) { return event.toLowerCase(); }).indexOf(key.toLowerCase()) !== -1; };
var bindHandlers = function (initEvent, listeners, editor) {
    Object.keys(listeners)
        .filter(isValidKey)
        .forEach(function (key) {
        var handler = listeners[key];
        if (typeof handler === 'function') {
            if (key === 'onInit') {
                handler(initEvent, editor);
            }
            else {
                editor.on(key.substring(2), function (e) { return handler(e, editor); });
            }
        }
    });
};
var bindModelHandlers = function (ctx, editor) {
    var modelEvents = ctx.$props.modelEvents ? ctx.$props.modelEvents : null;
    var normalizedEvents = Array.isArray(modelEvents) ? modelEvents.join(' ') : modelEvents;
    editor.on(normalizedEvents ? normalizedEvents : 'change input undo redo', function () {
        ctx.$emit('input', editor.getContent({ format: ctx.$props.outputFormat }));
    });
};
var initEditor = function (initEvent, ctx, editor) {
    var value = ctx.$props.value ? ctx.$props.value : '';
    var initialValue = ctx.$props.initialValue ? ctx.$props.initialValue : '';
    editor.setContent(value || (ctx.initialized ? ctx.cache : initialValue));
    // Always bind the value listener in case users use :value instead of v-model
    ctx.$watch('value', function (val, prevVal) {
        if (editor && typeof val === 'string' && val !== prevVal && val !== editor.getContent({ format: ctx.$props.outputFormat })) {
            editor.setContent(val);
        }
    });
    // checks if the v-model shorthand is used (which sets an v-on:input listener) and then binds either
    // specified the events or defaults to "change keyup" event and emits the editor content on that event
    if (ctx.$listeners.input) {
        bindModelHandlers(ctx, editor);
    }
    bindHandlers(initEvent, ctx.$listeners, editor);
    ctx.initialized = true;
};
var unique = 0;
var uuid = function (prefix) {
    var time = Date.now();
    var random = Math.floor(Math.random() * 1000000000);
    unique++;
    return prefix + '_' + random + unique + String(time);
};
var isTextarea = function (element) {
    return element !== null && element.tagName.toLowerCase() === 'textarea';
};
var normalizePluginArray = function (plugins) {
    if (typeof plugins === 'undefined' || plugins === '') {
        return [];
    }
    return Array.isArray(plugins) ? plugins : plugins.split(' ');
};
var mergePlugins = function (initPlugins, inputPlugins) {
    return normalizePluginArray(initPlugins).concat(normalizePluginArray(inputPlugins));
};
var isNullOrUndefined = function (value) { return value === null || value === undefined; };


// CONCATENATED MODULE: ./node_modules/@tinymce/tinymce-vue/lib/es2015/main/ts/ScriptLoader.js
/**
 * Copyright (c) 2018-present, Ephox, Inc.
 *
 * This source code is licensed under the Apache 2 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

var createState = function () {
    return {
        listeners: [],
        scriptId: uuid('tiny-script'),
        scriptLoaded: false
    };
};
var CreateScriptLoader = function () {
    var state = createState();
    var injectScriptTag = function (scriptId, doc, url, callback) {
        var scriptTag = doc.createElement('script');
        scriptTag.referrerPolicy = 'origin';
        scriptTag.type = 'application/javascript';
        scriptTag.id = scriptId;
        scriptTag.src = url;
        var handler = function () {
            scriptTag.removeEventListener('load', handler);
            callback();
        };
        scriptTag.addEventListener('load', handler);
        if (doc.head) {
            doc.head.appendChild(scriptTag);
        }
    };
    var load = function (doc, url, callback) {
        if (state.scriptLoaded) {
            callback();
        }
        else {
            state.listeners.push(callback);
            if (!doc.getElementById(state.scriptId)) {
                injectScriptTag(state.scriptId, doc, url, function () {
                    state.listeners.forEach(function (fn) { return fn(); });
                    state.scriptLoaded = true;
                });
            }
        }
    };
    // Only to be used by tests.
    var reinitialize = function () {
        state = createState();
    };
    return {
        load: load,
        reinitialize: reinitialize
    };
};
var ScriptLoader = CreateScriptLoader();


// EXTERNAL MODULE: ./node_modules/@tinymce/tinymce-vue/lib/es2015/main/ts/TinyMCE.js
var TinyMCE = __webpack_require__("c4a9");

// CONCATENATED MODULE: ./node_modules/@tinymce/tinymce-vue/lib/es2015/main/ts/components/EditorPropTypes.js
/**
 * Copyright (c) 2018-present, Ephox, Inc.
 *
 * This source code is licensed under the Apache 2 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
var editorProps = {
    apiKey: String,
    cloudChannel: String,
    id: String,
    init: Object,
    initialValue: String,
    inline: Boolean,
    modelEvents: [String, Array],
    plugins: [String, Array],
    tagName: String,
    toolbar: [String, Array],
    value: String,
    disabled: Boolean,
    tinymceScriptSrc: String,
    outputFormat: {
        type: String,
        validator: function (prop) { return prop === 'html' || prop === 'text'; }
    },
};

// CONCATENATED MODULE: ./node_modules/@tinymce/tinymce-vue/lib/es2015/main/ts/components/Editor.js
/**
 * Copyright (c) 2018-present, Ephox, Inc.
 *
 * This source code is licensed under the Apache 2 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};




var renderInline = function (h, id, tagName) {
    return h(tagName ? tagName : 'div', {
        attrs: { id: id }
    });
};
var renderIframe = function (h, id) {
    return h('textarea', {
        attrs: { id: id },
        style: { visibility: 'hidden' }
    });
};
var initialise = function (ctx) { return function () {
    var finalInit = __assign(__assign({}, ctx.$props.init), { readonly: ctx.$props.disabled, selector: "#" + ctx.elementId, plugins: mergePlugins(ctx.$props.init && ctx.$props.init.plugins, ctx.$props.plugins), toolbar: ctx.$props.toolbar || (ctx.$props.init && ctx.$props.init.toolbar), inline: ctx.inlineEditor, setup: function (editor) {
            ctx.editor = editor;
            editor.on('init', function (e) { return initEditor(e, ctx, editor); });
            if (ctx.$props.init && typeof ctx.$props.init.setup === 'function') {
                ctx.$props.init.setup(editor);
            }
        } });
    if (isTextarea(ctx.element)) {
        ctx.element.style.visibility = '';
        ctx.element.style.display = '';
    }
    Object(TinyMCE["a" /* getTinymce */])().init(finalInit);
}; };
var Editor = {
    props: editorProps,
    created: function () {
        this.elementId = this.$props.id || uuid('tiny-vue');
        this.inlineEditor = (this.$props.init && this.$props.init.inline) || this.$props.inline;
        this.initialized = false;
    },
    watch: {
        disabled: function () {
            this.editor.setMode(this.disabled ? 'readonly' : 'design');
        }
    },
    mounted: function () {
        this.element = this.$el;
        if (Object(TinyMCE["a" /* getTinymce */])() !== null) {
            initialise(this)();
        }
        else if (this.element && this.element.ownerDocument) {
            var channel = this.$props.cloudChannel ? this.$props.cloudChannel : '5';
            var apiKey = this.$props.apiKey ? this.$props.apiKey : 'no-api-key';
            var scriptSrc = isNullOrUndefined(this.$props.tinymceScriptSrc) ?
                "https://cdn.tiny.cloud/1/" + apiKey + "/tinymce/" + channel + "/tinymce.min.js" :
                this.$props.tinymceScriptSrc;
            ScriptLoader.load(this.element.ownerDocument, scriptSrc, initialise(this));
        }
    },
    beforeDestroy: function () {
        if (Object(TinyMCE["a" /* getTinymce */])() !== null) {
            Object(TinyMCE["a" /* getTinymce */])().remove(this.editor);
        }
    },
    deactivated: function () {
        var _a;
        if (!this.inlineEditor) {
            this.cache = this.editor.getContent();
            (_a = Object(TinyMCE["a" /* getTinymce */])()) === null || _a === void 0 ? void 0 : _a.remove(this.editor);
        }
    },
    activated: function () {
        if (!this.inlineEditor && this.initialized) {
            initialise(this)();
        }
    },
    render: function (h) {
        return this.inlineEditor ? renderInline(h, this.elementId, this.$props.tagName) : renderIframe(h, this.elementId);
    }
};

// CONCATENATED MODULE: ./node_modules/@tinymce/tinymce-vue/lib/es2015/main/ts/index.js
/**
 * Copyright (c) 2018-present, Ephox, Inc.
 *
 * This source code is licensed under the Apache 2 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/* harmony default export */ var ts = (Editor);

// CONCATENATED MODULE: ./src/components/input/rich-text-editor/constants.js
var TINYMCE_SCRIPT = 'https://cdn.tiny.cloud/1/no-api-key/tinymce/5/tinymce.min.js';
// EXTERNAL MODULE: ./src/components/input/label/PpInputLabel.vue + 4 modules
var PpInputLabel = __webpack_require__("8e6c");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/input/rich-text-editor/PpRichTextEditor.vue?vue&type=script&lang=js&






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * Documentation for the TinyMCE vue component can be found
 * here: https://www.tiny.cloud/docs/integrations/vue/
 */



/* harmony default export */ var PpRichTextEditorvue_type_script_lang_js_ = ({
  name: 'PpRichTextEditor',
  components: {
    editor: ts,
    'pp-input-label': PpInputLabel["default"]
  },
  props: {
    /**
     * label for the editor
     */
    label: {
      type: String,
      default: ''
    },

    /**
     * If true, display optional label with a different color than the main label
     */
    optional: {
      type: Boolean,
      default: false
    },

    /**
     * Initial content of the editor when the editor is initialized. Can be HTML.
     */
    initialValue: {
      type: String,
      default: ''
    },

    /**
     * The disabled property can dynamically switch the editor between a “disabled”
     * (read-only) mode (true) and the standard editable mode (false).
     */
    disabled: {
      type: Boolean,
      default: false
    },

    /**
     * The object sent to the TinyMCE's init method used to initialize the editor.
     * Documentation: https://www.tiny.cloud/docs/integrations/vue/#init
     */
    init: {
      type: Object,
      default: function _default() {
        return {
          height: 300,
          menubar: false,
          statusbar: false,
          content_style: "\n            @font-face {\n              font-family: 'Open Sans';\n              font-display: swap;\n              src: url('https://sa1s3.patientpop.com/assets/fonts/provider/OpenSans-Regular-webfont.eot');\n              src: url('https://sa1s3.patientpop.com/assets/fonts/provider/OpenSans-Regular-webfont.eot?#iefix') format('embedded-opentype'), url('https://sa1s3.patientpop.com/assets/fonts/provider/OpenSans-Regular-webfont.woff') format('woff'), url('https://sa1s3.patientpop.com/assets/fonts/provider/OpenSans-Regular-webfont.ttf') format('truetype'), url('https://sa1s3.patientpop.com/assets/fonts/provider/OpenSans-Regular-webfont.svg#open_sansregular') format('svg');\n              font-weight: 400;\n              font-style: normal;\n            }\n            @font-face {\n              font-family: 'Open Sans';\n              font-display: swap;\n              src: url('https://sa1s3.patientpop.com/assets/fonts/provider/OpenSans-Light-webfont.eot');\n              src: url('https://sa1s3.patientpop.com/assets/fonts/provider/OpenSans-Light-webfont.eot?#iefix') format('embedded-opentype'), url('https://sa1s3.patientpop.com/assets/fonts/provider/OpenSans-Light-webfont.woff') format('woff'), url('https://sa1s3.patientpop.com/assets/fonts/provider/OpenSans-Light-webfont.ttf') format('truetype'), url('https://sa1s3.patientpop.com/assets/fonts/provider/OpenSans-Light-webfont.svg#open_sanslight') format('svg');\n              font-weight: 300;\n              font-style: normal;\n            }\n            @font-face {\n              font-family: 'Open Sans';\n              font-display: swap;\n              src: url('https://sa1s3.patientpop.com/assets/fonts/provider/OpenSans-Bold-webfont.eot');\n              src: url('https://sa1s3.patientpop.com/assets/fonts/provider/OpenSans-Bold-webfont.eot?#iefix') format('embedded-opentype'), url('https://sa1s3.patientpop.com/assets/fonts/provider/OpenSans-Bold-webfont.woff') format('woff'), url('https://sa1s3.patientpop.com/assets/fonts/provider/OpenSans-Bold-webfont.ttf') format('truetype'), url('https://sa1s3.patientpop.com/assets/fonts/provider/OpenSans-Bold-webfont.svg#open_sansbold') format('svg');\n              font-weight: 700;\n              font-style: normal;\n            }\n            @font-face {\n              font-family: 'Open Sans';\n              font-display: swap;\n              src: url('https://sa1s3.patientpop.com/assets/fonts/provider/OpenSans-Semibold-webfont.eot');\n              src: url('https://sa1s3.patientpop.com/assets/fonts/provider/OpenSans-Semibold-webfont.eot?#iefix') format('embedded-opentype'), url('https://sa1s3.patientpop.com/assets/fonts/provider/OpenSans-Semibold-webfont.woff') format('woff'), url('https://sa1s3.patientpop.com/assets/fonts/provider/OpenSans-Semibold-webfont.ttf') format('truetype'), url('https://sa1s3.patientpop.com/assets/fonts/provider/OpenSans-Semibold-webfont.svg#open_sanssemibold') format('svg');\n              font-weight: 600;\n              font-style: normal;\n            }\n            body { font-family: Open Sans; }\n          ",
          font_formats: "\n            Andale Mono=andale mono,times;\n            Arial=arial,helvetica,sans-serif;\n            Arial Black=arial black,avant garde;\n            Book Antiqua=book antiqua,palatino;\n            Comic Sans MS=comic sans ms,sans-serif;\n            Courier New=courier new,courier;\n            Georgia=georgia,palatino;\n            Helvetica=helvetica;\n            Impact=impact,chicago;\n            Open Sans=open sans;\n            Symbol=symbol;\n            Tahoma=tahoma,arial,helvetica,sans-serif;\n            Terminal=terminal,monaco;\n            Times New Roman=times new roman,times;\n            Trebuchet MS=trebuchet ms,geneva;\n            Verdana=verdana,geneva;\n            Webdings=webdings;\n            Wingdings=wingdings,zapf dingbats\n          "
        };
      }
    },

    /**
     * Used to include plugins for the editor. Equivalent to passing in a plugins option
     * to the init.
     * Documentation: https://www.tiny.cloud/docs/integrations/vue/#plugins
     */
    plugins: {
      type: Array,
      default: function _default() {
        return ['advlist autolink lists link image charmap preview searchreplace visualblocks code table contextmenu paste wordcount imagetools help'];
      }
    },

    /**
     * Used to set the toolbar for the editor. Equivalent to passing in a toolbar option
     * to the init.
     * Documentation: https://www.tiny.cloud/docs/integrations/vue/#toolbar
     */
    toolbar: {
      type: String,
      default: 'formatselect fontselect bold italic | alignleft aligncenter alignright alignjustify | bullist numlist code | removeformat | link image | help | forecolor | table tableinsertdialog tablecellprops tableprops'
    },
    errorMessages: {
      type: String,
      default: ''
    },
    apiKey: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      defaultFont: 'Open Sans',
      isFocused: false,
      tinyMCEPlugin: null
    };
  },
  computed: {
    isErrorState: function isErrorState() {
      return this.errorMessages;
    }
  },
  beforeCreated: function beforeCreated() {
    var _this = this;

    return Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.addScript(TINYMCE_SCRIPT);

            case 2:
              _this.tinyMCEPlugin = _context.sent;

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  beforeDestroy: function beforeDestroy() {
    if (this.tinyMCEPlugin) {
      document.head.removeChild(this.tinyMCEPlugin);
    }
  },
  methods: {
    addScript: function addScript(script) {
      var plugin = document.createElement('script');
      plugin.setAttribute('src', this.apiKey ? script.replace('no-api-key', this.apiKey) : script);
      plugin.async = true;
      document.head.appendChild(plugin);
      return new Promise(function (resolve, reject) {
        plugin.onload = function () {
          return resolve(plugin);
        };

        plugin.onerror = function (e) {
          return reject(e);
        };
      });
    }
  }
});
// CONCATENATED MODULE: ./src/components/input/rich-text-editor/PpRichTextEditor.vue?vue&type=script&lang=js&
 /* harmony default export */ var rich_text_editor_PpRichTextEditorvue_type_script_lang_js_ = (PpRichTextEditorvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/input/rich-text-editor/PpRichTextEditor.vue?vue&type=style&index=0&id=233fd1d2&lang=scss&scoped=true&
var PpRichTextEditorvue_type_style_index_0_id_233fd1d2_lang_scss_scoped_true_ = __webpack_require__("3194");

// EXTERNAL MODULE: ./src/components/input/rich-text-editor/PpRichTextEditor.vue?vue&type=style&index=1&lang=scss&
var PpRichTextEditorvue_type_style_index_1_lang_scss_ = __webpack_require__("0c25");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/input/rich-text-editor/PpRichTextEditor.vue







/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  rich_text_editor_PpRichTextEditorvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "233fd1d2",
  null
  
)

/* harmony default export */ var PpRichTextEditor = __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "35a1":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("f5df");
var Iterators = __webpack_require__("3f8c");
var wellKnownSymbol = __webpack_require__("b622");

var ITERATOR = wellKnownSymbol('iterator');

module.exports = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),

/***/ "35a9":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.v-dialog{border-radius:10px;margin:24px;overflow-y:auto;pointer-events:auto;transition:.3s cubic-bezier(.25,.8,.25,1);width:100%;z-index:inherit;box-shadow:0 11px 15px -7px transparent,0 24px 38px 3px transparent,0 9px 46px 8px rgba(0,0,0,.12)}.v-dialog:not(.v-dialog--fullscreen){max-height:90%}.v-dialog>*{width:100%}.v-dialog>.v-card>.v-card__title{font-size:1rem;font-weight:500;letter-spacing:normal;padding:24px 56px 24px 28px}.v-dialog>.v-card>.v-card__text{padding:24px 28px 28px}.v-dialog>.v-card>.v-card__subtitle{padding:0 24px 20px}.v-dialog>.v-card>.v-card__actions{padding:8px 28px 28px}.v-dialog__content{align-items:center;display:flex;height:100%;justify-content:center;left:0;pointer-events:none;position:fixed;top:0;transition:.2s cubic-bezier(.25,.8,.25,1),z-index 1ms;width:100%;z-index:6;outline:none}.v-dialog__container{display:none}.v-dialog__container--attached{display:inline}.v-dialog--animated{-webkit-animation-duration:.15s;animation-duration:.15s;-webkit-animation-name:animate-dialog;animation-name:animate-dialog;-webkit-animation-timing-function:cubic-bezier(.25,.8,.25,1);animation-timing-function:cubic-bezier(.25,.8,.25,1)}.v-dialog--fullscreen{border-radius:0;margin:0;height:100%;position:fixed;overflow-y:auto;top:0;left:0}.v-dialog--fullscreen>.v-card{min-height:100%;min-width:100%;margin:0!important;padding:0!important}.v-dialog--scrollable,.v-dialog--scrollable>form{display:flex}.v-dialog--scrollable>.v-card,.v-dialog--scrollable>form>.v-card{display:flex;flex:1 1 100%;flex-direction:column;max-height:100%;max-width:100%}.v-dialog--scrollable>.v-card>.v-card__actions,.v-dialog--scrollable>.v-card>.v-card__title,.v-dialog--scrollable>form>.v-card>.v-card__actions,.v-dialog--scrollable>form>.v-card>.v-card__title{flex:0 0 auto}.v-dialog--scrollable>.v-card>.v-card__text,.v-dialog--scrollable>form>.v-card>.v-card__text{-webkit-backface-visibility:hidden;backface-visibility:hidden;flex:1 1 auto;overflow-y:auto}@-webkit-keyframes animate-dialog{0%{transform:scale(1)}50%{transform:scale(1.03)}to{transform:scale(1)}}@keyframes animate-dialog{0%{transform:scale(1)}50%{transform:scale(1.03)}to{transform:scale(1)}}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "3658":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpUploadFile_vue_vue_type_style_index_0_id_6d3d1270_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1ef8");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpUploadFile_vue_vue_type_style_index_0_id_6d3d1270_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpUploadFile_vue_vue_type_style_index_0_id_6d3d1270_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "3660":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M7.5 16.5L5 18.5L6 19.5L7.5 21L9 21.5H12H14L16.5 21L18 20L18.5 18.5L18 17H16.5L13.5 16L11 16.5H7.5Z\" fill=\"#DFE4E5\"></path><path d=\"M6.5 16.5L3.5 17.5L2.5 15.5L2 14V11L2.5 8.5L4.5 5.5L7 3.5L11.5 2.5L15.5 3L18.5 5L21.5 10V13.5L21 17L20 17.5L19 18L18 17.5L15.5 16.5C15 16.3333 13.9 16 13.5 16C13.1 16 12.3333 15.6667 12 15.5L12.5 14.5L14 13.5L14.5 12.1875V9L13.5 7.5L12 7L10.5 7.5L9.5 9L9 10.5L9.5 13L10.5 14L12 14.5L11.5 16H10.5H9.5L8 16.5H6.5Z\" fill=\"white\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M1 12C1 18.0751 5.92487 23 12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12ZM17.9647 18.7398C16.3767 20.1462 14.2881 21 12 21C9.71194 21 7.6233 20.1462 6.03532 18.7398C6.32801 17.6874 8.43062 17 12 17C15.5694 17 17.672 17.6873 17.9647 18.7398ZM19.3995 17.1246C18.274 15.6381 15.6294 15 12 15C8.3706 15 5.72596 15.6381 4.60051 17.1246C3.59138 15.6703 3 13.9042 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 13.9042 20.4086 15.6703 19.3995 17.1246ZM8 10C8 7.75576 9.5791 6 12 6C14.4142 6 16 7.92158 16 10.2C16 13.4796 14.2181 15 12 15C9.76086 15 8 13.4274 8 10Z\" fill=\"#688083\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M10 10C10 12.2693 10.8182 13 12 13C13.1777 13 14 12.2984 14 10.2C14 8.95042 13.2157 8 12 8C10.7337 8 10 8.81582 10 10Z\" fill=\"#DFE4E5\"></path></svg>";

/***/ }),

/***/ "366b":
/***/ (function(module, exports, __webpack_require__) {

var compareDesc = __webpack_require__("c873")
var parse = __webpack_require__("c8d5")
var differenceInSeconds = __webpack_require__("e13a")
var differenceInMonths = __webpack_require__("17cd")
var enLocale = __webpack_require__("52cf")

var MINUTES_IN_DAY = 1440
var MINUTES_IN_ALMOST_TWO_DAYS = 2520
var MINUTES_IN_MONTH = 43200
var MINUTES_IN_TWO_MONTHS = 86400

/**
 * @category Common Helpers
 * @summary Return the distance between the given dates in words.
 *
 * @description
 * Return the distance between the given dates in words.
 *
 * | Distance between dates                                            | Result              |
 * |-------------------------------------------------------------------|---------------------|
 * | 0 ... 30 secs                                                     | less than a minute  |
 * | 30 secs ... 1 min 30 secs                                         | 1 minute            |
 * | 1 min 30 secs ... 44 mins 30 secs                                 | [2..44] minutes     |
 * | 44 mins ... 30 secs ... 89 mins 30 secs                           | about 1 hour        |
 * | 89 mins 30 secs ... 23 hrs 59 mins 30 secs                        | about [2..24] hours |
 * | 23 hrs 59 mins 30 secs ... 41 hrs 59 mins 30 secs                 | 1 day               |
 * | 41 hrs 59 mins 30 secs ... 29 days 23 hrs 59 mins 30 secs         | [2..30] days        |
 * | 29 days 23 hrs 59 mins 30 secs ... 44 days 23 hrs 59 mins 30 secs | about 1 month       |
 * | 44 days 23 hrs 59 mins 30 secs ... 59 days 23 hrs 59 mins 30 secs | about 2 months      |
 * | 59 days 23 hrs 59 mins 30 secs ... 1 yr                           | [2..12] months      |
 * | 1 yr ... 1 yr 3 months                                            | about 1 year        |
 * | 1 yr 3 months ... 1 yr 9 month s                                  | over 1 year         |
 * | 1 yr 9 months ... 2 yrs                                           | almost 2 years      |
 * | N yrs ... N yrs 3 months                                          | about N years       |
 * | N yrs 3 months ... N yrs 9 months                                 | over N years        |
 * | N yrs 9 months ... N+1 yrs                                        | almost N+1 years    |
 *
 * With `options.includeSeconds == true`:
 * | Distance between dates | Result               |
 * |------------------------|----------------------|
 * | 0 secs ... 5 secs      | less than 5 seconds  |
 * | 5 secs ... 10 secs     | less than 10 seconds |
 * | 10 secs ... 20 secs    | less than 20 seconds |
 * | 20 secs ... 40 secs    | half a minute        |
 * | 40 secs ... 60 secs    | less than a minute   |
 * | 60 secs ... 90 secs    | 1 minute             |
 *
 * @param {Date|String|Number} dateToCompare - the date to compare with
 * @param {Date|String|Number} date - the other date
 * @param {Object} [options] - the object with options
 * @param {Boolean} [options.includeSeconds=false] - distances less than a minute are more detailed
 * @param {Boolean} [options.addSuffix=false] - result indicates if the second date is earlier or later than the first
 * @param {Object} [options.locale=enLocale] - the locale object
 * @returns {String} the distance in words
 *
 * @example
 * // What is the distance between 2 July 2014 and 1 January 2015?
 * var result = distanceInWords(
 *   new Date(2014, 6, 2),
 *   new Date(2015, 0, 1)
 * )
 * //=> '6 months'
 *
 * @example
 * // What is the distance between 1 January 2015 00:00:15
 * // and 1 January 2015 00:00:00, including seconds?
 * var result = distanceInWords(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   new Date(2015, 0, 1, 0, 0, 0),
 *   {includeSeconds: true}
 * )
 * //=> 'less than 20 seconds'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, with a suffix?
 * var result = distanceInWords(
 *   new Date(2016, 0, 1),
 *   new Date(2015, 0, 1),
 *   {addSuffix: true}
 * )
 * //=> 'about 1 year ago'
 *
 * @example
 * // What is the distance between 1 August 2016 and 1 January 2015 in Esperanto?
 * var eoLocale = require('date-fns/locale/eo')
 * var result = distanceInWords(
 *   new Date(2016, 7, 1),
 *   new Date(2015, 0, 1),
 *   {locale: eoLocale}
 * )
 * //=> 'pli ol 1 jaro'
 */
function distanceInWords (dirtyDateToCompare, dirtyDate, dirtyOptions) {
  var options = dirtyOptions || {}

  var comparison = compareDesc(dirtyDateToCompare, dirtyDate)

  var locale = options.locale
  var localize = enLocale.distanceInWords.localize
  if (locale && locale.distanceInWords && locale.distanceInWords.localize) {
    localize = locale.distanceInWords.localize
  }

  var localizeOptions = {
    addSuffix: Boolean(options.addSuffix),
    comparison: comparison
  }

  var dateLeft, dateRight
  if (comparison > 0) {
    dateLeft = parse(dirtyDateToCompare)
    dateRight = parse(dirtyDate)
  } else {
    dateLeft = parse(dirtyDate)
    dateRight = parse(dirtyDateToCompare)
  }

  var seconds = differenceInSeconds(dateRight, dateLeft)
  var offset = dateRight.getTimezoneOffset() - dateLeft.getTimezoneOffset()
  var minutes = Math.round(seconds / 60) - offset
  var months

  // 0 up to 2 mins
  if (minutes < 2) {
    if (options.includeSeconds) {
      if (seconds < 5) {
        return localize('lessThanXSeconds', 5, localizeOptions)
      } else if (seconds < 10) {
        return localize('lessThanXSeconds', 10, localizeOptions)
      } else if (seconds < 20) {
        return localize('lessThanXSeconds', 20, localizeOptions)
      } else if (seconds < 40) {
        return localize('halfAMinute', null, localizeOptions)
      } else if (seconds < 60) {
        return localize('lessThanXMinutes', 1, localizeOptions)
      } else {
        return localize('xMinutes', 1, localizeOptions)
      }
    } else {
      if (minutes === 0) {
        return localize('lessThanXMinutes', 1, localizeOptions)
      } else {
        return localize('xMinutes', minutes, localizeOptions)
      }
    }

  // 2 mins up to 0.75 hrs
  } else if (minutes < 45) {
    return localize('xMinutes', minutes, localizeOptions)

  // 0.75 hrs up to 1.5 hrs
  } else if (minutes < 90) {
    return localize('aboutXHours', 1, localizeOptions)

  // 1.5 hrs up to 24 hrs
  } else if (minutes < MINUTES_IN_DAY) {
    var hours = Math.round(minutes / 60)
    return localize('aboutXHours', hours, localizeOptions)

  // 1 day up to 1.75 days
  } else if (minutes < MINUTES_IN_ALMOST_TWO_DAYS) {
    return localize('xDays', 1, localizeOptions)

  // 1.75 days up to 30 days
  } else if (minutes < MINUTES_IN_MONTH) {
    var days = Math.round(minutes / MINUTES_IN_DAY)
    return localize('xDays', days, localizeOptions)

  // 1 month up to 2 months
  } else if (minutes < MINUTES_IN_TWO_MONTHS) {
    months = Math.round(minutes / MINUTES_IN_MONTH)
    return localize('aboutXMonths', months, localizeOptions)
  }

  months = differenceInMonths(dateRight, dateLeft)

  // 2 months up to 12 months
  if (months < 12) {
    var nearestMonth = Math.round(minutes / MINUTES_IN_MONTH)
    return localize('xMonths', nearestMonth, localizeOptions)

  // 1 year up to max Date
  } else {
    var monthsSinceStartOfYear = months % 12
    var years = Math.floor(months / 12)

    // N years up to 1 years 3 months
    if (monthsSinceStartOfYear < 3) {
      return localize('aboutXYears', years, localizeOptions)

    // N years 3 months up to N years 9 months
    } else if (monthsSinceStartOfYear < 9) {
      return localize('overXYears', years, localizeOptions)

    // N years 9 months up to N year 12 months
    } else {
      return localize('almostXYears', years + 1, localizeOptions)
    }
  }
}

module.exports = distanceInWords


/***/ }),

/***/ "368e":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("35a9");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("29e286db", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "3691":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("c8d5")

/**
 * @category Quarter Helpers
 * @summary Return the end of a year quarter for the given date.
 *
 * @description
 * Return the end of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of a quarter
 *
 * @example
 * // The end of a quarter for 2 September 2014 11:55:00:
 * var result = endOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 23:59:59.999
 */
function endOfQuarter (dirtyDate) {
  var date = parse(dirtyDate)
  var currentMonth = date.getMonth()
  var month = currentMonth - currentMonth % 3 + 3
  date.setMonth(month, 0)
  date.setHours(23, 59, 59, 999)
  return date
}

module.exports = endOfQuarter


/***/ }),

/***/ "369a":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M10.5 1C14.5107 1 17.9408 3.48534 19.3345 6.99991L13 7C11.8954 7 11 7.89543 11 9L11.0003 19.9871C10.8346 19.9956 10.6678 20 10.5 20C5.25329 20 1 15.7467 1 10.5C1 5.25329 5.25329 1 10.5 1Z\" fill=\"#D5EAFD\"></path><path d=\"M10.5 1C14.5107 1 17.9408 3.48534 19.3345 6.99991L13 7C11.8954 7 11 7.89543 11 9V8.999L8.55463 8.99951C8.51866 9.48807 8.5 9.98988 8.5 10.5C8.5 11.0105 8.51869 11.5126 8.55471 12.0015L11 12.001V14.001L8.8114 14.0018C8.98345 14.9178 9.22199 15.7459 9.51484 16.4414C9.78664 17.0869 10.0852 17.5659 10.3604 17.8424L10.5 17.977L10.6396 17.8424C10.757 17.7245 10.8787 17.5696 11.0007 17.3807L11.0003 19.9871C10.8346 19.9956 10.6678 20 10.5 20C5.25329 20 1 15.7467 1 10.5C1 5.25329 5.25329 1 10.5 1ZM6.78042 14.0013L3.8656 14.001C4.70635 15.591 6.10188 16.8422 7.79441 17.4971C7.35409 16.5363 7.00468 15.3439 6.78042 14.0013ZM6.54958 8.99993L3.14994 9.00041C3.05162 9.48495 3 9.98644 3 10.5C3 11.0139 3.05169 11.5157 3.15015 12.0006L6.54965 12.0011C6.51697 11.5121 6.5 11.0108 6.5 10.5C6.5 9.98958 6.51695 9.48855 6.54958 8.99993ZM7.79446 3.50271L7.73992 3.52418C6.07159 4.18483 4.69673 5.42666 3.86507 6.99995L6.78026 6.99974C7.0045 5.65667 7.35398 4.46391 7.79446 3.50271ZM10.5 3.023L10.3604 3.15756C10.0852 3.43406 9.78664 3.91308 9.51484 4.5586C9.22189 5.25437 8.98328 6.08277 8.81121 6.9992H12.1888C12.0167 6.08277 11.7781 5.25437 11.4852 4.5586C11.2134 3.91308 10.9148 3.43406 10.6396 3.15756L10.5 3.023ZM13.2056 3.50285L13.2402 3.57936C13.6644 4.52702 14.0014 5.69214 14.2197 6.99974L17.1349 6.99995C16.2942 5.40957 14.8985 4.15789 13.2056 3.50285Z\" fill=\"#079CB2\"></path><path d=\"M21 7C22.1046 7 23 7.89543 23 9V21C23 22.1046 22.1046 23 21 23H13C11.8954 23 11 22.1046 11 21V9C11 7.89543 11.8954 7 13 7H21ZM21 9H13V21H21V9Z\" fill=\"#079CB2\"></path><rect x=\"13\" y=\"9\" width=\"8\" height=\"12\" fill=\"white\"></rect><path d=\"M17.998 13C17.998 13.5523 17.5503 14 16.998 14C16.4458 14 15.998 13.5523 15.998 13C15.998 12.4477 16.4458 12 16.998 12C17.5503 12 17.998 12.4477 17.998 13Z\" fill=\"#079CB2\"></path><path d=\"M18.998 18V17C18.998 15.8954 18.1026 15 16.998 15C15.8935 15 14.998 15.8954 14.998 17V18H18.998Z\" fill=\"#079CB2\"></path></svg>";

/***/ }),

/***/ "36a7":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("c7e5");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("731b9222", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "3709":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpPanel_vue_vue_type_style_index_0_id_bcc9c6b0_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("8d52");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpPanel_vue_vue_type_style_index_0_id_bcc9c6b0_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpPanel_vue_vue_type_style_index_0_id_bcc9c6b0_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "3764":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><circle cx=\"12\" cy=\"12\" r=\"9\" fill=\"white\"></circle><circle cx=\"12\" cy=\"12\" r=\"7\" fill=\"#D5EAFD\"></circle><path d=\"M12 23C5.925 23 1 18.075 1 12C1 5.925 5.925 1 12 1C18.075 1 23 5.925 23 12C23 18.075 18.075 23 12 23ZM12 21C16.9705 21 21 16.9705 21 12C21 7.0295 16.9705 3 12 3C7.0295 3 3 7.0295 3 12C3 16.9705 7.0295 21 12 21ZM13 17.376V18.5C13 18.7652 12.8946 19.0196 12.7071 19.2071C12.5196 19.3946 12.2652 19.5 12 19.5C11.7348 19.5 11.4804 19.3946 11.2929 19.2071C11.1054 19.0196 11 18.7652 11 18.5V17.3855C10.5159 17.2704 10.0542 17.0762 9.6335 16.8105C9.2205 16.5525 8.9245 16.287 8.747 16.084C8.57411 15.8841 8.48741 15.6238 8.50586 15.3601C8.5243 15.0965 8.64638 14.8508 8.84541 14.6769C9.04444 14.503 9.30424 14.4149 9.568 14.432C9.83177 14.4491 10.078 14.5699 10.253 14.768C10.31 14.8335 10.4635 14.971 10.694 15.115C11.081 15.357 11.5165 15.5 11.9955 15.5C12.9355 15.5 13.5495 14.943 13.497 14.461C13.4475 14.009 13.0305 13.661 11.699 12.9705L11.5395 12.8875C11.5336 12.8846 11.5278 12.8816 11.522 12.8785L11.3805 12.805C9.439 11.7985 8.6675 11.155 8.515 9.7565C8.3545 8.2875 9.4535 7.0155 11 6.624V5.5C11 5.23478 11.1054 4.98043 11.2929 4.79289C11.4804 4.60536 11.7348 4.5 12 4.5C12.2652 4.5 12.5196 4.60536 12.7071 4.79289C12.8946 4.98043 13 5.23478 13 5.5V6.6145C13.4841 6.72956 13.9458 6.92385 14.3665 7.1895C14.7795 7.4475 15.0755 7.713 15.253 7.916C15.4259 8.11593 15.5126 8.37618 15.4941 8.63986C15.4757 8.90353 15.3536 9.14917 15.1546 9.3231C14.9556 9.49702 14.6958 9.58507 14.432 9.568C14.1682 9.55093 13.922 9.43013 13.747 9.232C13.69 9.1665 13.5365 9.029 13.306 8.885C12.919 8.643 12.4835 8.5 12.0045 8.5C11.0645 8.5 10.4505 9.057 10.503 9.539C10.5525 9.991 10.9695 10.339 12.301 11.0295C12.4072 11.0845 12.5133 11.1395 12.6195 11.1945C14.561 12.2015 15.3325 12.8455 15.485 14.2435C15.6455 15.7125 14.5465 16.9845 13 17.376Z\" fill=\"#079CB2\"></path></svg>";

/***/ }),

/***/ "37c6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _VProgressLinear__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("8e36");


/* harmony default export */ __webpack_exports__["a"] = (_VProgressLinear__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]);

/***/ }),

/***/ "37da":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.i, "@import url(https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css);"]);
exports.push([module.i, "@import url(https://cdn-prd.patientpop.com/pp-icon-font/v1.6.0/pp-icon-font.css);"]);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.pp-input-toggle-group__list[data-v-1de99991]{--cards-color:#d6d6d6;padding:2px;width:100%}.pp-input-toggle-group__list .pp-button[type=button][data-v-1de99991]{border:none;color:#545454;height:32px}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "37e8":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var definePropertyModule = __webpack_require__("9bf2");
var anObject = __webpack_require__("825a");
var objectKeys = __webpack_require__("df75");

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
module.exports = DESCRIPTORS ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule.f(O, key = keys[index++], Properties[key]);
  return O;
};


/***/ }),

/***/ "3814":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("c8d5")
var getDaysInMonth = __webpack_require__("5416")

/**
 * @category Month Helpers
 * @summary Set the month to the given date.
 *
 * @description
 * Set the month to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} month - the month of the new date
 * @returns {Date} the new date with the month setted
 *
 * @example
 * // Set February to 1 September 2014:
 * var result = setMonth(new Date(2014, 8, 1), 1)
 * //=> Sat Feb 01 2014 00:00:00
 */
function setMonth (dirtyDate, dirtyMonth) {
  var date = parse(dirtyDate)
  var month = Number(dirtyMonth)
  var year = date.getFullYear()
  var day = date.getDate()

  var dateWithDesiredMonth = new Date(0)
  dateWithDesiredMonth.setFullYear(year, month, 15)
  dateWithDesiredMonth.setHours(0, 0, 0, 0)
  var daysInMonth = getDaysInMonth(dateWithDesiredMonth)
  // Set the last day of the new month
  // if the original date was the last day of the longer month
  date.setMonth(month, Math.min(day, daysInMonth))
  return date
}

module.exports = setMonth


/***/ }),

/***/ "381f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c662cfac-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/card/PpCard.vue?vue&type=template&id=34bf26aa&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g({staticClass:"pp-card pb-4 mx-4 my-4",style:({ width: _vm.width }),attrs:{"draggable":_vm.isDraggable}},_vm.$listeners),[(_vm.isDraggable)?_c('div',{staticClass:"pp-card__drag",attrs:{"title":"Click and hold to drag this card"}},[_c('pp-tooltip',{attrs:{"text":"Click to drag"}},[_c('div',{staticClass:"pp-card__drag-icon"},[_c('div',{staticClass:"pp-card__drag-nibs"}),_c('div',{staticClass:"pp-card__drag-nibs"}),_c('div',{staticClass:"pp-card__drag-nibs"})])])],1):_vm._e(),_c('div',{staticClass:"pp-card__image-container d-flex align-center justify-center",class:{ 'pp-card__image-container--default': _vm.useDefaultHeaderImage },style:({ background: _vm.calculateBackground })},[(!_vm.background)?_c('img',{staticClass:"pp-card__image",attrs:{"alt":_vm.title,"src":_vm.headerImageSrc},on:{"error":function($event){_vm.headerImageError = true}}}):_vm._e(),(_vm.showAvatar)?_c('v-avatar',{staticClass:"pp-card__avatar",class:{ 'rounded-lg' : _vm.tile },attrs:{"size":64,"color":_vm.avatarColor}},[(_vm.icon)?_c('i',{staticClass:"pp-card__avatar__icon d-flex",class:("pp-icon-" + _vm.icon)}):(_vm.initials)?_c('span',{staticClass:"white--text text-h2"},[_vm._v(" "+_vm._s(_vm.initials)+" ")]):_vm._e()]):_vm._e()],1),_c('div',{staticClass:"pp-card__body px-4 pt-3"},[_c('p',{staticClass:"pp-card__title text-h6 font-weight-bold"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{staticClass:"pp-card__subtitle-container d-flex align-center mt-1"},[(_vm.subtitle)?_c('p',{staticClass:"pp-card__subtitle"},[_vm._v(" "+_vm._s(_vm.subtitle)+" ")]):_vm._e(),(_vm.chipText)?_c('pp-status-chip',{staticClass:"pp-card__status-chip",attrs:{"text":_vm.chipText,"sub-text":_vm.chipSubText,"status":_vm.chipStatus}}):_vm._e()],1)]),(_vm.showCardFooter)?_c('div',{staticClass:"pp-card__footer d-flex align-center justify-space-between pt-7 px-7"},[_c('div',{staticClass:"d-flex align-center"},[_c('span',{staticClass:"pp-card__avatar-image"},[_c('img',{attrs:{"src":_vm.avatarImageSrc,"alt":_vm.name},on:{"error":function($event){_vm.avatarImageError = true}}})]),_c('span',{staticClass:"pp-card__avatar-name ml-3"},[_vm._v(_vm._s(_vm.name))])]),(_vm.featuredBlog)?_c('pp-tooltip',{attrs:{"text":"Featured Post","position":"top"}},[_c('i',{staticClass:"pp-card__featured pp-icon-star--circle",attrs:{"role":"img","aria-label":"Featured Post"}})]):_vm._e()],1):_vm._e()])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/card/PpCard.vue?vue&type=template&id=34bf26aa&scoped=true&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.index-of.js
var es_array_index_of = __webpack_require__("c975");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__("a9e3");

// EXTERNAL MODULE: ./src/components/tooltip/PpTooltip.vue + 6 modules
var PpTooltip = __webpack_require__("284e");

// EXTERNAL MODULE: ./src/components/statusChip/PpStatusChip.vue + 4 modules
var PpStatusChip = __webpack_require__("e921");

// EXTERNAL MODULE: ./src/styles/colors.scss
var colors = __webpack_require__("1c98");
var colors_default = /*#__PURE__*/__webpack_require__.n(colors);

// CONCATENATED MODULE: ./src/components/card/constants.js
var DEFAULT_HEADER_IMAGE = 'https://ui-cdn.patientpop.com/assets/img/no-image-default.svg';
var DEFAULT_AVATAR_IMAGE = 'https://sa1s3optim.patientpop.com/assets/production/stock-images/2289066.png';
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/card/PpCard.vue?vue&type=script&lang=js&


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var PpCardvue_type_script_lang_js_ = ({
  name: 'PpCard',
  components: {
    PpTooltip: PpTooltip["default"],
    PpStatusChip: PpStatusChip["default"]
  },
  props: {
    /**
     * Sets image for avatar
     */
    avatarImage: {
      type: String,
      default: DEFAULT_AVATAR_IMAGE
    },

    /**
     * Sets chip status
     */
    chipStatus: {
      type: String,
      default: 'success'
    },

    /**
     * Sets chip sub text
     */
    chipSubText: {
      type: String,
      default: ''
    },

    /**
     * Sets chip text
     */
    chipText: {
      type: String,
      default: ''
    },

    /**
     * Sets if the blog is a featured blog. Requires showCardFooter === true
     */
    featuredBlog: {
      type: Boolean,
      default: false
    },

    /**
     * Sets the image header
     */
    headerImage: {
      type: String,
      default: ''
    },

    /**
     * 1-based index to show the current order value of the card.
     * Only visible when isDraggable == true
     */
    index: {
      type: Number,
      default: null
    },

    /**
     * Adds a white top to the card with a drag icon and optional index number
     */
    isDraggable: {
      type: Boolean,
      default: false
    },

    /**
     * Sets name of avatar
     */
    name: {
      type: String,
      default: ''
    },

    /**
     * Sets card footer
     */
    showCardFooter: {
      type: Boolean,
      default: false
    },

    /**
     * Sets title of card
     */
    title: {
      type: String,
      required: true
    },

    /**
     * Sets subtitle of card
     */
    subtitle: {
      type: String,
      default: ''
    },

    /**
     * Sets the width of the card
     */
    width: {
      type: String,
      default: null
    },

    /**
     * Sets background color
     */
    background: {
      type: String,
      default: '',
      validator: function validator(value) {
        return ['growth2', 'diastole', 'firstAid', 'energize', 'vigor', 'vitality2', 'systole', 'diastole', 'holistic', 'restore', 'avatarTeal2', 'purple30', 'red40', 'yellow40', 'green50', 'orange40', 'purple50', 'red30', 'blue50', 'green30', ''].indexOf(value) !== -1;
      }
    },

    /**
    * Set icon for card
    */
    icon: {
      type: String,
      default: ''
    },

    /**
     * Set initials to be inside avatar
     */
    initials: {
      type: String,
      default: ''
    },

    /**
     * Set avatar shape to be a tile
     */
    tile: {
      type: Boolean,
      default: false
    },

    /**
     * Set avatar background color
     */
    avatarColor: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      headerImageError: false,
      avatarImageError: false
    };
  },
  computed: {
    useDefaultHeaderImage: function useDefaultHeaderImage() {
      return this.headerImageError || !this.headerImage;
    },
    useDefaultAvatarImage: function useDefaultAvatarImage() {
      return this.avatarImageError || !this.avatarImage;
    },
    avatarImageSrc: function avatarImageSrc() {
      return this.useDefaultAvatarImage ? DEFAULT_AVATAR_IMAGE : this.avatarImage;
    },
    headerImageSrc: function headerImageSrc() {
      return this.useDefaultHeaderImage ? DEFAULT_HEADER_IMAGE : this.headerImage;
    },
    calculateBackground: function calculateBackground() {
      return colors_default.a[this.background];
    },
    showAvatar: function showAvatar() {
      return this.icon || this.tile && this.icon || this.tile && this.initials;
    }
  }
});
// CONCATENATED MODULE: ./src/components/card/PpCard.vue?vue&type=script&lang=js&
 /* harmony default export */ var card_PpCardvue_type_script_lang_js_ = (PpCardvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/card/PpCard.vue?vue&type=style&index=0&id=34bf26aa&lang=scss&scoped=true&
var PpCardvue_type_style_index_0_id_34bf26aa_lang_scss_scoped_true_ = __webpack_require__("2e90");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// EXTERNAL MODULE: ./node_modules/vuetify-loader/lib/runtime/installComponents.js
var installComponents = __webpack_require__("6544");
var installComponents_default = /*#__PURE__*/__webpack_require__.n(installComponents);

// EXTERNAL MODULE: ./node_modules/vuetify/lib/components/VAvatar/VAvatar.js
var VAvatar = __webpack_require__("8212");

// CONCATENATED MODULE: ./src/components/card/PpCard.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  card_PpCardvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "34bf26aa",
  null
  
)

/* harmony default export */ var PpCard = __webpack_exports__["default"] = (component.exports);

/* vuetify-loader */


installComponents_default()(component, {VAvatar: VAvatar["a" /* default */]})


/***/ }),

/***/ "3835":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ _slicedToArray; });

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("a4d3");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__("e01a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.iterator.js
var es_symbol_iterator = __webpack_require__("d28b");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__("e260");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("d3b7");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__("3ca3");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__("ddb0");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js







function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__("06c5");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableRest.js
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js




function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || Object(unsupportedIterableToArray["a" /* default */])(arr, i) || _nonIterableRest();
}

/***/ }),

/***/ "3885":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.theme--light.v-icon{color:var(--active-icon,#2b2b2b)}.theme--light.v-icon:focus:after{opacity:.12}.theme--light.v-icon.v-icon.v-icon--disabled{color:rgba(0,0,0,.38)!important}.theme--dark.v-icon{color:#fff}.theme--dark.v-icon:focus:after{opacity:.24}.theme--dark.v-icon.v-icon.v-icon--disabled{color:hsla(0,0%,100%,.5)!important}.v-icon.v-icon{align-items:center;display:inline-flex;font-feature-settings:\"liga\";font-size:24px;justify-content:center;letter-spacing:normal;line-height:1;position:relative;text-indent:0;transition:.3s cubic-bezier(.25,.8,.5,1),visibility 0s;vertical-align:middle;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.v-icon.v-icon:after{background-color:currentColor;border-radius:50%;content:\"\";display:inline-block;height:100%;left:0;opacity:0;pointer-events:none;position:absolute;top:0;transform:scale(1.3);width:100%;transition:opacity .2s cubic-bezier(.4,0,.6,1)}.v-icon.v-icon--dense{font-size:20px}.v-icon--right{margin-left:8px}.v-icon--left{margin-right:8px}.v-icon.v-icon.v-icon--link{cursor:pointer;outline:none}.v-icon--disabled{pointer-events:none}.v-icon--dense__component,.v-icon--dense__svg{height:20px}.v-icon__component,.v-icon__svg{height:24px;width:24px}.v-icon__svg{fill:currentColor}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "38cb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("fb6a");
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("a9e3");
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("53ca");
/* harmony import */ var _colorable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("a9ad");
/* harmony import */ var _themeable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("7560");
/* harmony import */ var _registrable__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("3206");
/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("80d2");
/* harmony import */ var _util_console__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("d9bd");
/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("58df");



// Mixins


 // Utilities




var baseMixins = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"])(_colorable__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"], Object(_registrable__WEBPACK_IMPORTED_MODULE_5__[/* inject */ "a"])('form'), _themeable__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"]);
/* @vue/component */

/* harmony default export */ __webpack_exports__["a"] = (baseMixins.extend({
  name: 'validatable',
  props: {
    disabled: Boolean,
    error: Boolean,
    errorCount: {
      type: [Number, String],
      default: 1
    },
    errorMessages: {
      type: [String, Array],
      default: function _default() {
        return [];
      }
    },
    messages: {
      type: [String, Array],
      default: function _default() {
        return [];
      }
    },
    readonly: Boolean,
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    success: Boolean,
    successMessages: {
      type: [String, Array],
      default: function _default() {
        return [];
      }
    },
    validateOnBlur: Boolean,
    value: {
      required: false
    }
  },
  data: function data() {
    return {
      errorBucket: [],
      hasColor: false,
      hasFocused: false,
      hasInput: false,
      isFocused: false,
      isResetting: false,
      lazyValue: this.value,
      valid: false
    };
  },
  computed: {
    computedColor: function computedColor() {
      if (this.isDisabled) return undefined;
      if (this.color) return this.color; // It's assumed that if the input is on a
      // dark background, the user will want to
      // have a white color. If the entire app
      // is setup to be dark, then they will
      // like want to use their primary color

      if (this.isDark && !this.appIsDark) return 'white';else return 'primary';
    },
    hasError: function hasError() {
      return this.internalErrorMessages.length > 0 || this.errorBucket.length > 0 || this.error;
    },
    // TODO: Add logic that allows the user to enable based
    // upon a good validation
    hasSuccess: function hasSuccess() {
      return this.internalSuccessMessages.length > 0 || this.success;
    },
    externalError: function externalError() {
      return this.internalErrorMessages.length > 0 || this.error;
    },
    hasMessages: function hasMessages() {
      return this.validationTarget.length > 0;
    },
    hasState: function hasState() {
      if (this.isDisabled) return false;
      return this.hasSuccess || this.shouldValidate && this.hasError;
    },
    internalErrorMessages: function internalErrorMessages() {
      return this.genInternalMessages(this.errorMessages);
    },
    internalMessages: function internalMessages() {
      return this.genInternalMessages(this.messages);
    },
    internalSuccessMessages: function internalSuccessMessages() {
      return this.genInternalMessages(this.successMessages);
    },
    internalValue: {
      get: function get() {
        return this.lazyValue;
      },
      set: function set(val) {
        this.lazyValue = val;
        this.$emit('input', val);
      }
    },
    isDisabled: function isDisabled() {
      return this.disabled || !!this.form && this.form.disabled;
    },
    isInteractive: function isInteractive() {
      return !this.isDisabled && !this.isReadonly;
    },
    isReadonly: function isReadonly() {
      return this.readonly || !!this.form && this.form.readonly;
    },
    shouldValidate: function shouldValidate() {
      if (this.externalError) return true;
      if (this.isResetting) return false;
      return this.validateOnBlur ? this.hasFocused && !this.isFocused : this.hasInput || this.hasFocused;
    },
    validations: function validations() {
      return this.validationTarget.slice(0, Number(this.errorCount));
    },
    validationState: function validationState() {
      if (this.isDisabled) return undefined;
      if (this.hasError && this.shouldValidate) return 'error';
      if (this.hasSuccess) return 'success';
      if (this.hasColor) return this.computedColor;
      return undefined;
    },
    validationTarget: function validationTarget() {
      if (this.internalErrorMessages.length > 0) {
        return this.internalErrorMessages;
      } else if (this.successMessages && this.successMessages.length > 0) {
        return this.internalSuccessMessages;
      } else if (this.messages && this.messages.length > 0) {
        return this.internalMessages;
      } else if (this.shouldValidate) {
        return this.errorBucket;
      } else return [];
    }
  },
  watch: {
    rules: {
      handler: function handler(newVal, oldVal) {
        if (Object(_util_helpers__WEBPACK_IMPORTED_MODULE_6__[/* deepEqual */ "j"])(newVal, oldVal)) return;
        this.validate();
      },
      deep: true
    },
    internalValue: function internalValue() {
      // If it's the first time we're setting input,
      // mark it with hasInput
      this.hasInput = true;
      this.validateOnBlur || this.$nextTick(this.validate);
    },
    isFocused: function isFocused(val) {
      // Should not check validation
      // if disabled
      if (!val && !this.isDisabled) {
        this.hasFocused = true;
        this.validateOnBlur && this.$nextTick(this.validate);
      }
    },
    isResetting: function isResetting() {
      var _this = this;

      setTimeout(function () {
        _this.hasInput = false;
        _this.hasFocused = false;
        _this.isResetting = false;

        _this.validate();
      }, 0);
    },
    hasError: function hasError(val) {
      if (this.shouldValidate) {
        this.$emit('update:error', val);
      }
    },
    value: function value(val) {
      this.lazyValue = val;
    }
  },
  beforeMount: function beforeMount() {
    this.validate();
  },
  created: function created() {
    this.form && this.form.register(this);
  },
  beforeDestroy: function beforeDestroy() {
    this.form && this.form.unregister(this);
  },
  methods: {
    genInternalMessages: function genInternalMessages(messages) {
      if (!messages) return [];else if (Array.isArray(messages)) return messages;else return [messages];
    },

    /** @public */
    reset: function reset() {
      this.isResetting = true;
      this.internalValue = Array.isArray(this.internalValue) ? [] : null;
    },

    /** @public */
    resetValidation: function resetValidation() {
      this.isResetting = true;
    },

    /** @public */
    validate: function validate() {
      var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var value = arguments.length > 1 ? arguments[1] : undefined;
      var errorBucket = [];
      value = value || this.internalValue;
      if (force) this.hasInput = this.hasFocused = true;

      for (var index = 0; index < this.rules.length; index++) {
        var rule = this.rules[index];
        var valid = typeof rule === 'function' ? rule(value) : rule;

        if (valid === false || typeof valid === 'string') {
          errorBucket.push(valid || '');
        } else if (typeof valid !== 'boolean') {
          Object(_util_console__WEBPACK_IMPORTED_MODULE_7__[/* consoleError */ "b"])("Rules should return a string or boolean, received '".concat(Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(valid), "' instead"), this);
        }
      }

      this.errorBucket = errorBucket;
      this.valid = errorBucket.length === 0;
      return this.valid;
    }
  }
}));

/***/ }),

/***/ "38cf":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var repeat = __webpack_require__("1148");

// `String.prototype.repeat` method
// https://tc39.es/ecma262/#sec-string.prototype.repeat
$({ target: 'String', proto: true }, {
  repeat: repeat
});


/***/ }),

/***/ "38e9":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("62df");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("0e1fedfc", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "394d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c662cfac-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/calendar-nav/PpCalendarNav.vue?vue&type=template&id=595f5f79&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"text-center justify-center align-center pp-calendar-nav flex-nowrap",attrs:{"no-gutters":""}},[_c('v-col',{staticClass:"align-self-baseline justify-start d-flex align-center",attrs:{"cols":"2","sm":"1"}},[(!_vm.hideBackButton)?_c('pp-button',{staticClass:"col-button back-btn",attrs:{"disabled":_vm.disableBackButton,"type":"tertiary","icon":"caret--left","aria-label":"Previous"},on:{"click":_vm.backClick}}):_vm._e()],1),_vm._l((_vm.days),function(day,index){return _c('v-col',{key:day.date.short},[_c('v-row',{staticClass:"grey--text text--darken-1 ma-0"},[_c('v-col',{staticClass:"py-0 text-uppercase pp-calendar-nav__weekday font-weight-bold mb-sm-1",attrs:{"aria-label":day.weekday.long}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v(" "+_vm._s(_vm.isMobile ? day.weekday.long : day.weekday.short)+" ")])])],1),_c('v-row',{staticClass:"font-weight-bold ma-0"},[_c('v-col',{staticClass:"py-0 px-1 pp-calendar-nav__date grey--text text--darken-4"},[(_vm.isMobile)?[_vm._v(" "+_vm._s(day.date.long)+" ")]:[_vm._v(" "+_vm._s(day.date.short)+" ")]],2)],1),(Object.keys(_vm.$scopedSlots).includes(("calendar-nav-day-" + index)))?_c('v-row',[_c('v-col',[_vm._t(("calendar-nav-day-" + index),null,{"day":day})],2)],1):_vm._e()],1)}),_c('v-col',{staticClass:"align-self-baseline justify-end d-flex align-center",attrs:{"cols":"2","sm":"1"}},[(!_vm.hideForwardButton)?_c('pp-button',{staticClass:"col-button forward-btn",attrs:{"disabled":_vm.disableForwardButton,"type":"tertiary","icon":"caret--right","small":"","aria-label":"Next"},on:{"click":_vm.forwardClick}}):_vm._e()],1)],2)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/calendar-nav/PpCalendarNav.vue?vue&type=template&id=595f5f79&scoped=true&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("d81d");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__("a9e3");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__("2909");

// EXTERNAL MODULE: ./src/components/button/PpButton.vue + 5 modules
var PpButton = __webpack_require__("251c");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/calendar-nav/PpCalendarNav.vue?vue&type=script&lang=js&



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * PatientPop Calendar Nav
 */

/* harmony default export */ var PpCalendarNavvue_type_script_lang_js_ = ({
  name: 'PpCalendarNav',
  components: {
    'pp-button': PpButton["default"]
  },
  props: {
    /**
     * The first date in the calendar nav. Must be a Date object
     */
    startDate: {
      type: Date,
      required: true
    },

    /**
     * Number of visible days
     */
    daysToShow: {
      type: Number,
      default: 7
    },

    /**
     * Number of days to navigate when clicking the nav buttons
     */
    daysToNavigate: {
      type: Number,
      default: 7
    },

    /**
     * Boolean that determines whether or not to hide the back button
     */
    hideBackButton: {
      type: Boolean,
      default: false
    },

    /**
     * Boolean that determines whether or not to hide the forward button
     */
    hideForwardButton: {
      type: Boolean,
      default: false
    },

    /**
     * Boolean that determines whether or not to disable the back button
     */
    disableBackButton: {
      type: Boolean,
      default: false
    },

    /**
     * Boolean that determines whether or not to disable the forward button
     */
    disableForwardButton: {
      type: Boolean,
      default: false
    },

    /**
     * Boolean that determines whether or not to show full date texts
     */
    fullDateTexts: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    var _this$$ppUi;

    var curDate = new Date(Date.now());
    var tomorrowDate = new Date(new Date(curDate).setDate(curDate.getDate() + 1));
    return {
      firstDate: this.startDate,
      todayDate: curDate,
      tomorrowDate: tomorrowDate,
      isMobile: (_this$$ppUi = this.$ppUi) === null || _this$$ppUi === void 0 ? void 0 : _this$$ppUi.isMobile
    };
  },
  computed: {
    days: function days() {
      var _this = this;

      var date = new Date(this.firstDate);
      return Object(toConsumableArray["a" /* default */])(Array(this.daysToShow)).map(function () {
        var d = {
          weekday: {
            short: _this.formatDate({
              weekday: 'short'
            }, date),
            long: _this[_this.isMobile ? 'getFormatWeekDay' : 'formatDate']({
              weekday: 'long'
            }, date)
          },
          date: {
            short: _this.formatDate({
              month: 'short',
              day: 'numeric'
            }, date),
            long: _this.formatDate({
              month: 'long',
              day: 'numeric',
              year: 'numeric'
            }, date)
          }
        };
        date.setDate(date.getDate() + 1);
        return d;
      });
    }
  },
  watch: {
    startDate: {
      handler: function handler(newVal) {
        if (this.firstDate !== newVal) {
          this.firstDate = newVal;
        }
      }
    }
  },
  methods: {
    getFormatWeekDay: function getFormatWeekDay(options, date) {
      if (this.compareDate(date, this.todayDate)) {
        return 'Today';
      } else if (this.compareDate(date, this.tomorrowDate)) {
        return 'Tomorrow';
      }

      return this.formatDate(options, date);
    },
    compareDate: function compareDate(date1, date2) {
      return date1.getDate() === date2.getDate() && date1.getMonth() === date2.getMonth() && date1.getFullYear() === date2.getFullYear();
    },
    formatDate: function formatDate(options, date) {
      return new Intl.DateTimeFormat('en-US', options).format(date);
    },
    backClick: function backClick() {
      this.firstDate = new Date(this.firstDate.setDate(this.firstDate.getDate() - this.daysToNavigate));
      this.emitUpdate('back');
    },
    forwardClick: function forwardClick() {
      this.firstDate = new Date(this.firstDate.setDate(this.firstDate.getDate() + this.daysToNavigate));
      this.emitUpdate('forward');
    },
    emitUpdate: function emitUpdate(direction) {
      var lastDate = new Date(this.firstDate);
      lastDate.setDate(lastDate.getDate() + this.daysToNavigate - 1);
      this.$emit('update', {
        start: this.firstDate,
        end: lastDate,
        direction: direction
      });
    }
  }
});
// CONCATENATED MODULE: ./src/components/calendar-nav/PpCalendarNav.vue?vue&type=script&lang=js&
 /* harmony default export */ var calendar_nav_PpCalendarNavvue_type_script_lang_js_ = (PpCalendarNavvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/calendar-nav/PpCalendarNav.vue?vue&type=style&index=0&id=595f5f79&lang=scss&scoped=true&
var PpCalendarNavvue_type_style_index_0_id_595f5f79_lang_scss_scoped_true_ = __webpack_require__("0a90");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// EXTERNAL MODULE: ./node_modules/vuetify-loader/lib/runtime/installComponents.js
var installComponents = __webpack_require__("6544");
var installComponents_default = /*#__PURE__*/__webpack_require__.n(installComponents);

// EXTERNAL MODULE: ./node_modules/vuetify/lib/components/VGrid/VCol.js
var VCol = __webpack_require__("62ad");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/components/VGrid/VRow.js
var VRow = __webpack_require__("0fd9");

// CONCATENATED MODULE: ./src/components/calendar-nav/PpCalendarNav.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  calendar_nav_PpCalendarNavvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "595f5f79",
  null
  
)

/* harmony default export */ var PpCalendarNav = __webpack_exports__["default"] = (component.exports);

/* vuetify-loader */



installComponents_default()(component, {VCol: VCol["a" /* default */],VRow: VRow["a" /* default */]})


/***/ }),

/***/ "3ac3":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("c8d5")

/**
 * @category Minute Helpers
 * @summary Return the end of a minute for the given date.
 *
 * @description
 * Return the end of a minute for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of a minute
 *
 * @example
 * // The end of a minute for 1 December 2014 22:15:45.400:
 * var result = endOfMinute(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:59.999
 */
function endOfMinute (dirtyDate) {
  var date = parse(dirtyDate)
  date.setSeconds(59, 999)
  return date
}

module.exports = endOfMinute


/***/ }),

/***/ "3ad0":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("2a37");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("09a48ec5", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "3b30":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M11 8L22 3V21L11 16V8Z\" fill=\"#DFE4E5\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M21 2C20.4477 2 20 2.44772 20 3V3.90909L11 8H5C3.34315 8 2 9.34315 2 11V13C2 14.6569 3.34315 16 5 16H5.25L5.78101 20.2481C5.90612 21.2489 6.75692 22 7.76556 22H9.43845C9.60197 22 9.76488 21.9799 9.92352 21.9403C10.9951 21.6724 11.6466 20.5865 11.3787 19.5149L10.5 16H11L20 20.0909V21C20 21.5523 20.4477 22 21 22C21.5523 22 22 21.5523 22 21V3C22 2.44772 21.5523 2 21 2ZM20 17.894V6.105L13 9.287V14.712L20 17.894Z\" fill=\"#1F3A3E\"></path><path d=\"M11 14V10H5C4.48716 10 4.06449 10.386 4.00673 10.8834L4 11V13C4 13.5128 4.38604 13.9355 4.88338 13.9933L5 14H11Z\" fill=\"white\"></path><path d=\"M8.43862 16H7.26562L7.76619 20H9.43907L8.43862 16Z\" fill=\"white\"></path></svg>";

/***/ }),

/***/ "3b6e":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.i, "@import url(https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css);"]);
exports.push([module.i, "@import url(https://cdn-prd.patientpop.com/pp-icon-font/v1.6.0/pp-icon-font.css);"]);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.pp-portal-user-menu[data-v-0b18df46]{position:fixed;right:26px;top:calc(var(--pp-header-height)/2 - 18px);z-index:8}@media(max-width:960px){.pp-portal-user-menu[data-v-0b18df46]{right:20px;top:calc(var(--pp-top-bar-height)/2 - 18px)}}.v-list[data-v-0b18df46]{padding-left:1em;padding-right:1em}.v-list-item-group[data-v-0b18df46]{border-top:1px solid #d6d6d6;margin-top:.5em;padding-top:.5em}.v-list-item-group[data-v-0b18df46]:first-child{margin-top:-1em}.v-list-item[data-v-0b18df46]{margin-left:-.5em;width:calc(100% + 1em);z-index:0}.v-list-item[data-v-0b18df46]:before{background-color:#d6d6d6;z-index:-1}.v-list-item--active[data-v-0b18df46]:before{opacity:0}.v-list-item[data-v-0b18df46]:hover:before{opacity:1}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "3b7b":
/***/ (function(module, exports, __webpack_require__) {

var startOfISOYear = __webpack_require__("4497")
var addWeeks = __webpack_require__("7a83")

var MILLISECONDS_IN_WEEK = 604800000

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the number of weeks in an ISO week-numbering year of the given date.
 *
 * @description
 * Get the number of weeks in an ISO week-numbering year of the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the number of ISO weeks in a year
 *
 * @example
 * // How many weeks are in ISO week-numbering year 2015?
 * var result = getISOWeeksInYear(new Date(2015, 1, 11))
 * //=> 53
 */
function getISOWeeksInYear (dirtyDate) {
  var thisYear = startOfISOYear(dirtyDate)
  var nextYear = startOfISOYear(addWeeks(thisYear, 60))
  var diff = nextYear.valueOf() - thisYear.valueOf()
  // Round the number of weeks to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / MILLISECONDS_IN_WEEK)
}

module.exports = getISOWeeksInYear


/***/ }),

/***/ "3bb7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpInputToggleGroup_vue_vue_type_style_index_0_id_1de99991_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("07bf");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpInputToggleGroup_vue_vue_type_style_index_0_id_1de99991_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpInputToggleGroup_vue_vue_type_style_index_0_id_1de99991_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "3bb9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c662cfac-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/payment-form/PpPaymentForm.vue?vue&type=template&id=7636e91e&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pp-container',{staticClass:"pp-payment-form__container"},[(_vm.isLoading)?_c('pp-loading-icon'):_c('div',[(_vm.scriptsError)?_c('pp-form-message',{attrs:{"text":"Cannot load a payment form","type":"error"}}):_vm._e(),(!_vm.paymentSuccessful && !_vm.scriptsError)?_c('div',[(_vm.formHeader)?_c('h4',{staticClass:"pp-payment-form__header"},[_vm._v(" "+_vm._s(_vm.formHeader)+" ")]):_vm._e(),_c('pp-row',[_c('pp-col',[_c('label',{staticClass:"pp-payment-form__label",attrs:{"for":"pp-payment-form__name"}},[_vm._v(" Card Holder ")]),_c('div',{attrs:{"id":"pp-payment-form__name"}})])],1),_c('pp-divider',{staticClass:"pp-payment-form__divider"}),_c('pp-row',[_c('pp-col',[_c('label',{staticClass:"pp-payment-form__label",attrs:{"for":"pp-payment-form__address"}},[_vm._v(" Address ")]),_c('div',{attrs:{"id":"pp-payment-form__address"}})])],1),_c('pp-divider',{staticClass:"pp-payment-form__divider"}),_c('pp-row',[_c('pp-col',[_c('label',{staticClass:"pp-payment-form__label",attrs:{"for":"pp-payment-form__number"}},[_vm._v(" Payment Info ")]),_c('div',{attrs:{"id":"pp-payment-form__number"}})])],1),_c('pp-row',{staticClass:"mt-0"},[_c('pp-col',{attrs:{"cols":"6"}},[_c('div',{attrs:{"id":"pp-payment-form__expiration"}})]),_c('v-spacer'),_c('pp-col',{attrs:{"cols":"6"}},[_c('div',{attrs:{"id":"pp-payment-form__cvv"}})])],1),(_vm.errorMessage)?_c('pp-row',{staticClass:"row--dense"},[_c('pp-col',{attrs:{"cols":"12"}},[_c('pp-form-message',{attrs:{"text":_vm.errorMessage,"type":"error"}})],1)],1):_vm._e(),(_vm.showSubmitButton)?_c('pp-row',[_c('pp-col',[_vm._t("submit-button",[_c('pp-button',{attrs:{"data-test":"pp-payment-submit-button","text":_vm.submitButtonText,"type":"primary","disabled":_vm.paymentInProgress,"submit":true,"block":true},on:{"click":_vm.submitPayment}})])],2)],1):_vm._e()],1):_vm._e()],1)],1)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/payment-form/PpPaymentForm.vue?vue&type=template&id=7636e91e&scoped=true&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("4de4");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("caad");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__("a15b");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("d81d");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__("a9e3");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.assign.js
var es_object_assign = __webpack_require__("cca6");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("d3b7");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.promise.js
var es_promise = __webpack_require__("e6cf");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("2532");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__("53ca");

// EXTERNAL MODULE: ./node_modules/regenerator-runtime/runtime.js
var runtime = __webpack_require__("96cf");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("1da1");

// CONCATENATED MODULE: ./src/components/payment-form/constants.js
var JQUERY_SCRIPT = 'https://code.jquery.com/jquery-3.5.1.min.js';
var ON_SCREEN_FIELDS = ['name', 'number', 'expiration', 'cvv', 'payment.method', 'payment.number', 'payment.expiration', 'payment.cvv', 'address1', 'address', 'city', 'state', 'zip', 'email', 'phone', 'address.address1', 'address.city', 'address.state', 'address.zip', 'address.email', 'address.phone'];
var PAYFIELDS_MAPPINGS = [{
  type: 'number',
  element: '#pp-payment-form__number'
}, {
  type: 'cvv',
  element: '#pp-payment-form__cvv'
}, {
  type: 'name',
  element: '#pp-payment-form__name'
}, {
  type: 'address',
  element: '#pp-payment-form__address'
}, {
  type: 'expiration',
  element: '#pp-payment-form__expiration'
}];
var PAYFIELDS_PLACEHOLDERS = {
  '#name': 'Card holder name',
  '#payment_number': 'Card number',
  '#expiration': 'MM/YY',
  '#payment_cvv': 'CVV/CVC',
  '#address1': 'Address'
};
// EXTERNAL MODULE: ./src/styles/colors.scss
var colors = __webpack_require__("1c98");
var colors_default = /*#__PURE__*/__webpack_require__.n(colors);

// CONCATENATED MODULE: ./src/components/payment-form/payfields-styles.js

/* harmony default export */ var payfields_styles = ({
  '.input': {
    'box-sizing': 'border-box',
    color: colors_default.a.synapse1,
    font: '16px Inter, Helvetica, sans-serif',
    background: 'white',
    width: '100%',
    padding: '16px 12px',
    margin: '24px auto',
    border: "1px solid ".concat(colors_default.a.synapse4),
    'border-radius': '4px',
    display: 'flex',
    'justify-content': 'center'
  },
  '.name': {
    margin: '8px auto'
  },
  '.address1': {
    margin: '8px auto 24px'
  },
  '.expiration': {
    margin: '0 auto'
  },
  '.cvv': {
    margin: '0 auto'
  },
  '.number': {
    margin: '8px auto 0'
  },
  '.card-icon': {
    width: '32px',
    top: '15px'
  },
  '.form-error': {
    color: colors_default.a.firstAid,
    position: 'absolute',
    right: '2%',
    background: 'white',
    'font-size': '12px',
    height: '16px',
    padding: '0 2px',
    'margin-top': '-32px'
  },
  '.name-error': {
    'margin-top': '-16px'
  },
  '.address1-error': {
    'margin-top': '-32px'
  },
  '.address-form-error': {
    transform: 'none',
    'margin-top': '-32px'
  },
  '.number-error': {
    right: '2%',
    'margin-top': '-8px'
  },
  '.expiration-error': {
    right: '4%',
    'margin-top': '-8px'
  },
  '.cvv-error': {
    right: '4%',
    'margin-top': '-8px'
  }
});
// EXTERNAL MODULE: ./src/components/form-message/PpFormMessage.vue + 5 modules
var PpFormMessage = __webpack_require__("6a21");

// EXTERNAL MODULE: ./src/components/row/PpRow.vue + 4 modules
var PpRow = __webpack_require__("eeac");

// EXTERNAL MODULE: ./src/components/col/PpCol.vue + 4 modules
var PpCol = __webpack_require__("8ecc");

// EXTERNAL MODULE: ./src/components/divider/PpDivider.vue + 4 modules
var PpDivider = __webpack_require__("8bb3");

// EXTERNAL MODULE: ./src/components/loading-icon/PpLoadingIcon.vue + 4 modules
var PpLoadingIcon = __webpack_require__("efbd");

// EXTERNAL MODULE: ./src/components/container/PpContainer.vue + 4 modules
var PpContainer = __webpack_require__("3d51");

// EXTERNAL MODULE: ./src/components/button/PpButton.vue + 5 modules
var PpButton = __webpack_require__("251c");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/payment-form/PpPaymentForm.vue?vue&type=script&lang=js&












//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global PayFields */









/* harmony default export */ var PpPaymentFormvue_type_script_lang_js_ = ({
  name: 'PpPaymentForm',
  components: {
    PpContainer: PpContainer["default"],
    PpLoadingIcon: PpLoadingIcon["default"],
    PpFormMessage: PpFormMessage["default"],
    PpDivider: PpDivider["default"],
    PpRow: PpRow["default"],
    PpCol: PpCol["default"],
    PpButton: PpButton["default"]
  },
  props: {
    formHeader: {
      type: String,
      default: 'Payment Information'
    },
    showSubmitButton: {
      type: Boolean,
      default: true
    },
    submitButtonText: {
      type: String,
      default: 'Submit payment'
    },
    invoiceId: {
      type: String,
      required: true
    },

    /* Invoice amount in cents */
    invoiceAmount: {
      type: [Number, String],
      required: true
    },
    payrixMerchantId: {
      type: String,
      required: true
    },
    payrixApiKey: {
      type: String,
      required: true
    },
    payrixScript: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      isLoading: false,
      paymentInProgress: false,
      paymentSuccessful: false,
      scriptsError: false,
      paymentFailed: false,
      jqueryPlugin: null,
      payrixPlugin: null,
      errorMessage: ''
    };
  },
  beforeDestroy: function beforeDestroy() {
    if (this.jqueryPlugin) {
      document.head.removeChild(this.jqueryPlugin);
    }

    if (this.payrixPlugin) {
      document.head.removeChild(this.payrixPlugin);
    }
  },
  mounted: function mounted() {
    var _this = this;

    return Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.isLoading = true;
              _context.prev = 1;

              if (!((typeof PayFields === "undefined" ? "undefined" : Object(esm_typeof["a" /* default */])(PayFields)) === 'object')) {
                _context.next = 6;
                break;
              }

              PayFields.reload();
              _context.next = 12;
              break;

            case 6:
              _context.next = 8;
              return _this.addScript(JQUERY_SCRIPT);

            case 8:
              _this.jqueryPlugin = _context.sent;
              _context.next = 11;
              return _this.addScript(_this.payrixScript);

            case 11:
              _this.payrixPlugin = _context.sent;

            case 12:
              _this.setupPayFields();

              _this.$emit('form-loaded');

              _context.next = 20;
              break;

            case 16:
              _context.prev = 16;
              _context.t0 = _context["catch"](1);
              _this.scriptsError = true;

              _this.$emit('form-failed');

            case 20:
              _context.prev = 20;
              _this.isLoading = false;
              return _context.finish(20);

            case 23:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 16, 20, 23]]);
    }))();
  },
  methods: {
    addScript: function addScript(script) {
      var plugin = document.createElement('script');
      plugin.setAttribute('src', script);
      plugin.async = true;
      document.head.appendChild(plugin);
      return new Promise(function (resolve, reject) {
        plugin.onload = function () {
          return resolve(plugin);
        };

        plugin.onerror = function (e) {
          return reject(e);
        };
      });
    },
    submitPayment: function submitPayment() {
      PayFields.config.amount = this.invoiceAmount;
      PayFields.submit();
      this.paymentInProgress = true;
      this.$emit('payment-submitted');
    },
    onSuccess: function onSuccess() {
      this.paymentSuccessful = true;
      this.$emit('payment-succeeded');
    },
    onError: function onError(errors) {
      this.paymentInProgress = false;
      this.paymentFailed = true; // inconsistency on the Payrix side - handle different error objects

      var errorsArray = errors.errors || errors; // filter out errors mapped to on-screen fields

      this.errorMessage = errorsArray.filter(function (error) {
        return !ON_SCREEN_FIELDS.includes(error.field);
      }).map(function (error) {
        return error.msg;
      }).join(' ');
      this.$emit('payment-failed', this.errorMessage);
    },
    onValidationError: function onValidationError() {
      this.paymentInProgress = false;
      this.paymentFailed = true;
      this.$emit('payment-validation-failed');
    },
    onFinish: function onFinish(response) {
      this.paymentInProgress = false;
    },
    setupPayFields: function setupPayFields() {
      Object.assign(PayFields.config, {
        apiKey: this.payrixApiKey,
        merchant: this.payrixMerchantId,
        amount: this.invoiceAmount,
        order: this.invoiceId,
        allowPartial: 1
      });
      PayFields.fields = PAYFIELDS_MAPPINGS;
      PayFields.onSuccess = this.onSuccess;
      PayFields.onFailure = this.onError;
      PayFields.onValidationFailure = this.onValidationError;
      PayFields.onFinish = this.onFinish;
      PayFields.customizations = {
        placeholders: PAYFIELDS_PLACEHOLDERS,
        style: payfields_styles
      };
    }
  }
});
// CONCATENATED MODULE: ./src/components/payment-form/PpPaymentForm.vue?vue&type=script&lang=js&
 /* harmony default export */ var payment_form_PpPaymentFormvue_type_script_lang_js_ = (PpPaymentFormvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/payment-form/PpPaymentForm.vue?vue&type=style&index=0&id=7636e91e&lang=scss&scoped=true&
var PpPaymentFormvue_type_style_index_0_id_7636e91e_lang_scss_scoped_true_ = __webpack_require__("dc56");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// EXTERNAL MODULE: ./node_modules/vuetify-loader/lib/runtime/installComponents.js
var installComponents = __webpack_require__("6544");
var installComponents_default = /*#__PURE__*/__webpack_require__.n(installComponents);

// EXTERNAL MODULE: ./node_modules/vuetify/src/components/VGrid/_grid.sass
var _grid = __webpack_require__("20f6");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/util/helpers.js
var helpers = __webpack_require__("80d2");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VGrid/VSpacer.js


/* harmony default export */ var VSpacer = (Object(helpers["i" /* createSimpleFunctional */])('spacer', 'div', 'v-spacer'));
// CONCATENATED MODULE: ./src/components/payment-form/PpPaymentForm.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  payment_form_PpPaymentFormvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "7636e91e",
  null
  
)

/* harmony default export */ var PpPaymentForm = __webpack_exports__["default"] = (component.exports);

/* vuetify-loader */


installComponents_default()(component, {VSpacer: VSpacer})


/***/ }),

/***/ "3bbe":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");

module.exports = function (it) {
  if (!isObject(it) && it !== null) {
    throw TypeError("Can't set " + String(it) + ' as a prototype');
  } return it;
};


/***/ }),

/***/ "3bc7":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("c8d5")
var differenceInCalendarDays = __webpack_require__("d420")
var compareAsc = __webpack_require__("0d3e")

/**
 * @category Day Helpers
 * @summary Get the number of full days between the given dates.
 *
 * @description
 * Get the number of full days between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of full days
 *
 * @example
 * // How many full days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * var result = differenceInDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 365
 */
function differenceInDays (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)

  var sign = compareAsc(dateLeft, dateRight)
  var difference = Math.abs(differenceInCalendarDays(dateLeft, dateRight))
  dateLeft.setDate(dateLeft.getDate() - sign * difference)

  // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
  // If so, result must be decreased by 1 in absolute value
  var isLastDayNotFull = compareAsc(dateLeft, dateRight) === -sign
  return sign * (difference - isLastDayNotFull)
}

module.exports = differenceInDays


/***/ }),

/***/ "3be1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpInputRadioGroup_vue_vue_type_style_index_0_id_698620e8_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("b22b");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpInputRadioGroup_vue_vue_type_style_index_0_id_698620e8_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpInputRadioGroup_vue_vue_type_style_index_0_id_698620e8_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "3c93":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("fdcd");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("5083c661", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "3ca3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var charAt = __webpack_require__("6547").charAt;
var InternalStateModule = __webpack_require__("69f3");
var defineIterator = __webpack_require__("7dd0");

var STRING_ITERATOR = 'String Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(STRING_ITERATOR);

// `String.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
defineIterator(String, 'String', function (iterated) {
  setInternalState(this, {
    type: STRING_ITERATOR,
    string: String(iterated),
    index: 0
  });
// `%StringIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
  var state = getInternalState(this);
  var string = state.string;
  var index = state.index;
  var point;
  if (index >= string.length) return { value: undefined, done: true };
  point = charAt(string, index);
  state.index += point.length;
  return { value: point, done: false };
});


/***/ }),

/***/ "3cae":
/***/ (function(module, exports, __webpack_require__) {

var startOfDay = __webpack_require__("0978")

/**
 * @category Day Helpers
 * @summary Return the start of today.
 *
 * @description
 * Return the start of today.
 *
 * @returns {Date} the start of today
 *
 * @example
 * // If today is 6 October 2014:
 * var result = startOfToday()
 * //=> Mon Oct 6 2014 00:00:00
 */
function startOfToday () {
  return startOfDay(new Date())
}

module.exports = startOfToday


/***/ }),

/***/ "3d02":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M11 8L22 3V21L11 16V8Z\" fill=\"#D5EAFD\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M21 2C20.4477 2 20 2.44772 20 3V3.90909L11 8H5C3.34315 8 2 9.34315 2 11V13C2 14.6569 3.34315 16 5 16H5.25L5.78101 20.2481C5.90612 21.2489 6.75692 22 7.76556 22H9.43845C9.60197 22 9.76488 21.9799 9.92352 21.9403C10.9951 21.6724 11.6466 20.5865 11.3787 19.5149L10.5 16H11L20 20.0909V21C20 21.5523 20.4477 22 21 22C21.5523 22 22 21.5523 22 21V3C22 2.44772 21.5523 2 21 2ZM20 17.894V6.105L13 9.287V14.712L20 17.894Z\" fill=\"#079CB2\"></path><path d=\"M11 14V10H5C4.48716 10 4.06449 10.386 4.00673 10.8834L4 11V13C4 13.5128 4.38604 13.9355 4.88338 13.9933L5 14H11Z\" fill=\"white\"></path><path d=\"M8.43862 16H7.26562L7.76619 20H9.43907L8.43862 16Z\" fill=\"white\"></path></svg>";

/***/ }),

/***/ "3d51":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c662cfac-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/container/PpContainer.vue?vue&type=template&id=51490595&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',_vm._g(_vm._b({},'v-container',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/container/PpContainer.vue?vue&type=template&id=51490595&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/container/PpContainer.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
/* harmony default export */ var PpContainervue_type_script_lang_js_ = ({
  name: 'PpContainer'
});
// CONCATENATED MODULE: ./src/components/container/PpContainer.vue?vue&type=script&lang=js&
 /* harmony default export */ var container_PpContainervue_type_script_lang_js_ = (PpContainervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// EXTERNAL MODULE: ./node_modules/vuetify-loader/lib/runtime/installComponents.js
var installComponents = __webpack_require__("6544");
var installComponents_default = /*#__PURE__*/__webpack_require__.n(installComponents);

// EXTERNAL MODULE: ./node_modules/vuetify/lib/components/VGrid/VContainer.js
var VContainer = __webpack_require__("a523");

// CONCATENATED MODULE: ./src/components/container/PpContainer.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  container_PpContainervue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var PpContainer = __webpack_exports__["default"] = (component.exports);

/* vuetify-loader */


installComponents_default()(component, {VContainer: VContainer["a" /* default */]})


/***/ }),

/***/ "3d56":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c662cfac-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/scrollable-list/PpScrollableList.vue?vue&type=template&id=766f6a8c&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.cssClass},[[_vm._l((_vm.visibleItems),function(item,index){return [_c('div',{key:("item-" + index),staticClass:"pp-scrollable-list__item-wrapper",class:_vm.horizontal ? 'mx-1' : 'my-2'},[_vm._t(("scrollable-list-item-" + index),null,{"item":item})],2)]}),(_vm.showMoreButton)?_c('div',{staticClass:"text-center"},[_vm._t("more-button",[_c('pp-button',{staticClass:"more-button my-1",attrs:{"type":"secondary","text":"more"},on:{"click":_vm.handleMoreClick}})],{"click":_vm.handleMoreClick})],2):_vm._e()]],2)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/scrollable-list/PpScrollableList.vue?vue&type=template&id=766f6a8c&scoped=true&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__("fb6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__("a9e3");

// EXTERNAL MODULE: ./src/components/button/PpButton.vue + 5 modules
var PpButton = __webpack_require__("251c");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/scrollable-list/PpScrollableList.vue?vue&type=script&lang=js&


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * PatientPop Scrollable List
 */

/* harmony default export */ var PpScrollableListvue_type_script_lang_js_ = ({
  name: 'PpScrollableList',
  components: {
    'pp-button': PpButton["default"]
  },
  props: {
    /**
     * list of items
     */
    items: {
      type: Array,
      required: true
    },

    /**
     * Number of items by default on desktop (all items are visible by default on mobile)
     */
    defaultVisibleItems: {
      type: Number,
      required: true
    },

    /**
     * Boolean that allows parent to control whether or not all items should be visible
     */
    showAll: {
      type: Boolean,
      default: false
    },
    horizontal: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      showAllItems: this.showAll
    };
  },
  computed: {
    visibleItems: function visibleItems() {
      return this.showAllItems || this.horizontal ? this.items : this.items.slice(0, this.defaultVisibleItems);
    },
    showMoreButton: function showMoreButton() {
      return !this.showAllItems && !this.horizontal && this.items.length > this.defaultVisibleItems;
    },
    cssClass: function cssClass() {
      var baseClass = 'pp-scrollable-list';
      return this.horizontal ? "".concat(baseClass, " ").concat(baseClass, "--horizontal") : baseClass;
    }
  },
  watch: {
    showAll: function showAll(_showAll) {
      this.showAllItems = _showAll;
    }
  },
  methods: {
    handleMoreClick: function handleMoreClick() {
      this.showAllItems = true;
      this.$emit('more-click');
    }
  }
});
// CONCATENATED MODULE: ./src/components/scrollable-list/PpScrollableList.vue?vue&type=script&lang=js&
 /* harmony default export */ var scrollable_list_PpScrollableListvue_type_script_lang_js_ = (PpScrollableListvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/scrollable-list/PpScrollableList.vue?vue&type=style&index=0&id=766f6a8c&lang=scss&scoped=true&
var PpScrollableListvue_type_style_index_0_id_766f6a8c_lang_scss_scoped_true_ = __webpack_require__("c6e8");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/scrollable-list/PpScrollableList.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  scrollable_list_PpScrollableListvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "766f6a8c",
  null
  
)

/* harmony default export */ var PpScrollableList = __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "3d86":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("fecb");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("49e9b95f", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "3d8d":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("e462");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("51aab48a", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "3e2c":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.theme--light.v-snack__wrapper{color:var(--pp-text-primary,#2b2b2b)}.theme--dark.v-snack__wrapper{color:var(--pp-primary-button-text-color,#004852)}.v-sheet.v-snack__wrapper{border-radius:5px}.v-sheet.v-snack__wrapper:not(.v-sheet--outlined){box-shadow:0 3px 5px -1px transparent,0 6px 10px 0 transparent,0 1px 18px 0 rgba(0,0,0,.12)}.v-sheet.v-snack__wrapper.v-sheet--shaped{border-radius:20px 5px}.v-snack{bottom:0;display:flex;font-size:1rem;justify-content:center;left:0;pointer-events:none;right:0;top:0;width:100%}.v-snack:not(.v-snack--absolute){height:100vh;position:fixed;z-index:1000}.v-snack:not(.v-snack--centered):not(.v-snack--top){align-items:flex-end}.v-snack__wrapper{align-items:center;border-color:currentColor!important;display:flex;margin:8px;max-width:672px;min-height:48px;min-width:344px;padding:0;pointer-events:auto;position:relative;transition-duration:.15s;transition-property:opacity,transform;transition-timing-function:cubic-bezier(0,0,.2,1)}.v-snack__wrapper.theme--dark{background-color:#333;color:hsla(0,0%,100%,.87)}.v-snack__content{flex-grow:1;font-size:1rem;font-weight:400;letter-spacing:-.02em;line-height:1.4285714286rem;margin-right:auto;padding:14px 16px;text-align:initial}.v-snack__action{align-items:center;align-self:center;display:flex}.v-snack__action .v-ripple__container{display:none}.v-application--is-ltr .v-snack__action{margin-right:8px}.v-application--is-rtl .v-snack__action{margin-left:8px}.v-snack__action>.v-snack__btn.v-btn{padding:0 8px}.v-snack__btn{margin-left:0;margin-right:0;margin:0;min-width:auto}.v-snack--absolute{height:100%;position:absolute;z-index:1}.v-snack--centered{align-items:center}.v-snack--left{justify-content:flex-start;right:auto}.v-snack--multi-line .v-snack__wrapper{min-height:68px}.v-snack--right{justify-content:flex-end;left:auto}.v-snack:not(.v-snack--has-background) .v-snack__wrapper{box-shadow:none!important}.v-snack--bottom{top:auto}.v-snack--text .v-snack__wrapper:before{background-color:currentColor;border-radius:inherit;bottom:0;content:\"\";left:0;opacity:.12;pointer-events:none;position:absolute;right:0;top:0}.v-snack--top{align-items:flex-start;bottom:auto}.v-snack--vertical .v-snack__wrapper{flex-direction:column}.v-snack--vertical .v-snack__wrapper .v-snack__action{align-self:flex-end;margin-bottom:8px}.v-snack-transition-enter.v-snack__wrapper{transform:scale(.8)}.v-snack-transition-enter.v-snack__wrapper,.v-snack-transition-leave-to.v-snack__wrapper{opacity:0}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "3e35":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.i, "@import url(https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css);"]);
exports.push([module.i, "@import url(https://cdn-prd.patientpop.com/pp-icon-font/v1.6.0/pp-icon-font.css);"]);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.pp-shortcut-container[data-v-3e08c342]  [aria-haspopup]{height:100%;min-height:36px}.pp-shortcut-menu-btn[data-v-3e08c342]{height:100%;--pp-theme-color-bg:#004852;--pp-button-hover-bg:#417e86}.pp-shortcut-menu[data-v-3e08c342]{--pp-button-tertiary-bg:transparent;--pp-list-item-content-padding:0;--pp-list-item-padding:0;--pp-list-item-title-font-size:1.1428571429rem;--pp-list-item-title-subtitle-line-height:1.5;background:#fff}.v-list-item-group[data-v-3e08c342]{border-top:1px solid #d6d6d6;margin-top:.5em;padding-top:.5em}.v-list-item-group[data-v-3e08c342]:first-child{border-top:0;margin-top:-.5em}.pp-drop-down-button[data-v-3e08c342]  .pp-drop-down-button__main-button{flex-grow:1;max-width:320px;overflow:hidden;text-align:left}.pp-drop-down-button[data-v-3e08c342]  .pp-drop-down-button__main-button:hover:before{opacity:0}.pp-drop-down-button[data-v-3e08c342]  .pp-drop-down-button__main-button .v-btn__content{display:block;max-width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.pp-drop-down-button[data-v-3e08c342]  .pp-drop-down-button__secondary-button{border-left:0}.pp-drop-down-button[data-v-3e08c342]  .pp-drop-down-button__secondary-button i{font-size:2em}.v-list-item--highlighted.v-list-item[data-v-3e08c342]  .pp-drop-down-button__secondary-button{opacity:1}.v-list-item[data-v-3e08c342]  .pp-drop-down-button__secondary-button{opacity:0}.v-list-item[data-v-3e08c342] :hover .pp-drop-down-button__secondary-button{opacity:1}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "3e60":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.i, "@import url(https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css);"]);
exports.push([module.i, "@import url(https://cdn-prd.patientpop.com/pp-icon-font/v1.6.0/pp-icon-font.css);"]);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.pp-app[data-v-7ccadf14]{color:#2b2b2b}.pp-app--full-height[data-v-7ccadf14]{height:100%}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "3ea3":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var sign = __webpack_require__("f748");

var abs = Math.abs;
var pow = Math.pow;

// `Math.cbrt` method
// https://tc39.es/ecma262/#sec-math.cbrt
$({ target: 'Math', stat: true }, {
  cbrt: function cbrt(x) {
    return sign(x = +x) * pow(abs(x), 1 / 3);
  }
});


/***/ }),

/***/ "3eac":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.v-list-group .v-list-group__header .v-list-item__icon.v-list-group__header__append-icon{align-self:center;margin:0;min-width:48px;justify-content:flex-end}.v-list-group--sub-group{align-items:center;display:flex;flex-wrap:wrap}.v-list-group__header.v-list-item--active:not(:hover):not(:focus):before{opacity:0}.v-list-group__items{flex:1 1 auto}.v-list-group__items .v-list-group__items,.v-list-group__items .v-list-item{overflow:hidden}.v-list-group--active>.v-list-group__header.v-list-group__header--sub-group>.v-list-group__header__prepend-icon .v-icon,.v-list-group--active>.v-list-group__header>.v-list-group__header__append-icon .v-icon{transform:rotate(-180deg)}.v-list-group--active>.v-list-group__header .v-list-group__header__prepend-icon .v-icon,.v-list-group--active>.v-list-group__header .v-list-item,.v-list-group--active>.v-list-group__header .v-list-item__content{color:inherit}.v-application--is-ltr .v-list-group--sub-group .v-list-item__action:first-child,.v-application--is-ltr .v-list-group--sub-group .v-list-item__avatar:first-child,.v-application--is-ltr .v-list-group--sub-group .v-list-item__icon:first-child{margin-right:16px}.v-application--is-rtl .v-list-group--sub-group .v-list-item__action:first-child,.v-application--is-rtl .v-list-group--sub-group .v-list-item__avatar:first-child,.v-application--is-rtl .v-list-group--sub-group .v-list-item__icon:first-child{margin-left:16px}.v-application--is-ltr .v-list-group--sub-group .v-list-group__header{padding-left:32px}.v-application--is-rtl .v-list-group--sub-group .v-list-group__header{padding-right:32px}.v-application--is-ltr .v-list-group--sub-group .v-list-group__items .v-list-item{padding-left:40px}.v-application--is-rtl .v-list-group--sub-group .v-list-group__items .v-list-item{padding-right:40px}.v-list-group--sub-group.v-list-group--active .v-list-item__icon.v-list-group__header__prepend-icon .v-icon{transform:rotate(-180deg)}.v-application--is-ltr .v-list-group--no-action>.v-list-group__items>.v-list-item{padding-left:72px}.v-application--is-rtl .v-list-group--no-action>.v-list-group__items>.v-list-item{padding-right:72px}.v-application--is-ltr .v-list-group--no-action.v-list-group--sub-group>.v-list-group__items>.v-list-item{padding-left:88px}.v-application--is-rtl .v-list-group--no-action.v-list-group--sub-group>.v-list-group__items>.v-list-item{padding-right:88px}.v-application--is-ltr .v-list--dense .v-list-group--sub-group .v-list-group__header{padding-left:24px}.v-application--is-rtl .v-list--dense .v-list-group--sub-group .v-list-group__header{padding-right:24px}.v-application--is-ltr .v-list--dense.v-list--nav .v-list-group--no-action>.v-list-group__items>.v-list-item{padding-left:64px}.v-application--is-rtl .v-list--dense.v-list--nav .v-list-group--no-action>.v-list-group__items>.v-list-item{padding-right:64px}.v-application--is-ltr .v-list--dense.v-list--nav .v-list-group--no-action.v-list-group--sub-group>.v-list-group__items>.v-list-item{padding-left:80px}.v-application--is-rtl .v-list--dense.v-list--nav .v-list-group--no-action.v-list-group--sub-group>.v-list-group__items>.v-list-item{padding-right:80px}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "3eee":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("c8d5")
var endOfDay = __webpack_require__("9744")
var endOfMonth = __webpack_require__("d6f8")

/**
 * @category Month Helpers
 * @summary Is the given date the last day of a month?
 *
 * @description
 * Is the given date the last day of a month?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is the last day of a month
 *
 * @example
 * // Is 28 February 2014 the last day of a month?
 * var result = isLastDayOfMonth(new Date(2014, 1, 28))
 * //=> true
 */
function isLastDayOfMonth (dirtyDate) {
  var date = parse(dirtyDate)
  return endOfDay(date).getTime() === endOfMonth(date).getTime()
}

module.exports = isLastDayOfMonth


/***/ }),

/***/ "3ef2":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M16 10H20C21.1046 10 22 10.8954 22 12V19C22 20.1046 21.1046 21 20 21H18C16.8954 21 16 20.1046 16 19V10Z\" fill=\"#DFE4E5\" stroke=\"#688083\" stroke-width=\"2\"></path><path d=\"M1 5C1 3.34315 2.34315 2 4 2H15C16.6569 2 18 3.34315 18 5V22H4C2.34315 22 1 20.6569 1 19V5Z\" fill=\"white\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M15 4H4C3.44771 4 3 4.44772 3 5V19C3 19.5523 3.44772 20 4 20H16.3125C16.3125 20 16 19.7266 16 19C16 18.2734 16 5 16 5C16 4.44772 15.5523 4 15 4ZM4 2C2.34315 2 1 3.34315 1 5V19C1 20.6569 2.34315 22 4 22H18V20V19V5C18 3.34315 16.6569 2 15 2H4Z\" fill=\"#688083\"></path><rect x=\"5\" y=\"15\" width=\"9\" height=\"2\" rx=\"1\" fill=\"#688083\"></rect><path d=\"M18 20H19C18.2738 20 18 19.6199 18 19V19.4709V19.7751V20Z\" fill=\"#688083\"></path><path d=\"M6 7H12.75C12.8881 7 13 7.11193 13 7.25V12H6.25C6.11193 12 6 11.8881 6 11.75V7Z\" fill=\"#DFE4E5\" stroke=\"#688083\" stroke-width=\"2\"></path></svg>";

/***/ }),

/***/ "3ef9":
/***/ (function(module, exports, __webpack_require__) {

var isSameMinute = __webpack_require__("f564")

/**
 * @category Minute Helpers
 * @summary Is the given date in the same minute as the current date?
 *
 * @description
 * Is the given date in the same minute as the current date?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in this minute
 *
 * @example
 * // If now is 25 September 2014 18:30:15.500,
 * // is 25 September 2014 18:30:00 in this minute?
 * var result = isThisMinute(new Date(2014, 8, 25, 18, 30))
 * //=> true
 */
function isThisMinute (dirtyDate) {
  return isSameMinute(new Date(), dirtyDate)
}

module.exports = isThisMinute


/***/ }),

/***/ "3f06":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.theme--light.v-select .v-select__selection--comma{color:var(--pp-text-primary,#2b2b2b)}.theme--light.v-select .v-select__selection--disabled{color:var(--pp-text-disabled,#f6f6f6)}.theme--light.v-select.v-text-field--solo-inverted.v-input--is-focused .v-select__selection--comma{color:#fff}.theme--dark.v-select .v-select__selection--comma{color:var(--pp-primary-button-text-color,#004852)}.theme--dark.v-select .v-select__selection--disabled{color:hsla(0,0%,100%,.5)}.theme--dark.v-select.v-text-field--solo-inverted.v-input--is-focused .v-select__selection--comma{color:rgba(0,0,0,.87)}.v-select{position:relative}.v-select:not(.v-select--is-multi).v-text-field--single-line .v-select__selections{flex-wrap:nowrap}.v-select>.v-input__control>.v-input__slot{cursor:pointer}.v-select .v-chip{flex:0 1 auto;margin:4px}.v-select .v-chip--selected:after{opacity:.22}.v-select .fade-transition-leave-active{position:absolute;left:0}.v-select.v-input--is-dirty ::-moz-placeholder{color:transparent!important}.v-select.v-input--is-dirty :-ms-input-placeholder{color:transparent!important}.v-select.v-input--is-dirty ::placeholder{color:transparent!important}.v-select:not(.v-input--is-dirty):not(.v-input--is-focused) .v-text-field__prefix{line-height:20px;top:7px;transition:.3s cubic-bezier(.25,.8,.5,1)}.v-select.v-text-field--enclosed:not(.v-text-field--single-line):not(.v-text-field--outlined) .v-select__selections{padding-top:20px}.v-select.v-text-field--outlined:not(.v-text-field--single-line) .v-select__selections{padding:8px 0}.v-select.v-text-field--outlined:not(.v-text-field--single-line).v-input--dense .v-select__selections{padding:4px 0}.v-select.v-text-field input{flex:1 1;margin-top:0;min-width:0;pointer-events:none;position:relative}.v-select.v-select--is-menu-active .v-input__icon--append .v-icon{transform:rotate(180deg)}.v-select.v-select--chips input{margin:0}.v-select.v-select--chips .v-select__selections{min-height:42px}.v-select.v-select--chips.v-input--dense .v-select__selections{min-height:40px}.v-select.v-select--chips .v-chip--select.v-chip--active:before{opacity:.2}.v-select.v-select--chips.v-select--chips--small .v-select__selections{min-height:26px}.v-select.v-select--chips:not(.v-text-field--single-line).v-text-field--box .v-select__selections,.v-select.v-select--chips:not(.v-text-field--single-line).v-text-field--enclosed .v-select__selections{min-height:68px}.v-select.v-select--chips:not(.v-text-field--single-line).v-text-field--box.v-input--dense .v-select__selections,.v-select.v-select--chips:not(.v-text-field--single-line).v-text-field--enclosed.v-input--dense .v-select__selections{min-height:40px}.v-select.v-select--chips:not(.v-text-field--single-line).v-text-field--box.v-select--chips--small .v-select__selections,.v-select.v-select--chips:not(.v-text-field--single-line).v-text-field--enclosed.v-select--chips--small .v-select__selections{min-height:26px}.v-select.v-select--chips:not(.v-text-field--single-line).v-text-field--box.v-select--chips--small.v-input--dense .v-select__selections,.v-select.v-select--chips:not(.v-text-field--single-line).v-text-field--enclosed.v-select--chips--small.v-input--dense .v-select__selections{min-height:38px}.v-select.v-text-field--reverse .v-select__selections,.v-select.v-text-field--reverse .v-select__slot{flex-direction:row-reverse}.v-select__selections{align-items:center;display:flex;flex:1 1;flex-wrap:wrap;line-height:18px;max-width:100%;min-width:0}.v-select__selection{max-width:90%}.v-select__selection--comma{margin:7px 4px 7px 0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.v-select.v-input--dense .v-select__selection--comma{margin:5px 4px 3px 0}.v-select.v-input--dense .v-chip{margin:0 4px 0 4px}.v-select__slot{position:relative;align-items:center;display:flex;max-width:100%;min-width:0;width:100%}.v-select:not(.v-text-field--single-line):not(.v-text-field--outlined) .v-select__slot>input{align-self:flex-end}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "3f61":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpApp_vue_vue_type_style_index_1_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("5332");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpApp_vue_vue_type_style_index_1_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpApp_vue_vue_type_style_index_1_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "3f8c":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "4049":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c662cfac-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/audio-player/PpAudioPlayer.vue?vue&type=template&id=060f210a&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"pp-audio-player text-center pa-2",attrs:{"flat":_vm.flat}},[_c('v-card-text',[(_vm.isLoading)?_c('pp-loader',{attrs:{"size":40,"width":4}}):[_vm._t("file-name",[(_vm.fileName)?_c('p',{staticClass:"text-left text-h6 mb-2"},[_vm._v(" "+_vm._s(_vm.fileName)+" ")]):_vm._e()]),_c('v-row',{staticClass:"justify-center align-center"},[_c('v-col',[_c('v-progress-linear',{staticClass:"pp-audio-player__progress mt-3",class:_vm.disabled ? 'pp-audio-player__progress--disabled' : '',attrs:{"value":_vm.percentage,"role":"button","background-color":("grey " + (_vm.disabled ? 'lighten-3' : ''))},on:{"change":_vm.setPosition}})],1),_c('pp-button',{staticClass:"pp-audio-player__btn mx-2",attrs:{"type":"primary","icon":_vm.playing ? 'pause' : 'play',"disabled":_vm.disabled},nativeOn:{"click":function($event){_vm.playing ? _vm.pause() : _vm.play()}}}),(_vm.showStopBtn)?_c('pp-button',{staticClass:"pp-audio-player__btn mr-2",attrs:{"type":"secondary","icon":"stop","disabled":_vm.disabled},nativeOn:{"click":function($event){return _vm.stop()}}}):_vm._e(),(_vm.file)?_c('p',{staticClass:"pp-audio-player__time-elapsed align-self-center text-caption font-weight-bold mb-0 mt-1 pr-2",class:_vm.file ? '' : 'grey--text text--lighten-3'},[_vm._v(" "+_vm._s(_vm.elapsedTime)+" / "+_vm._s(_vm.duration)+" ")]):_vm._e()],1),(_vm.fileError)?_c('pp-display-error',{staticClass:"pt-2",attrs:{"message":"Failed to load audio file"}}):_vm._e()]],2),_c('audio',{ref:"player",attrs:{"src":_vm.file},on:{"canplaythrough":_vm.handleCanPlayThrough,"timeupdate":_vm.handleTimeUpdate,"error":_vm.handleError,"ended":_vm.handleEnded}})],1)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/audio-player/PpAudioPlayer.vue?vue&type=template&id=060f210a&scoped=true&

// EXTERNAL MODULE: ./src/components/display-error/PpDisplayError.vue + 4 modules
var PpDisplayError = __webpack_require__("cfdb");

// EXTERNAL MODULE: ./src/components/loader/PpLoader.vue + 4 modules
var PpLoader = __webpack_require__("d888");

// EXTERNAL MODULE: ./src/components/button/PpButton.vue + 5 modules
var PpButton = __webpack_require__("251c");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/audio-player/PpAudioPlayer.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var PpAudioPlayervue_type_script_lang_js_ = ({
  name: 'PpAudioPlayer',
  components: {
    'pp-display-error': PpDisplayError["default"],
    'pp-loader': PpLoader["default"],
    'pp-button': PpButton["default"]
  },
  props: {
    /**
     * Sets the audio file to reproduce
     */
    file: {
      type: String,
      default: null
    },

    /**
     * Sets the audio file name
     */
    fileName: {
      type: String,
      default: null
    },

    /**
     * Sets the flat value of the container
     */
    flat: {
      type: Boolean,
      default: false
    },

    /**
     * Shows or hides the stop button
     */
    showStopBtn: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      isLoading: true,
      playing: false,
      audio: undefined,
      currentTime: 0,
      totalDuration: 0,
      readyState: 0,
      fileError: false
    };
  },
  computed: {
    duration: function duration() {
      return this.formatTime(this.totalDuration);
    },
    elapsedTime: function elapsedTime() {
      return this.formatTime(this.currentTime);
    },
    percentage: function percentage() {
      return this.audio ? this.currentTime / this.totalDuration * 100 : 0;
    },
    disabled: function disabled() {
      return !this.file || this.fileError;
    }
  },
  watch: {
    file: function file() {
      this.isLoading = true;
      this.fileError = false;
      this.stop();
    }
  },
  mounted: function mounted() {
    this.audio = this.$refs.player;
    if (!this.file) this.isLoading = false;
  },
  methods: {
    formatTime: function formatTime(second) {
      return new Date(second * 1000).toISOString().substr(14, 5);
    },
    setPosition: function setPosition(percentage) {
      this.audio.currentTime = this.totalDuration / 100 * percentage;
    },
    stop: function stop() {
      this.pause();
      this.audio.currentTime = 0;
    },
    play: function play() {
      this.audio.play();
      this.playing = true;
    },
    pause: function pause() {
      this.audio.pause();
      this.playing = false;
    },
    handleCanPlayThrough: function handleCanPlayThrough() {
      this.totalDuration = parseInt(this.audio.duration);
      this.fileError = false;
      this.isLoading = false;
    },
    handleTimeUpdate: function handleTimeUpdate(_ref) {
      var currentTime = _ref.target.currentTime;
      this.currentTime = currentTime;
    },
    handleError: function handleError() {
      if (this.file) {
        this.fileError = true;
      }

      this.isLoading = false;
    },
    handleEnded: function handleEnded() {
      this.playing = false;
    }
  }
});
// CONCATENATED MODULE: ./src/components/audio-player/PpAudioPlayer.vue?vue&type=script&lang=js&
 /* harmony default export */ var audio_player_PpAudioPlayervue_type_script_lang_js_ = (PpAudioPlayervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/audio-player/PpAudioPlayer.vue?vue&type=style&index=0&id=060f210a&lang=scss&scoped=true&
var PpAudioPlayervue_type_style_index_0_id_060f210a_lang_scss_scoped_true_ = __webpack_require__("e334");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// EXTERNAL MODULE: ./node_modules/vuetify-loader/lib/runtime/installComponents.js
var installComponents = __webpack_require__("6544");
var installComponents_default = /*#__PURE__*/__webpack_require__.n(installComponents);

// EXTERNAL MODULE: ./node_modules/vuetify/lib/components/VCard/VCard.js
var VCard = __webpack_require__("b0af");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/components/VCard/index.js
var components_VCard = __webpack_require__("99d9");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/components/VGrid/VCol.js
var VCol = __webpack_require__("62ad");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/components/VProgressLinear/VProgressLinear.js
var VProgressLinear = __webpack_require__("8e36");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/components/VGrid/VRow.js
var VRow = __webpack_require__("0fd9");

// CONCATENATED MODULE: ./src/components/audio-player/PpAudioPlayer.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  audio_player_PpAudioPlayervue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "060f210a",
  null
  
)

/* harmony default export */ var PpAudioPlayer = __webpack_exports__["default"] = (component.exports);

/* vuetify-loader */






installComponents_default()(component, {VCard: VCard["a" /* default */],VCardText: components_VCard["b" /* VCardText */],VCol: VCol["a" /* default */],VProgressLinear: VProgressLinear["a" /* default */],VRow: VRow["a" /* default */]})


/***/ }),

/***/ "4069":
/***/ (function(module, exports, __webpack_require__) {

// this method was added to unscopables after implementation
// in popular engines, so it's moved to a separate module
var addToUnscopables = __webpack_require__("44d2");

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('flat');


/***/ }),

/***/ "408a":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("c6b6");

// `thisNumberValue` abstract operation
// https://tc39.es/ecma262/#sec-thisnumbervalue
module.exports = function (value) {
  if (typeof value != 'number' && classof(value) != 'Number') {
    throw TypeError('Incorrect invocation');
  }
  return +value;
};


/***/ }),

/***/ "411b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c662cfac-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/link/PpLink.vue?vue&type=template&id=cd6c2852&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"pp-link font-weight-bold",attrs:{"target":"_blank","href":_vm.route},on:{"click":_vm.clickEvent}},[_c('i',{class:("pp-icon-" + _vm.icon)}),_vm._v(" "+_vm._s(_vm.text)+" ")])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/link/PpLink.vue?vue&type=template&id=cd6c2852&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/link/PpLink.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var PpLinkvue_type_script_lang_js_ = ({
  name: 'PpLink',
  props: {
    /**
     * Sets the icon
     */
    icon: {
      type: String,
      default: 'new-window'
    },

    /**
     * Sets the text
     */
    text: {
      type: String,
      required: true
    },

    /**
     * Sets the route
     */
    route: {
      type: String,
      required: true
    }
  },
  methods: {
    clickEvent: function clickEvent() {
      this.$emit('click-event');
    }
  }
});
// CONCATENATED MODULE: ./src/components/link/PpLink.vue?vue&type=script&lang=js&
 /* harmony default export */ var link_PpLinkvue_type_script_lang_js_ = (PpLinkvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/link/PpLink.vue?vue&type=style&index=0&id=cd6c2852&lang=scss&scoped=true&
var PpLinkvue_type_style_index_0_id_cd6c2852_lang_scss_scoped_true_ = __webpack_require__("5c78");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/link/PpLink.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  link_PpLinkvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "cd6c2852",
  null
  
)

/* harmony default export */ var PpLink = __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "4160":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var forEach = __webpack_require__("17c2");

// `Array.prototype.forEach` method
// https://tc39.es/ecma262/#sec-array.prototype.foreach
$({ target: 'Array', proto: true, forced: [].forEach != forEach }, {
  forEach: forEach
});


/***/ }),

/***/ "4175":
/***/ (function(module, exports, __webpack_require__) {

var endOfWeek = __webpack_require__("7494")

/**
 * @category ISO Week Helpers
 * @summary Return the end of an ISO week for the given date.
 *
 * @description
 * Return the end of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of an ISO week
 *
 * @example
 * // The end of an ISO week for 2 September 2014 11:55:00:
 * var result = endOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Sep 07 2014 23:59:59.999
 */
function endOfISOWeek (dirtyDate) {
  return endOfWeek(dirtyDate, {weekStartsOn: 1})
}

module.exports = endOfISOWeek


/***/ }),

/***/ "428f":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");

module.exports = global;


/***/ }),

/***/ "42ad":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.container{width:100%;padding:12px;margin-right:auto;margin-left:auto}@media(min-width:960px){.container{max-width:900px}}@media(min-width:1264px){.container{max-width:1185px}}@media(min-width:1904px){.container{max-width:1785px}}.container--fluid{max-width:100%}.row{display:flex;flex-wrap:wrap;flex:1 1 auto;margin:-12px}.row+.row{margin-top:12px}.row+.row--dense{margin-top:4px}.row--dense{margin:-4px}.row--dense>.col,.row--dense>[class*=col-]{padding:4px}.no-gutters{margin:0}.no-gutters>.col,.no-gutters>[class*=col-]{padding:0}.col,.col-1,.col-2,.col-3,.col-4,.col-5,.col-6,.col-7,.col-8,.col-9,.col-10,.col-11,.col-12,.col-auto,.col-lg,.col-lg-1,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-lg-10,.col-lg-11,.col-lg-12,.col-lg-auto,.col-md,.col-md-1,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-md-10,.col-md-11,.col-md-12,.col-md-auto,.col-sm,.col-sm-1,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-sm-10,.col-sm-11,.col-sm-12,.col-sm-auto,.col-xl,.col-xl-1,.col-xl-2,.col-xl-3,.col-xl-4,.col-xl-5,.col-xl-6,.col-xl-7,.col-xl-8,.col-xl-9,.col-xl-10,.col-xl-11,.col-xl-12,.col-xl-auto{width:100%;padding:12px}.col{flex-basis:0;flex-grow:1;max-width:100%}.col-auto{flex:0 0 auto;width:auto;max-width:100%}.col-1{flex:0 0 8.3333333333%;max-width:8.3333333333%}.col-2{flex:0 0 16.6666666667%;max-width:16.6666666667%}.col-3{flex:0 0 25%;max-width:25%}.col-4{flex:0 0 33.3333333333%;max-width:33.3333333333%}.col-5{flex:0 0 41.6666666667%;max-width:41.6666666667%}.col-6{flex:0 0 50%;max-width:50%}.col-7{flex:0 0 58.3333333333%;max-width:58.3333333333%}.col-8{flex:0 0 66.6666666667%;max-width:66.6666666667%}.col-9{flex:0 0 75%;max-width:75%}.col-10{flex:0 0 83.3333333333%;max-width:83.3333333333%}.col-11{flex:0 0 91.6666666667%;max-width:91.6666666667%}.col-12{flex:0 0 100%;max-width:100%}.v-application--is-ltr .offset-1{margin-left:8.3333333333%}.v-application--is-rtl .offset-1{margin-right:8.3333333333%}.v-application--is-ltr .offset-2{margin-left:16.6666666667%}.v-application--is-rtl .offset-2{margin-right:16.6666666667%}.v-application--is-ltr .offset-3{margin-left:25%}.v-application--is-rtl .offset-3{margin-right:25%}.v-application--is-ltr .offset-4{margin-left:33.3333333333%}.v-application--is-rtl .offset-4{margin-right:33.3333333333%}.v-application--is-ltr .offset-5{margin-left:41.6666666667%}.v-application--is-rtl .offset-5{margin-right:41.6666666667%}.v-application--is-ltr .offset-6{margin-left:50%}.v-application--is-rtl .offset-6{margin-right:50%}.v-application--is-ltr .offset-7{margin-left:58.3333333333%}.v-application--is-rtl .offset-7{margin-right:58.3333333333%}.v-application--is-ltr .offset-8{margin-left:66.6666666667%}.v-application--is-rtl .offset-8{margin-right:66.6666666667%}.v-application--is-ltr .offset-9{margin-left:75%}.v-application--is-rtl .offset-9{margin-right:75%}.v-application--is-ltr .offset-10{margin-left:83.3333333333%}.v-application--is-rtl .offset-10{margin-right:83.3333333333%}.v-application--is-ltr .offset-11{margin-left:91.6666666667%}.v-application--is-rtl .offset-11{margin-right:91.6666666667%}@media(min-width:600px){.col-sm{flex-basis:0;flex-grow:1;max-width:100%}.col-sm-auto{flex:0 0 auto;width:auto;max-width:100%}.col-sm-1{flex:0 0 8.3333333333%;max-width:8.3333333333%}.col-sm-2{flex:0 0 16.6666666667%;max-width:16.6666666667%}.col-sm-3{flex:0 0 25%;max-width:25%}.col-sm-4{flex:0 0 33.3333333333%;max-width:33.3333333333%}.col-sm-5{flex:0 0 41.6666666667%;max-width:41.6666666667%}.col-sm-6{flex:0 0 50%;max-width:50%}.col-sm-7{flex:0 0 58.3333333333%;max-width:58.3333333333%}.col-sm-8{flex:0 0 66.6666666667%;max-width:66.6666666667%}.col-sm-9{flex:0 0 75%;max-width:75%}.col-sm-10{flex:0 0 83.3333333333%;max-width:83.3333333333%}.col-sm-11{flex:0 0 91.6666666667%;max-width:91.6666666667%}.col-sm-12{flex:0 0 100%;max-width:100%}.v-application--is-ltr .offset-sm-0{margin-left:0}.v-application--is-rtl .offset-sm-0{margin-right:0}.v-application--is-ltr .offset-sm-1{margin-left:8.3333333333%}.v-application--is-rtl .offset-sm-1{margin-right:8.3333333333%}.v-application--is-ltr .offset-sm-2{margin-left:16.6666666667%}.v-application--is-rtl .offset-sm-2{margin-right:16.6666666667%}.v-application--is-ltr .offset-sm-3{margin-left:25%}.v-application--is-rtl .offset-sm-3{margin-right:25%}.v-application--is-ltr .offset-sm-4{margin-left:33.3333333333%}.v-application--is-rtl .offset-sm-4{margin-right:33.3333333333%}.v-application--is-ltr .offset-sm-5{margin-left:41.6666666667%}.v-application--is-rtl .offset-sm-5{margin-right:41.6666666667%}.v-application--is-ltr .offset-sm-6{margin-left:50%}.v-application--is-rtl .offset-sm-6{margin-right:50%}.v-application--is-ltr .offset-sm-7{margin-left:58.3333333333%}.v-application--is-rtl .offset-sm-7{margin-right:58.3333333333%}.v-application--is-ltr .offset-sm-8{margin-left:66.6666666667%}.v-application--is-rtl .offset-sm-8{margin-right:66.6666666667%}.v-application--is-ltr .offset-sm-9{margin-left:75%}.v-application--is-rtl .offset-sm-9{margin-right:75%}.v-application--is-ltr .offset-sm-10{margin-left:83.3333333333%}.v-application--is-rtl .offset-sm-10{margin-right:83.3333333333%}.v-application--is-ltr .offset-sm-11{margin-left:91.6666666667%}.v-application--is-rtl .offset-sm-11{margin-right:91.6666666667%}}@media(min-width:960px){.col-md{flex-basis:0;flex-grow:1;max-width:100%}.col-md-auto{flex:0 0 auto;width:auto;max-width:100%}.col-md-1{flex:0 0 8.3333333333%;max-width:8.3333333333%}.col-md-2{flex:0 0 16.6666666667%;max-width:16.6666666667%}.col-md-3{flex:0 0 25%;max-width:25%}.col-md-4{flex:0 0 33.3333333333%;max-width:33.3333333333%}.col-md-5{flex:0 0 41.6666666667%;max-width:41.6666666667%}.col-md-6{flex:0 0 50%;max-width:50%}.col-md-7{flex:0 0 58.3333333333%;max-width:58.3333333333%}.col-md-8{flex:0 0 66.6666666667%;max-width:66.6666666667%}.col-md-9{flex:0 0 75%;max-width:75%}.col-md-10{flex:0 0 83.3333333333%;max-width:83.3333333333%}.col-md-11{flex:0 0 91.6666666667%;max-width:91.6666666667%}.col-md-12{flex:0 0 100%;max-width:100%}.v-application--is-ltr .offset-md-0{margin-left:0}.v-application--is-rtl .offset-md-0{margin-right:0}.v-application--is-ltr .offset-md-1{margin-left:8.3333333333%}.v-application--is-rtl .offset-md-1{margin-right:8.3333333333%}.v-application--is-ltr .offset-md-2{margin-left:16.6666666667%}.v-application--is-rtl .offset-md-2{margin-right:16.6666666667%}.v-application--is-ltr .offset-md-3{margin-left:25%}.v-application--is-rtl .offset-md-3{margin-right:25%}.v-application--is-ltr .offset-md-4{margin-left:33.3333333333%}.v-application--is-rtl .offset-md-4{margin-right:33.3333333333%}.v-application--is-ltr .offset-md-5{margin-left:41.6666666667%}.v-application--is-rtl .offset-md-5{margin-right:41.6666666667%}.v-application--is-ltr .offset-md-6{margin-left:50%}.v-application--is-rtl .offset-md-6{margin-right:50%}.v-application--is-ltr .offset-md-7{margin-left:58.3333333333%}.v-application--is-rtl .offset-md-7{margin-right:58.3333333333%}.v-application--is-ltr .offset-md-8{margin-left:66.6666666667%}.v-application--is-rtl .offset-md-8{margin-right:66.6666666667%}.v-application--is-ltr .offset-md-9{margin-left:75%}.v-application--is-rtl .offset-md-9{margin-right:75%}.v-application--is-ltr .offset-md-10{margin-left:83.3333333333%}.v-application--is-rtl .offset-md-10{margin-right:83.3333333333%}.v-application--is-ltr .offset-md-11{margin-left:91.6666666667%}.v-application--is-rtl .offset-md-11{margin-right:91.6666666667%}}@media(min-width:1264px){.col-lg{flex-basis:0;flex-grow:1;max-width:100%}.col-lg-auto{flex:0 0 auto;width:auto;max-width:100%}.col-lg-1{flex:0 0 8.3333333333%;max-width:8.3333333333%}.col-lg-2{flex:0 0 16.6666666667%;max-width:16.6666666667%}.col-lg-3{flex:0 0 25%;max-width:25%}.col-lg-4{flex:0 0 33.3333333333%;max-width:33.3333333333%}.col-lg-5{flex:0 0 41.6666666667%;max-width:41.6666666667%}.col-lg-6{flex:0 0 50%;max-width:50%}.col-lg-7{flex:0 0 58.3333333333%;max-width:58.3333333333%}.col-lg-8{flex:0 0 66.6666666667%;max-width:66.6666666667%}.col-lg-9{flex:0 0 75%;max-width:75%}.col-lg-10{flex:0 0 83.3333333333%;max-width:83.3333333333%}.col-lg-11{flex:0 0 91.6666666667%;max-width:91.6666666667%}.col-lg-12{flex:0 0 100%;max-width:100%}.v-application--is-ltr .offset-lg-0{margin-left:0}.v-application--is-rtl .offset-lg-0{margin-right:0}.v-application--is-ltr .offset-lg-1{margin-left:8.3333333333%}.v-application--is-rtl .offset-lg-1{margin-right:8.3333333333%}.v-application--is-ltr .offset-lg-2{margin-left:16.6666666667%}.v-application--is-rtl .offset-lg-2{margin-right:16.6666666667%}.v-application--is-ltr .offset-lg-3{margin-left:25%}.v-application--is-rtl .offset-lg-3{margin-right:25%}.v-application--is-ltr .offset-lg-4{margin-left:33.3333333333%}.v-application--is-rtl .offset-lg-4{margin-right:33.3333333333%}.v-application--is-ltr .offset-lg-5{margin-left:41.6666666667%}.v-application--is-rtl .offset-lg-5{margin-right:41.6666666667%}.v-application--is-ltr .offset-lg-6{margin-left:50%}.v-application--is-rtl .offset-lg-6{margin-right:50%}.v-application--is-ltr .offset-lg-7{margin-left:58.3333333333%}.v-application--is-rtl .offset-lg-7{margin-right:58.3333333333%}.v-application--is-ltr .offset-lg-8{margin-left:66.6666666667%}.v-application--is-rtl .offset-lg-8{margin-right:66.6666666667%}.v-application--is-ltr .offset-lg-9{margin-left:75%}.v-application--is-rtl .offset-lg-9{margin-right:75%}.v-application--is-ltr .offset-lg-10{margin-left:83.3333333333%}.v-application--is-rtl .offset-lg-10{margin-right:83.3333333333%}.v-application--is-ltr .offset-lg-11{margin-left:91.6666666667%}.v-application--is-rtl .offset-lg-11{margin-right:91.6666666667%}}@media(min-width:1904px){.col-xl{flex-basis:0;flex-grow:1;max-width:100%}.col-xl-auto{flex:0 0 auto;width:auto;max-width:100%}.col-xl-1{flex:0 0 8.3333333333%;max-width:8.3333333333%}.col-xl-2{flex:0 0 16.6666666667%;max-width:16.6666666667%}.col-xl-3{flex:0 0 25%;max-width:25%}.col-xl-4{flex:0 0 33.3333333333%;max-width:33.3333333333%}.col-xl-5{flex:0 0 41.6666666667%;max-width:41.6666666667%}.col-xl-6{flex:0 0 50%;max-width:50%}.col-xl-7{flex:0 0 58.3333333333%;max-width:58.3333333333%}.col-xl-8{flex:0 0 66.6666666667%;max-width:66.6666666667%}.col-xl-9{flex:0 0 75%;max-width:75%}.col-xl-10{flex:0 0 83.3333333333%;max-width:83.3333333333%}.col-xl-11{flex:0 0 91.6666666667%;max-width:91.6666666667%}.col-xl-12{flex:0 0 100%;max-width:100%}.v-application--is-ltr .offset-xl-0{margin-left:0}.v-application--is-rtl .offset-xl-0{margin-right:0}.v-application--is-ltr .offset-xl-1{margin-left:8.3333333333%}.v-application--is-rtl .offset-xl-1{margin-right:8.3333333333%}.v-application--is-ltr .offset-xl-2{margin-left:16.6666666667%}.v-application--is-rtl .offset-xl-2{margin-right:16.6666666667%}.v-application--is-ltr .offset-xl-3{margin-left:25%}.v-application--is-rtl .offset-xl-3{margin-right:25%}.v-application--is-ltr .offset-xl-4{margin-left:33.3333333333%}.v-application--is-rtl .offset-xl-4{margin-right:33.3333333333%}.v-application--is-ltr .offset-xl-5{margin-left:41.6666666667%}.v-application--is-rtl .offset-xl-5{margin-right:41.6666666667%}.v-application--is-ltr .offset-xl-6{margin-left:50%}.v-application--is-rtl .offset-xl-6{margin-right:50%}.v-application--is-ltr .offset-xl-7{margin-left:58.3333333333%}.v-application--is-rtl .offset-xl-7{margin-right:58.3333333333%}.v-application--is-ltr .offset-xl-8{margin-left:66.6666666667%}.v-application--is-rtl .offset-xl-8{margin-right:66.6666666667%}.v-application--is-ltr .offset-xl-9{margin-left:75%}.v-application--is-rtl .offset-xl-9{margin-right:75%}.v-application--is-ltr .offset-xl-10{margin-left:83.3333333333%}.v-application--is-rtl .offset-xl-10{margin-right:83.3333333333%}.v-application--is-ltr .offset-xl-11{margin-left:91.6666666667%}.v-application--is-rtl .offset-xl-11{margin-right:91.6666666667%}}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "4399":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("c8d5")

/**
 * @category Quarter Helpers
 * @summary Return the start of a year quarter for the given date.
 *
 * @description
 * Return the start of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of a quarter
 *
 * @example
 * // The start of a quarter for 2 September 2014 11:55:00:
 * var result = startOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Jul 01 2014 00:00:00
 */
function startOfQuarter (dirtyDate) {
  var date = parse(dirtyDate)
  var currentMonth = date.getMonth()
  var month = currentMonth - currentMonth % 3
  date.setMonth(month, 1)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = startOfQuarter


/***/ }),

/***/ "4400":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M10.4762 1C5.22476 1 0.952381 5.037 0.952381 10C0.952381 11.735 1.46762 13.392 2.45048 14.836L0.443483 18.2464C0.247329 18.5797 0.487651 19 0.874401 19H10.4762C15.7276 19 20 14.963 20 10C20 5.037 15.7276 1 10.4762 1Z\" fill=\"#DFE4E5\"></path><path d=\"M3.31231 15.3432L3.63367 14.7971L3.27715 14.2733C2.40576 12.9931 1.95238 11.5317 1.95238 10C1.95238 5.64186 5.72296 2 10.4762 2C15.2294 2 19 5.64186 19 10C19 14.3581 15.2294 18 10.4762 18H1.7488L3.31231 15.3432Z\" stroke=\"#688083\" stroke-width=\"2\"></path><path d=\"M15.0952 7C19.559 7 23.1905 10.5884 23.1905 15C23.1905 16.5422 22.7525 18.0151 21.9171 19.2987L24 23H15.0952C10.6315 23 7 19.4116 7 15C7 10.5884 10.6315 7 15.0952 7Z\" fill=\"white\"></path><path d=\"M21.0456 19.7891L20.7484 19.261L21.079 18.7532C21.8086 17.6322 22.1905 16.3489 22.1905 15C22.1905 11.1519 19.0179 8 15.0952 8C11.1726 8 8 11.1519 8 15C8 18.8481 11.1726 22 15.0952 22H22.2898L21.0456 19.7891Z\" stroke=\"#688083\" stroke-width=\"2\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M17 15C17 15.5523 17.4477 16 18 16C18.5523 16 19 15.5523 19 15C19 14.4477 18.5523 14 18 14C17.4477 14 17 14.4477 17 15ZM14 15C14 15.5523 14.4477 16 15 16C15.5523 16 16 15.5523 16 15C16 14.4477 15.5523 14 15 14C14.4477 14 14 14.4477 14 15ZM12 16C11.4477 16 11 15.5523 11 15C11 14.4477 11.4477 14 12 14C12.5523 14 13 14.4477 13 15C13 15.5523 12.5523 16 12 16Z\" fill=\"#688083\"></path></svg>";

/***/ }),

/***/ "448d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpInputMultiselect_vue_vue_type_style_index_0_id_3a33170c_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("b71b");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpInputMultiselect_vue_vue_type_style_index_0_id_3a33170c_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpInputMultiselect_vue_vue_type_style_index_0_id_3a33170c_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "4497":
/***/ (function(module, exports, __webpack_require__) {

var getISOYear = __webpack_require__("8964")
var startOfISOWeek = __webpack_require__("b4c7")

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the start of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the start of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of an ISO year
 *
 * @example
 * // The start of an ISO week-numbering year for 2 July 2005:
 * var result = startOfISOYear(new Date(2005, 6, 2))
 * //=> Mon Jan 03 2005 00:00:00
 */
function startOfISOYear (dirtyDate) {
  var year = getISOYear(dirtyDate)
  var fourthOfJanuary = new Date(0)
  fourthOfJanuary.setFullYear(year, 0, 4)
  fourthOfJanuary.setHours(0, 0, 0, 0)
  var date = startOfISOWeek(fourthOfJanuary)
  return date
}

module.exports = startOfISOYear


/***/ }),

/***/ "44ad":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");
var classof = __webpack_require__("c6b6");

var split = ''.split;

// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins
  return !Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) == 'String' ? split.call(it, '') : Object(it);
} : Object;


/***/ }),

/***/ "44d2":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");
var create = __webpack_require__("7c73");
var definePropertyModule = __webpack_require__("9bf2");

var UNSCOPABLES = wellKnownSymbol('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] == undefined) {
  definePropertyModule.f(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: create(null)
  });
}

// add a key to Array.prototype[@@unscopables]
module.exports = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};


/***/ }),

/***/ "44de":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");

module.exports = function (a, b) {
  var console = global.console;
  if (console && console.error) {
    arguments.length === 1 ? console.error(a) : console.error(a, b);
  }
};


/***/ }),

/***/ "44e7":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");
var classof = __webpack_require__("c6b6");
var wellKnownSymbol = __webpack_require__("b622");

var MATCH = wellKnownSymbol('match');

// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : classof(it) == 'RegExp');
};


/***/ }),

/***/ "45a3":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.theme--light.v-counter{color:var(--pp-text-secondary,#2b2b2b)}.theme--dark.v-counter{color:hsla(0,0%,100%,.7)}.v-counter{flex:0 1 auto;font-size:12px;min-height:12px;line-height:12px}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "45fc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $some = __webpack_require__("b727").some;
var arrayMethodIsStrict = __webpack_require__("a640");
var arrayMethodUsesToLength = __webpack_require__("ae40");

var STRICT_METHOD = arrayMethodIsStrict('some');
var USES_TO_LENGTH = arrayMethodUsesToLength('some');

// `Array.prototype.some` method
// https://tc39.es/ecma262/#sec-array.prototype.some
$({ target: 'Array', proto: true, forced: !STRICT_METHOD || !USES_TO_LENGTH }, {
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "463f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PORTAL_SETTINGS_OPEN; });
var PORTAL_SETTINGS_OPEN = 'portal-settings-open';

/***/ }),

/***/ "466d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fixRegExpWellKnownSymbolLogic = __webpack_require__("d784");
var anObject = __webpack_require__("825a");
var toLength = __webpack_require__("50c4");
var requireObjectCoercible = __webpack_require__("1d80");
var advanceStringIndex = __webpack_require__("8aa5");
var regExpExec = __webpack_require__("14c3");

// @@match logic
fixRegExpWellKnownSymbolLogic('match', 1, function (MATCH, nativeMatch, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.es/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = requireObjectCoercible(this);
      var matcher = regexp == undefined ? undefined : regexp[MATCH];
      return matcher !== undefined ? matcher.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@match
    function (regexp) {
      var res = maybeCallNative(nativeMatch, regexp, this);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);

      if (!rx.global) return regExpExec(rx, S);

      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = String(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});


/***/ }),

/***/ "4736":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("d9f0");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("3d80b0f0", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "4748":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c662cfac-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/shortcut/menu/PpShortcutMenu.vue?vue&type=template&id=3e08c342&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pp-shortcut-container"},[_c('v-menu',{ref:"shortcutMenu",attrs:{"attach":_vm.attach,"close-on-click":!_vm.showEditShortcutDialog && !_vm.showConfirmDeleteDialog,"close-on-content-click":false,"content-class":("pp-shortcut-menu " + (_vm.loading ? 'pp-shortcut-menu--loading' : '')),"disable-keys":true,"max-height":375,"max-width":375,"min-width":375,"offset-y":"","top":"","z-index":"20"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('pp-tooltip',{attrs:{"nudge-right":"30","position":"top","text":"Shortcuts"}},[_c('pp-button',_vm._g(_vm._b({staticClass:"rounded rounded-r-0 pp-shortcut-menu-btn white--text align-end pb-2 text-h4",attrs:{"icon":"bolt","type":"primary"}},'pp-button',attrs,false),on))],1)]}}]),model:{value:(_vm.showShortcutsMenu),callback:function ($$v) {_vm.showShortcutsMenu=$$v},expression:"showShortcutsMenu"}},[(_vm.loading)?[_c('v-skeleton-loader',{attrs:{"type":"list-item-two-line@3"}})]:[_c('v-list',[_c('h3',{staticClass:"text-h5 pl-5 py-1 d-flex align-center shortcuts-heading"},[_c('i',{staticClass:"pp-icon-bolt d-inline-flex pr-2"}),_vm._v(" Shortcuts ")]),_c('v-list-item-group',{model:{value:(_vm.selectedSystemShortcut),callback:function ($$v) {_vm.selectedSystemShortcut=$$v},expression:"selectedSystemShortcut"}},_vm._l((_vm.systemShortcuts),function(shortcut,i){return _c('v-list-item',{key:i,attrs:{"data-shortcut-index":i},on:{"click":function($event){return _vm.itemClicked(shortcut)}}},[_c('v-list-item-content',{staticClass:"pl-5 py-2"},[_c('i',{staticClass:"mb-0 flex-shrink-1 flex-grow-0 flex-fill pr-3",class:("pp-icon-" + (shortcut.icon ? shortcut.icon : 'message'))}),_c('div',{staticClass:"text-h6 font-weight-bold flex-fill"},[_vm._v(" "+_vm._s(shortcut.title)+" ")])])],1)}),1),_c('v-list-item-group',{model:{value:(_vm.selectedCustomShortcut),callback:function ($$v) {_vm.selectedCustomShortcut=$$v},expression:"selectedCustomShortcut"}},[_c('div',{staticClass:"text-subtitle-1 text--grey text--darken-2 my-1 pl-5 pr-2 grey--text text-uppercase"},[_vm._v(" Custom Shortcuts "),_c('button',{staticClass:"primary--text float-right",attrs:{"role":"button"},on:{"click":_vm.addShortcut}},[_vm._v(" Add ")])]),_vm._l((_vm.customShortcuts),function(shortcut,i){return _c('v-list-item',{key:i,attrs:{"data-editable":true,"data-shortcut-index":shortcut.id},on:{"click":function($event){return _vm.itemClicked(shortcut)}}},[_c('v-list-item-content',[_c('pp-drop-down-button',{ref:("action" + i),refInFor:true,attrs:{"dense":true,"items":_vm.shortcutActions,"main-button-icon":shortcut.icon ? shortcut.icon : 'message',"nudge-bottom":0,"text":shortcut.title,"secondary-button-icon":"more","type":"tertiary"},on:{"item-clicked":function($event){return _vm.handleShortcutAction($event, shortcut)}},model:{value:(_vm.showShortcutActions[i]),callback:function ($$v) {_vm.$set(_vm.showShortcutActions, i, $$v)},expression:"showShortcutActions[i]"}})],1)],1)})],2)],1)]],2),_c('pp-shortcut-edit',{attrs:{"custom-error-messages":_vm.customErrorMessages,"saving":_vm.saving,"shortcut":_vm.chosenShortcut},on:{"save":_vm.saveShortcut},model:{value:(_vm.showEditShortcutDialog),callback:function ($$v) {_vm.showEditShortcutDialog=$$v},expression:"showEditShortcutDialog"}}),_c('pp-shortcut-delete',{on:{"delete":_vm.confirmDelete},model:{value:(_vm.showConfirmDeleteDialog),callback:function ($$v) {_vm.showConfirmDeleteDialog=$$v},expression:"showConfirmDeleteDialog"}})],1)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/shortcut/menu/PpShortcutMenu.vue?vue&type=template&id=3e08c342&scoped=true&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("4de4");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("4160");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("b64b");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.values.js
var es_object_values = __webpack_require__("07ac");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("159b");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("ade3");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__("5530");

// EXTERNAL MODULE: ./src/components/drop-down-button/PpDropDownButton.vue + 4 modules
var PpDropDownButton = __webpack_require__("ae8e");

// EXTERNAL MODULE: ./src/components/button/PpButton.vue + 5 modules
var PpButton = __webpack_require__("251c");

// EXTERNAL MODULE: ./src/components/tooltip/PpTooltip.vue + 6 modules
var PpTooltip = __webpack_require__("284e");

// EXTERNAL MODULE: ./src/components/shortcut/edit/PpShortcutEdit.vue + 4 modules
var PpShortcutEdit = __webpack_require__("234b");

// EXTERNAL MODULE: ./src/components/shortcut/delete/PpShortcutDelete.vue + 4 modules
var PpShortcutDelete = __webpack_require__("4ce4");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/shortcut/menu/PpShortcutMenu.vue?vue&type=script&lang=js&







//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var PpShortcutMenuvue_type_script_lang_js_ = ({
  name: 'PpShortcutMenu',
  components: {
    'pp-button': PpButton["default"],
    'pp-drop-down-button': PpDropDownButton["default"],
    'pp-tooltip': PpTooltip["default"],
    'pp-shortcut-edit': PpShortcutEdit["default"],
    'pp-shortcut-delete': PpShortcutDelete["default"]
  },
  props: {
    /** If set will show skeleton loader **/
    loading: {
      type: Boolean,
      default: false
    },

    /** System Shortcuts - array of objects with format {title, icon, content} **/
    systemShortcuts: {
      type: Array,
      default: function _default() {
        return [];
      }
    },

    /** Custom Shortcuts - array of objects with format {title, icon, content}
     * these will be editable and show the edit actions **/
    customShortcuts: {
      type: Object,
      default: function _default() {
        return {};
      }
    },

    /** Passes down value to dialogs to show saving state **/
    saving: {
      type: Boolean,
      default: false
    },

    /** Passes down custom error message to saving modal **/
    customErrorMessages: {
      type: String,
      default: ''
    },

    /** attach the dialogs to specific element eg .pp-composer (used to make sure dialogs show correctly) **/
    attach: {
      type: [String, Boolean],
      default: false
    }
  },
  data: function data() {
    return {
      showShortcutsMenu: false,
      showEditShortcutDialog: false,
      showConfirmDeleteDialog: false,
      chosenShortcut: {
        id: null,
        title: null,
        content: null
      },
      shortcutActions: [{
        id: 'edit',
        title: 'Edit',
        icon: 'edit'
      }, {
        id: 'delete',
        title: 'Delete',
        icon: 'delete',
        caution: true
      }],
      showShortcutActions: {},
      selectedSystemShortcut: null,
      selectedCustomShortcut: null,
      dialogWasShown: false
    };
  },
  computed: {
    shortcutInFocus: function shortcutInFocus() {
      return this.$refs.shortcutMenu.tiles[this.$refs.shortcutMenu.listIndex];
    }
  },
  watch: {
    systemShortcuts: {
      deep: true,
      handler: function handler() {
        // when changed due to delete/add then update the size of the menu
        this.$refs.shortcutMenu.updateDimensions();
      }
    },
    customShortcuts: {
      deep: true,
      handler: function handler() {
        // when changed due to delete/add then update the size of the menu
        this.$refs.shortcutMenu.updateDimensions(); // update the show actions

        this.setupShowActions();
      }
    },
    showShortcutsMenu: {
      handler: function handler(val) {
        var _this = this;

        this.$ppAnalytics.trackEvent({
          category: 'shortcuts',
          action: 'menu',
          label: val ? 'show' : 'hide'
        });

        if (val) {
          this.$nextTick(function () {
            _this.$refs.shortcutMenu.getTiles(); // reset the selections


            _this.selectedSystemShortcut = null;
            _this.selectedCustomShortcut = null;
            _this.$refs.shortcutMenu.listIndex = -1;
          });
        }
      }
    },
    showShortcutActions: {
      deep: true,
      handler: function handler(val) {
        // if any of the shortcut action menus are shown
        // (need to check that only one is set to true)
        if (Object.values(val) && Object.values(val).filter(function (e) {
          return e === true;
        }).length === 1) {
          this.$ppAnalytics.trackEvent({
            category: 'shortcuts',
            action: 'actions',
            label: 'show'
          });
        }
      }
    }
  },
  created: function created() {
    // for keyboard controls, we need to handle separate to vuetify
    window.addEventListener('keydown', this.onKeyDown);
    this.setupShowActions();
  },
  destroyed: function destroyed() {
    window.removeEventListener('keydown', this.onKeyDown);
  },
  methods: {
    // set up for hide/show controls for custom shortcut action - used in keyboard navigation
    setupShowActions: function setupShowActions() {
      var _this2 = this;

      // for custom shortcuts
      Object.keys(this.customShortcuts).forEach(function (id) {
        if (!_this2.showShortcutActions[id]) {
          _this2.showShortcutActions = Object(objectSpread2["a" /* default */])(Object(objectSpread2["a" /* default */])({}, _this2.showShortcutActions), {}, Object(defineProperty["a" /* default */])({}, id, false));
        }
      });
    },
    itemClicked: function itemClicked(item) {
      this.$emit('insert', item);
      this.showShortcutsMenu = false;
    },
    handleShortcutAction: function handleShortcutAction(event, shortcut) {
      this.chosenShortcut = shortcut;

      if (event === 'edit') {
        this.editShortcut(shortcut);
      } else if (event === 'delete') {
        this.deleteShortcut(shortcut);
      }
    },
    showEditCreateDialog: function showEditCreateDialog() {
      this.dialogWasShown = true;
      this.showEditShortcutDialog = true;
    },
    addShortcut: function addShortcut() {
      this.$ppAnalytics.trackEvent({
        category: 'shortcuts',
        action: 'add',
        label: 'show'
      });
      this.chosenShortcut = {
        id: null,
        title: null,
        content: null
      };
      this.showEditCreateDialog();
    },
    editShortcut: function editShortcut() {
      this.$ppAnalytics.trackEvent({
        category: 'shortcuts',
        action: 'edit',
        label: 'show'
      });
      this.showEditCreateDialog();
    },
    saveShortcut: function saveShortcut(shortcut) {
      this.$emit('save', shortcut);
    },
    deleteShortcut: function deleteShortcut() {
      this.$ppAnalytics.trackEvent({
        category: 'shortcuts',
        action: 'delete',
        label: 'show'
      });
      this.showConfirmDeleteDialog = true;
    },
    confirmDelete: function confirmDelete() {
      this.$emit('delete', this.chosenShortcut);
      this.showConfirmDeleteDialog = false;
    },
    // keyboard navigation
    onKeyDown: function onKeyDown(e) {
      var shortcutInFocus, isShortcutEditable, shortcutIndex;

      if (this.shortcutInFocus) {
        shortcutInFocus = this.shortcutInFocus;
        isShortcutEditable = shortcutInFocus.dataset.editable;
        shortcutIndex = shortcutInFocus.dataset.shortcutIndex;
      } // close the shortcuts menu / actions menu  / dialogs on esc


      if (e.code === 'Escape' && this.showShortcutsMenu) {
        if (this.showEditShortcutDialog) {
          this.showEditShortcutDialog = false;
          this.$ppAnalytics.trackEvent({
            category: 'shortcuts-keyboard-nav',
            action: 'edit',
            label: 'esc'
          });
        } else if (this.showConfirmDeleteDialog) {
          this.showConfirmDeleteDialog = false;
          this.$ppAnalytics.trackEvent({
            category: 'shortcuts-keyboard-nav',
            action: 'delete',
            label: 'esc'
          });
        } else if (shortcutInFocus && isShortcutEditable && this.showShortcutActions[shortcutIndex]) {
          this.showShortcutActions[shortcutIndex] = false;
          this.$ppAnalytics.trackEvent({
            category: 'shortcuts-keyboard-nav',
            action: 'actions-menu',
            label: 'esc'
          });
        } else {
          this.showShortcutsMenu = false;
          this.$ppAnalytics.trackEvent({
            category: 'shortcuts-keyboard-nav',
            action: 'shortcuts-menu',
            label: 'esc'
          });
        }
      } // if there is an element in focus use left/right arrow to open/close actions


      if (shortcutInFocus && isShortcutEditable) {
        if (e.code === 'ArrowRight') {
          this.showShortcutActions[shortcutIndex] = true;
          this.$ppAnalytics.trackEvent({
            category: 'shortcuts-keyboard-nav',
            action: 'actions-menu',
            label: 'right'
          });
        }

        if (e.code === 'ArrowLeft') {
          this.showShortcutActions[shortcutIndex] = false;
          this.$ppAnalytics.trackEvent({
            category: 'shortcuts-keyboard-nav',
            action: 'actions-menu',
            label: 'left'
          });
        }
      } // on down arrow press


      if (e.code === 'ArrowDown' && this.showShortcutsMenu) {
        // if there is shortcut actions menu open then navigate the actions menu
        if (shortcutInFocus && this.showShortcutActions[shortcutIndex]) {
          this.$refs["action".concat(shortcutIndex)][0].$refs.menu.getTiles();
          this.$refs["action".concat(shortcutIndex)][0].$refs.menu.nextTile();
          this.$ppAnalytics.trackEvent({
            category: 'shortcuts-keyboard-nav',
            action: 'actions-menu',
            label: 'down'
          });
        } else {
          // otherwise navigate the shortcuts menu
          this.$refs.shortcutMenu.getTiles();
          this.$refs.shortcutMenu.nextTile();
          this.$ppAnalytics.trackEvent({
            category: 'shortcuts-keyboard-nav',
            action: 'shortcuts-menu',
            label: 'down'
          });
        }
      } // on arrow up press


      if (e.code === 'ArrowUp' && this.showShortcutsMenu) {
        // if there is shortcut actions menu open then navigate the actions menu
        if (shortcutInFocus && this.showShortcutActions[shortcutIndex]) {
          this.$refs["action".concat(shortcutIndex)][0].$refs.menu.getTiles();
          this.$refs["action".concat(shortcutIndex)][0].$refs.menu.prevTile();
          this.$ppAnalytics.trackEvent({
            category: 'shortcuts-keyboard-nav',
            action: 'actions-menu',
            label: 'up'
          });
        } else {
          // otherwise navigate the shortcuts menu
          this.$refs.shortcutMenu.getTiles();
          this.$refs.shortcutMenu.prevTile();
          this.$ppAnalytics.trackEvent({
            category: 'shortcuts-keyboard-nav',
            action: 'shortcuts-menu',
            label: 'up'
          });
        }
      } // on enter press and there is a shortcut in focus


      if (e.code === 'Enter' && shortcutInFocus) {
        // if no action menu open then click that
        if (!this.showShortcutActions[shortcutIndex]) {
          this.$refs.shortcutMenu.tiles[this.$refs.shortcutMenu.listIndex].click();
          this.$ppAnalytics.trackEvent({
            category: 'shortcuts-keyboard-nav',
            action: 'shortcuts-menu',
            label: 'select'
          });
        } else if (this.$refs["action".concat(shortcutIndex)][0].$refs.menu.listIndex > -1) {
          // otherwise handle the enter click on the shortcut action menu
          var shortcut = this.customShortcuts[shortcutIndex];
          var actionChosen = this.shortcutActions[this.$refs["action".concat(shortcutIndex)][0].$refs.menu.listIndex].id;
          this.handleShortcutAction(actionChosen, shortcut);
          this.$ppAnalytics.trackEvent({
            category: 'shortcuts-keyboard-nav',
            action: 'action-menu',
            label: 'select'
          });
        }
      }
    }
  }
});
// CONCATENATED MODULE: ./src/components/shortcut/menu/PpShortcutMenu.vue?vue&type=script&lang=js&
 /* harmony default export */ var menu_PpShortcutMenuvue_type_script_lang_js_ = (PpShortcutMenuvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/shortcut/menu/PpShortcutMenu.vue?vue&type=style&index=0&id=3e08c342&lang=scss&scoped=true&
var PpShortcutMenuvue_type_style_index_0_id_3e08c342_lang_scss_scoped_true_ = __webpack_require__("892e");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// EXTERNAL MODULE: ./node_modules/vuetify-loader/lib/runtime/installComponents.js
var installComponents = __webpack_require__("6544");
var installComponents_default = /*#__PURE__*/__webpack_require__.n(installComponents);

// EXTERNAL MODULE: ./node_modules/vuetify/lib/components/VList/VList.js
var VList = __webpack_require__("8860");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/components/VList/VListItem.js
var VListItem = __webpack_require__("da13");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/components/VList/index.js + 3 modules
var components_VList = __webpack_require__("5d23");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/components/VList/VListItemGroup.js
var VListItemGroup = __webpack_require__("1baa");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/components/VMenu/VMenu.js
var VMenu = __webpack_require__("e449");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.from.js
var es_array_from = __webpack_require__("a630");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.index-of.js
var es_array_index_of = __webpack_require__("c975");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("d81d");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__("ac1f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__("3ca3");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.replace.js
var es_string_replace = __webpack_require__("5319");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.split.js
var es_string_split = __webpack_require__("1276");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__("3835");

// EXTERNAL MODULE: ./node_modules/vuetify/src/components/VSkeletonLoader/VSkeletonLoader.sass
var VSkeletonLoader = __webpack_require__("1f09");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/mixins/elevatable/index.js
var elevatable = __webpack_require__("c995");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/mixins/measurable/index.js
var measurable = __webpack_require__("24b2");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/mixins/themeable/index.js
var themeable = __webpack_require__("7560");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/util/mixins.js
var mixins = __webpack_require__("58df");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/util/helpers.js
var helpers = __webpack_require__("80d2");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VSkeletonLoader/VSkeletonLoader.js









// Styles
 // Mixins



 // Utilities



/* @vue/component */

/* harmony default export */ var VSkeletonLoader_VSkeletonLoader = (Object(mixins["a" /* default */])(elevatable["a" /* default */], measurable["a" /* default */], themeable["a" /* default */]).extend({
  name: 'VSkeletonLoader',
  props: {
    boilerplate: Boolean,
    loading: Boolean,
    tile: Boolean,
    transition: String,
    type: String,
    types: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    attrs: function attrs() {
      if (!this.isLoading) return this.$attrs;
      return !this.boilerplate ? Object(objectSpread2["a" /* default */])({
        'aria-busy': true,
        'aria-live': 'polite',
        role: 'alert'
      }, this.$attrs) : {};
    },
    classes: function classes() {
      return Object(objectSpread2["a" /* default */])(Object(objectSpread2["a" /* default */])({
        'v-skeleton-loader--boilerplate': this.boilerplate,
        'v-skeleton-loader--is-loading': this.isLoading,
        'v-skeleton-loader--tile': this.tile
      }, this.themeClasses), this.elevationClasses);
    },
    isLoading: function isLoading() {
      return !('default' in this.$scopedSlots) || this.loading;
    },
    rootTypes: function rootTypes() {
      return Object(objectSpread2["a" /* default */])({
        actions: 'button@2',
        article: 'heading, paragraph',
        avatar: 'avatar',
        button: 'button',
        card: 'image, card-heading',
        'card-avatar': 'image, list-item-avatar',
        'card-heading': 'heading',
        chip: 'chip',
        'date-picker': 'list-item, card-heading, divider, date-picker-options, date-picker-days, actions',
        'date-picker-options': 'text, avatar@2',
        'date-picker-days': 'avatar@28',
        heading: 'heading',
        image: 'image',
        'list-item': 'text',
        'list-item-avatar': 'avatar, text',
        'list-item-two-line': 'sentences',
        'list-item-avatar-two-line': 'avatar, sentences',
        'list-item-three-line': 'paragraph',
        'list-item-avatar-three-line': 'avatar, paragraph',
        paragraph: 'text@3',
        sentences: 'text@2',
        table: 'table-heading, table-thead, table-tbody, table-tfoot',
        'table-heading': 'heading, text',
        'table-thead': 'heading@6',
        'table-tbody': 'table-row-divider@6',
        'table-row-divider': 'table-row, divider',
        'table-row': 'table-cell@6',
        'table-cell': 'text',
        'table-tfoot': 'text@2, avatar@2',
        text: 'text'
      }, this.types);
    }
  },
  methods: {
    genBone: function genBone(text, children) {
      return this.$createElement('div', {
        staticClass: "v-skeleton-loader__".concat(text, " v-skeleton-loader__bone")
      }, children);
    },
    genBones: function genBones(bone) {
      var _this = this;

      // e.g. 'text@3'
      var _bone$split = bone.split('@'),
          _bone$split2 = Object(slicedToArray["a" /* default */])(_bone$split, 2),
          type = _bone$split2[0],
          length = _bone$split2[1];

      var generator = function generator() {
        return _this.genStructure(type);
      }; // Generate a length array based upon
      // value after @ in the bone string


      return Array.from({
        length: length
      }).map(generator);
    },
    // Fix type when this is merged
    // https://github.com/microsoft/TypeScript/pull/33050
    genStructure: function genStructure(type) {
      var children = [];
      type = type || this.type || '';
      var bone = this.rootTypes[type] || ''; // End of recursion, do nothing

      /* eslint-disable-next-line no-empty, brace-style */

      if (type === bone) {} // Array of values - e.g. 'heading, paragraph, text@2'
      else if (type.indexOf(',') > -1) return this.mapBones(type); // Array of values - e.g. 'paragraph@4'
        else if (type.indexOf('@') > -1) return this.genBones(type); // Array of values - e.g. 'card@2'
          else if (bone.indexOf(',') > -1) children = this.mapBones(bone); // Array of values - e.g. 'list-item@2'
            else if (bone.indexOf('@') > -1) children = this.genBones(bone); // Single value - e.g. 'card-heading'
              else if (bone) children.push(this.genStructure(bone));

      return [this.genBone(type, children)];
    },
    genSkeleton: function genSkeleton() {
      var children = [];
      if (!this.isLoading) children.push(Object(helpers["s" /* getSlot */])(this));else children.push(this.genStructure());
      /* istanbul ignore else */

      if (!this.transition) return children;
      /* istanbul ignore next */

      return this.$createElement('transition', {
        props: {
          name: this.transition
        },
        // Only show transition when
        // content has been loaded
        on: {
          afterEnter: this.resetStyles,
          beforeEnter: this.onBeforeEnter,
          beforeLeave: this.onBeforeLeave,
          leaveCancelled: this.resetStyles
        }
      }, children);
    },
    mapBones: function mapBones(bones) {
      // Remove spaces and return array of structures
      return bones.replace(/\s/g, '').split(',').map(this.genStructure);
    },
    onBeforeEnter: function onBeforeEnter(el) {
      this.resetStyles(el);
      if (!this.isLoading) return;
      el._initialStyle = {
        display: el.style.display,
        transition: el.style.transition
      };
      el.style.setProperty('transition', 'none', 'important');
    },
    onBeforeLeave: function onBeforeLeave(el) {
      el.style.setProperty('display', 'none', 'important');
    },
    resetStyles: function resetStyles(el) {
      if (!el._initialStyle) return;
      el.style.display = el._initialStyle.display || '';
      el.style.transition = el._initialStyle.transition;
      delete el._initialStyle;
    }
  },
  render: function render(h) {
    return h('div', {
      staticClass: 'v-skeleton-loader',
      attrs: this.attrs,
      on: this.$listeners,
      class: this.classes,
      style: this.isLoading ? this.measurableStyles : undefined
    }, [this.genSkeleton()]);
  }
}));
// CONCATENATED MODULE: ./src/components/shortcut/menu/PpShortcutMenu.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  menu_PpShortcutMenuvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "3e08c342",
  null
  
)

/* harmony default export */ var PpShortcutMenu = __webpack_exports__["default"] = (component.exports);

/* vuetify-loader */







installComponents_default()(component, {VList: VList["a" /* default */],VListItem: VListItem["a" /* default */],VListItemContent: components_VList["a" /* VListItemContent */],VListItemGroup: VListItemGroup["a" /* default */],VMenu: VMenu["a" /* default */],VSkeletonLoader: VSkeletonLoader_VSkeletonLoader})


/***/ }),

/***/ "4804":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("3885");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("47daea2c", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "480e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("7db0");
/* harmony import */ var core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _mixins_themeable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("7560");

// Mixins

/* @vue/component */

/* harmony default export */ __webpack_exports__["a"] = (_mixins_themeable__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].extend({
  name: 'v-theme-provider',
  props: {
    root: Boolean
  },
  computed: {
    isDark: function isDark() {
      return this.root ? this.rootIsDark : _mixins_themeable__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].options.computed.isDark.call(this);
    }
  },
  render: function render() {
    /* istanbul ignore next */
    return this.$slots.default && this.$slots.default.find(function (node) {
      return !node.isComment && node.text !== ' ';
    });
  }
}));

/***/ }),

/***/ "4820":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("bbfd");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("7e96a3be", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "4840":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("825a");
var aFunction = __webpack_require__("1c0b");
var wellKnownSymbol = __webpack_require__("b622");

var SPECIES = wellKnownSymbol('species');

// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
module.exports = function (O, defaultConstructor) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? defaultConstructor : aFunction(S);
};


/***/ }),

/***/ "487b":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M9 10H22L21.5 19L13.4715 20.5439C10.9347 21.0318 8.6077 19.023 8.71991 16.4422L9 10Z\" fill=\"white\"></path><path d=\"M3 2C2.44772 2 2 2.44772 2 3V13C2 13.5523 2.44772 14 3 14H7V11C7 9.34315 8.34315 8 10 8H18V3C18 2.44772 17.5523 2 17 2H3Z\" fill=\"#DFE4E5\"></path><path d=\"M13 13H11V15H13V13Z\" fill=\"#688083\"></path><path d=\"M16 13H14V15H16V13Z\" fill=\"#688083\"></path><path d=\"M17 13H19V15H17V13Z\" fill=\"#688083\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M17 1H3C1.89543 1 1 1.89543 1 3V13C1 14.1046 1.89543 15 3 15H7V17C7 18.5977 8.24892 19.9037 9.82373 19.9949L9.999 20L10 22.0005C10 22.1704 10.0433 22.3376 10.1258 22.4861C10.3941 22.9689 11.0029 23.1429 11.4856 22.8746L16.659 20H20C21.6569 20 23 18.6569 23 17V11C23 9.34315 21.6569 8 20 8H19V3C19 1.89543 18.1046 1 17 1ZM7 11V13H3V4.49959L8.07206 8.70142C7.41664 9.25174 7 10.0772 7 11ZM9.99663 10C9.44589 10.0018 9 10.4488 9 11V17C9 17.5301 9.41451 17.9678 9.88181 17.9958L11.998 18.0572L11.9992 20.3013L16.1407 18H20C20.5523 18 21 17.5523 21 17V11C21 10.4477 20.5523 10 20 10L9.99663 10ZM17 4.31709L12.7033 8H17V4.31709ZM15.4634 3H4.32487L9.98903 7.69234L15.4634 3Z\" fill=\"#688083\"></path></svg>";

/***/ }),

/***/ "48a6":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("c8d5")

/**
 * @category Weekday Helpers
 * @summary Is the given date Saturday?
 *
 * @description
 * Is the given date Saturday?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is Saturday
 *
 * @example
 * // Is 27 September 2014 Saturday?
 * var result = isSaturday(new Date(2014, 8, 27))
 * //=> true
 */
function isSaturday (dirtyDate) {
  return parse(dirtyDate).getDay() === 6
}

module.exports = isSaturday


/***/ }),

/***/ "48be":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpAvatarIcon_vue_vue_type_style_index_0_id_b11fa4ce_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1cc2");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpAvatarIcon_vue_vue_type_style_index_0_id_b11fa4ce_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpAvatarIcon_vue_vue_type_style_index_0_id_b11fa4ce_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "490a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("99af");
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("a9e3");
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _src_components_VProgressCircular_VProgressCircular_sass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("8d4f");
/* harmony import */ var _src_components_VProgressCircular_VProgressCircular_sass__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_src_components_VProgressCircular_VProgressCircular_sass__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _mixins_colorable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("a9ad");
/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("80d2");


// Styles
 // Mixins

 // Utils


/* @vue/component */

/* harmony default export */ __webpack_exports__["a"] = (_mixins_colorable__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].extend({
  name: 'v-progress-circular',
  props: {
    button: Boolean,
    indeterminate: Boolean,
    rotate: {
      type: [Number, String],
      default: 0
    },
    size: {
      type: [Number, String],
      default: 32
    },
    width: {
      type: [Number, String],
      default: 4
    },
    value: {
      type: [Number, String],
      default: 0
    }
  },
  data: function data() {
    return {
      radius: 20
    };
  },
  computed: {
    calculatedSize: function calculatedSize() {
      return Number(this.size) + (this.button ? 8 : 0);
    },
    circumference: function circumference() {
      return 2 * Math.PI * this.radius;
    },
    classes: function classes() {
      return {
        'v-progress-circular--indeterminate': this.indeterminate,
        'v-progress-circular--button': this.button
      };
    },
    normalizedValue: function normalizedValue() {
      if (this.value < 0) {
        return 0;
      }

      if (this.value > 100) {
        return 100;
      }

      return parseFloat(this.value);
    },
    strokeDashArray: function strokeDashArray() {
      return Math.round(this.circumference * 1000) / 1000;
    },
    strokeDashOffset: function strokeDashOffset() {
      return (100 - this.normalizedValue) / 100 * this.circumference + 'px';
    },
    strokeWidth: function strokeWidth() {
      return Number(this.width) / +this.size * this.viewBoxSize * 2;
    },
    styles: function styles() {
      return {
        height: Object(_util_helpers__WEBPACK_IMPORTED_MODULE_4__[/* convertToUnit */ "g"])(this.calculatedSize),
        width: Object(_util_helpers__WEBPACK_IMPORTED_MODULE_4__[/* convertToUnit */ "g"])(this.calculatedSize)
      };
    },
    svgStyles: function svgStyles() {
      return {
        transform: "rotate(".concat(Number(this.rotate), "deg)")
      };
    },
    viewBoxSize: function viewBoxSize() {
      return this.radius / (1 - Number(this.width) / +this.size);
    }
  },
  methods: {
    genCircle: function genCircle(name, offset) {
      return this.$createElement('circle', {
        class: "v-progress-circular__".concat(name),
        attrs: {
          fill: 'transparent',
          cx: 2 * this.viewBoxSize,
          cy: 2 * this.viewBoxSize,
          r: this.radius,
          'stroke-width': this.strokeWidth,
          'stroke-dasharray': this.strokeDashArray,
          'stroke-dashoffset': offset
        }
      });
    },
    genSvg: function genSvg() {
      var children = [this.indeterminate || this.genCircle('underlay', 0), this.genCircle('overlay', this.strokeDashOffset)];
      return this.$createElement('svg', {
        style: this.svgStyles,
        attrs: {
          xmlns: 'http://www.w3.org/2000/svg',
          viewBox: "".concat(this.viewBoxSize, " ").concat(this.viewBoxSize, " ").concat(2 * this.viewBoxSize, " ").concat(2 * this.viewBoxSize)
        }
      }, children);
    },
    genInfo: function genInfo() {
      return this.$createElement('div', {
        staticClass: 'v-progress-circular__info'
      }, this.$slots.default);
    }
  },
  render: function render(h) {
    return h('div', this.setTextColor(this.color, {
      staticClass: 'v-progress-circular',
      attrs: {
        role: 'progressbar',
        'aria-valuemin': 0,
        'aria-valuemax': 100,
        'aria-valuenow': this.indeterminate ? undefined : this.normalizedValue
      },
      class: this.classes,
      style: this.styles,
      on: this.$listeners
    }), [this.genSvg(), this.genInfo()]);
  }
}));

/***/ }),

/***/ "4930":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");

module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
  // Chrome 38 Symbol has incorrect toString conversion
  // eslint-disable-next-line no-undef
  return !String(Symbol());
});


/***/ }),

/***/ "495d":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("9220");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("e7c19d6a", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "4971":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c662cfac-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/composer/PpComposer.vue?vue&type=template&id=3ef68c2a&scoped=true&
var PpComposervue_type_template_id_3ef68c2a_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"pp-composer"},[(_vm.disabled)?_c('pp-status-banner',{staticClass:"mb-2",attrs:{"status":"error","text":"This patient has opted out of receiving further text messages from this practice"}}):(_vm.readonly)?_c('pp-status-banner',{staticClass:"mb-2",attrs:{"status":"info"},scopedSlots:_vm._u([{key:"text",fn:function(){return [_vm._v(" This conversation is read only. "),_c('a',{attrs:{"href":"https://app.kareo.com/messages-ui/#/message-center/messages/location-inbox","target":"_blank"}},[_vm._v("Go to Kareo Message Center")])]},proxy:true}])}):_c('v-form',{attrs:{"disabled":_vm.disabled},on:{"submit":function($event){$event.preventDefault();return _vm.sendMessage($event)}}},[_c('v-layout',[_c('pp-shortcut-menu',{attrs:{"custom-error-messages":_vm.savingShortcutErrorMessages,"custom-shortcuts":_vm.customShortcuts,"loading":_vm.loadingShortcuts,"saving":_vm.savingShortcut,"system-shortcuts":_vm.systemShortcuts,"attach":".pp-composer"},on:{"delete":_vm.deleteShortcut,"insert":_vm.insertShortcut,"save":_vm.saveShortcut}}),_c('pp-input-textarea',{staticClass:"flex-grow-1 mr-5 pp-composer__input",attrs:{"auto-grow":"","rows":"1","hide-details":"","placeholder":"Type something..."},on:{"focus":_vm.onFocus,"input":_vm.updateMessageValue,"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }if(!$event.shiftKey){ return null; }if($event.ctrlKey||$event.altKey||$event.metaKey){ return null; }$event.preventDefault();},"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }if($event.ctrlKey||$event.shiftKey||$event.altKey||$event.metaKey){ return null; }$event.preventDefault();return _vm.sendMessage($event)}},model:{value:(_vm.$attrs.value),callback:function ($$v) {_vm.$set(_vm.$attrs, "value", $$v)},expression:"$attrs.value"}}),_c('pp-button',{staticClass:"align-self-end pp-composer__send-btn",attrs:{"icon":"send","type":"primary"},on:{"click":_vm.clickSend}})],1)],1)],1)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/composer/PpComposer.vue?vue&type=template&id=3ef68c2a&scoped=true&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.trim.js
var es_string_trim = __webpack_require__("498a");

// EXTERNAL MODULE: ./src/components/input/textarea/PpInputTextarea.vue + 5 modules
var PpInputTextarea = __webpack_require__("d696");

// EXTERNAL MODULE: ./src/components/button/PpButton.vue + 5 modules
var PpButton = __webpack_require__("251c");

// EXTERNAL MODULE: ./src/components/status-banner/PpStatusBanner.vue + 5 modules
var PpStatusBanner = __webpack_require__("1586");

// EXTERNAL MODULE: ./src/components/shortcut/menu/PpShortcutMenu.vue + 5 modules
var PpShortcutMenu = __webpack_require__("4748");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/composer/PpComposer.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/**
 * An input field with submit button which checks for consent
 */

/* harmony default export */ var PpComposervue_type_script_lang_js_ = ({
  name: 'PpComposer',
  components: {
    'pp-shortcut-menu': PpShortcutMenu["default"],
    'pp-status-banner': PpStatusBanner["default"],
    'pp-input-textarea': PpInputTextarea["default"],
    'pp-button': PpButton["default"]
  },
  props: {
    /**
     * Disables input and send, typically used if patient has opted out of messaging
     */
    disabled: {
      type: Boolean,
      default: false
    },

    /**
     * Shows message directing user to Kareo for messaging
     */
    readonly: {
      type: Boolean,
      default: false
    },

    /** System Shortcuts - array of objects with format {title, icon, content} **/
    systemShortcuts: {
      type: Array,
      default: function _default() {
        return [];
      }
    },

    /** Custom Shortcuts - array of objects with format {title, icon, content}
     * these will be editable and show the edit actions **/
    customShortcuts: {
      type: Object,
      default: function _default() {}
    },
    savingShortcut: {
      type: Boolean,
      default: false
    },
    loadingShortcuts: {
      type: Boolean,
      default: false
    },
    savingShortcutErrorMessages: {
      type: String,
      default: ''
    }
  },
  computed: {
    message: function message() {
      return this.$attrs.value.trim();
    }
  },
  methods: {
    onFocus: function onFocus() {
      this.$emit('focus');
    },
    updateMessageValue: function updateMessageValue(event) {
      this.$emit('input', event.trim());
    },
    sendMessage: function sendMessage() {
      if (this.message && this.message !== '') {
        this.$emit('send', this.message);
      }
    },
    clickSend: function clickSend() {
      this.onFocus();
      this.sendMessage();
    },
    insertShortcut: function insertShortcut(shortcut) {
      this.$emit('input', this.$attrs.value + shortcut.content.trim());
    },
    saveShortcut: function saveShortcut(shortcut) {
      this.$emit('save-shortcut', shortcut);
    },
    deleteShortcut: function deleteShortcut(shortcut) {
      this.$emit('delete-shortcut', shortcut);
    }
  }
});
// CONCATENATED MODULE: ./src/components/composer/PpComposer.vue?vue&type=script&lang=js&
 /* harmony default export */ var composer_PpComposervue_type_script_lang_js_ = (PpComposervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/composer/PpComposer.vue?vue&type=style&index=0&id=3ef68c2a&lang=scss&scoped=true&
var PpComposervue_type_style_index_0_id_3ef68c2a_lang_scss_scoped_true_ = __webpack_require__("2af0");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// EXTERNAL MODULE: ./node_modules/vuetify-loader/lib/runtime/installComponents.js
var installComponents = __webpack_require__("6544");
var installComponents_default = /*#__PURE__*/__webpack_require__.n(installComponents);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("4de4");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__("7db0");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("4160");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("caad");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.values.js
var es_object_values = __webpack_require__("07ac");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("2532");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("159b");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__("5530");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/util/mixins.js
var mixins = __webpack_require__("58df");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/mixins/binds-attrs/index.js
var binds_attrs = __webpack_require__("7e2b");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/mixins/registrable/index.js
var registrable = __webpack_require__("3206");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VForm/VForm.js








// Mixins



/* @vue/component */

/* harmony default export */ var VForm = (Object(mixins["a" /* default */])(binds_attrs["a" /* default */], Object(registrable["b" /* provide */])('form')
/* @vue/component */
).extend({
  name: 'v-form',
  provide: function provide() {
    return {
      form: this
    };
  },
  inheritAttrs: false,
  props: {
    disabled: Boolean,
    lazyValidation: Boolean,
    readonly: Boolean,
    value: Boolean
  },
  data: function data() {
    return {
      inputs: [],
      watchers: [],
      errorBag: {}
    };
  },
  watch: {
    errorBag: {
      handler: function handler(val) {
        var errors = Object.values(val).includes(true);
        this.$emit('input', !errors);
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    watchInput: function watchInput(input) {
      var _this = this;

      var watcher = function watcher(input) {
        return input.$watch('hasError', function (val) {
          _this.$set(_this.errorBag, input._uid, val);
        }, {
          immediate: true
        });
      };

      var watchers = {
        _uid: input._uid,
        valid: function valid() {},
        shouldValidate: function shouldValidate() {}
      };

      if (this.lazyValidation) {
        // Only start watching inputs if we need to
        watchers.shouldValidate = input.$watch('shouldValidate', function (val) {
          if (!val) return; // Only watch if we're not already doing it

          if (_this.errorBag.hasOwnProperty(input._uid)) return;
          watchers.valid = watcher(input);
        });
      } else {
        watchers.valid = watcher(input);
      }

      return watchers;
    },

    /** @public */
    validate: function validate() {
      return this.inputs.filter(function (input) {
        return !input.validate(true);
      }).length === 0;
    },

    /** @public */
    reset: function reset() {
      this.inputs.forEach(function (input) {
        return input.reset();
      });
      this.resetErrorBag();
    },
    resetErrorBag: function resetErrorBag() {
      var _this2 = this;

      if (this.lazyValidation) {
        // Account for timeout in validatable
        setTimeout(function () {
          _this2.errorBag = {};
        }, 0);
      }
    },

    /** @public */
    resetValidation: function resetValidation() {
      this.inputs.forEach(function (input) {
        return input.resetValidation();
      });
      this.resetErrorBag();
    },
    register: function register(input) {
      this.inputs.push(input);
      this.watchers.push(this.watchInput(input));
    },
    unregister: function unregister(input) {
      var found = this.inputs.find(function (i) {
        return i._uid === input._uid;
      });
      if (!found) return;
      var unwatch = this.watchers.find(function (i) {
        return i._uid === found._uid;
      });

      if (unwatch) {
        unwatch.valid();
        unwatch.shouldValidate();
      }

      this.watchers = this.watchers.filter(function (i) {
        return i._uid !== found._uid;
      });
      this.inputs = this.inputs.filter(function (i) {
        return i._uid !== found._uid;
      });
      this.$delete(this.errorBag, found._uid);
    }
  },
  render: function render(h) {
    var _this3 = this;

    return h('form', {
      staticClass: 'v-form',
      attrs: Object(objectSpread2["a" /* default */])({
        novalidate: true
      }, this.attrs$),
      on: {
        submit: function submit(e) {
          return _this3.$emit('submit', e);
        }
      }
    }, this.$slots.default);
  }
}));
// EXTERNAL MODULE: ./node_modules/vuetify/src/components/VGrid/_grid.sass
var _grid = __webpack_require__("20f6");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/components/VGrid/grid.js
var grid = __webpack_require__("e8f2");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VGrid/VLayout.js


/* harmony default export */ var VLayout = (Object(grid["a" /* default */])('layout'));
// CONCATENATED MODULE: ./src/components/composer/PpComposer.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  composer_PpComposervue_type_script_lang_js_,
  PpComposervue_type_template_id_3ef68c2a_scoped_true_render,
  staticRenderFns,
  false,
  null,
  "3ef68c2a",
  null
  
)

/* harmony default export */ var PpComposer = __webpack_exports__["default"] = (component.exports);

/* vuetify-loader */



installComponents_default()(component, {VForm: VForm,VLayout: VLayout})


/***/ }),

/***/ "498a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $trim = __webpack_require__("58a8").trim;
var forcedStringTrimMethod = __webpack_require__("c8d2");

// `String.prototype.trim` method
// https://tc39.es/ecma262/#sec-string.prototype.trim
$({ target: 'String', proto: true, forced: forcedStringTrimMethod('trim') }, {
  trim: function trim() {
    return $trim(this);
  }
});


/***/ }),

/***/ "499e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "default", function() { return /* binding */ addStylesClient; });

// CONCATENATED MODULE: ./node_modules/vue-style-loader/lib/listToStyles.js
/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}

// CONCATENATED MODULE: ./node_modules/vue-style-loader/lib/addStylesClient.js
/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/



var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}
var options = null
var ssrIdKey = 'data-vue-ssr-id'

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

function addStylesClient (parentId, list, _isProduction, _options) {
  isProduction = _isProduction

  options = _options || {}

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }
  if (options.ssrId) {
    styleElement.setAttribute(ssrIdKey, obj.id)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),

/***/ "4a02":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpInputText_vue_vue_type_style_index_0_id_c2092df8_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ff93");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpInputText_vue_vue_type_style_index_0_id_c2092df8_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpInputText_vue_vue_type_style_index_0_id_c2092df8_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "4a6a":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><rect x=\"3\" y=\"3\" width=\"18\" height=\"18\" rx=\"2\" stroke=\"#1F3A3E\" stroke-width=\"2\"></rect><mask id=\"path-2-inside-1_167_13\" fill=\"white\"><rect x=\"6\" y=\"6\" width=\"8\" height=\"6\" rx=\"0.5\"></rect></mask><rect x=\"6\" y=\"6\" width=\"8\" height=\"6\" rx=\"0.5\" fill=\"#DFE4E5\" stroke=\"#1F3A3E\" stroke-width=\"4\" mask=\"url(#path-2-inside-1_167_13)\"></rect><rect x=\"6\" y=\"11\" width=\"2\" height=\"7\" rx=\"0.5\" fill=\"#1F3A3E\"></rect><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M17.1563 18.8535C16.9612 19.0487 16.6449 19.049 16.4495 18.8541L9.46329 11.8852C9.26766 11.69 9.26741 11.3732 9.46275 11.1777L10.1576 10.4825C10.3527 10.2873 10.669 10.2871 10.8644 10.4819L17.8506 17.4508C18.0462 17.6459 18.0465 17.9628 17.8512 18.1582L17.1563 18.8535Z\" fill=\"#1F3A3E\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M17.8523 11.8405C18.0474 12.0358 18.0474 12.3522 17.8523 12.5474L11.5505 18.853C11.3553 19.0484 11.0385 19.0484 10.8432 18.853L10.1484 18.1577C9.95325 17.9624 9.95326 17.646 10.1484 17.4508L16.4502 11.1453C16.6455 10.9499 16.9622 10.9499 17.1575 11.1453L17.8523 11.8405Z\" fill=\"#1F3A3E\"></path></svg>";

/***/ }),

/***/ "4ad4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("caad");
/* harmony import */ var core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_some_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("45fc");
/* harmony import */ var core_js_modules_es_array_some_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("b0c0");
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("cca6");
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("b64b");
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("53ca");
/* harmony import */ var _delayable__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("16b7");
/* harmony import */ var _toggleable__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("f2e7");
/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("58df");
/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("80d2");
/* harmony import */ var _util_console__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("d9bd");






// Mixins

 // Utilities




var baseMixins = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"])(_delayable__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"], _toggleable__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"]);
/* @vue/component */

/* harmony default export */ __webpack_exports__["a"] = (baseMixins.extend({
  name: 'activatable',
  props: {
    activator: {
      default: null,
      validator: function validator(val) {
        return ['string', 'object'].includes(Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(val));
      }
    },
    disabled: Boolean,
    internalActivator: Boolean,
    openOnHover: Boolean,
    openOnFocus: Boolean
  },
  data: function data() {
    return {
      // Do not use this directly, call getActivator() instead
      activatorElement: null,
      activatorNode: [],
      events: ['click', 'mouseenter', 'mouseleave', 'focus'],
      listeners: {}
    };
  },
  watch: {
    activator: 'resetActivator',
    openOnFocus: 'resetActivator',
    openOnHover: 'resetActivator'
  },
  mounted: function mounted() {
    var slotType = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_9__[/* getSlotType */ "t"])(this, 'activator', true);

    if (slotType && ['v-slot', 'normal'].includes(slotType)) {
      Object(_util_console__WEBPACK_IMPORTED_MODULE_10__[/* consoleError */ "b"])("The activator slot must be bound, try '<template v-slot:activator=\"{ on }\"><v-btn v-on=\"on\">'", this);
    }

    this.addActivatorEvents();
  },
  beforeDestroy: function beforeDestroy() {
    this.removeActivatorEvents();
  },
  methods: {
    addActivatorEvents: function addActivatorEvents() {
      if (!this.activator || this.disabled || !this.getActivator()) return;
      this.listeners = this.genActivatorListeners();
      var keys = Object.keys(this.listeners);

      for (var _i = 0, _keys = keys; _i < _keys.length; _i++) {
        var key = _keys[_i];
        this.getActivator().addEventListener(key, this.listeners[key]);
      }
    },
    genActivator: function genActivator() {
      var node = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_9__[/* getSlot */ "s"])(this, 'activator', Object.assign(this.getValueProxy(), {
        on: this.genActivatorListeners(),
        attrs: this.genActivatorAttributes()
      })) || [];
      this.activatorNode = node;
      return node;
    },
    genActivatorAttributes: function genActivatorAttributes() {
      return {
        role: 'button',
        'aria-haspopup': true,
        'aria-expanded': String(this.isActive)
      };
    },
    genActivatorListeners: function genActivatorListeners() {
      var _this = this;

      if (this.disabled) return {};
      var listeners = {};

      if (this.openOnHover) {
        listeners.mouseenter = function (e) {
          _this.getActivator(e);

          _this.runDelay('open');
        };

        listeners.mouseleave = function (e) {
          _this.getActivator(e);

          _this.runDelay('close');
        };
      } else {
        listeners.click = function (e) {
          var activator = _this.getActivator(e);

          if (activator) activator.focus();
          e.stopPropagation();
          _this.isActive = !_this.isActive;
        };
      }

      if (this.openOnFocus) {
        listeners.focus = function (e) {
          _this.getActivator(e);

          e.stopPropagation();
          _this.isActive = !_this.isActive;
        };
      }

      return listeners;
    },
    getActivator: function getActivator(e) {
      // If we've already fetched the activator, re-use
      if (this.activatorElement) return this.activatorElement;
      var activator = null;

      if (this.activator) {
        var target = this.internalActivator ? this.$el : document;

        if (typeof this.activator === 'string') {
          // Selector
          activator = target.querySelector(this.activator);
        } else if (this.activator.$el) {
          // Component (ref)
          activator = this.activator.$el;
        } else {
          // HTMLElement | Element
          activator = this.activator;
        }
      } else if (this.activatorNode.length === 1 || this.activatorNode.length && !e) {
        // Use the contents of the activator slot
        // There's either only one element in it or we
        // don't have a click event to use as a last resort
        var vm = this.activatorNode[0].componentInstance;

        if (vm && vm.$options.mixins && //                         Activatable is indirectly used via Menuable
        vm.$options.mixins.some(function (m) {
          return m.options && ['activatable', 'menuable'].includes(m.options.name);
        })) {
          // Activator is actually another activatible component, use its activator (#8846)
          activator = vm.getActivator();
        } else {
          activator = this.activatorNode[0].elm;
        }
      } else if (e) {
        // Activated by a click or focus event
        activator = e.currentTarget || e.target;
      }

      this.activatorElement = activator;
      return this.activatorElement;
    },
    getContentSlot: function getContentSlot() {
      return Object(_util_helpers__WEBPACK_IMPORTED_MODULE_9__[/* getSlot */ "s"])(this, 'default', this.getValueProxy(), true);
    },
    getValueProxy: function getValueProxy() {
      var self = this;
      return {
        get value() {
          return self.isActive;
        },

        set value(isActive) {
          self.isActive = isActive;
        }

      };
    },
    removeActivatorEvents: function removeActivatorEvents() {
      if (!this.activator || !this.activatorElement) return;
      var keys = Object.keys(this.listeners);

      for (var _i2 = 0, _keys2 = keys; _i2 < _keys2.length; _i2++) {
        var key = _keys2[_i2];
        this.activatorElement.removeEventListener(key, this.listeners[key]);
      }

      this.listeners = {};
    },
    resetActivator: function resetActivator() {
      this.removeActivatorEvents();
      this.activatorElement = null;
      this.getActivator();
      this.addActivatorEvents();
    }
  }
}));

/***/ }),

/***/ "4ae1":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var getBuiltIn = __webpack_require__("d066");
var aFunction = __webpack_require__("1c0b");
var anObject = __webpack_require__("825a");
var isObject = __webpack_require__("861d");
var create = __webpack_require__("7c73");
var bind = __webpack_require__("0538");
var fails = __webpack_require__("d039");

var nativeConstruct = getBuiltIn('Reflect', 'construct');

// `Reflect.construct` method
// https://tc39.es/ecma262/#sec-reflect.construct
// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(nativeConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  nativeConstruct(function () { /* empty */ });
});
var FORCED = NEW_TARGET_BUG || ARGS_BUG;

$({ target: 'Reflect', stat: true, forced: FORCED, sham: FORCED }, {
  construct: function construct(Target, args /* , newTarget */) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return nativeConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),

/***/ "4b85":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("42ad");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("13a6741d", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "4c51":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.container.grow-shrink-0{flex-grow:0;flex-shrink:0}.container.fill-height{align-items:center;display:flex;flex-wrap:wrap}.container.fill-height>.row{flex:1 1 100%;max-width:calc(100% + 24px)}.container.fill-height>.layout{height:100%;flex:1 1 auto}.container.fill-height>.layout.grow-shrink-0{flex-grow:0;flex-shrink:0}.container.grid-list-xs .layout .flex{padding:1px}.container.grid-list-xs .layout:only-child{margin:-1px}.container.grid-list-xs .layout:not(:only-child){margin:auto -1px}.container.grid-list-xs :not(:only-child) .layout:first-child{margin-top:-1px}.container.grid-list-xs :not(:only-child) .layout:last-child{margin-bottom:-1px}.container.grid-list-sm .layout .flex{padding:2px}.container.grid-list-sm .layout:only-child{margin:-2px}.container.grid-list-sm .layout:not(:only-child){margin:auto -2px}.container.grid-list-sm :not(:only-child) .layout:first-child{margin-top:-2px}.container.grid-list-sm :not(:only-child) .layout:last-child{margin-bottom:-2px}.container.grid-list-md .layout .flex{padding:4px}.container.grid-list-md .layout:only-child{margin:-4px}.container.grid-list-md .layout:not(:only-child){margin:auto -4px}.container.grid-list-md :not(:only-child) .layout:first-child{margin-top:-4px}.container.grid-list-md :not(:only-child) .layout:last-child{margin-bottom:-4px}.container.grid-list-lg .layout .flex{padding:8px}.container.grid-list-lg .layout:only-child{margin:-8px}.container.grid-list-lg .layout:not(:only-child){margin:auto -8px}.container.grid-list-lg :not(:only-child) .layout:first-child{margin-top:-8px}.container.grid-list-lg :not(:only-child) .layout:last-child{margin-bottom:-8px}.container.grid-list-xl .layout .flex{padding:12px}.container.grid-list-xl .layout:only-child{margin:-12px}.container.grid-list-xl .layout:not(:only-child){margin:auto -12px}.container.grid-list-xl :not(:only-child) .layout:first-child{margin-top:-12px}.container.grid-list-xl :not(:only-child) .layout:last-child{margin-bottom:-12px}.layout{display:flex;flex:1 1 auto;flex-wrap:nowrap;min-width:0}.layout.reverse{flex-direction:row-reverse}.layout.column{flex-direction:column}.layout.column.reverse{flex-direction:column-reverse}.layout.column>.flex{max-width:100%}.layout.wrap{flex-wrap:wrap}.layout.grow-shrink-0{flex-grow:0;flex-shrink:0}@media (min-width:0){.flex.xs12{flex-basis:100%;flex-grow:0;max-width:100%}.flex.order-xs12{order:12}.flex.xs11{flex-basis:91.6666666667%;flex-grow:0;max-width:91.6666666667%}.flex.order-xs11{order:11}.flex.xs10{flex-basis:83.3333333333%;flex-grow:0;max-width:83.3333333333%}.flex.order-xs10{order:10}.flex.xs9{flex-basis:75%;flex-grow:0;max-width:75%}.flex.order-xs9{order:9}.flex.xs8{flex-basis:66.6666666667%;flex-grow:0;max-width:66.6666666667%}.flex.order-xs8{order:8}.flex.xs7{flex-basis:58.3333333333%;flex-grow:0;max-width:58.3333333333%}.flex.order-xs7{order:7}.flex.xs6{flex-basis:50%;flex-grow:0;max-width:50%}.flex.order-xs6{order:6}.flex.xs5{flex-basis:41.6666666667%;flex-grow:0;max-width:41.6666666667%}.flex.order-xs5{order:5}.flex.xs4{flex-basis:33.3333333333%;flex-grow:0;max-width:33.3333333333%}.flex.order-xs4{order:4}.flex.xs3{flex-basis:25%;flex-grow:0;max-width:25%}.flex.order-xs3{order:3}.flex.xs2{flex-basis:16.6666666667%;flex-grow:0;max-width:16.6666666667%}.flex.order-xs2{order:2}.flex.xs1{flex-basis:8.3333333333%;flex-grow:0;max-width:8.3333333333%}.flex.order-xs1{order:1}.v-application--is-ltr .flex.offset-xs12{margin-left:100%}.v-application--is-rtl .flex.offset-xs12{margin-right:100%}.v-application--is-ltr .flex.offset-xs11{margin-left:91.6666666667%}.v-application--is-rtl .flex.offset-xs11{margin-right:91.6666666667%}.v-application--is-ltr .flex.offset-xs10{margin-left:83.3333333333%}.v-application--is-rtl .flex.offset-xs10{margin-right:83.3333333333%}.v-application--is-ltr .flex.offset-xs9{margin-left:75%}.v-application--is-rtl .flex.offset-xs9{margin-right:75%}.v-application--is-ltr .flex.offset-xs8{margin-left:66.6666666667%}.v-application--is-rtl .flex.offset-xs8{margin-right:66.6666666667%}.v-application--is-ltr .flex.offset-xs7{margin-left:58.3333333333%}.v-application--is-rtl .flex.offset-xs7{margin-right:58.3333333333%}.v-application--is-ltr .flex.offset-xs6{margin-left:50%}.v-application--is-rtl .flex.offset-xs6{margin-right:50%}.v-application--is-ltr .flex.offset-xs5{margin-left:41.6666666667%}.v-application--is-rtl .flex.offset-xs5{margin-right:41.6666666667%}.v-application--is-ltr .flex.offset-xs4{margin-left:33.3333333333%}.v-application--is-rtl .flex.offset-xs4{margin-right:33.3333333333%}.v-application--is-ltr .flex.offset-xs3{margin-left:25%}.v-application--is-rtl .flex.offset-xs3{margin-right:25%}.v-application--is-ltr .flex.offset-xs2{margin-left:16.6666666667%}.v-application--is-rtl .flex.offset-xs2{margin-right:16.6666666667%}.v-application--is-ltr .flex.offset-xs1{margin-left:8.3333333333%}.v-application--is-rtl .flex.offset-xs1{margin-right:8.3333333333%}.v-application--is-ltr .flex.offset-xs0{margin-left:0}.v-application--is-rtl .flex.offset-xs0{margin-right:0}}@media (min-width:600px){.flex.sm12{flex-basis:100%;flex-grow:0;max-width:100%}.flex.order-sm12{order:12}.flex.sm11{flex-basis:91.6666666667%;flex-grow:0;max-width:91.6666666667%}.flex.order-sm11{order:11}.flex.sm10{flex-basis:83.3333333333%;flex-grow:0;max-width:83.3333333333%}.flex.order-sm10{order:10}.flex.sm9{flex-basis:75%;flex-grow:0;max-width:75%}.flex.order-sm9{order:9}.flex.sm8{flex-basis:66.6666666667%;flex-grow:0;max-width:66.6666666667%}.flex.order-sm8{order:8}.flex.sm7{flex-basis:58.3333333333%;flex-grow:0;max-width:58.3333333333%}.flex.order-sm7{order:7}.flex.sm6{flex-basis:50%;flex-grow:0;max-width:50%}.flex.order-sm6{order:6}.flex.sm5{flex-basis:41.6666666667%;flex-grow:0;max-width:41.6666666667%}.flex.order-sm5{order:5}.flex.sm4{flex-basis:33.3333333333%;flex-grow:0;max-width:33.3333333333%}.flex.order-sm4{order:4}.flex.sm3{flex-basis:25%;flex-grow:0;max-width:25%}.flex.order-sm3{order:3}.flex.sm2{flex-basis:16.6666666667%;flex-grow:0;max-width:16.6666666667%}.flex.order-sm2{order:2}.flex.sm1{flex-basis:8.3333333333%;flex-grow:0;max-width:8.3333333333%}.flex.order-sm1{order:1}.v-application--is-ltr .flex.offset-sm12{margin-left:100%}.v-application--is-rtl .flex.offset-sm12{margin-right:100%}.v-application--is-ltr .flex.offset-sm11{margin-left:91.6666666667%}.v-application--is-rtl .flex.offset-sm11{margin-right:91.6666666667%}.v-application--is-ltr .flex.offset-sm10{margin-left:83.3333333333%}.v-application--is-rtl .flex.offset-sm10{margin-right:83.3333333333%}.v-application--is-ltr .flex.offset-sm9{margin-left:75%}.v-application--is-rtl .flex.offset-sm9{margin-right:75%}.v-application--is-ltr .flex.offset-sm8{margin-left:66.6666666667%}.v-application--is-rtl .flex.offset-sm8{margin-right:66.6666666667%}.v-application--is-ltr .flex.offset-sm7{margin-left:58.3333333333%}.v-application--is-rtl .flex.offset-sm7{margin-right:58.3333333333%}.v-application--is-ltr .flex.offset-sm6{margin-left:50%}.v-application--is-rtl .flex.offset-sm6{margin-right:50%}.v-application--is-ltr .flex.offset-sm5{margin-left:41.6666666667%}.v-application--is-rtl .flex.offset-sm5{margin-right:41.6666666667%}.v-application--is-ltr .flex.offset-sm4{margin-left:33.3333333333%}.v-application--is-rtl .flex.offset-sm4{margin-right:33.3333333333%}.v-application--is-ltr .flex.offset-sm3{margin-left:25%}.v-application--is-rtl .flex.offset-sm3{margin-right:25%}.v-application--is-ltr .flex.offset-sm2{margin-left:16.6666666667%}.v-application--is-rtl .flex.offset-sm2{margin-right:16.6666666667%}.v-application--is-ltr .flex.offset-sm1{margin-left:8.3333333333%}.v-application--is-rtl .flex.offset-sm1{margin-right:8.3333333333%}.v-application--is-ltr .flex.offset-sm0{margin-left:0}.v-application--is-rtl .flex.offset-sm0{margin-right:0}}@media (min-width:960px){.flex.md12{flex-basis:100%;flex-grow:0;max-width:100%}.flex.order-md12{order:12}.flex.md11{flex-basis:91.6666666667%;flex-grow:0;max-width:91.6666666667%}.flex.order-md11{order:11}.flex.md10{flex-basis:83.3333333333%;flex-grow:0;max-width:83.3333333333%}.flex.order-md10{order:10}.flex.md9{flex-basis:75%;flex-grow:0;max-width:75%}.flex.order-md9{order:9}.flex.md8{flex-basis:66.6666666667%;flex-grow:0;max-width:66.6666666667%}.flex.order-md8{order:8}.flex.md7{flex-basis:58.3333333333%;flex-grow:0;max-width:58.3333333333%}.flex.order-md7{order:7}.flex.md6{flex-basis:50%;flex-grow:0;max-width:50%}.flex.order-md6{order:6}.flex.md5{flex-basis:41.6666666667%;flex-grow:0;max-width:41.6666666667%}.flex.order-md5{order:5}.flex.md4{flex-basis:33.3333333333%;flex-grow:0;max-width:33.3333333333%}.flex.order-md4{order:4}.flex.md3{flex-basis:25%;flex-grow:0;max-width:25%}.flex.order-md3{order:3}.flex.md2{flex-basis:16.6666666667%;flex-grow:0;max-width:16.6666666667%}.flex.order-md2{order:2}.flex.md1{flex-basis:8.3333333333%;flex-grow:0;max-width:8.3333333333%}.flex.order-md1{order:1}.v-application--is-ltr .flex.offset-md12{margin-left:100%}.v-application--is-rtl .flex.offset-md12{margin-right:100%}.v-application--is-ltr .flex.offset-md11{margin-left:91.6666666667%}.v-application--is-rtl .flex.offset-md11{margin-right:91.6666666667%}.v-application--is-ltr .flex.offset-md10{margin-left:83.3333333333%}.v-application--is-rtl .flex.offset-md10{margin-right:83.3333333333%}.v-application--is-ltr .flex.offset-md9{margin-left:75%}.v-application--is-rtl .flex.offset-md9{margin-right:75%}.v-application--is-ltr .flex.offset-md8{margin-left:66.6666666667%}.v-application--is-rtl .flex.offset-md8{margin-right:66.6666666667%}.v-application--is-ltr .flex.offset-md7{margin-left:58.3333333333%}.v-application--is-rtl .flex.offset-md7{margin-right:58.3333333333%}.v-application--is-ltr .flex.offset-md6{margin-left:50%}.v-application--is-rtl .flex.offset-md6{margin-right:50%}.v-application--is-ltr .flex.offset-md5{margin-left:41.6666666667%}.v-application--is-rtl .flex.offset-md5{margin-right:41.6666666667%}.v-application--is-ltr .flex.offset-md4{margin-left:33.3333333333%}.v-application--is-rtl .flex.offset-md4{margin-right:33.3333333333%}.v-application--is-ltr .flex.offset-md3{margin-left:25%}.v-application--is-rtl .flex.offset-md3{margin-right:25%}.v-application--is-ltr .flex.offset-md2{margin-left:16.6666666667%}.v-application--is-rtl .flex.offset-md2{margin-right:16.6666666667%}.v-application--is-ltr .flex.offset-md1{margin-left:8.3333333333%}.v-application--is-rtl .flex.offset-md1{margin-right:8.3333333333%}.v-application--is-ltr .flex.offset-md0{margin-left:0}.v-application--is-rtl .flex.offset-md0{margin-right:0}}@media (min-width:1264px){.flex.lg12{flex-basis:100%;flex-grow:0;max-width:100%}.flex.order-lg12{order:12}.flex.lg11{flex-basis:91.6666666667%;flex-grow:0;max-width:91.6666666667%}.flex.order-lg11{order:11}.flex.lg10{flex-basis:83.3333333333%;flex-grow:0;max-width:83.3333333333%}.flex.order-lg10{order:10}.flex.lg9{flex-basis:75%;flex-grow:0;max-width:75%}.flex.order-lg9{order:9}.flex.lg8{flex-basis:66.6666666667%;flex-grow:0;max-width:66.6666666667%}.flex.order-lg8{order:8}.flex.lg7{flex-basis:58.3333333333%;flex-grow:0;max-width:58.3333333333%}.flex.order-lg7{order:7}.flex.lg6{flex-basis:50%;flex-grow:0;max-width:50%}.flex.order-lg6{order:6}.flex.lg5{flex-basis:41.6666666667%;flex-grow:0;max-width:41.6666666667%}.flex.order-lg5{order:5}.flex.lg4{flex-basis:33.3333333333%;flex-grow:0;max-width:33.3333333333%}.flex.order-lg4{order:4}.flex.lg3{flex-basis:25%;flex-grow:0;max-width:25%}.flex.order-lg3{order:3}.flex.lg2{flex-basis:16.6666666667%;flex-grow:0;max-width:16.6666666667%}.flex.order-lg2{order:2}.flex.lg1{flex-basis:8.3333333333%;flex-grow:0;max-width:8.3333333333%}.flex.order-lg1{order:1}.v-application--is-ltr .flex.offset-lg12{margin-left:100%}.v-application--is-rtl .flex.offset-lg12{margin-right:100%}.v-application--is-ltr .flex.offset-lg11{margin-left:91.6666666667%}.v-application--is-rtl .flex.offset-lg11{margin-right:91.6666666667%}.v-application--is-ltr .flex.offset-lg10{margin-left:83.3333333333%}.v-application--is-rtl .flex.offset-lg10{margin-right:83.3333333333%}.v-application--is-ltr .flex.offset-lg9{margin-left:75%}.v-application--is-rtl .flex.offset-lg9{margin-right:75%}.v-application--is-ltr .flex.offset-lg8{margin-left:66.6666666667%}.v-application--is-rtl .flex.offset-lg8{margin-right:66.6666666667%}.v-application--is-ltr .flex.offset-lg7{margin-left:58.3333333333%}.v-application--is-rtl .flex.offset-lg7{margin-right:58.3333333333%}.v-application--is-ltr .flex.offset-lg6{margin-left:50%}.v-application--is-rtl .flex.offset-lg6{margin-right:50%}.v-application--is-ltr .flex.offset-lg5{margin-left:41.6666666667%}.v-application--is-rtl .flex.offset-lg5{margin-right:41.6666666667%}.v-application--is-ltr .flex.offset-lg4{margin-left:33.3333333333%}.v-application--is-rtl .flex.offset-lg4{margin-right:33.3333333333%}.v-application--is-ltr .flex.offset-lg3{margin-left:25%}.v-application--is-rtl .flex.offset-lg3{margin-right:25%}.v-application--is-ltr .flex.offset-lg2{margin-left:16.6666666667%}.v-application--is-rtl .flex.offset-lg2{margin-right:16.6666666667%}.v-application--is-ltr .flex.offset-lg1{margin-left:8.3333333333%}.v-application--is-rtl .flex.offset-lg1{margin-right:8.3333333333%}.v-application--is-ltr .flex.offset-lg0{margin-left:0}.v-application--is-rtl .flex.offset-lg0{margin-right:0}}@media (min-width:1904px){.flex.xl12{flex-basis:100%;flex-grow:0;max-width:100%}.flex.order-xl12{order:12}.flex.xl11{flex-basis:91.6666666667%;flex-grow:0;max-width:91.6666666667%}.flex.order-xl11{order:11}.flex.xl10{flex-basis:83.3333333333%;flex-grow:0;max-width:83.3333333333%}.flex.order-xl10{order:10}.flex.xl9{flex-basis:75%;flex-grow:0;max-width:75%}.flex.order-xl9{order:9}.flex.xl8{flex-basis:66.6666666667%;flex-grow:0;max-width:66.6666666667%}.flex.order-xl8{order:8}.flex.xl7{flex-basis:58.3333333333%;flex-grow:0;max-width:58.3333333333%}.flex.order-xl7{order:7}.flex.xl6{flex-basis:50%;flex-grow:0;max-width:50%}.flex.order-xl6{order:6}.flex.xl5{flex-basis:41.6666666667%;flex-grow:0;max-width:41.6666666667%}.flex.order-xl5{order:5}.flex.xl4{flex-basis:33.3333333333%;flex-grow:0;max-width:33.3333333333%}.flex.order-xl4{order:4}.flex.xl3{flex-basis:25%;flex-grow:0;max-width:25%}.flex.order-xl3{order:3}.flex.xl2{flex-basis:16.6666666667%;flex-grow:0;max-width:16.6666666667%}.flex.order-xl2{order:2}.flex.xl1{flex-basis:8.3333333333%;flex-grow:0;max-width:8.3333333333%}.flex.order-xl1{order:1}.v-application--is-ltr .flex.offset-xl12{margin-left:100%}.v-application--is-rtl .flex.offset-xl12{margin-right:100%}.v-application--is-ltr .flex.offset-xl11{margin-left:91.6666666667%}.v-application--is-rtl .flex.offset-xl11{margin-right:91.6666666667%}.v-application--is-ltr .flex.offset-xl10{margin-left:83.3333333333%}.v-application--is-rtl .flex.offset-xl10{margin-right:83.3333333333%}.v-application--is-ltr .flex.offset-xl9{margin-left:75%}.v-application--is-rtl .flex.offset-xl9{margin-right:75%}.v-application--is-ltr .flex.offset-xl8{margin-left:66.6666666667%}.v-application--is-rtl .flex.offset-xl8{margin-right:66.6666666667%}.v-application--is-ltr .flex.offset-xl7{margin-left:58.3333333333%}.v-application--is-rtl .flex.offset-xl7{margin-right:58.3333333333%}.v-application--is-ltr .flex.offset-xl6{margin-left:50%}.v-application--is-rtl .flex.offset-xl6{margin-right:50%}.v-application--is-ltr .flex.offset-xl5{margin-left:41.6666666667%}.v-application--is-rtl .flex.offset-xl5{margin-right:41.6666666667%}.v-application--is-ltr .flex.offset-xl4{margin-left:33.3333333333%}.v-application--is-rtl .flex.offset-xl4{margin-right:33.3333333333%}.v-application--is-ltr .flex.offset-xl3{margin-left:25%}.v-application--is-rtl .flex.offset-xl3{margin-right:25%}.v-application--is-ltr .flex.offset-xl2{margin-left:16.6666666667%}.v-application--is-rtl .flex.offset-xl2{margin-right:16.6666666667%}.v-application--is-ltr .flex.offset-xl1{margin-left:8.3333333333%}.v-application--is-rtl .flex.offset-xl1{margin-right:8.3333333333%}.v-application--is-ltr .flex.offset-xl0{margin-left:0}.v-application--is-rtl .flex.offset-xl0{margin-right:0}}.child-flex>*,.flex{flex:1 1 auto;max-width:100%}.child-flex>.grow-shrink-0,.flex.grow-shrink-0{flex-grow:0;flex-shrink:0}.grow,.spacer{flex-grow:1!important}.grow{flex-shrink:0!important}.shrink{flex-grow:0!important;flex-shrink:1!important}.fill-height{height:100%}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "4c53":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var createHTML = __webpack_require__("857a");
var forcedStringHTMLMethod = __webpack_require__("af03");

// `String.prototype.sub` method
// https://tc39.es/ecma262/#sec-string.prototype.sub
$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('sub') }, {
  sub: function sub() {
    return createHTML(this, 'sub', '', '');
  }
});


/***/ }),

/***/ "4ce4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c662cfac-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/shortcut/delete/PpShortcutDelete.vue?vue&type=template&id=6daaabe4&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pp-dialog',{attrs:{"caution":true,"max-width":400,"value":_vm.$attrs.value,"body":"Are you sure you want to delete this shortcut? This action cannot be undone.","prepend-title-icon":"delete","primary-button-text":"Delete","secondary-button-text":"Cancel","title":"Delete Shortcut"},on:{"close":function($event){return _vm.cancelDelete($event)},"confirm":_vm.confirmDelete}})}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/shortcut/delete/PpShortcutDelete.vue?vue&type=template&id=6daaabe4&

// EXTERNAL MODULE: ./src/components/dialog/PpDialog.vue + 5 modules
var PpDialog = __webpack_require__("bdf9");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/shortcut/delete/PpShortcutDelete.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var PpShortcutDeletevue_type_script_lang_js_ = ({
  name: 'PpShortcutDelete',
  components: {
    'pp-dialog': PpDialog["default"]
  },
  methods: {
    cancelDelete: function cancelDelete(e) {
      if (e === 'key-escape') {
        return;
      }

      this.$ppAnalytics.trackEvent({
        category: 'shortcuts',
        action: 'delete',
        label: 'close'
      });
      this.$emit('input', false);
    },
    confirmDelete: function confirmDelete() {
      this.$ppAnalytics.trackEvent({
        category: 'shortcuts',
        action: 'delete',
        label: 'confirm'
      });
      this.$emit('delete');
    }
  }
});
// CONCATENATED MODULE: ./src/components/shortcut/delete/PpShortcutDelete.vue?vue&type=script&lang=js&
 /* harmony default export */ var delete_PpShortcutDeletevue_type_script_lang_js_ = (PpShortcutDeletevue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/shortcut/delete/PpShortcutDelete.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  delete_PpShortcutDeletevue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var PpShortcutDelete = __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "4d63":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var global = __webpack_require__("da84");
var isForced = __webpack_require__("94ca");
var inheritIfRequired = __webpack_require__("7156");
var defineProperty = __webpack_require__("9bf2").f;
var getOwnPropertyNames = __webpack_require__("241c").f;
var isRegExp = __webpack_require__("44e7");
var getFlags = __webpack_require__("ad6d");
var stickyHelpers = __webpack_require__("9f7f");
var redefine = __webpack_require__("6eeb");
var fails = __webpack_require__("d039");
var setInternalState = __webpack_require__("69f3").set;
var setSpecies = __webpack_require__("2626");
var wellKnownSymbol = __webpack_require__("b622");

var MATCH = wellKnownSymbol('match');
var NativeRegExp = global.RegExp;
var RegExpPrototype = NativeRegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;

// "new" should create a new object, old webkit bug
var CORRECT_NEW = new NativeRegExp(re1) !== re1;

var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y;

var FORCED = DESCRIPTORS && isForced('RegExp', (!CORRECT_NEW || UNSUPPORTED_Y || fails(function () {
  re2[MATCH] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return NativeRegExp(re1) != re1 || NativeRegExp(re2) == re2 || NativeRegExp(re1, 'i') != '/a/i';
})));

// `RegExp` constructor
// https://tc39.es/ecma262/#sec-regexp-constructor
if (FORCED) {
  var RegExpWrapper = function RegExp(pattern, flags) {
    var thisIsRegExp = this instanceof RegExpWrapper;
    var patternIsRegExp = isRegExp(pattern);
    var flagsAreUndefined = flags === undefined;
    var sticky;

    if (!thisIsRegExp && patternIsRegExp && pattern.constructor === RegExpWrapper && flagsAreUndefined) {
      return pattern;
    }

    if (CORRECT_NEW) {
      if (patternIsRegExp && !flagsAreUndefined) pattern = pattern.source;
    } else if (pattern instanceof RegExpWrapper) {
      if (flagsAreUndefined) flags = getFlags.call(pattern);
      pattern = pattern.source;
    }

    if (UNSUPPORTED_Y) {
      sticky = !!flags && flags.indexOf('y') > -1;
      if (sticky) flags = flags.replace(/y/g, '');
    }

    var result = inheritIfRequired(
      CORRECT_NEW ? new NativeRegExp(pattern, flags) : NativeRegExp(pattern, flags),
      thisIsRegExp ? this : RegExpPrototype,
      RegExpWrapper
    );

    if (UNSUPPORTED_Y && sticky) setInternalState(result, { sticky: sticky });

    return result;
  };
  var proxy = function (key) {
    key in RegExpWrapper || defineProperty(RegExpWrapper, key, {
      configurable: true,
      get: function () { return NativeRegExp[key]; },
      set: function (it) { NativeRegExp[key] = it; }
    });
  };
  var keys = getOwnPropertyNames(NativeRegExp);
  var index = 0;
  while (keys.length > index) proxy(keys[index++]);
  RegExpPrototype.constructor = RegExpWrapper;
  RegExpWrapper.prototype = RegExpPrototype;
  redefine(global, 'RegExp', RegExpWrapper);
}

// https://tc39.es/ecma262/#sec-get-regexp-@@species
setSpecies('RegExp');


/***/ }),

/***/ "4d64":
/***/ (function(module, exports, __webpack_require__) {

var toIndexedObject = __webpack_require__("fc6a");
var toLength = __webpack_require__("50c4");
var toAbsoluteIndex = __webpack_require__("23cb");

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

module.exports = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};


/***/ }),

/***/ "4d90":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $padStart = __webpack_require__("0ccb").start;
var WEBKIT_BUG = __webpack_require__("9a0c");

// `String.prototype.padStart` method
// https://tc39.es/ecma262/#sec-string.prototype.padstart
$({ target: 'String', proto: true, forced: WEBKIT_BUG }, {
  padStart: function padStart(maxLength /* , fillString = ' ' */) {
    return $padStart(this, maxLength, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "4daf":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./app/PpApp.vue": "f4b7",
	"./audio-player/PpAudioPlayer.vue": "4049",
	"./avatar-icon/PpAvatarIcon.vue": "020a",
	"./avatar-info/PpAvatarInfo.vue": "bfe6",
	"./avatar-location/PpAvatarLocation.vue": "f498",
	"./button/PpButton.vue": "251c",
	"./calendar-nav/PpCalendarNav.vue": "394d",
	"./card/PpCard.vue": "381f",
	"./chart/PpSingleStackBarChart.vue": "fc89",
	"./chart/horizontal-slide/PpChartHorizontalSlide.vue": "76a3",
	"./check-list/PpCheckList.vue": "305c",
	"./col/PpCol.vue": "8ecc",
	"./composer/PpComposer.vue": "4971",
	"./container/PpContainer.vue": "3d51",
	"./conversation/PpConversation.vue": "2eb6",
	"./conversation/header/PpConversationHeader.vue": "5ac2",
	"./data-table/PpDataTable.vue": "710d",
	"./dialog/PpDialog.vue": "bdf9",
	"./dialog/consent/PpDialogConsent.vue": "9f4c",
	"./dialog/phi/PpDialogPhi.vue": "b041",
	"./display-error/PpDisplayError.vue": "cfdb",
	"./divider/PpDivider.vue": "8bb3",
	"./drop-down-button/PpDropDownButton.vue": "ae8e",
	"./expansion-panel/PpExpansionPanel.vue": "bb4d",
	"./expansion-panels/PpExpansionPanels.vue": "c20a",
	"./form-message/PpFormMessage.vue": "6a21",
	"./idle-time/PpIdleTime.vue": "5b74",
	"./image/PpImage.vue": "05cb",
	"./info-card/PpInfoCard.vue": "16c9",
	"./input/avatar/PpInputAvatar.vue": "5ce5",
	"./input/checkbox/PpInputCheckbox.vue": "8327",
	"./input/color/PpInputColor.vue": "b442",
	"./input/date-range/PpInputDateRange.vue": "fa7d",
	"./input/date-range/month-layout/PpInputDateRangeMonthLayout.vue": "5a59",
	"./input/date/PpInputDate.vue": "9f67",
	"./input/file/PpInputFile.vue": "b9b8",
	"./input/image-upload/PpInputImageUpload.vue": "20cf",
	"./input/label/PpInputLabel.vue": "8e6c",
	"./input/multiselect/PpInputMultiselect.vue": "f892",
	"./input/radio-group/PpInputRadioGroup.vue": "bfb0",
	"./input/rich-text-editor/PpRichTextEditor.vue": "359a",
	"./input/search/PpInputSearch.vue": "52af",
	"./input/select/PpInputSelect.vue": "b8f2",
	"./input/switch/PpInputSwitch.vue": "deba",
	"./input/text/PpInputText.vue": "ac90",
	"./input/textarea/PpInputTextarea.vue": "d696",
	"./input/time-range/PpInputTimeRange.vue": "fa98",
	"./input/time/PpInputTime.vue": "b376",
	"./input/toggle-group/PpInputToggleGroup.vue": "f5ec",
	"./lazy/PpLazy.vue": "9dbe",
	"./link/PpLink.vue": "411b",
	"./loader/PpLoader.vue": "d888",
	"./loading-icon/PpLoadingIcon.vue": "efbd",
	"./map/PpMap.vue": "d0d7",
	"./masked-data/PpMaskedData.vue": "9287",
	"./message/PpMessage.vue": "fdc0",
	"./multi-card/PpMultiCard.vue": "1d29",
	"./nav-item/PpNavItem.vue": "d10b",
	"./nav-list/PpNavList.vue": "cb72",
	"./notification/PpNotification.vue": "2093",
	"./page-container-header/PpPageContainerHeader.vue": "8b36",
	"./page-container/PpPageContainer.vue": "87c0",
	"./page-header/PpPageHeader.vue": "2598",
	"./pagination/PpPagination.vue": "5a0d",
	"./panel/PpPanel.vue": "06e8",
	"./payment-form/PpPaymentForm.vue": "3bb9",
	"./portal/PpPortal.vue": "c7fb",
	"./portal/user-menu/PpPortalUserMenu.vue": "830a",
	"./row/PpRow.vue": "eeac",
	"./scrollable-list/PpScrollableList.vue": "3d56",
	"./shortcut/delete/PpShortcutDelete.vue": "4ce4",
	"./shortcut/edit/PpShortcutEdit.vue": "234b",
	"./shortcut/menu/PpShortcutMenu.vue": "4748",
	"./side-nav/PpSideNav.vue": "d123",
	"./side-overlay/PpSideOverlay.vue": "5174",
	"./signature-icon/PpSignatureIcon.vue": "8b6e",
	"./snack-bar/PpSnackBar.vue": "8550",
	"./snack-message/PpSnackMessage.vue": "925a",
	"./status-banner/PpStatusBanner.vue": "1586",
	"./statusChip/PpStatusChip.vue": "e921",
	"./tooltip/PpTooltip.vue": "284e",
	"./upload-file/PpUploadFile.vue": "184d",
	"./upload-history-card/PpUploadHistoryCard.vue": "53e6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4daf";

/***/ }),

/***/ "4de4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $filter = __webpack_require__("b727").filter;
var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");
var arrayMethodUsesToLength = __webpack_require__("ae40");

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('filter');
// Edge 14- issue
var USES_TO_LENGTH = arrayMethodUsesToLength('filter');

// `Array.prototype.filter` method
// https://tc39.es/ecma262/#sec-array.prototype.filter
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT || !USES_TO_LENGTH }, {
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "4df4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var bind = __webpack_require__("0366");
var toObject = __webpack_require__("7b0b");
var callWithSafeIterationClosing = __webpack_require__("9bdd");
var isArrayIteratorMethod = __webpack_require__("e95a");
var toLength = __webpack_require__("50c4");
var createProperty = __webpack_require__("8418");
var getIteratorMethod = __webpack_require__("35a1");

// `Array.from` method implementation
// https://tc39.es/ecma262/#sec-array.from
module.exports = function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
  var O = toObject(arrayLike);
  var C = typeof this == 'function' ? this : Array;
  var argumentsLength = arguments.length;
  var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
  var mapping = mapfn !== undefined;
  var iteratorMethod = getIteratorMethod(O);
  var index = 0;
  var length, result, step, iterator, next, value;
  if (mapping) mapfn = bind(mapfn, argumentsLength > 2 ? arguments[2] : undefined, 2);
  // if the target is not iterable or it's an array with the default iterator - use a simple case
  if (iteratorMethod != undefined && !(C == Array && isArrayIteratorMethod(iteratorMethod))) {
    iterator = iteratorMethod.call(O);
    next = iterator.next;
    result = new C();
    for (;!(step = next.call(iterator)).done; index++) {
      value = mapping ? callWithSafeIterationClosing(iterator, mapfn, [step.value, index], true) : step.value;
      createProperty(result, index, value);
    }
  } else {
    length = toLength(O.length);
    result = new C(length);
    for (;length > index; index++) {
      value = mapping ? mapfn(O[index], index) : O[index];
      createProperty(result, index, value);
    }
  }
  result.length = index;
  return result;
};


/***/ }),

/***/ "4e82":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return factory; });
/* harmony import */ var _home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ade3");
/* harmony import */ var _registrable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("3206");

// Mixins

function factory(namespace, child, parent) {
  return Object(_registrable__WEBPACK_IMPORTED_MODULE_1__[/* inject */ "a"])(namespace, child, parent).extend({
    name: 'groupable',
    props: {
      activeClass: {
        type: String,
        default: function _default() {
          if (!this[namespace]) return undefined;
          return this[namespace].activeClass;
        }
      },
      disabled: Boolean
    },
    data: function data() {
      return {
        isActive: false
      };
    },
    computed: {
      groupClasses: function groupClasses() {
        if (!this.activeClass) return {};
        return Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({}, this.activeClass, this.isActive);
      }
    },
    created: function created() {
      this[namespace] && this[namespace].register(this);
    },
    beforeDestroy: function beforeDestroy() {
      this[namespace] && this[namespace].unregister(this);
    },
    methods: {
      toggle: function toggle() {
        this.$emit('change');
      }
    }
  });
}
/* eslint-disable-next-line @typescript-eslint/no-redeclare */

var Groupable = factory('itemGroup');
/* unused harmony default export */ var _unused_webpack_default_export = (Groupable);

/***/ }),

/***/ "4ec9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var collection = __webpack_require__("6d61");
var collectionStrong = __webpack_require__("6566");

// `Map` constructor
// https://tc39.es/ecma262/#sec-map-objects
module.exports = collection('Map', function (init) {
  return function Map() { return init(this, arguments.length ? arguments[0] : undefined); };
}, collectionStrong);


/***/ }),

/***/ "4f09":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.v-date-picker-years{font-size:16px;font-weight:400;height:290px;list-style-type:none;overflow:auto;text-align:center}.v-date-picker-years.v-date-picker-years{padding:0}.v-date-picker-years li{cursor:pointer;padding:8px 0;transition:none}.v-date-picker-years li.active{font-size:26px;font-weight:500;padding:10px 0}.v-date-picker-years li:hover{background:rgba(0,0,0,.12)}.v-picker--landscape .v-date-picker-years{padding:0;height:290px}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "4f67":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("c8d5")

/**
 * @category Common Helpers
 * @summary Return a date from the array closest to the given date.
 *
 * @description
 * Return a date from the array closest to the given date.
 *
 * @param {Date|String|Number} dateToCompare - the date to compare with
 * @param {Date[]|String[]|Number[]} datesArray - the array to search
 * @returns {Date} the date from the array closest to the given date
 * @throws {TypeError} the second argument must be an instance of Array
 *
 * @example
 * // Which date is closer to 6 September 2015: 1 January 2000 or 1 January 2030?
 * var dateToCompare = new Date(2015, 8, 6)
 * var result = closestTo(dateToCompare, [
 *   new Date(2000, 0, 1),
 *   new Date(2030, 0, 1)
 * ])
 * //=> Tue Jan 01 2030 00:00:00
 */
function closestTo (dirtyDateToCompare, dirtyDatesArray) {
  if (!(dirtyDatesArray instanceof Array)) {
    throw new TypeError(toString.call(dirtyDatesArray) + ' is not an instance of Array')
  }

  var dateToCompare = parse(dirtyDateToCompare)
  var timeToCompare = dateToCompare.getTime()

  var result
  var minDistance

  dirtyDatesArray.forEach(function (dirtyDate) {
    var currentDate = parse(dirtyDate)
    var distance = Math.abs(timeToCompare - currentDate.getTime())
    if (result === undefined || distance < minDistance) {
      result = currentDate
      minDistance = distance
    }
  })

  return result
}

module.exports = closestTo


/***/ }),

/***/ "4f6e":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.i, "@import url(https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css);"]);
exports.push([module.i, "@import url(https://cdn-prd.patientpop.com/pp-icon-font/v1.6.0/pp-icon-font.css);"]);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.pp-payment-form__container[data-v-7636e91e]{min-height:550px;position:relative}.pp-payment-form__header[data-v-7636e91e]{font-weight:600;margin:4px 0 16px}.pp-payment-form__label[data-v-7636e91e]{display:flex;width:99%}.pp-payment-form__divider[data-v-7636e91e]{display:flex;justify-content:center;margin:24px auto 20px}#pp-payment-form__address[data-v-7636e91e]{height:340px}@media(max-width:600px){#pp-payment-form__address[data-v-7636e91e]{height:374px}}#pp-payment-form__name[data-v-7636e91e]{height:48px;width:100%}@media(max-width:600px){#pp-payment-form__name[data-v-7636e91e]{height:53px}}#pp-payment-form__number[data-v-7636e91e]{height:54px}#pp-payment-form__cvv[data-v-7636e91e],#pp-payment-form__expiration[data-v-7636e91e]{height:40px}@media(max-width:600px){#pp-payment-form__cvv[data-v-7636e91e],#pp-payment-form__expiration[data-v-7636e91e]{height:50px}}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "4f87":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.theme--light.v-data-table .v-data-table-header th.sortable .v-data-table-header__icon{color:var(--pp-text-disabled,#f6f6f6)}.theme--light.v-data-table .v-data-table-header th.sortable.active,.theme--light.v-data-table .v-data-table-header th.sortable.active .v-data-table-header__icon,.theme--light.v-data-table .v-data-table-header th.sortable:hover{color:var(--pp-text-primary,#2b2b2b)}.theme--light.v-data-table .v-data-table-header__sort-badge{background-color:#d6d6d6;color:var(--pp-text-primary,#2b2b2b)}.theme--dark.v-data-table .v-data-table-header th.sortable .v-data-table-header__icon{color:hsla(0,0%,100%,.5)}.theme--dark.v-data-table .v-data-table-header th.sortable.active,.theme--dark.v-data-table .v-data-table-header th.sortable.active .v-data-table-header__icon,.theme--dark.v-data-table .v-data-table-header th.sortable:hover{color:var(--pp-primary-button-text-color,#004852)}.theme--dark.v-data-table .v-data-table-header__sort-badge{background-color:hsla(0,0%,100%,.12);color:var(--pp-primary-button-text-color,#004852)}.v-data-table-header th.sortable{pointer-events:auto;cursor:pointer;outline:0}.v-data-table-header th.active .v-data-table-header__icon,.v-data-table-header th:hover .v-data-table-header__icon{transform:none;opacity:1}.v-data-table-header th.desc .v-data-table-header__icon{transform:rotate(-180deg)}.v-data-table-header__icon{display:inline-block;opacity:0;transition:.3s cubic-bezier(.25,.8,.5,1)}.v-data-table-header__sort-badge{display:inline-flex;justify-content:center;align-items:center;border:0;border-radius:50%;min-width:18px;min-height:18px;height:18px;width:18px}.v-data-table-header-mobile th{height:auto}.v-data-table-header-mobile__wrapper{display:flex}.v-data-table-header-mobile__wrapper .v-select{margin-bottom:8px}.v-data-table-header-mobile__wrapper .v-select .v-chip{height:24px}.v-data-table-header-mobile__wrapper .v-select .v-chip__close.desc .v-icon{transform:rotate(-180deg)}.v-data-table-header-mobile__select{min-width:56px;display:flex;align-items:center;justify-content:center}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "4fad":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var $entries = __webpack_require__("6f53").entries;

// `Object.entries` method
// https://tc39.es/ecma262/#sec-object.entries
$({ target: 'Object', stat: true }, {
  entries: function entries(O) {
    return $entries(O);
  }
});


/***/ }),

/***/ "4fc9":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("a03c");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("20f69928", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "4ff9":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("fdc2");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("58403efe", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "50c4":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("a691");

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
module.exports = function (argument) {
  return argument > 0 ? min(toInteger(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


/***/ }),

/***/ "5135":
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;

module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),

/***/ "5174":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c662cfac-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/side-overlay/PpSideOverlay.vue?vue&type=template&id=2a173d5a&
var PpSideOverlayvue_type_template_id_2a173d5a_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-overlay',{attrs:{"absolute":false,"value":_vm.$attrs.value,"dark":false,"z-index":"8"}},[_c('v-navigation-drawer',{staticClass:"pa-5",attrs:{"temporary":false,"fixed":"","width":_vm.width,"right":"","stateless":"","mobile-breakpoint":0},model:{value:(_vm.$attrs.value),callback:function ($$v) {_vm.$set(_vm.$attrs, "value", $$v)},expression:"$attrs.value"}},[_c('pp-button',{attrs:{"type":"icon","icon":"close","absolute":"","right":""},on:{"click":_vm.close}}),_vm._t("content")],2)],1)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/side-overlay/PpSideOverlay.vue?vue&type=template&id=2a173d5a&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__("a9e3");

// EXTERNAL MODULE: ./src/components/button/PpButton.vue + 5 modules
var PpButton = __webpack_require__("251c");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/side-overlay/PpSideOverlay.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var PpSideOverlayvue_type_script_lang_js_ = ({
  name: 'PpSideOverlay',
  components: {
    PpButton: PpButton["default"]
  },
  props: {
    width: {
      type: Number,
      default: 500
    }
  },
  methods: {
    close: function close() {
      this.$emit('input', false);
    }
  }
});
// CONCATENATED MODULE: ./src/components/side-overlay/PpSideOverlay.vue?vue&type=script&lang=js&
 /* harmony default export */ var side_overlay_PpSideOverlayvue_type_script_lang_js_ = (PpSideOverlayvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// EXTERNAL MODULE: ./node_modules/vuetify-loader/lib/runtime/installComponents.js
var installComponents = __webpack_require__("6544");
var installComponents_default = /*#__PURE__*/__webpack_require__.n(installComponents);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("99af");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.fixed.js
var es_string_fixed = __webpack_require__("c7cd");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__("5530");

// EXTERNAL MODULE: ./node_modules/vuetify/src/components/VNavigationDrawer/VNavigationDrawer.sass
var VNavigationDrawer = __webpack_require__("7958");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/components/VImg/VImg.js + 2 modules
var VImg = __webpack_require__("adda");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/mixins/positionable/index.js
var positionable = __webpack_require__("fe6c");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/util/mixins.js
var mixins = __webpack_require__("58df");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/mixins/applicationable/index.js
 // Util


function applicationable(value) {
  var events = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  /* @vue/component */
  return Object(mixins["a" /* default */])(Object(positionable["b" /* factory */])(['absolute', 'fixed'])).extend({
    name: 'applicationable',
    props: {
      app: Boolean
    },
    computed: {
      applicationProperty: function applicationProperty() {
        return value;
      }
    },
    watch: {
      // If previous value was app
      // reset the provided prop
      app: function app(x, prev) {
        prev ? this.removeApplication(true) : this.callUpdate();
      },
      applicationProperty: function applicationProperty(newVal, oldVal) {
        this.$vuetify.application.unregister(this._uid, oldVal);
      }
    },
    activated: function activated() {
      this.callUpdate();
    },
    created: function created() {
      for (var i = 0, length = events.length; i < length; i++) {
        this.$watch(events[i], this.callUpdate);
      }

      this.callUpdate();
    },
    mounted: function mounted() {
      this.callUpdate();
    },
    deactivated: function deactivated() {
      this.removeApplication();
    },
    destroyed: function destroyed() {
      this.removeApplication();
    },
    methods: {
      callUpdate: function callUpdate() {
        if (!this.app) return;
        this.$vuetify.application.register(this._uid, this.applicationProperty, this.updateApplication());
      },
      removeApplication: function removeApplication() {
        var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        if (!force && !this.app) return;
        this.$vuetify.application.unregister(this._uid, this.applicationProperty);
      },
      updateApplication: function updateApplication() {
        return 0;
      }
    }
  });
}
// EXTERNAL MODULE: ./node_modules/vuetify/lib/mixins/colorable/index.js
var colorable = __webpack_require__("a9ad");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/mixins/dependent/index.js
var dependent = __webpack_require__("b848");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/mixins/mobile/index.js
var mobile = __webpack_require__("e4cd");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/mixins/overlayable/index.js
var overlayable = __webpack_require__("e707");

// EXTERNAL MODULE: external {"commonjs":"vue","commonjs2":"vue","root":"Vue"}
var external_commonjs_vue_commonjs2_vue_root_Vue_ = __webpack_require__("8bbf");
var external_commonjs_vue_commonjs2_vue_root_Vue_default = /*#__PURE__*/__webpack_require__.n(external_commonjs_vue_commonjs2_vue_root_Vue_);

// CONCATENATED MODULE: ./node_modules/vuetify/lib/mixins/ssr-bootable/index.js

/**
 * SSRBootable
 *
 * @mixin
 *
 * Used in layout components (drawer, toolbar, content)
 * to avoid an entry animation when using SSR
 */

/* harmony default export */ var ssr_bootable = (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
  name: 'ssr-bootable',
  data: function data() {
    return {
      isBooted: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    // Use setAttribute instead of dataset
    // because dataset does not work well
    // with unit tests
    window.requestAnimationFrame(function () {
      _this.$el.setAttribute('data-booted', 'true');

      _this.isBooted = true;
    });
  }
}));
// EXTERNAL MODULE: ./node_modules/vuetify/lib/mixins/themeable/index.js
var themeable = __webpack_require__("7560");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/directives/click-outside/index.js
var click_outside = __webpack_require__("a293");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/directives/resize/index.js
var resize = __webpack_require__("dc22");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/directives/touch/index.js
var touch = __webpack_require__("c3f0");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/util/helpers.js
var helpers = __webpack_require__("80d2");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VNavigationDrawer/VNavigationDrawer.js




// Styles
 // Components

 // Mixins







 // Directives



 // Utilities



var baseMixins = Object(mixins["a" /* default */])(applicationable('left', ['isActive', 'isMobile', 'miniVariant', 'expandOnHover', 'permanent', 'right', 'temporary', 'width']), colorable["a" /* default */], dependent["a" /* default */], mobile["a" /* default */], overlayable["a" /* default */], ssr_bootable, themeable["a" /* default */]);
/* @vue/component */

/* harmony default export */ var VNavigationDrawer_VNavigationDrawer = (baseMixins.extend({
  name: 'v-navigation-drawer',
  directives: {
    ClickOutside: click_outside["a" /* default */],
    Resize: resize["a" /* default */],
    Touch: touch["a" /* default */]
  },
  provide: function provide() {
    return {
      isInNav: this.tag === 'nav'
    };
  },
  props: {
    bottom: Boolean,
    clipped: Boolean,
    disableResizeWatcher: Boolean,
    disableRouteWatcher: Boolean,
    expandOnHover: Boolean,
    floating: Boolean,
    height: {
      type: [Number, String],
      default: function _default() {
        return this.app ? '100vh' : '100%';
      }
    },
    miniVariant: Boolean,
    miniVariantWidth: {
      type: [Number, String],
      default: 56
    },
    permanent: Boolean,
    right: Boolean,
    src: {
      type: [String, Object],
      default: ''
    },
    stateless: Boolean,
    tag: {
      type: String,
      default: function _default() {
        return this.app ? 'nav' : 'aside';
      }
    },
    temporary: Boolean,
    touchless: Boolean,
    width: {
      type: [Number, String],
      default: 256
    },
    value: null
  },
  data: function data() {
    return {
      isMouseover: false,
      touchArea: {
        left: 0,
        right: 0
      },
      stackMinZIndex: 6
    };
  },
  computed: {
    /**
     * Used for setting an app value from a dynamic
     * property. Called from applicationable.js
     */
    applicationProperty: function applicationProperty() {
      return this.right ? 'right' : 'left';
    },
    classes: function classes() {
      return Object(objectSpread2["a" /* default */])({
        'v-navigation-drawer': true,
        'v-navigation-drawer--absolute': this.absolute,
        'v-navigation-drawer--bottom': this.bottom,
        'v-navigation-drawer--clipped': this.clipped,
        'v-navigation-drawer--close': !this.isActive,
        'v-navigation-drawer--fixed': !this.absolute && (this.app || this.fixed),
        'v-navigation-drawer--floating': this.floating,
        'v-navigation-drawer--is-mobile': this.isMobile,
        'v-navigation-drawer--is-mouseover': this.isMouseover,
        'v-navigation-drawer--mini-variant': this.isMiniVariant,
        'v-navigation-drawer--custom-mini-variant': Number(this.miniVariantWidth) !== 56,
        'v-navigation-drawer--open': this.isActive,
        'v-navigation-drawer--open-on-hover': this.expandOnHover,
        'v-navigation-drawer--right': this.right,
        'v-navigation-drawer--temporary': this.temporary
      }, this.themeClasses);
    },
    computedMaxHeight: function computedMaxHeight() {
      if (!this.hasApp) return null;
      var computedMaxHeight = this.$vuetify.application.bottom + this.$vuetify.application.footer + this.$vuetify.application.bar;
      if (!this.clipped) return computedMaxHeight;
      return computedMaxHeight + this.$vuetify.application.top;
    },
    computedTop: function computedTop() {
      if (!this.hasApp) return 0;
      var computedTop = this.$vuetify.application.bar;
      computedTop += this.clipped ? this.$vuetify.application.top : 0;
      return computedTop;
    },
    computedTransform: function computedTransform() {
      if (this.isActive) return 0;
      if (this.isBottom) return 100;
      return this.right ? 100 : -100;
    },
    computedWidth: function computedWidth() {
      return this.isMiniVariant ? this.miniVariantWidth : this.width;
    },
    hasApp: function hasApp() {
      return this.app && !this.isMobile && !this.temporary;
    },
    isBottom: function isBottom() {
      return this.bottom && this.isMobile;
    },
    isMiniVariant: function isMiniVariant() {
      return !this.expandOnHover && this.miniVariant || this.expandOnHover && !this.isMouseover;
    },
    isMobile: function isMobile() {
      return !this.stateless && !this.permanent && mobile["a" /* default */].options.computed.isMobile.call(this);
    },
    reactsToClick: function reactsToClick() {
      return !this.stateless && !this.permanent && (this.isMobile || this.temporary);
    },
    reactsToMobile: function reactsToMobile() {
      return this.app && !this.disableResizeWatcher && !this.permanent && !this.stateless && !this.temporary;
    },
    reactsToResize: function reactsToResize() {
      return !this.disableResizeWatcher && !this.stateless;
    },
    reactsToRoute: function reactsToRoute() {
      return !this.disableRouteWatcher && !this.stateless && (this.temporary || this.isMobile);
    },
    showOverlay: function showOverlay() {
      return !this.hideOverlay && this.isActive && (this.isMobile || this.temporary);
    },
    styles: function styles() {
      var translate = this.isBottom ? 'translateY' : 'translateX';
      return {
        height: Object(helpers["g" /* convertToUnit */])(this.height),
        top: !this.isBottom ? Object(helpers["g" /* convertToUnit */])(this.computedTop) : 'auto',
        maxHeight: this.computedMaxHeight != null ? "calc(100% - ".concat(Object(helpers["g" /* convertToUnit */])(this.computedMaxHeight), ")") : undefined,
        transform: "".concat(translate, "(").concat(Object(helpers["g" /* convertToUnit */])(this.computedTransform, '%'), ")"),
        width: Object(helpers["g" /* convertToUnit */])(this.computedWidth)
      };
    }
  },
  watch: {
    $route: 'onRouteChange',
    isActive: function isActive(val) {
      this.$emit('input', val);
    },

    /**
     * When mobile changes, adjust the active state
     * only when there has been a previous value
     */
    isMobile: function isMobile(val, prev) {
      !val && this.isActive && !this.temporary && this.removeOverlay();
      if (prev == null || !this.reactsToResize || !this.reactsToMobile) return;
      this.isActive = !val;
    },
    permanent: function permanent(val) {
      // If enabling prop enable the drawer
      if (val) this.isActive = true;
    },
    showOverlay: function showOverlay(val) {
      if (val) this.genOverlay();else this.removeOverlay();
    },
    value: function value(val) {
      if (this.permanent) return;

      if (val == null) {
        this.init();
        return;
      }

      if (val !== this.isActive) this.isActive = val;
    },
    expandOnHover: 'updateMiniVariant',
    isMouseover: function isMouseover(val) {
      this.updateMiniVariant(!val);
    }
  },
  beforeMount: function beforeMount() {
    this.init();
  },
  methods: {
    calculateTouchArea: function calculateTouchArea() {
      var parent = this.$el.parentNode;
      if (!parent) return;
      var parentRect = parent.getBoundingClientRect();
      this.touchArea = {
        left: parentRect.left + 50,
        right: parentRect.right - 50
      };
    },
    closeConditional: function closeConditional() {
      return this.isActive && !this._isDestroyed && this.reactsToClick;
    },
    genAppend: function genAppend() {
      return this.genPosition('append');
    },
    genBackground: function genBackground() {
      var props = {
        height: '100%',
        width: '100%',
        src: this.src
      };
      var image = this.$scopedSlots.img ? this.$scopedSlots.img(props) : this.$createElement(VImg["a" /* default */], {
        props: props
      });
      return this.$createElement('div', {
        staticClass: 'v-navigation-drawer__image'
      }, [image]);
    },
    genDirectives: function genDirectives() {
      var _this = this;

      var directives = [{
        name: 'click-outside',
        value: {
          handler: function handler() {
            _this.isActive = false;
          },
          closeConditional: this.closeConditional,
          include: this.getOpenDependentElements
        }
      }];

      if (!this.touchless && !this.stateless) {
        directives.push({
          name: 'touch',
          value: {
            parent: true,
            left: this.swipeLeft,
            right: this.swipeRight
          }
        });
      }

      return directives;
    },
    genListeners: function genListeners() {
      var _this2 = this;

      var on = {
        transitionend: function transitionend(e) {
          if (e.target !== e.currentTarget) return;

          _this2.$emit('transitionend', e); // IE11 does not support new Event('resize')


          var resizeEvent = document.createEvent('UIEvents');
          resizeEvent.initUIEvent('resize', true, false, window, 0);
          window.dispatchEvent(resizeEvent);
        }
      };

      if (this.miniVariant) {
        on.click = function () {
          return _this2.$emit('update:mini-variant', false);
        };
      }

      if (this.expandOnHover) {
        on.mouseenter = function () {
          return _this2.isMouseover = true;
        };

        on.mouseleave = function () {
          return _this2.isMouseover = false;
        };
      }

      return on;
    },
    genPosition: function genPosition(name) {
      var slot = Object(helpers["s" /* getSlot */])(this, name);
      if (!slot) return slot;
      return this.$createElement('div', {
        staticClass: "v-navigation-drawer__".concat(name)
      }, slot);
    },
    genPrepend: function genPrepend() {
      return this.genPosition('prepend');
    },
    genContent: function genContent() {
      return this.$createElement('div', {
        staticClass: 'v-navigation-drawer__content'
      }, this.$slots.default);
    },
    genBorder: function genBorder() {
      return this.$createElement('div', {
        staticClass: 'v-navigation-drawer__border'
      });
    },
    init: function init() {
      if (this.permanent) {
        this.isActive = true;
      } else if (this.stateless || this.value != null) {
        this.isActive = this.value;
      } else if (!this.temporary) {
        this.isActive = !this.isMobile;
      }
    },
    onRouteChange: function onRouteChange() {
      if (this.reactsToRoute && this.closeConditional()) {
        this.isActive = false;
      }
    },
    swipeLeft: function swipeLeft(e) {
      if (this.isActive && this.right) return;
      this.calculateTouchArea();
      if (Math.abs(e.touchendX - e.touchstartX) < 100) return;
      if (this.right && e.touchstartX >= this.touchArea.right) this.isActive = true;else if (!this.right && this.isActive) this.isActive = false;
    },
    swipeRight: function swipeRight(e) {
      if (this.isActive && !this.right) return;
      this.calculateTouchArea();
      if (Math.abs(e.touchendX - e.touchstartX) < 100) return;
      if (!this.right && e.touchstartX <= this.touchArea.left) this.isActive = true;else if (this.right && this.isActive) this.isActive = false;
    },

    /**
     * Update the application layout
     */
    updateApplication: function updateApplication() {
      if (!this.isActive || this.isMobile || this.temporary || !this.$el) return 0;
      var width = Number(this.computedWidth);
      return isNaN(width) ? this.$el.clientWidth : width;
    },
    updateMiniVariant: function updateMiniVariant(val) {
      if (this.miniVariant !== val) this.$emit('update:mini-variant', val);
    }
  },
  render: function render(h) {
    var children = [this.genPrepend(), this.genContent(), this.genAppend(), this.genBorder()];
    if (this.src || Object(helpers["s" /* getSlot */])(this, 'img')) children.unshift(this.genBackground());
    return h(this.tag, this.setBackgroundColor(this.color, {
      class: this.classes,
      style: this.styles,
      directives: this.genDirectives(),
      on: this.genListeners()
    }), children);
  }
}));
// EXTERNAL MODULE: ./node_modules/vuetify/lib/components/VOverlay/VOverlay.js
var VOverlay = __webpack_require__("a797");

// CONCATENATED MODULE: ./src/components/side-overlay/PpSideOverlay.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  side_overlay_PpSideOverlayvue_type_script_lang_js_,
  PpSideOverlayvue_type_template_id_2a173d5a_render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var PpSideOverlay = __webpack_exports__["default"] = (component.exports);

/* vuetify-loader */



installComponents_default()(component, {VNavigationDrawer: VNavigationDrawer_VNavigationDrawer,VOverlay: VOverlay["a" /* default */]})


/***/ }),

/***/ "520e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpDialogConsent_vue_vue_type_style_index_0_id_a1f58fb8_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("9c8a");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpDialogConsent_vue_vue_type_style_index_0_id_a1f58fb8_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpDialogConsent_vue_vue_type_style_index_0_id_a1f58fb8_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "5292":
/***/ (function(module, exports, __webpack_require__) {

var lastDayOfWeek = __webpack_require__("cb96")

/**
 * @category ISO Week Helpers
 * @summary Return the last day of an ISO week for the given date.
 *
 * @description
 * Return the last day of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the last day of an ISO week
 *
 * @example
 * // The last day of an ISO week for 2 September 2014 11:55:00:
 * var result = lastDayOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Sep 07 2014 00:00:00
 */
function lastDayOfISOWeek (dirtyDate) {
  return lastDayOfWeek(dirtyDate, {weekStartsOn: 1})
}

module.exports = lastDayOfISOWeek


/***/ }),

/***/ "52af":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c662cfac-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/input/search/PpInputSearch.vue?vue&type=template&id=9f96eb4e&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-autocomplete',_vm._g(_vm._b({ref:"autocomplete",staticClass:"pp-input-search",attrs:{"cache-items":false,"clearable":true,"hide-no-data":_vm.hideNoData,"item-text":_vm.itemText,"item-value":_vm.itemValue,"items":_vm.itemsToShow,"error-messages":_vm.errorMessages,"loading":_vm.loading,"hide-details":_vm.hideDetails,"no-data-text":_vm.noDataText,"no-filter":_vm.noFilter,"placeholder":_vm.placeholder,"ripple":false,"search-input":_vm.search,"append-icon":"","clear-icon":"mdi-close","outlined":"","filled":""},on:{"update:searchInput":function($event){_vm.search=$event},"update:search-input":function($event){_vm.search=$event},"input":_vm.onSelected,"click:clear":_vm.clearSearch},scopedSlots:_vm._u([{key:"prepend-inner",fn:function(){return [_c('i',{staticClass:"pp-icon-search"})]},proxy:true},{key:"no-data",fn:function(){return [_c('div',{staticClass:"pa-5 text-center"},[(_vm.noDataIcon)?_c('i',{class:("pp-icon-" + _vm.noDataIcon)}):_vm._e(),_c('p',{staticClass:"mb-0"},[_vm._v(" "+_vm._s(_vm.noDataText)+" ")])])]},proxy:true},_vm._l((_vm.$scopedSlots),function(_,slot){return {key:slot,fn:function(scope){return [_vm._t(slot,null,null,scope)]}}})],null,true),model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},'v-autocomplete',_vm.$attrs,false),_vm.$listeners),[_vm._l((_vm.$slots),function(_,slot){return _vm._t(slot,null,{"slot":slot})})],2)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/input/search/PpInputSearch.vue?vue&type=template&id=9f96eb4e&scoped=true&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__("a9e3");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__("ac1f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.search.js
var es_string_search = __webpack_require__("841c");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/input/search/PpInputSearch.vue?vue&type=script&lang=js&



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var PpInputSearchvue_type_script_lang_js_ = ({
  name: 'PpInputSearch',
  props: {
    /**
     * Items to show after query results
     */
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },

    /**
     * Shows to the user the search is loading
     */
    loading: {
      type: Boolean,
      default: false
    },

    /**
     * The placeholder shown in the input
     */
    placeholder: {
      type: String,
      default: 'Search'
    },

    /**
     * Set property of items’s text value
     */
    itemText: {
      type: String,
      default: 'text'
    },

    /**
     * Set property of items’s value
     */
    itemValue: {
      type: String,
      default: 'value'
    },

    /**
     * Any error messages such as required, validation, etc...
     */
    errorMessages: {
      type: Array,
      default: function _default() {
        return [];
      }
    },

    /**
     * The minimum character count before emitting query
     */
    minCharacter: {
      type: Number,
      default: 2
    },

    /**
     * Hides hint and validation errors
     */
    hideDetails: {
      type: [String, Boolean],
      default: true
    },
    noDataText: {
      type: String,
      default: 'Record not found.'
    },
    noDataIcon: {
      type: String,
      default: ''
    },

    /**
     * When using server side filtering this should be enabled
     */
    noFilter: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      value: '',
      search: null,
      itemsToShow: [],
      hideNoData: true
    };
  },
  watch: {
    search: function search(val) {
      val && val.length > this.minCharacter && !this.value && this.runQuery(val);
    },
    loading: function loading(isLoading) {
      if (isLoading === false) {
        if (this.items.length > 0) {
          this.itemsToShow = this.items;
        } else {
          this.hideNoData = false;
        }
      }
    }
  },
  methods: {
    runQuery: function runQuery(v) {
      this.$emit('query', v);
    },
    clearSearch: function clearSearch() {
      this.search = '';
      this.itemsToShow = [];
      this.hideNoData = true;
      this.$emit('clear-search');
    },
    onSelected: function onSelected() {
      if (this.value) {
        this.$emit('selected', this.value);
      }
    }
  }
});
// CONCATENATED MODULE: ./src/components/input/search/PpInputSearch.vue?vue&type=script&lang=js&
 /* harmony default export */ var search_PpInputSearchvue_type_script_lang_js_ = (PpInputSearchvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/input/search/PpInputSearch.vue?vue&type=style&index=0&id=9f96eb4e&lang=scss&scoped=true&
var PpInputSearchvue_type_style_index_0_id_9f96eb4e_lang_scss_scoped_true_ = __webpack_require__("6371");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// EXTERNAL MODULE: ./node_modules/vuetify-loader/lib/runtime/installComponents.js
var installComponents = __webpack_require__("6544");
var installComponents_default = /*#__PURE__*/__webpack_require__.n(installComponents);

// EXTERNAL MODULE: ./node_modules/vuetify/lib/components/VAutocomplete/VAutocomplete.js
var VAutocomplete = __webpack_require__("c6a6");

// CONCATENATED MODULE: ./src/components/input/search/PpInputSearch.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  search_PpInputSearchvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "9f96eb4e",
  null
  
)

/* harmony default export */ var PpInputSearch = __webpack_exports__["default"] = (component.exports);

/* vuetify-loader */


installComponents_default()(component, {VAutocomplete: VAutocomplete["a" /* default */]})


/***/ }),

/***/ "52b4":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.theme--light.v-subheader{color:var(--pp-text-secondary,#2b2b2b)}.theme--dark.v-subheader{color:hsla(0,0%,100%,.7)}.v-subheader{align-items:center;display:flex;height:48px;font-size:1rem;font-weight:400;padding:0 16px 0 16px}.v-subheader--inset{margin-left:56px}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "52cf":
/***/ (function(module, exports, __webpack_require__) {

var buildDistanceInWordsLocale = __webpack_require__("2d96")
var buildFormatLocale = __webpack_require__("e830")

/**
 * @category Locales
 * @summary English locale.
 */
module.exports = {
  distanceInWords: buildDistanceInWordsLocale(),
  format: buildFormatLocale()
}


/***/ }),

/***/ "5306":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("d052");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("2633c2ef", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "5311":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _directives_ripple__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("5607");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("8bbf");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_1__);
// Directives
 // Types


/* harmony default export */ __webpack_exports__["a"] = (vue__WEBPACK_IMPORTED_MODULE_1___default.a.extend({
  name: 'rippleable',
  directives: {
    ripple: _directives_ripple__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]
  },
  props: {
    ripple: {
      type: [Boolean, Object],
      default: true
    }
  },
  methods: {
    genRipple: function genRipple() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (!this.ripple) return null;
      data.staticClass = 'v-input--selection-controls__ripple';
      data.directives = data.directives || [];
      data.directives.push({
        name: 'ripple',
        value: {
          center: true
        }
      });
      return this.$createElement('div', data);
    }
  }
}));

/***/ }),

/***/ "5319":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fixRegExpWellKnownSymbolLogic = __webpack_require__("d784");
var anObject = __webpack_require__("825a");
var toLength = __webpack_require__("50c4");
var toInteger = __webpack_require__("a691");
var requireObjectCoercible = __webpack_require__("1d80");
var advanceStringIndex = __webpack_require__("8aa5");
var getSubstitution = __webpack_require__("0cb2");
var regExpExec = __webpack_require__("14c3");

var max = Math.max;
var min = Math.min;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
fixRegExpWellKnownSymbolLogic('replace', 2, function (REPLACE, nativeReplace, maybeCallNative, reason) {
  var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = reason.REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE;
  var REPLACE_KEEPS_$0 = reason.REPLACE_KEEPS_$0;
  var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? '$' : '$0';

  return [
    // `String.prototype.replace` method
    // https://tc39.es/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = requireObjectCoercible(this);
      var replacer = searchValue == undefined ? undefined : searchValue[REPLACE];
      return replacer !== undefined
        ? replacer.call(searchValue, O, replaceValue)
        : nativeReplace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      if (
        (!REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE && REPLACE_KEEPS_$0) ||
        (typeof replaceValue === 'string' && replaceValue.indexOf(UNSAFE_SUBSTITUTE) === -1)
      ) {
        var res = maybeCallNative(nativeReplace, regexp, this, replaceValue);
        if (res.done) return res.value;
      }

      var rx = anObject(regexp);
      var S = String(this);

      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);

      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;

        results.push(result);
        if (!global) break;

        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }

      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];

        var matched = String(result[0]);
        var position = max(min(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];
});


/***/ }),

/***/ "5332":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("dd48");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("2156c014", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "53ca":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _typeof; });
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("a4d3");
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("e01a");
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("d28b");
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("e260");
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("d3b7");
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("3ca3");
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("ddb0");
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_6__);







function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

/***/ }),

/***/ "53e6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c662cfac-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/upload-history-card/PpUploadHistoryCard.vue?vue&type=template&id=ce8c15aa&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pp-info-card',{attrs:{"status":_vm.status},scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('pp-row',{staticClass:"align-center"},[_c('pp-col',{attrs:{"cols":"10","sm":"11"}},[_c('pp-row',[_c('pp-col',{staticClass:"align-center d-flex pt-0",attrs:{"cols":"12"}},[_c('h2',{staticClass:"text-h2 d-inline text-truncate"},[_vm._v(" "+_vm._s(_vm.fileName)+" ")]),(_vm.hasErrors)?_c('pp-status-chip',{staticClass:"ml-3",attrs:{"status":"error","text":"Error"}}):_vm._e()],1),_c('pp-col',{staticClass:"d-flex align-center",attrs:{"cols":"12","md":"3","lg":"3"}},[_c('i',{staticClass:"pp-icon-patient mt-1 mr-1"}),_vm._v(" "+_vm._s(_vm.recordCount)+" ")]),_c('pp-col',{staticClass:"d-flex align-center"},[_c('i',{staticClass:"pp-icon-arrow-circle-up mt-1 mr-2"}),_c('span',{staticClass:"hidden-sm-and-down mr-1"},[_vm._v("Uploaded")]),_vm._v(" "+_vm._s(_vm.uploadedTime)+" ")])],1)],1),(_vm.hasErrors)?_c('pp-col',{attrs:{"cols":"2","sm":"1"}},[_c('pp-tooltip',{attrs:{"text":"Error Report","position":"top"}},[_c('pp-button',{attrs:{"type":"secondary","icon":"file-draft"},on:{"click":_vm.goToReport}})],1)],1):_vm._e()],1)]},proxy:true}])})}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/upload-history-card/PpUploadHistoryCard.vue?vue&type=template&id=ce8c15aa&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("99af");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__("a9e3");

// EXTERNAL MODULE: ./src/components/row/PpRow.vue + 4 modules
var PpRow = __webpack_require__("eeac");

// EXTERNAL MODULE: ./src/components/col/PpCol.vue + 4 modules
var PpCol = __webpack_require__("8ecc");

// EXTERNAL MODULE: ./src/components/tooltip/PpTooltip.vue + 6 modules
var PpTooltip = __webpack_require__("284e");

// EXTERNAL MODULE: ./src/components/info-card/PpInfoCard.vue + 5 modules
var PpInfoCard = __webpack_require__("16c9");

// EXTERNAL MODULE: ./src/components/button/PpButton.vue + 5 modules
var PpButton = __webpack_require__("251c");

// EXTERNAL MODULE: ./src/components/statusChip/PpStatusChip.vue + 4 modules
var PpStatusChip = __webpack_require__("e921");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/upload-history-card/PpUploadHistoryCard.vue?vue&type=script&lang=js&


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var PpUploadHistoryCardvue_type_script_lang_js_ = ({
  name: 'PpUploadHistoryCard',
  components: {
    'pp-row': PpRow["default"],
    'pp-col': PpCol["default"],
    'pp-tooltip': PpTooltip["default"],
    'pp-info-card': PpInfoCard["default"],
    'pp-button': PpButton["default"],
    'pp-status-chip': PpStatusChip["default"]
  },
  props: {
    fileName: {
      type: String,
      required: true
    },
    hasErrors: {
      type: Boolean,
      default: false
    },
    createdAt: {
      type: String,
      required: true
    },
    count: {
      type: Number,
      required: true
    }
  },
  computed: {
    status: function status() {
      return this.hasErrors ? 'error' : '';
    },
    recordCount: function recordCount() {
      return "".concat(this.count, " Record").concat(this.count > 1 ? 's' : '');
    },
    uploadedTime: function uploadedTime() {
      var formatDate = new Intl.DateTimeFormat('en-US', {
        month: 'short',
        year: 'numeric',
        day: 'numeric'
      }).format(new Date(this.createdAt));
      var formatTime = new Intl.DateTimeFormat('en-US', {
        hour: 'numeric',
        minute: 'numeric'
      }).format(new Date(this.createdAt));
      return "".concat(formatDate, " at ").concat(formatTime);
    }
  },
  methods: {
    goToReport: function goToReport() {
      this.$emit('go-to-report');
    }
  }
});
// CONCATENATED MODULE: ./src/components/upload-history-card/PpUploadHistoryCard.vue?vue&type=script&lang=js&
 /* harmony default export */ var upload_history_card_PpUploadHistoryCardvue_type_script_lang_js_ = (PpUploadHistoryCardvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/upload-history-card/PpUploadHistoryCard.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  upload_history_card_PpUploadHistoryCardvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var PpUploadHistoryCard = __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "5416":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("c8d5")

/**
 * @category Month Helpers
 * @summary Get the number of days in a month of the given date.
 *
 * @description
 * Get the number of days in a month of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the number of days in a month
 *
 * @example
 * // How many days are in February 2000?
 * var result = getDaysInMonth(new Date(2000, 1))
 * //=> 29
 */
function getDaysInMonth (dirtyDate) {
  var date = parse(dirtyDate)
  var year = date.getFullYear()
  var monthIndex = date.getMonth()
  var lastDayOfMonth = new Date(0)
  lastDayOfMonth.setFullYear(year, monthIndex + 1, 0)
  lastDayOfMonth.setHours(0, 0, 0, 0)
  return lastDayOfMonth.getDate()
}

module.exports = getDaysInMonth


/***/ }),

/***/ "5465":
/***/ (function(module, exports) {

var MILLISECONDS_IN_MINUTE = 60000

/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */
module.exports = function getTimezoneOffsetInMilliseconds (dirtyDate) {
  var date = new Date(dirtyDate.getTime())
  var baseTimezoneOffset = date.getTimezoneOffset()
  date.setSeconds(0, 0)
  var millisecondsPartOfTimezoneOffset = date.getTime() % MILLISECONDS_IN_MINUTE

  return baseTimezoneOffset * MILLISECONDS_IN_MINUTE + millisecondsPartOfTimezoneOffset
}


/***/ }),

/***/ "5530":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _objectSpread2; });
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("a4d3");
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("4de4");
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("4160");
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("e439");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("dbb4");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("b64b");
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("159b");
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("ade3");









function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

/***/ }),

/***/ "5607":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Ripple */
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("99af");
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("b0c0");
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("a9e3");
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("d3b7");
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("25f0");
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _src_directives_ripple_VRipple_sass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("7435");
/* harmony import */ var _src_directives_ripple_VRipple_sass__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_src_directives_ripple_VRipple_sass__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("80d2");





// Styles
 // Utilities



var DELAY_RIPPLE = 80;

function transform(el, value) {
  el.style.transform = value;
  el.style.webkitTransform = value;
}

function opacity(el, value) {
  el.style.opacity = value.toString();
}

function isTouchEvent(e) {
  return e.constructor.name === 'TouchEvent';
}

function isKeyboardEvent(e) {
  return e.constructor.name === 'KeyboardEvent';
}

var calculate = function calculate(e, el) {
  var value = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var localX = 0;
  var localY = 0;

  if (!isKeyboardEvent(e)) {
    var offset = el.getBoundingClientRect();
    var target = isTouchEvent(e) ? e.touches[e.touches.length - 1] : e;
    localX = target.clientX - offset.left;
    localY = target.clientY - offset.top;
  }

  var radius = 0;
  var scale = 0.3;

  if (el._ripple && el._ripple.circle) {
    scale = 0.15;
    radius = el.clientWidth / 2;
    radius = value.center ? radius : radius + Math.sqrt(Math.pow(localX - radius, 2) + Math.pow(localY - radius, 2)) / 4;
  } else {
    radius = Math.sqrt(Math.pow(el.clientWidth, 2) + Math.pow(el.clientHeight, 2)) / 2;
  }

  var centerX = "".concat((el.clientWidth - radius * 2) / 2, "px");
  var centerY = "".concat((el.clientHeight - radius * 2) / 2, "px");
  var x = value.center ? centerX : "".concat(localX - radius, "px");
  var y = value.center ? centerY : "".concat(localY - radius, "px");
  return {
    radius: radius,
    scale: scale,
    x: x,
    y: y,
    centerX: centerX,
    centerY: centerY
  };
};

var ripples = {
  /* eslint-disable max-statements */
  show: function show(e, el) {
    var value = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    if (!el._ripple || !el._ripple.enabled) {
      return;
    }

    var container = document.createElement('span');
    var animation = document.createElement('span');
    container.appendChild(animation);
    container.className = 'v-ripple__container';

    if (value.class) {
      container.className += " ".concat(value.class);
    }

    var _calculate = calculate(e, el, value),
        radius = _calculate.radius,
        scale = _calculate.scale,
        x = _calculate.x,
        y = _calculate.y,
        centerX = _calculate.centerX,
        centerY = _calculate.centerY;

    var size = "".concat(radius * 2, "px");
    animation.className = 'v-ripple__animation';
    animation.style.width = size;
    animation.style.height = size;
    el.appendChild(container);
    var computed = window.getComputedStyle(el);

    if (computed && computed.position === 'static') {
      el.style.position = 'relative';
      el.dataset.previousPosition = 'static';
    }

    animation.classList.add('v-ripple__animation--enter');
    animation.classList.add('v-ripple__animation--visible');
    transform(animation, "translate(".concat(x, ", ").concat(y, ") scale3d(").concat(scale, ",").concat(scale, ",").concat(scale, ")"));
    opacity(animation, 0);
    animation.dataset.activated = String(performance.now());
    setTimeout(function () {
      animation.classList.remove('v-ripple__animation--enter');
      animation.classList.add('v-ripple__animation--in');
      transform(animation, "translate(".concat(centerX, ", ").concat(centerY, ") scale3d(1,1,1)"));
      opacity(animation, 0.25);
    }, 0);
  },
  hide: function hide(el) {
    if (!el || !el._ripple || !el._ripple.enabled) return;
    var ripples = el.getElementsByClassName('v-ripple__animation');
    if (ripples.length === 0) return;
    var animation = ripples[ripples.length - 1];
    if (animation.dataset.isHiding) return;else animation.dataset.isHiding = 'true';
    var diff = performance.now() - Number(animation.dataset.activated);
    var delay = Math.max(250 - diff, 0);
    setTimeout(function () {
      animation.classList.remove('v-ripple__animation--in');
      animation.classList.add('v-ripple__animation--out');
      opacity(animation, 0);
      setTimeout(function () {
        var ripples = el.getElementsByClassName('v-ripple__animation');

        if (ripples.length === 1 && el.dataset.previousPosition) {
          el.style.position = el.dataset.previousPosition;
          delete el.dataset.previousPosition;
        }

        animation.parentNode && el.removeChild(animation.parentNode);
      }, 300);
    }, delay);
  }
};

function isRippleEnabled(value) {
  return typeof value === 'undefined' || !!value;
}

function rippleShow(e) {
  var value = {};
  var element = e.currentTarget;
  if (!element || !element._ripple || element._ripple.touched) return;

  if (isTouchEvent(e)) {
    element._ripple.touched = true;
    element._ripple.isTouch = true;
  } else {
    // It's possible for touch events to fire
    // as mouse events on Android/iOS, this
    // will skip the event call if it has
    // already been registered as touch
    if (element._ripple.isTouch) return;
  }

  value.center = element._ripple.centered || isKeyboardEvent(e);

  if (element._ripple.class) {
    value.class = element._ripple.class;
  }

  if (isTouchEvent(e)) {
    // already queued that shows or hides the ripple
    if (element._ripple.showTimerCommit) return;

    element._ripple.showTimerCommit = function () {
      ripples.show(e, element, value);
    };

    element._ripple.showTimer = window.setTimeout(function () {
      if (element && element._ripple && element._ripple.showTimerCommit) {
        element._ripple.showTimerCommit();

        element._ripple.showTimerCommit = null;
      }
    }, DELAY_RIPPLE);
  } else {
    ripples.show(e, element, value);
  }
}

function rippleHide(e) {
  var element = e.currentTarget;
  if (!element || !element._ripple) return;
  window.clearTimeout(element._ripple.showTimer); // The touch interaction occurs before the show timer is triggered.
  // We still want to show ripple effect.

  if (e.type === 'touchend' && element._ripple.showTimerCommit) {
    element._ripple.showTimerCommit();

    element._ripple.showTimerCommit = null; // re-queue ripple hiding

    element._ripple.showTimer = setTimeout(function () {
      rippleHide(e);
    });
    return;
  }

  window.setTimeout(function () {
    if (element._ripple) {
      element._ripple.touched = false;
    }
  });
  ripples.hide(element);
}

function rippleCancelShow(e) {
  var element = e.currentTarget;
  if (!element || !element._ripple) return;

  if (element._ripple.showTimerCommit) {
    element._ripple.showTimerCommit = null;
  }

  window.clearTimeout(element._ripple.showTimer);
}

var keyboardRipple = false;

function keyboardRippleShow(e) {
  if (!keyboardRipple && (e.keyCode === _util_helpers__WEBPACK_IMPORTED_MODULE_6__[/* keyCodes */ "x"].enter || e.keyCode === _util_helpers__WEBPACK_IMPORTED_MODULE_6__[/* keyCodes */ "x"].space)) {
    keyboardRipple = true;
    rippleShow(e);
  }
}

function keyboardRippleHide(e) {
  keyboardRipple = false;
  rippleHide(e);
}

function updateRipple(el, binding, wasEnabled) {
  var enabled = isRippleEnabled(binding.value);

  if (!enabled) {
    ripples.hide(el);
  }

  el._ripple = el._ripple || {};
  el._ripple.enabled = enabled;
  var value = binding.value || {};

  if (value.center) {
    el._ripple.centered = true;
  }

  if (value.class) {
    el._ripple.class = binding.value.class;
  }

  if (value.circle) {
    el._ripple.circle = value.circle;
  }

  if (enabled && !wasEnabled) {
    el.addEventListener('touchstart', rippleShow, {
      passive: true
    });
    el.addEventListener('touchend', rippleHide, {
      passive: true
    });
    el.addEventListener('touchmove', rippleCancelShow, {
      passive: true
    });
    el.addEventListener('touchcancel', rippleHide);
    el.addEventListener('mousedown', rippleShow);
    el.addEventListener('mouseup', rippleHide);
    el.addEventListener('mouseleave', rippleHide);
    el.addEventListener('keydown', keyboardRippleShow);
    el.addEventListener('keyup', keyboardRippleHide); // Anchor tags can be dragged, causes other hides to fail - #1537

    el.addEventListener('dragstart', rippleHide, {
      passive: true
    });
  } else if (!enabled && wasEnabled) {
    removeListeners(el);
  }
}

function removeListeners(el) {
  el.removeEventListener('mousedown', rippleShow);
  el.removeEventListener('touchstart', rippleShow);
  el.removeEventListener('touchend', rippleHide);
  el.removeEventListener('touchmove', rippleCancelShow);
  el.removeEventListener('touchcancel', rippleHide);
  el.removeEventListener('mouseup', rippleHide);
  el.removeEventListener('mouseleave', rippleHide);
  el.removeEventListener('keydown', keyboardRippleShow);
  el.removeEventListener('keyup', keyboardRippleHide);
  el.removeEventListener('dragstart', rippleHide);
}

function directive(el, binding, node) {
  updateRipple(el, binding, false);

  if (false) {}
}

function unbind(el) {
  delete el._ripple;
  removeListeners(el);
}

function update(el, binding) {
  if (binding.value === binding.oldValue) {
    return;
  }

  var wasEnabled = isRippleEnabled(binding.oldValue);
  updateRipple(el, binding, wasEnabled);
}

var Ripple = {
  bind: directive,
  unbind: unbind,
  update: update
};
/* harmony default export */ __webpack_exports__["a"] = (Ripple);

/***/ }),

/***/ "5692":
/***/ (function(module, exports, __webpack_require__) {

var IS_PURE = __webpack_require__("c430");
var store = __webpack_require__("c6cd");

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.8.3',
  mode: IS_PURE ? 'pure' : 'global',
  copyright: '© 2021 Denis Pushkarev (zloirock.ru)'
});


/***/ }),

/***/ "5692e":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.i, "@import url(https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css);"]);
exports.push([module.i, "@import url(https://cdn-prd.patientpop.com/pp-icon-font/v1.6.0/pp-icon-font.css);"]);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.theme--light.v-input[data-v-9f96eb4e]:not(.theme--light.v-input--is-focused)  fieldset{border-color:transparent}.theme--light.v-input[data-v-9f96eb4e]:not(.theme--light.v-input--is-focused):not(.theme--light.v-input--is-disabled){--text-primary:#2b2b2b}.theme--light.v-input .pp-input-text__error-icon[data-v-9f96eb4e]{color:#b51a2c}.theme--light.v-input:not(.theme--light.v-input--is-focused):not(.theme--light.v-input--is-disabled).error--text[data-v-9f96eb4e]{--pp-text-field-fill:#fceeee}.theme--light.v-input.pp-input-select--white-bg[data-v-9f96eb4e]:not(.theme--light.v-input--is-disabled),.theme--light.v-input.pp-input-text--white-bg[data-v-9f96eb4e]:not(.theme--light.v-input--is-disabled){--pp-text-placeholder:#545454}.theme--light.v-input.pp-input-select--white-bg[data-v-9f96eb4e]:not(.theme--light.v-input--is-disabled):not(.theme--light.v-input--is-focused):not(.error--text),.theme--light.v-input.pp-input-text--white-bg[data-v-9f96eb4e]:not(.theme--light.v-input--is-disabled):not(.theme--light.v-input--is-focused):not(.error--text){--pp-text-field-fill:#fff}.theme--light.v-input.pp-input-select--white-bg[data-v-9f96eb4e]:not(.theme--light.v-input--is-disabled):not(.theme--light.v-input--is-focused):not(.error--text)  .theme--light.v-input__slot:hover,.theme--light.v-input.pp-input-text--white-bg[data-v-9f96eb4e]:not(.theme--light.v-input--is-disabled):not(.theme--light.v-input--is-focused):not(.error--text)  .theme--light.v-input__slot:hover{--pp-text-field-fill-on-hover:#fff}.theme--light.v-input.theme--light.v-input--is-focused[data-v-9f96eb4e]{--pp-text-field-fill:#fff}.theme--light.v-input.theme--light.v-input--is-disabled[data-v-9f96eb4e]{--pp-text-disabled:#9a9a9a;--pp-text-field-fill:#f6f6f6;--pp-text-placeholder:#9a9a9a}.theme--light.v-input[data-v-9f96eb4e]  input::-moz-placeholder,.theme--light.v-input[data-v-9f96eb4e]  textarea::-moz-placeholder{color:var(--pp-text-placeholder,#545454)}.theme--light.v-input[data-v-9f96eb4e]  input:-ms-input-placeholder,.theme--light.v-input[data-v-9f96eb4e]  textarea:-ms-input-placeholder{color:var(--pp-text-placeholder,#545454)}.theme--light.v-input[data-v-9f96eb4e]  input::placeholder,.theme--light.v-input[data-v-9f96eb4e]  textarea::placeholder{color:var(--pp-text-placeholder,#545454)}.theme--light.v-input[data-v-9f96eb4e]  .theme--light.v-input__append-inner{margin-bottom:auto;margin-top:auto}.theme--light.v-input[data-v-9f96eb4e]  .theme--light.v-input__append-inner i:before{display:block}.pp-input-search[data-v-9f96eb4e]  .mdi-close{margin-top:-.35em}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "56ef":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("d066");
var getOwnPropertyNamesModule = __webpack_require__("241c");
var getOwnPropertySymbolsModule = __webpack_require__("7418");
var anObject = __webpack_require__("825a");

// all object keys, includes non-enumerable and symbols
module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
};


/***/ }),

/***/ "56f0":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><rect x=\"1\" y=\"4\" width=\"22\" height=\"16\" rx=\"3\" fill=\"white\" stroke=\"#079CB2\" stroke-width=\"2\"></rect><rect x=\"2\" y=\"8\" width=\"20\" height=\"3\" fill=\"#D5EAFD\"></rect><rect x=\"4\" y=\"15\" width=\"6\" height=\"2\" rx=\"1\" fill=\"#079CB2\"></rect></svg>";

/***/ }),

/***/ "57e3":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.v-textarea textarea{align-self:stretch;flex:1 1 auto;line-height:1.75rem;max-width:100%;min-height:32px;outline:none;padding:0;width:100%}.v-textarea .v-text-field__prefix,.v-textarea .v-text-field__suffix{padding-top:2px;align-self:start}.v-textarea.v-text-field--box .v-text-field__prefix,.v-textarea.v-text-field--box textarea,.v-textarea.v-text-field--enclosed .v-text-field__prefix,.v-textarea.v-text-field--enclosed textarea{margin-top:24px}.v-textarea.v-text-field--box.v-text-field--outlined:not(.v-input--dense) .v-text-field__prefix,.v-textarea.v-text-field--box.v-text-field--outlined:not(.v-input--dense) .v-text-field__suffix,.v-textarea.v-text-field--box.v-text-field--outlined:not(.v-input--dense) textarea,.v-textarea.v-text-field--box.v-text-field--single-line:not(.v-input--dense) .v-text-field__prefix,.v-textarea.v-text-field--box.v-text-field--single-line:not(.v-input--dense) .v-text-field__suffix,.v-textarea.v-text-field--box.v-text-field--single-line:not(.v-input--dense) textarea,.v-textarea.v-text-field--enclosed.v-text-field--outlined:not(.v-input--dense) .v-text-field__prefix,.v-textarea.v-text-field--enclosed.v-text-field--outlined:not(.v-input--dense) .v-text-field__suffix,.v-textarea.v-text-field--enclosed.v-text-field--outlined:not(.v-input--dense) textarea,.v-textarea.v-text-field--enclosed.v-text-field--single-line:not(.v-input--dense) .v-text-field__prefix,.v-textarea.v-text-field--enclosed.v-text-field--single-line:not(.v-input--dense) .v-text-field__suffix,.v-textarea.v-text-field--enclosed.v-text-field--single-line:not(.v-input--dense) textarea{margin-top:var(--pp-textarea-margin-top,10px)}.v-textarea.v-text-field--box.v-text-field--outlined:not(.v-input--dense) .v-label,.v-textarea.v-text-field--box.v-text-field--single-line:not(.v-input--dense) .v-label,.v-textarea.v-text-field--enclosed.v-text-field--outlined:not(.v-input--dense) .v-label,.v-textarea.v-text-field--enclosed.v-text-field--single-line:not(.v-input--dense) .v-label{top:18px}.v-textarea.v-text-field--box.v-text-field--outlined.v-input--dense .v-text-field__prefix,.v-textarea.v-text-field--box.v-text-field--outlined.v-input--dense .v-text-field__suffix,.v-textarea.v-text-field--box.v-text-field--outlined.v-input--dense textarea,.v-textarea.v-text-field--box.v-text-field--single-line.v-input--dense .v-text-field__prefix,.v-textarea.v-text-field--box.v-text-field--single-line.v-input--dense .v-text-field__suffix,.v-textarea.v-text-field--box.v-text-field--single-line.v-input--dense textarea,.v-textarea.v-text-field--enclosed.v-text-field--outlined.v-input--dense .v-text-field__prefix,.v-textarea.v-text-field--enclosed.v-text-field--outlined.v-input--dense .v-text-field__suffix,.v-textarea.v-text-field--enclosed.v-text-field--outlined.v-input--dense textarea,.v-textarea.v-text-field--enclosed.v-text-field--single-line.v-input--dense .v-text-field__prefix,.v-textarea.v-text-field--enclosed.v-text-field--single-line.v-input--dense .v-text-field__suffix,.v-textarea.v-text-field--enclosed.v-text-field--single-line.v-input--dense textarea{margin-top:6px}.v-textarea.v-text-field--box.v-text-field--outlined.v-input--dense .v-input__append-inner,.v-textarea.v-text-field--box.v-text-field--outlined.v-input--dense .v-input__append-outer,.v-textarea.v-text-field--box.v-text-field--outlined.v-input--dense .v-input__prepend-inner,.v-textarea.v-text-field--box.v-text-field--outlined.v-input--dense .v-input__prepend-outer,.v-textarea.v-text-field--box.v-text-field--single-line.v-input--dense .v-input__append-inner,.v-textarea.v-text-field--box.v-text-field--single-line.v-input--dense .v-input__append-outer,.v-textarea.v-text-field--box.v-text-field--single-line.v-input--dense .v-input__prepend-inner,.v-textarea.v-text-field--box.v-text-field--single-line.v-input--dense .v-input__prepend-outer,.v-textarea.v-text-field--enclosed.v-text-field--outlined.v-input--dense .v-input__append-inner,.v-textarea.v-text-field--enclosed.v-text-field--outlined.v-input--dense .v-input__append-outer,.v-textarea.v-text-field--enclosed.v-text-field--outlined.v-input--dense .v-input__prepend-inner,.v-textarea.v-text-field--enclosed.v-text-field--outlined.v-input--dense .v-input__prepend-outer,.v-textarea.v-text-field--enclosed.v-text-field--single-line.v-input--dense .v-input__append-inner,.v-textarea.v-text-field--enclosed.v-text-field--single-line.v-input--dense .v-input__append-outer,.v-textarea.v-text-field--enclosed.v-text-field--single-line.v-input--dense .v-input__prepend-inner,.v-textarea.v-text-field--enclosed.v-text-field--single-line.v-input--dense .v-input__prepend-outer{align-self:flex-start;margin-top:8px}.v-textarea.v-text-field--solo{align-items:flex-start}.v-textarea.v-text-field--solo .v-input__append-inner,.v-textarea.v-text-field--solo .v-input__append-outer,.v-textarea.v-text-field--solo .v-input__prepend-inner,.v-textarea.v-text-field--solo .v-input__prepend-outer{align-self:flex-start;margin-top:12px}.v-application--is-ltr .v-textarea.v-text-field--solo .v-input__append-inner{padding-left:12px}.v-application--is-rtl .v-textarea.v-text-field--solo .v-input__append-inner{padding-right:12px}.v-textarea--auto-grow textarea{overflow:hidden}.v-textarea--no-resize textarea{resize:none}.v-textarea.v-text-field--enclosed .v-text-field__slot{align-self:stretch}.v-application--is-ltr .v-textarea.v-text-field--enclosed .v-text-field__slot{margin-right:-12px}.v-application--is-rtl .v-textarea.v-text-field--enclosed .v-text-field__slot{margin-left:-12px}.v-application--is-ltr .v-textarea.v-text-field--enclosed .v-text-field__slot textarea{padding-right:12px}.v-application--is-rtl .v-textarea.v-text-field--enclosed .v-text-field__slot textarea{padding-left:12px}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "57fe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpInputCheckbox_vue_vue_type_style_index_0_id_46c47d0c_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("609f");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpInputCheckbox_vue_vue_type_style_index_0_id_46c47d0c_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpInputCheckbox_vue_vue_type_style_index_0_id_46c47d0c_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "580f":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("c8d5")
var startOfYear = __webpack_require__("a4b7")
var differenceInCalendarDays = __webpack_require__("d420")

/**
 * @category Day Helpers
 * @summary Get the day of the year of the given date.
 *
 * @description
 * Get the day of the year of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the day of year
 *
 * @example
 * // Which day of the year is 2 July 2014?
 * var result = getDayOfYear(new Date(2014, 6, 2))
 * //=> 183
 */
function getDayOfYear (dirtyDate) {
  var date = parse(dirtyDate)
  var diff = differenceInCalendarDays(date, startOfYear(date))
  var dayOfYear = diff + 1
  return dayOfYear
}

module.exports = getDayOfYear


/***/ }),

/***/ "5899":
/***/ (function(module, exports) {

// a string of all valid unicode whitespaces
// eslint-disable-next-line max-len
module.exports = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),

/***/ "58a8":
/***/ (function(module, exports, __webpack_require__) {

var requireObjectCoercible = __webpack_require__("1d80");
var whitespaces = __webpack_require__("5899");

var whitespace = '[' + whitespaces + ']';
var ltrim = RegExp('^' + whitespace + whitespace + '*');
var rtrim = RegExp(whitespace + whitespace + '*$');

// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod = function (TYPE) {
  return function ($this) {
    var string = String(requireObjectCoercible($this));
    if (TYPE & 1) string = string.replace(ltrim, '');
    if (TYPE & 2) string = string.replace(rtrim, '');
    return string;
  };
};

module.exports = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimstart
  start: createMethod(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimend
  end: createMethod(2),
  // `String.prototype.trim` method
  // https://tc39.es/ecma262/#sec-string.prototype.trim
  trim: createMethod(3)
};


/***/ }),

/***/ "58d5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpConversation_vue_vue_type_style_index_0_id_6ca91290_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("b659");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpConversation_vue_vue_type_style_index_0_id_6ca91290_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpConversation_vue_vue_type_style_index_0_id_6ca91290_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "58df":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mixins; });
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("8bbf");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
/* eslint-disable max-len, import/export, no-use-before-define */

function mixins() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend({
    mixins: args
  });
}

/***/ }),

/***/ "5901":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.i, "@import url(https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css);"]);
exports.push([module.i, "@import url(https://cdn-prd.patientpop.com/pp-icon-font/v1.6.0/pp-icon-font.css);"]);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.pp-panel[data-v-bcc9c6b0]{background:#fff;border:1px solid #d6d6d6}.pp-panel__subtitle[data-v-bcc9c6b0]{color:#545454}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "5981":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("e1c8");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("1b9b5d20", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "5987":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.v-color-picker .v-input__slider{border-radius:5px}.v-color-picker .v-input__slider .v-slider{margin:0}.v-color-picker__alpha:not(.v-input--is-disabled) .v-slider{border-radius:5px;background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAGElEQVQYlWNgYGCQwoKxgqGgcJA5h3yFAAs8BRWVSwooAAAAAElFTkSuQmCC) repeat}.v-color-picker__sliders{display:flex;flex:1 0 auto;flex-direction:column}.v-color-picker__dot{position:relative;height:36px;width:36px;background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAGElEQVQYlWNgYGCQwoKxgqGgcJA5h3yFAAs8BRWVSwooAAAAAElFTkSuQmCC) repeat;border-radius:50%;overflow:hidden}.v-application--is-ltr .v-color-picker__dot{margin-right:24px}.v-application--is-rtl .v-color-picker__dot{margin-left:24px}.v-color-picker__dot>div{width:100%;height:100%}.v-application--is-ltr .v-color-picker__hue:not(.v-input--is-disabled){background:linear-gradient(90deg,red 0,#ff0 16.66%,#0f0 33.33%,#0ff 50%,#00f 66.66%,#f0f 83.33%,red)}.v-application--is-rtl .v-color-picker__hue:not(.v-input--is-disabled){background:linear-gradient(270deg,red 0,#ff0 16.66%,#0f0 33.33%,#0ff 50%,#00f 66.66%,#f0f 83.33%,red)}.v-color-picker__track{position:relative;width:100%}.v-color-picker__preview{align-items:center;display:flex}.v-color-picker__preview .v-slider{min-height:10px}.v-color-picker__preview .v-slider:not(.v-slider--disabled) .v-slider__thumb{box-shadow:0 3px 3px -2px transparent,0 3px 4px 0 transparent,0 1px 8px 0 rgba(0,0,0,.12)}.v-color-picker__preview .v-slider:not(.v-slider--disabled) .v-slider__track-container{opacity:0}.v-color-picker__preview:not(.v-color-picker__preview--hide-alpha) .v-color-picker__hue{margin-bottom:24px}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "59e1":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><rect x=\"4\" y=\"6\" width=\"16\" height=\"2\" fill=\"#D5EAFD\"></rect><rect x=\"4\" y=\"10\" width=\"16\" height=\"10\" fill=\"white\"></rect><path d=\"M7 14V12H11V14H7Z\" fill=\"#079CB2\"></path><path d=\"M15 18V16H11V18H15Z\" fill=\"#079CB2\"></path><path d=\"M11 12H13V14H11V12Z\" fill=\"#079CB2\"></path><path d=\"M17 16H15V18H17V16Z\" fill=\"#079CB2\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M6 4V3C6 2.44772 6.44772 2 7 2C7.55228 2 8 2.44772 8 3V4H16V3C16 2.44772 16.4477 2 17 2C17.5523 2 18 2.44772 18 3V4H19.4963C20.8809 4 22 5.11672 22 6.50524V19.4948C22 20.8809 20.8878 22 19.4963 22H4.50371C3.11907 22 2 20.8833 2 19.4948V6.50524C2 5.11911 3.11219 4 4.50371 4H6ZM19.4963 6C19.7773 6 20 6.22223 20 6.50524V8H4V6.50524C4 6.22091 4.21954 6 4.50371 6H19.4963ZM4 10V19.4948C4 19.7778 4.2227 20 4.50371 20H19.4963C19.7805 20 20 19.7791 20 19.4948V10H4Z\" fill=\"#079CB2\"></path></svg>";

/***/ }),

/***/ "5a0d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c662cfac-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/pagination/PpPagination.vue?vue&type=template&id=435e27ea&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-pagination',_vm._g(_vm._b({staticClass:"pp-pagination",attrs:{"prev-icon":"pp-icon-arrow--back","next-icon":"pp-icon-arrow--right","total-visible":7,"color":"transparent"}},'v-pagination',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/pagination/PpPagination.vue?vue&type=template&id=435e27ea&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/pagination/PpPagination.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var PpPaginationvue_type_script_lang_js_ = ({
  name: 'PpPagination'
});
// CONCATENATED MODULE: ./src/components/pagination/PpPagination.vue?vue&type=script&lang=js&
 /* harmony default export */ var pagination_PpPaginationvue_type_script_lang_js_ = (PpPaginationvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/pagination/PpPagination.vue?vue&type=style&index=0&id=435e27ea&lang=scss&scoped=true&
var PpPaginationvue_type_style_index_0_id_435e27ea_lang_scss_scoped_true_ = __webpack_require__("d813");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// EXTERNAL MODULE: ./node_modules/vuetify-loader/lib/runtime/installComponents.js
var installComponents = __webpack_require__("6544");
var installComponents_default = /*#__PURE__*/__webpack_require__.n(installComponents);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("99af");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("d81d");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__("a9e3");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("d3b7");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("25f0");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__("2909");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__("5530");

// EXTERNAL MODULE: ./node_modules/vuetify/src/components/VPagination/VPagination.sass
var VPagination = __webpack_require__("17b3");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/components/VIcon/index.js
var VIcon = __webpack_require__("9d26");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/directives/resize/index.js
var resize = __webpack_require__("dc22");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/mixins/colorable/index.js
var colorable = __webpack_require__("a9ad");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/mixins/intersectable/index.js
var intersectable = __webpack_require__("de2c");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/mixins/themeable/index.js
var themeable = __webpack_require__("7560");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/util/mixins.js
var mixins = __webpack_require__("58df");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VPagination/VPagination.js








 // Directives

 // Mixins



 // Utilities


/* @vue/component */

/* harmony default export */ var VPagination_VPagination = (Object(mixins["a" /* default */])(colorable["a" /* default */], Object(intersectable["a" /* default */])({
  onVisible: ['init']
}), themeable["a" /* default */]).extend({
  name: 'v-pagination',
  directives: {
    Resize: resize["a" /* default */]
  },
  props: {
    circle: Boolean,
    disabled: Boolean,
    length: {
      type: Number,
      default: 0,
      validator: function validator(val) {
        return val % 1 === 0;
      }
    },
    nextIcon: {
      type: String,
      default: '$next'
    },
    prevIcon: {
      type: String,
      default: '$prev'
    },
    totalVisible: [Number, String],
    value: {
      type: Number,
      default: 0
    },
    pageAriaLabel: {
      type: String,
      default: '$vuetify.pagination.ariaLabel.page'
    },
    currentPageAriaLabel: {
      type: String,
      default: '$vuetify.pagination.ariaLabel.currentPage'
    },
    previousAriaLabel: {
      type: String,
      default: '$vuetify.pagination.ariaLabel.previous'
    },
    nextAriaLabel: {
      type: String,
      default: '$vuetify.pagination.ariaLabel.next'
    },
    wrapperAriaLabel: {
      type: String,
      default: '$vuetify.pagination.ariaLabel.wrapper'
    }
  },
  data: function data() {
    return {
      maxButtons: 0,
      selected: null
    };
  },
  computed: {
    classes: function classes() {
      return Object(objectSpread2["a" /* default */])({
        'v-pagination': true,
        'v-pagination--circle': this.circle,
        'v-pagination--disabled': this.disabled
      }, this.themeClasses);
    },
    items: function items() {
      var totalVisible = parseInt(this.totalVisible, 10);

      if (totalVisible === 0) {
        return [];
      }

      var maxLength = Math.min(Math.max(0, totalVisible) || this.length, Math.max(0, this.maxButtons) || this.length, this.length);

      if (this.length <= maxLength) {
        return this.range(1, this.length);
      }

      var even = maxLength % 2 === 0 ? 1 : 0;
      var left = Math.floor(maxLength / 2);
      var right = this.length - left + 1 + even;

      if (this.value > left && this.value < right) {
        var start = this.value - left + 2;
        var end = this.value + left - 2 - even;
        return [1, '...'].concat(Object(toConsumableArray["a" /* default */])(this.range(start, end)), ['...', this.length]);
      } else if (this.value === left) {
        var _end = this.value + left - 1 - even;

        return [].concat(Object(toConsumableArray["a" /* default */])(this.range(1, _end)), ['...', this.length]);
      } else if (this.value === right) {
        var _start = this.value - left + 1;

        return [1, '...'].concat(Object(toConsumableArray["a" /* default */])(this.range(_start, this.length)));
      } else {
        return [].concat(Object(toConsumableArray["a" /* default */])(this.range(1, left)), ['...'], Object(toConsumableArray["a" /* default */])(this.range(right, this.length)));
      }
    }
  },
  watch: {
    value: function value() {
      this.init();
    }
  },
  mounted: function mounted() {
    this.init();
  },
  methods: {
    init: function init() {
      var _this = this;

      this.selected = null;
      this.$nextTick(this.onResize); // TODO: Change this (f75dee3a, cbdf7caa)

      setTimeout(function () {
        return _this.selected = _this.value;
      }, 100);
    },
    onResize: function onResize() {
      var width = this.$el && this.$el.parentElement ? this.$el.parentElement.clientWidth : window.innerWidth;
      this.maxButtons = Math.floor((width - 96) / 42);
    },
    next: function next(e) {
      e.preventDefault();
      this.$emit('input', this.value + 1);
      this.$emit('next');
    },
    previous: function previous(e) {
      e.preventDefault();
      this.$emit('input', this.value - 1);
      this.$emit('previous');
    },
    range: function range(from, to) {
      var range = [];
      from = from > 0 ? from : 1;

      for (var i = from; i <= to; i++) {
        range.push(i);
      }

      return range;
    },
    genIcon: function genIcon(h, icon, disabled, fn, label) {
      return h('li', [h('button', {
        staticClass: 'v-pagination__navigation',
        class: {
          'v-pagination__navigation--disabled': disabled
        },
        attrs: {
          disabled: disabled,
          type: 'button',
          'aria-label': label
        },
        on: disabled ? {} : {
          click: fn
        }
      }, [h(VIcon["a" /* default */], [icon])])]);
    },
    genItem: function genItem(h, i) {
      var _this2 = this;

      var color = i === this.value && (this.color || 'primary');
      var isCurrentPage = i === this.value;
      var ariaLabel = isCurrentPage ? this.currentPageAriaLabel : this.pageAriaLabel;
      return h('button', this.setBackgroundColor(color, {
        staticClass: 'v-pagination__item',
        class: {
          'v-pagination__item--active': i === this.value
        },
        attrs: {
          type: 'button',
          'aria-current': isCurrentPage,
          'aria-label': this.$vuetify.lang.t(ariaLabel, i)
        },
        on: {
          click: function click() {
            return _this2.$emit('input', i);
          }
        }
      }), [i.toString()]);
    },
    genItems: function genItems(h) {
      var _this3 = this;

      return this.items.map(function (i, index) {
        return h('li', {
          key: index
        }, [isNaN(Number(i)) ? h('span', {
          class: 'v-pagination__more'
        }, [i.toString()]) : _this3.genItem(h, i)]);
      });
    },
    genList: function genList(h, children) {
      return h('ul', {
        directives: [{
          modifiers: {
            quiet: true
          },
          name: 'resize',
          value: this.onResize
        }],
        class: this.classes
      }, children);
    }
  },
  render: function render(h) {
    var children = [this.genIcon(h, this.$vuetify.rtl ? this.nextIcon : this.prevIcon, this.value <= 1, this.previous, this.$vuetify.lang.t(this.previousAriaLabel)), this.genItems(h), this.genIcon(h, this.$vuetify.rtl ? this.prevIcon : this.nextIcon, this.value >= this.length, this.next, this.$vuetify.lang.t(this.nextAriaLabel))];
    return h('nav', {
      attrs: {
        role: 'navigation',
        'aria-label': this.$vuetify.lang.t(this.wrapperAriaLabel)
      }
    }, [this.genList(h, children)]);
  }
}));
// CONCATENATED MODULE: ./src/components/pagination/PpPagination.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  pagination_PpPaginationvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "435e27ea",
  null
  
)

/* harmony default export */ var PpPagination = __webpack_exports__["default"] = (component.exports);

/* vuetify-loader */


installComponents_default()(component, {VPagination: VPagination_VPagination})


/***/ }),

/***/ "5a34":
/***/ (function(module, exports, __webpack_require__) {

var isRegExp = __webpack_require__("44e7");

module.exports = function (it) {
  if (isRegExp(it)) {
    throw TypeError("The method doesn't accept regular expressions");
  } return it;
};


/***/ }),

/***/ "5a38":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("c8d5")

/**
 * @category Weekday Helpers
 * @summary Is the given date Thursday?
 *
 * @description
 * Is the given date Thursday?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is Thursday
 *
 * @example
 * // Is 25 September 2014 Thursday?
 * var result = isThursday(new Date(2014, 8, 25))
 * //=> true
 */
function isThursday (dirtyDate) {
  return parse(dirtyDate).getDay() === 4
}

module.exports = isThursday


/***/ }),

/***/ "5a59":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c662cfac-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/input/date-range/month-layout/PpInputDateRangeMonthLayout.vue?vue&type=template&id=92c47fd6&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pp-col',[_c('div',{staticClass:"months-text"},[(_vm.showMonthArrow)?_c('i',{class:_vm.arrowClasses,attrs:{"data-test":"arrow"},on:{"click":_vm.arrowAction}}):_vm._e(),_vm._v(" "+_vm._s(_vm.monthTitle)+" "),(_vm.secondaryArrow)?_c('i',{staticClass:"right-arrow-icon pp-icon-caret--right",attrs:{"data-test":"secondary-arrow"},on:{"click":_vm.secondaryArrowAction}}):_vm._e()]),_c('ul',{class:_vm.styleClasses.daysWeeks},_vm._l((_vm.weekLabels),function(day){return _c('li',{key:day},[_vm._v(" "+_vm._s(day)+" ")])}),0),_vm._l((_vm.numberOfWeeks),function(week){return _c('ul',{key:week,class:[_vm.styleClasses.days]},_vm._l((_vm.NUM_OF_DAYS),function(day){return _c('li',{key:day,staticClass:"calendar-days--day",class:_vm.getCalendarCellClasses(week, day, _vm.calendarKey, _vm.startDate, _vm.endDate),on:{"click":function($event){return _vm.onDayClick(week, day)}}},[_vm._v(" "+_vm._s(_vm.getDayCell(week, day, _vm.startDate, _vm.endDate))+" ")])}),0)})],2)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/input/date-range/month-layout/PpInputDateRangeMonthLayout.vue?vue&type=template&id=92c47fd6&scoped=true&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__("a9e3");

// EXTERNAL MODULE: ./src/components/col/PpCol.vue + 4 modules
var PpCol = __webpack_require__("8ecc");

// EXTERNAL MODULE: ./src/components/input/date-range/constants.js
var constants = __webpack_require__("9ede");

// EXTERNAL MODULE: ./src/components/input/date-range/functions.js
var functions = __webpack_require__("21dd");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/input/date-range/month-layout/PpInputDateRangeMonthLayout.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var PpInputDateRangeMonthLayoutvue_type_script_lang_js_ = ({
  name: 'PpInputDateRangeMonthLayout',
  components: {
    'pp-col': PpCol["default"]
  },
  props: {
    /**
     * Number of weeks present in the month
     */
    numberOfWeeks: {
      type: Number,
      required: true
    },

    /**
     * The action to be performed when the left arrow is clicked
    */
    arrowAction: {
      required: true,
      type: Function
    },

    /**
     * class to be applied to the left arrow icon
     */
    arrowClasses: {
      default: 'left-arrow-icon pp-icon-caret--left',
      type: String
    },

    /**
     * The calendar identifier
     */
    calendarKey: {
      default: 'left',
      type: String
    },

    /**
     * The last date of the month
     */
    endDate: {
      default: 3,
      type: Number
    },

    /**
     * Function that returns the class names for a given day
     * const getCalendarCellClasses = () => (
     *  {
     *    'calendar-days-selected': false,
     *    'calendar-days-in-range': false,
     *    'calendar-days--disabled': false
     *  }
     * )
     */
    getCalendarCellClasses: {
      required: true,
      type: Function
    },

    /**
     * The message to be displayed as the month title
     */
    monthTitle: {
      default: 'Month',
      required: true,
      type: String
    },

    /**
     * The function to be called when a day is clicked
     */
    onDayClick: {
      required: true,
      type: Function
    },

    /**
     * Enable the right arrow
    */
    secondaryArrow: {
      default: false,
      type: Boolean
    },

    /**
     * The action to be performed when the right arrow is clicked
    */
    secondaryArrowAction: {
      default: function _default() {},
      type: Function
    },

    /**
     * Enable the left arrow
    */
    showMonthArrow: {
      default: true,
      type: Boolean
    },

    /**
     * the day of the week of the first day of the month
     */
    startDate: {
      default: 1,
      type: Number
    },

    /**
     * List of class names to overwrite the default names
     * DEFAULT_STYLE_CLASSES = {
     *    daysWeeks: 'calendar-weeks',
     *    days: 'calendar-days'
     * }
     */
    styleClasses: {
      required: true,
      type: Object
    },

    /**
     * An array of the labels for days of the week
     * const weekLabels = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT']
     */
    weekLabels: {
      default: function _default() {
        return constants["b" /* DAY_SHORT_NAMES */];
      },
      type: Array
    }
  },
  data: function data() {
    return {
      NUM_OF_DAYS: constants["h" /* NUM_OF_DAYS */]
    };
  },
  methods: {
    getDayIndexInMonth: functions["b" /* getDayIndexInMonth */],
    getDayCell: functions["a" /* getDayCell */]
  }
});
// CONCATENATED MODULE: ./src/components/input/date-range/month-layout/PpInputDateRangeMonthLayout.vue?vue&type=script&lang=js&
 /* harmony default export */ var month_layout_PpInputDateRangeMonthLayoutvue_type_script_lang_js_ = (PpInputDateRangeMonthLayoutvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/input/date-range/month-layout/PpInputDateRangeMonthLayout.vue?vue&type=style&index=0&id=92c47fd6&lang=scss&scoped=true&
var PpInputDateRangeMonthLayoutvue_type_style_index_0_id_92c47fd6_lang_scss_scoped_true_ = __webpack_require__("1b8f");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/input/date-range/month-layout/PpInputDateRangeMonthLayout.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  month_layout_PpInputDateRangeMonthLayoutvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "92c47fd6",
  null
  
)

/* harmony default export */ var PpInputDateRangeMonthLayout = __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "5a60":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("c8d5")

/**
 * @category Month Helpers
 * @summary Are the given dates in the same month?
 *
 * @description
 * Are the given dates in the same month?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same month
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same month?
 * var result = isSameMonth(
 *   new Date(2014, 8, 2),
 *   new Date(2014, 8, 25)
 * )
 * //=> true
 */
function isSameMonth (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)
  return dateLeft.getFullYear() === dateRight.getFullYear() &&
    dateLeft.getMonth() === dateRight.getMonth()
}

module.exports = isSameMonth


/***/ }),

/***/ "5a63":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("9246");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("eed969d2", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "5ac2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c662cfac-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/conversation/header/PpConversationHeader.vue?vue&type=template&id=5346c4ae&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pp-conversation-header pb-3"},[_c('h2',{staticClass:"text-truncate"},[_vm._v(" "+_vm._s(_vm.patientName)+" ")]),_c('p',{staticClass:"text-h6 mb-0"},[_vm._v(" Sending from "+_vm._s(_vm.locationName)+" ")]),(_vm.consent)?[_vm._m(0)]:_vm._e()],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-center text-h6"},[_c('i',{staticClass:"pp-icon-check-circle green--text d-inline-flex mr-1"}),_c('span',{staticClass:"d-inline-flex"},[_vm._v("HIPAA Consent")])])}]


// CONCATENATED MODULE: ./src/components/conversation/header/PpConversationHeader.vue?vue&type=template&id=5346c4ae&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/conversation/header/PpConversationHeader.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * Shows the patient name with a consent check, designed for use with conversation component
 */
/* harmony default export */ var PpConversationHeadervue_type_script_lang_js_ = ({
  name: 'PpConversationHeader',
  props: {
    consent: {
      type: Boolean,
      default: false
    },
    patientName: {
      type: String,
      required: true
    },
    locationName: {
      type: String,
      required: true
    }
  }
});
// CONCATENATED MODULE: ./src/components/conversation/header/PpConversationHeader.vue?vue&type=script&lang=js&
 /* harmony default export */ var header_PpConversationHeadervue_type_script_lang_js_ = (PpConversationHeadervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/conversation/header/PpConversationHeader.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  header_PpConversationHeadervue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var PpConversationHeader = __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "5b74":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c662cfac-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/idle-time/PpIdleTime.vue?vue&type=template&id=7f0189c6&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pp-dialog',{attrs:{"max-width":400,"value":_vm.showModal,"content-class":"pp-idle-time","primary-button-text":"Stay Signed In","secondary-button-text":"Sign Out","title":"Need more time?"},on:{"close":_vm.onClose,"confirm":_vm.confirm},scopedSlots:_vm._u([{key:"body",fn:function(){return [_c('p',{staticClass:"mt-5"},[_vm._v(" Your session is about to expire. You will be automatically signed out in ")]),_c('div',{staticClass:"idle-time primary--text font-weight-bold"},[_vm._v(" "+_vm._s(_vm.prettyTime)+" ")]),_c('p',{staticClass:"mb-5"},[_vm._v(" To continue your session, select "),_c('span',{staticClass:"font-weight-bold"},[_vm._v("Stay signed in.")])])]},proxy:true}])})}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/idle-time/PpIdleTime.vue?vue&type=template&id=7f0189c6&scoped=true&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("4160");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__("a9e3");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("d3b7");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("25f0");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.pad-start.js
var es_string_pad_start = __webpack_require__("4d90");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("159b");

// EXTERNAL MODULE: ./src/components/dialog/PpDialog.vue + 5 modules
var PpDialog = __webpack_require__("bdf9");

// CONCATENATED MODULE: ./src/components/idle-time/constants.js
var EMIT_ACTIVE_EVENT_NAME = 'active';
var USER_EVENTS = ['mousemove', 'mousedown', 'keypress', 'scroll', 'touchstart', 'click'];
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/idle-time/PpIdleTime.vue?vue&type=script&lang=js&






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var PpIdleTimevue_type_script_lang_js_ = ({
  name: 'PpIdleTime',
  components: {
    'pp-dialog': PpDialog["default"]
  },
  props: {
    /**
     * The time before showing a warning
     */
    warningTime: {
      type: Number,
      required: true
    },

    /**
     * The interval to send the heartbeat
     */
    heartBeatTime: {
      type: Number,
      required: true
    },

    /**
     * Max time allowed before log out
     */
    maxTime: {
      type: Number,
      required: true
    },

    /**
     * The session inactivity timeout
     */
    sessionInactivityTimeout: {
      type: Number,
      required: true
    }
  },
  data: function data() {
    return {
      userIsActive: true,
      userEvents: USER_EVENTS,
      remainingTime: this.maxTime,
      countDownTimer: null,
      heartBeatTimer: null,
      showModal: false
    };
  },
  computed: {
    // format time to display in hh:mm:ss
    prettyTime: function prettyTime() {
      var time = this.remainingTime / 1000;
      var minutes = Math.floor(time / 60);
      var seconds = (time - minutes * 60).toString();

      if (seconds <= 0) {
        seconds = '0';
      }

      seconds = seconds.padStart(2, '0');
      return minutes + ':' + seconds;
    }
  },
  watch: {
    maxTime: {
      immediate: true,
      handler: function handler(maxTime) {
        this.remainingTime = maxTime;
      }
    },
    sessionInactivityTimeout: {
      immediate: true,
      handler: function handler() {
        this.initializeTimeoutConfiguration();
      }
    },
    // when time falls below threshold show the modal
    remainingTime: function remainingTime() {
      if (this.remainingTime < this.warningTime) {
        this.$ppAnalytics.trackEvent({
          category: 'idle-time',
          action: 'modal-shown'
        });
        this.showModal = true;
      } else {
        this.showModal = false;
      }
    }
  },
  destroyed: function destroyed() {
    // remove any event listeners
    this.removeEvents();
  },
  methods: {
    initialSetup: function initialSetup() {
      // register user interaction events
      this.registerEvents(); // start the countdown timer from remaining time

      this.startCountDownTimer(); // start the heartbeat timer

      this.startHeartBeatTimer();
    },
    // when changing auto logout configuration in profile setting, will restart component
    initializeTimeoutConfiguration: function initializeTimeoutConfiguration() {
      clearInterval(this.heartBeatTimer);
      clearInterval(this.countDownTimer);
      this.remainingTime = this.maxTime;
      this.userIsActive = true;
      this.showModal = false;
      this.initialSetup();
    },
    // register user tracking events
    registerEvents: function registerEvents() {
      var _this = this;

      this.userEvents.forEach(function (name) {
        window.addEventListener(name, _this.setUserActive);
      });
    },
    removeEvents: function removeEvents() {
      var _this2 = this;

      this.userEvents.forEach(function (name) {
        window.removeEventListener(name, _this2.setUserActive);
      });
    },
    setUserActive: function setUserActive() {
      // only set active and reset if we haven't gotten below warning threshold
      if (!this.showModal) {
        this.userIsActive = true;
        this.resetCountDownTimer();
      }
    },
    // out of time, emit event and log out
    outOfTime: function outOfTime() {
      this.$emit('out-of-time');
      window.location.assign('/logout');
    },
    startHeartBeatTimer: function startHeartBeatTimer() {
      var _this3 = this;

      // define variables for intervals so they can be easily destroyed
      this.heartBeatTimer = setInterval(function () {
        // if user is active then send heartbeat
        if (_this3.userIsActive && _this3.remainingTime >= 0) {
          // is active send heartbeat
          _this3.$emit(EMIT_ACTIVE_EVENT_NAME, true);

          _this3.userIsActive = false;
        } else {
          // not active - call session
          _this3.$emit(EMIT_ACTIVE_EVENT_NAME, false);
        }
      }, this.heartBeatTime);
    },
    startCountDownTimer: function startCountDownTimer() {
      var _this4 = this;

      // define variables for intervals so they can be easily destroyed
      this.countDownTimer = setInterval(function () {
        if (_this4.remainingTime > 0) {
          _this4.remainingTime = _this4.remainingTime - 1000;
        } else {
          clearInterval(_this4.countDownTimer);

          _this4.outOfTime();
        }
      }, 1000);
    },
    resetCountDownTimer: function resetCountDownTimer() {
      var hideModal = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      clearInterval(this.countDownTimer);
      this.remainingTime = this.maxTime;
      this.startCountDownTimer();

      if (hideModal) {
        this.showModal = false;
      }
    },
    onClose: function onClose(value) {
      // if its the x button then just reset the counter
      if (value === 'close-button') {
        this.resetCountDownTimer(true);
      } // if its the cancel button sign out the user


      if (value === 'secondary-button') {
        this.outOfTime();
      }
    },
    confirm: function confirm() {
      this.$ppAnalytics.trackEvent({
        category: 'idle-time',
        action: 'stay-logged-in'
      });
      this.resetCountDownTimer(true);
      this.$emit(EMIT_ACTIVE_EVENT_NAME, true);
    }
  }
});
// CONCATENATED MODULE: ./src/components/idle-time/PpIdleTime.vue?vue&type=script&lang=js&
 /* harmony default export */ var idle_time_PpIdleTimevue_type_script_lang_js_ = (PpIdleTimevue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/idle-time/PpIdleTime.vue?vue&type=style&index=0&id=7f0189c6&lang=scss&scoped=true&
var PpIdleTimevue_type_style_index_0_id_7f0189c6_lang_scss_scoped_true_ = __webpack_require__("0569");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/idle-time/PpIdleTime.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  idle_time_PpIdleTimevue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "7f0189c6",
  null
  
)

/* harmony default export */ var PpIdleTime = __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "5bb0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpInputFile_vue_vue_type_style_index_0_id_6cf0f976_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("e4a8");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpInputFile_vue_vue_type_style_index_0_id_6cf0f976_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpInputFile_vue_vue_type_style_index_0_id_6cf0f976_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "5c6c":
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ "5c78":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpLink_vue_vue_type_style_index_0_id_cd6c2852_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("23b5");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpLink_vue_vue_type_style_index_0_id_cd6c2852_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpLink_vue_vue_type_style_index_0_id_cd6c2852_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "5ce5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c662cfac-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/input/avatar/PpInputAvatar.vue?vue&type=template&id=1cb9db2c&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"d-flex pp-input-avatar"},[_c('div',{staticClass:"pp-input-avatar__wrapper d-flex align-center flex-column",on:{"mouseenter":function($event){return _vm.toggleOverlay(_vm.HOVERING_STATE)},"mouseleave":function($event){return _vm.toggleOverlay(_vm.NOT_HOVERING_STATE)}}},[_c('pp-avatar-icon',{attrs:{"name":_vm.name,"image":_vm.image,"size":"xxxl","loading":_vm.loading,"is-practice":true}}),(_vm.showRemoveOverlay)?_c('div',{staticClass:"pp-input-avatar__delete-overlay font-weight-bold d-flex flex-column align-center justify-center",on:{"click":_vm.clearFile}},[_c('i',{staticClass:"d-flex text-h1 pp-input-avatar__delete-icon pp-icon-delete"}),_c('span',{staticClass:"pp-input-avatar__delete-label"},[_vm._v(" Remove ")])]):_vm._e(),(!_vm.loading)?_c('input',{ref:"file",staticClass:"pp-input-avatar__input",attrs:{"type":"file","accept":_vm.acceptFileTypes},domProps:{"value":_vm.inputValue},on:{"change":_vm.fileChange}}):_vm._e()],1)]),_c('pp-button',{staticClass:"mt-3 pp-input-avatar__upload-button",attrs:{"disabled":_vm.loading,"type":"secondary","text":"Upload photo"},on:{"click":_vm.handleUploadButton}})],1)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/input/avatar/PpInputAvatar.vue?vue&type=template&id=1cb9db2c&scoped=true&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("caad");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__("a15b");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.reduce.js
var es_array_reduce = __webpack_require__("13d5");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__("a9e3");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.to-fixed.js
var es_number_to_fixed = __webpack_require__("b680");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__("ac1f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("2532");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.replace.js
var es_string_replace = __webpack_require__("5319");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.split.js
var es_string_split = __webpack_require__("1276");

// CONCATENATED MODULE: ./src/components/input/avatar/constants.js
var DEFAULT_PROFILE_IMAGE = 'https://sa1s3optim.patientpop.com/assets/production/stock-images/2289066.png';
var DISPLAY_STATE = 'displayImage';
var NOT_DISPLAY_STATE = 'notDisplayImage';
var HOVERING_STATE = 'hovering';
var NOT_HOVERING_STATE = 'notHovering';
// EXTERNAL MODULE: ./src/components/button/PpButton.vue + 5 modules
var PpButton = __webpack_require__("251c");

// EXTERNAL MODULE: ./src/components/avatar-icon/PpAvatarIcon.vue + 4 modules
var PpAvatarIcon = __webpack_require__("020a");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/input/avatar/PpInputAvatar.vue?vue&type=script&lang=js&









//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var PpInputAvatarvue_type_script_lang_js_ = ({
  name: 'PpInputAvatar',
  components: {
    'pp-button': PpButton["default"],
    'pp-avatar-icon': PpAvatarIcon["default"]
  },
  model: {
    prop: 'image',
    event: 'file-selected'
  },
  props: {
    image: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    },

    /**
     * This field is number of maximum bytes for files (default to 1Mb)
     */
    maxSize: {
      type: Number,
      default: 1048576
    },

    /**
     * Array file types, ex: .json, .csv
     */
    fileTypes: {
      type: Array,
      default: function _default() {
        return ['.png', '.jpeg', '.jpg'];
      }
    },
    name: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      inputValue: '',
      HOVERING_STATE: HOVERING_STATE,
      NOT_HOVERING_STATE: NOT_HOVERING_STATE,
      state: ''
    };
  },
  computed: {
    showRemoveOverlay: function showRemoveOverlay() {
      return this.image && this.state === HOVERING_STATE && !this.loading;
    },
    acceptFileTypes: function acceptFileTypes() {
      var acceptTypes = this.fileTypes.reduce(function (accumulation, value) {
        value = value.replace('.', '');
        accumulation.push("image/".concat(value));
        return accumulation;
      }, []);
      return acceptTypes.join(', ');
    }
  },
  methods: {
    clearFile: function clearFile() {
      this.$emit('file-selected', null);
    },
    fileChange: function fileChange(e) {
      var inputImage = this.getInputImage(e);

      if (!inputImage) {
        return;
      } // Validate file types


      if (!this.fileTypes.includes('.' + inputImage.type.split('/').pop())) {
        this.$emit('error', "Please make sure your file is of the following types: ".concat(this.fileTypes.join(', '), "."));
        this.clearFile();
        return;
      } // Validate maxsize limit


      if (inputImage.size > this.maxSize) {
        var maxSizeInMb = (this.maxSize / 1048576).toFixed(2);
        this.$emit('error', "Image must be less than ".concat(maxSizeInMb, " MB."));
        this.clearFile();
        return;
      }

      this.uploadImage(inputImage);
    },
    getInputImage: function getInputImage(e) {
      var _e$target, _e$target$files, _e$dataTransfer, _e$dataTransfer$files, _e$originalEvent, _e$originalEvent$data;

      if ((_e$target = e.target) !== null && _e$target !== void 0 && (_e$target$files = _e$target.files) !== null && _e$target$files !== void 0 && _e$target$files.length) {
        return e.target.files[0];
      } else if ((_e$dataTransfer = e.dataTransfer) !== null && _e$dataTransfer !== void 0 && (_e$dataTransfer$files = _e$dataTransfer.files) !== null && _e$dataTransfer$files !== void 0 && _e$dataTransfer$files.length) {
        return e.dataTransfer.files[0];
      }

      return e === null || e === void 0 ? void 0 : (_e$originalEvent = e.originalEvent) === null || _e$originalEvent === void 0 ? void 0 : (_e$originalEvent$data = _e$originalEvent.dataTransfer) === null || _e$originalEvent$data === void 0 ? void 0 : _e$originalEvent$data.files[0];
    },
    uploadImage: function uploadImage(inputImage) {
      var _this = this;

      var reader = new FileReader();

      reader.onload = function (evt) {
        _this.$emit('file-selected', evt.target.result);
      };

      if (inputImage instanceof Blob) {
        reader.readAsDataURL(inputImage);
      }
    },
    toggleOverlay: function toggleOverlay(value) {
      this.state = value;
    },
    handleUploadButton: function handleUploadButton() {
      var fileInputElement = this.$refs.file;
      fileInputElement.click();
      this.$emit('upload-button-clicked');
    }
  }
});
// CONCATENATED MODULE: ./src/components/input/avatar/PpInputAvatar.vue?vue&type=script&lang=js&
 /* harmony default export */ var avatar_PpInputAvatarvue_type_script_lang_js_ = (PpInputAvatarvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/input/avatar/PpInputAvatar.vue?vue&type=style&index=0&id=1cb9db2c&lang=scss&scoped=true&
var PpInputAvatarvue_type_style_index_0_id_1cb9db2c_lang_scss_scoped_true_ = __webpack_require__("e554");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/input/avatar/PpInputAvatar.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  avatar_PpInputAvatarvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "1cb9db2c",
  null
  
)

/* harmony default export */ var PpInputAvatar = __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "5ce8":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.i, "@import url(https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css);"]);
exports.push([module.i, "@import url(https://cdn-prd.patientpop.com/pp-icon-font/v1.6.0/pp-icon-font.css);"]);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.error--text[data-v-62f2f138]  .v-text-field__control{position:relative}.error--text[data-v-62f2f138]  .v-messages{display:inline-block;left:0;overflow:hidden;position:absolute;top:calc(100% - 14px)}.error--text[data-v-62f2f138]  .v-messages__message{background:#fff;overflow:hidden;padding:0 3px;text-overflow:ellipsis;white-space:nowrap}.pp-input-description[data-v-62f2f138]{white-space:pre-line}[data-v-62f2f138] .message-transition-leave,[data-v-62f2f138] .message-transition-leave-active{display:inline-block;max-width:70%;overflow:hidden;position:absolute;right:8px;text-align:right;top:calc(100% - 30px);transform:translateY(-7px)}[data-v-62f2f138] .v-counter{position:absolute;right:0}.theme--light.v-input[data-v-62f2f138]:not(.theme--light.v-input--is-focused)  fieldset{border-color:transparent}.theme--light.v-input[data-v-62f2f138]:not(.theme--light.v-input--is-focused):not(.theme--light.v-input--is-disabled){--text-primary:#2b2b2b}.theme--light.v-input .pp-input-text__error-icon[data-v-62f2f138]{color:#b51a2c}.theme--light.v-input:not(.theme--light.v-input--is-focused):not(.theme--light.v-input--is-disabled).error--text[data-v-62f2f138]{--pp-text-field-fill:#fceeee}.theme--light.v-input.pp-input-select--white-bg[data-v-62f2f138]:not(.theme--light.v-input--is-disabled),.theme--light.v-input.pp-input-text--white-bg[data-v-62f2f138]:not(.theme--light.v-input--is-disabled){--pp-text-placeholder:#545454}.theme--light.v-input.pp-input-select--white-bg[data-v-62f2f138]:not(.theme--light.v-input--is-disabled):not(.theme--light.v-input--is-focused):not(.error--text),.theme--light.v-input.pp-input-text--white-bg[data-v-62f2f138]:not(.theme--light.v-input--is-disabled):not(.theme--light.v-input--is-focused):not(.error--text){--pp-text-field-fill:#fff}.theme--light.v-input.pp-input-select--white-bg[data-v-62f2f138]:not(.theme--light.v-input--is-disabled):not(.theme--light.v-input--is-focused):not(.error--text)  .theme--light.v-input__slot:hover,.theme--light.v-input.pp-input-text--white-bg[data-v-62f2f138]:not(.theme--light.v-input--is-disabled):not(.theme--light.v-input--is-focused):not(.error--text)  .theme--light.v-input__slot:hover{--pp-text-field-fill-on-hover:#fff}.theme--light.v-input.theme--light.v-input--is-focused[data-v-62f2f138]{--pp-text-field-fill:#fff}.theme--light.v-input.theme--light.v-input--is-disabled[data-v-62f2f138]{--pp-text-disabled:#9a9a9a;--pp-text-field-fill:#f6f6f6;--pp-text-placeholder:#9a9a9a}.theme--light.v-input[data-v-62f2f138]  input::-moz-placeholder,.theme--light.v-input[data-v-62f2f138]  textarea::-moz-placeholder{color:var(--pp-text-placeholder,#545454)}.theme--light.v-input[data-v-62f2f138]  input:-ms-input-placeholder,.theme--light.v-input[data-v-62f2f138]  textarea:-ms-input-placeholder{color:var(--pp-text-placeholder,#545454)}.theme--light.v-input[data-v-62f2f138]  input::placeholder,.theme--light.v-input[data-v-62f2f138]  textarea::placeholder{color:var(--pp-text-placeholder,#545454)}.theme--light.v-input[data-v-62f2f138]  .theme--light.v-input__append-inner{margin-bottom:auto;margin-top:auto}.theme--light.v-input[data-v-62f2f138]  .theme--light.v-input__append-inner i:before{display:block}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "5d0b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpDataTable_vue_vue_type_style_index_1_id_4d4a0701_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("0158");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpDataTable_vue_vue_type_style_index_1_id_4d4a0701_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpDataTable_vue_vue_type_style_index_1_id_4d4a0701_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "5d1f":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("0d7d");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("168fbdf7", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "5d23":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ VListItemContent; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* binding */ VListItemTitle; });

// UNUSED EXPORTS: VListItemActionText, VListItemSubtitle, VList, VListGroup, VListItem, VListItemAction, VListItemAvatar, VListItemIcon, VListItemGroup

// EXTERNAL MODULE: ./node_modules/vuetify/lib/util/helpers.js
var helpers = __webpack_require__("80d2");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/components/VList/VList.js
var VList = __webpack_require__("8860");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__("ac1f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.match.js
var es_string_match = __webpack_require__("466d");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__("5530");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("ade3");

// EXTERNAL MODULE: ./node_modules/vuetify/src/components/VList/VListGroup.sass
var VListGroup = __webpack_require__("db42");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/components/VIcon/index.js
var VIcon = __webpack_require__("9d26");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/components/VList/VListItem.js
var VListItem = __webpack_require__("da13");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.trim.js
var es_string_trim = __webpack_require__("498a");

// EXTERNAL MODULE: external {"commonjs":"vue","commonjs2":"vue","root":"Vue"}
var external_commonjs_vue_commonjs2_vue_root_Vue_ = __webpack_require__("8bbf");
var external_commonjs_vue_commonjs2_vue_root_Vue_default = /*#__PURE__*/__webpack_require__.n(external_commonjs_vue_commonjs2_vue_root_Vue_);

// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VList/VListItemIcon.js

// Types

/* @vue/component */

/* harmony default export */ var VListItemIcon = (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
  name: 'v-list-item-icon',
  functional: true,
  render: function render(h, _ref) {
    var data = _ref.data,
        children = _ref.children;
    data.staticClass = "v-list-item__icon ".concat(data.staticClass || '').trim();
    return h('div', data, children);
  }
}));
// EXTERNAL MODULE: ./node_modules/vuetify/lib/mixins/binds-attrs/index.js
var binds_attrs = __webpack_require__("7e2b");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/mixins/bootable/index.js
var bootable = __webpack_require__("9d65");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/mixins/colorable/index.js
var colorable = __webpack_require__("a9ad");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/mixins/toggleable/index.js
var toggleable = __webpack_require__("f2e7");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/mixins/registrable/index.js
var registrable = __webpack_require__("3206");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/directives/ripple/index.js
var ripple = __webpack_require__("5607");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/components/transitions/index.js + 2 modules
var transitions = __webpack_require__("0789");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/util/mixins.js
var mixins = __webpack_require__("58df");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VList/VListGroup.js




// Styles
 // Components



 // Mixins





 // Directives

 // Transitions

 // Utils



var baseMixins = Object(mixins["a" /* default */])(binds_attrs["a" /* default */], bootable["a" /* default */], colorable["a" /* default */], Object(registrable["a" /* inject */])('list'), toggleable["a" /* default */]);
/* harmony default export */ var VList_VListGroup = (baseMixins.extend().extend({
  name: 'v-list-group',
  directives: {
    ripple: ripple["a" /* default */]
  },
  props: {
    activeClass: {
      type: String,
      default: ''
    },
    appendIcon: {
      type: String,
      default: '$expand'
    },
    color: {
      type: String,
      default: 'primary'
    },
    disabled: Boolean,
    group: String,
    noAction: Boolean,
    prependIcon: String,
    ripple: {
      type: [Boolean, Object],
      default: true
    },
    subGroup: Boolean
  },
  computed: {
    classes: function classes() {
      return {
        'v-list-group--active': this.isActive,
        'v-list-group--disabled': this.disabled,
        'v-list-group--no-action': this.noAction,
        'v-list-group--sub-group': this.subGroup
      };
    }
  },
  watch: {
    isActive: function isActive(val) {
      /* istanbul ignore else */
      if (!this.subGroup && val) {
        this.list && this.list.listClick(this._uid);
      }
    },
    $route: 'onRouteChange'
  },
  created: function created() {
    this.list && this.list.register(this);

    if (this.group && this.$route && this.value == null) {
      this.isActive = this.matchRoute(this.$route.path);
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.list && this.list.unregister(this);
  },
  methods: {
    click: function click(e) {
      var _this = this;

      if (this.disabled) return;
      this.isBooted = true;
      this.$emit('click', e);
      this.$nextTick(function () {
        return _this.isActive = !_this.isActive;
      });
    },
    genIcon: function genIcon(icon) {
      return this.$createElement(VIcon["a" /* default */], icon);
    },
    genAppendIcon: function genAppendIcon() {
      var icon = !this.subGroup ? this.appendIcon : false;
      if (!icon && !this.$slots.appendIcon) return null;
      return this.$createElement(VListItemIcon, {
        staticClass: 'v-list-group__header__append-icon'
      }, [this.$slots.appendIcon || this.genIcon(icon)]);
    },
    genHeader: function genHeader() {
      return this.$createElement(VListItem["a" /* default */], {
        staticClass: 'v-list-group__header',
        attrs: {
          'aria-expanded': String(this.isActive),
          role: 'button'
        },
        class: Object(defineProperty["a" /* default */])({}, this.activeClass, this.isActive),
        props: {
          inputValue: this.isActive
        },
        directives: [{
          name: 'ripple',
          value: this.ripple
        }],
        on: Object(objectSpread2["a" /* default */])(Object(objectSpread2["a" /* default */])({}, this.listeners$), {}, {
          click: this.click
        })
      }, [this.genPrependIcon(), this.$slots.activator, this.genAppendIcon()]);
    },
    genItems: function genItems() {
      var _this2 = this;

      return this.showLazyContent(function () {
        return [_this2.$createElement('div', {
          staticClass: 'v-list-group__items',
          directives: [{
            name: 'show',
            value: _this2.isActive
          }]
        }, Object(helpers["s" /* getSlot */])(_this2))];
      });
    },
    genPrependIcon: function genPrependIcon() {
      var icon = this.subGroup && this.prependIcon == null ? '$subgroup' : this.prependIcon;
      if (!icon && !this.$slots.prependIcon) return null;
      return this.$createElement(VListItemIcon, {
        staticClass: 'v-list-group__header__prepend-icon'
      }, [this.$slots.prependIcon || this.genIcon(icon)]);
    },
    onRouteChange: function onRouteChange(to) {
      /* istanbul ignore if */
      if (!this.group) return;
      var isActive = this.matchRoute(to.path);
      /* istanbul ignore else */

      if (isActive && this.isActive !== isActive) {
        this.list && this.list.listClick(this._uid);
      }

      this.isActive = isActive;
    },
    toggle: function toggle(uid) {
      var _this3 = this;

      var isActive = this._uid === uid;
      if (isActive) this.isBooted = true;
      this.$nextTick(function () {
        return _this3.isActive = isActive;
      });
    },
    matchRoute: function matchRoute(to) {
      return to.match(this.group) !== null;
    }
  },
  render: function render(h) {
    return h('div', this.setTextColor(this.isActive && this.color, {
      staticClass: 'v-list-group',
      class: this.classes
    }), [this.genHeader(), h(transitions["a" /* VExpandTransition */], this.genItems())]);
  }
}));
// EXTERNAL MODULE: ./node_modules/vuetify/lib/components/VList/VListItemGroup.js
var VListItemGroup = __webpack_require__("1baa");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/components/VList/VListItemAction.js
var VListItemAction = __webpack_require__("1800");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__("a9e3");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/components/VAvatar/index.js
var VAvatar = __webpack_require__("713a");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VList/VListItemAvatar.js


// Components

/* @vue/component */

/* harmony default export */ var VListItemAvatar = (VAvatar["a" /* default */].extend({
  name: 'v-list-item-avatar',
  props: {
    horizontal: Boolean,
    size: {
      type: [Number, String],
      default: 40
    }
  },
  computed: {
    classes: function classes() {
      return Object(objectSpread2["a" /* default */])(Object(objectSpread2["a" /* default */])({
        'v-list-item__avatar--horizontal': this.horizontal
      }, VAvatar["a" /* default */].options.computed.classes.call(this)), {}, {
        'v-avatar--tile': this.tile || this.horizontal
      });
    }
  },
  render: function render(h) {
    var render = VAvatar["a" /* default */].options.render.call(this, h);
    render.data = render.data || {};
    render.data.staticClass += ' v-list-item__avatar';
    return render;
  }
}));
// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VList/index.js








var VListItemActionText = Object(helpers["i" /* createSimpleFunctional */])('v-list-item__action-text', 'span');
var VListItemContent = Object(helpers["i" /* createSimpleFunctional */])('v-list-item__content', 'div');
var VListItemTitle = Object(helpers["i" /* createSimpleFunctional */])('v-list-item__title', 'div');
var VListItemSubtitle = Object(helpers["i" /* createSimpleFunctional */])('v-list-item__subtitle', 'div');

/* harmony default export */ var components_VList = ({
  $_vuetify_subcomponents: {
    VList: VList["a" /* default */],
    VListGroup: VList_VListGroup,
    VListItem: VListItem["a" /* default */],
    VListItemAction: VListItemAction["a" /* default */],
    VListItemActionText: VListItemActionText,
    VListItemAvatar: VListItemAvatar,
    VListItemContent: VListItemContent,
    VListItemGroup: VListItemGroup["a" /* default */],
    VListItemIcon: VListItemIcon,
    VListItemSubtitle: VListItemSubtitle,
    VListItemTitle: VListItemTitle
  }
});

/***/ }),

/***/ "5d23d":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".pp-divider[data-v-2e674112]{max-width:none}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "5d3b":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M5 20C4.44772 20 4 19.5523 4 19L4 4C4 3.44771 4.44772 3 5 3L8 3L8 20L5 20Z\" fill=\"#D5EAFD\"></path><path d=\"M8 20L8 3L20 3L20 20L8 20Z\" fill=\"white\"></path><path d=\"M5 3H19C20.1046 3 21 3.89543 21 5V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V5C3 3.89543 3.89543 3 5 3Z\" stroke=\"#079CB2\" stroke-width=\"2\"></path><path d=\"M13.6626 14.7182L17.7206 10.6413C17.9624 10.3987 18.0571 10.0449 17.9689 9.7131C17.8806 9.38135 17.623 9.12208 17.2929 9.03296C16.9628 8.94384 16.6104 9.0384 16.3686 9.28104L12.9876 12.6798L11.6336 11.3195C11.2597 10.9441 10.6537 10.9443 10.2801 11.32C9.90645 11.6956 9.90667 12.3044 10.2806 12.6798L12.3096 14.7182C12.4889 14.8986 12.7323 15 12.9861 15C13.2399 15 13.4832 14.8986 13.6626 14.7182Z\" fill=\"#079CB2\"></path><rect width=\"17\" height=\"2\" transform=\"matrix(1.19249e-08 -1 -1 -1.19249e-08 8 20)\" fill=\"#079CB2\"></rect></svg>";

/***/ }),

/***/ "5d95":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("c8d5")

/**
 * @category Hour Helpers
 * @summary Get the hours of the given date.
 *
 * @description
 * Get the hours of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the hours
 *
 * @example
 * // Get the hours of 29 February 2012 11:45:00:
 * var result = getHours(new Date(2012, 1, 29, 11, 45))
 * //=> 11
 */
function getHours (dirtyDate) {
  var date = parse(dirtyDate)
  var hours = date.getHours()
  return hours
}

module.exports = getHours


/***/ }),

/***/ "5e41":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.i, "@import url(https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css);"]);
exports.push([module.i, "@import url(https://cdn-prd.patientpop.com/pp-icon-font/v1.6.0/pp-icon-font.css);"]);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}@media(max-width:600px){.pp-calendar-nav[data-v-595f5f79]{border-bottom:1px solid #d6d6d6;border-top:1px solid #d6d6d6;padding:16px 0}}.pp-calendar-nav__weekday[data-v-595f5f79]{color:#545454;font-size:.7857142857rem;line-height:.9285714286rem}@media(max-width:600px){.pp-calendar-nav__weekday[data-v-595f5f79]{margin:0 0 2px}}.pp-calendar-nav__date[data-v-595f5f79]{letter-spacing:-.01em;line-height:1.3571428571rem}[data-v-595f5f79] .pp-button i{height:1em}[data-v-595f5f79] .pp-button.col-button[disabled]{opacity:.5}[data-v-595f5f79] .pp-button.col-button i{color:#545454;font-size:12px}[data-v-595f5f79] .pp-button.col-button.back-btn i{margin-left:-2px}[data-v-595f5f79] .pp-button.col-button.forward-btn i{margin-left:2px}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "5e89":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");

var floor = Math.floor;

// `Number.isInteger` method implementation
// https://tc39.es/ecma262/#sec-number.isinteger
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),

/***/ "5f0c":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("c67f");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("b5bdd594", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "5f54":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.theme--light.v-picker__title{background:#d6d6d6}.theme--dark.v-picker__title{background:#545454}.theme--light.v-picker__body{background:#fff}.theme--dark.v-picker__body{background:#2b2b2b}.v-picker{border-radius:5px;contain:layout style;display:inline-flex;flex-direction:column;font-size:1rem;vertical-align:top;position:relative}.v-picker--full-width{display:flex;width:100%}.v-picker--full-width>.v-picker__body{margin:initial}.v-picker__title{color:#fff;border-top-left-radius:5px;border-top-right-radius:5px;padding:16px}.v-picker__title__btn{transition:.3s cubic-bezier(.25,.8,.5,1)}.v-picker__title__btn:not(.v-picker__title__btn--active){opacity:.6;cursor:pointer}.v-picker__title__btn:not(.v-picker__title__btn--active):hover:not(:focus){opacity:1}.v-picker__title__btn--readonly{pointer-events:none}.v-picker__title__btn--active{opacity:1}.v-picker__body{height:auto;overflow:hidden;position:relative;z-index:0;flex:1 0 auto;display:flex;flex-direction:column;align-items:center;margin:0 auto}.v-picker__body>div{width:100%}.v-picker__body>div.fade-transition-leave-active{position:absolute}.v-picker--landscape .v-picker__title{border-top-right-radius:0;border-bottom-right-radius:0;width:170px;position:absolute;top:0;height:100%;z-index:1}.v-application--is-ltr .v-picker--landscape .v-picker__title{left:0}.v-application--is-rtl .v-picker--landscape .v-picker__title{right:0}.v-application--is-ltr .v-picker--landscape .v-picker__actions:not(.v-picker__actions--no-title),.v-application--is-ltr .v-picker--landscape .v-picker__body:not(.v-picker__body--no-title){margin-left:170px;margin-right:0}.v-application--is-rtl .v-picker--landscape .v-picker__actions:not(.v-picker__actions--no-title),.v-application--is-rtl .v-picker--landscape .v-picker__body:not(.v-picker__body--no-title){margin-right:170px;margin-left:0}.v-picker--flat{box-shadow:0 0 0 0 transparent,0 0 0 0 transparent,0 0 0 0 rgba(0,0,0,.12)}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "5fb2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// based on https://github.com/bestiejs/punycode.js/blob/master/punycode.js
var maxInt = 2147483647; // aka. 0x7FFFFFFF or 2^31-1
var base = 36;
var tMin = 1;
var tMax = 26;
var skew = 38;
var damp = 700;
var initialBias = 72;
var initialN = 128; // 0x80
var delimiter = '-'; // '\x2D'
var regexNonASCII = /[^\0-\u007E]/; // non-ASCII chars
var regexSeparators = /[.\u3002\uFF0E\uFF61]/g; // RFC 3490 separators
var OVERFLOW_ERROR = 'Overflow: input needs wider integers to process';
var baseMinusTMin = base - tMin;
var floor = Math.floor;
var stringFromCharCode = String.fromCharCode;

/**
 * Creates an array containing the numeric code points of each Unicode
 * character in the string. While JavaScript uses UCS-2 internally,
 * this function will convert a pair of surrogate halves (each of which
 * UCS-2 exposes as separate characters) into a single code point,
 * matching UTF-16.
 */
var ucs2decode = function (string) {
  var output = [];
  var counter = 0;
  var length = string.length;
  while (counter < length) {
    var value = string.charCodeAt(counter++);
    if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
      // It's a high surrogate, and there is a next character.
      var extra = string.charCodeAt(counter++);
      if ((extra & 0xFC00) == 0xDC00) { // Low surrogate.
        output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
      } else {
        // It's an unmatched surrogate; only append this code unit, in case the
        // next code unit is the high surrogate of a surrogate pair.
        output.push(value);
        counter--;
      }
    } else {
      output.push(value);
    }
  }
  return output;
};

/**
 * Converts a digit/integer into a basic code point.
 */
var digitToBasic = function (digit) {
  //  0..25 map to ASCII a..z or A..Z
  // 26..35 map to ASCII 0..9
  return digit + 22 + 75 * (digit < 26);
};

/**
 * Bias adaptation function as per section 3.4 of RFC 3492.
 * https://tools.ietf.org/html/rfc3492#section-3.4
 */
var adapt = function (delta, numPoints, firstTime) {
  var k = 0;
  delta = firstTime ? floor(delta / damp) : delta >> 1;
  delta += floor(delta / numPoints);
  for (; delta > baseMinusTMin * tMax >> 1; k += base) {
    delta = floor(delta / baseMinusTMin);
  }
  return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
};

/**
 * Converts a string of Unicode symbols (e.g. a domain name label) to a
 * Punycode string of ASCII-only symbols.
 */
// eslint-disable-next-line  max-statements
var encode = function (input) {
  var output = [];

  // Convert the input in UCS-2 to an array of Unicode code points.
  input = ucs2decode(input);

  // Cache the length.
  var inputLength = input.length;

  // Initialize the state.
  var n = initialN;
  var delta = 0;
  var bias = initialBias;
  var i, currentValue;

  // Handle the basic code points.
  for (i = 0; i < input.length; i++) {
    currentValue = input[i];
    if (currentValue < 0x80) {
      output.push(stringFromCharCode(currentValue));
    }
  }

  var basicLength = output.length; // number of basic code points.
  var handledCPCount = basicLength; // number of code points that have been handled;

  // Finish the basic string with a delimiter unless it's empty.
  if (basicLength) {
    output.push(delimiter);
  }

  // Main encoding loop:
  while (handledCPCount < inputLength) {
    // All non-basic code points < n have been handled already. Find the next larger one:
    var m = maxInt;
    for (i = 0; i < input.length; i++) {
      currentValue = input[i];
      if (currentValue >= n && currentValue < m) {
        m = currentValue;
      }
    }

    // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>, but guard against overflow.
    var handledCPCountPlusOne = handledCPCount + 1;
    if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
      throw RangeError(OVERFLOW_ERROR);
    }

    delta += (m - n) * handledCPCountPlusOne;
    n = m;

    for (i = 0; i < input.length; i++) {
      currentValue = input[i];
      if (currentValue < n && ++delta > maxInt) {
        throw RangeError(OVERFLOW_ERROR);
      }
      if (currentValue == n) {
        // Represent delta as a generalized variable-length integer.
        var q = delta;
        for (var k = base; /* no condition */; k += base) {
          var t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
          if (q < t) break;
          var qMinusT = q - t;
          var baseMinusT = base - t;
          output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT)));
          q = floor(qMinusT / baseMinusT);
        }

        output.push(stringFromCharCode(digitToBasic(q)));
        bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
        delta = 0;
        ++handledCPCount;
      }
    }

    ++delta;
    ++n;
  }
  return output.join('');
};

module.exports = function (input) {
  var encoded = [];
  var labels = input.toLowerCase().replace(regexSeparators, '\u002E').split('.');
  var i, label;
  for (i = 0; i < labels.length; i++) {
    label = labels[i];
    encoded.push(regexNonASCII.test(label) ? 'xn--' + encode(label) : label);
  }
  return encoded.join('.');
};


/***/ }),

/***/ "604c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BaseItemGroup; });
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("4de4");
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("7db0");
/* harmony import */ var core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_find_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("c740");
/* harmony import */ var core_js_modules_es_array_find_index_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find_index_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("4160");
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("caad");
/* harmony import */ var core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_index_of_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("c975");
/* harmony import */ var core_js_modules_es_array_index_of_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("fb6a");
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_splice_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("a434");
/* harmony import */ var core_js_modules_es_array_splice_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_splice_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("a9e3");
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("2532");
/* harmony import */ var core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("159b");
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("5530");
/* harmony import */ var _src_components_VItemGroup_VItemGroup_sass__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("166a");
/* harmony import */ var _src_components_VItemGroup_VItemGroup_sass__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_src_components_VItemGroup_VItemGroup_sass__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _mixins_proxyable__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("a452");
/* harmony import */ var _mixins_themeable__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("7560");
/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("58df");
/* harmony import */ var _util_console__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("d9bd");












// Styles


 // Utilities



var BaseItemGroup = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_15__[/* default */ "a"])(_mixins_proxyable__WEBPACK_IMPORTED_MODULE_13__[/* default */ "a"], _mixins_themeable__WEBPACK_IMPORTED_MODULE_14__[/* default */ "a"]).extend({
  name: 'base-item-group',
  props: {
    activeClass: {
      type: String,
      default: 'v-item--active'
    },
    mandatory: Boolean,
    max: {
      type: [Number, String],
      default: null
    },
    multiple: Boolean,
    tag: {
      type: String,
      default: 'div'
    }
  },
  data: function data() {
    return {
      // As long as a value is defined, show it
      // Otherwise, check if multiple
      // to determine which default to provide
      internalLazyValue: this.value !== undefined ? this.value : this.multiple ? [] : undefined,
      items: []
    };
  },
  computed: {
    classes: function classes() {
      return Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_11__[/* default */ "a"])({
        'v-item-group': true
      }, this.themeClasses);
    },
    selectedIndex: function selectedIndex() {
      return this.selectedItem && this.items.indexOf(this.selectedItem) || -1;
    },
    selectedItem: function selectedItem() {
      if (this.multiple) return undefined;
      return this.selectedItems[0];
    },
    selectedItems: function selectedItems() {
      var _this = this;

      return this.items.filter(function (item, index) {
        return _this.toggleMethod(_this.getValue(item, index));
      });
    },
    selectedValues: function selectedValues() {
      if (this.internalValue == null) return [];
      return Array.isArray(this.internalValue) ? this.internalValue : [this.internalValue];
    },
    toggleMethod: function toggleMethod() {
      var _this2 = this;

      if (!this.multiple) {
        return function (v) {
          return _this2.internalValue === v;
        };
      }

      var internalValue = this.internalValue;

      if (Array.isArray(internalValue)) {
        return function (v) {
          return internalValue.includes(v);
        };
      }

      return function () {
        return false;
      };
    }
  },
  watch: {
    internalValue: 'updateItemsState',
    items: 'updateItemsState'
  },
  created: function created() {
    if (this.multiple && !Array.isArray(this.internalValue)) {
      Object(_util_console__WEBPACK_IMPORTED_MODULE_16__[/* consoleWarn */ "c"])('Model must be bound to an array if the multiple property is true.', this);
    }
  },
  methods: {
    genData: function genData() {
      return {
        class: this.classes
      };
    },
    getValue: function getValue(item, i) {
      return item.value == null || item.value === '' ? i : item.value;
    },
    onClick: function onClick(item) {
      this.updateInternalValue(this.getValue(item, this.items.indexOf(item)));
    },
    register: function register(item) {
      var _this3 = this;

      var index = this.items.push(item) - 1;
      item.$on('change', function () {
        return _this3.onClick(item);
      }); // If no value provided and mandatory,
      // assign first registered item

      if (this.mandatory && !this.selectedValues.length) {
        this.updateMandatory();
      }

      this.updateItem(item, index);
    },
    unregister: function unregister(item) {
      if (this._isDestroyed) return;
      var index = this.items.indexOf(item);
      var value = this.getValue(item, index);
      this.items.splice(index, 1);
      var valueIndex = this.selectedValues.indexOf(value); // Items is not selected, do nothing

      if (valueIndex < 0) return; // If not mandatory, use regular update process

      if (!this.mandatory) {
        return this.updateInternalValue(value);
      } // Remove the value


      if (this.multiple && Array.isArray(this.internalValue)) {
        this.internalValue = this.internalValue.filter(function (v) {
          return v !== value;
        });
      } else {
        this.internalValue = undefined;
      } // If mandatory and we have no selection
      // add the last item as value

      /* istanbul ignore else */


      if (!this.selectedItems.length) {
        this.updateMandatory(true);
      }
    },
    updateItem: function updateItem(item, index) {
      var value = this.getValue(item, index);
      item.isActive = this.toggleMethod(value);
    },
    // https://github.com/vuetifyjs/vuetify/issues/5352
    updateItemsState: function updateItemsState() {
      var _this4 = this;

      this.$nextTick(function () {
        if (_this4.mandatory && !_this4.selectedItems.length) {
          return _this4.updateMandatory();
        } // TODO: Make this smarter so it
        // doesn't have to iterate every
        // child in an update


        _this4.items.forEach(_this4.updateItem);
      });
    },
    updateInternalValue: function updateInternalValue(value) {
      this.multiple ? this.updateMultiple(value) : this.updateSingle(value);
    },
    updateMandatory: function updateMandatory(last) {
      if (!this.items.length) return;
      var items = this.items.slice();
      if (last) items.reverse();
      var item = items.find(function (item) {
        return !item.disabled;
      }); // If no tabs are available
      // aborts mandatory value

      if (!item) return;
      var index = this.items.indexOf(item);
      this.updateInternalValue(this.getValue(item, index));
    },
    updateMultiple: function updateMultiple(value) {
      var defaultValue = Array.isArray(this.internalValue) ? this.internalValue : [];
      var internalValue = defaultValue.slice();
      var index = internalValue.findIndex(function (val) {
        return val === value;
      });
      if (this.mandatory && // Item already exists
      index > -1 && // value would be reduced below min
      internalValue.length - 1 < 1) return;
      if ( // Max is set
      this.max != null && // Item doesn't exist
      index < 0 && // value would be increased above max
      internalValue.length + 1 > this.max) return;
      index > -1 ? internalValue.splice(index, 1) : internalValue.push(value);
      this.internalValue = internalValue;
    },
    updateSingle: function updateSingle(value) {
      var isSame = value === this.internalValue;
      if (this.mandatory && isSame) return;
      this.internalValue = isSame ? undefined : value;
    }
  },
  render: function render(h) {
    return h(this.tag, this.genData(), this.$slots.default);
  }
});
/* unused harmony default export */ var _unused_webpack_default_export = (BaseItemGroup.extend({
  name: 'v-item-group',
  provide: function provide() {
    return {
      itemGroup: this
    };
  }
}));

/***/ }),

/***/ "605d":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("c6b6");
var global = __webpack_require__("da84");

module.exports = classof(global.process) == 'process';


/***/ }),

/***/ "6074":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.i, "@import url(https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css);"]);
exports.push([module.i, "@import url(https://cdn-prd.patientpop.com/pp-icon-font/v1.6.0/pp-icon-font.css);"]);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.pp-card[data-v-74fb8428]{background-color:#fff;border-radius:6px;box-shadow:0 1px 2px rgba(130,138,163,.25);overflow:hidden;width:var(--pp-multi-card-width)}.pp-card__bg[data-v-74fb8428]:nth-of-type(10n+1){--pp-multi-card-bg:#417e86}.pp-card__bg[data-v-74fb8428]:nth-of-type(10n+2){--pp-multi-card-bg:#c74b76}.pp-card__bg[data-v-74fb8428]:nth-of-type(10n+3){--pp-multi-card-bg:#d83b4d}.pp-card__bg[data-v-74fb8428]:nth-of-type(10n+4){--pp-multi-card-bg:#fcde73}.pp-card__bg[data-v-74fb8428]:nth-of-type(10n+5){--pp-multi-card-bg:#3fa266}.pp-card__bg[data-v-74fb8428]:nth-of-type(10n+6){--pp-multi-card-bg:#ffaf95}.pp-card__bg[data-v-74fb8428]:nth-of-type(10n+7){--pp-multi-card-bg:#8657ac}.pp-card__bg[data-v-74fb8428]:nth-of-type(10n+8){--pp-multi-card-bg:#c74b76}.pp-card__bg[data-v-74fb8428]:nth-of-type(10n+9){--pp-multi-card-bg:#079cb2}.pp-card__bg[data-v-74fb8428]:nth-of-type(10n+10){--pp-multi-card-bg:#6fc691}.pp-card[data-v-74fb8428]:hover{box-shadow:0 12px 24px rgba(74,84,114,.04),0 6px 12px rgba(74,84,114,.04),0 4px 4px rgba(74,84,114,.04),0 2px 2px rgba(74,84,114,.04);cursor:pointer;transition:all .2s linear}.pp-card__image-container[data-v-74fb8428]{height:160px;width:100%}.pp-card__image-container--bg[data-v-74fb8428]{background-color:var(--pp-multi-card-bg)}.pp-card__image[data-v-74fb8428]{display:block;height:100%;-o-object-fit:cover;object-fit:cover;width:100%}.pp-card__subtitle[data-v-74fb8428],.pp-card__title[data-v-74fb8428]{-webkit-box-orient:vertical;display:-webkit-box;-webkit-line-clamp:1;overflow:hidden;text-overflow:ellipsis}.pp-card__title[data-v-74fb8428]{color:#2b2b2b;margin:0}.pp-card__subtitle-container[data-v-74fb8428]{height:21px;justify-content:space-between}.pp-card__subtitle[data-v-74fb8428]{color:#545454;font-size:1rem;margin-bottom:0}.pp-card__status-chip[data-v-74fb8428]{font-size:.857rem;right:0}.pp-card__drag[data-v-74fb8428]{align-items:center;cursor:move;display:flex;height:40px;position:absolute}.pp-card__drag-icon[data-v-74fb8428]{align-items:center;display:flex;flex-direction:column;justify-content:center;width:40px}.pp-card__drag-nibs[data-v-74fb8428]{display:flex;position:relative}.pp-card__drag-nibs[data-v-74fb8428]:after,.pp-card__drag-nibs[data-v-74fb8428]:before{background-color:#fff;border-radius:100%;content:\"\";display:block;height:3px;margin:1px;transition:background-color .2s linear;width:3px}.pp-card__avatar[data-v-74fb8428]{position:absolute}.pp-card__avatar__icon[data-v-74fb8428]{color:#fff;font-size:2.057em}.pp-card__avatar[data-v-74fb8428]:before{background-blend-mode:soft-light;background-color:#fff;content:\"\";height:100%;left:0;opacity:.2;position:absolute;top:0;width:100%}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "609f":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("a7dc");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("61af3c61", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "60da":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__("83ab");
var fails = __webpack_require__("d039");
var objectKeys = __webpack_require__("df75");
var getOwnPropertySymbolsModule = __webpack_require__("7418");
var propertyIsEnumerableModule = __webpack_require__("d1e7");
var toObject = __webpack_require__("7b0b");
var IndexedObject = __webpack_require__("44ad");

var nativeAssign = Object.assign;
var defineProperty = Object.defineProperty;

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
module.exports = !nativeAssign || fails(function () {
  // should have correct order of operations (Edge bug)
  if (DESCRIPTORS && nativeAssign({ b: 1 }, nativeAssign(defineProperty({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var symbol = Symbol();
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return nativeAssign({}, A)[symbol] != 7 || objectKeys(nativeAssign({}, B)).join('') != alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject(arguments[index++]);
    var keys = getOwnPropertySymbols ? objectKeys(S).concat(getOwnPropertySymbols(S)) : objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || propertyIsEnumerable.call(S, key)) T[key] = S[key];
    }
  } return T;
} : nativeAssign;


/***/ }),

/***/ "615b":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("b6b0");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("00f9175a", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "61ae":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M5 20C4.44772 20 4 19.5523 4 19L4 4C4 3.44771 4.44772 3 5 3L8 3L8 20L5 20Z\" fill=\"#DFE4E5\"></path><path d=\"M8 20L8 3L20 3L20 20L8 20Z\" fill=\"white\"></path><path d=\"M5 3H19C20.1046 3 21 3.89543 21 5V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V5C3 3.89543 3.89543 3 5 3Z\" stroke=\"#688083\" stroke-width=\"2\"></path><path d=\"M13.6626 14.7182L17.7206 10.6413C17.9624 10.3987 18.0571 10.0449 17.9689 9.7131C17.8806 9.38135 17.623 9.12208 17.2929 9.03296C16.9628 8.94384 16.6104 9.0384 16.3686 9.28104L12.9876 12.6798L11.6336 11.3195C11.2597 10.9441 10.6537 10.9443 10.2801 11.32C9.90645 11.6956 9.90667 12.3044 10.2806 12.6798L12.3096 14.7182C12.4889 14.8986 12.7323 15 12.9861 15C13.2399 15 13.4832 14.8986 13.6626 14.7182Z\" fill=\"#688083\"></path><rect width=\"17\" height=\"2\" transform=\"matrix(1.19249e-08 -1 -1 -1.19249e-08 8 20)\" fill=\"#688083\"></rect></svg>";

/***/ }),

/***/ "61d2":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("9b0c");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("d35030b6", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "6254":
/***/ (function(module, exports, __webpack_require__) {

var distanceInWords = __webpack_require__("366b")

/**
 * @category Common Helpers
 * @summary Return the distance between the given date and now in words.
 *
 * @description
 * Return the distance between the given date and now in words.
 *
 * | Distance to now                                                   | Result              |
 * |-------------------------------------------------------------------|---------------------|
 * | 0 ... 30 secs                                                     | less than a minute  |
 * | 30 secs ... 1 min 30 secs                                         | 1 minute            |
 * | 1 min 30 secs ... 44 mins 30 secs                                 | [2..44] minutes     |
 * | 44 mins ... 30 secs ... 89 mins 30 secs                           | about 1 hour        |
 * | 89 mins 30 secs ... 23 hrs 59 mins 30 secs                        | about [2..24] hours |
 * | 23 hrs 59 mins 30 secs ... 41 hrs 59 mins 30 secs                 | 1 day               |
 * | 41 hrs 59 mins 30 secs ... 29 days 23 hrs 59 mins 30 secs         | [2..30] days        |
 * | 29 days 23 hrs 59 mins 30 secs ... 44 days 23 hrs 59 mins 30 secs | about 1 month       |
 * | 44 days 23 hrs 59 mins 30 secs ... 59 days 23 hrs 59 mins 30 secs | about 2 months      |
 * | 59 days 23 hrs 59 mins 30 secs ... 1 yr                           | [2..12] months      |
 * | 1 yr ... 1 yr 3 months                                            | about 1 year        |
 * | 1 yr 3 months ... 1 yr 9 month s                                  | over 1 year         |
 * | 1 yr 9 months ... 2 yrs                                           | almost 2 years      |
 * | N yrs ... N yrs 3 months                                          | about N years       |
 * | N yrs 3 months ... N yrs 9 months                                 | over N years        |
 * | N yrs 9 months ... N+1 yrs                                        | almost N+1 years    |
 *
 * With `options.includeSeconds == true`:
 * | Distance to now     | Result               |
 * |---------------------|----------------------|
 * | 0 secs ... 5 secs   | less than 5 seconds  |
 * | 5 secs ... 10 secs  | less than 10 seconds |
 * | 10 secs ... 20 secs | less than 20 seconds |
 * | 20 secs ... 40 secs | half a minute        |
 * | 40 secs ... 60 secs | less than a minute   |
 * | 60 secs ... 90 secs | 1 minute             |
 *
 * @param {Date|String|Number} date - the given date
 * @param {Object} [options] - the object with options
 * @param {Boolean} [options.includeSeconds=false] - distances less than a minute are more detailed
 * @param {Boolean} [options.addSuffix=false] - result specifies if the second date is earlier or later than the first
 * @param {Object} [options.locale=enLocale] - the locale object
 * @returns {String} the distance in words
 *
 * @example
 * // If today is 1 January 2015, what is the distance to 2 July 2014?
 * var result = distanceInWordsToNow(
 *   new Date(2014, 6, 2)
 * )
 * //=> '6 months'
 *
 * @example
 * // If now is 1 January 2015 00:00:00,
 * // what is the distance to 1 January 2015 00:00:15, including seconds?
 * var result = distanceInWordsToNow(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   {includeSeconds: true}
 * )
 * //=> 'less than 20 seconds'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 January 2016, with a suffix?
 * var result = distanceInWordsToNow(
 *   new Date(2016, 0, 1),
 *   {addSuffix: true}
 * )
 * //=> 'in about 1 year'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 August 2016 in Esperanto?
 * var eoLocale = require('date-fns/locale/eo')
 * var result = distanceInWordsToNow(
 *   new Date(2016, 7, 1),
 *   {locale: eoLocale}
 * )
 * //=> 'pli ol 1 jaro'
 */
function distanceInWordsToNow (dirtyDate, dirtyOptions) {
  return distanceInWords(Date.now(), dirtyDate, dirtyOptions)
}

module.exports = distanceInWordsToNow


/***/ }),

/***/ "62ad":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("4160");
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("caad");
/* harmony import */ var core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("e260");
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_reduce_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("13d5");
/* harmony import */ var core_js_modules_es_array_reduce_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_some_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("45fc");
/* harmony import */ var core_js_modules_es_array_some_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_map_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("4ec9");
/* harmony import */ var core_js_modules_es_map_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_map_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("a9e3");
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("b64b");
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("d3b7");
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("ac1f");
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("3ca3");
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("5319");
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_string_starts_with_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("2ca0");
/* harmony import */ var core_js_modules_es_string_starts_with_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_starts_with_js__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("159b");
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("ddb0");
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("ade3");
/* harmony import */ var _home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("5530");
/* harmony import */ var _src_components_VGrid_VGrid_sass__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("4b85");
/* harmony import */ var _src_components_VGrid_VGrid_sass__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(_src_components_VGrid_VGrid_sass__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("8bbf");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var _util_mergeData__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("d9f7");
/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("80d2");




















 // no xs

var breakpoints = ['sm', 'md', 'lg', 'xl'];

var breakpointProps = function () {
  return breakpoints.reduce(function (props, val) {
    props[val] = {
      type: [Boolean, String, Number],
      default: false
    };
    return props;
  }, {});
}();

var offsetProps = function () {
  return breakpoints.reduce(function (props, val) {
    props['offset' + Object(_util_helpers__WEBPACK_IMPORTED_MODULE_20__[/* upperFirst */ "G"])(val)] = {
      type: [String, Number],
      default: null
    };
    return props;
  }, {});
}();

var orderProps = function () {
  return breakpoints.reduce(function (props, val) {
    props['order' + Object(_util_helpers__WEBPACK_IMPORTED_MODULE_20__[/* upperFirst */ "G"])(val)] = {
      type: [String, Number],
      default: null
    };
    return props;
  }, {});
}();

var propMap = {
  col: Object.keys(breakpointProps),
  offset: Object.keys(offsetProps),
  order: Object.keys(orderProps)
};

function breakpointClass(type, prop, val) {
  var className = type;

  if (val == null || val === false) {
    return undefined;
  }

  if (prop) {
    var breakpoint = prop.replace(type, '');
    className += "-".concat(breakpoint);
  } // Handling the boolean style prop when accepting [Boolean, String, Number]
  // means Vue will not convert <v-col sm></v-col> to sm: true for us.
  // Since the default is false, an empty string indicates the prop's presence.


  if (type === 'col' && (val === '' || val === true)) {
    // .col-md
    return className.toLowerCase();
  } // .order-md-6


  className += "-".concat(val);
  return className.toLowerCase();
}

var cache = new Map();
/* harmony default export */ __webpack_exports__["a"] = (vue__WEBPACK_IMPORTED_MODULE_18___default.a.extend({
  name: 'v-col',
  functional: true,
  props: Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_16__[/* default */ "a"])(Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_16__[/* default */ "a"])(Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_16__[/* default */ "a"])(Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_16__[/* default */ "a"])({
    cols: {
      type: [Boolean, String, Number],
      default: false
    }
  }, breakpointProps), {}, {
    offset: {
      type: [String, Number],
      default: null
    }
  }, offsetProps), {}, {
    order: {
      type: [String, Number],
      default: null
    }
  }, orderProps), {}, {
    alignSelf: {
      type: String,
      default: null,
      validator: function validator(str) {
        return ['auto', 'start', 'end', 'center', 'baseline', 'stretch'].includes(str);
      }
    },
    tag: {
      type: String,
      default: 'div'
    }
  }),
  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children,
        parent = _ref.parent;
    // Super-fast memoization based on props, 5x faster than JSON.stringify
    var cacheKey = '';

    for (var prop in props) {
      cacheKey += String(props[prop]);
    }

    var classList = cache.get(cacheKey);

    if (!classList) {
      (function () {
        var _classList$push;

        classList = []; // Loop through `col`, `offset`, `order` breakpoint props

        var type;

        for (type in propMap) {
          propMap[type].forEach(function (prop) {
            var value = props[prop];
            var className = breakpointClass(type, prop, value);
            if (className) classList.push(className);
          });
        }

        var hasColClasses = classList.some(function (className) {
          return className.startsWith('col-');
        });
        classList.push((_classList$push = {
          // Default to .col if no other col-{bp}-* classes generated nor `cols` specified.
          col: !hasColClasses || !props.cols
        }, Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_15__[/* default */ "a"])(_classList$push, "col-".concat(props.cols), props.cols), Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_15__[/* default */ "a"])(_classList$push, "offset-".concat(props.offset), props.offset), Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_15__[/* default */ "a"])(_classList$push, "order-".concat(props.order), props.order), Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_15__[/* default */ "a"])(_classList$push, "align-self-".concat(props.alignSelf), props.alignSelf), _classList$push));
        cache.set(cacheKey, classList);
      })();
    }

    return h(props.tag, Object(_util_mergeData__WEBPACK_IMPORTED_MODULE_19__[/* default */ "a"])(data, {
      class: classList
    }), children);
  }
}));

/***/ }),

/***/ "62df":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.i, "@import url(https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css);"]);
exports.push([module.i, "@import url(https://cdn-prd.patientpop.com/pp-icon-font/v1.6.0/pp-icon-font.css);"]);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.error--text[data-v-63ab36bc]  .v-text-field__control{position:relative}.error--text[data-v-63ab36bc]  .v-messages{display:inline-block;left:0;overflow:hidden;position:absolute;top:calc(100% - 14px)}.error--text[data-v-63ab36bc]  .v-messages__message{background:#fff;overflow:hidden;padding:0 3px;text-overflow:ellipsis;white-space:nowrap}.theme--light.v-input[data-v-63ab36bc]:not(.theme--light.v-input--is-focused)  fieldset{border-color:transparent}.theme--light.v-input[data-v-63ab36bc]:not(.theme--light.v-input--is-focused):not(.theme--light.v-input--is-disabled){--text-primary:#2b2b2b}.theme--light.v-input .pp-input-text__error-icon[data-v-63ab36bc]{color:#b51a2c}.theme--light.v-input:not(.theme--light.v-input--is-focused):not(.theme--light.v-input--is-disabled).error--text[data-v-63ab36bc]{--pp-text-field-fill:#fceeee}.theme--light.v-input.pp-input-select--white-bg[data-v-63ab36bc]:not(.theme--light.v-input--is-disabled),.theme--light.v-input.pp-input-text--white-bg[data-v-63ab36bc]:not(.theme--light.v-input--is-disabled){--pp-text-placeholder:#545454}.theme--light.v-input.pp-input-select--white-bg[data-v-63ab36bc]:not(.theme--light.v-input--is-disabled):not(.theme--light.v-input--is-focused):not(.error--text),.theme--light.v-input.pp-input-text--white-bg[data-v-63ab36bc]:not(.theme--light.v-input--is-disabled):not(.theme--light.v-input--is-focused):not(.error--text){--pp-text-field-fill:#fff}.theme--light.v-input.pp-input-select--white-bg[data-v-63ab36bc]:not(.theme--light.v-input--is-disabled):not(.theme--light.v-input--is-focused):not(.error--text)  .theme--light.v-input__slot:hover,.theme--light.v-input.pp-input-text--white-bg[data-v-63ab36bc]:not(.theme--light.v-input--is-disabled):not(.theme--light.v-input--is-focused):not(.error--text)  .theme--light.v-input__slot:hover{--pp-text-field-fill-on-hover:#fff}.theme--light.v-input.theme--light.v-input--is-focused[data-v-63ab36bc]{--pp-text-field-fill:#fff}.theme--light.v-input.theme--light.v-input--is-disabled[data-v-63ab36bc]{--pp-text-disabled:#9a9a9a;--pp-text-field-fill:#f6f6f6;--pp-text-placeholder:#9a9a9a}.theme--light.v-input[data-v-63ab36bc]  input::-moz-placeholder,.theme--light.v-input[data-v-63ab36bc]  textarea::-moz-placeholder{color:var(--pp-text-placeholder,#545454)}.theme--light.v-input[data-v-63ab36bc]  input:-ms-input-placeholder,.theme--light.v-input[data-v-63ab36bc]  textarea:-ms-input-placeholder{color:var(--pp-text-placeholder,#545454)}.theme--light.v-input[data-v-63ab36bc]  input::placeholder,.theme--light.v-input[data-v-63ab36bc]  textarea::placeholder{color:var(--pp-text-placeholder,#545454)}.theme--light.v-input[data-v-63ab36bc]  .theme--light.v-input__append-inner{margin-bottom:auto;margin-top:auto}.theme--light.v-input[data-v-63ab36bc]  .theme--light.v-input__append-inner i:before{display:block}[data-v-63ab36bc]{--pp-list-item-min-height:24px;--pp-list-item-padding:6px 12px;--pp-list-item-title-font-size:14px;--pp-list-item-title-subtitle-line-height:20px}[data-v-63ab36bc] .v-list-item{box-sizing:content-box;z-index:1}[data-v-63ab36bc] .v-list-item:before{border-radius:20px}[data-v-63ab36bc] .v-list-item:hover:not(::v-deep .v-list-item--active):before{background:var(--pp-theme-color,#2b2b2b)}[data-v-63ab36bc] .v-list-item:hover::v-deep .v-list-item--active:before{background:var(--pp-theme-color,#067889)}[data-v-63ab36bc] .v-list-item:not(:last-child){margin-bottom:4px}[data-v-63ab36bc] .v-text-field input{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.v-select .select-caret[data-v-63ab36bc]{cursor:pointer;font-size:.457em;position:absolute;right:1em;top:50%;transform:translateY(-50%)}.v-select--is-menu-active[data-v-63ab36bc]  .error--text{display:none}.v-input[data-v-63ab36bc]  .v-input__icon--clear{margin-right:.7em;margin-top:-.2em}.v-input[data-v-63ab36bc]  .v-input__append-inner{align-items:center;height:100%;justify-content:left;margin-top:0;padding:0;width:2.1428571429rem}.v-input.pp-input-select__autocomplete[data-v-63ab36bc]  .v-input__control .v-input__slot{padding:0 0 0 .8571428571rem}.v-input--is-disabled.pp-input-select-loading[data-v-63ab36bc]{--pp-text-field-fill:#fef5d5}.pp-input-select__native[data-v-63ab36bc]{height:2.7857142857rem;position:relative}.pp-input-select__native__select[data-v-63ab36bc]{border:1px solid #d6d6d6;color:#2b2b2b;cursor:pointer;display:block;left:0;overflow:hidden;position:absolute;text-overflow:ellipsis;top:0;white-space:nowrap;width:100%;z-index:10}.pp-input-select__native__select[data-v-63ab36bc]:focus{border-color:#079cb2;outline:none}.pp-input-select__native__select--placeholder[data-v-63ab36bc]{color:#9a9a9a}.pp-input-select__native__select--error[data-v-63ab36bc]{border-color:#d83b4d}.pp-input-select__native__caret[data-v-63ab36bc]{font-size:.457em;position:absolute;right:.75rem;top:50%;transform:translateY(-50%)}.pp-input-select__native__prepend-icon[data-v-63ab36bc]{left:.75rem;position:absolute;top:50%;transform:translateY(-50%)}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "6337":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("c8d5")

var MILLISECONDS_IN_DAY = 24 * 60 * 60 * 1000

/**
 * @category Range Helpers
 * @summary Get the number of days that overlap in two date ranges
 *
 * @description
 * Get the number of days that overlap in two date ranges
 *
 * @param {Date|String|Number} initialRangeStartDate - the start of the initial range
 * @param {Date|String|Number} initialRangeEndDate - the end of the initial range
 * @param {Date|String|Number} comparedRangeStartDate - the start of the range to compare it with
 * @param {Date|String|Number} comparedRangeEndDate - the end of the range to compare it with
 * @returns {Number} the number of days that overlap in two date ranges
 * @throws {Error} startDate of a date range cannot be after its endDate
 *
 * @example
 * // For overlapping date ranges adds 1 for each started overlapping day:
 * getOverlappingDaysInRanges(
 *   new Date(2014, 0, 10), new Date(2014, 0, 20), new Date(2014, 0, 17), new Date(2014, 0, 21)
 * )
 * //=> 3
 *
 * @example
 * // For non-overlapping date ranges returns 0:
 * getOverlappingDaysInRanges(
 *   new Date(2014, 0, 10), new Date(2014, 0, 20), new Date(2014, 0, 21), new Date(2014, 0, 22)
 * )
 * //=> 0
 */
function getOverlappingDaysInRanges (dirtyInitialRangeStartDate, dirtyInitialRangeEndDate, dirtyComparedRangeStartDate, dirtyComparedRangeEndDate) {
  var initialStartTime = parse(dirtyInitialRangeStartDate).getTime()
  var initialEndTime = parse(dirtyInitialRangeEndDate).getTime()
  var comparedStartTime = parse(dirtyComparedRangeStartDate).getTime()
  var comparedEndTime = parse(dirtyComparedRangeEndDate).getTime()

  if (initialStartTime > initialEndTime || comparedStartTime > comparedEndTime) {
    throw new Error('The start of the range cannot be after the end of the range')
  }

  var isOverlapping = initialStartTime < comparedEndTime && comparedStartTime < initialEndTime

  if (!isOverlapping) {
    return 0
  }

  var overlapStartDate = comparedStartTime < initialStartTime
    ? initialStartTime
    : comparedStartTime

  var overlapEndDate = comparedEndTime > initialEndTime
    ? initialEndTime
    : comparedEndTime

  var differenceInMs = overlapEndDate - overlapStartDate

  return Math.ceil(differenceInMs / MILLISECONDS_IN_DAY)
}

module.exports = getOverlappingDaysInRanges


/***/ }),

/***/ "6371":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpInputSearch_vue_vue_type_style_index_0_id_9f96eb4e_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("bdd2");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpInputSearch_vue_vue_type_style_index_0_id_9f96eb4e_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpInputSearch_vue_vue_type_style_index_0_id_9f96eb4e_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "63f4":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><rect x=\"3\" y=\"3\" width=\"14\" height=\"13\" fill=\"#DFE4E5\"></rect><path d=\"M15 3H5C3.89543 3 3 3.80589 3 4.8V19.2C3 20.1941 3.89543 21 5 21H15C16.1046 21 17 20.1941 17 19.2V4.8C17 3.80589 16.1046 3 15 3Z\" stroke=\"#1F3A3E\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M10 18H10.01\" stroke=\"#1F3A3E\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M21 13C21 14.1046 20.1046 15 19 15H10V9C10 7.89543 10.8954 7 12 7H21V13Z\" fill=\"white\" stroke=\"#1F3A3E\" stroke-width=\"2\"></path><rect x=\"13\" y=\"10\" width=\"5\" height=\"2\" fill=\"#1F3A3E\"></rect></svg>";

/***/ }),

/***/ "6544":
/***/ (function(module, exports) {

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function installComponents (component, components) {
  var options = typeof component.exports === 'function'
    ? component.exports.extendOptions
    : component.options

  if (typeof component.exports === 'function') {
    options.components = component.exports.options.components
  }

  options.components = options.components || {}

  for (var i in components) {
    options.components[i] = options.components[i] || components[i]
  }
}


/***/ }),

/***/ "6547":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("a691");
var requireObjectCoercible = __webpack_require__("1d80");

// `String.prototype.{ codePointAt, at }` methods implementation
var createMethod = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = String(requireObjectCoercible($this));
    var position = toInteger(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = S.charCodeAt(position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = S.charCodeAt(position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING ? S.charAt(position) : first
        : CONVERT_TO_STRING ? S.slice(position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

module.exports = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod(true)
};


/***/ }),

/***/ "6566":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var defineProperty = __webpack_require__("9bf2").f;
var create = __webpack_require__("7c73");
var redefineAll = __webpack_require__("e2cc");
var bind = __webpack_require__("0366");
var anInstance = __webpack_require__("19aa");
var iterate = __webpack_require__("2266");
var defineIterator = __webpack_require__("7dd0");
var setSpecies = __webpack_require__("2626");
var DESCRIPTORS = __webpack_require__("83ab");
var fastKey = __webpack_require__("f183").fastKey;
var InternalStateModule = __webpack_require__("69f3");

var setInternalState = InternalStateModule.set;
var internalStateGetterFor = InternalStateModule.getterFor;

module.exports = {
  getConstructor: function (wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, CONSTRUCTOR_NAME);
      setInternalState(that, {
        type: CONSTRUCTOR_NAME,
        index: create(null),
        first: undefined,
        last: undefined,
        size: 0
      });
      if (!DESCRIPTORS) that.size = 0;
      if (iterable != undefined) iterate(iterable, that[ADDER], { that: that, AS_ENTRIES: IS_MAP });
    });

    var getInternalState = internalStateGetterFor(CONSTRUCTOR_NAME);

    var define = function (that, key, value) {
      var state = getInternalState(that);
      var entry = getEntry(that, key);
      var previous, index;
      // change existing entry
      if (entry) {
        entry.value = value;
      // create new entry
      } else {
        state.last = entry = {
          index: index = fastKey(key, true),
          key: key,
          value: value,
          previous: previous = state.last,
          next: undefined,
          removed: false
        };
        if (!state.first) state.first = entry;
        if (previous) previous.next = entry;
        if (DESCRIPTORS) state.size++;
        else that.size++;
        // add to index
        if (index !== 'F') state.index[index] = entry;
      } return that;
    };

    var getEntry = function (that, key) {
      var state = getInternalState(that);
      // fast case
      var index = fastKey(key);
      var entry;
      if (index !== 'F') return state.index[index];
      // frozen object case
      for (entry = state.first; entry; entry = entry.next) {
        if (entry.key == key) return entry;
      }
    };

    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        var that = this;
        var state = getInternalState(that);
        var data = state.index;
        var entry = state.first;
        while (entry) {
          entry.removed = true;
          if (entry.previous) entry.previous = entry.previous.next = undefined;
          delete data[entry.index];
          entry = entry.next;
        }
        state.first = state.last = undefined;
        if (DESCRIPTORS) state.size = 0;
        else that.size = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = this;
        var state = getInternalState(that);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.next;
          var prev = entry.previous;
          delete state.index[entry.index];
          entry.removed = true;
          if (prev) prev.next = next;
          if (next) next.previous = prev;
          if (state.first == entry) state.first = next;
          if (state.last == entry) state.last = prev;
          if (DESCRIPTORS) state.size--;
          else that.size--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        var state = getInternalState(this);
        var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.next : state.first) {
          boundFunction(entry.value, entry.key, this);
          // revert to the last existing entry
          while (entry && entry.removed) entry = entry.previous;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(this, key);
      }
    });

    redefineAll(C.prototype, IS_MAP ? {
      // 23.1.3.6 Map.prototype.get(key)
      get: function get(key) {
        var entry = getEntry(this, key);
        return entry && entry.value;
      },
      // 23.1.3.9 Map.prototype.set(key, value)
      set: function set(key, value) {
        return define(this, key === 0 ? 0 : key, value);
      }
    } : {
      // 23.2.3.1 Set.prototype.add(value)
      add: function add(value) {
        return define(this, value = value === 0 ? 0 : value, value);
      }
    });
    if (DESCRIPTORS) defineProperty(C.prototype, 'size', {
      get: function () {
        return getInternalState(this).size;
      }
    });
    return C;
  },
  setStrong: function (C, CONSTRUCTOR_NAME, IS_MAP) {
    var ITERATOR_NAME = CONSTRUCTOR_NAME + ' Iterator';
    var getInternalCollectionState = internalStateGetterFor(CONSTRUCTOR_NAME);
    var getInternalIteratorState = internalStateGetterFor(ITERATOR_NAME);
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    defineIterator(C, CONSTRUCTOR_NAME, function (iterated, kind) {
      setInternalState(this, {
        type: ITERATOR_NAME,
        target: iterated,
        state: getInternalCollectionState(iterated),
        kind: kind,
        last: undefined
      });
    }, function () {
      var state = getInternalIteratorState(this);
      var kind = state.kind;
      var entry = state.last;
      // revert to the last existing entry
      while (entry && entry.removed) entry = entry.previous;
      // get next entry
      if (!state.target || !(state.last = entry = entry ? entry.next : state.state.first)) {
        // or finish the iteration
        state.target = undefined;
        return { value: undefined, done: true };
      }
      // return step by kind
      if (kind == 'keys') return { value: entry.key, done: false };
      if (kind == 'values') return { value: entry.value, done: false };
      return { value: [entry.key, entry.value], done: false };
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(CONSTRUCTOR_NAME);
  }
};


/***/ }),

/***/ "6570":
/***/ (function(module, exports, __webpack_require__) {

var differenceInMilliseconds = __webpack_require__("e785")

var MILLISECONDS_IN_MINUTE = 60000

/**
 * @category Minute Helpers
 * @summary Get the number of minutes between the given dates.
 *
 * @description
 * Get the number of minutes between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of minutes
 *
 * @example
 * // How many minutes are between 2 July 2014 12:07:59 and 2 July 2014 12:20:00?
 * var result = differenceInMinutes(
 *   new Date(2014, 6, 2, 12, 20, 0),
 *   new Date(2014, 6, 2, 12, 7, 59)
 * )
 * //=> 12
 */
function differenceInMinutes (dirtyDateLeft, dirtyDateRight) {
  var diff = differenceInMilliseconds(dirtyDateLeft, dirtyDateRight) / MILLISECONDS_IN_MINUTE
  return diff > 0 ? Math.floor(diff) : Math.ceil(diff)
}

module.exports = differenceInMinutes


/***/ }),

/***/ "65c5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpExpansionPanel_vue_vue_type_style_index_0_id_30219416_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("4820");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpExpansionPanel_vue_vue_type_style_index_0_id_30219416_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpExpansionPanel_vue_vue_type_style_index_0_id_30219416_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "65f0":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");
var isArray = __webpack_require__("e8b5");
var wellKnownSymbol = __webpack_require__("b622");

var SPECIES = wellKnownSymbol('species');

// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray, length) {
  var C;
  if (isArray(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    else if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return new (C === undefined ? Array : C)(length === 0 ? 0 : length);
};


/***/ }),

/***/ "662a":
/***/ (function(module, exports, __webpack_require__) {

var startOfHour = __webpack_require__("fbaf")

/**
 * @category Hour Helpers
 * @summary Are the given dates in the same hour?
 *
 * @description
 * Are the given dates in the same hour?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same hour
 *
 * @example
 * // Are 4 September 2014 06:00:00 and 4 September 06:30:00 in the same hour?
 * var result = isSameHour(
 *   new Date(2014, 8, 4, 6, 0),
 *   new Date(2014, 8, 4, 6, 30)
 * )
 * //=> true
 */
function isSameHour (dirtyDateLeft, dirtyDateRight) {
  var dateLeftStartOfHour = startOfHour(dirtyDateLeft)
  var dateRightStartOfHour = startOfHour(dirtyDateRight)

  return dateLeftStartOfHour.getTime() === dateRightStartOfHour.getTime()
}

module.exports = isSameHour


/***/ }),

/***/ "6665":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("c8d5")
var getDaysInMonth = __webpack_require__("5416")

/**
 * @category Month Helpers
 * @summary Add the specified number of months to the given date.
 *
 * @description
 * Add the specified number of months to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be added
 * @returns {Date} the new date with the months added
 *
 * @example
 * // Add 5 months to 1 September 2014:
 * var result = addMonths(new Date(2014, 8, 1), 5)
 * //=> Sun Feb 01 2015 00:00:00
 */
function addMonths (dirtyDate, dirtyAmount) {
  var date = parse(dirtyDate)
  var amount = Number(dirtyAmount)
  var desiredMonth = date.getMonth() + amount
  var dateWithDesiredMonth = new Date(0)
  dateWithDesiredMonth.setFullYear(date.getFullYear(), desiredMonth, 1)
  dateWithDesiredMonth.setHours(0, 0, 0, 0)
  var daysInMonth = getDaysInMonth(dateWithDesiredMonth)
  // Set the last day of the new month
  // if the original date was the last day of the longer month
  date.setMonth(desiredMonth, Math.min(daysInMonth, date.getDate()))
  return date
}

module.exports = addMonths


/***/ }),

/***/ "6695":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("22c4");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("0e4a6ac0", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "676d":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.theme--light.v-pagination .v-pagination__item{background:var(--cards-color,#fff);color:var(--pp-text-primary,#2b2b2b)}.theme--light.v-pagination .v-pagination__item--active{color:#fff}.theme--light.v-pagination .v-pagination__navigation{background:var(--cards-color,#fff)}.theme--dark.v-pagination .v-pagination__item{background:#1e1e1e;color:var(--pp-primary-button-text-color,#004852)}.theme--dark.v-pagination .v-pagination__item--active{color:#fff}.theme--dark.v-pagination .v-pagination__navigation{background:#1e1e1e}.v-pagination{align-items:center;display:inline-flex;list-style-type:none;justify-content:center;margin:0;max-width:100%;width:100%}.v-pagination.v-pagination{padding-left:0}.v-pagination>li{align-items:center;display:flex}.v-pagination--circle .v-pagination__item,.v-pagination--circle .v-pagination__more,.v-pagination--circle .v-pagination__navigation{border-radius:50%}.v-pagination--disabled{pointer-events:none;opacity:.6}.v-pagination__item{background:transparent;border-radius:5px;font-size:.8571428571rem;height:34px;margin:.3rem;min-width:34px;padding:0 5px;text-decoration:none;transition:.3s cubic-bezier(0,0,.2,1);width:auto;box-shadow:0 3px 1px -2px transparent,0 2px 2px 0 transparent,0 1px 5px 0 rgba(0,0,0,.12)}.v-pagination__item--active{box-shadow:0 2px 4px -1px transparent,0 4px 5px 0 transparent,0 1px 10px 0 rgba(0,0,0,.12)}.v-pagination__navigation{box-shadow:0 3px 1px -2px transparent,0 2px 2px 0 transparent,0 1px 5px 0 rgba(0,0,0,.12);border-radius:5px;display:inline-flex;justify-content:center;align-items:center;text-decoration:none;height:32px;width:32px;margin:.3rem 10px}.v-pagination__navigation .v-icon{transition:.2s cubic-bezier(.4,0,.6,1);vertical-align:middle}.v-pagination__navigation--disabled{opacity:.6;pointer-events:none}.v-pagination__more{margin:.3rem;display:inline-flex;align-items:flex-end;justify-content:center;height:32px;width:32px}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "6801":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.i, "@import url(https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css);"]);
exports.push([module.i, "@import url(https://cdn-prd.patientpop.com/pp-icon-font/v1.6.0/pp-icon-font.css);"]);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}main[data-v-e6e0eea4]{--pp-header-height:77px;--pp-top-bar-height:64px;position:relative}@media(min-width:960px){main[data-v-e6e0eea4]  .pp-page-header{padding-right:90px}}main[data-v-e6e0eea4]:not(.container--fluid){max-width:var(--pp-main-width,1188px)}.pp-app[data-v-e6e0eea4]{background:#f6f6f6;display:grid;grid-template-columns:var(--side-bar-width,0) calc(100% - var(--side-bar-width, 0px));min-height:100vh}@media(min-width:960px){.pp-app[data-v-e6e0eea4]{--side-bar-width:18.8571428571rem}}.pp-app--white-bg[data-v-e6e0eea4]{background:#fff}header[data-v-e6e0eea4]{z-index:1}@media(min-width:960px){.practice-header[data-v-e6e0eea4]{background:#004852;position:sticky;top:0;z-index:1}}.practice-header__logo[data-v-e6e0eea4]{max-width:161px}.practice-header__switch-practice[data-v-e6e0eea4]{cursor:pointer}@media(min-width:960px){.portal-side[data-v-e6e0eea4]{border-right:1px solid #d6d6d6;z-index:7}}@media(min-width:960px){.portal-side--with-pendo[data-v-e6e0eea4]:after{background:#004852;bottom:0;content:\"\";display:block;height:90px;position:fixed;width:calc(var(--side-bar-width, 200px) - 16px)}}@media(min-width:960px){.portal-side--with-pendo[data-v-e6e0eea4]  nav{padding-bottom:90px}}.portal-side__switch-practice[data-v-e6e0eea4]{background-color:#fff;position:absolute}.pp-icon-chevron-down[data-v-e6e0eea4]{font-size:.875em}@media print{._pendo-badge[data-v-e6e0eea4]{display:none!important}}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "68dd":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("3f06");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("489a7227", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "6929":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpInputSelect_vue_vue_type_style_index_1_id_63ab36bc_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("38e9");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpInputSelect_vue_vue_type_style_index_1_id_63ab36bc_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpInputSelect_vue_vue_type_style_index_1_id_63ab36bc_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "693a":
/***/ (function(module, exports) {

/**
 * @category Day Helpers
 * @summary Return the start of yesterday.
 *
 * @description
 * Return the start of yesterday.
 *
 * @returns {Date} the start of yesterday
 *
 * @example
 * // If today is 6 October 2014:
 * var result = startOfYesterday()
 * //=> Sun Oct 5 2014 00:00:00
 */
function startOfYesterday () {
  var now = new Date()
  var year = now.getFullYear()
  var month = now.getMonth()
  var day = now.getDate()

  var date = new Date(0)
  date.setFullYear(year, month, day - 1)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = startOfYesterday


/***/ }),

/***/ "69f3":
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_WEAK_MAP = __webpack_require__("7f9a");
var global = __webpack_require__("da84");
var isObject = __webpack_require__("861d");
var createNonEnumerableProperty = __webpack_require__("9112");
var objectHas = __webpack_require__("5135");
var shared = __webpack_require__("c6cd");
var sharedKey = __webpack_require__("f772");
var hiddenKeys = __webpack_require__("d012");

var WeakMap = global.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP) {
  var store = shared.state || (shared.state = new WeakMap());
  var wmget = store.get;
  var wmhas = store.has;
  var wmset = store.set;
  set = function (it, metadata) {
    metadata.facade = it;
    wmset.call(store, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget.call(store, it) || {};
  };
  has = function (it) {
    return wmhas.call(store, it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    metadata.facade = it;
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return objectHas(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return objectHas(it, STATE);
  };
}

module.exports = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};


/***/ }),

/***/ "6a21":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c662cfac-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/form-message/PpFormMessage.vue?vue&type=template&id=77eef96a&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pp-form-message pa-3 d-flex align-center rounded",class:[
    (_vm.textColor + "--text"),
    ("pp-form-message--" + _vm.type) ]},[_c('i',{staticClass:"mr-3 d-flex align-center",class:_vm.iconClasses.concat( [("pp-icon-" + _vm.typeIcon + " " + _vm.type + "--text pp-form-message__icon")]
    )}),_c('div',{staticClass:"text-h6"},[_vm._t("text",[_vm._v(" "+_vm._s(_vm.text)+" ")])],2)])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/form-message/PpFormMessage.vue?vue&type=template&id=77eef96a&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.index-of.js
var es_array_index_of = __webpack_require__("c975");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.values.js
var es_object_values = __webpack_require__("07ac");

// CONCATENATED MODULE: ./src/components/form-message/constants.js
var POSITIONS = {
  BOTTOM: 'bottom',
  CENTER: 'center',
  TOP: 'top'
};
var TYPES = {
  ALERT: 'alert',
  SUCCESS: 'success',
  WARNING: 'warning',
  ERROR: 'error'
};
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/form-message/PpFormMessage.vue?vue&type=script&lang=js&


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var PpFormMessagevue_type_script_lang_js_ = ({
  name: 'PpFormMessage',
  props: {
    /**
     * Sets message type: ['error', 'alert', 'warning', 'success']
     * error is default type
     */
    type: {
      type: String,
      validator: function validator(value) {
        return Object.values(TYPES).indexOf(value) !== -1;
      },
      default: 'error'
    },
    text: {
      type: String,
      default: ''
    },

    /**
     * Sets the icon vertical align: ['bottom', 'center', 'top']
     * top is default align
     */
    iconVerticalAlign: {
      type: String,
      default: 'top',
      validator: function validator(value) {
        return Object.values(POSITIONS).indexOf(value) !== -1;
      }
    }
  },
  computed: {
    typeIcon: function typeIcon() {
      switch (this.type) {
        case TYPES.SUCCESS:
          return 'check-circle';

        case TYPES.ALERT:
          return 'info';

        case TYPES.WARNING:
          return 'alert';

        default:
          return 'close-alt';
      }
    },
    iconClasses: function iconClasses() {
      var classes = [];

      switch (this.iconVerticalAlign) {
        case POSITIONS.TOP:
          classes.push('mb-auto');
          break;

        case POSITIONS.BOTTOM:
          classes.push('mt-auto');
          break;

        case POSITIONS.CENTER:
          classes.push('my-auto');
          break;
      }

      return classes;
    },
    textColor: function textColor() {
      switch (this.type) {
        case TYPES.ALERT:
          return 'orange';

        case TYPES.SUCCESS:
          return 'green';

        case TYPES.WARNING:
          return 'yellow';

        case TYPES.ERROR:
          return 'red';

        default:
          return 'red';
      }
    }
  }
});
// CONCATENATED MODULE: ./src/components/form-message/PpFormMessage.vue?vue&type=script&lang=js&
 /* harmony default export */ var form_message_PpFormMessagevue_type_script_lang_js_ = (PpFormMessagevue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/form-message/PpFormMessage.vue?vue&type=style&index=0&lang=scss&
var PpFormMessagevue_type_style_index_0_lang_scss_ = __webpack_require__("110a");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/form-message/PpFormMessage.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  form_message_PpFormMessagevue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var PpFormMessage = __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "6b75":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _arrayLikeToArray; });
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

/***/ }),

/***/ "6b8f":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("c8d5")

/**
 * @category Common Helpers
 * @summary Is the first date before the second one?
 *
 * @description
 * Is the first date before the second one?
 *
 * @param {Date|String|Number} date - the date that should be before the other one to return true
 * @param {Date|String|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is before the second date
 *
 * @example
 * // Is 10 July 1989 before 11 February 1987?
 * var result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> false
 */
function isBefore (dirtyDate, dirtyDateToCompare) {
  var date = parse(dirtyDate)
  var dateToCompare = parse(dirtyDateToCompare)
  return date.getTime() < dateToCompare.getTime()
}

module.exports = isBefore


/***/ }),

/***/ "6baa":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><rect x=\"3\" y=\"3\" width=\"18\" height=\"14\" fill=\"white\"></rect><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M13.4274 12C15.3757 12 17.0407 13.4038 17.3699 15.3241L18 19H6L6.63015 15.3241C6.95935 13.4038 8.62428 12 10.5726 12H13.4274ZM12 5C13.933 5 15.5 6.567 15.5 8.5C15.5 10.433 13.933 12 12 12C10.067 12 8.5 10.433 8.5 8.5C8.5 6.567 10.067 5 12 5Z\" fill=\"#D5EAFD\"></path><path d=\"M16 21C16.5523 21 17 21.4477 17 22C17 22.5523 16.5523 23 16 23H8C7.44772 23 7 22.5523 7 22C7 21.4477 7.44772 21 8 21H16ZM4 19C2.34315 19 1 17.6569 1 16V4C1 2.34315 2.34315 1 4 1H20C21.6569 1 23 2.34315 23 4V16C23 17.6569 21.6569 19 20 19H4ZM20 3H4C3.48716 3 3.06449 3.38604 3.00673 3.88338L3 4V16C3 16.5128 3.38604 16.9355 3.88338 16.9933L4 17H6.343L6.63015 15.3241C6.95935 13.4038 8.62428 12 10.5726 12H13.4274C15.3757 12 17.0407 13.4038 17.3699 15.3241L17.657 17H20C20.5128 17 20.9355 16.614 20.9933 16.1166L21 16V4C21 3.48716 20.614 3.06449 20.1166 3.00673L20 3ZM13.4274 14H10.5726C9.65258 14 8.85893 14.6261 8.63492 15.5045L8.60139 15.6621L8.372 17H15.627L15.3986 15.6621C15.2432 14.7552 14.492 14.0788 13.5883 14.0064L13.4274 14ZM12 5C13.933 5 15.5 6.567 15.5 8.5C15.5 10.433 13.933 12 12 12C10.067 12 8.5 10.433 8.5 8.5C8.5 6.567 10.067 5 12 5ZM12 7C11.1716 7 10.5 7.67157 10.5 8.5C10.5 9.32843 11.1716 10 12 10C12.8284 10 13.5 9.32843 13.5 8.5C13.5 7.67157 12.8284 7 12 7Z\" fill=\"#079CB2\"></path></svg>";

/***/ }),

/***/ "6c2a":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.i, "@import url(https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css);"]);
exports.push([module.i, "@import url(https://cdn-prd.patientpop.com/pp-icon-font/v1.6.0/pp-icon-font.css);"]);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.v-menu__content.pp-input-selcect-options-container{box-shadow:0 3px 14px 2px rgba(0,0,0,.12)}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "6cf7":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><rect x=\"8\" y=\"3\" width=\"8\" height=\"5\" fill=\"#DFE4E5\"></rect><rect x=\"8\" y=\"16\" width=\"8\" height=\"5\" fill=\"#DFE4E5\"></rect><rect x=\"4\" y=\"9\" width=\"16\" height=\"8\" fill=\"white\"></rect><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8 7V4H16V7H8ZM6 7V2H18V7H20C21.1046 7 22 7.89543 22 9V17C22 18.1046 21.1046 19 20 19H17V17H20V9H4V17H7V19H4C2.89543 19 2 18.1046 2 17V9C2 7.89543 2.89543 7 4 7H6ZM18 10C18.5523 10 19 10.4477 19 11C19 11.5523 18.5523 12 18 12C17.4477 12 17 11.5523 17 11C17 10.4477 17.4477 10 18 10ZM16 11C16 10.4477 15.5523 10 15 10C14.4477 10 14 10.4477 14 11C14 11.5523 14.4477 12 15 12C15.5523 12 16 11.5523 16 11Z\" fill=\"#688083\"></path><path d=\"M7 16H17V19C17 20.1046 16.1046 21 15 21H7V16Z\" fill=\"#DFE4E5\" stroke=\"#688083\" stroke-width=\"2\"></path></svg>";

/***/ }),

/***/ "6d61":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var global = __webpack_require__("da84");
var isForced = __webpack_require__("94ca");
var redefine = __webpack_require__("6eeb");
var InternalMetadataModule = __webpack_require__("f183");
var iterate = __webpack_require__("2266");
var anInstance = __webpack_require__("19aa");
var isObject = __webpack_require__("861d");
var fails = __webpack_require__("d039");
var checkCorrectnessOfIteration = __webpack_require__("1c7e");
var setToStringTag = __webpack_require__("d44e");
var inheritIfRequired = __webpack_require__("7156");

module.exports = function (CONSTRUCTOR_NAME, wrapper, common) {
  var IS_MAP = CONSTRUCTOR_NAME.indexOf('Map') !== -1;
  var IS_WEAK = CONSTRUCTOR_NAME.indexOf('Weak') !== -1;
  var ADDER = IS_MAP ? 'set' : 'add';
  var NativeConstructor = global[CONSTRUCTOR_NAME];
  var NativePrototype = NativeConstructor && NativeConstructor.prototype;
  var Constructor = NativeConstructor;
  var exported = {};

  var fixMethod = function (KEY) {
    var nativeMethod = NativePrototype[KEY];
    redefine(NativePrototype, KEY,
      KEY == 'add' ? function add(value) {
        nativeMethod.call(this, value === 0 ? 0 : value);
        return this;
      } : KEY == 'delete' ? function (key) {
        return IS_WEAK && !isObject(key) ? false : nativeMethod.call(this, key === 0 ? 0 : key);
      } : KEY == 'get' ? function get(key) {
        return IS_WEAK && !isObject(key) ? undefined : nativeMethod.call(this, key === 0 ? 0 : key);
      } : KEY == 'has' ? function has(key) {
        return IS_WEAK && !isObject(key) ? false : nativeMethod.call(this, key === 0 ? 0 : key);
      } : function set(key, value) {
        nativeMethod.call(this, key === 0 ? 0 : key, value);
        return this;
      }
    );
  };

  // eslint-disable-next-line max-len
  if (isForced(CONSTRUCTOR_NAME, typeof NativeConstructor != 'function' || !(IS_WEAK || NativePrototype.forEach && !fails(function () {
    new NativeConstructor().entries().next();
  })))) {
    // create collection constructor
    Constructor = common.getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER);
    InternalMetadataModule.REQUIRED = true;
  } else if (isForced(CONSTRUCTOR_NAME, true)) {
    var instance = new Constructor();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~ Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    // eslint-disable-next-line no-new
    var ACCEPT_ITERABLES = checkCorrectnessOfIteration(function (iterable) { new NativeConstructor(iterable); });
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new NativeConstructor();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });

    if (!ACCEPT_ITERABLES) {
      Constructor = wrapper(function (dummy, iterable) {
        anInstance(dummy, Constructor, CONSTRUCTOR_NAME);
        var that = inheritIfRequired(new NativeConstructor(), dummy, Constructor);
        if (iterable != undefined) iterate(iterable, that[ADDER], { that: that, AS_ENTRIES: IS_MAP });
        return that;
      });
      Constructor.prototype = NativePrototype;
      NativePrototype.constructor = Constructor;
    }

    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }

    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);

    // weak collections should not contains .clear method
    if (IS_WEAK && NativePrototype.clear) delete NativePrototype.clear;
  }

  exported[CONSTRUCTOR_NAME] = Constructor;
  $({ global: true, forced: Constructor != NativeConstructor }, exported);

  setToStringTag(Constructor, CONSTRUCTOR_NAME);

  if (!IS_WEAK) common.setStrong(Constructor, CONSTRUCTOR_NAME, IS_MAP);

  return Constructor;
};


/***/ }),

/***/ "6de0":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M11.9996 18.1543L17.2921 20.9337C17.6596 21.1267 18.0888 20.8146 18.0186 20.4055L17.008 14.5196L21.2886 10.3516C21.5861 10.0619 21.4221 9.55679 21.0111 9.49714L15.0949 8.63842L12.4486 3.28234C12.2648 2.91036 11.7344 2.91036 11.5506 3.28234L8.90425 8.63842L2.98804 9.49714C2.57707 9.55679 2.41305 10.0619 2.71059 10.3516L6.99122 14.5196L5.98058 20.4055C5.91034 20.8146 6.33959 21.1267 6.70705 20.9337L11.9996 18.1543Z\" fill=\"white\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M11.9993 18.1543L6.70673 20.9337C6.33927 21.1266 5.91002 20.8146 5.98026 20.4055L6.9909 14.5196L2.71027 10.3516C2.41273 10.0619 2.57675 9.55678 2.98772 9.49713L8.90392 8.63841L11.5502 3.28233C11.734 2.91035 12.2645 2.91035 12.4483 3.28233L15.0946 8.63841L21.0108 9.49713C21.4218 9.55678 21.5858 10.0619 21.2883 10.3516L17.0076 14.5196L18.0183 20.4055C18.0885 20.8146 17.6593 21.1266 17.2918 20.9337L11.9993 18.1543ZM19.1605 15.2195L19.9927 20.0665C20.3439 22.1118 18.1977 23.6722 16.3604 22.7073L11.9993 20.4171L7.63816 22.7073C5.80086 23.6722 3.65461 22.1118 4.0058 20.0665L4.83805 15.2195L1.3127 11.787C-0.174971 10.3384 0.645106 7.81281 2.69995 7.51456L7.57422 6.80707L9.75416 2.39493C10.6731 0.53502 13.3254 0.535028 14.2444 2.39493L16.4243 6.80707L21.2986 7.51456C23.3534 7.81281 24.1735 10.3384 22.6858 11.787L19.1605 15.2195Z\" fill=\"#1F3A3E\"></path><path d=\"M11.9996 15.6793L15.0334 17.2801C15.2167 17.3768 15.4314 17.2212 15.3965 17.0169L14.8169 13.625L17.273 11.222C17.421 11.0773 17.3391 10.8258 17.1343 10.7959L13.7408 10.301L12.224 7.21637C12.1324 7.03013 11.8669 7.03012 11.7753 7.21637L10.2585 10.301L6.865 10.7959C6.66023 10.8258 6.57833 11.0773 6.72625 11.222L9.18244 13.625L8.60281 17.0169C8.56789 17.2212 8.78256 17.3768 8.96591 17.2801L11.9996 15.6793Z\" fill=\"#DFE4E5\"></path></svg>";

/***/ }),

/***/ "6e1e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return UPLOAD_FILE_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IMG_URL; });
var UPLOAD_FILE_STATUS = {
  INIT: 'init',
  UPLOADING: 'uploading',
  COMPLETE: 'complete',
  ERROR: 'error'
};
var IMG_URL = {
  FILE_UPLOADED: 'https://ui-cdn.patientpop.com/assets/img/file-uploaded.svg',
  FILE_ERROR: 'https://ui-cdn.patientpop.com/assets/img/file-error.svg',
  DEFAULT_FILE_UPLOAD: 'https://ui-cdn.patientpop.com/assets/img/illustrative-icons/spreadsheet.svg',
  FILE_DRAGGING: 'https://ui-cdn.patientpop.com/assets/img/file-dragging.svg'
};

/***/ }),

/***/ "6e9b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpNavItem_vue_vue_type_style_index_0_id_14cd72c3_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("92e1");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpNavItem_vue_vue_type_style_index_0_id_14cd72c3_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpNavItem_vue_vue_type_style_index_0_id_14cd72c3_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "6ece":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("298f");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("601a32f1", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "6eeb":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var createNonEnumerableProperty = __webpack_require__("9112");
var has = __webpack_require__("5135");
var setGlobal = __webpack_require__("ce4e");
var inspectSource = __webpack_require__("8925");
var InternalStateModule = __webpack_require__("69f3");

var getInternalState = InternalStateModule.get;
var enforceInternalState = InternalStateModule.enforce;
var TEMPLATE = String(String).split('String');

(module.exports = function (O, key, value, options) {
  var unsafe = options ? !!options.unsafe : false;
  var simple = options ? !!options.enumerable : false;
  var noTargetGet = options ? !!options.noTargetGet : false;
  var state;
  if (typeof value == 'function') {
    if (typeof key == 'string' && !has(value, 'name')) {
      createNonEnumerableProperty(value, 'name', key);
    }
    state = enforceInternalState(value);
    if (!state.source) {
      state.source = TEMPLATE.join(typeof key == 'string' ? key : '');
    }
  }
  if (O === global) {
    if (simple) O[key] = value;
    else setGlobal(key, value);
    return;
  } else if (!unsafe) {
    delete O[key];
  } else if (!noTargetGet && O[key]) {
    simple = true;
  }
  if (simple) O[key] = value;
  else createNonEnumerableProperty(O, key, value);
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, 'toString', function toString() {
  return typeof this == 'function' && getInternalState(this).source || inspectSource(this);
});


/***/ }),

/***/ "6f00":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("c8d5")

/**
 * @category Hour Helpers
 * @summary Set the hours to the given date.
 *
 * @description
 * Set the hours to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} hours - the hours of the new date
 * @returns {Date} the new date with the hours setted
 *
 * @example
 * // Set 4 hours to 1 September 2014 11:30:00:
 * var result = setHours(new Date(2014, 8, 1, 11, 30), 4)
 * //=> Mon Sep 01 2014 04:30:00
 */
function setHours (dirtyDate, dirtyHours) {
  var date = parse(dirtyDate)
  var hours = Number(dirtyHours)
  date.setHours(hours)
  return date
}

module.exports = setHours


/***/ }),

/***/ "6f4e":
/***/ (function(module, exports) {

/**
 * @category Day Helpers
 * @summary Return the end of tomorrow.
 *
 * @description
 * Return the end of tomorrow.
 *
 * @returns {Date} the end of tomorrow
 *
 * @example
 * // If today is 6 October 2014:
 * var result = endOfTomorrow()
 * //=> Tue Oct 7 2014 23:59:59.999
 */
function endOfTomorrow () {
  var now = new Date()
  var year = now.getFullYear()
  var month = now.getMonth()
  var day = now.getDate()

  var date = new Date(0)
  date.setFullYear(year, month, day + 1)
  date.setHours(23, 59, 59, 999)
  return date
}

module.exports = endOfTomorrow


/***/ }),

/***/ "6f53":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var objectKeys = __webpack_require__("df75");
var toIndexedObject = __webpack_require__("fc6a");
var propertyIsEnumerable = __webpack_require__("d1e7").f;

// `Object.{ entries, values }` methods implementation
var createMethod = function (TO_ENTRIES) {
  return function (it) {
    var O = toIndexedObject(it);
    var keys = objectKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || propertyIsEnumerable.call(O, key)) {
        result.push(TO_ENTRIES ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};

module.exports = {
  // `Object.entries` method
  // https://tc39.es/ecma262/#sec-object.entries
  entries: createMethod(true),
  // `Object.values` method
  // https://tc39.es/ecma262/#sec-object.values
  values: createMethod(false)
};


/***/ }),

/***/ "6fcc":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("c8d5")
var differenceInCalendarYears = __webpack_require__("2a9c")
var compareAsc = __webpack_require__("0d3e")

/**
 * @category Year Helpers
 * @summary Get the number of full years between the given dates.
 *
 * @description
 * Get the number of full years between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of full years
 *
 * @example
 * // How many full years are between 31 December 2013 and 11 February 2015?
 * var result = differenceInYears(
 *   new Date(2015, 1, 11),
 *   new Date(2013, 11, 31)
 * )
 * //=> 1
 */
function differenceInYears (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)

  var sign = compareAsc(dateLeft, dateRight)
  var difference = Math.abs(differenceInCalendarYears(dateLeft, dateRight))
  dateLeft.setFullYear(dateLeft.getFullYear() - sign * difference)

  // Math.abs(diff in full years - diff in calendar years) === 1 if last calendar year is not full
  // If so, result must be decreased by 1 in absolute value
  var isLastYearNotFull = compareAsc(dateLeft, dateRight) === -sign
  return sign * (difference - isLastYearNotFull)
}

module.exports = differenceInYears


/***/ }),

/***/ "7001":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpStatusBanner_vue_vue_type_style_index_0_id_112baaea_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("f24b");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpStatusBanner_vue_vue_type_style_index_0_id_112baaea_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpStatusBanner_vue_vue_type_style_index_0_id_112baaea_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "7022":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.i, "@import url(https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css);"]);
exports.push([module.i, "@import url(https://cdn-prd.patientpop.com/pp-icon-font/v1.6.0/pp-icon-font.css);"]);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.pp-status-chip[data-v-edf4fc24]{border-radius:4px;padding-bottom:2px;padding-top:2px;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content}.pp-status-chip__sub-text--with-dot[data-v-edf4fc24]:before{align-items:center;content:\"•\";display:flex;font-size:10px;margin:0 .4em}.pp-status-chip--simple[data-v-edf4fc24]{align-items:center}.pp-status-chip--simple[data-v-edf4fc24]:before{border-radius:50%;content:\"\";height:.6em;margin-right:.4em;width:.6em}.pp-status-chip--simple--primary[data-v-edf4fc24]:before{background-color:var(--pp-theme-color,#004852)}.pp-status-chip--simple--success[data-v-edf4fc24]:before{background-color:#3fa266}.pp-status-chip--simple--warning[data-v-edf4fc24]:before{background-color:#fcde73}.pp-status-chip--simple--alert[data-v-edf4fc24]:before{background-color:#ff8d6e}.pp-status-chip--simple--error[data-v-edf4fc24]:before{background-color:#b51a2c}.pp-status-chip--simple--info[data-v-edf4fc24]:before{background-color:#8657ac}.pp-status-chip--simple--pending[data-v-edf4fc24]:before{background-color:#079cb2}.pp-status-chip--simple--inactive[data-v-edf4fc24]:before{background-color:#545454}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "7044":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("f1e0");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("1eda72e8", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "70f2":
/***/ (function(module, exports, __webpack_require__) {

var getDayOfYear = __webpack_require__("580f")
var getISOWeek = __webpack_require__("81fc")
var getISOYear = __webpack_require__("8964")
var parse = __webpack_require__("c8d5")
var isValid = __webpack_require__("7eea")
var enLocale = __webpack_require__("52cf")

/**
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format.
 *
 * Accepted tokens:
 * | Unit                    | Token | Result examples                  |
 * |-------------------------|-------|----------------------------------|
 * | Month                   | M     | 1, 2, ..., 12                    |
 * |                         | Mo    | 1st, 2nd, ..., 12th              |
 * |                         | MM    | 01, 02, ..., 12                  |
 * |                         | MMM   | Jan, Feb, ..., Dec               |
 * |                         | MMMM  | January, February, ..., December |
 * | Quarter                 | Q     | 1, 2, 3, 4                       |
 * |                         | Qo    | 1st, 2nd, 3rd, 4th               |
 * | Day of month            | D     | 1, 2, ..., 31                    |
 * |                         | Do    | 1st, 2nd, ..., 31st              |
 * |                         | DD    | 01, 02, ..., 31                  |
 * | Day of year             | DDD   | 1, 2, ..., 366                   |
 * |                         | DDDo  | 1st, 2nd, ..., 366th             |
 * |                         | DDDD  | 001, 002, ..., 366               |
 * | Day of week             | d     | 0, 1, ..., 6                     |
 * |                         | do    | 0th, 1st, ..., 6th               |
 * |                         | dd    | Su, Mo, ..., Sa                  |
 * |                         | ddd   | Sun, Mon, ..., Sat               |
 * |                         | dddd  | Sunday, Monday, ..., Saturday    |
 * | Day of ISO week         | E     | 1, 2, ..., 7                     |
 * | ISO week                | W     | 1, 2, ..., 53                    |
 * |                         | Wo    | 1st, 2nd, ..., 53rd              |
 * |                         | WW    | 01, 02, ..., 53                  |
 * | Year                    | YY    | 00, 01, ..., 99                  |
 * |                         | YYYY  | 1900, 1901, ..., 2099            |
 * | ISO week-numbering year | GG    | 00, 01, ..., 99                  |
 * |                         | GGGG  | 1900, 1901, ..., 2099            |
 * | AM/PM                   | A     | AM, PM                           |
 * |                         | a     | am, pm                           |
 * |                         | aa    | a.m., p.m.                       |
 * | Hour                    | H     | 0, 1, ... 23                     |
 * |                         | HH    | 00, 01, ... 23                   |
 * |                         | h     | 1, 2, ..., 12                    |
 * |                         | hh    | 01, 02, ..., 12                  |
 * | Minute                  | m     | 0, 1, ..., 59                    |
 * |                         | mm    | 00, 01, ..., 59                  |
 * | Second                  | s     | 0, 1, ..., 59                    |
 * |                         | ss    | 00, 01, ..., 59                  |
 * | 1/10 of second          | S     | 0, 1, ..., 9                     |
 * | 1/100 of second         | SS    | 00, 01, ..., 99                  |
 * | Millisecond             | SSS   | 000, 001, ..., 999               |
 * | Timezone                | Z     | -01:00, +00:00, ... +12:00       |
 * |                         | ZZ    | -0100, +0000, ..., +1200         |
 * | Seconds timestamp       | X     | 512969520                        |
 * | Milliseconds timestamp  | x     | 512969520900                     |
 *
 * The characters wrapped in square brackets are escaped.
 *
 * The result may vary by locale.
 *
 * @param {Date|String|Number} date - the original date
 * @param {String} [format='YYYY-MM-DDTHH:mm:ss.SSSZ'] - the string of tokens
 * @param {Object} [options] - the object with options
 * @param {Object} [options.locale=enLocale] - the locale object
 * @returns {String} the formatted date string
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * var result = format(
 *   new Date(2014, 1, 11),
 *   'MM/DD/YYYY'
 * )
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * var eoLocale = require('date-fns/locale/eo')
 * var result = format(
 *   new Date(2014, 6, 2),
 *   'Do [de] MMMM YYYY',
 *   {locale: eoLocale}
 * )
 * //=> '2-a de julio 2014'
 */
function format (dirtyDate, dirtyFormatStr, dirtyOptions) {
  var formatStr = dirtyFormatStr ? String(dirtyFormatStr) : 'YYYY-MM-DDTHH:mm:ss.SSSZ'
  var options = dirtyOptions || {}

  var locale = options.locale
  var localeFormatters = enLocale.format.formatters
  var formattingTokensRegExp = enLocale.format.formattingTokensRegExp
  if (locale && locale.format && locale.format.formatters) {
    localeFormatters = locale.format.formatters

    if (locale.format.formattingTokensRegExp) {
      formattingTokensRegExp = locale.format.formattingTokensRegExp
    }
  }

  var date = parse(dirtyDate)

  if (!isValid(date)) {
    return 'Invalid Date'
  }

  var formatFn = buildFormatFn(formatStr, localeFormatters, formattingTokensRegExp)

  return formatFn(date)
}

var formatters = {
  // Month: 1, 2, ..., 12
  'M': function (date) {
    return date.getMonth() + 1
  },

  // Month: 01, 02, ..., 12
  'MM': function (date) {
    return addLeadingZeros(date.getMonth() + 1, 2)
  },

  // Quarter: 1, 2, 3, 4
  'Q': function (date) {
    return Math.ceil((date.getMonth() + 1) / 3)
  },

  // Day of month: 1, 2, ..., 31
  'D': function (date) {
    return date.getDate()
  },

  // Day of month: 01, 02, ..., 31
  'DD': function (date) {
    return addLeadingZeros(date.getDate(), 2)
  },

  // Day of year: 1, 2, ..., 366
  'DDD': function (date) {
    return getDayOfYear(date)
  },

  // Day of year: 001, 002, ..., 366
  'DDDD': function (date) {
    return addLeadingZeros(getDayOfYear(date), 3)
  },

  // Day of week: 0, 1, ..., 6
  'd': function (date) {
    return date.getDay()
  },

  // Day of ISO week: 1, 2, ..., 7
  'E': function (date) {
    return date.getDay() || 7
  },

  // ISO week: 1, 2, ..., 53
  'W': function (date) {
    return getISOWeek(date)
  },

  // ISO week: 01, 02, ..., 53
  'WW': function (date) {
    return addLeadingZeros(getISOWeek(date), 2)
  },

  // Year: 00, 01, ..., 99
  'YY': function (date) {
    return addLeadingZeros(date.getFullYear(), 4).substr(2)
  },

  // Year: 1900, 1901, ..., 2099
  'YYYY': function (date) {
    return addLeadingZeros(date.getFullYear(), 4)
  },

  // ISO week-numbering year: 00, 01, ..., 99
  'GG': function (date) {
    return String(getISOYear(date)).substr(2)
  },

  // ISO week-numbering year: 1900, 1901, ..., 2099
  'GGGG': function (date) {
    return getISOYear(date)
  },

  // Hour: 0, 1, ... 23
  'H': function (date) {
    return date.getHours()
  },

  // Hour: 00, 01, ..., 23
  'HH': function (date) {
    return addLeadingZeros(date.getHours(), 2)
  },

  // Hour: 1, 2, ..., 12
  'h': function (date) {
    var hours = date.getHours()
    if (hours === 0) {
      return 12
    } else if (hours > 12) {
      return hours % 12
    } else {
      return hours
    }
  },

  // Hour: 01, 02, ..., 12
  'hh': function (date) {
    return addLeadingZeros(formatters['h'](date), 2)
  },

  // Minute: 0, 1, ..., 59
  'm': function (date) {
    return date.getMinutes()
  },

  // Minute: 00, 01, ..., 59
  'mm': function (date) {
    return addLeadingZeros(date.getMinutes(), 2)
  },

  // Second: 0, 1, ..., 59
  's': function (date) {
    return date.getSeconds()
  },

  // Second: 00, 01, ..., 59
  'ss': function (date) {
    return addLeadingZeros(date.getSeconds(), 2)
  },

  // 1/10 of second: 0, 1, ..., 9
  'S': function (date) {
    return Math.floor(date.getMilliseconds() / 100)
  },

  // 1/100 of second: 00, 01, ..., 99
  'SS': function (date) {
    return addLeadingZeros(Math.floor(date.getMilliseconds() / 10), 2)
  },

  // Millisecond: 000, 001, ..., 999
  'SSS': function (date) {
    return addLeadingZeros(date.getMilliseconds(), 3)
  },

  // Timezone: -01:00, +00:00, ... +12:00
  'Z': function (date) {
    return formatTimezone(date.getTimezoneOffset(), ':')
  },

  // Timezone: -0100, +0000, ... +1200
  'ZZ': function (date) {
    return formatTimezone(date.getTimezoneOffset())
  },

  // Seconds timestamp: 512969520
  'X': function (date) {
    return Math.floor(date.getTime() / 1000)
  },

  // Milliseconds timestamp: 512969520900
  'x': function (date) {
    return date.getTime()
  }
}

function buildFormatFn (formatStr, localeFormatters, formattingTokensRegExp) {
  var array = formatStr.match(formattingTokensRegExp)
  var length = array.length

  var i
  var formatter
  for (i = 0; i < length; i++) {
    formatter = localeFormatters[array[i]] || formatters[array[i]]
    if (formatter) {
      array[i] = formatter
    } else {
      array[i] = removeFormattingTokens(array[i])
    }
  }

  return function (date) {
    var output = ''
    for (var i = 0; i < length; i++) {
      if (array[i] instanceof Function) {
        output += array[i](date, formatters)
      } else {
        output += array[i]
      }
    }
    return output
  }
}

function removeFormattingTokens (input) {
  if (input.match(/\[[\s\S]/)) {
    return input.replace(/^\[|]$/g, '')
  }
  return input.replace(/\\/g, '')
}

function formatTimezone (offset, delimeter) {
  delimeter = delimeter || ''
  var sign = offset > 0 ? '-' : '+'
  var absOffset = Math.abs(offset)
  var hours = Math.floor(absOffset / 60)
  var minutes = absOffset % 60
  return sign + addLeadingZeros(hours, 2) + delimeter + addLeadingZeros(minutes, 2)
}

function addLeadingZeros (number, targetLength) {
  var output = Math.abs(number).toString()
  while (output.length < targetLength) {
    output = '0' + output
  }
  return output
}

module.exports = format


/***/ }),

/***/ "710d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c662cfac-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/data-table/PpDataTable.vue?vue&type=template&id=4d4a0701&scoped=true&
var PpDataTablevue_type_template_id_4d4a0701_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pp-data-table",class:[
    _vm.actionable ? 'pp-data-table--actionable' : ''
  ]},[_c('v-data-table',_vm._g(_vm._b({attrs:{"footer-props":_vm.disablePagination || _vm.usePpPagination ? {} : _vm.footerProps,"page":_vm.page,"disable-pagination":_vm.disablePagination,"header-props":{sortIcon: 'mdi-menu-swap pp-data-table-sort-icon mb-1'}},on:{"update:page":function($event){_vm.page=$event},"page-count":_vm.onPageCountChanged},scopedSlots:_vm._u([_vm._l((Object.keys(_vm.$scopedSlots)),function(slot){return {key:slot,fn:function(scope){return [_vm._t(slot,null,null,scope)]}}}),{key:"loading",fn:function(){return [_c('pp-loading-icon')]},proxy:true},{key:"footer.page-text",fn:function(pageText){return [_vm._v(" "+_vm._s(pageText.pageStart)+"-"+_vm._s(pageText.pageStop)+" of "+_vm._s(pageText.itemsLength)+" ")]}}],null,true)},'v-data-table',_vm.$attrs,false),_vm.$listeners),[_vm._l((Object.keys(_vm.$slots)),function(slot){return _vm._t(slot,null,{"slot":slot})})],2),(!_vm.disablePagination && _vm.usePpPagination)?_c('pp-pagination',{attrs:{"length":_vm.pageCount},model:{value:(_vm.page),callback:function ($$v) {_vm.page=$$v},expression:"page"}}):_vm._e()],1)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/data-table/PpDataTable.vue?vue&type=template&id=4d4a0701&scoped=true&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__("a9e3");

// EXTERNAL MODULE: ./src/components/loading-icon/PpLoadingIcon.vue + 4 modules
var PpLoadingIcon = __webpack_require__("efbd");

// EXTERNAL MODULE: ./src/components/pagination/PpPagination.vue + 5 modules
var PpPagination = __webpack_require__("5a0d");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/data-table/PpDataTable.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var PpDataTablevue_type_script_lang_js_ = ({
  name: 'PpDataTable',
  components: {
    'pp-loading-icon': PpLoadingIcon["default"],
    PpPagination: PpPagination["default"]
  },
  props: {
    page: {
      type: Number,
      default: 1
    },
    disablePagination: {
      type: Boolean,
      default: false
    },
    usePpPagination: {
      type: Boolean,
      default: false
    },

    /**
     * In some cases the "all" option for pagination will not be supported by BE
     */
    hideAllFromFooter: {
      type: Boolean,
      default: false
    },

    /**
     * enable "ACTIONABLE UI"
     */
    actionable: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      footerProps: {
        firstPage: 'First page',
        itemsPerPageAllText: 'All',
        itemsPerPageText: 'Items per page:',
        lastPage: 'Last page',
        nextPage: 'Next page',
        prevPage: 'Previous page',
        nextIcon: 'mdi-chevron-right',
        prevIcon: 'mdi-chevron-left',
        itemsPerPageOptions: this.hideAllFromFooter ? [5, 10, 15, 20] : [5, 10, 15, -1]
      },
      pageCount: 0
    };
  },
  methods: {
    onPageCountChanged: function onPageCountChanged(event) {
      this.pageCount = event;
      this.$emit('page-count', event);
    }
  }
});
// CONCATENATED MODULE: ./src/components/data-table/PpDataTable.vue?vue&type=script&lang=js&
 /* harmony default export */ var data_table_PpDataTablevue_type_script_lang_js_ = (PpDataTablevue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/data-table/PpDataTable.vue?vue&type=style&index=0&lang=scss&
var PpDataTablevue_type_style_index_0_lang_scss_ = __webpack_require__("1c4c");

// EXTERNAL MODULE: ./src/components/data-table/PpDataTable.vue?vue&type=style&index=1&id=4d4a0701&lang=scss&scoped=true&
var PpDataTablevue_type_style_index_1_id_4d4a0701_lang_scss_scoped_true_ = __webpack_require__("5d0b");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// EXTERNAL MODULE: ./node_modules/vuetify-loader/lib/runtime/installComponents.js
var installComponents = __webpack_require__("6544");
var installComponents_default = /*#__PURE__*/__webpack_require__.n(installComponents);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("99af");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.every.js
var es_array_every = __webpack_require__("a623");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("4de4");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__("7db0");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.find-index.js
var es_array_find_index = __webpack_require__("c740");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("4160");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.from.js
var es_array_from = __webpack_require__("a630");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("d81d");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.reduce.js
var es_array_reduce = __webpack_require__("13d5");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.some.js
var es_array_some = __webpack_require__("45fc");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.splice.js
var es_array_splice = __webpack_require__("a434");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("b0c0");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.assign.js
var es_object_assign = __webpack_require__("cca6");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__("3ca3");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.trim.js
var es_string_trim = __webpack_require__("498a");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__("3835");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__("53ca");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__("5530");

// EXTERNAL MODULE: ./node_modules/vuetify/src/components/VDataTable/VDataTable.sass
var VDataTable = __webpack_require__("91f4");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__("fb6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__("ac1f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.search.js
var es_string_search = __webpack_require__("841c");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__("2909");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/util/helpers.js
var helpers = __webpack_require__("80d2");

// EXTERNAL MODULE: external {"commonjs":"vue","commonjs2":"vue","root":"Vue"}
var external_commonjs_vue_commonjs2_vue_root_Vue_ = __webpack_require__("8bbf");
var external_commonjs_vue_commonjs2_vue_root_Vue_default = /*#__PURE__*/__webpack_require__.n(external_commonjs_vue_commonjs2_vue_root_Vue_);

// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VData/VData.js











// Helpers


/* harmony default export */ var VData = (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
  name: 'v-data',
  inheritAttrs: false,
  props: {
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    options: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    sortBy: {
      type: [String, Array],
      default: function _default() {
        return [];
      }
    },
    sortDesc: {
      type: [Boolean, Array],
      default: function _default() {
        return [];
      }
    },
    customSort: {
      type: Function,
      default: helpers["E" /* sortItems */]
    },
    mustSort: Boolean,
    multiSort: Boolean,
    page: {
      type: Number,
      default: 1
    },
    itemsPerPage: {
      type: Number,
      default: 10
    },
    groupBy: {
      type: [String, Array],
      default: function _default() {
        return [];
      }
    },
    groupDesc: {
      type: [Boolean, Array],
      default: function _default() {
        return [];
      }
    },
    customGroup: {
      type: Function,
      default: helpers["v" /* groupItems */]
    },
    locale: {
      type: String,
      default: 'en-US'
    },
    disableSort: Boolean,
    disablePagination: Boolean,
    disableFiltering: Boolean,
    search: String,
    customFilter: {
      type: Function,
      default: helpers["D" /* searchItems */]
    },
    serverItemsLength: {
      type: Number,
      default: -1
    }
  },
  data: function data() {
    var internalOptions = {
      page: this.page,
      itemsPerPage: this.itemsPerPage,
      sortBy: Object(helpers["H" /* wrapInArray */])(this.sortBy),
      sortDesc: Object(helpers["H" /* wrapInArray */])(this.sortDesc),
      groupBy: Object(helpers["H" /* wrapInArray */])(this.groupBy),
      groupDesc: Object(helpers["H" /* wrapInArray */])(this.groupDesc),
      mustSort: this.mustSort,
      multiSort: this.multiSort
    };

    if (this.options) {
      internalOptions = Object.assign(internalOptions, this.options);
    }

    var _internalOptions = internalOptions,
        sortBy = _internalOptions.sortBy,
        sortDesc = _internalOptions.sortDesc,
        groupBy = _internalOptions.groupBy,
        groupDesc = _internalOptions.groupDesc;
    var sortDiff = sortBy.length - sortDesc.length;
    var groupDiff = groupBy.length - groupDesc.length;

    if (sortDiff > 0) {
      var _internalOptions$sort;

      (_internalOptions$sort = internalOptions.sortDesc).push.apply(_internalOptions$sort, Object(toConsumableArray["a" /* default */])(Object(helpers["m" /* fillArray */])(sortDiff, false)));
    }

    if (groupDiff > 0) {
      var _internalOptions$grou;

      (_internalOptions$grou = internalOptions.groupDesc).push.apply(_internalOptions$grou, Object(toConsumableArray["a" /* default */])(Object(helpers["m" /* fillArray */])(groupDiff, false)));
    }

    return {
      internalOptions: internalOptions
    };
  },
  computed: {
    itemsLength: function itemsLength() {
      return this.serverItemsLength >= 0 ? this.serverItemsLength : this.filteredItems.length;
    },
    pageCount: function pageCount() {
      return this.internalOptions.itemsPerPage <= 0 ? 1 : Math.ceil(this.itemsLength / this.internalOptions.itemsPerPage);
    },
    pageStart: function pageStart() {
      if (this.internalOptions.itemsPerPage === -1 || !this.items.length) return 0;
      return (this.internalOptions.page - 1) * this.internalOptions.itemsPerPage;
    },
    pageStop: function pageStop() {
      if (this.internalOptions.itemsPerPage === -1) return this.itemsLength;
      if (!this.items.length) return 0;
      return Math.min(this.itemsLength, this.internalOptions.page * this.internalOptions.itemsPerPage);
    },
    isGrouped: function isGrouped() {
      return !!this.internalOptions.groupBy.length;
    },
    pagination: function pagination() {
      return {
        page: this.internalOptions.page,
        itemsPerPage: this.internalOptions.itemsPerPage,
        pageStart: this.pageStart,
        pageStop: this.pageStop,
        pageCount: this.pageCount,
        itemsLength: this.itemsLength
      };
    },
    filteredItems: function filteredItems() {
      var items = this.items.slice();

      if (!this.disableFiltering && this.serverItemsLength <= 0) {
        items = this.customFilter(items, this.search);
      }

      return items;
    },
    computedItems: function computedItems() {
      var items = this.filteredItems.slice();

      if (!this.disableSort && this.serverItemsLength <= 0) {
        items = this.sortItems(items);
      }

      if (!this.disablePagination && this.serverItemsLength <= 0) {
        items = this.paginateItems(items);
      }

      return items;
    },
    groupedItems: function groupedItems() {
      return this.isGrouped ? this.groupItems(this.computedItems) : null;
    },
    scopedProps: function scopedProps() {
      return {
        sort: this.sort,
        sortArray: this.sortArray,
        group: this.group,
        items: this.computedItems,
        options: this.internalOptions,
        updateOptions: this.updateOptions,
        pagination: this.pagination,
        groupedItems: this.groupedItems,
        originalItemsLength: this.items.length
      };
    },
    computedOptions: function computedOptions() {
      return Object(objectSpread2["a" /* default */])({}, this.options);
    }
  },
  watch: {
    computedOptions: {
      handler: function handler(options, old) {
        if (Object(helpers["j" /* deepEqual */])(options, old)) return;
        this.updateOptions(options);
      },
      deep: true,
      immediate: true
    },
    internalOptions: {
      handler: function handler(options, old) {
        if (Object(helpers["j" /* deepEqual */])(options, old)) return;
        this.$emit('update:options', options);
      },
      deep: true,
      immediate: true
    },
    page: function page(_page) {
      this.updateOptions({
        page: _page
      });
    },
    'internalOptions.page': function internalOptionsPage(page) {
      this.$emit('update:page', page);
    },
    itemsPerPage: function itemsPerPage(_itemsPerPage) {
      this.updateOptions({
        itemsPerPage: _itemsPerPage
      });
    },
    'internalOptions.itemsPerPage': function internalOptionsItemsPerPage(itemsPerPage) {
      this.$emit('update:items-per-page', itemsPerPage);
    },
    sortBy: function sortBy(_sortBy) {
      this.updateOptions({
        sortBy: Object(helpers["H" /* wrapInArray */])(_sortBy)
      });
    },
    'internalOptions.sortBy': function internalOptionsSortBy(sortBy, old) {
      !Object(helpers["j" /* deepEqual */])(sortBy, old) && this.$emit('update:sort-by', Array.isArray(this.sortBy) ? sortBy : sortBy[0]);
    },
    sortDesc: function sortDesc(_sortDesc) {
      this.updateOptions({
        sortDesc: Object(helpers["H" /* wrapInArray */])(_sortDesc)
      });
    },
    'internalOptions.sortDesc': function internalOptionsSortDesc(sortDesc, old) {
      !Object(helpers["j" /* deepEqual */])(sortDesc, old) && this.$emit('update:sort-desc', Array.isArray(this.sortDesc) ? sortDesc : sortDesc[0]);
    },
    groupBy: function groupBy(_groupBy) {
      this.updateOptions({
        groupBy: Object(helpers["H" /* wrapInArray */])(_groupBy)
      });
    },
    'internalOptions.groupBy': function internalOptionsGroupBy(groupBy, old) {
      !Object(helpers["j" /* deepEqual */])(groupBy, old) && this.$emit('update:group-by', Array.isArray(this.groupBy) ? groupBy : groupBy[0]);
    },
    groupDesc: function groupDesc(_groupDesc) {
      this.updateOptions({
        groupDesc: Object(helpers["H" /* wrapInArray */])(_groupDesc)
      });
    },
    'internalOptions.groupDesc': function internalOptionsGroupDesc(groupDesc, old) {
      !Object(helpers["j" /* deepEqual */])(groupDesc, old) && this.$emit('update:group-desc', Array.isArray(this.groupDesc) ? groupDesc : groupDesc[0]);
    },
    multiSort: function multiSort(_multiSort) {
      this.updateOptions({
        multiSort: _multiSort
      });
    },
    'internalOptions.multiSort': function internalOptionsMultiSort(multiSort) {
      this.$emit('update:multi-sort', multiSort);
    },
    mustSort: function mustSort(_mustSort) {
      this.updateOptions({
        mustSort: _mustSort
      });
    },
    'internalOptions.mustSort': function internalOptionsMustSort(mustSort) {
      this.$emit('update:must-sort', mustSort);
    },
    pageCount: {
      handler: function handler(pageCount) {
        this.$emit('page-count', pageCount);
      },
      immediate: true
    },
    computedItems: {
      handler: function handler(computedItems) {
        this.$emit('current-items', computedItems);
      },
      immediate: true
    },
    pagination: {
      handler: function handler(pagination, old) {
        if (Object(helpers["j" /* deepEqual */])(pagination, old)) return;
        this.$emit('pagination', this.pagination);
      },
      immediate: true
    }
  },
  methods: {
    toggle: function toggle(key, oldBy, oldDesc, page, mustSort, multiSort) {
      var by = oldBy.slice();
      var desc = oldDesc.slice();
      var byIndex = by.findIndex(function (k) {
        return k === key;
      });

      if (byIndex < 0) {
        if (!multiSort) {
          by = [];
          desc = [];
        }

        by.push(key);
        desc.push(false);
      } else if (byIndex >= 0 && !desc[byIndex]) {
        desc[byIndex] = true;
      } else if (!mustSort) {
        by.splice(byIndex, 1);
        desc.splice(byIndex, 1);
      } else {
        desc[byIndex] = false;
      } // Reset page to 1 if sortBy or sortDesc have changed


      if (!Object(helpers["j" /* deepEqual */])(by, oldBy) || !Object(helpers["j" /* deepEqual */])(desc, oldDesc)) {
        page = 1;
      }

      return {
        by: by,
        desc: desc,
        page: page
      };
    },
    group: function group(key) {
      var _this$toggle = this.toggle(key, this.internalOptions.groupBy, this.internalOptions.groupDesc, this.internalOptions.page, true, false),
          groupBy = _this$toggle.by,
          groupDesc = _this$toggle.desc,
          page = _this$toggle.page;

      this.updateOptions({
        groupBy: groupBy,
        groupDesc: groupDesc,
        page: page
      });
    },
    sort: function sort(key) {
      if (Array.isArray(key)) return this.sortArray(key);

      var _this$toggle2 = this.toggle(key, this.internalOptions.sortBy, this.internalOptions.sortDesc, this.internalOptions.page, this.internalOptions.mustSort, this.internalOptions.multiSort),
          sortBy = _this$toggle2.by,
          sortDesc = _this$toggle2.desc,
          page = _this$toggle2.page;

      this.updateOptions({
        sortBy: sortBy,
        sortDesc: sortDesc,
        page: page
      });
    },
    sortArray: function sortArray(sortBy) {
      var _this = this;

      var sortDesc = sortBy.map(function (s) {
        var i = _this.internalOptions.sortBy.findIndex(function (k) {
          return k === s;
        });

        return i > -1 ? _this.internalOptions.sortDesc[i] : false;
      });
      this.updateOptions({
        sortBy: sortBy,
        sortDesc: sortDesc
      });
    },
    updateOptions: function updateOptions(options) {
      this.internalOptions = Object(objectSpread2["a" /* default */])(Object(objectSpread2["a" /* default */])(Object(objectSpread2["a" /* default */])({}, this.internalOptions), options), {}, {
        page: this.serverItemsLength < 0 ? Math.max(1, Math.min(options.page || this.internalOptions.page, this.pageCount)) : options.page || this.internalOptions.page
      });
    },
    sortItems: function sortItems(items) {
      var sortBy = this.internalOptions.sortBy;
      var sortDesc = this.internalOptions.sortDesc;

      if (this.internalOptions.groupBy.length) {
        sortBy = [].concat(Object(toConsumableArray["a" /* default */])(this.internalOptions.groupBy), Object(toConsumableArray["a" /* default */])(sortBy));
        sortDesc = [].concat(Object(toConsumableArray["a" /* default */])(this.internalOptions.groupDesc), Object(toConsumableArray["a" /* default */])(sortDesc));
      }

      return this.customSort(items, sortBy, sortDesc, this.locale);
    },
    groupItems: function groupItems(items) {
      return this.customGroup(items, this.internalOptions.groupBy, this.internalOptions.groupDesc);
    },
    paginateItems: function paginateItems(items) {
      // Make sure we don't try to display non-existant page if items suddenly change
      // TODO: Could possibly move this to pageStart/pageStop?
      if (this.serverItemsLength === -1 && items.length <= this.pageStart) {
        this.internalOptions.page = Math.max(1, this.internalOptions.page - 1);
      }

      return items.slice(this.pageStart, this.pageStop);
    }
  },
  render: function render() {
    return this.$scopedSlots.default && this.$scopedSlots.default(this.scopedProps);
  }
}));
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("caad");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("b64b");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.values.js
var es_object_values = __webpack_require__("07ac");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("2532");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("d3b7");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("25f0");

// EXTERNAL MODULE: ./node_modules/vuetify/src/components/VDataIterator/VDataFooter.sass
var VDataFooter = __webpack_require__("495d");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/components/VSelect/VSelect.js + 4 modules
var VSelect = __webpack_require__("b974");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/components/VIcon/index.js
var VIcon = __webpack_require__("9d26");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/components/VBtn/index.js
var VBtn = __webpack_require__("afdd");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VDataIterator/VDataFooter.js






 // Components



 // Types


/* harmony default export */ var VDataIterator_VDataFooter = (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
  name: 'v-data-footer',
  props: {
    options: {
      type: Object,
      required: true
    },
    pagination: {
      type: Object,
      required: true
    },
    itemsPerPageOptions: {
      type: Array,
      default: function _default() {
        return [5, 10, 15, -1];
      }
    },
    prevIcon: {
      type: String,
      default: '$prev'
    },
    nextIcon: {
      type: String,
      default: '$next'
    },
    firstIcon: {
      type: String,
      default: '$first'
    },
    lastIcon: {
      type: String,
      default: '$last'
    },
    itemsPerPageText: {
      type: String,
      default: '$vuetify.dataFooter.itemsPerPageText'
    },
    itemsPerPageAllText: {
      type: String,
      default: '$vuetify.dataFooter.itemsPerPageAll'
    },
    showFirstLastPage: Boolean,
    showCurrentPage: Boolean,
    disablePagination: Boolean,
    disableItemsPerPage: Boolean,
    pageText: {
      type: String,
      default: '$vuetify.dataFooter.pageText'
    }
  },
  computed: {
    disableNextPageIcon: function disableNextPageIcon() {
      return this.options.itemsPerPage <= 0 || this.options.page * this.options.itemsPerPage >= this.pagination.itemsLength || this.pagination.pageStop < 0;
    },
    computedDataItemsPerPageOptions: function computedDataItemsPerPageOptions() {
      var _this = this;

      return this.itemsPerPageOptions.map(function (option) {
        if (Object(esm_typeof["a" /* default */])(option) === 'object') return option;else return _this.genDataItemsPerPageOption(option);
      });
    }
  },
  methods: {
    updateOptions: function updateOptions(obj) {
      this.$emit('update:options', Object.assign({}, this.options, obj));
    },
    onFirstPage: function onFirstPage() {
      this.updateOptions({
        page: 1
      });
    },
    onPreviousPage: function onPreviousPage() {
      this.updateOptions({
        page: this.options.page - 1
      });
    },
    onNextPage: function onNextPage() {
      this.updateOptions({
        page: this.options.page + 1
      });
    },
    onLastPage: function onLastPage() {
      this.updateOptions({
        page: this.pagination.pageCount
      });
    },
    onChangeItemsPerPage: function onChangeItemsPerPage(itemsPerPage) {
      this.updateOptions({
        itemsPerPage: itemsPerPage,
        page: 1
      });
    },
    genDataItemsPerPageOption: function genDataItemsPerPageOption(option) {
      return {
        text: option === -1 ? this.$vuetify.lang.t(this.itemsPerPageAllText) : String(option),
        value: option
      };
    },
    genItemsPerPageSelect: function genItemsPerPageSelect() {
      var value = this.options.itemsPerPage;
      var computedIPPO = this.computedDataItemsPerPageOptions;
      if (computedIPPO.length <= 1) return null;
      if (!computedIPPO.find(function (ippo) {
        return ippo.value === value;
      })) value = computedIPPO[0];
      return this.$createElement('div', {
        staticClass: 'v-data-footer__select'
      }, [this.$vuetify.lang.t(this.itemsPerPageText), this.$createElement(VSelect["a" /* default */], {
        attrs: {
          'aria-label': this.$vuetify.lang.t(this.itemsPerPageText)
        },
        props: {
          disabled: this.disableItemsPerPage,
          items: computedIPPO,
          value: value,
          hideDetails: true,
          auto: true,
          minWidth: '75px'
        },
        on: {
          input: this.onChangeItemsPerPage
        }
      })]);
    },
    genPaginationInfo: function genPaginationInfo() {
      var children = ['–'];
      var itemsLength = this.pagination.itemsLength;
      var pageStart = this.pagination.pageStart;
      var pageStop = this.pagination.pageStop;

      if (this.pagination.itemsLength && this.pagination.itemsPerPage) {
        pageStart = this.pagination.pageStart + 1;
        pageStop = itemsLength < this.pagination.pageStop || this.pagination.pageStop < 0 ? itemsLength : this.pagination.pageStop;
        children = this.$scopedSlots['page-text'] ? [this.$scopedSlots['page-text']({
          pageStart: pageStart,
          pageStop: pageStop,
          itemsLength: itemsLength
        })] : [this.$vuetify.lang.t(this.pageText, pageStart, pageStop, itemsLength)];
      } else if (this.$scopedSlots['page-text']) {
        children = [this.$scopedSlots['page-text']({
          pageStart: pageStart,
          pageStop: pageStop,
          itemsLength: itemsLength
        })];
      }

      return this.$createElement('div', {
        class: 'v-data-footer__pagination'
      }, children);
    },
    genIcon: function genIcon(click, disabled, label, icon) {
      return this.$createElement(VBtn["a" /* default */], {
        props: {
          disabled: disabled || this.disablePagination,
          icon: true,
          text: true
        },
        on: {
          click: click
        },
        attrs: {
          'aria-label': label
        }
      }, [this.$createElement(VIcon["a" /* default */], icon)]);
    },
    genIcons: function genIcons() {
      var before = [];
      var after = [];
      before.push(this.genIcon(this.onPreviousPage, this.options.page === 1, this.$vuetify.lang.t('$vuetify.dataFooter.prevPage'), this.$vuetify.rtl ? this.nextIcon : this.prevIcon));
      after.push(this.genIcon(this.onNextPage, this.disableNextPageIcon, this.$vuetify.lang.t('$vuetify.dataFooter.nextPage'), this.$vuetify.rtl ? this.prevIcon : this.nextIcon));

      if (this.showFirstLastPage) {
        before.unshift(this.genIcon(this.onFirstPage, this.options.page === 1, this.$vuetify.lang.t('$vuetify.dataFooter.firstPage'), this.$vuetify.rtl ? this.lastIcon : this.firstIcon));
        after.push(this.genIcon(this.onLastPage, this.options.page >= this.pagination.pageCount || this.options.itemsPerPage === -1, this.$vuetify.lang.t('$vuetify.dataFooter.lastPage'), this.$vuetify.rtl ? this.firstIcon : this.lastIcon));
      }

      return [this.$createElement('div', {
        staticClass: 'v-data-footer__icons-before'
      }, before), this.showCurrentPage && this.$createElement('span', [this.options.page.toString()]), this.$createElement('div', {
        staticClass: 'v-data-footer__icons-after'
      }, after)];
    }
  },
  render: function render() {
    return this.$createElement('div', {
      staticClass: 'v-data-footer'
    }, [this.genItemsPerPageSelect(), this.genPaginationInfo(), this.genIcons()]);
  }
}));
// EXTERNAL MODULE: ./node_modules/vuetify/lib/mixins/mobile/index.js
var mobile = __webpack_require__("e4cd");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/mixins/themeable/index.js
var themeable = __webpack_require__("7560");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/util/mixins.js
var mixins = __webpack_require__("58df");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/util/console.js + 32 modules
var console = __webpack_require__("d9bd");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VDataIterator/VDataIterator.js













// Components

 // Mixins


 // Helpers




/* @vue/component */

/* harmony default export */ var VDataIterator = (Object(mixins["a" /* default */])(mobile["a" /* default */], themeable["a" /* default */]).extend({
  name: 'v-data-iterator',
  props: Object(objectSpread2["a" /* default */])(Object(objectSpread2["a" /* default */])({}, VData.options.props), {}, {
    itemKey: {
      type: String,
      default: 'id'
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    singleSelect: Boolean,
    expanded: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    mobileBreakpoint: Object(objectSpread2["a" /* default */])(Object(objectSpread2["a" /* default */])({}, mobile["a" /* default */].options.props.mobileBreakpoint), {}, {
      default: 600
    }),
    singleExpand: Boolean,
    loading: [Boolean, String],
    noResultsText: {
      type: String,
      default: '$vuetify.dataIterator.noResultsText'
    },
    noDataText: {
      type: String,
      default: '$vuetify.noDataText'
    },
    loadingText: {
      type: String,
      default: '$vuetify.dataIterator.loadingText'
    },
    hideDefaultFooter: Boolean,
    footerProps: Object,
    selectableKey: {
      type: String,
      default: 'isSelectable'
    }
  }),
  data: function data() {
    return {
      selection: {},
      expansion: {},
      internalCurrentItems: []
    };
  },
  computed: {
    everyItem: function everyItem() {
      var _this = this;

      return !!this.selectableItems.length && this.selectableItems.every(function (i) {
        return _this.isSelected(i);
      });
    },
    someItems: function someItems() {
      var _this2 = this;

      return this.selectableItems.some(function (i) {
        return _this2.isSelected(i);
      });
    },
    sanitizedFooterProps: function sanitizedFooterProps() {
      return Object(helpers["d" /* camelizeObjectKeys */])(this.footerProps);
    },
    selectableItems: function selectableItems() {
      var _this3 = this;

      return this.internalCurrentItems.filter(function (item) {
        return _this3.isSelectable(item);
      });
    }
  },
  watch: {
    value: {
      handler: function handler(value) {
        var _this4 = this;

        this.selection = value.reduce(function (selection, item) {
          selection[Object(helpers["p" /* getObjectValueByPath */])(item, _this4.itemKey)] = item;
          return selection;
        }, {});
      },
      immediate: true
    },
    selection: function selection(value, old) {
      if (Object(helpers["j" /* deepEqual */])(Object.keys(value), Object.keys(old))) return;
      this.$emit('input', Object.values(value));
    },
    expanded: {
      handler: function handler(value) {
        var _this5 = this;

        this.expansion = value.reduce(function (expansion, item) {
          expansion[Object(helpers["p" /* getObjectValueByPath */])(item, _this5.itemKey)] = true;
          return expansion;
        }, {});
      },
      immediate: true
    },
    expansion: function expansion(value, old) {
      var _this6 = this;

      if (Object(helpers["j" /* deepEqual */])(value, old)) return;
      var keys = Object.keys(value).filter(function (k) {
        return value[k];
      });
      var expanded = !keys.length ? [] : this.items.filter(function (i) {
        return keys.includes(String(Object(helpers["p" /* getObjectValueByPath */])(i, _this6.itemKey)));
      });
      this.$emit('update:expanded', expanded);
    }
  },
  created: function created() {
    var _this7 = this;

    var breakingProps = [['disable-initial-sort', 'sort-by'], ['filter', 'custom-filter'], ['pagination', 'options'], ['total-items', 'server-items-length'], ['hide-actions', 'hide-default-footer'], ['rows-per-page-items', 'footer-props.items-per-page-options'], ['rows-per-page-text', 'footer-props.items-per-page-text'], ['prev-icon', 'footer-props.prev-icon'], ['next-icon', 'footer-props.next-icon']];
    /* istanbul ignore next */

    breakingProps.forEach(function (_ref) {
      var _ref2 = Object(slicedToArray["a" /* default */])(_ref, 2),
          original = _ref2[0],
          replacement = _ref2[1];

      if (_this7.$attrs.hasOwnProperty(original)) Object(console["a" /* breaking */])(original, replacement, _this7);
    });
    var removedProps = ['expand', 'content-class', 'content-props', 'content-tag'];
    /* istanbul ignore next */

    removedProps.forEach(function (prop) {
      if (_this7.$attrs.hasOwnProperty(prop)) Object(console["e" /* removed */])(prop);
    });
  },
  methods: {
    toggleSelectAll: function toggleSelectAll(value) {
      var selection = Object.assign({}, this.selection);

      for (var i = 0; i < this.selectableItems.length; i++) {
        var item = this.selectableItems[i];
        if (!this.isSelectable(item)) continue;
        var key = Object(helpers["p" /* getObjectValueByPath */])(item, this.itemKey);
        if (value) selection[key] = item;else delete selection[key];
      }

      this.selection = selection;
      this.$emit('toggle-select-all', {
        items: this.internalCurrentItems,
        value: value
      });
    },
    isSelectable: function isSelectable(item) {
      return Object(helpers["p" /* getObjectValueByPath */])(item, this.selectableKey) !== false;
    },
    isSelected: function isSelected(item) {
      return !!this.selection[Object(helpers["p" /* getObjectValueByPath */])(item, this.itemKey)] || false;
    },
    select: function select(item) {
      var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var emit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      if (!this.isSelectable(item)) return;
      var selection = this.singleSelect ? {} : Object.assign({}, this.selection);
      var key = Object(helpers["p" /* getObjectValueByPath */])(item, this.itemKey);
      if (value) selection[key] = item;else delete selection[key];

      if (this.singleSelect && emit) {
        var keys = Object.keys(this.selection);
        var old = keys.length && Object(helpers["p" /* getObjectValueByPath */])(this.selection[keys[0]], this.itemKey);
        old && old !== key && this.$emit('item-selected', {
          item: this.selection[old],
          value: false
        });
      }

      this.selection = selection;
      emit && this.$emit('item-selected', {
        item: item,
        value: value
      });
    },
    isExpanded: function isExpanded(item) {
      return this.expansion[Object(helpers["p" /* getObjectValueByPath */])(item, this.itemKey)] || false;
    },
    expand: function expand(item) {
      var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var expansion = this.singleExpand ? {} : Object.assign({}, this.expansion);
      var key = Object(helpers["p" /* getObjectValueByPath */])(item, this.itemKey);
      if (value) expansion[key] = true;else delete expansion[key];
      this.expansion = expansion;
      this.$emit('item-expanded', {
        item: item,
        value: value
      });
    },
    createItemProps: function createItemProps(item, index) {
      var _this8 = this;

      return {
        item: item,
        index: index,
        select: function select(v) {
          return _this8.select(item, v);
        },
        isSelected: this.isSelected(item),
        expand: function expand(v) {
          return _this8.expand(item, v);
        },
        isExpanded: this.isExpanded(item),
        isMobile: this.isMobile
      };
    },
    genEmptyWrapper: function genEmptyWrapper(content) {
      return this.$createElement('div', content);
    },
    genEmpty: function genEmpty(originalItemsLength, filteredItemsLength) {
      if (originalItemsLength === 0 && this.loading) {
        var loading = this.$slots.loading || this.$vuetify.lang.t(this.loadingText);
        return this.genEmptyWrapper(loading);
      } else if (originalItemsLength === 0) {
        var noData = this.$slots['no-data'] || this.$vuetify.lang.t(this.noDataText);
        return this.genEmptyWrapper(noData);
      } else if (filteredItemsLength === 0) {
        var noResults = this.$slots['no-results'] || this.$vuetify.lang.t(this.noResultsText);
        return this.genEmptyWrapper(noResults);
      }

      return null;
    },
    genItems: function genItems(props) {
      var _this9 = this;

      var empty = this.genEmpty(props.originalItemsLength, props.pagination.itemsLength);
      if (empty) return [empty];

      if (this.$scopedSlots.default) {
        return this.$scopedSlots.default(Object(objectSpread2["a" /* default */])(Object(objectSpread2["a" /* default */])({}, props), {}, {
          isSelected: this.isSelected,
          select: this.select,
          isExpanded: this.isExpanded,
          isMobile: this.isMobile,
          expand: this.expand
        }));
      }

      if (this.$scopedSlots.item) {
        return props.items.map(function (item, index) {
          return _this9.$scopedSlots.item(_this9.createItemProps(item, index));
        });
      }

      return [];
    },
    genFooter: function genFooter(props) {
      if (this.hideDefaultFooter) return null;
      var data = {
        props: Object(objectSpread2["a" /* default */])(Object(objectSpread2["a" /* default */])({}, this.sanitizedFooterProps), {}, {
          options: props.options,
          pagination: props.pagination
        }),
        on: {
          'update:options': function updateOptions(value) {
            return props.updateOptions(value);
          }
        }
      };
      var scopedSlots = Object(helpers["q" /* getPrefixedScopedSlots */])('footer.', this.$scopedSlots);
      return this.$createElement(VDataIterator_VDataFooter, Object(objectSpread2["a" /* default */])({
        scopedSlots: scopedSlots
      }, data));
    },
    genDefaultScopedSlot: function genDefaultScopedSlot(props) {
      var outerProps = Object(objectSpread2["a" /* default */])(Object(objectSpread2["a" /* default */])({}, props), {}, {
        someItems: this.someItems,
        everyItem: this.everyItem,
        toggleSelectAll: this.toggleSelectAll
      });

      return this.$createElement('div', {
        staticClass: 'v-data-iterator'
      }, [Object(helpers["s" /* getSlot */])(this, 'header', outerProps, true), this.genItems(props), this.genFooter(props), Object(helpers["s" /* getSlot */])(this, 'footer', outerProps, true)]);
    }
  },
  render: function render() {
    var _this10 = this;

    return this.$createElement(VData, {
      props: this.$props,
      on: {
        'update:options': function updateOptions(v, old) {
          return !Object(helpers["j" /* deepEqual */])(v, old) && _this10.$emit('update:options', v);
        },
        'update:page': function updatePage(v) {
          return _this10.$emit('update:page', v);
        },
        'update:items-per-page': function updateItemsPerPage(v) {
          return _this10.$emit('update:items-per-page', v);
        },
        'update:sort-by': function updateSortBy(v) {
          return _this10.$emit('update:sort-by', v);
        },
        'update:sort-desc': function updateSortDesc(v) {
          return _this10.$emit('update:sort-desc', v);
        },
        'update:group-by': function updateGroupBy(v) {
          return _this10.$emit('update:group-by', v);
        },
        'update:group-desc': function updateGroupDesc(v) {
          return _this10.$emit('update:group-desc', v);
        },
        pagination: function pagination(v, old) {
          return !Object(helpers["j" /* deepEqual */])(v, old) && _this10.$emit('pagination', v);
        },
        'current-items': function currentItems(v) {
          _this10.internalCurrentItems = v;

          _this10.$emit('current-items', v);
        },
        'page-count': function pageCount(v) {
          return _this10.$emit('page-count', v);
        }
      },
      scopedSlots: {
        default: this.genDefaultScopedSlot
      }
    });
  }
}));
// EXTERNAL MODULE: ./node_modules/vuetify/src/components/VDataTable/VDataTableHeader.sass
var VDataTableHeader = __webpack_require__("f823");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/components/VChip/index.js
var VChip = __webpack_require__("34ef");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/components/VCheckbox/VSimpleCheckbox.js
var VSimpleCheckbox = __webpack_require__("9e88");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/directives/ripple/index.js
var ripple = __webpack_require__("5607");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VDataTable/mixins/header.js





/* harmony default export */ var mixins_header = (Object(mixins["a" /* default */])().extend({
  // https://github.com/vuejs/vue/issues/6872
  directives: {
    ripple: ripple["a" /* default */]
  },
  props: {
    headers: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    options: {
      type: Object,
      default: function _default() {
        return {
          page: 1,
          itemsPerPage: 10,
          sortBy: [],
          sortDesc: [],
          groupBy: [],
          groupDesc: [],
          multiSort: false,
          mustSort: false
        };
      }
    },
    sortIcon: {
      type: String,
      default: '$sort'
    },
    everyItem: Boolean,
    someItems: Boolean,
    showGroupBy: Boolean,
    singleSelect: Boolean,
    disableSort: Boolean
  },
  methods: {
    genSelectAll: function genSelectAll() {
      var _this = this;

      var data = {
        props: {
          value: this.everyItem,
          indeterminate: !this.everyItem && this.someItems
        },
        on: {
          input: function input(v) {
            return _this.$emit('toggle-select-all', v);
          }
        }
      };

      if (this.$scopedSlots['data-table-select']) {
        return this.$scopedSlots['data-table-select'](data);
      }

      return this.$createElement(VSimpleCheckbox["a" /* default */], Object(objectSpread2["a" /* default */])({
        staticClass: 'v-data-table__checkbox'
      }, data));
    },
    genSortIcon: function genSortIcon() {
      return this.$createElement(VIcon["a" /* default */], {
        staticClass: 'v-data-table-header__icon',
        props: {
          size: 18
        }
      }, [this.sortIcon]);
    }
  }
}));
// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VDataTable/VDataTableHeaderMobile.js











/* harmony default export */ var VDataTableHeaderMobile = (Object(mixins["a" /* default */])(mixins_header).extend({
  name: 'v-data-table-header-mobile',
  props: {
    sortByText: {
      type: String,
      default: '$vuetify.dataTable.sortBy'
    }
  },
  methods: {
    genSortChip: function genSortChip(props) {
      var _this = this;

      var children = [props.item.text];
      var sortIndex = this.options.sortBy.findIndex(function (k) {
        return k === props.item.value;
      });
      var beingSorted = sortIndex >= 0;
      var isDesc = this.options.sortDesc[sortIndex];
      children.push(this.$createElement('div', {
        staticClass: 'v-chip__close',
        class: {
          sortable: true,
          active: beingSorted,
          asc: beingSorted && !isDesc,
          desc: beingSorted && isDesc
        }
      }, [this.genSortIcon()]));
      return this.$createElement(VChip["a" /* default */], {
        staticClass: 'sortable',
        on: {
          click: function click(e) {
            e.stopPropagation();

            _this.$emit('sort', props.item.value);
          }
        }
      }, children);
    },
    genSortSelect: function genSortSelect(items) {
      var _this2 = this;

      return this.$createElement(VSelect["a" /* default */], {
        props: {
          label: this.$vuetify.lang.t(this.sortByText),
          items: items,
          hideDetails: true,
          multiple: this.options.multiSort,
          value: this.options.multiSort ? this.options.sortBy : this.options.sortBy[0],
          menuProps: {
            closeOnContentClick: true
          }
        },
        on: {
          change: function change(v) {
            return _this2.$emit('sort', v);
          }
        },
        scopedSlots: {
          selection: function selection(props) {
            return _this2.genSortChip(props);
          }
        }
      });
    }
  },
  render: function render(h) {
    var children = [];
    var header = this.headers.find(function (h) {
      return h.value === 'data-table-select';
    });

    if (header && !this.singleSelect) {
      children.push(this.$createElement('div', {
        class: ['v-data-table-header-mobile__select'].concat(Object(toConsumableArray["a" /* default */])(Object(helpers["H" /* wrapInArray */])(header.class))),
        attrs: {
          width: header.width
        }
      }, [this.genSelectAll()]));
    }

    var sortHeaders = this.headers.filter(function (h) {
      return h.sortable !== false && h.value !== 'data-table-select';
    }).map(function (h) {
      return {
        text: h.text,
        value: h.value
      };
    });

    if (!this.disableSort && sortHeaders.length) {
      children.push(this.genSortSelect(sortHeaders));
    }

    var th = h('th', [h('div', {
      staticClass: 'v-data-table-header-mobile__wrapper'
    }, children)]);
    var tr = h('tr', [th]);
    return h('thead', {
      staticClass: 'v-data-table-header v-data-table-header-mobile'
    }, [tr]);
  }
}));
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__("a15b");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VDataTable/VDataTableHeaderDesktop.js








/* harmony default export */ var VDataTableHeaderDesktop = (Object(mixins["a" /* default */])(mixins_header).extend({
  name: 'v-data-table-header-desktop',
  methods: {
    genGroupByToggle: function genGroupByToggle(header) {
      var _this = this;

      return this.$createElement('span', {
        on: {
          click: function click(e) {
            e.stopPropagation();

            _this.$emit('group', header.value);
          }
        }
      }, ['group']);
    },
    getAria: function getAria(beingSorted, isDesc) {
      var _this2 = this;

      var $t = function $t(key) {
        return _this2.$vuetify.lang.t("$vuetify.dataTable.ariaLabel.".concat(key));
      };

      var ariaSort = 'none';
      var ariaLabel = [$t('sortNone'), $t('activateAscending')];

      if (!beingSorted) {
        return {
          ariaSort: ariaSort,
          ariaLabel: ariaLabel.join(' ')
        };
      }

      if (isDesc) {
        ariaSort = 'descending';
        ariaLabel = [$t('sortDescending'), $t(this.options.mustSort ? 'activateAscending' : 'activateNone')];
      } else {
        ariaSort = 'ascending';
        ariaLabel = [$t('sortAscending'), $t('activateDescending')];
      }

      return {
        ariaSort: ariaSort,
        ariaLabel: ariaLabel.join(' ')
      };
    },
    genHeader: function genHeader(header) {
      var _this3 = this;

      var data = {
        attrs: {
          role: 'columnheader',
          scope: 'col',
          'aria-label': header.text || ''
        },
        style: {
          width: Object(helpers["g" /* convertToUnit */])(header.width),
          minWidth: Object(helpers["g" /* convertToUnit */])(header.width)
        },
        class: ["text-".concat(header.align || 'start')].concat(Object(toConsumableArray["a" /* default */])(Object(helpers["H" /* wrapInArray */])(header.class)), [header.divider && 'v-data-table__divider']),
        on: {}
      };
      var children = [];

      if (header.value === 'data-table-select' && !this.singleSelect) {
        return this.$createElement('th', data, [this.genSelectAll()]);
      }

      children.push(this.$scopedSlots[header.value] ? this.$scopedSlots[header.value]({
        header: header
      }) : this.$createElement('span', [header.text]));

      if (!this.disableSort && (header.sortable || !header.hasOwnProperty('sortable'))) {
        data.on.click = function () {
          return _this3.$emit('sort', header.value);
        };

        var sortIndex = this.options.sortBy.findIndex(function (k) {
          return k === header.value;
        });
        var beingSorted = sortIndex >= 0;
        var isDesc = this.options.sortDesc[sortIndex];
        data.class.push('sortable');

        var _this$getAria = this.getAria(beingSorted, isDesc),
            ariaLabel = _this$getAria.ariaLabel,
            ariaSort = _this$getAria.ariaSort;

        data.attrs['aria-label'] += "".concat(header.text ? ': ' : '').concat(ariaLabel);
        data.attrs['aria-sort'] = ariaSort;

        if (beingSorted) {
          data.class.push('active');
          data.class.push(isDesc ? 'desc' : 'asc');
        }

        if (header.align === 'end') children.unshift(this.genSortIcon());else children.push(this.genSortIcon());

        if (this.options.multiSort && beingSorted) {
          children.push(this.$createElement('span', {
            class: 'v-data-table-header__sort-badge'
          }, [String(sortIndex + 1)]));
        }
      }

      if (this.showGroupBy && header.groupable !== false) children.push(this.genGroupByToggle(header));
      return this.$createElement('th', data, children);
    }
  },
  render: function render() {
    var _this4 = this;

    return this.$createElement('thead', {
      staticClass: 'v-data-table-header'
    }, [this.$createElement('tr', this.headers.map(function (header) {
      return _this4.genHeader(header);
    }))]);
  }
}));
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.index-of.js
var es_array_index_of = __webpack_require__("c975");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/util/dedupeModelListeners.js



/**
 * Removes duplicate `@input` listeners when
 * using v-model with functional components
 *
 * @see https://github.com/vuetifyjs/vuetify/issues/4460
 */
function dedupeModelListeners(data) {
  if (data.model && data.on && data.on.input) {
    if (Array.isArray(data.on.input)) {
      var i = data.on.input.indexOf(data.model.callback);
      if (i > -1) data.on.input.splice(i, 1);
    } else {
      delete data.on.input;
    }
  }
}
// EXTERNAL MODULE: ./node_modules/vuetify/lib/util/mergeData.js
var mergeData = __webpack_require__("d9f7");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/util/rebuildFunctionalSlots.js
function rebuildFunctionalSlots(slots, h) {
  var children = [];

  for (var slot in slots) {
    if (slots.hasOwnProperty(slot)) {
      children.push(h('template', {
        slot: slot
      }, slots[slot]));
    }
  }

  return children;
}
// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VDataTable/VDataTableHeader.js

// Styles
 // Components


 // Mixins

 // Utilities



 // Types


/* @vue/component */

/* harmony default export */ var VDataTable_VDataTableHeader = (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
  name: 'v-data-table-header',
  functional: true,
  props: Object(objectSpread2["a" /* default */])(Object(objectSpread2["a" /* default */])({}, mixins_header.options.props), {}, {
    mobile: Boolean
  }),
  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        slots = _ref.slots;
    dedupeModelListeners(data);
    var children = rebuildFunctionalSlots(slots(), h);
    data = Object(mergeData["a" /* default */])(data, {
      props: props
    });

    if (props.mobile) {
      return h(VDataTableHeaderMobile, data, children);
    } else {
      return h(VDataTableHeaderDesktop, data, children);
    }
  }
}));
// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VDataTable/Row.js


// Types
 // Utils


/* harmony default export */ var Row = (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
  name: 'row',
  functional: true,
  props: {
    headers: Array,
    index: Number,
    item: Object,
    rtl: Boolean
  },
  render: function render(h, _ref) {
    var props = _ref.props,
        slots = _ref.slots,
        data = _ref.data;
    var computedSlots = slots();
    var columns = props.headers.map(function (header) {
      var children = [];
      var value = Object(helpers["p" /* getObjectValueByPath */])(props.item, header.value);
      var slotName = header.value;
      var scopedSlot = data.scopedSlots && data.scopedSlots[slotName];
      var regularSlot = computedSlots[slotName];

      if (scopedSlot) {
        children.push(scopedSlot({
          item: props.item,
          isMobile: false,
          header: header,
          index: props.index,
          value: value
        }));
      } else if (regularSlot) {
        children.push(regularSlot);
      } else {
        children.push(value == null ? value : String(value));
      }

      var textAlign = "text-".concat(header.align || 'start');
      return h('td', {
        class: [textAlign, header.cellClass, {
          'v-data-table__divider': header.divider
        }]
      }, children);
    });
    return h('tr', data, columns);
  }
}));
// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VDataTable/RowGroup.js


/* harmony default export */ var RowGroup = (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
  name: 'row-group',
  functional: true,
  props: {
    value: {
      type: Boolean,
      default: true
    },
    headerClass: {
      type: String,
      default: 'v-row-group__header'
    },
    contentClass: String,
    summaryClass: {
      type: String,
      default: 'v-row-group__summary'
    }
  },
  render: function render(h, _ref) {
    var slots = _ref.slots,
        props = _ref.props;
    var computedSlots = slots();
    var children = [];

    if (computedSlots['column.header']) {
      children.push(h('tr', {
        staticClass: props.headerClass
      }, computedSlots['column.header']));
    } else if (computedSlots['row.header']) {
      children.push.apply(children, Object(toConsumableArray["a" /* default */])(computedSlots['row.header']));
    }

    if (computedSlots['row.content'] && props.value) children.push.apply(children, Object(toConsumableArray["a" /* default */])(computedSlots['row.content']));

    if (computedSlots['column.summary']) {
      children.push(h('tr', {
        staticClass: props.summaryClass
      }, computedSlots['column.summary']));
    } else if (computedSlots['row.summary']) {
      children.push.apply(children, Object(toConsumableArray["a" /* default */])(computedSlots['row.summary']));
    }

    return children;
  }
}));
// EXTERNAL MODULE: ./node_modules/vuetify/src/components/VDataTable/VSimpleTable.sass
var VSimpleTable = __webpack_require__("8b37");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VDataTable/VSimpleTable.js






/* harmony default export */ var VDataTable_VSimpleTable = (Object(mixins["a" /* default */])(themeable["a" /* default */]).extend({
  name: 'v-simple-table',
  props: {
    dense: Boolean,
    fixedHeader: Boolean,
    height: [Number, String]
  },
  computed: {
    classes: function classes() {
      return Object(objectSpread2["a" /* default */])({
        'v-data-table--dense': this.dense,
        'v-data-table--fixed-height': !!this.height && !this.fixedHeader,
        'v-data-table--fixed-header': this.fixedHeader,
        'v-data-table--has-top': !!this.$slots.top,
        'v-data-table--has-bottom': !!this.$slots.bottom
      }, this.themeClasses);
    }
  },
  methods: {
    genWrapper: function genWrapper() {
      return this.$slots.wrapper || this.$createElement('div', {
        staticClass: 'v-data-table__wrapper',
        style: {
          height: Object(helpers["g" /* convertToUnit */])(this.height)
        }
      }, [this.$createElement('table', this.$slots.default)]);
    }
  },
  render: function render(h) {
    return h('div', {
      staticClass: 'v-data-table',
      class: this.classes
    }, [this.$slots.top, this.genWrapper(), this.$slots.bottom]);
  }
}));
// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VDataTable/MobileRow.js





/* harmony default export */ var MobileRow = (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
  name: 'row',
  functional: true,
  props: {
    headers: Array,
    hideDefaultHeader: Boolean,
    index: Number,
    item: Object,
    rtl: Boolean
  },
  render: function render(h, _ref) {
    var props = _ref.props,
        slots = _ref.slots,
        data = _ref.data;
    var computedSlots = slots();
    var columns = props.headers.map(function (header) {
      var classes = {
        'v-data-table__mobile-row': true
      };
      var children = [];
      var value = Object(helpers["p" /* getObjectValueByPath */])(props.item, header.value);
      var slotName = header.value;
      var scopedSlot = data.scopedSlots && data.scopedSlots[slotName];
      var regularSlot = computedSlots[slotName];

      if (scopedSlot) {
        children.push(scopedSlot({
          item: props.item,
          isMobile: true,
          header: header,
          index: props.index,
          value: value
        }));
      } else if (regularSlot) {
        children.push(regularSlot);
      } else {
        children.push(value == null ? value : String(value));
      }

      var mobileRowChildren = [h('div', {
        staticClass: 'v-data-table__mobile-row__cell'
      }, children)];

      if (header.value !== 'dataTableSelect' && !props.hideDefaultHeader) {
        mobileRowChildren.unshift(h('div', {
          staticClass: 'v-data-table__mobile-row__header'
        }, [header.text]));
      }

      return h('td', {
        class: classes
      }, mobileRowChildren);
    });
    return h('tr', Object(objectSpread2["a" /* default */])(Object(objectSpread2["a" /* default */])({}, data), {}, {
      staticClass: 'v-data-table__mobile-table-row'
    }), columns);
  }
}));
// EXTERNAL MODULE: ./node_modules/vuetify/lib/mixins/loadable/index.js
var loadable = __webpack_require__("297c");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VDataTable/VDataTable.js



















 // Components




 // import VVirtualTable from './VVirtualTable'






 // Mixins

 // Directives

 // Helpers






function filterFn(item, search, filter) {
  return function (header) {
    var value = Object(helpers["p" /* getObjectValueByPath */])(item, header.value);
    return header.filter ? header.filter(value, search, item) : filter(value, search, item);
  };
}

function searchTableItems(items, search, headersWithCustomFilters, headersWithoutCustomFilters, customFilter) {
  search = typeof search === 'string' ? search.trim() : null;
  return items.filter(function (item) {
    // Headers with custom filters are evaluated whether or not a search term has been provided.
    // We need to match every filter to be included in the results.
    var matchesColumnFilters = headersWithCustomFilters.every(filterFn(item, search, helpers["k" /* defaultFilter */])); // Headers without custom filters are only filtered by the `search` property if it is defined.
    // We only need a single column to match the search term to be included in the results.

    var matchesSearchTerm = !search || headersWithoutCustomFilters.some(filterFn(item, search, customFilter));
    return matchesColumnFilters && matchesSearchTerm;
  });
}
/* @vue/component */


/* harmony default export */ var VDataTable_VDataTable = (Object(mixins["a" /* default */])(VDataIterator, loadable["a" /* default */]).extend({
  name: 'v-data-table',
  // https://github.com/vuejs/vue/issues/6872
  directives: {
    ripple: ripple["a" /* default */]
  },
  props: {
    headers: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    showSelect: Boolean,
    showExpand: Boolean,
    showGroupBy: Boolean,
    // TODO: Fix
    // virtualRows: Boolean,
    height: [Number, String],
    hideDefaultHeader: Boolean,
    caption: String,
    dense: Boolean,
    headerProps: Object,
    calculateWidths: Boolean,
    fixedHeader: Boolean,
    headersLength: Number,
    expandIcon: {
      type: String,
      default: '$expand'
    },
    customFilter: {
      type: Function,
      default: helpers["k" /* defaultFilter */]
    },
    itemClass: {
      type: [String, Function],
      default: function _default() {
        return '';
      }
    },
    loaderHeight: {
      type: [Number, String],
      default: 4
    }
  },
  data: function data() {
    return {
      internalGroupBy: [],
      openCache: {},
      widths: []
    };
  },
  computed: {
    computedHeaders: function computedHeaders() {
      var _this = this;

      if (!this.headers) return [];
      var headers = this.headers.filter(function (h) {
        return h.value === undefined || !_this.internalGroupBy.find(function (v) {
          return v === h.value;
        });
      });
      var defaultHeader = {
        text: '',
        sortable: false,
        width: '1px'
      };

      if (this.showSelect) {
        var index = headers.findIndex(function (h) {
          return h.value === 'data-table-select';
        });
        if (index < 0) headers.unshift(Object(objectSpread2["a" /* default */])(Object(objectSpread2["a" /* default */])({}, defaultHeader), {}, {
          value: 'data-table-select'
        }));else headers.splice(index, 1, Object(objectSpread2["a" /* default */])(Object(objectSpread2["a" /* default */])({}, defaultHeader), headers[index]));
      }

      if (this.showExpand) {
        var _index = headers.findIndex(function (h) {
          return h.value === 'data-table-expand';
        });

        if (_index < 0) headers.unshift(Object(objectSpread2["a" /* default */])(Object(objectSpread2["a" /* default */])({}, defaultHeader), {}, {
          value: 'data-table-expand'
        }));else headers.splice(_index, 1, Object(objectSpread2["a" /* default */])(Object(objectSpread2["a" /* default */])({}, defaultHeader), headers[_index]));
      }

      return headers;
    },
    colspanAttrs: function colspanAttrs() {
      return this.isMobile ? undefined : {
        colspan: this.headersLength || this.computedHeaders.length
      };
    },
    columnSorters: function columnSorters() {
      return this.computedHeaders.reduce(function (acc, header) {
        if (header.sort) acc[header.value] = header.sort;
        return acc;
      }, {});
    },
    headersWithCustomFilters: function headersWithCustomFilters() {
      return this.headers.filter(function (header) {
        return header.filter && (!header.hasOwnProperty('filterable') || header.filterable === true);
      });
    },
    headersWithoutCustomFilters: function headersWithoutCustomFilters() {
      return this.headers.filter(function (header) {
        return !header.filter && (!header.hasOwnProperty('filterable') || header.filterable === true);
      });
    },
    sanitizedHeaderProps: function sanitizedHeaderProps() {
      return Object(helpers["d" /* camelizeObjectKeys */])(this.headerProps);
    },
    computedItemsPerPage: function computedItemsPerPage() {
      var itemsPerPage = this.options && this.options.itemsPerPage ? this.options.itemsPerPage : this.itemsPerPage;
      var itemsPerPageOptions = this.sanitizedFooterProps.itemsPerPageOptions;

      if (itemsPerPageOptions && !itemsPerPageOptions.find(function (item) {
        return typeof item === 'number' ? item === itemsPerPage : item.value === itemsPerPage;
      })) {
        var firstOption = itemsPerPageOptions[0];
        return Object(esm_typeof["a" /* default */])(firstOption) === 'object' ? firstOption.value : firstOption;
      }

      return itemsPerPage;
    }
  },
  created: function created() {
    var _this2 = this;

    var breakingProps = [['sort-icon', 'header-props.sort-icon'], ['hide-headers', 'hide-default-header'], ['select-all', 'show-select']];
    /* istanbul ignore next */

    breakingProps.forEach(function (_ref) {
      var _ref2 = Object(slicedToArray["a" /* default */])(_ref, 2),
          original = _ref2[0],
          replacement = _ref2[1];

      if (_this2.$attrs.hasOwnProperty(original)) Object(console["a" /* breaking */])(original, replacement, _this2);
    });
  },
  mounted: function mounted() {
    // if ((!this.sortBy || !this.sortBy.length) && (!this.options.sortBy || !this.options.sortBy.length)) {
    //   const firstSortable = this.headers.find(h => !('sortable' in h) || !!h.sortable)
    //   if (firstSortable) this.updateOptions({ sortBy: [firstSortable.value], sortDesc: [false] })
    // }
    if (this.calculateWidths) {
      window.addEventListener('resize', this.calcWidths);
      this.calcWidths();
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.calculateWidths) {
      window.removeEventListener('resize', this.calcWidths);
    }
  },
  methods: {
    calcWidths: function calcWidths() {
      this.widths = Array.from(this.$el.querySelectorAll('th')).map(function (e) {
        return e.clientWidth;
      });
    },
    customFilterWithColumns: function customFilterWithColumns(items, search) {
      return searchTableItems(items, search, this.headersWithCustomFilters, this.headersWithoutCustomFilters, this.customFilter);
    },
    customSortWithHeaders: function customSortWithHeaders(items, sortBy, sortDesc, locale) {
      return this.customSort(items, sortBy, sortDesc, locale, this.columnSorters);
    },
    createItemProps: function createItemProps(item, index) {
      var props = VDataIterator.options.methods.createItemProps.call(this, item, index);
      return Object.assign(props, {
        headers: this.computedHeaders
      });
    },
    genCaption: function genCaption(props) {
      if (this.caption) return [this.$createElement('caption', [this.caption])];
      return Object(helpers["s" /* getSlot */])(this, 'caption', props, true);
    },
    genColgroup: function genColgroup(props) {
      var _this3 = this;

      return this.$createElement('colgroup', this.computedHeaders.map(function (header) {
        return _this3.$createElement('col', {
          class: {
            divider: header.divider
          }
        });
      }));
    },
    genLoading: function genLoading() {
      var th = this.$createElement('th', {
        staticClass: 'column',
        attrs: this.colspanAttrs
      }, [this.genProgress()]);
      var tr = this.$createElement('tr', {
        staticClass: 'v-data-table__progress'
      }, [th]);
      return this.$createElement('thead', [tr]);
    },
    genHeaders: function genHeaders(props) {
      var data = {
        props: Object(objectSpread2["a" /* default */])(Object(objectSpread2["a" /* default */])({}, this.sanitizedHeaderProps), {}, {
          headers: this.computedHeaders,
          options: props.options,
          mobile: this.isMobile,
          showGroupBy: this.showGroupBy,
          someItems: this.someItems,
          everyItem: this.everyItem,
          singleSelect: this.singleSelect,
          disableSort: this.disableSort
        }),
        on: {
          sort: props.sort,
          group: props.group,
          'toggle-select-all': this.toggleSelectAll
        }
      };
      var children = [Object(helpers["s" /* getSlot */])(this, 'header', Object(objectSpread2["a" /* default */])(Object(objectSpread2["a" /* default */])({}, data), {}, {
        isMobile: this.isMobile
      }))];

      if (!this.hideDefaultHeader) {
        var scopedSlots = Object(helpers["q" /* getPrefixedScopedSlots */])('header.', this.$scopedSlots);
        children.push(this.$createElement(VDataTable_VDataTableHeader, Object(objectSpread2["a" /* default */])(Object(objectSpread2["a" /* default */])({}, data), {}, {
          scopedSlots: scopedSlots
        })));
      }

      if (this.loading) children.push(this.genLoading());
      return children;
    },
    genEmptyWrapper: function genEmptyWrapper(content) {
      return this.$createElement('tr', {
        staticClass: 'v-data-table__empty-wrapper'
      }, [this.$createElement('td', {
        attrs: this.colspanAttrs
      }, content)]);
    },
    genItems: function genItems(items, props) {
      var empty = this.genEmpty(props.originalItemsLength, props.pagination.itemsLength);
      if (empty) return [empty];
      return props.groupedItems ? this.genGroupedRows(props.groupedItems, props) : this.genRows(items, props);
    },
    genGroupedRows: function genGroupedRows(groupedItems, props) {
      var _this4 = this;

      return groupedItems.map(function (group) {
        if (!_this4.openCache.hasOwnProperty(group.name)) _this4.$set(_this4.openCache, group.name, true);

        if (_this4.$scopedSlots.group) {
          return _this4.$scopedSlots.group({
            group: group.name,
            options: props.options,
            isMobile: _this4.isMobile,
            items: group.items,
            headers: _this4.computedHeaders
          });
        } else {
          return _this4.genDefaultGroupedRow(group.name, group.items, props);
        }
      });
    },
    genDefaultGroupedRow: function genDefaultGroupedRow(group, items, props) {
      var _this5 = this;

      var isOpen = !!this.openCache[group];
      var children = [this.$createElement('template', {
        slot: 'row.content'
      }, this.genRows(items, props))];

      var toggleFn = function toggleFn() {
        return _this5.$set(_this5.openCache, group, !_this5.openCache[group]);
      };

      var removeFn = function removeFn() {
        return props.updateOptions({
          groupBy: [],
          groupDesc: []
        });
      };

      if (this.$scopedSlots['group.header']) {
        children.unshift(this.$createElement('template', {
          slot: 'column.header'
        }, [this.$scopedSlots['group.header']({
          group: group,
          groupBy: props.options.groupBy,
          isMobile: this.isMobile,
          items: items,
          headers: this.computedHeaders,
          isOpen: isOpen,
          toggle: toggleFn,
          remove: removeFn
        })]));
      } else {
        var toggle = this.$createElement(VBtn["a" /* default */], {
          staticClass: 'ma-0',
          props: {
            icon: true,
            small: true
          },
          on: {
            click: toggleFn
          }
        }, [this.$createElement(VIcon["a" /* default */], [isOpen ? '$minus' : '$plus'])]);
        var remove = this.$createElement(VBtn["a" /* default */], {
          staticClass: 'ma-0',
          props: {
            icon: true,
            small: true
          },
          on: {
            click: removeFn
          }
        }, [this.$createElement(VIcon["a" /* default */], ['$close'])]);
        var column = this.$createElement('td', {
          staticClass: 'text-start',
          attrs: this.colspanAttrs
        }, [toggle, "".concat(props.options.groupBy[0], ": ").concat(group), remove]);
        children.unshift(this.$createElement('template', {
          slot: 'column.header'
        }, [column]));
      }

      if (this.$scopedSlots['group.summary']) {
        children.push(this.$createElement('template', {
          slot: 'column.summary'
        }, [this.$scopedSlots['group.summary']({
          group: group,
          groupBy: props.options.groupBy,
          isMobile: this.isMobile,
          items: items,
          headers: this.computedHeaders,
          isOpen: isOpen,
          toggle: toggleFn
        })]));
      }

      return this.$createElement(RowGroup, {
        key: group,
        props: {
          value: isOpen
        }
      }, children);
    },
    genRows: function genRows(items, props) {
      return this.$scopedSlots.item ? this.genScopedRows(items, props) : this.genDefaultRows(items, props);
    },
    genScopedRows: function genScopedRows(items, props) {
      var rows = [];

      for (var i = 0; i < items.length; i++) {
        var item = items[i];
        rows.push(this.$scopedSlots.item(Object(objectSpread2["a" /* default */])(Object(objectSpread2["a" /* default */])({}, this.createItemProps(item, i)), {}, {
          isMobile: this.isMobile
        })));

        if (this.isExpanded(item)) {
          rows.push(this.$scopedSlots['expanded-item']({
            headers: this.computedHeaders,
            isMobile: this.isMobile,
            index: i,
            item: item
          }));
        }
      }

      return rows;
    },
    genDefaultRows: function genDefaultRows(items, props) {
      var _this6 = this;

      return this.$scopedSlots['expanded-item'] ? items.map(function (item, index) {
        return _this6.genDefaultExpandedRow(item, index);
      }) : items.map(function (item, index) {
        return _this6.genDefaultSimpleRow(item, index);
      });
    },
    genDefaultExpandedRow: function genDefaultExpandedRow(item, index) {
      var isExpanded = this.isExpanded(item);
      var classes = {
        'v-data-table__expanded v-data-table__expanded__row': isExpanded
      };
      var headerRow = this.genDefaultSimpleRow(item, index, classes);
      var expandedRow = this.$createElement('tr', {
        staticClass: 'v-data-table__expanded v-data-table__expanded__content'
      }, [this.$scopedSlots['expanded-item']({
        headers: this.computedHeaders,
        isMobile: this.isMobile,
        item: item
      })]);
      return this.$createElement(RowGroup, {
        props: {
          value: isExpanded
        }
      }, [this.$createElement('template', {
        slot: 'row.header'
      }, [headerRow]), this.$createElement('template', {
        slot: 'row.content'
      }, [expandedRow])]);
    },
    genDefaultSimpleRow: function genDefaultSimpleRow(item, index) {
      var _this7 = this;

      var classes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var scopedSlots = Object(helpers["q" /* getPrefixedScopedSlots */])('item.', this.$scopedSlots);
      var data = this.createItemProps(item, index);

      if (this.showSelect) {
        var slot = scopedSlots['data-table-select'];
        scopedSlots['data-table-select'] = slot ? function () {
          return slot(Object(objectSpread2["a" /* default */])(Object(objectSpread2["a" /* default */])({}, data), {}, {
            isMobile: _this7.isMobile
          }));
        } : function () {
          return _this7.$createElement(VSimpleCheckbox["a" /* default */], {
            staticClass: 'v-data-table__checkbox',
            props: {
              value: data.isSelected,
              disabled: !_this7.isSelectable(item)
            },
            on: {
              input: function input(val) {
                return data.select(val);
              }
            }
          });
        };
      }

      if (this.showExpand) {
        var _slot = scopedSlots['data-table-expand'];
        scopedSlots['data-table-expand'] = _slot ? function () {
          return _slot(data);
        } : function () {
          return _this7.$createElement(VIcon["a" /* default */], {
            staticClass: 'v-data-table__expand-icon',
            class: {
              'v-data-table__expand-icon--active': data.isExpanded
            },
            on: {
              click: function click(e) {
                e.stopPropagation();
                data.expand(!data.isExpanded);
              }
            }
          }, [_this7.expandIcon]);
        };
      }

      return this.$createElement(this.isMobile ? MobileRow : Row, {
        key: Object(helpers["p" /* getObjectValueByPath */])(item, this.itemKey),
        class: Object(mergeData["b" /* mergeClasses */])(Object(objectSpread2["a" /* default */])(Object(objectSpread2["a" /* default */])({}, classes), {}, {
          'v-data-table__selected': data.isSelected
        }), Object(helpers["r" /* getPropertyFromItem */])(item, this.itemClass)),
        props: {
          headers: this.computedHeaders,
          hideDefaultHeader: this.hideDefaultHeader,
          index: index,
          item: item,
          rtl: this.$vuetify.rtl
        },
        scopedSlots: scopedSlots,
        on: {
          // TODO: for click, the first argument should be the event, and the second argument should be data,
          // but this is a breaking change so it's for v3
          click: function click() {
            return _this7.$emit('click:row', item, data);
          },
          contextmenu: function contextmenu(event) {
            return _this7.$emit('contextmenu:row', event, data);
          },
          dblclick: function dblclick(event) {
            return _this7.$emit('dblclick:row', event, data);
          }
        }
      });
    },
    genBody: function genBody(props) {
      var data = Object(objectSpread2["a" /* default */])(Object(objectSpread2["a" /* default */])({}, props), {}, {
        expand: this.expand,
        headers: this.computedHeaders,
        isExpanded: this.isExpanded,
        isMobile: this.isMobile,
        isSelected: this.isSelected,
        select: this.select
      });

      if (this.$scopedSlots.body) {
        return this.$scopedSlots.body(data);
      }

      return this.$createElement('tbody', [Object(helpers["s" /* getSlot */])(this, 'body.prepend', data, true), this.genItems(props.items, props), Object(helpers["s" /* getSlot */])(this, 'body.append', data, true)]);
    },
    genFooters: function genFooters(props) {
      var data = {
        props: Object(objectSpread2["a" /* default */])({
          options: props.options,
          pagination: props.pagination,
          itemsPerPageText: '$vuetify.dataTable.itemsPerPageText'
        }, this.sanitizedFooterProps),
        on: {
          'update:options': function updateOptions(value) {
            return props.updateOptions(value);
          }
        },
        widths: this.widths,
        headers: this.computedHeaders
      };
      var children = [Object(helpers["s" /* getSlot */])(this, 'footer', data, true)];

      if (!this.hideDefaultFooter) {
        children.push(this.$createElement(VDataIterator_VDataFooter, Object(objectSpread2["a" /* default */])(Object(objectSpread2["a" /* default */])({}, data), {}, {
          scopedSlots: Object(helpers["q" /* getPrefixedScopedSlots */])('footer.', this.$scopedSlots)
        })));
      }

      return children;
    },
    genDefaultScopedSlot: function genDefaultScopedSlot(props) {
      var simpleProps = {
        height: this.height,
        fixedHeader: this.fixedHeader,
        dense: this.dense
      }; // if (this.virtualRows) {
      //   return this.$createElement(VVirtualTable, {
      //     props: Object.assign(simpleProps, {
      //       items: props.items,
      //       height: this.height,
      //       rowHeight: this.dense ? 24 : 48,
      //       headerHeight: this.dense ? 32 : 48,
      //       // TODO: expose rest of props from virtual table?
      //     }),
      //     scopedSlots: {
      //       items: ({ items }) => this.genItems(items, props) as any,
      //     },
      //   }, [
      //     this.proxySlot('body.before', [this.genCaption(props), this.genHeaders(props)]),
      //     this.proxySlot('bottom', this.genFooters(props)),
      //   ])
      // }

      return this.$createElement(VDataTable_VSimpleTable, {
        props: simpleProps
      }, [this.proxySlot('top', Object(helpers["s" /* getSlot */])(this, 'top', Object(objectSpread2["a" /* default */])(Object(objectSpread2["a" /* default */])({}, props), {}, {
        isMobile: this.isMobile
      }), true)), this.genCaption(props), this.genColgroup(props), this.genHeaders(props), this.genBody(props), this.proxySlot('bottom', this.genFooters(props))]);
    },
    proxySlot: function proxySlot(slot, content) {
      return this.$createElement('template', {
        slot: slot
      }, content);
    }
  },
  render: function render() {
    var _this8 = this;

    return this.$createElement(VData, {
      props: Object(objectSpread2["a" /* default */])(Object(objectSpread2["a" /* default */])({}, this.$props), {}, {
        customFilter: this.customFilterWithColumns,
        customSort: this.customSortWithHeaders,
        itemsPerPage: this.computedItemsPerPage
      }),
      on: {
        'update:options': function updateOptions(v, old) {
          _this8.internalGroupBy = v.groupBy || [];
          !Object(helpers["j" /* deepEqual */])(v, old) && _this8.$emit('update:options', v);
        },
        'update:page': function updatePage(v) {
          return _this8.$emit('update:page', v);
        },
        'update:items-per-page': function updateItemsPerPage(v) {
          return _this8.$emit('update:items-per-page', v);
        },
        'update:sort-by': function updateSortBy(v) {
          return _this8.$emit('update:sort-by', v);
        },
        'update:sort-desc': function updateSortDesc(v) {
          return _this8.$emit('update:sort-desc', v);
        },
        'update:group-by': function updateGroupBy(v) {
          return _this8.$emit('update:group-by', v);
        },
        'update:group-desc': function updateGroupDesc(v) {
          return _this8.$emit('update:group-desc', v);
        },
        pagination: function pagination(v, old) {
          return !Object(helpers["j" /* deepEqual */])(v, old) && _this8.$emit('pagination', v);
        },
        'current-items': function currentItems(v) {
          _this8.internalCurrentItems = v;

          _this8.$emit('current-items', v);
        },
        'page-count': function pageCount(v) {
          return _this8.$emit('page-count', v);
        }
      },
      scopedSlots: {
        default: this.genDefaultScopedSlot
      }
    });
  }
}));
// CONCATENATED MODULE: ./src/components/data-table/PpDataTable.vue







/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  data_table_PpDataTablevue_type_script_lang_js_,
  PpDataTablevue_type_template_id_4d4a0701_scoped_true_render,
  staticRenderFns,
  false,
  null,
  "4d4a0701",
  null
  
)

/* harmony default export */ var PpDataTable = __webpack_exports__["default"] = (component.exports);

/* vuetify-loader */


installComponents_default()(component, {VDataTable: VDataTable_VDataTable})


/***/ }),

/***/ "713a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _VAvatar__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("8212");


/* harmony default export */ __webpack_exports__["a"] = (_VAvatar__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]);

/***/ }),

/***/ "7156":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");
var setPrototypeOf = __webpack_require__("d2bb");

// makes subclassing work correct for wrapped built-ins
module.exports = function ($this, dummy, Wrapper) {
  var NewTarget, NewTargetPrototype;
  if (
    // it can work only with native `setPrototypeOf`
    setPrototypeOf &&
    // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    typeof (NewTarget = dummy.constructor) == 'function' &&
    NewTarget !== Wrapper &&
    isObject(NewTargetPrototype = NewTarget.prototype) &&
    NewTargetPrototype !== Wrapper.prototype
  ) setPrototypeOf($this, NewTargetPrototype);
  return $this;
};


/***/ }),

/***/ "72b7":
/***/ (function(module, exports, __webpack_require__) {

var addMilliseconds = __webpack_require__("ec1f")

var MILLISECONDS_IN_MINUTE = 60000

/**
 * @category Minute Helpers
 * @summary Add the specified number of minutes to the given date.
 *
 * @description
 * Add the specified number of minutes to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of minutes to be added
 * @returns {Date} the new date with the minutes added
 *
 * @example
 * // Add 30 minutes to 10 July 2014 12:00:00:
 * var result = addMinutes(new Date(2014, 6, 10, 12, 0), 30)
 * //=> Thu Jul 10 2014 12:30:00
 */
function addMinutes (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addMilliseconds(dirtyDate, amount * MILLISECONDS_IN_MINUTE)
}

module.exports = addMinutes


/***/ }),

/***/ "72ce":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.theme--light.v-radio--is-disabled label{color:var(--pp-text-disabled,#f6f6f6)}.theme--light.v-radio--is-disabled .v-icon{color:#d6d6d6!important}.theme--dark.v-radio--is-disabled label{color:hsla(0,0%,100%,.5)}.theme--dark.v-radio--is-disabled .v-icon{color:hsla(0,0%,100%,.3)!important}.v-radio{align-items:center;display:flex;height:auto;outline:none}.v-radio--is-disabled{pointer-events:none;cursor:default}.v-input--radio-group.v-input--radio-group--row .v-radio{margin-right:16px}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "7338":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("c8d5")

/**
 * @category Month Helpers
 * @summary Get the month of the given date.
 *
 * @description
 * Get the month of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the month
 *
 * @example
 * // Which month is 29 February 2012?
 * var result = getMonth(new Date(2012, 1, 29))
 * //=> 1
 */
function getMonth (dirtyDate) {
  var date = parse(dirtyDate)
  var month = date.getMonth()
  return month
}

module.exports = getMonth


/***/ }),

/***/ "736a":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.i, "@import url(https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css);"]);
exports.push([module.i, "@import url(https://cdn-prd.patientpop.com/pp-icon-font/v1.6.0/pp-icon-font.css);"]);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}label[data-v-a024b9e8]{color:#2b2b2b;display:block;margin-bottom:4px}label span[data-v-a024b9e8]{color:#545454}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "7378":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><rect x=\"3\" y=\"4\" width=\"18\" height=\"19\" rx=\"3\" fill=\"white\"></rect><rect x=\"8\" y=\"3\" width=\"8\" height=\"3\" fill=\"#D5EAFD\"></rect><path d=\"M6.71 4C6.90441 3.55503 7.22412 3.17626 7.63014 2.9099C8.03615 2.64355 8.51092 2.50112 8.9965 2.5H9.2075C9.40223 2.05382 9.72299 1.67421 10.1304 1.40774C10.5378 1.14128 11.0142 0.99957 11.501 1H12.499C12.9856 1.00008 13.4616 1.14202 13.8687 1.40843C14.2759 1.67484 14.5966 2.05417 14.7915 2.5H15.0035C15.4894 2.50036 15.9646 2.64246 16.3709 2.9089C16.7772 3.17534 17.097 3.55453 17.291 4H18.5C18.8284 4 19.1536 4.0647 19.4569 4.1904C19.7603 4.3161 20.036 4.50033 20.2681 4.73259C20.5003 4.96484 20.6844 5.24056 20.81 5.54399C20.9356 5.84741 21.0001 6.17261 21 6.501V20.499C20.9997 21.1621 20.7363 21.7979 20.2675 22.2668C19.7988 22.7358 19.1631 22.9995 18.5 23H5.5C5.17161 23 4.84644 22.9353 4.54306 22.8096C4.23968 22.6839 3.96404 22.4997 3.73188 22.2674C3.49972 22.0352 3.31559 21.7594 3.19001 21.456C3.06444 21.1526 2.99987 20.8274 3 20.499V6.501C3.00026 5.83795 3.26371 5.20212 3.73246 4.73317C4.20122 4.26423 4.83695 4.00053 5.5 4H6.71ZM6.551 6H5.5C5.225 6 5 6.225 5 6.501V20.499C4.99987 20.5647 5.0127 20.6299 5.03777 20.6907C5.06284 20.7514 5.09965 20.8067 5.14609 20.8532C5.19253 20.8997 5.2477 20.9367 5.30843 20.9618C5.36915 20.987 5.43425 21 5.5 21H18.5C18.775 21 19 20.775 19 20.499V6.501C19.0001 6.43526 18.9873 6.37013 18.9622 6.30935C18.9372 6.24857 18.9003 6.19334 18.8539 6.1468C18.8075 6.10027 18.7523 6.06335 18.6916 6.03816C18.6308 6.01297 18.5657 6 18.5 6H17.449C17.2155 7.14 16.2065 8 15.004 8H8.996C7.789 8 6.7835 7.14 6.551 6ZM10 4.5H8.9965C8.86404 4.50223 8.73777 4.55642 8.64489 4.65088C8.55202 4.74535 8.49998 4.87253 8.5 5.005V5.495C8.5 5.775 8.724 6 8.9965 6H15.0035C15.273 6 15.5 5.7725 15.5 5.495V5.005C15.5 4.725 15.276 4.5 15.0035 4.5H14C13.7348 4.5 13.4804 4.39464 13.2929 4.20711C13.1054 4.01957 13 3.76522 13 3.5C13 3.225 12.775 3 12.499 3H11.501C11.4352 2.99974 11.37 3.01248 11.3092 3.0375C11.2484 3.06253 11.1931 3.09933 11.1465 3.1458C11.0999 3.19227 11.063 3.24748 11.0379 3.30827C11.0127 3.36906 10.9999 3.43422 11 3.5C11 3.76522 10.8946 4.01957 10.7071 4.20711C10.5196 4.39464 10.2652 4.5 10 4.5Z\" fill=\"#079CB2\"></path><path d=\"M9 11C9 11.5523 8.55228 12 8 12C7.44772 12 7 11.5523 7 11C7 10.4477 7.44772 10 8 10C8.55228 10 9 10.4477 9 11Z\" fill=\"#079CB2\"></path><path d=\"M9 14C9 14.5523 8.55228 15 8 15C7.44772 15 7 14.5523 7 14C7 13.4477 7.44772 13 8 13C8.55228 13 9 13.4477 9 14Z\" fill=\"#079CB2\"></path><path d=\"M9 17C9 17.5523 8.55228 18 8 18C7.44772 18 7 17.5523 7 17C7 16.4477 7.44772 16 8 16C8.55228 16 9 16.4477 9 17Z\" fill=\"#079CB2\"></path><path d=\"M10 11C10 10.4477 10.4477 10 11 10H16C16.5523 10 17 10.4477 17 11C17 11.5523 16.5523 12 16 12H11C10.4477 12 10 11.5523 10 11Z\" fill=\"#079CB2\"></path><path d=\"M10 14C10 13.4477 10.4477 13 11 13H16C16.5523 13 17 13.4477 17 14C17 14.5523 16.5523 15 16 15H11C10.4477 15 10 14.5523 10 14Z\" fill=\"#079CB2\"></path><path d=\"M10 17C10 16.4477 10.4477 16 11 16H16C16.5523 16 17 16.4477 17 17C17 17.5523 16.5523 18 16 18H11C10.4477 18 10 17.5523 10 17Z\" fill=\"#079CB2\"></path></svg>";

/***/ }),

/***/ "7418":
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ "7435":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("ac87");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("ac501fa2", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "7443":
/***/ (function(module, exports, __webpack_require__) {

var endOfDay = __webpack_require__("9744")

/**
 * @category Day Helpers
 * @summary Return the end of today.
 *
 * @description
 * Return the end of today.
 *
 * @returns {Date} the end of today
 *
 * @example
 * // If today is 6 October 2014:
 * var result = endOfToday()
 * //=> Mon Oct 6 2014 23:59:59.999
 */
function endOfToday () {
  return endOfDay(new Date())
}

module.exports = endOfToday


/***/ }),

/***/ "746f":
/***/ (function(module, exports, __webpack_require__) {

var path = __webpack_require__("428f");
var has = __webpack_require__("5135");
var wrappedWellKnownSymbolModule = __webpack_require__("e538");
var defineProperty = __webpack_require__("9bf2").f;

module.exports = function (NAME) {
  var Symbol = path.Symbol || (path.Symbol = {});
  if (!has(Symbol, NAME)) defineProperty(Symbol, NAME, {
    value: wrappedWellKnownSymbolModule.f(NAME)
  });
};


/***/ }),

/***/ "7494":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("c8d5")

/**
 * @category Week Helpers
 * @summary Return the end of a week for the given date.
 *
 * @description
 * Return the end of a week for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @param {Object} [options] - the object with options
 * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the end of a week
 *
 * @example
 * // The end of a week for 2 September 2014 11:55:00:
 * var result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sat Sep 06 2014 23:59:59.999
 *
 * @example
 * // If the week starts on Monday, the end of the week for 2 September 2014 11:55:00:
 * var result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0), {weekStartsOn: 1})
 * //=> Sun Sep 07 2014 23:59:59.999
 */
function endOfWeek (dirtyDate, dirtyOptions) {
  var weekStartsOn = dirtyOptions ? (Number(dirtyOptions.weekStartsOn) || 0) : 0

  var date = parse(dirtyDate)
  var day = date.getDay()
  var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn)

  date.setDate(date.getDate() + diff)
  date.setHours(23, 59, 59, 999)
  return date
}

module.exports = endOfWeek


/***/ }),

/***/ "74c8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpPortal_vue_vue_type_style_index_0_id_e6e0eea4_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("fdcf");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpPortal_vue_vue_type_style_index_0_id_e6e0eea4_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpPortal_vue_vue_type_style_index_0_id_e6e0eea4_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "753d":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.i, "@import url(https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css);"]);
exports.push([module.i, "@import url(https://cdn-prd.patientpop.com/pp-icon-font/v1.6.0/pp-icon-font.css);"]);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.consent-options[data-v-a1f58fb8]{list-style:none}.consent-options__option[data-v-a1f58fb8]{border:var(--list-border-width,1px) solid var(--list-border-color,#d6d6d6);cursor:pointer;min-height:7em;padding:1.5em;transition:background-image 1s}@media(min-width:960px){.consent-options__option[data-v-a1f58fb8]{background-position:1em 1em;background-repeat:no-repeat;background-size:auto 64px;padding:1.5em 1.5em 1.5em calc(64px + 1.5em)}.consent-options__option--obtained[data-v-a1f58fb8]{background-image:url(https://ui-cdn.patientpop.com/assets/img/consent-obtained.svg)}.consent-options__option--required[data-v-a1f58fb8]{background-image:url(https://ui-cdn.patientpop.com/assets/img/consent-required.svg);background-position:1.5em 1em}}.consent-options__option[data-v-a1f58fb8]:first-child{margin-bottom:1em}.consent-options__option[data-v-a1f58fb8]:hover{background-color:#f6f6f6}.consent-options__option--active[data-v-a1f58fb8],.consent-options__option--active[data-v-a1f58fb8]:hover{--list-border-color:#079cb2;--list-border-width:2px;background-color:#e6f5f7}.mock-text[data-v-a1f58fb8]{box-shadow:0 .1em .1em #9a9a9a}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "7560":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return functionalThemeClasses; });
/* harmony import */ var _home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("5530");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("8bbf");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_1__);


/* @vue/component */

var Themeable = vue__WEBPACK_IMPORTED_MODULE_1___default.a.extend().extend({
  name: 'themeable',
  provide: function provide() {
    return {
      theme: this.themeableProvide
    };
  },
  inject: {
    theme: {
      default: {
        isDark: false
      }
    }
  },
  props: {
    dark: {
      type: Boolean,
      default: null
    },
    light: {
      type: Boolean,
      default: null
    }
  },
  data: function data() {
    return {
      themeableProvide: {
        isDark: false
      }
    };
  },
  computed: {
    appIsDark: function appIsDark() {
      return this.$vuetify.theme.dark || false;
    },
    isDark: function isDark() {
      if (this.dark === true) {
        // explicitly dark
        return true;
      } else if (this.light === true) {
        // explicitly light
        return false;
      } else {
        // inherit from parent, or default false if there is none
        return this.theme.isDark;
      }
    },
    themeClasses: function themeClasses() {
      return {
        'theme--dark': this.isDark,
        'theme--light': !this.isDark
      };
    },

    /** Used by menus and dialogs, inherits from v-app instead of the parent */
    rootIsDark: function rootIsDark() {
      if (this.dark === true) {
        // explicitly dark
        return true;
      } else if (this.light === true) {
        // explicitly light
        return false;
      } else {
        // inherit from v-app
        return this.appIsDark;
      }
    },
    rootThemeClasses: function rootThemeClasses() {
      return {
        'theme--dark': this.rootIsDark,
        'theme--light': !this.rootIsDark
      };
    }
  },
  watch: {
    isDark: {
      handler: function handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.themeableProvide.isDark = this.isDark;
        }
      },
      immediate: true
    }
  }
});
/* harmony default export */ __webpack_exports__["a"] = (Themeable);
function functionalThemeClasses(context) {
  var vm = Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({}, context.props), context.injections);

  var isDark = Themeable.options.computed.isDark.call(vm);
  return Themeable.options.computed.themeClasses.call({
    isDark: isDark
  });
}

/***/ }),

/***/ "75eb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("4160");
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("159b");
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ade3");
/* harmony import */ var _home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("53ca");
/* harmony import */ var _bootable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("9d65");
/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("80d2");
/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("58df");
/* harmony import */ var _util_console__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("d9bd");




// Mixins
 // Utilities





function validateAttachTarget(val) {
  var type = Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(val);

  if (type === 'boolean' || type === 'string') return true;
  return val.nodeType === Node.ELEMENT_NODE;
}
/* @vue/component */


/* harmony default export */ __webpack_exports__["a"] = (Object(_util_mixins__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])(_bootable__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"]).extend({
  name: 'detachable',
  props: {
    attach: {
      default: false,
      validator: validateAttachTarget
    },
    contentClass: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      activatorNode: null,
      hasDetached: false
    };
  },
  watch: {
    attach: function attach() {
      this.hasDetached = false;
      this.initDetach();
    },
    hasContent: function hasContent() {
      this.$nextTick(this.initDetach);
    }
  },
  beforeMount: function beforeMount() {
    var _this = this;

    this.$nextTick(function () {
      if (_this.activatorNode) {
        var activator = Array.isArray(_this.activatorNode) ? _this.activatorNode : [_this.activatorNode];
        activator.forEach(function (node) {
          if (!node.elm) return;
          if (!_this.$el.parentNode) return;
          var target = _this.$el === _this.$el.parentNode.firstChild ? _this.$el : _this.$el.nextSibling;

          _this.$el.parentNode.insertBefore(node.elm, target);
        });
      }
    });
  },
  mounted: function mounted() {
    this.hasContent && this.initDetach();
  },
  deactivated: function deactivated() {
    this.isActive = false;
  },
  beforeDestroy: function beforeDestroy() {
    // IE11 Fix
    try {
      if (this.$refs.content && this.$refs.content.parentNode) {
        this.$refs.content.parentNode.removeChild(this.$refs.content);
      }

      if (this.activatorNode) {
        var activator = Array.isArray(this.activatorNode) ? this.activatorNode : [this.activatorNode];
        activator.forEach(function (node) {
          node.elm && node.elm.parentNode && node.elm.parentNode.removeChild(node.elm);
        });
      }
    } catch (e) {
      console.log(e);
    }
  },
  methods: {
    getScopeIdAttrs: function getScopeIdAttrs() {
      var scopeId = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_5__[/* getObjectValueByPath */ "p"])(this.$vnode, 'context.$options._scopeId');
      return scopeId && Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])({}, scopeId, '');
    },
    initDetach: function initDetach() {
      if (this._isDestroyed || !this.$refs.content || this.hasDetached || // Leave menu in place if attached
      // and dev has not changed target
      this.attach === '' || // If used as a boolean prop (<v-menu attach>)
      this.attach === true || // If bound to a boolean (<v-menu :attach="true">)
      this.attach === 'attach' // If bound as boolean prop in pug (v-menu(attach))
      ) return;
      var target;

      if (this.attach === false) {
        // Default, detach to app
        target = document.querySelector('[data-app]');
      } else if (typeof this.attach === 'string') {
        // CSS selector
        target = document.querySelector(this.attach);
      } else {
        // DOM Element
        target = this.attach;
      }

      if (!target) {
        Object(_util_console__WEBPACK_IMPORTED_MODULE_7__[/* consoleWarn */ "c"])("Unable to locate target ".concat(this.attach || '[data-app]'), this);
        return;
      }

      target.appendChild(this.$refs.content);
      this.hasDetached = true;
    }
  }
}));

/***/ }),

/***/ "7606":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("c8d5")

/**
 * @category Weekday Helpers
 * @summary Is the given date Tuesday?
 *
 * @description
 * Is the given date Tuesday?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is Tuesday
 *
 * @example
 * // Is 23 September 2014 Tuesday?
 * var result = isTuesday(new Date(2014, 8, 23))
 * //=> true
 */
function isTuesday (dirtyDate) {
  return parse(dirtyDate).getDay() === 2
}

module.exports = isTuesday


/***/ }),

/***/ "7686":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.i, "@import url(https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css);"]);
exports.push([module.i, "@import url(https://cdn-prd.patientpop.com/pp-icon-font/v1.6.0/pp-icon-font.css);"]);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.pp-input-file[data-v-6cf0f976]{border:2px dashed #d6d6d6}.pp-input-file--dragging[data-v-6cf0f976],.pp-input-file--uploading[data-v-6cf0f976]{background:#e6f5f7;border-color:#079cb2}.pp-input-file--complete[data-v-6cf0f976]{background:#f0faf2;border-color:#3fa266}.pp-input-file--error[data-v-6cf0f976]{border-color:#d83b4d}.pp-input-file img[data-v-6cf0f976]{width:100px}.pp-input-file__select-file[data-v-6cf0f976]{color:#067889;cursor:pointer}.pp-input-file__select-file[data-v-6cf0f976]:hover{text-decoration:underline}label[data-v-6cf0f976]{cursor:pointer}.pp-icon-check[data-v-6cf0f976]{margin-top:.15em}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "76a3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c662cfac-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/chart/horizontal-slide/PpChartHorizontalSlide.vue?vue&type=template&id=624fcc47&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pp-chart-horizontal-slide",style:(_vm.styleProgress)},[_c('progress',{staticClass:"pp-chart-horizontal-slide__progress",attrs:{"max":_vm.maxValue},domProps:{"value":_vm.value}},[_vm._v(" "+_vm._s(_vm.percentage)+" ")]),_c('div',{staticClass:"pp-chart-horizontal-slide__marker",attrs:{"title":_vm.value}})])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/chart/horizontal-slide/PpChartHorizontalSlide.vue?vue&type=template&id=624fcc47&scoped=true&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__("a9e3");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/chart/horizontal-slide/PpChartHorizontalSlide.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var PpChartHorizontalSlidevue_type_script_lang_js_ = ({
  name: 'PpChartHorizontalSlide',
  props: {
    value: {
      type: Number,
      required: true
    },
    color: {
      type: String,
      required: true
    },
    maxValue: {
      type: Number,
      required: true
    }
  },
  computed: {
    styleProgress: function styleProgress() {
      return {
        '--pp-slide-chart-margin-left': this.value / this.maxValue,
        '--pp-slide-chart-color': this.color
      };
    },
    percentage: function percentage() {
      return "".concat(Math.floor(this.value / this.maxValue), " %");
    }
  }
});
// CONCATENATED MODULE: ./src/components/chart/horizontal-slide/PpChartHorizontalSlide.vue?vue&type=script&lang=js&
 /* harmony default export */ var horizontal_slide_PpChartHorizontalSlidevue_type_script_lang_js_ = (PpChartHorizontalSlidevue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/chart/horizontal-slide/PpChartHorizontalSlide.vue?vue&type=style&index=0&id=624fcc47&lang=scss&scoped=true&
var PpChartHorizontalSlidevue_type_style_index_0_id_624fcc47_lang_scss_scoped_true_ = __webpack_require__("c7a1");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/chart/horizontal-slide/PpChartHorizontalSlide.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  horizontal_slide_PpChartHorizontalSlidevue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "624fcc47",
  null
  
)

/* harmony default export */ var PpChartHorizontalSlide = __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "77ff":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("5e41");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("11e9c2f6", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "7839":
/***/ (function(module, exports) {

// IE8- don't enum bug keys
module.exports = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];


/***/ }),

/***/ "7863":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("5987");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("6accd068", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "7873":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("ca91");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("b3e50f38", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "7893":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><rect x=\"5\" y=\"5\" width=\"17\" height=\"17\" rx=\"1\" fill=\"#DFE4E5\" stroke=\"#1F3A3E\" stroke-width=\"2\"></rect><rect x=\"2\" y=\"2\" width=\"16\" height=\"16\" rx=\"1\" fill=\"white\" stroke=\"#1F3A3E\" stroke-width=\"2\"></rect><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M11.4985 9.25C11.4985 8.42157 10.827 7.75 9.99854 7.75C9.17012 7.75 8.49854 8.42157 8.49854 9.25V9.75C8.49854 10.5784 9.17012 11.25 9.99854 11.25C10.827 11.25 11.4985 10.5784 11.4985 9.75V9.25ZM9 12C7.89543 12 7 12.8954 7 14V15H13V14C13 12.8954 12.1046 12 11 12H9Z\" fill=\"#1F3A3E\"></path><path d=\"M3 4H17V6H3V4Z\" fill=\"#1F3A3E\"></path><path d=\"M5 3H7V5H5V3Z\" fill=\"#1F3A3E\"></path><path d=\"M8.99854 3H10.9985V5H8.99854V3Z\" fill=\"#1F3A3E\"></path></svg>";

/***/ }),

/***/ "7893e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpPortalUserMenu_vue_vue_type_style_index_0_id_0b18df46_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("9bdf");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpPortalUserMenu_vue_vue_type_style_index_0_id_0b18df46_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpPortalUserMenu_vue_vue_type_style_index_0_id_0b18df46_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "7916":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}@-webkit-keyframes v-shake{59%{margin-left:0}60%,80%{margin-left:2px}70%,90%{margin-left:-2px}}@keyframes v-shake{59%{margin-left:0}60%,80%{margin-left:2px}70%,90%{margin-left:-2px}}.v-application .black{background-color:#000!important;border-color:#000!important}.v-application .black--text{color:#000!important;caret-color:#000!important}.v-application .white{background-color:#fff!important;border-color:#fff!important}.v-application .white--text{color:#fff!important;caret-color:#fff!important}.v-application .transparent{background-color:transparent!important;border-color:transparent!important}.v-application .transparent--text{color:transparent!important;caret-color:transparent!important}.v-application .red{background-color:#d83b4d!important;border-color:#d83b4d!important}.v-application .red--text{color:#d83b4d!important;caret-color:#d83b4d!important}.v-application .red.lighten-5{background-color:#fceeee!important;border-color:#fceeee!important}.v-application .red--text.text--lighten-5{color:#fceeee!important;caret-color:#fceeee!important}.v-application .red.lighten-4{background-color:#fbcbd1!important;border-color:#fbcbd1!important}.v-application .red--text.text--lighten-4{color:#fbcbd1!important;caret-color:#fbcbd1!important}.v-application .red.lighten-3{background-color:#ef9a9a!important;border-color:#ef9a9a!important}.v-application .red--text.text--lighten-3{color:#ef9a9a!important;caret-color:#ef9a9a!important}.v-application .red.lighten-2{background-color:#e57373!important;border-color:#e57373!important}.v-application .red--text.text--lighten-2{color:#e57373!important;caret-color:#e57373!important}.v-application .red.lighten-1{background-color:#ef5350!important;border-color:#ef5350!important}.v-application .red--text.text--lighten-1{color:#ef5350!important;caret-color:#ef5350!important}.v-application .red.darken-1{background-color:#b51a2c!important;border-color:#b51a2c!important}.v-application .red--text.text--darken-1{color:#b51a2c!important;caret-color:#b51a2c!important}.v-application .red.darken-2{background-color:#b51a2c!important;border-color:#b51a2c!important}.v-application .red--text.text--darken-2{color:#b51a2c!important;caret-color:#b51a2c!important}.v-application .red.darken-3{background-color:#c62828!important;border-color:#c62828!important}.v-application .red--text.text--darken-3{color:#c62828!important;caret-color:#c62828!important}.v-application .red.darken-4{background-color:#b71c1c!important;border-color:#b71c1c!important}.v-application .red--text.text--darken-4{color:#b71c1c!important;caret-color:#b71c1c!important}.v-application .red.accent-1{background-color:#b51a2c!important;border-color:#b51a2c!important}.v-application .red--text.text--accent-1{color:#b51a2c!important;caret-color:#b51a2c!important}.v-application .red.accent-2{background-color:#ff5252!important;border-color:#ff5252!important}.v-application .red--text.text--accent-2{color:#ff5252!important;caret-color:#ff5252!important}.v-application .red.accent-3{background-color:#ff1744!important;border-color:#ff1744!important}.v-application .red--text.text--accent-3{color:#ff1744!important;caret-color:#ff1744!important}.v-application .red.accent-4{background-color:#d50000!important;border-color:#d50000!important}.v-application .red--text.text--accent-4{color:#d50000!important;caret-color:#d50000!important}.v-application .red.lighten-6{background-color:#fceeee!important;border-color:#fceeee!important}.v-application .red--text.text--lighten-6{color:#fceeee!important;caret-color:#fceeee!important}.v-application .pink{background-color:#e91e63!important;border-color:#e91e63!important}.v-application .pink--text{color:#e91e63!important;caret-color:#e91e63!important}.v-application .pink.lighten-5{background-color:#fce4ec!important;border-color:#fce4ec!important}.v-application .pink--text.text--lighten-5{color:#fce4ec!important;caret-color:#fce4ec!important}.v-application .pink.lighten-4{background-color:#f8bbd0!important;border-color:#f8bbd0!important}.v-application .pink--text.text--lighten-4{color:#f8bbd0!important;caret-color:#f8bbd0!important}.v-application .pink.lighten-3{background-color:#f48fb1!important;border-color:#f48fb1!important}.v-application .pink--text.text--lighten-3{color:#f48fb1!important;caret-color:#f48fb1!important}.v-application .pink.lighten-2{background-color:#f06292!important;border-color:#f06292!important}.v-application .pink--text.text--lighten-2{color:#f06292!important;caret-color:#f06292!important}.v-application .pink.lighten-1{background-color:#ec407a!important;border-color:#ec407a!important}.v-application .pink--text.text--lighten-1{color:#ec407a!important;caret-color:#ec407a!important}.v-application .pink.darken-1{background-color:#d81b60!important;border-color:#d81b60!important}.v-application .pink--text.text--darken-1{color:#d81b60!important;caret-color:#d81b60!important}.v-application .pink.darken-2{background-color:#c2185b!important;border-color:#c2185b!important}.v-application .pink--text.text--darken-2{color:#c2185b!important;caret-color:#c2185b!important}.v-application .pink.darken-3{background-color:#ad1457!important;border-color:#ad1457!important}.v-application .pink--text.text--darken-3{color:#ad1457!important;caret-color:#ad1457!important}.v-application .pink.darken-4{background-color:#880e4f!important;border-color:#880e4f!important}.v-application .pink--text.text--darken-4{color:#880e4f!important;caret-color:#880e4f!important}.v-application .pink.accent-1{background-color:#ff80ab!important;border-color:#ff80ab!important}.v-application .pink--text.text--accent-1{color:#ff80ab!important;caret-color:#ff80ab!important}.v-application .pink.accent-2{background-color:#ff4081!important;border-color:#ff4081!important}.v-application .pink--text.text--accent-2{color:#ff4081!important;caret-color:#ff4081!important}.v-application .pink.accent-3{background-color:#f50057!important;border-color:#f50057!important}.v-application .pink--text.text--accent-3{color:#f50057!important;caret-color:#f50057!important}.v-application .pink.accent-4{background-color:#c51162!important;border-color:#c51162!important}.v-application .pink--text.text--accent-4{color:#c51162!important;caret-color:#c51162!important}.v-application .purple{background-color:#8657ac!important;border-color:#8657ac!important}.v-application .purple--text{color:#8657ac!important;caret-color:#8657ac!important}.v-application .purple.lighten-5{background-color:#e7d8ff!important;border-color:#e7d8ff!important}.v-application .purple--text.text--lighten-5{color:#e7d8ff!important;caret-color:#e7d8ff!important}.v-application .purple.lighten-4{background-color:#e1bee7!important;border-color:#e1bee7!important}.v-application .purple--text.text--lighten-4{color:#e1bee7!important;caret-color:#e1bee7!important}.v-application .purple.lighten-3{background-color:#ce93d8!important;border-color:#ce93d8!important}.v-application .purple--text.text--lighten-3{color:#ce93d8!important;caret-color:#ce93d8!important}.v-application .purple.lighten-2{background-color:#ba68c8!important;border-color:#ba68c8!important}.v-application .purple--text.text--lighten-2{color:#ba68c8!important;caret-color:#ba68c8!important}.v-application .purple.lighten-1{background-color:#ab47bc!important;border-color:#ab47bc!important}.v-application .purple--text.text--lighten-1{color:#ab47bc!important;caret-color:#ab47bc!important}.v-application .purple.darken-1{background-color:#8657ac!important;border-color:#8657ac!important}.v-application .purple--text.text--darken-1{color:#8657ac!important;caret-color:#8657ac!important}.v-application .purple.darken-2{background-color:#8657ac!important;border-color:#8657ac!important}.v-application .purple--text.text--darken-2{color:#8657ac!important;caret-color:#8657ac!important}.v-application .purple.darken-3{background-color:#6a1b9a!important;border-color:#6a1b9a!important}.v-application .purple--text.text--darken-3{color:#6a1b9a!important;caret-color:#6a1b9a!important}.v-application .purple.darken-4{background-color:#4a148c!important;border-color:#4a148c!important}.v-application .purple--text.text--darken-4{color:#4a148c!important;caret-color:#4a148c!important}.v-application .purple.accent-1{background-color:#8657ac!important;border-color:#8657ac!important}.v-application .purple--text.text--accent-1{color:#8657ac!important;caret-color:#8657ac!important}.v-application .purple.accent-2{background-color:#e040fb!important;border-color:#e040fb!important}.v-application .purple--text.text--accent-2{color:#e040fb!important;caret-color:#e040fb!important}.v-application .purple.accent-3{background-color:#d500f9!important;border-color:#d500f9!important}.v-application .purple--text.text--accent-3{color:#d500f9!important;caret-color:#d500f9!important}.v-application .purple.accent-4{background-color:#a0f!important;border-color:#a0f!important}.v-application .purple--text.text--accent-4{color:#a0f!important;caret-color:#a0f!important}.v-application .deep-purple{background-color:#673ab7!important;border-color:#673ab7!important}.v-application .deep-purple--text{color:#673ab7!important;caret-color:#673ab7!important}.v-application .deep-purple.lighten-5{background-color:#ede7f6!important;border-color:#ede7f6!important}.v-application .deep-purple--text.text--lighten-5{color:#ede7f6!important;caret-color:#ede7f6!important}.v-application .deep-purple.lighten-4{background-color:#d1c4e9!important;border-color:#d1c4e9!important}.v-application .deep-purple--text.text--lighten-4{color:#d1c4e9!important;caret-color:#d1c4e9!important}.v-application .deep-purple.lighten-3{background-color:#b39ddb!important;border-color:#b39ddb!important}.v-application .deep-purple--text.text--lighten-3{color:#b39ddb!important;caret-color:#b39ddb!important}.v-application .deep-purple.lighten-2{background-color:#9575cd!important;border-color:#9575cd!important}.v-application .deep-purple--text.text--lighten-2{color:#9575cd!important;caret-color:#9575cd!important}.v-application .deep-purple.lighten-1{background-color:#7e57c2!important;border-color:#7e57c2!important}.v-application .deep-purple--text.text--lighten-1{color:#7e57c2!important;caret-color:#7e57c2!important}.v-application .deep-purple.darken-1{background-color:#5e35b1!important;border-color:#5e35b1!important}.v-application .deep-purple--text.text--darken-1{color:#5e35b1!important;caret-color:#5e35b1!important}.v-application .deep-purple.darken-2{background-color:#512da8!important;border-color:#512da8!important}.v-application .deep-purple--text.text--darken-2{color:#512da8!important;caret-color:#512da8!important}.v-application .deep-purple.darken-3{background-color:#4527a0!important;border-color:#4527a0!important}.v-application .deep-purple--text.text--darken-3{color:#4527a0!important;caret-color:#4527a0!important}.v-application .deep-purple.darken-4{background-color:#311b92!important;border-color:#311b92!important}.v-application .deep-purple--text.text--darken-4{color:#311b92!important;caret-color:#311b92!important}.v-application .deep-purple.accent-1{background-color:#b388ff!important;border-color:#b388ff!important}.v-application .deep-purple--text.text--accent-1{color:#b388ff!important;caret-color:#b388ff!important}.v-application .deep-purple.accent-2{background-color:#7c4dff!important;border-color:#7c4dff!important}.v-application .deep-purple--text.text--accent-2{color:#7c4dff!important;caret-color:#7c4dff!important}.v-application .deep-purple.accent-3{background-color:#651fff!important;border-color:#651fff!important}.v-application .deep-purple--text.text--accent-3{color:#651fff!important;caret-color:#651fff!important}.v-application .deep-purple.accent-4{background-color:#6200ea!important;border-color:#6200ea!important}.v-application .deep-purple--text.text--accent-4{color:#6200ea!important;caret-color:#6200ea!important}.v-application .indigo{background-color:#3f51b5!important;border-color:#3f51b5!important}.v-application .indigo--text{color:#3f51b5!important;caret-color:#3f51b5!important}.v-application .indigo.lighten-5{background-color:#e8eaf6!important;border-color:#e8eaf6!important}.v-application .indigo--text.text--lighten-5{color:#e8eaf6!important;caret-color:#e8eaf6!important}.v-application .indigo.lighten-4{background-color:#c5cae9!important;border-color:#c5cae9!important}.v-application .indigo--text.text--lighten-4{color:#c5cae9!important;caret-color:#c5cae9!important}.v-application .indigo.lighten-3{background-color:#9fa8da!important;border-color:#9fa8da!important}.v-application .indigo--text.text--lighten-3{color:#9fa8da!important;caret-color:#9fa8da!important}.v-application .indigo.lighten-2{background-color:#7986cb!important;border-color:#7986cb!important}.v-application .indigo--text.text--lighten-2{color:#7986cb!important;caret-color:#7986cb!important}.v-application .indigo.lighten-1{background-color:#5c6bc0!important;border-color:#5c6bc0!important}.v-application .indigo--text.text--lighten-1{color:#5c6bc0!important;caret-color:#5c6bc0!important}.v-application .indigo.darken-1{background-color:#3949ab!important;border-color:#3949ab!important}.v-application .indigo--text.text--darken-1{color:#3949ab!important;caret-color:#3949ab!important}.v-application .indigo.darken-2{background-color:#303f9f!important;border-color:#303f9f!important}.v-application .indigo--text.text--darken-2{color:#303f9f!important;caret-color:#303f9f!important}.v-application .indigo.darken-3{background-color:#283593!important;border-color:#283593!important}.v-application .indigo--text.text--darken-3{color:#283593!important;caret-color:#283593!important}.v-application .indigo.darken-4{background-color:#1a237e!important;border-color:#1a237e!important}.v-application .indigo--text.text--darken-4{color:#1a237e!important;caret-color:#1a237e!important}.v-application .indigo.accent-1{background-color:#8c9eff!important;border-color:#8c9eff!important}.v-application .indigo--text.text--accent-1{color:#8c9eff!important;caret-color:#8c9eff!important}.v-application .indigo.accent-2{background-color:#536dfe!important;border-color:#536dfe!important}.v-application .indigo--text.text--accent-2{color:#536dfe!important;caret-color:#536dfe!important}.v-application .indigo.accent-3{background-color:#3d5afe!important;border-color:#3d5afe!important}.v-application .indigo--text.text--accent-3{color:#3d5afe!important;caret-color:#3d5afe!important}.v-application .indigo.accent-4{background-color:#304ffe!important;border-color:#304ffe!important}.v-application .indigo--text.text--accent-4{color:#304ffe!important;caret-color:#304ffe!important}.v-application .blue{background-color:#079cb2!important;border-color:#079cb2!important}.v-application .blue--text{color:#079cb2!important;caret-color:#079cb2!important}.v-application .blue.lighten-5{background-color:#e6f5f7!important;border-color:#e6f5f7!important}.v-application .blue--text.text--lighten-5{color:#e6f5f7!important;caret-color:#e6f5f7!important}.v-application .blue.lighten-4{background-color:#83cdd9!important;border-color:#83cdd9!important}.v-application .blue--text.text--lighten-4{color:#83cdd9!important;caret-color:#83cdd9!important}.v-application .blue.lighten-3{background-color:#90caf9!important;border-color:#90caf9!important}.v-application .blue--text.text--lighten-3{color:#90caf9!important;caret-color:#90caf9!important}.v-application .blue.lighten-2{background-color:#64b5f6!important;border-color:#64b5f6!important}.v-application .blue--text.text--lighten-2{color:#64b5f6!important;caret-color:#64b5f6!important}.v-application .blue.lighten-1{background-color:#42a5f5!important;border-color:#42a5f5!important}.v-application .blue--text.text--lighten-1{color:#42a5f5!important;caret-color:#42a5f5!important}.v-application .blue.darken-1{background-color:#067889!important;border-color:#067889!important}.v-application .blue--text.text--darken-1{color:#067889!important;caret-color:#067889!important}.v-application .blue.darken-2{background-color:#067889!important;border-color:#067889!important}.v-application .blue--text.text--darken-2{color:#067889!important;caret-color:#067889!important}.v-application .blue.darken-3{background-color:#1565c0!important;border-color:#1565c0!important}.v-application .blue--text.text--darken-3{color:#1565c0!important;caret-color:#1565c0!important}.v-application .blue.darken-4{background-color:#0d47a1!important;border-color:#0d47a1!important}.v-application .blue--text.text--darken-4{color:#0d47a1!important;caret-color:#0d47a1!important}.v-application .blue.accent-1{background-color:#067889!important;border-color:#067889!important}.v-application .blue--text.text--accent-1{color:#067889!important;caret-color:#067889!important}.v-application .blue.accent-2{background-color:#448aff!important;border-color:#448aff!important}.v-application .blue--text.text--accent-2{color:#448aff!important;caret-color:#448aff!important}.v-application .blue.accent-3{background-color:#2979ff!important;border-color:#2979ff!important}.v-application .blue--text.text--accent-3{color:#2979ff!important;caret-color:#2979ff!important}.v-application .blue.accent-4{background-color:#2962ff!important;border-color:#2962ff!important}.v-application .blue--text.text--accent-4{color:#2962ff!important;caret-color:#2962ff!important}.v-application .light-blue{background-color:#03a9f4!important;border-color:#03a9f4!important}.v-application .light-blue--text{color:#03a9f4!important;caret-color:#03a9f4!important}.v-application .light-blue.lighten-5{background-color:#e1f5fe!important;border-color:#e1f5fe!important}.v-application .light-blue--text.text--lighten-5{color:#e1f5fe!important;caret-color:#e1f5fe!important}.v-application .light-blue.lighten-4{background-color:#b3e5fc!important;border-color:#b3e5fc!important}.v-application .light-blue--text.text--lighten-4{color:#b3e5fc!important;caret-color:#b3e5fc!important}.v-application .light-blue.lighten-3{background-color:#81d4fa!important;border-color:#81d4fa!important}.v-application .light-blue--text.text--lighten-3{color:#81d4fa!important;caret-color:#81d4fa!important}.v-application .light-blue.lighten-2{background-color:#4fc3f7!important;border-color:#4fc3f7!important}.v-application .light-blue--text.text--lighten-2{color:#4fc3f7!important;caret-color:#4fc3f7!important}.v-application .light-blue.lighten-1{background-color:#29b6f6!important;border-color:#29b6f6!important}.v-application .light-blue--text.text--lighten-1{color:#29b6f6!important;caret-color:#29b6f6!important}.v-application .light-blue.darken-1{background-color:#039be5!important;border-color:#039be5!important}.v-application .light-blue--text.text--darken-1{color:#039be5!important;caret-color:#039be5!important}.v-application .light-blue.darken-2{background-color:#0288d1!important;border-color:#0288d1!important}.v-application .light-blue--text.text--darken-2{color:#0288d1!important;caret-color:#0288d1!important}.v-application .light-blue.darken-3{background-color:#0277bd!important;border-color:#0277bd!important}.v-application .light-blue--text.text--darken-3{color:#0277bd!important;caret-color:#0277bd!important}.v-application .light-blue.darken-4{background-color:#01579b!important;border-color:#01579b!important}.v-application .light-blue--text.text--darken-4{color:#01579b!important;caret-color:#01579b!important}.v-application .light-blue.accent-1{background-color:#80d8ff!important;border-color:#80d8ff!important}.v-application .light-blue--text.text--accent-1{color:#80d8ff!important;caret-color:#80d8ff!important}.v-application .light-blue.accent-2{background-color:#40c4ff!important;border-color:#40c4ff!important}.v-application .light-blue--text.text--accent-2{color:#40c4ff!important;caret-color:#40c4ff!important}.v-application .light-blue.accent-3{background-color:#00b0ff!important;border-color:#00b0ff!important}.v-application .light-blue--text.text--accent-3{color:#00b0ff!important;caret-color:#00b0ff!important}.v-application .light-blue.accent-4{background-color:#0091ea!important;border-color:#0091ea!important}.v-application .light-blue--text.text--accent-4{color:#0091ea!important;caret-color:#0091ea!important}.v-application .cyan{background-color:#00bcd4!important;border-color:#00bcd4!important}.v-application .cyan--text{color:#00bcd4!important;caret-color:#00bcd4!important}.v-application .cyan.lighten-5{background-color:#e0f7fa!important;border-color:#e0f7fa!important}.v-application .cyan--text.text--lighten-5{color:#e0f7fa!important;caret-color:#e0f7fa!important}.v-application .cyan.lighten-4{background-color:#b2ebf2!important;border-color:#b2ebf2!important}.v-application .cyan--text.text--lighten-4{color:#b2ebf2!important;caret-color:#b2ebf2!important}.v-application .cyan.lighten-3{background-color:#80deea!important;border-color:#80deea!important}.v-application .cyan--text.text--lighten-3{color:#80deea!important;caret-color:#80deea!important}.v-application .cyan.lighten-2{background-color:#4dd0e1!important;border-color:#4dd0e1!important}.v-application .cyan--text.text--lighten-2{color:#4dd0e1!important;caret-color:#4dd0e1!important}.v-application .cyan.lighten-1{background-color:#26c6da!important;border-color:#26c6da!important}.v-application .cyan--text.text--lighten-1{color:#26c6da!important;caret-color:#26c6da!important}.v-application .cyan.darken-1{background-color:#00acc1!important;border-color:#00acc1!important}.v-application .cyan--text.text--darken-1{color:#00acc1!important;caret-color:#00acc1!important}.v-application .cyan.darken-2{background-color:#0097a7!important;border-color:#0097a7!important}.v-application .cyan--text.text--darken-2{color:#0097a7!important;caret-color:#0097a7!important}.v-application .cyan.darken-3{background-color:#00838f!important;border-color:#00838f!important}.v-application .cyan--text.text--darken-3{color:#00838f!important;caret-color:#00838f!important}.v-application .cyan.darken-4{background-color:#006064!important;border-color:#006064!important}.v-application .cyan--text.text--darken-4{color:#006064!important;caret-color:#006064!important}.v-application .cyan.accent-1{background-color:#84ffff!important;border-color:#84ffff!important}.v-application .cyan--text.text--accent-1{color:#84ffff!important;caret-color:#84ffff!important}.v-application .cyan.accent-2{background-color:#18ffff!important;border-color:#18ffff!important}.v-application .cyan--text.text--accent-2{color:#18ffff!important;caret-color:#18ffff!important}.v-application .cyan.accent-3{background-color:#00e5ff!important;border-color:#00e5ff!important}.v-application .cyan--text.text--accent-3{color:#00e5ff!important;caret-color:#00e5ff!important}.v-application .cyan.accent-4{background-color:#00b8d4!important;border-color:#00b8d4!important}.v-application .cyan--text.text--accent-4{color:#00b8d4!important;caret-color:#00b8d4!important}.v-application .teal{background-color:#009688!important;border-color:#009688!important}.v-application .teal--text{color:#009688!important;caret-color:#009688!important}.v-application .teal.lighten-5{background-color:#e0f2f1!important;border-color:#e0f2f1!important}.v-application .teal--text.text--lighten-5{color:#e0f2f1!important;caret-color:#e0f2f1!important}.v-application .teal.lighten-4{background-color:#b2dfdb!important;border-color:#b2dfdb!important}.v-application .teal--text.text--lighten-4{color:#b2dfdb!important;caret-color:#b2dfdb!important}.v-application .teal.lighten-3{background-color:#80cbc4!important;border-color:#80cbc4!important}.v-application .teal--text.text--lighten-3{color:#80cbc4!important;caret-color:#80cbc4!important}.v-application .teal.lighten-2{background-color:#4db6ac!important;border-color:#4db6ac!important}.v-application .teal--text.text--lighten-2{color:#4db6ac!important;caret-color:#4db6ac!important}.v-application .teal.lighten-1{background-color:#26a69a!important;border-color:#26a69a!important}.v-application .teal--text.text--lighten-1{color:#26a69a!important;caret-color:#26a69a!important}.v-application .teal.darken-1{background-color:#00897b!important;border-color:#00897b!important}.v-application .teal--text.text--darken-1{color:#00897b!important;caret-color:#00897b!important}.v-application .teal.darken-2{background-color:#00796b!important;border-color:#00796b!important}.v-application .teal--text.text--darken-2{color:#00796b!important;caret-color:#00796b!important}.v-application .teal.darken-3{background-color:#00695c!important;border-color:#00695c!important}.v-application .teal--text.text--darken-3{color:#00695c!important;caret-color:#00695c!important}.v-application .teal.darken-4{background-color:#004d40!important;border-color:#004d40!important}.v-application .teal--text.text--darken-4{color:#004d40!important;caret-color:#004d40!important}.v-application .teal.accent-1{background-color:#a7ffeb!important;border-color:#a7ffeb!important}.v-application .teal--text.text--accent-1{color:#a7ffeb!important;caret-color:#a7ffeb!important}.v-application .teal.accent-2{background-color:#64ffda!important;border-color:#64ffda!important}.v-application .teal--text.text--accent-2{color:#64ffda!important;caret-color:#64ffda!important}.v-application .teal.accent-3{background-color:#1de9b6!important;border-color:#1de9b6!important}.v-application .teal--text.text--accent-3{color:#1de9b6!important;caret-color:#1de9b6!important}.v-application .teal.accent-4{background-color:#00bfa5!important;border-color:#00bfa5!important}.v-application .teal--text.text--accent-4{color:#00bfa5!important;caret-color:#00bfa5!important}.v-application .green{background-color:#3fa266!important;border-color:#3fa266!important}.v-application .green--text{color:#3fa266!important;caret-color:#3fa266!important}.v-application .green.lighten-5{background-color:#f0faf2!important;border-color:#f0faf2!important}.v-application .green--text.text--lighten-5{color:#f0faf2!important;caret-color:#f0faf2!important}.v-application .green.lighten-4{background-color:#c8e6c9!important;border-color:#c8e6c9!important}.v-application .green--text.text--lighten-4{color:#c8e6c9!important;caret-color:#c8e6c9!important}.v-application .green.lighten-3{background-color:#a5d6a7!important;border-color:#a5d6a7!important}.v-application .green--text.text--lighten-3{color:#a5d6a7!important;caret-color:#a5d6a7!important}.v-application .green.lighten-2{background-color:#81c784!important;border-color:#81c784!important}.v-application .green--text.text--lighten-2{color:#81c784!important;caret-color:#81c784!important}.v-application .green.lighten-1{background-color:#66bb6a!important;border-color:#66bb6a!important}.v-application .green--text.text--lighten-1{color:#66bb6a!important;caret-color:#66bb6a!important}.v-application .green.darken-1{background-color:#1d6b45!important;border-color:#1d6b45!important}.v-application .green--text.text--darken-1{color:#1d6b45!important;caret-color:#1d6b45!important}.v-application .green.darken-2{background-color:#1d6b45!important;border-color:#1d6b45!important}.v-application .green--text.text--darken-2{color:#1d6b45!important;caret-color:#1d6b45!important}.v-application .green.darken-3{background-color:#2e7d32!important;border-color:#2e7d32!important}.v-application .green--text.text--darken-3{color:#2e7d32!important;caret-color:#2e7d32!important}.v-application .green.darken-4{background-color:#1b5e20!important;border-color:#1b5e20!important}.v-application .green--text.text--darken-4{color:#1b5e20!important;caret-color:#1b5e20!important}.v-application .green.accent-1{background-color:#1d6b45!important;border-color:#1d6b45!important}.v-application .green--text.text--accent-1{color:#1d6b45!important;caret-color:#1d6b45!important}.v-application .green.accent-2{background-color:#69f0ae!important;border-color:#69f0ae!important}.v-application .green--text.text--accent-2{color:#69f0ae!important;caret-color:#69f0ae!important}.v-application .green.accent-3{background-color:#00e676!important;border-color:#00e676!important}.v-application .green--text.text--accent-3{color:#00e676!important;caret-color:#00e676!important}.v-application .green.accent-4{background-color:#00c853!important;border-color:#00c853!important}.v-application .green--text.text--accent-4{color:#00c853!important;caret-color:#00c853!important}.v-application .light-green{background-color:#8bc34a!important;border-color:#8bc34a!important}.v-application .light-green--text{color:#8bc34a!important;caret-color:#8bc34a!important}.v-application .light-green.lighten-5{background-color:#f1f8e9!important;border-color:#f1f8e9!important}.v-application .light-green--text.text--lighten-5{color:#f1f8e9!important;caret-color:#f1f8e9!important}.v-application .light-green.lighten-4{background-color:#dcedc8!important;border-color:#dcedc8!important}.v-application .light-green--text.text--lighten-4{color:#dcedc8!important;caret-color:#dcedc8!important}.v-application .light-green.lighten-3{background-color:#c5e1a5!important;border-color:#c5e1a5!important}.v-application .light-green--text.text--lighten-3{color:#c5e1a5!important;caret-color:#c5e1a5!important}.v-application .light-green.lighten-2{background-color:#aed581!important;border-color:#aed581!important}.v-application .light-green--text.text--lighten-2{color:#aed581!important;caret-color:#aed581!important}.v-application .light-green.lighten-1{background-color:#9ccc65!important;border-color:#9ccc65!important}.v-application .light-green--text.text--lighten-1{color:#9ccc65!important;caret-color:#9ccc65!important}.v-application .light-green.darken-1{background-color:#7cb342!important;border-color:#7cb342!important}.v-application .light-green--text.text--darken-1{color:#7cb342!important;caret-color:#7cb342!important}.v-application .light-green.darken-2{background-color:#689f38!important;border-color:#689f38!important}.v-application .light-green--text.text--darken-2{color:#689f38!important;caret-color:#689f38!important}.v-application .light-green.darken-3{background-color:#558b2f!important;border-color:#558b2f!important}.v-application .light-green--text.text--darken-3{color:#558b2f!important;caret-color:#558b2f!important}.v-application .light-green.darken-4{background-color:#33691e!important;border-color:#33691e!important}.v-application .light-green--text.text--darken-4{color:#33691e!important;caret-color:#33691e!important}.v-application .light-green.accent-1{background-color:#ccff90!important;border-color:#ccff90!important}.v-application .light-green--text.text--accent-1{color:#ccff90!important;caret-color:#ccff90!important}.v-application .light-green.accent-2{background-color:#b2ff59!important;border-color:#b2ff59!important}.v-application .light-green--text.text--accent-2{color:#b2ff59!important;caret-color:#b2ff59!important}.v-application .light-green.accent-3{background-color:#76ff03!important;border-color:#76ff03!important}.v-application .light-green--text.text--accent-3{color:#76ff03!important;caret-color:#76ff03!important}.v-application .light-green.accent-4{background-color:#64dd17!important;border-color:#64dd17!important}.v-application .light-green--text.text--accent-4{color:#64dd17!important;caret-color:#64dd17!important}.v-application .lime{background-color:#cddc39!important;border-color:#cddc39!important}.v-application .lime--text{color:#cddc39!important;caret-color:#cddc39!important}.v-application .lime.lighten-5{background-color:#f9fbe7!important;border-color:#f9fbe7!important}.v-application .lime--text.text--lighten-5{color:#f9fbe7!important;caret-color:#f9fbe7!important}.v-application .lime.lighten-4{background-color:#f0f4c3!important;border-color:#f0f4c3!important}.v-application .lime--text.text--lighten-4{color:#f0f4c3!important;caret-color:#f0f4c3!important}.v-application .lime.lighten-3{background-color:#e6ee9c!important;border-color:#e6ee9c!important}.v-application .lime--text.text--lighten-3{color:#e6ee9c!important;caret-color:#e6ee9c!important}.v-application .lime.lighten-2{background-color:#dce775!important;border-color:#dce775!important}.v-application .lime--text.text--lighten-2{color:#dce775!important;caret-color:#dce775!important}.v-application .lime.lighten-1{background-color:#d4e157!important;border-color:#d4e157!important}.v-application .lime--text.text--lighten-1{color:#d4e157!important;caret-color:#d4e157!important}.v-application .lime.darken-1{background-color:#c0ca33!important;border-color:#c0ca33!important}.v-application .lime--text.text--darken-1{color:#c0ca33!important;caret-color:#c0ca33!important}.v-application .lime.darken-2{background-color:#afb42b!important;border-color:#afb42b!important}.v-application .lime--text.text--darken-2{color:#afb42b!important;caret-color:#afb42b!important}.v-application .lime.darken-3{background-color:#9e9d24!important;border-color:#9e9d24!important}.v-application .lime--text.text--darken-3{color:#9e9d24!important;caret-color:#9e9d24!important}.v-application .lime.darken-4{background-color:#827717!important;border-color:#827717!important}.v-application .lime--text.text--darken-4{color:#827717!important;caret-color:#827717!important}.v-application .lime.accent-1{background-color:#f4ff81!important;border-color:#f4ff81!important}.v-application .lime--text.text--accent-1{color:#f4ff81!important;caret-color:#f4ff81!important}.v-application .lime.accent-2{background-color:#eeff41!important;border-color:#eeff41!important}.v-application .lime--text.text--accent-2{color:#eeff41!important;caret-color:#eeff41!important}.v-application .lime.accent-3{background-color:#c6ff00!important;border-color:#c6ff00!important}.v-application .lime--text.text--accent-3{color:#c6ff00!important;caret-color:#c6ff00!important}.v-application .lime.accent-4{background-color:#aeea00!important;border-color:#aeea00!important}.v-application .lime--text.text--accent-4{color:#aeea00!important;caret-color:#aeea00!important}.v-application .yellow{background-color:#fcde73!important;border-color:#fcde73!important}.v-application .yellow--text{color:#fcde73!important;caret-color:#fcde73!important}.v-application .yellow.lighten-5{background-color:#fef5d5!important;border-color:#fef5d5!important}.v-application .yellow--text.text--lighten-5{color:#fef5d5!important;caret-color:#fef5d5!important}.v-application .yellow.lighten-4{background-color:#fff9c4!important;border-color:#fff9c4!important}.v-application .yellow--text.text--lighten-4{color:#fff9c4!important;caret-color:#fff9c4!important}.v-application .yellow.lighten-3{background-color:#fff59d!important;border-color:#fff59d!important}.v-application .yellow--text.text--lighten-3{color:#fff59d!important;caret-color:#fff59d!important}.v-application .yellow.lighten-2{background-color:#fff176!important;border-color:#fff176!important}.v-application .yellow--text.text--lighten-2{color:#fff176!important;caret-color:#fff176!important}.v-application .yellow.lighten-1{background-color:#ffee58!important;border-color:#ffee58!important}.v-application .yellow--text.text--lighten-1{color:#ffee58!important;caret-color:#ffee58!important}.v-application .yellow.darken-1{background-color:#f2ba2a!important;border-color:#f2ba2a!important}.v-application .yellow--text.text--darken-1{color:#f2ba2a!important;caret-color:#f2ba2a!important}.v-application .yellow.darken-2{background-color:#f2ba2a!important;border-color:#f2ba2a!important}.v-application .yellow--text.text--darken-2{color:#f2ba2a!important;caret-color:#f2ba2a!important}.v-application .yellow.darken-3{background-color:#f9a825!important;border-color:#f9a825!important}.v-application .yellow--text.text--darken-3{color:#f9a825!important;caret-color:#f9a825!important}.v-application .yellow.darken-4{background-color:#f57f17!important;border-color:#f57f17!important}.v-application .yellow--text.text--darken-4{color:#f57f17!important;caret-color:#f57f17!important}.v-application .yellow.accent-1{background-color:#f2ba2a!important;border-color:#f2ba2a!important}.v-application .yellow--text.text--accent-1{color:#f2ba2a!important;caret-color:#f2ba2a!important}.v-application .yellow.accent-2{background-color:#ff0!important;border-color:#ff0!important}.v-application .yellow--text.text--accent-2{color:#ff0!important;caret-color:#ff0!important}.v-application .yellow.accent-3{background-color:#ffea00!important;border-color:#ffea00!important}.v-application .yellow--text.text--accent-3{color:#ffea00!important;caret-color:#ffea00!important}.v-application .yellow.accent-4{background-color:#ffd600!important;border-color:#ffd600!important}.v-application .yellow--text.text--accent-4{color:#ffd600!important;caret-color:#ffd600!important}.v-application .amber{background-color:#ffc107!important;border-color:#ffc107!important}.v-application .amber--text{color:#ffc107!important;caret-color:#ffc107!important}.v-application .amber.lighten-5{background-color:#fff8e1!important;border-color:#fff8e1!important}.v-application .amber--text.text--lighten-5{color:#fff8e1!important;caret-color:#fff8e1!important}.v-application .amber.lighten-4{background-color:#ffecb3!important;border-color:#ffecb3!important}.v-application .amber--text.text--lighten-4{color:#ffecb3!important;caret-color:#ffecb3!important}.v-application .amber.lighten-3{background-color:#ffe082!important;border-color:#ffe082!important}.v-application .amber--text.text--lighten-3{color:#ffe082!important;caret-color:#ffe082!important}.v-application .amber.lighten-2{background-color:#ffd54f!important;border-color:#ffd54f!important}.v-application .amber--text.text--lighten-2{color:#ffd54f!important;caret-color:#ffd54f!important}.v-application .amber.lighten-1{background-color:#ffca28!important;border-color:#ffca28!important}.v-application .amber--text.text--lighten-1{color:#ffca28!important;caret-color:#ffca28!important}.v-application .amber.darken-1{background-color:#ffb300!important;border-color:#ffb300!important}.v-application .amber--text.text--darken-1{color:#ffb300!important;caret-color:#ffb300!important}.v-application .amber.darken-2{background-color:#ffa000!important;border-color:#ffa000!important}.v-application .amber--text.text--darken-2{color:#ffa000!important;caret-color:#ffa000!important}.v-application .amber.darken-3{background-color:#ff8f00!important;border-color:#ff8f00!important}.v-application .amber--text.text--darken-3{color:#ff8f00!important;caret-color:#ff8f00!important}.v-application .amber.darken-4{background-color:#ff6f00!important;border-color:#ff6f00!important}.v-application .amber--text.text--darken-4{color:#ff6f00!important;caret-color:#ff6f00!important}.v-application .amber.accent-1{background-color:#ffe57f!important;border-color:#ffe57f!important}.v-application .amber--text.text--accent-1{color:#ffe57f!important;caret-color:#ffe57f!important}.v-application .amber.accent-2{background-color:#ffd740!important;border-color:#ffd740!important}.v-application .amber--text.text--accent-2{color:#ffd740!important;caret-color:#ffd740!important}.v-application .amber.accent-3{background-color:#ffc400!important;border-color:#ffc400!important}.v-application .amber--text.text--accent-3{color:#ffc400!important;caret-color:#ffc400!important}.v-application .amber.accent-4{background-color:#ffab00!important;border-color:#ffab00!important}.v-application .amber--text.text--accent-4{color:#ffab00!important;caret-color:#ffab00!important}.v-application .orange{background-color:#ff8d6e!important;border-color:#ff8d6e!important}.v-application .orange--text{color:#ff8d6e!important;caret-color:#ff8d6e!important}.v-application .orange.lighten-5{background-color:#f6f3eb!important;border-color:#f6f3eb!important}.v-application .orange--text.text--lighten-5{color:#f6f3eb!important;caret-color:#f6f3eb!important}.v-application .orange.lighten-4{background-color:#ffe0b2!important;border-color:#ffe0b2!important}.v-application .orange--text.text--lighten-4{color:#ffe0b2!important;caret-color:#ffe0b2!important}.v-application .orange.lighten-3{background-color:#ffcc80!important;border-color:#ffcc80!important}.v-application .orange--text.text--lighten-3{color:#ffcc80!important;caret-color:#ffcc80!important}.v-application .orange.lighten-2{background-color:#ffb74d!important;border-color:#ffb74d!important}.v-application .orange--text.text--lighten-2{color:#ffb74d!important;caret-color:#ffb74d!important}.v-application .orange.lighten-1{background-color:#ffa726!important;border-color:#ffa726!important}.v-application .orange--text.text--lighten-1{color:#ffa726!important;caret-color:#ffa726!important}.v-application .orange.darken-1{background-color:#ff8d6e!important;border-color:#ff8d6e!important}.v-application .orange--text.text--darken-1{color:#ff8d6e!important;caret-color:#ff8d6e!important}.v-application .orange.darken-2{background-color:#ff8d6e!important;border-color:#ff8d6e!important}.v-application .orange--text.text--darken-2{color:#ff8d6e!important;caret-color:#ff8d6e!important}.v-application .orange.darken-3{background-color:#ef6c00!important;border-color:#ef6c00!important}.v-application .orange--text.text--darken-3{color:#ef6c00!important;caret-color:#ef6c00!important}.v-application .orange.darken-4{background-color:#e65100!important;border-color:#e65100!important}.v-application .orange--text.text--darken-4{color:#e65100!important;caret-color:#e65100!important}.v-application .orange.accent-1{background-color:#ff8d6e!important;border-color:#ff8d6e!important}.v-application .orange--text.text--accent-1{color:#ff8d6e!important;caret-color:#ff8d6e!important}.v-application .orange.accent-2{background-color:#ffab40!important;border-color:#ffab40!important}.v-application .orange--text.text--accent-2{color:#ffab40!important;caret-color:#ffab40!important}.v-application .orange.accent-3{background-color:#ff9100!important;border-color:#ff9100!important}.v-application .orange--text.text--accent-3{color:#ff9100!important;caret-color:#ff9100!important}.v-application .orange.accent-4{background-color:#ff6d00!important;border-color:#ff6d00!important}.v-application .orange--text.text--accent-4{color:#ff6d00!important;caret-color:#ff6d00!important}.v-application .deep-orange{background-color:#ff5722!important;border-color:#ff5722!important}.v-application .deep-orange--text{color:#ff5722!important;caret-color:#ff5722!important}.v-application .deep-orange.lighten-5{background-color:#fbe9e7!important;border-color:#fbe9e7!important}.v-application .deep-orange--text.text--lighten-5{color:#fbe9e7!important;caret-color:#fbe9e7!important}.v-application .deep-orange.lighten-4{background-color:#ffccbc!important;border-color:#ffccbc!important}.v-application .deep-orange--text.text--lighten-4{color:#ffccbc!important;caret-color:#ffccbc!important}.v-application .deep-orange.lighten-3{background-color:#ffab91!important;border-color:#ffab91!important}.v-application .deep-orange--text.text--lighten-3{color:#ffab91!important;caret-color:#ffab91!important}.v-application .deep-orange.lighten-2{background-color:#ff8a65!important;border-color:#ff8a65!important}.v-application .deep-orange--text.text--lighten-2{color:#ff8a65!important;caret-color:#ff8a65!important}.v-application .deep-orange.lighten-1{background-color:#ff7043!important;border-color:#ff7043!important}.v-application .deep-orange--text.text--lighten-1{color:#ff7043!important;caret-color:#ff7043!important}.v-application .deep-orange.darken-1{background-color:#f4511e!important;border-color:#f4511e!important}.v-application .deep-orange--text.text--darken-1{color:#f4511e!important;caret-color:#f4511e!important}.v-application .deep-orange.darken-2{background-color:#e64a19!important;border-color:#e64a19!important}.v-application .deep-orange--text.text--darken-2{color:#e64a19!important;caret-color:#e64a19!important}.v-application .deep-orange.darken-3{background-color:#d84315!important;border-color:#d84315!important}.v-application .deep-orange--text.text--darken-3{color:#d84315!important;caret-color:#d84315!important}.v-application .deep-orange.darken-4{background-color:#bf360c!important;border-color:#bf360c!important}.v-application .deep-orange--text.text--darken-4{color:#bf360c!important;caret-color:#bf360c!important}.v-application .deep-orange.accent-1{background-color:#ff9e80!important;border-color:#ff9e80!important}.v-application .deep-orange--text.text--accent-1{color:#ff9e80!important;caret-color:#ff9e80!important}.v-application .deep-orange.accent-2{background-color:#ff6e40!important;border-color:#ff6e40!important}.v-application .deep-orange--text.text--accent-2{color:#ff6e40!important;caret-color:#ff6e40!important}.v-application .deep-orange.accent-3{background-color:#ff3d00!important;border-color:#ff3d00!important}.v-application .deep-orange--text.text--accent-3{color:#ff3d00!important;caret-color:#ff3d00!important}.v-application .deep-orange.accent-4{background-color:#dd2c00!important;border-color:#dd2c00!important}.v-application .deep-orange--text.text--accent-4{color:#dd2c00!important;caret-color:#dd2c00!important}.v-application .brown{background-color:#795548!important;border-color:#795548!important}.v-application .brown--text{color:#795548!important;caret-color:#795548!important}.v-application .brown.lighten-5{background-color:#efebe9!important;border-color:#efebe9!important}.v-application .brown--text.text--lighten-5{color:#efebe9!important;caret-color:#efebe9!important}.v-application .brown.lighten-4{background-color:#d7ccc8!important;border-color:#d7ccc8!important}.v-application .brown--text.text--lighten-4{color:#d7ccc8!important;caret-color:#d7ccc8!important}.v-application .brown.lighten-3{background-color:#bcaaa4!important;border-color:#bcaaa4!important}.v-application .brown--text.text--lighten-3{color:#bcaaa4!important;caret-color:#bcaaa4!important}.v-application .brown.lighten-2{background-color:#a1887f!important;border-color:#a1887f!important}.v-application .brown--text.text--lighten-2{color:#a1887f!important;caret-color:#a1887f!important}.v-application .brown.lighten-1{background-color:#8d6e63!important;border-color:#8d6e63!important}.v-application .brown--text.text--lighten-1{color:#8d6e63!important;caret-color:#8d6e63!important}.v-application .brown.darken-1{background-color:#6d4c41!important;border-color:#6d4c41!important}.v-application .brown--text.text--darken-1{color:#6d4c41!important;caret-color:#6d4c41!important}.v-application .brown.darken-2{background-color:#5d4037!important;border-color:#5d4037!important}.v-application .brown--text.text--darken-2{color:#5d4037!important;caret-color:#5d4037!important}.v-application .brown.darken-3{background-color:#4e342e!important;border-color:#4e342e!important}.v-application .brown--text.text--darken-3{color:#4e342e!important;caret-color:#4e342e!important}.v-application .brown.darken-4{background-color:#3e2723!important;border-color:#3e2723!important}.v-application .brown--text.text--darken-4{color:#3e2723!important;caret-color:#3e2723!important}.v-application .blue-grey{background-color:#607d8b!important;border-color:#607d8b!important}.v-application .blue-grey--text{color:#607d8b!important;caret-color:#607d8b!important}.v-application .blue-grey.lighten-5{background-color:#eceff1!important;border-color:#eceff1!important}.v-application .blue-grey--text.text--lighten-5{color:#eceff1!important;caret-color:#eceff1!important}.v-application .blue-grey.lighten-4{background-color:#cfd8dc!important;border-color:#cfd8dc!important}.v-application .blue-grey--text.text--lighten-4{color:#cfd8dc!important;caret-color:#cfd8dc!important}.v-application .blue-grey.lighten-3{background-color:#b0bec5!important;border-color:#b0bec5!important}.v-application .blue-grey--text.text--lighten-3{color:#b0bec5!important;caret-color:#b0bec5!important}.v-application .blue-grey.lighten-2{background-color:#90a4ae!important;border-color:#90a4ae!important}.v-application .blue-grey--text.text--lighten-2{color:#90a4ae!important;caret-color:#90a4ae!important}.v-application .blue-grey.lighten-1{background-color:#78909c!important;border-color:#78909c!important}.v-application .blue-grey--text.text--lighten-1{color:#78909c!important;caret-color:#78909c!important}.v-application .blue-grey.darken-1{background-color:#546e7a!important;border-color:#546e7a!important}.v-application .blue-grey--text.text--darken-1{color:#546e7a!important;caret-color:#546e7a!important}.v-application .blue-grey.darken-2{background-color:#455a64!important;border-color:#455a64!important}.v-application .blue-grey--text.text--darken-2{color:#455a64!important;caret-color:#455a64!important}.v-application .blue-grey.darken-3{background-color:#37474f!important;border-color:#37474f!important}.v-application .blue-grey--text.text--darken-3{color:#37474f!important;caret-color:#37474f!important}.v-application .blue-grey.darken-4{background-color:#263238!important;border-color:#263238!important}.v-application .blue-grey--text.text--darken-4{color:#263238!important;caret-color:#263238!important}.v-application .grey{background-color:#9a9a9a!important;border-color:#9a9a9a!important}.v-application .grey--text{color:#9a9a9a!important;caret-color:#9a9a9a!important}.v-application .grey.lighten-5{background-color:#fafafa!important;border-color:#fafafa!important}.v-application .grey--text.text--lighten-5{color:#fafafa!important;caret-color:#fafafa!important}.v-application .grey.lighten-4{background-color:#f6f6f6!important;border-color:#f6f6f6!important}.v-application .grey--text.text--lighten-4{color:#f6f6f6!important;caret-color:#f6f6f6!important}.v-application .grey.lighten-3{background-color:#f6f6f6!important;border-color:#f6f6f6!important}.v-application .grey--text.text--lighten-3{color:#f6f6f6!important;caret-color:#f6f6f6!important}.v-application .grey.lighten-2{background-color:#d6d6d6!important;border-color:#d6d6d6!important}.v-application .grey--text.text--lighten-2{color:#d6d6d6!important;caret-color:#d6d6d6!important}.v-application .grey.lighten-1{background-color:#9a9a9a!important;border-color:#9a9a9a!important}.v-application .grey--text.text--lighten-1{color:#9a9a9a!important;caret-color:#9a9a9a!important}.v-application .grey.darken-1{background-color:#545454!important;border-color:#545454!important}.v-application .grey--text.text--darken-1{color:#545454!important;caret-color:#545454!important}.v-application .grey.darken-2{background-color:#545454!important;border-color:#545454!important}.v-application .grey--text.text--darken-2{color:#545454!important;caret-color:#545454!important}.v-application .grey.darken-3{background-color:#2b2b2b!important;border-color:#2b2b2b!important}.v-application .grey--text.text--darken-3{color:#2b2b2b!important;caret-color:#2b2b2b!important}.v-application .grey.darken-4{background-color:#2b2b2b!important;border-color:#2b2b2b!important}.v-application .grey--text.text--darken-4{color:#2b2b2b!important;caret-color:#2b2b2b!important}.v-application .shades.black{background-color:#000!important;border-color:#000!important}.v-application .shades--text.text--black{color:#000!important;caret-color:#000!important}.v-application .shades.white{background-color:#fff!important;border-color:#fff!important}.v-application .shades--text.text--white{color:#fff!important;caret-color:#fff!important}.v-application .shades.transparent{background-color:transparent!important;border-color:transparent!important}.v-application .shades--text.text--transparent{color:transparent!important;caret-color:transparent!important}/*!\n * ress.css • v2.0.4\n * MIT License\n * github.com/filipelinhares/ress\n */html{box-sizing:border-box;overflow-y:scroll;-webkit-text-size-adjust:100%;word-break:normal;-moz-tab-size:4;-o-tab-size:4;tab-size:4}*,:after,:before{background-repeat:no-repeat;box-sizing:inherit}:after,:before{text-decoration:inherit;vertical-align:inherit}*{padding:0;margin:0}hr{overflow:visible;height:0}details,main{display:block}summary{display:list-item}small{font-size:80%}[hidden]{display:none}abbr[title]{border-bottom:none;text-decoration:underline;-webkit-text-decoration:underline dotted;text-decoration:underline dotted}a{background-color:transparent}a:active,a:hover{outline-width:0}code,kbd,pre,samp{font-family:monospace,monospace}pre{font-size:1em}b,strong{font-weight:bolder}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}input{border-radius:0}[disabled]{cursor:default}[type=number]::-webkit-inner-spin-button,[type=number]::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}[type=search]::-webkit-search-cancel-button,[type=search]::-webkit-search-decoration{-webkit-appearance:none}textarea{overflow:auto;resize:vertical}button,input,optgroup,select,textarea{font:inherit}optgroup{font-weight:700}button{overflow:visible}button,select{text-transform:none}[role=button],[type=button],[type=reset],[type=submit],button{cursor:pointer;color:inherit}[type=button]::-moz-focus-inner,[type=reset]::-moz-focus-inner,[type=submit]::-moz-focus-inner,button::-moz-focus-inner{border-style:none;padding:0}[type=button]::-moz-focus-inner,[type=reset]::-moz-focus-inner,[type=submit]::-moz-focus-inner,button:-moz-focusring{outline:1px dotted ButtonText}[type=reset],[type=submit],button,html [type=button]{-webkit-appearance:button}button,input,select,textarea{background-color:transparent;border-style:none}select{-moz-appearance:none;-webkit-appearance:none}select::-ms-expand{display:none}select::-ms-value{color:currentColor}legend{border:0;color:inherit;display:table;white-space:normal;max-width:100%}::-webkit-file-upload-button{-webkit-appearance:button;color:inherit;font:inherit}img{border-style:none}progress{vertical-align:baseline}@media screen{[hidden~=screen]{display:inherit}[hidden~=screen]:not(:active):not(:focus):not(:target){position:absolute!important;clip:rect(0 0 0 0)!important}}[aria-busy=true]{cursor:progress}[aria-controls]{cursor:pointer}[aria-disabled=true]{cursor:default}.v-application .elevation-24{box-shadow:0 11px 15px -7px transparent,0 24px 38px 3px transparent,0 9px 46px 8px rgba(0,0,0,.12)!important}.v-application .elevation-23{box-shadow:0 11px 14px -7px transparent,0 23px 36px 3px transparent,0 9px 44px 8px rgba(0,0,0,.12)!important}.v-application .elevation-22{box-shadow:0 10px 14px -6px transparent,0 22px 35px 3px transparent,0 8px 42px 7px rgba(0,0,0,.12)!important}.v-application .elevation-21{box-shadow:0 10px 13px -6px transparent,0 21px 33px 3px transparent,0 8px 40px 7px rgba(0,0,0,.12)!important}.v-application .elevation-20{box-shadow:0 10px 13px -6px transparent,0 20px 31px 3px transparent,0 8px 38px 7px rgba(0,0,0,.12)!important}.v-application .elevation-19{box-shadow:0 9px 12px -6px transparent,0 19px 29px 2px transparent,0 7px 36px 6px rgba(0,0,0,.12)!important}.v-application .elevation-18{box-shadow:0 9px 11px -5px transparent,0 18px 28px 2px transparent,0 7px 34px 6px rgba(0,0,0,.12)!important}.v-application .elevation-17{box-shadow:0 8px 11px -5px transparent,0 17px 26px 2px transparent,0 6px 32px 5px rgba(0,0,0,.12)!important}.v-application .elevation-16{box-shadow:0 8px 10px -5px transparent,0 16px 24px 2px transparent,0 6px 30px 5px rgba(0,0,0,.12)!important}.v-application .elevation-15{box-shadow:0 8px 9px -5px transparent,0 15px 22px 2px transparent,0 6px 28px 5px rgba(0,0,0,.12)!important}.v-application .elevation-14{box-shadow:0 7px 9px -4px transparent,0 14px 21px 2px transparent,0 5px 26px 4px rgba(0,0,0,.12)!important}.v-application .elevation-13{box-shadow:0 7px 8px -4px transparent,0 13px 19px 2px transparent,0 5px 24px 4px rgba(0,0,0,.12)!important}.v-application .elevation-12{box-shadow:0 7px 8px -4px transparent,0 12px 17px 2px transparent,0 5px 22px 4px rgba(0,0,0,.12)!important}.v-application .elevation-11{box-shadow:0 6px 7px -4px transparent,0 11px 15px 1px transparent,0 4px 20px 3px rgba(0,0,0,.12)!important}.v-application .elevation-10{box-shadow:0 6px 6px -3px transparent,0 10px 14px 1px transparent,0 4px 18px 3px rgba(0,0,0,.12)!important}.v-application .elevation-9{box-shadow:0 5px 6px -3px transparent,0 9px 12px 1px transparent,0 3px 16px 2px rgba(0,0,0,.12)!important}.v-application .elevation-8{box-shadow:0 5px 5px -3px transparent,0 8px 10px 1px transparent,0 3px 14px 2px rgba(0,0,0,.12)!important}.v-application .elevation-7{box-shadow:0 4px 5px -2px transparent,0 7px 10px 1px transparent,0 2px 16px 1px rgba(0,0,0,.12)!important}.v-application .elevation-6{box-shadow:0 3px 5px -1px transparent,0 6px 10px 0 transparent,0 1px 18px 0 rgba(0,0,0,.12)!important}.v-application .elevation-5{box-shadow:0 3px 5px -1px transparent,0 5px 8px 0 transparent,0 1px 14px 0 rgba(0,0,0,.12)!important}.v-application .elevation-4{box-shadow:0 2px 4px -1px transparent,0 4px 5px 0 transparent,0 1px 10px 0 rgba(0,0,0,.12)!important}.v-application .elevation-3{box-shadow:0 3px 3px -2px transparent,0 3px 4px 0 transparent,0 1px 8px 0 rgba(0,0,0,.12)!important}.v-application .elevation-2{box-shadow:0 3px 1px -2px transparent,0 2px 2px 0 transparent,0 1px 5px 0 rgba(0,0,0,.12)!important}.v-application .elevation-1{box-shadow:0 2px 1px -1px transparent,0 1px 1px 0 transparent,0 1px 3px 0 rgba(0,0,0,.12)!important}.v-application .elevation-0{box-shadow:0 0 0 0 transparent,0 0 0 0 transparent,0 0 0 0 rgba(0,0,0,.12)!important}.v-application .carousel-transition-enter{transform:translate(100%)}.v-application .carousel-transition-leave,.v-application .carousel-transition-leave-to{position:absolute;top:0;transform:translate(-100%)}.carousel-reverse-transition-enter{transform:translate(-100%)}.carousel-reverse-transition-leave,.carousel-reverse-transition-leave-to{position:absolute;top:0;transform:translate(100%)}.dialog-transition-enter,.dialog-transition-leave-to{transform:scale(.5);opacity:0}.dialog-transition-enter-to,.dialog-transition-leave{opacity:1}.dialog-bottom-transition-enter,.dialog-bottom-transition-leave-to{transform:translateY(100%)}.dialog-top-transition-enter,.dialog-top-transition-leave-to{transform:translateY(-100%)}.picker-reverse-transition-enter-active,.picker-reverse-transition-leave-active,.picker-transition-enter-active,.picker-transition-leave-active{transition:.3s cubic-bezier(0,0,.2,1)}.picker-reverse-transition-enter,.picker-reverse-transition-leave-to,.picker-transition-enter,.picker-transition-leave-to{opacity:0}.picker-reverse-transition-leave,.picker-reverse-transition-leave-active,.picker-reverse-transition-leave-to,.picker-transition-leave,.picker-transition-leave-active,.picker-transition-leave-to{position:absolute!important}.picker-transition-enter{transform:translateY(100%)}.picker-reverse-transition-enter,.picker-transition-leave-to{transform:translateY(-100%)}.picker-reverse-transition-leave-to{transform:translateY(100%)}.picker-title-transition-enter-to,.picker-title-transition-leave{transform:translate(0)}.picker-title-transition-enter{transform:translate(-100%)}.picker-title-transition-leave-to{opacity:0;transform:translate(100%)}.picker-title-transition-leave,.picker-title-transition-leave-active,.picker-title-transition-leave-to{position:absolute!important}.tab-transition-enter{transform:translate(100%)}.tab-transition-leave,.tab-transition-leave-active{position:absolute;top:0}.tab-transition-leave-to{position:absolute}.tab-reverse-transition-enter,.tab-transition-leave-to{transform:translate(-100%)}.tab-reverse-transition-leave,.tab-reverse-transition-leave-to{top:0;position:absolute;transform:translate(100%)}.expand-transition-enter-active,.expand-transition-leave-active{transition:.3s cubic-bezier(.25,.8,.5,1)!important}.expand-transition-move{transition:transform .6s}.expand-x-transition-enter-active,.expand-x-transition-leave-active{transition:.3s cubic-bezier(.25,.8,.5,1)!important}.expand-x-transition-move{transition:transform .6s}.scale-transition-enter-active,.scale-transition-leave-active{transition:.3s cubic-bezier(.25,.8,.5,1)!important}.scale-transition-move{transition:transform .6s}.scale-transition-enter,.scale-transition-leave,.scale-transition-leave-to{opacity:0;transform:scale(0)}.scale-rotate-transition-enter-active,.scale-rotate-transition-leave-active{transition:.3s cubic-bezier(.25,.8,.5,1)!important}.scale-rotate-transition-move{transition:transform .6s}.scale-rotate-transition-enter,.scale-rotate-transition-leave,.scale-rotate-transition-leave-to{opacity:0;transform:scale(0) rotate(-45deg)}.scale-rotate-reverse-transition-enter-active,.scale-rotate-reverse-transition-leave-active{transition:.3s cubic-bezier(.25,.8,.5,1)!important}.scale-rotate-reverse-transition-move{transition:transform .6s}.scale-rotate-reverse-transition-enter,.scale-rotate-reverse-transition-leave,.scale-rotate-reverse-transition-leave-to{opacity:0;transform:scale(0) rotate(45deg)}.message-transition-enter-active,.message-transition-leave-active{transition:.3s cubic-bezier(.25,.8,.5,1)!important}.message-transition-move{transition:transform .6s}.message-transition-enter,.message-transition-leave-to{opacity:0;transform:translateY(-15px)}.message-transition-leave,.message-transition-leave-active{position:absolute}.slide-y-transition-enter-active,.slide-y-transition-leave-active{transition:.3s cubic-bezier(.25,.8,.5,1)!important}.slide-y-transition-move{transition:transform .6s}.slide-y-transition-enter,.slide-y-transition-leave-to{opacity:0;transform:translateY(-15px)}.slide-y-reverse-transition-enter-active,.slide-y-reverse-transition-leave-active{transition:.3s cubic-bezier(.25,.8,.5,1)!important}.slide-y-reverse-transition-move{transition:transform .6s}.slide-y-reverse-transition-enter,.slide-y-reverse-transition-leave-to{opacity:0;transform:translateY(15px)}.scroll-y-transition-enter-active,.scroll-y-transition-leave-active{transition:.3s cubic-bezier(.25,.8,.5,1)!important}.scroll-y-transition-move{transition:transform .6s}.scroll-y-transition-enter,.scroll-y-transition-leave-to{opacity:0}.scroll-y-transition-enter{transform:translateY(-15px)}.scroll-y-transition-leave-to{transform:translateY(15px)}.scroll-y-reverse-transition-enter-active,.scroll-y-reverse-transition-leave-active{transition:.3s cubic-bezier(.25,.8,.5,1)!important}.scroll-y-reverse-transition-move{transition:transform .6s}.scroll-y-reverse-transition-enter,.scroll-y-reverse-transition-leave-to{opacity:0}.scroll-y-reverse-transition-enter{transform:translateY(15px)}.scroll-y-reverse-transition-leave-to{transform:translateY(-15px)}.scroll-x-transition-enter-active,.scroll-x-transition-leave-active{transition:.3s cubic-bezier(.25,.8,.5,1)!important}.scroll-x-transition-move{transition:transform .6s}.scroll-x-transition-enter,.scroll-x-transition-leave-to{opacity:0}.scroll-x-transition-enter{transform:translateX(-15px)}.scroll-x-transition-leave-to{transform:translateX(15px)}.scroll-x-reverse-transition-enter-active,.scroll-x-reverse-transition-leave-active{transition:.3s cubic-bezier(.25,.8,.5,1)!important}.scroll-x-reverse-transition-move{transition:transform .6s}.scroll-x-reverse-transition-enter,.scroll-x-reverse-transition-leave-to{opacity:0}.scroll-x-reverse-transition-enter{transform:translateX(15px)}.scroll-x-reverse-transition-leave-to{transform:translateX(-15px)}.slide-x-transition-enter-active,.slide-x-transition-leave-active{transition:.3s cubic-bezier(.25,.8,.5,1)!important}.slide-x-transition-move{transition:transform .6s}.slide-x-transition-enter,.slide-x-transition-leave-to{opacity:0;transform:translateX(-15px)}.slide-x-reverse-transition-enter-active,.slide-x-reverse-transition-leave-active{transition:.3s cubic-bezier(.25,.8,.5,1)!important}.slide-x-reverse-transition-move{transition:transform .6s}.slide-x-reverse-transition-enter,.slide-x-reverse-transition-leave-to{opacity:0;transform:translateX(15px)}.fade-transition-enter-active,.fade-transition-leave-active{transition:.3s cubic-bezier(.25,.8,.5,1)!important}.fade-transition-move{transition:transform .6s}.fade-transition-enter,.fade-transition-leave-to{opacity:0!important}.fab-transition-enter-active,.fab-transition-leave-active{transition:.3s cubic-bezier(.25,.8,.5,1)!important}.fab-transition-move{transition:transform .6s}.fab-transition-enter,.fab-transition-leave-to{transform:scale(0) rotate(-45deg)}.v-application .blockquote{padding:16px 0 16px 24px;font-size:18px;font-weight:300}.v-application code,.v-application kbd{border-radius:3px;font-size:85%;font-weight:400}.v-application code{padding:.2em .4em}.v-application kbd{padding:.2em .4rem;box-shadow:0 3px 1px -2px transparent,0 2px 2px 0 transparent,0 1px 5px 0 rgba(0,0,0,.12)}.theme--light.v-application code{background-color:rgba(0,0,0,.05);color:currentColor}.theme--light.v-application kbd{background:#212529;color:#fff}.theme--dark.v-application code{background-color:hsla(0,0%,100%,.1);color:currentColor}.theme--dark.v-application kbd{background:#212529;color:#fff}html{font-size:14px;overflow-x:hidden;text-rendering:optimizeLegibility;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;-webkit-tap-highlight-color:rgba(0,0,0,0)}html.overflow-y-hidden{overflow-y:hidden!important}.v-application{font-family:AkkuratLL,Helvetica,Arial,sans-serif;line-height:1.5}.v-application ::-ms-clear,.v-application ::-ms-reveal{display:none}.v-application .theme--light.heading{color:var(--pp-text-primary,#2b2b2b)}.v-application .theme--dark.heading{color:var(--pp-primary-button-text-color,#004852)}.v-application ol,.v-application ul{padding-left:24px}.v-application .display-4{font-size:2rem!important;font-weight:600;line-height:2.4285714286rem;letter-spacing:-.02em!important;font-family:AkkuratLL,Helvetica,Arial,sans-serif!important}.v-application .display-3{font-size:1.7142857143rem!important;line-height:2.2857142857rem}.v-application .display-2,.v-application .display-3{font-weight:600;letter-spacing:-.01em!important;font-family:AkkuratLL,Helvetica,Arial,sans-serif!important}.v-application .display-2{font-size:1.4285714286rem!important;line-height:2rem}.v-application .display-1{font-size:1.2857142857rem!important}.v-application .display-1,.v-application .headline{font-weight:600;line-height:1.7142857143rem;letter-spacing:-.01em!important;font-family:AkkuratLL,Helvetica,Arial,sans-serif!important}.v-application .headline{font-size:1.1428571429rem!important}.v-application .title{font-size:1rem!important;font-weight:500;line-height:1.4285714286rem;letter-spacing:normal!important;font-family:AkkuratLL,Helvetica,Arial,sans-serif!important}.v-application .subtitle-2{font-size:.7142857143rem!important}.v-application .subtitle-1,.v-application .subtitle-2{font-weight:400;letter-spacing:normal!important;line-height:1.1428571429rem;font-family:AkkuratLL,Helvetica,Arial,sans-serif!important}.v-application .subtitle-1{font-size:.8571428571rem!important}.v-application .body-2{font-size:1rem!important;letter-spacing:-.02em!important;line-height:1.4285714286rem}.v-application .body-1,.v-application .body-2{font-weight:400;font-family:AkkuratLL,Helvetica,Arial,sans-serif!important}.v-application .body-1{font-size:1.1428571429rem!important;letter-spacing:normal!important;line-height:1.7142857143rem}.v-application .caption{font-weight:400;letter-spacing:.0333333333em!important;line-height:1.25rem}.v-application .caption,.v-application .overline{font-size:.75rem!important;font-family:AkkuratLL,Helvetica,Arial,sans-serif!important}.v-application .overline{font-weight:500;letter-spacing:.1666666667em!important;line-height:2rem;text-transform:uppercase}.v-application p{margin-bottom:16px}@media only print{.v-application .hidden-print-only{display:none!important}}@media only screen{.v-application .hidden-screen-only{display:none!important}}@media only screen and (max-width:599px){.v-application .hidden-xs-only{display:none!important}}@media only screen and (min-width:600px)and (max-width:959px){.v-application .hidden-sm-only{display:none!important}}@media only screen and (max-width:959px){.v-application .hidden-sm-and-down{display:none!important}}@media only screen and (min-width:600px){.v-application .hidden-sm-and-up{display:none!important}}@media only screen and (min-width:960px)and (max-width:1263px){.v-application .hidden-md-only{display:none!important}}@media only screen and (max-width:1263px){.v-application .hidden-md-and-down{display:none!important}}@media only screen and (min-width:960px){.v-application .hidden-md-and-up{display:none!important}}@media only screen and (min-width:1264px)and (max-width:1903px){.v-application .hidden-lg-only{display:none!important}}@media only screen and (max-width:1903px){.v-application .hidden-lg-and-down{display:none!important}}@media only screen and (min-width:1264px){.v-application .hidden-lg-and-up{display:none!important}}@media only screen and (min-width:1904px){.v-application .hidden-xl-only{display:none!important}}.d-sr-only,.d-sr-only-focusable:not(:focus){border:0!important;clip:rect(0,0,0,0)!important;height:1px!important;margin:-1px!important;overflow:hidden!important;padding:0!important;position:absolute!important;white-space:nowrap!important;width:1px!important}.v-application .font-weight-thin{font-weight:100!important}.v-application .font-weight-light{font-weight:300!important}.v-application .font-weight-regular{font-weight:400!important}.v-application .font-weight-medium{font-weight:500!important}.v-application .font-weight-bold{font-weight:600!important}.v-application .font-weight-black{font-weight:900!important}.v-application .font-italic{font-style:italic!important}.v-application .transition-fast-out-slow-in{transition:.3s cubic-bezier(.4,0,.2,1)!important}.v-application .transition-linear-out-slow-in{transition:.3s cubic-bezier(0,0,.2,1)!important}.v-application .transition-fast-out-linear-in{transition:.3s cubic-bezier(.4,0,1,1)!important}.v-application .transition-ease-in-out{transition:.3s cubic-bezier(.4,0,.6,1)!important}.v-application .transition-fast-in-fast-out{transition:.3s cubic-bezier(.25,.8,.25,1)!important}.v-application .transition-swing{transition:.3s cubic-bezier(.25,.8,.5,1)!important}.v-application .overflow-auto{overflow:auto!important}.v-application .overflow-hidden{overflow:hidden!important}.v-application .overflow-visible{overflow:visible!important}.v-application .overflow-x-auto{overflow-x:auto!important}.v-application .overflow-x-hidden{overflow-x:hidden!important}.v-application .overflow-y-auto{overflow-y:auto!important}.v-application .overflow-y-hidden{overflow-y:hidden!important}.v-application .d-none{display:none!important}.v-application .d-inline{display:inline!important}.v-application .d-inline-block{display:inline-block!important}.v-application .d-block{display:block!important}.v-application .d-table{display:table!important}.v-application .d-table-row{display:table-row!important}.v-application .d-table-cell{display:table-cell!important}.v-application .d-flex{display:flex!important}.v-application .d-inline-flex{display:inline-flex!important}.v-application .float-none{float:none!important}.v-application .float-left{float:left!important}.v-application .float-right{float:right!important}.v-application .flex-fill{flex:1 1 auto!important}.v-application .flex-row{flex-direction:row!important}.v-application .flex-column{flex-direction:column!important}.v-application .flex-row-reverse{flex-direction:row-reverse!important}.v-application .flex-column-reverse{flex-direction:column-reverse!important}.v-application .flex-grow-0{flex-grow:0!important}.v-application .flex-grow-1{flex-grow:1!important}.v-application .flex-shrink-0{flex-shrink:0!important}.v-application .flex-shrink-1{flex-shrink:1!important}.v-application .flex-wrap{flex-wrap:wrap!important}.v-application .flex-nowrap{flex-wrap:nowrap!important}.v-application .flex-wrap-reverse{flex-wrap:wrap-reverse!important}.v-application .justify-start{justify-content:flex-start!important}.v-application .justify-end{justify-content:flex-end!important}.v-application .justify-center{justify-content:center!important}.v-application .justify-space-between{justify-content:space-between!important}.v-application .justify-space-around{justify-content:space-around!important}.v-application .align-start{align-items:flex-start!important}.v-application .align-end{align-items:flex-end!important}.v-application .align-center{align-items:center!important}.v-application .align-baseline{align-items:baseline!important}.v-application .align-stretch{align-items:stretch!important}.v-application .align-content-start{align-content:flex-start!important}.v-application .align-content-end{align-content:flex-end!important}.v-application .align-content-center{align-content:center!important}.v-application .align-content-space-between{align-content:space-between!important}.v-application .align-content-space-around{align-content:space-around!important}.v-application .align-content-stretch{align-content:stretch!important}.v-application .align-self-auto{align-self:auto!important}.v-application .align-self-start{align-self:flex-start!important}.v-application .align-self-end{align-self:flex-end!important}.v-application .align-self-center{align-self:center!important}.v-application .align-self-baseline{align-self:baseline!important}.v-application .align-self-stretch{align-self:stretch!important}.v-application .order-first{order:-1!important}.v-application .order-0{order:0!important}.v-application .order-1{order:1!important}.v-application .order-2{order:2!important}.v-application .order-3{order:3!important}.v-application .order-4{order:4!important}.v-application .order-5{order:5!important}.v-application .order-6{order:6!important}.v-application .order-7{order:7!important}.v-application .order-8{order:8!important}.v-application .order-9{order:9!important}.v-application .order-10{order:10!important}.v-application .order-11{order:11!important}.v-application .order-12{order:12!important}.v-application .order-last{order:13!important}.v-application .ma-0{margin:0!important}.v-application .ma-1{margin:4px!important}.v-application .ma-2{margin:8px!important}.v-application .ma-3{margin:12px!important}.v-application .ma-4{margin:16px!important}.v-application .ma-5{margin:20px!important}.v-application .ma-6{margin:24px!important}.v-application .ma-7{margin:28px!important}.v-application .ma-8{margin:32px!important}.v-application .ma-9{margin:36px!important}.v-application .ma-10{margin:40px!important}.v-application .ma-11{margin:44px!important}.v-application .ma-12{margin:48px!important}.v-application .ma-13{margin:52px!important}.v-application .ma-14{margin:56px!important}.v-application .ma-15{margin:60px!important}.v-application .ma-16{margin:64px!important}.v-application .ma-auto{margin:auto!important}.v-application .mx-0{margin-right:0!important;margin-left:0!important}.v-application .mx-1{margin-right:4px!important;margin-left:4px!important}.v-application .mx-2{margin-right:8px!important;margin-left:8px!important}.v-application .mx-3{margin-right:12px!important;margin-left:12px!important}.v-application .mx-4{margin-right:16px!important;margin-left:16px!important}.v-application .mx-5{margin-right:20px!important;margin-left:20px!important}.v-application .mx-6{margin-right:24px!important;margin-left:24px!important}.v-application .mx-7{margin-right:28px!important;margin-left:28px!important}.v-application .mx-8{margin-right:32px!important;margin-left:32px!important}.v-application .mx-9{margin-right:36px!important;margin-left:36px!important}.v-application .mx-10{margin-right:40px!important;margin-left:40px!important}.v-application .mx-11{margin-right:44px!important;margin-left:44px!important}.v-application .mx-12{margin-right:48px!important;margin-left:48px!important}.v-application .mx-13{margin-right:52px!important;margin-left:52px!important}.v-application .mx-14{margin-right:56px!important;margin-left:56px!important}.v-application .mx-15{margin-right:60px!important;margin-left:60px!important}.v-application .mx-16{margin-right:64px!important;margin-left:64px!important}.v-application .mx-auto{margin-right:auto!important;margin-left:auto!important}.v-application .my-0{margin-top:0!important;margin-bottom:0!important}.v-application .my-1{margin-top:4px!important;margin-bottom:4px!important}.v-application .my-2{margin-top:8px!important;margin-bottom:8px!important}.v-application .my-3{margin-top:12px!important;margin-bottom:12px!important}.v-application .my-4{margin-top:16px!important;margin-bottom:16px!important}.v-application .my-5{margin-top:20px!important;margin-bottom:20px!important}.v-application .my-6{margin-top:24px!important;margin-bottom:24px!important}.v-application .my-7{margin-top:28px!important;margin-bottom:28px!important}.v-application .my-8{margin-top:32px!important;margin-bottom:32px!important}.v-application .my-9{margin-top:36px!important;margin-bottom:36px!important}.v-application .my-10{margin-top:40px!important;margin-bottom:40px!important}.v-application .my-11{margin-top:44px!important;margin-bottom:44px!important}.v-application .my-12{margin-top:48px!important;margin-bottom:48px!important}.v-application .my-13{margin-top:52px!important;margin-bottom:52px!important}.v-application .my-14{margin-top:56px!important;margin-bottom:56px!important}.v-application .my-15{margin-top:60px!important;margin-bottom:60px!important}.v-application .my-16{margin-top:64px!important;margin-bottom:64px!important}.v-application .my-auto{margin-top:auto!important;margin-bottom:auto!important}.v-application .mt-0{margin-top:0!important}.v-application .mt-1{margin-top:4px!important}.v-application .mt-2{margin-top:8px!important}.v-application .mt-3{margin-top:12px!important}.v-application .mt-4{margin-top:16px!important}.v-application .mt-5{margin-top:20px!important}.v-application .mt-6{margin-top:24px!important}.v-application .mt-7{margin-top:28px!important}.v-application .mt-8{margin-top:32px!important}.v-application .mt-9{margin-top:36px!important}.v-application .mt-10{margin-top:40px!important}.v-application .mt-11{margin-top:44px!important}.v-application .mt-12{margin-top:48px!important}.v-application .mt-13{margin-top:52px!important}.v-application .mt-14{margin-top:56px!important}.v-application .mt-15{margin-top:60px!important}.v-application .mt-16{margin-top:64px!important}.v-application .mt-auto{margin-top:auto!important}.v-application .mr-0{margin-right:0!important}.v-application .mr-1{margin-right:4px!important}.v-application .mr-2{margin-right:8px!important}.v-application .mr-3{margin-right:12px!important}.v-application .mr-4{margin-right:16px!important}.v-application .mr-5{margin-right:20px!important}.v-application .mr-6{margin-right:24px!important}.v-application .mr-7{margin-right:28px!important}.v-application .mr-8{margin-right:32px!important}.v-application .mr-9{margin-right:36px!important}.v-application .mr-10{margin-right:40px!important}.v-application .mr-11{margin-right:44px!important}.v-application .mr-12{margin-right:48px!important}.v-application .mr-13{margin-right:52px!important}.v-application .mr-14{margin-right:56px!important}.v-application .mr-15{margin-right:60px!important}.v-application .mr-16{margin-right:64px!important}.v-application .mr-auto{margin-right:auto!important}.v-application .mb-0{margin-bottom:0!important}.v-application .mb-1{margin-bottom:4px!important}.v-application .mb-2{margin-bottom:8px!important}.v-application .mb-3{margin-bottom:12px!important}.v-application .mb-4{margin-bottom:16px!important}.v-application .mb-5{margin-bottom:20px!important}.v-application .mb-6{margin-bottom:24px!important}.v-application .mb-7{margin-bottom:28px!important}.v-application .mb-8{margin-bottom:32px!important}.v-application .mb-9{margin-bottom:36px!important}.v-application .mb-10{margin-bottom:40px!important}.v-application .mb-11{margin-bottom:44px!important}.v-application .mb-12{margin-bottom:48px!important}.v-application .mb-13{margin-bottom:52px!important}.v-application .mb-14{margin-bottom:56px!important}.v-application .mb-15{margin-bottom:60px!important}.v-application .mb-16{margin-bottom:64px!important}.v-application .mb-auto{margin-bottom:auto!important}.v-application .ml-0{margin-left:0!important}.v-application .ml-1{margin-left:4px!important}.v-application .ml-2{margin-left:8px!important}.v-application .ml-3{margin-left:12px!important}.v-application .ml-4{margin-left:16px!important}.v-application .ml-5{margin-left:20px!important}.v-application .ml-6{margin-left:24px!important}.v-application .ml-7{margin-left:28px!important}.v-application .ml-8{margin-left:32px!important}.v-application .ml-9{margin-left:36px!important}.v-application .ml-10{margin-left:40px!important}.v-application .ml-11{margin-left:44px!important}.v-application .ml-12{margin-left:48px!important}.v-application .ml-13{margin-left:52px!important}.v-application .ml-14{margin-left:56px!important}.v-application .ml-15{margin-left:60px!important}.v-application .ml-16{margin-left:64px!important}.v-application .ml-auto{margin-left:auto!important}.v-application--is-ltr .ms-0{margin-left:0!important}.v-application--is-rtl .ms-0{margin-right:0!important}.v-application--is-ltr .ms-1{margin-left:4px!important}.v-application--is-rtl .ms-1{margin-right:4px!important}.v-application--is-ltr .ms-2{margin-left:8px!important}.v-application--is-rtl .ms-2{margin-right:8px!important}.v-application--is-ltr .ms-3{margin-left:12px!important}.v-application--is-rtl .ms-3{margin-right:12px!important}.v-application--is-ltr .ms-4{margin-left:16px!important}.v-application--is-rtl .ms-4{margin-right:16px!important}.v-application--is-ltr .ms-5{margin-left:20px!important}.v-application--is-rtl .ms-5{margin-right:20px!important}.v-application--is-ltr .ms-6{margin-left:24px!important}.v-application--is-rtl .ms-6{margin-right:24px!important}.v-application--is-ltr .ms-7{margin-left:28px!important}.v-application--is-rtl .ms-7{margin-right:28px!important}.v-application--is-ltr .ms-8{margin-left:32px!important}.v-application--is-rtl .ms-8{margin-right:32px!important}.v-application--is-ltr .ms-9{margin-left:36px!important}.v-application--is-rtl .ms-9{margin-right:36px!important}.v-application--is-ltr .ms-10{margin-left:40px!important}.v-application--is-rtl .ms-10{margin-right:40px!important}.v-application--is-ltr .ms-11{margin-left:44px!important}.v-application--is-rtl .ms-11{margin-right:44px!important}.v-application--is-ltr .ms-12{margin-left:48px!important}.v-application--is-rtl .ms-12{margin-right:48px!important}.v-application--is-ltr .ms-13{margin-left:52px!important}.v-application--is-rtl .ms-13{margin-right:52px!important}.v-application--is-ltr .ms-14{margin-left:56px!important}.v-application--is-rtl .ms-14{margin-right:56px!important}.v-application--is-ltr .ms-15{margin-left:60px!important}.v-application--is-rtl .ms-15{margin-right:60px!important}.v-application--is-ltr .ms-16{margin-left:64px!important}.v-application--is-rtl .ms-16{margin-right:64px!important}.v-application--is-ltr .ms-auto{margin-left:auto!important}.v-application--is-rtl .ms-auto{margin-right:auto!important}.v-application--is-ltr .me-0{margin-right:0!important}.v-application--is-rtl .me-0{margin-left:0!important}.v-application--is-ltr .me-1{margin-right:4px!important}.v-application--is-rtl .me-1{margin-left:4px!important}.v-application--is-ltr .me-2{margin-right:8px!important}.v-application--is-rtl .me-2{margin-left:8px!important}.v-application--is-ltr .me-3{margin-right:12px!important}.v-application--is-rtl .me-3{margin-left:12px!important}.v-application--is-ltr .me-4{margin-right:16px!important}.v-application--is-rtl .me-4{margin-left:16px!important}.v-application--is-ltr .me-5{margin-right:20px!important}.v-application--is-rtl .me-5{margin-left:20px!important}.v-application--is-ltr .me-6{margin-right:24px!important}.v-application--is-rtl .me-6{margin-left:24px!important}.v-application--is-ltr .me-7{margin-right:28px!important}.v-application--is-rtl .me-7{margin-left:28px!important}.v-application--is-ltr .me-8{margin-right:32px!important}.v-application--is-rtl .me-8{margin-left:32px!important}.v-application--is-ltr .me-9{margin-right:36px!important}.v-application--is-rtl .me-9{margin-left:36px!important}.v-application--is-ltr .me-10{margin-right:40px!important}.v-application--is-rtl .me-10{margin-left:40px!important}.v-application--is-ltr .me-11{margin-right:44px!important}.v-application--is-rtl .me-11{margin-left:44px!important}.v-application--is-ltr .me-12{margin-right:48px!important}.v-application--is-rtl .me-12{margin-left:48px!important}.v-application--is-ltr .me-13{margin-right:52px!important}.v-application--is-rtl .me-13{margin-left:52px!important}.v-application--is-ltr .me-14{margin-right:56px!important}.v-application--is-rtl .me-14{margin-left:56px!important}.v-application--is-ltr .me-15{margin-right:60px!important}.v-application--is-rtl .me-15{margin-left:60px!important}.v-application--is-ltr .me-16{margin-right:64px!important}.v-application--is-rtl .me-16{margin-left:64px!important}.v-application--is-ltr .me-auto{margin-right:auto!important}.v-application--is-rtl .me-auto{margin-left:auto!important}.v-application .ma-n1{margin:-4px!important}.v-application .ma-n2{margin:-8px!important}.v-application .ma-n3{margin:-12px!important}.v-application .ma-n4{margin:-16px!important}.v-application .ma-n5{margin:-20px!important}.v-application .ma-n6{margin:-24px!important}.v-application .ma-n7{margin:-28px!important}.v-application .ma-n8{margin:-32px!important}.v-application .ma-n9{margin:-36px!important}.v-application .ma-n10{margin:-40px!important}.v-application .ma-n11{margin:-44px!important}.v-application .ma-n12{margin:-48px!important}.v-application .ma-n13{margin:-52px!important}.v-application .ma-n14{margin:-56px!important}.v-application .ma-n15{margin:-60px!important}.v-application .ma-n16{margin:-64px!important}.v-application .mx-n1{margin-right:-4px!important;margin-left:-4px!important}.v-application .mx-n2{margin-right:-8px!important;margin-left:-8px!important}.v-application .mx-n3{margin-right:-12px!important;margin-left:-12px!important}.v-application .mx-n4{margin-right:-16px!important;margin-left:-16px!important}.v-application .mx-n5{margin-right:-20px!important;margin-left:-20px!important}.v-application .mx-n6{margin-right:-24px!important;margin-left:-24px!important}.v-application .mx-n7{margin-right:-28px!important;margin-left:-28px!important}.v-application .mx-n8{margin-right:-32px!important;margin-left:-32px!important}.v-application .mx-n9{margin-right:-36px!important;margin-left:-36px!important}.v-application .mx-n10{margin-right:-40px!important;margin-left:-40px!important}.v-application .mx-n11{margin-right:-44px!important;margin-left:-44px!important}.v-application .mx-n12{margin-right:-48px!important;margin-left:-48px!important}.v-application .mx-n13{margin-right:-52px!important;margin-left:-52px!important}.v-application .mx-n14{margin-right:-56px!important;margin-left:-56px!important}.v-application .mx-n15{margin-right:-60px!important;margin-left:-60px!important}.v-application .mx-n16{margin-right:-64px!important;margin-left:-64px!important}.v-application .my-n1{margin-top:-4px!important;margin-bottom:-4px!important}.v-application .my-n2{margin-top:-8px!important;margin-bottom:-8px!important}.v-application .my-n3{margin-top:-12px!important;margin-bottom:-12px!important}.v-application .my-n4{margin-top:-16px!important;margin-bottom:-16px!important}.v-application .my-n5{margin-top:-20px!important;margin-bottom:-20px!important}.v-application .my-n6{margin-top:-24px!important;margin-bottom:-24px!important}.v-application .my-n7{margin-top:-28px!important;margin-bottom:-28px!important}.v-application .my-n8{margin-top:-32px!important;margin-bottom:-32px!important}.v-application .my-n9{margin-top:-36px!important;margin-bottom:-36px!important}.v-application .my-n10{margin-top:-40px!important;margin-bottom:-40px!important}.v-application .my-n11{margin-top:-44px!important;margin-bottom:-44px!important}.v-application .my-n12{margin-top:-48px!important;margin-bottom:-48px!important}.v-application .my-n13{margin-top:-52px!important;margin-bottom:-52px!important}.v-application .my-n14{margin-top:-56px!important;margin-bottom:-56px!important}.v-application .my-n15{margin-top:-60px!important;margin-bottom:-60px!important}.v-application .my-n16{margin-top:-64px!important;margin-bottom:-64px!important}.v-application .mt-n1{margin-top:-4px!important}.v-application .mt-n2{margin-top:-8px!important}.v-application .mt-n3{margin-top:-12px!important}.v-application .mt-n4{margin-top:-16px!important}.v-application .mt-n5{margin-top:-20px!important}.v-application .mt-n6{margin-top:-24px!important}.v-application .mt-n7{margin-top:-28px!important}.v-application .mt-n8{margin-top:-32px!important}.v-application .mt-n9{margin-top:-36px!important}.v-application .mt-n10{margin-top:-40px!important}.v-application .mt-n11{margin-top:-44px!important}.v-application .mt-n12{margin-top:-48px!important}.v-application .mt-n13{margin-top:-52px!important}.v-application .mt-n14{margin-top:-56px!important}.v-application .mt-n15{margin-top:-60px!important}.v-application .mt-n16{margin-top:-64px!important}.v-application .mr-n1{margin-right:-4px!important}.v-application .mr-n2{margin-right:-8px!important}.v-application .mr-n3{margin-right:-12px!important}.v-application .mr-n4{margin-right:-16px!important}.v-application .mr-n5{margin-right:-20px!important}.v-application .mr-n6{margin-right:-24px!important}.v-application .mr-n7{margin-right:-28px!important}.v-application .mr-n8{margin-right:-32px!important}.v-application .mr-n9{margin-right:-36px!important}.v-application .mr-n10{margin-right:-40px!important}.v-application .mr-n11{margin-right:-44px!important}.v-application .mr-n12{margin-right:-48px!important}.v-application .mr-n13{margin-right:-52px!important}.v-application .mr-n14{margin-right:-56px!important}.v-application .mr-n15{margin-right:-60px!important}.v-application .mr-n16{margin-right:-64px!important}.v-application .mb-n1{margin-bottom:-4px!important}.v-application .mb-n2{margin-bottom:-8px!important}.v-application .mb-n3{margin-bottom:-12px!important}.v-application .mb-n4{margin-bottom:-16px!important}.v-application .mb-n5{margin-bottom:-20px!important}.v-application .mb-n6{margin-bottom:-24px!important}.v-application .mb-n7{margin-bottom:-28px!important}.v-application .mb-n8{margin-bottom:-32px!important}.v-application .mb-n9{margin-bottom:-36px!important}.v-application .mb-n10{margin-bottom:-40px!important}.v-application .mb-n11{margin-bottom:-44px!important}.v-application .mb-n12{margin-bottom:-48px!important}.v-application .mb-n13{margin-bottom:-52px!important}.v-application .mb-n14{margin-bottom:-56px!important}.v-application .mb-n15{margin-bottom:-60px!important}.v-application .mb-n16{margin-bottom:-64px!important}.v-application .ml-n1{margin-left:-4px!important}.v-application .ml-n2{margin-left:-8px!important}.v-application .ml-n3{margin-left:-12px!important}.v-application .ml-n4{margin-left:-16px!important}.v-application .ml-n5{margin-left:-20px!important}.v-application .ml-n6{margin-left:-24px!important}.v-application .ml-n7{margin-left:-28px!important}.v-application .ml-n8{margin-left:-32px!important}.v-application .ml-n9{margin-left:-36px!important}.v-application .ml-n10{margin-left:-40px!important}.v-application .ml-n11{margin-left:-44px!important}.v-application .ml-n12{margin-left:-48px!important}.v-application .ml-n13{margin-left:-52px!important}.v-application .ml-n14{margin-left:-56px!important}.v-application .ml-n15{margin-left:-60px!important}.v-application .ml-n16{margin-left:-64px!important}.v-application--is-ltr .ms-n1{margin-left:-4px!important}.v-application--is-rtl .ms-n1{margin-right:-4px!important}.v-application--is-ltr .ms-n2{margin-left:-8px!important}.v-application--is-rtl .ms-n2{margin-right:-8px!important}.v-application--is-ltr .ms-n3{margin-left:-12px!important}.v-application--is-rtl .ms-n3{margin-right:-12px!important}.v-application--is-ltr .ms-n4{margin-left:-16px!important}.v-application--is-rtl .ms-n4{margin-right:-16px!important}.v-application--is-ltr .ms-n5{margin-left:-20px!important}.v-application--is-rtl .ms-n5{margin-right:-20px!important}.v-application--is-ltr .ms-n6{margin-left:-24px!important}.v-application--is-rtl .ms-n6{margin-right:-24px!important}.v-application--is-ltr .ms-n7{margin-left:-28px!important}.v-application--is-rtl .ms-n7{margin-right:-28px!important}.v-application--is-ltr .ms-n8{margin-left:-32px!important}.v-application--is-rtl .ms-n8{margin-right:-32px!important}.v-application--is-ltr .ms-n9{margin-left:-36px!important}.v-application--is-rtl .ms-n9{margin-right:-36px!important}.v-application--is-ltr .ms-n10{margin-left:-40px!important}.v-application--is-rtl .ms-n10{margin-right:-40px!important}.v-application--is-ltr .ms-n11{margin-left:-44px!important}.v-application--is-rtl .ms-n11{margin-right:-44px!important}.v-application--is-ltr .ms-n12{margin-left:-48px!important}.v-application--is-rtl .ms-n12{margin-right:-48px!important}.v-application--is-ltr .ms-n13{margin-left:-52px!important}.v-application--is-rtl .ms-n13{margin-right:-52px!important}.v-application--is-ltr .ms-n14{margin-left:-56px!important}.v-application--is-rtl .ms-n14{margin-right:-56px!important}.v-application--is-ltr .ms-n15{margin-left:-60px!important}.v-application--is-rtl .ms-n15{margin-right:-60px!important}.v-application--is-ltr .ms-n16{margin-left:-64px!important}.v-application--is-rtl .ms-n16{margin-right:-64px!important}.v-application--is-ltr .me-n1{margin-right:-4px!important}.v-application--is-rtl .me-n1{margin-left:-4px!important}.v-application--is-ltr .me-n2{margin-right:-8px!important}.v-application--is-rtl .me-n2{margin-left:-8px!important}.v-application--is-ltr .me-n3{margin-right:-12px!important}.v-application--is-rtl .me-n3{margin-left:-12px!important}.v-application--is-ltr .me-n4{margin-right:-16px!important}.v-application--is-rtl .me-n4{margin-left:-16px!important}.v-application--is-ltr .me-n5{margin-right:-20px!important}.v-application--is-rtl .me-n5{margin-left:-20px!important}.v-application--is-ltr .me-n6{margin-right:-24px!important}.v-application--is-rtl .me-n6{margin-left:-24px!important}.v-application--is-ltr .me-n7{margin-right:-28px!important}.v-application--is-rtl .me-n7{margin-left:-28px!important}.v-application--is-ltr .me-n8{margin-right:-32px!important}.v-application--is-rtl .me-n8{margin-left:-32px!important}.v-application--is-ltr .me-n9{margin-right:-36px!important}.v-application--is-rtl .me-n9{margin-left:-36px!important}.v-application--is-ltr .me-n10{margin-right:-40px!important}.v-application--is-rtl .me-n10{margin-left:-40px!important}.v-application--is-ltr .me-n11{margin-right:-44px!important}.v-application--is-rtl .me-n11{margin-left:-44px!important}.v-application--is-ltr .me-n12{margin-right:-48px!important}.v-application--is-rtl .me-n12{margin-left:-48px!important}.v-application--is-ltr .me-n13{margin-right:-52px!important}.v-application--is-rtl .me-n13{margin-left:-52px!important}.v-application--is-ltr .me-n14{margin-right:-56px!important}.v-application--is-rtl .me-n14{margin-left:-56px!important}.v-application--is-ltr .me-n15{margin-right:-60px!important}.v-application--is-rtl .me-n15{margin-left:-60px!important}.v-application--is-ltr .me-n16{margin-right:-64px!important}.v-application--is-rtl .me-n16{margin-left:-64px!important}.v-application .pa-0{padding:0!important}.v-application .pa-1{padding:4px!important}.v-application .pa-2{padding:8px!important}.v-application .pa-3{padding:12px!important}.v-application .pa-4{padding:16px!important}.v-application .pa-5{padding:20px!important}.v-application .pa-6{padding:24px!important}.v-application .pa-7{padding:28px!important}.v-application .pa-8{padding:32px!important}.v-application .pa-9{padding:36px!important}.v-application .pa-10{padding:40px!important}.v-application .pa-11{padding:44px!important}.v-application .pa-12{padding:48px!important}.v-application .pa-13{padding:52px!important}.v-application .pa-14{padding:56px!important}.v-application .pa-15{padding:60px!important}.v-application .pa-16{padding:64px!important}.v-application .px-0{padding-right:0!important;padding-left:0!important}.v-application .px-1{padding-right:4px!important;padding-left:4px!important}.v-application .px-2{padding-right:8px!important;padding-left:8px!important}.v-application .px-3{padding-right:12px!important;padding-left:12px!important}.v-application .px-4{padding-right:16px!important;padding-left:16px!important}.v-application .px-5{padding-right:20px!important;padding-left:20px!important}.v-application .px-6{padding-right:24px!important;padding-left:24px!important}.v-application .px-7{padding-right:28px!important;padding-left:28px!important}.v-application .px-8{padding-right:32px!important;padding-left:32px!important}.v-application .px-9{padding-right:36px!important;padding-left:36px!important}.v-application .px-10{padding-right:40px!important;padding-left:40px!important}.v-application .px-11{padding-right:44px!important;padding-left:44px!important}.v-application .px-12{padding-right:48px!important;padding-left:48px!important}.v-application .px-13{padding-right:52px!important;padding-left:52px!important}.v-application .px-14{padding-right:56px!important;padding-left:56px!important}.v-application .px-15{padding-right:60px!important;padding-left:60px!important}.v-application .px-16{padding-right:64px!important;padding-left:64px!important}.v-application .py-0{padding-top:0!important;padding-bottom:0!important}.v-application .py-1{padding-top:4px!important;padding-bottom:4px!important}.v-application .py-2{padding-top:8px!important;padding-bottom:8px!important}.v-application .py-3{padding-top:12px!important;padding-bottom:12px!important}.v-application .py-4{padding-top:16px!important;padding-bottom:16px!important}.v-application .py-5{padding-top:20px!important;padding-bottom:20px!important}.v-application .py-6{padding-top:24px!important;padding-bottom:24px!important}.v-application .py-7{padding-top:28px!important;padding-bottom:28px!important}.v-application .py-8{padding-top:32px!important;padding-bottom:32px!important}.v-application .py-9{padding-top:36px!important;padding-bottom:36px!important}.v-application .py-10{padding-top:40px!important;padding-bottom:40px!important}.v-application .py-11{padding-top:44px!important;padding-bottom:44px!important}.v-application .py-12{padding-top:48px!important;padding-bottom:48px!important}.v-application .py-13{padding-top:52px!important;padding-bottom:52px!important}.v-application .py-14{padding-top:56px!important;padding-bottom:56px!important}.v-application .py-15{padding-top:60px!important;padding-bottom:60px!important}.v-application .py-16{padding-top:64px!important;padding-bottom:64px!important}.v-application .pt-0{padding-top:0!important}.v-application .pt-1{padding-top:4px!important}.v-application .pt-2{padding-top:8px!important}.v-application .pt-3{padding-top:12px!important}.v-application .pt-4{padding-top:16px!important}.v-application .pt-5{padding-top:20px!important}.v-application .pt-6{padding-top:24px!important}.v-application .pt-7{padding-top:28px!important}.v-application .pt-8{padding-top:32px!important}.v-application .pt-9{padding-top:36px!important}.v-application .pt-10{padding-top:40px!important}.v-application .pt-11{padding-top:44px!important}.v-application .pt-12{padding-top:48px!important}.v-application .pt-13{padding-top:52px!important}.v-application .pt-14{padding-top:56px!important}.v-application .pt-15{padding-top:60px!important}.v-application .pt-16{padding-top:64px!important}.v-application .pr-0{padding-right:0!important}.v-application .pr-1{padding-right:4px!important}.v-application .pr-2{padding-right:8px!important}.v-application .pr-3{padding-right:12px!important}.v-application .pr-4{padding-right:16px!important}.v-application .pr-5{padding-right:20px!important}.v-application .pr-6{padding-right:24px!important}.v-application .pr-7{padding-right:28px!important}.v-application .pr-8{padding-right:32px!important}.v-application .pr-9{padding-right:36px!important}.v-application .pr-10{padding-right:40px!important}.v-application .pr-11{padding-right:44px!important}.v-application .pr-12{padding-right:48px!important}.v-application .pr-13{padding-right:52px!important}.v-application .pr-14{padding-right:56px!important}.v-application .pr-15{padding-right:60px!important}.v-application .pr-16{padding-right:64px!important}.v-application .pb-0{padding-bottom:0!important}.v-application .pb-1{padding-bottom:4px!important}.v-application .pb-2{padding-bottom:8px!important}.v-application .pb-3{padding-bottom:12px!important}.v-application .pb-4{padding-bottom:16px!important}.v-application .pb-5{padding-bottom:20px!important}.v-application .pb-6{padding-bottom:24px!important}.v-application .pb-7{padding-bottom:28px!important}.v-application .pb-8{padding-bottom:32px!important}.v-application .pb-9{padding-bottom:36px!important}.v-application .pb-10{padding-bottom:40px!important}.v-application .pb-11{padding-bottom:44px!important}.v-application .pb-12{padding-bottom:48px!important}.v-application .pb-13{padding-bottom:52px!important}.v-application .pb-14{padding-bottom:56px!important}.v-application .pb-15{padding-bottom:60px!important}.v-application .pb-16{padding-bottom:64px!important}.v-application .pl-0{padding-left:0!important}.v-application .pl-1{padding-left:4px!important}.v-application .pl-2{padding-left:8px!important}.v-application .pl-3{padding-left:12px!important}.v-application .pl-4{padding-left:16px!important}.v-application .pl-5{padding-left:20px!important}.v-application .pl-6{padding-left:24px!important}.v-application .pl-7{padding-left:28px!important}.v-application .pl-8{padding-left:32px!important}.v-application .pl-9{padding-left:36px!important}.v-application .pl-10{padding-left:40px!important}.v-application .pl-11{padding-left:44px!important}.v-application .pl-12{padding-left:48px!important}.v-application .pl-13{padding-left:52px!important}.v-application .pl-14{padding-left:56px!important}.v-application .pl-15{padding-left:60px!important}.v-application .pl-16{padding-left:64px!important}.v-application--is-ltr .ps-0{padding-left:0!important}.v-application--is-rtl .ps-0{padding-right:0!important}.v-application--is-ltr .ps-1{padding-left:4px!important}.v-application--is-rtl .ps-1{padding-right:4px!important}.v-application--is-ltr .ps-2{padding-left:8px!important}.v-application--is-rtl .ps-2{padding-right:8px!important}.v-application--is-ltr .ps-3{padding-left:12px!important}.v-application--is-rtl .ps-3{padding-right:12px!important}.v-application--is-ltr .ps-4{padding-left:16px!important}.v-application--is-rtl .ps-4{padding-right:16px!important}.v-application--is-ltr .ps-5{padding-left:20px!important}.v-application--is-rtl .ps-5{padding-right:20px!important}.v-application--is-ltr .ps-6{padding-left:24px!important}.v-application--is-rtl .ps-6{padding-right:24px!important}.v-application--is-ltr .ps-7{padding-left:28px!important}.v-application--is-rtl .ps-7{padding-right:28px!important}.v-application--is-ltr .ps-8{padding-left:32px!important}.v-application--is-rtl .ps-8{padding-right:32px!important}.v-application--is-ltr .ps-9{padding-left:36px!important}.v-application--is-rtl .ps-9{padding-right:36px!important}.v-application--is-ltr .ps-10{padding-left:40px!important}.v-application--is-rtl .ps-10{padding-right:40px!important}.v-application--is-ltr .ps-11{padding-left:44px!important}.v-application--is-rtl .ps-11{padding-right:44px!important}.v-application--is-ltr .ps-12{padding-left:48px!important}.v-application--is-rtl .ps-12{padding-right:48px!important}.v-application--is-ltr .ps-13{padding-left:52px!important}.v-application--is-rtl .ps-13{padding-right:52px!important}.v-application--is-ltr .ps-14{padding-left:56px!important}.v-application--is-rtl .ps-14{padding-right:56px!important}.v-application--is-ltr .ps-15{padding-left:60px!important}.v-application--is-rtl .ps-15{padding-right:60px!important}.v-application--is-ltr .ps-16{padding-left:64px!important}.v-application--is-rtl .ps-16{padding-right:64px!important}.v-application--is-ltr .pe-0{padding-right:0!important}.v-application--is-rtl .pe-0{padding-left:0!important}.v-application--is-ltr .pe-1{padding-right:4px!important}.v-application--is-rtl .pe-1{padding-left:4px!important}.v-application--is-ltr .pe-2{padding-right:8px!important}.v-application--is-rtl .pe-2{padding-left:8px!important}.v-application--is-ltr .pe-3{padding-right:12px!important}.v-application--is-rtl .pe-3{padding-left:12px!important}.v-application--is-ltr .pe-4{padding-right:16px!important}.v-application--is-rtl .pe-4{padding-left:16px!important}.v-application--is-ltr .pe-5{padding-right:20px!important}.v-application--is-rtl .pe-5{padding-left:20px!important}.v-application--is-ltr .pe-6{padding-right:24px!important}.v-application--is-rtl .pe-6{padding-left:24px!important}.v-application--is-ltr .pe-7{padding-right:28px!important}.v-application--is-rtl .pe-7{padding-left:28px!important}.v-application--is-ltr .pe-8{padding-right:32px!important}.v-application--is-rtl .pe-8{padding-left:32px!important}.v-application--is-ltr .pe-9{padding-right:36px!important}.v-application--is-rtl .pe-9{padding-left:36px!important}.v-application--is-ltr .pe-10{padding-right:40px!important}.v-application--is-rtl .pe-10{padding-left:40px!important}.v-application--is-ltr .pe-11{padding-right:44px!important}.v-application--is-rtl .pe-11{padding-left:44px!important}.v-application--is-ltr .pe-12{padding-right:48px!important}.v-application--is-rtl .pe-12{padding-left:48px!important}.v-application--is-ltr .pe-13{padding-right:52px!important}.v-application--is-rtl .pe-13{padding-left:52px!important}.v-application--is-ltr .pe-14{padding-right:56px!important}.v-application--is-rtl .pe-14{padding-left:56px!important}.v-application--is-ltr .pe-15{padding-right:60px!important}.v-application--is-rtl .pe-15{padding-left:60px!important}.v-application--is-ltr .pe-16{padding-right:64px!important}.v-application--is-rtl .pe-16{padding-left:64px!important}.v-application .rounded-0{border-radius:0!important}.v-application .rounded-sm{border-radius:2.5px!important}.v-application .rounded{border-radius:5px!important}.v-application .rounded-lg{border-radius:10px!important}.v-application .rounded-xl{border-radius:20px!important}.v-application .rounded-pill{border-radius:9999px!important}.v-application .rounded-circle{border-radius:50%!important}.v-application .rounded-t-0{border-top-left-radius:0!important;border-top-right-radius:0!important}.v-application .rounded-t-sm{border-top-left-radius:2.5px!important;border-top-right-radius:2.5px!important}.v-application .rounded-t{border-top-left-radius:5px!important;border-top-right-radius:5px!important}.v-application .rounded-t-lg{border-top-left-radius:10px!important;border-top-right-radius:10px!important}.v-application .rounded-t-xl{border-top-left-radius:20px!important;border-top-right-radius:20px!important}.v-application .rounded-t-pill{border-top-left-radius:9999px!important;border-top-right-radius:9999px!important}.v-application .rounded-t-circle{border-top-left-radius:50%!important;border-top-right-radius:50%!important}.v-application .rounded-r-0{border-top-right-radius:0!important;border-bottom-right-radius:0!important}.v-application .rounded-r-sm{border-top-right-radius:2.5px!important;border-bottom-right-radius:2.5px!important}.v-application .rounded-r{border-top-right-radius:5px!important;border-bottom-right-radius:5px!important}.v-application .rounded-r-lg{border-top-right-radius:10px!important;border-bottom-right-radius:10px!important}.v-application .rounded-r-xl{border-top-right-radius:20px!important;border-bottom-right-radius:20px!important}.v-application .rounded-r-pill{border-top-right-radius:9999px!important;border-bottom-right-radius:9999px!important}.v-application .rounded-r-circle{border-top-right-radius:50%!important;border-bottom-right-radius:50%!important}.v-application .rounded-b-0{border-bottom-left-radius:0!important;border-bottom-right-radius:0!important}.v-application .rounded-b-sm{border-bottom-left-radius:2.5px!important;border-bottom-right-radius:2.5px!important}.v-application .rounded-b{border-bottom-left-radius:5px!important;border-bottom-right-radius:5px!important}.v-application .rounded-b-lg{border-bottom-left-radius:10px!important;border-bottom-right-radius:10px!important}.v-application .rounded-b-xl{border-bottom-left-radius:20px!important;border-bottom-right-radius:20px!important}.v-application .rounded-b-pill{border-bottom-left-radius:9999px!important;border-bottom-right-radius:9999px!important}.v-application .rounded-b-circle{border-bottom-left-radius:50%!important;border-bottom-right-radius:50%!important}.v-application .rounded-l-0{border-top-left-radius:0!important;border-bottom-left-radius:0!important}.v-application .rounded-l-sm{border-top-left-radius:2.5px!important;border-bottom-left-radius:2.5px!important}.v-application .rounded-l{border-top-left-radius:5px!important;border-bottom-left-radius:5px!important}.v-application .rounded-l-lg{border-top-left-radius:10px!important;border-bottom-left-radius:10px!important}.v-application .rounded-l-xl{border-top-left-radius:20px!important;border-bottom-left-radius:20px!important}.v-application .rounded-l-pill{border-top-left-radius:9999px!important;border-bottom-left-radius:9999px!important}.v-application .rounded-l-circle{border-top-left-radius:50%!important;border-bottom-left-radius:50%!important}.v-application .rounded-tl-0{border-top-left-radius:0!important}.v-application .rounded-tl-sm{border-top-left-radius:2.5px!important}.v-application .rounded-tl{border-top-left-radius:5px!important}.v-application .rounded-tl-lg{border-top-left-radius:10px!important}.v-application .rounded-tl-xl{border-top-left-radius:20px!important}.v-application .rounded-tl-pill{border-top-left-radius:9999px!important}.v-application .rounded-tl-circle{border-top-left-radius:50%!important}.v-application .rounded-tr-0{border-top-right-radius:0!important}.v-application .rounded-tr-sm{border-top-right-radius:2.5px!important}.v-application .rounded-tr{border-top-right-radius:5px!important}.v-application .rounded-tr-lg{border-top-right-radius:10px!important}.v-application .rounded-tr-xl{border-top-right-radius:20px!important}.v-application .rounded-tr-pill{border-top-right-radius:9999px!important}.v-application .rounded-tr-circle{border-top-right-radius:50%!important}.v-application .rounded-br-0{border-bottom-right-radius:0!important}.v-application .rounded-br-sm{border-bottom-right-radius:2.5px!important}.v-application .rounded-br{border-bottom-right-radius:5px!important}.v-application .rounded-br-lg{border-bottom-right-radius:10px!important}.v-application .rounded-br-xl{border-bottom-right-radius:20px!important}.v-application .rounded-br-pill{border-bottom-right-radius:9999px!important}.v-application .rounded-br-circle{border-bottom-right-radius:50%!important}.v-application .rounded-bl-0{border-bottom-left-radius:0!important}.v-application .rounded-bl-sm{border-bottom-left-radius:2.5px!important}.v-application .rounded-bl{border-bottom-left-radius:5px!important}.v-application .rounded-bl-lg{border-bottom-left-radius:10px!important}.v-application .rounded-bl-xl{border-bottom-left-radius:20px!important}.v-application .rounded-bl-pill{border-bottom-left-radius:9999px!important}.v-application .rounded-bl-circle{border-bottom-left-radius:50%!important}.v-application .text-left{text-align:left!important}.v-application .text-right{text-align:right!important}.v-application .text-center{text-align:center!important}.v-application .text-justify{text-align:justify!important}.v-application .text-start{text-align:start!important}.v-application .text-end{text-align:end!important}.v-application .text-decoration-line-through{text-decoration:line-through!important}.v-application .text-decoration-none{text-decoration:none!important}.v-application .text-decoration-overline{text-decoration:overline!important}.v-application .text-decoration-underline{text-decoration:underline!important}.v-application .text-wrap{white-space:normal!important}.v-application .text-no-wrap{white-space:nowrap!important}.v-application .text-pre{white-space:pre!important}.v-application .text-pre-line{white-space:pre-line!important}.v-application .text-pre-wrap{white-space:pre-wrap!important}.v-application .text-break{overflow-wrap:break-word!important;word-break:break-word!important}.v-application .text-truncate{white-space:nowrap!important;overflow:hidden!important;text-overflow:ellipsis!important}.v-application .text-none{text-transform:none!important}.v-application .text-capitalize{text-transform:capitalize!important}.v-application .text-lowercase{text-transform:lowercase!important}.v-application .text-uppercase{text-transform:uppercase!important}.v-application .text-h1{font-size:2rem!important;font-weight:600;line-height:2.4285714286rem;letter-spacing:-.02em!important;font-family:AkkuratLL,Helvetica,Arial,sans-serif!important}.v-application .text-h2{font-size:1.7142857143rem!important;line-height:2.2857142857rem}.v-application .text-h2,.v-application .text-h3{font-weight:600;letter-spacing:-.01em!important;font-family:AkkuratLL,Helvetica,Arial,sans-serif!important}.v-application .text-h3{font-size:1.4285714286rem!important;line-height:2rem}.v-application .text-h4{font-size:1.2857142857rem!important}.v-application .text-h4,.v-application .text-h5{font-weight:600;line-height:1.7142857143rem;letter-spacing:-.01em!important;font-family:AkkuratLL,Helvetica,Arial,sans-serif!important}.v-application .text-h5{font-size:1.1428571429rem!important}.v-application .text-h6{font-size:1rem!important;font-weight:500;line-height:1.4285714286rem;letter-spacing:normal!important;font-family:AkkuratLL,Helvetica,Arial,sans-serif!important}.v-application .text-subtitle-1{font-size:.8571428571rem!important}.v-application .text-subtitle-1,.v-application .text-subtitle-2{font-weight:400;line-height:1.1428571429rem;letter-spacing:normal!important;font-family:AkkuratLL,Helvetica,Arial,sans-serif!important}.v-application .text-subtitle-2{font-size:.7142857143rem!important}.v-application .text-body-1{font-size:1.1428571429rem!important;line-height:1.7142857143rem;letter-spacing:normal!important}.v-application .text-body-1,.v-application .text-body-2{font-weight:400;font-family:AkkuratLL,Helvetica,Arial,sans-serif!important}.v-application .text-body-2{font-size:1rem!important;line-height:1.4285714286rem;letter-spacing:-.02em!important}.v-application .text-button{font-size:.875rem!important;font-weight:500;line-height:2.25rem;letter-spacing:.0892857143em!important;font-family:AkkuratLL,Helvetica,Arial,sans-serif!important;text-transform:uppercase!important}.v-application .text-caption{font-weight:400;line-height:1.25rem;letter-spacing:.0333333333em!important}.v-application .text-caption,.v-application .text-overline{font-size:.75rem!important;font-family:AkkuratLL,Helvetica,Arial,sans-serif!important}.v-application .text-overline{font-weight:500;line-height:2rem;letter-spacing:.1666666667em!important;text-transform:uppercase!important}@media(min-width:600px){.v-application .d-sm-none{display:none!important}.v-application .d-sm-inline{display:inline!important}.v-application .d-sm-inline-block{display:inline-block!important}.v-application .d-sm-block{display:block!important}.v-application .d-sm-table{display:table!important}.v-application .d-sm-table-row{display:table-row!important}.v-application .d-sm-table-cell{display:table-cell!important}.v-application .d-sm-flex{display:flex!important}.v-application .d-sm-inline-flex{display:inline-flex!important}.v-application .float-sm-none{float:none!important}.v-application .float-sm-left{float:left!important}.v-application .float-sm-right{float:right!important}.v-application .flex-sm-fill{flex:1 1 auto!important}.v-application .flex-sm-row{flex-direction:row!important}.v-application .flex-sm-column{flex-direction:column!important}.v-application .flex-sm-row-reverse{flex-direction:row-reverse!important}.v-application .flex-sm-column-reverse{flex-direction:column-reverse!important}.v-application .flex-sm-grow-0{flex-grow:0!important}.v-application .flex-sm-grow-1{flex-grow:1!important}.v-application .flex-sm-shrink-0{flex-shrink:0!important}.v-application .flex-sm-shrink-1{flex-shrink:1!important}.v-application .flex-sm-wrap{flex-wrap:wrap!important}.v-application .flex-sm-nowrap{flex-wrap:nowrap!important}.v-application .flex-sm-wrap-reverse{flex-wrap:wrap-reverse!important}.v-application .justify-sm-start{justify-content:flex-start!important}.v-application .justify-sm-end{justify-content:flex-end!important}.v-application .justify-sm-center{justify-content:center!important}.v-application .justify-sm-space-between{justify-content:space-between!important}.v-application .justify-sm-space-around{justify-content:space-around!important}.v-application .align-sm-start{align-items:flex-start!important}.v-application .align-sm-end{align-items:flex-end!important}.v-application .align-sm-center{align-items:center!important}.v-application .align-sm-baseline{align-items:baseline!important}.v-application .align-sm-stretch{align-items:stretch!important}.v-application .align-content-sm-start{align-content:flex-start!important}.v-application .align-content-sm-end{align-content:flex-end!important}.v-application .align-content-sm-center{align-content:center!important}.v-application .align-content-sm-space-between{align-content:space-between!important}.v-application .align-content-sm-space-around{align-content:space-around!important}.v-application .align-content-sm-stretch{align-content:stretch!important}.v-application .align-self-sm-auto{align-self:auto!important}.v-application .align-self-sm-start{align-self:flex-start!important}.v-application .align-self-sm-end{align-self:flex-end!important}.v-application .align-self-sm-center{align-self:center!important}.v-application .align-self-sm-baseline{align-self:baseline!important}.v-application .align-self-sm-stretch{align-self:stretch!important}.v-application .order-sm-first{order:-1!important}.v-application .order-sm-0{order:0!important}.v-application .order-sm-1{order:1!important}.v-application .order-sm-2{order:2!important}.v-application .order-sm-3{order:3!important}.v-application .order-sm-4{order:4!important}.v-application .order-sm-5{order:5!important}.v-application .order-sm-6{order:6!important}.v-application .order-sm-7{order:7!important}.v-application .order-sm-8{order:8!important}.v-application .order-sm-9{order:9!important}.v-application .order-sm-10{order:10!important}.v-application .order-sm-11{order:11!important}.v-application .order-sm-12{order:12!important}.v-application .order-sm-last{order:13!important}.v-application .ma-sm-0{margin:0!important}.v-application .ma-sm-1{margin:4px!important}.v-application .ma-sm-2{margin:8px!important}.v-application .ma-sm-3{margin:12px!important}.v-application .ma-sm-4{margin:16px!important}.v-application .ma-sm-5{margin:20px!important}.v-application .ma-sm-6{margin:24px!important}.v-application .ma-sm-7{margin:28px!important}.v-application .ma-sm-8{margin:32px!important}.v-application .ma-sm-9{margin:36px!important}.v-application .ma-sm-10{margin:40px!important}.v-application .ma-sm-11{margin:44px!important}.v-application .ma-sm-12{margin:48px!important}.v-application .ma-sm-13{margin:52px!important}.v-application .ma-sm-14{margin:56px!important}.v-application .ma-sm-15{margin:60px!important}.v-application .ma-sm-16{margin:64px!important}.v-application .ma-sm-auto{margin:auto!important}.v-application .mx-sm-0{margin-right:0!important;margin-left:0!important}.v-application .mx-sm-1{margin-right:4px!important;margin-left:4px!important}.v-application .mx-sm-2{margin-right:8px!important;margin-left:8px!important}.v-application .mx-sm-3{margin-right:12px!important;margin-left:12px!important}.v-application .mx-sm-4{margin-right:16px!important;margin-left:16px!important}.v-application .mx-sm-5{margin-right:20px!important;margin-left:20px!important}.v-application .mx-sm-6{margin-right:24px!important;margin-left:24px!important}.v-application .mx-sm-7{margin-right:28px!important;margin-left:28px!important}.v-application .mx-sm-8{margin-right:32px!important;margin-left:32px!important}.v-application .mx-sm-9{margin-right:36px!important;margin-left:36px!important}.v-application .mx-sm-10{margin-right:40px!important;margin-left:40px!important}.v-application .mx-sm-11{margin-right:44px!important;margin-left:44px!important}.v-application .mx-sm-12{margin-right:48px!important;margin-left:48px!important}.v-application .mx-sm-13{margin-right:52px!important;margin-left:52px!important}.v-application .mx-sm-14{margin-right:56px!important;margin-left:56px!important}.v-application .mx-sm-15{margin-right:60px!important;margin-left:60px!important}.v-application .mx-sm-16{margin-right:64px!important;margin-left:64px!important}.v-application .mx-sm-auto{margin-right:auto!important;margin-left:auto!important}.v-application .my-sm-0{margin-top:0!important;margin-bottom:0!important}.v-application .my-sm-1{margin-top:4px!important;margin-bottom:4px!important}.v-application .my-sm-2{margin-top:8px!important;margin-bottom:8px!important}.v-application .my-sm-3{margin-top:12px!important;margin-bottom:12px!important}.v-application .my-sm-4{margin-top:16px!important;margin-bottom:16px!important}.v-application .my-sm-5{margin-top:20px!important;margin-bottom:20px!important}.v-application .my-sm-6{margin-top:24px!important;margin-bottom:24px!important}.v-application .my-sm-7{margin-top:28px!important;margin-bottom:28px!important}.v-application .my-sm-8{margin-top:32px!important;margin-bottom:32px!important}.v-application .my-sm-9{margin-top:36px!important;margin-bottom:36px!important}.v-application .my-sm-10{margin-top:40px!important;margin-bottom:40px!important}.v-application .my-sm-11{margin-top:44px!important;margin-bottom:44px!important}.v-application .my-sm-12{margin-top:48px!important;margin-bottom:48px!important}.v-application .my-sm-13{margin-top:52px!important;margin-bottom:52px!important}.v-application .my-sm-14{margin-top:56px!important;margin-bottom:56px!important}.v-application .my-sm-15{margin-top:60px!important;margin-bottom:60px!important}.v-application .my-sm-16{margin-top:64px!important;margin-bottom:64px!important}.v-application .my-sm-auto{margin-top:auto!important;margin-bottom:auto!important}.v-application .mt-sm-0{margin-top:0!important}.v-application .mt-sm-1{margin-top:4px!important}.v-application .mt-sm-2{margin-top:8px!important}.v-application .mt-sm-3{margin-top:12px!important}.v-application .mt-sm-4{margin-top:16px!important}.v-application .mt-sm-5{margin-top:20px!important}.v-application .mt-sm-6{margin-top:24px!important}.v-application .mt-sm-7{margin-top:28px!important}.v-application .mt-sm-8{margin-top:32px!important}.v-application .mt-sm-9{margin-top:36px!important}.v-application .mt-sm-10{margin-top:40px!important}.v-application .mt-sm-11{margin-top:44px!important}.v-application .mt-sm-12{margin-top:48px!important}.v-application .mt-sm-13{margin-top:52px!important}.v-application .mt-sm-14{margin-top:56px!important}.v-application .mt-sm-15{margin-top:60px!important}.v-application .mt-sm-16{margin-top:64px!important}.v-application .mt-sm-auto{margin-top:auto!important}.v-application .mr-sm-0{margin-right:0!important}.v-application .mr-sm-1{margin-right:4px!important}.v-application .mr-sm-2{margin-right:8px!important}.v-application .mr-sm-3{margin-right:12px!important}.v-application .mr-sm-4{margin-right:16px!important}.v-application .mr-sm-5{margin-right:20px!important}.v-application .mr-sm-6{margin-right:24px!important}.v-application .mr-sm-7{margin-right:28px!important}.v-application .mr-sm-8{margin-right:32px!important}.v-application .mr-sm-9{margin-right:36px!important}.v-application .mr-sm-10{margin-right:40px!important}.v-application .mr-sm-11{margin-right:44px!important}.v-application .mr-sm-12{margin-right:48px!important}.v-application .mr-sm-13{margin-right:52px!important}.v-application .mr-sm-14{margin-right:56px!important}.v-application .mr-sm-15{margin-right:60px!important}.v-application .mr-sm-16{margin-right:64px!important}.v-application .mr-sm-auto{margin-right:auto!important}.v-application .mb-sm-0{margin-bottom:0!important}.v-application .mb-sm-1{margin-bottom:4px!important}.v-application .mb-sm-2{margin-bottom:8px!important}.v-application .mb-sm-3{margin-bottom:12px!important}.v-application .mb-sm-4{margin-bottom:16px!important}.v-application .mb-sm-5{margin-bottom:20px!important}.v-application .mb-sm-6{margin-bottom:24px!important}.v-application .mb-sm-7{margin-bottom:28px!important}.v-application .mb-sm-8{margin-bottom:32px!important}.v-application .mb-sm-9{margin-bottom:36px!important}.v-application .mb-sm-10{margin-bottom:40px!important}.v-application .mb-sm-11{margin-bottom:44px!important}.v-application .mb-sm-12{margin-bottom:48px!important}.v-application .mb-sm-13{margin-bottom:52px!important}.v-application .mb-sm-14{margin-bottom:56px!important}.v-application .mb-sm-15{margin-bottom:60px!important}.v-application .mb-sm-16{margin-bottom:64px!important}.v-application .mb-sm-auto{margin-bottom:auto!important}.v-application .ml-sm-0{margin-left:0!important}.v-application .ml-sm-1{margin-left:4px!important}.v-application .ml-sm-2{margin-left:8px!important}.v-application .ml-sm-3{margin-left:12px!important}.v-application .ml-sm-4{margin-left:16px!important}.v-application .ml-sm-5{margin-left:20px!important}.v-application .ml-sm-6{margin-left:24px!important}.v-application .ml-sm-7{margin-left:28px!important}.v-application .ml-sm-8{margin-left:32px!important}.v-application .ml-sm-9{margin-left:36px!important}.v-application .ml-sm-10{margin-left:40px!important}.v-application .ml-sm-11{margin-left:44px!important}.v-application .ml-sm-12{margin-left:48px!important}.v-application .ml-sm-13{margin-left:52px!important}.v-application .ml-sm-14{margin-left:56px!important}.v-application .ml-sm-15{margin-left:60px!important}.v-application .ml-sm-16{margin-left:64px!important}.v-application .ml-sm-auto{margin-left:auto!important}.v-application--is-ltr .ms-sm-0{margin-left:0!important}.v-application--is-rtl .ms-sm-0{margin-right:0!important}.v-application--is-ltr .ms-sm-1{margin-left:4px!important}.v-application--is-rtl .ms-sm-1{margin-right:4px!important}.v-application--is-ltr .ms-sm-2{margin-left:8px!important}.v-application--is-rtl .ms-sm-2{margin-right:8px!important}.v-application--is-ltr .ms-sm-3{margin-left:12px!important}.v-application--is-rtl .ms-sm-3{margin-right:12px!important}.v-application--is-ltr .ms-sm-4{margin-left:16px!important}.v-application--is-rtl .ms-sm-4{margin-right:16px!important}.v-application--is-ltr .ms-sm-5{margin-left:20px!important}.v-application--is-rtl .ms-sm-5{margin-right:20px!important}.v-application--is-ltr .ms-sm-6{margin-left:24px!important}.v-application--is-rtl .ms-sm-6{margin-right:24px!important}.v-application--is-ltr .ms-sm-7{margin-left:28px!important}.v-application--is-rtl .ms-sm-7{margin-right:28px!important}.v-application--is-ltr .ms-sm-8{margin-left:32px!important}.v-application--is-rtl .ms-sm-8{margin-right:32px!important}.v-application--is-ltr .ms-sm-9{margin-left:36px!important}.v-application--is-rtl .ms-sm-9{margin-right:36px!important}.v-application--is-ltr .ms-sm-10{margin-left:40px!important}.v-application--is-rtl .ms-sm-10{margin-right:40px!important}.v-application--is-ltr .ms-sm-11{margin-left:44px!important}.v-application--is-rtl .ms-sm-11{margin-right:44px!important}.v-application--is-ltr .ms-sm-12{margin-left:48px!important}.v-application--is-rtl .ms-sm-12{margin-right:48px!important}.v-application--is-ltr .ms-sm-13{margin-left:52px!important}.v-application--is-rtl .ms-sm-13{margin-right:52px!important}.v-application--is-ltr .ms-sm-14{margin-left:56px!important}.v-application--is-rtl .ms-sm-14{margin-right:56px!important}.v-application--is-ltr .ms-sm-15{margin-left:60px!important}.v-application--is-rtl .ms-sm-15{margin-right:60px!important}.v-application--is-ltr .ms-sm-16{margin-left:64px!important}.v-application--is-rtl .ms-sm-16{margin-right:64px!important}.v-application--is-ltr .ms-sm-auto{margin-left:auto!important}.v-application--is-rtl .ms-sm-auto{margin-right:auto!important}.v-application--is-ltr .me-sm-0{margin-right:0!important}.v-application--is-rtl .me-sm-0{margin-left:0!important}.v-application--is-ltr .me-sm-1{margin-right:4px!important}.v-application--is-rtl .me-sm-1{margin-left:4px!important}.v-application--is-ltr .me-sm-2{margin-right:8px!important}.v-application--is-rtl .me-sm-2{margin-left:8px!important}.v-application--is-ltr .me-sm-3{margin-right:12px!important}.v-application--is-rtl .me-sm-3{margin-left:12px!important}.v-application--is-ltr .me-sm-4{margin-right:16px!important}.v-application--is-rtl .me-sm-4{margin-left:16px!important}.v-application--is-ltr .me-sm-5{margin-right:20px!important}.v-application--is-rtl .me-sm-5{margin-left:20px!important}.v-application--is-ltr .me-sm-6{margin-right:24px!important}.v-application--is-rtl .me-sm-6{margin-left:24px!important}.v-application--is-ltr .me-sm-7{margin-right:28px!important}.v-application--is-rtl .me-sm-7{margin-left:28px!important}.v-application--is-ltr .me-sm-8{margin-right:32px!important}.v-application--is-rtl .me-sm-8{margin-left:32px!important}.v-application--is-ltr .me-sm-9{margin-right:36px!important}.v-application--is-rtl .me-sm-9{margin-left:36px!important}.v-application--is-ltr .me-sm-10{margin-right:40px!important}.v-application--is-rtl .me-sm-10{margin-left:40px!important}.v-application--is-ltr .me-sm-11{margin-right:44px!important}.v-application--is-rtl .me-sm-11{margin-left:44px!important}.v-application--is-ltr .me-sm-12{margin-right:48px!important}.v-application--is-rtl .me-sm-12{margin-left:48px!important}.v-application--is-ltr .me-sm-13{margin-right:52px!important}.v-application--is-rtl .me-sm-13{margin-left:52px!important}.v-application--is-ltr .me-sm-14{margin-right:56px!important}.v-application--is-rtl .me-sm-14{margin-left:56px!important}.v-application--is-ltr .me-sm-15{margin-right:60px!important}.v-application--is-rtl .me-sm-15{margin-left:60px!important}.v-application--is-ltr .me-sm-16{margin-right:64px!important}.v-application--is-rtl .me-sm-16{margin-left:64px!important}.v-application--is-ltr .me-sm-auto{margin-right:auto!important}.v-application--is-rtl .me-sm-auto{margin-left:auto!important}.v-application .ma-sm-n1{margin:-4px!important}.v-application .ma-sm-n2{margin:-8px!important}.v-application .ma-sm-n3{margin:-12px!important}.v-application .ma-sm-n4{margin:-16px!important}.v-application .ma-sm-n5{margin:-20px!important}.v-application .ma-sm-n6{margin:-24px!important}.v-application .ma-sm-n7{margin:-28px!important}.v-application .ma-sm-n8{margin:-32px!important}.v-application .ma-sm-n9{margin:-36px!important}.v-application .ma-sm-n10{margin:-40px!important}.v-application .ma-sm-n11{margin:-44px!important}.v-application .ma-sm-n12{margin:-48px!important}.v-application .ma-sm-n13{margin:-52px!important}.v-application .ma-sm-n14{margin:-56px!important}.v-application .ma-sm-n15{margin:-60px!important}.v-application .ma-sm-n16{margin:-64px!important}.v-application .mx-sm-n1{margin-right:-4px!important;margin-left:-4px!important}.v-application .mx-sm-n2{margin-right:-8px!important;margin-left:-8px!important}.v-application .mx-sm-n3{margin-right:-12px!important;margin-left:-12px!important}.v-application .mx-sm-n4{margin-right:-16px!important;margin-left:-16px!important}.v-application .mx-sm-n5{margin-right:-20px!important;margin-left:-20px!important}.v-application .mx-sm-n6{margin-right:-24px!important;margin-left:-24px!important}.v-application .mx-sm-n7{margin-right:-28px!important;margin-left:-28px!important}.v-application .mx-sm-n8{margin-right:-32px!important;margin-left:-32px!important}.v-application .mx-sm-n9{margin-right:-36px!important;margin-left:-36px!important}.v-application .mx-sm-n10{margin-right:-40px!important;margin-left:-40px!important}.v-application .mx-sm-n11{margin-right:-44px!important;margin-left:-44px!important}.v-application .mx-sm-n12{margin-right:-48px!important;margin-left:-48px!important}.v-application .mx-sm-n13{margin-right:-52px!important;margin-left:-52px!important}.v-application .mx-sm-n14{margin-right:-56px!important;margin-left:-56px!important}.v-application .mx-sm-n15{margin-right:-60px!important;margin-left:-60px!important}.v-application .mx-sm-n16{margin-right:-64px!important;margin-left:-64px!important}.v-application .my-sm-n1{margin-top:-4px!important;margin-bottom:-4px!important}.v-application .my-sm-n2{margin-top:-8px!important;margin-bottom:-8px!important}.v-application .my-sm-n3{margin-top:-12px!important;margin-bottom:-12px!important}.v-application .my-sm-n4{margin-top:-16px!important;margin-bottom:-16px!important}.v-application .my-sm-n5{margin-top:-20px!important;margin-bottom:-20px!important}.v-application .my-sm-n6{margin-top:-24px!important;margin-bottom:-24px!important}.v-application .my-sm-n7{margin-top:-28px!important;margin-bottom:-28px!important}.v-application .my-sm-n8{margin-top:-32px!important;margin-bottom:-32px!important}.v-application .my-sm-n9{margin-top:-36px!important;margin-bottom:-36px!important}.v-application .my-sm-n10{margin-top:-40px!important;margin-bottom:-40px!important}.v-application .my-sm-n11{margin-top:-44px!important;margin-bottom:-44px!important}.v-application .my-sm-n12{margin-top:-48px!important;margin-bottom:-48px!important}.v-application .my-sm-n13{margin-top:-52px!important;margin-bottom:-52px!important}.v-application .my-sm-n14{margin-top:-56px!important;margin-bottom:-56px!important}.v-application .my-sm-n15{margin-top:-60px!important;margin-bottom:-60px!important}.v-application .my-sm-n16{margin-top:-64px!important;margin-bottom:-64px!important}.v-application .mt-sm-n1{margin-top:-4px!important}.v-application .mt-sm-n2{margin-top:-8px!important}.v-application .mt-sm-n3{margin-top:-12px!important}.v-application .mt-sm-n4{margin-top:-16px!important}.v-application .mt-sm-n5{margin-top:-20px!important}.v-application .mt-sm-n6{margin-top:-24px!important}.v-application .mt-sm-n7{margin-top:-28px!important}.v-application .mt-sm-n8{margin-top:-32px!important}.v-application .mt-sm-n9{margin-top:-36px!important}.v-application .mt-sm-n10{margin-top:-40px!important}.v-application .mt-sm-n11{margin-top:-44px!important}.v-application .mt-sm-n12{margin-top:-48px!important}.v-application .mt-sm-n13{margin-top:-52px!important}.v-application .mt-sm-n14{margin-top:-56px!important}.v-application .mt-sm-n15{margin-top:-60px!important}.v-application .mt-sm-n16{margin-top:-64px!important}.v-application .mr-sm-n1{margin-right:-4px!important}.v-application .mr-sm-n2{margin-right:-8px!important}.v-application .mr-sm-n3{margin-right:-12px!important}.v-application .mr-sm-n4{margin-right:-16px!important}.v-application .mr-sm-n5{margin-right:-20px!important}.v-application .mr-sm-n6{margin-right:-24px!important}.v-application .mr-sm-n7{margin-right:-28px!important}.v-application .mr-sm-n8{margin-right:-32px!important}.v-application .mr-sm-n9{margin-right:-36px!important}.v-application .mr-sm-n10{margin-right:-40px!important}.v-application .mr-sm-n11{margin-right:-44px!important}.v-application .mr-sm-n12{margin-right:-48px!important}.v-application .mr-sm-n13{margin-right:-52px!important}.v-application .mr-sm-n14{margin-right:-56px!important}.v-application .mr-sm-n15{margin-right:-60px!important}.v-application .mr-sm-n16{margin-right:-64px!important}.v-application .mb-sm-n1{margin-bottom:-4px!important}.v-application .mb-sm-n2{margin-bottom:-8px!important}.v-application .mb-sm-n3{margin-bottom:-12px!important}.v-application .mb-sm-n4{margin-bottom:-16px!important}.v-application .mb-sm-n5{margin-bottom:-20px!important}.v-application .mb-sm-n6{margin-bottom:-24px!important}.v-application .mb-sm-n7{margin-bottom:-28px!important}.v-application .mb-sm-n8{margin-bottom:-32px!important}.v-application .mb-sm-n9{margin-bottom:-36px!important}.v-application .mb-sm-n10{margin-bottom:-40px!important}.v-application .mb-sm-n11{margin-bottom:-44px!important}.v-application .mb-sm-n12{margin-bottom:-48px!important}.v-application .mb-sm-n13{margin-bottom:-52px!important}.v-application .mb-sm-n14{margin-bottom:-56px!important}.v-application .mb-sm-n15{margin-bottom:-60px!important}.v-application .mb-sm-n16{margin-bottom:-64px!important}.v-application .ml-sm-n1{margin-left:-4px!important}.v-application .ml-sm-n2{margin-left:-8px!important}.v-application .ml-sm-n3{margin-left:-12px!important}.v-application .ml-sm-n4{margin-left:-16px!important}.v-application .ml-sm-n5{margin-left:-20px!important}.v-application .ml-sm-n6{margin-left:-24px!important}.v-application .ml-sm-n7{margin-left:-28px!important}.v-application .ml-sm-n8{margin-left:-32px!important}.v-application .ml-sm-n9{margin-left:-36px!important}.v-application .ml-sm-n10{margin-left:-40px!important}.v-application .ml-sm-n11{margin-left:-44px!important}.v-application .ml-sm-n12{margin-left:-48px!important}.v-application .ml-sm-n13{margin-left:-52px!important}.v-application .ml-sm-n14{margin-left:-56px!important}.v-application .ml-sm-n15{margin-left:-60px!important}.v-application .ml-sm-n16{margin-left:-64px!important}.v-application--is-ltr .ms-sm-n1{margin-left:-4px!important}.v-application--is-rtl .ms-sm-n1{margin-right:-4px!important}.v-application--is-ltr .ms-sm-n2{margin-left:-8px!important}.v-application--is-rtl .ms-sm-n2{margin-right:-8px!important}.v-application--is-ltr .ms-sm-n3{margin-left:-12px!important}.v-application--is-rtl .ms-sm-n3{margin-right:-12px!important}.v-application--is-ltr .ms-sm-n4{margin-left:-16px!important}.v-application--is-rtl .ms-sm-n4{margin-right:-16px!important}.v-application--is-ltr .ms-sm-n5{margin-left:-20px!important}.v-application--is-rtl .ms-sm-n5{margin-right:-20px!important}.v-application--is-ltr .ms-sm-n6{margin-left:-24px!important}.v-application--is-rtl .ms-sm-n6{margin-right:-24px!important}.v-application--is-ltr .ms-sm-n7{margin-left:-28px!important}.v-application--is-rtl .ms-sm-n7{margin-right:-28px!important}.v-application--is-ltr .ms-sm-n8{margin-left:-32px!important}.v-application--is-rtl .ms-sm-n8{margin-right:-32px!important}.v-application--is-ltr .ms-sm-n9{margin-left:-36px!important}.v-application--is-rtl .ms-sm-n9{margin-right:-36px!important}.v-application--is-ltr .ms-sm-n10{margin-left:-40px!important}.v-application--is-rtl .ms-sm-n10{margin-right:-40px!important}.v-application--is-ltr .ms-sm-n11{margin-left:-44px!important}.v-application--is-rtl .ms-sm-n11{margin-right:-44px!important}.v-application--is-ltr .ms-sm-n12{margin-left:-48px!important}.v-application--is-rtl .ms-sm-n12{margin-right:-48px!important}.v-application--is-ltr .ms-sm-n13{margin-left:-52px!important}.v-application--is-rtl .ms-sm-n13{margin-right:-52px!important}.v-application--is-ltr .ms-sm-n14{margin-left:-56px!important}.v-application--is-rtl .ms-sm-n14{margin-right:-56px!important}.v-application--is-ltr .ms-sm-n15{margin-left:-60px!important}.v-application--is-rtl .ms-sm-n15{margin-right:-60px!important}.v-application--is-ltr .ms-sm-n16{margin-left:-64px!important}.v-application--is-rtl .ms-sm-n16{margin-right:-64px!important}.v-application--is-ltr .me-sm-n1{margin-right:-4px!important}.v-application--is-rtl .me-sm-n1{margin-left:-4px!important}.v-application--is-ltr .me-sm-n2{margin-right:-8px!important}.v-application--is-rtl .me-sm-n2{margin-left:-8px!important}.v-application--is-ltr .me-sm-n3{margin-right:-12px!important}.v-application--is-rtl .me-sm-n3{margin-left:-12px!important}.v-application--is-ltr .me-sm-n4{margin-right:-16px!important}.v-application--is-rtl .me-sm-n4{margin-left:-16px!important}.v-application--is-ltr .me-sm-n5{margin-right:-20px!important}.v-application--is-rtl .me-sm-n5{margin-left:-20px!important}.v-application--is-ltr .me-sm-n6{margin-right:-24px!important}.v-application--is-rtl .me-sm-n6{margin-left:-24px!important}.v-application--is-ltr .me-sm-n7{margin-right:-28px!important}.v-application--is-rtl .me-sm-n7{margin-left:-28px!important}.v-application--is-ltr .me-sm-n8{margin-right:-32px!important}.v-application--is-rtl .me-sm-n8{margin-left:-32px!important}.v-application--is-ltr .me-sm-n9{margin-right:-36px!important}.v-application--is-rtl .me-sm-n9{margin-left:-36px!important}.v-application--is-ltr .me-sm-n10{margin-right:-40px!important}.v-application--is-rtl .me-sm-n10{margin-left:-40px!important}.v-application--is-ltr .me-sm-n11{margin-right:-44px!important}.v-application--is-rtl .me-sm-n11{margin-left:-44px!important}.v-application--is-ltr .me-sm-n12{margin-right:-48px!important}.v-application--is-rtl .me-sm-n12{margin-left:-48px!important}.v-application--is-ltr .me-sm-n13{margin-right:-52px!important}.v-application--is-rtl .me-sm-n13{margin-left:-52px!important}.v-application--is-ltr .me-sm-n14{margin-right:-56px!important}.v-application--is-rtl .me-sm-n14{margin-left:-56px!important}.v-application--is-ltr .me-sm-n15{margin-right:-60px!important}.v-application--is-rtl .me-sm-n15{margin-left:-60px!important}.v-application--is-ltr .me-sm-n16{margin-right:-64px!important}.v-application--is-rtl .me-sm-n16{margin-left:-64px!important}.v-application .pa-sm-0{padding:0!important}.v-application .pa-sm-1{padding:4px!important}.v-application .pa-sm-2{padding:8px!important}.v-application .pa-sm-3{padding:12px!important}.v-application .pa-sm-4{padding:16px!important}.v-application .pa-sm-5{padding:20px!important}.v-application .pa-sm-6{padding:24px!important}.v-application .pa-sm-7{padding:28px!important}.v-application .pa-sm-8{padding:32px!important}.v-application .pa-sm-9{padding:36px!important}.v-application .pa-sm-10{padding:40px!important}.v-application .pa-sm-11{padding:44px!important}.v-application .pa-sm-12{padding:48px!important}.v-application .pa-sm-13{padding:52px!important}.v-application .pa-sm-14{padding:56px!important}.v-application .pa-sm-15{padding:60px!important}.v-application .pa-sm-16{padding:64px!important}.v-application .px-sm-0{padding-right:0!important;padding-left:0!important}.v-application .px-sm-1{padding-right:4px!important;padding-left:4px!important}.v-application .px-sm-2{padding-right:8px!important;padding-left:8px!important}.v-application .px-sm-3{padding-right:12px!important;padding-left:12px!important}.v-application .px-sm-4{padding-right:16px!important;padding-left:16px!important}.v-application .px-sm-5{padding-right:20px!important;padding-left:20px!important}.v-application .px-sm-6{padding-right:24px!important;padding-left:24px!important}.v-application .px-sm-7{padding-right:28px!important;padding-left:28px!important}.v-application .px-sm-8{padding-right:32px!important;padding-left:32px!important}.v-application .px-sm-9{padding-right:36px!important;padding-left:36px!important}.v-application .px-sm-10{padding-right:40px!important;padding-left:40px!important}.v-application .px-sm-11{padding-right:44px!important;padding-left:44px!important}.v-application .px-sm-12{padding-right:48px!important;padding-left:48px!important}.v-application .px-sm-13{padding-right:52px!important;padding-left:52px!important}.v-application .px-sm-14{padding-right:56px!important;padding-left:56px!important}.v-application .px-sm-15{padding-right:60px!important;padding-left:60px!important}.v-application .px-sm-16{padding-right:64px!important;padding-left:64px!important}.v-application .py-sm-0{padding-top:0!important;padding-bottom:0!important}.v-application .py-sm-1{padding-top:4px!important;padding-bottom:4px!important}.v-application .py-sm-2{padding-top:8px!important;padding-bottom:8px!important}.v-application .py-sm-3{padding-top:12px!important;padding-bottom:12px!important}.v-application .py-sm-4{padding-top:16px!important;padding-bottom:16px!important}.v-application .py-sm-5{padding-top:20px!important;padding-bottom:20px!important}.v-application .py-sm-6{padding-top:24px!important;padding-bottom:24px!important}.v-application .py-sm-7{padding-top:28px!important;padding-bottom:28px!important}.v-application .py-sm-8{padding-top:32px!important;padding-bottom:32px!important}.v-application .py-sm-9{padding-top:36px!important;padding-bottom:36px!important}.v-application .py-sm-10{padding-top:40px!important;padding-bottom:40px!important}.v-application .py-sm-11{padding-top:44px!important;padding-bottom:44px!important}.v-application .py-sm-12{padding-top:48px!important;padding-bottom:48px!important}.v-application .py-sm-13{padding-top:52px!important;padding-bottom:52px!important}.v-application .py-sm-14{padding-top:56px!important;padding-bottom:56px!important}.v-application .py-sm-15{padding-top:60px!important;padding-bottom:60px!important}.v-application .py-sm-16{padding-top:64px!important;padding-bottom:64px!important}.v-application .pt-sm-0{padding-top:0!important}.v-application .pt-sm-1{padding-top:4px!important}.v-application .pt-sm-2{padding-top:8px!important}.v-application .pt-sm-3{padding-top:12px!important}.v-application .pt-sm-4{padding-top:16px!important}.v-application .pt-sm-5{padding-top:20px!important}.v-application .pt-sm-6{padding-top:24px!important}.v-application .pt-sm-7{padding-top:28px!important}.v-application .pt-sm-8{padding-top:32px!important}.v-application .pt-sm-9{padding-top:36px!important}.v-application .pt-sm-10{padding-top:40px!important}.v-application .pt-sm-11{padding-top:44px!important}.v-application .pt-sm-12{padding-top:48px!important}.v-application .pt-sm-13{padding-top:52px!important}.v-application .pt-sm-14{padding-top:56px!important}.v-application .pt-sm-15{padding-top:60px!important}.v-application .pt-sm-16{padding-top:64px!important}.v-application .pr-sm-0{padding-right:0!important}.v-application .pr-sm-1{padding-right:4px!important}.v-application .pr-sm-2{padding-right:8px!important}.v-application .pr-sm-3{padding-right:12px!important}.v-application .pr-sm-4{padding-right:16px!important}.v-application .pr-sm-5{padding-right:20px!important}.v-application .pr-sm-6{padding-right:24px!important}.v-application .pr-sm-7{padding-right:28px!important}.v-application .pr-sm-8{padding-right:32px!important}.v-application .pr-sm-9{padding-right:36px!important}.v-application .pr-sm-10{padding-right:40px!important}.v-application .pr-sm-11{padding-right:44px!important}.v-application .pr-sm-12{padding-right:48px!important}.v-application .pr-sm-13{padding-right:52px!important}.v-application .pr-sm-14{padding-right:56px!important}.v-application .pr-sm-15{padding-right:60px!important}.v-application .pr-sm-16{padding-right:64px!important}.v-application .pb-sm-0{padding-bottom:0!important}.v-application .pb-sm-1{padding-bottom:4px!important}.v-application .pb-sm-2{padding-bottom:8px!important}.v-application .pb-sm-3{padding-bottom:12px!important}.v-application .pb-sm-4{padding-bottom:16px!important}.v-application .pb-sm-5{padding-bottom:20px!important}.v-application .pb-sm-6{padding-bottom:24px!important}.v-application .pb-sm-7{padding-bottom:28px!important}.v-application .pb-sm-8{padding-bottom:32px!important}.v-application .pb-sm-9{padding-bottom:36px!important}.v-application .pb-sm-10{padding-bottom:40px!important}.v-application .pb-sm-11{padding-bottom:44px!important}.v-application .pb-sm-12{padding-bottom:48px!important}.v-application .pb-sm-13{padding-bottom:52px!important}.v-application .pb-sm-14{padding-bottom:56px!important}.v-application .pb-sm-15{padding-bottom:60px!important}.v-application .pb-sm-16{padding-bottom:64px!important}.v-application .pl-sm-0{padding-left:0!important}.v-application .pl-sm-1{padding-left:4px!important}.v-application .pl-sm-2{padding-left:8px!important}.v-application .pl-sm-3{padding-left:12px!important}.v-application .pl-sm-4{padding-left:16px!important}.v-application .pl-sm-5{padding-left:20px!important}.v-application .pl-sm-6{padding-left:24px!important}.v-application .pl-sm-7{padding-left:28px!important}.v-application .pl-sm-8{padding-left:32px!important}.v-application .pl-sm-9{padding-left:36px!important}.v-application .pl-sm-10{padding-left:40px!important}.v-application .pl-sm-11{padding-left:44px!important}.v-application .pl-sm-12{padding-left:48px!important}.v-application .pl-sm-13{padding-left:52px!important}.v-application .pl-sm-14{padding-left:56px!important}.v-application .pl-sm-15{padding-left:60px!important}.v-application .pl-sm-16{padding-left:64px!important}.v-application--is-ltr .ps-sm-0{padding-left:0!important}.v-application--is-rtl .ps-sm-0{padding-right:0!important}.v-application--is-ltr .ps-sm-1{padding-left:4px!important}.v-application--is-rtl .ps-sm-1{padding-right:4px!important}.v-application--is-ltr .ps-sm-2{padding-left:8px!important}.v-application--is-rtl .ps-sm-2{padding-right:8px!important}.v-application--is-ltr .ps-sm-3{padding-left:12px!important}.v-application--is-rtl .ps-sm-3{padding-right:12px!important}.v-application--is-ltr .ps-sm-4{padding-left:16px!important}.v-application--is-rtl .ps-sm-4{padding-right:16px!important}.v-application--is-ltr .ps-sm-5{padding-left:20px!important}.v-application--is-rtl .ps-sm-5{padding-right:20px!important}.v-application--is-ltr .ps-sm-6{padding-left:24px!important}.v-application--is-rtl .ps-sm-6{padding-right:24px!important}.v-application--is-ltr .ps-sm-7{padding-left:28px!important}.v-application--is-rtl .ps-sm-7{padding-right:28px!important}.v-application--is-ltr .ps-sm-8{padding-left:32px!important}.v-application--is-rtl .ps-sm-8{padding-right:32px!important}.v-application--is-ltr .ps-sm-9{padding-left:36px!important}.v-application--is-rtl .ps-sm-9{padding-right:36px!important}.v-application--is-ltr .ps-sm-10{padding-left:40px!important}.v-application--is-rtl .ps-sm-10{padding-right:40px!important}.v-application--is-ltr .ps-sm-11{padding-left:44px!important}.v-application--is-rtl .ps-sm-11{padding-right:44px!important}.v-application--is-ltr .ps-sm-12{padding-left:48px!important}.v-application--is-rtl .ps-sm-12{padding-right:48px!important}.v-application--is-ltr .ps-sm-13{padding-left:52px!important}.v-application--is-rtl .ps-sm-13{padding-right:52px!important}.v-application--is-ltr .ps-sm-14{padding-left:56px!important}.v-application--is-rtl .ps-sm-14{padding-right:56px!important}.v-application--is-ltr .ps-sm-15{padding-left:60px!important}.v-application--is-rtl .ps-sm-15{padding-right:60px!important}.v-application--is-ltr .ps-sm-16{padding-left:64px!important}.v-application--is-rtl .ps-sm-16{padding-right:64px!important}.v-application--is-ltr .pe-sm-0{padding-right:0!important}.v-application--is-rtl .pe-sm-0{padding-left:0!important}.v-application--is-ltr .pe-sm-1{padding-right:4px!important}.v-application--is-rtl .pe-sm-1{padding-left:4px!important}.v-application--is-ltr .pe-sm-2{padding-right:8px!important}.v-application--is-rtl .pe-sm-2{padding-left:8px!important}.v-application--is-ltr .pe-sm-3{padding-right:12px!important}.v-application--is-rtl .pe-sm-3{padding-left:12px!important}.v-application--is-ltr .pe-sm-4{padding-right:16px!important}.v-application--is-rtl .pe-sm-4{padding-left:16px!important}.v-application--is-ltr .pe-sm-5{padding-right:20px!important}.v-application--is-rtl .pe-sm-5{padding-left:20px!important}.v-application--is-ltr .pe-sm-6{padding-right:24px!important}.v-application--is-rtl .pe-sm-6{padding-left:24px!important}.v-application--is-ltr .pe-sm-7{padding-right:28px!important}.v-application--is-rtl .pe-sm-7{padding-left:28px!important}.v-application--is-ltr .pe-sm-8{padding-right:32px!important}.v-application--is-rtl .pe-sm-8{padding-left:32px!important}.v-application--is-ltr .pe-sm-9{padding-right:36px!important}.v-application--is-rtl .pe-sm-9{padding-left:36px!important}.v-application--is-ltr .pe-sm-10{padding-right:40px!important}.v-application--is-rtl .pe-sm-10{padding-left:40px!important}.v-application--is-ltr .pe-sm-11{padding-right:44px!important}.v-application--is-rtl .pe-sm-11{padding-left:44px!important}.v-application--is-ltr .pe-sm-12{padding-right:48px!important}.v-application--is-rtl .pe-sm-12{padding-left:48px!important}.v-application--is-ltr .pe-sm-13{padding-right:52px!important}.v-application--is-rtl .pe-sm-13{padding-left:52px!important}.v-application--is-ltr .pe-sm-14{padding-right:56px!important}.v-application--is-rtl .pe-sm-14{padding-left:56px!important}.v-application--is-ltr .pe-sm-15{padding-right:60px!important}.v-application--is-rtl .pe-sm-15{padding-left:60px!important}.v-application--is-ltr .pe-sm-16{padding-right:64px!important}.v-application--is-rtl .pe-sm-16{padding-left:64px!important}.v-application .text-sm-left{text-align:left!important}.v-application .text-sm-right{text-align:right!important}.v-application .text-sm-center{text-align:center!important}.v-application .text-sm-justify{text-align:justify!important}.v-application .text-sm-start{text-align:start!important}.v-application .text-sm-end{text-align:end!important}.v-application .text-sm-h1{font-size:2rem!important;font-weight:600;line-height:2.4285714286rem;letter-spacing:-.02em!important;font-family:AkkuratLL,Helvetica,Arial,sans-serif!important}.v-application .text-sm-h2{font-size:1.7142857143rem!important;line-height:2.2857142857rem}.v-application .text-sm-h2,.v-application .text-sm-h3{font-weight:600;letter-spacing:-.01em!important;font-family:AkkuratLL,Helvetica,Arial,sans-serif!important}.v-application .text-sm-h3{font-size:1.4285714286rem!important;line-height:2rem}.v-application .text-sm-h4{font-size:1.2857142857rem!important}.v-application .text-sm-h4,.v-application .text-sm-h5{font-weight:600;line-height:1.7142857143rem;letter-spacing:-.01em!important;font-family:AkkuratLL,Helvetica,Arial,sans-serif!important}.v-application .text-sm-h5{font-size:1.1428571429rem!important}.v-application .text-sm-h6{font-size:1rem!important;font-weight:500;line-height:1.4285714286rem;letter-spacing:normal!important;font-family:AkkuratLL,Helvetica,Arial,sans-serif!important}.v-application .text-sm-subtitle-1{font-size:.8571428571rem!important}.v-application .text-sm-subtitle-1,.v-application .text-sm-subtitle-2{font-weight:400;line-height:1.1428571429rem;letter-spacing:normal!important;font-family:AkkuratLL,Helvetica,Arial,sans-serif!important}.v-application .text-sm-subtitle-2{font-size:.7142857143rem!important}.v-application .text-sm-body-1{font-size:1.1428571429rem!important;line-height:1.7142857143rem;letter-spacing:normal!important}.v-application .text-sm-body-1,.v-application .text-sm-body-2{font-weight:400;font-family:AkkuratLL,Helvetica,Arial,sans-serif!important}.v-application .text-sm-body-2{font-size:1rem!important;line-height:1.4285714286rem;letter-spacing:-.02em!important}.v-application .text-sm-button{font-size:.875rem!important;font-weight:500;line-height:2.25rem;letter-spacing:.0892857143em!important;font-family:AkkuratLL,Helvetica,Arial,sans-serif!important;text-transform:uppercase!important}.v-application .text-sm-caption{font-weight:400;line-height:1.25rem;letter-spacing:.0333333333em!important}.v-application .text-sm-caption,.v-application .text-sm-overline{font-size:.75rem!important;font-family:AkkuratLL,Helvetica,Arial,sans-serif!important}.v-application .text-sm-overline{font-weight:500;line-height:2rem;letter-spacing:.1666666667em!important;text-transform:uppercase!important}}@media(min-width:960px){.v-application .d-md-none{display:none!important}.v-application .d-md-inline{display:inline!important}.v-application .d-md-inline-block{display:inline-block!important}.v-application .d-md-block{display:block!important}.v-application .d-md-table{display:table!important}.v-application .d-md-table-row{display:table-row!important}.v-application .d-md-table-cell{display:table-cell!important}.v-application .d-md-flex{display:flex!important}.v-application .d-md-inline-flex{display:inline-flex!important}.v-application .float-md-none{float:none!important}.v-application .float-md-left{float:left!important}.v-application .float-md-right{float:right!important}.v-application .flex-md-fill{flex:1 1 auto!important}.v-application .flex-md-row{flex-direction:row!important}.v-application .flex-md-column{flex-direction:column!important}.v-application .flex-md-row-reverse{flex-direction:row-reverse!important}.v-application .flex-md-column-reverse{flex-direction:column-reverse!important}.v-application .flex-md-grow-0{flex-grow:0!important}.v-application .flex-md-grow-1{flex-grow:1!important}.v-application .flex-md-shrink-0{flex-shrink:0!important}.v-application .flex-md-shrink-1{flex-shrink:1!important}.v-application .flex-md-wrap{flex-wrap:wrap!important}.v-application .flex-md-nowrap{flex-wrap:nowrap!important}.v-application .flex-md-wrap-reverse{flex-wrap:wrap-reverse!important}.v-application .justify-md-start{justify-content:flex-start!important}.v-application .justify-md-end{justify-content:flex-end!important}.v-application .justify-md-center{justify-content:center!important}.v-application .justify-md-space-between{justify-content:space-between!important}.v-application .justify-md-space-around{justify-content:space-around!important}.v-application .align-md-start{align-items:flex-start!important}.v-application .align-md-end{align-items:flex-end!important}.v-application .align-md-center{align-items:center!important}.v-application .align-md-baseline{align-items:baseline!important}.v-application .align-md-stretch{align-items:stretch!important}.v-application .align-content-md-start{align-content:flex-start!important}.v-application .align-content-md-end{align-content:flex-end!important}.v-application .align-content-md-center{align-content:center!important}.v-application .align-content-md-space-between{align-content:space-between!important}.v-application .align-content-md-space-around{align-content:space-around!important}.v-application .align-content-md-stretch{align-content:stretch!important}.v-application .align-self-md-auto{align-self:auto!important}.v-application .align-self-md-start{align-self:flex-start!important}.v-application .align-self-md-end{align-self:flex-end!important}.v-application .align-self-md-center{align-self:center!important}.v-application .align-self-md-baseline{align-self:baseline!important}.v-application .align-self-md-stretch{align-self:stretch!important}.v-application .order-md-first{order:-1!important}.v-application .order-md-0{order:0!important}.v-application .order-md-1{order:1!important}.v-application .order-md-2{order:2!important}.v-application .order-md-3{order:3!important}.v-application .order-md-4{order:4!important}.v-application .order-md-5{order:5!important}.v-application .order-md-6{order:6!important}.v-application .order-md-7{order:7!important}.v-application .order-md-8{order:8!important}.v-application .order-md-9{order:9!important}.v-application .order-md-10{order:10!important}.v-application .order-md-11{order:11!important}.v-application .order-md-12{order:12!important}.v-application .order-md-last{order:13!important}.v-application .ma-md-0{margin:0!important}.v-application .ma-md-1{margin:4px!important}.v-application .ma-md-2{margin:8px!important}.v-application .ma-md-3{margin:12px!important}.v-application .ma-md-4{margin:16px!important}.v-application .ma-md-5{margin:20px!important}.v-application .ma-md-6{margin:24px!important}.v-application .ma-md-7{margin:28px!important}.v-application .ma-md-8{margin:32px!important}.v-application .ma-md-9{margin:36px!important}.v-application .ma-md-10{margin:40px!important}.v-application .ma-md-11{margin:44px!important}.v-application .ma-md-12{margin:48px!important}.v-application .ma-md-13{margin:52px!important}.v-application .ma-md-14{margin:56px!important}.v-application .ma-md-15{margin:60px!important}.v-application .ma-md-16{margin:64px!important}.v-application .ma-md-auto{margin:auto!important}.v-application .mx-md-0{margin-right:0!important;margin-left:0!important}.v-application .mx-md-1{margin-right:4px!important;margin-left:4px!important}.v-application .mx-md-2{margin-right:8px!important;margin-left:8px!important}.v-application .mx-md-3{margin-right:12px!important;margin-left:12px!important}.v-application .mx-md-4{margin-right:16px!important;margin-left:16px!important}.v-application .mx-md-5{margin-right:20px!important;margin-left:20px!important}.v-application .mx-md-6{margin-right:24px!important;margin-left:24px!important}.v-application .mx-md-7{margin-right:28px!important;margin-left:28px!important}.v-application .mx-md-8{margin-right:32px!important;margin-left:32px!important}.v-application .mx-md-9{margin-right:36px!important;margin-left:36px!important}.v-application .mx-md-10{margin-right:40px!important;margin-left:40px!important}.v-application .mx-md-11{margin-right:44px!important;margin-left:44px!important}.v-application .mx-md-12{margin-right:48px!important;margin-left:48px!important}.v-application .mx-md-13{margin-right:52px!important;margin-left:52px!important}.v-application .mx-md-14{margin-right:56px!important;margin-left:56px!important}.v-application .mx-md-15{margin-right:60px!important;margin-left:60px!important}.v-application .mx-md-16{margin-right:64px!important;margin-left:64px!important}.v-application .mx-md-auto{margin-right:auto!important;margin-left:auto!important}.v-application .my-md-0{margin-top:0!important;margin-bottom:0!important}.v-application .my-md-1{margin-top:4px!important;margin-bottom:4px!important}.v-application .my-md-2{margin-top:8px!important;margin-bottom:8px!important}.v-application .my-md-3{margin-top:12px!important;margin-bottom:12px!important}.v-application .my-md-4{margin-top:16px!important;margin-bottom:16px!important}.v-application .my-md-5{margin-top:20px!important;margin-bottom:20px!important}.v-application .my-md-6{margin-top:24px!important;margin-bottom:24px!important}.v-application .my-md-7{margin-top:28px!important;margin-bottom:28px!important}.v-application .my-md-8{margin-top:32px!important;margin-bottom:32px!important}.v-application .my-md-9{margin-top:36px!important;margin-bottom:36px!important}.v-application .my-md-10{margin-top:40px!important;margin-bottom:40px!important}.v-application .my-md-11{margin-top:44px!important;margin-bottom:44px!important}.v-application .my-md-12{margin-top:48px!important;margin-bottom:48px!important}.v-application .my-md-13{margin-top:52px!important;margin-bottom:52px!important}.v-application .my-md-14{margin-top:56px!important;margin-bottom:56px!important}.v-application .my-md-15{margin-top:60px!important;margin-bottom:60px!important}.v-application .my-md-16{margin-top:64px!important;margin-bottom:64px!important}.v-application .my-md-auto{margin-top:auto!important;margin-bottom:auto!important}.v-application .mt-md-0{margin-top:0!important}.v-application .mt-md-1{margin-top:4px!important}.v-application .mt-md-2{margin-top:8px!important}.v-application .mt-md-3{margin-top:12px!important}.v-application .mt-md-4{margin-top:16px!important}.v-application .mt-md-5{margin-top:20px!important}.v-application .mt-md-6{margin-top:24px!important}.v-application .mt-md-7{margin-top:28px!important}.v-application .mt-md-8{margin-top:32px!important}.v-application .mt-md-9{margin-top:36px!important}.v-application .mt-md-10{margin-top:40px!important}.v-application .mt-md-11{margin-top:44px!important}.v-application .mt-md-12{margin-top:48px!important}.v-application .mt-md-13{margin-top:52px!important}.v-application .mt-md-14{margin-top:56px!important}.v-application .mt-md-15{margin-top:60px!important}.v-application .mt-md-16{margin-top:64px!important}.v-application .mt-md-auto{margin-top:auto!important}.v-application .mr-md-0{margin-right:0!important}.v-application .mr-md-1{margin-right:4px!important}.v-application .mr-md-2{margin-right:8px!important}.v-application .mr-md-3{margin-right:12px!important}.v-application .mr-md-4{margin-right:16px!important}.v-application .mr-md-5{margin-right:20px!important}.v-application .mr-md-6{margin-right:24px!important}.v-application .mr-md-7{margin-right:28px!important}.v-application .mr-md-8{margin-right:32px!important}.v-application .mr-md-9{margin-right:36px!important}.v-application .mr-md-10{margin-right:40px!important}.v-application .mr-md-11{margin-right:44px!important}.v-application .mr-md-12{margin-right:48px!important}.v-application .mr-md-13{margin-right:52px!important}.v-application .mr-md-14{margin-right:56px!important}.v-application .mr-md-15{margin-right:60px!important}.v-application .mr-md-16{margin-right:64px!important}.v-application .mr-md-auto{margin-right:auto!important}.v-application .mb-md-0{margin-bottom:0!important}.v-application .mb-md-1{margin-bottom:4px!important}.v-application .mb-md-2{margin-bottom:8px!important}.v-application .mb-md-3{margin-bottom:12px!important}.v-application .mb-md-4{margin-bottom:16px!important}.v-application .mb-md-5{margin-bottom:20px!important}.v-application .mb-md-6{margin-bottom:24px!important}.v-application .mb-md-7{margin-bottom:28px!important}.v-application .mb-md-8{margin-bottom:32px!important}.v-application .mb-md-9{margin-bottom:36px!important}.v-application .mb-md-10{margin-bottom:40px!important}.v-application .mb-md-11{margin-bottom:44px!important}.v-application .mb-md-12{margin-bottom:48px!important}.v-application .mb-md-13{margin-bottom:52px!important}.v-application .mb-md-14{margin-bottom:56px!important}.v-application .mb-md-15{margin-bottom:60px!important}.v-application .mb-md-16{margin-bottom:64px!important}.v-application .mb-md-auto{margin-bottom:auto!important}.v-application .ml-md-0{margin-left:0!important}.v-application .ml-md-1{margin-left:4px!important}.v-application .ml-md-2{margin-left:8px!important}.v-application .ml-md-3{margin-left:12px!important}.v-application .ml-md-4{margin-left:16px!important}.v-application .ml-md-5{margin-left:20px!important}.v-application .ml-md-6{margin-left:24px!important}.v-application .ml-md-7{margin-left:28px!important}.v-application .ml-md-8{margin-left:32px!important}.v-application .ml-md-9{margin-left:36px!important}.v-application .ml-md-10{margin-left:40px!important}.v-application .ml-md-11{margin-left:44px!important}.v-application .ml-md-12{margin-left:48px!important}.v-application .ml-md-13{margin-left:52px!important}.v-application .ml-md-14{margin-left:56px!important}.v-application .ml-md-15{margin-left:60px!important}.v-application .ml-md-16{margin-left:64px!important}.v-application .ml-md-auto{margin-left:auto!important}.v-application--is-ltr .ms-md-0{margin-left:0!important}.v-application--is-rtl .ms-md-0{margin-right:0!important}.v-application--is-ltr .ms-md-1{margin-left:4px!important}.v-application--is-rtl .ms-md-1{margin-right:4px!important}.v-application--is-ltr .ms-md-2{margin-left:8px!important}.v-application--is-rtl .ms-md-2{margin-right:8px!important}.v-application--is-ltr .ms-md-3{margin-left:12px!important}.v-application--is-rtl .ms-md-3{margin-right:12px!important}.v-application--is-ltr .ms-md-4{margin-left:16px!important}.v-application--is-rtl .ms-md-4{margin-right:16px!important}.v-application--is-ltr .ms-md-5{margin-left:20px!important}.v-application--is-rtl .ms-md-5{margin-right:20px!important}.v-application--is-ltr .ms-md-6{margin-left:24px!important}.v-application--is-rtl .ms-md-6{margin-right:24px!important}.v-application--is-ltr .ms-md-7{margin-left:28px!important}.v-application--is-rtl .ms-md-7{margin-right:28px!important}.v-application--is-ltr .ms-md-8{margin-left:32px!important}.v-application--is-rtl .ms-md-8{margin-right:32px!important}.v-application--is-ltr .ms-md-9{margin-left:36px!important}.v-application--is-rtl .ms-md-9{margin-right:36px!important}.v-application--is-ltr .ms-md-10{margin-left:40px!important}.v-application--is-rtl .ms-md-10{margin-right:40px!important}.v-application--is-ltr .ms-md-11{margin-left:44px!important}.v-application--is-rtl .ms-md-11{margin-right:44px!important}.v-application--is-ltr .ms-md-12{margin-left:48px!important}.v-application--is-rtl .ms-md-12{margin-right:48px!important}.v-application--is-ltr .ms-md-13{margin-left:52px!important}.v-application--is-rtl .ms-md-13{margin-right:52px!important}.v-application--is-ltr .ms-md-14{margin-left:56px!important}.v-application--is-rtl .ms-md-14{margin-right:56px!important}.v-application--is-ltr .ms-md-15{margin-left:60px!important}.v-application--is-rtl .ms-md-15{margin-right:60px!important}.v-application--is-ltr .ms-md-16{margin-left:64px!important}.v-application--is-rtl .ms-md-16{margin-right:64px!important}.v-application--is-ltr .ms-md-auto{margin-left:auto!important}.v-application--is-rtl .ms-md-auto{margin-right:auto!important}.v-application--is-ltr .me-md-0{margin-right:0!important}.v-application--is-rtl .me-md-0{margin-left:0!important}.v-application--is-ltr .me-md-1{margin-right:4px!important}.v-application--is-rtl .me-md-1{margin-left:4px!important}.v-application--is-ltr .me-md-2{margin-right:8px!important}.v-application--is-rtl .me-md-2{margin-left:8px!important}.v-application--is-ltr .me-md-3{margin-right:12px!important}.v-application--is-rtl .me-md-3{margin-left:12px!important}.v-application--is-ltr .me-md-4{margin-right:16px!important}.v-application--is-rtl .me-md-4{margin-left:16px!important}.v-application--is-ltr .me-md-5{margin-right:20px!important}.v-application--is-rtl .me-md-5{margin-left:20px!important}.v-application--is-ltr .me-md-6{margin-right:24px!important}.v-application--is-rtl .me-md-6{margin-left:24px!important}.v-application--is-ltr .me-md-7{margin-right:28px!important}.v-application--is-rtl .me-md-7{margin-left:28px!important}.v-application--is-ltr .me-md-8{margin-right:32px!important}.v-application--is-rtl .me-md-8{margin-left:32px!important}.v-application--is-ltr .me-md-9{margin-right:36px!important}.v-application--is-rtl .me-md-9{margin-left:36px!important}.v-application--is-ltr .me-md-10{margin-right:40px!important}.v-application--is-rtl .me-md-10{margin-left:40px!important}.v-application--is-ltr .me-md-11{margin-right:44px!important}.v-application--is-rtl .me-md-11{margin-left:44px!important}.v-application--is-ltr .me-md-12{margin-right:48px!important}.v-application--is-rtl .me-md-12{margin-left:48px!important}.v-application--is-ltr .me-md-13{margin-right:52px!important}.v-application--is-rtl .me-md-13{margin-left:52px!important}.v-application--is-ltr .me-md-14{margin-right:56px!important}.v-application--is-rtl .me-md-14{margin-left:56px!important}.v-application--is-ltr .me-md-15{margin-right:60px!important}.v-application--is-rtl .me-md-15{margin-left:60px!important}.v-application--is-ltr .me-md-16{margin-right:64px!important}.v-application--is-rtl .me-md-16{margin-left:64px!important}.v-application--is-ltr .me-md-auto{margin-right:auto!important}.v-application--is-rtl .me-md-auto{margin-left:auto!important}.v-application .ma-md-n1{margin:-4px!important}.v-application .ma-md-n2{margin:-8px!important}.v-application .ma-md-n3{margin:-12px!important}.v-application .ma-md-n4{margin:-16px!important}.v-application .ma-md-n5{margin:-20px!important}.v-application .ma-md-n6{margin:-24px!important}.v-application .ma-md-n7{margin:-28px!important}.v-application .ma-md-n8{margin:-32px!important}.v-application .ma-md-n9{margin:-36px!important}.v-application .ma-md-n10{margin:-40px!important}.v-application .ma-md-n11{margin:-44px!important}.v-application .ma-md-n12{margin:-48px!important}.v-application .ma-md-n13{margin:-52px!important}.v-application .ma-md-n14{margin:-56px!important}.v-application .ma-md-n15{margin:-60px!important}.v-application .ma-md-n16{margin:-64px!important}.v-application .mx-md-n1{margin-right:-4px!important;margin-left:-4px!important}.v-application .mx-md-n2{margin-right:-8px!important;margin-left:-8px!important}.v-application .mx-md-n3{margin-right:-12px!important;margin-left:-12px!important}.v-application .mx-md-n4{margin-right:-16px!important;margin-left:-16px!important}.v-application .mx-md-n5{margin-right:-20px!important;margin-left:-20px!important}.v-application .mx-md-n6{margin-right:-24px!important;margin-left:-24px!important}.v-application .mx-md-n7{margin-right:-28px!important;margin-left:-28px!important}.v-application .mx-md-n8{margin-right:-32px!important;margin-left:-32px!important}.v-application .mx-md-n9{margin-right:-36px!important;margin-left:-36px!important}.v-application .mx-md-n10{margin-right:-40px!important;margin-left:-40px!important}.v-application .mx-md-n11{margin-right:-44px!important;margin-left:-44px!important}.v-application .mx-md-n12{margin-right:-48px!important;margin-left:-48px!important}.v-application .mx-md-n13{margin-right:-52px!important;margin-left:-52px!important}.v-application .mx-md-n14{margin-right:-56px!important;margin-left:-56px!important}.v-application .mx-md-n15{margin-right:-60px!important;margin-left:-60px!important}.v-application .mx-md-n16{margin-right:-64px!important;margin-left:-64px!important}.v-application .my-md-n1{margin-top:-4px!important;margin-bottom:-4px!important}.v-application .my-md-n2{margin-top:-8px!important;margin-bottom:-8px!important}.v-application .my-md-n3{margin-top:-12px!important;margin-bottom:-12px!important}.v-application .my-md-n4{margin-top:-16px!important;margin-bottom:-16px!important}.v-application .my-md-n5{margin-top:-20px!important;margin-bottom:-20px!important}.v-application .my-md-n6{margin-top:-24px!important;margin-bottom:-24px!important}.v-application .my-md-n7{margin-top:-28px!important;margin-bottom:-28px!important}.v-application .my-md-n8{margin-top:-32px!important;margin-bottom:-32px!important}.v-application .my-md-n9{margin-top:-36px!important;margin-bottom:-36px!important}.v-application .my-md-n10{margin-top:-40px!important;margin-bottom:-40px!important}.v-application .my-md-n11{margin-top:-44px!important;margin-bottom:-44px!important}.v-application .my-md-n12{margin-top:-48px!important;margin-bottom:-48px!important}.v-application .my-md-n13{margin-top:-52px!important;margin-bottom:-52px!important}.v-application .my-md-n14{margin-top:-56px!important;margin-bottom:-56px!important}.v-application .my-md-n15{margin-top:-60px!important;margin-bottom:-60px!important}.v-application .my-md-n16{margin-top:-64px!important;margin-bottom:-64px!important}.v-application .mt-md-n1{margin-top:-4px!important}.v-application .mt-md-n2{margin-top:-8px!important}.v-application .mt-md-n3{margin-top:-12px!important}.v-application .mt-md-n4{margin-top:-16px!important}.v-application .mt-md-n5{margin-top:-20px!important}.v-application .mt-md-n6{margin-top:-24px!important}.v-application .mt-md-n7{margin-top:-28px!important}.v-application .mt-md-n8{margin-top:-32px!important}.v-application .mt-md-n9{margin-top:-36px!important}.v-application .mt-md-n10{margin-top:-40px!important}.v-application .mt-md-n11{margin-top:-44px!important}.v-application .mt-md-n12{margin-top:-48px!important}.v-application .mt-md-n13{margin-top:-52px!important}.v-application .mt-md-n14{margin-top:-56px!important}.v-application .mt-md-n15{margin-top:-60px!important}.v-application .mt-md-n16{margin-top:-64px!important}.v-application .mr-md-n1{margin-right:-4px!important}.v-application .mr-md-n2{margin-right:-8px!important}.v-application .mr-md-n3{margin-right:-12px!important}.v-application .mr-md-n4{margin-right:-16px!important}.v-application .mr-md-n5{margin-right:-20px!important}.v-application .mr-md-n6{margin-right:-24px!important}.v-application .mr-md-n7{margin-right:-28px!important}.v-application .mr-md-n8{margin-right:-32px!important}.v-application .mr-md-n9{margin-right:-36px!important}.v-application .mr-md-n10{margin-right:-40px!important}.v-application .mr-md-n11{margin-right:-44px!important}.v-application .mr-md-n12{margin-right:-48px!important}.v-application .mr-md-n13{margin-right:-52px!important}.v-application .mr-md-n14{margin-right:-56px!important}.v-application .mr-md-n15{margin-right:-60px!important}.v-application .mr-md-n16{margin-right:-64px!important}.v-application .mb-md-n1{margin-bottom:-4px!important}.v-application .mb-md-n2{margin-bottom:-8px!important}.v-application .mb-md-n3{margin-bottom:-12px!important}.v-application .mb-md-n4{margin-bottom:-16px!important}.v-application .mb-md-n5{margin-bottom:-20px!important}.v-application .mb-md-n6{margin-bottom:-24px!important}.v-application .mb-md-n7{margin-bottom:-28px!important}.v-application .mb-md-n8{margin-bottom:-32px!important}.v-application .mb-md-n9{margin-bottom:-36px!important}.v-application .mb-md-n10{margin-bottom:-40px!important}.v-application .mb-md-n11{margin-bottom:-44px!important}.v-application .mb-md-n12{margin-bottom:-48px!important}.v-application .mb-md-n13{margin-bottom:-52px!important}.v-application .mb-md-n14{margin-bottom:-56px!important}.v-application .mb-md-n15{margin-bottom:-60px!important}.v-application .mb-md-n16{margin-bottom:-64px!important}.v-application .ml-md-n1{margin-left:-4px!important}.v-application .ml-md-n2{margin-left:-8px!important}.v-application .ml-md-n3{margin-left:-12px!important}.v-application .ml-md-n4{margin-left:-16px!important}.v-application .ml-md-n5{margin-left:-20px!important}.v-application .ml-md-n6{margin-left:-24px!important}.v-application .ml-md-n7{margin-left:-28px!important}.v-application .ml-md-n8{margin-left:-32px!important}.v-application .ml-md-n9{margin-left:-36px!important}.v-application .ml-md-n10{margin-left:-40px!important}.v-application .ml-md-n11{margin-left:-44px!important}.v-application .ml-md-n12{margin-left:-48px!important}.v-application .ml-md-n13{margin-left:-52px!important}.v-application .ml-md-n14{margin-left:-56px!important}.v-application .ml-md-n15{margin-left:-60px!important}.v-application .ml-md-n16{margin-left:-64px!important}.v-application--is-ltr .ms-md-n1{margin-left:-4px!important}.v-application--is-rtl .ms-md-n1{margin-right:-4px!important}.v-application--is-ltr .ms-md-n2{margin-left:-8px!important}.v-application--is-rtl .ms-md-n2{margin-right:-8px!important}.v-application--is-ltr .ms-md-n3{margin-left:-12px!important}.v-application--is-rtl .ms-md-n3{margin-right:-12px!important}.v-application--is-ltr .ms-md-n4{margin-left:-16px!important}.v-application--is-rtl .ms-md-n4{margin-right:-16px!important}.v-application--is-ltr .ms-md-n5{margin-left:-20px!important}.v-application--is-rtl .ms-md-n5{margin-right:-20px!important}.v-application--is-ltr .ms-md-n6{margin-left:-24px!important}.v-application--is-rtl .ms-md-n6{margin-right:-24px!important}.v-application--is-ltr .ms-md-n7{margin-left:-28px!important}.v-application--is-rtl .ms-md-n7{margin-right:-28px!important}.v-application--is-ltr .ms-md-n8{margin-left:-32px!important}.v-application--is-rtl .ms-md-n8{margin-right:-32px!important}.v-application--is-ltr .ms-md-n9{margin-left:-36px!important}.v-application--is-rtl .ms-md-n9{margin-right:-36px!important}.v-application--is-ltr .ms-md-n10{margin-left:-40px!important}.v-application--is-rtl .ms-md-n10{margin-right:-40px!important}.v-application--is-ltr .ms-md-n11{margin-left:-44px!important}.v-application--is-rtl .ms-md-n11{margin-right:-44px!important}.v-application--is-ltr .ms-md-n12{margin-left:-48px!important}.v-application--is-rtl .ms-md-n12{margin-right:-48px!important}.v-application--is-ltr .ms-md-n13{margin-left:-52px!important}.v-application--is-rtl .ms-md-n13{margin-right:-52px!important}.v-application--is-ltr .ms-md-n14{margin-left:-56px!important}.v-application--is-rtl .ms-md-n14{margin-right:-56px!important}.v-application--is-ltr .ms-md-n15{margin-left:-60px!important}.v-application--is-rtl .ms-md-n15{margin-right:-60px!important}.v-application--is-ltr .ms-md-n16{margin-left:-64px!important}.v-application--is-rtl .ms-md-n16{margin-right:-64px!important}.v-application--is-ltr .me-md-n1{margin-right:-4px!important}.v-application--is-rtl .me-md-n1{margin-left:-4px!important}.v-application--is-ltr .me-md-n2{margin-right:-8px!important}.v-application--is-rtl .me-md-n2{margin-left:-8px!important}.v-application--is-ltr .me-md-n3{margin-right:-12px!important}.v-application--is-rtl .me-md-n3{margin-left:-12px!important}.v-application--is-ltr .me-md-n4{margin-right:-16px!important}.v-application--is-rtl .me-md-n4{margin-left:-16px!important}.v-application--is-ltr .me-md-n5{margin-right:-20px!important}.v-application--is-rtl .me-md-n5{margin-left:-20px!important}.v-application--is-ltr .me-md-n6{margin-right:-24px!important}.v-application--is-rtl .me-md-n6{margin-left:-24px!important}.v-application--is-ltr .me-md-n7{margin-right:-28px!important}.v-application--is-rtl .me-md-n7{margin-left:-28px!important}.v-application--is-ltr .me-md-n8{margin-right:-32px!important}.v-application--is-rtl .me-md-n8{margin-left:-32px!important}.v-application--is-ltr .me-md-n9{margin-right:-36px!important}.v-application--is-rtl .me-md-n9{margin-left:-36px!important}.v-application--is-ltr .me-md-n10{margin-right:-40px!important}.v-application--is-rtl .me-md-n10{margin-left:-40px!important}.v-application--is-ltr .me-md-n11{margin-right:-44px!important}.v-application--is-rtl .me-md-n11{margin-left:-44px!important}.v-application--is-ltr .me-md-n12{margin-right:-48px!important}.v-application--is-rtl .me-md-n12{margin-left:-48px!important}.v-application--is-ltr .me-md-n13{margin-right:-52px!important}.v-application--is-rtl .me-md-n13{margin-left:-52px!important}.v-application--is-ltr .me-md-n14{margin-right:-56px!important}.v-application--is-rtl .me-md-n14{margin-left:-56px!important}.v-application--is-ltr .me-md-n15{margin-right:-60px!important}.v-application--is-rtl .me-md-n15{margin-left:-60px!important}.v-application--is-ltr .me-md-n16{margin-right:-64px!important}.v-application--is-rtl .me-md-n16{margin-left:-64px!important}.v-application .pa-md-0{padding:0!important}.v-application .pa-md-1{padding:4px!important}.v-application .pa-md-2{padding:8px!important}.v-application .pa-md-3{padding:12px!important}.v-application .pa-md-4{padding:16px!important}.v-application .pa-md-5{padding:20px!important}.v-application .pa-md-6{padding:24px!important}.v-application .pa-md-7{padding:28px!important}.v-application .pa-md-8{padding:32px!important}.v-application .pa-md-9{padding:36px!important}.v-application .pa-md-10{padding:40px!important}.v-application .pa-md-11{padding:44px!important}.v-application .pa-md-12{padding:48px!important}.v-application .pa-md-13{padding:52px!important}.v-application .pa-md-14{padding:56px!important}.v-application .pa-md-15{padding:60px!important}.v-application .pa-md-16{padding:64px!important}.v-application .px-md-0{padding-right:0!important;padding-left:0!important}.v-application .px-md-1{padding-right:4px!important;padding-left:4px!important}.v-application .px-md-2{padding-right:8px!important;padding-left:8px!important}.v-application .px-md-3{padding-right:12px!important;padding-left:12px!important}.v-application .px-md-4{padding-right:16px!important;padding-left:16px!important}.v-application .px-md-5{padding-right:20px!important;padding-left:20px!important}.v-application .px-md-6{padding-right:24px!important;padding-left:24px!important}.v-application .px-md-7{padding-right:28px!important;padding-left:28px!important}.v-application .px-md-8{padding-right:32px!important;padding-left:32px!important}.v-application .px-md-9{padding-right:36px!important;padding-left:36px!important}.v-application .px-md-10{padding-right:40px!important;padding-left:40px!important}.v-application .px-md-11{padding-right:44px!important;padding-left:44px!important}.v-application .px-md-12{padding-right:48px!important;padding-left:48px!important}.v-application .px-md-13{padding-right:52px!important;padding-left:52px!important}.v-application .px-md-14{padding-right:56px!important;padding-left:56px!important}.v-application .px-md-15{padding-right:60px!important;padding-left:60px!important}.v-application .px-md-16{padding-right:64px!important;padding-left:64px!important}.v-application .py-md-0{padding-top:0!important;padding-bottom:0!important}.v-application .py-md-1{padding-top:4px!important;padding-bottom:4px!important}.v-application .py-md-2{padding-top:8px!important;padding-bottom:8px!important}.v-application .py-md-3{padding-top:12px!important;padding-bottom:12px!important}.v-application .py-md-4{padding-top:16px!important;padding-bottom:16px!important}.v-application .py-md-5{padding-top:20px!important;padding-bottom:20px!important}.v-application .py-md-6{padding-top:24px!important;padding-bottom:24px!important}.v-application .py-md-7{padding-top:28px!important;padding-bottom:28px!important}.v-application .py-md-8{padding-top:32px!important;padding-bottom:32px!important}.v-application .py-md-9{padding-top:36px!important;padding-bottom:36px!important}.v-application .py-md-10{padding-top:40px!important;padding-bottom:40px!important}.v-application .py-md-11{padding-top:44px!important;padding-bottom:44px!important}.v-application .py-md-12{padding-top:48px!important;padding-bottom:48px!important}.v-application .py-md-13{padding-top:52px!important;padding-bottom:52px!important}.v-application .py-md-14{padding-top:56px!important;padding-bottom:56px!important}.v-application .py-md-15{padding-top:60px!important;padding-bottom:60px!important}.v-application .py-md-16{padding-top:64px!important;padding-bottom:64px!important}.v-application .pt-md-0{padding-top:0!important}.v-application .pt-md-1{padding-top:4px!important}.v-application .pt-md-2{padding-top:8px!important}.v-application .pt-md-3{padding-top:12px!important}.v-application .pt-md-4{padding-top:16px!important}.v-application .pt-md-5{padding-top:20px!important}.v-application .pt-md-6{padding-top:24px!important}.v-application .pt-md-7{padding-top:28px!important}.v-application .pt-md-8{padding-top:32px!important}.v-application .pt-md-9{padding-top:36px!important}.v-application .pt-md-10{padding-top:40px!important}.v-application .pt-md-11{padding-top:44px!important}.v-application .pt-md-12{padding-top:48px!important}.v-application .pt-md-13{padding-top:52px!important}.v-application .pt-md-14{padding-top:56px!important}.v-application .pt-md-15{padding-top:60px!important}.v-application .pt-md-16{padding-top:64px!important}.v-application .pr-md-0{padding-right:0!important}.v-application .pr-md-1{padding-right:4px!important}.v-application .pr-md-2{padding-right:8px!important}.v-application .pr-md-3{padding-right:12px!important}.v-application .pr-md-4{padding-right:16px!important}.v-application .pr-md-5{padding-right:20px!important}.v-application .pr-md-6{padding-right:24px!important}.v-application .pr-md-7{padding-right:28px!important}.v-application .pr-md-8{padding-right:32px!important}.v-application .pr-md-9{padding-right:36px!important}.v-application .pr-md-10{padding-right:40px!important}.v-application .pr-md-11{padding-right:44px!important}.v-application .pr-md-12{padding-right:48px!important}.v-application .pr-md-13{padding-right:52px!important}.v-application .pr-md-14{padding-right:56px!important}.v-application .pr-md-15{padding-right:60px!important}.v-application .pr-md-16{padding-right:64px!important}.v-application .pb-md-0{padding-bottom:0!important}.v-application .pb-md-1{padding-bottom:4px!important}.v-application .pb-md-2{padding-bottom:8px!important}.v-application .pb-md-3{padding-bottom:12px!important}.v-application .pb-md-4{padding-bottom:16px!important}.v-application .pb-md-5{padding-bottom:20px!important}.v-application .pb-md-6{padding-bottom:24px!important}.v-application .pb-md-7{padding-bottom:28px!important}.v-application .pb-md-8{padding-bottom:32px!important}.v-application .pb-md-9{padding-bottom:36px!important}.v-application .pb-md-10{padding-bottom:40px!important}.v-application .pb-md-11{padding-bottom:44px!important}.v-application .pb-md-12{padding-bottom:48px!important}.v-application .pb-md-13{padding-bottom:52px!important}.v-application .pb-md-14{padding-bottom:56px!important}.v-application .pb-md-15{padding-bottom:60px!important}.v-application .pb-md-16{padding-bottom:64px!important}.v-application .pl-md-0{padding-left:0!important}.v-application .pl-md-1{padding-left:4px!important}.v-application .pl-md-2{padding-left:8px!important}.v-application .pl-md-3{padding-left:12px!important}.v-application .pl-md-4{padding-left:16px!important}.v-application .pl-md-5{padding-left:20px!important}.v-application .pl-md-6{padding-left:24px!important}.v-application .pl-md-7{padding-left:28px!important}.v-application .pl-md-8{padding-left:32px!important}.v-application .pl-md-9{padding-left:36px!important}.v-application .pl-md-10{padding-left:40px!important}.v-application .pl-md-11{padding-left:44px!important}.v-application .pl-md-12{padding-left:48px!important}.v-application .pl-md-13{padding-left:52px!important}.v-application .pl-md-14{padding-left:56px!important}.v-application .pl-md-15{padding-left:60px!important}.v-application .pl-md-16{padding-left:64px!important}.v-application--is-ltr .ps-md-0{padding-left:0!important}.v-application--is-rtl .ps-md-0{padding-right:0!important}.v-application--is-ltr .ps-md-1{padding-left:4px!important}.v-application--is-rtl .ps-md-1{padding-right:4px!important}.v-application--is-ltr .ps-md-2{padding-left:8px!important}.v-application--is-rtl .ps-md-2{padding-right:8px!important}.v-application--is-ltr .ps-md-3{padding-left:12px!important}.v-application--is-rtl .ps-md-3{padding-right:12px!important}.v-application--is-ltr .ps-md-4{padding-left:16px!important}.v-application--is-rtl .ps-md-4{padding-right:16px!important}.v-application--is-ltr .ps-md-5{padding-left:20px!important}.v-application--is-rtl .ps-md-5{padding-right:20px!important}.v-application--is-ltr .ps-md-6{padding-left:24px!important}.v-application--is-rtl .ps-md-6{padding-right:24px!important}.v-application--is-ltr .ps-md-7{padding-left:28px!important}.v-application--is-rtl .ps-md-7{padding-right:28px!important}.v-application--is-ltr .ps-md-8{padding-left:32px!important}.v-application--is-rtl .ps-md-8{padding-right:32px!important}.v-application--is-ltr .ps-md-9{padding-left:36px!important}.v-application--is-rtl .ps-md-9{padding-right:36px!important}.v-application--is-ltr .ps-md-10{padding-left:40px!important}.v-application--is-rtl .ps-md-10{padding-right:40px!important}.v-application--is-ltr .ps-md-11{padding-left:44px!important}.v-application--is-rtl .ps-md-11{padding-right:44px!important}.v-application--is-ltr .ps-md-12{padding-left:48px!important}.v-application--is-rtl .ps-md-12{padding-right:48px!important}.v-application--is-ltr .ps-md-13{padding-left:52px!important}.v-application--is-rtl .ps-md-13{padding-right:52px!important}.v-application--is-ltr .ps-md-14{padding-left:56px!important}.v-application--is-rtl .ps-md-14{padding-right:56px!important}.v-application--is-ltr .ps-md-15{padding-left:60px!important}.v-application--is-rtl .ps-md-15{padding-right:60px!important}.v-application--is-ltr .ps-md-16{padding-left:64px!important}.v-application--is-rtl .ps-md-16{padding-right:64px!important}.v-application--is-ltr .pe-md-0{padding-right:0!important}.v-application--is-rtl .pe-md-0{padding-left:0!important}.v-application--is-ltr .pe-md-1{padding-right:4px!important}.v-application--is-rtl .pe-md-1{padding-left:4px!important}.v-application--is-ltr .pe-md-2{padding-right:8px!important}.v-application--is-rtl .pe-md-2{padding-left:8px!important}.v-application--is-ltr .pe-md-3{padding-right:12px!important}.v-application--is-rtl .pe-md-3{padding-left:12px!important}.v-application--is-ltr .pe-md-4{padding-right:16px!important}.v-application--is-rtl .pe-md-4{padding-left:16px!important}.v-application--is-ltr .pe-md-5{padding-right:20px!important}.v-application--is-rtl .pe-md-5{padding-left:20px!important}.v-application--is-ltr .pe-md-6{padding-right:24px!important}.v-application--is-rtl .pe-md-6{padding-left:24px!important}.v-application--is-ltr .pe-md-7{padding-right:28px!important}.v-application--is-rtl .pe-md-7{padding-left:28px!important}.v-application--is-ltr .pe-md-8{padding-right:32px!important}.v-application--is-rtl .pe-md-8{padding-left:32px!important}.v-application--is-ltr .pe-md-9{padding-right:36px!important}.v-application--is-rtl .pe-md-9{padding-left:36px!important}.v-application--is-ltr .pe-md-10{padding-right:40px!important}.v-application--is-rtl .pe-md-10{padding-left:40px!important}.v-application--is-ltr .pe-md-11{padding-right:44px!important}.v-application--is-rtl .pe-md-11{padding-left:44px!important}.v-application--is-ltr .pe-md-12{padding-right:48px!important}.v-application--is-rtl .pe-md-12{padding-left:48px!important}.v-application--is-ltr .pe-md-13{padding-right:52px!important}.v-application--is-rtl .pe-md-13{padding-left:52px!important}.v-application--is-ltr .pe-md-14{padding-right:56px!important}.v-application--is-rtl .pe-md-14{padding-left:56px!important}.v-application--is-ltr .pe-md-15{padding-right:60px!important}.v-application--is-rtl .pe-md-15{padding-left:60px!important}.v-application--is-ltr .pe-md-16{padding-right:64px!important}.v-application--is-rtl .pe-md-16{padding-left:64px!important}.v-application .text-md-left{text-align:left!important}.v-application .text-md-right{text-align:right!important}.v-application .text-md-center{text-align:center!important}.v-application .text-md-justify{text-align:justify!important}.v-application .text-md-start{text-align:start!important}.v-application .text-md-end{text-align:end!important}.v-application .text-md-h1{font-size:2rem!important;font-weight:600;line-height:2.4285714286rem;letter-spacing:-.02em!important;font-family:AkkuratLL,Helvetica,Arial,sans-serif!important}.v-application .text-md-h2{font-size:1.7142857143rem!important;line-height:2.2857142857rem}.v-application .text-md-h2,.v-application .text-md-h3{font-weight:600;letter-spacing:-.01em!important;font-family:AkkuratLL,Helvetica,Arial,sans-serif!important}.v-application .text-md-h3{font-size:1.4285714286rem!important;line-height:2rem}.v-application .text-md-h4{font-size:1.2857142857rem!important}.v-application .text-md-h4,.v-application .text-md-h5{font-weight:600;line-height:1.7142857143rem;letter-spacing:-.01em!important;font-family:AkkuratLL,Helvetica,Arial,sans-serif!important}.v-application .text-md-h5{font-size:1.1428571429rem!important}.v-application .text-md-h6{font-size:1rem!important;font-weight:500;line-height:1.4285714286rem;letter-spacing:normal!important;font-family:AkkuratLL,Helvetica,Arial,sans-serif!important}.v-application .text-md-subtitle-1{font-size:.8571428571rem!important}.v-application .text-md-subtitle-1,.v-application .text-md-subtitle-2{font-weight:400;line-height:1.1428571429rem;letter-spacing:normal!important;font-family:AkkuratLL,Helvetica,Arial,sans-serif!important}.v-application .text-md-subtitle-2{font-size:.7142857143rem!important}.v-application .text-md-body-1{font-size:1.1428571429rem!important;line-height:1.7142857143rem;letter-spacing:normal!important}.v-application .text-md-body-1,.v-application .text-md-body-2{font-weight:400;font-family:AkkuratLL,Helvetica,Arial,sans-serif!important}.v-application .text-md-body-2{font-size:1rem!important;line-height:1.4285714286rem;letter-spacing:-.02em!important}.v-application .text-md-button{font-size:.875rem!important;font-weight:500;line-height:2.25rem;letter-spacing:.0892857143em!important;font-family:AkkuratLL,Helvetica,Arial,sans-serif!important;text-transform:uppercase!important}.v-application .text-md-caption{font-weight:400;line-height:1.25rem;letter-spacing:.0333333333em!important}.v-application .text-md-caption,.v-application .text-md-overline{font-size:.75rem!important;font-family:AkkuratLL,Helvetica,Arial,sans-serif!important}.v-application .text-md-overline{font-weight:500;line-height:2rem;letter-spacing:.1666666667em!important;text-transform:uppercase!important}}@media(min-width:1264px){.v-application .d-lg-none{display:none!important}.v-application .d-lg-inline{display:inline!important}.v-application .d-lg-inline-block{display:inline-block!important}.v-application .d-lg-block{display:block!important}.v-application .d-lg-table{display:table!important}.v-application .d-lg-table-row{display:table-row!important}.v-application .d-lg-table-cell{display:table-cell!important}.v-application .d-lg-flex{display:flex!important}.v-application .d-lg-inline-flex{display:inline-flex!important}.v-application .float-lg-none{float:none!important}.v-application .float-lg-left{float:left!important}.v-application .float-lg-right{float:right!important}.v-application .flex-lg-fill{flex:1 1 auto!important}.v-application .flex-lg-row{flex-direction:row!important}.v-application .flex-lg-column{flex-direction:column!important}.v-application .flex-lg-row-reverse{flex-direction:row-reverse!important}.v-application .flex-lg-column-reverse{flex-direction:column-reverse!important}.v-application .flex-lg-grow-0{flex-grow:0!important}.v-application .flex-lg-grow-1{flex-grow:1!important}.v-application .flex-lg-shrink-0{flex-shrink:0!important}.v-application .flex-lg-shrink-1{flex-shrink:1!important}.v-application .flex-lg-wrap{flex-wrap:wrap!important}.v-application .flex-lg-nowrap{flex-wrap:nowrap!important}.v-application .flex-lg-wrap-reverse{flex-wrap:wrap-reverse!important}.v-application .justify-lg-start{justify-content:flex-start!important}.v-application .justify-lg-end{justify-content:flex-end!important}.v-application .justify-lg-center{justify-content:center!important}.v-application .justify-lg-space-between{justify-content:space-between!important}.v-application .justify-lg-space-around{justify-content:space-around!important}.v-application .align-lg-start{align-items:flex-start!important}.v-application .align-lg-end{align-items:flex-end!important}.v-application .align-lg-center{align-items:center!important}.v-application .align-lg-baseline{align-items:baseline!important}.v-application .align-lg-stretch{align-items:stretch!important}.v-application .align-content-lg-start{align-content:flex-start!important}.v-application .align-content-lg-end{align-content:flex-end!important}.v-application .align-content-lg-center{align-content:center!important}.v-application .align-content-lg-space-between{align-content:space-between!important}.v-application .align-content-lg-space-around{align-content:space-around!important}.v-application .align-content-lg-stretch{align-content:stretch!important}.v-application .align-self-lg-auto{align-self:auto!important}.v-application .align-self-lg-start{align-self:flex-start!important}.v-application .align-self-lg-end{align-self:flex-end!important}.v-application .align-self-lg-center{align-self:center!important}.v-application .align-self-lg-baseline{align-self:baseline!important}.v-application .align-self-lg-stretch{align-self:stretch!important}.v-application .order-lg-first{order:-1!important}.v-application .order-lg-0{order:0!important}.v-application .order-lg-1{order:1!important}.v-application .order-lg-2{order:2!important}.v-application .order-lg-3{order:3!important}.v-application .order-lg-4{order:4!important}.v-application .order-lg-5{order:5!important}.v-application .order-lg-6{order:6!important}.v-application .order-lg-7{order:7!important}.v-application .order-lg-8{order:8!important}.v-application .order-lg-9{order:9!important}.v-application .order-lg-10{order:10!important}.v-application .order-lg-11{order:11!important}.v-application .order-lg-12{order:12!important}.v-application .order-lg-last{order:13!important}.v-application .ma-lg-0{margin:0!important}.v-application .ma-lg-1{margin:4px!important}.v-application .ma-lg-2{margin:8px!important}.v-application .ma-lg-3{margin:12px!important}.v-application .ma-lg-4{margin:16px!important}.v-application .ma-lg-5{margin:20px!important}.v-application .ma-lg-6{margin:24px!important}.v-application .ma-lg-7{margin:28px!important}.v-application .ma-lg-8{margin:32px!important}.v-application .ma-lg-9{margin:36px!important}.v-application .ma-lg-10{margin:40px!important}.v-application .ma-lg-11{margin:44px!important}.v-application .ma-lg-12{margin:48px!important}.v-application .ma-lg-13{margin:52px!important}.v-application .ma-lg-14{margin:56px!important}.v-application .ma-lg-15{margin:60px!important}.v-application .ma-lg-16{margin:64px!important}.v-application .ma-lg-auto{margin:auto!important}.v-application .mx-lg-0{margin-right:0!important;margin-left:0!important}.v-application .mx-lg-1{margin-right:4px!important;margin-left:4px!important}.v-application .mx-lg-2{margin-right:8px!important;margin-left:8px!important}.v-application .mx-lg-3{margin-right:12px!important;margin-left:12px!important}.v-application .mx-lg-4{margin-right:16px!important;margin-left:16px!important}.v-application .mx-lg-5{margin-right:20px!important;margin-left:20px!important}.v-application .mx-lg-6{margin-right:24px!important;margin-left:24px!important}.v-application .mx-lg-7{margin-right:28px!important;margin-left:28px!important}.v-application .mx-lg-8{margin-right:32px!important;margin-left:32px!important}.v-application .mx-lg-9{margin-right:36px!important;margin-left:36px!important}.v-application .mx-lg-10{margin-right:40px!important;margin-left:40px!important}.v-application .mx-lg-11{margin-right:44px!important;margin-left:44px!important}.v-application .mx-lg-12{margin-right:48px!important;margin-left:48px!important}.v-application .mx-lg-13{margin-right:52px!important;margin-left:52px!important}.v-application .mx-lg-14{margin-right:56px!important;margin-left:56px!important}.v-application .mx-lg-15{margin-right:60px!important;margin-left:60px!important}.v-application .mx-lg-16{margin-right:64px!important;margin-left:64px!important}.v-application .mx-lg-auto{margin-right:auto!important;margin-left:auto!important}.v-application .my-lg-0{margin-top:0!important;margin-bottom:0!important}.v-application .my-lg-1{margin-top:4px!important;margin-bottom:4px!important}.v-application .my-lg-2{margin-top:8px!important;margin-bottom:8px!important}.v-application .my-lg-3{margin-top:12px!important;margin-bottom:12px!important}.v-application .my-lg-4{margin-top:16px!important;margin-bottom:16px!important}.v-application .my-lg-5{margin-top:20px!important;margin-bottom:20px!important}.v-application .my-lg-6{margin-top:24px!important;margin-bottom:24px!important}.v-application .my-lg-7{margin-top:28px!important;margin-bottom:28px!important}.v-application .my-lg-8{margin-top:32px!important;margin-bottom:32px!important}.v-application .my-lg-9{margin-top:36px!important;margin-bottom:36px!important}.v-application .my-lg-10{margin-top:40px!important;margin-bottom:40px!important}.v-application .my-lg-11{margin-top:44px!important;margin-bottom:44px!important}.v-application .my-lg-12{margin-top:48px!important;margin-bottom:48px!important}.v-application .my-lg-13{margin-top:52px!important;margin-bottom:52px!important}.v-application .my-lg-14{margin-top:56px!important;margin-bottom:56px!important}.v-application .my-lg-15{margin-top:60px!important;margin-bottom:60px!important}.v-application .my-lg-16{margin-top:64px!important;margin-bottom:64px!important}.v-application .my-lg-auto{margin-top:auto!important;margin-bottom:auto!important}.v-application .mt-lg-0{margin-top:0!important}.v-application .mt-lg-1{margin-top:4px!important}.v-application .mt-lg-2{margin-top:8px!important}.v-application .mt-lg-3{margin-top:12px!important}.v-application .mt-lg-4{margin-top:16px!important}.v-application .mt-lg-5{margin-top:20px!important}.v-application .mt-lg-6{margin-top:24px!important}.v-application .mt-lg-7{margin-top:28px!important}.v-application .mt-lg-8{margin-top:32px!important}.v-application .mt-lg-9{margin-top:36px!important}.v-application .mt-lg-10{margin-top:40px!important}.v-application .mt-lg-11{margin-top:44px!important}.v-application .mt-lg-12{margin-top:48px!important}.v-application .mt-lg-13{margin-top:52px!important}.v-application .mt-lg-14{margin-top:56px!important}.v-application .mt-lg-15{margin-top:60px!important}.v-application .mt-lg-16{margin-top:64px!important}.v-application .mt-lg-auto{margin-top:auto!important}.v-application .mr-lg-0{margin-right:0!important}.v-application .mr-lg-1{margin-right:4px!important}.v-application .mr-lg-2{margin-right:8px!important}.v-application .mr-lg-3{margin-right:12px!important}.v-application .mr-lg-4{margin-right:16px!important}.v-application .mr-lg-5{margin-right:20px!important}.v-application .mr-lg-6{margin-right:24px!important}.v-application .mr-lg-7{margin-right:28px!important}.v-application .mr-lg-8{margin-right:32px!important}.v-application .mr-lg-9{margin-right:36px!important}.v-application .mr-lg-10{margin-right:40px!important}.v-application .mr-lg-11{margin-right:44px!important}.v-application .mr-lg-12{margin-right:48px!important}.v-application .mr-lg-13{margin-right:52px!important}.v-application .mr-lg-14{margin-right:56px!important}.v-application .mr-lg-15{margin-right:60px!important}.v-application .mr-lg-16{margin-right:64px!important}.v-application .mr-lg-auto{margin-right:auto!important}.v-application .mb-lg-0{margin-bottom:0!important}.v-application .mb-lg-1{margin-bottom:4px!important}.v-application .mb-lg-2{margin-bottom:8px!important}.v-application .mb-lg-3{margin-bottom:12px!important}.v-application .mb-lg-4{margin-bottom:16px!important}.v-application .mb-lg-5{margin-bottom:20px!important}.v-application .mb-lg-6{margin-bottom:24px!important}.v-application .mb-lg-7{margin-bottom:28px!important}.v-application .mb-lg-8{margin-bottom:32px!important}.v-application .mb-lg-9{margin-bottom:36px!important}.v-application .mb-lg-10{margin-bottom:40px!important}.v-application .mb-lg-11{margin-bottom:44px!important}.v-application .mb-lg-12{margin-bottom:48px!important}.v-application .mb-lg-13{margin-bottom:52px!important}.v-application .mb-lg-14{margin-bottom:56px!important}.v-application .mb-lg-15{margin-bottom:60px!important}.v-application .mb-lg-16{margin-bottom:64px!important}.v-application .mb-lg-auto{margin-bottom:auto!important}.v-application .ml-lg-0{margin-left:0!important}.v-application .ml-lg-1{margin-left:4px!important}.v-application .ml-lg-2{margin-left:8px!important}.v-application .ml-lg-3{margin-left:12px!important}.v-application .ml-lg-4{margin-left:16px!important}.v-application .ml-lg-5{margin-left:20px!important}.v-application .ml-lg-6{margin-left:24px!important}.v-application .ml-lg-7{margin-left:28px!important}.v-application .ml-lg-8{margin-left:32px!important}.v-application .ml-lg-9{margin-left:36px!important}.v-application .ml-lg-10{margin-left:40px!important}.v-application .ml-lg-11{margin-left:44px!important}.v-application .ml-lg-12{margin-left:48px!important}.v-application .ml-lg-13{margin-left:52px!important}.v-application .ml-lg-14{margin-left:56px!important}.v-application .ml-lg-15{margin-left:60px!important}.v-application .ml-lg-16{margin-left:64px!important}.v-application .ml-lg-auto{margin-left:auto!important}.v-application--is-ltr .ms-lg-0{margin-left:0!important}.v-application--is-rtl .ms-lg-0{margin-right:0!important}.v-application--is-ltr .ms-lg-1{margin-left:4px!important}.v-application--is-rtl .ms-lg-1{margin-right:4px!important}.v-application--is-ltr .ms-lg-2{margin-left:8px!important}.v-application--is-rtl .ms-lg-2{margin-right:8px!important}.v-application--is-ltr .ms-lg-3{margin-left:12px!important}.v-application--is-rtl .ms-lg-3{margin-right:12px!important}.v-application--is-ltr .ms-lg-4{margin-left:16px!important}.v-application--is-rtl .ms-lg-4{margin-right:16px!important}.v-application--is-ltr .ms-lg-5{margin-left:20px!important}.v-application--is-rtl .ms-lg-5{margin-right:20px!important}.v-application--is-ltr .ms-lg-6{margin-left:24px!important}.v-application--is-rtl .ms-lg-6{margin-right:24px!important}.v-application--is-ltr .ms-lg-7{margin-left:28px!important}.v-application--is-rtl .ms-lg-7{margin-right:28px!important}.v-application--is-ltr .ms-lg-8{margin-left:32px!important}.v-application--is-rtl .ms-lg-8{margin-right:32px!important}.v-application--is-ltr .ms-lg-9{margin-left:36px!important}.v-application--is-rtl .ms-lg-9{margin-right:36px!important}.v-application--is-ltr .ms-lg-10{margin-left:40px!important}.v-application--is-rtl .ms-lg-10{margin-right:40px!important}.v-application--is-ltr .ms-lg-11{margin-left:44px!important}.v-application--is-rtl .ms-lg-11{margin-right:44px!important}.v-application--is-ltr .ms-lg-12{margin-left:48px!important}.v-application--is-rtl .ms-lg-12{margin-right:48px!important}.v-application--is-ltr .ms-lg-13{margin-left:52px!important}.v-application--is-rtl .ms-lg-13{margin-right:52px!important}.v-application--is-ltr .ms-lg-14{margin-left:56px!important}.v-application--is-rtl .ms-lg-14{margin-right:56px!important}.v-application--is-ltr .ms-lg-15{margin-left:60px!important}.v-application--is-rtl .ms-lg-15{margin-right:60px!important}.v-application--is-ltr .ms-lg-16{margin-left:64px!important}.v-application--is-rtl .ms-lg-16{margin-right:64px!important}.v-application--is-ltr .ms-lg-auto{margin-left:auto!important}.v-application--is-rtl .ms-lg-auto{margin-right:auto!important}.v-application--is-ltr .me-lg-0{margin-right:0!important}.v-application--is-rtl .me-lg-0{margin-left:0!important}.v-application--is-ltr .me-lg-1{margin-right:4px!important}.v-application--is-rtl .me-lg-1{margin-left:4px!important}.v-application--is-ltr .me-lg-2{margin-right:8px!important}.v-application--is-rtl .me-lg-2{margin-left:8px!important}.v-application--is-ltr .me-lg-3{margin-right:12px!important}.v-application--is-rtl .me-lg-3{margin-left:12px!important}.v-application--is-ltr .me-lg-4{margin-right:16px!important}.v-application--is-rtl .me-lg-4{margin-left:16px!important}.v-application--is-ltr .me-lg-5{margin-right:20px!important}.v-application--is-rtl .me-lg-5{margin-left:20px!important}.v-application--is-ltr .me-lg-6{margin-right:24px!important}.v-application--is-rtl .me-lg-6{margin-left:24px!important}.v-application--is-ltr .me-lg-7{margin-right:28px!important}.v-application--is-rtl .me-lg-7{margin-left:28px!important}.v-application--is-ltr .me-lg-8{margin-right:32px!important}.v-application--is-rtl .me-lg-8{margin-left:32px!important}.v-application--is-ltr .me-lg-9{margin-right:36px!important}.v-application--is-rtl .me-lg-9{margin-left:36px!important}.v-application--is-ltr .me-lg-10{margin-right:40px!important}.v-application--is-rtl .me-lg-10{margin-left:40px!important}.v-application--is-ltr .me-lg-11{margin-right:44px!important}.v-application--is-rtl .me-lg-11{margin-left:44px!important}.v-application--is-ltr .me-lg-12{margin-right:48px!important}.v-application--is-rtl .me-lg-12{margin-left:48px!important}.v-application--is-ltr .me-lg-13{margin-right:52px!important}.v-application--is-rtl .me-lg-13{margin-left:52px!important}.v-application--is-ltr .me-lg-14{margin-right:56px!important}.v-application--is-rtl .me-lg-14{margin-left:56px!important}.v-application--is-ltr .me-lg-15{margin-right:60px!important}.v-application--is-rtl .me-lg-15{margin-left:60px!important}.v-application--is-ltr .me-lg-16{margin-right:64px!important}.v-application--is-rtl .me-lg-16{margin-left:64px!important}.v-application--is-ltr .me-lg-auto{margin-right:auto!important}.v-application--is-rtl .me-lg-auto{margin-left:auto!important}.v-application .ma-lg-n1{margin:-4px!important}.v-application .ma-lg-n2{margin:-8px!important}.v-application .ma-lg-n3{margin:-12px!important}.v-application .ma-lg-n4{margin:-16px!important}.v-application .ma-lg-n5{margin:-20px!important}.v-application .ma-lg-n6{margin:-24px!important}.v-application .ma-lg-n7{margin:-28px!important}.v-application .ma-lg-n8{margin:-32px!important}.v-application .ma-lg-n9{margin:-36px!important}.v-application .ma-lg-n10{margin:-40px!important}.v-application .ma-lg-n11{margin:-44px!important}.v-application .ma-lg-n12{margin:-48px!important}.v-application .ma-lg-n13{margin:-52px!important}.v-application .ma-lg-n14{margin:-56px!important}.v-application .ma-lg-n15{margin:-60px!important}.v-application .ma-lg-n16{margin:-64px!important}.v-application .mx-lg-n1{margin-right:-4px!important;margin-left:-4px!important}.v-application .mx-lg-n2{margin-right:-8px!important;margin-left:-8px!important}.v-application .mx-lg-n3{margin-right:-12px!important;margin-left:-12px!important}.v-application .mx-lg-n4{margin-right:-16px!important;margin-left:-16px!important}.v-application .mx-lg-n5{margin-right:-20px!important;margin-left:-20px!important}.v-application .mx-lg-n6{margin-right:-24px!important;margin-left:-24px!important}.v-application .mx-lg-n7{margin-right:-28px!important;margin-left:-28px!important}.v-application .mx-lg-n8{margin-right:-32px!important;margin-left:-32px!important}.v-application .mx-lg-n9{margin-right:-36px!important;margin-left:-36px!important}.v-application .mx-lg-n10{margin-right:-40px!important;margin-left:-40px!important}.v-application .mx-lg-n11{margin-right:-44px!important;margin-left:-44px!important}.v-application .mx-lg-n12{margin-right:-48px!important;margin-left:-48px!important}.v-application .mx-lg-n13{margin-right:-52px!important;margin-left:-52px!important}.v-application .mx-lg-n14{margin-right:-56px!important;margin-left:-56px!important}.v-application .mx-lg-n15{margin-right:-60px!important;margin-left:-60px!important}.v-application .mx-lg-n16{margin-right:-64px!important;margin-left:-64px!important}.v-application .my-lg-n1{margin-top:-4px!important;margin-bottom:-4px!important}.v-application .my-lg-n2{margin-top:-8px!important;margin-bottom:-8px!important}.v-application .my-lg-n3{margin-top:-12px!important;margin-bottom:-12px!important}.v-application .my-lg-n4{margin-top:-16px!important;margin-bottom:-16px!important}.v-application .my-lg-n5{margin-top:-20px!important;margin-bottom:-20px!important}.v-application .my-lg-n6{margin-top:-24px!important;margin-bottom:-24px!important}.v-application .my-lg-n7{margin-top:-28px!important;margin-bottom:-28px!important}.v-application .my-lg-n8{margin-top:-32px!important;margin-bottom:-32px!important}.v-application .my-lg-n9{margin-top:-36px!important;margin-bottom:-36px!important}.v-application .my-lg-n10{margin-top:-40px!important;margin-bottom:-40px!important}.v-application .my-lg-n11{margin-top:-44px!important;margin-bottom:-44px!important}.v-application .my-lg-n12{margin-top:-48px!important;margin-bottom:-48px!important}.v-application .my-lg-n13{margin-top:-52px!important;margin-bottom:-52px!important}.v-application .my-lg-n14{margin-top:-56px!important;margin-bottom:-56px!important}.v-application .my-lg-n15{margin-top:-60px!important;margin-bottom:-60px!important}.v-application .my-lg-n16{margin-top:-64px!important;margin-bottom:-64px!important}.v-application .mt-lg-n1{margin-top:-4px!important}.v-application .mt-lg-n2{margin-top:-8px!important}.v-application .mt-lg-n3{margin-top:-12px!important}.v-application .mt-lg-n4{margin-top:-16px!important}.v-application .mt-lg-n5{margin-top:-20px!important}.v-application .mt-lg-n6{margin-top:-24px!important}.v-application .mt-lg-n7{margin-top:-28px!important}.v-application .mt-lg-n8{margin-top:-32px!important}.v-application .mt-lg-n9{margin-top:-36px!important}.v-application .mt-lg-n10{margin-top:-40px!important}.v-application .mt-lg-n11{margin-top:-44px!important}.v-application .mt-lg-n12{margin-top:-48px!important}.v-application .mt-lg-n13{margin-top:-52px!important}.v-application .mt-lg-n14{margin-top:-56px!important}.v-application .mt-lg-n15{margin-top:-60px!important}.v-application .mt-lg-n16{margin-top:-64px!important}.v-application .mr-lg-n1{margin-right:-4px!important}.v-application .mr-lg-n2{margin-right:-8px!important}.v-application .mr-lg-n3{margin-right:-12px!important}.v-application .mr-lg-n4{margin-right:-16px!important}.v-application .mr-lg-n5{margin-right:-20px!important}.v-application .mr-lg-n6{margin-right:-24px!important}.v-application .mr-lg-n7{margin-right:-28px!important}.v-application .mr-lg-n8{margin-right:-32px!important}.v-application .mr-lg-n9{margin-right:-36px!important}.v-application .mr-lg-n10{margin-right:-40px!important}.v-application .mr-lg-n11{margin-right:-44px!important}.v-application .mr-lg-n12{margin-right:-48px!important}.v-application .mr-lg-n13{margin-right:-52px!important}.v-application .mr-lg-n14{margin-right:-56px!important}.v-application .mr-lg-n15{margin-right:-60px!important}.v-application .mr-lg-n16{margin-right:-64px!important}.v-application .mb-lg-n1{margin-bottom:-4px!important}.v-application .mb-lg-n2{margin-bottom:-8px!important}.v-application .mb-lg-n3{margin-bottom:-12px!important}.v-application .mb-lg-n4{margin-bottom:-16px!important}.v-application .mb-lg-n5{margin-bottom:-20px!important}.v-application .mb-lg-n6{margin-bottom:-24px!important}.v-application .mb-lg-n7{margin-bottom:-28px!important}.v-application .mb-lg-n8{margin-bottom:-32px!important}.v-application .mb-lg-n9{margin-bottom:-36px!important}.v-application .mb-lg-n10{margin-bottom:-40px!important}.v-application .mb-lg-n11{margin-bottom:-44px!important}.v-application .mb-lg-n12{margin-bottom:-48px!important}.v-application .mb-lg-n13{margin-bottom:-52px!important}.v-application .mb-lg-n14{margin-bottom:-56px!important}.v-application .mb-lg-n15{margin-bottom:-60px!important}.v-application .mb-lg-n16{margin-bottom:-64px!important}.v-application .ml-lg-n1{margin-left:-4px!important}.v-application .ml-lg-n2{margin-left:-8px!important}.v-application .ml-lg-n3{margin-left:-12px!important}.v-application .ml-lg-n4{margin-left:-16px!important}.v-application .ml-lg-n5{margin-left:-20px!important}.v-application .ml-lg-n6{margin-left:-24px!important}.v-application .ml-lg-n7{margin-left:-28px!important}.v-application .ml-lg-n8{margin-left:-32px!important}.v-application .ml-lg-n9{margin-left:-36px!important}.v-application .ml-lg-n10{margin-left:-40px!important}.v-application .ml-lg-n11{margin-left:-44px!important}.v-application .ml-lg-n12{margin-left:-48px!important}.v-application .ml-lg-n13{margin-left:-52px!important}.v-application .ml-lg-n14{margin-left:-56px!important}.v-application .ml-lg-n15{margin-left:-60px!important}.v-application .ml-lg-n16{margin-left:-64px!important}.v-application--is-ltr .ms-lg-n1{margin-left:-4px!important}.v-application--is-rtl .ms-lg-n1{margin-right:-4px!important}.v-application--is-ltr .ms-lg-n2{margin-left:-8px!important}.v-application--is-rtl .ms-lg-n2{margin-right:-8px!important}.v-application--is-ltr .ms-lg-n3{margin-left:-12px!important}.v-application--is-rtl .ms-lg-n3{margin-right:-12px!important}.v-application--is-ltr .ms-lg-n4{margin-left:-16px!important}.v-application--is-rtl .ms-lg-n4{margin-right:-16px!important}.v-application--is-ltr .ms-lg-n5{margin-left:-20px!important}.v-application--is-rtl .ms-lg-n5{margin-right:-20px!important}.v-application--is-ltr .ms-lg-n6{margin-left:-24px!important}.v-application--is-rtl .ms-lg-n6{margin-right:-24px!important}.v-application--is-ltr .ms-lg-n7{margin-left:-28px!important}.v-application--is-rtl .ms-lg-n7{margin-right:-28px!important}.v-application--is-ltr .ms-lg-n8{margin-left:-32px!important}.v-application--is-rtl .ms-lg-n8{margin-right:-32px!important}.v-application--is-ltr .ms-lg-n9{margin-left:-36px!important}.v-application--is-rtl .ms-lg-n9{margin-right:-36px!important}.v-application--is-ltr .ms-lg-n10{margin-left:-40px!important}.v-application--is-rtl .ms-lg-n10{margin-right:-40px!important}.v-application--is-ltr .ms-lg-n11{margin-left:-44px!important}.v-application--is-rtl .ms-lg-n11{margin-right:-44px!important}.v-application--is-ltr .ms-lg-n12{margin-left:-48px!important}.v-application--is-rtl .ms-lg-n12{margin-right:-48px!important}.v-application--is-ltr .ms-lg-n13{margin-left:-52px!important}.v-application--is-rtl .ms-lg-n13{margin-right:-52px!important}.v-application--is-ltr .ms-lg-n14{margin-left:-56px!important}.v-application--is-rtl .ms-lg-n14{margin-right:-56px!important}.v-application--is-ltr .ms-lg-n15{margin-left:-60px!important}.v-application--is-rtl .ms-lg-n15{margin-right:-60px!important}.v-application--is-ltr .ms-lg-n16{margin-left:-64px!important}.v-application--is-rtl .ms-lg-n16{margin-right:-64px!important}.v-application--is-ltr .me-lg-n1{margin-right:-4px!important}.v-application--is-rtl .me-lg-n1{margin-left:-4px!important}.v-application--is-ltr .me-lg-n2{margin-right:-8px!important}.v-application--is-rtl .me-lg-n2{margin-left:-8px!important}.v-application--is-ltr .me-lg-n3{margin-right:-12px!important}.v-application--is-rtl .me-lg-n3{margin-left:-12px!important}.v-application--is-ltr .me-lg-n4{margin-right:-16px!important}.v-application--is-rtl .me-lg-n4{margin-left:-16px!important}.v-application--is-ltr .me-lg-n5{margin-right:-20px!important}.v-application--is-rtl .me-lg-n5{margin-left:-20px!important}.v-application--is-ltr .me-lg-n6{margin-right:-24px!important}.v-application--is-rtl .me-lg-n6{margin-left:-24px!important}.v-application--is-ltr .me-lg-n7{margin-right:-28px!important}.v-application--is-rtl .me-lg-n7{margin-left:-28px!important}.v-application--is-ltr .me-lg-n8{margin-right:-32px!important}.v-application--is-rtl .me-lg-n8{margin-left:-32px!important}.v-application--is-ltr .me-lg-n9{margin-right:-36px!important}.v-application--is-rtl .me-lg-n9{margin-left:-36px!important}.v-application--is-ltr .me-lg-n10{margin-right:-40px!important}.v-application--is-rtl .me-lg-n10{margin-left:-40px!important}.v-application--is-ltr .me-lg-n11{margin-right:-44px!important}.v-application--is-rtl .me-lg-n11{margin-left:-44px!important}.v-application--is-ltr .me-lg-n12{margin-right:-48px!important}.v-application--is-rtl .me-lg-n12{margin-left:-48px!important}.v-application--is-ltr .me-lg-n13{margin-right:-52px!important}.v-application--is-rtl .me-lg-n13{margin-left:-52px!important}.v-application--is-ltr .me-lg-n14{margin-right:-56px!important}.v-application--is-rtl .me-lg-n14{margin-left:-56px!important}.v-application--is-ltr .me-lg-n15{margin-right:-60px!important}.v-application--is-rtl .me-lg-n15{margin-left:-60px!important}.v-application--is-ltr .me-lg-n16{margin-right:-64px!important}.v-application--is-rtl .me-lg-n16{margin-left:-64px!important}.v-application .pa-lg-0{padding:0!important}.v-application .pa-lg-1{padding:4px!important}.v-application .pa-lg-2{padding:8px!important}.v-application .pa-lg-3{padding:12px!important}.v-application .pa-lg-4{padding:16px!important}.v-application .pa-lg-5{padding:20px!important}.v-application .pa-lg-6{padding:24px!important}.v-application .pa-lg-7{padding:28px!important}.v-application .pa-lg-8{padding:32px!important}.v-application .pa-lg-9{padding:36px!important}.v-application .pa-lg-10{padding:40px!important}.v-application .pa-lg-11{padding:44px!important}.v-application .pa-lg-12{padding:48px!important}.v-application .pa-lg-13{padding:52px!important}.v-application .pa-lg-14{padding:56px!important}.v-application .pa-lg-15{padding:60px!important}.v-application .pa-lg-16{padding:64px!important}.v-application .px-lg-0{padding-right:0!important;padding-left:0!important}.v-application .px-lg-1{padding-right:4px!important;padding-left:4px!important}.v-application .px-lg-2{padding-right:8px!important;padding-left:8px!important}.v-application .px-lg-3{padding-right:12px!important;padding-left:12px!important}.v-application .px-lg-4{padding-right:16px!important;padding-left:16px!important}.v-application .px-lg-5{padding-right:20px!important;padding-left:20px!important}.v-application .px-lg-6{padding-right:24px!important;padding-left:24px!important}.v-application .px-lg-7{padding-right:28px!important;padding-left:28px!important}.v-application .px-lg-8{padding-right:32px!important;padding-left:32px!important}.v-application .px-lg-9{padding-right:36px!important;padding-left:36px!important}.v-application .px-lg-10{padding-right:40px!important;padding-left:40px!important}.v-application .px-lg-11{padding-right:44px!important;padding-left:44px!important}.v-application .px-lg-12{padding-right:48px!important;padding-left:48px!important}.v-application .px-lg-13{padding-right:52px!important;padding-left:52px!important}.v-application .px-lg-14{padding-right:56px!important;padding-left:56px!important}.v-application .px-lg-15{padding-right:60px!important;padding-left:60px!important}.v-application .px-lg-16{padding-right:64px!important;padding-left:64px!important}.v-application .py-lg-0{padding-top:0!important;padding-bottom:0!important}.v-application .py-lg-1{padding-top:4px!important;padding-bottom:4px!important}.v-application .py-lg-2{padding-top:8px!important;padding-bottom:8px!important}.v-application .py-lg-3{padding-top:12px!important;padding-bottom:12px!important}.v-application .py-lg-4{padding-top:16px!important;padding-bottom:16px!important}.v-application .py-lg-5{padding-top:20px!important;padding-bottom:20px!important}.v-application .py-lg-6{padding-top:24px!important;padding-bottom:24px!important}.v-application .py-lg-7{padding-top:28px!important;padding-bottom:28px!important}.v-application .py-lg-8{padding-top:32px!important;padding-bottom:32px!important}.v-application .py-lg-9{padding-top:36px!important;padding-bottom:36px!important}.v-application .py-lg-10{padding-top:40px!important;padding-bottom:40px!important}.v-application .py-lg-11{padding-top:44px!important;padding-bottom:44px!important}.v-application .py-lg-12{padding-top:48px!important;padding-bottom:48px!important}.v-application .py-lg-13{padding-top:52px!important;padding-bottom:52px!important}.v-application .py-lg-14{padding-top:56px!important;padding-bottom:56px!important}.v-application .py-lg-15{padding-top:60px!important;padding-bottom:60px!important}.v-application .py-lg-16{padding-top:64px!important;padding-bottom:64px!important}.v-application .pt-lg-0{padding-top:0!important}.v-application .pt-lg-1{padding-top:4px!important}.v-application .pt-lg-2{padding-top:8px!important}.v-application .pt-lg-3{padding-top:12px!important}.v-application .pt-lg-4{padding-top:16px!important}.v-application .pt-lg-5{padding-top:20px!important}.v-application .pt-lg-6{padding-top:24px!important}.v-application .pt-lg-7{padding-top:28px!important}.v-application .pt-lg-8{padding-top:32px!important}.v-application .pt-lg-9{padding-top:36px!important}.v-application .pt-lg-10{padding-top:40px!important}.v-application .pt-lg-11{padding-top:44px!important}.v-application .pt-lg-12{padding-top:48px!important}.v-application .pt-lg-13{padding-top:52px!important}.v-application .pt-lg-14{padding-top:56px!important}.v-application .pt-lg-15{padding-top:60px!important}.v-application .pt-lg-16{padding-top:64px!important}.v-application .pr-lg-0{padding-right:0!important}.v-application .pr-lg-1{padding-right:4px!important}.v-application .pr-lg-2{padding-right:8px!important}.v-application .pr-lg-3{padding-right:12px!important}.v-application .pr-lg-4{padding-right:16px!important}.v-application .pr-lg-5{padding-right:20px!important}.v-application .pr-lg-6{padding-right:24px!important}.v-application .pr-lg-7{padding-right:28px!important}.v-application .pr-lg-8{padding-right:32px!important}.v-application .pr-lg-9{padding-right:36px!important}.v-application .pr-lg-10{padding-right:40px!important}.v-application .pr-lg-11{padding-right:44px!important}.v-application .pr-lg-12{padding-right:48px!important}.v-application .pr-lg-13{padding-right:52px!important}.v-application .pr-lg-14{padding-right:56px!important}.v-application .pr-lg-15{padding-right:60px!important}.v-application .pr-lg-16{padding-right:64px!important}.v-application .pb-lg-0{padding-bottom:0!important}.v-application .pb-lg-1{padding-bottom:4px!important}.v-application .pb-lg-2{padding-bottom:8px!important}.v-application .pb-lg-3{padding-bottom:12px!important}.v-application .pb-lg-4{padding-bottom:16px!important}.v-application .pb-lg-5{padding-bottom:20px!important}.v-application .pb-lg-6{padding-bottom:24px!important}.v-application .pb-lg-7{padding-bottom:28px!important}.v-application .pb-lg-8{padding-bottom:32px!important}.v-application .pb-lg-9{padding-bottom:36px!important}.v-application .pb-lg-10{padding-bottom:40px!important}.v-application .pb-lg-11{padding-bottom:44px!important}.v-application .pb-lg-12{padding-bottom:48px!important}.v-application .pb-lg-13{padding-bottom:52px!important}.v-application .pb-lg-14{padding-bottom:56px!important}.v-application .pb-lg-15{padding-bottom:60px!important}.v-application .pb-lg-16{padding-bottom:64px!important}.v-application .pl-lg-0{padding-left:0!important}.v-application .pl-lg-1{padding-left:4px!important}.v-application .pl-lg-2{padding-left:8px!important}.v-application .pl-lg-3{padding-left:12px!important}.v-application .pl-lg-4{padding-left:16px!important}.v-application .pl-lg-5{padding-left:20px!important}.v-application .pl-lg-6{padding-left:24px!important}.v-application .pl-lg-7{padding-left:28px!important}.v-application .pl-lg-8{padding-left:32px!important}.v-application .pl-lg-9{padding-left:36px!important}.v-application .pl-lg-10{padding-left:40px!important}.v-application .pl-lg-11{padding-left:44px!important}.v-application .pl-lg-12{padding-left:48px!important}.v-application .pl-lg-13{padding-left:52px!important}.v-application .pl-lg-14{padding-left:56px!important}.v-application .pl-lg-15{padding-left:60px!important}.v-application .pl-lg-16{padding-left:64px!important}.v-application--is-ltr .ps-lg-0{padding-left:0!important}.v-application--is-rtl .ps-lg-0{padding-right:0!important}.v-application--is-ltr .ps-lg-1{padding-left:4px!important}.v-application--is-rtl .ps-lg-1{padding-right:4px!important}.v-application--is-ltr .ps-lg-2{padding-left:8px!important}.v-application--is-rtl .ps-lg-2{padding-right:8px!important}.v-application--is-ltr .ps-lg-3{padding-left:12px!important}.v-application--is-rtl .ps-lg-3{padding-right:12px!important}.v-application--is-ltr .ps-lg-4{padding-left:16px!important}.v-application--is-rtl .ps-lg-4{padding-right:16px!important}.v-application--is-ltr .ps-lg-5{padding-left:20px!important}.v-application--is-rtl .ps-lg-5{padding-right:20px!important}.v-application--is-ltr .ps-lg-6{padding-left:24px!important}.v-application--is-rtl .ps-lg-6{padding-right:24px!important}.v-application--is-ltr .ps-lg-7{padding-left:28px!important}.v-application--is-rtl .ps-lg-7{padding-right:28px!important}.v-application--is-ltr .ps-lg-8{padding-left:32px!important}.v-application--is-rtl .ps-lg-8{padding-right:32px!important}.v-application--is-ltr .ps-lg-9{padding-left:36px!important}.v-application--is-rtl .ps-lg-9{padding-right:36px!important}.v-application--is-ltr .ps-lg-10{padding-left:40px!important}.v-application--is-rtl .ps-lg-10{padding-right:40px!important}.v-application--is-ltr .ps-lg-11{padding-left:44px!important}.v-application--is-rtl .ps-lg-11{padding-right:44px!important}.v-application--is-ltr .ps-lg-12{padding-left:48px!important}.v-application--is-rtl .ps-lg-12{padding-right:48px!important}.v-application--is-ltr .ps-lg-13{padding-left:52px!important}.v-application--is-rtl .ps-lg-13{padding-right:52px!important}.v-application--is-ltr .ps-lg-14{padding-left:56px!important}.v-application--is-rtl .ps-lg-14{padding-right:56px!important}.v-application--is-ltr .ps-lg-15{padding-left:60px!important}.v-application--is-rtl .ps-lg-15{padding-right:60px!important}.v-application--is-ltr .ps-lg-16{padding-left:64px!important}.v-application--is-rtl .ps-lg-16{padding-right:64px!important}.v-application--is-ltr .pe-lg-0{padding-right:0!important}.v-application--is-rtl .pe-lg-0{padding-left:0!important}.v-application--is-ltr .pe-lg-1{padding-right:4px!important}.v-application--is-rtl .pe-lg-1{padding-left:4px!important}.v-application--is-ltr .pe-lg-2{padding-right:8px!important}.v-application--is-rtl .pe-lg-2{padding-left:8px!important}.v-application--is-ltr .pe-lg-3{padding-right:12px!important}.v-application--is-rtl .pe-lg-3{padding-left:12px!important}.v-application--is-ltr .pe-lg-4{padding-right:16px!important}.v-application--is-rtl .pe-lg-4{padding-left:16px!important}.v-application--is-ltr .pe-lg-5{padding-right:20px!important}.v-application--is-rtl .pe-lg-5{padding-left:20px!important}.v-application--is-ltr .pe-lg-6{padding-right:24px!important}.v-application--is-rtl .pe-lg-6{padding-left:24px!important}.v-application--is-ltr .pe-lg-7{padding-right:28px!important}.v-application--is-rtl .pe-lg-7{padding-left:28px!important}.v-application--is-ltr .pe-lg-8{padding-right:32px!important}.v-application--is-rtl .pe-lg-8{padding-left:32px!important}.v-application--is-ltr .pe-lg-9{padding-right:36px!important}.v-application--is-rtl .pe-lg-9{padding-left:36px!important}.v-application--is-ltr .pe-lg-10{padding-right:40px!important}.v-application--is-rtl .pe-lg-10{padding-left:40px!important}.v-application--is-ltr .pe-lg-11{padding-right:44px!important}.v-application--is-rtl .pe-lg-11{padding-left:44px!important}.v-application--is-ltr .pe-lg-12{padding-right:48px!important}.v-application--is-rtl .pe-lg-12{padding-left:48px!important}.v-application--is-ltr .pe-lg-13{padding-right:52px!important}.v-application--is-rtl .pe-lg-13{padding-left:52px!important}.v-application--is-ltr .pe-lg-14{padding-right:56px!important}.v-application--is-rtl .pe-lg-14{padding-left:56px!important}.v-application--is-ltr .pe-lg-15{padding-right:60px!important}.v-application--is-rtl .pe-lg-15{padding-left:60px!important}.v-application--is-ltr .pe-lg-16{padding-right:64px!important}.v-application--is-rtl .pe-lg-16{padding-left:64px!important}.v-application .text-lg-left{text-align:left!important}.v-application .text-lg-right{text-align:right!important}.v-application .text-lg-center{text-align:center!important}.v-application .text-lg-justify{text-align:justify!important}.v-application .text-lg-start{text-align:start!important}.v-application .text-lg-end{text-align:end!important}.v-application .text-lg-h1{font-size:2rem!important;font-weight:600;line-height:2.4285714286rem;letter-spacing:-.02em!important;font-family:AkkuratLL,Helvetica,Arial,sans-serif!important}.v-application .text-lg-h2{font-size:1.7142857143rem!important;line-height:2.2857142857rem}.v-application .text-lg-h2,.v-application .text-lg-h3{font-weight:600;letter-spacing:-.01em!important;font-family:AkkuratLL,Helvetica,Arial,sans-serif!important}.v-application .text-lg-h3{font-size:1.4285714286rem!important;line-height:2rem}.v-application .text-lg-h4{font-size:1.2857142857rem!important}.v-application .text-lg-h4,.v-application .text-lg-h5{font-weight:600;line-height:1.7142857143rem;letter-spacing:-.01em!important;font-family:AkkuratLL,Helvetica,Arial,sans-serif!important}.v-application .text-lg-h5{font-size:1.1428571429rem!important}.v-application .text-lg-h6{font-size:1rem!important;font-weight:500;line-height:1.4285714286rem;letter-spacing:normal!important;font-family:AkkuratLL,Helvetica,Arial,sans-serif!important}.v-application .text-lg-subtitle-1{font-size:.8571428571rem!important}.v-application .text-lg-subtitle-1,.v-application .text-lg-subtitle-2{font-weight:400;line-height:1.1428571429rem;letter-spacing:normal!important;font-family:AkkuratLL,Helvetica,Arial,sans-serif!important}.v-application .text-lg-subtitle-2{font-size:.7142857143rem!important}.v-application .text-lg-body-1{font-size:1.1428571429rem!important;line-height:1.7142857143rem;letter-spacing:normal!important}.v-application .text-lg-body-1,.v-application .text-lg-body-2{font-weight:400;font-family:AkkuratLL,Helvetica,Arial,sans-serif!important}.v-application .text-lg-body-2{font-size:1rem!important;line-height:1.4285714286rem;letter-spacing:-.02em!important}.v-application .text-lg-button{font-size:.875rem!important;font-weight:500;line-height:2.25rem;letter-spacing:.0892857143em!important;font-family:AkkuratLL,Helvetica,Arial,sans-serif!important;text-transform:uppercase!important}.v-application .text-lg-caption{font-weight:400;line-height:1.25rem;letter-spacing:.0333333333em!important}.v-application .text-lg-caption,.v-application .text-lg-overline{font-size:.75rem!important;font-family:AkkuratLL,Helvetica,Arial,sans-serif!important}.v-application .text-lg-overline{font-weight:500;line-height:2rem;letter-spacing:.1666666667em!important;text-transform:uppercase!important}}@media(min-width:1904px){.v-application .d-xl-none{display:none!important}.v-application .d-xl-inline{display:inline!important}.v-application .d-xl-inline-block{display:inline-block!important}.v-application .d-xl-block{display:block!important}.v-application .d-xl-table{display:table!important}.v-application .d-xl-table-row{display:table-row!important}.v-application .d-xl-table-cell{display:table-cell!important}.v-application .d-xl-flex{display:flex!important}.v-application .d-xl-inline-flex{display:inline-flex!important}.v-application .float-xl-none{float:none!important}.v-application .float-xl-left{float:left!important}.v-application .float-xl-right{float:right!important}.v-application .flex-xl-fill{flex:1 1 auto!important}.v-application .flex-xl-row{flex-direction:row!important}.v-application .flex-xl-column{flex-direction:column!important}.v-application .flex-xl-row-reverse{flex-direction:row-reverse!important}.v-application .flex-xl-column-reverse{flex-direction:column-reverse!important}.v-application .flex-xl-grow-0{flex-grow:0!important}.v-application .flex-xl-grow-1{flex-grow:1!important}.v-application .flex-xl-shrink-0{flex-shrink:0!important}.v-application .flex-xl-shrink-1{flex-shrink:1!important}.v-application .flex-xl-wrap{flex-wrap:wrap!important}.v-application .flex-xl-nowrap{flex-wrap:nowrap!important}.v-application .flex-xl-wrap-reverse{flex-wrap:wrap-reverse!important}.v-application .justify-xl-start{justify-content:flex-start!important}.v-application .justify-xl-end{justify-content:flex-end!important}.v-application .justify-xl-center{justify-content:center!important}.v-application .justify-xl-space-between{justify-content:space-between!important}.v-application .justify-xl-space-around{justify-content:space-around!important}.v-application .align-xl-start{align-items:flex-start!important}.v-application .align-xl-end{align-items:flex-end!important}.v-application .align-xl-center{align-items:center!important}.v-application .align-xl-baseline{align-items:baseline!important}.v-application .align-xl-stretch{align-items:stretch!important}.v-application .align-content-xl-start{align-content:flex-start!important}.v-application .align-content-xl-end{align-content:flex-end!important}.v-application .align-content-xl-center{align-content:center!important}.v-application .align-content-xl-space-between{align-content:space-between!important}.v-application .align-content-xl-space-around{align-content:space-around!important}.v-application .align-content-xl-stretch{align-content:stretch!important}.v-application .align-self-xl-auto{align-self:auto!important}.v-application .align-self-xl-start{align-self:flex-start!important}.v-application .align-self-xl-end{align-self:flex-end!important}.v-application .align-self-xl-center{align-self:center!important}.v-application .align-self-xl-baseline{align-self:baseline!important}.v-application .align-self-xl-stretch{align-self:stretch!important}.v-application .order-xl-first{order:-1!important}.v-application .order-xl-0{order:0!important}.v-application .order-xl-1{order:1!important}.v-application .order-xl-2{order:2!important}.v-application .order-xl-3{order:3!important}.v-application .order-xl-4{order:4!important}.v-application .order-xl-5{order:5!important}.v-application .order-xl-6{order:6!important}.v-application .order-xl-7{order:7!important}.v-application .order-xl-8{order:8!important}.v-application .order-xl-9{order:9!important}.v-application .order-xl-10{order:10!important}.v-application .order-xl-11{order:11!important}.v-application .order-xl-12{order:12!important}.v-application .order-xl-last{order:13!important}.v-application .ma-xl-0{margin:0!important}.v-application .ma-xl-1{margin:4px!important}.v-application .ma-xl-2{margin:8px!important}.v-application .ma-xl-3{margin:12px!important}.v-application .ma-xl-4{margin:16px!important}.v-application .ma-xl-5{margin:20px!important}.v-application .ma-xl-6{margin:24px!important}.v-application .ma-xl-7{margin:28px!important}.v-application .ma-xl-8{margin:32px!important}.v-application .ma-xl-9{margin:36px!important}.v-application .ma-xl-10{margin:40px!important}.v-application .ma-xl-11{margin:44px!important}.v-application .ma-xl-12{margin:48px!important}.v-application .ma-xl-13{margin:52px!important}.v-application .ma-xl-14{margin:56px!important}.v-application .ma-xl-15{margin:60px!important}.v-application .ma-xl-16{margin:64px!important}.v-application .ma-xl-auto{margin:auto!important}.v-application .mx-xl-0{margin-right:0!important;margin-left:0!important}.v-application .mx-xl-1{margin-right:4px!important;margin-left:4px!important}.v-application .mx-xl-2{margin-right:8px!important;margin-left:8px!important}.v-application .mx-xl-3{margin-right:12px!important;margin-left:12px!important}.v-application .mx-xl-4{margin-right:16px!important;margin-left:16px!important}.v-application .mx-xl-5{margin-right:20px!important;margin-left:20px!important}.v-application .mx-xl-6{margin-right:24px!important;margin-left:24px!important}.v-application .mx-xl-7{margin-right:28px!important;margin-left:28px!important}.v-application .mx-xl-8{margin-right:32px!important;margin-left:32px!important}.v-application .mx-xl-9{margin-right:36px!important;margin-left:36px!important}.v-application .mx-xl-10{margin-right:40px!important;margin-left:40px!important}.v-application .mx-xl-11{margin-right:44px!important;margin-left:44px!important}.v-application .mx-xl-12{margin-right:48px!important;margin-left:48px!important}.v-application .mx-xl-13{margin-right:52px!important;margin-left:52px!important}.v-application .mx-xl-14{margin-right:56px!important;margin-left:56px!important}.v-application .mx-xl-15{margin-right:60px!important;margin-left:60px!important}.v-application .mx-xl-16{margin-right:64px!important;margin-left:64px!important}.v-application .mx-xl-auto{margin-right:auto!important;margin-left:auto!important}.v-application .my-xl-0{margin-top:0!important;margin-bottom:0!important}.v-application .my-xl-1{margin-top:4px!important;margin-bottom:4px!important}.v-application .my-xl-2{margin-top:8px!important;margin-bottom:8px!important}.v-application .my-xl-3{margin-top:12px!important;margin-bottom:12px!important}.v-application .my-xl-4{margin-top:16px!important;margin-bottom:16px!important}.v-application .my-xl-5{margin-top:20px!important;margin-bottom:20px!important}.v-application .my-xl-6{margin-top:24px!important;margin-bottom:24px!important}.v-application .my-xl-7{margin-top:28px!important;margin-bottom:28px!important}.v-application .my-xl-8{margin-top:32px!important;margin-bottom:32px!important}.v-application .my-xl-9{margin-top:36px!important;margin-bottom:36px!important}.v-application .my-xl-10{margin-top:40px!important;margin-bottom:40px!important}.v-application .my-xl-11{margin-top:44px!important;margin-bottom:44px!important}.v-application .my-xl-12{margin-top:48px!important;margin-bottom:48px!important}.v-application .my-xl-13{margin-top:52px!important;margin-bottom:52px!important}.v-application .my-xl-14{margin-top:56px!important;margin-bottom:56px!important}.v-application .my-xl-15{margin-top:60px!important;margin-bottom:60px!important}.v-application .my-xl-16{margin-top:64px!important;margin-bottom:64px!important}.v-application .my-xl-auto{margin-top:auto!important;margin-bottom:auto!important}.v-application .mt-xl-0{margin-top:0!important}.v-application .mt-xl-1{margin-top:4px!important}.v-application .mt-xl-2{margin-top:8px!important}.v-application .mt-xl-3{margin-top:12px!important}.v-application .mt-xl-4{margin-top:16px!important}.v-application .mt-xl-5{margin-top:20px!important}.v-application .mt-xl-6{margin-top:24px!important}.v-application .mt-xl-7{margin-top:28px!important}.v-application .mt-xl-8{margin-top:32px!important}.v-application .mt-xl-9{margin-top:36px!important}.v-application .mt-xl-10{margin-top:40px!important}.v-application .mt-xl-11{margin-top:44px!important}.v-application .mt-xl-12{margin-top:48px!important}.v-application .mt-xl-13{margin-top:52px!important}.v-application .mt-xl-14{margin-top:56px!important}.v-application .mt-xl-15{margin-top:60px!important}.v-application .mt-xl-16{margin-top:64px!important}.v-application .mt-xl-auto{margin-top:auto!important}.v-application .mr-xl-0{margin-right:0!important}.v-application .mr-xl-1{margin-right:4px!important}.v-application .mr-xl-2{margin-right:8px!important}.v-application .mr-xl-3{margin-right:12px!important}.v-application .mr-xl-4{margin-right:16px!important}.v-application .mr-xl-5{margin-right:20px!important}.v-application .mr-xl-6{margin-right:24px!important}.v-application .mr-xl-7{margin-right:28px!important}.v-application .mr-xl-8{margin-right:32px!important}.v-application .mr-xl-9{margin-right:36px!important}.v-application .mr-xl-10{margin-right:40px!important}.v-application .mr-xl-11{margin-right:44px!important}.v-application .mr-xl-12{margin-right:48px!important}.v-application .mr-xl-13{margin-right:52px!important}.v-application .mr-xl-14{margin-right:56px!important}.v-application .mr-xl-15{margin-right:60px!important}.v-application .mr-xl-16{margin-right:64px!important}.v-application .mr-xl-auto{margin-right:auto!important}.v-application .mb-xl-0{margin-bottom:0!important}.v-application .mb-xl-1{margin-bottom:4px!important}.v-application .mb-xl-2{margin-bottom:8px!important}.v-application .mb-xl-3{margin-bottom:12px!important}.v-application .mb-xl-4{margin-bottom:16px!important}.v-application .mb-xl-5{margin-bottom:20px!important}.v-application .mb-xl-6{margin-bottom:24px!important}.v-application .mb-xl-7{margin-bottom:28px!important}.v-application .mb-xl-8{margin-bottom:32px!important}.v-application .mb-xl-9{margin-bottom:36px!important}.v-application .mb-xl-10{margin-bottom:40px!important}.v-application .mb-xl-11{margin-bottom:44px!important}.v-application .mb-xl-12{margin-bottom:48px!important}.v-application .mb-xl-13{margin-bottom:52px!important}.v-application .mb-xl-14{margin-bottom:56px!important}.v-application .mb-xl-15{margin-bottom:60px!important}.v-application .mb-xl-16{margin-bottom:64px!important}.v-application .mb-xl-auto{margin-bottom:auto!important}.v-application .ml-xl-0{margin-left:0!important}.v-application .ml-xl-1{margin-left:4px!important}.v-application .ml-xl-2{margin-left:8px!important}.v-application .ml-xl-3{margin-left:12px!important}.v-application .ml-xl-4{margin-left:16px!important}.v-application .ml-xl-5{margin-left:20px!important}.v-application .ml-xl-6{margin-left:24px!important}.v-application .ml-xl-7{margin-left:28px!important}.v-application .ml-xl-8{margin-left:32px!important}.v-application .ml-xl-9{margin-left:36px!important}.v-application .ml-xl-10{margin-left:40px!important}.v-application .ml-xl-11{margin-left:44px!important}.v-application .ml-xl-12{margin-left:48px!important}.v-application .ml-xl-13{margin-left:52px!important}.v-application .ml-xl-14{margin-left:56px!important}.v-application .ml-xl-15{margin-left:60px!important}.v-application .ml-xl-16{margin-left:64px!important}.v-application .ml-xl-auto{margin-left:auto!important}.v-application--is-ltr .ms-xl-0{margin-left:0!important}.v-application--is-rtl .ms-xl-0{margin-right:0!important}.v-application--is-ltr .ms-xl-1{margin-left:4px!important}.v-application--is-rtl .ms-xl-1{margin-right:4px!important}.v-application--is-ltr .ms-xl-2{margin-left:8px!important}.v-application--is-rtl .ms-xl-2{margin-right:8px!important}.v-application--is-ltr .ms-xl-3{margin-left:12px!important}.v-application--is-rtl .ms-xl-3{margin-right:12px!important}.v-application--is-ltr .ms-xl-4{margin-left:16px!important}.v-application--is-rtl .ms-xl-4{margin-right:16px!important}.v-application--is-ltr .ms-xl-5{margin-left:20px!important}.v-application--is-rtl .ms-xl-5{margin-right:20px!important}.v-application--is-ltr .ms-xl-6{margin-left:24px!important}.v-application--is-rtl .ms-xl-6{margin-right:24px!important}.v-application--is-ltr .ms-xl-7{margin-left:28px!important}.v-application--is-rtl .ms-xl-7{margin-right:28px!important}.v-application--is-ltr .ms-xl-8{margin-left:32px!important}.v-application--is-rtl .ms-xl-8{margin-right:32px!important}.v-application--is-ltr .ms-xl-9{margin-left:36px!important}.v-application--is-rtl .ms-xl-9{margin-right:36px!important}.v-application--is-ltr .ms-xl-10{margin-left:40px!important}.v-application--is-rtl .ms-xl-10{margin-right:40px!important}.v-application--is-ltr .ms-xl-11{margin-left:44px!important}.v-application--is-rtl .ms-xl-11{margin-right:44px!important}.v-application--is-ltr .ms-xl-12{margin-left:48px!important}.v-application--is-rtl .ms-xl-12{margin-right:48px!important}.v-application--is-ltr .ms-xl-13{margin-left:52px!important}.v-application--is-rtl .ms-xl-13{margin-right:52px!important}.v-application--is-ltr .ms-xl-14{margin-left:56px!important}.v-application--is-rtl .ms-xl-14{margin-right:56px!important}.v-application--is-ltr .ms-xl-15{margin-left:60px!important}.v-application--is-rtl .ms-xl-15{margin-right:60px!important}.v-application--is-ltr .ms-xl-16{margin-left:64px!important}.v-application--is-rtl .ms-xl-16{margin-right:64px!important}.v-application--is-ltr .ms-xl-auto{margin-left:auto!important}.v-application--is-rtl .ms-xl-auto{margin-right:auto!important}.v-application--is-ltr .me-xl-0{margin-right:0!important}.v-application--is-rtl .me-xl-0{margin-left:0!important}.v-application--is-ltr .me-xl-1{margin-right:4px!important}.v-application--is-rtl .me-xl-1{margin-left:4px!important}.v-application--is-ltr .me-xl-2{margin-right:8px!important}.v-application--is-rtl .me-xl-2{margin-left:8px!important}.v-application--is-ltr .me-xl-3{margin-right:12px!important}.v-application--is-rtl .me-xl-3{margin-left:12px!important}.v-application--is-ltr .me-xl-4{margin-right:16px!important}.v-application--is-rtl .me-xl-4{margin-left:16px!important}.v-application--is-ltr .me-xl-5{margin-right:20px!important}.v-application--is-rtl .me-xl-5{margin-left:20px!important}.v-application--is-ltr .me-xl-6{margin-right:24px!important}.v-application--is-rtl .me-xl-6{margin-left:24px!important}.v-application--is-ltr .me-xl-7{margin-right:28px!important}.v-application--is-rtl .me-xl-7{margin-left:28px!important}.v-application--is-ltr .me-xl-8{margin-right:32px!important}.v-application--is-rtl .me-xl-8{margin-left:32px!important}.v-application--is-ltr .me-xl-9{margin-right:36px!important}.v-application--is-rtl .me-xl-9{margin-left:36px!important}.v-application--is-ltr .me-xl-10{margin-right:40px!important}.v-application--is-rtl .me-xl-10{margin-left:40px!important}.v-application--is-ltr .me-xl-11{margin-right:44px!important}.v-application--is-rtl .me-xl-11{margin-left:44px!important}.v-application--is-ltr .me-xl-12{margin-right:48px!important}.v-application--is-rtl .me-xl-12{margin-left:48px!important}.v-application--is-ltr .me-xl-13{margin-right:52px!important}.v-application--is-rtl .me-xl-13{margin-left:52px!important}.v-application--is-ltr .me-xl-14{margin-right:56px!important}.v-application--is-rtl .me-xl-14{margin-left:56px!important}.v-application--is-ltr .me-xl-15{margin-right:60px!important}.v-application--is-rtl .me-xl-15{margin-left:60px!important}.v-application--is-ltr .me-xl-16{margin-right:64px!important}.v-application--is-rtl .me-xl-16{margin-left:64px!important}.v-application--is-ltr .me-xl-auto{margin-right:auto!important}.v-application--is-rtl .me-xl-auto{margin-left:auto!important}.v-application .ma-xl-n1{margin:-4px!important}.v-application .ma-xl-n2{margin:-8px!important}.v-application .ma-xl-n3{margin:-12px!important}.v-application .ma-xl-n4{margin:-16px!important}.v-application .ma-xl-n5{margin:-20px!important}.v-application .ma-xl-n6{margin:-24px!important}.v-application .ma-xl-n7{margin:-28px!important}.v-application .ma-xl-n8{margin:-32px!important}.v-application .ma-xl-n9{margin:-36px!important}.v-application .ma-xl-n10{margin:-40px!important}.v-application .ma-xl-n11{margin:-44px!important}.v-application .ma-xl-n12{margin:-48px!important}.v-application .ma-xl-n13{margin:-52px!important}.v-application .ma-xl-n14{margin:-56px!important}.v-application .ma-xl-n15{margin:-60px!important}.v-application .ma-xl-n16{margin:-64px!important}.v-application .mx-xl-n1{margin-right:-4px!important;margin-left:-4px!important}.v-application .mx-xl-n2{margin-right:-8px!important;margin-left:-8px!important}.v-application .mx-xl-n3{margin-right:-12px!important;margin-left:-12px!important}.v-application .mx-xl-n4{margin-right:-16px!important;margin-left:-16px!important}.v-application .mx-xl-n5{margin-right:-20px!important;margin-left:-20px!important}.v-application .mx-xl-n6{margin-right:-24px!important;margin-left:-24px!important}.v-application .mx-xl-n7{margin-right:-28px!important;margin-left:-28px!important}.v-application .mx-xl-n8{margin-right:-32px!important;margin-left:-32px!important}.v-application .mx-xl-n9{margin-right:-36px!important;margin-left:-36px!important}.v-application .mx-xl-n10{margin-right:-40px!important;margin-left:-40px!important}.v-application .mx-xl-n11{margin-right:-44px!important;margin-left:-44px!important}.v-application .mx-xl-n12{margin-right:-48px!important;margin-left:-48px!important}.v-application .mx-xl-n13{margin-right:-52px!important;margin-left:-52px!important}.v-application .mx-xl-n14{margin-right:-56px!important;margin-left:-56px!important}.v-application .mx-xl-n15{margin-right:-60px!important;margin-left:-60px!important}.v-application .mx-xl-n16{margin-right:-64px!important;margin-left:-64px!important}.v-application .my-xl-n1{margin-top:-4px!important;margin-bottom:-4px!important}.v-application .my-xl-n2{margin-top:-8px!important;margin-bottom:-8px!important}.v-application .my-xl-n3{margin-top:-12px!important;margin-bottom:-12px!important}.v-application .my-xl-n4{margin-top:-16px!important;margin-bottom:-16px!important}.v-application .my-xl-n5{margin-top:-20px!important;margin-bottom:-20px!important}.v-application .my-xl-n6{margin-top:-24px!important;margin-bottom:-24px!important}.v-application .my-xl-n7{margin-top:-28px!important;margin-bottom:-28px!important}.v-application .my-xl-n8{margin-top:-32px!important;margin-bottom:-32px!important}.v-application .my-xl-n9{margin-top:-36px!important;margin-bottom:-36px!important}.v-application .my-xl-n10{margin-top:-40px!important;margin-bottom:-40px!important}.v-application .my-xl-n11{margin-top:-44px!important;margin-bottom:-44px!important}.v-application .my-xl-n12{margin-top:-48px!important;margin-bottom:-48px!important}.v-application .my-xl-n13{margin-top:-52px!important;margin-bottom:-52px!important}.v-application .my-xl-n14{margin-top:-56px!important;margin-bottom:-56px!important}.v-application .my-xl-n15{margin-top:-60px!important;margin-bottom:-60px!important}.v-application .my-xl-n16{margin-top:-64px!important;margin-bottom:-64px!important}.v-application .mt-xl-n1{margin-top:-4px!important}.v-application .mt-xl-n2{margin-top:-8px!important}.v-application .mt-xl-n3{margin-top:-12px!important}.v-application .mt-xl-n4{margin-top:-16px!important}.v-application .mt-xl-n5{margin-top:-20px!important}.v-application .mt-xl-n6{margin-top:-24px!important}.v-application .mt-xl-n7{margin-top:-28px!important}.v-application .mt-xl-n8{margin-top:-32px!important}.v-application .mt-xl-n9{margin-top:-36px!important}.v-application .mt-xl-n10{margin-top:-40px!important}.v-application .mt-xl-n11{margin-top:-44px!important}.v-application .mt-xl-n12{margin-top:-48px!important}.v-application .mt-xl-n13{margin-top:-52px!important}.v-application .mt-xl-n14{margin-top:-56px!important}.v-application .mt-xl-n15{margin-top:-60px!important}.v-application .mt-xl-n16{margin-top:-64px!important}.v-application .mr-xl-n1{margin-right:-4px!important}.v-application .mr-xl-n2{margin-right:-8px!important}.v-application .mr-xl-n3{margin-right:-12px!important}.v-application .mr-xl-n4{margin-right:-16px!important}.v-application .mr-xl-n5{margin-right:-20px!important}.v-application .mr-xl-n6{margin-right:-24px!important}.v-application .mr-xl-n7{margin-right:-28px!important}.v-application .mr-xl-n8{margin-right:-32px!important}.v-application .mr-xl-n9{margin-right:-36px!important}.v-application .mr-xl-n10{margin-right:-40px!important}.v-application .mr-xl-n11{margin-right:-44px!important}.v-application .mr-xl-n12{margin-right:-48px!important}.v-application .mr-xl-n13{margin-right:-52px!important}.v-application .mr-xl-n14{margin-right:-56px!important}.v-application .mr-xl-n15{margin-right:-60px!important}.v-application .mr-xl-n16{margin-right:-64px!important}.v-application .mb-xl-n1{margin-bottom:-4px!important}.v-application .mb-xl-n2{margin-bottom:-8px!important}.v-application .mb-xl-n3{margin-bottom:-12px!important}.v-application .mb-xl-n4{margin-bottom:-16px!important}.v-application .mb-xl-n5{margin-bottom:-20px!important}.v-application .mb-xl-n6{margin-bottom:-24px!important}.v-application .mb-xl-n7{margin-bottom:-28px!important}.v-application .mb-xl-n8{margin-bottom:-32px!important}.v-application .mb-xl-n9{margin-bottom:-36px!important}.v-application .mb-xl-n10{margin-bottom:-40px!important}.v-application .mb-xl-n11{margin-bottom:-44px!important}.v-application .mb-xl-n12{margin-bottom:-48px!important}.v-application .mb-xl-n13{margin-bottom:-52px!important}.v-application .mb-xl-n14{margin-bottom:-56px!important}.v-application .mb-xl-n15{margin-bottom:-60px!important}.v-application .mb-xl-n16{margin-bottom:-64px!important}.v-application .ml-xl-n1{margin-left:-4px!important}.v-application .ml-xl-n2{margin-left:-8px!important}.v-application .ml-xl-n3{margin-left:-12px!important}.v-application .ml-xl-n4{margin-left:-16px!important}.v-application .ml-xl-n5{margin-left:-20px!important}.v-application .ml-xl-n6{margin-left:-24px!important}.v-application .ml-xl-n7{margin-left:-28px!important}.v-application .ml-xl-n8{margin-left:-32px!important}.v-application .ml-xl-n9{margin-left:-36px!important}.v-application .ml-xl-n10{margin-left:-40px!important}.v-application .ml-xl-n11{margin-left:-44px!important}.v-application .ml-xl-n12{margin-left:-48px!important}.v-application .ml-xl-n13{margin-left:-52px!important}.v-application .ml-xl-n14{margin-left:-56px!important}.v-application .ml-xl-n15{margin-left:-60px!important}.v-application .ml-xl-n16{margin-left:-64px!important}.v-application--is-ltr .ms-xl-n1{margin-left:-4px!important}.v-application--is-rtl .ms-xl-n1{margin-right:-4px!important}.v-application--is-ltr .ms-xl-n2{margin-left:-8px!important}.v-application--is-rtl .ms-xl-n2{margin-right:-8px!important}.v-application--is-ltr .ms-xl-n3{margin-left:-12px!important}.v-application--is-rtl .ms-xl-n3{margin-right:-12px!important}.v-application--is-ltr .ms-xl-n4{margin-left:-16px!important}.v-application--is-rtl .ms-xl-n4{margin-right:-16px!important}.v-application--is-ltr .ms-xl-n5{margin-left:-20px!important}.v-application--is-rtl .ms-xl-n5{margin-right:-20px!important}.v-application--is-ltr .ms-xl-n6{margin-left:-24px!important}.v-application--is-rtl .ms-xl-n6{margin-right:-24px!important}.v-application--is-ltr .ms-xl-n7{margin-left:-28px!important}.v-application--is-rtl .ms-xl-n7{margin-right:-28px!important}.v-application--is-ltr .ms-xl-n8{margin-left:-32px!important}.v-application--is-rtl .ms-xl-n8{margin-right:-32px!important}.v-application--is-ltr .ms-xl-n9{margin-left:-36px!important}.v-application--is-rtl .ms-xl-n9{margin-right:-36px!important}.v-application--is-ltr .ms-xl-n10{margin-left:-40px!important}.v-application--is-rtl .ms-xl-n10{margin-right:-40px!important}.v-application--is-ltr .ms-xl-n11{margin-left:-44px!important}.v-application--is-rtl .ms-xl-n11{margin-right:-44px!important}.v-application--is-ltr .ms-xl-n12{margin-left:-48px!important}.v-application--is-rtl .ms-xl-n12{margin-right:-48px!important}.v-application--is-ltr .ms-xl-n13{margin-left:-52px!important}.v-application--is-rtl .ms-xl-n13{margin-right:-52px!important}.v-application--is-ltr .ms-xl-n14{margin-left:-56px!important}.v-application--is-rtl .ms-xl-n14{margin-right:-56px!important}.v-application--is-ltr .ms-xl-n15{margin-left:-60px!important}.v-application--is-rtl .ms-xl-n15{margin-right:-60px!important}.v-application--is-ltr .ms-xl-n16{margin-left:-64px!important}.v-application--is-rtl .ms-xl-n16{margin-right:-64px!important}.v-application--is-ltr .me-xl-n1{margin-right:-4px!important}.v-application--is-rtl .me-xl-n1{margin-left:-4px!important}.v-application--is-ltr .me-xl-n2{margin-right:-8px!important}.v-application--is-rtl .me-xl-n2{margin-left:-8px!important}.v-application--is-ltr .me-xl-n3{margin-right:-12px!important}.v-application--is-rtl .me-xl-n3{margin-left:-12px!important}.v-application--is-ltr .me-xl-n4{margin-right:-16px!important}.v-application--is-rtl .me-xl-n4{margin-left:-16px!important}.v-application--is-ltr .me-xl-n5{margin-right:-20px!important}.v-application--is-rtl .me-xl-n5{margin-left:-20px!important}.v-application--is-ltr .me-xl-n6{margin-right:-24px!important}.v-application--is-rtl .me-xl-n6{margin-left:-24px!important}.v-application--is-ltr .me-xl-n7{margin-right:-28px!important}.v-application--is-rtl .me-xl-n7{margin-left:-28px!important}.v-application--is-ltr .me-xl-n8{margin-right:-32px!important}.v-application--is-rtl .me-xl-n8{margin-left:-32px!important}.v-application--is-ltr .me-xl-n9{margin-right:-36px!important}.v-application--is-rtl .me-xl-n9{margin-left:-36px!important}.v-application--is-ltr .me-xl-n10{margin-right:-40px!important}.v-application--is-rtl .me-xl-n10{margin-left:-40px!important}.v-application--is-ltr .me-xl-n11{margin-right:-44px!important}.v-application--is-rtl .me-xl-n11{margin-left:-44px!important}.v-application--is-ltr .me-xl-n12{margin-right:-48px!important}.v-application--is-rtl .me-xl-n12{margin-left:-48px!important}.v-application--is-ltr .me-xl-n13{margin-right:-52px!important}.v-application--is-rtl .me-xl-n13{margin-left:-52px!important}.v-application--is-ltr .me-xl-n14{margin-right:-56px!important}.v-application--is-rtl .me-xl-n14{margin-left:-56px!important}.v-application--is-ltr .me-xl-n15{margin-right:-60px!important}.v-application--is-rtl .me-xl-n15{margin-left:-60px!important}.v-application--is-ltr .me-xl-n16{margin-right:-64px!important}.v-application--is-rtl .me-xl-n16{margin-left:-64px!important}.v-application .pa-xl-0{padding:0!important}.v-application .pa-xl-1{padding:4px!important}.v-application .pa-xl-2{padding:8px!important}.v-application .pa-xl-3{padding:12px!important}.v-application .pa-xl-4{padding:16px!important}.v-application .pa-xl-5{padding:20px!important}.v-application .pa-xl-6{padding:24px!important}.v-application .pa-xl-7{padding:28px!important}.v-application .pa-xl-8{padding:32px!important}.v-application .pa-xl-9{padding:36px!important}.v-application .pa-xl-10{padding:40px!important}.v-application .pa-xl-11{padding:44px!important}.v-application .pa-xl-12{padding:48px!important}.v-application .pa-xl-13{padding:52px!important}.v-application .pa-xl-14{padding:56px!important}.v-application .pa-xl-15{padding:60px!important}.v-application .pa-xl-16{padding:64px!important}.v-application .px-xl-0{padding-right:0!important;padding-left:0!important}.v-application .px-xl-1{padding-right:4px!important;padding-left:4px!important}.v-application .px-xl-2{padding-right:8px!important;padding-left:8px!important}.v-application .px-xl-3{padding-right:12px!important;padding-left:12px!important}.v-application .px-xl-4{padding-right:16px!important;padding-left:16px!important}.v-application .px-xl-5{padding-right:20px!important;padding-left:20px!important}.v-application .px-xl-6{padding-right:24px!important;padding-left:24px!important}.v-application .px-xl-7{padding-right:28px!important;padding-left:28px!important}.v-application .px-xl-8{padding-right:32px!important;padding-left:32px!important}.v-application .px-xl-9{padding-right:36px!important;padding-left:36px!important}.v-application .px-xl-10{padding-right:40px!important;padding-left:40px!important}.v-application .px-xl-11{padding-right:44px!important;padding-left:44px!important}.v-application .px-xl-12{padding-right:48px!important;padding-left:48px!important}.v-application .px-xl-13{padding-right:52px!important;padding-left:52px!important}.v-application .px-xl-14{padding-right:56px!important;padding-left:56px!important}.v-application .px-xl-15{padding-right:60px!important;padding-left:60px!important}.v-application .px-xl-16{padding-right:64px!important;padding-left:64px!important}.v-application .py-xl-0{padding-top:0!important;padding-bottom:0!important}.v-application .py-xl-1{padding-top:4px!important;padding-bottom:4px!important}.v-application .py-xl-2{padding-top:8px!important;padding-bottom:8px!important}.v-application .py-xl-3{padding-top:12px!important;padding-bottom:12px!important}.v-application .py-xl-4{padding-top:16px!important;padding-bottom:16px!important}.v-application .py-xl-5{padding-top:20px!important;padding-bottom:20px!important}.v-application .py-xl-6{padding-top:24px!important;padding-bottom:24px!important}.v-application .py-xl-7{padding-top:28px!important;padding-bottom:28px!important}.v-application .py-xl-8{padding-top:32px!important;padding-bottom:32px!important}.v-application .py-xl-9{padding-top:36px!important;padding-bottom:36px!important}.v-application .py-xl-10{padding-top:40px!important;padding-bottom:40px!important}.v-application .py-xl-11{padding-top:44px!important;padding-bottom:44px!important}.v-application .py-xl-12{padding-top:48px!important;padding-bottom:48px!important}.v-application .py-xl-13{padding-top:52px!important;padding-bottom:52px!important}.v-application .py-xl-14{padding-top:56px!important;padding-bottom:56px!important}.v-application .py-xl-15{padding-top:60px!important;padding-bottom:60px!important}.v-application .py-xl-16{padding-top:64px!important;padding-bottom:64px!important}.v-application .pt-xl-0{padding-top:0!important}.v-application .pt-xl-1{padding-top:4px!important}.v-application .pt-xl-2{padding-top:8px!important}.v-application .pt-xl-3{padding-top:12px!important}.v-application .pt-xl-4{padding-top:16px!important}.v-application .pt-xl-5{padding-top:20px!important}.v-application .pt-xl-6{padding-top:24px!important}.v-application .pt-xl-7{padding-top:28px!important}.v-application .pt-xl-8{padding-top:32px!important}.v-application .pt-xl-9{padding-top:36px!important}.v-application .pt-xl-10{padding-top:40px!important}.v-application .pt-xl-11{padding-top:44px!important}.v-application .pt-xl-12{padding-top:48px!important}.v-application .pt-xl-13{padding-top:52px!important}.v-application .pt-xl-14{padding-top:56px!important}.v-application .pt-xl-15{padding-top:60px!important}.v-application .pt-xl-16{padding-top:64px!important}.v-application .pr-xl-0{padding-right:0!important}.v-application .pr-xl-1{padding-right:4px!important}.v-application .pr-xl-2{padding-right:8px!important}.v-application .pr-xl-3{padding-right:12px!important}.v-application .pr-xl-4{padding-right:16px!important}.v-application .pr-xl-5{padding-right:20px!important}.v-application .pr-xl-6{padding-right:24px!important}.v-application .pr-xl-7{padding-right:28px!important}.v-application .pr-xl-8{padding-right:32px!important}.v-application .pr-xl-9{padding-right:36px!important}.v-application .pr-xl-10{padding-right:40px!important}.v-application .pr-xl-11{padding-right:44px!important}.v-application .pr-xl-12{padding-right:48px!important}.v-application .pr-xl-13{padding-right:52px!important}.v-application .pr-xl-14{padding-right:56px!important}.v-application .pr-xl-15{padding-right:60px!important}.v-application .pr-xl-16{padding-right:64px!important}.v-application .pb-xl-0{padding-bottom:0!important}.v-application .pb-xl-1{padding-bottom:4px!important}.v-application .pb-xl-2{padding-bottom:8px!important}.v-application .pb-xl-3{padding-bottom:12px!important}.v-application .pb-xl-4{padding-bottom:16px!important}.v-application .pb-xl-5{padding-bottom:20px!important}.v-application .pb-xl-6{padding-bottom:24px!important}.v-application .pb-xl-7{padding-bottom:28px!important}.v-application .pb-xl-8{padding-bottom:32px!important}.v-application .pb-xl-9{padding-bottom:36px!important}.v-application .pb-xl-10{padding-bottom:40px!important}.v-application .pb-xl-11{padding-bottom:44px!important}.v-application .pb-xl-12{padding-bottom:48px!important}.v-application .pb-xl-13{padding-bottom:52px!important}.v-application .pb-xl-14{padding-bottom:56px!important}.v-application .pb-xl-15{padding-bottom:60px!important}.v-application .pb-xl-16{padding-bottom:64px!important}.v-application .pl-xl-0{padding-left:0!important}.v-application .pl-xl-1{padding-left:4px!important}.v-application .pl-xl-2{padding-left:8px!important}.v-application .pl-xl-3{padding-left:12px!important}.v-application .pl-xl-4{padding-left:16px!important}.v-application .pl-xl-5{padding-left:20px!important}.v-application .pl-xl-6{padding-left:24px!important}.v-application .pl-xl-7{padding-left:28px!important}.v-application .pl-xl-8{padding-left:32px!important}.v-application .pl-xl-9{padding-left:36px!important}.v-application .pl-xl-10{padding-left:40px!important}.v-application .pl-xl-11{padding-left:44px!important}.v-application .pl-xl-12{padding-left:48px!important}.v-application .pl-xl-13{padding-left:52px!important}.v-application .pl-xl-14{padding-left:56px!important}.v-application .pl-xl-15{padding-left:60px!important}.v-application .pl-xl-16{padding-left:64px!important}.v-application--is-ltr .ps-xl-0{padding-left:0!important}.v-application--is-rtl .ps-xl-0{padding-right:0!important}.v-application--is-ltr .ps-xl-1{padding-left:4px!important}.v-application--is-rtl .ps-xl-1{padding-right:4px!important}.v-application--is-ltr .ps-xl-2{padding-left:8px!important}.v-application--is-rtl .ps-xl-2{padding-right:8px!important}.v-application--is-ltr .ps-xl-3{padding-left:12px!important}.v-application--is-rtl .ps-xl-3{padding-right:12px!important}.v-application--is-ltr .ps-xl-4{padding-left:16px!important}.v-application--is-rtl .ps-xl-4{padding-right:16px!important}.v-application--is-ltr .ps-xl-5{padding-left:20px!important}.v-application--is-rtl .ps-xl-5{padding-right:20px!important}.v-application--is-ltr .ps-xl-6{padding-left:24px!important}.v-application--is-rtl .ps-xl-6{padding-right:24px!important}.v-application--is-ltr .ps-xl-7{padding-left:28px!important}.v-application--is-rtl .ps-xl-7{padding-right:28px!important}.v-application--is-ltr .ps-xl-8{padding-left:32px!important}.v-application--is-rtl .ps-xl-8{padding-right:32px!important}.v-application--is-ltr .ps-xl-9{padding-left:36px!important}.v-application--is-rtl .ps-xl-9{padding-right:36px!important}.v-application--is-ltr .ps-xl-10{padding-left:40px!important}.v-application--is-rtl .ps-xl-10{padding-right:40px!important}.v-application--is-ltr .ps-xl-11{padding-left:44px!important}.v-application--is-rtl .ps-xl-11{padding-right:44px!important}.v-application--is-ltr .ps-xl-12{padding-left:48px!important}.v-application--is-rtl .ps-xl-12{padding-right:48px!important}.v-application--is-ltr .ps-xl-13{padding-left:52px!important}.v-application--is-rtl .ps-xl-13{padding-right:52px!important}.v-application--is-ltr .ps-xl-14{padding-left:56px!important}.v-application--is-rtl .ps-xl-14{padding-right:56px!important}.v-application--is-ltr .ps-xl-15{padding-left:60px!important}.v-application--is-rtl .ps-xl-15{padding-right:60px!important}.v-application--is-ltr .ps-xl-16{padding-left:64px!important}.v-application--is-rtl .ps-xl-16{padding-right:64px!important}.v-application--is-ltr .pe-xl-0{padding-right:0!important}.v-application--is-rtl .pe-xl-0{padding-left:0!important}.v-application--is-ltr .pe-xl-1{padding-right:4px!important}.v-application--is-rtl .pe-xl-1{padding-left:4px!important}.v-application--is-ltr .pe-xl-2{padding-right:8px!important}.v-application--is-rtl .pe-xl-2{padding-left:8px!important}.v-application--is-ltr .pe-xl-3{padding-right:12px!important}.v-application--is-rtl .pe-xl-3{padding-left:12px!important}.v-application--is-ltr .pe-xl-4{padding-right:16px!important}.v-application--is-rtl .pe-xl-4{padding-left:16px!important}.v-application--is-ltr .pe-xl-5{padding-right:20px!important}.v-application--is-rtl .pe-xl-5{padding-left:20px!important}.v-application--is-ltr .pe-xl-6{padding-right:24px!important}.v-application--is-rtl .pe-xl-6{padding-left:24px!important}.v-application--is-ltr .pe-xl-7{padding-right:28px!important}.v-application--is-rtl .pe-xl-7{padding-left:28px!important}.v-application--is-ltr .pe-xl-8{padding-right:32px!important}.v-application--is-rtl .pe-xl-8{padding-left:32px!important}.v-application--is-ltr .pe-xl-9{padding-right:36px!important}.v-application--is-rtl .pe-xl-9{padding-left:36px!important}.v-application--is-ltr .pe-xl-10{padding-right:40px!important}.v-application--is-rtl .pe-xl-10{padding-left:40px!important}.v-application--is-ltr .pe-xl-11{padding-right:44px!important}.v-application--is-rtl .pe-xl-11{padding-left:44px!important}.v-application--is-ltr .pe-xl-12{padding-right:48px!important}.v-application--is-rtl .pe-xl-12{padding-left:48px!important}.v-application--is-ltr .pe-xl-13{padding-right:52px!important}.v-application--is-rtl .pe-xl-13{padding-left:52px!important}.v-application--is-ltr .pe-xl-14{padding-right:56px!important}.v-application--is-rtl .pe-xl-14{padding-left:56px!important}.v-application--is-ltr .pe-xl-15{padding-right:60px!important}.v-application--is-rtl .pe-xl-15{padding-left:60px!important}.v-application--is-ltr .pe-xl-16{padding-right:64px!important}.v-application--is-rtl .pe-xl-16{padding-left:64px!important}.v-application .text-xl-left{text-align:left!important}.v-application .text-xl-right{text-align:right!important}.v-application .text-xl-center{text-align:center!important}.v-application .text-xl-justify{text-align:justify!important}.v-application .text-xl-start{text-align:start!important}.v-application .text-xl-end{text-align:end!important}.v-application .text-xl-h1{font-size:2rem!important;font-weight:600;line-height:2.4285714286rem;letter-spacing:-.02em!important;font-family:AkkuratLL,Helvetica,Arial,sans-serif!important}.v-application .text-xl-h2{font-size:1.7142857143rem!important;line-height:2.2857142857rem}.v-application .text-xl-h2,.v-application .text-xl-h3{font-weight:600;letter-spacing:-.01em!important;font-family:AkkuratLL,Helvetica,Arial,sans-serif!important}.v-application .text-xl-h3{font-size:1.4285714286rem!important;line-height:2rem}.v-application .text-xl-h4{font-size:1.2857142857rem!important}.v-application .text-xl-h4,.v-application .text-xl-h5{font-weight:600;line-height:1.7142857143rem;letter-spacing:-.01em!important;font-family:AkkuratLL,Helvetica,Arial,sans-serif!important}.v-application .text-xl-h5{font-size:1.1428571429rem!important}.v-application .text-xl-h6{font-size:1rem!important;font-weight:500;line-height:1.4285714286rem;letter-spacing:normal!important;font-family:AkkuratLL,Helvetica,Arial,sans-serif!important}.v-application .text-xl-subtitle-1{font-size:.8571428571rem!important}.v-application .text-xl-subtitle-1,.v-application .text-xl-subtitle-2{font-weight:400;line-height:1.1428571429rem;letter-spacing:normal!important;font-family:AkkuratLL,Helvetica,Arial,sans-serif!important}.v-application .text-xl-subtitle-2{font-size:.7142857143rem!important}.v-application .text-xl-body-1{font-size:1.1428571429rem!important;line-height:1.7142857143rem;letter-spacing:normal!important}.v-application .text-xl-body-1,.v-application .text-xl-body-2{font-weight:400;font-family:AkkuratLL,Helvetica,Arial,sans-serif!important}.v-application .text-xl-body-2{font-size:1rem!important;line-height:1.4285714286rem;letter-spacing:-.02em!important}.v-application .text-xl-button{font-size:.875rem!important;font-weight:500;line-height:2.25rem;letter-spacing:.0892857143em!important;font-family:AkkuratLL,Helvetica,Arial,sans-serif!important;text-transform:uppercase!important}.v-application .text-xl-caption{font-weight:400;line-height:1.25rem;letter-spacing:.0333333333em!important}.v-application .text-xl-caption,.v-application .text-xl-overline{font-size:.75rem!important;font-family:AkkuratLL,Helvetica,Arial,sans-serif!important}.v-application .text-xl-overline{font-weight:500;line-height:2rem;letter-spacing:.1666666667em!important;text-transform:uppercase!important}}@media print{.v-application .d-print-none{display:none!important}.v-application .d-print-inline{display:inline!important}.v-application .d-print-inline-block{display:inline-block!important}.v-application .d-print-block{display:block!important}.v-application .d-print-table{display:table!important}.v-application .d-print-table-row{display:table-row!important}.v-application .d-print-table-cell{display:table-cell!important}.v-application .d-print-flex{display:flex!important}.v-application .d-print-inline-flex{display:inline-flex!important}.v-application .float-print-none{float:none!important}.v-application .float-print-left{float:left!important}.v-application .float-print-right{float:right!important}}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "7921":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><rect x=\"5\" y=\"5\" width=\"17\" height=\"17\" rx=\"1\" fill=\"#DFE4E5\" stroke=\"#688083\" stroke-width=\"2\"></rect><rect x=\"2\" y=\"2\" width=\"16\" height=\"16\" rx=\"1\" fill=\"white\" stroke=\"#688083\" stroke-width=\"2\"></rect><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M11.4985 9.25C11.4985 8.42157 10.827 7.75 9.99854 7.75C9.17012 7.75 8.49854 8.42157 8.49854 9.25V9.75C8.49854 10.5784 9.17012 11.25 9.99854 11.25C10.827 11.25 11.4985 10.5784 11.4985 9.75V9.25ZM9 12C7.89543 12 7 12.8954 7 14V15H13V14C13 12.8954 12.1046 12 11 12H9Z\" fill=\"#688083\"></path><path d=\"M3 4H17V6H3V4Z\" fill=\"#688083\"></path><path d=\"M5 3H7V5H5V3Z\" fill=\"#688083\"></path><path d=\"M8.99854 3H10.9985V5H8.99854V3Z\" fill=\"#688083\"></path></svg>";

/***/ }),

/***/ "7958":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("0dac");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("866d5f84", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "79c7":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("ab8f");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("46b2b221", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "7a83":
/***/ (function(module, exports, __webpack_require__) {

var addDays = __webpack_require__("8946")

/**
 * @category Week Helpers
 * @summary Add the specified number of weeks to the given date.
 *
 * @description
 * Add the specified number of week to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of weeks to be added
 * @returns {Date} the new date with the weeks added
 *
 * @example
 * // Add 4 weeks to 1 September 2014:
 * var result = addWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Sep 29 2014 00:00:00
 */
function addWeeks (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  var days = amount * 7
  return addDays(dirtyDate, days)
}

module.exports = addWeeks


/***/ }),

/***/ "7b0b":
/***/ (function(module, exports, __webpack_require__) {

var requireObjectCoercible = __webpack_require__("1d80");

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
module.exports = function (argument) {
  return Object(requireObjectCoercible(argument));
};


/***/ }),

/***/ "7bc6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return isCssColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return colorToInt; });
/* unused harmony export classToHex */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return intToHex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return colorToHex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return HSVAtoRGBA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return RGBAtoHSVA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return HSVAtoHSLA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HSLAtoHSVA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return RGBAtoCSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return RGBtoCSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return RGBAtoHex; });
/* unused harmony export HexToRGBA */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return HexToHSVA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return HSVAtoHex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return parseHex; });
/* unused harmony export parseGradient */
/* unused harmony export RGBtoInt */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return contrastRatio; });
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("99af");
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_join_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("a15b");
/* harmony import */ var core_js_modules_es_array_join_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("d81d");
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("fb6a");
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("b0c0");
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("d3b7");
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_values_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("07ac");
/* harmony import */ var core_js_modules_es_object_values_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_values_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("ac1f");
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("25f0");
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_string_match_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("466d");
/* harmony import */ var core_js_modules_es_string_match_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_match_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_string_repeat_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("38cf");
/* harmony import */ var core_js_modules_es_string_repeat_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_repeat_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("5319");
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_string_split_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("1276");
/* harmony import */ var core_js_modules_es_string_split_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split_js__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_string_starts_with_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("2ca0");
/* harmony import */ var core_js_modules_es_string_starts_with_js__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_starts_with_js__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_string_trim_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("498a");
/* harmony import */ var core_js_modules_es_string_trim_js__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_trim_js__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("5530");
/* harmony import */ var _home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("3835");
/* harmony import */ var _console__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("d9bd");
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("80d2");
/* harmony import */ var _color_transformSRGB__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("8da5");

















// Utilities



function isCssColor(color) {
  return !!color && !!color.match(/^(#|var\(--|(rgb|hsl)a?\()/);
}
function colorToInt(color) {
  var rgb;

  if (typeof color === 'number') {
    rgb = color;
  } else if (typeof color === 'string') {
    var c = color[0] === '#' ? color.substring(1) : color;

    if (c.length === 3) {
      c = c.split('').map(function (char) {
        return char + char;
      }).join('');
    }

    if (c.length !== 6) {
      Object(_console__WEBPACK_IMPORTED_MODULE_17__[/* consoleWarn */ "c"])("'".concat(color, "' is not a valid rgb color"));
    }

    rgb = parseInt(c, 16);
  } else {
    throw new TypeError("Colors can only be numbers or strings, recieved ".concat(color == null ? color : color.constructor.name, " instead"));
  }

  if (rgb < 0) {
    Object(_console__WEBPACK_IMPORTED_MODULE_17__[/* consoleWarn */ "c"])("Colors cannot be negative: '".concat(color, "'"));
    rgb = 0;
  } else if (rgb > 0xffffff || isNaN(rgb)) {
    Object(_console__WEBPACK_IMPORTED_MODULE_17__[/* consoleWarn */ "c"])("'".concat(color, "' is not a valid rgb color"));
    rgb = 0xffffff;
  }

  return rgb;
}
function classToHex(color, colors, currentTheme) {
  var _color$toString$trim$ = color.toString().trim().replace('-', '').split(' ', 2),
      _color$toString$trim$2 = Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_16__[/* default */ "a"])(_color$toString$trim$, 2),
      colorName = _color$toString$trim$2[0],
      colorModifier = _color$toString$trim$2[1];

  var hexColor = '';

  if (colorName && colorName in colors) {
    if (colorModifier && colorModifier in colors[colorName]) {
      hexColor = colors[colorName][colorModifier];
    } else if ('base' in colors[colorName]) {
      hexColor = colors[colorName].base;
    }
  } else if (colorName && colorName in currentTheme) {
    hexColor = currentTheme[colorName];
  }

  return hexColor;
}
function intToHex(color) {
  var hexColor = color.toString(16);
  if (hexColor.length < 6) hexColor = '0'.repeat(6 - hexColor.length) + hexColor;
  return '#' + hexColor;
}
function colorToHex(color) {
  return intToHex(colorToInt(color));
}
/**
 * Converts HSVA to RGBA. Based on formula from https://en.wikipedia.org/wiki/HSL_and_HSV
 *
 * @param color HSVA color as an array [0-360, 0-1, 0-1, 0-1]
 */

function HSVAtoRGBA(hsva) {
  var h = hsva.h,
      s = hsva.s,
      v = hsva.v,
      a = hsva.a;

  var f = function f(n) {
    var k = (n + h / 60) % 6;
    return v - v * s * Math.max(Math.min(k, 4 - k, 1), 0);
  };

  var rgb = [f(5), f(3), f(1)].map(function (v) {
    return Math.round(v * 255);
  });
  return {
    r: rgb[0],
    g: rgb[1],
    b: rgb[2],
    a: a
  };
}
/**
 * Converts RGBA to HSVA. Based on formula from https://en.wikipedia.org/wiki/HSL_and_HSV
 *
 * @param color RGBA color as an array [0-255, 0-255, 0-255, 0-1]
 */

function RGBAtoHSVA(rgba) {
  if (!rgba) return {
    h: 0,
    s: 1,
    v: 1,
    a: 1
  };
  var r = rgba.r / 255;
  var g = rgba.g / 255;
  var b = rgba.b / 255;
  var max = Math.max(r, g, b);
  var min = Math.min(r, g, b);
  var h = 0;

  if (max !== min) {
    if (max === r) {
      h = 60 * (0 + (g - b) / (max - min));
    } else if (max === g) {
      h = 60 * (2 + (b - r) / (max - min));
    } else if (max === b) {
      h = 60 * (4 + (r - g) / (max - min));
    }
  }

  if (h < 0) h = h + 360;
  var s = max === 0 ? 0 : (max - min) / max;
  var hsv = [h, s, max];
  return {
    h: hsv[0],
    s: hsv[1],
    v: hsv[2],
    a: rgba.a
  };
}
function HSVAtoHSLA(hsva) {
  var h = hsva.h,
      s = hsva.s,
      v = hsva.v,
      a = hsva.a;
  var l = v - v * s / 2;
  var sprime = l === 1 || l === 0 ? 0 : (v - l) / Math.min(l, 1 - l);
  return {
    h: h,
    s: sprime,
    l: l,
    a: a
  };
}
function HSLAtoHSVA(hsl) {
  var h = hsl.h,
      s = hsl.s,
      l = hsl.l,
      a = hsl.a;
  var v = l + s * Math.min(l, 1 - l);
  var sprime = v === 0 ? 0 : 2 - 2 * l / v;
  return {
    h: h,
    s: sprime,
    v: v,
    a: a
  };
}
function RGBAtoCSS(rgba) {
  return "rgba(".concat(rgba.r, ", ").concat(rgba.g, ", ").concat(rgba.b, ", ").concat(rgba.a, ")");
}
function RGBtoCSS(rgba) {
  return RGBAtoCSS(Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_15__[/* default */ "a"])(Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_15__[/* default */ "a"])({}, rgba), {}, {
    a: 1
  }));
}
function RGBAtoHex(rgba) {
  var toHex = function toHex(v) {
    var h = Math.round(v).toString(16);
    return ('00'.substr(0, 2 - h.length) + h).toUpperCase();
  };

  return "#".concat([toHex(rgba.r), toHex(rgba.g), toHex(rgba.b), toHex(Math.round(rgba.a * 255))].join(''));
}
function HexToRGBA(hex) {
  var rgba = Object(_helpers__WEBPACK_IMPORTED_MODULE_18__[/* chunk */ "e"])(hex.slice(1), 2).map(function (c) {
    return parseInt(c, 16);
  });
  return {
    r: rgba[0],
    g: rgba[1],
    b: rgba[2],
    a: Math.round(rgba[3] / 255 * 100) / 100
  };
}
function HexToHSVA(hex) {
  var rgb = HexToRGBA(hex);
  return RGBAtoHSVA(rgb);
}
function HSVAtoHex(hsva) {
  return RGBAtoHex(HSVAtoRGBA(hsva));
}
function parseHex(hex) {
  if (hex.startsWith('#')) {
    hex = hex.slice(1);
  }

  hex = hex.replace(/([^0-9a-f])/gi, 'F');

  if (hex.length === 3 || hex.length === 4) {
    hex = hex.split('').map(function (x) {
      return x + x;
    }).join('');
  }

  if (hex.length === 6) {
    hex = Object(_helpers__WEBPACK_IMPORTED_MODULE_18__[/* padEnd */ "A"])(hex, 8, 'F');
  } else {
    hex = Object(_helpers__WEBPACK_IMPORTED_MODULE_18__[/* padEnd */ "A"])(Object(_helpers__WEBPACK_IMPORTED_MODULE_18__[/* padEnd */ "A"])(hex, 6), 8, 'F');
  }

  return "#".concat(hex).toUpperCase().substr(0, 9);
}
function parseGradient(gradient, colors, currentTheme) {
  return gradient.replace(/([a-z]+(\s[a-z]+-[1-5])?)(?=$|,)/gi, function (x) {
    return classToHex(x, colors, currentTheme) || x;
  }).replace(/(rgba\()#[0-9a-f]+(?=,)/gi, function (x) {
    return 'rgba(' + Object.values(HexToRGBA(parseHex(x.replace(/rgba\(/, '')))).slice(0, 3).join(',');
  });
}
function RGBtoInt(rgba) {
  return (rgba.r << 16) + (rgba.g << 8) + rgba.b;
}
/**
 * Returns the contrast ratio (1-21) between two colors.
 *
 * @param c1 First color
 * @param c2 Second color
 */

function contrastRatio(c1, c2) {
  var _toXYZ = Object(_color_transformSRGB__WEBPACK_IMPORTED_MODULE_19__[/* toXYZ */ "b"])(RGBtoInt(c1)),
      _toXYZ2 = Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_16__[/* default */ "a"])(_toXYZ, 2),
      y1 = _toXYZ2[1];

  var _toXYZ3 = Object(_color_transformSRGB__WEBPACK_IMPORTED_MODULE_19__[/* toXYZ */ "b"])(RGBtoInt(c2)),
      _toXYZ4 = Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_16__[/* default */ "a"])(_toXYZ3, 2),
      y2 = _toXYZ4[1];

  return (Math.max(y1, y2) + 0.05) / (Math.min(y1, y2) + 0.05);
}

/***/ }),

/***/ "7bd2":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("1a75");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("fa124dac", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "7c73":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("825a");
var defineProperties = __webpack_require__("37e8");
var enumBugKeys = __webpack_require__("7839");
var hiddenKeys = __webpack_require__("d012");
var html = __webpack_require__("1be4");
var documentCreateElement = __webpack_require__("cc12");
var sharedKey = __webpack_require__("f772");

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO = sharedKey('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    /* global ActiveXObject */
    activeXDocument = document.domain && new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) : NullProtoObjectViaIFrame();
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : defineProperties(result, Properties);
};


/***/ }),

/***/ "7c8c":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("d985");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("443b979b", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "7d72":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M16 10H20C21.1046 10 22 10.8954 22 12V19C22 20.1046 21.1046 21 20 21H18C16.8954 21 16 20.1046 16 19V10Z\" fill=\"#DFE4E5\" stroke=\"#1F3A3E\" stroke-width=\"2\"></path><path d=\"M1 5C1 3.34315 2.34315 2 4 2H15C16.6569 2 18 3.34315 18 5V22H4C2.34315 22 1 20.6569 1 19V5Z\" fill=\"white\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M15 4H4C3.44771 4 3 4.44772 3 5V19C3 19.5523 3.44772 20 4 20H16.3125C16.3125 20 16 19.7266 16 19C16 18.2734 16 5 16 5C16 4.44772 15.5523 4 15 4ZM4 2C2.34315 2 1 3.34315 1 5V19C1 20.6569 2.34315 22 4 22H18V20V19V5C18 3.34315 16.6569 2 15 2H4Z\" fill=\"#1F3A3E\"></path><rect x=\"5\" y=\"15\" width=\"9\" height=\"2\" rx=\"1\" fill=\"#1F3A3E\"></rect><path d=\"M18 20H19C18.2738 20 18 19.6199 18 19V19.4709V19.7751V20Z\" fill=\"#1F3A3E\"></path><path d=\"M6 7H12.75C12.8881 7 13 7.11193 13 7.25V12H6.25C6.11193 12 6 11.8881 6 11.75V7Z\" fill=\"#DFE4E5\" stroke=\"#1F3A3E\" stroke-width=\"2\"></path></svg>";

/***/ }),

/***/ "7db0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $find = __webpack_require__("b727").find;
var addToUnscopables = __webpack_require__("44d2");
var arrayMethodUsesToLength = __webpack_require__("ae40");

var FIND = 'find';
var SKIPS_HOLES = true;

var USES_TO_LENGTH = arrayMethodUsesToLength(FIND);

// Shouldn't skip holes
if (FIND in []) Array(1)[FIND](function () { SKIPS_HOLES = false; });

// `Array.prototype.find` method
// https://tc39.es/ecma262/#sec-array.prototype.find
$({ target: 'Array', proto: true, forced: SKIPS_HOLES || !USES_TO_LENGTH }, {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables(FIND);


/***/ }),

/***/ "7dc7":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M10.4762 1C5.22476 1 0.952381 5.037 0.952381 10C0.952381 11.735 1.46762 13.392 2.45048 14.836L0.443483 18.2464C0.247329 18.5797 0.487651 19 0.874401 19H10.4762C15.7276 19 20 14.963 20 10C20 5.037 15.7276 1 10.4762 1Z\" fill=\"#DFE4E5\"></path><path d=\"M3.31231 15.3432L3.63367 14.7971L3.27715 14.2733C2.40576 12.9931 1.95238 11.5317 1.95238 10C1.95238 5.64186 5.72296 2 10.4762 2C15.2294 2 19 5.64186 19 10C19 14.3581 15.2294 18 10.4762 18H1.7488L3.31231 15.3432Z\" stroke=\"#1F3A3E\" stroke-width=\"2\"></path><path d=\"M15.0952 7C19.559 7 23.1905 10.5884 23.1905 15C23.1905 16.5422 22.7525 18.0151 21.9171 19.2987L24 23H15.0952C10.6315 23 7 19.4116 7 15C7 10.5884 10.6315 7 15.0952 7Z\" fill=\"white\"></path><path d=\"M21.0456 19.7891L20.7484 19.261L21.079 18.7532C21.8086 17.6322 22.1905 16.3489 22.1905 15C22.1905 11.1519 19.0179 8 15.0952 8C11.1726 8 8 11.1519 8 15C8 18.8481 11.1726 22 15.0952 22H22.2898L21.0456 19.7891Z\" stroke=\"#1F3A3E\" stroke-width=\"2\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M17 15C17 15.5523 17.4477 16 18 16C18.5523 16 19 15.5523 19 15C19 14.4477 18.5523 14 18 14C17.4477 14 17 14.4477 17 15ZM14 15C14 15.5523 14.4477 16 15 16C15.5523 16 16 15.5523 16 15C16 14.4477 15.5523 14 15 14C14.4477 14 14 14.4477 14 15ZM12 16C11.4477 16 11 15.5523 11 15C11 14.4477 11.4477 14 12 14C12.5523 14 13 14.4477 13 15C13 15.5523 12.5523 16 12 16Z\" fill=\"#1F3A3E\"></path></svg>";

/***/ }),

/***/ "7dd0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var createIteratorConstructor = __webpack_require__("9ed3");
var getPrototypeOf = __webpack_require__("e163");
var setPrototypeOf = __webpack_require__("d2bb");
var setToStringTag = __webpack_require__("d44e");
var createNonEnumerableProperty = __webpack_require__("9112");
var redefine = __webpack_require__("6eeb");
var wellKnownSymbol = __webpack_require__("b622");
var IS_PURE = __webpack_require__("c430");
var Iterators = __webpack_require__("3f8c");
var IteratorsCore = __webpack_require__("ae93");

var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR = wellKnownSymbol('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

module.exports = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    } return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (IteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (!IS_PURE && getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf) {
          setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
        } else if (typeof CurrentIteratorPrototype[ITERATOR] != 'function') {
          createNonEnumerableProperty(CurrentIteratorPrototype, ITERATOR, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
      if (IS_PURE) Iterators[TO_STRING_TAG] = returnThis;
    }
  }

  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    INCORRECT_VALUES_NAME = true;
    defaultIterator = function values() { return nativeIterator.call(this); };
  }

  // define iterator
  if ((!IS_PURE || FORCED) && IterablePrototype[ITERATOR] !== defaultIterator) {
    createNonEnumerableProperty(IterablePrototype, ITERATOR, defaultIterator);
  }
  Iterators[NAME] = defaultIterator;

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        redefine(IterablePrototype, KEY, methods[KEY]);
      }
    } else $({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  return methods;
};


/***/ }),

/***/ "7e2b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("8bbf");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);

/**
 * This mixin provides `attrs$` and `listeners$` to work around
 * vue bug https://github.com/vuejs/vue/issues/10115
 */

function makeWatcher(property) {
  return function (val, oldVal) {
    for (var attr in oldVal) {
      if (!Object.prototype.hasOwnProperty.call(val, attr)) {
        this.$delete(this.$data[property], attr);
      }
    }

    for (var _attr in val) {
      this.$set(this.$data[property], _attr, val[_attr]);
    }
  };
}

/* harmony default export */ __webpack_exports__["a"] = (vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend({
  data: function data() {
    return {
      attrs$: {},
      listeners$: {}
    };
  },
  created: function created() {
    // Work around unwanted re-renders: https://github.com/vuejs/vue/issues/10115
    // Make sure to use `attrs$` instead of `$attrs` (confusing right?)
    this.$watch('$attrs', makeWatcher('attrs$'), {
      immediate: true
    });
    this.$watch('$listeners', makeWatcher('listeners$'), {
      immediate: true
    });
  }
}));

/***/ }),

/***/ "7e58":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("b83e");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("fd0f0bbe", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "7ecb":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.i, "@import url(https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css);"]);
exports.push([module.i, "@import url(https://cdn-prd.patientpop.com/pp-icon-font/v1.6.0/pp-icon-font.css);"]);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.pp-avatar-icon--disabled[data-v-b11fa4ce]{filter:grayscale(100%)}.pp-avatar-icon__initials--xs[data-v-b11fa4ce],.pp-avatar-icon__initials--xxs[data-v-b11fa4ce]{font-size:.7142857143rem}.pp-avatar-icon__initials--sm[data-v-b11fa4ce]{font-size:.8571428571rem}.pp-avatar-icon__initials--md[data-v-b11fa4ce]{font-size:1rem}.pp-avatar-icon__initials--lg[data-v-b11fa4ce]{font-size:1.1428571429rem}.pp-avatar-icon__initials--xl[data-v-b11fa4ce]{font-size:1.4285714286rem}.pp-avatar-icon__initials--xxl[data-v-b11fa4ce]{font-size:2rem}.pp-avatar-icon__initials--xxxl[data-v-b11fa4ce]{font-size:3.1428571429rem}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "7ed6":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.v-color-picker__swatches{overflow-y:auto}.v-color-picker__swatches>div{display:flex;flex-wrap:wrap;justify-content:center;padding:8px}.v-color-picker__swatch{display:flex;flex-direction:column;margin-bottom:10px}.v-color-picker__color{position:relative;height:18px;max-height:18px;width:45px;margin:2px 4px;border-radius:2px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;overflow:hidden;background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAGElEQVQYlWNgYGCQwoKxgqGgcJA5h3yFAAs8BRWVSwooAAAAAElFTkSuQmCC) repeat;cursor:pointer}.v-color-picker__color>div{display:flex;align-items:center;justify-content:center;width:100%;height:100%}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "7eea":
/***/ (function(module, exports, __webpack_require__) {

var isDate = __webpack_require__("a735")

/**
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @param {Date} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} argument must be an instance of Date
 *
 * @example
 * // For the valid date:
 * var result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the invalid date:
 * var result = isValid(new Date(''))
 * //=> false
 */
function isValid (dirtyDate) {
  if (isDate(dirtyDate)) {
    return !isNaN(dirtyDate)
  } else {
    throw new TypeError(toString.call(dirtyDate) + ' is not an instance of Date')
  }
}

module.exports = isValid


/***/ }),

/***/ "7f7e":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.v-chip:not(.v-chip--outlined).accent,.v-chip:not(.v-chip--outlined).error,.v-chip:not(.v-chip--outlined).info,.v-chip:not(.v-chip--outlined).primary,.v-chip:not(.v-chip--outlined).secondary,.v-chip:not(.v-chip--outlined).success,.v-chip:not(.v-chip--outlined).warning{color:var(--pp-primary-button-text-color,#004852)}.theme--light.v-chip{border-color:#d6d6d6;color:var(--pp-text-primary,#2b2b2b)}.theme--light.v-chip:not(.v-chip--active){background:#e0e0e0}.theme--light.v-chip:hover:before{opacity:.1}.theme--light.v-chip--active:before,.theme--light.v-chip--active:hover:before,.theme--light.v-chip:focus:before{opacity:.12}.theme--light.v-chip--active:focus:before{opacity:.16}.theme--dark.v-chip{border-color:hsla(0,0%,100%,.12);color:var(--pp-primary-button-text-color,#004852)}.theme--dark.v-chip:not(.v-chip--active){background:#555}.theme--dark.v-chip:hover:before{opacity:.08}.theme--dark.v-chip--active:before,.theme--dark.v-chip--active:hover:before,.theme--dark.v-chip:focus:before{opacity:.24}.theme--dark.v-chip--active:focus:before{opacity:.32}.v-chip{align-items:center;cursor:default;display:inline-flex;line-height:20px;max-width:100%;outline:none;overflow:hidden;padding:0 12px;position:relative;text-decoration:none;transition-duration:.28s;transition-property:box-shadow,opacity;transition-timing-function:cubic-bezier(.4,0,.2,1);vertical-align:middle;white-space:nowrap}.v-chip:before{background-color:currentColor;bottom:0;border-radius:inherit;content:\"\";left:0;opacity:0;position:absolute;pointer-events:none;right:0;top:0}.v-chip .v-avatar{height:24px!important;min-width:24px!important;width:24px!important}.v-chip .v-icon{font-size:24px}.v-application--is-ltr .v-chip .v-avatar--left,.v-application--is-ltr .v-chip .v-icon--left{margin-left:-6px;margin-right:6px}.v-application--is-ltr .v-chip .v-avatar--right,.v-application--is-ltr .v-chip .v-icon--right,.v-application--is-rtl .v-chip .v-avatar--left,.v-application--is-rtl .v-chip .v-icon--left{margin-left:6px;margin-right:-6px}.v-application--is-rtl .v-chip .v-avatar--right,.v-application--is-rtl .v-chip .v-icon--right{margin-left:-6px;margin-right:6px}.v-chip:not(.v-chip--no-color) .v-icon{color:inherit}.v-chip .v-chip__close.v-icon{font-size:18px;max-height:18px;max-width:18px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.v-application--is-ltr .v-chip .v-chip__close.v-icon.v-icon--right{margin-right:-4px}.v-application--is-rtl .v-chip .v-chip__close.v-icon.v-icon--right{margin-left:-4px}.v-chip .v-chip__close.v-icon:active,.v-chip .v-chip__close.v-icon:focus,.v-chip .v-chip__close.v-icon:hover{opacity:.72}.v-chip .v-chip__content{align-items:center;display:inline-flex;height:100%;max-width:100%}.v-chip--active .v-icon{color:inherit}.v-chip--link:before{transition:opacity .3s cubic-bezier(.25,.8,.5,1)}.v-chip--link:focus:before{opacity:.32}.v-chip--clickable{cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.v-chip--clickable:active{box-shadow:0 3px 1px -2px transparent,0 2px 2px 0 transparent,0 1px 5px 0 rgba(0,0,0,.12)}.v-chip--disabled{opacity:.4;pointer-events:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.v-chip__filter{max-width:24px}.v-chip__filter.v-icon{color:inherit}.v-chip__filter.expand-x-transition-enter,.v-chip__filter.expand-x-transition-leave-active{margin:0}.v-chip--pill .v-chip__filter{margin-right:0 16px 0 0}.v-chip--pill .v-avatar{height:32px!important;width:32px!important}.v-application--is-ltr .v-chip--pill .v-avatar--left{margin-left:-12px}.v-application--is-ltr .v-chip--pill .v-avatar--right,.v-application--is-rtl .v-chip--pill .v-avatar--left{margin-right:-12px}.v-application--is-rtl .v-chip--pill .v-avatar--right{margin-left:-12px}.v-chip--label{border-radius:5px!important}.v-chip.v-chip--outlined{border-width:thin;border-style:solid}.v-chip.v-chip--outlined.v-chip--active:before{opacity:.08}.v-chip.v-chip--outlined .v-icon{color:inherit}.v-chip.v-chip--outlined.v-chip.v-chip{background-color:transparent!important}.v-chip.v-chip--selected{background:transparent}.v-chip.v-chip--selected:after{opacity:.28}.v-chip.v-size--x-small{border-radius:8px;font-size:10px;height:16px}.v-chip.v-size--small{border-radius:12px;font-size:12px;height:24px}.v-chip.v-size--default{border-radius:16px;font-size:14px;height:32px}.v-chip.v-size--large{border-radius:27px;font-size:16px;height:54px}.v-chip.v-size--x-large{border-radius:33px;font-size:18px;height:66px}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "7f9a":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var inspectSource = __webpack_require__("8925");

var WeakMap = global.WeakMap;

module.exports = typeof WeakMap === 'function' && /native code/.test(inspectSource(WeakMap));


/***/ }),

/***/ "7fd8":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("c8d5")

/**
 * @category Common Helpers
 * @summary Return an index of the closest date from the array comparing to the given date.
 *
 * @description
 * Return an index of the closest date from the array comparing to the given date.
 *
 * @param {Date|String|Number} dateToCompare - the date to compare with
 * @param {Date[]|String[]|Number[]} datesArray - the array to search
 * @returns {Number} an index of the date closest to the given date
 * @throws {TypeError} the second argument must be an instance of Array
 *
 * @example
 * // Which date is closer to 6 September 2015?
 * var dateToCompare = new Date(2015, 8, 6)
 * var datesArray = [
 *   new Date(2015, 0, 1),
 *   new Date(2016, 0, 1),
 *   new Date(2017, 0, 1)
 * ]
 * var result = closestIndexTo(dateToCompare, datesArray)
 * //=> 1
 */
function closestIndexTo (dirtyDateToCompare, dirtyDatesArray) {
  if (!(dirtyDatesArray instanceof Array)) {
    throw new TypeError(toString.call(dirtyDatesArray) + ' is not an instance of Array')
  }

  var dateToCompare = parse(dirtyDateToCompare)
  var timeToCompare = dateToCompare.getTime()

  var result
  var minDistance

  dirtyDatesArray.forEach(function (dirtyDate, index) {
    var currentDate = parse(dirtyDate)
    var distance = Math.abs(timeToCompare - currentDate.getTime())
    if (result === undefined || distance < minDistance) {
      result = index
      minDistance = distance
    }
  })

  return result
}

module.exports = closestIndexTo


/***/ }),

/***/ "8016":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./aid-ads--active.svg": "3d02",
	"./aid-ads--hover.svg": "3b30",
	"./aid-ads.svg": "f141",
	"./appointments--active.svg": "83df",
	"./appointments--hover.svg": "f110",
	"./appointments.svg": "e55c",
	"./blog--active.svg": "f663",
	"./blog--hover.svg": "7d72",
	"./blog.svg": "3ef2",
	"./calendar--active.svg": "59e1",
	"./calendar--hover.svg": "a966",
	"./calendar.svg": "10e1",
	"./campaigns--active.svg": "a000",
	"./campaigns--hover.svg": "1fd7",
	"./campaigns.svg": "487b",
	"./credit--active.svg": "56f0",
	"./credit--hover.svg": "027e",
	"./credit.svg": "bbb5",
	"./fax--active.svg": "828f",
	"./fax--hover.svg": "c074",
	"./fax.svg": "6cf7",
	"./help--active.svg": "31b3",
	"./help--hover.svg": "913e",
	"./help.svg": "828a",
	"./inbox--active.svg": "ff95",
	"./inbox--hover.svg": "0ea5",
	"./inbox.svg": "97a7",
	"./insights--active.svg": "b893",
	"./insights--hover.svg": "bb90",
	"./insights.svg": "2774",
	"./messages--active.svg": "ff00",
	"./messages--hover.svg": "7dc7",
	"./messages.svg": "4400",
	"./notifications--active.svg": "fabf",
	"./notifications--hover.svg": "c624",
	"./notifications.svg": "b9a8",
	"./onboarding--active.svg": "5d3b",
	"./onboarding--hover.svg": "fb01",
	"./onboarding.svg": "61ae",
	"./patients--active.svg": "2e94",
	"./patients--hover.svg": "afaf",
	"./patients.svg": "3660",
	"./payments--active.svg": "3764",
	"./payments--hover.svg": "9417",
	"./payments.svg": "f709",
	"./phone-leads--active.svg": "e80a",
	"./phone-leads--hover.svg": "63f4",
	"./phone-leads.svg": "d04a",
	"./prescription--active.svg": "9b3e",
	"./prescription--hover.svg": "4a6a",
	"./prescription.svg": "ab6f",
	"./presence--active.svg": "369a",
	"./presence--hover.svg": "b8d5",
	"./presence.svg": "a806",
	"./reminders--active.svg": "b933",
	"./reminders--hover.svg": "8b76",
	"./reminders.svg": "aa79",
	"./reputation--active.svg": "ca68",
	"./reputation--hover.svg": "6de0",
	"./reputation.svg": "0539",
	"./schedule--active.svg": "0834",
	"./schedule--hover.svg": "8e45",
	"./schedule.svg": "c580",
	"./settings--active.svg": "c67e",
	"./settings--hover.svg": "afe3",
	"./settings.svg": "c696",
	"./social--active.svg": "1c75",
	"./social--hover.svg": "fb3b",
	"./social.svg": "19cf",
	"./tasks--active.svg": "7378",
	"./tasks--hover.svg": "9cd2",
	"./tasks.svg": "324e",
	"./telehealth--active.svg": "6baa",
	"./telehealth--hover.svg": "e7e2",
	"./telehealth.svg": "b0e0",
	"./web-editor--active.svg": "ffb7",
	"./web-editor--hover.svg": "2b64",
	"./web-editor.svg": "1da9",
	"./website--active.svg": "01ba",
	"./website--hover.svg": "7893",
	"./website.svg": "7921"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8016";

/***/ }),

/***/ "805b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpSignatureIcon_vue_vue_type_style_index_0_id_1021e088_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("0918");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpSignatureIcon_vue_vue_type_style_index_0_id_1021e088_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpSignatureIcon_vue_vue_type_style_index_0_id_1021e088_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "80d2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return createSimpleFunctional; });
/* unused harmony export directiveConfig */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addOnceEventListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return passiveSupported; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return addPassiveEventListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return getNestedValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return deepEqual; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return getObjectValueByPath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return getPropertyFromItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return createRange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return getZIndex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return escapeHTML; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return filterObjectOnKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return convertToUnit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return kebabCase; });
/* unused harmony export isObject */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return keyCodes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return remapInternalIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return keys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return camelize; });
/* unused harmony export arrayDiff */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return upperFirst; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return groupItems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return wrapInArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return sortItems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return defaultFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return searchItems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return getSlotType; });
/* unused harmony export debounce */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return throttle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return getPrefixedScopedSlots; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return getSlot; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return clamp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return padEnd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return chunk; });
/* unused harmony export humanReadableFileSize */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return camelizeObjectKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return mergeDeep; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return fillArray; });
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("99af");
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_every_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("a623");
/* harmony import */ var core_js_modules_es_array_every_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_every_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_fill_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("cb29");
/* harmony import */ var core_js_modules_es_array_fill_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_fill_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("4de4");
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("a630");
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_index_of_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("c975");
/* harmony import */ var core_js_modules_es_array_index_of_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("d81d");
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_reduce_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("13d5");
/* harmony import */ var core_js_modules_es_array_reduce_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("fb6a");
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_array_some_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("45fc");
/* harmony import */ var core_js_modules_es_array_some_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("b0c0");
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("a9e3");
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_number_to_fixed_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("b680");
/* harmony import */ var core_js_modules_es_number_to_fixed_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_to_fixed_js__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_object_freeze_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("dca8");
/* harmony import */ var core_js_modules_es_object_freeze_js__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_freeze_js__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("b64b");
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("d3b7");
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("ac1f");
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("25f0");
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("3ca3");
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_es_string_repeat_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("38cf");
/* harmony import */ var core_js_modules_es_string_repeat_js__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_repeat_js__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("5319");
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_es_string_split_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__("1276");
/* harmony import */ var core_js_modules_es_string_split_js__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split_js__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_es_string_starts_with_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__("2ca0");
/* harmony import */ var core_js_modules_es_string_starts_with_js__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_starts_with_js__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var core_js_modules_es_string_trim_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__("498a");
/* harmony import */ var core_js_modules_es_string_trim_js__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_trim_js__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var _home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__("3835");
/* harmony import */ var _home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__("53ca");
/* harmony import */ var _home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__("5530");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__("8bbf");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_27__);




























function createSimpleFunctional(c) {
  var el = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'div';
  var name = arguments.length > 2 ? arguments[2] : undefined;
  return vue__WEBPACK_IMPORTED_MODULE_27___default.a.extend({
    name: name || c.replace(/__/g, '-'),
    functional: true,
    render: function render(h, _ref) {
      var data = _ref.data,
          children = _ref.children;
      data.staticClass = "".concat(c, " ").concat(data.staticClass || '').trim();
      return h(el, data, children);
    }
  });
}
function directiveConfig(binding) {
  var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_26__[/* default */ "a"])(Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_26__[/* default */ "a"])(Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_26__[/* default */ "a"])({}, defaults), binding.modifiers), {}, {
    value: binding.arg
  }, binding.value || {});
}
function addOnceEventListener(el, eventName, cb) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  var once = function once(event) {
    cb(event);
    el.removeEventListener(eventName, once, options);
  };

  el.addEventListener(eventName, once, options);
}
var passiveSupported = false;

try {
  if (typeof window !== 'undefined') {
    var testListenerOpts = Object.defineProperty({}, 'passive', {
      get: function get() {
        passiveSupported = true;
      }
    });
    window.addEventListener('testListener', testListenerOpts, testListenerOpts);
    window.removeEventListener('testListener', testListenerOpts, testListenerOpts);
  }
} catch (e) {
  console.warn(e);
}


function addPassiveEventListener(el, event, cb, options) {
  el.addEventListener(event, cb, passiveSupported ? options : false);
}
function getNestedValue(obj, path, fallback) {
  var last = path.length - 1;
  if (last < 0) return obj === undefined ? fallback : obj;

  for (var i = 0; i < last; i++) {
    if (obj == null) {
      return fallback;
    }

    obj = obj[path[i]];
  }

  if (obj == null) return fallback;
  return obj[path[last]] === undefined ? fallback : obj[path[last]];
}
function deepEqual(a, b) {
  if (a === b) return true;

  if (a instanceof Date && b instanceof Date && a.getTime() !== b.getTime()) {
    // If the values are Date, compare them as timestamps
    return false;
  }

  if (a !== Object(a) || b !== Object(b)) {
    // If the values aren't objects, they were already checked for equality
    return false;
  }

  var props = Object.keys(a);

  if (props.length !== Object.keys(b).length) {
    // Different number of props, don't bother to check
    return false;
  }

  return props.every(function (p) {
    return deepEqual(a[p], b[p]);
  });
}
function getObjectValueByPath(obj, path, fallback) {
  // credit: http://stackoverflow.com/questions/6491463/accessing-nested-javascript-objects-with-string-key#comment55278413_6491621
  if (obj == null || !path || typeof path !== 'string') return fallback;
  if (obj[path] !== undefined) return obj[path];
  path = path.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties

  path = path.replace(/^\./, ''); // strip a leading dot

  return getNestedValue(obj, path.split('.'), fallback);
}
function getPropertyFromItem(item, property, fallback) {
  if (property == null) return item === undefined ? fallback : item;
  if (item !== Object(item)) return fallback === undefined ? item : fallback;
  if (typeof property === 'string') return getObjectValueByPath(item, property, fallback);
  if (Array.isArray(property)) return getNestedValue(item, property, fallback);
  if (typeof property !== 'function') return fallback;
  var value = property(item, fallback);
  return typeof value === 'undefined' ? fallback : value;
}
function createRange(length) {
  return Array.from({
    length: length
  }, function (v, k) {
    return k;
  });
}
function getZIndex(el) {
  if (!el || el.nodeType !== Node.ELEMENT_NODE) return 0;
  var index = +window.getComputedStyle(el).getPropertyValue('z-index');
  if (!index) return getZIndex(el.parentNode);
  return index;
}
var tagsToReplace = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;'
};
function escapeHTML(str) {
  return str.replace(/[&<>]/g, function (tag) {
    return tagsToReplace[tag] || tag;
  });
}
function filterObjectOnKeys(obj, keys) {
  var filtered = {};

  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];

    if (typeof obj[key] !== 'undefined') {
      filtered[key] = obj[key];
    }
  }

  return filtered;
}
function convertToUnit(str) {
  var unit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'px';

  if (str == null || str === '') {
    return undefined;
  } else if (isNaN(+str)) {
    return String(str);
  } else {
    return "".concat(Number(str)).concat(unit);
  }
}
function kebabCase(str) {
  return (str || '').replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
}
function isObject(obj) {
  return obj !== null && Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_25__[/* default */ "a"])(obj) === 'object';
} // KeyboardEvent.keyCode aliases

var keyCodes = Object.freeze({
  enter: 13,
  tab: 9,
  delete: 46,
  esc: 27,
  space: 32,
  up: 38,
  down: 40,
  left: 37,
  right: 39,
  end: 35,
  home: 36,
  del: 46,
  backspace: 8,
  insert: 45,
  pageup: 33,
  pagedown: 34
});
/**
 * This remaps internal names like '$cancel' or '$vuetify.icons.cancel'
 * to the current name or component for that icon.
 */

function remapInternalIcon(vm, iconName) {
  // Look for custom component in the configuration
  var component = vm.$vuetify.icons.component; // Look for overrides

  if (iconName.startsWith('$')) {
    // Get the target icon name
    var iconPath = "$vuetify.icons.values.".concat(iconName.split('$').pop().split('.').pop()); // Now look up icon indirection name,
    // e.g. '$vuetify.icons.values.cancel'

    var override = getObjectValueByPath(vm, iconPath, iconName);
    if (typeof override === 'string') iconName = override;else return override;
  }

  if (component == null) {
    return iconName;
  }

  return {
    component: component,
    props: {
      icon: iconName
    }
  };
}
function keys(o) {
  return Object.keys(o);
}
/**
 * Camelize a hyphen-delimited string.
 */

var camelizeRE = /-(\w)/g;
var camelize = function camelize(str) {
  return str.replace(camelizeRE, function (_, c) {
    return c ? c.toUpperCase() : '';
  });
};
/**
 * Returns the set difference of B and A, i.e. the set of elements in B but not in A
 */

function arrayDiff(a, b) {
  var diff = [];

  for (var i = 0; i < b.length; i++) {
    if (a.indexOf(b[i]) < 0) diff.push(b[i]);
  }

  return diff;
}
/**
 * Makes the first character of a string uppercase
 */

function upperFirst(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}
function groupItems(items, groupBy, groupDesc) {
  var key = groupBy[0];
  var groups = [];
  var current;

  for (var i = 0; i < items.length; i++) {
    var item = items[i];
    var val = getObjectValueByPath(item, key, null);

    if (current !== val) {
      var _val;

      current = val;
      groups.push({
        name: (_val = val) != null ? _val : '',
        items: []
      });
    }

    groups[groups.length - 1].items.push(item);
  }

  return groups;
}
function wrapInArray(v) {
  return v != null ? Array.isArray(v) ? v : [v] : [];
}
function sortItems(items, sortBy, sortDesc, locale, customSorters) {
  if (sortBy === null || !sortBy.length) return items;
  var stringCollator = new Intl.Collator(locale, {
    sensitivity: 'accent',
    usage: 'sort'
  });
  return items.sort(function (a, b) {
    for (var i = 0; i < sortBy.length; i++) {
      var sortKey = sortBy[i];
      var sortA = getObjectValueByPath(a, sortKey);
      var sortB = getObjectValueByPath(b, sortKey);

      if (sortDesc[i]) {
        var _ref2 = [sortB, sortA];
        sortA = _ref2[0];
        sortB = _ref2[1];
      }

      if (customSorters && customSorters[sortKey]) {
        var customResult = customSorters[sortKey](sortA, sortB);
        if (!customResult) continue;
        return customResult;
      } // Check if both cannot be evaluated


      if (sortA === null && sortB === null) {
        continue;
      }

      var _map = [sortA, sortB].map(function (s) {
        return (s || '').toString().toLocaleLowerCase();
      });

      var _map2 = Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_24__[/* default */ "a"])(_map, 2);

      sortA = _map2[0];
      sortB = _map2[1];

      if (sortA !== sortB) {
        if (!isNaN(sortA) && !isNaN(sortB)) return Number(sortA) - Number(sortB);
        return stringCollator.compare(sortA, sortB);
      }
    }

    return 0;
  });
}
function defaultFilter(value, search, item) {
  return value != null && search != null && typeof value !== 'boolean' && value.toString().toLocaleLowerCase().indexOf(search.toLocaleLowerCase()) !== -1;
}
function searchItems(items, search) {
  if (!search) return items;
  search = search.toString().toLowerCase();
  if (search.trim() === '') return items;
  return items.filter(function (item) {
    return Object.keys(item).some(function (key) {
      return defaultFilter(getObjectValueByPath(item, key), search, item);
    });
  });
}
/**
 * Returns:
 *  - 'normal' for old style slots - `<template slot="default">`
 *  - 'scoped' for old style scoped slots (`<template slot="default" slot-scope="data">`) or bound v-slot (`#default="data"`)
 *  - 'v-slot' for unbound v-slot (`#default`) - only if the third param is true, otherwise counts as scoped
 */

function getSlotType(vm, name, split) {
  if (vm.$slots[name] && vm.$scopedSlots[name] && vm.$scopedSlots[name].name) {
    return split ? 'v-slot' : 'scoped';
  }

  if (vm.$slots[name]) return 'normal';
  if (vm.$scopedSlots[name]) return 'scoped';
}
function debounce(fn, delay) {
  var timeoutId = 0;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    clearTimeout(timeoutId);
    timeoutId = setTimeout(function () {
      return fn.apply(void 0, args);
    }, delay);
  };
}
function throttle(fn, limit) {
  var throttling = false;
  return function () {
    if (!throttling) {
      throttling = true;
      setTimeout(function () {
        return throttling = false;
      }, limit);
      return fn.apply(void 0, arguments);
    }
  };
}
function getPrefixedScopedSlots(prefix, scopedSlots) {
  return Object.keys(scopedSlots).filter(function (k) {
    return k.startsWith(prefix);
  }).reduce(function (obj, k) {
    obj[k.replace(prefix, '')] = scopedSlots[k];
    return obj;
  }, {});
}
function getSlot(vm) {
  var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'default';
  var data = arguments.length > 2 ? arguments[2] : undefined;
  var optional = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  if (vm.$scopedSlots[name]) {
    return vm.$scopedSlots[name](data instanceof Function ? data() : data);
  } else if (vm.$slots[name] && (!data || optional)) {
    return vm.$slots[name];
  }

  return undefined;
}
function clamp(value) {
  var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  return Math.max(min, Math.min(max, value));
}
function padEnd(str, length) {
  var char = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '0';
  return str + char.repeat(Math.max(0, length - str.length));
}
function chunk(str) {
  var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var chunked = [];
  var index = 0;

  while (index < str.length) {
    chunked.push(str.substr(index, size));
    index += size;
  }

  return chunked;
}
function humanReadableFileSize(bytes) {
  var binary = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var base = binary ? 1024 : 1000;

  if (bytes < base) {
    return "".concat(bytes, " B");
  }

  var prefix = binary ? ['Ki', 'Mi', 'Gi'] : ['k', 'M', 'G'];
  var unit = -1;

  while (Math.abs(bytes) >= base && unit < prefix.length - 1) {
    bytes /= base;
    ++unit;
  }

  return "".concat(bytes.toFixed(1), " ").concat(prefix[unit], "B");
}
function camelizeObjectKeys(obj) {
  if (!obj) return {};
  return Object.keys(obj).reduce(function (o, key) {
    o[camelize(key)] = obj[key];
    return o;
  }, {});
}
function mergeDeep() {
  var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  for (var key in target) {
    var sourceProperty = source[key];
    var targetProperty = target[key]; // Only continue deep merging if
    // both properties are objects

    if (isObject(sourceProperty) && isObject(targetProperty)) {
      source[key] = mergeDeep(sourceProperty, targetProperty);
      continue;
    }

    source[key] = targetProperty;
  }

  return source;
}
function fillArray(length, obj) {
  return Array(length).fill(obj);
}

/***/ }),

/***/ "8148":
/***/ (function(module, exports) {

/**
 * @category Day Helpers
 * @summary Return the start of tomorrow.
 *
 * @description
 * Return the start of tomorrow.
 *
 * @returns {Date} the start of tomorrow
 *
 * @example
 * // If today is 6 October 2014:
 * var result = startOfTomorrow()
 * //=> Tue Oct 7 2014 00:00:00
 */
function startOfTomorrow () {
  var now = new Date()
  var year = now.getFullYear()
  var month = now.getMonth()
  var day = now.getDate()

  var date = new Date(0)
  date.setFullYear(year, month, day + 1)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = startOfTomorrow


/***/ }),

/***/ "81d5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toObject = __webpack_require__("7b0b");
var toAbsoluteIndex = __webpack_require__("23cb");
var toLength = __webpack_require__("50c4");

// `Array.prototype.fill` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.fill
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var argumentsLength = arguments.length;
  var index = toAbsoluteIndex(argumentsLength > 1 ? arguments[1] : undefined, length);
  var end = argumentsLength > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),

/***/ "81fc":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("c8d5")
var startOfISOWeek = __webpack_require__("b4c7")
var startOfISOYear = __webpack_require__("4497")

var MILLISECONDS_IN_WEEK = 604800000

/**
 * @category ISO Week Helpers
 * @summary Get the ISO week of the given date.
 *
 * @description
 * Get the ISO week of the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the ISO week
 *
 * @example
 * // Which week of the ISO-week numbering year is 2 January 2005?
 * var result = getISOWeek(new Date(2005, 0, 2))
 * //=> 53
 */
function getISOWeek (dirtyDate) {
  var date = parse(dirtyDate)
  var diff = startOfISOWeek(date).getTime() - startOfISOYear(date).getTime()

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1
}

module.exports = getISOWeek


/***/ }),

/***/ "8212":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("a9e3");
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("5530");
/* harmony import */ var _src_components_VAvatar_VAvatar_sass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("3408");
/* harmony import */ var _src_components_VAvatar_VAvatar_sass__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_src_components_VAvatar_VAvatar_sass__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _mixins_colorable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("a9ad");
/* harmony import */ var _mixins_measurable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("24b2");
/* harmony import */ var _mixins_roundable__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("a236");
/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("80d2");
/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("58df");


 // Mixins



 // Utilities



/* harmony default export */ __webpack_exports__["a"] = (Object(_util_mixins__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(_mixins_colorable__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"], _mixins_measurable__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"], _mixins_roundable__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"]).extend({
  name: 'v-avatar',
  props: {
    left: Boolean,
    right: Boolean,
    size: {
      type: [Number, String],
      default: 48
    }
  },
  computed: {
    classes: function classes() {
      return Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])({
        'v-avatar--left': this.left,
        'v-avatar--right': this.right
      }, this.roundedClasses);
    },
    styles: function styles() {
      return Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])({
        height: Object(_util_helpers__WEBPACK_IMPORTED_MODULE_6__[/* convertToUnit */ "g"])(this.size),
        minWidth: Object(_util_helpers__WEBPACK_IMPORTED_MODULE_6__[/* convertToUnit */ "g"])(this.size),
        width: Object(_util_helpers__WEBPACK_IMPORTED_MODULE_6__[/* convertToUnit */ "g"])(this.size)
      }, this.measurableStyles);
    }
  },
  render: function render(h) {
    var data = {
      staticClass: 'v-avatar',
      class: this.classes,
      style: this.styles,
      on: this.$listeners
    };
    return h('div', this.setBackgroundColor(this.color, data), this.$slots.default);
  }
}));

/***/ }),

/***/ "825a":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");

module.exports = function (it) {
  if (!isObject(it)) {
    throw TypeError(String(it) + ' is not an object');
  } return it;
};


/***/ }),

/***/ "828a":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_1488_303)\"><circle cx=\"12\" cy=\"12\" r=\"10\" fill=\"white\" stroke=\"#688083\" stroke-width=\"2\"></circle><circle cx=\"12\" cy=\"12\" r=\"7\" fill=\"#DFE4E5\"></circle><path d=\"M11.125 16.0908C11.125 16.5929 11.5169 17 12.0003 17C12.4837 17 12.8756 16.5929 12.8756 16.0908C12.8756 15.5886 12.4837 15.1815 12.0003 15.1815C11.5169 15.1815 11.125 15.5886 11.125 16.0908Z\" fill=\"#688083\"></path><path d=\"M11.125 14.2738H12.875C12.875 13.5479 12.9847 13.4149 13.7038 13.0413C14.9535 12.392 15.5 11.7295 15.5 10.1823C15.5 8.20075 13.9988 7 12 7C10.067 7 8.5 8.6283 8.5 10.6369H10.25C10.25 9.63261 11.0335 8.81846 12 8.81846C13.1175 8.81846 13.75 9.32436 13.75 10.1823C13.75 10.9082 13.6403 11.0412 12.9212 11.4148C11.6715 12.0641 11.125 12.7266 11.125 14.2738Z\" fill=\"#688083\"></path></g><defs><clipPath id=\"clip0_1488_303\"><rect width=\"24\" height=\"24\" fill=\"white\"></rect></clipPath></defs></svg>";

/***/ }),

/***/ "828f":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><rect x=\"8\" y=\"3\" width=\"8\" height=\"5\" fill=\"#D5EAFD\"></rect><rect x=\"8\" y=\"16\" width=\"8\" height=\"5\" fill=\"#D5EAFD\"></rect><rect x=\"4\" y=\"9\" width=\"16\" height=\"8\" fill=\"white\"></rect><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8 7V4H16V7H8ZM6 7V2H18V7H20C21.1046 7 22 7.89543 22 9V17C22 18.1046 21.1046 19 20 19H17V17H20V9H4V17H7V19H4C2.89543 19 2 18.1046 2 17V9C2 7.89543 2.89543 7 4 7H6ZM18 10C18.5523 10 19 10.4477 19 11C19 11.5523 18.5523 12 18 12C17.4477 12 17 11.5523 17 11C17 10.4477 17.4477 10 18 10ZM16 11C16 10.4477 15.5523 10 15 10C14.4477 10 14 10.4477 14 11C14 11.5523 14.4477 12 15 12C15.5523 12 16 11.5523 16 11Z\" fill=\"#079CB2\"></path><path d=\"M7 16H17V19C17 20.1046 16.1046 21 15 21H7V16Z\" fill=\"#D5EAFD\" stroke=\"#079CB2\" stroke-width=\"2\"></path></svg>";

/***/ }),

/***/ "8294":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpDropDownButton_vue_vue_type_style_index_0_id_128b2aa0_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("5306");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpDropDownButton_vue_vue_type_style_index_0_id_128b2aa0_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpDropDownButton_vue_vue_type_style_index_0_id_128b2aa0_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "82dc":
/***/ (function(module, exports, __webpack_require__) {

var startOfISOWeek = __webpack_require__("b4c7")

var MILLISECONDS_IN_MINUTE = 60000
var MILLISECONDS_IN_WEEK = 604800000

/**
 * @category ISO Week Helpers
 * @summary Get the number of calendar ISO weeks between the given dates.
 *
 * @description
 * Get the number of calendar ISO weeks between the given dates.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar ISO weeks
 *
 * @example
 * // How many calendar ISO weeks are between 6 July 2014 and 21 July 2014?
 * var result = differenceInCalendarISOWeeks(
 *   new Date(2014, 6, 21),
 *   new Date(2014, 6, 6)
 * )
 * //=> 3
 */
function differenceInCalendarISOWeeks (dirtyDateLeft, dirtyDateRight) {
  var startOfISOWeekLeft = startOfISOWeek(dirtyDateLeft)
  var startOfISOWeekRight = startOfISOWeek(dirtyDateRight)

  var timestampLeft = startOfISOWeekLeft.getTime() -
    startOfISOWeekLeft.getTimezoneOffset() * MILLISECONDS_IN_MINUTE
  var timestampRight = startOfISOWeekRight.getTime() -
    startOfISOWeekRight.getTimezoneOffset() * MILLISECONDS_IN_MINUTE

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_WEEK)
}

module.exports = differenceInCalendarISOWeeks


/***/ }),

/***/ "8301":
/***/ (function(module, exports, __webpack_require__) {

var differenceInMonths = __webpack_require__("17cd")

/**
 * @category Quarter Helpers
 * @summary Get the number of full quarters between the given dates.
 *
 * @description
 * Get the number of full quarters between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of full quarters
 *
 * @example
 * // How many full quarters are between 31 December 2013 and 2 July 2014?
 * var result = differenceInQuarters(
 *   new Date(2014, 6, 2),
 *   new Date(2013, 11, 31)
 * )
 * //=> 2
 */
function differenceInQuarters (dirtyDateLeft, dirtyDateRight) {
  var diff = differenceInMonths(dirtyDateLeft, dirtyDateRight) / 3
  return diff > 0 ? Math.floor(diff) : Math.ceil(diff)
}

module.exports = differenceInQuarters


/***/ }),

/***/ "830a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c662cfac-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/portal/user-menu/PpPortalUserMenu.vue?vue&type=template&id=0b18df46&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-menu',{attrs:{"max-width":_vm.width,"min-width":_vm.width,"nudge-bottom":45,"z-index":"20"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('pp-avatar-icon',_vm._g(_vm._b({staticClass:"pp-portal-user-menu",attrs:{"name":_vm.name,"image":_vm.image,"is-practice":true,"size":"md"}},'pp-avatar-icon',attrs,false),on))]}}])},[_c('div',{staticClass:"white px-3 py-5 text-h6 font-weight-bold text-truncate"},[_vm._v(" "+_vm._s(_vm.name)+" ")]),_c('v-list',{attrs:{"dense":"","nav":""}},_vm._l((_vm.items),function(navItem,j){return _c('v-list-item-group',{key:j},[(navItem.items.length > 1)?_c('div',{staticClass:"text-subtitle-1 my-1 grey--text"},[_vm._v(" "+_vm._s(navItem.name)+" ")]):_vm._e(),_vm._l((navItem.items),function(item,i){return _c('v-list-item',{key:i,on:{"click":function($event){return _vm.itemClicked(item)}}},[(item.icon)?_c('i',{staticClass:"mr-3 d-flex",class:("pp-icon-" + (item.icon))}):_vm._e(),_c('v-list-item-content',[_c('v-list-item-title',{domProps:{"textContent":_vm._s(item.name)}})],1)],1)})],2)}),1)],1)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/portal/user-menu/PpPortalUserMenu.vue?vue&type=template&id=0b18df46&scoped=true&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__("a9e3");

// EXTERNAL MODULE: ./src/components/avatar-icon/PpAvatarIcon.vue + 4 modules
var PpAvatarIcon = __webpack_require__("020a");

// CONCATENATED MODULE: ./src/components/portal/user-menu/constants.js
var CLICK_TYPE = {
  EVENT: 'event',
  URL: 'url'
};
var URLS = {
  SUPPORT: '/support/',
  LOGOUT: '/logout/'
};
var DEFAULT_MENU = [{
  name: 'Settings',
  items: [{
    name: 'My account',
    icon: 'patient',
    type: CLICK_TYPE.EVENT,
    route: '/profile/my-account'
  }, {
    name: 'My notifications',
    icon: 'bell',
    type: CLICK_TYPE.EVENT,
    route: '/profile/notifications'
  }]
}, {
  name: 'Customer Care',
  items: [{
    name: 'Customer Care',
    icon: 'support',
    type: CLICK_TYPE.URL,
    route: URLS.SUPPORT
  }]
}, {
  name: 'Sign Out',
  items: [{
    name: 'Sign Out',
    icon: 'arrow-circle-left',
    type: CLICK_TYPE.URL,
    route: URLS.LOGOUT
  }]
}];
// EXTERNAL MODULE: ./src/components/portal/constants.js
var constants = __webpack_require__("463f");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/portal/user-menu/PpPortalUserMenu.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var PpPortalUserMenuvue_type_script_lang_js_ = ({
  name: 'PpPortalUserMenu',
  components: {
    'pp-avatar-icon': PpAvatarIcon["default"]
  },
  props: {
    image: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      required: true
    },

    /**
     * Items array: will include section of items (will be separated by dividing lines),
     * each item = {*name*, icon, *type*, *route*}.
     * Refer to the default menu for set up
     */
    items: {
      type: Array,
      default: function _default() {
        return DEFAULT_MENU;
      }
    },
    width: {
      type: Number,
      default: 280
    }
  },
  methods: {
    itemClicked: function itemClicked(item) {
      this.$emit('navigate', item);

      if (item.type === CLICK_TYPE.URL) {
        // if the URL starts with http then open in new window
        if (/^((http|https|ftp):\/\/)/.test(item.route)) {
          window.open(item.route, '_blank');
        } else {
          window.location.assign(item.route);
        }
      } else if (item.type === CLICK_TYPE.EVENT) {
        document.dispatchEvent(new CustomEvent(constants["a" /* PORTAL_SETTINGS_OPEN */], {
          detail: {
            page: item.route
          }
        }));
      }
    }
  }
});
// CONCATENATED MODULE: ./src/components/portal/user-menu/PpPortalUserMenu.vue?vue&type=script&lang=js&
 /* harmony default export */ var user_menu_PpPortalUserMenuvue_type_script_lang_js_ = (PpPortalUserMenuvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/portal/user-menu/PpPortalUserMenu.vue?vue&type=style&index=0&id=0b18df46&lang=scss&scoped=true&
var PpPortalUserMenuvue_type_style_index_0_id_0b18df46_lang_scss_scoped_true_ = __webpack_require__("7893e");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// EXTERNAL MODULE: ./node_modules/vuetify-loader/lib/runtime/installComponents.js
var installComponents = __webpack_require__("6544");
var installComponents_default = /*#__PURE__*/__webpack_require__.n(installComponents);

// EXTERNAL MODULE: ./node_modules/vuetify/lib/components/VList/VList.js
var VList = __webpack_require__("8860");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/components/VList/VListItem.js
var VListItem = __webpack_require__("da13");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/components/VList/index.js + 3 modules
var components_VList = __webpack_require__("5d23");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/components/VList/VListItemGroup.js
var VListItemGroup = __webpack_require__("1baa");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/components/VMenu/VMenu.js
var VMenu = __webpack_require__("e449");

// CONCATENATED MODULE: ./src/components/portal/user-menu/PpPortalUserMenu.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  user_menu_PpPortalUserMenuvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "0b18df46",
  null
  
)

/* harmony default export */ var PpPortalUserMenu = __webpack_exports__["default"] = (component.exports);

/* vuetify-loader */







installComponents_default()(component, {VList: VList["a" /* default */],VListItem: VListItem["a" /* default */],VListItemContent: components_VList["a" /* VListItemContent */],VListItemGroup: VListItemGroup["a" /* default */],VListItemTitle: components_VList["b" /* VListItemTitle */],VMenu: VMenu["a" /* default */]})


/***/ }),

/***/ "8312":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.i, "@import url(https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css);"]);
exports.push([module.i, "@import url(https://cdn-prd.patientpop.com/pp-icon-font/v1.6.0/pp-icon-font.css);"]);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}", ""]);
// Exports
exports.locals = {
	"legacyBrand": "#07c597",
	"white": "#fff",
	"growth1": "#004852",
	"growth1_5": "#195b63",
	"growth2": "#417e86",
	"growth3": "#8cb2b6",
	"growth4": "#cbdde0",
	"growth5": "#eef7f9",
	"vitality0": "#dc785d",
	"vitality1": "#ff8d6e",
	"vitality2": "#ffaf95",
	"vitality3": "#ffcfbf",
	"vitality4": "#ffe9e3",
	"backbone1": "#f6f3eb",
	"backbone2": "#f0eee8",
	"backbone3": "#e8e5df",
	"backbone4": "#e1ded8",
	"core1": "#8ca7a2",
	"core2": "#b3c6c4",
	"core3": "#d4e0dd",
	"core4": "#e9efee",
	"care1": "#e0d3c8",
	"care2": "#eee5de",
	"care3": "#f6f2ec",
	"care4": "#fbf9f8",
	"synapse1": "#2b2b2b",
	"synapse2": "#545454",
	"synapse3": "#9a9a9a",
	"synapse4": "#d6d6d6",
	"synapse5": "#f6f6f6",
	"synapse6": "#fff",
	"soma": "#1d6b45",
	"vigor": "#3fa266",
	"cyto": "#3fa266",
	"restore": "#6fc691",
	"asana": "#f0faf2",
	"neuron": "#f2ba2a",
	"energize": "#fcde73",
	"amino": "#fef5d5",
	"remedy": "#b51a2c",
	"firstAid": "#d83b4d",
	"siren": "#fbcbd1",
	"plasma": "#fceeee",
	"circadian": "#4678cc",
	"practice": "#067889",
	"holistic": "#079cb2",
	"community": "#0ab7ad",
	"placebo": "#83cdd9",
	"reflex": "#0dddd1",
	"diastole": "#c74b76",
	"systole": "#8657ac",
	"membrane": "#e7d8ff",
	"pneumo": "#e6f5f7",
	"avatarDefault": "#e0d3c8"
};
module.exports = exports;


/***/ }),

/***/ "8327":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c662cfac-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/input/checkbox/PpInputCheckbox.vue?vue&type=template&id=46c47d0c&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"d-flex flex-wrap align-center pp-input-checkbox",class:{'pp-input-checkbox--disabled':_vm.disabled}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.$attrs.value),expression:"$attrs.value"}],attrs:{"disabled":_vm.disabled,"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.$attrs.value)?_vm._i(_vm.$attrs.value,null)>-1:(_vm.$attrs.value)},on:{"change":[function($event){var $$a=_vm.$attrs.value,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.$attrs, "value", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.$attrs, "value", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.$attrs, "value", $$c)}},_vm.emitChange]}}),_c('span',{staticClass:"d-flex align-center justify-center pp-input-checkbox__checkbox mr-2",class:[
      _vm.small ? 'mb-auto' : ''
    ]},[_c('i',{staticClass:"pp-icon-check"})]),(_vm.$slots.label || _vm.label)?_c('span',{staticClass:"pp-input-checkbox__label ",class:[
      _vm.small ? 'text-body-2 pp-input-checkbox__label__small' : ''
    ]},[_vm._t("label",[_vm._v(" "+_vm._s(_vm.label)+" ")])],2):_vm._e(),(_vm.errorMessages.length > 0)?_c('span',{staticClass:"error--text text-caption pp-input-checkbox__error-messages"},[_vm._l((_vm.errorMessages),function(errorMessage){return [_vm._v(" "+_vm._s(errorMessage)+" ")]})],2):_vm._e()])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/input/checkbox/PpInputCheckbox.vue?vue&type=template&id=46c47d0c&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/input/checkbox/PpInputCheckbox.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var PpInputCheckboxvue_type_script_lang_js_ = ({
  name: 'PpInputCheckbox',
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    errorMessages: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    label: {
      type: String,
      default: ''
    },
    small: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    emitChange: function emitChange() {
      this.$emit('input', this.$attrs.value);
    }
  }
});
// CONCATENATED MODULE: ./src/components/input/checkbox/PpInputCheckbox.vue?vue&type=script&lang=js&
 /* harmony default export */ var checkbox_PpInputCheckboxvue_type_script_lang_js_ = (PpInputCheckboxvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/input/checkbox/PpInputCheckbox.vue?vue&type=style&index=0&id=46c47d0c&lang=scss&scoped=true&
var PpInputCheckboxvue_type_style_index_0_id_46c47d0c_lang_scss_scoped_true_ = __webpack_require__("57fe");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/input/checkbox/PpInputCheckbox.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  checkbox_PpInputCheckboxvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "46c47d0c",
  null
  
)

/* harmony default export */ var PpInputCheckbox = __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "8336":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("4160");
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("caad");
/* harmony import */ var core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("a9e3");
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_string_fixed_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("c7cd");
/* harmony import */ var core_js_modules_es_string_fixed_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_fixed_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("53ca");
/* harmony import */ var _home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("3835");
/* harmony import */ var _home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("5530");
/* harmony import */ var _src_components_VBtn_VBtn_sass__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("86cc");
/* harmony import */ var _src_components_VBtn_VBtn_sass__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_src_components_VBtn_VBtn_sass__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _VSheet__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("10d2");
/* harmony import */ var _VProgressCircular__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("22da");
/* harmony import */ var _mixins_groupable__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("4e82");
/* harmony import */ var _mixins_toggleable__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("f2e7");
/* harmony import */ var _mixins_elevatable__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("c995");
/* harmony import */ var _mixins_positionable__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("fe6c");
/* harmony import */ var _mixins_routable__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("1c87");
/* harmony import */ var _mixins_sizeable__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("af2b");
/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("58df");
/* harmony import */ var _util_console__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("d9bd");







// Styles
 // Extensions

 // Components

 // Mixins






 // Utilities



var baseMixins = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_16__[/* default */ "a"])(_VSheet__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"], _mixins_routable__WEBPACK_IMPORTED_MODULE_14__[/* default */ "a"], _mixins_positionable__WEBPACK_IMPORTED_MODULE_13__[/* default */ "a"], _mixins_sizeable__WEBPACK_IMPORTED_MODULE_15__[/* default */ "a"], Object(_mixins_groupable__WEBPACK_IMPORTED_MODULE_10__[/* factory */ "a"])('btnToggle'), Object(_mixins_toggleable__WEBPACK_IMPORTED_MODULE_11__[/* factory */ "b"])('inputValue')
/* @vue/component */
);
/* harmony default export */ __webpack_exports__["a"] = (baseMixins.extend().extend({
  name: 'v-btn',
  props: {
    activeClass: {
      type: String,
      default: function _default() {
        if (!this.btnToggle) return '';
        return this.btnToggle.activeClass;
      }
    },
    block: Boolean,
    depressed: Boolean,
    fab: Boolean,
    icon: Boolean,
    loading: Boolean,
    outlined: Boolean,
    plain: Boolean,
    retainFocusOnClick: Boolean,
    rounded: Boolean,
    tag: {
      type: String,
      default: 'button'
    },
    text: Boolean,
    tile: Boolean,
    type: {
      type: String,
      default: 'button'
    },
    value: null
  },
  data: function data() {
    return {
      proxyClass: 'v-btn--active'
    };
  },
  computed: {
    classes: function classes() {
      return Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])(Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])(Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])(Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])(Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])({
        'v-btn': true
      }, _mixins_routable__WEBPACK_IMPORTED_MODULE_14__[/* default */ "a"].options.computed.classes.call(this)), {}, {
        'v-btn--absolute': this.absolute,
        'v-btn--block': this.block,
        'v-btn--bottom': this.bottom,
        'v-btn--disabled': this.disabled,
        'v-btn--is-elevated': this.isElevated,
        'v-btn--fab': this.fab,
        'v-btn--fixed': this.fixed,
        'v-btn--has-bg': this.hasBg,
        'v-btn--icon': this.icon,
        'v-btn--left': this.left,
        'v-btn--loading': this.loading,
        'v-btn--outlined': this.outlined,
        'v-btn--plain': this.plain,
        'v-btn--right': this.right,
        'v-btn--round': this.isRound,
        'v-btn--rounded': this.rounded,
        'v-btn--router': this.to,
        'v-btn--text': this.text,
        'v-btn--tile': this.tile,
        'v-btn--top': this.top
      }, this.themeClasses), this.groupClasses), this.elevationClasses), this.sizeableClasses);
    },
    computedElevation: function computedElevation() {
      if (this.disabled) return undefined;
      return _mixins_elevatable__WEBPACK_IMPORTED_MODULE_12__[/* default */ "a"].options.computed.computedElevation.call(this);
    },
    computedRipple: function computedRipple() {
      var _this$ripple;

      var defaultRipple = this.icon || this.fab ? {
        circle: true
      } : true;
      if (this.disabled) return false;else return (_this$ripple = this.ripple) != null ? _this$ripple : defaultRipple;
    },
    hasBg: function hasBg() {
      return !this.text && !this.plain && !this.outlined && !this.icon;
    },
    isElevated: function isElevated() {
      return Boolean(!this.icon && !this.text && !this.outlined && !this.depressed && !this.disabled && !this.plain && (this.elevation == null || Number(this.elevation) > 0));
    },
    isRound: function isRound() {
      return Boolean(this.icon || this.fab);
    },
    styles: function styles() {
      return Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])({}, this.measurableStyles);
    }
  },
  created: function created() {
    var _this = this;

    var breakingProps = [['flat', 'text'], ['outline', 'outlined'], ['round', 'rounded']];
    /* istanbul ignore next */

    breakingProps.forEach(function (_ref) {
      var _ref2 = Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(_ref, 2),
          original = _ref2[0],
          replacement = _ref2[1];

      if (_this.$attrs.hasOwnProperty(original)) Object(_util_console__WEBPACK_IMPORTED_MODULE_17__[/* breaking */ "a"])(original, replacement, _this);
    });
  },
  methods: {
    click: function click(e) {
      // TODO: Remove this in v3
      !this.retainFocusOnClick && !this.fab && e.detail && this.$el.blur();
      this.$emit('click', e);
      this.btnToggle && this.toggle();
    },
    genContent: function genContent() {
      return this.$createElement('span', {
        staticClass: 'v-btn__content'
      }, this.$slots.default);
    },
    genLoader: function genLoader() {
      return this.$createElement('span', {
        class: 'v-btn__loader'
      }, this.$slots.loader || [this.$createElement(_VProgressCircular__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"], {
        props: {
          indeterminate: true,
          size: 23,
          width: 2
        }
      })]);
    }
  },
  render: function render(h) {
    var children = [this.genContent(), this.loading && this.genLoader()];

    var _this$generateRouteLi = this.generateRouteLink(),
        tag = _this$generateRouteLi.tag,
        data = _this$generateRouteLi.data;

    var setColor = this.hasBg ? this.setBackgroundColor : this.setTextColor;

    if (tag === 'button') {
      data.attrs.type = this.type;
      data.attrs.disabled = this.disabled;
    }

    data.attrs.value = ['string', 'number'].includes(Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(this.value)) ? this.value : JSON.stringify(this.value);
    return h(tag, this.disabled ? data : setColor(this.color, data), children);
  }
}));

/***/ }),

/***/ "83ab":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");

// Detect IE8's incomplete defineProperty implementation
module.exports = !fails(function () {
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});


/***/ }),

/***/ "83df":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M21.1608 18.0894C20.1079 19.6733 18.6622 20.9572 16.965 21.8157C15.2678 22.6742 13.377 23.078 11.4772 22.9876C9.57739 22.8972 7.73346 22.3157 6.12543 21.3C4.51741 20.2842 3.20023 18.8689 2.30248 17.1921C1.40473 15.5153 0.95708 13.6345 1.00324 11.733C1.0494 9.83162 1.58779 7.97467 2.56584 6.34344C3.5439 4.71221 4.92821 3.36245 6.58363 2.42592C8.23905 1.4894 10.109 0.998105 12.011 1.00001L12 12L21.1608 18.0894Z\" fill=\"white\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19Z\" fill=\"#D5EAFD\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M14.293 15.707L11.293 12.707C11.105 12.519 11 12.265 11 12V7H13V11.586L15.707 14.293L14.293 15.707Z\" fill=\"#079CB2\"></path><path d=\"M21.1462 18.1113C21.453 17.6521 21.3295 17.0311 20.8703 16.7242C20.4111 16.4174 19.7901 16.5409 19.4832 17.0001L21.1462 18.1113ZM4.92894 19.0711L5.63604 18.364L4.92894 19.0711ZM2.76121 8.17317L1.83733 7.79048H1.83733L2.76121 8.17317ZM19.4832 17.0001C18.4943 18.4802 17.0887 19.6337 15.4442 20.3149L16.2095 22.1627C18.2195 21.3301 19.9375 19.9202 21.1462 18.1113L19.4832 17.0001ZM15.4442 20.3149C13.7996 20.9961 11.99 21.1743 10.2442 20.8271L9.85401 22.7886C11.9878 23.2131 14.1995 22.9952 16.2095 22.1627L15.4442 20.3149ZM10.2442 20.8271C8.49836 20.4798 6.89472 19.6226 5.63604 18.364L4.22183 19.7782C5.76021 21.3166 7.72022 22.3642 9.85401 22.7886L10.2442 20.8271ZM5.63604 18.364C4.37737 17.1053 3.5202 15.5016 3.17294 13.7558L1.21137 14.146C1.6358 16.2798 2.68345 18.2398 4.22183 19.7782L5.63604 18.364ZM3.17294 13.7558C2.82567 12.01 3.0039 10.2004 3.68509 8.55585L1.83733 7.79048C1.00477 9.80047 0.786929 12.0122 1.21137 14.146L3.17294 13.7558ZM3.68509 8.55585C4.36628 6.91131 5.51983 5.50571 6.99987 4.51677L5.88873 2.85383C4.07979 4.06253 2.66989 5.7805 1.83733 7.79048L3.68509 8.55585ZM6.99987 4.51677C8.47992 3.52784 10.22 3 12 3V1C9.82441 1 7.69767 1.64514 5.88873 2.85383L6.99987 4.51677Z\" fill=\"#079CB2\"></path><circle cx=\"12\" cy=\"2\" r=\"1\" fill=\"#079CB2\"></circle><circle cx=\"17.0254\" cy=\"3.35254\" r=\"1\" fill=\"#079CB2\"></circle><circle cx=\"22\" cy=\"12\" r=\"1\" fill=\"#079CB2\"></circle><circle cx=\"20.6035\" cy=\"6.87402\" r=\"1\" fill=\"#079CB2\"></circle></svg>";

/***/ }),

/***/ "83f0":
/***/ (function(module, exports, __webpack_require__) {

var addSeconds = __webpack_require__("af1b")

/**
 * @category Second Helpers
 * @summary Subtract the specified number of seconds from the given date.
 *
 * @description
 * Subtract the specified number of seconds from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of seconds to be subtracted
 * @returns {Date} the new date with the seconds subtracted
 *
 * @example
 * // Subtract 30 seconds from 10 July 2014 12:45:00:
 * var result = subSeconds(new Date(2014, 6, 10, 12, 45, 0), 30)
 * //=> Thu Jul 10 2014 12:44:30
 */
function subSeconds (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addSeconds(dirtyDate, -amount)
}

module.exports = subSeconds


/***/ }),

/***/ "8418":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toPrimitive = __webpack_require__("c04e");
var definePropertyModule = __webpack_require__("9bf2");
var createPropertyDescriptor = __webpack_require__("5c6c");

module.exports = function (object, key, value) {
  var propertyKey = toPrimitive(key);
  if (propertyKey in object) definePropertyModule.f(object, propertyKey, createPropertyDescriptor(0, value));
  else object[propertyKey] = value;
};


/***/ }),

/***/ "841c":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fixRegExpWellKnownSymbolLogic = __webpack_require__("d784");
var anObject = __webpack_require__("825a");
var requireObjectCoercible = __webpack_require__("1d80");
var sameValue = __webpack_require__("129f");
var regExpExec = __webpack_require__("14c3");

// @@search logic
fixRegExpWellKnownSymbolLogic('search', 1, function (SEARCH, nativeSearch, maybeCallNative) {
  return [
    // `String.prototype.search` method
    // https://tc39.es/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = requireObjectCoercible(this);
      var searcher = regexp == undefined ? undefined : regexp[SEARCH];
      return searcher !== undefined ? searcher.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@search
    function (regexp) {
      var res = maybeCallNative(nativeSearch, regexp, this);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);

      var previousLastIndex = rx.lastIndex;
      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = regExpExec(rx, S);
      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});


/***/ }),

/***/ "84b9":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("c8d5")

/**
 * @category Weekday Helpers
 * @summary Get the day of the ISO week of the given date.
 *
 * @description
 * Get the day of the ISO week of the given date,
 * which is 7 for Sunday, 1 for Monday etc.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the day of ISO week
 *
 * @example
 * // Which day of the ISO week is 26 February 2012?
 * var result = getISODay(new Date(2012, 1, 26))
 * //=> 7
 */
function getISODay (dirtyDate) {
  var date = parse(dirtyDate)
  var day = date.getDay()

  if (day === 0) {
    day = 7
  }

  return day
}

module.exports = getISODay


/***/ }),

/***/ "8547":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("8bbf");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("80d2");


/* harmony default export */ __webpack_exports__["a"] = (vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend({
  name: 'comparable',
  props: {
    valueComparator: {
      type: Function,
      default: _util_helpers__WEBPACK_IMPORTED_MODULE_1__[/* deepEqual */ "j"]
    }
  }
}));

/***/ }),

/***/ "8550":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c662cfac-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/snack-bar/PpSnackBar.vue?vue&type=template&id=171d6108&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.show)?_c('div',{staticClass:"d-flex align-center justify-center snack-bar",class:((_vm.snackMessage.status) + " " + (_vm.snackMessage.status) + "--text")},[_vm._v(" "+_vm._s(_vm.snackMessage.message)+" "),_c('pp-button',{staticClass:"snack-bar__close",attrs:{"absolute":"","bottom":"","icon":"close","type":"icon"},on:{"click":function($event){_vm.show = false}}})],1):_vm._e()])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/snack-bar/PpSnackBar.vue?vue&type=template&id=171d6108&scoped=true&

// EXTERNAL MODULE: ./src/components/button/PpButton.vue + 5 modules
var PpButton = __webpack_require__("251c");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/snack-bar/PpSnackBar.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var PpSnackBarvue_type_script_lang_js_ = ({
  name: 'PpSnackBar',
  components: {
    'pp-button': PpButton["default"]
  },
  props: {
    /**
     * Should be an object with properties: message, status, duration
     */
    snackMessage: {
      type: Object,
      default: function _default() {
        return {
          message: 'Error',
          status: 'error',
          duration: 3500
        };
      }
    }
  },
  data: function data() {
    return {
      show: false
    };
  },
  watch: {
    snackMessage: {
      deep: true,
      immediate: true,
      handler: function handler() {
        var _this = this;

        this.show = true;
        setTimeout(function () {
          _this.show = false;
        }, this.snackMessage.duration);
      }
    }
  }
});
// CONCATENATED MODULE: ./src/components/snack-bar/PpSnackBar.vue?vue&type=script&lang=js&
 /* harmony default export */ var snack_bar_PpSnackBarvue_type_script_lang_js_ = (PpSnackBarvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/snack-bar/PpSnackBar.vue?vue&type=style&index=0&id=171d6108&lang=scss&scoped=true&
var PpSnackBarvue_type_style_index_0_id_171d6108_lang_scss_scoped_true_ = __webpack_require__("ec96");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/snack-bar/PpSnackBar.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  snack_bar_PpSnackBarvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "171d6108",
  null
  
)

/* harmony default export */ var PpSnackBar = __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "855b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpInfoCard_vue_vue_type_style_index_0_id_16df49b6_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("5f0c");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpInfoCard_vue_vue_type_style_index_0_id_16df49b6_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpInfoCard_vue_vue_type_style_index_0_id_16df49b6_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "857a":
/***/ (function(module, exports, __webpack_require__) {

var requireObjectCoercible = __webpack_require__("1d80");

var quot = /"/g;

// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
// https://tc39.es/ecma262/#sec-createhtml
module.exports = function (string, tag, attribute, value) {
  var S = String(requireObjectCoercible(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};


/***/ }),

/***/ "85c7":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.i, "@import url(https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css);"]);
exports.push([module.i, "@import url(https://cdn-prd.patientpop.com/pp-icon-font/v1.6.0/pp-icon-font.css);"]);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.pp-composer[data-v-3ef68c2a]{--pp-textarea-margin-top:5px;position:relative}.pp-composer--checking[data-v-3ef68c2a],.pp-composer--checking[data-v-3ef68c2a]  textarea{cursor:progress}.pp-composer__input[data-v-3ef68c2a]  textarea{max-height:224px;overflow-y:auto}.pp-composer__input[data-v-3ef68c2a]  .v-textarea{border-bottom-left-radius:0;border-top-left-radius:0}.pp-composer__send-btn[data-v-3ef68c2a]{font-size:1.25rem}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "85c9":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.i, "@import url(https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css);"]);
exports.push([module.i, "@import url(https://cdn-prd.patientpop.com/pp-icon-font/v1.6.0/pp-icon-font.css);"]);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.nav-item[data-v-14cd72c3]{--nav-icon:var(--icon);color:#e9efee;cursor:pointer;flex:1;font-size:1em;letter-spacing:-.00625em}.nav-item[data-v-14cd72c3]:not(.nav-item--active):hover{background:#195b63;border-radius:50px;--nav-icon:var(--icon--hover)}button.nav-item[data-v-14cd72c3]{display:inline-flex;flex:0;outline:none}.nav-item--active[data-v-14cd72c3]{--nav-icon:var(--icon--active);--sub-nav-dot-color:#067889;color:#fff;font-weight:700}.nav-item--active[data-v-14cd72c3]:not(.nav-item--sub){background:#417e86;border-radius:50px}.nav-item[data-v-14cd72c3]:before{content:var(--nav-icon);display:inline-block;height:var(--icon-size,20px);margin-right:.5em;overflow:hidden;width:var(--icon-size,20px)}button.nav-item[data-v-14cd72c3]:before{margin-right:0}.nav-item--large[data-v-14cd72c3]:before{--icon-size:25px}.nav-item--sub[data-v-14cd72c3]:before{--icon-size:4px;background:var(--sub-nav-dot-color,transparent);border-radius:50%;content:\"\";margin-right:1.25em}.v-size--default.nav-chip[data-v-14cd72c3]{color:var(--chip-color,#004852);font-size:.7em;height:1.25rem}.v-size--default.nav-chip--activate[data-v-14cd72c3],.v-size--default.nav-chip--free-upgrade[data-v-14cd72c3]{--chip-color:#3fa266}.v-size--default.nav-chip--trial[data-v-14cd72c3]{--chip-color:#545454}.pp-icon-alert[data-v-14cd72c3]{color:#fcde73;font-size:1.429rem}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "861d":
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),

/***/ "861d4":
/***/ (function(module, exports, __webpack_require__) {

var getISOYear = __webpack_require__("8964")
var startOfISOWeek = __webpack_require__("b4c7")

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the end of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the end of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of an ISO week-numbering year
 *
 * @example
 * // The end of an ISO week-numbering year for 2 July 2005:
 * var result = endOfISOYear(new Date(2005, 6, 2))
 * //=> Sun Jan 01 2006 23:59:59.999
 */
function endOfISOYear (dirtyDate) {
  var year = getISOYear(dirtyDate)
  var fourthOfJanuaryOfNextYear = new Date(0)
  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4)
  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0)
  var date = startOfISOWeek(fourthOfJanuaryOfNextYear)
  date.setMilliseconds(date.getMilliseconds() - 1)
  return date
}

module.exports = endOfISOYear


/***/ }),

/***/ "8654":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.flat.js
var es_array_flat = __webpack_require__("0481");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("caad");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.unscopables.flat.js
var es_array_unscopables_flat = __webpack_require__("4069");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__("a9e3");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.assign.js
var es_object_assign = __webpack_require__("cca6");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.is.js
var es_object_is = __webpack_require__("2b19");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("d3b7");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("25f0");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__("2909");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__("5530");

// EXTERNAL MODULE: ./node_modules/vuetify/src/components/VTextField/VTextField.sass
var VTextField = __webpack_require__("4ff9");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/components/VInput/index.js + 3 modules
var VInput = __webpack_require__("c37a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("99af");

// EXTERNAL MODULE: ./node_modules/vuetify/src/components/VCounter/VCounter.sass
var VCounter = __webpack_require__("e9b1");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/mixins/themeable/index.js
var themeable = __webpack_require__("7560");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/util/mixins.js
var mixins = __webpack_require__("58df");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VCounter/VCounter.js



// Styles
 // Mixins



/* @vue/component */

/* harmony default export */ var VCounter_VCounter = (Object(mixins["a" /* default */])(themeable["a" /* default */]).extend({
  name: 'v-counter',
  functional: true,
  props: {
    value: {
      type: [Number, String],
      default: ''
    },
    max: [Number, String]
  },
  render: function render(h, ctx) {
    var props = ctx.props;
    var max = parseInt(props.max, 10);
    var value = parseInt(props.value, 10);
    var content = max ? "".concat(value, " / ").concat(max) : String(props.value);
    var isGreater = max && value > max;
    return h('div', {
      staticClass: 'v-counter',
      class: Object(objectSpread2["a" /* default */])({
        'error--text': isGreater
      }, Object(themeable["b" /* functionalThemeClasses */])(ctx))
    }, content);
  }
}));
// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VCounter/index.js


/* harmony default export */ var components_VCounter = (VCounter_VCounter);
// EXTERNAL MODULE: ./node_modules/vuetify/lib/components/VLabel/index.js + 1 modules
var VLabel = __webpack_require__("ba87");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/mixins/intersectable/index.js
var intersectable = __webpack_require__("de2c");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/mixins/loadable/index.js
var loadable = __webpack_require__("297c");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/mixins/validatable/index.js
var validatable = __webpack_require__("38cb");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/directives/resize/index.js
var resize = __webpack_require__("dc22");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/directives/ripple/index.js
var ripple = __webpack_require__("5607");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/util/helpers.js
var helpers = __webpack_require__("80d2");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/util/console.js + 32 modules
var console = __webpack_require__("d9bd");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VTextField/VTextField.js










// Styles
 // Extensions

 // Components


 // Mixins



 // Directives


 // Utilities


 // Types


var baseMixins = Object(mixins["a" /* default */])(VInput["a" /* default */], Object(intersectable["a" /* default */])({
  onVisible: ['onResize', 'tryAutofocus']
}), loadable["a" /* default */]);
var dirtyTypes = ['color', 'file', 'time', 'date', 'datetime-local', 'week', 'month'];
/* @vue/component */

/* harmony default export */ var VTextField_VTextField = __webpack_exports__["a"] = (baseMixins.extend().extend({
  name: 'v-text-field',
  directives: {
    resize: resize["a" /* default */],
    ripple: ripple["a" /* default */]
  },
  inheritAttrs: false,
  props: {
    appendOuterIcon: String,
    autofocus: Boolean,
    clearable: Boolean,
    clearIcon: {
      type: String,
      default: '$clear'
    },
    counter: [Boolean, Number, String],
    counterValue: Function,
    filled: Boolean,
    flat: Boolean,
    fullWidth: Boolean,
    label: String,
    outlined: Boolean,
    placeholder: String,
    prefix: String,
    prependInnerIcon: String,
    reverse: Boolean,
    rounded: Boolean,
    shaped: Boolean,
    singleLine: Boolean,
    solo: Boolean,
    soloInverted: Boolean,
    suffix: String,
    type: {
      type: String,
      default: 'text'
    }
  },
  data: function data() {
    return {
      badInput: false,
      labelWidth: 0,
      prefixWidth: 0,
      prependWidth: 0,
      initialValue: null,
      isBooted: false,
      isClearing: false
    };
  },
  computed: {
    classes: function classes() {
      return Object(objectSpread2["a" /* default */])(Object(objectSpread2["a" /* default */])({}, VInput["a" /* default */].options.computed.classes.call(this)), {}, {
        'v-text-field': true,
        'v-text-field--full-width': this.fullWidth,
        'v-text-field--prefix': this.prefix,
        'v-text-field--single-line': this.isSingle,
        'v-text-field--solo': this.isSolo,
        'v-text-field--solo-inverted': this.soloInverted,
        'v-text-field--solo-flat': this.flat,
        'v-text-field--filled': this.filled,
        'v-text-field--is-booted': this.isBooted,
        'v-text-field--enclosed': this.isEnclosed,
        'v-text-field--reverse': this.reverse,
        'v-text-field--outlined': this.outlined,
        'v-text-field--placeholder': this.placeholder,
        'v-text-field--rounded': this.rounded,
        'v-text-field--shaped': this.shaped
      });
    },
    computedColor: function computedColor() {
      var computedColor = validatable["a" /* default */].options.computed.computedColor.call(this);
      if (!this.soloInverted || !this.isFocused) return computedColor;
      return this.color || 'primary';
    },
    computedCounterValue: function computedCounterValue() {
      if (typeof this.counterValue === 'function') {
        return this.counterValue(this.internalValue);
      }

      return Object(toConsumableArray["a" /* default */])((this.internalValue || '').toString()).length;
    },
    hasCounter: function hasCounter() {
      return this.counter !== false && this.counter != null;
    },
    hasDetails: function hasDetails() {
      return VInput["a" /* default */].options.computed.hasDetails.call(this) || this.hasCounter;
    },
    internalValue: {
      get: function get() {
        return this.lazyValue;
      },
      set: function set(val) {
        this.lazyValue = val;
        this.$emit('input', this.lazyValue);
      }
    },
    isDirty: function isDirty() {
      var _this$lazyValue;

      return ((_this$lazyValue = this.lazyValue) == null ? void 0 : _this$lazyValue.toString().length) > 0 || this.badInput;
    },
    isEnclosed: function isEnclosed() {
      return this.filled || this.isSolo || this.outlined;
    },
    isLabelActive: function isLabelActive() {
      return this.isDirty || dirtyTypes.includes(this.type);
    },
    isSingle: function isSingle() {
      return this.isSolo || this.singleLine || this.fullWidth || // https://material.io/components/text-fields/#filled-text-field
      this.filled && !this.hasLabel;
    },
    isSolo: function isSolo() {
      return this.solo || this.soloInverted;
    },
    labelPosition: function labelPosition() {
      var offset = this.prefix && !this.labelValue ? this.prefixWidth : 0;
      if (this.labelValue && this.prependWidth) offset -= this.prependWidth;
      return this.$vuetify.rtl === this.reverse ? {
        left: offset,
        right: 'auto'
      } : {
        left: 'auto',
        right: offset
      };
    },
    showLabel: function showLabel() {
      return this.hasLabel && !(this.isSingle && this.labelValue);
    },
    labelValue: function labelValue() {
      return this.isFocused || this.isLabelActive;
    }
  },
  watch: {
    // labelValue: 'setLabelWidth', // moved to mounted, see #11533
    outlined: 'setLabelWidth',
    label: function label() {
      this.$nextTick(this.setLabelWidth);
    },
    prefix: function prefix() {
      this.$nextTick(this.setPrefixWidth);
    },
    isFocused: 'updateValue',
    value: function value(val) {
      this.lazyValue = val;
    }
  },
  created: function created() {
    /* istanbul ignore next */
    if (this.$attrs.hasOwnProperty('box')) {
      Object(console["a" /* breaking */])('box', 'filled', this);
    }
    /* istanbul ignore next */


    if (this.$attrs.hasOwnProperty('browser-autocomplete')) {
      Object(console["a" /* breaking */])('browser-autocomplete', 'autocomplete', this);
    }
    /* istanbul ignore if */


    if (this.shaped && !(this.filled || this.outlined || this.isSolo)) {
      Object(console["c" /* consoleWarn */])('shaped should be used with either filled or outlined', this);
    }
  },
  mounted: function mounted() {
    var _this = this;

    // #11533
    this.$watch(function () {
      return _this.labelValue;
    }, this.setLabelWidth);
    this.autofocus && this.tryAutofocus();
    requestAnimationFrame(function () {
      return _this.isBooted = true;
    });
  },
  methods: {
    /** @public */
    focus: function focus() {
      this.onFocus();
    },

    /** @public */
    blur: function blur(e) {
      var _this2 = this;

      // https://github.com/vuetifyjs/vuetify/issues/5913
      // Safari tab order gets broken if called synchronous
      window.requestAnimationFrame(function () {
        _this2.$refs.input && _this2.$refs.input.blur();
      });
    },
    clearableCallback: function clearableCallback() {
      var _this3 = this;

      this.$refs.input && this.$refs.input.focus();
      this.$nextTick(function () {
        return _this3.internalValue = null;
      });
    },
    genAppendSlot: function genAppendSlot() {
      var slot = [];

      if (this.$slots['append-outer']) {
        slot.push(this.$slots['append-outer']);
      } else if (this.appendOuterIcon) {
        slot.push(this.genIcon('appendOuter'));
      }

      return this.genSlot('append', 'outer', slot);
    },
    genPrependInnerSlot: function genPrependInnerSlot() {
      var slot = [];

      if (this.$slots['prepend-inner']) {
        slot.push(this.$slots['prepend-inner']);
      } else if (this.prependInnerIcon) {
        slot.push(this.genIcon('prependInner'));
      }

      return this.genSlot('prepend', 'inner', slot);
    },
    genIconSlot: function genIconSlot() {
      var slot = [];

      if (this.$slots.append) {
        slot.push(this.$slots.append);
      } else if (this.appendIcon) {
        slot.push(this.genIcon('append'));
      }

      return this.genSlot('append', 'inner', slot);
    },
    genInputSlot: function genInputSlot() {
      var input = VInput["a" /* default */].options.methods.genInputSlot.call(this);
      var prepend = this.genPrependInnerSlot();

      if (prepend) {
        input.children = input.children || [];
        input.children.unshift(prepend);
      }

      return input;
    },
    genClearIcon: function genClearIcon() {
      if (!this.clearable) return null;
      var data = this.isDirty ? undefined : {
        attrs: {
          disabled: true
        }
      };
      return this.genSlot('append', 'inner', [this.genIcon('clear', this.clearableCallback, data)]);
    },
    genCounter: function genCounter() {
      var _ref;

      if (!this.hasCounter) return null;
      var max = this.counter === true ? this.attrs$.maxlength : this.counter;
      var props = {
        dark: this.dark,
        light: this.light,
        max: max,
        value: this.computedCounterValue
      };
      return (_ref = this.$scopedSlots.counter == null ? void 0 : this.$scopedSlots.counter({
        props: props
      })) != null ? _ref : this.$createElement(components_VCounter, {
        props: props
      });
    },
    genControl: function genControl() {
      return VInput["a" /* default */].options.methods.genControl.call(this);
    },
    genDefaultSlot: function genDefaultSlot() {
      return [this.genFieldset(), this.genTextFieldSlot(), this.genClearIcon(), this.genIconSlot(), this.genProgress()];
    },
    genFieldset: function genFieldset() {
      if (!this.outlined) return null;
      return this.$createElement('fieldset', {
        attrs: {
          'aria-hidden': true
        }
      }, [this.genLegend()]);
    },
    genLabel: function genLabel() {
      if (!this.showLabel) return null;
      var data = {
        props: {
          absolute: true,
          color: this.validationState,
          dark: this.dark,
          disabled: this.isDisabled,
          focused: !this.isSingle && (this.isFocused || !!this.validationState),
          for: this.computedId,
          left: this.labelPosition.left,
          light: this.light,
          right: this.labelPosition.right,
          value: this.labelValue
        }
      };
      return this.$createElement(VLabel["a" /* default */], data, this.$slots.label || this.label);
    },
    genLegend: function genLegend() {
      var width = !this.singleLine && (this.labelValue || this.isDirty) ? this.labelWidth : 0;
      var span = this.$createElement('span', {
        domProps: {
          innerHTML: '&#8203;'
        }
      });
      return this.$createElement('legend', {
        style: {
          width: !this.isSingle ? Object(helpers["g" /* convertToUnit */])(width) : undefined
        }
      }, [span]);
    },
    genInput: function genInput() {
      var listeners = Object.assign({}, this.listeners$);
      delete listeners.change; // Change should not be bound externally

      return this.$createElement('input', {
        style: {},
        domProps: {
          value: this.type === 'number' && Object.is(this.lazyValue, -0) ? '-0' : this.lazyValue
        },
        attrs: Object(objectSpread2["a" /* default */])(Object(objectSpread2["a" /* default */])({}, this.attrs$), {}, {
          autofocus: this.autofocus,
          disabled: this.isDisabled,
          id: this.computedId,
          placeholder: this.isFocused || !this.hasLabel ? this.placeholder : undefined,
          readonly: this.isReadonly,
          type: this.type
        }),
        on: Object.assign(listeners, {
          blur: this.onBlur,
          input: this.onInput,
          focus: this.onFocus,
          keydown: this.onKeyDown
        }),
        ref: 'input',
        directives: [{
          name: 'resize',
          modifiers: {
            quiet: true
          },
          value: this.onResize
        }]
      });
    },
    genMessages: function genMessages() {
      if (!this.showDetails) return null;
      var messagesNode = VInput["a" /* default */].options.methods.genMessages.call(this);
      var counterNode = this.genCounter();
      return this.$createElement('div', {
        staticClass: 'v-text-field__details'
      }, [messagesNode, counterNode]);
    },
    genTextFieldSlot: function genTextFieldSlot() {
      return this.$createElement('div', {
        staticClass: 'v-text-field__slot'
      }, [this.genLabel(), this.prefix ? this.genAffix('prefix') : null, this.genInput(), this.suffix ? this.genAffix('suffix') : null]);
    },
    genAffix: function genAffix(type) {
      return this.$createElement('div', {
        class: "v-text-field__".concat(type),
        ref: type
      }, this[type]);
    },
    onBlur: function onBlur(e) {
      var _this4 = this;

      this.isFocused = false;
      e && this.$nextTick(function () {
        return _this4.$emit('blur', e);
      });
    },
    onClick: function onClick() {
      if (this.isFocused || this.isDisabled || !this.$refs.input) return;
      this.$refs.input.focus();
    },
    onFocus: function onFocus(e) {
      if (!this.$refs.input) return;

      if (document.activeElement !== this.$refs.input) {
        return this.$refs.input.focus();
      }

      if (!this.isFocused) {
        this.isFocused = true;
        e && this.$emit('focus', e);
      }
    },
    onInput: function onInput(e) {
      var target = e.target;
      this.internalValue = target.value;
      this.badInput = target.validity && target.validity.badInput;
    },
    onKeyDown: function onKeyDown(e) {
      if (e.keyCode === helpers["x" /* keyCodes */].enter) this.$emit('change', this.internalValue);
      this.$emit('keydown', e);
    },
    onMouseDown: function onMouseDown(e) {
      // Prevent input from being blurred
      if (e.target !== this.$refs.input) {
        e.preventDefault();
        e.stopPropagation();
      }

      VInput["a" /* default */].options.methods.onMouseDown.call(this, e);
    },
    onMouseUp: function onMouseUp(e) {
      if (this.hasMouseDown) this.focus();
      VInput["a" /* default */].options.methods.onMouseUp.call(this, e);
    },
    setLabelWidth: function setLabelWidth() {
      if (!this.outlined) return;
      this.labelWidth = this.$refs.label ? Math.min(this.$refs.label.scrollWidth * 0.75 + 6, this.$el.offsetWidth - 24) : 0;
    },
    setPrefixWidth: function setPrefixWidth() {
      if (!this.$refs.prefix) return;
      this.prefixWidth = this.$refs.prefix.offsetWidth;
    },
    setPrependWidth: function setPrependWidth() {
      if (!this.outlined || !this.$refs['prepend-inner']) return;
      this.prependWidth = this.$refs['prepend-inner'].offsetWidth;
    },
    tryAutofocus: function tryAutofocus() {
      if (!this.autofocus || typeof document === 'undefined' || !this.$refs.input || document.activeElement === this.$refs.input) return false;
      this.$refs.input.focus();
      return true;
    },
    updateValue: function updateValue(val) {
      // Sets validationState from validatable
      this.hasColor = val;

      if (val) {
        this.initialValue = this.lazyValue;
      } else if (this.initialValue !== this.lazyValue) {
        this.$emit('change', this.lazyValue);
      }
    },
    onResize: function onResize() {
      this.setLabelWidth();
      this.setPrefixWidth();
      this.setPrependWidth();
    }
  }
}));

/***/ }),

/***/ "86cc":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("ec07");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("234eb56d", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "87c0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c662cfac-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/page-container/PpPageContainer.vue?vue&type=template&id=3662bbc0&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pp-container',{staticClass:"py-0 pp-page-container",class:{'pp-page-container--with-footer': !_vm.hideFooter && !_vm.isLoading},attrs:{"fluid":true,"tag":_vm.tag},on:{"submit":function($event){$event.preventDefault();return _vm.clickFooterButton($event)}}},[_vm._t("topContent"),_c('pp-page-container-header',{staticClass:"mb-5 mx-n3 page-header",attrs:{"heading-tag":_vm.headerHeadingTag,"show-back-arrow":_vm.showBackArrow,"back-action-default":_vm.backActionDefault,"sub-page":_vm.subPage,"sub-title":_vm.subTitle,"title":_vm.title},on:{"back":_vm.goBack},scopedSlots:_vm._u([{key:"topNav",fn:function(){return [(!_vm.isLoading)?_vm._t("topNav"):_vm._e()]},proxy:true},{key:"headerActions",fn:function(){return [(!_vm.isLoading)?_vm._t("headerActions"):_vm._e()]},proxy:true}],null,true)}),_c('main',[(_vm.isLoading)?_c('pp-loading-icon',{staticClass:"page-container-loading"}):_vm._t("content")],2),(!_vm.hideFooter && !_vm.isLoading)?_c('footer',{staticClass:"mx-n3 px-3 pt-4 mt-4 pb-2 d-flex align-center",class:!_vm.$slots.footer ? 'justify-end' : ''},[_vm._t("footer",[(_vm.footerText)?_c('div',{staticClass:"mr-4 text-h6 grey--text text--darken-1 d-none d-sm-flex"},[_vm._v(" "+_vm._s(_vm.footerText)+" ")]):_vm._e(),(_vm.showSecondaryFooterButton)?_c('pp-button',{staticClass:"mr-4",attrs:{"disabled":_vm.disableSecondaryFooterButton,"text":_vm.secondaryFooterButtonText,"type":"secondary"},on:{"click":_vm.clickSecondaryFooterButton}}):_vm._e(),(_vm.tag==='form')?_c('pp-button',{attrs:{"disabled":_vm.disableFooterButton,"loading":_vm.loadingFooterButton,"prepend-icon":_vm.footerButtonPrependIcon,"submit":true,"text":_vm.footerButtonText,"type":"primary"}}):_c('pp-button',{attrs:{"disabled":_vm.disableFooterButton,"loading":_vm.loadingFooterButton,"prepend-icon":_vm.footerButtonPrependIcon,"text":_vm.footerButtonText,"type":"primary"},on:{"click":_vm.clickFooterButton}})])],2):_vm._e()],2)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/page-container/PpPageContainer.vue?vue&type=template&id=3662bbc0&scoped=true&

// EXTERNAL MODULE: ./src/components/container/PpContainer.vue + 4 modules
var PpContainer = __webpack_require__("3d51");

// EXTERNAL MODULE: ./src/components/button/PpButton.vue + 5 modules
var PpButton = __webpack_require__("251c");

// EXTERNAL MODULE: ./src/components/loading-icon/PpLoadingIcon.vue + 4 modules
var PpLoadingIcon = __webpack_require__("efbd");

// EXTERNAL MODULE: ./src/components/page-container-header/PpPageContainerHeader.vue + 4 modules
var PpPageContainerHeader = __webpack_require__("8b36");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/page-container/PpPageContainer.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/**
 * Page Container with sticky header and footer, allowing for a sticky top bar at top (eg used in practice settings)
 */

/* harmony default export */ var PpPageContainervue_type_script_lang_js_ = ({
  name: 'PpPageContainer',
  components: {
    'pp-button': PpButton["default"],
    'pp-container': PpContainer["default"],
    'pp-page-container-header': PpPageContainerHeader["default"],
    'pp-loading-icon': PpLoadingIcon["default"]
  },
  props: {
    title: {
      type: String,
      required: true
    },
    subTitle: {
      type: String,
      default: null
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    showBackArrow: {
      type: Boolean,
      default: false
    },
    backActionDefault: {
      type: Boolean,
      default: true
    },

    /**
     * If it's not a sub-page then hide the main title and back arrow on mobile
     */
    subPage: {
      type: Boolean,
      default: false
    },
    hideFooter: {
      type: Boolean,
      default: false
    },
    footerButtonText: {
      type: String,
      default: 'Save'
    },

    /**
     * Default the footer CTA to use check icon
     */
    footerButtonPrependIcon: {
      type: String,
      default: 'check'
    },
    disableFooterButton: {
      type: Boolean,
      default: false
    },
    disableSecondaryFooterButton: {
      type: Boolean,
      default: false
    },
    showSecondaryFooterButton: {
      type: Boolean,
      default: false
    },
    secondaryFooterButtonText: {
      type: String,
      default: 'Cancel'
    },

    /**
     * Default action for the secondary footer button is to go back, add ability to overwrite if needed
     */
    secondaryFooterButtonActionDefault: {
      type: Boolean,
      default: true
    },
    loadingFooterButton: {
      type: Boolean,
      default: false
    },
    footerText: {
      type: String,
      default: null
    },
    headerHeadingTag: {
      type: String,
      default: 'h1'
    },
    tag: {
      type: String,
      default: 'div'
    }
  },
  methods: {
    clickFooterButton: function clickFooterButton() {
      this.$emit('footer-button-click');
    },
    clickSecondaryFooterButton: function clickSecondaryFooterButton() {
      this.$emit('secondary-footer-button-click'); // default go back one on route

      if (this.secondaryFooterButtonActionDefault) {
        this.$router.go(-1);
      }
    },
    goBack: function goBack() {
      this.$emit('back');
    }
  }
});
// CONCATENATED MODULE: ./src/components/page-container/PpPageContainer.vue?vue&type=script&lang=js&
 /* harmony default export */ var page_container_PpPageContainervue_type_script_lang_js_ = (PpPageContainervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/page-container/PpPageContainer.vue?vue&type=style&index=0&id=3662bbc0&lang=scss&scoped=true&
var PpPageContainervue_type_style_index_0_id_3662bbc0_lang_scss_scoped_true_ = __webpack_require__("ed6b");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/page-container/PpPageContainer.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  page_container_PpPageContainervue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "3662bbc0",
  null
  
)

/* harmony default export */ var PpPageContainer = __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "8860":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var core_js_modules_es_array_find_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("c740");
/* harmony import */ var core_js_modules_es_array_find_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_flat_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("0481");
/* harmony import */ var core_js_modules_es_array_flat_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_flat_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_splice_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("a434");
/* harmony import */ var core_js_modules_es_array_splice_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_splice_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_unscopables_flat_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("4069");
/* harmony import */ var core_js_modules_es_array_unscopables_flat_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_unscopables_flat_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_createForOfIteratorHelper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("b85c");
/* harmony import */ var _home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("5530");
/* harmony import */ var _src_components_VList_VList_sass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("3ad0");
/* harmony import */ var _src_components_VList_VList_sass__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_src_components_VList_VList_sass__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _VSheet_VSheet__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("8dd9");






// Styles
 // Components


/* @vue/component */

/* harmony default export */ __webpack_exports__["a"] = (_VSheet_VSheet__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"].extend().extend({
  name: 'v-list',
  provide: function provide() {
    return {
      isInList: true,
      list: this
    };
  },
  inject: {
    isInMenu: {
      default: false
    },
    isInNav: {
      default: false
    }
  },
  props: {
    dense: Boolean,
    disabled: Boolean,
    expand: Boolean,
    flat: Boolean,
    nav: Boolean,
    rounded: Boolean,
    subheader: Boolean,
    threeLine: Boolean,
    twoLine: Boolean
  },
  data: function data() {
    return {
      groups: []
    };
  },
  computed: {
    classes: function classes() {
      return Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])({}, _VSheet_VSheet__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"].options.computed.classes.call(this)), {}, {
        'v-list--dense': this.dense,
        'v-list--disabled': this.disabled,
        'v-list--flat': this.flat,
        'v-list--nav': this.nav,
        'v-list--rounded': this.rounded,
        'v-list--subheader': this.subheader,
        'v-list--two-line': this.twoLine,
        'v-list--three-line': this.threeLine
      });
    }
  },
  methods: {
    register: function register(content) {
      this.groups.push(content);
    },
    unregister: function unregister(content) {
      var index = this.groups.findIndex(function (g) {
        return g._uid === content._uid;
      });
      if (index > -1) this.groups.splice(index, 1);
    },
    listClick: function listClick(uid) {
      if (this.expand) return;

      var _iterator = Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_createForOfIteratorHelper__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(this.groups),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var group = _step.value;
          group.toggle(uid);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  },
  render: function render(h) {
    var data = {
      staticClass: 'v-list',
      class: this.classes,
      style: this.styles,
      attrs: Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])({
        role: this.isInNav || this.isInMenu ? undefined : 'list'
      }, this.attrs$)
    };
    return h(this.tag, this.setBackgroundColor(this.color, data), [this.$slots.default]);
  }
}));

/***/ }),

/***/ "8875":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// addapted from the document.currentScript polyfill by Adam Miller
// MIT license
// source: https://github.com/amiller-gh/currentScript-polyfill

// added support for Firefox https://bugzilla.mozilla.org/show_bug.cgi?id=1620505

(function (root, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}
}(typeof self !== 'undefined' ? self : this, function () {
  function getCurrentScript () {
    var descriptor = Object.getOwnPropertyDescriptor(document, 'currentScript')
    // for chrome
    if (!descriptor && 'currentScript' in document && document.currentScript) {
      return document.currentScript
    }

    // for other browsers with native support for currentScript
    if (descriptor && descriptor.get !== getCurrentScript && document.currentScript) {
      return document.currentScript
    }
  
    // IE 8-10 support script readyState
    // IE 11+ & Firefox support stack trace
    try {
      throw new Error();
    }
    catch (err) {
      // Find the second match for the "at" string to get file src url from stack.
      var ieStackRegExp = /.*at [^(]*\((.*):(.+):(.+)\)$/ig,
        ffStackRegExp = /@([^@]*):(\d+):(\d+)\s*$/ig,
        stackDetails = ieStackRegExp.exec(err.stack) || ffStackRegExp.exec(err.stack),
        scriptLocation = (stackDetails && stackDetails[1]) || false,
        line = (stackDetails && stackDetails[2]) || false,
        currentLocation = document.location.href.replace(document.location.hash, ''),
        pageSource,
        inlineScriptSourceRegExp,
        inlineScriptSource,
        scripts = document.getElementsByTagName('script'); // Live NodeList collection
  
      if (scriptLocation === currentLocation) {
        pageSource = document.documentElement.outerHTML;
        inlineScriptSourceRegExp = new RegExp('(?:[^\\n]+?\\n){0,' + (line - 2) + '}[^<]*<script>([\\d\\D]*?)<\\/script>[\\d\\D]*', 'i');
        inlineScriptSource = pageSource.replace(inlineScriptSourceRegExp, '$1').trim();
      }
  
      for (var i = 0; i < scripts.length; i++) {
        // If ready state is interactive, return the script tag
        if (scripts[i].readyState === 'interactive') {
          return scripts[i];
        }
  
        // If src matches, return the script tag
        if (scripts[i].src === scriptLocation) {
          return scripts[i];
        }
  
        // If inline source matches, return the script tag
        if (
          scriptLocation === currentLocation &&
          scripts[i].innerHTML &&
          scripts[i].innerHTML.trim() === inlineScriptSource
        ) {
          return scripts[i];
        }
      }
  
      // If no match, return null
      return null;
    }
  };

  return getCurrentScript
}));


/***/ }),

/***/ "8885":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("b532");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("d97c5b60", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "8902":
/***/ (function(module, exports, __webpack_require__) {

var addYears = __webpack_require__("fcb3")

/**
 * @category Year Helpers
 * @summary Subtract the specified number of years from the given date.
 *
 * @description
 * Subtract the specified number of years from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of years to be subtracted
 * @returns {Date} the new date with the years subtracted
 *
 * @example
 * // Subtract 5 years from 1 September 2014:
 * var result = subYears(new Date(2014, 8, 1), 5)
 * //=> Tue Sep 01 2009 00:00:00
 */
function subYears (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addYears(dirtyDate, -amount)
}

module.exports = subYears


/***/ }),

/***/ "8925":
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__("c6cd");

var functionToString = Function.toString;

// this helper broken in `3.4.1-3.4.4`, so we can't use `shared` helper
if (typeof store.inspectSource != 'function') {
  store.inspectSource = function (it) {
    return functionToString.call(it);
  };
}

module.exports = store.inspectSource;


/***/ }),

/***/ "892e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpShortcutMenu_vue_vue_type_style_index_0_id_3e08c342_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("0968");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpShortcutMenu_vue_vue_type_style_index_0_id_3e08c342_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpShortcutMenu_vue_vue_type_style_index_0_id_3e08c342_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "8946":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("c8d5")

/**
 * @category Day Helpers
 * @summary Add the specified number of days to the given date.
 *
 * @description
 * Add the specified number of days to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be added
 * @returns {Date} the new date with the days added
 *
 * @example
 * // Add 10 days to 1 September 2014:
 * var result = addDays(new Date(2014, 8, 1), 10)
 * //=> Thu Sep 11 2014 00:00:00
 */
function addDays (dirtyDate, dirtyAmount) {
  var date = parse(dirtyDate)
  var amount = Number(dirtyAmount)
  date.setDate(date.getDate() + amount)
  return date
}

module.exports = addDays


/***/ }),

/***/ "8964":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("c8d5")
var startOfISOWeek = __webpack_require__("b4c7")

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the ISO week-numbering year of the given date.
 *
 * @description
 * Get the ISO week-numbering year of the given date,
 * which always starts 3 days before the year's first Thursday.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the ISO week-numbering year
 *
 * @example
 * // Which ISO-week numbering year is 2 January 2005?
 * var result = getISOYear(new Date(2005, 0, 2))
 * //=> 2004
 */
function getISOYear (dirtyDate) {
  var date = parse(dirtyDate)
  var year = date.getFullYear()

  var fourthOfJanuaryOfNextYear = new Date(0)
  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4)
  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0)
  var startOfNextYear = startOfISOWeek(fourthOfJanuaryOfNextYear)

  var fourthOfJanuaryOfThisYear = new Date(0)
  fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4)
  fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0)
  var startOfThisYear = startOfISOWeek(fourthOfJanuaryOfThisYear)

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year
  } else {
    return year - 1
  }
}

module.exports = getISOYear


/***/ }),

/***/ "899c":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("d880");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("6e0051b7", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "89c8":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.theme--light.v-input,.theme--light.v-input input,.theme--light.v-input textarea{color:var(--pp-text-primary,#2b2b2b)}.theme--light.v-input input::-moz-placeholder,.theme--light.v-input textarea::-moz-placeholder{color:var(--pp-text-disabled,#f6f6f6)}.theme--light.v-input input:-ms-input-placeholder,.theme--light.v-input textarea:-ms-input-placeholder{color:var(--pp-text-disabled,#f6f6f6)}.theme--light.v-input input::placeholder,.theme--light.v-input textarea::placeholder{color:var(--pp-text-disabled,#f6f6f6)}.theme--light.v-input--is-disabled,.theme--light.v-input--is-disabled input,.theme--light.v-input--is-disabled textarea{color:var(--pp-text-disabled,#f6f6f6)}.theme--dark.v-input,.theme--dark.v-input input,.theme--dark.v-input textarea{color:var(--pp-primary-button-text-color,#004852)}.theme--dark.v-input input::-moz-placeholder,.theme--dark.v-input textarea::-moz-placeholder{color:hsla(0,0%,100%,.5)}.theme--dark.v-input input:-ms-input-placeholder,.theme--dark.v-input textarea:-ms-input-placeholder{color:hsla(0,0%,100%,.5)}.theme--dark.v-input input::placeholder,.theme--dark.v-input textarea::placeholder{color:hsla(0,0%,100%,.5)}.theme--dark.v-input--is-disabled,.theme--dark.v-input--is-disabled input,.theme--dark.v-input--is-disabled textarea{color:hsla(0,0%,100%,.5)}.v-input{align-items:flex-start;display:flex;flex:1 1 auto;font-size:14px;letter-spacing:normal;max-width:100%;text-align:left}.v-input .v-progress-linear{top:calc(100% - 1px);left:0}.v-input input{max-height:32px}.v-input input:invalid,.v-input textarea:invalid{box-shadow:none}.v-input input:active,.v-input input:focus,.v-input textarea:active,.v-input textarea:focus{outline:none}.v-input .v-label{height:20px;line-height:20px;letter-spacing:normal}.v-input__append-outer,.v-input__prepend-outer{display:inline-flex;margin-bottom:4px;margin-top:4px;line-height:1}.v-input__append-outer .v-icon,.v-input__prepend-outer .v-icon{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.v-application--is-ltr .v-input__append-outer{margin-left:9px}.v-application--is-ltr .v-input__prepend-outer,.v-application--is-rtl .v-input__append-outer{margin-right:9px}.v-application--is-rtl .v-input__prepend-outer{margin-left:9px}.v-input__control{display:flex;flex-direction:column;height:auto;flex-grow:1;flex-wrap:wrap;min-width:0;width:100%}.v-input__icon{align-items:center;display:inline-flex;height:24px;flex:1 0 auto;justify-content:center;min-width:24px;width:24px}.v-input__icon--clear{border-radius:50%}.v-input__icon--clear .v-icon--disabled{visibility:hidden}.v-input__slot{align-items:center;color:inherit;display:flex;margin-bottom:8px;min-height:inherit;position:relative;transition:.3s cubic-bezier(.25,.8,.5,1);width:100%}.v-input--dense>.v-input__control>.v-input__slot{margin-bottom:4px}.v-input--is-disabled:not(.v-input--is-readonly){pointer-events:none}.v-input--is-loading>.v-input__control>.v-input__slot:after,.v-input--is-loading>.v-input__control>.v-input__slot:before{display:none}.v-input--hide-details>.v-input__control>.v-input__slot{margin-bottom:0}.v-input--has-state.error--text .v-label{-webkit-animation:v-shake .6s cubic-bezier(.25,.8,.5,1);animation:v-shake .6s cubic-bezier(.25,.8,.5,1)}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "8a01":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpApp_vue_vue_type_style_index_2_id_7ccadf14_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("301d");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpApp_vue_vue_type_style_index_2_id_7ccadf14_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpApp_vue_vue_type_style_index_2_id_7ccadf14_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "8a79":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var getOwnPropertyDescriptor = __webpack_require__("06cf").f;
var toLength = __webpack_require__("50c4");
var notARegExp = __webpack_require__("5a34");
var requireObjectCoercible = __webpack_require__("1d80");
var correctIsRegExpLogic = __webpack_require__("ab13");
var IS_PURE = __webpack_require__("c430");

var nativeEndsWith = ''.endsWith;
var min = Math.min;

var CORRECT_IS_REGEXP_LOGIC = correctIsRegExpLogic('endsWith');
// https://github.com/zloirock/core-js/pull/702
var MDN_POLYFILL_BUG = !IS_PURE && !CORRECT_IS_REGEXP_LOGIC && !!function () {
  var descriptor = getOwnPropertyDescriptor(String.prototype, 'endsWith');
  return descriptor && !descriptor.writable;
}();

// `String.prototype.endsWith` method
// https://tc39.es/ecma262/#sec-string.prototype.endswith
$({ target: 'String', proto: true, forced: !MDN_POLYFILL_BUG && !CORRECT_IS_REGEXP_LOGIC }, {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = String(requireObjectCoercible(this));
    notARegExp(searchString);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : min(toLength(endPosition), len);
    var search = String(searchString);
    return nativeEndsWith
      ? nativeEndsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});


/***/ }),

/***/ "8aa5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var charAt = __webpack_require__("6547").charAt;

// `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? charAt(S, index).length : 1);
};


/***/ }),

/***/ "8adc":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("7f7e");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("ebbe09d2", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "8aed":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("c8d5")

/**
 * @category Minute Helpers
 * @summary Set the minutes to the given date.
 *
 * @description
 * Set the minutes to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} minutes - the minutes of the new date
 * @returns {Date} the new date with the minutes setted
 *
 * @example
 * // Set 45 minutes to 1 September 2014 11:30:40:
 * var result = setMinutes(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:45:40
 */
function setMinutes (dirtyDate, dirtyMinutes) {
  var date = parse(dirtyDate)
  var minutes = Number(dirtyMinutes)
  date.setMinutes(minutes)
  return date
}

module.exports = setMinutes


/***/ }),

/***/ "8b36":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c662cfac-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/page-container-header/PpPageContainerHeader.vue?vue&type=template&id=7db3db16&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"px-3 py-0 py-sm-2 d-flex align-center",class:{ 'flex-column flex-sm-row': !_vm.headerActionStandAlone }},[(_vm.showBackArrow)?_c('pp-button',{staticClass:"mr-2",class:!_vm.subPage ? 'd-none d-md-flex' : '',attrs:{"icon":"arrow--back","type":"secondary"},on:{"click":_vm.goBack}}):_vm._e(),_c(_vm.headingTag,{tag:"component",staticClass:"text-h2 text-truncate mb-0",class:{'d-none d-md-block': !_vm.subPage, 'text-h4' : _vm.headingTag==='h2'}},[_vm._v(" "+_vm._s(_vm.title)+" "),(_vm.subTitle)?_c('span',{staticClass:"text-h6 d-block"},[_vm._v(" "+_vm._s(_vm.subTitle)+" ")]):_vm._e()]),_vm._t("topNav"),(_vm.showHeaderActions)?_c('div',{staticClass:"flex-grow-1 justify-end d-flex align-center",class:{ 'mt-4 mt-sm-0': !_vm.headerActionStandAlone }},[_vm._t("headerActions")],2):_vm._e()],2)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/page-container-header/PpPageContainerHeader.vue?vue&type=template&id=7db3db16&scoped=true&

// EXTERNAL MODULE: ./src/components/button/PpButton.vue + 5 modules
var PpButton = __webpack_require__("251c");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/page-container-header/PpPageContainerHeader.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * Page Container Header with sticky header and footer, allowing for a sticky top bar at top (eg used in practice settings)
 */

/* harmony default export */ var PpPageContainerHeadervue_type_script_lang_js_ = ({
  name: 'PpPageContainerHeader',
  components: {
    'pp-button': PpButton["default"]
  },
  props: {
    title: {
      type: String,
      required: true
    },
    subTitle: {
      type: String,
      default: null
    },

    /**
     * If it's not a sub page then hide the main title and back arrow on mobile
     */
    subPage: {
      type: Boolean,
      default: false
    },
    showBackArrow: {
      type: Boolean,
      default: false
    },
    backActionDefault: {
      type: Boolean,
      default: true
    },
    headingTag: {
      type: String,
      default: 'h1'
    },

    /**
     * This is for layout of tabbed nav on mobile. Set headerActionStandAlone: true when there is no nav on the left.
     */
    headerActionStandAlone: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    showHeaderActions: function showHeaderActions() {
      return this.$slots.headerActions;
    }
  },
  methods: {
    goBack: function goBack() {
      this.$emit('back'); // default go back one on route

      if (this.backActionDefault) {
        this.$router.go(-1);
      }
    }
  }
});
// CONCATENATED MODULE: ./src/components/page-container-header/PpPageContainerHeader.vue?vue&type=script&lang=js&
 /* harmony default export */ var page_container_header_PpPageContainerHeadervue_type_script_lang_js_ = (PpPageContainerHeadervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/page-container-header/PpPageContainerHeader.vue?vue&type=style&index=0&id=7db3db16&lang=scss&scoped=true&
var PpPageContainerHeadervue_type_style_index_0_id_7db3db16_lang_scss_scoped_true_ = __webpack_require__("c637");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/page-container-header/PpPageContainerHeader.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  page_container_header_PpPageContainerHeadervue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "7db3db16",
  null
  
)

/* harmony default export */ var PpPageContainerHeader = __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "8b37":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("ffc4");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("875d6a56", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "8b51":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpStatusChip_vue_vue_type_style_index_0_id_edf4fc24_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("d1e1");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpStatusChip_vue_vue_type_style_index_0_id_edf4fc24_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpStatusChip_vue_vue_type_style_index_0_id_edf4fc24_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "8b6e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c662cfac-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/signature-icon/PpSignatureIcon.vue?vue&type=template&id=1021e088&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex rounded align-center justify-center pp-signature-icon px-1"},[(_vm.iconPosition === 'left')?_c('i',{class:("pp-icon-" + _vm.icon + " success--text mr-1")}):_vm._e(),_c('span',{staticClass:"text-subtitle-2 font-weight-bold"},[_vm._v(_vm._s(_vm.text))]),(_vm.iconPosition === 'right')?_c('i',{class:("pp-icon-" + _vm.icon + " success--text ml-1")}):_vm._e()])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/signature-icon/PpSignatureIcon.vue?vue&type=template&id=1021e088&scoped=true&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.index-of.js
var es_array_index_of = __webpack_require__("c975");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.values.js
var es_object_values = __webpack_require__("07ac");

// CONCATENATED MODULE: ./src/components/signature-icon/constants.js
var ICON_POSITIONS = {
  LEFT: 'left',
  RIGHT: 'right'
};
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/signature-icon/PpSignatureIcon.vue?vue&type=script&lang=js&


//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var PpSignatureIconvue_type_script_lang_js_ = ({
  name: 'PpSignatureIcon',
  props: {
    text: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      default: 'tebra'
    },
    iconPosition: {
      type: String,
      default: 'right',
      validator: function validator(value) {
        return Object.values(ICON_POSITIONS).indexOf(value) !== -1;
      }
    }
  }
});
// CONCATENATED MODULE: ./src/components/signature-icon/PpSignatureIcon.vue?vue&type=script&lang=js&
 /* harmony default export */ var signature_icon_PpSignatureIconvue_type_script_lang_js_ = (PpSignatureIconvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/signature-icon/PpSignatureIcon.vue?vue&type=style&index=0&id=1021e088&lang=scss&scoped=true&
var PpSignatureIconvue_type_style_index_0_id_1021e088_lang_scss_scoped_true_ = __webpack_require__("805b");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/signature-icon/PpSignatureIcon.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  signature_icon_PpSignatureIconvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "1021e088",
  null
  
)

/* harmony default export */ var PpSignatureIcon = __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "8b76":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M11 5H21\" stroke=\"#697492\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M11 19H21\" stroke=\"#697492\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M11 12H21\" stroke=\"#697492\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><circle cx=\"5\" cy=\"19\" r=\"2\" fill=\"#D9DBE6\" stroke=\"#697492\" stroke-width=\"2\"></circle><circle cx=\"5\" cy=\"12\" r=\"2\" fill=\"#D9DBE6\" stroke=\"#697492\" stroke-width=\"2\"></circle><circle cx=\"5\" cy=\"5\" r=\"2\" fill=\"#D9DBE6\" stroke=\"#697492\" stroke-width=\"2\"></circle></svg>";

/***/ }),

/***/ "8ba4":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var isInteger = __webpack_require__("5e89");

// `Number.isInteger` method
// https://tc39.es/ecma262/#sec-number.isinteger
$({ target: 'Number', stat: true }, {
  isInteger: isInteger
});


/***/ }),

/***/ "8bb3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c662cfac-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/divider/PpDivider.vue?vue&type=template&id=2e674112&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-divider',{staticClass:"pp-divider",attrs:{"vertical":_vm.vertical}})}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/divider/PpDivider.vue?vue&type=template&id=2e674112&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/divider/PpDivider.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//

/**
 * Use as a separator between components
 */
/* harmony default export */ var PpDividervue_type_script_lang_js_ = ({
  name: 'PpDivider',
  props: {
    /**
     * Select divider's orientation
     */
    vertical: {
      type: Boolean,
      default: false
    }
  }
});
// CONCATENATED MODULE: ./src/components/divider/PpDivider.vue?vue&type=script&lang=js&
 /* harmony default export */ var divider_PpDividervue_type_script_lang_js_ = (PpDividervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/divider/PpDivider.vue?vue&type=style&index=0&id=2e674112&scoped=true&lang=css&
var PpDividervue_type_style_index_0_id_2e674112_scoped_true_lang_css_ = __webpack_require__("b280");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// EXTERNAL MODULE: ./node_modules/vuetify-loader/lib/runtime/installComponents.js
var installComponents = __webpack_require__("6544");
var installComponents_default = /*#__PURE__*/__webpack_require__.n(installComponents);

// EXTERNAL MODULE: ./node_modules/vuetify/lib/components/VDivider/VDivider.js
var VDivider = __webpack_require__("ce7e");

// CONCATENATED MODULE: ./src/components/divider/PpDivider.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  divider_PpDividervue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "2e674112",
  null
  
)

/* harmony default export */ var PpDivider = __webpack_exports__["default"] = (component.exports);

/* vuetify-loader */


installComponents_default()(component, {VDivider: VDivider["a" /* default */]})


/***/ }),

/***/ "8bbf":
/***/ (function(module, exports) {

module.exports = require("vue");

/***/ }),

/***/ "8c44":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("6c2a");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("ecbcaba0", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "8c81":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("c8d5")

/**
 * @category Millisecond Helpers
 * @summary Get the milliseconds of the given date.
 *
 * @description
 * Get the milliseconds of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the milliseconds
 *
 * @example
 * // Get the milliseconds of 29 February 2012 11:45:05.123:
 * var result = getMilliseconds(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 123
 */
function getMilliseconds (dirtyDate) {
  var date = parse(dirtyDate)
  var milliseconds = date.getMilliseconds()
  return milliseconds
}

module.exports = getMilliseconds


/***/ }),

/***/ "8ce9":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("24f3");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("fbbe736c", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "8d24":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpButton_vue_vue_type_style_index_0_id_c5417a2a_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("7c8c");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpButton_vue_vue_type_style_index_0_id_c5417a2a_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpButton_vue_vue_type_style_index_0_id_c5417a2a_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "8d4f":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("0b4c");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("9e459412", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "8d52":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("5901");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("0086c282", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "8d94":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("e60d");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("81ced97e", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "8da5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fromXYZ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return toXYZ; });
/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("80d2");
 // For converting XYZ to sRGB

var srgbForwardMatrix = [[3.2406, -1.5372, -0.4986], [-0.9689, 1.8758, 0.0415], [0.0557, -0.2040, 1.0570]]; // Forward gamma adjust

var srgbForwardTransform = function srgbForwardTransform(C) {
  return C <= 0.0031308 ? C * 12.92 : 1.055 * Math.pow(C, 1 / 2.4) - 0.055;
}; // For converting sRGB to XYZ


var srgbReverseMatrix = [[0.4124, 0.3576, 0.1805], [0.2126, 0.7152, 0.0722], [0.0193, 0.1192, 0.9505]]; // Reverse gamma adjust

var srgbReverseTransform = function srgbReverseTransform(C) {
  return C <= 0.04045 ? C / 12.92 : Math.pow((C + 0.055) / 1.055, 2.4);
};

function fromXYZ(xyz) {
  var rgb = Array(3);
  var transform = srgbForwardTransform;
  var matrix = srgbForwardMatrix; // Matrix transform, then gamma adjustment

  for (var i = 0; i < 3; ++i) {
    rgb[i] = Math.round(Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__[/* clamp */ "f"])(transform(matrix[i][0] * xyz[0] + matrix[i][1] * xyz[1] + matrix[i][2] * xyz[2])) * 255);
  } // Rescale back to [0, 255]


  return (rgb[0] << 16) + (rgb[1] << 8) + (rgb[2] << 0);
}
function toXYZ(rgb) {
  var xyz = [0, 0, 0];
  var transform = srgbReverseTransform;
  var matrix = srgbReverseMatrix; // Rescale from [0, 255] to [0, 1] then adjust sRGB gamma to linear RGB

  var r = transform((rgb >> 16 & 0xff) / 255);
  var g = transform((rgb >> 8 & 0xff) / 255);
  var b = transform((rgb >> 0 & 0xff) / 255); // Matrix color space transform

  for (var i = 0; i < 3; ++i) {
    xyz[i] = matrix[i][0] * r + matrix[i][1] * g + matrix[i][2] * b;
  }

  return xyz;
}

/***/ }),

/***/ "8dd9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("5530");
/* harmony import */ var _src_components_VSheet_VSheet_sass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("25a8");
/* harmony import */ var _src_components_VSheet_VSheet_sass__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_src_components_VSheet_VSheet_sass__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _mixins_binds_attrs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("7e2b");
/* harmony import */ var _mixins_colorable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("a9ad");
/* harmony import */ var _mixins_elevatable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("c995");
/* harmony import */ var _mixins_measurable__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("24b2");
/* harmony import */ var _mixins_roundable__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("a236");
/* harmony import */ var _mixins_themeable__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("7560");
/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("58df");

// Styles
 // Mixins






 // Helpers


/* @vue/component */

/* harmony default export */ __webpack_exports__["a"] = (Object(_util_mixins__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"])(_mixins_binds_attrs__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"], _mixins_colorable__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"], _mixins_elevatable__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"], _mixins_measurable__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"], _mixins_roundable__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"], _mixins_themeable__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"]).extend({
  name: 'v-sheet',
  props: {
    outlined: Boolean,
    shaped: Boolean,
    tag: {
      type: String,
      default: 'div'
    }
  },
  computed: {
    classes: function classes() {
      return Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({
        'v-sheet': true,
        'v-sheet--outlined': this.outlined,
        'v-sheet--shaped': this.shaped
      }, this.themeClasses), this.elevationClasses), this.roundedClasses);
    },
    styles: function styles() {
      return this.measurableStyles;
    }
  },
  render: function render(h) {
    var data = {
      class: this.classes,
      style: this.styles,
      on: this.listeners$
    };
    return h(this.tag, this.setBackgroundColor(this.color, data), this.$slots.default);
  }
}));

/***/ }),

/***/ "8e36":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("a9e3");
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_string_fixed_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("c7cd");
/* harmony import */ var core_js_modules_es_string_fixed_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_fixed_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("5530");
/* harmony import */ var _home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("ade3");
/* harmony import */ var _src_components_VProgressLinear_VProgressLinear_sass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("6ece");
/* harmony import */ var _src_components_VProgressLinear_VProgressLinear_sass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_src_components_VProgressLinear_VProgressLinear_sass__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _transitions__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("0789");
/* harmony import */ var _mixins_colorable__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("a9ad");
/* harmony import */ var _mixins_positionable__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("fe6c");
/* harmony import */ var _mixins_proxyable__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("a452");
/* harmony import */ var _mixins_themeable__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("7560");
/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("80d2");
/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("58df");




 // Components

 // Mixins




 // Utilities



var baseMixins = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_11__[/* default */ "a"])(_mixins_colorable__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"], Object(_mixins_positionable__WEBPACK_IMPORTED_MODULE_7__[/* factory */ "b"])(['absolute', 'fixed', 'top', 'bottom']), _mixins_proxyable__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"], _mixins_themeable__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"]);
/* @vue/component */

/* harmony default export */ __webpack_exports__["a"] = (baseMixins.extend({
  name: 'v-progress-linear',
  props: {
    active: {
      type: Boolean,
      default: true
    },
    backgroundColor: {
      type: String,
      default: null
    },
    backgroundOpacity: {
      type: [Number, String],
      default: null
    },
    bufferValue: {
      type: [Number, String],
      default: 100
    },
    color: {
      type: String,
      default: 'primary'
    },
    height: {
      type: [Number, String],
      default: 4
    },
    indeterminate: Boolean,
    query: Boolean,
    reverse: Boolean,
    rounded: Boolean,
    stream: Boolean,
    striped: Boolean,
    value: {
      type: [Number, String],
      default: 0
    }
  },
  data: function data() {
    return {
      internalLazyValue: this.value || 0
    };
  },
  computed: {
    __cachedBackground: function __cachedBackground() {
      return this.$createElement('div', this.setBackgroundColor(this.backgroundColor || this.color, {
        staticClass: 'v-progress-linear__background',
        style: this.backgroundStyle
      }));
    },
    __cachedBar: function __cachedBar() {
      return this.$createElement(this.computedTransition, [this.__cachedBarType]);
    },
    __cachedBarType: function __cachedBarType() {
      return this.indeterminate ? this.__cachedIndeterminate : this.__cachedDeterminate;
    },
    __cachedBuffer: function __cachedBuffer() {
      return this.$createElement('div', {
        staticClass: 'v-progress-linear__buffer',
        style: this.styles
      });
    },
    __cachedDeterminate: function __cachedDeterminate() {
      return this.$createElement('div', this.setBackgroundColor(this.color, {
        staticClass: "v-progress-linear__determinate",
        style: {
          width: Object(_util_helpers__WEBPACK_IMPORTED_MODULE_10__[/* convertToUnit */ "g"])(this.normalizedValue, '%')
        }
      }));
    },
    __cachedIndeterminate: function __cachedIndeterminate() {
      return this.$createElement('div', {
        staticClass: 'v-progress-linear__indeterminate',
        class: {
          'v-progress-linear__indeterminate--active': this.active
        }
      }, [this.genProgressBar('long'), this.genProgressBar('short')]);
    },
    __cachedStream: function __cachedStream() {
      if (!this.stream) return null;
      return this.$createElement('div', this.setTextColor(this.color, {
        staticClass: 'v-progress-linear__stream',
        style: {
          width: Object(_util_helpers__WEBPACK_IMPORTED_MODULE_10__[/* convertToUnit */ "g"])(100 - this.normalizedBuffer, '%')
        }
      }));
    },
    backgroundStyle: function backgroundStyle() {
      var _ref;

      var backgroundOpacity = this.backgroundOpacity == null ? this.backgroundColor ? 1 : 0.3 : parseFloat(this.backgroundOpacity);
      return _ref = {
        opacity: backgroundOpacity
      }, Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(_ref, this.isReversed ? 'right' : 'left', Object(_util_helpers__WEBPACK_IMPORTED_MODULE_10__[/* convertToUnit */ "g"])(this.normalizedValue, '%')), Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(_ref, "width", Object(_util_helpers__WEBPACK_IMPORTED_MODULE_10__[/* convertToUnit */ "g"])(this.normalizedBuffer - this.normalizedValue, '%')), _ref;
    },
    classes: function classes() {
      return Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])({
        'v-progress-linear--absolute': this.absolute,
        'v-progress-linear--fixed': this.fixed,
        'v-progress-linear--query': this.query,
        'v-progress-linear--reactive': this.reactive,
        'v-progress-linear--reverse': this.isReversed,
        'v-progress-linear--rounded': this.rounded,
        'v-progress-linear--striped': this.striped
      }, this.themeClasses);
    },
    computedTransition: function computedTransition() {
      return this.indeterminate ? _transitions__WEBPACK_IMPORTED_MODULE_5__[/* VFadeTransition */ "d"] : _transitions__WEBPACK_IMPORTED_MODULE_5__[/* VSlideXTransition */ "f"];
    },
    isReversed: function isReversed() {
      return this.$vuetify.rtl !== this.reverse;
    },
    normalizedBuffer: function normalizedBuffer() {
      return this.normalize(this.bufferValue);
    },
    normalizedValue: function normalizedValue() {
      return this.normalize(this.internalLazyValue);
    },
    reactive: function reactive() {
      return Boolean(this.$listeners.change);
    },
    styles: function styles() {
      var styles = {};

      if (!this.active) {
        styles.height = 0;
      }

      if (!this.indeterminate && parseFloat(this.normalizedBuffer) !== 100) {
        styles.width = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_10__[/* convertToUnit */ "g"])(this.normalizedBuffer, '%');
      }

      return styles;
    }
  },
  methods: {
    genContent: function genContent() {
      var slot = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_10__[/* getSlot */ "s"])(this, 'default', {
        value: this.internalLazyValue
      });
      if (!slot) return null;
      return this.$createElement('div', {
        staticClass: 'v-progress-linear__content'
      }, slot);
    },
    genListeners: function genListeners() {
      var listeners = this.$listeners;

      if (this.reactive) {
        listeners.click = this.onClick;
      }

      return listeners;
    },
    genProgressBar: function genProgressBar(name) {
      return this.$createElement('div', this.setBackgroundColor(this.color, {
        staticClass: 'v-progress-linear__indeterminate',
        class: Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])({}, name, true)
      }));
    },
    onClick: function onClick(e) {
      if (!this.reactive) return;

      var _this$$el$getBounding = this.$el.getBoundingClientRect(),
          width = _this$$el$getBounding.width;

      this.internalValue = e.offsetX / width * 100;
    },
    normalize: function normalize(value) {
      if (value < 0) return 0;
      if (value > 100) return 100;
      return parseFloat(value);
    }
  },
  render: function render(h) {
    var data = {
      staticClass: 'v-progress-linear',
      attrs: {
        role: 'progressbar',
        'aria-valuemin': 0,
        'aria-valuemax': this.normalizedBuffer,
        'aria-valuenow': this.indeterminate ? undefined : this.normalizedValue
      },
      class: this.classes,
      style: {
        bottom: this.bottom ? 0 : undefined,
        height: this.active ? Object(_util_helpers__WEBPACK_IMPORTED_MODULE_10__[/* convertToUnit */ "g"])(this.height) : 0,
        top: this.top ? 0 : undefined
      },
      on: this.genListeners()
    };
    return h('div', data, [this.__cachedStream, this.__cachedBackground, this.__cachedBuffer, this.__cachedBar, this.genContent()]);
  }
}));

/***/ }),

/***/ "8e45":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><rect x=\"4\" y=\"5\" width=\"16\" height=\"3\" fill=\"#DFE4E5\"></rect><rect x=\"4\" y=\"10\" width=\"16\" height=\"10\" fill=\"white\"></rect><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8 5C8 5.55228 7.55228 6 7 6C6.44772 6 6 5.55228 6 5H4V8H20V5H18C18 5.55228 17.5523 6 17 6C16.4477 6 16 5.55228 16 5H8ZM20 10H4V20H20V10ZM18 3C18 2.44772 17.5523 2 17 2C16.4477 2 16 2.44772 16 3H8C8 2.44772 7.55228 2 7 2C6.44772 2 6 2.44772 6 3H4C2.89543 3 2 3.89543 2 5V20C2 21.1046 2.89543 22 4 22H20C21.1046 22 22 21.1046 22 20V5C22 3.89543 21.1046 3 20 3H18ZM7 14V12H9V14H7ZM11 14H13V12H11V14ZM15 14V12H17V14H15ZM7 16V18H9V16H7ZM13 18H11V16H13V18Z\" fill=\"#1F3A3E\"></path></svg>";

/***/ }),

/***/ "8e46":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpAvatarInfo_vue_vue_type_style_index_0_id_b0984a4c_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("4fc9");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpAvatarInfo_vue_vue_type_style_index_0_id_b0984a4c_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpAvatarInfo_vue_vue_type_style_index_0_id_b0984a4c_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "8e6c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c662cfac-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/input/label/PpInputLabel.vue?vue&type=template&id=a024b9e8&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',_vm._g({staticClass:"font-weight-medium",attrs:{"for":_vm.inputId}},_vm.$listeners),[_vm._v(" "+_vm._s(_vm.label)+" "),(_vm.optional)?_c('span',[_vm._v(" (Optional) ")]):_vm._e()])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/input/label/PpInputLabel.vue?vue&type=template&id=a024b9e8&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/input/label/PpInputLabel.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var PpInputLabelvue_type_script_lang_js_ = ({
  name: 'PpInputLabel',
  props: {
    label: {
      type: String,
      required: true
    },
    inputId: {
      type: String,
      default: null
    },
    optional: {
      type: Boolean,
      default: false
    }
  }
});
// CONCATENATED MODULE: ./src/components/input/label/PpInputLabel.vue?vue&type=script&lang=js&
 /* harmony default export */ var label_PpInputLabelvue_type_script_lang_js_ = (PpInputLabelvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/input/label/PpInputLabel.vue?vue&type=style&index=0&id=a024b9e8&lang=scss&scoped=true&
var PpInputLabelvue_type_style_index_0_id_a024b9e8_lang_scss_scoped_true_ = __webpack_require__("a122");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/input/label/PpInputLabel.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  label_PpInputLabelvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "a024b9e8",
  null
  
)

/* harmony default export */ var PpInputLabel = __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "8ecc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c662cfac-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/col/PpCol.vue?vue&type=template&id=65a5d2f2&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',_vm._g(_vm._b({},'v-col',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/col/PpCol.vue?vue&type=template&id=65a5d2f2&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/col/PpCol.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
/* harmony default export */ var PpColvue_type_script_lang_js_ = ({
  name: 'PpCol'
});
// CONCATENATED MODULE: ./src/components/col/PpCol.vue?vue&type=script&lang=js&
 /* harmony default export */ var col_PpColvue_type_script_lang_js_ = (PpColvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// EXTERNAL MODULE: ./node_modules/vuetify-loader/lib/runtime/installComponents.js
var installComponents = __webpack_require__("6544");
var installComponents_default = /*#__PURE__*/__webpack_require__.n(installComponents);

// EXTERNAL MODULE: ./node_modules/vuetify/lib/components/VGrid/VCol.js
var VCol = __webpack_require__("62ad");

// CONCATENATED MODULE: ./src/components/col/PpCol.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  col_PpColvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var PpCol = __webpack_exports__["default"] = (component.exports);

/* vuetify-loader */


installComponents_default()(component, {VCol: VCol["a" /* default */]})


/***/ }),

/***/ "8efc":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("f6a8");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("28d83398", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "8ff2":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("b4f0");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("5cce6597", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "902e":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("c8d5")

/**
 * @category Timestamp Helpers
 * @summary Get the milliseconds timestamp of the given date.
 *
 * @description
 * Get the milliseconds timestamp of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the timestamp
 *
 * @example
 * // Get the timestamp of 29 February 2012 11:45:05.123:
 * var result = getTime(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 1330515905123
 */
function getTime (dirtyDate) {
  var date = parse(dirtyDate)
  var timestamp = date.getTime()
  return timestamp
}

module.exports = getTime


/***/ }),

/***/ "90a2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Intersect */
/* harmony import */ var core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("7db0");
/* harmony import */ var core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("53ca");



function inserted(el, binding) {
  var modifiers = binding.modifiers || {};
  var value = binding.value;

  var _ref = Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(value) === 'object' ? value : {
    handler: value,
    options: {}
  },
      handler = _ref.handler,
      options = _ref.options;

  var observer = new IntersectionObserver(function () {
    var entries = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var observer = arguments.length > 1 ? arguments[1] : undefined;

    /* istanbul ignore if */
    if (!el._observe) return; // Just in case, should never fire
    // If is not quiet or has already been
    // initted, invoke the user callback

    if (handler && (!modifiers.quiet || el._observe.init)) {
      var isIntersecting = Boolean(entries.find(function (entry) {
        return entry.isIntersecting;
      }));
      handler(entries, observer, isIntersecting);
    } // If has already been initted and
    // has the once modifier, unbind


    if (el._observe.init && modifiers.once) unbind(el); // Otherwise, mark the observer as initted
    else el._observe.init = true;
  }, options);
  el._observe = {
    init: false,
    observer: observer
  };
  observer.observe(el);
}

function unbind(el) {
  /* istanbul ignore if */
  if (!el._observe) return;

  el._observe.observer.unobserve(el);

  delete el._observe;
}

var Intersect = {
  inserted: inserted,
  unbind: unbind
};
/* harmony default export */ __webpack_exports__["a"] = (Intersect);

/***/ }),

/***/ "90e3":
/***/ (function(module, exports) {

var id = 0;
var postfix = Math.random();

module.exports = function (key) {
  return 'Symbol(' + String(key === undefined ? '' : key) + ')_' + (++id + postfix).toString(36);
};


/***/ }),

/***/ "90e5":
/***/ (function(module, exports) {

var commonFormatterKeys = [
  'M', 'MM', 'Q', 'D', 'DD', 'DDD', 'DDDD', 'd',
  'E', 'W', 'WW', 'YY', 'YYYY', 'GG', 'GGGG',
  'H', 'HH', 'h', 'hh', 'm', 'mm',
  's', 'ss', 'S', 'SS', 'SSS',
  'Z', 'ZZ', 'X', 'x'
]

function buildFormattingTokensRegExp (formatters) {
  var formatterKeys = []
  for (var key in formatters) {
    if (formatters.hasOwnProperty(key)) {
      formatterKeys.push(key)
    }
  }

  var formattingTokens = commonFormatterKeys
    .concat(formatterKeys)
    .sort()
    .reverse()
  var formattingTokensRegExp = new RegExp(
    '(\\[[^\\[]*\\])|(\\\\)?' + '(' + formattingTokens.join('|') + '|.)', 'g'
  )

  return formattingTokensRegExp
}

module.exports = buildFormattingTokensRegExp


/***/ }),

/***/ "9112":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var definePropertyModule = __webpack_require__("9bf2");
var createPropertyDescriptor = __webpack_require__("5c6c");

module.exports = DESCRIPTORS ? function (object, key, value) {
  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ "9113":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("c8d5")

/**
 * @category Second Helpers
 * @summary Set the seconds to the given date.
 *
 * @description
 * Set the seconds to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} seconds - the seconds of the new date
 * @returns {Date} the new date with the seconds setted
 *
 * @example
 * // Set 45 seconds to 1 September 2014 11:30:40:
 * var result = setSeconds(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:30:45
 */
function setSeconds (dirtyDate, dirtySeconds) {
  var date = parse(dirtyDate)
  var seconds = Number(dirtySeconds)
  date.setSeconds(seconds)
  return date
}

module.exports = setSeconds


/***/ }),

/***/ "9130":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.i, "@import url(https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css);"]);
exports.push([module.i, "@import url(https://cdn-prd.patientpop.com/pp-icon-font/v1.6.0/pp-icon-font.css);"]);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.pp-loading-icon[data-v-18424fb7]{left:50%;margin:0;overflow:hidden;position:absolute;top:50%;transform:translate(-50%,-50%)}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "9134":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("1138");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("35a929f7", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "913e":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_1488_309)\"><circle cx=\"12\" cy=\"12\" r=\"10\" fill=\"white\" stroke=\"#1F3A3E\" stroke-width=\"2\"></circle><circle cx=\"12\" cy=\"12\" r=\"7\" fill=\"#DFE4E5\"></circle><path d=\"M11.125 16.0908C11.125 16.5929 11.5169 17 12.0003 17C12.4837 17 12.8756 16.5929 12.8756 16.0908C12.8756 15.5886 12.4837 15.1815 12.0003 15.1815C11.5169 15.1815 11.125 15.5886 11.125 16.0908Z\" fill=\"#1F3A3E\"></path><path d=\"M11.125 14.2738H12.875C12.875 13.5479 12.9847 13.4149 13.7038 13.0413C14.9535 12.392 15.5 11.7295 15.5 10.1823C15.5 8.20075 13.9988 7 12 7C10.067 7 8.5 8.6283 8.5 10.6369H10.25C10.25 9.63261 11.0335 8.81846 12 8.81846C13.1175 8.81846 13.75 9.32436 13.75 10.1823C13.75 10.9082 13.6403 11.0412 12.9212 11.4148C11.6715 12.0641 11.125 12.7266 11.125 14.2738Z\" fill=\"#1F3A3E\"></path></g><defs><clipPath id=\"clip0_1488_309\"><rect width=\"24\" height=\"24\" fill=\"white\"></rect></clipPath></defs></svg>";

/***/ }),

/***/ "9141":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpPageHeader_vue_vue_type_style_index_0_id_1ca6b76c_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("9c90");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpPageHeader_vue_vue_type_style_index_0_id_1ca6b76c_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpPageHeader_vue_vue_type_style_index_0_id_1ca6b76c_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "91f4":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("f9f8");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("6ff88715", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "9220":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.v-data-footer{display:flex;flex-wrap:wrap;justify-content:flex-end;align-items:center;font-size:.8571428571rem;padding:0 8px}.v-data-footer .v-btn{color:inherit}.v-application--is-ltr .v-data-footer__icons-before .v-btn:last-child{margin-right:7px}.v-application--is-ltr .v-data-footer__icons-after .v-btn:first-child,.v-application--is-rtl .v-data-footer__icons-before .v-btn:last-child{margin-left:7px}.v-application--is-rtl .v-data-footer__icons-after .v-btn:first-child{margin-right:7px}.v-data-footer__pagination{display:block;text-align:center}.v-application--is-ltr .v-data-footer__pagination{margin:0 32px 0 24px}.v-application--is-rtl .v-data-footer__pagination{margin:0 24px 0 32px}.v-data-footer__select{display:flex;align-items:center;flex:0 0 0;justify-content:flex-end;white-space:nowrap}.v-application--is-ltr .v-data-footer__select{margin-right:14px}.v-application--is-rtl .v-data-footer__select{margin-left:14px}.v-data-footer__select .v-select{flex:0 1 0;padding:0;position:static}.v-application--is-ltr .v-data-footer__select .v-select{margin:13px 0 13px 34px}.v-application--is-rtl .v-data-footer__select .v-select{margin:13px 34px 13px 0}.v-data-footer__select .v-select__selections{flex-wrap:nowrap}.v-data-footer__select .v-select__selections .v-select__selection--comma{font-size:.75rem}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "9246":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.i, "@import url(https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css);"]);
exports.push([module.i, "@import url(https://cdn-prd.patientpop.com/pp-icon-font/v1.6.0/pp-icon-font.css);"]);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.swatch[data-v-0d1c1272]{background:var(--swatch-color);cursor:pointer;height:var(--pp-swatch-size,26px);width:var(--pp-swatch-size,26px)}.swatch--within-input[data-v-0d1c1272]{margin-top:-6px}.swatch--with-border[data-v-0d1c1272]{border:1px solid #d6d6d6}.v-input--is-disabled .swatch[data-v-0d1c1272]{opacity:.25}.swatch--selector[data-v-0d1c1272]{--pp-swatch-size:40px}.swatch--selector[data-v-0d1c1272]:after{align-items:center;content:attr(data-color);display:flex;margin-left:4em}.pp-color-picker[data-v-0d1c1272]{background-color:#fff}.pp-color-picker__mode-select[data-v-0d1c1272]{display:block;left:15px;position:absolute;top:260px;width:90px;--pp-text-field-min-height:0}.v-color-picker[data-v-0d1c1272]  .v-color-picker__canvas,.v-color-picker[data-v-0d1c1272]  .v-color-picker__dot{border-radius:.4em}.v-color-picker[data-v-0d1c1272]  .v-color-picker__preview{padding-right:8px}.v-color-picker[data-v-0d1c1272]  .v-color-picker__sliders .v-color-picker__track:first-of-type{margin-bottom:.5em}.v-color-picker[data-v-0d1c1272]  .v-color-picker__edit{align-items:center;background:#f6f6f6;height:36px;padding-left:95px}.v-color-picker[data-v-0d1c1272]  .v-color-picker__input span{display:none}.v-color-picker[data-v-0d1c1272]  .v-color-picker__input input{background:transparent;border:0;margin-bottom:0;margin-right:0}.v-color-picker[data-v-0d1c1272]  .v-color-picker__input input:focus{background:#fff;border:2px solid #079cb2}.v-color-picker[data-v-0d1c1272]  .v-slider__thumb{border:1px solid #545454!important}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "925a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c662cfac-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/snack-message/PpSnackMessage.vue?vue&type=template&id=78ffc6e8&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-snackbar',_vm._g(_vm._b({attrs:{"light":""},scopedSlots:_vm._u([_vm._l((_vm.$slots),function(_,name){return {key:name,fn:function(){return [_vm._t(name)]},proxy:true}})],null,true)},'v-snackbar',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/snack-message/PpSnackMessage.vue?vue&type=template&id=78ffc6e8&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/snack-message/PpSnackMessage.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var PpSnackMessagevue_type_script_lang_js_ = ({
  name: 'PpSnackMessage'
});
// CONCATENATED MODULE: ./src/components/snack-message/PpSnackMessage.vue?vue&type=script&lang=js&
 /* harmony default export */ var snack_message_PpSnackMessagevue_type_script_lang_js_ = (PpSnackMessagevue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// EXTERNAL MODULE: ./node_modules/vuetify-loader/lib/runtime/installComponents.js
var installComponents = __webpack_require__("6544");
var installComponents_default = /*#__PURE__*/__webpack_require__.n(installComponents);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("caad");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__("a9e3");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("ade3");

// EXTERNAL MODULE: ./node_modules/vuetify/src/components/VSnackbar/VSnackbar.sass
var VSnackbar = __webpack_require__("ca71");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/components/VSheet/VSheet.js
var VSheet = __webpack_require__("8dd9");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/mixins/colorable/index.js
var colorable = __webpack_require__("a9ad");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/mixins/themeable/index.js
var themeable = __webpack_require__("7560");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/mixins/toggleable/index.js
var toggleable = __webpack_require__("f2e7");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/mixins/positionable/index.js
var positionable = __webpack_require__("fe6c");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/util/mixins.js
var mixins = __webpack_require__("58df");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/util/helpers.js
var helpers = __webpack_require__("80d2");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/util/console.js + 32 modules
var console = __webpack_require__("d9bd");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VSnackbar/VSnackbar.js



// Styles
 // Components

 // Mixins




 // Utilities




/* harmony default export */ var VSnackbar_VSnackbar = (Object(mixins["a" /* default */])(VSheet["a" /* default */], colorable["a" /* default */], toggleable["a" /* default */], Object(positionable["b" /* factory */])(['absolute', 'bottom', 'left', 'right', 'top'])
/* @vue/component */
).extend({
  name: 'v-snackbar',
  props: {
    app: Boolean,
    centered: Boolean,
    contentClass: {
      type: String,
      default: ''
    },
    multiLine: Boolean,
    text: Boolean,
    timeout: {
      type: [Number, String],
      default: 5000
    },
    transition: {
      type: [Boolean, String],
      default: 'v-snack-transition',
      validator: function validator(v) {
        return typeof v === 'string' || v === false;
      }
    },
    vertical: Boolean
  },
  data: function data() {
    return {
      activeTimeout: -1
    };
  },
  computed: {
    classes: function classes() {
      return {
        'v-snack--absolute': this.absolute,
        'v-snack--active': this.isActive,
        'v-snack--bottom': this.bottom || !this.top,
        'v-snack--centered': this.centered,
        'v-snack--has-background': this.hasBackground,
        'v-snack--left': this.left,
        'v-snack--multi-line': this.multiLine && !this.vertical,
        'v-snack--right': this.right,
        'v-snack--text': this.text,
        'v-snack--top': this.top,
        'v-snack--vertical': this.vertical
      };
    },
    // Text and outlined styles both
    // use transparent backgrounds
    hasBackground: function hasBackground() {
      return !this.text && !this.outlined;
    },
    // Snackbar is dark by default
    // override themeable logic.
    isDark: function isDark() {
      return this.hasBackground ? !this.light : themeable["a" /* default */].options.computed.isDark.call(this);
    },
    styles: function styles() {
      // Styles are not needed when
      // using the absolute prop.
      if (this.absolute) return {};
      var _this$$vuetify$applic = this.$vuetify.application,
          bar = _this$$vuetify$applic.bar,
          bottom = _this$$vuetify$applic.bottom,
          footer = _this$$vuetify$applic.footer,
          insetFooter = _this$$vuetify$applic.insetFooter,
          left = _this$$vuetify$applic.left,
          right = _this$$vuetify$applic.right,
          top = _this$$vuetify$applic.top; // Should always move for y-axis
      // applicationable components.

      return {
        paddingBottom: Object(helpers["g" /* convertToUnit */])(bottom + footer + insetFooter),
        paddingLeft: !this.app ? undefined : Object(helpers["g" /* convertToUnit */])(left),
        paddingRight: !this.app ? undefined : Object(helpers["g" /* convertToUnit */])(right),
        paddingTop: Object(helpers["g" /* convertToUnit */])(bar + top)
      };
    }
  },
  watch: {
    isActive: 'setTimeout',
    timeout: 'setTimeout'
  },
  mounted: function mounted() {
    if (this.isActive) this.setTimeout();
  },
  created: function created() {
    /* istanbul ignore next */
    if (this.$attrs.hasOwnProperty('auto-height')) {
      Object(console["e" /* removed */])('auto-height', this);
    }
    /* istanbul ignore next */
    // eslint-disable-next-line eqeqeq


    if (this.timeout == 0) {
      Object(console["d" /* deprecate */])('timeout="0"', '-1', this);
    }
  },
  methods: {
    genActions: function genActions() {
      return this.$createElement('div', {
        staticClass: 'v-snack__action '
      }, [Object(helpers["s" /* getSlot */])(this, 'action', {
        attrs: {
          class: 'v-snack__btn'
        }
      })]);
    },
    genContent: function genContent() {
      return this.$createElement('div', {
        staticClass: 'v-snack__content',
        class: Object(defineProperty["a" /* default */])({}, this.contentClass, true),
        attrs: {
          role: 'status',
          'aria-live': 'polite'
        }
      }, [Object(helpers["s" /* getSlot */])(this)]);
    },
    genWrapper: function genWrapper() {
      var _this = this;

      var setColor = this.hasBackground ? this.setBackgroundColor : this.setTextColor;
      var data = setColor(this.color, {
        staticClass: 'v-snack__wrapper',
        class: VSheet["a" /* default */].options.computed.classes.call(this),
        directives: [{
          name: 'show',
          value: this.isActive
        }],
        on: {
          mouseenter: function mouseenter() {
            return window.clearTimeout(_this.activeTimeout);
          },
          mouseleave: this.setTimeout
        }
      });
      return this.$createElement('div', data, [this.genContent(), this.genActions()]);
    },
    genTransition: function genTransition() {
      return this.$createElement('transition', {
        props: {
          name: this.transition
        }
      }, [this.genWrapper()]);
    },
    setTimeout: function setTimeout() {
      var _this2 = this;

      window.clearTimeout(this.activeTimeout);
      var timeout = Number(this.timeout);

      if (!this.isActive || // TODO: remove 0 in v3
      [0, -1].includes(timeout)) {
        return;
      }

      this.activeTimeout = window.setTimeout(function () {
        _this2.isActive = false;
      }, timeout);
    }
  },
  render: function render(h) {
    return h('div', {
      staticClass: 'v-snack',
      class: this.classes,
      style: this.styles
    }, [this.transition !== false ? this.genTransition() : this.genWrapper()]);
  }
}));
// CONCATENATED MODULE: ./src/components/snack-message/PpSnackMessage.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  snack_message_PpSnackMessagevue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var PpSnackMessage = __webpack_exports__["default"] = (component.exports);

/* vuetify-loader */


installComponents_default()(component, {VSnackbar: VSnackbar_VSnackbar})


/***/ }),

/***/ "9263":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var regexpFlags = __webpack_require__("ad6d");
var stickyHelpers = __webpack_require__("9f7f");

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/;
  var re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
})();

var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y || stickyHelpers.BROKEN_CARET;

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;
    var sticky = UNSUPPORTED_Y && re.sticky;
    var flags = regexpFlags.call(re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;

    if (sticky) {
      flags = flags.replace('y', '');
      if (flags.indexOf('g') === -1) {
        flags += 'g';
      }

      strCopy = String(str).slice(re.lastIndex);
      // Support anchored sticky behavior.
      if (re.lastIndex > 0 && (!re.multiline || re.multiline && str[re.lastIndex - 1] !== '\n')) {
        source = '(?: ' + source + ')';
        strCopy = ' ' + strCopy;
        charsAdded++;
      }
      // ^(? + rx + ) is needed, in combination with some str slicing, to
      // simulate the 'y' flag.
      reCopy = new RegExp('^(?:' + source + ')', flags);
    }

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

    match = nativeExec.call(sticky ? reCopy : re, strCopy);

    if (sticky) {
      if (match) {
        match.input = match.input.slice(charsAdded);
        match[0] = match[0].slice(charsAdded);
        match.index = re.lastIndex;
        re.lastIndex += match[0].length;
      } else re.lastIndex = 0;
    } else if (UPDATES_LAST_INDEX_WRONG && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),

/***/ "9287":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c662cfac-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/masked-data/PpMaskedData.vue?vue&type=template&id=1effbcc5&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"pp-masked-data",on:{"click":_vm.openDialog}},[_vm._t("default",[_vm._v(" "+_vm._s(_vm.text)+" ")]),(_vm.showDialog)?_c('pp-dialog-phi',{on:{"close":_vm.onClose,"confirm":_vm.onConfirm}}):_vm._e()],2)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/masked-data/PpMaskedData.vue?vue&type=template&id=1effbcc5&scoped=true&

// EXTERNAL MODULE: ./src/components/dialog/phi/PpDialogPhi.vue + 4 modules
var PpDialogPhi = __webpack_require__("b041");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/masked-data/PpMaskedData.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var PpMaskedDatavue_type_script_lang_js_ = ({
  name: 'PpMaskedData',
  components: {
    'pp-dialog-phi': PpDialogPhi["default"]
  },
  props: {
    text: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      showDialog: false
    };
  },
  methods: {
    openDialog: function openDialog() {
      this.showDialog = true;
      this.$emit('open-dialog');
    },
    onConfirm: function onConfirm(event) {
      this.showDialog = false;
      this.$emit('confirm', event);
    },
    onClose: function onClose() {
      this.showDialog = false;
      this.$emit('close');
    }
  }
});
// CONCATENATED MODULE: ./src/components/masked-data/PpMaskedData.vue?vue&type=script&lang=js&
 /* harmony default export */ var masked_data_PpMaskedDatavue_type_script_lang_js_ = (PpMaskedDatavue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/masked-data/PpMaskedData.vue?vue&type=style&index=0&id=1effbcc5&lang=scss&scoped=true&
var PpMaskedDatavue_type_style_index_0_id_1effbcc5_lang_scss_scoped_true_ = __webpack_require__("b8a8");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/masked-data/PpMaskedData.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  masked_data_PpMaskedDatavue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "1effbcc5",
  null
  
)

/* harmony default export */ var PpMaskedData = __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "92e1":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("85c9");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("1d5c2c89", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "9373":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.i, "@import url(https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css);"]);
exports.push([module.i, "@import url(https://cdn-prd.patientpop.com/pp-icon-font/v1.6.0/pp-icon-font.css);"]);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.pp-status-banner[data-v-112baaea]{position:relative}.pp-status-banner__loader[data-v-112baaea]{left:auto;right:1em}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "9408":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.i, "@import url(https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css);"]);
exports.push([module.i, "@import url(https://cdn-prd.patientpop.com/pp-icon-font/v1.6.0/pp-icon-font.css);"]);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.pp-data-table.pp-data-table--actionable[data-v-4d4a0701] .v-data-table .v-data-table__wrapper>table>thead.v-data-table-header>tr th{color:#545454;font-size:.8571428571rem;font-weight:600;letter-spacing:.02em;line-height:1.0714285714rem;padding:12px 20px;text-transform:uppercase}.pp-data-table.pp-data-table--actionable[data-v-4d4a0701] .v-data-table .v-data-table__wrapper>table>thead.v-data-table-header>tr th:first-child{padding-left:32px}.pp-data-table.pp-data-table--actionable[data-v-4d4a0701] .v-data-table .v-data-table__wrapper>table>thead.v-data-table-header>tr th:last-child{padding-right:32px}.pp-data-table.pp-data-table--actionable[data-v-4d4a0701] .v-data-table .v-data-table__wrapper>table>tbody{position:relative}.pp-data-table.pp-data-table--actionable[data-v-4d4a0701] .v-data-table .v-data-table__wrapper>table>tbody>tr:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper):last-child:not(:hover) td:after{content:none}.pp-data-table.pp-data-table--actionable[data-v-4d4a0701] .v-data-table .v-data-table__wrapper>table>tbody>tr:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) td{background:transparent;border:none;color:#2b2b2b;font-size:1rem;font-weight:500;letter-spacing:.02em;line-height:1.4285714286rem;min-height:70px;padding:17px 20px;position:relative;z-index:2}.pp-data-table.pp-data-table--actionable[data-v-4d4a0701] .v-data-table .v-data-table__wrapper>table>tbody>tr:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) td:after{background:#d6d6d6;bottom:0;content:\"\";height:1px;left:0;position:absolute;top:auto;width:100%;z-index:-1}.pp-data-table.pp-data-table--actionable[data-v-4d4a0701] .v-data-table .v-data-table__wrapper>table>tbody>tr:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) td:first-child{padding-left:32px}.pp-data-table.pp-data-table--actionable[data-v-4d4a0701] .v-data-table .v-data-table__wrapper>table>tbody>tr:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) td:first-child:after{left:20px;width:calc(100% - 20px)}.pp-data-table.pp-data-table--actionable[data-v-4d4a0701] .v-data-table .v-data-table__wrapper>table>tbody>tr:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) td:last-child{padding-right:32px}.pp-data-table.pp-data-table--actionable[data-v-4d4a0701] .v-data-table .v-data-table__wrapper>table>tbody>tr:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) td:last-child:after{width:calc(100% - 20px)}.pp-data-table.pp-data-table--actionable[data-v-4d4a0701] .v-data-table .v-data-table__wrapper>table>tbody>tr:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) td:only-child{padding-left:32px;padding-right:32px}.pp-data-table.pp-data-table--actionable[data-v-4d4a0701] .v-data-table .v-data-table__wrapper>table>tbody>tr:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) td:only-child:after{left:20px;width:calc(100% - 40px)}.pp-data-table.pp-data-table--actionable[data-v-4d4a0701] .v-data-table .v-data-table__wrapper>table>tbody>tr:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper):first-child.editing td:after,.pp-data-table.pp-data-table--actionable[data-v-4d4a0701] .v-data-table .v-data-table__wrapper>table>tbody>tr:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper):first-child.selected td:after,.pp-data-table.pp-data-table--actionable[data-v-4d4a0701] .v-data-table .v-data-table__wrapper>table>tbody>tr:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper):first-child:hover td:after{height:100%}.pp-data-table.pp-data-table--actionable[data-v-4d4a0701] .v-data-table .v-data-table__wrapper>table>tbody>tr:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper).editing,.pp-data-table.pp-data-table--actionable[data-v-4d4a0701] .v-data-table .v-data-table__wrapper>table>tbody>tr:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper).selected,.pp-data-table.pp-data-table--actionable[data-v-4d4a0701] .v-data-table .v-data-table__wrapper>table>tbody>tr:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper):hover{background:transparent}.pp-data-table.pp-data-table--actionable[data-v-4d4a0701] .v-data-table .v-data-table__wrapper>table>tbody>tr:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper).editing td:after,.pp-data-table.pp-data-table--actionable[data-v-4d4a0701] .v-data-table .v-data-table__wrapper>table>tbody>tr:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper).selected td:after,.pp-data-table.pp-data-table--actionable[data-v-4d4a0701] .v-data-table .v-data-table__wrapper>table>tbody>tr:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper):hover td:after{background:#f6f6f6;height:calc(100% + 1px)}.pp-data-table.pp-data-table--actionable[data-v-4d4a0701] .v-data-table .v-data-table__wrapper>table>tbody>tr:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper).editing td:first-child:after,.pp-data-table.pp-data-table--actionable[data-v-4d4a0701] .v-data-table .v-data-table__wrapper>table>tbody>tr:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper).selected td:first-child:after,.pp-data-table.pp-data-table--actionable[data-v-4d4a0701] .v-data-table .v-data-table__wrapper>table>tbody>tr:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper):hover td:first-child:after{border-bottom-left-radius:8px;border-top-left-radius:8px;left:12px;width:calc(100% - 12px)}.pp-data-table.pp-data-table--actionable[data-v-4d4a0701] .v-data-table .v-data-table__wrapper>table>tbody>tr:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper).editing td:last-child:after,.pp-data-table.pp-data-table--actionable[data-v-4d4a0701] .v-data-table .v-data-table__wrapper>table>tbody>tr:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper).selected td:last-child:after,.pp-data-table.pp-data-table--actionable[data-v-4d4a0701] .v-data-table .v-data-table__wrapper>table>tbody>tr:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper):hover td:last-child:after{border-bottom-right-radius:8px;border-top-right-radius:8px;width:calc(100% - 12px)}.pp-data-table.pp-data-table--actionable[data-v-4d4a0701] .v-data-table .v-data-table__wrapper>table>tbody>tr:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper).editing td:only-child:after,.pp-data-table.pp-data-table--actionable[data-v-4d4a0701] .v-data-table .v-data-table__wrapper>table>tbody>tr:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper).selected td:only-child:after,.pp-data-table.pp-data-table--actionable[data-v-4d4a0701] .v-data-table .v-data-table__wrapper>table>tbody>tr:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper):hover td:only-child:after{border-radius:8px;left:12px;width:calc(100% - 24px)}.pp-data-table.pp-data-table--actionable[data-v-4d4a0701] .v-data-table .v-data-footer,.pp-data-table.pp-data-table--actionable[data-v-4d4a0701] .v-data-table .v-data-table__wrapper>table tr:last-child th{border-top:1px solid #d6d6d6}.pp-data-table:not(.pp-data-table--actionable) .v-data-table[data-v-4d4a0701]  .v-data-table .v-data-table__wrapper>table>thead.v-data-table-header tr th{color:#545454}.pp-data-table:not(.pp-data-table--actionable) .v-data-table[data-v-4d4a0701]  .v-data-table tr:last-child th{border-top:1px solid #d6d6d6}.pp-data-table:not(.pp-data-table--actionable) .v-data-table[data-v-4d4a0701]  .v-data-table tr:last-child td{border-bottom:1px solid #d6d6d6}.pp-data-table:not(.pp-data-table--actionable) .v-data-table .v-data-footer[data-v-4d4a0701]{border:none}.pp-data-table .v-data-table__empty-wrapper td[data-v-4d4a0701]{height:260px;position:relative;text-align:center}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "9417":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><circle cx=\"12\" cy=\"12\" r=\"9\" fill=\"white\"></circle><circle cx=\"12\" cy=\"12\" r=\"7\" fill=\"#DFE4E5\"></circle><path d=\"M12 23C5.925 23 1 18.075 1 12C1 5.925 5.925 1 12 1C18.075 1 23 5.925 23 12C23 18.075 18.075 23 12 23ZM12 21C16.9705 21 21 16.9705 21 12C21 7.0295 16.9705 3 12 3C7.0295 3 3 7.0295 3 12C3 16.9705 7.0295 21 12 21ZM13 17.376V18.5C13 18.7652 12.8946 19.0196 12.7071 19.2071C12.5196 19.3946 12.2652 19.5 12 19.5C11.7348 19.5 11.4804 19.3946 11.2929 19.2071C11.1054 19.0196 11 18.7652 11 18.5V17.3855C10.5159 17.2704 10.0542 17.0762 9.6335 16.8105C9.2205 16.5525 8.9245 16.287 8.747 16.084C8.57411 15.8841 8.48741 15.6238 8.50586 15.3601C8.5243 15.0965 8.64638 14.8508 8.84541 14.6769C9.04444 14.503 9.30424 14.4149 9.568 14.432C9.83177 14.4491 10.078 14.5699 10.253 14.768C10.31 14.8335 10.4635 14.971 10.694 15.115C11.081 15.357 11.5165 15.5 11.9955 15.5C12.9355 15.5 13.5495 14.943 13.497 14.461C13.4475 14.009 13.0305 13.661 11.699 12.9705L11.5395 12.8875C11.5336 12.8846 11.5278 12.8816 11.522 12.8785L11.3805 12.805C9.439 11.7985 8.6675 11.155 8.515 9.7565C8.3545 8.2875 9.4535 7.0155 11 6.624V5.5C11 5.23478 11.1054 4.98043 11.2929 4.79289C11.4804 4.60536 11.7348 4.5 12 4.5C12.2652 4.5 12.5196 4.60536 12.7071 4.79289C12.8946 4.98043 13 5.23478 13 5.5V6.6145C13.4841 6.72956 13.9458 6.92385 14.3665 7.1895C14.7795 7.4475 15.0755 7.713 15.253 7.916C15.4259 8.11593 15.5126 8.37618 15.4941 8.63986C15.4757 8.90353 15.3536 9.14917 15.1546 9.3231C14.9556 9.49702 14.6958 9.58507 14.432 9.568C14.1682 9.55093 13.922 9.43013 13.747 9.232C13.69 9.1665 13.5365 9.029 13.306 8.885C12.919 8.643 12.4835 8.5 12.0045 8.5C11.0645 8.5 10.4505 9.057 10.503 9.539C10.5525 9.991 10.9695 10.339 12.301 11.0295C12.4072 11.0845 12.5133 11.1395 12.6195 11.1945C14.561 12.2015 15.3325 12.8455 15.485 14.2435C15.6455 15.7125 14.5465 16.9845 13 17.376Z\" fill=\"#1F3A3E\"></path></svg>";

/***/ }),

/***/ "942b":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("c8d5")

/**
 * @category Month Helpers
 * @summary Return the start of a month for the given date.
 *
 * @description
 * Return the start of a month for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of a month
 *
 * @example
 * // The start of a month for 2 September 2014 11:55:00:
 * var result = startOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfMonth (dirtyDate) {
  var date = parse(dirtyDate)
  date.setDate(1)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = startOfMonth


/***/ }),

/***/ "94ca":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : typeof detection == 'function' ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

module.exports = isForced;


/***/ }),

/***/ "9530":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("c8d5")

/**
 * @category Day Helpers
 * @summary Set the day of the year to the given date.
 *
 * @description
 * Set the day of the year to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} dayOfYear - the day of the year of the new date
 * @returns {Date} the new date with the day of the year setted
 *
 * @example
 * // Set the 2nd day of the year to 2 July 2014:
 * var result = setDayOfYear(new Date(2014, 6, 2), 2)
 * //=> Thu Jan 02 2014 00:00:00
 */
function setDayOfYear (dirtyDate, dirtyDayOfYear) {
  var date = parse(dirtyDate)
  var dayOfYear = Number(dirtyDayOfYear)
  date.setMonth(0)
  date.setDate(dayOfYear)
  return date
}

module.exports = setDayOfYear


/***/ }),

/***/ "957f":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("c8d5")

/**
 * @category Day Helpers
 * @summary Set the day of the month to the given date.
 *
 * @description
 * Set the day of the month to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} dayOfMonth - the day of the month of the new date
 * @returns {Date} the new date with the day of the month setted
 *
 * @example
 * // Set the 30th day of the month to 1 September 2014:
 * var result = setDate(new Date(2014, 8, 1), 30)
 * //=> Tue Sep 30 2014 00:00:00
 */
function setDate (dirtyDate, dirtyDayOfMonth) {
  var date = parse(dirtyDate)
  var dayOfMonth = Number(dirtyDayOfMonth)
  date.setDate(dayOfMonth)
  return date
}

module.exports = setDate


/***/ }),

/***/ "95ea":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("c8d5")

/**
 * @category Common Helpers
 * @summary Return the latest of the given dates.
 *
 * @description
 * Return the latest of the given dates.
 *
 * @param {...(Date|String|Number)} dates - the dates to compare
 * @returns {Date} the latest of the dates
 *
 * @example
 * // Which of these dates is the latest?
 * var result = max(
 *   new Date(1989, 6, 10),
 *   new Date(1987, 1, 11),
 *   new Date(1995, 6, 2),
 *   new Date(1990, 0, 1)
 * )
 * //=> Sun Jul 02 1995 00:00:00
 */
function max () {
  var dirtyDates = Array.prototype.slice.call(arguments)
  var dates = dirtyDates.map(function (dirtyDate) {
    return parse(dirtyDate)
  })
  var latestTimestamp = Math.max.apply(null, dates)
  return new Date(latestTimestamp)
}

module.exports = max


/***/ }),

/***/ "95ed":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("7916");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("1fbbad14", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "96cf":
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = (function (exports) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
    return obj[key];
  }
  try {
    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
    define({}, "");
  } catch (err) {
    define = function(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunction.displayName = define(
    GeneratorFunctionPrototype,
    toStringTagSymbol,
    "GeneratorFunction"
  );

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      define(prototype, method, function(arg) {
        return this._invoke(method, arg);
      });
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      define(genFun, toStringTagSymbol, "GeneratorFunction");
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;

    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList),
      PromiseImpl
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        // Note: ["return"] must be used for ES3 parsing compatibility.
        if (delegate.iterator["return"]) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  define(Gp, toStringTagSymbol, "Generator");

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
   true ? module.exports : undefined
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  Function("r", "regeneratorRuntime = r")(runtime);
}


/***/ }),

/***/ "9706":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("c8d5")
var startOfISOYear = __webpack_require__("4497")
var differenceInCalendarDays = __webpack_require__("d420")

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Set the ISO week-numbering year to the given date.
 *
 * @description
 * Set the ISO week-numbering year to the given date,
 * saving the week number and the weekday number.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} isoYear - the ISO week-numbering year of the new date
 * @returns {Date} the new date with the ISO week-numbering year setted
 *
 * @example
 * // Set ISO week-numbering year 2007 to 29 December 2008:
 * var result = setISOYear(new Date(2008, 11, 29), 2007)
 * //=> Mon Jan 01 2007 00:00:00
 */
function setISOYear (dirtyDate, dirtyISOYear) {
  var date = parse(dirtyDate)
  var isoYear = Number(dirtyISOYear)
  var diff = differenceInCalendarDays(date, startOfISOYear(date))
  var fourthOfJanuary = new Date(0)
  fourthOfJanuary.setFullYear(isoYear, 0, 4)
  fourthOfJanuary.setHours(0, 0, 0, 0)
  date = startOfISOYear(fourthOfJanuary)
  date.setDate(date.getDate() + diff)
  return date
}

module.exports = setISOYear


/***/ }),

/***/ "9734":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("eb69");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("ba29df18", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "9744":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("c8d5")

/**
 * @category Day Helpers
 * @summary Return the end of a day for the given date.
 *
 * @description
 * Return the end of a day for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of a day
 *
 * @example
 * // The end of a day for 2 September 2014 11:55:00:
 * var result = endOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 23:59:59.999
 */
function endOfDay (dirtyDate) {
  var date = parse(dirtyDate)
  date.setHours(23, 59, 59, 999)
  return date
}

module.exports = endOfDay


/***/ }),

/***/ "97a7":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M3 3H21V15H17L15 16L12 18.5L9 16L6.5 15H3V3Z\" fill=\"#DFE4E5\"></path><path d=\"M8 15H4L3 16V20L4 21H20L21 20V16L20 15H16L14 17L12 18L10 17L8 15Z\" fill=\"white\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2 4.82C2 3.2615 3.12 2 4.5035 2H19.4965C20.878 2 22 3.265 22 4.82V19.18C22 20.7385 20.88 22 19.4965 22H4.5035C3.122 22 2 20.735 2 19.18V4.82ZM16.4985 16C16.1015 16 15.6005 16.361 15.475 16.737L15.4225 16.8955C15.0245 18.0885 13.7595 19 12.5015 19H11.4985C10.2405 19 8.9755 18.0885 8.5775 16.895L8.525 16.737C8.3995 16.361 7.899 16 7.5015 16H4V19.4985C4 19.776 4.225 20 4.5035 20H19.4965C19.776 20 20 19.776 20 19.4985V16H16.4985ZM20 14V4.5C20 4.2265 19.7735 4 19.4965 4H4.5035C4.43755 3.99954 4.37215 4.01213 4.31108 4.03705C4.25002 4.06197 4.19448 4.09873 4.14768 4.1452C4.10088 4.19168 4.06374 4.24695 4.03839 4.30785C4.01305 4.36874 4 4.43404 4 4.5V14H7.5015C8.7595 14 10.0245 14.9115 10.4225 16.105L10.475 16.263C10.6005 16.639 11.1015 17 11.4985 17H12.5015C12.899 17 13.3995 16.639 13.525 16.263L13.5775 16.1045C13.9755 14.9115 15.2405 14 16.4985 14H20ZM8.5 8.5C8.23478 8.5 7.98043 8.39464 7.79289 8.20711C7.60536 8.01957 7.5 7.76522 7.5 7.5C7.5 7.23478 7.60536 6.98043 7.79289 6.79289C7.98043 6.60536 8.23478 6.5 8.5 6.5H15.5C15.7652 6.5 16.0196 6.60536 16.2071 6.79289C16.3946 6.98043 16.5 7.23478 16.5 7.5C16.5 7.76522 16.3946 8.01957 16.2071 8.20711C16.0196 8.39464 15.7652 8.5 15.5 8.5H8.5ZM8.5 11.5C8.23478 11.5 7.98043 11.3946 7.79289 11.2071C7.60536 11.0196 7.5 10.7652 7.5 10.5C7.5 10.2348 7.60536 9.98043 7.79289 9.79289C7.98043 9.60536 8.23478 9.5 8.5 9.5H15.5C15.7652 9.5 16.0196 9.60536 16.2071 9.79289C16.3946 9.98043 16.5 10.2348 16.5 10.5C16.5 10.7652 16.3946 11.0196 16.2071 11.2071C16.0196 11.3946 15.7652 11.5 15.5 11.5H8.5Z\" fill=\"#688083\"></path></svg>";

/***/ }),

/***/ "97af":
/***/ (function(module, exports, __webpack_require__) {

var isSameISOYear = __webpack_require__("2fff")

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Is the given date in the same ISO week-numbering year as the current date?
 *
 * @description
 * Is the given date in the same ISO week-numbering year as the current date?
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in this ISO week-numbering year
 *
 * @example
 * // If today is 25 September 2014,
 * // is 30 December 2013 in this ISO week-numbering year?
 * var result = isThisISOYear(new Date(2013, 11, 30))
 * //=> true
 */
function isThisISOYear (dirtyDate) {
  return isSameISOYear(new Date(), dirtyDate)
}

module.exports = isThisISOYear


/***/ }),

/***/ "9861":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// TODO: in core-js@4, move /modules/ dependencies to public entries for better optimization by tools like `preset-env`
__webpack_require__("e260");
var $ = __webpack_require__("23e7");
var getBuiltIn = __webpack_require__("d066");
var USE_NATIVE_URL = __webpack_require__("0d3b");
var redefine = __webpack_require__("6eeb");
var redefineAll = __webpack_require__("e2cc");
var setToStringTag = __webpack_require__("d44e");
var createIteratorConstructor = __webpack_require__("9ed3");
var InternalStateModule = __webpack_require__("69f3");
var anInstance = __webpack_require__("19aa");
var hasOwn = __webpack_require__("5135");
var bind = __webpack_require__("0366");
var classof = __webpack_require__("f5df");
var anObject = __webpack_require__("825a");
var isObject = __webpack_require__("861d");
var create = __webpack_require__("7c73");
var createPropertyDescriptor = __webpack_require__("5c6c");
var getIterator = __webpack_require__("9a1f");
var getIteratorMethod = __webpack_require__("35a1");
var wellKnownSymbol = __webpack_require__("b622");

var $fetch = getBuiltIn('fetch');
var Headers = getBuiltIn('Headers');
var ITERATOR = wellKnownSymbol('iterator');
var URL_SEARCH_PARAMS = 'URLSearchParams';
var URL_SEARCH_PARAMS_ITERATOR = URL_SEARCH_PARAMS + 'Iterator';
var setInternalState = InternalStateModule.set;
var getInternalParamsState = InternalStateModule.getterFor(URL_SEARCH_PARAMS);
var getInternalIteratorState = InternalStateModule.getterFor(URL_SEARCH_PARAMS_ITERATOR);

var plus = /\+/g;
var sequences = Array(4);

var percentSequence = function (bytes) {
  return sequences[bytes - 1] || (sequences[bytes - 1] = RegExp('((?:%[\\da-f]{2}){' + bytes + '})', 'gi'));
};

var percentDecode = function (sequence) {
  try {
    return decodeURIComponent(sequence);
  } catch (error) {
    return sequence;
  }
};

var deserialize = function (it) {
  var result = it.replace(plus, ' ');
  var bytes = 4;
  try {
    return decodeURIComponent(result);
  } catch (error) {
    while (bytes) {
      result = result.replace(percentSequence(bytes--), percentDecode);
    }
    return result;
  }
};

var find = /[!'()~]|%20/g;

var replace = {
  '!': '%21',
  "'": '%27',
  '(': '%28',
  ')': '%29',
  '~': '%7E',
  '%20': '+'
};

var replacer = function (match) {
  return replace[match];
};

var serialize = function (it) {
  return encodeURIComponent(it).replace(find, replacer);
};

var parseSearchParams = function (result, query) {
  if (query) {
    var attributes = query.split('&');
    var index = 0;
    var attribute, entry;
    while (index < attributes.length) {
      attribute = attributes[index++];
      if (attribute.length) {
        entry = attribute.split('=');
        result.push({
          key: deserialize(entry.shift()),
          value: deserialize(entry.join('='))
        });
      }
    }
  }
};

var updateSearchParams = function (query) {
  this.entries.length = 0;
  parseSearchParams(this.entries, query);
};

var validateArgumentsLength = function (passed, required) {
  if (passed < required) throw TypeError('Not enough arguments');
};

var URLSearchParamsIterator = createIteratorConstructor(function Iterator(params, kind) {
  setInternalState(this, {
    type: URL_SEARCH_PARAMS_ITERATOR,
    iterator: getIterator(getInternalParamsState(params).entries),
    kind: kind
  });
}, 'Iterator', function next() {
  var state = getInternalIteratorState(this);
  var kind = state.kind;
  var step = state.iterator.next();
  var entry = step.value;
  if (!step.done) {
    step.value = kind === 'keys' ? entry.key : kind === 'values' ? entry.value : [entry.key, entry.value];
  } return step;
});

// `URLSearchParams` constructor
// https://url.spec.whatwg.org/#interface-urlsearchparams
var URLSearchParamsConstructor = function URLSearchParams(/* init */) {
  anInstance(this, URLSearchParamsConstructor, URL_SEARCH_PARAMS);
  var init = arguments.length > 0 ? arguments[0] : undefined;
  var that = this;
  var entries = [];
  var iteratorMethod, iterator, next, step, entryIterator, entryNext, first, second, key;

  setInternalState(that, {
    type: URL_SEARCH_PARAMS,
    entries: entries,
    updateURL: function () { /* empty */ },
    updateSearchParams: updateSearchParams
  });

  if (init !== undefined) {
    if (isObject(init)) {
      iteratorMethod = getIteratorMethod(init);
      if (typeof iteratorMethod === 'function') {
        iterator = iteratorMethod.call(init);
        next = iterator.next;
        while (!(step = next.call(iterator)).done) {
          entryIterator = getIterator(anObject(step.value));
          entryNext = entryIterator.next;
          if (
            (first = entryNext.call(entryIterator)).done ||
            (second = entryNext.call(entryIterator)).done ||
            !entryNext.call(entryIterator).done
          ) throw TypeError('Expected sequence with length 2');
          entries.push({ key: first.value + '', value: second.value + '' });
        }
      } else for (key in init) if (hasOwn(init, key)) entries.push({ key: key, value: init[key] + '' });
    } else {
      parseSearchParams(entries, typeof init === 'string' ? init.charAt(0) === '?' ? init.slice(1) : init : init + '');
    }
  }
};

var URLSearchParamsPrototype = URLSearchParamsConstructor.prototype;

redefineAll(URLSearchParamsPrototype, {
  // `URLSearchParams.prototype.append` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-append
  append: function append(name, value) {
    validateArgumentsLength(arguments.length, 2);
    var state = getInternalParamsState(this);
    state.entries.push({ key: name + '', value: value + '' });
    state.updateURL();
  },
  // `URLSearchParams.prototype.delete` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-delete
  'delete': function (name) {
    validateArgumentsLength(arguments.length, 1);
    var state = getInternalParamsState(this);
    var entries = state.entries;
    var key = name + '';
    var index = 0;
    while (index < entries.length) {
      if (entries[index].key === key) entries.splice(index, 1);
      else index++;
    }
    state.updateURL();
  },
  // `URLSearchParams.prototype.get` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-get
  get: function get(name) {
    validateArgumentsLength(arguments.length, 1);
    var entries = getInternalParamsState(this).entries;
    var key = name + '';
    var index = 0;
    for (; index < entries.length; index++) {
      if (entries[index].key === key) return entries[index].value;
    }
    return null;
  },
  // `URLSearchParams.prototype.getAll` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-getall
  getAll: function getAll(name) {
    validateArgumentsLength(arguments.length, 1);
    var entries = getInternalParamsState(this).entries;
    var key = name + '';
    var result = [];
    var index = 0;
    for (; index < entries.length; index++) {
      if (entries[index].key === key) result.push(entries[index].value);
    }
    return result;
  },
  // `URLSearchParams.prototype.has` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-has
  has: function has(name) {
    validateArgumentsLength(arguments.length, 1);
    var entries = getInternalParamsState(this).entries;
    var key = name + '';
    var index = 0;
    while (index < entries.length) {
      if (entries[index++].key === key) return true;
    }
    return false;
  },
  // `URLSearchParams.prototype.set` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-set
  set: function set(name, value) {
    validateArgumentsLength(arguments.length, 1);
    var state = getInternalParamsState(this);
    var entries = state.entries;
    var found = false;
    var key = name + '';
    var val = value + '';
    var index = 0;
    var entry;
    for (; index < entries.length; index++) {
      entry = entries[index];
      if (entry.key === key) {
        if (found) entries.splice(index--, 1);
        else {
          found = true;
          entry.value = val;
        }
      }
    }
    if (!found) entries.push({ key: key, value: val });
    state.updateURL();
  },
  // `URLSearchParams.prototype.sort` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-sort
  sort: function sort() {
    var state = getInternalParamsState(this);
    var entries = state.entries;
    // Array#sort is not stable in some engines
    var slice = entries.slice();
    var entry, entriesIndex, sliceIndex;
    entries.length = 0;
    for (sliceIndex = 0; sliceIndex < slice.length; sliceIndex++) {
      entry = slice[sliceIndex];
      for (entriesIndex = 0; entriesIndex < sliceIndex; entriesIndex++) {
        if (entries[entriesIndex].key > entry.key) {
          entries.splice(entriesIndex, 0, entry);
          break;
        }
      }
      if (entriesIndex === sliceIndex) entries.push(entry);
    }
    state.updateURL();
  },
  // `URLSearchParams.prototype.forEach` method
  forEach: function forEach(callback /* , thisArg */) {
    var entries = getInternalParamsState(this).entries;
    var boundFunction = bind(callback, arguments.length > 1 ? arguments[1] : undefined, 3);
    var index = 0;
    var entry;
    while (index < entries.length) {
      entry = entries[index++];
      boundFunction(entry.value, entry.key, this);
    }
  },
  // `URLSearchParams.prototype.keys` method
  keys: function keys() {
    return new URLSearchParamsIterator(this, 'keys');
  },
  // `URLSearchParams.prototype.values` method
  values: function values() {
    return new URLSearchParamsIterator(this, 'values');
  },
  // `URLSearchParams.prototype.entries` method
  entries: function entries() {
    return new URLSearchParamsIterator(this, 'entries');
  }
}, { enumerable: true });

// `URLSearchParams.prototype[@@iterator]` method
redefine(URLSearchParamsPrototype, ITERATOR, URLSearchParamsPrototype.entries);

// `URLSearchParams.prototype.toString` method
// https://url.spec.whatwg.org/#urlsearchparams-stringification-behavior
redefine(URLSearchParamsPrototype, 'toString', function toString() {
  var entries = getInternalParamsState(this).entries;
  var result = [];
  var index = 0;
  var entry;
  while (index < entries.length) {
    entry = entries[index++];
    result.push(serialize(entry.key) + '=' + serialize(entry.value));
  } return result.join('&');
}, { enumerable: true });

setToStringTag(URLSearchParamsConstructor, URL_SEARCH_PARAMS);

$({ global: true, forced: !USE_NATIVE_URL }, {
  URLSearchParams: URLSearchParamsConstructor
});

// Wrap `fetch` for correct work with polyfilled `URLSearchParams`
// https://github.com/zloirock/core-js/issues/674
if (!USE_NATIVE_URL && typeof $fetch == 'function' && typeof Headers == 'function') {
  $({ global: true, enumerable: true, forced: true }, {
    fetch: function fetch(input /* , init */) {
      var args = [input];
      var init, body, headers;
      if (arguments.length > 1) {
        init = arguments[1];
        if (isObject(init)) {
          body = init.body;
          if (classof(body) === URL_SEARCH_PARAMS) {
            headers = init.headers ? new Headers(init.headers) : new Headers();
            if (!headers.has('content-type')) {
              headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
            }
            init = create(init, {
              body: createPropertyDescriptor(0, String(body)),
              headers: createPropertyDescriptor(0, headers)
            });
          }
        }
        args.push(init);
      } return $fetch.apply(this, args);
    }
  });
}

module.exports = {
  URLSearchParams: URLSearchParamsConstructor,
  getState: getInternalParamsState
};


/***/ }),

/***/ "9864":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.v-simple-checkbox{align-self:center;line-height:normal;position:relative;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:pointer}.v-simple-checkbox--disabled{cursor:default}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "9911":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var createHTML = __webpack_require__("857a");
var forcedStringHTMLMethod = __webpack_require__("af03");

// `String.prototype.link` method
// https://tc39.es/ecma262/#sec-string.prototype.link
$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('link') }, {
  link: function link(url) {
    return createHTML(this, 'a', 'href', url);
  }
});


/***/ }),

/***/ "99af":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var fails = __webpack_require__("d039");
var isArray = __webpack_require__("e8b5");
var isObject = __webpack_require__("861d");
var toObject = __webpack_require__("7b0b");
var toLength = __webpack_require__("50c4");
var createProperty = __webpack_require__("8418");
var arraySpeciesCreate = __webpack_require__("65f0");
var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");
var wellKnownSymbol = __webpack_require__("b622");
var V8_VERSION = __webpack_require__("2d00");

var IS_CONCAT_SPREADABLE = wellKnownSymbol('isConcatSpreadable');
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
var MAXIMUM_ALLOWED_INDEX_EXCEEDED = 'Maximum allowed index exceeded';

// We can't use this feature detection in V8 since it causes
// deoptimization and serious performance degradation
// https://github.com/zloirock/core-js/issues/679
var IS_CONCAT_SPREADABLE_SUPPORT = V8_VERSION >= 51 || !fails(function () {
  var array = [];
  array[IS_CONCAT_SPREADABLE] = false;
  return array.concat()[0] !== array;
});

var SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('concat');

var isConcatSpreadable = function (O) {
  if (!isObject(O)) return false;
  var spreadable = O[IS_CONCAT_SPREADABLE];
  return spreadable !== undefined ? !!spreadable : isArray(O);
};

var FORCED = !IS_CONCAT_SPREADABLE_SUPPORT || !SPECIES_SUPPORT;

// `Array.prototype.concat` method
// https://tc39.es/ecma262/#sec-array.prototype.concat
// with adding support of @@isConcatSpreadable and @@species
$({ target: 'Array', proto: true, forced: FORCED }, {
  concat: function concat(arg) { // eslint-disable-line no-unused-vars
    var O = toObject(this);
    var A = arraySpeciesCreate(O, 0);
    var n = 0;
    var i, k, length, len, E;
    for (i = -1, length = arguments.length; i < length; i++) {
      E = i === -1 ? O : arguments[i];
      if (isConcatSpreadable(E)) {
        len = toLength(E.length);
        if (n + len > MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
        for (k = 0; k < len; k++, n++) if (k in E) createProperty(A, n, E[k]);
      } else {
        if (n >= MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
        createProperty(A, n++, E);
      }
    }
    A.length = n;
    return A;
  }
});


/***/ }),

/***/ "99d9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VCardActions; });
/* unused harmony export VCardSubtitle */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VCardText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return VCardTitle; });
/* harmony import */ var _VCard__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("b0af");
/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("80d2");


var VCardActions = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_1__[/* createSimpleFunctional */ "i"])('v-card__actions');
var VCardSubtitle = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_1__[/* createSimpleFunctional */ "i"])('v-card__subtitle');
var VCardText = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_1__[/* createSimpleFunctional */ "i"])('v-card__text');
var VCardTitle = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_1__[/* createSimpleFunctional */ "i"])('v-card__title');

/* unused harmony default export */ var _unused_webpack_default_export = ({
  $_vuetify_subcomponents: {
    VCard: _VCard__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"],
    VCardActions: VCardActions,
    VCardSubtitle: VCardSubtitle,
    VCardText: VCardText,
    VCardTitle: VCardTitle
  }
});

/***/ }),

/***/ "9a0c":
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/zloirock/core-js/issues/280
var userAgent = __webpack_require__("342f");

// eslint-disable-next-line unicorn/no-unsafe-regex
module.exports = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);


/***/ }),

/***/ "9a1f":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("825a");
var getIteratorMethod = __webpack_require__("35a1");

module.exports = function (it) {
  var iteratorMethod = getIteratorMethod(it);
  if (typeof iteratorMethod != 'function') {
    throw TypeError(String(it) + ' is not iterable');
  } return anObject(iteratorMethod.call(it));
};


/***/ }),

/***/ "9a42":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.theme--light.v-date-picker-header .v-date-picker-header__value:not(.v-date-picker-header__value--disabled) button:not(:hover):not(:focus){color:var(--pp-text-primary,#2b2b2b)}.theme--light.v-date-picker-header .v-date-picker-header__value--disabled button{color:var(--pp-text-disabled,#f6f6f6)}.theme--dark.v-date-picker-header .v-date-picker-header__value:not(.v-date-picker-header__value--disabled) button:not(:hover):not(:focus){color:var(--pp-primary-button-text-color,#004852)}.theme--dark.v-date-picker-header .v-date-picker-header__value--disabled button{color:hsla(0,0%,100%,.5)}.v-date-picker-header{padding:4px 16px;align-items:center;display:flex;justify-content:space-between;position:relative}.v-date-picker-header .v-btn{margin:0;z-index:auto}.v-date-picker-header .v-icon{cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.v-date-picker-header__value{flex:1;text-align:center;position:relative;overflow:hidden}.v-date-picker-header__value div{transition:.3s cubic-bezier(.25,.8,.5,1);width:100%}.v-date-picker-header__value button{cursor:pointer;font-weight:700;outline:none;padding:.5rem;transition:.3s cubic-bezier(.25,.8,.5,1)}.v-date-picker-header--disabled{pointer-events:none}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "9a87":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.v-item-group{flex:0 1 auto;position:relative;max-width:100%;transition:.3s cubic-bezier(.25,.8,.5,1)}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "9aaa":
/***/ (function(module, exports, __webpack_require__) {

var startOfQuarter = __webpack_require__("4399")

/**
 * @category Quarter Helpers
 * @summary Are the given dates in the same year quarter?
 *
 * @description
 * Are the given dates in the same year quarter?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same quarter
 *
 * @example
 * // Are 1 January 2014 and 8 March 2014 in the same quarter?
 * var result = isSameQuarter(
 *   new Date(2014, 0, 1),
 *   new Date(2014, 2, 8)
 * )
 * //=> true
 */
function isSameQuarter (dirtyDateLeft, dirtyDateRight) {
  var dateLeftStartOfQuarter = startOfQuarter(dirtyDateLeft)
  var dateRightStartOfQuarter = startOfQuarter(dirtyDateRight)

  return dateLeftStartOfQuarter.getTime() === dateRightStartOfQuarter.getTime()
}

module.exports = isSameQuarter


/***/ }),

/***/ "9aae":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("b87f");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("25c8802d", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "9ad8":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("c8d5")

/**
 * @category Weekday Helpers
 * @summary Does the given date fall on a weekend?
 *
 * @description
 * Does the given date fall on a weekend?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date falls on a weekend
 *
 * @example
 * // Does 5 October 2014 fall on a weekend?
 * var result = isWeekend(new Date(2014, 9, 5))
 * //=> true
 */
function isWeekend (dirtyDate) {
  var date = parse(dirtyDate)
  var day = date.getDay()
  return day === 0 || day === 6
}

module.exports = isWeekend


/***/ }),

/***/ "9b0c":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.theme--light.v-list-item--disabled{color:var(--pp-text-disabled,#f6f6f6)}.theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled){color:var(--pp-text-primary,#2b2b2b)!important}.theme--light.v-list-item .v-list-item__mask{color:var(--pp-text-disabled,#f6f6f6);background:#f6f6f6}.theme--light.v-list-item .v-list-item__action-text,.theme--light.v-list-item .v-list-item__subtitle{color:var(--pp-text-secondary,#2b2b2b)}.theme--light.v-list-item:hover:before{opacity:.1}.theme--light.v-list-item--active:before,.theme--light.v-list-item--active:hover:before,.theme--light.v-list-item:focus:before{opacity:.12}.theme--light.v-list-item--active:focus:before,.theme--light.v-list-item.v-list-item--highlighted:before{opacity:.16}.theme--dark.v-list-item--disabled{color:hsla(0,0%,100%,.5)}.theme--dark.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled){color:var(--pp-primary-button-text-color,#004852)!important}.theme--dark.v-list-item .v-list-item__mask{color:hsla(0,0%,100%,.5);background:#494949}.theme--dark.v-list-item .v-list-item__action-text,.theme--dark.v-list-item .v-list-item__subtitle{color:hsla(0,0%,100%,.7)}.theme--dark.v-list-item:hover:before{opacity:.08}.theme--dark.v-list-item--active:before,.theme--dark.v-list-item--active:hover:before,.theme--dark.v-list-item:focus:before{opacity:.24}.theme--dark.v-list-item--active:focus:before,.theme--dark.v-list-item.v-list-item--highlighted:before{opacity:.32}.v-list-item{align-items:center;display:flex;flex:1 1 100%;letter-spacing:normal;min-height:24px;outline:none;padding:var(--pp-list-item-padding,0 16px);position:relative;text-decoration:none}.v-list-item--disabled{pointer-events:none}.v-list-item--selectable{-webkit-user-select:auto;-moz-user-select:auto;-ms-user-select:auto;user-select:auto}.v-list-item:after{content:\"\";min-height:inherit;font-size:0}.v-list-item__action{align-self:center;margin:var(--pp-list-item-action-margin,6px 0)}.v-list-item__action .v-input,.v-list-item__action .v-input--selection-controls__input,.v-list-item__action .v-input__control,.v-list-item__action .v-input__slot{margin:0!important}.v-list-item__action .v-input{padding:0}.v-list-item__action .v-input .v-messages{display:none}.v-list-item__action-text{font-size:.75rem}.v-list-item__avatar{align-self:center;justify-content:flex-start}.v-list-item__avatar,.v-list-item__avatar.v-list-item__avatar--horizontal{margin-bottom:8px;margin-top:8px}.v-application--is-ltr .v-list-item__avatar.v-list-item__avatar--horizontal:first-child{margin-left:-16px}.v-application--is-rtl .v-list-item__avatar.v-list-item__avatar--horizontal:first-child{margin-right:-16px}.v-application--is-ltr .v-list-item__avatar.v-list-item__avatar--horizontal:last-child{margin-left:-16px}.v-application--is-rtl .v-list-item__avatar.v-list-item__avatar--horizontal:last-child{margin-right:-16px}.v-list-item__content{align-items:center;align-self:center;display:flex;flex-wrap:wrap;flex:1 1;overflow:hidden;padding:var(--pp-list-item-content-padding,12px 0)}.v-list-item__content>*{line-height:1.1;flex:1 0 100%}.v-list-item__content>:not(:last-child){margin-bottom:2px}.v-list-item__icon{align-self:flex-start;margin:16px 0}.v-application--is-ltr .v-list-item__action:last-of-type:not(:only-child),.v-application--is-ltr .v-list-item__avatar:last-of-type:not(:only-child),.v-application--is-ltr .v-list-item__icon:last-of-type:not(:only-child){margin-left:16px}.v-application--is-ltr .v-list-item__avatar:first-child,.v-application--is-rtl .v-list-item__action:last-of-type:not(:only-child),.v-application--is-rtl .v-list-item__avatar:last-of-type:not(:only-child),.v-application--is-rtl .v-list-item__icon:last-of-type:not(:only-child){margin-right:16px}.v-application--is-rtl .v-list-item__avatar:first-child{margin-left:16px}.v-application--is-ltr .v-list-item__action:first-child,.v-application--is-ltr .v-list-item__icon:first-child{margin-right:32px}.v-application--is-rtl .v-list-item__action:first-child,.v-application--is-rtl .v-list-item__icon:first-child{margin-left:32px}.v-list-item__action,.v-list-item__avatar,.v-list-item__icon{display:inline-flex;min-width:24px}.v-list-item .v-list-item__subtitle,.v-list-item .v-list-item__title{line-height:var(--pp-list-item-title-subtitle-line-height,1.2)}.v-list-item__subtitle,.v-list-item__title{flex:1 1 100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.v-list-item__title{align-self:center;font-size:var(--pp-list-item-title-font-size,.8571428571rem)}.v-list-item__title>.v-badge{margin-top:16px}.v-list-item__subtitle{font-size:.7142857143rem}.v-list--dense .v-list-item,.v-list-item--dense{min-height:0}.v-list--dense .v-list-item .v-list-item__icon,.v-list-item--dense .v-list-item__icon{height:24px;margin-top:8px;margin-bottom:8px}.v-list--dense .v-list-item .v-list-item__content,.v-list-item--dense .v-list-item__content{padding:8px 0}.v-list--dense .v-list-item .v-list-item__subtitle,.v-list--dense .v-list-item .v-list-item__title,.v-list-item--dense .v-list-item__subtitle,.v-list-item--dense .v-list-item__title{font-size:.8125rem;font-weight:500;line-height:1rem}.v-list--dense .v-list-item.v-list-item--two-line,.v-list-item--dense.v-list-item--two-line{min-height:60px}.v-list--dense .v-list-item.v-list-item--three-line,.v-list-item--dense.v-list-item--three-line{min-height:76px}.v-list-item--link{cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.v-list-item--link:before{background-color:currentColor;bottom:0;content:\"\";left:0;opacity:0;pointer-events:none;position:absolute;right:0;top:0;transition:.3s cubic-bezier(.25,.8,.5,1)}.v-list .v-list-item--active,.v-list .v-list-item--active .v-icon{color:inherit}.v-list-item__action--stack{align-items:flex-end;align-self:stretch;justify-content:space-between;white-space:nowrap;flex-direction:column}.v-list--three-line .v-list-item .v-list-item__avatar:not(.v-list-item__avatar--horizontal),.v-list--three-line .v-list-item .v-list-item__icon,.v-list--two-line .v-list-item .v-list-item__avatar:not(.v-list-item__avatar--horizontal),.v-list--two-line .v-list-item .v-list-item__icon,.v-list-item--three-line .v-list-item__avatar:not(.v-list-item__avatar--horizontal),.v-list-item--three-line .v-list-item__icon,.v-list-item--two-line .v-list-item__avatar:not(.v-list-item__avatar--horizontal),.v-list-item--two-line .v-list-item__icon{margin-bottom:16px;margin-top:16px}.v-list--two-line .v-list-item,.v-list-item--two-line{min-height:64px}.v-list--two-line .v-list-item .v-list-item__icon,.v-list-item--two-line .v-list-item__icon{margin-bottom:32px}.v-list--three-line .v-list-item,.v-list-item--three-line{min-height:88px}.v-list--three-line .v-list-item .v-list-item__action,.v-list--three-line .v-list-item .v-list-item__avatar,.v-list-item--three-line .v-list-item__action,.v-list-item--three-line .v-list-item__avatar{align-self:flex-start;margin-top:16px;margin-bottom:16px}.v-list--three-line .v-list-item .v-list-item__content,.v-list-item--three-line .v-list-item__content{align-self:stretch}.v-list--three-line .v-list-item .v-list-item__subtitle,.v-list-item--three-line .v-list-item__subtitle{white-space:normal;-webkit-line-clamp:2;-webkit-box-orient:vertical;display:-webkit-box}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "9b3e":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><rect x=\"3\" y=\"3\" width=\"18\" height=\"18\" rx=\"2\" stroke=\"#079CB2\" stroke-width=\"2\"></rect><mask id=\"path-2-inside-1_167_189\" fill=\"white\"><rect x=\"6\" y=\"6\" width=\"8\" height=\"6\" rx=\"0.5\"></rect></mask><rect x=\"6\" y=\"6\" width=\"8\" height=\"6\" rx=\"0.5\" fill=\"#D5EAFD\" stroke=\"#079CB2\" stroke-width=\"4\" mask=\"url(#path-2-inside-1_167_189)\"></rect><rect x=\"6\" y=\"11\" width=\"2\" height=\"7\" rx=\"0.5\" fill=\"#079CB2\"></rect><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M17.1563 18.8535C16.9612 19.0487 16.6449 19.049 16.4495 18.8541L9.46329 11.8852C9.26766 11.69 9.26741 11.3732 9.46275 11.1777L10.1576 10.4825C10.3527 10.2873 10.669 10.2871 10.8644 10.4819L17.8506 17.4508C18.0462 17.6459 18.0465 17.9628 17.8512 18.1582L17.1563 18.8535Z\" fill=\"#079CB2\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M17.8523 11.8405C18.0474 12.0358 18.0474 12.3522 17.8523 12.5474L11.5505 18.853C11.3553 19.0484 11.0385 19.0484 10.8432 18.853L10.1484 18.1577C9.95325 17.9624 9.95326 17.646 10.1484 17.4508L16.4502 11.1453C16.6455 10.9499 16.9622 10.9499 17.1575 11.1453L17.8523 11.8405Z\" fill=\"#079CB2\"></path></svg>";

/***/ }),

/***/ "9b7d":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("bf67");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("fe2c0dac", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "9bb9":
/***/ (function(module, exports, __webpack_require__) {

var isSameMonth = __webpack_require__("5a60")

/**
 * @category Month Helpers
 * @summary Is the given date in the same month as the current date?
 *
 * @description
 * Is the given date in the same month as the current date?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in this month
 *
 * @example
 * // If today is 25 September 2014, is 15 September 2014 in this month?
 * var result = isThisMonth(new Date(2014, 8, 15))
 * //=> true
 */
function isThisMonth (dirtyDate) {
  return isSameMonth(new Date(), dirtyDate)
}

module.exports = isThisMonth


/***/ }),

/***/ "9bdd":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("825a");
var iteratorClose = __webpack_require__("2a62");

// call something on iterator step with safe closing on error
module.exports = function (iterator, fn, value, ENTRIES) {
  try {
    return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (error) {
    iteratorClose(iterator);
    throw error;
  }
};


/***/ }),

/***/ "9bdf":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("3b6e");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("7bec8427", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "9bf2":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var IE8_DOM_DEFINE = __webpack_require__("0cfb");
var anObject = __webpack_require__("825a");
var toPrimitive = __webpack_require__("c04e");

var nativeDefineProperty = Object.defineProperty;

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
exports.f = DESCRIPTORS ? nativeDefineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return nativeDefineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ "9c8a":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("753d");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("88f1daf4", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "9c90":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("1464");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("3130370d", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "9cb1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpInputColor_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("d512");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpInputColor_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpInputColor_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "9cd2":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><rect x=\"3\" y=\"4\" width=\"18\" height=\"19\" rx=\"3\" fill=\"white\"></rect><rect x=\"8\" y=\"3\" width=\"8\" height=\"3\" fill=\"#DFE4E5\"></rect><path d=\"M6.71 4C6.90441 3.55503 7.22412 3.17626 7.63014 2.9099C8.03615 2.64355 8.51092 2.50112 8.9965 2.5H9.2075C9.40223 2.05382 9.72299 1.67421 10.1304 1.40774C10.5378 1.14128 11.0142 0.99957 11.501 1H12.499C12.9856 1.00008 13.4616 1.14202 13.8687 1.40843C14.2759 1.67484 14.5966 2.05417 14.7915 2.5H15.0035C15.4894 2.50036 15.9646 2.64246 16.3709 2.9089C16.7772 3.17534 17.097 3.55453 17.291 4H18.5C18.8284 4 19.1536 4.0647 19.4569 4.1904C19.7603 4.3161 20.036 4.50033 20.2681 4.73259C20.5003 4.96484 20.6844 5.24056 20.81 5.54399C20.9356 5.84741 21.0001 6.17261 21 6.501V20.499C20.9997 21.1621 20.7363 21.7979 20.2675 22.2668C19.7988 22.7358 19.1631 22.9995 18.5 23H5.5C5.17161 23 4.84644 22.9353 4.54306 22.8096C4.23968 22.6839 3.96404 22.4997 3.73188 22.2674C3.49972 22.0352 3.31559 21.7594 3.19001 21.456C3.06444 21.1526 2.99987 20.8274 3 20.499V6.501C3.00026 5.83795 3.26371 5.20212 3.73246 4.73317C4.20122 4.26423 4.83695 4.00053 5.5 4H6.71ZM6.551 6H5.5C5.225 6 5 6.225 5 6.501V20.499C4.99987 20.5647 5.0127 20.6299 5.03777 20.6907C5.06284 20.7514 5.09965 20.8067 5.14609 20.8532C5.19253 20.8997 5.2477 20.9367 5.30843 20.9618C5.36915 20.987 5.43425 21 5.5 21H18.5C18.775 21 19 20.775 19 20.499V6.501C19.0001 6.43526 18.9873 6.37013 18.9622 6.30935C18.9372 6.24857 18.9003 6.19334 18.8539 6.1468C18.8075 6.10027 18.7523 6.06335 18.6916 6.03816C18.6308 6.01297 18.5657 6 18.5 6H17.449C17.2155 7.14 16.2065 8 15.004 8H8.996C7.789 8 6.7835 7.14 6.551 6ZM10 4.5H8.9965C8.86404 4.50223 8.73777 4.55642 8.64489 4.65088C8.55202 4.74535 8.49998 4.87253 8.5 5.005V5.495C8.5 5.775 8.724 6 8.9965 6H15.0035C15.273 6 15.5 5.7725 15.5 5.495V5.005C15.5 4.725 15.276 4.5 15.0035 4.5H14C13.7348 4.5 13.4804 4.39464 13.2929 4.20711C13.1054 4.01957 13 3.76522 13 3.5C13 3.225 12.775 3 12.499 3H11.501C11.4352 2.99974 11.37 3.01248 11.3092 3.0375C11.2484 3.06253 11.1931 3.09933 11.1465 3.1458C11.0999 3.19227 11.063 3.24748 11.0379 3.30827C11.0127 3.36906 10.9999 3.43422 11 3.5C11 3.76522 10.8946 4.01957 10.7071 4.20711C10.5196 4.39464 10.2652 4.5 10 4.5Z\" fill=\"#1F3A3E\"></path><path d=\"M9 11C9 11.5523 8.55228 12 8 12C7.44772 12 7 11.5523 7 11C7 10.4477 7.44772 10 8 10C8.55228 10 9 10.4477 9 11Z\" fill=\"#1F3A3E\"></path><path d=\"M9 14C9 14.5523 8.55228 15 8 15C7.44772 15 7 14.5523 7 14C7 13.4477 7.44772 13 8 13C8.55228 13 9 13.4477 9 14Z\" fill=\"#1F3A3E\"></path><path d=\"M9 17C9 17.5523 8.55228 18 8 18C7.44772 18 7 17.5523 7 17C7 16.4477 7.44772 16 8 16C8.55228 16 9 16.4477 9 17Z\" fill=\"#1F3A3E\"></path><path d=\"M10 11C10 10.4477 10.4477 10 11 10H16C16.5523 10 17 10.4477 17 11C17 11.5523 16.5523 12 16 12H11C10.4477 12 10 11.5523 10 11Z\" fill=\"#1F3A3E\"></path><path d=\"M10 14C10 13.4477 10.4477 13 11 13H16C16.5523 13 17 13.4477 17 14C17 14.5523 16.5523 15 16 15H11C10.4477 15 10 14.5523 10 14Z\" fill=\"#1F3A3E\"></path><path d=\"M10 17C10 16.4477 10.4477 16 11 16H16C16.5523 16 17 16.4477 17 17C17 17.5523 16.5523 18 16 18H11C10.4477 18 10 17.5523 10 17Z\" fill=\"#1F3A3E\"></path></svg>";

/***/ }),

/***/ "9d01":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("ef3c");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("abe07c22", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "9d26":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _VIcon__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("132d");


/* harmony default export */ __webpack_exports__["a"] = (_VIcon__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]);

/***/ }),

/***/ "9d65":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _util_console__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("d9bd");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("8bbf");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_1__);
// Utilities
 // Types


/**
 * Bootable
 * @mixin
 *
 * Used to add lazy content functionality to components
 * Looks for change in "isActive" to automatically boot
 * Otherwise can be set manually
 */

/* @vue/component */

/* harmony default export */ __webpack_exports__["a"] = (vue__WEBPACK_IMPORTED_MODULE_1___default.a.extend().extend({
  name: 'bootable',
  props: {
    eager: Boolean
  },
  data: function data() {
    return {
      isBooted: false
    };
  },
  computed: {
    hasContent: function hasContent() {
      return this.isBooted || this.eager || this.isActive;
    }
  },
  watch: {
    isActive: function isActive() {
      this.isBooted = true;
    }
  },
  created: function created() {
    /* istanbul ignore next */
    if ('lazy' in this.$attrs) {
      Object(_util_console__WEBPACK_IMPORTED_MODULE_0__[/* removed */ "e"])('lazy', this);
    }
  },
  methods: {
    showLazyContent: function showLazyContent(content) {
      return this.hasContent && content ? content() : [this.$createElement()];
    }
  }
}));

/***/ }),

/***/ "9dbe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c662cfac-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/lazy/PpLazy.vue?vue&type=template&id=a5582210&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-lazy',_vm._g(_vm._b({},'v-lazy',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/lazy/PpLazy.vue?vue&type=template&id=a5582210&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/lazy/PpLazy.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
/* harmony default export */ var PpLazyvue_type_script_lang_js_ = ({
  name: 'PpLazy'
});
// CONCATENATED MODULE: ./src/components/lazy/PpLazy.vue?vue&type=script&lang=js&
 /* harmony default export */ var lazy_PpLazyvue_type_script_lang_js_ = (PpLazyvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// EXTERNAL MODULE: ./node_modules/vuetify-loader/lib/runtime/installComponents.js
var installComponents = __webpack_require__("6544");
var installComponents_default = /*#__PURE__*/__webpack_require__.n(installComponents);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__("5530");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/mixins/measurable/index.js
var measurable = __webpack_require__("24b2");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/mixins/toggleable/index.js
var toggleable = __webpack_require__("f2e7");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/directives/intersect/index.js
var intersect = __webpack_require__("90a2");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/util/mixins.js
var mixins = __webpack_require__("58df");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/util/helpers.js
var helpers = __webpack_require__("80d2");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VLazy/VLazy.js

// Mixins

 // Directives

 // Utilities



/* harmony default export */ var VLazy = (Object(mixins["a" /* default */])(measurable["a" /* default */], toggleable["a" /* default */]).extend({
  name: 'VLazy',
  directives: {
    intersect: intersect["a" /* default */]
  },
  props: {
    options: {
      type: Object,
      // For more information on types, navigate to:
      // https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
      default: function _default() {
        return {
          root: undefined,
          rootMargin: undefined,
          threshold: undefined
        };
      }
    },
    tag: {
      type: String,
      default: 'div'
    },
    transition: {
      type: String,
      default: 'fade-transition'
    }
  },
  computed: {
    styles: function styles() {
      return Object(objectSpread2["a" /* default */])({}, this.measurableStyles);
    }
  },
  methods: {
    genContent: function genContent() {
      var slot = Object(helpers["s" /* getSlot */])(this);
      /* istanbul ignore if */

      if (!this.transition) return slot;
      var children = [];
      if (this.isActive) children.push(slot);
      return this.$createElement('transition', {
        props: {
          name: this.transition
        }
      }, children);
    },
    onObserve: function onObserve(entries, observer, isIntersecting) {
      if (this.isActive) return;
      this.isActive = isIntersecting;
    }
  },
  render: function render(h) {
    return h(this.tag, {
      staticClass: 'v-lazy',
      attrs: this.$attrs,
      directives: [{
        name: 'intersect',
        value: {
          handler: this.onObserve,
          options: this.options
        }
      }],
      on: this.$listeners,
      style: this.styles
    }, [this.genContent()]);
  }
}));
// CONCATENATED MODULE: ./src/components/lazy/PpLazy.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  lazy_PpLazyvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var PpLazy = __webpack_exports__["default"] = (component.exports);

/* vuetify-loader */


installComponents_default()(component, {VLazy: VLazy})


/***/ }),

/***/ "9e29":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("1e94");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("aedf4dfc", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "9e88":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("4160");
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("159b");
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("5530");
/* harmony import */ var _src_components_VCheckbox_VSimpleCheckbox_sass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("cf36");
/* harmony import */ var _src_components_VCheckbox_VSimpleCheckbox_sass__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_src_components_VCheckbox_VSimpleCheckbox_sass__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _directives_ripple__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("5607");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("8bbf");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _VIcon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("132d");
/* harmony import */ var _mixins_colorable__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("a9ad");
/* harmony import */ var _mixins_themeable__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("7560");
/* harmony import */ var _util_mergeData__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("d9f7");
/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("80d2");






 // Mixins


 // Utilities



/* harmony default export */ __webpack_exports__["a"] = (vue__WEBPACK_IMPORTED_MODULE_5___default.a.extend({
  name: 'v-simple-checkbox',
  functional: true,
  directives: {
    ripple: _directives_ripple__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"]
  },
  props: Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])({}, _mixins_colorable__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"].options.props), _mixins_themeable__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"].options.props), {}, {
    disabled: Boolean,
    ripple: {
      type: Boolean,
      default: true
    },
    value: Boolean,
    indeterminate: Boolean,
    indeterminateIcon: {
      type: String,
      default: '$checkboxIndeterminate'
    },
    onIcon: {
      type: String,
      default: '$checkboxOn'
    },
    offIcon: {
      type: String,
      default: '$checkboxOff'
    }
  }),
  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        listeners = _ref.listeners;
    var children = [];

    if (props.ripple && !props.disabled) {
      var _ripple = h('div', _mixins_colorable__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"].options.methods.setTextColor(props.color, {
        staticClass: 'v-input--selection-controls__ripple',
        directives: [{
          name: 'ripple',
          value: {
            center: true
          }
        }]
      }));

      children.push(_ripple);
    }

    var icon = props.offIcon;
    if (props.indeterminate) icon = props.indeterminateIcon;else if (props.value) icon = props.onIcon;
    children.push(h(_VIcon__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"], _mixins_colorable__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"].options.methods.setTextColor(props.value && props.color, {
      props: {
        disabled: props.disabled,
        dark: props.dark,
        light: props.light
      }
    }), icon));
    var classes = {
      'v-simple-checkbox': true,
      'v-simple-checkbox--disabled': props.disabled
    };
    return h('div', Object(_util_mergeData__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(data, {
      class: classes,
      on: {
        click: function click(e) {
          e.stopPropagation();

          if (data.on && data.on.input && !props.disabled) {
            Object(_util_helpers__WEBPACK_IMPORTED_MODULE_10__[/* wrapInArray */ "H"])(data.on.input).forEach(function (f) {
              return f(!props.value);
            });
          }
        }
      }
    }), children);
  }
}));

/***/ }),

/***/ "9ebc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpDialog_vue_vue_type_style_index_0_id_8d2ba264_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("7044");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpDialog_vue_vue_type_style_index_0_id_8d2ba264_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpDialog_vue_vue_type_style_index_0_id_8d2ba264_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "9ed3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var IteratorPrototype = __webpack_require__("ae93").IteratorPrototype;
var create = __webpack_require__("7c73");
var createPropertyDescriptor = __webpack_require__("5c6c");
var setToStringTag = __webpack_require__("d44e");
var Iterators = __webpack_require__("3f8c");

var returnThis = function () { return this; };

module.exports = function (IteratorConstructor, NAME, next) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create(IteratorPrototype, { next: createPropertyDescriptor(1, next) });
  setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
  Iterators[TO_STRING_TAG] = returnThis;
  return IteratorConstructor;
};


/***/ }),

/***/ "9ede":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return NUM_OF_DAYS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DEFAULT_STYLE_CLASSES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CUSTOM_RANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DESKTOP_CALENDAR_WIDTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return MONTH_LONG_NAMES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DAY_SHORT_NAMES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ISO_8601; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return DISPLAY_FORMAT; });
var NUM_OF_DAYS = 7;
var DEFAULT_STYLE_CLASSES = {
  daysWeeks: 'calendar-weeks',
  days: 'calendar-days',
  daysSelected: 'calendar-days-selected',
  daysInRange: 'calendar-days-in-range',
  firstDate: 'calendar-month-left',
  secondDate: 'calendar-month-right',
  presetRanges: 'calendar-preset-button',
  dateDisabled: 'calendar-days--disabled'
};
var CUSTOM_RANGE = 'Custom Range';
var DESKTOP_CALENDAR_WIDTH = 834;
var MONTH_LONG_NAMES = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
var DAY_SHORT_NAMES = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
var ISO_8601 = 'YYYY-MM-DD';
var DISPLAY_FORMAT = 'MMM D, YYYY';

/***/ }),

/***/ "9f4c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c662cfac-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/dialog/consent/PpDialogConsent.vue?vue&type=template&id=a1f58fb8&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pp-dialog',{attrs:{"disable-primary-button":_vm.disablePrimaryButton,"max-width":600,"primary-button-text":_vm.primaryButtonText,"value":_vm.show,"secondary-button-text":"Cancel","title":"Send Consent Message"},on:{"close":_vm.closeDialog,"confirm":_vm.confirmConsent},scopedSlots:_vm._u([{key:"body",fn:function(){return [_vm._t("additional-content"),_c('p',[_vm._v(" To text with this patient, you must first obtain their consent. Please select this patient’s consent status: ")]),_c('ul',{staticClass:"consent-options pa-0 "},_vm._l((_vm.options),function(option){return _c('li',{key:option.id,staticClass:"rounded-lg consent-options__option",class:_vm.optionClass[option.id],style:(("--option-background-img: url('" + (option.backgroundImg) + "')")),on:{"click":function($event){return _vm.chooseOption(option.id)}}},[_c('p',{staticClass:"text-h5 d-block mb-0"},[_vm._v(" "+_vm._s(option.title)+" ")]),_c('p',{staticClass:"mb-0"},[_vm._v(" "+_vm._s(option.description)+" ")]),(_vm.showConsentText[option.id])?[_c('p',{staticClass:"mt-2"},[_vm._v(" By clicking the "),_c('span',{staticClass:"blue--text",on:{"click":_vm.confirmConsent}},[_vm._v("send")]),_vm._v(" button below, the following message will be sent to your patient: ")]),_c('div',{staticClass:"mock-text mt-2 text-h6 rounded-b-xl rounded-tr-xl pa-5 white"},[_vm._v(" "+_vm._s(_vm.practiceName)+" would like to send you text messages. As you know texts are not encrypted and could potentially be viewed by third parties. To receive texts from us regarding your health and account, please reply ‘CONSENT’. You can always unsubscribe by replying ‘UNSUB’ ")])]:_vm._e()],2)}),0)]},proxy:true}],null,true)})}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/dialog/consent/PpDialogConsent.vue?vue&type=template&id=a1f58fb8&scoped=true&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.reduce.js
var es_array_reduce = __webpack_require__("13d5");

// EXTERNAL MODULE: ./src/components/dialog/PpDialog.vue + 5 modules
var PpDialog = __webpack_require__("bdf9");

// CONCATENATED MODULE: ./src/components/dialog/consent/constants.js
var CONSENT_OPTIONS = {
  OBTAINED: 'obtained',
  REQUIRED: 'required'
};
var OBTAINED_DETAILS = {
  id: CONSENT_OPTIONS.OBTAINED,
  title: 'Consent Obtained',
  description: 'My practice has already obtained consent to text about patient’s health and account.'
};
var REQUIRED_DETAILS = {
  id: CONSENT_OPTIONS.REQUIRED,
  title: 'Consent still required',
  description: 'My practice needs to obtain consent form this patient.'
};
var CONSENT_DETAILS = [OBTAINED_DETAILS, REQUIRED_DETAILS];
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/dialog/consent/PpDialogConsent.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var PpDialogConsentvue_type_script_lang_js_ = ({
  name: 'PpDialogConsent',
  components: {
    'pp-dialog': PpDialog["default"]
  },
  props: {
    show: {
      type: Boolean,
      default: true
    },

    /** Used for the text that will be sent out asking for consent */
    practiceName: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      selectedConsent: '',
      options: CONSENT_DETAILS
    };
  },
  computed: {
    primaryButtonText: function primaryButtonText() {
      return this.selectedConsent === CONSENT_OPTIONS.REQUIRED ? 'Send' : 'Okay';
    },
    disablePrimaryButton: function disablePrimaryButton() {
      return !this.selectedConsent;
    },
    optionClass: function optionClass() {
      var _this = this;

      var baseClass = 'consent-options__option';
      return this.options.reduce(function (classes, option) {
        classes[option.id] = [];
        classes[option.id].push("".concat(baseClass, "--").concat(option.id));

        if (_this.selectedConsent === option.id) {
          classes[option.id].push("".concat(baseClass, "--active"));
        }

        return classes;
      }, {});
    },
    showConsentText: function showConsentText() {
      var _this2 = this;

      return this.options.reduce(function (showConsentTextOptions, option) {
        showConsentTextOptions[option.id] = false;

        if (option.id === CONSENT_OPTIONS.REQUIRED && _this2.selectedConsent === option.id) {
          showConsentTextOptions[option.id] = true;
        }

        return showConsentTextOptions;
      }, {});
    }
  },
  methods: {
    chooseOption: function chooseOption(optionId) {
      this.selectedConsent = optionId;
    },
    confirmConsent: function confirmConsent() {
      this.$emit('confirm', this.selectedConsent);
    },
    closeDialog: function closeDialog() {
      this.$emit('close');
      this.selectedConsent = '';
    }
  }
});
// CONCATENATED MODULE: ./src/components/dialog/consent/PpDialogConsent.vue?vue&type=script&lang=js&
 /* harmony default export */ var consent_PpDialogConsentvue_type_script_lang_js_ = (PpDialogConsentvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/dialog/consent/PpDialogConsent.vue?vue&type=style&index=0&id=a1f58fb8&lang=scss&scoped=true&
var PpDialogConsentvue_type_style_index_0_id_a1f58fb8_lang_scss_scoped_true_ = __webpack_require__("520e");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/dialog/consent/PpDialogConsent.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  consent_PpDialogConsentvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "a1f58fb8",
  null
  
)

/* harmony default export */ var PpDialogConsent = __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "9f67":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c662cfac-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/input/date/PpInputDate.vue?vue&type=template&id=196abf97&scoped=true&
var PpInputDatevue_type_template_id_196abf97_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.native)?[(_vm.label)?_c('pp-input-label',{attrs:{"label":_vm.label,"input-id":("input-" + _vm._uid + "}"),"optional":_vm.optional}}):_vm._e(),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.nativeDate),expression:"nativeDate"}],staticClass:"pa-2 pp-input-date-native",class:{'pp-input-date-native--error':_vm.errorMessages.length > 0},attrs:{"id":("input-" + _vm._uid + "}"),"type":"date","placeholder":_vm.placeholder,"disabled":_vm.disabled},domProps:{"value":(_vm.nativeDate)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.nativeDate=$event.target.value},function($event){return _vm.onDateChosen($event.target.value)}]}}),(_vm.errorMessages.length > 0)?_c('div',{staticClass:"error--text text-caption mt-n3 mr-2 px-1 float-right white"},[_vm._l((_vm.errorMessages),function(errorMessage){return [_vm._v(" "+_vm._s(errorMessage)+" ")]})],2):_vm._e()]:_c('v-menu',{attrs:{"close-on-content-click":false,"min-width":"auto","offset-y":"","left":true,"transition":"scale-transition"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var attrs = ref.attrs;
return [_c('pp-input-text',_vm._g(_vm._b({attrs:{"disabled":_vm.disabled,"error-messages":_vm.errorMessages,"label":_vm.label,"placeholder":_vm.placeholder,"description":_vm.description,"prepend-inner-icon":"schedule","autocomplete":"off","type":"tel","maxlength":"10"},on:{"change":_vm.onDateTyped,"keyup":_vm.onKeyUp,"click":function($event){_vm.showDatePicker = true}},model:{value:(_vm.dateToShow),callback:function ($$v) {_vm.dateToShow=$$v},expression:"dateToShow"}},'pp-input-text',attrs,false),_vm.$listeners))]}}]),model:{value:(_vm.showDatePicker),callback:function ($$v) {_vm.showDatePicker=$$v},expression:"showDatePicker"}},[_c('v-date-picker',{attrs:{"color":"blue","no-title":"","scrollable":""},on:{"input":_vm.onDateChosen},model:{value:(_vm.dateValue),callback:function ($$v) {_vm.dateValue=$$v},expression:"dateValue"}})],1)],2)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/input/date/PpInputDate.vue?vue&type=template&id=196abf97&scoped=true&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("99af");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__("fb6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__("ac1f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.match.js
var es_string_match = __webpack_require__("466d");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.pad-start.js
var es_string_pad_start = __webpack_require__("4d90");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.replace.js
var es_string_replace = __webpack_require__("5319");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.split.js
var es_string_split = __webpack_require__("1276");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__("3835");

// EXTERNAL MODULE: ./src/components/input/text/PpInputText.vue + 4 modules
var PpInputText = __webpack_require__("ac90");

// EXTERNAL MODULE: ./src/components/input/label/PpInputLabel.vue + 4 modules
var PpInputLabel = __webpack_require__("8e6c");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/input/date/PpInputDate.vue?vue&type=script&lang=js&








//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var PpInputDatevue_type_script_lang_js_ = ({
  name: 'PpInputDate',
  components: {
    'pp-input-text': PpInputText["default"],
    'pp-input-label': PpInputLabel["default"]
  },
  component: {
    PpInputText: PpInputText["default"]
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    errorMessages: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    label: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: 'MM/DD/YYYY'
    },

    /**
     * As the user experience can be improved on mobile using the native select of the platform, we allow such option.
     */
    native: {
      type: Boolean,
      default: false
    },

    /**
     * If true, display optional label with a different color than the main label
     */
    optional: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      showDatePicker: false,
      nativeDate: '',
      dateToShow: this.formatDate(this.$attrs.value),
      dateValue: this.$attrs.value
    };
  },
  watch: {
    $attrs: {
      deep: true,
      immediate: true,
      handler: function handler() {
        this.dateToShow = this.formatDate(this.$attrs.value); // check for valid date and set the date picker to it

        if (this.isValidDate(this.$attrs.value)) {
          this.dateValue = this.parseDate(this.$attrs.value);
        }
      }
    }
  },
  methods: {
    // check for is valid date
    isValidDate: function isValidDate(date) {
      if (date) {
        var reg = /^(((0[1-9]|[12]\d|3[01])\/(0[13578]|1[02])\/((19|[2-9]\d)\d{2}))|((0[1-9]|[12]\d|30)\/(0[13456789]|1[012])\/((19|[2-9]\d)\d{2}))|((0[1-9]|1\d|2[0-8])\/02\/((19|[2-9]\d)\d{2}))|(29\/02\/((1[6-9]|[2-9]\d)(0[48]|[2468][048]|[13579][26])|(([1][26]|[2468][048]|[3579][26])00))))$/g;
        var reg2 = /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/;
        return date.match(reg) || date.match(reg2);
      }
    },
    // mask the input for mm/dd/yyyy
    onKeyUp: function onKeyUp() {
      if (!this.dateToShow) {
        return;
      } // strip out non numeric characters and get first 8


      var v = this.dateToShow.replace(/\D/g, '').slice(0, 8); // if the length is long enough, then add /

      if (v.length >= 5) {
        this.dateToShow = "".concat(v.slice(0, 2), "/").concat(v.slice(2, 4), "/").concat(v.slice(4));
        return;
      } else if (v.length >= 3) {
        this.dateToShow = "".concat(v.slice(0, 2), "/").concat(v.slice(2));
        return;
      }

      this.dateToShow = v;
    },
    // when date is entered via typing
    onDateTyped: function onDateTyped(date) {
      // hide the date picker
      this.showDatePicker = false; // if its not a valid date, leave as is and emit input with invalid date

      if (!date || !this.isValidDate(date)) {
        this.$emit('input', date);
      } else {
        this.$emit('input', this.parseDate(date));
      } // emit the way the user has entered the date


      this.$emit('chosen', 'type');
    },
    // when date is chosen from date picker
    onDateChosen: function onDateChosen(date) {
      // hide the date picker
      this.showDatePicker = false; // emit input with the change

      this.$emit('input', date); // updates the date shown in the input text box

      this.dateToShow = this.formatDate(date); // emit the way the user has entered the date

      if (!this.native) {
        this.$emit('chosen', 'picker');
      }
    },
    // convert date from YYYY-MM-DD to MM/DD/YYYY
    formatDate: function formatDate(date) {
      if (!date || date.split('-').length < 3) {
        return date;
      }

      var _date$split = date.split('-'),
          _date$split2 = Object(slicedToArray["a" /* default */])(_date$split, 3),
          year = _date$split2[0],
          month = _date$split2[1],
          day = _date$split2[2];

      return "".concat(month, "/").concat(day, "/").concat(year);
    },
    // convert date from MM/DD/YYYY to YYYY-MM-DD
    parseDate: function parseDate(date) {
      if (!date) {
        return null;
      }

      var _date$split3 = date.split('/'),
          _date$split4 = Object(slicedToArray["a" /* default */])(_date$split3, 3),
          month = _date$split4[0],
          day = _date$split4[1],
          year = _date$split4[2];

      return "".concat(year, "-").concat(String(month).padStart(2, '0'), "-").concat(String(day).padStart(2, '0'));
    }
  }
});
// CONCATENATED MODULE: ./src/components/input/date/PpInputDate.vue?vue&type=script&lang=js&
 /* harmony default export */ var date_PpInputDatevue_type_script_lang_js_ = (PpInputDatevue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/input/date/PpInputDate.vue?vue&type=style&index=0&id=196abf97&lang=scss&scoped=true&
var PpInputDatevue_type_style_index_0_id_196abf97_lang_scss_scoped_true_ = __webpack_require__("e890");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// EXTERNAL MODULE: ./node_modules/vuetify-loader/lib/runtime/installComponents.js
var installComponents = __webpack_require__("6544");
var installComponents_default = /*#__PURE__*/__webpack_require__.n(installComponents);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("4de4");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("caad");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.index-of.js
var es_array_index_of = __webpack_require__("c975");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("d81d");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("b0c0");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__("a9e3");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__("5530");

// EXTERNAL MODULE: ./node_modules/vuetify/src/components/VDatePicker/VDatePickerTitle.sass
var VDatePickerTitle = __webpack_require__("d951");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/components/VIcon/index.js
var VIcon = __webpack_require__("9d26");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.trim.js
var es_string_trim = __webpack_require__("498a");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/mixins/colorable/index.js
var colorable = __webpack_require__("a9ad");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/util/mixins.js
var mixins = __webpack_require__("58df");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/util/helpers.js
var helpers = __webpack_require__("80d2");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/mixins/picker-button/index.js

// Mixins
 // Utilities



/* @vue/component */

/* harmony default export */ var picker_button = (Object(mixins["a" /* default */])(colorable["a" /* default */]).extend({
  methods: {
    genPickerButton: function genPickerButton(prop, value, content) {
      var _this = this;

      var readonly = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var staticClass = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
      var active = this[prop] === value;

      var click = function click(event) {
        event.stopPropagation();

        _this.$emit("update:".concat(Object(helpers["w" /* kebabCase */])(prop)), value);
      };

      return this.$createElement('div', {
        staticClass: "v-picker__title__btn ".concat(staticClass).trim(),
        class: {
          'v-picker__title__btn--active': active,
          'v-picker__title__btn--readonly': readonly
        },
        on: active || readonly ? undefined : {
          click: click
        }
      }, Array.isArray(content) ? content : [content]);
    }
  }
}));
// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VDatePicker/VDatePickerTitle.js

 // Components

 // Mixins

 // Utils


/* harmony default export */ var VDatePicker_VDatePickerTitle = (Object(mixins["a" /* default */])(picker_button
/* @vue/component */
).extend({
  name: 'v-date-picker-title',
  props: {
    date: {
      type: String,
      default: ''
    },
    disabled: Boolean,
    readonly: Boolean,
    selectingYear: Boolean,
    value: {
      type: String
    },
    year: {
      type: [Number, String],
      default: ''
    },
    yearIcon: {
      type: String
    }
  },
  data: function data() {
    return {
      isReversing: false
    };
  },
  computed: {
    computedTransition: function computedTransition() {
      return this.isReversing ? 'picker-reverse-transition' : 'picker-transition';
    }
  },
  watch: {
    value: function value(val, prev) {
      this.isReversing = val < prev;
    }
  },
  methods: {
    genYearIcon: function genYearIcon() {
      return this.$createElement(VIcon["a" /* default */], {
        props: {
          dark: true
        }
      }, this.yearIcon);
    },
    getYearBtn: function getYearBtn() {
      return this.genPickerButton('selectingYear', true, [String(this.year), this.yearIcon ? this.genYearIcon() : null], false, 'v-date-picker-title__year');
    },
    genTitleText: function genTitleText() {
      return this.$createElement('transition', {
        props: {
          name: this.computedTransition
        }
      }, [this.$createElement('div', {
        domProps: {
          innerHTML: this.date || '&nbsp;'
        },
        key: this.value
      })]);
    },
    genTitleDate: function genTitleDate() {
      return this.genPickerButton('selectingYear', false, [this.genTitleText()], false, 'v-date-picker-title__date');
    }
  },
  render: function render(h) {
    return h('div', {
      staticClass: 'v-date-picker-title',
      class: {
        'v-date-picker-title--disabled': this.disabled
      }
    }, [this.getYearBtn(), this.genTitleDate()]);
  }
}));
// EXTERNAL MODULE: ./node_modules/vuetify/src/components/VDatePicker/VDatePickerHeader.sass
var VDatePickerHeader = __webpack_require__("2102");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/components/VBtn/index.js
var VBtn = __webpack_require__("afdd");

// EXTERNAL MODULE: external {"commonjs":"vue","commonjs2":"vue","root":"Vue"}
var external_commonjs_vue_commonjs2_vue_root_Vue_ = __webpack_require__("8bbf");
var external_commonjs_vue_commonjs2_vue_root_Vue_default = /*#__PURE__*/__webpack_require__.n(external_commonjs_vue_commonjs2_vue_root_Vue_);

// CONCATENATED MODULE: ./node_modules/vuetify/lib/mixins/localable/index.js

/* harmony default export */ var localable = (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
  name: 'localable',
  props: {
    locale: String
  },
  computed: {
    currentLocale: function currentLocale() {
      return this.locale || this.$vuetify.lang.current;
    }
  }
}));
// EXTERNAL MODULE: ./node_modules/vuetify/lib/mixins/themeable/index.js
var themeable = __webpack_require__("7560");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__("a15b");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.repeat.js
var es_string_repeat = __webpack_require__("38cf");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VDatePicker/util/pad.js



var padStart = function padStart(string, targetLength, padString) {
  targetLength = targetLength >> 0;
  string = String(string);
  padString = String(padString);

  if (string.length > targetLength) {
    return String(string);
  }

  targetLength = targetLength - string.length;

  if (targetLength > padString.length) {
    padString += padString.repeat(targetLength / padString.length);
  }

  return padString.slice(0, targetLength) + String(string);
};

/* harmony default export */ var pad = (function (n) {
  var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  return padStart(n, length, '0');
});
// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VDatePicker/util/createNativeLocaleFormatter.js







function createNativeLocaleFormatter(locale, options) {
  var substrOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    start: 0,
    length: 0
  };

  var makeIsoString = function makeIsoString(dateString) {
    var _dateString$trim$spli = dateString.trim().split(' ')[0].split('-'),
        _dateString$trim$spli2 = Object(slicedToArray["a" /* default */])(_dateString$trim$spli, 3),
        year = _dateString$trim$spli2[0],
        month = _dateString$trim$spli2[1],
        date = _dateString$trim$spli2[2];

    return [pad(year, 4), pad(month || 1), pad(date || 1)].join('-');
  };

  try {
    var intlFormatter = new Intl.DateTimeFormat(locale || undefined, options);
    return function (dateString) {
      return intlFormatter.format(new Date("".concat(makeIsoString(dateString), "T00:00:00+00:00")));
    };
  } catch (e) {
    return substrOptions.start || substrOptions.length ? function (dateString) {
      return makeIsoString(dateString).substr(substrOptions.start || 0, substrOptions.length);
    } : undefined;
  }
}

/* harmony default export */ var util_createNativeLocaleFormatter = (createNativeLocaleFormatter);
// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VDatePicker/util/monthChange.js







/**
 * @param {String} value YYYY-MM format
 * @param {Number} sign -1 or +1
 */

/* harmony default export */ var monthChange = (function (value, sign) {
  var _value$split$map = value.split('-').map(Number),
      _value$split$map2 = Object(slicedToArray["a" /* default */])(_value$split$map, 2),
      year = _value$split$map2[0],
      month = _value$split$map2[1];

  if (month + sign === 0) {
    return "".concat(year - 1, "-12");
  } else if (month + sign === 13) {
    return "".concat(year + 1, "-01");
  } else {
    return "".concat(year, "-").concat(pad(month + sign));
  }
});
// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VDatePicker/VDatePickerHeader.js






 // Components


 // Mixins



 // Utils



/* harmony default export */ var VDatePicker_VDatePickerHeader = (Object(mixins["a" /* default */])(colorable["a" /* default */], localable, themeable["a" /* default */]
/* @vue/component */
).extend({
  name: 'v-date-picker-header',
  props: {
    disabled: Boolean,
    format: Function,
    min: String,
    max: String,
    nextAriaLabel: String,
    nextIcon: {
      type: String,
      default: '$next'
    },
    prevAriaLabel: String,
    prevIcon: {
      type: String,
      default: '$prev'
    },
    readonly: Boolean,
    value: {
      type: [Number, String],
      required: true
    }
  },
  data: function data() {
    return {
      isReversing: false
    };
  },
  computed: {
    formatter: function formatter() {
      if (this.format) {
        return this.format;
      } else if (String(this.value).split('-')[1]) {
        return util_createNativeLocaleFormatter(this.currentLocale, {
          month: 'long',
          year: 'numeric',
          timeZone: 'UTC'
        }, {
          length: 7
        });
      } else {
        return util_createNativeLocaleFormatter(this.currentLocale, {
          year: 'numeric',
          timeZone: 'UTC'
        }, {
          length: 4
        });
      }
    }
  },
  watch: {
    value: function value(newVal, oldVal) {
      this.isReversing = newVal < oldVal;
    }
  },
  methods: {
    genBtn: function genBtn(change) {
      var _this = this;

      var ariaLabelId = change > 0 ? this.nextAriaLabel : this.prevAriaLabel;
      var ariaLabel = ariaLabelId ? this.$vuetify.lang.t(ariaLabelId) : undefined;
      var disabled = this.disabled || change < 0 && this.min && this.calculateChange(change) < this.min || change > 0 && this.max && this.calculateChange(change) > this.max;
      return this.$createElement(VBtn["a" /* default */], {
        attrs: {
          'aria-label': ariaLabel
        },
        props: {
          dark: this.dark,
          disabled: disabled,
          icon: true,
          light: this.light
        },
        on: {
          click: function click(e) {
            e.stopPropagation();

            _this.$emit('input', _this.calculateChange(change));
          }
        }
      }, [this.$createElement(VIcon["a" /* default */], change < 0 === !this.$vuetify.rtl ? this.prevIcon : this.nextIcon)]);
    },
    calculateChange: function calculateChange(sign) {
      var _String$split$map = String(this.value).split('-').map(Number),
          _String$split$map2 = Object(slicedToArray["a" /* default */])(_String$split$map, 2),
          year = _String$split$map2[0],
          month = _String$split$map2[1];

      if (month == null) {
        return "".concat(year + sign);
      } else {
        return monthChange(String(this.value), sign);
      }
    },
    genHeader: function genHeader() {
      var _this2 = this;

      var color = !this.disabled && (this.color || 'accent');
      var header = this.$createElement('div', this.setTextColor(color, {
        key: String(this.value)
      }), [this.$createElement('button', {
        attrs: {
          type: 'button'
        },
        on: {
          click: function click() {
            return _this2.$emit('toggle');
          }
        }
      }, [this.$slots.default || this.formatter(String(this.value))])]);
      var transition = this.$createElement('transition', {
        props: {
          name: this.isReversing === !this.$vuetify.rtl ? 'tab-reverse-transition' : 'tab-transition'
        }
      }, [header]);
      return this.$createElement('div', {
        staticClass: 'v-date-picker-header__value',
        class: {
          'v-date-picker-header__value--disabled': this.disabled
        }
      }, [transition]);
    }
  },
  render: function render() {
    return this.$createElement('div', {
      staticClass: 'v-date-picker-header',
      class: Object(objectSpread2["a" /* default */])({
        'v-date-picker-header--disabled': this.disabled
      }, this.themeClasses)
    }, [this.genBtn(-1), this.genHeader(), this.genBtn(+1)]);
  }
}));
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.math.sign.js
var es_math_sign = __webpack_require__("2af1");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("2532");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__("2909");

// EXTERNAL MODULE: ./node_modules/vuetify/src/components/VDatePicker/VDatePickerTable.sass
var VDatePickerTable = __webpack_require__("c982");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/directives/touch/index.js
var touch = __webpack_require__("c3f0");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.reduce.js
var es_array_reduce = __webpack_require__("13d5");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("b64b");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.ends-with.js
var es_string_ends_with = __webpack_require__("8a79");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VDatePicker/util/eventHelpers.js




function createItemTypeNativeListeners(instance, itemTypeSuffix, value) {
  return Object.keys(instance.$listeners).reduce(function (on, eventName) {
    if (eventName.endsWith(itemTypeSuffix)) {
      on[eventName.slice(0, -itemTypeSuffix.length)] = function (event) {
        return instance.$emit(eventName, value, event);
      };
    }

    return on;
  }, {});
}
function createItemTypeListeners(instance, itemTypeSuffix) {
  return Object.keys(instance.$listeners).reduce(function (on, eventName) {
    if (eventName.endsWith(itemTypeSuffix)) {
      on[eventName] = instance.$listeners[eventName];
    }

    return on;
  }, {});
}
// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VDatePicker/util/sanitizeDateString.js




// Adds leading zero to month/day if necessary, returns 'YYYY' if type = 'year',
// 'YYYY-MM' if 'month' and 'YYYY-MM-DD' if 'date'

/* harmony default export */ var sanitizeDateString = (function (dateString, type) {
  var _dateString$split = dateString.split('-'),
      _dateString$split2 = Object(slicedToArray["a" /* default */])(_dateString$split, 3),
      year = _dateString$split2[0],
      _dateString$split2$ = _dateString$split2[1],
      month = _dateString$split2$ === void 0 ? 1 : _dateString$split2$,
      _dateString$split2$2 = _dateString$split2[2],
      date = _dateString$split2$2 === void 0 ? 1 : _dateString$split2$2;

  return "".concat(year, "-").concat(pad(month), "-").concat(pad(date)).substr(0, {
    date: 10,
    month: 7,
    year: 4
  }[type]);
});
// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VDatePicker/util/isDateAllowed.js
function isDateAllowed_isDateAllowed(date, min, max, allowedFn) {
  return (!allowedFn || allowedFn(date)) && (!min || date >= min.substr(0, 10)) && (!max || date <= max);
}
// EXTERNAL MODULE: ./node_modules/vuetify/lib/util/mergeData.js
var mergeData = __webpack_require__("d9f7");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VDatePicker/mixins/date-picker-table.js











 // Directives

 // Mixins



 // Utils






/* harmony default export */ var date_picker_table = (Object(mixins["a" /* default */])(colorable["a" /* default */], localable, themeable["a" /* default */]
/* @vue/component */
).extend({
  directives: {
    Touch: touch["a" /* default */]
  },
  props: {
    allowedDates: Function,
    current: String,
    disabled: Boolean,
    format: Function,
    events: {
      type: [Array, Function, Object],
      default: function _default() {
        return null;
      }
    },
    eventColor: {
      type: [Array, Function, Object, String],
      default: function _default() {
        return 'warning';
      }
    },
    min: String,
    max: String,
    range: Boolean,
    readonly: Boolean,
    scrollable: Boolean,
    tableDate: {
      type: String,
      required: true
    },
    value: [String, Array]
  },
  data: function data() {
    return {
      isReversing: false,
      wheelThrottle: null
    };
  },
  computed: {
    computedTransition: function computedTransition() {
      return this.isReversing === !this.$vuetify.rtl ? 'tab-reverse-transition' : 'tab-transition';
    },
    displayedMonth: function displayedMonth() {
      return Number(this.tableDate.split('-')[1]) - 1;
    },
    displayedYear: function displayedYear() {
      return Number(this.tableDate.split('-')[0]);
    }
  },
  watch: {
    tableDate: function tableDate(newVal, oldVal) {
      this.isReversing = newVal < oldVal;
    }
  },
  mounted: function mounted() {
    this.wheelThrottle = Object(helpers["F" /* throttle */])(this.wheel, 250);
  },
  methods: {
    genButtonClasses: function genButtonClasses(isAllowed, isFloating, isSelected, isCurrent) {
      return Object(objectSpread2["a" /* default */])({
        'v-size--default': !isFloating,
        'v-date-picker-table__current': isCurrent,
        'v-btn--active': isSelected,
        'v-btn--flat': !isAllowed || this.disabled,
        'v-btn--text': isSelected === isCurrent,
        'v-btn--rounded': isFloating,
        'v-btn--disabled': !isAllowed || this.disabled,
        'v-btn--outlined': isCurrent && !isSelected
      }, this.themeClasses);
    },
    genButtonEvents: function genButtonEvents(value, isAllowed, mouseEventType) {
      var _this = this;

      if (this.disabled) return undefined;
      return Object(mergeData["c" /* mergeListeners */])({
        click: function click() {
          if (isAllowed && !_this.readonly) _this.$emit('input', value);
        }
      }, createItemTypeNativeListeners(this, ":".concat(mouseEventType), value));
    },
    genButton: function genButton(value, isFloating, mouseEventType, formatter) {
      var isOtherMonth = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
      var isAllowed = isDateAllowed_isDateAllowed(value, this.min, this.max, this.allowedDates);
      var isSelected = this.isSelected(value) && isAllowed;
      var isCurrent = value === this.current;
      var setColor = isSelected ? this.setBackgroundColor : this.setTextColor;
      var color = (isSelected || isCurrent) && (this.color || 'accent');
      return this.$createElement('button', setColor(color, {
        staticClass: 'v-btn',
        class: this.genButtonClasses(isAllowed && !isOtherMonth, isFloating, isSelected, isCurrent),
        attrs: {
          type: 'button'
        },
        domProps: {
          disabled: this.disabled || !isAllowed || isOtherMonth
        },
        on: this.genButtonEvents(value, isAllowed, mouseEventType)
      }), [this.$createElement('div', {
        staticClass: 'v-btn__content'
      }, [formatter(value)]), this.genEvents(value)]);
    },
    getEventColors: function getEventColors(date) {
      var arrayize = function arrayize(v) {
        return Array.isArray(v) ? v : [v];
      };

      var eventData;
      var eventColors = [];

      if (Array.isArray(this.events)) {
        eventData = this.events.includes(date);
      } else if (this.events instanceof Function) {
        eventData = this.events(date) || false;
      } else if (this.events) {
        eventData = this.events[date] || false;
      } else {
        eventData = false;
      }

      if (!eventData) {
        return [];
      } else if (eventData !== true) {
        eventColors = arrayize(eventData);
      } else if (typeof this.eventColor === 'string') {
        eventColors = [this.eventColor];
      } else if (typeof this.eventColor === 'function') {
        eventColors = arrayize(this.eventColor(date));
      } else if (Array.isArray(this.eventColor)) {
        eventColors = this.eventColor;
      } else {
        eventColors = arrayize(this.eventColor[date]);
      }

      return eventColors.filter(function (v) {
        return v;
      });
    },
    genEvents: function genEvents(date) {
      var _this2 = this;

      var eventColors = this.getEventColors(date);
      return eventColors.length ? this.$createElement('div', {
        staticClass: 'v-date-picker-table__events'
      }, eventColors.map(function (color) {
        return _this2.$createElement('div', _this2.setBackgroundColor(color));
      })) : null;
    },
    isValidScroll: function isValidScroll(e, calculateTableDate) {
      var tableDate = calculateTableDate(e.deltaY); // tableDate is 'YYYY-MM' for DateTable and 'YYYY' for MonthTable

      var sanitizeType = tableDate.split('-').length === 1 ? 'year' : 'month';
      return e.deltaY === 0 || e.deltaY < 0 && (this.min ? tableDate >= sanitizeDateString(this.min, sanitizeType) : true) || e.deltaY > 0 && (this.max ? tableDate <= sanitizeDateString(this.max, sanitizeType) : true);
    },
    wheel: function wheel(e, calculateTableDate) {
      this.$emit('update:table-date', calculateTableDate(e.deltaY));
    },
    touch: function touch(value, calculateTableDate) {
      this.$emit('update:table-date', calculateTableDate(value));
    },
    genTable: function genTable(staticClass, children, calculateTableDate) {
      var _this3 = this;

      var transition = this.$createElement('transition', {
        props: {
          name: this.computedTransition
        }
      }, [this.$createElement('table', {
        key: this.tableDate
      }, children)]);
      var touchDirective = {
        name: 'touch',
        value: {
          left: function left(e) {
            return e.offsetX < -15 && _this3.touch(1, calculateTableDate);
          },
          right: function right(e) {
            return e.offsetX > 15 && _this3.touch(-1, calculateTableDate);
          }
        }
      };
      return this.$createElement('div', {
        staticClass: staticClass,
        class: Object(objectSpread2["a" /* default */])({
          'v-date-picker-table--disabled': this.disabled
        }, this.themeClasses),
        on: !this.disabled && this.scrollable ? {
          wheel: function wheel(e) {
            e.preventDefault();

            if (_this3.isValidScroll(e, calculateTableDate)) {
              _this3.wheelThrottle(e, calculateTableDate);
            }
          }
        } : undefined,
        directives: [touchDirective]
      }, [transition]);
    },
    isSelected: function isSelected(value) {
      if (Array.isArray(this.value)) {
        if (this.range && this.value.length === 2) {
          var _sort = Object(toConsumableArray["a" /* default */])(this.value).sort(),
              _sort2 = Object(slicedToArray["a" /* default */])(_sort, 2),
              from = _sort2[0],
              to = _sort2[1];

          return from <= value && value <= to;
        } else {
          return this.value.indexOf(value) !== -1;
        }
      }

      return value === this.value;
    }
  }
}));
// CONCATENATED MODULE: ./node_modules/vuetify/lib/util/dateTimeUtils.js
function createUTCDate(year) {
  var month = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var day = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var date;

  if (year < 100 && year >= 0) {
    date = new Date(Date.UTC(year, month, day));

    if (isFinite(date.getUTCFullYear())) {
      date.setUTCFullYear(year);
    }
  } else {
    date = new Date(Date.UTC(year, month, day));
  }

  return date;
}

function firstWeekOffset(year, firstDayOfWeek, firstDayOfYear) {
  var firstWeekDayInFirstWeek = 7 + firstDayOfWeek - firstDayOfYear;
  var firstWeekDayOfYear = (7 + createUTCDate(year, 0, firstWeekDayInFirstWeek).getUTCDay() - firstDayOfWeek) % 7;
  return -firstWeekDayOfYear + firstWeekDayInFirstWeek - 1;
}

function dayOfYear(year, month, day, firstDayOfWeek) {
  var dayOfYear = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334][month];

  if (month > 1 && isLeapYear(year)) {
    dayOfYear++;
  }

  return dayOfYear + day;
}

function weeksInYear(year, firstDayOfWeek, firstDayOfYear) {
  var weekOffset = firstWeekOffset(year, firstDayOfWeek, firstDayOfYear);
  var weekOffsetNext = firstWeekOffset(year + 1, firstDayOfWeek, firstDayOfYear);
  var daysInYear = isLeapYear(year) ? 366 : 365;
  return (daysInYear - weekOffset + weekOffsetNext) / 7;
}

function weekNumber(year, month, day, firstDayOfWeek, localeFirstDayOfYear) {
  var weekOffset = firstWeekOffset(year, firstDayOfWeek, localeFirstDayOfYear);
  var week = Math.ceil((dayOfYear(year, month, day, firstDayOfWeek) - weekOffset) / 7);

  if (week < 1) {
    return week + weeksInYear(year - 1, firstDayOfWeek, localeFirstDayOfYear);
  } else if (week > weeksInYear(year, firstDayOfWeek, localeFirstDayOfYear)) {
    return week - weeksInYear(year, firstDayOfWeek, localeFirstDayOfYear);
  } else {
    return week;
  }
}
function isLeapYear(year) {
  return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
}
// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VDatePicker/VDatePickerDateTable.js





// Mixins
 // Utils





/* harmony default export */ var VDatePickerDateTable = (Object(mixins["a" /* default */])(date_picker_table
/* @vue/component */
).extend({
  name: 'v-date-picker-date-table',
  props: {
    firstDayOfWeek: {
      type: [String, Number],
      default: 0
    },
    localeFirstDayOfYear: {
      type: [String, Number],
      default: 0
    },
    showAdjacentMonths: Boolean,
    showWeek: Boolean,
    weekdayFormat: Function
  },
  computed: {
    formatter: function formatter() {
      return this.format || util_createNativeLocaleFormatter(this.currentLocale, {
        day: 'numeric',
        timeZone: 'UTC'
      }, {
        start: 8,
        length: 2
      });
    },
    weekdayFormatter: function weekdayFormatter() {
      return this.weekdayFormat || util_createNativeLocaleFormatter(this.currentLocale, {
        weekday: 'narrow',
        timeZone: 'UTC'
      });
    },
    weekDays: function weekDays() {
      var _this = this;

      var first = parseInt(this.firstDayOfWeek, 10);
      return this.weekdayFormatter ? Object(helpers["h" /* createRange */])(7).map(function (i) {
        return _this.weekdayFormatter("2017-01-".concat(first + i + 15));
      }) // 2017-01-15 is Sunday
      : Object(helpers["h" /* createRange */])(7).map(function (i) {
        return ['S', 'M', 'T', 'W', 'T', 'F', 'S'][(i + first) % 7];
      });
    }
  },
  methods: {
    calculateTableDate: function calculateTableDate(delta) {
      return monthChange(this.tableDate, Math.sign(delta || 1));
    },
    genTHead: function genTHead() {
      var _this2 = this;

      var days = this.weekDays.map(function (day) {
        return _this2.$createElement('th', day);
      });

      if (this.showWeek) {
        days.unshift(this.$createElement('th'));
      }

      return this.$createElement('thead', this.genTR(days));
    },
    // Returns number of the days from the firstDayOfWeek to the first day of the current month
    weekDaysBeforeFirstDayOfTheMonth: function weekDaysBeforeFirstDayOfTheMonth() {
      var firstDayOfTheMonth = new Date("".concat(this.displayedYear, "-").concat(pad(this.displayedMonth + 1), "-01T00:00:00+00:00"));
      var weekDay = firstDayOfTheMonth.getUTCDay();
      return (weekDay - parseInt(this.firstDayOfWeek) + 7) % 7;
    },
    getWeekNumber: function getWeekNumber(dayInMonth) {
      return weekNumber(this.displayedYear, this.displayedMonth, dayInMonth, parseInt(this.firstDayOfWeek), parseInt(this.localeFirstDayOfYear));
    },
    genWeekNumber: function genWeekNumber(weekNumber) {
      return this.$createElement('td', [this.$createElement('small', {
        staticClass: 'v-date-picker-table--date__week'
      }, String(weekNumber).padStart(2, '0'))]);
    },
    // eslint-disable-next-line max-statements
    genTBody: function genTBody() {
      var children = [];
      var daysInMonth = new Date(this.displayedYear, this.displayedMonth + 1, 0).getDate();
      var rows = [];
      var day = this.weekDaysBeforeFirstDayOfTheMonth();

      if (this.showWeek) {
        rows.push(this.genWeekNumber(this.getWeekNumber(1)));
      }

      var prevMonthYear = this.displayedMonth ? this.displayedYear : this.displayedYear - 1;
      var prevMonth = (this.displayedMonth + 11) % 12;
      var firstDayFromPreviousMonth = new Date(this.displayedYear, this.displayedMonth, 0).getDate();

      while (day--) {
        var date = "".concat(prevMonthYear, "-").concat(pad(prevMonth + 1), "-").concat(pad(firstDayFromPreviousMonth - day));
        rows.push(this.$createElement('td', this.showAdjacentMonths ? [this.genButton(date, true, 'date', this.formatter, true)] : []));
      }

      for (day = 1; day <= daysInMonth; day++) {
        var _date = "".concat(this.displayedYear, "-").concat(pad(this.displayedMonth + 1), "-").concat(pad(day));

        rows.push(this.$createElement('td', [this.genButton(_date, true, 'date', this.formatter)]));

        if (rows.length % (this.showWeek ? 8 : 7) === 0) {
          children.push(this.genTR(rows));
          rows = [];

          if (this.showWeek && day < daysInMonth) {
            rows.push(this.genWeekNumber(this.getWeekNumber(day + 7)));
          }
        }
      }

      var nextMonthYear = this.displayedMonth === 11 ? this.displayedYear + 1 : this.displayedYear;
      var nextMonth = (this.displayedMonth + 1) % 12;
      var nextMonthDay = 1;

      while (rows.length < 7) {
        var _date2 = "".concat(nextMonthYear, "-").concat(pad(nextMonth + 1), "-").concat(pad(nextMonthDay++));

        rows.push(this.$createElement('td', this.showAdjacentMonths ? [this.genButton(_date2, true, 'date', this.formatter, true)] : []));
      }

      if (rows.length) {
        children.push(this.genTR(rows));
      }

      return this.$createElement('tbody', children);
    },
    genTR: function genTR(children) {
      return [this.$createElement('tr', children)];
    }
  },
  render: function render() {
    return this.genTable('v-date-picker-table v-date-picker-table--date', [this.genTHead(), this.genTBody()], this.calculateTableDate);
  }
}));
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.fill.js
var es_array_fill = __webpack_require__("cb29");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VDatePicker/VDatePickerMonthTable.js




// Mixins
 // Utils



/* harmony default export */ var VDatePickerMonthTable = (Object(mixins["a" /* default */])(date_picker_table
/* @vue/component */
).extend({
  name: 'v-date-picker-month-table',
  computed: {
    formatter: function formatter() {
      return this.format || util_createNativeLocaleFormatter(this.currentLocale, {
        month: 'short',
        timeZone: 'UTC'
      }, {
        start: 5,
        length: 2
      });
    }
  },
  methods: {
    calculateTableDate: function calculateTableDate(delta) {
      return "".concat(parseInt(this.tableDate, 10) + Math.sign(delta || 1));
    },
    genTBody: function genTBody() {
      var _this = this;

      var children = [];
      var cols = Array(3).fill(null);
      var rows = 12 / cols.length;

      var _loop = function _loop(row) {
        var tds = cols.map(function (_, col) {
          var month = row * cols.length + col;
          var date = "".concat(_this.displayedYear, "-").concat(pad(month + 1));
          return _this.$createElement('td', {
            key: month
          }, [_this.genButton(date, false, 'month', _this.formatter)]);
        });
        children.push(_this.$createElement('tr', {
          key: row
        }, tds));
      };

      for (var row = 0; row < rows; row++) {
        _loop(row);
      }

      return this.$createElement('tbody', children);
    }
  },
  render: function render() {
    return this.genTable('v-date-picker-table v-date-picker-table--month', [this.genTBody()], this.calculateTableDate);
  }
}));
// EXTERNAL MODULE: ./node_modules/vuetify/src/components/VDatePicker/VDatePickerYears.sass
var VDatePickerYears = __webpack_require__("02f0");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VDatePicker/VDatePickerYears.js

 // Mixins


 // Utils




/* harmony default export */ var VDatePicker_VDatePickerYears = (Object(mixins["a" /* default */])(colorable["a" /* default */], localable
/* @vue/component */
).extend({
  name: 'v-date-picker-years',
  props: {
    format: Function,
    min: [Number, String],
    max: [Number, String],
    readonly: Boolean,
    value: [Number, String]
  },
  data: function data() {
    return {
      defaultColor: 'primary'
    };
  },
  computed: {
    formatter: function formatter() {
      return this.format || util_createNativeLocaleFormatter(this.currentLocale, {
        year: 'numeric',
        timeZone: 'UTC'
      }, {
        length: 4
      });
    }
  },
  mounted: function mounted() {
    var _this = this;

    setTimeout(function () {
      var activeItem = _this.$el.getElementsByClassName('active')[0];

      if (activeItem) {
        _this.$el.scrollTop = activeItem.offsetTop - _this.$el.offsetHeight / 2 + activeItem.offsetHeight / 2;
      } else if (_this.min && !_this.max) {
        _this.$el.scrollTop = _this.$el.scrollHeight;
      } else if (!_this.min && _this.max) {
        _this.$el.scrollTop = 0;
      } else {
        _this.$el.scrollTop = _this.$el.scrollHeight / 2 - _this.$el.offsetHeight / 2;
      }
    });
  },
  methods: {
    genYearItem: function genYearItem(year) {
      var _this2 = this;

      var formatted = this.formatter("".concat(year));
      var active = parseInt(this.value, 10) === year;
      var color = active && (this.color || 'primary');
      return this.$createElement('li', this.setTextColor(color, {
        key: year,
        class: {
          active: active
        },
        on: Object(mergeData["c" /* mergeListeners */])({
          click: function click() {
            return _this2.$emit('input', year);
          }
        }, createItemTypeNativeListeners(this, ':year', year))
      }), formatted);
    },
    genYearItems: function genYearItems() {
      var children = [];
      var selectedYear = this.value ? parseInt(this.value, 10) : new Date().getFullYear();
      var maxYear = this.max ? parseInt(this.max, 10) : selectedYear + 100;
      var minYear = Math.min(maxYear, this.min ? parseInt(this.min, 10) : selectedYear - 100);

      for (var year = maxYear; year >= minYear; year--) {
        children.push(this.genYearItem(year));
      }

      return children;
    }
  },
  render: function render() {
    return this.$createElement('ul', {
      staticClass: 'v-date-picker-years',
      ref: 'years'
    }, this.genYearItems());
  }
}));
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.flat.js
var es_array_flat = __webpack_require__("0481");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.unscopables.flat.js
var es_array_unscopables_flat = __webpack_require__("4069");

// EXTERNAL MODULE: ./node_modules/vuetify/src/components/VPicker/VPicker.sass
var VPicker = __webpack_require__("e53c");

// EXTERNAL MODULE: ./node_modules/vuetify/src/components/VCard/VCard.sass
var VCard = __webpack_require__("615b");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/mixins/elevatable/index.js
var elevatable = __webpack_require__("c995");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VPicker/VPicker.js





 // Mixins



 // Helpers



/* @vue/component */

/* harmony default export */ var VPicker_VPicker = (Object(mixins["a" /* default */])(colorable["a" /* default */], elevatable["a" /* default */], themeable["a" /* default */]).extend({
  name: 'v-picker',
  props: {
    flat: Boolean,
    fullWidth: Boolean,
    landscape: Boolean,
    noTitle: Boolean,
    transition: {
      type: String,
      default: 'fade-transition'
    },
    width: {
      type: [Number, String],
      default: 290
    }
  },
  computed: {
    computedTitleColor: function computedTitleColor() {
      var defaultTitleColor = this.isDark ? false : this.color || 'primary';
      return this.color || defaultTitleColor;
    }
  },
  methods: {
    genTitle: function genTitle() {
      return this.$createElement('div', this.setBackgroundColor(this.computedTitleColor, {
        staticClass: 'v-picker__title',
        class: {
          'v-picker__title--landscape': this.landscape
        }
      }), this.$slots.title);
    },
    genBodyTransition: function genBodyTransition() {
      return this.$createElement('transition', {
        props: {
          name: this.transition
        }
      }, this.$slots.default);
    },
    genBody: function genBody() {
      return this.$createElement('div', {
        staticClass: 'v-picker__body',
        class: Object(objectSpread2["a" /* default */])({
          'v-picker__body--no-title': this.noTitle
        }, this.themeClasses),
        style: this.fullWidth ? undefined : {
          width: Object(helpers["g" /* convertToUnit */])(this.width)
        }
      }, [this.genBodyTransition()]);
    },
    genActions: function genActions() {
      return this.$createElement('div', {
        staticClass: 'v-picker__actions v-card__actions',
        class: {
          'v-picker__actions--no-title': this.noTitle
        }
      }, this.$slots.actions);
    }
  },
  render: function render(h) {
    return h('div', {
      staticClass: 'v-picker v-card',
      class: Object(objectSpread2["a" /* default */])(Object(objectSpread2["a" /* default */])({
        'v-picker--flat': this.flat,
        'v-picker--landscape': this.landscape,
        'v-picker--full-width': this.fullWidth
      }, this.themeClasses), this.elevationClasses)
    }, [this.$slots.title ? this.genTitle() : null, this.genBody(), this.$slots.actions ? this.genActions() : null]);
  }
}));
// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VPicker/index.js


/* harmony default export */ var components_VPicker = (VPicker_VPicker);
// CONCATENATED MODULE: ./node_modules/vuetify/lib/mixins/picker/index.js



// Components
 // Mixins



 // Utils


/* harmony default export */ var picker = (Object(mixins["a" /* default */])(colorable["a" /* default */], elevatable["a" /* default */], themeable["a" /* default */]
/* @vue/component */
).extend({
  name: 'picker',
  props: {
    flat: Boolean,
    fullWidth: Boolean,
    headerColor: String,
    landscape: Boolean,
    noTitle: Boolean,
    width: {
      type: [Number, String],
      default: 290
    }
  },
  methods: {
    genPickerTitle: function genPickerTitle() {
      return null;
    },
    genPickerBody: function genPickerBody() {
      return null;
    },
    genPickerActionsSlot: function genPickerActionsSlot() {
      return this.$scopedSlots.default ? this.$scopedSlots.default({
        save: this.save,
        cancel: this.cancel
      }) : this.$slots.default;
    },
    genPicker: function genPicker(staticClass) {
      var children = [];

      if (!this.noTitle) {
        var title = this.genPickerTitle();
        title && children.push(title);
      }

      var body = this.genPickerBody();
      body && children.push(body);
      children.push(this.$createElement('template', {
        slot: 'actions'
      }, [this.genPickerActionsSlot()]));
      return this.$createElement(components_VPicker, {
        staticClass: staticClass,
        props: {
          color: this.headerColor || this.color,
          dark: this.dark,
          elevation: this.elevation,
          flat: this.flat,
          fullWidth: this.fullWidth,
          landscape: this.landscape,
          light: this.light,
          width: this.width,
          noTitle: this.noTitle
        }
      }, children);
    }
  }
}));
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__("53ca");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VCalendar/util/timestamp.js




var PARSE_REGEX = /^(\d{4})-(\d{1,2})(-(\d{1,2}))?([^\d]+(\d{1,2}))?(:(\d{1,2}))?(:(\d{1,2}))?$/;
var PARSE_TIME = /(\d\d?)(:(\d\d?)|)(:(\d\d?)|)/;
var DAYS_IN_MONTH = [0, 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
var DAYS_IN_MONTH_LEAP = [0, 31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
var DAYS_IN_MONTH_MIN = 28;
var DAYS_IN_MONTH_MAX = 31;
var MONTH_MAX = 12;
var MONTH_MIN = 1;
var DAY_MIN = 1;
var DAYS_IN_WEEK = 7;
var MINUTES_IN_HOUR = 60;
var MINUTE_MAX = 59;
var MINUTES_IN_DAY = 24 * 60;
var HOURS_IN_DAY = 24;
var HOUR_MAX = 23;
var FIRST_HOUR = 0;
var OFFSET_YEAR = 10000;
var OFFSET_MONTH = 100;
var OFFSET_HOUR = 100;
var OFFSET_TIME = 10000;
function getStartOfWeek(timestamp, weekdays, today) {
  var start = copyTimestamp(timestamp);
  findWeekday(start, weekdays[0], prevDay);
  updateFormatted(start);

  if (today) {
    updateRelative(start, today, start.hasTime);
  }

  return start;
}
function getEndOfWeek(timestamp, weekdays, today) {
  var end = copyTimestamp(timestamp);
  findWeekday(end, weekdays[weekdays.length - 1]);
  updateFormatted(end);

  if (today) {
    updateRelative(end, today, end.hasTime);
  }

  return end;
}
function getStartOfMonth(timestamp) {
  var start = copyTimestamp(timestamp);
  start.day = DAY_MIN;
  updateWeekday(start);
  updateFormatted(start);
  return start;
}
function getEndOfMonth(timestamp) {
  var end = copyTimestamp(timestamp);
  end.day = timestamp_daysInMonth(end.year, end.month);
  updateWeekday(end);
  updateFormatted(end);
  return end;
}
function validateTime(input) {
  return typeof input === 'number' && isFinite(input) || !!PARSE_TIME.exec(input) || Object(esm_typeof["a" /* default */])(input) === 'object' && isFinite(input.hour) && isFinite(input.minute);
}
function parseTime(input) {
  if (typeof input === 'number') {
    // when a number is given, it's minutes since 12:00am
    return input;
  } else if (typeof input === 'string') {
    // when a string is given, it's a hh:mm:ss format where seconds are optional
    var parts = PARSE_TIME.exec(input);

    if (!parts) {
      return false;
    }

    return parseInt(parts[1]) * 60 + parseInt(parts[3] || 0);
  } else if (Object(esm_typeof["a" /* default */])(input) === 'object') {
    // when an object is given, it must have hour and minute
    if (typeof input.hour !== 'number' || typeof input.minute !== 'number') {
      return false;
    }

    return input.hour * 60 + input.minute;
  } else {
    // unsupported type
    return false;
  }
}
function validateTimestamp(input) {
  return typeof input === 'number' && isFinite(input) || typeof input === 'string' && !!PARSE_REGEX.exec(input) || input instanceof Date;
}
function parseTimestamp(input) {
  var required = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var now = arguments.length > 2 ? arguments[2] : undefined;

  if (typeof input === 'number' && isFinite(input)) {
    input = new Date(input);
  }

  if (input instanceof Date) {
    var date = timestamp_parseDate(input);

    if (now) {
      updateRelative(date, now, date.hasTime);
    }

    return date;
  }

  if (typeof input !== 'string') {
    if (required) {
      throw new Error("".concat(input, " is not a valid timestamp. It must be a Date, number of seconds since Epoch, or a string in the format of YYYY-MM-DD or YYYY-MM-DD hh:mm. Zero-padding is optional and seconds are ignored."));
    }

    return null;
  } // YYYY-MM-DD hh:mm:ss


  var parts = PARSE_REGEX.exec(input);

  if (!parts) {
    if (required) {
      throw new Error("".concat(input, " is not a valid timestamp. It must be a Date, number of seconds since Epoch, or a string in the format of YYYY-MM-DD or YYYY-MM-DD hh:mm. Zero-padding is optional and seconds are ignored."));
    }

    return null;
  }

  var timestamp = {
    date: input,
    time: '',
    year: parseInt(parts[1]),
    month: parseInt(parts[2]),
    day: parseInt(parts[4]) || 1,
    hour: parseInt(parts[6]) || 0,
    minute: parseInt(parts[8]) || 0,
    weekday: 0,
    hasDay: !!parts[4],
    hasTime: !!(parts[6] && parts[8]),
    past: false,
    present: false,
    future: false
  };
  updateWeekday(timestamp);
  updateFormatted(timestamp);

  if (now) {
    updateRelative(timestamp, now, timestamp.hasTime);
  }

  return timestamp;
}
function timestamp_parseDate(date) {
  return updateFormatted({
    date: '',
    time: '',
    year: date.getFullYear(),
    month: date.getMonth() + 1,
    day: date.getDate(),
    weekday: date.getDay(),
    hour: date.getHours(),
    minute: date.getMinutes(),
    hasDay: true,
    hasTime: true,
    past: false,
    present: true,
    future: false
  });
}
function getDayIdentifier(timestamp) {
  return timestamp.year * OFFSET_YEAR + timestamp.month * OFFSET_MONTH + timestamp.day;
}
function getTimeIdentifier(timestamp) {
  return timestamp.hour * OFFSET_HOUR + timestamp.minute;
}
function getTimestampIdentifier(timestamp) {
  return getDayIdentifier(timestamp) * OFFSET_TIME + getTimeIdentifier(timestamp);
}
function updateRelative(timestamp, now) {
  var time = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var a = getDayIdentifier(now);
  var b = getDayIdentifier(timestamp);
  var present = a === b;

  if (timestamp.hasTime && time && present) {
    a = getTimeIdentifier(now);
    b = getTimeIdentifier(timestamp);
    present = a === b;
  }

  timestamp.past = b < a;
  timestamp.present = present;
  timestamp.future = b > a;
  return timestamp;
}
function isTimedless(input) {
  return input instanceof Date || typeof input === 'number' && isFinite(input);
}
function updateHasTime(timestamp, hasTime, now) {
  if (timestamp.hasTime !== hasTime) {
    timestamp.hasTime = hasTime;

    if (!hasTime) {
      timestamp.hour = HOUR_MAX;
      timestamp.minute = MINUTE_MAX;
      timestamp.time = getTime(timestamp);
    }

    if (now) {
      updateRelative(timestamp, now, timestamp.hasTime);
    }
  }

  return timestamp;
}
function updateMinutes(timestamp, minutes, now) {
  timestamp.hasTime = true;
  timestamp.hour = Math.floor(minutes / MINUTES_IN_HOUR);
  timestamp.minute = minutes % MINUTES_IN_HOUR;
  timestamp.time = getTime(timestamp);

  if (now) {
    updateRelative(timestamp, now, true);
  }

  return timestamp;
}
function updateWeekday(timestamp) {
  timestamp.weekday = getWeekday(timestamp);
  return timestamp;
}
function updateFormatted(timestamp) {
  timestamp.time = getTime(timestamp);
  timestamp.date = getDate(timestamp);
  return timestamp;
}
function getWeekday(timestamp) {
  if (timestamp.hasDay) {
    var _ = Math.floor;
    var k = timestamp.day;
    var m = (timestamp.month + 9) % MONTH_MAX + 1;

    var C = _(timestamp.year / 100);

    var Y = timestamp.year % 100 - (timestamp.month <= 2 ? 1 : 0);
    return ((k + _(2.6 * m - 0.2) - 2 * C + Y + _(Y / 4) + _(C / 4)) % 7 + 7) % 7;
  }

  return timestamp.weekday;
}
function timestamp_daysInMonth(year, month) {
  return isLeapYear(year) ? DAYS_IN_MONTH_LEAP[month] : DAYS_IN_MONTH[month];
}
function copyTimestamp(timestamp) {
  var date = timestamp.date,
      time = timestamp.time,
      year = timestamp.year,
      month = timestamp.month,
      day = timestamp.day,
      weekday = timestamp.weekday,
      hour = timestamp.hour,
      minute = timestamp.minute,
      hasDay = timestamp.hasDay,
      hasTime = timestamp.hasTime,
      past = timestamp.past,
      present = timestamp.present,
      future = timestamp.future;
  return {
    date: date,
    time: time,
    year: year,
    month: month,
    day: day,
    weekday: weekday,
    hour: hour,
    minute: minute,
    hasDay: hasDay,
    hasTime: hasTime,
    past: past,
    present: present,
    future: future
  };
}
function padNumber(x, length) {
  var padded = String(x);

  while (padded.length < length) {
    padded = '0' + padded;
  }

  return padded;
}
function getDate(timestamp) {
  var str = "".concat(padNumber(timestamp.year, 4), "-").concat(padNumber(timestamp.month, 2));
  if (timestamp.hasDay) str += "-".concat(padNumber(timestamp.day, 2));
  return str;
}
function getTime(timestamp) {
  if (!timestamp.hasTime) {
    return '';
  }

  return "".concat(padNumber(timestamp.hour, 2), ":").concat(padNumber(timestamp.minute, 2));
}
function nextMinutes(timestamp, minutes) {
  timestamp.minute += minutes;

  while (timestamp.minute > MINUTES_IN_HOUR) {
    timestamp.minute -= MINUTES_IN_HOUR;
    timestamp.hour++;

    if (timestamp.hour >= HOURS_IN_DAY) {
      nextDay(timestamp);
      timestamp.hour = FIRST_HOUR;
    }
  }

  return timestamp;
}
function nextDay(timestamp) {
  timestamp.day++;
  timestamp.weekday = (timestamp.weekday + 1) % DAYS_IN_WEEK;

  if (timestamp.day > DAYS_IN_MONTH_MIN && timestamp.day > timestamp_daysInMonth(timestamp.year, timestamp.month)) {
    timestamp.day = DAY_MIN;
    timestamp.month++;

    if (timestamp.month > MONTH_MAX) {
      timestamp.month = MONTH_MIN;
      timestamp.year++;
    }
  }

  return timestamp;
}
function prevDay(timestamp) {
  timestamp.day--;
  timestamp.weekday = (timestamp.weekday + 6) % DAYS_IN_WEEK;

  if (timestamp.day < DAY_MIN) {
    timestamp.month--;

    if (timestamp.month < MONTH_MIN) {
      timestamp.year--;
      timestamp.month = MONTH_MAX;
    }

    timestamp.day = timestamp_daysInMonth(timestamp.year, timestamp.month);
  }

  return timestamp;
}
function relativeDays(timestamp) {
  var mover = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : nextDay;
  var days = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

  while (--days >= 0) {
    mover(timestamp);
  }

  return timestamp;
}
function diffMinutes(min, max) {
  var Y = (max.year - min.year) * 525600;
  var M = (max.month - min.month) * 43800;
  var D = (max.day - min.day) * 1440;
  var h = (max.hour - min.hour) * 60;
  var m = max.minute - min.minute;
  return Y + M + D + h + m;
}
function findWeekday(timestamp, weekday) {
  var mover = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : nextDay;
  var maxDays = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 6;

  while (timestamp.weekday !== weekday && --maxDays >= 0) {
    mover(timestamp);
  }

  return timestamp;
}
function getWeekdaySkips(weekdays) {
  var skips = [1, 1, 1, 1, 1, 1, 1];
  var filled = [0, 0, 0, 0, 0, 0, 0];

  for (var i = 0; i < weekdays.length; i++) {
    filled[weekdays[i]] = 1;
  }

  for (var k = 0; k < DAYS_IN_WEEK; k++) {
    var skip = 1;

    for (var j = 1; j < DAYS_IN_WEEK; j++) {
      var next = (k + j) % DAYS_IN_WEEK;

      if (filled[next]) {
        break;
      }

      skip++;
    }

    skips[k] = filled[k] * skip;
  }

  return skips;
}
function timestampToDate(timestamp) {
  var time = "".concat(padNumber(timestamp.hour, 2), ":").concat(padNumber(timestamp.minute, 2));
  var date = timestamp.date;
  return new Date("".concat(date, "T").concat(time, ":00+00:00"));
}
function createDayList(start, end, now, weekdaySkips) {
  var max = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 42;
  var min = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
  var stop = getDayIdentifier(end);
  var days = [];
  var current = copyTimestamp(start);
  var currentIdentifier = 0;
  var stopped = currentIdentifier === stop;

  if (stop < getDayIdentifier(start)) {
    throw new Error('End date is earlier than start date.');
  }

  while ((!stopped || days.length < min) && days.length < max) {
    currentIdentifier = getDayIdentifier(current);
    stopped = stopped || currentIdentifier === stop;

    if (weekdaySkips[current.weekday] === 0) {
      current = nextDay(current);
      continue;
    }

    var day = copyTimestamp(current);
    updateFormatted(day);
    updateRelative(day, now);
    days.push(day);
    current = relativeDays(current, nextDay, weekdaySkips[current.weekday]);
  }

  if (!days.length) throw new Error('No dates found using specified start date, end date, and weekdays.');
  return days;
}
function createIntervalList(timestamp, first, minutes, count, now) {
  var intervals = [];

  for (var i = 0; i < count; i++) {
    var mins = first + i * minutes;
    var int = copyTimestamp(timestamp);
    intervals.push(updateMinutes(int, mins, now));
  }

  return intervals;
}
function timestamp_createNativeLocaleFormatter(locale, getOptions) {
  var emptyFormatter = function emptyFormatter(_t, _s) {
    return '';
  };

  if (typeof Intl === 'undefined' || typeof Intl.DateTimeFormat === 'undefined') {
    return emptyFormatter;
  }

  return function (timestamp, short) {
    try {
      var intlFormatter = new Intl.DateTimeFormat(locale || undefined, getOptions(timestamp, short));
      return intlFormatter.format(timestampToDate(timestamp));
    } catch (e) {
      return '';
    }
  };
}
// EXTERNAL MODULE: ./node_modules/vuetify/lib/util/console.js + 32 modules
var console = __webpack_require__("d9bd");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VDatePicker/VDatePicker.js











// Components




 // Mixins


 // Utils







/* harmony default export */ var VDatePicker = (Object(mixins["a" /* default */])(localable, picker).extend({
  name: 'v-date-picker',
  props: {
    allowedDates: Function,
    // Function formatting the day in date picker table
    dayFormat: Function,
    disabled: Boolean,
    events: {
      type: [Array, Function, Object],
      default: function _default() {
        return null;
      }
    },
    eventColor: {
      type: [Array, Function, Object, String],
      default: function _default() {
        return 'warning';
      }
    },
    firstDayOfWeek: {
      type: [String, Number],
      default: 0
    },
    // Function formatting the tableDate in the day/month table header
    headerDateFormat: Function,
    localeFirstDayOfYear: {
      type: [String, Number],
      default: 0
    },
    max: String,
    min: String,
    // Function formatting month in the months table
    monthFormat: Function,
    multiple: Boolean,
    nextIcon: {
      type: String,
      default: '$next'
    },
    nextMonthAriaLabel: {
      type: String,
      default: '$vuetify.datePicker.nextMonthAriaLabel'
    },
    nextYearAriaLabel: {
      type: String,
      default: '$vuetify.datePicker.nextYearAriaLabel'
    },
    pickerDate: String,
    prevIcon: {
      type: String,
      default: '$prev'
    },
    prevMonthAriaLabel: {
      type: String,
      default: '$vuetify.datePicker.prevMonthAriaLabel'
    },
    prevYearAriaLabel: {
      type: String,
      default: '$vuetify.datePicker.prevYearAriaLabel'
    },
    range: Boolean,
    reactive: Boolean,
    readonly: Boolean,
    scrollable: Boolean,
    showCurrent: {
      type: [Boolean, String],
      default: true
    },
    selectedItemsText: {
      type: String,
      default: '$vuetify.datePicker.itemsSelected'
    },
    showAdjacentMonths: Boolean,
    showWeek: Boolean,
    // Function formatting currently selected date in the picker title
    titleDateFormat: Function,
    type: {
      type: String,
      default: 'date',
      validator: function validator(type) {
        return ['date', 'month'].includes(type);
      }
    },
    value: [Array, String],
    weekdayFormat: Function,
    // Function formatting the year in table header and pickup title
    yearFormat: Function,
    yearIcon: String
  },
  data: function data() {
    var _this = this;

    var now = new Date();
    return {
      activePicker: this.type.toUpperCase(),
      inputDay: null,
      inputMonth: null,
      inputYear: null,
      isReversing: false,
      now: now,
      // tableDate is a string in 'YYYY' / 'YYYY-M' format (leading zero for month is not required)
      tableDate: function () {
        if (_this.pickerDate) {
          return _this.pickerDate;
        }

        var multipleValue = Object(helpers["H" /* wrapInArray */])(_this.value);
        var date = multipleValue[multipleValue.length - 1] || (typeof _this.showCurrent === 'string' ? _this.showCurrent : "".concat(now.getFullYear(), "-").concat(now.getMonth() + 1));
        return sanitizeDateString(date, _this.type === 'date' ? 'month' : 'year');
      }()
    };
  },
  computed: {
    multipleValue: function multipleValue() {
      return Object(helpers["H" /* wrapInArray */])(this.value);
    },
    isMultiple: function isMultiple() {
      return this.multiple || this.range;
    },
    lastValue: function lastValue() {
      return this.isMultiple ? this.multipleValue[this.multipleValue.length - 1] : this.value;
    },
    selectedMonths: function selectedMonths() {
      if (!this.value || this.type === 'month') {
        return this.value;
      } else if (this.isMultiple) {
        return this.multipleValue.map(function (val) {
          return val.substr(0, 7);
        });
      } else {
        return this.value.substr(0, 7);
      }
    },
    current: function current() {
      if (this.showCurrent === true) {
        return sanitizeDateString("".concat(this.now.getFullYear(), "-").concat(this.now.getMonth() + 1, "-").concat(this.now.getDate()), this.type);
      }

      return this.showCurrent || null;
    },
    inputDate: function inputDate() {
      return this.type === 'date' ? "".concat(this.inputYear, "-").concat(pad(this.inputMonth + 1), "-").concat(pad(this.inputDay)) : "".concat(this.inputYear, "-").concat(pad(this.inputMonth + 1));
    },
    tableMonth: function tableMonth() {
      return Number((this.pickerDate || this.tableDate).split('-')[1]) - 1;
    },
    tableYear: function tableYear() {
      return Number((this.pickerDate || this.tableDate).split('-')[0]);
    },
    minMonth: function minMonth() {
      return this.min ? sanitizeDateString(this.min, 'month') : null;
    },
    maxMonth: function maxMonth() {
      return this.max ? sanitizeDateString(this.max, 'month') : null;
    },
    minYear: function minYear() {
      return this.min ? sanitizeDateString(this.min, 'year') : null;
    },
    maxYear: function maxYear() {
      return this.max ? sanitizeDateString(this.max, 'year') : null;
    },
    formatters: function formatters() {
      return {
        year: this.yearFormat || util_createNativeLocaleFormatter(this.currentLocale, {
          year: 'numeric',
          timeZone: 'UTC'
        }, {
          length: 4
        }),
        titleDate: this.titleDateFormat || (this.isMultiple ? this.defaultTitleMultipleDateFormatter : this.defaultTitleDateFormatter)
      };
    },
    defaultTitleMultipleDateFormatter: function defaultTitleMultipleDateFormatter() {
      var _this2 = this;

      return function (dates) {
        if (!dates.length) {
          return '-';
        }

        if (dates.length === 1) {
          return _this2.defaultTitleDateFormatter(dates[0]);
        }

        return _this2.$vuetify.lang.t(_this2.selectedItemsText, dates.length);
      };
    },
    defaultTitleDateFormatter: function defaultTitleDateFormatter() {
      var titleFormats = {
        year: {
          year: 'numeric',
          timeZone: 'UTC'
        },
        month: {
          month: 'long',
          timeZone: 'UTC'
        },
        date: {
          weekday: 'short',
          month: 'short',
          day: 'numeric',
          timeZone: 'UTC'
        }
      };
      var titleDateFormatter = util_createNativeLocaleFormatter(this.currentLocale, titleFormats[this.type], {
        start: 0,
        length: {
          date: 10,
          month: 7,
          year: 4
        }[this.type]
      });

      var landscapeFormatter = function landscapeFormatter(date) {
        return titleDateFormatter(date).replace(/([^\d\s])([\d])/g, function (match, nonDigit, digit) {
          return "".concat(nonDigit, " ").concat(digit);
        }).replace(', ', ',<br>');
      };

      return this.landscape ? landscapeFormatter : titleDateFormatter;
    }
  },
  watch: {
    tableDate: function tableDate(val, prev) {
      // Make a ISO 8601 strings from val and prev for comparision, otherwise it will incorrectly
      // compare for example '2000-9' and '2000-10'
      var sanitizeType = this.type === 'month' ? 'year' : 'month';
      this.isReversing = sanitizeDateString(val, sanitizeType) < sanitizeDateString(prev, sanitizeType);
      this.$emit('update:picker-date', val);
    },
    pickerDate: function pickerDate(val) {
      if (val) {
        this.tableDate = val;
      } else if (this.lastValue && this.type === 'date') {
        this.tableDate = sanitizeDateString(this.lastValue, 'month');
      } else if (this.lastValue && this.type === 'month') {
        this.tableDate = sanitizeDateString(this.lastValue, 'year');
      }
    },
    value: function value(newValue, oldValue) {
      this.checkMultipleProp();
      this.setInputDate();

      if (!this.isMultiple && this.value && !this.pickerDate || this.isMultiple && this.multipleValue.length && (!oldValue || !oldValue.length) && !this.pickerDate) {
        this.tableDate = sanitizeDateString(this.inputDate, this.type === 'month' ? 'year' : 'month');
      }
    },
    type: function type(_type) {
      this.activePicker = _type.toUpperCase();

      if (this.value && this.value.length) {
        var output = this.multipleValue.map(function (val) {
          return sanitizeDateString(val, _type);
        }).filter(this.isDateAllowed);
        this.$emit('input', this.isMultiple ? output : output[0]);
      }
    }
  },
  created: function created() {
    this.checkMultipleProp();

    if (this.pickerDate !== this.tableDate) {
      this.$emit('update:picker-date', this.tableDate);
    }

    this.setInputDate();
  },
  methods: {
    emitInput: function emitInput(newInput) {
      if (this.range) {
        if (this.multipleValue.length !== 1) {
          this.$emit('input', [newInput]);
        } else {
          var _output = [this.multipleValue[0], newInput];
          this.$emit('input', _output);
          this.$emit('change', _output);
        }

        return;
      }

      var output = this.multiple ? this.multipleValue.indexOf(newInput) === -1 ? this.multipleValue.concat([newInput]) : this.multipleValue.filter(function (x) {
        return x !== newInput;
      }) : newInput;
      this.$emit('input', output);
      this.multiple || this.$emit('change', newInput);
    },
    checkMultipleProp: function checkMultipleProp() {
      if (this.value == null) return;
      var valueType = this.value.constructor.name;
      var expected = this.isMultiple ? 'Array' : 'String';

      if (valueType !== expected) {
        Object(console["c" /* consoleWarn */])("Value must be ".concat(this.isMultiple ? 'an' : 'a', " ").concat(expected, ", got ").concat(valueType), this);
      }
    },
    isDateAllowed: function isDateAllowed(value) {
      return isDateAllowed_isDateAllowed(value, this.min, this.max, this.allowedDates);
    },
    yearClick: function yearClick(value) {
      this.inputYear = value;

      if (this.type === 'month') {
        this.tableDate = "".concat(value);
      } else {
        this.tableDate = "".concat(value, "-").concat(pad((this.tableMonth || 0) + 1));
      }

      this.activePicker = 'MONTH';

      if (this.reactive && !this.readonly && !this.isMultiple && this.isDateAllowed(this.inputDate)) {
        this.$emit('input', this.inputDate);
      }
    },
    monthClick: function monthClick(value) {
      this.inputYear = parseInt(value.split('-')[0], 10);
      this.inputMonth = parseInt(value.split('-')[1], 10) - 1;

      if (this.type === 'date') {
        if (this.inputDay) {
          this.inputDay = Math.min(this.inputDay, timestamp_daysInMonth(this.inputYear, this.inputMonth + 1));
        }

        this.tableDate = value;
        this.activePicker = 'DATE';

        if (this.reactive && !this.readonly && !this.isMultiple && this.isDateAllowed(this.inputDate)) {
          this.$emit('input', this.inputDate);
        }
      } else {
        this.emitInput(this.inputDate);
      }
    },
    dateClick: function dateClick(value) {
      this.inputYear = parseInt(value.split('-')[0], 10);
      this.inputMonth = parseInt(value.split('-')[1], 10) - 1;
      this.inputDay = parseInt(value.split('-')[2], 10);
      this.emitInput(this.inputDate);
    },
    genPickerTitle: function genPickerTitle() {
      var _this3 = this;

      return this.$createElement(VDatePicker_VDatePickerTitle, {
        props: {
          date: this.value ? this.formatters.titleDate(this.isMultiple ? this.multipleValue : this.value) : '',
          disabled: this.disabled,
          readonly: this.readonly,
          selectingYear: this.activePicker === 'YEAR',
          year: this.formatters.year(this.multipleValue.length ? "".concat(this.inputYear) : this.tableDate),
          yearIcon: this.yearIcon,
          value: this.multipleValue[0]
        },
        slot: 'title',
        on: {
          'update:selecting-year': function updateSelectingYear(value) {
            return _this3.activePicker = value ? 'YEAR' : _this3.type.toUpperCase();
          }
        }
      });
    },
    genTableHeader: function genTableHeader() {
      var _this4 = this;

      return this.$createElement(VDatePicker_VDatePickerHeader, {
        props: {
          nextIcon: this.nextIcon,
          color: this.color,
          dark: this.dark,
          disabled: this.disabled,
          format: this.headerDateFormat,
          light: this.light,
          locale: this.locale,
          min: this.activePicker === 'DATE' ? this.minMonth : this.minYear,
          max: this.activePicker === 'DATE' ? this.maxMonth : this.maxYear,
          nextAriaLabel: this.activePicker === 'DATE' ? this.nextMonthAriaLabel : this.nextYearAriaLabel,
          prevAriaLabel: this.activePicker === 'DATE' ? this.prevMonthAriaLabel : this.prevYearAriaLabel,
          prevIcon: this.prevIcon,
          readonly: this.readonly,
          value: this.activePicker === 'DATE' ? "".concat(pad(this.tableYear, 4), "-").concat(pad(this.tableMonth + 1)) : "".concat(pad(this.tableYear, 4))
        },
        on: {
          toggle: function toggle() {
            return _this4.activePicker = _this4.activePicker === 'DATE' ? 'MONTH' : 'YEAR';
          },
          input: function input(value) {
            return _this4.tableDate = value;
          }
        }
      });
    },
    genDateTable: function genDateTable() {
      var _this5 = this;

      return this.$createElement(VDatePickerDateTable, {
        props: {
          allowedDates: this.allowedDates,
          color: this.color,
          current: this.current,
          dark: this.dark,
          disabled: this.disabled,
          events: this.events,
          eventColor: this.eventColor,
          firstDayOfWeek: this.firstDayOfWeek,
          format: this.dayFormat,
          light: this.light,
          locale: this.locale,
          localeFirstDayOfYear: this.localeFirstDayOfYear,
          min: this.min,
          max: this.max,
          range: this.range,
          readonly: this.readonly,
          scrollable: this.scrollable,
          showAdjacentMonths: this.showAdjacentMonths,
          showWeek: this.showWeek,
          tableDate: "".concat(pad(this.tableYear, 4), "-").concat(pad(this.tableMonth + 1)),
          value: this.value,
          weekdayFormat: this.weekdayFormat
        },
        ref: 'table',
        on: Object(objectSpread2["a" /* default */])({
          input: this.dateClick,
          'update:table-date': function updateTableDate(value) {
            return _this5.tableDate = value;
          }
        }, createItemTypeListeners(this, ':date'))
      });
    },
    genMonthTable: function genMonthTable() {
      var _this6 = this;

      return this.$createElement(VDatePickerMonthTable, {
        props: {
          allowedDates: this.type === 'month' ? this.allowedDates : null,
          color: this.color,
          current: this.current ? sanitizeDateString(this.current, 'month') : null,
          dark: this.dark,
          disabled: this.disabled,
          events: this.type === 'month' ? this.events : null,
          eventColor: this.type === 'month' ? this.eventColor : null,
          format: this.monthFormat,
          light: this.light,
          locale: this.locale,
          min: this.minMonth,
          max: this.maxMonth,
          range: this.range,
          readonly: this.readonly && this.type === 'month',
          scrollable: this.scrollable,
          value: this.selectedMonths,
          tableDate: "".concat(pad(this.tableYear, 4))
        },
        ref: 'table',
        on: Object(objectSpread2["a" /* default */])({
          input: this.monthClick,
          'update:table-date': function updateTableDate(value) {
            return _this6.tableDate = value;
          }
        }, createItemTypeListeners(this, ':month'))
      });
    },
    genYears: function genYears() {
      return this.$createElement(VDatePicker_VDatePickerYears, {
        props: {
          color: this.color,
          format: this.yearFormat,
          locale: this.locale,
          min: this.minYear,
          max: this.maxYear,
          value: this.tableYear
        },
        on: Object(objectSpread2["a" /* default */])({
          input: this.yearClick
        }, createItemTypeListeners(this, ':year'))
      });
    },
    genPickerBody: function genPickerBody() {
      var children = this.activePicker === 'YEAR' ? [this.genYears()] : [this.genTableHeader(), this.activePicker === 'DATE' ? this.genDateTable() : this.genMonthTable()];
      return this.$createElement('div', {
        key: this.activePicker
      }, children);
    },
    setInputDate: function setInputDate() {
      if (this.lastValue) {
        var array = this.lastValue.split('-');
        this.inputYear = parseInt(array[0], 10);
        this.inputMonth = parseInt(array[1], 10) - 1;

        if (this.type === 'date') {
          this.inputDay = parseInt(array[2], 10);
        }
      } else {
        this.inputYear = this.inputYear || this.now.getFullYear();
        this.inputMonth = this.inputMonth == null ? this.inputMonth : this.now.getMonth();
        this.inputDay = this.inputDay || this.now.getDate();
      }
    }
  },
  render: function render() {
    return this.genPicker('v-picker--date');
  }
}));
// EXTERNAL MODULE: ./node_modules/vuetify/lib/components/VMenu/VMenu.js
var VMenu = __webpack_require__("e449");

// CONCATENATED MODULE: ./src/components/input/date/PpInputDate.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  date_PpInputDatevue_type_script_lang_js_,
  PpInputDatevue_type_template_id_196abf97_scoped_true_render,
  staticRenderFns,
  false,
  null,
  "196abf97",
  null
  
)

/* harmony default export */ var PpInputDate = __webpack_exports__["default"] = (component.exports);

/* vuetify-loader */



installComponents_default()(component, {VDatePicker: VDatePicker,VMenu: VMenu["a" /* default */]})


/***/ }),

/***/ "9f7f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var fails = __webpack_require__("d039");

// babel-minify transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError,
// so we use an intermediate function.
function RE(s, f) {
  return RegExp(s, f);
}

exports.UNSUPPORTED_Y = fails(function () {
  // babel-minify transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
  var re = RE('a', 'y');
  re.lastIndex = 2;
  return re.exec('abcd') != null;
});

exports.BROKEN_CARET = fails(function () {
  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
  var re = RE('^r', 'gy');
  re.lastIndex = 2;
  return re.exec('str') != null;
});


/***/ }),

/***/ "9f7f1":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("23c7");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("808a1d7c", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "a000":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M9 10H22L21.5 19L13.4715 20.5439C10.9347 21.0318 8.6077 19.023 8.71991 16.4422L9 10Z\" fill=\"white\"></path><path d=\"M3 2C2.44772 2 2 2.44772 2 3V13C2 13.5523 2.44772 14 3 14H7V11C7 9.34315 8.34315 8 10 8H18V3C18 2.44772 17.5523 2 17 2H3Z\" fill=\"#D5EAFD\"></path><path d=\"M13 13H11V15H13V13Z\" fill=\"#079CB2\"></path><path d=\"M16 13H14V15H16V13Z\" fill=\"#079CB2\"></path><path d=\"M17 13H19V15H17V13Z\" fill=\"#079CB2\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M17 1H3C1.89543 1 1 1.89543 1 3V13C1 14.1046 1.89543 15 3 15H7V17C7 18.5977 8.24892 19.9037 9.82373 19.9949L9.999 20L10 22.0005C10 22.1704 10.0433 22.3376 10.1258 22.4861C10.3941 22.9689 11.0029 23.1429 11.4856 22.8746L16.659 20H20C21.6569 20 23 18.6569 23 17V11C23 9.34315 21.6569 8 20 8H19V3C19 1.89543 18.1046 1 17 1ZM7 11V13H3V4.49959L8.07206 8.70142C7.41664 9.25174 7 10.0772 7 11ZM9.99663 10C9.44589 10.0018 9 10.4488 9 11V17C9 17.5301 9.41451 17.9678 9.88181 17.9958L11.998 18.0572L11.9992 20.3013L16.1407 18H20C20.5523 18 21 17.5523 21 17V11C21 10.4477 20.5523 10 20 10L9.99663 10ZM17 4.31709L12.7033 8H17V4.31709ZM15.4634 3H4.32487L9.98903 7.69234L15.4634 3Z\" fill=\"#079CB2\"></path></svg>";

/***/ }),

/***/ "a03c":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.i, "@import url(https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css);"]);
exports.push([module.i, "@import url(https://cdn-prd.patientpop.com/pp-icon-font/v1.6.0/pp-icon-font.css);"]);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.pp-avatar-info__content[data-v-b0984a4c]{min-width:0}.virtual-visit-address[data-v-b0984a4c]{background-color:#e7d8ff;color:#8657ac;height:20px}.virtual-visit-address .virtual-visit-tag__text[data-v-b0984a4c]{font-size:12px;letter-spacing:-.02em;line-height:20px}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "a122":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpInputLabel_vue_vue_type_style_index_0_id_a024b9e8_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("0280");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpInputLabel_vue_vue_type_style_index_0_id_a024b9e8_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpInputLabel_vue_vue_type_style_index_0_id_a024b9e8_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "a15b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var IndexedObject = __webpack_require__("44ad");
var toIndexedObject = __webpack_require__("fc6a");
var arrayMethodIsStrict = __webpack_require__("a640");

var nativeJoin = [].join;

var ES3_STRINGS = IndexedObject != Object;
var STRICT_METHOD = arrayMethodIsStrict('join', ',');

// `Array.prototype.join` method
// https://tc39.es/ecma262/#sec-array.prototype.join
$({ target: 'Array', proto: true, forced: ES3_STRINGS || !STRICT_METHOD }, {
  join: function join(separator) {
    return nativeJoin.call(toIndexedObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),

/***/ "a236":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var core_js_modules_es_array_join_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("a15b");
/* harmony import */ var core_js_modules_es_array_join_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ac1f");
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_string_split_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("1276");
/* harmony import */ var core_js_modules_es_string_split_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("ade3");
/* harmony import */ var _home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_createForOfIteratorHelper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("b85c");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("8bbf");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_5__);






/* @vue/component */

/* harmony default export */ __webpack_exports__["a"] = (vue__WEBPACK_IMPORTED_MODULE_5___default.a.extend({
  name: 'roundable',
  props: {
    rounded: [Boolean, String],
    tile: Boolean
  },
  computed: {
    roundedClasses: function roundedClasses() {
      var composite = [];
      var rounded = typeof this.rounded === 'string' ? String(this.rounded) : this.rounded === true;

      if (this.tile) {
        composite.push('rounded-0');
      } else if (typeof rounded === 'string') {
        var values = rounded.split(' ');

        var _iterator = Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_createForOfIteratorHelper__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(values),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var value = _step.value;
            composite.push("rounded-".concat(value));
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      } else if (rounded) {
        composite.push('rounded');
      }

      return composite.length > 0 ? Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])({}, composite.join(' '), true) : {};
    }
  }
}));

/***/ }),

/***/ "a293":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ClickOutside */
/* harmony import */ var core_js_modules_es_array_some_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("45fc");
/* harmony import */ var core_js_modules_es_array_some_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("53ca");



function defaultConditional() {
  return true;
}

function directive(e, el, binding) {
  var handler = typeof binding.value === 'function' ? binding.value : binding.value.handler;
  var isActive = Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(binding.value) === 'object' && binding.value.closeConditional || defaultConditional; // The include element callbacks below can be expensive
  // so we should avoid calling them when we're not active.
  // Explicitly check for false to allow fallback compatibility
  // with non-toggleable components

  if (!e || isActive(e) === false) return; // Check if additional elements were passed to be included in check
  // (click must be outside all included elements, if any)

  var elements = (Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(binding.value) === 'object' && binding.value.include || function () {
    return [];
  })(); // Add the root element for the component this directive was defined on


  elements.push(el); // Check if it's a click outside our elements, and then if our callback returns true.
  // Non-toggleable components should take action in their callback and return falsy.
  // Toggleable can return true if it wants to deactivate.
  // Note that, because we're in the capture phase, this callback will occur before
  // the bubbling click event on any outside elements.

  !elements.some(function (el) {
    return el.contains(e.target);
  }) && setTimeout(function () {
    isActive(e) && handler && handler(e);
  }, 0);
}

var ClickOutside = {
  // [data-app] may not be found
  // if using bind, inserted makes
  // sure that the root element is
  // available, iOS does not support
  // clicks on body
  inserted: function inserted(el, binding) {
    var onClick = function onClick(e) {
      return directive(e, el, binding);
    }; // iOS does not recognize click events on document
    // or body, this is the entire purpose of the v-app
    // component and [data-app], stop removing this


    var app = document.querySelector('[data-app]') || document.body; // This is only for unit tests

    app.addEventListener('click', onClick, true);
    el._clickOutside = onClick;
  },
  unbind: function unbind(el) {
    if (!el._clickOutside) return;
    var app = document.querySelector('[data-app]') || document.body; // This is only for unit tests

    app && app.removeEventListener('click', el._clickOutside, true);
    delete el._clickOutside;
  }
};
/* harmony default export */ __webpack_exports__["a"] = (ClickOutside);

/***/ }),

/***/ "a2bf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isArray = __webpack_require__("e8b5");
var toLength = __webpack_require__("50c4");
var bind = __webpack_require__("0366");

// `FlattenIntoArray` abstract operation
// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var flattenIntoArray = function (target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? bind(mapper, thisArg, 3) : false;
  var element;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      if (depth > 0 && isArray(element)) {
        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
      } else {
        if (targetIndex >= 0x1FFFFFFFFFFFFF) throw TypeError('Exceed the acceptable array length');
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
};

module.exports = flattenIntoArray;


/***/ }),

/***/ "a431":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("c8d5")

/**
 * @category Common Helpers
 * @summary Is the first date after the second one?
 *
 * @description
 * Is the first date after the second one?
 *
 * @param {Date|String|Number} date - the date that should be after the other one to return true
 * @param {Date|String|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is after the second date
 *
 * @example
 * // Is 10 July 1989 after 11 February 1987?
 * var result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> true
 */
function isAfter (dirtyDate, dirtyDateToCompare) {
  var date = parse(dirtyDate)
  var dateToCompare = parse(dirtyDateToCompare)
  return date.getTime() > dateToCompare.getTime()
}

module.exports = isAfter


/***/ }),

/***/ "a434":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var toAbsoluteIndex = __webpack_require__("23cb");
var toInteger = __webpack_require__("a691");
var toLength = __webpack_require__("50c4");
var toObject = __webpack_require__("7b0b");
var arraySpeciesCreate = __webpack_require__("65f0");
var createProperty = __webpack_require__("8418");
var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");
var arrayMethodUsesToLength = __webpack_require__("ae40");

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('splice');
var USES_TO_LENGTH = arrayMethodUsesToLength('splice', { ACCESSORS: true, 0: 0, 1: 2 });

var max = Math.max;
var min = Math.min;
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
var MAXIMUM_ALLOWED_LENGTH_EXCEEDED = 'Maximum allowed length exceeded';

// `Array.prototype.splice` method
// https://tc39.es/ecma262/#sec-array.prototype.splice
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT || !USES_TO_LENGTH }, {
  splice: function splice(start, deleteCount /* , ...items */) {
    var O = toObject(this);
    var len = toLength(O.length);
    var actualStart = toAbsoluteIndex(start, len);
    var argumentsLength = arguments.length;
    var insertCount, actualDeleteCount, A, k, from, to;
    if (argumentsLength === 0) {
      insertCount = actualDeleteCount = 0;
    } else if (argumentsLength === 1) {
      insertCount = 0;
      actualDeleteCount = len - actualStart;
    } else {
      insertCount = argumentsLength - 2;
      actualDeleteCount = min(max(toInteger(deleteCount), 0), len - actualStart);
    }
    if (len + insertCount - actualDeleteCount > MAX_SAFE_INTEGER) {
      throw TypeError(MAXIMUM_ALLOWED_LENGTH_EXCEEDED);
    }
    A = arraySpeciesCreate(O, actualDeleteCount);
    for (k = 0; k < actualDeleteCount; k++) {
      from = actualStart + k;
      if (from in O) createProperty(A, k, O[from]);
    }
    A.length = actualDeleteCount;
    if (insertCount < actualDeleteCount) {
      for (k = actualStart; k < len - actualDeleteCount; k++) {
        from = k + actualDeleteCount;
        to = k + insertCount;
        if (from in O) O[to] = O[from];
        else delete O[to];
      }
      for (k = len; k > len - actualDeleteCount + insertCount; k--) delete O[k - 1];
    } else if (insertCount > actualDeleteCount) {
      for (k = len - actualDeleteCount; k > actualStart; k--) {
        from = k + actualDeleteCount - 1;
        to = k + insertCount - 1;
        if (from in O) O[to] = O[from];
        else delete O[to];
      }
    }
    for (k = 0; k < insertCount; k++) {
      O[k + actualStart] = arguments[k + 2];
    }
    O.length = len - actualDeleteCount + insertCount;
    return A;
  }
});


/***/ }),

/***/ "a452":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export factory */
/* harmony import */ var _home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ade3");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("8bbf");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_1__);


function factory() {
  var prop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'value';
  var event = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'change';
  return vue__WEBPACK_IMPORTED_MODULE_1___default.a.extend({
    name: 'proxyable',
    model: {
      prop: prop,
      event: event
    },
    props: Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({}, prop, {
      required: false
    }),
    data: function data() {
      return {
        internalLazyValue: this[prop]
      };
    },
    computed: {
      internalValue: {
        get: function get() {
          return this.internalLazyValue;
        },
        set: function set(val) {
          if (val === this.internalLazyValue) return;
          this.internalLazyValue = val;
          this.$emit(event, val);
        }
      }
    },
    watch: Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({}, prop, function (val) {
      this.internalLazyValue = val;
    })
  });
}
/* eslint-disable-next-line @typescript-eslint/no-redeclare */

var Proxyable = factory();
/* harmony default export */ __webpack_exports__["a"] = (Proxyable);

/***/ }),

/***/ "a493":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.theme--light.v-expansion-panels .v-expansion-panel{background-color:var(--cards-color,#fff);color:var(--pp-text-primary,#2b2b2b)}.theme--light.v-expansion-panels .v-expansion-panel--disabled{color:var(--pp-text-disabled,#f6f6f6)}.theme--light.v-expansion-panels .v-expansion-panel:not(:first-child):after{border-color:#d6d6d6}.theme--light.v-expansion-panels .v-expansion-panel-header .v-expansion-panel-header__icon .v-icon{color:var(--active-icon,#2b2b2b)}.theme--light.v-expansion-panels.v-expansion-panels--focusable .v-expansion-panel-header:hover:before{opacity:.1}.theme--light.v-expansion-panels.v-expansion-panels--focusable .v-expansion-panel-header--active:before,.theme--light.v-expansion-panels.v-expansion-panels--focusable .v-expansion-panel-header--active:hover:before,.theme--light.v-expansion-panels.v-expansion-panels--focusable .v-expansion-panel-header:focus:before{opacity:.12}.theme--light.v-expansion-panels.v-expansion-panels--focusable .v-expansion-panel-header--active:focus:before{opacity:.16}.theme--light.v-expansion-panels.v-expansion-panels--hover>.v-expansion-panel>.v-expansion-panel-header:hover:hover:before{opacity:.1}.theme--light.v-expansion-panels.v-expansion-panels--hover>.v-expansion-panel>.v-expansion-panel-header:hover--active:before,.theme--light.v-expansion-panels.v-expansion-panels--hover>.v-expansion-panel>.v-expansion-panel-header:hover--active:hover:before,.theme--light.v-expansion-panels.v-expansion-panels--hover>.v-expansion-panel>.v-expansion-panel-header:hover:focus:before{opacity:.12}.theme--light.v-expansion-panels.v-expansion-panels--hover>.v-expansion-panel>.v-expansion-panel-header:hover--active:focus:before{opacity:.16}.theme--dark.v-expansion-panels .v-expansion-panel{background-color:#1e1e1e;color:var(--pp-primary-button-text-color,#004852)}.theme--dark.v-expansion-panels .v-expansion-panel--disabled{color:hsla(0,0%,100%,.5)}.theme--dark.v-expansion-panels .v-expansion-panel:not(:first-child):after{border-color:hsla(0,0%,100%,.12)}.theme--dark.v-expansion-panels .v-expansion-panel-header .v-expansion-panel-header__icon .v-icon{color:#fff}.theme--dark.v-expansion-panels.v-expansion-panels--focusable .v-expansion-panel-header:hover:before{opacity:.08}.theme--dark.v-expansion-panels.v-expansion-panels--focusable .v-expansion-panel-header--active:before,.theme--dark.v-expansion-panels.v-expansion-panels--focusable .v-expansion-panel-header--active:hover:before,.theme--dark.v-expansion-panels.v-expansion-panels--focusable .v-expansion-panel-header:focus:before{opacity:.24}.theme--dark.v-expansion-panels.v-expansion-panels--focusable .v-expansion-panel-header--active:focus:before{opacity:.32}.theme--dark.v-expansion-panels.v-expansion-panels--hover>.v-expansion-panel>.v-expansion-panel-header:hover:hover:before{opacity:.08}.theme--dark.v-expansion-panels.v-expansion-panels--hover>.v-expansion-panel>.v-expansion-panel-header:hover--active:before,.theme--dark.v-expansion-panels.v-expansion-panels--hover>.v-expansion-panel>.v-expansion-panel-header:hover--active:hover:before,.theme--dark.v-expansion-panels.v-expansion-panels--hover>.v-expansion-panel>.v-expansion-panel-header:hover:focus:before{opacity:.24}.theme--dark.v-expansion-panels.v-expansion-panels--hover>.v-expansion-panel>.v-expansion-panel-header:hover--active:focus:before{opacity:.32}.v-expansion-panels{border-radius:5px;display:flex;flex-wrap:wrap;justify-content:center;list-style-type:none;padding:0;width:100%;z-index:1}.v-expansion-panels>*{cursor:auto}.v-expansion-panels>:first-child{border-top-left-radius:inherit;border-top-right-radius:inherit}.v-expansion-panels>:last-child{border-bottom-left-radius:inherit;border-bottom-right-radius:inherit}.v-expansion-panels:not(.v-expansion-panels--accordion):not(.v-expansion-panels--tile)>.v-expansion-panel--active{border-radius:5px}.v-expansion-panels:not(.v-expansion-panels--accordion):not(.v-expansion-panels--tile)>.v-expansion-panel--active+.v-expansion-panel{border-top-left-radius:5px;border-top-right-radius:5px}.v-expansion-panels:not(.v-expansion-panels--accordion):not(.v-expansion-panels--tile)>.v-expansion-panel--next-active{border-bottom-left-radius:5px;border-bottom-right-radius:5px}.v-expansion-panels:not(.v-expansion-panels--accordion):not(.v-expansion-panels--tile)>.v-expansion-panel--next-active .v-expansion-panel-header{border-bottom-left-radius:inherit;border-bottom-right-radius:inherit}.v-expansion-panel{flex:1 0 100%;max-width:100%;position:relative;transition:.3s cubic-bezier(.25,.8,.5,1)}.v-expansion-panel:before{border-radius:inherit;bottom:0;content:\"\";left:0;position:absolute;right:0;top:0;z-index:-1;transition:box-shadow .28s cubic-bezier(.4,0,.2,1);will-change:box-shadow;box-shadow:0 3px 1px -2px transparent,0 2px 2px 0 transparent,0 1px 5px 0 rgba(0,0,0,.12)}.v-expansion-panel:not(:first-child):after{border-top:thin solid;content:\"\";left:0;position:absolute;right:0;top:0;transition:border-color .2s cubic-bezier(.4,0,.2,1),opacity .2s cubic-bezier(.4,0,.2,1)}.v-expansion-panel--disabled .v-expansion-panel-header{pointer-events:none}.v-expansion-panel--active+.v-expansion-panel,.v-expansion-panel--active:not(:first-child){margin-top:16px}.v-expansion-panel--active+.v-expansion-panel:after,.v-expansion-panel--active:not(:first-child):after{opacity:0}.v-expansion-panel--active>.v-expansion-panel-header{min-height:64px}.v-expansion-panel--active>.v-expansion-panel-header--active .v-expansion-panel-header__icon:not(.v-expansion-panel-header__icon--disable-rotate) .v-icon{transform:rotate(-180deg)}.v-expansion-panel-header__icon{display:inline-flex;margin-bottom:-4px;margin-top:-4px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.v-application--is-ltr .v-expansion-panel-header__icon{margin-left:auto}.v-application--is-rtl .v-expansion-panel-header__icon{margin-right:auto}.v-expansion-panel-header{align-items:center;border-top-left-radius:inherit;border-top-right-radius:inherit;display:flex;font-size:var(--pp-expansion-panel-header-font-size,.9375rem);line-height:1;min-height:48px;outline:none;padding:var(--pp-expansion-panel-header-padding,16px 24px);position:relative;transition:min-height .3s cubic-bezier(.25,.8,.5,1);width:100%}.v-application--is-ltr .v-expansion-panel-header{text-align:left}.v-application--is-rtl .v-expansion-panel-header{text-align:right}.v-expansion-panel-header:not(.v-expansion-panel-header--mousedown):focus:before{opacity:.12}.v-expansion-panel-header:before{background-color:currentColor;border-radius:inherit;bottom:0;content:\"\";left:0;opacity:0;pointer-events:none;position:absolute;right:0;top:0;transition:opacity .3s cubic-bezier(.25,.8,.5,1)}.v-expansion-panel-header>:not(.v-expansion-panel-header__icon){flex:1 1 auto}.v-expansion-panel-content{display:flex}.v-expansion-panel-content__wrap{padding:0 24px 16px;flex:1 1 auto;max-width:100%}.v-expansion-panels--accordion>.v-expansion-panel{margin-top:0}.v-expansion-panels--accordion>.v-expansion-panel:after{opacity:1}.v-expansion-panels--popout>.v-expansion-panel{max-width:calc(100% - 32px)}.v-expansion-panels--popout>.v-expansion-panel--active{max-width:calc(100% + 16px)}.v-expansion-panels--inset>.v-expansion-panel{max-width:100%}.v-expansion-panels--inset>.v-expansion-panel--active{max-width:calc(100% - 32px)}.v-expansion-panels--flat>.v-expansion-panel:after{border-top:none}.v-expansion-panels--flat>.v-expansion-panel:before{box-shadow:0 0 0 0 transparent,0 0 0 0 transparent,0 0 0 0 rgba(0,0,0,.12)}.v-expansion-panels--tile,.v-expansion-panels--tile>.v-expansion-panel:before{border-radius:0}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "a4b4":
/***/ (function(module, exports, __webpack_require__) {

var userAgent = __webpack_require__("342f");

module.exports = /web0s(?!.*chrome)/i.test(userAgent);


/***/ }),

/***/ "a4b7":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("c8d5")

/**
 * @category Year Helpers
 * @summary Return the start of a year for the given date.
 *
 * @description
 * Return the start of a year for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of a year
 *
 * @example
 * // The start of a year for 2 September 2014 11:55:00:
 * var result = startOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Jan 01 2014 00:00:00
 */
function startOfYear (dirtyDate) {
  var cleanDate = parse(dirtyDate)
  var date = new Date(0)
  date.setFullYear(cleanDate.getFullYear(), 0, 1)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = startOfYear


/***/ }),

/***/ "a4d1":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.i, "@import url(https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css);"]);
exports.push([module.i, "@import url(https://cdn-prd.patientpop.com/pp-icon-font/v1.6.0/pp-icon-font.css);"]);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.pp-color-picker__mode-select__options .v-list-item{--pp-list-item-padding:6px 6px}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "a4d3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var global = __webpack_require__("da84");
var getBuiltIn = __webpack_require__("d066");
var IS_PURE = __webpack_require__("c430");
var DESCRIPTORS = __webpack_require__("83ab");
var NATIVE_SYMBOL = __webpack_require__("4930");
var USE_SYMBOL_AS_UID = __webpack_require__("fdbf");
var fails = __webpack_require__("d039");
var has = __webpack_require__("5135");
var isArray = __webpack_require__("e8b5");
var isObject = __webpack_require__("861d");
var anObject = __webpack_require__("825a");
var toObject = __webpack_require__("7b0b");
var toIndexedObject = __webpack_require__("fc6a");
var toPrimitive = __webpack_require__("c04e");
var createPropertyDescriptor = __webpack_require__("5c6c");
var nativeObjectCreate = __webpack_require__("7c73");
var objectKeys = __webpack_require__("df75");
var getOwnPropertyNamesModule = __webpack_require__("241c");
var getOwnPropertyNamesExternal = __webpack_require__("057f");
var getOwnPropertySymbolsModule = __webpack_require__("7418");
var getOwnPropertyDescriptorModule = __webpack_require__("06cf");
var definePropertyModule = __webpack_require__("9bf2");
var propertyIsEnumerableModule = __webpack_require__("d1e7");
var createNonEnumerableProperty = __webpack_require__("9112");
var redefine = __webpack_require__("6eeb");
var shared = __webpack_require__("5692");
var sharedKey = __webpack_require__("f772");
var hiddenKeys = __webpack_require__("d012");
var uid = __webpack_require__("90e3");
var wellKnownSymbol = __webpack_require__("b622");
var wrappedWellKnownSymbolModule = __webpack_require__("e538");
var defineWellKnownSymbol = __webpack_require__("746f");
var setToStringTag = __webpack_require__("d44e");
var InternalStateModule = __webpack_require__("69f3");
var $forEach = __webpack_require__("b727").forEach;

var HIDDEN = sharedKey('hidden');
var SYMBOL = 'Symbol';
var PROTOTYPE = 'prototype';
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(SYMBOL);
var ObjectPrototype = Object[PROTOTYPE];
var $Symbol = global.Symbol;
var $stringify = getBuiltIn('JSON', 'stringify');
var nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
var nativeDefineProperty = definePropertyModule.f;
var nativeGetOwnPropertyNames = getOwnPropertyNamesExternal.f;
var nativePropertyIsEnumerable = propertyIsEnumerableModule.f;
var AllSymbols = shared('symbols');
var ObjectPrototypeSymbols = shared('op-symbols');
var StringToSymbolRegistry = shared('string-to-symbol-registry');
var SymbolToStringRegistry = shared('symbol-to-string-registry');
var WellKnownSymbolsStore = shared('wks');
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var USE_SETTER = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDescriptor = DESCRIPTORS && fails(function () {
  return nativeObjectCreate(nativeDefineProperty({}, 'a', {
    get: function () { return nativeDefineProperty(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (O, P, Attributes) {
  var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor(ObjectPrototype, P);
  if (ObjectPrototypeDescriptor) delete ObjectPrototype[P];
  nativeDefineProperty(O, P, Attributes);
  if (ObjectPrototypeDescriptor && O !== ObjectPrototype) {
    nativeDefineProperty(ObjectPrototype, P, ObjectPrototypeDescriptor);
  }
} : nativeDefineProperty;

var wrap = function (tag, description) {
  var symbol = AllSymbols[tag] = nativeObjectCreate($Symbol[PROTOTYPE]);
  setInternalState(symbol, {
    type: SYMBOL,
    tag: tag,
    description: description
  });
  if (!DESCRIPTORS) symbol.description = description;
  return symbol;
};

var isSymbol = USE_SYMBOL_AS_UID ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return Object(it) instanceof $Symbol;
};

var $defineProperty = function defineProperty(O, P, Attributes) {
  if (O === ObjectPrototype) $defineProperty(ObjectPrototypeSymbols, P, Attributes);
  anObject(O);
  var key = toPrimitive(P, true);
  anObject(Attributes);
  if (has(AllSymbols, key)) {
    if (!Attributes.enumerable) {
      if (!has(O, HIDDEN)) nativeDefineProperty(O, HIDDEN, createPropertyDescriptor(1, {}));
      O[HIDDEN][key] = true;
    } else {
      if (has(O, HIDDEN) && O[HIDDEN][key]) O[HIDDEN][key] = false;
      Attributes = nativeObjectCreate(Attributes, { enumerable: createPropertyDescriptor(0, false) });
    } return setSymbolDescriptor(O, key, Attributes);
  } return nativeDefineProperty(O, key, Attributes);
};

var $defineProperties = function defineProperties(O, Properties) {
  anObject(O);
  var properties = toIndexedObject(Properties);
  var keys = objectKeys(properties).concat($getOwnPropertySymbols(properties));
  $forEach(keys, function (key) {
    if (!DESCRIPTORS || $propertyIsEnumerable.call(properties, key)) $defineProperty(O, key, properties[key]);
  });
  return O;
};

var $create = function create(O, Properties) {
  return Properties === undefined ? nativeObjectCreate(O) : $defineProperties(nativeObjectCreate(O), Properties);
};

var $propertyIsEnumerable = function propertyIsEnumerable(V) {
  var P = toPrimitive(V, true);
  var enumerable = nativePropertyIsEnumerable.call(this, P);
  if (this === ObjectPrototype && has(AllSymbols, P) && !has(ObjectPrototypeSymbols, P)) return false;
  return enumerable || !has(this, P) || !has(AllSymbols, P) || has(this, HIDDEN) && this[HIDDEN][P] ? enumerable : true;
};

var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(O, P) {
  var it = toIndexedObject(O);
  var key = toPrimitive(P, true);
  if (it === ObjectPrototype && has(AllSymbols, key) && !has(ObjectPrototypeSymbols, key)) return;
  var descriptor = nativeGetOwnPropertyDescriptor(it, key);
  if (descriptor && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) {
    descriptor.enumerable = true;
  }
  return descriptor;
};

var $getOwnPropertyNames = function getOwnPropertyNames(O) {
  var names = nativeGetOwnPropertyNames(toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (!has(AllSymbols, key) && !has(hiddenKeys, key)) result.push(key);
  });
  return result;
};

var $getOwnPropertySymbols = function getOwnPropertySymbols(O) {
  var IS_OBJECT_PROTOTYPE = O === ObjectPrototype;
  var names = nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? ObjectPrototypeSymbols : toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (has(AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || has(ObjectPrototype, key))) {
      result.push(AllSymbols[key]);
    }
  });
  return result;
};

// `Symbol` constructor
// https://tc39.es/ecma262/#sec-symbol-constructor
if (!NATIVE_SYMBOL) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor');
    var description = !arguments.length || arguments[0] === undefined ? undefined : String(arguments[0]);
    var tag = uid(description);
    var setter = function (value) {
      if (this === ObjectPrototype) setter.call(ObjectPrototypeSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDescriptor(this, tag, createPropertyDescriptor(1, value));
    };
    if (DESCRIPTORS && USE_SETTER) setSymbolDescriptor(ObjectPrototype, tag, { configurable: true, set: setter });
    return wrap(tag, description);
  };

  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return getInternalState(this).tag;
  });

  redefine($Symbol, 'withoutSetter', function (description) {
    return wrap(uid(description), description);
  });

  propertyIsEnumerableModule.f = $propertyIsEnumerable;
  definePropertyModule.f = $defineProperty;
  getOwnPropertyDescriptorModule.f = $getOwnPropertyDescriptor;
  getOwnPropertyNamesModule.f = getOwnPropertyNamesExternal.f = $getOwnPropertyNames;
  getOwnPropertySymbolsModule.f = $getOwnPropertySymbols;

  wrappedWellKnownSymbolModule.f = function (name) {
    return wrap(wellKnownSymbol(name), name);
  };

  if (DESCRIPTORS) {
    // https://github.com/tc39/proposal-Symbol-description
    nativeDefineProperty($Symbol[PROTOTYPE], 'description', {
      configurable: true,
      get: function description() {
        return getInternalState(this).description;
      }
    });
    if (!IS_PURE) {
      redefine(ObjectPrototype, 'propertyIsEnumerable', $propertyIsEnumerable, { unsafe: true });
    }
  }
}

$({ global: true, wrap: true, forced: !NATIVE_SYMBOL, sham: !NATIVE_SYMBOL }, {
  Symbol: $Symbol
});

$forEach(objectKeys(WellKnownSymbolsStore), function (name) {
  defineWellKnownSymbol(name);
});

$({ target: SYMBOL, stat: true, forced: !NATIVE_SYMBOL }, {
  // `Symbol.for` method
  // https://tc39.es/ecma262/#sec-symbol.for
  'for': function (key) {
    var string = String(key);
    if (has(StringToSymbolRegistry, string)) return StringToSymbolRegistry[string];
    var symbol = $Symbol(string);
    StringToSymbolRegistry[string] = symbol;
    SymbolToStringRegistry[symbol] = string;
    return symbol;
  },
  // `Symbol.keyFor` method
  // https://tc39.es/ecma262/#sec-symbol.keyfor
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol');
    if (has(SymbolToStringRegistry, sym)) return SymbolToStringRegistry[sym];
  },
  useSetter: function () { USE_SETTER = true; },
  useSimple: function () { USE_SETTER = false; }
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL, sham: !DESCRIPTORS }, {
  // `Object.create` method
  // https://tc39.es/ecma262/#sec-object.create
  create: $create,
  // `Object.defineProperty` method
  // https://tc39.es/ecma262/#sec-object.defineproperty
  defineProperty: $defineProperty,
  // `Object.defineProperties` method
  // https://tc39.es/ecma262/#sec-object.defineproperties
  defineProperties: $defineProperties,
  // `Object.getOwnPropertyDescriptor` method
  // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL }, {
  // `Object.getOwnPropertyNames` method
  // https://tc39.es/ecma262/#sec-object.getownpropertynames
  getOwnPropertyNames: $getOwnPropertyNames,
  // `Object.getOwnPropertySymbols` method
  // https://tc39.es/ecma262/#sec-object.getownpropertysymbols
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
$({ target: 'Object', stat: true, forced: fails(function () { getOwnPropertySymbolsModule.f(1); }) }, {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return getOwnPropertySymbolsModule.f(toObject(it));
  }
});

// `JSON.stringify` method behavior with symbols
// https://tc39.es/ecma262/#sec-json.stringify
if ($stringify) {
  var FORCED_JSON_STRINGIFY = !NATIVE_SYMBOL || fails(function () {
    var symbol = $Symbol();
    // MS Edge converts symbol values to JSON as {}
    return $stringify([symbol]) != '[null]'
      // WebKit converts symbol values to JSON as null
      || $stringify({ a: symbol }) != '{}'
      // V8 throws on boxed symbols
      || $stringify(Object(symbol)) != '{}';
  });

  $({ target: 'JSON', stat: true, forced: FORCED_JSON_STRINGIFY }, {
    // eslint-disable-next-line no-unused-vars
    stringify: function stringify(it, replacer, space) {
      var args = [it];
      var index = 1;
      var $replacer;
      while (arguments.length > index) args.push(arguments[index++]);
      $replacer = replacer;
      if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
      if (!isArray(replacer)) replacer = function (key, value) {
        if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
        if (!isSymbol(value)) return value;
      };
      args[1] = replacer;
      return $stringify.apply(null, args);
    }
  });
}

// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
if (!$Symbol[PROTOTYPE][TO_PRIMITIVE]) {
  createNonEnumerableProperty($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
}
// `Symbol.prototype[@@toStringTag]` property
// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
setToStringTag($Symbol, SYMBOL);

hiddenKeys[HIDDEN] = true;


/***/ }),

/***/ "a523":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("99af");
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("4de4");
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("b64b");
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_string_starts_with_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("2ca0");
/* harmony import */ var core_js_modules_es_string_starts_with_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_starts_with_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _src_components_VGrid_grid_sass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("20f6");
/* harmony import */ var _src_components_VGrid_grid_sass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_src_components_VGrid_grid_sass__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _src_components_VGrid_VGrid_sass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("4b85");
/* harmony import */ var _src_components_VGrid_VGrid_sass__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_src_components_VGrid_VGrid_sass__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _grid__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("e8f2");
/* harmony import */ var _util_mergeData__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("d9f7");








/* @vue/component */

/* harmony default export */ __webpack_exports__["a"] = (Object(_grid__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])('container').extend({
  name: 'v-container',
  functional: true,
  props: {
    id: String,
    tag: {
      type: String,
      default: 'div'
    },
    fluid: {
      type: Boolean,
      default: false
    }
  },
  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;
    var classes;
    var attrs = data.attrs;

    if (attrs) {
      // reset attrs to extract utility clases like pa-3
      data.attrs = {};
      classes = Object.keys(attrs).filter(function (key) {
        // TODO: Remove once resolved
        // https://github.com/vuejs/vue/issues/7841
        if (key === 'slot') return false;
        var value = attrs[key]; // add back data attributes like data-test="foo" but do not
        // add them as classes

        if (key.startsWith('data-')) {
          data.attrs[key] = value;
          return false;
        }

        return value || typeof value === 'string';
      });
    }

    if (props.id) {
      data.domProps = data.domProps || {};
      data.domProps.id = props.id;
    }

    return h(props.tag, Object(_util_mergeData__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(data, {
      staticClass: 'container',
      class: Array({
        'container--fluid': props.fluid
      }).concat(classes || [])
    }), children);
  }
}));

/***/ }),

/***/ "a623":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $every = __webpack_require__("b727").every;
var arrayMethodIsStrict = __webpack_require__("a640");
var arrayMethodUsesToLength = __webpack_require__("ae40");

var STRICT_METHOD = arrayMethodIsStrict('every');
var USES_TO_LENGTH = arrayMethodUsesToLength('every');

// `Array.prototype.every` method
// https://tc39.es/ecma262/#sec-array.prototype.every
$({ target: 'Array', proto: true, forced: !STRICT_METHOD || !USES_TO_LENGTH }, {
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "a630":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var from = __webpack_require__("4df4");
var checkCorrectnessOfIteration = __webpack_require__("1c7e");

var INCORRECT_ITERATION = !checkCorrectnessOfIteration(function (iterable) {
  Array.from(iterable);
});

// `Array.from` method
// https://tc39.es/ecma262/#sec-array.from
$({ target: 'Array', stat: true, forced: INCORRECT_ITERATION }, {
  from: from
});


/***/ }),

/***/ "a640":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__("d039");

module.exports = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call,no-throw-literal
    method.call(null, argument || function () { throw 1; }, 1);
  });
};


/***/ }),

/***/ "a691":
/***/ (function(module, exports) {

var ceil = Math.ceil;
var floor = Math.floor;

// `ToInteger` abstract operation
// https://tc39.es/ecma262/#sec-tointeger
module.exports = function (argument) {
  return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor : ceil)(argument);
};


/***/ }),

/***/ "a6a2":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.i, "@import url(https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css);"]);
exports.push([module.i, "@import url(https://cdn-prd.patientpop.com/pp-icon-font/v1.6.0/pp-icon-font.css);"]);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.pp-audio-player[data-v-060f210a]{min-height:8rem}.pp-audio-player__time-elapsed[data-v-060f210a]{min-width:11ch}.pp-audio-player__btn[data-v-060f210a]{font-size:1.75em}.pp-audio-player__progress--disabled[data-v-060f210a]{pointer-events:none}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "a735":
/***/ (function(module, exports) {

/**
 * @category Common Helpers
 * @summary Is the given argument an instance of Date?
 *
 * @description
 * Is the given argument an instance of Date?
 *
 * @param {*} argument - the argument to check
 * @returns {Boolean} the given argument is an instance of Date
 *
 * @example
 * // Is 'mayonnaise' a Date?
 * var result = isDate('mayonnaise')
 * //=> false
 */
function isDate (argument) {
  return argument instanceof Date
}

module.exports = isDate


/***/ }),

/***/ "a797":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("a9e3");
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("5530");
/* harmony import */ var _src_components_VOverlay_VOverlay_sass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("3c93");
/* harmony import */ var _src_components_VOverlay_VOverlay_sass__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_src_components_VOverlay_VOverlay_sass__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _mixins_colorable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("a9ad");
/* harmony import */ var _mixins_themeable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("7560");
/* harmony import */ var _mixins_toggleable__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("f2e7");
/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("58df");


// Styles
 // Mixins



 // Utilities


/* @vue/component */

/* harmony default export */ __webpack_exports__["a"] = (Object(_util_mixins__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])(_mixins_colorable__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"], _mixins_themeable__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"], _mixins_toggleable__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"]).extend({
  name: 'v-overlay',
  props: {
    absolute: Boolean,
    color: {
      type: String,
      default: '#212121'
    },
    dark: {
      type: Boolean,
      default: true
    },
    opacity: {
      type: [Number, String],
      default: 0.46
    },
    value: {
      default: true
    },
    zIndex: {
      type: [Number, String],
      default: 5
    }
  },
  computed: {
    __scrim: function __scrim() {
      var data = this.setBackgroundColor(this.color, {
        staticClass: 'v-overlay__scrim',
        style: {
          opacity: this.computedOpacity
        }
      });
      return this.$createElement('div', data);
    },
    classes: function classes() {
      return Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])({
        'v-overlay--absolute': this.absolute,
        'v-overlay--active': this.isActive
      }, this.themeClasses);
    },
    computedOpacity: function computedOpacity() {
      return Number(this.isActive ? this.opacity : 0);
    },
    styles: function styles() {
      return {
        zIndex: this.zIndex
      };
    }
  },
  methods: {
    genContent: function genContent() {
      return this.$createElement('div', {
        staticClass: 'v-overlay__content'
      }, this.$slots.default);
    }
  },
  render: function render(h) {
    var children = [this.__scrim];
    if (this.isActive) children.push(this.genContent());
    return h('div', {
      staticClass: 'v-overlay',
      class: this.classes,
      style: this.styles
    }, children);
  }
}));

/***/ }),

/***/ "a7dc":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.i, "@import url(https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css);"]);
exports.push([module.i, "@import url(https://cdn-prd.patientpop.com/pp-icon-font/v1.6.0/pp-icon-font.css);"]);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}input[type=checkbox][data-v-46c47d0c]{opacity:0;position:absolute;z-index:-100}.pp-input-checkbox[data-v-46c47d0c]{--pp-input-checkbox-focus:var(--pp-theme-color-secondary,#195b63);cursor:pointer}.pp-input-checkbox--disabled[data-v-46c47d0c]{cursor:not-allowed}.pp-input-checkbox[data-v-46c47d0c]:focus{outline:none}.pp-input-checkbox__checkbox[data-v-46c47d0c]{border:2px solid #9a9a9a;border-radius:4px;height:1.429em;width:1.429em}.pp-input-checkbox:not(.pp-input-checkbox--disabled):hover .pp-input-checkbox__checkbox[data-v-46c47d0c]{border-color:#2b2b2b}.pp-input-checkbox--disabled .pp-input-checkbox__checkbox[data-v-46c47d0c]{border-color:#d6d6d6}input[type=checkbox]:checked+.pp-input-checkbox__checkbox[data-v-46c47d0c]{--pp-input-checkbox-focus:var(--pp-theme-color-secondary,#8cb2b6);background:var(--pp-theme-color,#417e86);border:none}.pp-input-checkbox:not(.pp-input-checkbox--disabled):hover input[type=checkbox]:checked+.pp-input-checkbox__checkbox[data-v-46c47d0c]{background:#2b2b2b}.pp-input-checkbox:focus input[type=checkbox]:checked+.pp-input-checkbox__checkbox[data-v-46c47d0c]{background:#417e86}.pp-input-checkbox--disabled input[type=checkbox]:checked+.pp-input-checkbox__checkbox[data-v-46c47d0c]{background:#cbdde0}input[type=checkbox]:focus+.pp-input-checkbox__checkbox[data-v-46c47d0c]{outline:2px solid var(--pp-input-checkbox-focus,#195b63)}.pp-input-checkbox__checkbox i[data-v-46c47d0c]{display:none;font-size:.7145em}input[type=checkbox]:checked+.pp-input-checkbox__checkbox i[data-v-46c47d0c]{color:#fff;display:flex}.pp-input-checkbox__label[data-v-46c47d0c]{color:#545454;flex:1}.pp-input-checkbox--disabled .pp-input-checkbox__label[data-v-46c47d0c]{color:#9a9a9a}.pp-input-checkbox:not(.pp-input-checkbox--disabled):hover .pp-input-checkbox__label[data-v-46c47d0c]{color:#2b2b2b}.pp-input-checkbox__label__small[data-v-46c47d0c]{line-height:1.2142857143rem}.pp-input-checkbox__error-messages[data-v-46c47d0c]{display:flex;width:100%}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "a806":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M10.5 1C14.5107 1 17.9408 3.48534 19.3345 6.99991L13 7C11.8954 7 11 7.89543 11 9L11.0003 19.9871C10.8346 19.9956 10.6678 20 10.5 20C5.25329 20 1 15.7467 1 10.5C1 5.25329 5.25329 1 10.5 1Z\" fill=\"#DFE4E5\"></path><path d=\"M10.5 1C14.5107 1 17.9408 3.48534 19.3345 6.99991L13 7C11.8954 7 11 7.89543 11 9V8.999L8.55463 8.99951C8.51866 9.48807 8.5 9.98988 8.5 10.5C8.5 11.0105 8.51869 11.5126 8.55471 12.0015L11 12.001V14.001L8.8114 14.0018C8.98345 14.9178 9.22199 15.7459 9.51484 16.4414C9.78664 17.0869 10.0852 17.5659 10.3604 17.8424L10.5 17.977L10.6396 17.8424C10.757 17.7245 10.8787 17.5696 11.0007 17.3807L11.0003 19.9871C10.8346 19.9956 10.6678 20 10.5 20C5.25329 20 1 15.7467 1 10.5C1 5.25329 5.25329 1 10.5 1ZM6.78042 14.0013L3.8656 14.001C4.70635 15.591 6.10188 16.8422 7.79441 17.4971C7.35409 16.5363 7.00468 15.3439 6.78042 14.0013ZM6.54958 8.99993L3.14994 9.00041C3.05162 9.48495 3 9.98644 3 10.5C3 11.0139 3.05169 11.5157 3.15015 12.0006L6.54965 12.0011C6.51697 11.5121 6.5 11.0108 6.5 10.5C6.5 9.98958 6.51695 9.48855 6.54958 8.99993ZM7.79446 3.50271L7.73992 3.52418C6.07159 4.18483 4.69673 5.42666 3.86507 6.99995L6.78026 6.99974C7.0045 5.65667 7.35398 4.46391 7.79446 3.50271ZM10.5 3.023L10.3604 3.15756C10.0852 3.43406 9.78664 3.91308 9.51484 4.5586C9.22189 5.25437 8.98328 6.08277 8.81121 6.9992H12.1888C12.0167 6.08277 11.7781 5.25437 11.4852 4.5586C11.2134 3.91308 10.9148 3.43406 10.6396 3.15756L10.5 3.023ZM13.2056 3.50285L13.2402 3.57936C13.6644 4.52702 14.0014 5.69214 14.2197 6.99974L17.1349 6.99995C16.2942 5.40957 14.8985 4.15789 13.2056 3.50285Z\" fill=\"#688083\"></path><path d=\"M21 7C22.1046 7 23 7.89543 23 9V21C23 22.1046 22.1046 23 21 23H13C11.8954 23 11 22.1046 11 21V9C11 7.89543 11.8954 7 13 7H21ZM21 9H13V21H21V9Z\" fill=\"#688083\"></path><rect x=\"13\" y=\"9\" width=\"8\" height=\"12\" fill=\"white\"></rect><path d=\"M17.998 13C17.998 13.5523 17.5503 14 16.998 14C16.4458 14 15.998 13.5523 15.998 13C15.998 12.4477 16.4458 12 16.998 12C17.5503 12 17.998 12.4477 17.998 13Z\" fill=\"#688083\"></path><path d=\"M18.998 18V17C18.998 15.8954 18.1026 15 16.998 15C15.8935 15 14.998 15.8954 14.998 17V18H18.998Z\" fill=\"#688083\"></path></svg>";

/***/ }),

/***/ "a852":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("c8d5")

/**
 * @category Weekday Helpers
 * @summary Is the given date Friday?
 *
 * @description
 * Is the given date Friday?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is Friday
 *
 * @example
 * // Is 26 September 2014 Friday?
 * var result = isFriday(new Date(2014, 8, 26))
 * //=> true
 */
function isFriday (dirtyDate) {
  return parse(dirtyDate).getDay() === 5
}

module.exports = isFriday


/***/ }),

/***/ "a935":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("c8d5")

/**
 * @category Common Helpers
 * @summary Is the given date in the past?
 *
 * @description
 * Is the given date in the past?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in the past
 *
 * @example
 * // If today is 6 October 2014, is 2 July 2014 in the past?
 * var result = isPast(new Date(2014, 6, 2))
 * //=> true
 */
function isPast (dirtyDate) {
  return parse(dirtyDate).getTime() < new Date().getTime()
}

module.exports = isPast


/***/ }),

/***/ "a966":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><rect x=\"4\" y=\"6\" width=\"16\" height=\"2\" fill=\"#DFE4E5\"></rect><rect x=\"4\" y=\"10\" width=\"16\" height=\"10\" fill=\"white\"></rect><path d=\"M7 14V12H11V14H7Z\" fill=\"#1F3A3E\"></path><path d=\"M15 18V16H11V18H15Z\" fill=\"#1F3A3E\"></path><path d=\"M11 12H13V14H11V12Z\" fill=\"#1F3A3E\"></path><path d=\"M17 16H15V18H17V16Z\" fill=\"#1F3A3E\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M6 4V3C6 2.44772 6.44772 2 7 2C7.55228 2 8 2.44772 8 3V4H16V3C16 2.44772 16.4477 2 17 2C17.5523 2 18 2.44772 18 3V4H19.4963C20.8809 4 22 5.11672 22 6.50524V19.4948C22 20.8809 20.8878 22 19.4963 22H4.50371C3.11907 22 2 20.8833 2 19.4948V6.50524C2 5.11911 3.11219 4 4.50371 4H6ZM19.4963 6C19.7773 6 20 6.22223 20 6.50524V8H4V6.50524C4 6.22091 4.21954 6 4.50371 6H19.4963ZM4 10V19.4948C4 19.7778 4.2227 20 4.50371 20H19.4963C19.7805 20 20 19.7791 20 19.4948V10H4Z\" fill=\"#1F3A3E\"></path></svg>";

/***/ }),

/***/ "a9ad":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("d3b7");
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ac1f");
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("25f0");
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_string_split_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("1276");
/* harmony import */ var core_js_modules_es_string_split_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_string_trim_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("498a");
/* harmony import */ var core_js_modules_es_string_trim_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_trim_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("3835");
/* harmony import */ var _home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("ade3");
/* harmony import */ var _home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("5530");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("8bbf");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _util_console__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("d9bd");
/* harmony import */ var _util_colorUtils__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("7bc6");











/* harmony default export */ __webpack_exports__["a"] = (vue__WEBPACK_IMPORTED_MODULE_8___default.a.extend({
  name: 'colorable',
  props: {
    color: String
  },
  methods: {
    setBackgroundColor: function setBackgroundColor(color) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (typeof data.style === 'string') {
        // istanbul ignore next
        Object(_util_console__WEBPACK_IMPORTED_MODULE_9__[/* consoleError */ "b"])('style must be an object', this); // istanbul ignore next

        return data;
      }

      if (typeof data.class === 'string') {
        // istanbul ignore next
        Object(_util_console__WEBPACK_IMPORTED_MODULE_9__[/* consoleError */ "b"])('class must be an object', this); // istanbul ignore next

        return data;
      }

      if (Object(_util_colorUtils__WEBPACK_IMPORTED_MODULE_10__[/* isCssColor */ "n"])(color)) {
        data.style = Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])({}, data.style), {}, {
          'background-color': "".concat(color),
          'border-color': "".concat(color)
        });
      } else if (color) {
        data.class = Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])({}, data.class), {}, Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])({}, color, true));
      }

      return data;
    },
    setTextColor: function setTextColor(color) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (typeof data.style === 'string') {
        // istanbul ignore next
        Object(_util_console__WEBPACK_IMPORTED_MODULE_9__[/* consoleError */ "b"])('style must be an object', this); // istanbul ignore next

        return data;
      }

      if (typeof data.class === 'string') {
        // istanbul ignore next
        Object(_util_console__WEBPACK_IMPORTED_MODULE_9__[/* consoleError */ "b"])('class must be an object', this); // istanbul ignore next

        return data;
      }

      if (Object(_util_colorUtils__WEBPACK_IMPORTED_MODULE_10__[/* isCssColor */ "n"])(color)) {
        data.style = Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])({}, data.style), {}, {
          color: "".concat(color),
          'caret-color': "".concat(color)
        });
      } else if (color) {
        var _color$toString$trim$ = color.toString().trim().split(' ', 2),
            _color$toString$trim$2 = Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(_color$toString$trim$, 2),
            colorName = _color$toString$trim$2[0],
            colorModifier = _color$toString$trim$2[1];

        data.class = Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])({}, data.class), {}, Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])({}, colorName + '--text', true));

        if (colorModifier) {
          data.class['text--' + colorModifier] = true;
        }
      }

      return data;
    }
  }
}));

/***/ }),

/***/ "a9e3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__("83ab");
var global = __webpack_require__("da84");
var isForced = __webpack_require__("94ca");
var redefine = __webpack_require__("6eeb");
var has = __webpack_require__("5135");
var classof = __webpack_require__("c6b6");
var inheritIfRequired = __webpack_require__("7156");
var toPrimitive = __webpack_require__("c04e");
var fails = __webpack_require__("d039");
var create = __webpack_require__("7c73");
var getOwnPropertyNames = __webpack_require__("241c").f;
var getOwnPropertyDescriptor = __webpack_require__("06cf").f;
var defineProperty = __webpack_require__("9bf2").f;
var trim = __webpack_require__("58a8").trim;

var NUMBER = 'Number';
var NativeNumber = global[NUMBER];
var NumberPrototype = NativeNumber.prototype;

// Opera ~12 has broken Object#toString
var BROKEN_CLASSOF = classof(create(NumberPrototype)) == NUMBER;

// `ToNumber` abstract operation
// https://tc39.es/ecma262/#sec-tonumber
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  var first, third, radix, maxCode, digits, length, index, code;
  if (typeof it == 'string' && it.length > 2) {
    it = trim(it);
    first = it.charCodeAt(0);
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal of /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal of /^0o[0-7]+$/i
        default: return +it;
      }
      digits = it.slice(2);
      length = digits.length;
      for (index = 0; index < length; index++) {
        code = digits.charCodeAt(index);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

// `Number` constructor
// https://tc39.es/ecma262/#sec-number-constructor
if (isForced(NUMBER, !NativeNumber(' 0o1') || !NativeNumber('0b1') || NativeNumber('+0x1'))) {
  var NumberWrapper = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var dummy = this;
    return dummy instanceof NumberWrapper
      // check on 1..constructor(foo) case
      && (BROKEN_CLASSOF ? fails(function () { NumberPrototype.valueOf.call(dummy); }) : classof(dummy) != NUMBER)
        ? inheritIfRequired(new NativeNumber(toNumber(it)), dummy, NumberWrapper) : toNumber(it);
  };
  for (var keys = DESCRIPTORS ? getOwnPropertyNames(NativeNumber) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES2015 (in case, if modules with ES2015 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger,' +
    // ESNext
    'fromString,range'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(NativeNumber, key = keys[j]) && !has(NumberWrapper, key)) {
      defineProperty(NumberWrapper, key, getOwnPropertyDescriptor(NativeNumber, key));
    }
  }
  NumberWrapper.prototype = NumberPrototype;
  NumberPrototype.constructor = NumberWrapper;
  redefine(global, NUMBER, NumberWrapper);
}


/***/ }),

/***/ "a9ee":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.i, "@import url(https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css);"]);
exports.push([module.i, "@import url(https://cdn-prd.patientpop.com/pp-icon-font/v1.6.0/pp-icon-font.css);"]);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.error--text[data-v-c2092df8]  .v-text-field__control{position:relative}.error--text[data-v-c2092df8]  .v-messages{display:inline-block;left:0;overflow:hidden;position:absolute;top:calc(100% - 14px)}.error--text[data-v-c2092df8]  .v-messages__message{background:#fff;overflow:hidden;padding:0 3px;text-overflow:ellipsis;white-space:nowrap}.pp-input-description[data-v-c2092df8]{white-space:pre-line}[data-v-c2092df8] .message-transition-leave,[data-v-c2092df8] .message-transition-leave-active{display:inline-block;max-width:70%;overflow:hidden;position:absolute;right:8px;text-align:right;top:calc(100% - 30px);transform:translateY(-7px)}[data-v-c2092df8] .v-counter{position:absolute;right:0}.theme--light.v-input[data-v-c2092df8]:not(.theme--light.v-input--is-focused)  fieldset{border-color:transparent}.theme--light.v-input[data-v-c2092df8]:not(.theme--light.v-input--is-focused):not(.theme--light.v-input--is-disabled){--text-primary:#2b2b2b}.theme--light.v-input .pp-input-text__error-icon[data-v-c2092df8]{color:#b51a2c}.theme--light.v-input:not(.theme--light.v-input--is-focused):not(.theme--light.v-input--is-disabled).error--text[data-v-c2092df8]{--pp-text-field-fill:#fceeee}.theme--light.v-input.pp-input-select--white-bg[data-v-c2092df8]:not(.theme--light.v-input--is-disabled),.theme--light.v-input.pp-input-text--white-bg[data-v-c2092df8]:not(.theme--light.v-input--is-disabled){--pp-text-placeholder:#545454}.theme--light.v-input.pp-input-select--white-bg[data-v-c2092df8]:not(.theme--light.v-input--is-disabled):not(.theme--light.v-input--is-focused):not(.error--text),.theme--light.v-input.pp-input-text--white-bg[data-v-c2092df8]:not(.theme--light.v-input--is-disabled):not(.theme--light.v-input--is-focused):not(.error--text){--pp-text-field-fill:#fff}.theme--light.v-input.pp-input-select--white-bg[data-v-c2092df8]:not(.theme--light.v-input--is-disabled):not(.theme--light.v-input--is-focused):not(.error--text)  .theme--light.v-input__slot:hover,.theme--light.v-input.pp-input-text--white-bg[data-v-c2092df8]:not(.theme--light.v-input--is-disabled):not(.theme--light.v-input--is-focused):not(.error--text)  .theme--light.v-input__slot:hover{--pp-text-field-fill-on-hover:#fff}.theme--light.v-input.theme--light.v-input--is-focused[data-v-c2092df8]{--pp-text-field-fill:#fff}.theme--light.v-input.theme--light.v-input--is-disabled[data-v-c2092df8]{--pp-text-disabled:#9a9a9a;--pp-text-field-fill:#f6f6f6;--pp-text-placeholder:#9a9a9a}.theme--light.v-input[data-v-c2092df8]  input::-moz-placeholder,.theme--light.v-input[data-v-c2092df8]  textarea::-moz-placeholder{color:var(--pp-text-placeholder,#545454)}.theme--light.v-input[data-v-c2092df8]  input:-ms-input-placeholder,.theme--light.v-input[data-v-c2092df8]  textarea:-ms-input-placeholder{color:var(--pp-text-placeholder,#545454)}.theme--light.v-input[data-v-c2092df8]  input::placeholder,.theme--light.v-input[data-v-c2092df8]  textarea::placeholder{color:var(--pp-text-placeholder,#545454)}.theme--light.v-input[data-v-c2092df8]  .theme--light.v-input__append-inner{margin-bottom:auto;margin-top:auto}.theme--light.v-input[data-v-c2092df8]  .theme--light.v-input__append-inner i:before{display:block}.append-icon[data-v-c2092df8]:hover{color:#079cb2;cursor:pointer}.pp-input-text[data-v-c2092df8]  .v-input__icon--clear{height:1em}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "aa79":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M11 5H21\" stroke=\"#828AA3\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M11 19H21\" stroke=\"#828AA3\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M11 12H21\" stroke=\"#828AA3\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><circle cx=\"5\" cy=\"19\" r=\"2\" fill=\"#D9DBE6\" stroke=\"#828AA3\" stroke-width=\"2\"></circle><circle cx=\"5\" cy=\"12\" r=\"2\" fill=\"#D9DBE6\" stroke=\"#828AA3\" stroke-width=\"2\"></circle><circle cx=\"5\" cy=\"5\" r=\"2\" fill=\"#D9DBE6\" stroke=\"#828AA3\" stroke-width=\"2\"></circle></svg>";

/***/ }),

/***/ "ab13":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");

var MATCH = wellKnownSymbol('match');

module.exports = function (METHOD_NAME) {
  var regexp = /./;
  try {
    '/./'[METHOD_NAME](regexp);
  } catch (error1) {
    try {
      regexp[MATCH] = false;
      return '/./'[METHOD_NAME](regexp);
    } catch (error2) { /* empty */ }
  } return false;
};


/***/ }),

/***/ "ab6f":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><rect x=\"3\" y=\"3\" width=\"18\" height=\"18\" rx=\"2\" stroke=\"#688083\" stroke-width=\"2\"></rect><mask id=\"path-2-inside-1_109_543\" fill=\"white\"><rect x=\"6\" y=\"6\" width=\"8\" height=\"6\" rx=\"0.5\"></rect></mask><rect x=\"6\" y=\"6\" width=\"8\" height=\"6\" rx=\"0.5\" fill=\"#DFE4E5\" stroke=\"#688083\" stroke-width=\"4\" mask=\"url(#path-2-inside-1_109_543)\"></rect><rect x=\"6\" y=\"11\" width=\"2\" height=\"7\" rx=\"0.5\" fill=\"#688083\"></rect><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M17.1563 18.8535C16.9612 19.0487 16.6449 19.049 16.4495 18.8541L9.46329 11.8852C9.26766 11.69 9.26741 11.3732 9.46275 11.1777L10.1576 10.4825C10.3527 10.2873 10.669 10.2871 10.8644 10.4819L17.8506 17.4508C18.0462 17.6459 18.0465 17.9628 17.8512 18.1582L17.1563 18.8535Z\" fill=\"#688083\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M17.8523 11.8405C18.0474 12.0358 18.0474 12.3522 17.8523 12.5474L11.5505 18.853C11.3553 19.0484 11.0385 19.0484 10.8432 18.853L10.1484 18.1577C9.95325 17.9624 9.95326 17.646 10.1484 17.4508L16.4502 11.1453C16.6455 10.9499 16.9622 10.9499 17.1575 11.1453L17.8523 11.8405Z\" fill=\"#688083\"></path></svg>";

/***/ }),

/***/ "ab8f":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.i, "@import url(https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css);"]);
exports.push([module.i, "@import url(https://cdn-prd.patientpop.com/pp-icon-font/v1.6.0/pp-icon-font.css);"]);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.pp-message[data-v-683c2c2f]{display:grid;grid-template-columns:2.75em auto;grid-template-rows:20px auto}.pp-message__status[data-v-683c2c2f]{color:#545454;grid-column-start:2}.pp-message__message[data-v-683c2c2f]{background-color:#f6f2ec;overflow:hidden;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content}.pp-message__message--practice[data-v-683c2c2f]{background:#004852;color:#fff}.pp-message__message__source[data-v-683c2c2f]{background:#d6d6d6;color:#545454;font-size:.9rem}.pp-message__attachment-loading[data-v-683c2c2f]{height:5em;position:relative}.pp-message__attachment-loading[data-v-683c2c2f]:before{background:#fff;border-radius:2px;box-shadow:0 1px 1px rgba(49,59,89,.1);content:\"\";display:block;height:2.8571428571rem;width:2.2857142857rem}.pp-message__attachment-loading[data-v-683c2c2f]:after{border-bottom:.7857142857rem solid #d6d6d6;border-right:.7857142857rem solid transparent;content:\"\";display:block;height:0;left:39.5px;position:absolute;top:15px;width:0}.pp-message__attachment-loading .pp-loader[data-v-683c2c2f]{left:-1.175em;margin-right:.85em;margin-top:.2em;position:relative;top:auto}.pp-message__attachment-loading .pp-loader[data-v-683c2c2f]:after{border-left:.7857142857rem solid transparent;border-top:.7857142857rem solid #f6f6f6;content:\"\";display:block;height:0;left:12px;position:absolute;top:-16px;width:0}.pp-message__attachments[data-v-683c2c2f]{display:grid;grid-column-start:2;grid-gap:.25em}.pp-image[data-v-683c2c2f]{max-width:50%}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "abd4":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("c8d5")

/**
 * @category Common Helpers
 * @summary Are the given dates equal?
 *
 * @description
 * Are the given dates equal?
 *
 * @param {Date|String|Number} dateLeft - the first date to compare
 * @param {Date|String|Number} dateRight - the second date to compare
 * @returns {Boolean} the dates are equal
 *
 * @example
 * // Are 2 July 2014 06:30:45.000 and 2 July 2014 06:30:45.500 equal?
 * var result = isEqual(
 *   new Date(2014, 6, 2, 6, 30, 45, 0)
 *   new Date(2014, 6, 2, 6, 30, 45, 500)
 * )
 * //=> false
 */
function isEqual (dirtyLeftDate, dirtyRightDate) {
  var dateLeft = parse(dirtyLeftDate)
  var dateRight = parse(dirtyRightDate)
  return dateLeft.getTime() === dateRight.getTime()
}

module.exports = isEqual


/***/ }),

/***/ "abdf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpInputImageUpload_vue_vue_type_style_index_0_id_7bed88e3_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("4736");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpInputImageUpload_vue_vue_type_style_index_0_id_7bed88e3_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpInputImageUpload_vue_vue_type_style_index_0_id_7bed88e3_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "ac1f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var exec = __webpack_require__("9263");

// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
$({ target: 'RegExp', proto: true, forced: /./.exec !== exec }, {
  exec: exec
});


/***/ }),

/***/ "ac87":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.v-ripple__container{border-radius:inherit;width:100%;height:100%;z-index:0;contain:strict}.v-ripple__animation,.v-ripple__container{color:inherit;position:absolute;left:0;top:0;overflow:hidden;pointer-events:none}.v-ripple__animation{border-radius:50%;background:currentColor;opacity:0;will-change:transform,opacity}.v-ripple__animation--enter{transition:none}.v-ripple__animation--in{transition:transform .25s cubic-bezier(.4,0,.2,1),opacity .1s cubic-bezier(.4,0,.2,1)}.v-ripple__animation--out{transition:opacity .3s cubic-bezier(.4,0,.2,1)}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "ac90":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c662cfac-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/input/text/PpInputText.vue?vue&type=template&id=c2092df8&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pp-input-text"},[(_vm.label)?_c('pp-input-label',{attrs:{"label":_vm.label,"input-id":_vm.inputTextId,"optional":_vm.optional}}):_vm._e(),(_vm.showDescription)?_c('div',{staticClass:"subtitle-1 my-2 pp-input-description"},[_vm._t("description",[_vm._v(" "+_vm._s(_vm.description)+" ")])],2):_vm._e(),_c('v-text-field',_vm._g(_vm._b({ref:"inputText",class:[
      _vm.whiteBg ? 'pp-input-text--white-bg' : ''
    ],attrs:{"disabled":_vm.disabled,"error-messages":_vm.errorMessages,"value":_vm.value,"outlined":"","filled":"","single-line":"","hide-details":_vm.hideDetails},scopedSlots:_vm._u([{key:"append",fn:function(){return [(_vm.appendInnerIcon)?_c('i',{class:("append-icon pp-icon-" + _vm.appendInnerIcon),on:{"click":_vm.appendIconClick}}):(_vm.isErrorState)?_c('i',{class:"pp-input-text__error-icon pp-icon-info-circle ma-0"}):_vm._e()]},proxy:true},{key:"prepend-inner",fn:function(){return [(_vm.prependInnerIcon)?_c('i',{staticClass:"mr-2",class:("pp-icon-" + _vm.prependInnerIcon)}):_vm._e(),_vm._t("prepend-inner")]},proxy:true}],null,true)},'v-text-field',_vm.$attrs,false),_vm.$listeners))],1)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/input/text/PpInputText.vue?vue&type=template&id=c2092df8&scoped=true&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("a4d3");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__("e01a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__("a9e3");

// EXTERNAL MODULE: ./src/components/input/label/PpInputLabel.vue + 4 modules
var PpInputLabel = __webpack_require__("8e6c");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/input/text/PpInputText.vue?vue&type=script&lang=js&



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var PpInputTextvue_type_script_lang_js_ = ({
  name: 'PpInputText',
  components: {
    'pp-input-label': PpInputLabel["default"]
  },
  props: {
    value: {
      type: [String, Number],
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    errorMessages: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    label: {
      type: String,
      default: ''
    },

    /**
     * If true, display optional label with a different color than the main label
     */
    optional: {
      type: Boolean,
      default: false
    },
    whiteBg: {
      type: Boolean,
      default: false
    },

    /**
     * Using pp-icon-font icon name to set prepend Inner Icon for text box e.g.: 'email'
     */
    prependInnerIcon: {
      type: String,
      default: null
    },
    hideDetails: {
      type: [String, Boolean],
      default: false
    },
    description: {
      type: String,
      default: ''
    },
    appendInnerIcon: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      inputTextId: null
    };
  },
  computed: {
    showDescription: function showDescription() {
      return this.description || this.$slots.description;
    },
    isErrorState: function isErrorState() {
      return this.errorMessages.length > 0;
    }
  },
  mounted: function mounted() {
    var _this$$refs, _this$$refs$inputText, _this$$refs$inputText2, _this$$refs$inputText3;

    this.inputTextId = (_this$$refs = this.$refs) === null || _this$$refs === void 0 ? void 0 : (_this$$refs$inputText = _this$$refs.inputText) === null || _this$$refs$inputText === void 0 ? void 0 : (_this$$refs$inputText2 = _this$$refs$inputText.$refs) === null || _this$$refs$inputText2 === void 0 ? void 0 : (_this$$refs$inputText3 = _this$$refs$inputText2.input) === null || _this$$refs$inputText3 === void 0 ? void 0 : _this$$refs$inputText3.id;
  },
  methods: {
    appendIconClick: function appendIconClick() {
      var _this$$refs2;

      var inputTextControl = (_this$$refs2 = this.$refs) === null || _this$$refs2 === void 0 ? void 0 : _this$$refs2.inputText;
      inputTextControl.blur();
      this.$emit('click:append');
    }
  }
});
// CONCATENATED MODULE: ./src/components/input/text/PpInputText.vue?vue&type=script&lang=js&
 /* harmony default export */ var text_PpInputTextvue_type_script_lang_js_ = (PpInputTextvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/input/text/PpInputText.vue?vue&type=style&index=0&id=c2092df8&lang=scss&scoped=true&
var PpInputTextvue_type_style_index_0_id_c2092df8_lang_scss_scoped_true_ = __webpack_require__("4a02");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// EXTERNAL MODULE: ./node_modules/vuetify-loader/lib/runtime/installComponents.js
var installComponents = __webpack_require__("6544");
var installComponents_default = /*#__PURE__*/__webpack_require__.n(installComponents);

// EXTERNAL MODULE: ./node_modules/vuetify/lib/components/VTextField/VTextField.js + 2 modules
var VTextField = __webpack_require__("8654");

// CONCATENATED MODULE: ./src/components/input/text/PpInputText.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  text_PpInputTextvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "c2092df8",
  null
  
)

/* harmony default export */ var PpInputText = __webpack_exports__["default"] = (component.exports);

/* vuetify-loader */


installComponents_default()(component, {VTextField: VTextField["a" /* default */]})


/***/ }),

/***/ "ac99":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.i, "@import url(https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css);"]);
exports.push([module.i, "@import url(https://cdn-prd.patientpop.com/pp-icon-font/v1.6.0/pp-icon-font.css);"]);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.pp-input-description[data-v-698620e8]{white-space:pre-line}[data-v-698620e8] .message-transition-leave,[data-v-698620e8] .message-transition-leave-active{display:inline-block;max-width:70%;overflow:hidden;position:absolute;right:8px;text-align:right;top:calc(100% - 30px);transform:translateY(-7px)}@media only screen and (max-width:599px){.v-radio[data-v-698620e8]{border:1px solid #d6d6d6;flex:1;word-break:break-all}.v-input--radio-group--column[data-v-698620e8]{border-bottom:1px solid #d6d6d6}.v-input--radio-group--column .v-radio[data-v-698620e8]{border-bottom:0}.v-input--radio-group--row .v-radio[data-v-698620e8]{border-right:0}.v-input--radio-group--row .v-radio[data-v-698620e8]:last-child{border-right:1px solid #d6d6d6}}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "acc4":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("c8d5")

/**
 * @category Year Helpers
 * @summary Is the given date in the leap year?
 *
 * @description
 * Is the given date in the leap year?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in the leap year
 *
 * @example
 * // Is 1 September 2012 in the leap year?
 * var result = isLeapYear(new Date(2012, 8, 1))
 * //=> true
 */
function isLeapYear (dirtyDate) {
  var date = parse(dirtyDate)
  var year = date.getFullYear()
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0
}

module.exports = isLeapYear


/***/ }),

/***/ "ad51":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("cecd");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("1ea1e333", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "ad6d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__("825a");

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),

/***/ "adda":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__("a15b");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__("a9e3");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.ends-with.js
var es_string_ends_with = __webpack_require__("8a79");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.starts-with.js
var es_string_starts_with = __webpack_require__("2ca0");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__("53ca");

// EXTERNAL MODULE: ./node_modules/vuetify/src/components/VImg/VImg.sass
var VImg = __webpack_require__("8efc");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/directives/intersect/index.js
var intersect = __webpack_require__("90a2");

// EXTERNAL MODULE: ./node_modules/vuetify/src/components/VResponsive/VResponsive.sass
var VResponsive = __webpack_require__("36a7");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/mixins/measurable/index.js
var measurable = __webpack_require__("24b2");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/util/mixins.js
var mixins = __webpack_require__("58df");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VResponsive/VResponsive.js

 // Mixins

 // Utils


/* @vue/component */

/* harmony default export */ var VResponsive_VResponsive = (Object(mixins["a" /* default */])(measurable["a" /* default */]).extend({
  name: 'v-responsive',
  props: {
    aspectRatio: [String, Number],
    contentClass: String
  },
  computed: {
    computedAspectRatio: function computedAspectRatio() {
      return Number(this.aspectRatio);
    },
    aspectStyle: function aspectStyle() {
      return this.computedAspectRatio ? {
        paddingBottom: 1 / this.computedAspectRatio * 100 + '%'
      } : undefined;
    },
    __cachedSizer: function __cachedSizer() {
      if (!this.aspectStyle) return [];
      return this.$createElement('div', {
        style: this.aspectStyle,
        staticClass: 'v-responsive__sizer'
      });
    }
  },
  methods: {
    genContent: function genContent() {
      return this.$createElement('div', {
        staticClass: 'v-responsive__content',
        class: this.contentClass
      }, this.$slots.default);
    }
  },
  render: function render(h) {
    return h('div', {
      staticClass: 'v-responsive',
      style: this.measurableStyles,
      on: this.$listeners
    }, [this.__cachedSizer, this.genContent()]);
  }
}));
// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VResponsive/index.js


/* harmony default export */ var components_VResponsive = (VResponsive_VResponsive);
// EXTERNAL MODULE: ./node_modules/vuetify/lib/mixins/themeable/index.js
var themeable = __webpack_require__("7560");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/util/mergeData.js
var mergeData = __webpack_require__("d9f7");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/util/console.js + 32 modules
var console = __webpack_require__("d9bd");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VImg/VImg.js





// Styles
 // Directives

 // Components

 // Mixins

 // Utils




var hasIntersect = typeof window !== 'undefined' && 'IntersectionObserver' in window;
/* @vue/component */

/* harmony default export */ var VImg_VImg = __webpack_exports__["a"] = (Object(mixins["a" /* default */])(components_VResponsive, themeable["a" /* default */]).extend({
  name: 'v-img',
  directives: {
    intersect: intersect["a" /* default */]
  },
  props: {
    alt: String,
    contain: Boolean,
    eager: Boolean,
    gradient: String,
    lazySrc: String,
    options: {
      type: Object,
      // For more information on types, navigate to:
      // https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
      default: function _default() {
        return {
          root: undefined,
          rootMargin: undefined,
          threshold: undefined
        };
      }
    },
    position: {
      type: String,
      default: 'center center'
    },
    sizes: String,
    src: {
      type: [String, Object],
      default: ''
    },
    srcset: String,
    transition: {
      type: [Boolean, String],
      default: 'fade-transition'
    }
  },
  data: function data() {
    return {
      currentSrc: '',
      image: null,
      isLoading: true,
      calculatedAspectRatio: undefined,
      naturalWidth: undefined,
      hasError: false
    };
  },
  computed: {
    computedAspectRatio: function computedAspectRatio() {
      return Number(this.normalisedSrc.aspect || this.calculatedAspectRatio);
    },
    normalisedSrc: function normalisedSrc() {
      return this.src && Object(esm_typeof["a" /* default */])(this.src) === 'object' ? {
        src: this.src.src,
        srcset: this.srcset || this.src.srcset,
        lazySrc: this.lazySrc || this.src.lazySrc,
        aspect: Number(this.aspectRatio || this.src.aspect)
      } : {
        src: this.src,
        srcset: this.srcset,
        lazySrc: this.lazySrc,
        aspect: Number(this.aspectRatio || 0)
      };
    },
    __cachedImage: function __cachedImage() {
      if (!(this.normalisedSrc.src || this.normalisedSrc.lazySrc || this.gradient)) return [];
      var backgroundImage = [];
      var src = this.isLoading ? this.normalisedSrc.lazySrc : this.currentSrc;
      if (this.gradient) backgroundImage.push("linear-gradient(".concat(this.gradient, ")"));
      if (src) backgroundImage.push("url(\"".concat(src, "\")"));
      var image = this.$createElement('div', {
        staticClass: 'v-image__image',
        class: {
          'v-image__image--preload': this.isLoading,
          'v-image__image--contain': this.contain,
          'v-image__image--cover': !this.contain
        },
        style: {
          backgroundImage: backgroundImage.join(', '),
          backgroundPosition: this.position
        },
        key: +this.isLoading
      });
      /* istanbul ignore if */

      if (!this.transition) return image;
      return this.$createElement('transition', {
        attrs: {
          name: this.transition,
          mode: 'in-out'
        }
      }, [image]);
    }
  },
  watch: {
    src: function src() {
      // Force re-init when src changes
      if (!this.isLoading) this.init(undefined, undefined, true);else this.loadImage();
    },
    '$vuetify.breakpoint.width': 'getSrc'
  },
  mounted: function mounted() {
    this.init();
  },
  methods: {
    init: function init(entries, observer, isIntersecting) {
      // If the current browser supports the intersection
      // observer api, the image is not observable, and
      // the eager prop isn't being used, do not load
      if (hasIntersect && !isIntersecting && !this.eager) return;

      if (this.normalisedSrc.lazySrc) {
        var lazyImg = new Image();
        lazyImg.src = this.normalisedSrc.lazySrc;
        this.pollForSize(lazyImg, null);
      }
      /* istanbul ignore else */


      if (this.normalisedSrc.src) this.loadImage();
    },
    onLoad: function onLoad() {
      this.getSrc();
      this.isLoading = false;
      this.$emit('load', this.src);

      if (this.image && (this.normalisedSrc.src.endsWith('.svg') || this.normalisedSrc.src.startsWith('data:image/svg+xml'))) {
        if (this.image.naturalHeight && this.image.naturalWidth) {
          this.naturalWidth = this.image.naturalWidth;
          this.calculatedAspectRatio = this.image.naturalWidth / this.image.naturalHeight;
        } else {
          this.calculatedAspectRatio = 1;
        }
      }
    },
    onError: function onError() {
      this.hasError = true;
      this.$emit('error', this.src);
    },
    getSrc: function getSrc() {
      /* istanbul ignore else */
      if (this.image) this.currentSrc = this.image.currentSrc || this.image.src;
    },
    loadImage: function loadImage() {
      var _this = this;

      var image = new Image();
      this.image = image;

      image.onload = function () {
        /* istanbul ignore if */
        if (image.decode) {
          image.decode().catch(function (err) {
            Object(console["c" /* consoleWarn */])("Failed to decode image, trying to render anyway\n\n" + "src: ".concat(_this.normalisedSrc.src) + (err.message ? "\nOriginal error: ".concat(err.message) : ''), _this);
          }).then(_this.onLoad);
        } else {
          _this.onLoad();
        }
      };

      image.onerror = this.onError;
      this.hasError = false;
      image.src = this.normalisedSrc.src;
      this.sizes && (image.sizes = this.sizes);
      this.normalisedSrc.srcset && (image.srcset = this.normalisedSrc.srcset);
      this.aspectRatio || this.pollForSize(image);
      this.getSrc();
    },
    pollForSize: function pollForSize(img) {
      var _this2 = this;

      var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;

      var poll = function poll() {
        var naturalHeight = img.naturalHeight,
            naturalWidth = img.naturalWidth;

        if (naturalHeight || naturalWidth) {
          _this2.naturalWidth = naturalWidth;
          _this2.calculatedAspectRatio = naturalWidth / naturalHeight;
        } else if (!img.complete && _this2.isLoading && !_this2.hasError && timeout != null) {
          setTimeout(poll, timeout);
        }
      };

      poll();
    },
    genContent: function genContent() {
      var content = components_VResponsive.options.methods.genContent.call(this);

      if (this.naturalWidth) {
        this._b(content.data, 'div', {
          style: {
            width: "".concat(this.naturalWidth, "px")
          }
        });
      }

      return content;
    },
    __genPlaceholder: function __genPlaceholder() {
      if (this.$slots.placeholder) {
        var placeholder = this.isLoading ? [this.$createElement('div', {
          staticClass: 'v-image__placeholder'
        }, this.$slots.placeholder)] : [];
        if (!this.transition) return placeholder[0];
        return this.$createElement('transition', {
          props: {
            appear: true,
            name: this.transition
          }
        }, placeholder);
      }
    }
  },
  render: function render(h) {
    var node = components_VResponsive.options.render.call(this, h);
    var data = Object(mergeData["a" /* default */])(node.data, {
      staticClass: 'v-image',
      attrs: {
        'aria-label': this.alt,
        role: this.alt ? 'img' : undefined
      },
      class: this.themeClasses,
      // Only load intersect directive if it
      // will work in the current browser.
      directives: hasIntersect ? [{
        name: 'intersect',
        modifiers: {
          once: true
        },
        value: {
          handler: this.init,
          options: this.options
        }
      }] : undefined
    });
    node.children = [this.__cachedSizer, this.__cachedImage, this.__genPlaceholder(), this.genContent()];
    return h(node.tag, data, node.children);
  }
}));

/***/ }),

/***/ "ade3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _defineProperty; });
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

/***/ }),

/***/ "ae05":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.i, "@import url(https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css);"]);
exports.push([module.i, "@import url(https://cdn-prd.patientpop.com/pp-icon-font/v1.6.0/pp-icon-font.css);"]);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.pp-signature-icon[data-v-1021e088]{border:1px solid #d6d6d6;height:1.5em;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content}.pp-signature-icon i[data-v-1021e088]{font-size:.75em;margin-top:2px}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "ae40":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var fails = __webpack_require__("d039");
var has = __webpack_require__("5135");

var defineProperty = Object.defineProperty;
var cache = {};

var thrower = function (it) { throw it; };

module.exports = function (METHOD_NAME, options) {
  if (has(cache, METHOD_NAME)) return cache[METHOD_NAME];
  if (!options) options = {};
  var method = [][METHOD_NAME];
  var ACCESSORS = has(options, 'ACCESSORS') ? options.ACCESSORS : false;
  var argument0 = has(options, 0) ? options[0] : thrower;
  var argument1 = has(options, 1) ? options[1] : undefined;

  return cache[METHOD_NAME] = !!method && !fails(function () {
    if (ACCESSORS && !DESCRIPTORS) return true;
    var O = { length: -1 };

    if (ACCESSORS) defineProperty(O, 1, { enumerable: true, get: thrower });
    else O[1] = 1;

    method.call(O, argument0, argument1);
  });
};


/***/ }),

/***/ "ae8e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c662cfac-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/drop-down-button/PpDropDownButton.vue?vue&type=template&id=128b2aa0&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pp-drop-down-button d-flex"},[(_vm.showMainButton)?_c('pp-button',{staticClass:"pp-drop-down-button__main-button rounded-r-0",attrs:{"text":_vm.text,"type":_vm.$attrs.type || 'primary',"prepend-icon":_vm.mainButtonIcon},on:{"click":_vm.mainButtonClicked}}):_vm._e(),(_vm.items.length > 0)?_c('v-menu',{ref:"menu",staticClass:"pp-drop-down-button__menu",attrs:{"nudge-bottom":_vm.nudgeBottom,"left":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('div',_vm._g(_vm._b({attrs:{"role":"button"}},'div',attrs,false),on),[_vm._t("activator",[(_vm.ellipsis)?_c('div',_vm._g(_vm._b({staticClass:"pp-drop-down-button__ellipsis-button",attrs:{"role":"button"}},'div',attrs,false),on),[_c('pp-button',{attrs:{"type":"icon","icon":"more"}})],1):_c('pp-button',_vm._g({staticClass:"rounded-tl-0 rounded-bl-0 pp-drop-down-button__secondary-button",attrs:{"type":_vm.$attrs.type || 'primary',"icon":_vm.secondaryButtonIcon},on:{"click":function($event){return _vm.$emit('dropdown')}}},on))])],2)]}}],null,true),model:{value:(_vm.showDropDown),callback:function ($$v) {_vm.showDropDown=$$v},expression:"showDropDown"}},[_c('v-list',{staticClass:"rounded"},_vm._l((_vm.items),function(item,index){return _c('v-list-item',{key:index,staticClass:"pp-drop-down-button__menu-list pa-0"},[_c('v-list-item-title',{class:_vm.dense ? 'pa-0' : 'pa-2'},[_vm._t("default",[_c('pp-button',{staticClass:"pp-drop-down-button__menu-item justify-start py-1 rounded",class:_vm.listItemClasses(item),attrs:{"type":"secondary","text":item.title,"block":true,"prepend-icon":item.icon,"disabled":!!item.disabled},on:{"click":function($event){return _vm.$emit('item-clicked', item.id)}},scopedSlots:_vm._u([(item.description)?{key:"text",fn:function(){return [_c('div',{staticClass:"d-flex flex-column text-left"},[_vm._v(" "+_vm._s(item.title)+" "),_c('span',{staticClass:"subtitle-1 grey--text "},[_vm._v(_vm._s(item.description))])])]},proxy:true}:null],null,true)})],{"item":item})],2)],1)}),1)],1):_vm._e()],1)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/drop-down-button/PpDropDownButton.vue?vue&type=template&id=128b2aa0&scoped=true&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__("a9e3");

// EXTERNAL MODULE: ./src/components/button/PpButton.vue + 5 modules
var PpButton = __webpack_require__("251c");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/drop-down-button/PpDropDownButton.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var PpDropDownButtonvue_type_script_lang_js_ = ({
  name: 'PpDropDownButton',
  components: {
    'pp-button': PpButton["default"]
  },
  props: {
    /**
     * Label for main button
     */
    text: {
      type: String,
      default: ''
    },
    ellipsis: {
      type: Boolean,
      default: false
    },

    /**
     * Prepend icon for main button
     */
    mainButtonIcon: {
      type: String,
      default: null
    },

    /**
     * Prepend icon for secondary button
     */
    secondaryButtonIcon: {
      type: String,
      default: 'drop-arrow'
    },

    /**
     * Items for dropdown list, require title and id props.
     * For example: [{ id: '1', title: 'Child item title 1', icon: 'details', disabled: false, description: 'description' }]
     */
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },

    /**
     * Clicking the main button will open the drop down
     */
    openDropDownOnMainButton: {
      type: Boolean,
      default: false
    },

    /** adjust the location of the dropdown list */
    nudgeBottom: {
      type: Number,
      default: 40
    },

    /** condense the spacing around the list */
    dense: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      showDropDown: this.$attrs.value
    };
  },
  computed: {
    showMainButton: function showMainButton() {
      return !this.$slots.activator && !this.ellipsis;
    }
  },
  watch: {
    $attrs: {
      deep: true,
      handler: function handler(val) {
        if (val.value !== this.showDropDown) {
          this.showDropDown = val.value;
        }
      }
    },
    showDropDown: {
      handler: function handler(val) {
        this.$emit('input', val);
      }
    }
  },
  methods: {
    mainButtonClicked: function mainButtonClicked() {
      this.$emit('main-button-clicked');

      if (this.openDropDownOnMainButton) {
        this.showDropDown = !this.showDropDown;
      }
    },
    listItemClasses: function listItemClasses(item) {
      return {
        'pp-drop-down-button__menu-item--divider': item.divider,
        'error--text': item.caution
      };
    }
  }
});
// CONCATENATED MODULE: ./src/components/drop-down-button/PpDropDownButton.vue?vue&type=script&lang=js&
 /* harmony default export */ var drop_down_button_PpDropDownButtonvue_type_script_lang_js_ = (PpDropDownButtonvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/drop-down-button/PpDropDownButton.vue?vue&type=style&index=0&id=128b2aa0&lang=scss&scoped=true&
var PpDropDownButtonvue_type_style_index_0_id_128b2aa0_lang_scss_scoped_true_ = __webpack_require__("8294");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// EXTERNAL MODULE: ./node_modules/vuetify-loader/lib/runtime/installComponents.js
var installComponents = __webpack_require__("6544");
var installComponents_default = /*#__PURE__*/__webpack_require__.n(installComponents);

// EXTERNAL MODULE: ./node_modules/vuetify/lib/components/VList/VList.js
var VList = __webpack_require__("8860");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/components/VList/VListItem.js
var VListItem = __webpack_require__("da13");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/components/VList/index.js + 3 modules
var components_VList = __webpack_require__("5d23");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/components/VMenu/VMenu.js
var VMenu = __webpack_require__("e449");

// CONCATENATED MODULE: ./src/components/drop-down-button/PpDropDownButton.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  drop_down_button_PpDropDownButtonvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "128b2aa0",
  null
  
)

/* harmony default export */ var PpDropDownButton = __webpack_exports__["default"] = (component.exports);

/* vuetify-loader */





installComponents_default()(component, {VList: VList["a" /* default */],VListItem: VListItem["a" /* default */],VListItemTitle: components_VList["b" /* VListItemTitle */],VMenu: VMenu["a" /* default */]})


/***/ }),

/***/ "ae93":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__("d039");
var getPrototypeOf = __webpack_require__("e163");
var createNonEnumerableProperty = __webpack_require__("9112");
var has = __webpack_require__("5135");
var wellKnownSymbol = __webpack_require__("b622");
var IS_PURE = __webpack_require__("c430");

var ITERATOR = wellKnownSymbol('iterator');
var BUGGY_SAFARI_ITERATORS = false;

var returnThis = function () { return this; };

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;

if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = IteratorPrototype == undefined || fails(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype[ITERATOR].call(test) !== test;
});

if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
if ((!IS_PURE || NEW_ITERATOR_PROTOTYPE) && !has(IteratorPrototype, ITERATOR)) {
  createNonEnumerableProperty(IteratorPrototype, ITERATOR, returnThis);
}

module.exports = {
  IteratorPrototype: IteratorPrototype,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
};


/***/ }),

/***/ "af03":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");

// check the existence of a method, lowercase
// of a tag and escaping quotes in arguments
module.exports = function (METHOD_NAME) {
  return fails(function () {
    var test = ''[METHOD_NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  });
};


/***/ }),

/***/ "af1b":
/***/ (function(module, exports, __webpack_require__) {

var addMilliseconds = __webpack_require__("ec1f")

/**
 * @category Second Helpers
 * @summary Add the specified number of seconds to the given date.
 *
 * @description
 * Add the specified number of seconds to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of seconds to be added
 * @returns {Date} the new date with the seconds added
 *
 * @example
 * // Add 30 seconds to 10 July 2014 12:45:00:
 * var result = addSeconds(new Date(2014, 6, 10, 12, 45, 0), 30)
 * //=> Thu Jul 10 2014 12:45:30
 */
function addSeconds (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addMilliseconds(dirtyDate, amount * 1000)
}

module.exports = addSeconds


/***/ }),

/***/ "af2b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var core_js_modules_es_string_small_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("c96a");
/* harmony import */ var core_js_modules_es_string_small_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_small_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("8bbf");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_1__);


/* harmony default export */ __webpack_exports__["a"] = (vue__WEBPACK_IMPORTED_MODULE_1___default.a.extend({
  name: 'sizeable',
  props: {
    large: Boolean,
    small: Boolean,
    xLarge: Boolean,
    xSmall: Boolean
  },
  computed: {
    medium: function medium() {
      return Boolean(!this.xSmall && !this.small && !this.large && !this.xLarge);
    },
    sizeableClasses: function sizeableClasses() {
      return {
        'v-size--x-small': this.xSmall,
        'v-size--small': this.small,
        'v-size--default': this.medium,
        'v-size--large': this.large,
        'v-size--x-large': this.xLarge
      };
    }
  }
}));

/***/ }),

/***/ "afaf":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M7.5 16.5L5 18.5L6 19.5L7.5 21L9 21.5H12H14L16.5 21L18 20L18.5 18.5L18 17H16.5L13.5 16L11 16.5H7.5Z\" fill=\"#DFE4E5\"></path><path d=\"M6.5 16.5L3.5 17.5L2.5 15.5L2 14V11L2.5 8.5L4.5 5.5L7 3.5L11.5 2.5L15.5 3L18.5 5L21.5 10V13.5L21 17L20 17.5L19 18L18 17.5L15.5 16.5C15 16.3333 13.9 16 13.5 16C13.1 16 12.3333 15.6667 12 15.5L12.5 14.5L14 13.5L14.5 12.1875V9L13.5 7.5L12 7L10.5 7.5L9.5 9L9 10.5L9.5 13L10.5 14L12 14.5L11.5 16H10.5H9.5L8 16.5H6.5Z\" fill=\"white\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M1 12C1 18.0751 5.92487 23 12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12ZM17.9647 18.7398C16.3767 20.1462 14.2881 21 12 21C9.71194 21 7.6233 20.1462 6.03532 18.7398C6.32801 17.6874 8.43062 17 12 17C15.5694 17 17.672 17.6873 17.9647 18.7398ZM19.3995 17.1246C18.274 15.6381 15.6294 15 12 15C8.3706 15 5.72596 15.6381 4.60051 17.1246C3.59138 15.6703 3 13.9042 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 13.9042 20.4086 15.6703 19.3995 17.1246ZM8 10C8 7.75576 9.5791 6 12 6C14.4142 6 16 7.92158 16 10.2C16 13.4796 14.2181 15 12 15C9.76086 15 8 13.4274 8 10Z\" fill=\"#1F3A3E\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M10 10C10 12.2693 10.8182 13 12 13C13.1777 13 14 12.2984 14 10.2C14 8.95042 13.2157 8 12 8C10.7337 8 10 8.81582 10 10Z\" fill=\"#DFE4E5\"></path></svg>";

/***/ }),

/***/ "afdd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _VBtn__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("8336");


/* harmony default export */ __webpack_exports__["a"] = (_VBtn__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]);

/***/ }),

/***/ "afe3":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_167_1)\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M17.9809 15.7078L18.8527 13.6256L21 12.4139V11.6103L18.8534 10.3906L17.9941 8.30696L18.6558 5.93166L18.087 5.36362L15.7044 6.0192L13.6245 5.1471L12.4129 3H11.6093L10.3895 5.14655L8.30576 6.00595L5.93001 5.34321L5.36375 5.90947L6.0192 8.29155L5.1471 10.3715L3 11.583V12.3876L5.14482 13.6101L6.00385 15.693L5.34203 18.0688L5.90947 18.6362L8.29155 17.9808L10.3714 18.8529L11.5829 20.999H12.3873L13.609 18.8542L15.692 17.9951L18.0678 18.657L18.6362 18.0886L17.9809 15.7078Z\" fill=\"white\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M20.8733 18.6798L18.6562 20.897L15.8183 20.1065L15.0067 20.4412L13.5498 22.999H10.4153L8.96644 20.4325L8.15567 20.0925L5.31809 20.8733L3.10197 18.6572L3.89252 15.8193L3.55774 15.0076L1 13.5496V10.4151L3.56758 8.96634L3.90748 8.15567L3.1267 5.31809L5.34198 3.10281L8.17985 3.89446L8.99072 3.56004L10.4454 1H13.5808L15.0296 3.56758L15.8403 3.90748L18.6774 3.12683L20.8961 5.34235L20.1055 8.18067L20.44 8.99173L23 10.4464V13.5818L20.4327 15.0305L20.0925 15.843L20.8733 18.6798ZM17.9809 15.7078L18.8527 13.6256L21 12.4139V11.6103L18.8534 10.3906L17.9941 8.30696L18.6558 5.93166L18.087 5.36362L15.7044 6.0192L13.6245 5.1471L12.4129 3H11.6093L10.3895 5.14655L8.30576 6.00595L5.93001 5.34321L5.36375 5.90947L6.0192 8.29155L5.1471 10.3715L3 11.583V12.3876L5.14482 13.6101L6.00385 15.693L5.34203 18.0688L5.90947 18.6362L8.29155 17.9808L10.3714 18.8529L11.5829 20.999H12.3873L13.609 18.8542L15.692 17.9951L18.0678 18.657L18.6362 18.0886L17.9809 15.7078Z\" fill=\"#1F3A3E\"></path><circle cx=\"12\" cy=\"12\" r=\"3\" fill=\"#DFE4E5\" stroke=\"#1F3A3E\" stroke-width=\"2\"></circle></g><defs><clipPath id=\"clip0_167_1\"><rect width=\"24\" height=\"24\" fill=\"white\"></rect></clipPath></defs></svg>";

/***/ }),

/***/ "b041":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c662cfac-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/dialog/phi/PpDialogPhi.vue?vue&type=template&id=23d119ea&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pp-dialog',{attrs:{"value":_vm.show,"max-width":500,"primary-button-text":"Confirm Access","secondary-button-text":"Cancel","title":"Access Patient Information"},on:{"close":function($event){return _vm.$emit('close')},"confirm":_vm.onConfirm},scopedSlots:_vm._u([{key:"body",fn:function(){return [_c('p',[_vm._v(" Please confirm you want to see this patient's personal health information (PHI). Your request will be logged and audited to ensure access meets a valid business need. ")]),_c('pp-input-textarea',{attrs:{"label":"Reason for access (include link to ticket)","error-messages":_vm.errorMessages},on:{"focus":_vm.clearErrors},model:{value:(_vm.accessReason),callback:function ($$v) {_vm.accessReason=$$v},expression:"accessReason"}})]},proxy:true}])})}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/dialog/phi/PpDialogPhi.vue?vue&type=template&id=23d119ea&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.trim.js
var es_string_trim = __webpack_require__("498a");

// EXTERNAL MODULE: ./src/components/dialog/PpDialog.vue + 5 modules
var PpDialog = __webpack_require__("bdf9");

// EXTERNAL MODULE: ./src/components/input/textarea/PpInputTextarea.vue + 5 modules
var PpInputTextarea = __webpack_require__("d696");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/dialog/phi/PpDialogPhi.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var PpDialogPhivue_type_script_lang_js_ = ({
  name: 'PpDialogPhi',
  components: {
    'pp-input-textarea': PpInputTextarea["default"],
    'pp-dialog': PpDialog["default"]
  },
  props: {
    show: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      accessReason: '',
      errorMessages: []
    };
  },
  methods: {
    clearErrors: function clearErrors() {
      this.errorMessages = [];
    },
    onConfirm: function onConfirm() {
      if (!this.accessReason.trim()) {
        this.errorMessages = ['Reason is required'];
        return;
      }

      this.$emit('confirm', this.accessReason.trim());
    },
    closeDialog: function closeDialog() {
      this.$emit('close');
    }
  }
});
// CONCATENATED MODULE: ./src/components/dialog/phi/PpDialogPhi.vue?vue&type=script&lang=js&
 /* harmony default export */ var phi_PpDialogPhivue_type_script_lang_js_ = (PpDialogPhivue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/dialog/phi/PpDialogPhi.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  phi_PpDialogPhivue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var PpDialogPhi = __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "b0415":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var TO_STRING_TAG_SUPPORT = __webpack_require__("00ee");
var classof = __webpack_require__("f5df");

// `Object.prototype.toString` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.tostring
module.exports = TO_STRING_TAG_SUPPORT ? {}.toString : function toString() {
  return '[object ' + classof(this) + ']';
};


/***/ }),

/***/ "b0af":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var core_js_modules_es_array_flat_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("0481");
/* harmony import */ var core_js_modules_es_array_flat_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_flat_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_unscopables_flat_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("4069");
/* harmony import */ var core_js_modules_es_array_unscopables_flat_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_unscopables_flat_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("a9e3");
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("5530");
/* harmony import */ var _src_components_VCard_VCard_sass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("615b");
/* harmony import */ var _src_components_VCard_VCard_sass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_src_components_VCard_VCard_sass__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _VSheet__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("10d2");
/* harmony import */ var _mixins_loadable__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("297c");
/* harmony import */ var _mixins_routable__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("1c87");
/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("58df");




// Styles
 // Extensions

 // Mixins


 // Helpers


/* @vue/component */

/* harmony default export */ __webpack_exports__["a"] = (Object(_util_mixins__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"])(_mixins_loadable__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"], _mixins_routable__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"], _VSheet__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"]).extend({
  name: 'v-card',
  props: {
    flat: Boolean,
    hover: Boolean,
    img: String,
    link: Boolean,
    loaderHeight: {
      type: [Number, String],
      default: 4
    },
    raised: Boolean
  },
  computed: {
    classes: function classes() {
      return Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])({
        'v-card': true
      }, _mixins_routable__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"].options.computed.classes.call(this)), {}, {
        'v-card--flat': this.flat,
        'v-card--hover': this.hover,
        'v-card--link': this.isClickable,
        'v-card--loading': this.loading,
        'v-card--disabled': this.disabled,
        'v-card--raised': this.raised
      }, _VSheet__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"].options.computed.classes.call(this));
    },
    styles: function styles() {
      var style = Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])({}, _VSheet__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"].options.computed.styles.call(this));

      if (this.img) {
        style.background = "url(\"".concat(this.img, "\") center center / cover no-repeat");
      }

      return style;
    }
  },
  methods: {
    genProgress: function genProgress() {
      var render = _mixins_loadable__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"].options.methods.genProgress.call(this);
      if (!render) return null;
      return this.$createElement('div', {
        staticClass: 'v-card__progress',
        key: 'progress'
      }, [render]);
    }
  },
  render: function render(h) {
    var _this$generateRouteLi = this.generateRouteLink(),
        tag = _this$generateRouteLi.tag,
        data = _this$generateRouteLi.data;

    data.style = this.styles;

    if (this.isClickable) {
      data.attrs = data.attrs || {};
      data.attrs.tabindex = 0;
    }

    return h(tag, this.setBackgroundColor(this.color, data), [this.genProgress(), this.$slots.default]);
  }
}));

/***/ }),

/***/ "b0c0":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var defineProperty = __webpack_require__("9bf2").f;

var FunctionPrototype = Function.prototype;
var FunctionPrototypeToString = FunctionPrototype.toString;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// Function instances `.name` property
// https://tc39.es/ecma262/#sec-function-instances-name
if (DESCRIPTORS && !(NAME in FunctionPrototype)) {
  defineProperty(FunctionPrototype, NAME, {
    configurable: true,
    get: function () {
      try {
        return FunctionPrototypeToString.call(this).match(nameRE)[1];
      } catch (error) {
        return '';
      }
    }
  });
}


/***/ }),

/***/ "b0e0":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><rect x=\"3\" y=\"3\" width=\"18\" height=\"14\" fill=\"white\"></rect><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M13.4274 12C15.3757 12 17.0407 13.4038 17.3699 15.3241L18 19H6L6.63015 15.3241C6.95935 13.4038 8.62428 12 10.5726 12H13.4274ZM12 5C13.933 5 15.5 6.567 15.5 8.5C15.5 10.433 13.933 12 12 12C10.067 12 8.5 10.433 8.5 8.5C8.5 6.567 10.067 5 12 5Z\" fill=\"#DFE4E5\"></path><path d=\"M16 21C16.5523 21 17 21.4477 17 22C17 22.5523 16.5523 23 16 23H8C7.44772 23 7 22.5523 7 22C7 21.4477 7.44772 21 8 21H16ZM4 19C2.34315 19 1 17.6569 1 16V4C1 2.34315 2.34315 1 4 1H20C21.6569 1 23 2.34315 23 4V16C23 17.6569 21.6569 19 20 19H4ZM20 3H4C3.48716 3 3.06449 3.38604 3.00673 3.88338L3 4V16C3 16.5128 3.38604 16.9355 3.88338 16.9933L4 17H6.343L6.63015 15.3241C6.95935 13.4038 8.62428 12 10.5726 12H13.4274C15.3757 12 17.0407 13.4038 17.3699 15.3241L17.657 17H20C20.5128 17 20.9355 16.614 20.9933 16.1166L21 16V4C21 3.48716 20.614 3.06449 20.1166 3.00673L20 3ZM13.4274 14H10.5726C9.65258 14 8.85893 14.6261 8.63492 15.5045L8.60139 15.6621L8.372 17H15.627L15.3986 15.6621C15.2432 14.7552 14.492 14.0788 13.5883 14.0064L13.4274 14ZM12 5C13.933 5 15.5 6.567 15.5 8.5C15.5 10.433 13.933 12 12 12C10.067 12 8.5 10.433 8.5 8.5C8.5 6.567 10.067 5 12 5ZM12 7C11.1716 7 10.5 7.67157 10.5 8.5C10.5 9.32843 11.1716 10 12 10C12.8284 10 13.5 9.32843 13.5 8.5C13.5 7.67157 12.8284 7 12 7Z\" fill=\"#688083\"></path></svg>";

/***/ }),

/***/ "b13b":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("be73");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("0e0b71c4", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "b178":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("9130");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("23de1937", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "b1e0":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("f507");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("72f391c4", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "b1f3":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("a6a2");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("51ee1e6e", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "b22b":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("ac99");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("6a97cecc", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "b280":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpDivider_vue_vue_type_style_index_0_id_2e674112_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("d5af");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpDivider_vue_vue_type_style_index_0_id_2e674112_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpDivider_vue_vue_type_style_index_0_id_2e674112_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "b2e9":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("c8d5")

/**
 * @category Month Helpers
 * @summary Get the number of calendar months between the given dates.
 *
 * @description
 * Get the number of calendar months between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar months
 *
 * @example
 * // How many calendar months are between 31 January 2014 and 1 September 2014?
 * var result = differenceInCalendarMonths(
 *   new Date(2014, 8, 1),
 *   new Date(2014, 0, 31)
 * )
 * //=> 8
 */
function differenceInCalendarMonths (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)

  var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear()
  var monthDiff = dateLeft.getMonth() - dateRight.getMonth()

  return yearDiff * 12 + monthDiff
}

module.exports = differenceInCalendarMonths


/***/ }),

/***/ "b376":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c662cfac-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/input/time/PpInputTime.vue?vue&type=template&id=fa79b068&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pp-input-select',_vm._g({attrs:{"disabled":_vm.disabled,"items":_vm.timeOptions,"placeholder":_vm.value || _vm.placeholder,"error-messages":_vm.errorMessages,"error":_vm.error},model:{value:(_vm.selectedValue),callback:function ($$v) {_vm.selectedValue=$$v},expression:"selectedValue"}},_vm.$listeners))}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/input/time/PpInputTime.vue?vue&type=template&id=fa79b068&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("99af");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__("a9e3");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.is-integer.js
var es_number_is_integer = __webpack_require__("8ba4");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.constructor.js
var es_regexp_constructor = __webpack_require__("4d63");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__("ac1f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("25f0");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("2532");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.match.js
var es_string_match = __webpack_require__("466d");

// EXTERNAL MODULE: ./src/components/input/select/PpInputSelect.vue + 4 modules
var PpInputSelect = __webpack_require__("b8f2");

// CONCATENATED MODULE: ./src/components/input/time/constants.js
var DEFAULT_MIN_TIME = '12:00 AM';
var DEFAULT_MAX_TIME = '11:59 PM';
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/input/time/PpInputTime.vue?vue&type=script&lang=js&








//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var PpInputTimevue_type_script_lang_js_ = ({
  name: 'PpInputTime',
  components: {
    'pp-input-select': PpInputSelect["default"]
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    interval: {
      type: Number,
      default: 30,
      validator: function validator(value) {
        return Number.isInteger(value) && value > 0 && value <= 60;
      }
    },
    placeholder: {
      type: String,
      required: false,
      default: ''
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    minTime: {
      type: String,
      required: false,
      default: '12:00 AM'
    },
    maxTime: {
      type: String,
      required: false,
      default: '11:59 PM'
    },
    errorMessages: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    error: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    var _this$value;

    return {
      selectedValue: (_this$value = this.value) === null || _this$value === void 0 ? void 0 : _this$value.toUpperCase()
    };
  },
  computed: {
    timeOptions: function timeOptions() {
      var times = [];
      var parsedMinTime = this.parsedTime(this.minTime); // For case input min time with invalid format

      if (!parsedMinTime) {
        parsedMinTime = this.parsedTime(DEFAULT_MIN_TIME);
      }

      var parsedMaxTime = this.parsedTime(this.maxTime); // For case input max time with invalid format

      if (!parsedMaxTime) {
        parsedMaxTime = this.parsedTime(DEFAULT_MAX_TIME);
      }

      var minTimeMiliseconds = parsedMinTime.getTime();
      var maxTimeMiliseconds = parsedMaxTime.getTime();

      while (minTimeMiliseconds <= maxTimeMiliseconds) {
        var hours = parsedMinTime.getHours();
        var minutes = parsedMinTime.getMinutes();
        var stringMinutes = minutes < 10 ? '0' + minutes : minutes;
        var value = void 0;

        if (hours > 12) {
          value = "".concat(hours - 12, ":").concat(stringMinutes, " PM");
        } else if (hours === 12) {
          // Case 12:mm PM
          value = "12:".concat(stringMinutes, " PM");
        } else {
          value = "".concat(hours === 0 ? 12 : hours, ":").concat(stringMinutes, " AM");
        }

        times.push({
          text: value,
          value: value
        });
        minTimeMiliseconds = parsedMinTime.setMinutes(minutes + parseInt(this.interval));
      }

      return times;
    }
  },
  methods: {
    parsedTime: function parsedTime(time) {
      if (!time) {
        return null;
      } // Check if is not valid time format


      var pattern = new RegExp('^([1-9]|1[0-2]):([0-5][0-9]) ?([AP][M])$');
      var match = time.match(pattern);

      if (!match) {
        return null;
      }

      var date = new Date(); // Position 4 is meridiem

      if ('PM'.includes(match[3])) {
        // Position 2 is hours and 3 is minutes
        var hours = parseInt(match[1]) === 12 ? 12 : parseInt(match[1]) + 12;
        date.setHours(hours, match[2], 0);
      } else {
        // Position 2 is hours and 3 is minutes
        date.setHours(parseInt(match[1] === '12' ? 0 : match[1]), match[2], 0);
      }

      return date;
    }
  }
});
// CONCATENATED MODULE: ./src/components/input/time/PpInputTime.vue?vue&type=script&lang=js&
 /* harmony default export */ var time_PpInputTimevue_type_script_lang_js_ = (PpInputTimevue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/input/time/PpInputTime.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  time_PpInputTimevue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var PpInputTime = __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "b3f5":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("c8d5")
var differenceInCalendarISOYears = __webpack_require__("f9ff")
var compareAsc = __webpack_require__("0d3e")
var subISOYears = __webpack_require__("df35")

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the number of full ISO week-numbering years between the given dates.
 *
 * @description
 * Get the number of full ISO week-numbering years between the given dates.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of full ISO week-numbering years
 *
 * @example
 * // How many full ISO week-numbering years are between 1 January 2010 and 1 January 2012?
 * var result = differenceInISOYears(
 *   new Date(2012, 0, 1),
 *   new Date(2010, 0, 1)
 * )
 * //=> 1
 */
function differenceInISOYears (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)

  var sign = compareAsc(dateLeft, dateRight)
  var difference = Math.abs(differenceInCalendarISOYears(dateLeft, dateRight))
  dateLeft = subISOYears(dateLeft, sign * difference)

  // Math.abs(diff in full ISO years - diff in calendar ISO years) === 1
  // if last calendar ISO year is not full
  // If so, result must be decreased by 1 in absolute value
  var isLastISOYearNotFull = compareAsc(dateLeft, dateRight) === -sign
  return sign * (difference - isLastISOYearNotFull)
}

module.exports = differenceInISOYears


/***/ }),

/***/ "b442":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c662cfac-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/input/color/PpInputColor.vue?vue&type=template&id=0d1c1272&scoped=true&
var PpInputColorvue_type_template_id_0d1c1272_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-menu',{attrs:{"close-on-content-click":false,"close-on-click":!_vm.showInput,"offset-x":true,"content-class":"pp-color-picker","max-width":"320px","top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [(_vm.$slots.activator)?_c('div',_vm._g(_vm._b({staticClass:"d-inline"},'div',attrs,false),on),[_vm._t("activator")],2):(_vm.showInput)?_c('pp-input-text',_vm._g({class:_vm.inputClass,attrs:{"append-inner-icon":_vm.showReset ? 'previous' : '',"disabled":_vm.disabled,"error-messages":_vm.errorMessages,"label":_vm.label,"placeholder":_vm.placeholder},on:{"input":_vm.emitInputValue,"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.onEnterDown($event)},"click:append":_vm.emitReset},scopedSlots:_vm._u([{key:"prepend-inner",fn:function(){return [_c('div',_vm._g({staticClass:"swatch swatch--within-input rounded ml-n1",style:(("--swatch-color:" + (_vm.$attrs.value)))},on),[_c('span',{staticClass:"d-sr-only"},[_vm._v("Choose Color")])])]},proxy:true}],null,true),model:{value:(_vm.inputValue),callback:function ($$v) {_vm.inputValue=$$v},expression:"inputValue"}},on)):_c('div',_vm._g({staticClass:"swatch swatch--selector d-flex rounded-lg",class:{ 'swatch--with-border': _vm.$attrs.value === '' || _vm.$attrs.value === '#FFFFFF'},style:(("--swatch-color:" + (_vm.$attrs.value))),attrs:{"data-color":_vm.$attrs.value}},on),[_c('span',{staticClass:"d-sr-only"},[_vm._v("Choose Color")])])]}}],null,true),model:{value:(_vm.colorPickerOpen),callback:function ($$v) {_vm.colorPickerOpen=$$v},expression:"colorPickerOpen"}},[_c('div',{staticClass:"align-center px-3 pt-3 pb-2 d-flex justify-space-between"},[_c('p',{staticClass:"text-h5 mb-0"},[_vm._v(" Color picker ")]),_c('pp-button',{attrs:{"icon":"close","type":"icon"},on:{"click":function($event){return _vm.closeColorPicker('x')}}})],1),_c('v-color-picker',{staticClass:"mx-3",attrs:{"hide-mode-switch":true,"mode":_vm.colorMode,"width":"295px"},on:{"input":_vm.updateColor},model:{value:(_vm.colorValue),callback:function ($$v) {_vm.colorValue=$$v},expression:"colorValue"}}),_c('pp-input-select',{staticClass:"pp-color-picker__mode-select",attrs:{"hide-details":true,"items":_vm.colorModes,"white-bg":true,"menu-class":"pp-color-picker__mode-select__options"},on:{"input":_vm.changeColorMode},model:{value:(_vm.colorMode),callback:function ($$v) {_vm.colorMode=$$v},expression:"colorMode"}}),(_vm.showButtons)?_c('div',{staticClass:"d-flex justify-space-between px-3 pb-3"},[_c('pp-button',{attrs:{"text":"Cancel","type":"secondary"},on:{"click":_vm.cancelChoice}}),_c('pp-button',{attrs:{"text":"Ok","type":"primary"},on:{"click":_vm.confirmChoice}})],1):_vm._e()],1)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/input/color/PpInputColor.vue?vue&type=template&id=0d1c1272&scoped=true&

// EXTERNAL MODULE: ./src/components/input/select/PpInputSelect.vue + 4 modules
var PpInputSelect = __webpack_require__("b8f2");

// EXTERNAL MODULE: ./src/components/input/text/PpInputText.vue + 4 modules
var PpInputText = __webpack_require__("ac90");

// EXTERNAL MODULE: ./src/components/button/PpButton.vue + 5 modules
var PpButton = __webpack_require__("251c");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/input/color/PpInputColor.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/**
 * An input to allow user to select color, uses a pop-up color picker.  Note: to show the alpha slider will need to have an alpha value
 * e.g. for hex: #000000 = will not show the alpha slider, but #000000FF will show the alpha slider
 */

/* harmony default export */ var PpInputColorvue_type_script_lang_js_ = ({
  name: 'PpInputColor',
  components: {
    'pp-button': PpButton["default"],
    'pp-input-select': PpInputSelect["default"],
    'pp-input-text': PpInputText["default"]
  },
  props: {
    showInput: {
      type: Boolean,
      default: false
    },

    /**
     * Show the OK / Cancel button to confirm choice.  If shown will need to be clicked to update the value, otherwise will be on select of new color.
     */
    showButtons: {
      type: Boolean,
      default: false
    },

    /**
     * Show reset icon, which will emit a reset event
     */
    showReset: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    errorMessages: {
      type: Array,
      default: function _default() {
        return [];
      }
    },

    /**
     * Applies a CSS class to the input when using showInput for the color input
     */
    inputClass: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      inputValue: '',
      colorValue: '',
      colorMode: 'hexa',
      colorPickerOpen: false,
      colorModes: [{
        text: 'HEX',
        value: 'hexa'
      }, {
        text: 'RGBA',
        value: 'rgba'
      }, {
        text: 'HSLA',
        value: 'hsla'
      }]
    };
  },
  watch: {
    $attrs: {
      deep: true,
      handler: function handler() {
        this.setupValues();
      }
    }
  },
  mounted: function mounted() {
    this.setupValues();
  },
  methods: {
    setupValues: function setupValues() {
      this.inputValue = this.$attrs.value;
      this.colorValue = this.$attrs.value;
    },
    openColorPicker: function openColorPicker() {
      this.$ppAnalytics.trackEvent({
        category: 'color-picker',
        action: 'open'
      });
      this.colorPickerOpen = true;
    },
    closeColorPicker: function closeColorPicker(method) {
      this.$ppAnalytics.trackEvent({
        category: 'color-picker',
        action: 'close',
        label: method
      });
      this.colorPickerOpen = false;
    },
    emitReset: function emitReset() {
      this.$ppAnalytics.trackEvent({
        category: 'color-picker',
        action: 'reset'
      });
      this.$emit('reset');
    },
    emitInputValue: function emitInputValue() {
      this.$ppAnalytics.trackEvent({
        category: 'color-picker',
        action: 'change-color',
        label: 'input-text'
      });
      this.$emit('input', this.inputValue);
    },
    onEnterDown: function onEnterDown() {
      this.emitInputValue();
      this.openColorPicker();
    },
    cancelChoice: function cancelChoice() {
      this.closeColorPicker('cancel');
      this.colorValue = this.$attrs.value;
    },
    confirmChoice: function confirmChoice() {
      this.$emit('input', this.colorValue);
      this.closeColorPicker('confirm');
    },
    // if not showing buttons, then auto update the color value
    updateColor: function updateColor() {
      if (!this.showButtons) {
        this.$emit('input', this.colorValue);
      }
    },
    changeColorMode: function changeColorMode(e) {
      this.$ppAnalytics.trackEvent({
        category: 'color-picker',
        action: 'change-mode',
        label: e
      });
    }
  }
});
// CONCATENATED MODULE: ./src/components/input/color/PpInputColor.vue?vue&type=script&lang=js&
 /* harmony default export */ var color_PpInputColorvue_type_script_lang_js_ = (PpInputColorvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/input/color/PpInputColor.vue?vue&type=style&index=0&lang=scss&
var PpInputColorvue_type_style_index_0_lang_scss_ = __webpack_require__("9cb1");

// EXTERNAL MODULE: ./src/components/input/color/PpInputColor.vue?vue&type=style&index=1&id=0d1c1272&lang=scss&scoped=true&
var PpInputColorvue_type_style_index_1_id_0d1c1272_lang_scss_scoped_true_ = __webpack_require__("03e4");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// EXTERNAL MODULE: ./node_modules/vuetify-loader/lib/runtime/installComponents.js
var installComponents = __webpack_require__("6544");
var installComponents_default = /*#__PURE__*/__webpack_require__.n(installComponents);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.flat.js
var es_array_flat = __webpack_require__("0481");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("caad");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.unscopables.flat.js
var es_array_unscopables_flat = __webpack_require__("4069");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__("a9e3");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("b64b");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("2532");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__("5530");

// EXTERNAL MODULE: ./node_modules/vuetify/src/components/VColorPicker/VColorPicker.sass
var VColorPicker = __webpack_require__("bb18");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/components/VSheet/VSheet.js
var VSheet = __webpack_require__("8dd9");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("99af");

// EXTERNAL MODULE: ./node_modules/vuetify/src/components/VColorPicker/VColorPickerPreview.sass
var VColorPickerPreview = __webpack_require__("7863");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/components/VSlider/VSlider.js
var VSlider = __webpack_require__("ba0d");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/util/colorUtils.js
var colorUtils = __webpack_require__("7bc6");

// EXTERNAL MODULE: external {"commonjs":"vue","commonjs2":"vue","root":"Vue"}
var external_commonjs_vue_commonjs2_vue_root_Vue_ = __webpack_require__("8bbf");
var external_commonjs_vue_commonjs2_vue_root_Vue_default = /*#__PURE__*/__webpack_require__.n(external_commonjs_vue_commonjs2_vue_root_Vue_);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.every.js
var es_array_every = __webpack_require__("a623");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__("15fd");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__("53ca");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VColorPicker/util/index.js




// Utilities

function fromHSVA(hsva) {
  hsva = Object(objectSpread2["a" /* default */])({}, hsva);
  var hexa = Object(colorUtils["c" /* HSVAtoHex */])(hsva);
  var hsla = Object(colorUtils["b" /* HSVAtoHSLA */])(hsva);
  var rgba = Object(colorUtils["d" /* HSVAtoRGBA */])(hsva);
  return {
    alpha: hsva.a,
    hex: hexa.substr(0, 7),
    hexa: hexa,
    hsla: hsla,
    hsva: hsva,
    hue: hsva.h,
    rgba: rgba
  };
}
function fromHSLA(hsla) {
  var hsva = Object(colorUtils["a" /* HSLAtoHSVA */])(hsla);
  var hexa = Object(colorUtils["c" /* HSVAtoHex */])(hsva);
  var rgba = Object(colorUtils["d" /* HSVAtoRGBA */])(hsva);
  return {
    alpha: hsva.a,
    hex: hexa.substr(0, 7),
    hexa: hexa,
    hsla: hsla,
    hsva: hsva,
    hue: hsva.h,
    rgba: rgba
  };
}
function fromRGBA(rgba) {
  var hsva = Object(colorUtils["g" /* RGBAtoHSVA */])(rgba);
  var hexa = Object(colorUtils["h" /* RGBAtoHex */])(rgba);
  var hsla = Object(colorUtils["b" /* HSVAtoHSLA */])(hsva);
  return {
    alpha: hsva.a,
    hex: hexa.substr(0, 7),
    hexa: hexa,
    hsla: hsla,
    hsva: hsva,
    hue: hsva.h,
    rgba: rgba
  };
}
function fromHexa(hexa) {
  var hsva = Object(colorUtils["e" /* HexToHSVA */])(hexa);
  var hsla = Object(colorUtils["b" /* HSVAtoHSLA */])(hsva);
  var rgba = Object(colorUtils["d" /* HSVAtoRGBA */])(hsva);
  return {
    alpha: hsva.a,
    hex: hexa.substr(0, 7),
    hexa: hexa,
    hsla: hsla,
    hsva: hsva,
    hue: hsva.h,
    rgba: rgba
  };
}
function fromHex(hex) {
  return fromHexa(Object(colorUtils["o" /* parseHex */])(hex));
}

function has(obj, key) {
  return key.every(function (k) {
    return obj.hasOwnProperty(k);
  });
}

function parseColor(color, oldColor) {
  if (!color) return fromRGBA({
    r: 255,
    g: 0,
    b: 0,
    a: 1
  });

  if (typeof color === 'string') {
    if (color === 'transparent') return fromHexa('#00000000');
    var hex = Object(colorUtils["o" /* parseHex */])(color);
    if (oldColor && hex === oldColor.hexa) return oldColor;else return fromHexa(hex);
  }

  if (Object(esm_typeof["a" /* default */])(color) === 'object') {
    if (color.hasOwnProperty('alpha')) return color;
    var a = color.hasOwnProperty('a') ? parseFloat(color.a) : 1;

    if (has(color, ['r', 'g', 'b'])) {
      if (oldColor && color === oldColor.rgba) return oldColor;else return fromRGBA(Object(objectSpread2["a" /* default */])(Object(objectSpread2["a" /* default */])({}, color), {}, {
        a: a
      }));
    } else if (has(color, ['h', 's', 'l'])) {
      if (oldColor && color === oldColor.hsla) return oldColor;else return fromHSLA(Object(objectSpread2["a" /* default */])(Object(objectSpread2["a" /* default */])({}, color), {}, {
        a: a
      }));
    } else if (has(color, ['h', 's', 'v'])) {
      if (oldColor && color === oldColor.hsva) return oldColor;else return fromHSVA(Object(objectSpread2["a" /* default */])(Object(objectSpread2["a" /* default */])({}, color), {}, {
        a: a
      }));
    }
  }

  return fromRGBA({
    r: 255,
    g: 0,
    b: 0,
    a: 1
  });
}

function util_stripAlpha(color, stripAlpha) {
  if (stripAlpha) {
    var a = color.a,
        rest = Object(objectWithoutProperties["a" /* default */])(color, ["a"]);

    return rest;
  }

  return color;
}

function extractColor(color, input) {
  if (input == null) return color;

  if (typeof input === 'string') {
    return input.length === 7 ? color.hex : color.hexa;
  }

  if (Object(esm_typeof["a" /* default */])(input) === 'object') {
    var shouldStrip = typeof input.a === 'number' && input.a === 0 ? !!input.a : !input.a;
    if (has(input, ['r', 'g', 'b'])) return util_stripAlpha(color.rgba, shouldStrip);else if (has(input, ['h', 's', 'l'])) return util_stripAlpha(color.hsla, shouldStrip);else if (has(input, ['h', 's', 'v'])) return util_stripAlpha(color.hsva, shouldStrip);
  }

  return color;
}
function hasAlpha(color) {
  if (!color) return false;

  if (typeof color === 'string') {
    return color.length > 7;
  }

  if (Object(esm_typeof["a" /* default */])(color) === 'object') {
    return has(color, ['a']) || has(color, ['alpha']);
  }

  return false;
}
// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VColorPicker/VColorPickerPreview.js


// Styles
 // Components

 // Utilities

 // Types



/* harmony default export */ var VColorPicker_VColorPickerPreview = (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
  name: 'v-color-picker-preview',
  props: {
    color: Object,
    disabled: Boolean,
    hideAlpha: Boolean
  },
  methods: {
    genAlpha: function genAlpha() {
      var _this = this;

      return this.genTrack({
        staticClass: 'v-color-picker__alpha',
        props: {
          thumbColor: 'grey lighten-2',
          hideDetails: true,
          value: this.color.alpha,
          step: 0,
          min: 0,
          max: 1
        },
        style: {
          backgroundImage: this.disabled ? undefined : "linear-gradient(to ".concat(this.$vuetify.rtl ? 'left' : 'right', ", transparent, ").concat(Object(colorUtils["i" /* RGBtoCSS */])(this.color.rgba), ")")
        },
        on: {
          input: function input(val) {
            return _this.color.alpha !== val && _this.$emit('update:color', fromHSVA(Object(objectSpread2["a" /* default */])(Object(objectSpread2["a" /* default */])({}, _this.color.hsva), {}, {
              a: val
            })));
          }
        }
      });
    },
    genSliders: function genSliders() {
      return this.$createElement('div', {
        staticClass: 'v-color-picker__sliders'
      }, [this.genHue(), !this.hideAlpha && this.genAlpha()]);
    },
    genDot: function genDot() {
      return this.$createElement('div', {
        staticClass: 'v-color-picker__dot'
      }, [this.$createElement('div', {
        style: {
          background: Object(colorUtils["f" /* RGBAtoCSS */])(this.color.rgba)
        }
      })]);
    },
    genHue: function genHue() {
      var _this2 = this;

      return this.genTrack({
        staticClass: 'v-color-picker__hue',
        props: {
          thumbColor: 'grey lighten-2',
          hideDetails: true,
          value: this.color.hue,
          step: 0,
          min: 0,
          max: 360
        },
        on: {
          input: function input(val) {
            return _this2.color.hue !== val && _this2.$emit('update:color', fromHSVA(Object(objectSpread2["a" /* default */])(Object(objectSpread2["a" /* default */])({}, _this2.color.hsva), {}, {
              h: val
            })));
          }
        }
      });
    },
    genTrack: function genTrack(options) {
      return this.$createElement(VSlider["a" /* default */], Object(objectSpread2["a" /* default */])(Object(objectSpread2["a" /* default */])({
        class: 'v-color-picker__track'
      }, options), {}, {
        props: Object(objectSpread2["a" /* default */])({
          disabled: this.disabled
        }, options.props)
      }));
    }
  },
  render: function render(h) {
    return h('div', {
      staticClass: 'v-color-picker__preview',
      class: {
        'v-color-picker__preview--hide-alpha': this.hideAlpha
      }
    }, [this.genDot(), this.genSliders()]);
  }
}));
// EXTERNAL MODULE: ./node_modules/vuetify/src/components/VColorPicker/VColorPickerCanvas.sass
var VColorPickerCanvas = __webpack_require__("d59f");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/util/helpers.js
var helpers = __webpack_require__("80d2");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VColorPicker/VColorPickerCanvas.js


// Styles
 // Helpers


 // Types


/* harmony default export */ var VColorPicker_VColorPickerCanvas = (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
  name: 'v-color-picker-canvas',
  props: {
    color: {
      type: Object,
      default: function _default() {
        return fromRGBA({
          r: 255,
          g: 0,
          b: 0,
          a: 1
        });
      }
    },
    disabled: Boolean,
    dotSize: {
      type: [Number, String],
      default: 10
    },
    height: {
      type: [Number, String],
      default: 150
    },
    width: {
      type: [Number, String],
      default: 300
    }
  },
  data: function data() {
    return {
      boundingRect: {
        width: 0,
        height: 0,
        left: 0,
        top: 0
      }
    };
  },
  computed: {
    dot: function dot() {
      if (!this.color) return {
        x: 0,
        y: 0
      };
      return {
        x: this.color.hsva.s * parseInt(this.width, 10),
        y: (1 - this.color.hsva.v) * parseInt(this.height, 10)
      };
    }
  },
  watch: {
    'color.hue': 'updateCanvas'
  },
  mounted: function mounted() {
    this.updateCanvas();
  },
  methods: {
    emitColor: function emitColor(x, y) {
      var _this$boundingRect = this.boundingRect,
          left = _this$boundingRect.left,
          top = _this$boundingRect.top,
          width = _this$boundingRect.width,
          height = _this$boundingRect.height;
      this.$emit('update:color', fromHSVA({
        h: this.color.hue,
        s: Object(helpers["f" /* clamp */])(x - left, 0, width) / width,
        v: 1 - Object(helpers["f" /* clamp */])(y - top, 0, height) / height,
        a: this.color.alpha
      }));
    },
    updateCanvas: function updateCanvas() {
      if (!this.color) return;
      var canvas = this.$refs.canvas;
      var ctx = canvas.getContext('2d');
      if (!ctx) return;
      var saturationGradient = ctx.createLinearGradient(0, 0, canvas.width, 0);
      saturationGradient.addColorStop(0, 'hsla(0, 0%, 100%, 1)'); // white

      saturationGradient.addColorStop(1, "hsla(".concat(this.color.hue, ", 100%, 50%, 1)"));
      ctx.fillStyle = saturationGradient;
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      var valueGradient = ctx.createLinearGradient(0, 0, 0, canvas.height);
      valueGradient.addColorStop(0, 'hsla(0, 0%, 100%, 0)'); // transparent

      valueGradient.addColorStop(1, 'hsla(0, 0%, 0%, 1)'); // black

      ctx.fillStyle = valueGradient;
      ctx.fillRect(0, 0, canvas.width, canvas.height);
    },
    handleClick: function handleClick(e) {
      if (this.disabled) return;
      this.boundingRect = this.$el.getBoundingClientRect();
      this.emitColor(e.clientX, e.clientY);
    },
    handleMouseDown: function handleMouseDown(e) {
      // To prevent selection while moving cursor
      e.preventDefault();
      if (this.disabled) return;
      this.boundingRect = this.$el.getBoundingClientRect();
      window.addEventListener('mousemove', this.handleMouseMove);
      window.addEventListener('mouseup', this.handleMouseUp);
    },
    handleMouseMove: function handleMouseMove(e) {
      if (this.disabled) return;
      this.emitColor(e.clientX, e.clientY);
    },
    handleMouseUp: function handleMouseUp() {
      window.removeEventListener('mousemove', this.handleMouseMove);
      window.removeEventListener('mouseup', this.handleMouseUp);
    },
    genCanvas: function genCanvas() {
      return this.$createElement('canvas', {
        ref: 'canvas',
        attrs: {
          width: this.width,
          height: this.height
        }
      });
    },
    genDot: function genDot() {
      var radius = parseInt(this.dotSize, 10) / 2;
      var x = Object(helpers["g" /* convertToUnit */])(this.dot.x - radius);
      var y = Object(helpers["g" /* convertToUnit */])(this.dot.y - radius);
      return this.$createElement('div', {
        staticClass: 'v-color-picker__canvas-dot',
        class: {
          'v-color-picker__canvas-dot--disabled': this.disabled
        },
        style: {
          width: Object(helpers["g" /* convertToUnit */])(this.dotSize),
          height: Object(helpers["g" /* convertToUnit */])(this.dotSize),
          transform: "translate(".concat(x, ", ").concat(y, ")")
        }
      });
    }
  },
  render: function render(h) {
    return h('div', {
      staticClass: 'v-color-picker__canvas',
      style: {
        width: Object(helpers["g" /* convertToUnit */])(this.width),
        height: Object(helpers["g" /* convertToUnit */])(this.height)
      },
      on: {
        click: this.handleClick,
        mousedown: this.handleMouseDown
      }
    }, [this.genCanvas(), this.genDot()]);
  }
}));
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.index-of.js
var es_array_index_of = __webpack_require__("c975");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("d81d");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__("fb6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.assign.js
var es_object_assign = __webpack_require__("cca6");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.ends-with.js
var es_string_ends_with = __webpack_require__("8a79");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("ade3");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__("3835");

// EXTERNAL MODULE: ./node_modules/vuetify/src/components/VColorPicker/VColorPickerEdit.sass
var VColorPickerEdit = __webpack_require__("9f7f1");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/components/VBtn/index.js
var VBtn = __webpack_require__("afdd");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/components/VIcon/index.js
var VIcon = __webpack_require__("9d26");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VColorPicker/VColorPickerEdit.js










// Styles
 // Components


 // Helpers

 // Types



var modes = {
  rgba: {
    inputs: [['r', 255, 'int'], ['g', 255, 'int'], ['b', 255, 'int'], ['a', 1, 'float']],
    from: fromRGBA
  },
  hsla: {
    inputs: [['h', 360, 'int'], ['s', 1, 'float'], ['l', 1, 'float'], ['a', 1, 'float']],
    from: fromHSLA
  },
  hexa: {
    from: fromHexa
  }
};
/* harmony default export */ var VColorPicker_VColorPickerEdit = (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
  name: 'v-color-picker-edit',
  props: {
    color: Object,
    disabled: Boolean,
    hideAlpha: Boolean,
    hideModeSwitch: Boolean,
    mode: {
      type: String,
      default: 'rgba',
      validator: function validator(v) {
        return Object.keys(modes).includes(v);
      }
    }
  },
  data: function data() {
    return {
      modes: modes,
      internalMode: this.mode
    };
  },
  computed: {
    currentMode: function currentMode() {
      return this.modes[this.internalMode];
    }
  },
  watch: {
    mode: function mode(_mode) {
      this.internalMode = _mode;
    }
  },
  created: function created() {
    this.internalMode = this.mode;
  },
  methods: {
    getValue: function getValue(v, type) {
      if (type === 'float') return Math.round(v * 100) / 100;else if (type === 'int') return Math.round(v);else return 0;
    },
    parseValue: function parseValue(v, type) {
      if (type === 'float') return parseFloat(v);else if (type === 'int') return parseInt(v, 10) || 0;else return 0;
    },
    changeMode: function changeMode() {
      var modes = Object.keys(this.modes);
      var index = modes.indexOf(this.internalMode);
      var newMode = modes[(index + 1) % modes.length];
      this.internalMode = newMode;
      this.$emit('update:mode', newMode);
    },
    genInput: function genInput(target, attrs, value, on) {
      return this.$createElement('div', {
        staticClass: 'v-color-picker__input'
      }, [this.$createElement('input', {
        key: target,
        attrs: attrs,
        domProps: {
          value: value
        },
        on: on
      }), this.$createElement('span', target.toUpperCase())]);
    },
    genInputs: function genInputs() {
      var _this = this;

      if (this.internalMode === 'hexa') {
        var hex = this.color.hexa;
        var value = this.hideAlpha && hex.endsWith('FF') ? hex.substr(0, 7) : hex;
        return this.genInput('hex', {
          maxlength: this.hideAlpha ? 7 : 9,
          disabled: this.disabled
        }, value, {
          change: function change(e) {
            var el = e.target;

            _this.$emit('update:color', _this.currentMode.from(Object(colorUtils["o" /* parseHex */])(el.value)));
          }
        });
      } else {
        var inputs = this.hideAlpha ? this.currentMode.inputs.slice(0, -1) : this.currentMode.inputs;
        return inputs.map(function (_ref) {
          var _ref2 = Object(slicedToArray["a" /* default */])(_ref, 3),
              target = _ref2[0],
              max = _ref2[1],
              type = _ref2[2];

          var value = _this.color[_this.internalMode];
          return _this.genInput(target, {
            type: 'number',
            min: 0,
            max: max,
            step: type === 'float' ? '0.01' : type === 'int' ? '1' : undefined,
            disabled: _this.disabled
          }, _this.getValue(value[target], type), {
            input: function input(e) {
              var el = e.target;

              var newVal = _this.parseValue(el.value || '0', type);

              _this.$emit('update:color', _this.currentMode.from(Object.assign({}, value, Object(defineProperty["a" /* default */])({}, target, newVal)), _this.color.alpha));
            }
          });
        });
      }
    },
    genSwitch: function genSwitch() {
      return this.$createElement(VBtn["a" /* default */], {
        props: {
          small: true,
          icon: true,
          disabled: this.disabled
        },
        on: {
          click: this.changeMode
        }
      }, [this.$createElement(VIcon["a" /* default */], '$unfold')]);
    }
  },
  render: function render(h) {
    return h('div', {
      staticClass: 'v-color-picker__edit'
    }, [this.genInputs(), !this.hideModeSwitch && this.genSwitch()]);
  }
}));
// EXTERNAL MODULE: ./node_modules/vuetify/src/components/VColorPicker/VColorPickerSwatches.sass
var VColorPickerSwatches = __webpack_require__("31ce");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.freeze.js
var es_object_freeze = __webpack_require__("dca8");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/util/colors.js

var red = Object.freeze({
  base: '#f44336',
  lighten5: '#ffebee',
  lighten4: '#ffcdd2',
  lighten3: '#ef9a9a',
  lighten2: '#e57373',
  lighten1: '#ef5350',
  darken1: '#e53935',
  darken2: '#d32f2f',
  darken3: '#c62828',
  darken4: '#b71c1c',
  accent1: '#ff8a80',
  accent2: '#ff5252',
  accent3: '#ff1744',
  accent4: '#d50000'
});
var pink = Object.freeze({
  base: '#e91e63',
  lighten5: '#fce4ec',
  lighten4: '#f8bbd0',
  lighten3: '#f48fb1',
  lighten2: '#f06292',
  lighten1: '#ec407a',
  darken1: '#d81b60',
  darken2: '#c2185b',
  darken3: '#ad1457',
  darken4: '#880e4f',
  accent1: '#ff80ab',
  accent2: '#ff4081',
  accent3: '#f50057',
  accent4: '#c51162'
});
var purple = Object.freeze({
  base: '#9c27b0',
  lighten5: '#f3e5f5',
  lighten4: '#e1bee7',
  lighten3: '#ce93d8',
  lighten2: '#ba68c8',
  lighten1: '#ab47bc',
  darken1: '#8e24aa',
  darken2: '#7b1fa2',
  darken3: '#6a1b9a',
  darken4: '#4a148c',
  accent1: '#ea80fc',
  accent2: '#e040fb',
  accent3: '#d500f9',
  accent4: '#aa00ff'
});
var deepPurple = Object.freeze({
  base: '#673ab7',
  lighten5: '#ede7f6',
  lighten4: '#d1c4e9',
  lighten3: '#b39ddb',
  lighten2: '#9575cd',
  lighten1: '#7e57c2',
  darken1: '#5e35b1',
  darken2: '#512da8',
  darken3: '#4527a0',
  darken4: '#311b92',
  accent1: '#b388ff',
  accent2: '#7c4dff',
  accent3: '#651fff',
  accent4: '#6200ea'
});
var indigo = Object.freeze({
  base: '#3f51b5',
  lighten5: '#e8eaf6',
  lighten4: '#c5cae9',
  lighten3: '#9fa8da',
  lighten2: '#7986cb',
  lighten1: '#5c6bc0',
  darken1: '#3949ab',
  darken2: '#303f9f',
  darken3: '#283593',
  darken4: '#1a237e',
  accent1: '#8c9eff',
  accent2: '#536dfe',
  accent3: '#3d5afe',
  accent4: '#304ffe'
});
var blue = Object.freeze({
  base: '#2196f3',
  lighten5: '#e3f2fd',
  lighten4: '#bbdefb',
  lighten3: '#90caf9',
  lighten2: '#64b5f6',
  lighten1: '#42a5f5',
  darken1: '#1e88e5',
  darken2: '#1976d2',
  darken3: '#1565c0',
  darken4: '#0d47a1',
  accent1: '#82b1ff',
  accent2: '#448aff',
  accent3: '#2979ff',
  accent4: '#2962ff'
});
var lightBlue = Object.freeze({
  base: '#03a9f4',
  lighten5: '#e1f5fe',
  lighten4: '#b3e5fc',
  lighten3: '#81d4fa',
  lighten2: '#4fc3f7',
  lighten1: '#29b6f6',
  darken1: '#039be5',
  darken2: '#0288d1',
  darken3: '#0277bd',
  darken4: '#01579b',
  accent1: '#80d8ff',
  accent2: '#40c4ff',
  accent3: '#00b0ff',
  accent4: '#0091ea'
});
var cyan = Object.freeze({
  base: '#00bcd4',
  lighten5: '#e0f7fa',
  lighten4: '#b2ebf2',
  lighten3: '#80deea',
  lighten2: '#4dd0e1',
  lighten1: '#26c6da',
  darken1: '#00acc1',
  darken2: '#0097a7',
  darken3: '#00838f',
  darken4: '#006064',
  accent1: '#84ffff',
  accent2: '#18ffff',
  accent3: '#00e5ff',
  accent4: '#00b8d4'
});
var teal = Object.freeze({
  base: '#009688',
  lighten5: '#e0f2f1',
  lighten4: '#b2dfdb',
  lighten3: '#80cbc4',
  lighten2: '#4db6ac',
  lighten1: '#26a69a',
  darken1: '#00897b',
  darken2: '#00796b',
  darken3: '#00695c',
  darken4: '#004d40',
  accent1: '#a7ffeb',
  accent2: '#64ffda',
  accent3: '#1de9b6',
  accent4: '#00bfa5'
});
var green = Object.freeze({
  base: '#4caf50',
  lighten5: '#e8f5e9',
  lighten4: '#c8e6c9',
  lighten3: '#a5d6a7',
  lighten2: '#81c784',
  lighten1: '#66bb6a',
  darken1: '#43a047',
  darken2: '#388e3c',
  darken3: '#2e7d32',
  darken4: '#1b5e20',
  accent1: '#b9f6ca',
  accent2: '#69f0ae',
  accent3: '#00e676',
  accent4: '#00c853'
});
var lightGreen = Object.freeze({
  base: '#8bc34a',
  lighten5: '#f1f8e9',
  lighten4: '#dcedc8',
  lighten3: '#c5e1a5',
  lighten2: '#aed581',
  lighten1: '#9ccc65',
  darken1: '#7cb342',
  darken2: '#689f38',
  darken3: '#558b2f',
  darken4: '#33691e',
  accent1: '#ccff90',
  accent2: '#b2ff59',
  accent3: '#76ff03',
  accent4: '#64dd17'
});
var lime = Object.freeze({
  base: '#cddc39',
  lighten5: '#f9fbe7',
  lighten4: '#f0f4c3',
  lighten3: '#e6ee9c',
  lighten2: '#dce775',
  lighten1: '#d4e157',
  darken1: '#c0ca33',
  darken2: '#afb42b',
  darken3: '#9e9d24',
  darken4: '#827717',
  accent1: '#f4ff81',
  accent2: '#eeff41',
  accent3: '#c6ff00',
  accent4: '#aeea00'
});
var yellow = Object.freeze({
  base: '#ffeb3b',
  lighten5: '#fffde7',
  lighten4: '#fff9c4',
  lighten3: '#fff59d',
  lighten2: '#fff176',
  lighten1: '#ffee58',
  darken1: '#fdd835',
  darken2: '#fbc02d',
  darken3: '#f9a825',
  darken4: '#f57f17',
  accent1: '#ffff8d',
  accent2: '#ffff00',
  accent3: '#ffea00',
  accent4: '#ffd600'
});
var amber = Object.freeze({
  base: '#ffc107',
  lighten5: '#fff8e1',
  lighten4: '#ffecb3',
  lighten3: '#ffe082',
  lighten2: '#ffd54f',
  lighten1: '#ffca28',
  darken1: '#ffb300',
  darken2: '#ffa000',
  darken3: '#ff8f00',
  darken4: '#ff6f00',
  accent1: '#ffe57f',
  accent2: '#ffd740',
  accent3: '#ffc400',
  accent4: '#ffab00'
});
var orange = Object.freeze({
  base: '#ff9800',
  lighten5: '#fff3e0',
  lighten4: '#ffe0b2',
  lighten3: '#ffcc80',
  lighten2: '#ffb74d',
  lighten1: '#ffa726',
  darken1: '#fb8c00',
  darken2: '#f57c00',
  darken3: '#ef6c00',
  darken4: '#e65100',
  accent1: '#ffd180',
  accent2: '#ffab40',
  accent3: '#ff9100',
  accent4: '#ff6d00'
});
var deepOrange = Object.freeze({
  base: '#ff5722',
  lighten5: '#fbe9e7',
  lighten4: '#ffccbc',
  lighten3: '#ffab91',
  lighten2: '#ff8a65',
  lighten1: '#ff7043',
  darken1: '#f4511e',
  darken2: '#e64a19',
  darken3: '#d84315',
  darken4: '#bf360c',
  accent1: '#ff9e80',
  accent2: '#ff6e40',
  accent3: '#ff3d00',
  accent4: '#dd2c00'
});
var brown = Object.freeze({
  base: '#795548',
  lighten5: '#efebe9',
  lighten4: '#d7ccc8',
  lighten3: '#bcaaa4',
  lighten2: '#a1887f',
  lighten1: '#8d6e63',
  darken1: '#6d4c41',
  darken2: '#5d4037',
  darken3: '#4e342e',
  darken4: '#3e2723'
});
var blueGrey = Object.freeze({
  base: '#607d8b',
  lighten5: '#eceff1',
  lighten4: '#cfd8dc',
  lighten3: '#b0bec5',
  lighten2: '#90a4ae',
  lighten1: '#78909c',
  darken1: '#546e7a',
  darken2: '#455a64',
  darken3: '#37474f',
  darken4: '#263238'
});
var grey = Object.freeze({
  base: '#9e9e9e',
  lighten5: '#fafafa',
  lighten4: '#f5f5f5',
  lighten3: '#eeeeee',
  lighten2: '#e0e0e0',
  lighten1: '#bdbdbd',
  darken1: '#757575',
  darken2: '#616161',
  darken3: '#424242',
  darken4: '#212121'
});
var shades = Object.freeze({
  black: '#000000',
  white: '#ffffff',
  transparent: 'transparent'
});
/* harmony default export */ var colors = (Object.freeze({
  red: red,
  pink: pink,
  purple: purple,
  deepPurple: deepPurple,
  indigo: indigo,
  blue: blue,
  lightBlue: lightBlue,
  cyan: cyan,
  teal: teal,
  green: green,
  lightGreen: lightGreen,
  lime: lime,
  yellow: yellow,
  amber: amber,
  orange: orange,
  deepOrange: deepOrange,
  brown: brown,
  blueGrey: blueGrey,
  grey: grey,
  shades: shades
}));
// EXTERNAL MODULE: ./node_modules/vuetify/lib/util/mixins.js
var mixins = __webpack_require__("58df");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/mixins/themeable/index.js
var themeable = __webpack_require__("7560");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VColorPicker/VColorPickerSwatches.js



// Styles
 // Components

 // Helpers








function parseDefaultColors(colors) {
  return Object.keys(colors).map(function (key) {
    var color = colors[key];
    return color.base ? [color.base, color.darken4, color.darken3, color.darken2, color.darken1, color.lighten1, color.lighten2, color.lighten3, color.lighten4, color.lighten5] : [color.black, color.white, color.transparent];
  });
}

var white = fromHex('#FFFFFF').rgba;
var black = fromHex('#000000').rgba;
/* harmony default export */ var VColorPicker_VColorPickerSwatches = (Object(mixins["a" /* default */])(themeable["a" /* default */]).extend({
  name: 'v-color-picker-swatches',
  props: {
    swatches: {
      type: Array,
      default: function _default() {
        return parseDefaultColors(colors);
      }
    },
    color: Object,
    maxWidth: [Number, String],
    maxHeight: [Number, String]
  },
  methods: {
    genColor: function genColor(color) {
      var _this = this;

      var content = this.$createElement('div', {
        style: {
          background: color
        }
      }, [Object(helpers["j" /* deepEqual */])(this.color, parseColor(color, null)) && this.$createElement(VIcon["a" /* default */], {
        props: {
          small: true,
          dark: Object(colorUtils["l" /* contrastRatio */])(this.color.rgba, white) > 2 && this.color.alpha > 0.5,
          light: Object(colorUtils["l" /* contrastRatio */])(this.color.rgba, black) > 2 && this.color.alpha > 0.5
        }
      }, '$success')]);
      return this.$createElement('div', {
        staticClass: 'v-color-picker__color',
        on: {
          // TODO: Less hacky way of catching transparent
          click: function click() {
            return _this.$emit('update:color', fromHex(color === 'transparent' ? '#00000000' : color));
          }
        }
      }, [content]);
    },
    genSwatches: function genSwatches() {
      var _this2 = this;

      return this.swatches.map(function (swatch) {
        var colors = swatch.map(_this2.genColor);
        return _this2.$createElement('div', {
          staticClass: 'v-color-picker__swatch'
        }, colors);
      });
    }
  },
  render: function render(h) {
    return h('div', {
      staticClass: 'v-color-picker__swatches',
      style: {
        maxWidth: Object(helpers["g" /* convertToUnit */])(this.maxWidth),
        maxHeight: Object(helpers["g" /* convertToUnit */])(this.maxHeight)
      }
    }, [this.$createElement('div', this.genSwatches())]);
  }
}));
// EXTERNAL MODULE: ./node_modules/vuetify/lib/mixins/elevatable/index.js
var elevatable = __webpack_require__("c995");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VColorPicker/VColorPicker.js







// Styles
 // Components





 // Helpers



 // Mixins



/* harmony default export */ var VColorPicker_VColorPicker = (Object(mixins["a" /* default */])(elevatable["a" /* default */], themeable["a" /* default */]).extend({
  name: 'v-color-picker',
  props: {
    canvasHeight: {
      type: [String, Number],
      default: 150
    },
    disabled: Boolean,
    dotSize: {
      type: [Number, String],
      default: 10
    },
    flat: Boolean,
    hideCanvas: Boolean,
    hideSliders: Boolean,
    hideInputs: Boolean,
    hideModeSwitch: Boolean,
    mode: {
      type: String,
      default: 'rgba',
      validator: function validator(v) {
        return Object.keys(modes).includes(v);
      }
    },
    showSwatches: Boolean,
    swatches: Array,
    swatchesMaxHeight: {
      type: [Number, String],
      default: 150
    },
    value: {
      type: [Object, String]
    },
    width: {
      type: [Number, String],
      default: 300
    }
  },
  data: function data() {
    return {
      internalValue: fromRGBA({
        r: 255,
        g: 0,
        b: 0,
        a: 1
      })
    };
  },
  computed: {
    hideAlpha: function hideAlpha() {
      if (!this.value) return false;
      return !hasAlpha(this.value);
    }
  },
  watch: {
    value: {
      handler: function handler(color) {
        this.updateColor(parseColor(color, this.internalValue));
      },
      immediate: true
    }
  },
  methods: {
    updateColor: function updateColor(color) {
      this.internalValue = color;
      var value = extractColor(this.internalValue, this.value);

      if (!Object(helpers["j" /* deepEqual */])(value, this.value)) {
        this.$emit('input', value);
        this.$emit('update:color', this.internalValue);
      }
    },
    genCanvas: function genCanvas() {
      return this.$createElement(VColorPicker_VColorPickerCanvas, {
        props: {
          color: this.internalValue,
          disabled: this.disabled,
          dotSize: this.dotSize,
          width: this.width,
          height: this.canvasHeight
        },
        on: {
          'update:color': this.updateColor
        }
      });
    },
    genControls: function genControls() {
      return this.$createElement('div', {
        staticClass: 'v-color-picker__controls'
      }, [!this.hideSliders && this.genPreview(), !this.hideInputs && this.genEdit()]);
    },
    genEdit: function genEdit() {
      var _this = this;

      return this.$createElement(VColorPicker_VColorPickerEdit, {
        props: {
          color: this.internalValue,
          disabled: this.disabled,
          hideAlpha: this.hideAlpha,
          hideModeSwitch: this.hideModeSwitch,
          mode: this.mode
        },
        on: {
          'update:color': this.updateColor,
          'update:mode': function updateMode(v) {
            return _this.$emit('update:mode', v);
          }
        }
      });
    },
    genPreview: function genPreview() {
      return this.$createElement(VColorPicker_VColorPickerPreview, {
        props: {
          color: this.internalValue,
          disabled: this.disabled,
          hideAlpha: this.hideAlpha
        },
        on: {
          'update:color': this.updateColor
        }
      });
    },
    genSwatches: function genSwatches() {
      return this.$createElement(VColorPicker_VColorPickerSwatches, {
        props: {
          dark: this.dark,
          light: this.light,
          swatches: this.swatches,
          color: this.internalValue,
          maxHeight: this.swatchesMaxHeight
        },
        on: {
          'update:color': this.updateColor
        }
      });
    }
  },
  render: function render(h) {
    return h(VSheet["a" /* default */], {
      staticClass: 'v-color-picker',
      class: Object(objectSpread2["a" /* default */])(Object(objectSpread2["a" /* default */])({
        'v-color-picker--flat': this.flat
      }, this.themeClasses), this.elevationClasses),
      props: {
        maxWidth: this.width
      }
    }, [!this.hideCanvas && this.genCanvas(), (!this.hideSliders || !this.hideInputs) && this.genControls(), this.showSwatches && this.genSwatches()]);
  }
}));
// EXTERNAL MODULE: ./node_modules/vuetify/lib/components/VMenu/VMenu.js
var VMenu = __webpack_require__("e449");

// CONCATENATED MODULE: ./src/components/input/color/PpInputColor.vue







/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  color_PpInputColorvue_type_script_lang_js_,
  PpInputColorvue_type_template_id_0d1c1272_scoped_true_render,
  staticRenderFns,
  false,
  null,
  "0d1c1272",
  null
  
)

/* harmony default export */ var PpInputColor = __webpack_exports__["default"] = (component.exports);

/* vuetify-loader */



installComponents_default()(component, {VColorPicker: VColorPicker_VColorPicker,VMenu: VMenu["a" /* default */]})


/***/ }),

/***/ "b4a1":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("107f");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("0a5afb21", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "b4c7":
/***/ (function(module, exports, __webpack_require__) {

var startOfWeek = __webpack_require__("c7ce")

/**
 * @category ISO Week Helpers
 * @summary Return the start of an ISO week for the given date.
 *
 * @description
 * Return the start of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of an ISO week
 *
 * @example
 * // The start of an ISO week for 2 September 2014 11:55:00:
 * var result = startOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfISOWeek (dirtyDate) {
  return startOfWeek(dirtyDate, {weekStartsOn: 1})
}

module.exports = startOfISOWeek


/***/ }),

/***/ "b4f0":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.theme--light.v-messages{color:var(--pp-text-secondary,#2b2b2b)}.theme--dark.v-messages{color:hsla(0,0%,100%,.7)}.v-messages{flex:1 1 auto;font-size:12px;min-height:8px;min-width:1px;position:relative}.v-application--is-ltr .v-messages{text-align:left}.v-application--is-rtl .v-messages{text-align:right}.v-messages__message{line-height:12px;word-break:break-word;overflow-wrap:break-word;word-wrap:break-word;-webkit-hyphens:auto;-ms-hyphens:auto;hyphens:auto}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "b532":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.i, "@import url(https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css);"]);
exports.push([module.i, "@import url(https://cdn-prd.patientpop.com/pp-icon-font/v1.6.0/pp-icon-font.css);"]);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}li[data-v-6a452a5c]{list-style:none}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "b575":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var getOwnPropertyDescriptor = __webpack_require__("06cf").f;
var macrotask = __webpack_require__("2cf4").set;
var IS_IOS = __webpack_require__("1cdc");
var IS_WEBOS_WEBKIT = __webpack_require__("a4b4");
var IS_NODE = __webpack_require__("605d");

var MutationObserver = global.MutationObserver || global.WebKitMutationObserver;
var document = global.document;
var process = global.process;
var Promise = global.Promise;
// Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`
var queueMicrotaskDescriptor = getOwnPropertyDescriptor(global, 'queueMicrotask');
var queueMicrotask = queueMicrotaskDescriptor && queueMicrotaskDescriptor.value;

var flush, head, last, notify, toggle, node, promise, then;

// modern engines have queueMicrotask method
if (!queueMicrotask) {
  flush = function () {
    var parent, fn;
    if (IS_NODE && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (error) {
        if (head) notify();
        else last = undefined;
        throw error;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
  // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
  if (!IS_IOS && !IS_NODE && !IS_WEBOS_WEBKIT && MutationObserver && document) {
    toggle = true;
    node = document.createTextNode('');
    new MutationObserver(flush).observe(node, { characterData: true });
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    promise = Promise.resolve(undefined);
    then = promise.then;
    notify = function () {
      then.call(promise, flush);
    };
  // Node.js without promises
  } else if (IS_NODE) {
    notify = function () {
      process.nextTick(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }
}

module.exports = queueMicrotask || function (fn) {
  var task = { fn: fn, next: undefined };
  if (last) last.next = task;
  if (!head) {
    head = task;
    notify();
  } last = task;
};


/***/ }),

/***/ "b60f":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("c8d5")

/**
 * @category Day Helpers
 * @summary Get the day of the month of the given date.
 *
 * @description
 * Get the day of the month of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the day of month
 *
 * @example
 * // Which day of the month is 29 February 2012?
 * var result = getDate(new Date(2012, 1, 29))
 * //=> 29
 */
function getDate (dirtyDate) {
  var date = parse(dirtyDate)
  var dayOfMonth = date.getDate()
  return dayOfMonth
}

module.exports = getDate


/***/ }),

/***/ "b622":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var shared = __webpack_require__("5692");
var has = __webpack_require__("5135");
var uid = __webpack_require__("90e3");
var NATIVE_SYMBOL = __webpack_require__("4930");
var USE_SYMBOL_AS_UID = __webpack_require__("fdbf");

var WellKnownSymbolsStore = shared('wks');
var Symbol = global.Symbol;
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol : Symbol && Symbol.withoutSetter || uid;

module.exports = function (name) {
  if (!has(WellKnownSymbolsStore, name)) {
    if (NATIVE_SYMBOL && has(Symbol, name)) WellKnownSymbolsStore[name] = Symbol[name];
    else WellKnownSymbolsStore[name] = createWellKnownSymbol('Symbol.' + name);
  } return WellKnownSymbolsStore[name];
};


/***/ }),

/***/ "b626":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.i, "@import url(https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css);"]);
exports.push([module.i, "@import url(https://cdn-prd.patientpop.com/pp-icon-font/v1.6.0/pp-icon-font.css);"]);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.months-text[data-v-92c47fd6]{color:#2b2b2b;font-size:1.0714285714rem;font-weight:700;line-height:2rem;padding:0 .5714285714rem;text-align:center}@media(max-width:670px){.months-text[data-v-92c47fd6]{padding:0 .8571428571rem}}.months-text .left-arrow-icon[data-v-92c47fd6]{float:left;left:2px}.months-text .right-arrow-icon[data-v-92c47fd6]{float:right;right:5px}.months-text .left-arrow-icon[data-v-92c47fd6],.months-text .right-arrow-icon[data-v-92c47fd6]{background-color:#f6f6f6;border-radius:100%;color:#2b2b2b;cursor:pointer;font-size:.7142857143rem;height:1.7857142857rem;padding:0;position:relative;transform:none;width:1.7857142857rem}.months-text .left-arrow-icon[data-v-92c47fd6]:hover,.months-text .right-arrow-icon[data-v-92c47fd6]:hover{background-color:#d6d6d6}.calendar-weeks[data-v-92c47fd6]{margin:0;padding:10px 0;padding-left:0;text-align:center}.calendar-weeks li[data-v-92c47fd6]{color:#2b2b2b;display:inline-block;font-size:10px;height:2.5rem;line-height:2.5rem;text-align:center;width:2.5rem}.calendar-days[data-v-92c47fd6]{margin:0 0 5px;padding:0;text-align:center}.calendar-days[data-v-92c47fd6]:last-child{margin-bottom:0}.calendar-days--day[data-v-92c47fd6]{color:#2b2b2b;cursor:pointer;display:inline-block;height:2.5rem;line-height:2.5rem;position:relative;text-align:center;width:2.5rem}.calendar-days--day:last-child.calendar-days-selected.first-date-selected[data-v-92c47fd6]:before{border-radius:50% 0 0 50%;left:0}.calendar-days--day:first-child.calendar-days-selected.second-date-selected[data-v-92c47fd6]:before{border-radius:0 50% 50% 0;right:0}.calendar-days--day.calendar-days-in-range[data-v-92c47fd6]{background:#f6f6f6;color:#079cb2}.calendar-days--day.calendar-days-in-range[data-v-92c47fd6]:last-of-type{border-bottom-right-radius:100%;border-top-right-radius:100%}.calendar-days--day.calendar-days-in-range[data-v-92c47fd6]:first-of-type{border-bottom-left-radius:100%;border-top-left-radius:100%}.calendar-days--day.calendar-days-selected[data-v-92c47fd6],.calendar-days--day[data-v-92c47fd6]:hover{background:#079cb2;border-radius:100%;color:#fff}.calendar-days--day.calendar-days-selected[data-v-92c47fd6]:before{background:#f6f6f6;content:\" \";height:2.5rem;position:absolute;width:2.5rem;z-index:-1}.calendar-days--day.calendar-days-selected.same-end-date[data-v-92c47fd6]:before{width:0}.calendar-days--disabled[data-v-92c47fd6]{color:#9a9a9a;pointer-events:none}.calendar-days--disabled[data-v-92c47fd6]:before{content:\" \"}.calendar-month-left li.calendar-days-selected.first-date-selected[data-v-92c47fd6]:before{left:50%}.calendar-month-left li.calendar-days-selected.second-date-selected[data-v-92c47fd6]:before,.calendar-month-right li.calendar-days-selected.second-date-selected[data-v-92c47fd6]:before{right:50%}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "b64b":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var toObject = __webpack_require__("7b0b");
var nativeKeys = __webpack_require__("df75");
var fails = __webpack_require__("d039");

var FAILS_ON_PRIMITIVES = fails(function () { nativeKeys(1); });

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES }, {
  keys: function keys(it) {
    return nativeKeys(toObject(it));
  }
});


/***/ }),

/***/ "b659":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("2096");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("26f30a3f", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "b680":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var toInteger = __webpack_require__("a691");
var thisNumberValue = __webpack_require__("408a");
var repeat = __webpack_require__("1148");
var fails = __webpack_require__("d039");

var nativeToFixed = 1.0.toFixed;
var floor = Math.floor;

var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};

var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

var FORCED = nativeToFixed && (
  0.00008.toFixed(3) !== '0.000' ||
  0.9.toFixed(0) !== '1' ||
  1.255.toFixed(2) !== '1.25' ||
  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
) || !fails(function () {
  // V8 ~ Android 4.3-
  nativeToFixed.call({});
});

// `Number.prototype.toFixed` method
// https://tc39.es/ecma262/#sec-number.prototype.tofixed
$({ target: 'Number', proto: true, forced: FORCED }, {
  // eslint-disable-next-line max-statements
  toFixed: function toFixed(fractionDigits) {
    var number = thisNumberValue(this);
    var fractDigits = toInteger(fractionDigits);
    var data = [0, 0, 0, 0, 0, 0];
    var sign = '';
    var result = '0';
    var e, z, j, k;

    var multiply = function (n, c) {
      var index = -1;
      var c2 = c;
      while (++index < 6) {
        c2 += n * data[index];
        data[index] = c2 % 1e7;
        c2 = floor(c2 / 1e7);
      }
    };

    var divide = function (n) {
      var index = 6;
      var c = 0;
      while (--index >= 0) {
        c += data[index];
        data[index] = floor(c / n);
        c = (c % n) * 1e7;
      }
    };

    var dataToString = function () {
      var index = 6;
      var s = '';
      while (--index >= 0) {
        if (s !== '' || index === 0 || data[index] !== 0) {
          var t = String(data[index]);
          s = s === '' ? t : s + repeat.call('0', 7 - t.length) + t;
        }
      } return s;
    };

    if (fractDigits < 0 || fractDigits > 20) throw RangeError('Incorrect fraction digits');
    // eslint-disable-next-line no-self-compare
    if (number != number) return 'NaN';
    if (number <= -1e21 || number >= 1e21) return String(number);
    if (number < 0) {
      sign = '-';
      number = -number;
    }
    if (number > 1e-21) {
      e = log(number * pow(2, 69, 1)) - 69;
      z = e < 0 ? number * pow(2, -e, 1) : number / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(0, z);
        j = fractDigits;
        while (j >= 7) {
          multiply(1e7, 0);
          j -= 7;
        }
        multiply(pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(1 << 23);
          j -= 23;
        }
        divide(1 << j);
        multiply(1, 1);
        divide(2);
        result = dataToString();
      } else {
        multiply(0, z);
        multiply(1 << -e, 0);
        result = dataToString() + repeat.call('0', fractDigits);
      }
    }
    if (fractDigits > 0) {
      k = result.length;
      result = sign + (k <= fractDigits
        ? '0.' + repeat.call('0', fractDigits - k) + result
        : result.slice(0, k - fractDigits) + '.' + result.slice(k - fractDigits));
    } else {
      result = sign + result;
    } return result;
  }
});


/***/ }),

/***/ "b688":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.i, "@import url(https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css);"]);
exports.push([module.i, "@import url(https://cdn-prd.patientpop.com/pp-icon-font/v1.6.0/pp-icon-font.css);"]);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.v-input[data-v-25e1e7cd]  .v-input--switch__thumb{color:#fff!important}.v-input--switch.v-input--is-dirty.v-input--is-disabled[data-v-25e1e7cd]  .v-input--switch__track{background-color:var(--pp-switch-disabled-color,#e6f5f7)}.v-input--switch.v-input--is-disabled[data-v-25e1e7cd]  .v-input--switch__track{background-color:var(--pp-switch-disabled-color,#9a9a9a)}.v-input.pp-input-switch[data-v-25e1e7cd]{--pp-switch-track-x:0}.v-input.pp-input-switch[data-v-25e1e7cd] .v-input--switch__thumb{left:4px}.v-input.pp-input-switch[data-v-25e1e7cd] .v-input--switch__track{left:0}.v-input.pp-input-switch.v-input.pp-input-switch--small[data-v-25e1e7cd]{--pp-switch-track-height:20px;--pp-switch-track-width:40px;--pp-switch-thumb-top:calc(50% - 8px);--pp-switch-thumb-width:16px;--pp-switch-thumb-height:16px}.v-input.pp-input-switch.v-input.pp-input-switch--small[data-v-25e1e7cd] .v-input--switch__thumb{left:2px}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "b6b0":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.theme--light.v-card{background-color:var(--cards-color,#fff);color:var(--pp-text-primary,#2b2b2b)}.theme--light.v-card .v-card__subtitle,.theme--light.v-card>.v-card__text{color:var(--pp-text-secondary,#2b2b2b)}.theme--dark.v-card{background-color:#1e1e1e;color:var(--pp-primary-button-text-color,#004852)}.theme--dark.v-card .v-card__subtitle,.theme--dark.v-card>.v-card__text{color:hsla(0,0%,100%,.7)}.v-sheet.v-card{border-radius:5px}.v-sheet.v-card:not(.v-sheet--outlined){box-shadow:0 3px 1px -2px transparent,0 2px 2px 0 transparent,0 1px 5px 0 rgba(0,0,0,.12)}.v-sheet.v-card.v-sheet--shaped{border-radius:20px 5px}.v-card{border-width:thin;display:block;max-width:100%;outline:none;text-decoration:none;transition-property:box-shadow,opacity;overflow-wrap:break-word;position:relative;white-space:normal}.v-card>.v-card__progress+:not(.v-btn):not(.v-chip),.v-card>:first-child:not(.v-btn):not(.v-chip){border-top-left-radius:inherit;border-top-right-radius:inherit}.v-card>:last-child:not(.v-btn):not(.v-chip){border-bottom-left-radius:inherit;border-bottom-right-radius:inherit}.v-card__progress{top:0;left:0;right:0;overflow:hidden}.v-card__subtitle+.v-card__text{padding-top:0}.v-card__subtitle,.v-card__text{font-size:1rem;font-weight:400;line-height:1.5714285714rem;letter-spacing:normal}.v-card__subtitle,.v-card__text,.v-card__title{padding:16px}.v-card__title{align-items:center;display:flex;flex-wrap:wrap;font-size:1.7142857143rem;font-weight:700;letter-spacing:normal;line-height:2.2857142857rem;word-break:break-word}.v-card__title+.v-card__subtitle,.v-card__title+.v-card__text{padding-top:0}.v-card__title+.v-card__subtitle{margin-top:-16px}.v-card__text{width:100%}.v-card__actions{align-items:center;display:flex;padding:8px}.v-card__actions>.v-btn.v-btn{padding:0 14px}.v-application--is-ltr .v-card__actions>.v-btn.v-btn+.v-btn{margin-left:8px}.v-application--is-ltr .v-card__actions>.v-btn.v-btn .v-icon--left{margin-left:4px}.v-application--is-ltr .v-card__actions>.v-btn.v-btn .v-icon--right{margin-right:4px}.v-application--is-rtl .v-card__actions>.v-btn.v-btn+.v-btn{margin-right:8px}.v-application--is-rtl .v-card__actions>.v-btn.v-btn .v-icon--left{margin-right:4px}.v-application--is-rtl .v-card__actions>.v-btn.v-btn .v-icon--right{margin-left:4px}.v-card--flat{box-shadow:0 0 0 0 transparent,0 0 0 0 transparent,0 0 0 0 rgba(0,0,0,.12)!important}.v-sheet.v-card--hover{cursor:pointer;transition:box-shadow .4s cubic-bezier(.25,.8,.25,1)}.v-sheet.v-card--hover:focus,.v-sheet.v-card--hover:hover{box-shadow:0 5px 5px -3px transparent,0 8px 10px 1px transparent,0 3px 14px 2px rgba(0,0,0,.12)}.v-card--link,.v-card--link .v-chip{cursor:pointer}.v-card--link:focus:before{opacity:.08}.v-card--link:before{background:currentColor;bottom:0;content:\"\";left:0;opacity:0;pointer-events:none;position:absolute;right:0;top:0;transition:opacity .2s}.v-card--disabled{pointer-events:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.v-card--disabled>:not(.v-card__progress){opacity:.6;transition:inherit}.v-card--loading{overflow:hidden}.v-card--raised{box-shadow:0 5px 5px -3px transparent,0 8px 10px 1px transparent,0 3px 14px 2px rgba(0,0,0,.12)}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "b71b":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("1883");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("645622b6", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "b727":
/***/ (function(module, exports, __webpack_require__) {

var bind = __webpack_require__("0366");
var IndexedObject = __webpack_require__("44ad");
var toObject = __webpack_require__("7b0b");
var toLength = __webpack_require__("50c4");
var arraySpeciesCreate = __webpack_require__("65f0");

var push = [].push;

// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterOut }` methods implementation
var createMethod = function (TYPE) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var IS_FILTER_OUT = TYPE == 7;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  return function ($this, callbackfn, that, specificCreate) {
    var O = toObject($this);
    var self = IndexedObject(O);
    var boundFunction = bind(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var create = specificCreate || arraySpeciesCreate;
    var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_OUT ? create($this, 0) : undefined;
    var value, result;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (TYPE) {
        if (IS_MAP) target[index] = result; // map
        else if (result) switch (TYPE) {
          case 3: return true;              // some
          case 5: return value;             // find
          case 6: return index;             // findIndex
          case 2: push.call(target, value); // filter
        } else switch (TYPE) {
          case 4: return false;             // every
          case 7: push.call(target, value); // filterOut
        }
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};

module.exports = {
  // `Array.prototype.forEach` method
  // https://tc39.es/ecma262/#sec-array.prototype.foreach
  forEach: createMethod(0),
  // `Array.prototype.map` method
  // https://tc39.es/ecma262/#sec-array.prototype.map
  map: createMethod(1),
  // `Array.prototype.filter` method
  // https://tc39.es/ecma262/#sec-array.prototype.filter
  filter: createMethod(2),
  // `Array.prototype.some` method
  // https://tc39.es/ecma262/#sec-array.prototype.some
  some: createMethod(3),
  // `Array.prototype.every` method
  // https://tc39.es/ecma262/#sec-array.prototype.every
  every: createMethod(4),
  // `Array.prototype.find` method
  // https://tc39.es/ecma262/#sec-array.prototype.find
  find: createMethod(5),
  // `Array.prototype.findIndex` method
  // https://tc39.es/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod(6),
  // `Array.prototype.filterOut` method
  // https://github.com/tc39/proposal-array-filtering
  filterOut: createMethod(7)
};


/***/ }),

/***/ "b78a":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("c8d5")
var addDays = __webpack_require__("8946")

/**
 * @category Weekday Helpers
 * @summary Set the day of the week to the given date.
 *
 * @description
 * Set the day of the week to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} day - the day of the week of the new date
 * @param {Object} [options] - the object with options
 * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the new date with the day of the week setted
 *
 * @example
 * // Set Sunday to 1 September 2014:
 * var result = setDay(new Date(2014, 8, 1), 0)
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If week starts with Monday, set Sunday to 1 September 2014:
 * var result = setDay(new Date(2014, 8, 1), 0, {weekStartsOn: 1})
 * //=> Sun Sep 07 2014 00:00:00
 */
function setDay (dirtyDate, dirtyDay, dirtyOptions) {
  var weekStartsOn = dirtyOptions ? (Number(dirtyOptions.weekStartsOn) || 0) : 0
  var date = parse(dirtyDate)
  var day = Number(dirtyDay)
  var currentDay = date.getDay()

  var remainder = day % 7
  var dayIndex = (remainder + 7) % 7

  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay
  return addDays(date, diff)
}

module.exports = setDay


/***/ }),

/***/ "b810":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _VDivider__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ce7e");


/* harmony default export */ __webpack_exports__["a"] = (_VDivider__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]);

/***/ }),

/***/ "b83e":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.theme--light.v-btn-toggle:not(.v-btn-toggle--group){background:var(--cards-color,#fff);color:var(--pp-text-primary,#2b2b2b)}.theme--light.v-btn-toggle:not(.v-btn-toggle--group) .v-btn.v-btn{border-color:#d6d6d6!important}.theme--light.v-btn-toggle:not(.v-btn-toggle--group) .v-btn.v-btn:focus:not(:active){border-color:var(--pp-disabled-button-color,#fff)}.theme--light.v-btn-toggle:not(.v-btn-toggle--group) .v-btn.v-btn .v-icon{color:#000}.theme--dark.v-btn-toggle:not(.v-btn-toggle--group){background:#1e1e1e;color:var(--pp-primary-button-text-color,#004852)}.theme--dark.v-btn-toggle:not(.v-btn-toggle--group) .v-btn.v-btn{border-color:hsla(0,0%,100%,.12)!important}.theme--dark.v-btn-toggle:not(.v-btn-toggle--group) .v-btn.v-btn:focus:not(:active){border-color:var(--pp-disabled-button-color,#fff)}.theme--dark.v-btn-toggle:not(.v-btn-toggle--group) .v-btn.v-btn .v-icon{color:#fff}.v-btn-toggle{border-radius:5px;display:inline-flex;max-width:100%}.v-btn-toggle>.v-btn.v-btn{border-radius:0;border-style:solid;border-width:thin;box-shadow:none;opacity:.8;padding:0 12px}.v-application--is-ltr .v-btn-toggle>.v-btn.v-btn:first-child{border-top-left-radius:inherit;border-bottom-left-radius:inherit}.v-application--is-ltr .v-btn-toggle>.v-btn.v-btn:last-child,.v-application--is-rtl .v-btn-toggle>.v-btn.v-btn:first-child{border-top-right-radius:inherit;border-bottom-right-radius:inherit}.v-application--is-rtl .v-btn-toggle>.v-btn.v-btn:last-child{border-top-left-radius:inherit;border-bottom-left-radius:inherit}.v-btn-toggle>.v-btn.v-btn--active{color:inherit;opacity:1}.v-btn-toggle>.v-btn.v-btn:after{display:none}.v-application--is-ltr .v-btn-toggle>.v-btn.v-btn:not(:first-child),.v-application--is-rtl .v-btn-toggle>.v-btn.v-btn:not(:last-child){border-left-width:0}.v-btn-toggle:not(.v-btn-toggle--dense) .v-btn.v-btn.v-size--default{height:48px;min-height:0;min-width:48px}.v-btn-toggle--borderless>.v-btn.v-btn{border-width:0}.v-btn-toggle--dense>.v-btn.v-btn{padding:0 8px}.v-btn-toggle--group{border-radius:0}.v-btn-toggle--group>.v-btn.v-btn{background-color:transparent!important;border-color:transparent;margin:4px;min-width:auto}.v-btn-toggle--rounded{border-radius:24px}.v-btn-toggle--shaped{border-radius:24px 5px}.v-btn-toggle--tile{border-radius:0}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "b848":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2909");
/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("58df");



function searchChildren(children) {
  var results = [];

  for (var index = 0; index < children.length; index++) {
    var child = children[index];

    if (child.isActive && child.isDependent) {
      results.push(child);
    } else {
      results.push.apply(results, Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(searchChildren(child.$children)));
    }
  }

  return results;
}
/* @vue/component */


/* harmony default export */ __webpack_exports__["a"] = (Object(_util_mixins__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])().extend({
  name: 'dependent',
  data: function data() {
    return {
      closeDependents: true,
      isActive: false,
      isDependent: true
    };
  },
  watch: {
    isActive: function isActive(val) {
      if (val) return;
      var openDependents = this.getOpenDependents();

      for (var index = 0; index < openDependents.length; index++) {
        openDependents[index].isActive = false;
      }
    }
  },
  methods: {
    getOpenDependents: function getOpenDependents() {
      if (this.closeDependents) return searchChildren(this.$children);
      return [];
    },
    getOpenDependentElements: function getOpenDependentElements() {
      var result = [];
      var openDependents = this.getOpenDependents();

      for (var index = 0; index < openDependents.length; index++) {
        result.push.apply(result, Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(openDependents[index].getClickableDependentElements()));
      }

      return result;
    },
    getClickableDependentElements: function getClickableDependentElements() {
      var result = [this.$el];
      if (this.$refs.content) result.push(this.$refs.content);
      if (this.overlay) result.push(this.overlay.$el);
      result.push.apply(result, Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(this.getOpenDependentElements()));
      return result;
    }
  }
}));

/***/ }),

/***/ "b85c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _createForOfIteratorHelper; });
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("a4d3");
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("e01a");
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("d28b");
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("e260");
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("d3b7");
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("3ca3");
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("ddb0");
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_esm_unsupportedIterableToArray__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("06c5");








function _createForOfIteratorHelper(o, allowArrayLike) {
  var it;

  if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
    if (Array.isArray(o) || (it = Object(_babel_runtime_helpers_esm_unsupportedIterableToArray__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;

      var F = function F() {};

      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function s() {
      it = o[Symbol.iterator]();
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it["return"] != null) it["return"]();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

/***/ }),

/***/ "b87f":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.i, "@import url(https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css);"]);
exports.push([module.i, "@import url(https://cdn-prd.patientpop.com/pp-icon-font/v1.6.0/pp-icon-font.css);"]);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.pp-loader[data-v-6a597e20]{left:50%;margin-left:calc(var(--pp-loader-size)/-2);margin-top:calc(var(--pp-loader-size)/-2);position:absolute;top:50%}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "b893":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4 19.9999V14.9999H5C5.265 14.9999 5.52 14.8939 5.707 14.7069L7 13.4139L9.293 15.7069C9.481 15.8949 9.735 15.9999 10 15.9999C10.019 15.9999 10.036 15.9989 10.056 15.9979C10.34 15.9819 10.603 15.8469 10.781 15.6239L14.083 11.4969L17.293 14.7069C17.684 15.0969 18.316 15.0969 18.707 14.7069L20.414 12.9999H19.998L19.997 19.9999H4Z\" fill=\"#D5EAFD\"></path><path d=\"M3 3H20V13.5L14 11L10 14L7 13L3 14V3Z\" fill=\"white\"></path><rect x=\"3\" y=\"3\" width=\"18\" height=\"18\" rx=\"2\" stroke=\"#079CB2\" stroke-width=\"2\"></rect><path d=\"M5 15.0007H4V13.0007H4.586L6.293 11.2937C6.684 10.9017 7.316 10.9017 7.707 11.2937L9.917 13.5027L13.219 9.37574C13.397 9.15274 13.66 9.01774 13.944 9.00174C14.229 8.98474 14.506 9.09274 14.707 9.29374L18 12.5857L19.293 11.2937C19.48 11.1057 19.735 11.0007 19.998 11.0007L20.0073 13.4017L18.707 14.7077C18.316 15.0977 17.684 15.0977 17.293 14.7077L14.083 11.4977L10.781 15.6247C10.603 15.8477 10.34 15.9827 10.056 15.9987C10.036 15.9997 10.019 16.0007 10 16.0007C9.735 16.0007 9.481 15.8957 9.293 15.7077L7 13.4147L5.707 14.7077C5.52 14.8947 5.265 15.0007 5 15.0007Z\" fill=\"#079CB2\"></path></svg>";

/***/ }),

/***/ "b8a7":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("c8d5")

/**
 * @category Year Helpers
 * @summary Return the last day of a year for the given date.
 *
 * @description
 * Return the last day of a year for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the last day of a year
 *
 * @example
 * // The last day of a year for 2 September 2014 11:55:00:
 * var result = lastDayOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Dec 31 2014 00:00:00
 */
function lastDayOfYear (dirtyDate) {
  var date = parse(dirtyDate)
  var year = date.getFullYear()
  date.setFullYear(year + 1, 0, 0)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = lastDayOfYear


/***/ }),

/***/ "b8a8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpMaskedData_vue_vue_type_style_index_0_id_1effbcc5_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("207f");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpMaskedData_vue_vue_type_style_index_0_id_1effbcc5_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpMaskedData_vue_vue_type_style_index_0_id_1effbcc5_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "b8d5":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M10.5 1C14.5107 1 17.9408 3.48534 19.3345 6.99991L13 7C11.8954 7 11 7.89543 11 9L11.0003 19.9871C10.8346 19.9956 10.6678 20 10.5 20C5.25329 20 1 15.7467 1 10.5C1 5.25329 5.25329 1 10.5 1Z\" fill=\"#DFE4E5\"></path><path d=\"M10.5 1C14.5107 1 17.9408 3.48534 19.3345 6.99991L13 7C11.8954 7 11 7.89543 11 9V8.999L8.55463 8.99951C8.51866 9.48807 8.5 9.98988 8.5 10.5C8.5 11.0105 8.51869 11.5126 8.55471 12.0015L11 12.001V14.001L8.8114 14.0018C8.98345 14.9178 9.22199 15.7459 9.51484 16.4414C9.78664 17.0869 10.0852 17.5659 10.3604 17.8424L10.5 17.977L10.6396 17.8424C10.757 17.7245 10.8787 17.5696 11.0007 17.3807L11.0003 19.9871C10.8346 19.9956 10.6678 20 10.5 20C5.25329 20 1 15.7467 1 10.5C1 5.25329 5.25329 1 10.5 1ZM6.78042 14.0013L3.8656 14.001C4.70635 15.591 6.10188 16.8422 7.79441 17.4971C7.35409 16.5363 7.00468 15.3439 6.78042 14.0013ZM6.54958 8.99993L3.14994 9.00041C3.05162 9.48495 3 9.98644 3 10.5C3 11.0139 3.05169 11.5157 3.15015 12.0006L6.54965 12.0011C6.51697 11.5121 6.5 11.0108 6.5 10.5C6.5 9.98958 6.51695 9.48855 6.54958 8.99993ZM7.79446 3.50271L7.73992 3.52418C6.07159 4.18483 4.69673 5.42666 3.86507 6.99995L6.78026 6.99974C7.0045 5.65667 7.35398 4.46391 7.79446 3.50271ZM10.5 3.023L10.3604 3.15756C10.0852 3.43406 9.78664 3.91308 9.51484 4.5586C9.22189 5.25437 8.98328 6.08277 8.81121 6.9992H12.1888C12.0167 6.08277 11.7781 5.25437 11.4852 4.5586C11.2134 3.91308 10.9148 3.43406 10.6396 3.15756L10.5 3.023ZM13.2056 3.50285L13.2402 3.57936C13.6644 4.52702 14.0014 5.69214 14.2197 6.99974L17.1349 6.99995C16.2942 5.40957 14.8985 4.15789 13.2056 3.50285Z\" fill=\"#1F3A3E\"></path><path d=\"M21 7C22.1046 7 23 7.89543 23 9V21C23 22.1046 22.1046 23 21 23H13C11.8954 23 11 22.1046 11 21V9C11 7.89543 11.8954 7 13 7H21ZM21 9H13V21H21V9Z\" fill=\"#1F3A3E\"></path><rect x=\"13\" y=\"9\" width=\"8\" height=\"12\" fill=\"white\"></rect><path d=\"M17.998 13C17.998 13.5523 17.5503 14 16.998 14C16.4458 14 15.998 13.5523 15.998 13C15.998 12.4477 16.4458 12 16.998 12C17.5503 12 17.998 12.4477 17.998 13Z\" fill=\"#1F3A3E\"></path><path d=\"M18.998 18V17C18.998 15.8954 18.1026 15 16.998 15C15.8935 15 14.998 15.8954 14.998 17V18H18.998Z\" fill=\"#1F3A3E\"></path></svg>";

/***/ }),

/***/ "b8f2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c662cfac-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/input/select/PpInputSelect.vue?vue&type=template&id=63ab36bc&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pp-input-select"},[(_vm.native)?[(_vm.label)?_c('pp-input-label',{attrs:{"label":_vm.label,"optional":_vm.optional,"input-id":_vm.nativeLabelId}}):_vm._e(),_c('div',{staticClass:"pp-input-select__native"},[_c('i',{staticClass:"pp-input-select__native__prepend-icon",class:_vm.prependIconClass}),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.$attrs.value),expression:"$attrs.value"}],staticClass:"py-2 pr-7 rounded pp-input-select__native__select",class:_vm.nativeSelectClass,attrs:{"id":_vm.nativeLabelId},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.$attrs, "value", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.inputSelect]}},[_c('option',{attrs:{"value":"","disabled":"","hidden":""}},[_vm._v(" "+_vm._s(_vm.placeholder)+" ")]),_vm._l((_vm.items),function(item){return _c('option',{key:item[_vm.itemValue],domProps:{"value":item[_vm.itemValue],"selected":item[_vm.itemValue]===_vm.$attrs.value},on:{"input":_vm.inputSelect}},[_vm._v(" "+_vm._s(_vm.displayItem(item))+" ")])})],2),_c('i',{staticClass:"pp-icon-caret--down select-caret pp-input-select__native__caret grey--text text--darken-4"})]),(_vm.errorMessages.length > 0)?_c('span',{staticClass:"error--text text-caption pp-input-checkbox__error-messages"},[_vm._l((_vm.errorMessages),function(errorMessage){return [_vm._v(" "+_vm._s(errorMessage)+" ")]})],2):_vm._e()]:[(_vm.label)?_c('pp-input-label',{attrs:{"label":_vm.label,"optional":_vm.optional,"input-id":_vm.selectId}}):_vm._e(),_c(_vm.selectComponent,_vm._g(_vm._b({ref:"select",tag:"component",staticClass:"pp-input-select__autocomplete",class:[
        _vm.loadingClass,
        _vm.whiteBg ? 'pp-input-select--white-bg' : ''
      ],attrs:{"clearable":_vm.clearable,"error-messages":_vm.errorMessages,"error":_vm.error,"items":_vm.items,"item-text":_vm.itemText,"item-value":_vm.itemValue,"placeholder":_vm.placeholder,"ripple":false,"no-data-text":_vm.noDataText,"outlined":"","filled":"","clear-icon":"mdi-close","hide-details":_vm.shouldHideDetails,"menu-props":Object.assign({}, _vm.menuProps,
        {contentClass: _vm.menuContentClass}),"disabled":_vm.isDisabled},scopedSlots:_vm._u([{key:"item",fn:function(slotProps){return [(_vm.itemsPrependIcon)?[_c('i',{staticClass:"mr-2 d-flex justify-start flex-shrink-1",class:("pp-icon-" + _vm.itemsPrependIcon)})]:_vm._e(),_vm._v(" "+_vm._s(_vm.displayItem(slotProps.item))+" "),(slotProps.item[_vm.itemValue] === _vm.$attrs.value)?[_c('i',{staticClass:"pp-icon-check mx-2 d-flex justify-end flex-grow-1"})]:_vm._e()]}},(_vm.prependIcon)?{key:"prepend-inner",fn:function(){return [_c('i',{staticClass:"mr-2",class:_vm.prependIconClass})]},proxy:true}:null,{key:"append",fn:function(){return [(_vm.loading)?_c('v-progress-circular',{attrs:{"size":16,"color":"warning","width":"1","indeterminate":""}}):_c('i',{staticClass:"pp-icon-caret--down select-caret mr-1 grey--text text--darken-4"})]},proxy:true},_vm._l((_vm.$slots),function(_,name){return {key:name,fn:function(){return [_vm._t(name)]},proxy:true}})],null,true)},'component',_vm.$attrs,false),_vm.$listeners))]],2)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/input/select/PpInputSelect.vue?vue&type=template&id=63ab36bc&scoped=true&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__("a15b");

// EXTERNAL MODULE: ./src/components/input/label/PpInputLabel.vue + 4 modules
var PpInputLabel = __webpack_require__("8e6c");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/components/VSelect/VSelect.js + 4 modules
var VSelect = __webpack_require__("b974");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/components/VAutocomplete/VAutocomplete.js
var VAutocomplete = __webpack_require__("c6a6");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/input/select/PpInputSelect.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var PpInputSelectvue_type_script_lang_js_ = ({
  name: 'PpInputSelect',
  components: {
    'pp-input-label': PpInputLabel["default"],
    'v-select': VSelect["a" /* default */],
    'v-autocomplete': VAutocomplete["a" /* default */]
  },
  props: {
    label: {
      type: String,
      default: ''
    },

    /**
     * If true, display optional label with a different color than the main label
     */
    optional: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: 'Select'
    },

    /**
     * The items for the dropdown, should be an array of objects
     * [{ text: 'The text shown to user', value: 'theValue' }]
     */
    items: {
      type: Array,
      required: true
    },
    errorMessages: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    error: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    },
    noDataText: {
      type: String,
      default: 'No Option Found'
    },
    itemText: {
      type: [String, Function],
      default: 'text'
    },
    itemValue: {
      type: String,
      default: 'value'
    },

    /**
     * As the user experience can be improved on mobile using the native select of the platform, we allow such option.
     */
    native: {
      type: Boolean,
      default: false
    },

    /**
     * If present will prepend the given icon to the left of the input text.
     * Pulls from pp-font icon.
     */
    prependIcon: {
      type: String,
      default: null
    },
    hideDetails: {
      type: [String, Boolean],
      default: false
    },

    /**
     * If present will prepend the given icon to the left of the list items.
     * Pulls from pp-font icon.
     */
    itemsPrependIcon: {
      type: String,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    whiteBg: {
      type: Boolean,
      default: false
    },
    menuClass: {
      type: String,
      default: ''
    },

    /**
     * Will disable the ability to type to lookup
     */
    disableLookup: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      selectId: null,
      selected: ''
    };
  },
  computed: {
    // if disableLookup is true, use v-select otherwise use v-autocomplete
    selectComponent: function selectComponent() {
      return this.disableLookup ? VSelect["a" /* default */] : VAutocomplete["a" /* default */];
    },
    // set dropdown to show below if its select
    menuProps: function menuProps() {
      return this.disableLookup ? {
        bottom: true,
        offsetY: true
      } : {};
    },
    nativeLabelId: function nativeLabelId() {
      return "select-".concat(this._uid);
    },
    nativeSelectClass: function nativeSelectClass() {
      var classes = [];

      if (!this.$attrs.value) {
        classes.push('pp-input-select__native__select--placeholder');
      }

      if (this.errorMessages.length > 0) {
        classes.push('pp-input-select__native__select--error');
      }

      if (this.prependIcon) {
        classes.push('pl-10');
      } else {
        classes.push('pl-3');
      }

      return classes.join(' ');
    },
    prependIconClass: function prependIconClass() {
      return this.prependIcon ? "pp-icon-".concat(this.prependIcon) : null;
    },
    loadingClass: function loadingClass() {
      return this.loading ? 'warning pp-input-select-loading' : '';
    },
    isDisabled: function isDisabled() {
      return this.loading || this.disabled;
    },
    shouldHideDetails: function shouldHideDetails() {
      return this.loading ? true : this.hideDetails;
    },
    menuContentClass: function menuContentClass() {
      var classes = ['pp-input-selcect-options-container', 'mt-1', 'rounded-lg'];

      if (this.whiteBg) {
        classes.push('pp-input-selcect-options-container--white-bg');
      }

      if (this.menuClass) {
        classes.push(this.menuClass);
      }

      return classes.join(' ');
    }
  },
  mounted: function mounted() {
    var _this$$refs, _this$$refs$select, _this$$refs$select$$r, _this$$refs$select$$r2;

    this.selectId = (_this$$refs = this.$refs) === null || _this$$refs === void 0 ? void 0 : (_this$$refs$select = _this$$refs.select) === null || _this$$refs$select === void 0 ? void 0 : (_this$$refs$select$$r = _this$$refs$select.$refs) === null || _this$$refs$select$$r === void 0 ? void 0 : (_this$$refs$select$$r2 = _this$$refs$select$$r.input) === null || _this$$refs$select$$r2 === void 0 ? void 0 : _this$$refs$select$$r2.id;
  },
  methods: {
    changeSelect: function changeSelect() {
      this.$emit('change', this.$attrs.value);
    },
    inputSelect: function inputSelect() {
      this.$emit('input', this.$attrs.value);
    },
    displayItem: function displayItem(item) {
      return typeof this.itemText !== 'function' ? item[this.itemText] : this.itemText(item);
    }
  }
});
// CONCATENATED MODULE: ./src/components/input/select/PpInputSelect.vue?vue&type=script&lang=js&
 /* harmony default export */ var select_PpInputSelectvue_type_script_lang_js_ = (PpInputSelectvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/input/select/PpInputSelect.vue?vue&type=style&index=0&lang=scss&
var PpInputSelectvue_type_style_index_0_lang_scss_ = __webpack_require__("03ad");

// EXTERNAL MODULE: ./src/components/input/select/PpInputSelect.vue?vue&type=style&index=1&id=63ab36bc&lang=scss&scoped=true&
var PpInputSelectvue_type_style_index_1_id_63ab36bc_lang_scss_scoped_true_ = __webpack_require__("6929");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// EXTERNAL MODULE: ./node_modules/vuetify-loader/lib/runtime/installComponents.js
var installComponents = __webpack_require__("6544");
var installComponents_default = /*#__PURE__*/__webpack_require__.n(installComponents);

// EXTERNAL MODULE: ./node_modules/vuetify/lib/components/VProgressCircular/VProgressCircular.js
var VProgressCircular = __webpack_require__("490a");

// CONCATENATED MODULE: ./src/components/input/select/PpInputSelect.vue







/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  select_PpInputSelectvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "63ab36bc",
  null
  
)

/* harmony default export */ var PpInputSelect = __webpack_exports__["default"] = (component.exports);

/* vuetify-loader */


installComponents_default()(component, {VProgressCircular: VProgressCircular["a" /* default */]})


/***/ }),

/***/ "b8f9":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("c8d5")

/**
 * @category Quarter Helpers
 * @summary Get the year quarter of the given date.
 *
 * @description
 * Get the year quarter of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the quarter
 *
 * @example
 * // Which quarter is 2 July 2014?
 * var result = getQuarter(new Date(2014, 6, 2))
 * //=> 3
 */
function getQuarter (dirtyDate) {
  var date = parse(dirtyDate)
  var quarter = Math.floor(date.getMonth() / 3) + 1
  return quarter
}

module.exports = getQuarter


/***/ }),

/***/ "b933":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M11 5H21\" stroke=\"#2C98F7\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M11 19H21\" stroke=\"#2C98F7\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M11 12H21\" stroke=\"#2C98F7\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><circle cx=\"5\" cy=\"19\" r=\"2\" fill=\"#D9DBE6\" stroke=\"#2C98F7\" stroke-width=\"2\"></circle><circle cx=\"5\" cy=\"12\" r=\"2\" fill=\"#D9DBE6\" stroke=\"#2C98F7\" stroke-width=\"2\"></circle><circle cx=\"5\" cy=\"5\" r=\"2\" fill=\"#D9DBE6\" stroke=\"#2C98F7\" stroke-width=\"2\"></circle></svg>";

/***/ }),

/***/ "b974":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "b", function() { return /* binding */ defaultMenuProps; });

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("99af");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("4de4");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.find-index.js
var es_array_find_index = __webpack_require__("c740");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.from.js
var es_array_from = __webpack_require__("a630");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("caad");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__("e260");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("d81d");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.reduce.js
var es_array_reduce = __webpack_require__("13d5");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__("fb6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.splice.js
var es_array_splice = __webpack_require__("a434");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("b0c0");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.map.js
var es_map = __webpack_require__("4ec9");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("d3b7");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__("ac1f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("25f0");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("2532");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__("3ca3");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.split.js
var es_string_split = __webpack_require__("1276");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.starts-with.js
var es_string_starts_with = __webpack_require__("2ca0");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.trim.js
var es_string_trim = __webpack_require__("498a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__("ddb0");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js
var createForOfIteratorHelper = __webpack_require__("b85c");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("ade3");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__("5530");

// EXTERNAL MODULE: ./node_modules/vuetify/src/components/VTextField/VTextField.sass
var VTextField = __webpack_require__("4ff9");

// EXTERNAL MODULE: ./node_modules/vuetify/src/components/VSelect/VSelect.sass
var VSelect = __webpack_require__("68dd");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/components/VChip/index.js
var VChip = __webpack_require__("34ef");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/components/VMenu/index.js
var VMenu = __webpack_require__("326d");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.index-of.js
var es_array_index_of = __webpack_require__("c975");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__("a15b");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("b64b");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/components/VCheckbox/VSimpleCheckbox.js
var VSimpleCheckbox = __webpack_require__("9e88");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/components/VDivider/index.js
var VDivider = __webpack_require__("b810");

// EXTERNAL MODULE: ./node_modules/vuetify/src/components/VSubheader/VSubheader.sass
var VSubheader = __webpack_require__("0bc6");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/mixins/themeable/index.js
var themeable = __webpack_require__("7560");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/util/mixins.js
var mixins = __webpack_require__("58df");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VSubheader/VSubheader.js

// Styles
 // Mixins



/* harmony default export */ var VSubheader_VSubheader = (Object(mixins["a" /* default */])(themeable["a" /* default */]
/* @vue/component */
).extend({
  name: 'v-subheader',
  props: {
    inset: Boolean
  },
  render: function render(h) {
    return h('div', {
      staticClass: 'v-subheader',
      class: Object(objectSpread2["a" /* default */])({
        'v-subheader--inset': this.inset
      }, this.themeClasses),
      attrs: this.$attrs,
      on: this.$listeners
    }, this.$slots.default);
  }
}));
// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VSubheader/index.js


/* harmony default export */ var components_VSubheader = (VSubheader_VSubheader);
// EXTERNAL MODULE: ./node_modules/vuetify/lib/components/VList/VListItem.js
var VListItem = __webpack_require__("da13");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/components/VList/VListItemAction.js
var VListItemAction = __webpack_require__("1800");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/components/VList/index.js + 3 modules
var VList = __webpack_require__("5d23");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/components/VList/VList.js
var VList_VList = __webpack_require__("8860");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/directives/ripple/index.js
var ripple = __webpack_require__("5607");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/mixins/colorable/index.js
var colorable = __webpack_require__("a9ad");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/util/helpers.js
var helpers = __webpack_require__("80d2");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VSelect/VSelectList.js










// Components



 // Directives

 // Mixins


 // Helpers

 // Types


/* @vue/component */

/* harmony default export */ var VSelectList = (Object(mixins["a" /* default */])(colorable["a" /* default */], themeable["a" /* default */]).extend({
  name: 'v-select-list',
  // https://github.com/vuejs/vue/issues/6872
  directives: {
    ripple: ripple["a" /* default */]
  },
  props: {
    action: Boolean,
    dense: Boolean,
    hideSelected: Boolean,
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    itemDisabled: {
      type: [String, Array, Function],
      default: 'disabled'
    },
    itemText: {
      type: [String, Array, Function],
      default: 'text'
    },
    itemValue: {
      type: [String, Array, Function],
      default: 'value'
    },
    noDataText: String,
    noFilter: Boolean,
    searchInput: null,
    selectedItems: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  computed: {
    parsedItems: function parsedItems() {
      var _this = this;

      return this.selectedItems.map(function (item) {
        return _this.getValue(item);
      });
    },
    tileActiveClass: function tileActiveClass() {
      return Object.keys(this.setTextColor(this.color).class || {}).join(' ');
    },
    staticNoDataTile: function staticNoDataTile() {
      var tile = {
        attrs: {
          role: undefined
        },
        on: {
          mousedown: function mousedown(e) {
            return e.preventDefault();
          }
        }
      };
      return this.$createElement(VListItem["a" /* default */], tile, [this.genTileContent(this.noDataText)]);
    }
  },
  methods: {
    genAction: function genAction(item, inputValue) {
      var _this2 = this;

      return this.$createElement(VListItemAction["a" /* default */], [this.$createElement(VSimpleCheckbox["a" /* default */], {
        props: {
          color: this.color,
          value: inputValue
        },
        on: {
          input: function input() {
            return _this2.$emit('select', item);
          }
        }
      })]);
    },
    genDivider: function genDivider(props) {
      return this.$createElement(VDivider["a" /* default */], {
        props: props
      });
    },
    genFilteredText: function genFilteredText(text) {
      text = text || '';
      if (!this.searchInput || this.noFilter) return Object(helpers["l" /* escapeHTML */])(text);

      var _this$getMaskedCharac = this.getMaskedCharacters(text),
          start = _this$getMaskedCharac.start,
          middle = _this$getMaskedCharac.middle,
          end = _this$getMaskedCharac.end;

      return "".concat(Object(helpers["l" /* escapeHTML */])(start)).concat(this.genHighlight(middle)).concat(Object(helpers["l" /* escapeHTML */])(end));
    },
    genHeader: function genHeader(props) {
      return this.$createElement(components_VSubheader, {
        props: props
      }, props.header);
    },
    genHighlight: function genHighlight(text) {
      return "<span class=\"v-list-item__mask\">".concat(Object(helpers["l" /* escapeHTML */])(text), "</span>");
    },
    getMaskedCharacters: function getMaskedCharacters(text) {
      var searchInput = (this.searchInput || '').toString().toLocaleLowerCase();
      var index = text.toLocaleLowerCase().indexOf(searchInput);
      if (index < 0) return {
        start: text,
        middle: '',
        end: ''
      };
      var start = text.slice(0, index);
      var middle = text.slice(index, index + searchInput.length);
      var end = text.slice(index + searchInput.length);
      return {
        start: start,
        middle: middle,
        end: end
      };
    },
    genTile: function genTile(_ref) {
      var _this3 = this;

      var item = _ref.item,
          index = _ref.index,
          _ref$disabled = _ref.disabled,
          disabled = _ref$disabled === void 0 ? null : _ref$disabled,
          _ref$value = _ref.value,
          value = _ref$value === void 0 ? false : _ref$value;
      if (!value) value = this.hasItem(item);

      if (item === Object(item)) {
        disabled = disabled !== null ? disabled : this.getDisabled(item);
      }

      var tile = {
        attrs: {
          // Default behavior in list does not
          // contain aria-selected by default
          'aria-selected': String(value),
          id: "list-item-".concat(this._uid, "-").concat(index),
          role: 'option'
        },
        on: {
          mousedown: function mousedown(e) {
            // Prevent onBlur from being called
            e.preventDefault();
          },
          click: function click() {
            return disabled || _this3.$emit('select', item);
          }
        },
        props: {
          activeClass: this.tileActiveClass,
          disabled: disabled,
          ripple: true,
          inputValue: value
        }
      };

      if (!this.$scopedSlots.item) {
        return this.$createElement(VListItem["a" /* default */], tile, [this.action && !this.hideSelected && this.items.length > 0 ? this.genAction(item, value) : null, this.genTileContent(item, index)]);
      }

      var parent = this;
      var scopedSlot = this.$scopedSlots.item({
        parent: parent,
        item: item,
        attrs: Object(objectSpread2["a" /* default */])(Object(objectSpread2["a" /* default */])({}, tile.attrs), tile.props),
        on: tile.on
      });
      return this.needsTile(scopedSlot) ? this.$createElement(VListItem["a" /* default */], tile, scopedSlot) : scopedSlot;
    },
    genTileContent: function genTileContent(item) {
      var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var innerHTML = this.genFilteredText(this.getText(item));
      return this.$createElement(VList["a" /* VListItemContent */], [this.$createElement(VList["b" /* VListItemTitle */], {
        domProps: {
          innerHTML: innerHTML
        }
      })]);
    },
    hasItem: function hasItem(item) {
      return this.parsedItems.indexOf(this.getValue(item)) > -1;
    },
    needsTile: function needsTile(slot) {
      return slot.length !== 1 || slot[0].componentOptions == null || slot[0].componentOptions.Ctor.options.name !== 'v-list-item';
    },
    getDisabled: function getDisabled(item) {
      return Boolean(Object(helpers["r" /* getPropertyFromItem */])(item, this.itemDisabled, false));
    },
    getText: function getText(item) {
      return String(Object(helpers["r" /* getPropertyFromItem */])(item, this.itemText, item));
    },
    getValue: function getValue(item) {
      return Object(helpers["r" /* getPropertyFromItem */])(item, this.itemValue, this.getText(item));
    }
  },
  render: function render() {
    var children = [];
    var itemsLength = this.items.length;

    for (var index = 0; index < itemsLength; index++) {
      var item = this.items[index];
      if (this.hideSelected && this.hasItem(item)) continue;
      if (item == null) children.push(this.genTile({
        item: item,
        index: index
      }));else if (item.header) children.push(this.genHeader(item));else if (item.divider) children.push(this.genDivider(item));else children.push(this.genTile({
        item: item,
        index: index
      }));
    }

    children.length || children.push(this.$slots['no-data'] || this.staticNoDataTile);
    this.$slots['prepend-item'] && children.unshift(this.$slots['prepend-item']);
    this.$slots['append-item'] && children.push(this.$slots['append-item']);
    return this.$createElement(VList_VList["a" /* default */], {
      staticClass: 'v-select-list',
      class: this.themeClasses,
      attrs: {
        role: 'listbox',
        tabindex: -1
      },
      props: {
        dense: this.dense
      }
    }, children);
  }
}));
// EXTERNAL MODULE: ./node_modules/vuetify/lib/components/VInput/index.js + 3 modules
var VInput = __webpack_require__("c37a");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/components/VTextField/VTextField.js + 2 modules
var VTextField_VTextField = __webpack_require__("8654");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/mixins/comparable/index.js
var comparable = __webpack_require__("8547");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/mixins/dependent/index.js
var dependent = __webpack_require__("b848");

// EXTERNAL MODULE: external {"commonjs":"vue","commonjs2":"vue","root":"Vue"}
var external_commonjs_vue_commonjs2_vue_root_Vue_ = __webpack_require__("8bbf");
var external_commonjs_vue_commonjs2_vue_root_Vue_default = /*#__PURE__*/__webpack_require__.n(external_commonjs_vue_commonjs2_vue_root_Vue_);

// CONCATENATED MODULE: ./node_modules/vuetify/lib/mixins/filterable/index.js

/* @vue/component */

/* harmony default export */ var filterable = (external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
  name: 'filterable',
  props: {
    noDataText: {
      type: String,
      default: '$vuetify.noDataText'
    }
  }
}));
// EXTERNAL MODULE: ./node_modules/vuetify/lib/directives/click-outside/index.js
var click_outside = __webpack_require__("a293");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/util/mergeData.js
var mergeData = __webpack_require__("d9f7");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/util/console.js + 32 modules
var console = __webpack_require__("d9bd");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VSelect/VSelect.js
























// Styles

 // Components



 // Extensions


 // Mixins



 // Directives

 // Utilities



 // Types


var defaultMenuProps = {
  closeOnClick: false,
  closeOnContentClick: false,
  disableKeys: true,
  openOnClick: false,
  maxHeight: 304
}; // Types

var baseMixins = Object(mixins["a" /* default */])(VTextField_VTextField["a" /* default */], comparable["a" /* default */], dependent["a" /* default */], filterable);
/* @vue/component */

/* harmony default export */ var VSelect_VSelect = __webpack_exports__["a"] = (baseMixins.extend().extend({
  name: 'v-select',
  directives: {
    ClickOutside: click_outside["a" /* default */]
  },
  props: {
    appendIcon: {
      type: String,
      default: '$dropdown'
    },
    attach: {
      type: null,
      default: false
    },
    cacheItems: Boolean,
    chips: Boolean,
    clearable: Boolean,
    deletableChips: Boolean,
    disableLookup: Boolean,
    eager: Boolean,
    hideSelected: Boolean,
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    itemColor: {
      type: String,
      default: 'primary'
    },
    itemDisabled: {
      type: [String, Array, Function],
      default: 'disabled'
    },
    itemText: {
      type: [String, Array, Function],
      default: 'text'
    },
    itemValue: {
      type: [String, Array, Function],
      default: 'value'
    },
    menuProps: {
      type: [String, Array, Object],
      default: function _default() {
        return defaultMenuProps;
      }
    },
    multiple: Boolean,
    openOnClear: Boolean,
    returnObject: Boolean,
    smallChips: Boolean
  },
  data: function data() {
    return {
      cachedItems: this.cacheItems ? this.items : [],
      menuIsBooted: false,
      isMenuActive: false,
      lastItem: 20,
      // As long as a value is defined, show it
      // Otherwise, check if multiple
      // to determine which default to provide
      lazyValue: this.value !== undefined ? this.value : this.multiple ? [] : undefined,
      selectedIndex: -1,
      selectedItems: [],
      keyboardLookupPrefix: '',
      keyboardLookupLastTime: 0
    };
  },
  computed: {
    /* All items that the select has */
    allItems: function allItems() {
      return this.filterDuplicates(this.cachedItems.concat(this.items));
    },
    classes: function classes() {
      return Object(objectSpread2["a" /* default */])(Object(objectSpread2["a" /* default */])({}, VTextField_VTextField["a" /* default */].options.computed.classes.call(this)), {}, {
        'v-select': true,
        'v-select--chips': this.hasChips,
        'v-select--chips--small': this.smallChips,
        'v-select--is-menu-active': this.isMenuActive,
        'v-select--is-multi': this.multiple
      });
    },

    /* Used by other components to overwrite */
    computedItems: function computedItems() {
      return this.allItems;
    },
    computedOwns: function computedOwns() {
      return "list-".concat(this._uid);
    },
    computedCounterValue: function computedCounterValue() {
      return this.multiple ? this.selectedItems.length : (this.getText(this.selectedItems[0]) || '').toString().length;
    },
    directives: function directives() {
      var _this = this;

      return this.isFocused ? [{
        name: 'click-outside',
        value: {
          handler: this.blur,
          closeConditional: this.closeConditional,
          include: function include() {
            return _this.getOpenDependentElements();
          }
        }
      }] : undefined;
    },
    dynamicHeight: function dynamicHeight() {
      return 'auto';
    },
    hasChips: function hasChips() {
      return this.chips || this.smallChips;
    },
    hasSlot: function hasSlot() {
      return Boolean(this.hasChips || this.$scopedSlots.selection);
    },
    isDirty: function isDirty() {
      return this.selectedItems.length > 0;
    },
    listData: function listData() {
      var scopeId = this.$vnode && this.$vnode.context.$options._scopeId;
      var attrs = scopeId ? Object(defineProperty["a" /* default */])({}, scopeId, true) : {};
      return {
        attrs: Object(objectSpread2["a" /* default */])(Object(objectSpread2["a" /* default */])({}, attrs), {}, {
          id: this.computedOwns
        }),
        props: {
          action: this.multiple,
          color: this.itemColor,
          dense: this.dense,
          hideSelected: this.hideSelected,
          items: this.virtualizedItems,
          itemDisabled: this.itemDisabled,
          itemText: this.itemText,
          itemValue: this.itemValue,
          noDataText: this.$vuetify.lang.t(this.noDataText),
          selectedItems: this.selectedItems
        },
        on: {
          select: this.selectItem
        },
        scopedSlots: {
          item: this.$scopedSlots.item
        }
      };
    },
    staticList: function staticList() {
      if (this.$slots['no-data'] || this.$slots['prepend-item'] || this.$slots['append-item']) {
        Object(console["b" /* consoleError */])('assert: staticList should not be called if slots are used');
      }

      return this.$createElement(VSelectList, this.listData);
    },
    virtualizedItems: function virtualizedItems() {
      return this.$_menuProps.auto ? this.computedItems : this.computedItems.slice(0, this.lastItem);
    },
    menuCanShow: function menuCanShow() {
      return true;
    },
    $_menuProps: function $_menuProps() {
      var normalisedProps = typeof this.menuProps === 'string' ? this.menuProps.split(',') : this.menuProps;

      if (Array.isArray(normalisedProps)) {
        normalisedProps = normalisedProps.reduce(function (acc, p) {
          acc[p.trim()] = true;
          return acc;
        }, {});
      }

      return Object(objectSpread2["a" /* default */])(Object(objectSpread2["a" /* default */])({}, defaultMenuProps), {}, {
        eager: this.eager,
        value: this.menuCanShow && this.isMenuActive,
        nudgeBottom: normalisedProps.offsetY ? 1 : 0
      }, normalisedProps);
    }
  },
  watch: {
    internalValue: function internalValue(val) {
      this.initialValue = val;
      this.setSelectedItems();
    },
    isMenuActive: function isMenuActive(val) {
      var _this2 = this;

      window.setTimeout(function () {
        return _this2.onMenuActiveChange(val);
      });
    },
    items: {
      immediate: true,
      handler: function handler(val) {
        var _this3 = this;

        if (this.cacheItems) {
          // Breaks vue-test-utils if
          // this isn't calculated
          // on the next tick
          this.$nextTick(function () {
            _this3.cachedItems = _this3.filterDuplicates(_this3.cachedItems.concat(val));
          });
        }

        this.setSelectedItems();
      }
    }
  },
  methods: {
    /** @public */
    blur: function blur(e) {
      VTextField_VTextField["a" /* default */].options.methods.blur.call(this, e);
      this.isMenuActive = false;
      this.isFocused = false;
      this.selectedIndex = -1;
      this.setMenuIndex(-1);
    },

    /** @public */
    activateMenu: function activateMenu() {
      if (!this.isInteractive || this.isMenuActive) return;
      this.isMenuActive = true;
    },
    clearableCallback: function clearableCallback() {
      var _this4 = this;

      this.setValue(this.multiple ? [] : null);
      this.setMenuIndex(-1);
      this.$nextTick(function () {
        return _this4.$refs.input && _this4.$refs.input.focus();
      });
      if (this.openOnClear) this.isMenuActive = true;
    },
    closeConditional: function closeConditional(e) {
      if (!this.isMenuActive) return true;
      return !this._isDestroyed && ( // Click originates from outside the menu content
      // Multiple selects don't close when an item is clicked
      !this.getContent() || !this.getContent().contains(e.target)) && // Click originates from outside the element
      this.$el && !this.$el.contains(e.target) && e.target !== this.$el;
    },
    filterDuplicates: function filterDuplicates(arr) {
      var uniqueValues = new Map();

      for (var index = 0; index < arr.length; ++index) {
        var item = arr[index]; // Do not deduplicate headers or dividers (#12517)

        if (item.header || item.divider) {
          uniqueValues.set(item, item);
          continue;
        }

        var val = this.getValue(item); // TODO: comparator

        !uniqueValues.has(val) && uniqueValues.set(val, item);
      }

      return Array.from(uniqueValues.values());
    },
    findExistingIndex: function findExistingIndex(item) {
      var _this5 = this;

      var itemValue = this.getValue(item);
      return (this.internalValue || []).findIndex(function (i) {
        return _this5.valueComparator(_this5.getValue(i), itemValue);
      });
    },
    getContent: function getContent() {
      return this.$refs.menu && this.$refs.menu.$refs.content;
    },
    genChipSelection: function genChipSelection(item, index) {
      var _this6 = this;

      var isDisabled = !this.isInteractive || this.getDisabled(item);
      return this.$createElement(VChip["a" /* default */], {
        staticClass: 'v-chip--select',
        attrs: {
          tabindex: -1
        },
        props: {
          close: this.deletableChips && !isDisabled,
          disabled: isDisabled,
          inputValue: index === this.selectedIndex,
          small: this.smallChips
        },
        on: {
          click: function click(e) {
            if (isDisabled) return;
            e.stopPropagation();
            _this6.selectedIndex = index;
          },
          'click:close': function clickClose() {
            return _this6.onChipInput(item);
          }
        },
        key: JSON.stringify(this.getValue(item))
      }, this.getText(item));
    },
    genCommaSelection: function genCommaSelection(item, index, last) {
      var color = index === this.selectedIndex && this.computedColor;
      var isDisabled = !this.isInteractive || this.getDisabled(item);
      return this.$createElement('div', this.setTextColor(color, {
        staticClass: 'v-select__selection v-select__selection--comma',
        class: {
          'v-select__selection--disabled': isDisabled
        },
        key: JSON.stringify(this.getValue(item))
      }), "".concat(this.getText(item)).concat(last ? '' : ', '));
    },
    genDefaultSlot: function genDefaultSlot() {
      var selections = this.genSelections();
      var input = this.genInput(); // If the return is an empty array
      // push the input

      if (Array.isArray(selections)) {
        selections.push(input); // Otherwise push it into children
      } else {
        selections.children = selections.children || [];
        selections.children.push(input);
      }

      return [this.genFieldset(), this.$createElement('div', {
        staticClass: 'v-select__slot',
        directives: this.directives
      }, [this.genLabel(), this.prefix ? this.genAffix('prefix') : null, selections, this.suffix ? this.genAffix('suffix') : null, this.genClearIcon(), this.genIconSlot(), this.genHiddenInput()]), this.genMenu(), this.genProgress()];
    },
    genIcon: function genIcon(type, cb, extraData) {
      var icon = VInput["a" /* default */].options.methods.genIcon.call(this, type, cb, extraData);

      if (type === 'append') {
        // Don't allow the dropdown icon to be focused
        icon.children[0].data = Object(mergeData["a" /* default */])(icon.children[0].data, {
          attrs: {
            tabindex: icon.children[0].componentOptions.listeners && '-1',
            'aria-hidden': 'true',
            'aria-label': undefined
          }
        });
      }

      return icon;
    },
    genInput: function genInput() {
      var input = VTextField_VTextField["a" /* default */].options.methods.genInput.call(this);
      delete input.data.attrs.name;
      input.data = Object(mergeData["a" /* default */])(input.data, {
        domProps: {
          value: null
        },
        attrs: {
          readonly: true,
          type: 'text',
          'aria-readonly': String(this.isReadonly),
          'aria-activedescendant': Object(helpers["p" /* getObjectValueByPath */])(this.$refs.menu, 'activeTile.id'),
          autocomplete: Object(helpers["p" /* getObjectValueByPath */])(input.data, 'attrs.autocomplete', 'off')
        },
        on: {
          keypress: this.onKeyPress
        }
      });
      return input;
    },
    genHiddenInput: function genHiddenInput() {
      return this.$createElement('input', {
        domProps: {
          value: this.lazyValue
        },
        attrs: {
          type: 'hidden',
          name: this.attrs$.name
        }
      });
    },
    genInputSlot: function genInputSlot() {
      var render = VTextField_VTextField["a" /* default */].options.methods.genInputSlot.call(this);
      render.data.attrs = Object(objectSpread2["a" /* default */])(Object(objectSpread2["a" /* default */])({}, render.data.attrs), {}, {
        role: 'button',
        'aria-haspopup': 'listbox',
        'aria-expanded': String(this.isMenuActive),
        'aria-owns': this.computedOwns
      });
      return render;
    },
    genList: function genList() {
      // If there's no slots, we can use a cached VNode to improve performance
      if (this.$slots['no-data'] || this.$slots['prepend-item'] || this.$slots['append-item']) {
        return this.genListWithSlot();
      } else {
        return this.staticList;
      }
    },
    genListWithSlot: function genListWithSlot() {
      var _this7 = this;

      var slots = ['prepend-item', 'no-data', 'append-item'].filter(function (slotName) {
        return _this7.$slots[slotName];
      }).map(function (slotName) {
        return _this7.$createElement('template', {
          slot: slotName
        }, _this7.$slots[slotName]);
      }); // Requires destructuring due to Vue
      // modifying the `on` property when passed
      // as a referenced object

      return this.$createElement(VSelectList, Object(objectSpread2["a" /* default */])({}, this.listData), slots);
    },
    genMenu: function genMenu() {
      var _this8 = this;

      var props = this.$_menuProps;
      props.activator = this.$refs['input-slot']; // Attach to root el so that
      // menu covers prepend/append icons

      if ( // TODO: make this a computed property or helper or something
      this.attach === '' || // If used as a boolean prop (<v-menu attach>)
      this.attach === true || // If bound to a boolean (<v-menu :attach="true">)
      this.attach === 'attach' // If bound as boolean prop in pug (v-menu(attach))
      ) {
          props.attach = this.$el;
        } else {
        props.attach = this.attach;
      }

      return this.$createElement(VMenu["a" /* default */], {
        attrs: {
          role: undefined
        },
        props: props,
        on: {
          input: function input(val) {
            _this8.isMenuActive = val;
            _this8.isFocused = val;
          },
          scroll: this.onScroll
        },
        ref: 'menu'
      }, [this.genList()]);
    },
    genSelections: function genSelections() {
      var length = this.selectedItems.length;
      var children = new Array(length);
      var genSelection;

      if (this.$scopedSlots.selection) {
        genSelection = this.genSlotSelection;
      } else if (this.hasChips) {
        genSelection = this.genChipSelection;
      } else {
        genSelection = this.genCommaSelection;
      }

      while (length--) {
        children[length] = genSelection(this.selectedItems[length], length, length === children.length - 1);
      }

      return this.$createElement('div', {
        staticClass: 'v-select__selections'
      }, children);
    },
    genSlotSelection: function genSlotSelection(item, index) {
      var _this9 = this;

      return this.$scopedSlots.selection({
        attrs: {
          class: 'v-chip--select'
        },
        parent: this,
        item: item,
        index: index,
        select: function select(e) {
          e.stopPropagation();
          _this9.selectedIndex = index;
        },
        selected: index === this.selectedIndex,
        disabled: !this.isInteractive
      });
    },
    getMenuIndex: function getMenuIndex() {
      return this.$refs.menu ? this.$refs.menu.listIndex : -1;
    },
    getDisabled: function getDisabled(item) {
      return Object(helpers["r" /* getPropertyFromItem */])(item, this.itemDisabled, false);
    },
    getText: function getText(item) {
      return Object(helpers["r" /* getPropertyFromItem */])(item, this.itemText, item);
    },
    getValue: function getValue(item) {
      return Object(helpers["r" /* getPropertyFromItem */])(item, this.itemValue, this.getText(item));
    },
    onBlur: function onBlur(e) {
      e && this.$emit('blur', e);
    },
    onChipInput: function onChipInput(item) {
      if (this.multiple) this.selectItem(item);else this.setValue(null); // If all items have been deleted,
      // open `v-menu`

      if (this.selectedItems.length === 0) {
        this.isMenuActive = true;
      } else {
        this.isMenuActive = false;
      }

      this.selectedIndex = -1;
    },
    onClick: function onClick(e) {
      if (!this.isInteractive) return;

      if (!this.isAppendInner(e.target)) {
        this.isMenuActive = true;
      }

      if (!this.isFocused) {
        this.isFocused = true;
        this.$emit('focus');
      }

      this.$emit('click', e);
    },
    onEscDown: function onEscDown(e) {
      e.preventDefault();

      if (this.isMenuActive) {
        e.stopPropagation();
        this.isMenuActive = false;
      }
    },
    onKeyPress: function onKeyPress(e) {
      var _this10 = this;

      if (this.multiple || !this.isInteractive || this.disableLookup) return;
      var KEYBOARD_LOOKUP_THRESHOLD = 1000; // milliseconds

      var now = performance.now();

      if (now - this.keyboardLookupLastTime > KEYBOARD_LOOKUP_THRESHOLD) {
        this.keyboardLookupPrefix = '';
      }

      this.keyboardLookupPrefix += e.key.toLowerCase();
      this.keyboardLookupLastTime = now;
      var index = this.allItems.findIndex(function (item) {
        var text = (_this10.getText(item) || '').toString();
        return text.toLowerCase().startsWith(_this10.keyboardLookupPrefix);
      });
      var item = this.allItems[index];

      if (index !== -1) {
        this.lastItem = Math.max(this.lastItem, index + 5);
        this.setValue(this.returnObject ? item : this.getValue(item));
        this.$nextTick(function () {
          return _this10.$refs.menu.getTiles();
        });
        setTimeout(function () {
          return _this10.setMenuIndex(index);
        });
      }
    },
    onKeyDown: function onKeyDown(e) {
      var _this11 = this;

      if (this.isReadonly && e.keyCode !== helpers["x" /* keyCodes */].tab) return;
      var keyCode = e.keyCode;
      var menu = this.$refs.menu; // If enter, space, open menu

      if ([helpers["x" /* keyCodes */].enter, helpers["x" /* keyCodes */].space].includes(keyCode)) this.activateMenu();
      this.$emit('keydown', e);
      if (!menu) return; // If menu is active, allow default
      // listIndex change from menu

      if (this.isMenuActive && keyCode !== helpers["x" /* keyCodes */].tab) {
        this.$nextTick(function () {
          menu.changeListIndex(e);

          _this11.$emit('update:list-index', menu.listIndex);
        });
      } // If menu is not active, up/down/home/end can do
      // one of 2 things. If multiple, opens the
      // menu, if not, will cycle through all
      // available options


      if (!this.isMenuActive && [helpers["x" /* keyCodes */].up, helpers["x" /* keyCodes */].down, helpers["x" /* keyCodes */].home, helpers["x" /* keyCodes */].end].includes(keyCode)) return this.onUpDown(e); // If escape deactivate the menu

      if (keyCode === helpers["x" /* keyCodes */].esc) return this.onEscDown(e); // If tab - select item or close menu

      if (keyCode === helpers["x" /* keyCodes */].tab) return this.onTabDown(e); // If space preventDefault

      if (keyCode === helpers["x" /* keyCodes */].space) return this.onSpaceDown(e);
    },
    onMenuActiveChange: function onMenuActiveChange(val) {
      // If menu is closing and mulitple
      // or menuIndex is already set
      // skip menu index recalculation
      if (this.multiple && !val || this.getMenuIndex() > -1) return;
      var menu = this.$refs.menu;
      if (!menu || !this.isDirty) return; // When menu opens, set index of first active item

      for (var i = 0; i < menu.tiles.length; i++) {
        if (menu.tiles[i].getAttribute('aria-selected') === 'true') {
          this.setMenuIndex(i);
          break;
        }
      }
    },
    onMouseUp: function onMouseUp(e) {
      var _this12 = this;

      // eslint-disable-next-line sonarjs/no-collapsible-if
      if (this.hasMouseDown && e.which !== 3 && this.isInteractive) {
        // If append inner is present
        // and the target is itself
        // or inside, toggle menu
        if (this.isAppendInner(e.target)) {
          this.$nextTick(function () {
            return _this12.isMenuActive = !_this12.isMenuActive;
          });
        }
      }

      VTextField_VTextField["a" /* default */].options.methods.onMouseUp.call(this, e);
    },
    onScroll: function onScroll() {
      var _this13 = this;

      if (!this.isMenuActive) {
        requestAnimationFrame(function () {
          return _this13.getContent().scrollTop = 0;
        });
      } else {
        if (this.lastItem > this.computedItems.length) return;
        var showMoreItems = this.getContent().scrollHeight - (this.getContent().scrollTop + this.getContent().clientHeight) < 200;

        if (showMoreItems) {
          this.lastItem += 20;
        }
      }
    },
    onSpaceDown: function onSpaceDown(e) {
      e.preventDefault();
    },
    onTabDown: function onTabDown(e) {
      var menu = this.$refs.menu;
      if (!menu) return;
      var activeTile = menu.activeTile; // An item that is selected by
      // menu-index should toggled

      if (!this.multiple && activeTile && this.isMenuActive) {
        e.preventDefault();
        e.stopPropagation();
        activeTile.click();
      } else {
        // If we make it here,
        // the user has no selected indexes
        // and is probably tabbing out
        this.blur(e);
      }
    },
    onUpDown: function onUpDown(e) {
      var menu = this.$refs.menu;
      if (!menu) return;
      e.preventDefault(); // Multiple selects do not cycle their value
      // when pressing up or down, instead activate
      // the menu

      if (this.multiple) return this.activateMenu();
      var keyCode = e.keyCode; // Cycle through available values to achieve
      // select native behavior

      menu.isBooted = true;
      window.requestAnimationFrame(function () {
        menu.getTiles();

        switch (keyCode) {
          case helpers["x" /* keyCodes */].up:
            menu.prevTile();
            break;

          case helpers["x" /* keyCodes */].down:
            menu.nextTile();
            break;

          case helpers["x" /* keyCodes */].home:
            menu.firstTile();
            break;

          case helpers["x" /* keyCodes */].end:
            menu.lastTile();
            break;
        }

        menu.activeTile && menu.activeTile.click();
      });
    },
    selectItem: function selectItem(item) {
      var _this14 = this;

      if (!this.multiple) {
        this.setValue(this.returnObject ? item : this.getValue(item));
        this.isMenuActive = false;
      } else {
        var internalValue = (this.internalValue || []).slice();
        var i = this.findExistingIndex(item);
        i !== -1 ? internalValue.splice(i, 1) : internalValue.push(item);
        this.setValue(internalValue.map(function (i) {
          return _this14.returnObject ? i : _this14.getValue(i);
        })); // When selecting multiple
        // adjust menu after each
        // selection

        this.$nextTick(function () {
          _this14.$refs.menu && _this14.$refs.menu.updateDimensions();
        }); // We only need to reset list index for multiple
        // to keep highlight when an item is toggled
        // on and off

        if (!this.multiple) return;
        var listIndex = this.getMenuIndex();
        this.setMenuIndex(-1); // There is no item to re-highlight
        // when selections are hidden

        if (this.hideSelected) return;
        this.$nextTick(function () {
          return _this14.setMenuIndex(listIndex);
        });
      }
    },
    setMenuIndex: function setMenuIndex(index) {
      this.$refs.menu && (this.$refs.menu.listIndex = index);
    },
    setSelectedItems: function setSelectedItems() {
      var _this15 = this;

      var selectedItems = [];
      var values = !this.multiple || !Array.isArray(this.internalValue) ? [this.internalValue] : this.internalValue;

      var _iterator = Object(createForOfIteratorHelper["a" /* default */])(values),
          _step;

      try {
        var _loop = function _loop() {
          var value = _step.value;

          var index = _this15.allItems.findIndex(function (v) {
            return _this15.valueComparator(_this15.getValue(v), _this15.getValue(value));
          });

          if (index > -1) {
            selectedItems.push(_this15.allItems[index]);
          }
        };

        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      this.selectedItems = selectedItems;
    },
    setValue: function setValue(value) {
      var oldValue = this.internalValue;
      this.internalValue = value;
      value !== oldValue && this.$emit('change', value);
    },
    isAppendInner: function isAppendInner(target) {
      // return true if append inner is present
      // and the target is itself or inside
      var appendInner = this.$refs['append-inner'];
      return appendInner && (appendInner === target || appendInner.contains(target));
    }
  }
}));

/***/ }),

/***/ "b9a8":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M18.4998 1C20.9851 1 22.9998 3.01472 22.9998 5.5C22.9998 7.46681 21.738 9.13891 19.9798 9.75097L19.9999 9.74391L19.9998 14.6961C19.9998 15.4415 20.6838 16.0541 21.4254 16.1235L21.565 16.1301C22.357 16.1301 23 16.7731 23 17.5651C23 18.3115 22.4304 18.924 21.7031 18.9935L21.565 19.0001H15.999L15.9949 19.1996C15.8909 21.316 14.142 23 11.9998 23C9.791 23 8.00034 21.2097 7.9998 19.001L2.435 19.0001C1.642 19.0001 1 18.3581 1 17.5651C1 16.8197 1.56869 16.2063 2.29673 16.1367L2.435 16.1301C3.183 16.1301 3.93108 15.5575 4.01189 14.8266L4.01909 14.6961V9.1301C4.01909 5.4321 6.867 2.4351 10.565 2.4351C10.565 1.6421 11.207 1.0001 12 1.0001C12.792 1.0001 13.435 1.6421 13.435 2.4351C13.9894 2.4351 14.5251 2.50246 15.0353 2.62943L15.1154 2.53415C15.9402 1.59373 17.1506 1 18.4998 1ZM13.999 19.0001H9.999L10.0053 19.1493C10.0816 20.1841 10.9454 21 11.9998 21C13.0542 21 13.918 20.1841 13.9943 19.1493L13.999 19.0001Z\" fill=\"white\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12 1.00012C12.792 1.00012 13.435 1.64212 13.435 2.43512C13.9768 2.43512 14.5007 2.49945 15.0004 2.62089C12.0936 3.32833 10.0191 5.97391 10.0191 9.13012L10.019 16.9991L15.9998 17V19C15.9998 21.2092 14.2089 23 11.9998 23C9.79133 23 8.00089 21.2102 7.9998 19.002L2.435 19.0001C1.642 19.0001 1 18.3581 1 17.5651C1 16.7731 1.642 16.1301 2.435 16.1301C3.183 16.1301 3.93108 15.5575 4.01189 14.8266L4.01909 14.6961V9.13012C4.01909 5.43212 6.867 2.43512 10.565 2.43512C10.565 1.64212 11.207 1.00012 12 1.00012Z\" fill=\"#DFE4E5\"></path><path d=\"M18.4998 1C20.9851 1 22.9998 3.01472 22.9998 5.5C22.9998 7.46681 21.738 9.13891 19.9798 9.75097L19.9999 9.74391L19.9998 14.6961C19.9998 15.4415 20.6838 16.0541 21.4254 16.1235L21.565 16.1301C22.357 16.1301 23 16.7731 23 17.5651C23 18.3115 22.4304 18.924 21.7031 18.9935L21.565 19.0001H15.999L15.9949 19.1996C15.8909 21.316 14.142 23 11.9998 23C9.791 23 8.00034 21.2097 7.9998 19.001L2.435 19.0001C1.642 19.0001 1 18.3581 1 17.5651C1 16.8197 1.56869 16.2063 2.29673 16.1367L2.435 16.1301C3.183 16.1301 3.93108 15.5575 4.01189 14.8266L4.01909 14.6961V9.1301C4.01909 5.4321 6.867 2.4351 10.565 2.4351C10.565 1.6421 11.207 1.0001 12 1.0001C12.792 1.0001 13.435 1.6421 13.435 2.4351C13.9894 2.4351 14.5251 2.50246 15.0353 2.62943L15.1154 2.53415C15.9402 1.59373 17.1506 1 18.4998 1ZM13.999 19.0001H9.999L10.0053 19.1493C10.0816 20.1841 10.9454 21 11.9998 21C13.0542 21 13.918 20.1841 13.9943 19.1493L13.999 19.0001ZM13.435 4.4351H10.565C8.08509 4.4351 6.13036 6.38081 6.02367 8.91176L6.01909 9.1301V14.6961C6.01909 15.5351 5.69715 16.2918 5.18016 16.88L5.068 17H18.942L18.8301 16.8778C18.357 16.3345 18.0498 15.6482 18.0054 14.8877L17.9998 14.6961L17.9991 9.97246L18.0373 9.97652C15.7693 9.74498 13.9998 7.82913 13.9998 5.5C13.9998 5.21597 14.0261 4.93808 14.0764 4.66865L14.1147 4.4851C13.9615 4.46208 13.8053 4.44697 13.6467 4.43985L13.435 4.4351ZM18.4998 3C17.1191 3 15.9998 4.11929 15.9998 5.5C15.9998 6.88071 17.1191 8 18.4998 8C19.8805 8 20.9998 6.88071 20.9998 5.5C20.9998 4.11929 19.8805 3 18.4998 3Z\" fill=\"#688083\"></path></svg>";

/***/ }),

/***/ "b9b8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c662cfac-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/input/file/PpInputFile.vue?vue&type=template&id=6cf0f976&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{class:['pp-input-file py-6', ("pp-input-file--" + (_vm.config.modifierName))],attrs:{"flat":""},on:{"drop":function($event){$event.preventDefault();return _vm.dropFile($event)},"dragleave":function($event){$event.preventDefault();return _vm.leavingFile($event)},"dragover":function($event){$event.preventDefault();return _vm.draggingFile($event)}}},[_c('img',{staticClass:"my-4 mx-auto d-block",attrs:{"src":_vm.image,"alt":_vm.status}}),_vm._t("header",[(_vm.header)?_c('h3',{staticClass:"text-center px-4 pp-input-file__header"},[_vm._v(" "+_vm._s(_vm.header)+" ")]):_vm._e()]),(_vm.isInitial)?_c('p',{staticClass:"text-center"},[_vm._v(" or "),_c('span',{staticClass:"pp-input-file__select-file",on:{"click":_vm.openSelectFile}},[_vm._v("select file"+_vm._s(_vm.multiple ? 's' : ''))]),_c('input',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],ref:"inputFile",attrs:{"accept":_vm.fileTypes.join(', '),"multiple":_vm.multiple,"type":"file"},on:{"change":_vm.selectFile,"click":_vm.resetFile}})]):_vm._t("content",[_c('div',{staticClass:"text-center pt-2"},[(_vm.isUploading)?[(_vm.showProgress)?_c('div',{staticClass:"pt-2 px-8"},[_c('v-progress-linear',{staticClass:"mb-4",attrs:{"value":_vm.uploadProgress,"height":"6","background-color":"grey","rounded":""}}),_c('p',{staticClass:"font-weight-bold mb-0"},[_vm._v(" "+_vm._s(_vm.uploadProgress)+"% ")])],1):_c('v-progress-circular',{attrs:{"color":"grey","indeterminate":"","width":2,"size":"16"}})]:_vm._e(),(_vm.content)?_c('span',[_vm._v(" "+_vm._s(_vm.content)+" ")]):_vm._e()],2)])],2)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/input/file/PpInputFile.vue?vue&type=template&id=6cf0f976&scoped=true&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("99af");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("caad");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.index-of.js
var es_array_index_of = __webpack_require__("c975");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__("a15b");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("d81d");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("b0c0");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__("a9e3");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.entries.js
var es_object_entries = __webpack_require__("4fad");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.values.js
var es_object_values = __webpack_require__("07ac");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__("ac1f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("2532");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.split.js
var es_string_split = __webpack_require__("1276");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__("3835");

// EXTERNAL MODULE: ./src/components/input/file/constants.js
var constants = __webpack_require__("6e1e");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/input/file/PpInputFile.vue?vue&type=script&lang=js&













//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var PpInputFilevue_type_script_lang_js_ = ({
  name: 'PpInputFile',
  props: {
    /**
     * Array file types, ex: .json, .csv
     */
    fileTypes: {
      type: Array,
      required: true
    },

    /**
     * Current status for file upload
     * init is default state.
     * We have the following states: init, uploading, complete, error
     */
    status: {
      type: String,
      default: constants["b" /* UPLOAD_FILE_STATUS */].INIT,
      validator: function validator(value) {
        return Object.values(constants["b" /* UPLOAD_FILE_STATUS */]).indexOf(value) !== -1;
      }
    },

    /**
     * This field is number of maximum bytes for files (default to 1Mb)
     */
    maxSize: {
      type: Number,
      default: 1048576
    },

    /**
     * This field is used to determine whether to upload multiple files
     */
    multiple: {
      type: Boolean,
      default: false
    },

    /**
     * This field is to display the error message in the format of the error's header and content
     */
    errorMessage: {
      type: Object,
      default: function _default() {
        return {
          header: '',
          content: ''
        };
      }
    },

    /**
     * This field is used to set the header text
     */
    headerText: {
      type: String,
      default: null
    },

    /**
     * This field is used to set the content text
     */
    contentText: {
      type: String,
      default: null
    },

    /**
     * This field is used to determine if the upload progress should be shown or not
     */
    showProgress: {
      type: Boolean,
      default: false
    },

    /**
     * This field is used to set the upload progress
     */
    uploadProgress: {
      type: Number,
      default: 0
    },

    /**
     * This field is used to set the url of the file image to display
     */
    imgUrl: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      files: [],
      isDragging: false
    };
  },
  computed: {
    isUploading: function isUploading() {
      return this.status === constants["b" /* UPLOAD_FILE_STATUS */].UPLOADING;
    },
    isInitial: function isInitial() {
      return this.status === constants["b" /* UPLOAD_FILE_STATUS */].INIT;
    },
    fileNames: function fileNames() {
      // Only use these lines for samples uploading and uploaded status in stories
      if (this.files.length === 0 && window.__STORYBOOK_ADDONS) {
        if (this.multiple) {
          return ['sampleFileNameOne.csv', 'sampleFileNameTwo.csv'];
        }

        return ['sampleFileName.csv'];
      } // Join all file names with comma seperator


      return this.files.map(function (file) {
        return file.name;
      });
    },
    config: function config() {
      var result;

      switch (this.status) {
        case constants["b" /* UPLOAD_FILE_STATUS */].INIT:
          result = {
            icon: constants["a" /* IMG_URL */].DEFAULT_FILE_UPLOAD,
            modifierName: 'init',
            header: "Drag ".concat(this.fileTypes.join(', '), " file").concat(this.multiple ? 's' : '', " here"),
            content: ''
          };
          break;

        case constants["b" /* UPLOAD_FILE_STATUS */].UPLOADING:
          result = {
            icon: constants["a" /* IMG_URL */].FILE_DRAGGING,
            modifierName: 'uploading',
            header: this.fileNames.join(', '),
            content: "Verifying your file".concat(this.multiple ? 's' : '', ".")
          };
          break;

        case constants["b" /* UPLOAD_FILE_STATUS */].COMPLETE:
          result = {
            icon: constants["a" /* IMG_URL */].FILE_UPLOADED,
            modifierName: 'complete',
            header: "File".concat(this.multiple ? 's' : '', " looks good!"),
            content: 'You will be notified via email when upload is complete.'
          };
          break;

        case constants["b" /* UPLOAD_FILE_STATUS */].ERROR:
          result = {
            icon: constants["a" /* IMG_URL */].FILE_ERROR,
            modifierName: 'error',
            header: this.errorMessage.header,
            content: this.errorMessage.content
          };
          break;
      }

      if (this.isDragging) {
        result.icon = constants["a" /* IMG_URL */].FILE_DRAGGING;
        result.modifierName = 'dragging';
      }

      return result;
    },
    header: function header() {
      var _this$headerText;

      return (_this$headerText = this.headerText) !== null && _this$headerText !== void 0 ? _this$headerText : this.config.header;
    },
    content: function content() {
      var _this$contentText;

      return (_this$contentText = this.contentText) !== null && _this$contentText !== void 0 ? _this$contentText : this.config.content;
    },
    image: function image() {
      return this.imgUrl || this.config.icon;
    }
  },
  methods: {
    resetFile: function resetFile() {
      // Clear value for input file
      this.$refs.inputFile.value = null;
    },
    openSelectFile: function openSelectFile() {
      this.$refs.inputFile.click();
    },
    selectFile: function selectFile(e) {
      this.handleSelectFiles(e.target.files);
    },
    draggingFile: function draggingFile() {
      if (!this.isInitial) {
        return;
      }

      this.isDragging = true;
    },
    leavingFile: function leavingFile() {
      this.isDragging = false;
    },
    dropFile: function dropFile(e) {
      if (!this.isInitial) {
        return;
      }

      var droppedFiles = e.dataTransfer.files;

      if (!droppedFiles) {
        this.handleError({
          content: 'Something went wrong. Please try again!'
        });
        return;
      }

      this.isDragging = false;
      this.handleSelectFiles(droppedFiles);
    },
    handleError: function handleError(error) {
      this.$emit('error', error);
    },
    bytesToSize: function bytesToSize(bytes) {
      var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
      if (bytes === 0) return '0 Byte';
      var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
      return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
    },
    handleSelectFiles: function handleSelectFiles(filesSelected) {
      // if we are only doing single upload verify one file is selected
      if (Object.entries(filesSelected).length > 1 && !this.multiple) {
        this.handleError({
          content: 'Please choose one file at a time to upload.'
        });
        return;
      }

      this.files = [];

      for (var _i = 0, _Object$entries = Object.entries(filesSelected); _i < _Object$entries.length; _i++) {
        var _Object$entries$_i = Object(slicedToArray["a" /* default */])(_Object$entries[_i], 2),
            file = _Object$entries$_i[1];

        // Validate file types
        if (!this.fileTypes.includes('.' + file.name.split('.').pop())) {
          this.handleError({
            header: 'Wrong file type',
            content: "Please make sure your file".concat(this.multiple ? 's are' : ' is a', " ").concat(this.fileTypes.join(', '), ".")
          });
          return;
        } // Validate maxsize limit


        if (file.size > this.maxSize) {
          this.handleError({
            header: 'The file that you are trying to use is too large',
            content: "The maximum size of the file that can be uploaded is ".concat(this.bytesToSize(this.maxSize), ".")
          });
          return;
        }

        this.files.push(file);
      }

      if (this.files) {
        this.$emit('files-selected', this.files);
      }
    }
  }
});
// CONCATENATED MODULE: ./src/components/input/file/PpInputFile.vue?vue&type=script&lang=js&
 /* harmony default export */ var file_PpInputFilevue_type_script_lang_js_ = (PpInputFilevue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/input/file/PpInputFile.vue?vue&type=style&index=0&id=6cf0f976&lang=scss&scoped=true&
var PpInputFilevue_type_style_index_0_id_6cf0f976_lang_scss_scoped_true_ = __webpack_require__("5bb0");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// EXTERNAL MODULE: ./node_modules/vuetify-loader/lib/runtime/installComponents.js
var installComponents = __webpack_require__("6544");
var installComponents_default = /*#__PURE__*/__webpack_require__.n(installComponents);

// EXTERNAL MODULE: ./node_modules/vuetify/lib/components/VCard/VCard.js
var VCard = __webpack_require__("b0af");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/components/VProgressCircular/VProgressCircular.js
var VProgressCircular = __webpack_require__("490a");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/components/VProgressLinear/VProgressLinear.js
var VProgressLinear = __webpack_require__("8e36");

// CONCATENATED MODULE: ./src/components/input/file/PpInputFile.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  file_PpInputFilevue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "6cf0f976",
  null
  
)

/* harmony default export */ var PpInputFile = __webpack_exports__["default"] = (component.exports);

/* vuetify-loader */




installComponents_default()(component, {VCard: VCard["a" /* default */],VProgressCircular: VProgressCircular["a" /* default */],VProgressLinear: VProgressLinear["a" /* default */]})


/***/ }),

/***/ "ba0d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("99af");
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("caad");
/* harmony import */ var core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_index_of_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("c975");
/* harmony import */ var core_js_modules_es_array_index_of_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("d81d");
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("a9e3");
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_number_to_fixed_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("b680");
/* harmony import */ var core_js_modules_es_number_to_fixed_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_to_fixed_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("d3b7");
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("25f0");
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("2532");
/* harmony import */ var core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_string_trim_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("498a");
/* harmony import */ var core_js_modules_es_string_trim_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_trim_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("ade3");
/* harmony import */ var _home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("5530");
/* harmony import */ var _src_components_VSlider_VSlider_sass__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("9e29");
/* harmony import */ var _src_components_VSlider_VSlider_sass__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_src_components_VSlider_VSlider_sass__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _VInput__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("c37a");
/* harmony import */ var _transitions__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("0789");
/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("58df");
/* harmony import */ var _mixins_loadable__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("297c");
/* harmony import */ var _directives_click_outside__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("a293");
/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("80d2");
/* harmony import */ var _util_console__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("d9bd");












 // Components


 // Mixins


 // Directives

 // Helpers



/* harmony default export */ __webpack_exports__["a"] = (Object(_util_mixins__WEBPACK_IMPORTED_MODULE_15__[/* default */ "a"])(_VInput__WEBPACK_IMPORTED_MODULE_13__[/* default */ "a"], _mixins_loadable__WEBPACK_IMPORTED_MODULE_16__[/* default */ "a"]
/* @vue/component */
).extend({
  name: 'v-slider',
  directives: {
    ClickOutside: _directives_click_outside__WEBPACK_IMPORTED_MODULE_17__[/* default */ "a"]
  },
  mixins: [_mixins_loadable__WEBPACK_IMPORTED_MODULE_16__[/* default */ "a"]],
  props: {
    disabled: Boolean,
    inverseLabel: Boolean,
    max: {
      type: [Number, String],
      default: 100
    },
    min: {
      type: [Number, String],
      default: 0
    },
    step: {
      type: [Number, String],
      default: 1
    },
    thumbColor: String,
    thumbLabel: {
      type: [Boolean, String],
      default: undefined,
      validator: function validator(v) {
        return typeof v === 'boolean' || v === 'always';
      }
    },
    thumbSize: {
      type: [Number, String],
      default: 32
    },
    tickLabels: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    ticks: {
      type: [Boolean, String],
      default: false,
      validator: function validator(v) {
        return typeof v === 'boolean' || v === 'always';
      }
    },
    tickSize: {
      type: [Number, String],
      default: 2
    },
    trackColor: String,
    trackFillColor: String,
    value: [Number, String],
    vertical: Boolean
  },
  data: function data() {
    return {
      app: null,
      oldValue: null,
      keyPressed: 0,
      isFocused: false,
      isActive: false,
      noClick: false
    };
  },
  computed: {
    classes: function classes() {
      return Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_11__[/* default */ "a"])(Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_11__[/* default */ "a"])({}, _VInput__WEBPACK_IMPORTED_MODULE_13__[/* default */ "a"].options.computed.classes.call(this)), {}, {
        'v-input__slider': true,
        'v-input__slider--vertical': this.vertical,
        'v-input__slider--inverse-label': this.inverseLabel
      });
    },
    internalValue: {
      get: function get() {
        return this.lazyValue;
      },
      set: function set(val) {
        val = isNaN(val) ? this.minValue : val; // Round value to ensure the
        // entire slider range can
        // be selected with step

        var value = this.roundValue(Math.min(Math.max(val, this.minValue), this.maxValue));
        if (value === this.lazyValue) return;
        this.lazyValue = value;
        this.$emit('input', value);
      }
    },
    trackTransition: function trackTransition() {
      return this.keyPressed >= 2 ? 'none' : '';
    },
    minValue: function minValue() {
      return parseFloat(this.min);
    },
    maxValue: function maxValue() {
      return parseFloat(this.max);
    },
    stepNumeric: function stepNumeric() {
      return this.step > 0 ? parseFloat(this.step) : 0;
    },
    inputWidth: function inputWidth() {
      return (this.roundValue(this.internalValue) - this.minValue) / (this.maxValue - this.minValue) * 100;
    },
    trackFillStyles: function trackFillStyles() {
      var _ref;

      var startDir = this.vertical ? 'bottom' : 'left';
      var endDir = this.vertical ? 'top' : 'right';
      var valueDir = this.vertical ? 'height' : 'width';
      var start = this.$vuetify.rtl ? 'auto' : '0';
      var end = this.$vuetify.rtl ? '0' : 'auto';
      var value = this.isDisabled ? "calc(".concat(this.inputWidth, "% - 10px)") : "".concat(this.inputWidth, "%");
      return _ref = {
        transition: this.trackTransition
      }, Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_10__[/* default */ "a"])(_ref, startDir, start), Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_10__[/* default */ "a"])(_ref, endDir, end), Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_10__[/* default */ "a"])(_ref, valueDir, value), _ref;
    },
    trackStyles: function trackStyles() {
      var _ref2;

      var startDir = this.vertical ? this.$vuetify.rtl ? 'bottom' : 'top' : this.$vuetify.rtl ? 'left' : 'right';
      var endDir = this.vertical ? 'height' : 'width';
      var start = '0px';
      var end = this.isDisabled ? "calc(".concat(100 - this.inputWidth, "% - 10px)") : "calc(".concat(100 - this.inputWidth, "%)");
      return _ref2 = {
        transition: this.trackTransition
      }, Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_10__[/* default */ "a"])(_ref2, startDir, start), Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_10__[/* default */ "a"])(_ref2, endDir, end), _ref2;
    },
    showTicks: function showTicks() {
      return this.tickLabels.length > 0 || !!(!this.isDisabled && this.stepNumeric && this.ticks);
    },
    numTicks: function numTicks() {
      return Math.ceil((this.maxValue - this.minValue) / this.stepNumeric);
    },
    showThumbLabel: function showThumbLabel() {
      return !this.isDisabled && !!(this.thumbLabel || this.$scopedSlots['thumb-label']);
    },
    computedTrackColor: function computedTrackColor() {
      if (this.isDisabled) return undefined;
      if (this.trackColor) return this.trackColor;
      if (this.isDark) return this.validationState;
      return this.validationState || 'primary lighten-3';
    },
    computedTrackFillColor: function computedTrackFillColor() {
      if (this.isDisabled) return undefined;
      if (this.trackFillColor) return this.trackFillColor;
      return this.validationState || this.computedColor;
    },
    computedThumbColor: function computedThumbColor() {
      if (this.thumbColor) return this.thumbColor;
      return this.validationState || this.computedColor;
    }
  },
  watch: {
    min: function min(val) {
      var parsed = parseFloat(val);
      parsed > this.internalValue && this.$emit('input', parsed);
    },
    max: function max(val) {
      var parsed = parseFloat(val);
      parsed < this.internalValue && this.$emit('input', parsed);
    },
    value: {
      handler: function handler(v) {
        this.internalValue = v;
      }
    }
  },
  // If done in as immediate in
  // value watcher, causes issues
  // with vue-test-utils
  beforeMount: function beforeMount() {
    this.internalValue = this.value;
  },
  mounted: function mounted() {
    // Without a v-app, iOS does not work with body selectors
    this.app = document.querySelector('[data-app]') || Object(_util_console__WEBPACK_IMPORTED_MODULE_19__[/* consoleWarn */ "c"])('Missing v-app or a non-body wrapping element with the [data-app] attribute', this);
  },
  methods: {
    genDefaultSlot: function genDefaultSlot() {
      var children = [this.genLabel()];
      var slider = this.genSlider();
      this.inverseLabel ? children.unshift(slider) : children.push(slider);
      children.push(this.genProgress());
      return children;
    },
    genSlider: function genSlider() {
      return this.$createElement('div', {
        class: Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_11__[/* default */ "a"])({
          'v-slider': true,
          'v-slider--horizontal': !this.vertical,
          'v-slider--vertical': this.vertical,
          'v-slider--focused': this.isFocused,
          'v-slider--active': this.isActive,
          'v-slider--disabled': this.isDisabled,
          'v-slider--readonly': this.isReadonly
        }, this.themeClasses),
        directives: [{
          name: 'click-outside',
          value: this.onBlur
        }],
        on: {
          click: this.onSliderClick,
          mousedown: this.onSliderMouseDown
        }
      }, this.genChildren());
    },
    genChildren: function genChildren() {
      return [this.genInput(), this.genTrackContainer(), this.genSteps(), this.genThumbContainer(this.internalValue, this.inputWidth, this.isActive, this.isFocused, this.onSliderMouseDown, this.onFocus, this.onBlur)];
    },
    genInput: function genInput() {
      return this.$createElement('input', {
        attrs: Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_11__[/* default */ "a"])({
          value: this.internalValue,
          id: this.computedId,
          disabled: true,
          readonly: true,
          tabindex: -1
        }, this.$attrs)
      });
    },
    genTrackContainer: function genTrackContainer() {
      var children = [this.$createElement('div', this.setBackgroundColor(this.computedTrackColor, {
        staticClass: 'v-slider__track-background',
        style: this.trackStyles
      })), this.$createElement('div', this.setBackgroundColor(this.computedTrackFillColor, {
        staticClass: 'v-slider__track-fill',
        style: this.trackFillStyles
      }))];
      return this.$createElement('div', {
        staticClass: 'v-slider__track-container',
        ref: 'track'
      }, children);
    },
    genSteps: function genSteps() {
      var _this = this;

      if (!this.step || !this.showTicks) return null;
      var tickSize = parseFloat(this.tickSize);
      var range = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_18__[/* createRange */ "h"])(this.numTicks + 1);
      var direction = this.vertical ? 'bottom' : this.$vuetify.rtl ? 'right' : 'left';
      var offsetDirection = this.vertical ? this.$vuetify.rtl ? 'left' : 'right' : 'top';
      if (this.vertical) range.reverse();
      var ticks = range.map(function (index) {
        var _style;

        var children = [];

        if (_this.tickLabels[index]) {
          children.push(_this.$createElement('div', {
            staticClass: 'v-slider__tick-label'
          }, _this.tickLabels[index]));
        }

        var width = index * (100 / _this.numTicks);
        var filled = _this.$vuetify.rtl ? 100 - _this.inputWidth < width : width < _this.inputWidth;
        return _this.$createElement('span', {
          key: index,
          staticClass: 'v-slider__tick',
          class: {
            'v-slider__tick--filled': filled
          },
          style: (_style = {
            width: "".concat(tickSize, "px"),
            height: "".concat(tickSize, "px")
          }, Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_10__[/* default */ "a"])(_style, direction, "calc(".concat(width, "% - ").concat(tickSize / 2, "px)")), Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_10__[/* default */ "a"])(_style, offsetDirection, "calc(50% - ".concat(tickSize / 2, "px)")), _style)
        }, children);
      });
      return this.$createElement('div', {
        staticClass: 'v-slider__ticks-container',
        class: {
          'v-slider__ticks-container--always-show': this.ticks === 'always' || this.tickLabels.length > 0
        }
      }, ticks);
    },
    genThumbContainer: function genThumbContainer(value, valueWidth, isActive, isFocused, onDrag, onFocus, onBlur) {
      var ref = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 'thumb';
      var children = [this.genThumb()];
      var thumbLabelContent = this.genThumbLabelContent(value);
      this.showThumbLabel && children.push(this.genThumbLabel(thumbLabelContent));
      return this.$createElement('div', this.setTextColor(this.computedThumbColor, {
        ref: ref,
        key: ref,
        staticClass: 'v-slider__thumb-container',
        class: {
          'v-slider__thumb-container--active': isActive,
          'v-slider__thumb-container--focused': isFocused,
          'v-slider__thumb-container--show-label': this.showThumbLabel
        },
        style: this.getThumbContainerStyles(valueWidth),
        attrs: Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_11__[/* default */ "a"])({
          role: 'slider',
          tabindex: this.isDisabled ? -1 : this.$attrs.tabindex ? this.$attrs.tabindex : 0,
          'aria-label': this.label,
          'aria-valuemin': this.min,
          'aria-valuemax': this.max,
          'aria-valuenow': this.internalValue,
          'aria-readonly': String(this.isReadonly),
          'aria-orientation': this.vertical ? 'vertical' : 'horizontal'
        }, this.$attrs),
        on: {
          focus: onFocus,
          blur: onBlur,
          keydown: this.onKeyDown,
          keyup: this.onKeyUp,
          touchstart: onDrag,
          mousedown: onDrag
        }
      }), children);
    },
    genThumbLabelContent: function genThumbLabelContent(value) {
      return this.$scopedSlots['thumb-label'] ? this.$scopedSlots['thumb-label']({
        value: value
      }) : [this.$createElement('span', [String(value)])];
    },
    genThumbLabel: function genThumbLabel(content) {
      var size = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_18__[/* convertToUnit */ "g"])(this.thumbSize);
      var transform = this.vertical ? "translateY(20%) translateY(".concat(Number(this.thumbSize) / 3 - 1, "px) translateX(55%) rotate(135deg)") : "translateY(-20%) translateY(-12px) translateX(-50%) rotate(45deg)";
      return this.$createElement(_transitions__WEBPACK_IMPORTED_MODULE_14__[/* VScaleTransition */ "e"], {
        props: {
          origin: 'bottom center'
        }
      }, [this.$createElement('div', {
        staticClass: 'v-slider__thumb-label-container',
        directives: [{
          name: 'show',
          value: this.isFocused || this.isActive || this.thumbLabel === 'always'
        }]
      }, [this.$createElement('div', this.setBackgroundColor(this.computedThumbColor, {
        staticClass: 'v-slider__thumb-label',
        style: {
          height: size,
          width: size,
          transform: transform
        }
      }), [this.$createElement('div', content)])])]);
    },
    genThumb: function genThumb() {
      return this.$createElement('div', this.setBackgroundColor(this.computedThumbColor, {
        staticClass: 'v-slider__thumb'
      }));
    },
    getThumbContainerStyles: function getThumbContainerStyles(width) {
      var direction = this.vertical ? 'top' : 'left';
      var value = this.$vuetify.rtl ? 100 - width : width;
      value = this.vertical ? 100 - value : value;
      return Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_10__[/* default */ "a"])({
        transition: this.trackTransition
      }, direction, "".concat(value, "%"));
    },
    onSliderMouseDown: function onSliderMouseDown(e) {
      e.preventDefault();
      this.oldValue = this.internalValue;
      this.keyPressed = 2;
      this.isActive = true;
      var mouseUpOptions = _util_helpers__WEBPACK_IMPORTED_MODULE_18__[/* passiveSupported */ "B"] ? {
        passive: true,
        capture: true
      } : true;
      var mouseMoveOptions = _util_helpers__WEBPACK_IMPORTED_MODULE_18__[/* passiveSupported */ "B"] ? {
        passive: true
      } : false;

      if ('touches' in e) {
        this.app.addEventListener('touchmove', this.onMouseMove, mouseMoveOptions);
        Object(_util_helpers__WEBPACK_IMPORTED_MODULE_18__[/* addOnceEventListener */ "a"])(this.app, 'touchend', this.onSliderMouseUp, mouseUpOptions);
      } else {
        this.onMouseMove(e);
        this.app.addEventListener('mousemove', this.onMouseMove, mouseMoveOptions);
        Object(_util_helpers__WEBPACK_IMPORTED_MODULE_18__[/* addOnceEventListener */ "a"])(this.app, 'mouseup', this.onSliderMouseUp, mouseUpOptions);
      }

      this.$emit('start', this.internalValue);
    },
    onSliderMouseUp: function onSliderMouseUp(e) {
      e.stopPropagation();
      this.keyPressed = 0;
      var mouseMoveOptions = _util_helpers__WEBPACK_IMPORTED_MODULE_18__[/* passiveSupported */ "B"] ? {
        passive: true
      } : false;
      this.app.removeEventListener('touchmove', this.onMouseMove, mouseMoveOptions);
      this.app.removeEventListener('mousemove', this.onMouseMove, mouseMoveOptions);
      this.$emit('mouseup', e);
      this.$emit('end', this.internalValue);

      if (!Object(_util_helpers__WEBPACK_IMPORTED_MODULE_18__[/* deepEqual */ "j"])(this.oldValue, this.internalValue)) {
        this.$emit('change', this.internalValue);
        this.noClick = true;
      }

      this.isActive = false;
    },
    onMouseMove: function onMouseMove(e) {
      var _this$parseMouseMove = this.parseMouseMove(e),
          value = _this$parseMouseMove.value;

      this.internalValue = value;
    },
    onKeyDown: function onKeyDown(e) {
      if (!this.isInteractive) return;
      var value = this.parseKeyDown(e, this.internalValue);
      if (value == null || value < this.minValue || value > this.maxValue) return;
      this.internalValue = value;
      this.$emit('change', value);
    },
    onKeyUp: function onKeyUp() {
      this.keyPressed = 0;
    },
    onSliderClick: function onSliderClick(e) {
      if (this.noClick) {
        this.noClick = false;
        return;
      }

      var thumb = this.$refs.thumb;
      thumb.focus();
      this.onMouseMove(e);
      this.$emit('change', this.internalValue);
    },
    onBlur: function onBlur(e) {
      this.isFocused = false;
      this.$emit('blur', e);
    },
    onFocus: function onFocus(e) {
      this.isFocused = true;
      this.$emit('focus', e);
    },
    parseMouseMove: function parseMouseMove(e) {
      var start = this.vertical ? 'top' : 'left';
      var length = this.vertical ? 'height' : 'width';
      var click = this.vertical ? 'clientY' : 'clientX';

      var _this$$refs$track$get = this.$refs.track.getBoundingClientRect(),
          trackStart = _this$$refs$track$get[start],
          trackLength = _this$$refs$track$get[length];

      var clickOffset = 'touches' in e ? e.touches[0][click] : e[click]; // Can we get rid of any here?
      // It is possible for left to be NaN, force to number

      var clickPos = Math.min(Math.max((clickOffset - trackStart) / trackLength, 0), 1) || 0;
      if (this.vertical) clickPos = 1 - clickPos;
      if (this.$vuetify.rtl) clickPos = 1 - clickPos;
      var isInsideTrack = clickOffset >= trackStart && clickOffset <= trackStart + trackLength;
      var value = parseFloat(this.min) + clickPos * (this.maxValue - this.minValue);
      return {
        value: value,
        isInsideTrack: isInsideTrack
      };
    },
    parseKeyDown: function parseKeyDown(e, value) {
      if (!this.isInteractive) return;
      var pageup = _util_helpers__WEBPACK_IMPORTED_MODULE_18__[/* keyCodes */ "x"].pageup,
          pagedown = _util_helpers__WEBPACK_IMPORTED_MODULE_18__[/* keyCodes */ "x"].pagedown,
          end = _util_helpers__WEBPACK_IMPORTED_MODULE_18__[/* keyCodes */ "x"].end,
          home = _util_helpers__WEBPACK_IMPORTED_MODULE_18__[/* keyCodes */ "x"].home,
          left = _util_helpers__WEBPACK_IMPORTED_MODULE_18__[/* keyCodes */ "x"].left,
          right = _util_helpers__WEBPACK_IMPORTED_MODULE_18__[/* keyCodes */ "x"].right,
          down = _util_helpers__WEBPACK_IMPORTED_MODULE_18__[/* keyCodes */ "x"].down,
          up = _util_helpers__WEBPACK_IMPORTED_MODULE_18__[/* keyCodes */ "x"].up;
      if (![pageup, pagedown, end, home, left, right, down, up].includes(e.keyCode)) return;
      e.preventDefault();
      var step = this.stepNumeric || 1;
      var steps = (this.maxValue - this.minValue) / step;

      if ([left, right, down, up].includes(e.keyCode)) {
        this.keyPressed += 1;
        var increase = this.$vuetify.rtl ? [left, up] : [right, up];
        var direction = increase.includes(e.keyCode) ? 1 : -1;
        var multiplier = e.shiftKey ? 3 : e.ctrlKey ? 2 : 1;
        value = value + direction * step * multiplier;
      } else if (e.keyCode === home) {
        value = this.minValue;
      } else if (e.keyCode === end) {
        value = this.maxValue;
      } else {
        var _direction = e.keyCode === pagedown ? 1 : -1;

        value = value - _direction * step * (steps > 100 ? steps / 10 : 10);
      }

      return value;
    },
    roundValue: function roundValue(value) {
      if (!this.stepNumeric) return value; // Format input value using the same number
      // of decimals places as in the step prop

      var trimmedStep = this.step.toString().trim();
      var decimals = trimmedStep.indexOf('.') > -1 ? trimmedStep.length - trimmedStep.indexOf('.') - 1 : 0;
      var offset = this.minValue % this.stepNumeric;
      var newValue = Math.round((value - offset) / this.stepNumeric) * this.stepNumeric + offset;
      return parseFloat(Math.min(newValue, this.maxValue).toFixed(decimals));
    }
  }
}));

/***/ }),

/***/ "ba87":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// UNUSED EXPORTS: VLabel

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__("a9e3");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__("5530");

// EXTERNAL MODULE: ./node_modules/vuetify/src/components/VLabel/VLabel.sass
var VLabel = __webpack_require__("1b2c");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/mixins/colorable/index.js
var colorable = __webpack_require__("a9ad");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/mixins/themeable/index.js
var themeable = __webpack_require__("7560");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/util/mixins.js
var mixins = __webpack_require__("58df");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/util/helpers.js
var helpers = __webpack_require__("80d2");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VLabel/VLabel.js


// Styles
 // Mixins



 // Helpers


/* @vue/component */

/* harmony default export */ var VLabel_VLabel = (Object(mixins["a" /* default */])(themeable["a" /* default */]).extend({
  name: 'v-label',
  functional: true,
  props: {
    absolute: Boolean,
    color: {
      type: String,
      default: 'primary'
    },
    disabled: Boolean,
    focused: Boolean,
    for: String,
    left: {
      type: [Number, String],
      default: 0
    },
    right: {
      type: [Number, String],
      default: 'auto'
    },
    value: Boolean
  },
  render: function render(h, ctx) {
    var children = ctx.children,
        listeners = ctx.listeners,
        props = ctx.props;
    var data = {
      staticClass: 'v-label',
      class: Object(objectSpread2["a" /* default */])({
        'v-label--active': props.value,
        'v-label--is-disabled': props.disabled
      }, Object(themeable["b" /* functionalThemeClasses */])(ctx)),
      attrs: {
        for: props.for,
        'aria-hidden': !props.for
      },
      on: listeners,
      style: {
        left: Object(helpers["g" /* convertToUnit */])(props.left),
        right: Object(helpers["g" /* convertToUnit */])(props.right),
        position: props.absolute ? 'absolute' : 'relative'
      },
      ref: 'label'
    };
    return h('label', colorable["a" /* default */].options.methods.setTextColor(props.focused && props.color, data), children);
  }
}));
// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VLabel/index.js


/* harmony default export */ var components_VLabel = __webpack_exports__["a"] = (VLabel_VLabel);

/***/ }),

/***/ "badb":
/***/ (function(module, exports, __webpack_require__) {

var addMilliseconds = __webpack_require__("ec1f")

/**
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted
 * @returns {Date} the new date with the milliseconds subtracted
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * var result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */
function subMilliseconds (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addMilliseconds(dirtyDate, -amount)
}

module.exports = subMilliseconds


/***/ }),

/***/ "bb18":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("2c3a");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("5f549d02", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "bb2f":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");

module.exports = !fails(function () {
  return Object.isExtensible(Object.preventExtensions({}));
});


/***/ }),

/***/ "bb4d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c662cfac-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/expansion-panel/PpExpansionPanel.vue?vue&type=template&id=30219416&scoped=true&
var PpExpansionPanelvue_type_template_id_30219416_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-expansion-panel',_vm._g(_vm._b({},'v-expansion-panel',_vm.$attrs,false),_vm.$listeners),[_c('v-expansion-panel-header',{attrs:{"disable-icon-rotate":_vm.disableIconRotate,"expand-icon":"mdi-chevron-down"},scopedSlots:_vm._u([(_vm.hasCustomIcon)?{key:"actions",fn:function(){return [_c('i',{class:[("pp-icon-" + _vm.customIcon)]})]},proxy:true}:null],null,true)},[_c('span',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.title)+_vm._s(_vm.value))]),(_vm.subtitle)?_c('span',{staticClass:"font-italic text-right"},[_vm._v(" "+_vm._s(_vm.subtitle)+" ")]):_vm._e()]),_c('v-expansion-panel-content',{class:{ 'text-center': _vm.loading }},[(_vm.loading)?_c('v-progress-circular',{attrs:{"indeterminate":""}}):_vm._t("content")],2)],1)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/expansion-panel/PpExpansionPanel.vue?vue&type=template&id=30219416&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/expansion-panel/PpExpansionPanel.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * To use the expansion panel, will need to be wrapped in PpExpansionPanels
 */
/* harmony default export */ var PpExpansionPanelvue_type_script_lang_js_ = ({
  name: 'PpExpansionPanel',
  components: {},
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      default: ''
    },
    disableIconRotate: {
      type: Boolean,
      default: false
    },
    customIcon: {
      type: String,
      default: ''
    }
  },
  computed: {
    hasCustomIcon: function hasCustomIcon() {
      return !!this.customIcon;
    }
  }
});
// CONCATENATED MODULE: ./src/components/expansion-panel/PpExpansionPanel.vue?vue&type=script&lang=js&
 /* harmony default export */ var expansion_panel_PpExpansionPanelvue_type_script_lang_js_ = (PpExpansionPanelvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/expansion-panel/PpExpansionPanel.vue?vue&type=style&index=0&id=30219416&lang=scss&scoped=true&
var PpExpansionPanelvue_type_style_index_0_id_30219416_lang_scss_scoped_true_ = __webpack_require__("65c5");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// EXTERNAL MODULE: ./node_modules/vuetify-loader/lib/runtime/installComponents.js
var installComponents = __webpack_require__("6544");
var installComponents_default = /*#__PURE__*/__webpack_require__.n(installComponents);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__("5530");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/mixins/groupable/index.js
var groupable = __webpack_require__("4e82");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/mixins/registrable/index.js
var registrable = __webpack_require__("3206");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/util/helpers.js
var helpers = __webpack_require__("80d2");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/util/mixins.js
var mixins = __webpack_require__("58df");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VExpansionPanel/VExpansionPanel.js

// Mixins

 // Utilities



/* harmony default export */ var VExpansionPanel = (Object(mixins["a" /* default */])(Object(groupable["a" /* factory */])('expansionPanels', 'v-expansion-panel', 'v-expansion-panels'), Object(registrable["b" /* provide */])('expansionPanel', true)
/* @vue/component */
).extend({
  name: 'v-expansion-panel',
  props: {
    disabled: Boolean,
    readonly: Boolean
  },
  data: function data() {
    return {
      content: null,
      header: null,
      nextIsActive: false
    };
  },
  computed: {
    classes: function classes() {
      return Object(objectSpread2["a" /* default */])({
        'v-expansion-panel--active': this.isActive,
        'v-expansion-panel--next-active': this.nextIsActive,
        'v-expansion-panel--disabled': this.isDisabled
      }, this.groupClasses);
    },
    isDisabled: function isDisabled() {
      return this.expansionPanels.disabled || this.disabled;
    },
    isReadonly: function isReadonly() {
      return this.expansionPanels.readonly || this.readonly;
    }
  },
  methods: {
    registerContent: function registerContent(vm) {
      this.content = vm;
    },
    unregisterContent: function unregisterContent() {
      this.content = null;
    },
    registerHeader: function registerHeader(vm) {
      this.header = vm;
      vm.$on('click', this.onClick);
    },
    unregisterHeader: function unregisterHeader() {
      this.header = null;
    },
    onClick: function onClick(e) {
      if (e.detail) this.header.$el.blur();
      this.$emit('click', e);
      this.isReadonly || this.isDisabled || this.toggle();
    },
    toggle: function toggle() {
      var _this = this;

      /* istanbul ignore else */
      if (this.content) this.content.isBooted = true;
      this.$nextTick(function () {
        return _this.$emit('change');
      });
    }
  },
  render: function render(h) {
    return h('div', {
      staticClass: 'v-expansion-panel',
      class: this.classes,
      attrs: {
        'aria-expanded': String(this.isActive)
      }
    }, Object(helpers["s" /* getSlot */])(this));
  }
}));
// EXTERNAL MODULE: ./node_modules/vuetify/lib/components/transitions/index.js + 2 modules
var transitions = __webpack_require__("0789");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/mixins/bootable/index.js
var bootable = __webpack_require__("9d65");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/mixins/colorable/index.js
var colorable = __webpack_require__("a9ad");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VExpansionPanel/VExpansionPanelContent.js
 // Mixins



 // Utilities



var baseMixins = Object(mixins["a" /* default */])(bootable["a" /* default */], colorable["a" /* default */], Object(registrable["a" /* inject */])('expansionPanel', 'v-expansion-panel-content', 'v-expansion-panel'));
/* @vue/component */

/* harmony default export */ var VExpansionPanelContent = (baseMixins.extend().extend({
  name: 'v-expansion-panel-content',
  computed: {
    isActive: function isActive() {
      return this.expansionPanel.isActive;
    }
  },
  created: function created() {
    this.expansionPanel.registerContent(this);
  },
  beforeDestroy: function beforeDestroy() {
    this.expansionPanel.unregisterContent();
  },
  render: function render(h) {
    var _this = this;

    return h(transitions["a" /* VExpandTransition */], this.showLazyContent(function () {
      return [h('div', _this.setBackgroundColor(_this.color, {
        staticClass: 'v-expansion-panel-content',
        directives: [{
          name: 'show',
          value: _this.isActive
        }]
      }), [h('div', {
        class: 'v-expansion-panel-content__wrap'
      }, Object(helpers["s" /* getSlot */])(_this))])];
    }));
  }
}));
// EXTERNAL MODULE: ./node_modules/vuetify/lib/components/VIcon/index.js
var VIcon = __webpack_require__("9d26");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/directives/ripple/index.js
var ripple = __webpack_require__("5607");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VExpansionPanel/VExpansionPanelHeader.js

// Components

 // Mixins


 // Directives

 // Utilities



var VExpansionPanelHeader_baseMixins = Object(mixins["a" /* default */])(colorable["a" /* default */], Object(registrable["a" /* inject */])('expansionPanel', 'v-expansion-panel-header', 'v-expansion-panel'));
/* harmony default export */ var VExpansionPanelHeader = (VExpansionPanelHeader_baseMixins.extend().extend({
  name: 'v-expansion-panel-header',
  directives: {
    ripple: ripple["a" /* default */]
  },
  props: {
    disableIconRotate: Boolean,
    expandIcon: {
      type: String,
      default: '$expand'
    },
    hideActions: Boolean,
    ripple: {
      type: [Boolean, Object],
      default: false
    }
  },
  data: function data() {
    return {
      hasMousedown: false
    };
  },
  computed: {
    classes: function classes() {
      return {
        'v-expansion-panel-header--active': this.isActive,
        'v-expansion-panel-header--mousedown': this.hasMousedown
      };
    },
    isActive: function isActive() {
      return this.expansionPanel.isActive;
    },
    isDisabled: function isDisabled() {
      return this.expansionPanel.isDisabled;
    },
    isReadonly: function isReadonly() {
      return this.expansionPanel.isReadonly;
    }
  },
  created: function created() {
    this.expansionPanel.registerHeader(this);
  },
  beforeDestroy: function beforeDestroy() {
    this.expansionPanel.unregisterHeader();
  },
  methods: {
    onClick: function onClick(e) {
      this.$emit('click', e);
    },
    genIcon: function genIcon() {
      var icon = Object(helpers["s" /* getSlot */])(this, 'actions') || [this.$createElement(VIcon["a" /* default */], this.expandIcon)];
      return this.$createElement(transitions["d" /* VFadeTransition */], [this.$createElement('div', {
        staticClass: 'v-expansion-panel-header__icon',
        class: {
          'v-expansion-panel-header__icon--disable-rotate': this.disableIconRotate
        },
        directives: [{
          name: 'show',
          value: !this.isDisabled
        }]
      }, icon)]);
    }
  },
  render: function render(h) {
    var _this = this;

    return h('button', this.setBackgroundColor(this.color, {
      staticClass: 'v-expansion-panel-header',
      class: this.classes,
      attrs: {
        tabindex: this.isDisabled ? -1 : null,
        type: 'button'
      },
      directives: [{
        name: 'ripple',
        value: this.ripple
      }],
      on: Object(objectSpread2["a" /* default */])(Object(objectSpread2["a" /* default */])({}, this.$listeners), {}, {
        click: this.onClick,
        mousedown: function mousedown() {
          return _this.hasMousedown = true;
        },
        mouseup: function mouseup() {
          return _this.hasMousedown = false;
        }
      })
    }), [Object(helpers["s" /* getSlot */])(this, 'default', {
      open: this.isActive
    }, true), this.hideActions || this.genIcon()]);
  }
}));
// EXTERNAL MODULE: ./node_modules/vuetify/lib/components/VProgressCircular/VProgressCircular.js
var VProgressCircular = __webpack_require__("490a");

// CONCATENATED MODULE: ./src/components/expansion-panel/PpExpansionPanel.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  expansion_panel_PpExpansionPanelvue_type_script_lang_js_,
  PpExpansionPanelvue_type_template_id_30219416_scoped_true_render,
  staticRenderFns,
  false,
  null,
  "30219416",
  null
  
)

/* harmony default export */ var PpExpansionPanel = __webpack_exports__["default"] = (component.exports);

/* vuetify-loader */





installComponents_default()(component, {VExpansionPanel: VExpansionPanel,VExpansionPanelContent: VExpansionPanelContent,VExpansionPanelHeader: VExpansionPanelHeader,VProgressCircular: VProgressCircular["a" /* default */]})


/***/ }),

/***/ "bb7c":
/***/ (function(module, exports, __webpack_require__) {

var compareDesc = __webpack_require__("c873")
var parse = __webpack_require__("c8d5")
var differenceInSeconds = __webpack_require__("e13a")
var enLocale = __webpack_require__("52cf")

var MINUTES_IN_DAY = 1440
var MINUTES_IN_MONTH = 43200
var MINUTES_IN_YEAR = 525600

/**
 * @category Common Helpers
 * @summary Return the distance between the given dates in words.
 *
 * @description
 * Return the distance between the given dates in words, using strict units.
 * This is like `distanceInWords`, but does not use helpers like 'almost', 'over',
 * 'less than' and the like.
 *
 * | Distance between dates | Result              |
 * |------------------------|---------------------|
 * | 0 ... 59 secs          | [0..59] seconds     |
 * | 1 ... 59 mins          | [1..59] minutes     |
 * | 1 ... 23 hrs           | [1..23] hours       |
 * | 1 ... 29 days          | [1..29] days        |
 * | 1 ... 11 months        | [1..11] months      |
 * | 1 ... N years          | [1..N]  years       |
 *
 * @param {Date|String|Number} dateToCompare - the date to compare with
 * @param {Date|String|Number} date - the other date
 * @param {Object} [options] - the object with options
 * @param {Boolean} [options.addSuffix=false] - result indicates if the second date is earlier or later than the first
 * @param {'s'|'m'|'h'|'d'|'M'|'Y'} [options.unit] - if specified, will force a unit
 * @param {'floor'|'ceil'|'round'} [options.partialMethod='floor'] - which way to round partial units
 * @param {Object} [options.locale=enLocale] - the locale object
 * @returns {String} the distance in words
 *
 * @example
 * // What is the distance between 2 July 2014 and 1 January 2015?
 * var result = distanceInWordsStrict(
 *   new Date(2014, 6, 2),
 *   new Date(2015, 0, 2)
 * )
 * //=> '6 months'
 *
 * @example
 * // What is the distance between 1 January 2015 00:00:15
 * // and 1 January 2015 00:00:00?
 * var result = distanceInWordsStrict(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   new Date(2015, 0, 1, 0, 0, 0),
 * )
 * //=> '15 seconds'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, with a suffix?
 * var result = distanceInWordsStrict(
 *   new Date(2016, 0, 1),
 *   new Date(2015, 0, 1),
 *   {addSuffix: true}
 * )
 * //=> '1 year ago'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, in minutes?
 * var result = distanceInWordsStrict(
 *   new Date(2016, 0, 1),
 *   new Date(2015, 0, 1),
 *   {unit: 'm'}
 * )
 * //=> '525600 minutes'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 28 January 2015, in months, rounded up?
 * var result = distanceInWordsStrict(
 *   new Date(2015, 0, 28),
 *   new Date(2015, 0, 1),
 *   {unit: 'M', partialMethod: 'ceil'}
 * )
 * //=> '1 month'
 *
 * @example
 * // What is the distance between 1 August 2016 and 1 January 2015 in Esperanto?
 * var eoLocale = require('date-fns/locale/eo')
 * var result = distanceInWordsStrict(
 *   new Date(2016, 7, 1),
 *   new Date(2015, 0, 1),
 *   {locale: eoLocale}
 * )
 * //=> '1 jaro'
 */
function distanceInWordsStrict (dirtyDateToCompare, dirtyDate, dirtyOptions) {
  var options = dirtyOptions || {}

  var comparison = compareDesc(dirtyDateToCompare, dirtyDate)

  var locale = options.locale
  var localize = enLocale.distanceInWords.localize
  if (locale && locale.distanceInWords && locale.distanceInWords.localize) {
    localize = locale.distanceInWords.localize
  }

  var localizeOptions = {
    addSuffix: Boolean(options.addSuffix),
    comparison: comparison
  }

  var dateLeft, dateRight
  if (comparison > 0) {
    dateLeft = parse(dirtyDateToCompare)
    dateRight = parse(dirtyDate)
  } else {
    dateLeft = parse(dirtyDate)
    dateRight = parse(dirtyDateToCompare)
  }

  var unit
  var mathPartial = Math[options.partialMethod ? String(options.partialMethod) : 'floor']
  var seconds = differenceInSeconds(dateRight, dateLeft)
  var offset = dateRight.getTimezoneOffset() - dateLeft.getTimezoneOffset()
  var minutes = mathPartial(seconds / 60) - offset
  var hours, days, months, years

  if (options.unit) {
    unit = String(options.unit)
  } else {
    if (minutes < 1) {
      unit = 's'
    } else if (minutes < 60) {
      unit = 'm'
    } else if (minutes < MINUTES_IN_DAY) {
      unit = 'h'
    } else if (minutes < MINUTES_IN_MONTH) {
      unit = 'd'
    } else if (minutes < MINUTES_IN_YEAR) {
      unit = 'M'
    } else {
      unit = 'Y'
    }
  }

  // 0 up to 60 seconds
  if (unit === 's') {
    return localize('xSeconds', seconds, localizeOptions)

  // 1 up to 60 mins
  } else if (unit === 'm') {
    return localize('xMinutes', minutes, localizeOptions)

  // 1 up to 24 hours
  } else if (unit === 'h') {
    hours = mathPartial(minutes / 60)
    return localize('xHours', hours, localizeOptions)

  // 1 up to 30 days
  } else if (unit === 'd') {
    days = mathPartial(minutes / MINUTES_IN_DAY)
    return localize('xDays', days, localizeOptions)

  // 1 up to 12 months
  } else if (unit === 'M') {
    months = mathPartial(minutes / MINUTES_IN_MONTH)
    return localize('xMonths', months, localizeOptions)

  // 1 year up to max Date
  } else if (unit === 'Y') {
    years = mathPartial(minutes / MINUTES_IN_YEAR)
    return localize('xYears', years, localizeOptions)
  }

  throw new Error('Unknown unit: ' + unit)
}

module.exports = distanceInWordsStrict


/***/ }),

/***/ "bb90":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4 19.9999V14.9999H5C5.265 14.9999 5.52 14.8939 5.707 14.7069L7 13.4139L9.293 15.7069C9.481 15.8949 9.735 15.9999 10 15.9999C10.019 15.9999 10.036 15.9989 10.056 15.9979C10.34 15.9819 10.603 15.8469 10.781 15.6239L14.083 11.4969L17.293 14.7069C17.684 15.0969 18.316 15.0969 18.707 14.7069L20.414 12.9999H19.998L19.997 19.9999H4Z\" fill=\"#DFE4E5\"></path><path d=\"M3 3H20V13.5L14 11L10 14L7 13L3 14V3Z\" fill=\"white\"></path><rect x=\"3\" y=\"3\" width=\"18\" height=\"18\" rx=\"2\" stroke=\"#1F3A3E\" stroke-width=\"2\"></rect><path d=\"M5 15.0007H4V13.0007H4.586L6.293 11.2937C6.684 10.9017 7.316 10.9017 7.707 11.2937L9.917 13.5027L13.219 9.37574C13.397 9.15274 13.66 9.01774 13.944 9.00174C14.229 8.98474 14.506 9.09274 14.707 9.29374L18 12.5857L19.293 11.2937C19.48 11.1057 19.735 11.0007 19.998 11.0007L20.0073 13.4017L18.707 14.7077C18.316 15.0977 17.684 15.0977 17.293 14.7077L14.083 11.4977L10.781 15.6247C10.603 15.8477 10.34 15.9827 10.056 15.9987C10.036 15.9997 10.019 16.0007 10 16.0007C9.735 16.0007 9.481 15.8957 9.293 15.7077L7 13.4147L5.707 14.7077C5.52 14.8947 5.265 15.0007 5 15.0007Z\" fill=\"#1F3A3E\"></path></svg>";

/***/ }),

/***/ "bbb5":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><rect x=\"1\" y=\"4\" width=\"22\" height=\"16\" rx=\"3\" fill=\"white\" stroke=\"#688083\" stroke-width=\"2\"></rect><rect x=\"2\" y=\"8\" width=\"20\" height=\"3\" fill=\"#DFE4E5\"></rect><rect x=\"4\" y=\"15\" width=\"6\" height=\"2\" rx=\"1\" fill=\"#688083\"></rect></svg>";

/***/ }),

/***/ "bbfd":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.i, "@import url(https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css);"]);
exports.push([module.i, "@import url(https://cdn-prd.patientpop.com/pp-icon-font/v1.6.0/pp-icon-font.css);"]);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.v-expansion-panel-header[data-v-30219416]{flex-direction:row-reverse}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "bdd2":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("5692e");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("477713ab", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "bdf9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c662cfac-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/dialog/PpDialog.vue?vue&type=template&id=8d2ba264&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value)?_c('v-dialog',{attrs:{"persistent":true,"value":_vm.value,"max-width":_vm.maxWidth,"content-class":_vm.contentClass,"fullscreen":_vm.isFullScreen,"attach":_vm.attach},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.onEscapeKeyPressed($event)},"click:outside":_vm.onOutsideClick}},[_c('v-card',{staticClass:"display-dialog-content",attrs:{"tag":_vm.isForm ? 'form' : 'div'},on:{"submit":function($event){$event.preventDefault();return _vm.emitConfirm($event)}}},[(!_vm.hideCloseButton)?_c('pp-button',{staticClass:"close-button",attrs:{"absolute":"","right":"","type":"icon","icon":"close"},on:{"click":_vm.onCloseBtnClick}}):_vm._e(),(_vm.title || _vm.$slots.title)?_c('v-card-title',{staticClass:"headline font-weight-bold text-h3 display-dialog-content__title"},[(_vm.prependTitleIcon)?_c('i',{class:("mr-4 d-inline-flex pp-icon-" + _vm.prependTitleIcon)}):_vm._e(),_vm._t("title",[_vm._v(" "+_vm._s(_vm.title)+" ")])],2):_vm._e(),(_vm.$slots.body || _vm.body)?_c('v-card-text',{staticClass:"display-dialog-content__body"},[_vm._t("body",[_vm._v(" "+_vm._s(_vm.body)+" ")])],2):_vm._e(),(_vm.showDialogActions)?_c('v-card-actions',{staticClass:"display-dialog-content__actions",class:_vm.justifyClass},[_vm._t("secondary-action",[(_vm.isSecondaryButtonShown)?_c('pp-button',{attrs:{"type":"secondary","text":_vm.secondaryButtonText},on:{"click":_vm.onSecondaryBtnClick}}):_vm._e()]),(!_vm.hidePrimaryButton)?_c('pp-button',{attrs:{"type":_vm.caution ? 'caution' : 'primary',"disabled":_vm.disablePrimaryButton,"text":_vm.primaryButtonText,"block":_vm.fullWidthPrimaryButton,"loading":_vm.loading,"submit":_vm.isForm},on:{"click":_vm.onPrimaryBtnClick}}):_vm._e()],2):_vm._e()],1)],1):_vm._e()}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/dialog/PpDialog.vue?vue&type=template&id=8d2ba264&scoped=true&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__("a9e3");

// EXTERNAL MODULE: ./src/components/button/PpButton.vue + 5 modules
var PpButton = __webpack_require__("251c");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/dialog/PpDialog.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var PpDialogvue_type_script_lang_js_ = ({
  name: 'PpDialog',
  components: {
    'pp-button': PpButton["default"]
  },
  props: {
    /**
     * This is used to determine if the dialog will show or not
     */
    value: {
      type: Boolean,
      required: true
    },

    /**
     * Max width for the dialog modal, should be a number of pixels
     */
    maxWidth: {
      type: Number,
      default: 500
    },
    contentClass: {
      type: String,
      required: false,
      default: 'pp-dialog'
    },

    /**
     * Dialog title
     */
    title: {
      type: String,
      default: '',
      required: false
    },

    /**
     * Body for dialog modal
     */
    body: {
      type: String,
      default: '',
      required: false
    },

    /**
     * Display text for secondary button
     */
    secondaryButtonText: {
      type: String,
      default: '',
      required: false
    },

    /**
     * Display text for primary button
     */
    primaryButtonText: {
      type: String,
      default: ''
    },

    /**
     * Set disabled for primary button
     */
    disablePrimaryButton: {
      type: Boolean,
      default: false
    },

    /**
     * Set hiding for secondary button
     */
    hideSecondaryButton: {
      type: Boolean,
      default: false
    },

    /**
     * Hide/show dialog actions
     */
    showDialogActions: {
      type: Boolean,
      default: true
    },

    /**
     * primary button in loading state
     */
    loading: {
      type: Boolean,
      default: false
    },
    fullWidthPrimaryButton: {
      type: Boolean,
      default: false
    },
    hidePrimaryButton: {
      type: Boolean,
      default: false
    },
    fullScreen: {
      type: Boolean,
      default: false
    },

    /**
     * Sets the primary button type to a caution button
     */
    caution: {
      type: Boolean,
      default: false
    },

    /**
     * Using pp-icon-font icon name to set prepend Icon for dialog title e.g.: 'email'
     */
    prependTitleIcon: {
      type: String,
      default: null
    },

    /**
     * Used to wrap content of dialog in form tag and use the submit functionality to trigger the primaryCta
     */
    isForm: {
      type: Boolean,
      default: false
    },

    /**
     * attach the dialog to an element
     */
    attach: {
      type: [String, Boolean],
      default: false
    },

    /**
     * Hides the close button
     */
    hideCloseButton: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    var _this$$ppUi;

    return {
      isMobile: (_this$$ppUi = this.$ppUi) === null || _this$$ppUi === void 0 ? void 0 : _this$$ppUi.isMobile
    };
  },
  computed: {
    isSecondaryButtonShown: function isSecondaryButtonShown() {
      return !this.fullWidthPrimaryButton && !this.hideSecondaryButton;
    },
    justifyClass: function justifyClass() {
      return !this.fullWidthPrimaryButton && this.hideSecondaryButton ? 'justify-end' : 'justify-space-between';
    },
    isFullScreen: function isFullScreen() {
      return this.isMobile || this.fullScreen;
    }
  },
  methods: {
    onEscapeKeyPressed: function onEscapeKeyPressed() {
      this.$emit('close', 'key-escape');
    },
    onOutsideClick: function onOutsideClick() {
      this.$emit('click-outside');
    },
    onCloseBtnClick: function onCloseBtnClick() {
      this.$emit('close', 'close-button');
    },
    onSecondaryBtnClick: function onSecondaryBtnClick() {
      this.$emit('close', 'secondary-button');
    },
    onPrimaryBtnClick: function onPrimaryBtnClick() {
      if (!this.isForm) {
        this.emitConfirm();
      }
    },
    emitConfirm: function emitConfirm() {
      if (!this.loading) {
        this.$emit('confirm');
      }
    }
  }
});
// CONCATENATED MODULE: ./src/components/dialog/PpDialog.vue?vue&type=script&lang=js&
 /* harmony default export */ var dialog_PpDialogvue_type_script_lang_js_ = (PpDialogvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/dialog/PpDialog.vue?vue&type=style&index=0&id=8d2ba264&lang=scss&scoped=true&
var PpDialogvue_type_style_index_0_id_8d2ba264_lang_scss_scoped_true_ = __webpack_require__("9ebc");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// EXTERNAL MODULE: ./node_modules/vuetify-loader/lib/runtime/installComponents.js
var installComponents = __webpack_require__("6544");
var installComponents_default = /*#__PURE__*/__webpack_require__.n(installComponents);

// EXTERNAL MODULE: ./node_modules/vuetify/lib/components/VCard/VCard.js
var VCard = __webpack_require__("b0af");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/components/VCard/index.js
var components_VCard = __webpack_require__("99d9");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__("7db0");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("caad");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.some.js
var es_array_some = __webpack_require__("45fc");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("2532");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.trim.js
var es_string_trim = __webpack_require__("498a");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__("5530");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__("2909");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("ade3");

// EXTERNAL MODULE: ./node_modules/vuetify/src/components/VDialog/VDialog.sass
var VDialog = __webpack_require__("368e");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/components/VThemeProvider/VThemeProvider.js
var VThemeProvider = __webpack_require__("480e");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/mixins/activatable/index.js
var activatable = __webpack_require__("4ad4");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/mixins/dependent/index.js
var dependent = __webpack_require__("b848");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/mixins/detachable/index.js
var detachable = __webpack_require__("75eb");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/mixins/overlayable/index.js
var overlayable = __webpack_require__("e707");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/mixins/returnable/index.js
var returnable = __webpack_require__("e4d3");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/mixins/stackable/index.js
var stackable = __webpack_require__("21be");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/mixins/toggleable/index.js
var toggleable = __webpack_require__("f2e7");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/directives/click-outside/index.js
var click_outside = __webpack_require__("a293");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/util/mixins.js
var mixins = __webpack_require__("58df");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/util/console.js + 32 modules
var console = __webpack_require__("d9bd");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/util/helpers.js
var helpers = __webpack_require__("80d2");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VDialog/VDialog.js









// Styles
 // Components

 // Mixins







 // Directives

 // Helpers




var baseMixins = Object(mixins["a" /* default */])(activatable["a" /* default */], dependent["a" /* default */], detachable["a" /* default */], overlayable["a" /* default */], returnable["a" /* default */], stackable["a" /* default */], toggleable["a" /* default */]);
/* @vue/component */

/* harmony default export */ var VDialog_VDialog = (baseMixins.extend({
  name: 'v-dialog',
  directives: {
    ClickOutside: click_outside["a" /* default */]
  },
  props: {
    dark: Boolean,
    disabled: Boolean,
    fullscreen: Boolean,
    light: Boolean,
    maxWidth: {
      type: [String, Number],
      default: 'none'
    },
    noClickAnimation: Boolean,
    origin: {
      type: String,
      default: 'center center'
    },
    persistent: Boolean,
    retainFocus: {
      type: Boolean,
      default: true
    },
    scrollable: Boolean,
    transition: {
      type: [String, Boolean],
      default: 'dialog-transition'
    },
    width: {
      type: [String, Number],
      default: 'auto'
    }
  },
  data: function data() {
    return {
      activatedBy: null,
      animate: false,
      animateTimeout: -1,
      isActive: !!this.value,
      stackMinZIndex: 200,
      previousActiveElement: null
    };
  },
  computed: {
    classes: function classes() {
      var _ref;

      return _ref = {}, Object(defineProperty["a" /* default */])(_ref, "v-dialog ".concat(this.contentClass).trim(), true), Object(defineProperty["a" /* default */])(_ref, 'v-dialog--active', this.isActive), Object(defineProperty["a" /* default */])(_ref, 'v-dialog--persistent', this.persistent), Object(defineProperty["a" /* default */])(_ref, 'v-dialog--fullscreen', this.fullscreen), Object(defineProperty["a" /* default */])(_ref, 'v-dialog--scrollable', this.scrollable), Object(defineProperty["a" /* default */])(_ref, 'v-dialog--animated', this.animate), _ref;
    },
    contentClasses: function contentClasses() {
      return {
        'v-dialog__content': true,
        'v-dialog__content--active': this.isActive
      };
    },
    hasActivator: function hasActivator() {
      return Boolean(!!this.$slots.activator || !!this.$scopedSlots.activator);
    }
  },
  watch: {
    isActive: function isActive(val) {
      if (val) {
        this.show();
        this.hideScroll();
      } else {
        var _this$previousActiveE;

        this.removeOverlay();
        this.unbind();
        (_this$previousActiveE = this.previousActiveElement) == null ? void 0 : _this$previousActiveE.focus();
      }
    },
    fullscreen: function fullscreen(val) {
      if (!this.isActive) return;

      if (val) {
        this.hideScroll();
        this.removeOverlay(false);
      } else {
        this.showScroll();
        this.genOverlay();
      }
    }
  },
  created: function created() {
    /* istanbul ignore next */
    if (this.$attrs.hasOwnProperty('full-width')) {
      Object(console["e" /* removed */])('full-width', this);
    }
  },
  beforeMount: function beforeMount() {
    var _this = this;

    this.$nextTick(function () {
      _this.isBooted = _this.isActive;
      _this.isActive && _this.show();
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (typeof window !== 'undefined') this.unbind();
  },
  methods: {
    animateClick: function animateClick() {
      var _this2 = this;

      this.animate = false; // Needed for when clicking very fast
      // outside of the dialog

      this.$nextTick(function () {
        _this2.animate = true;
        window.clearTimeout(_this2.animateTimeout);
        _this2.animateTimeout = window.setTimeout(function () {
          return _this2.animate = false;
        }, 150);
      });
    },
    closeConditional: function closeConditional(e) {
      var target = e.target; // Ignore the click if the dialog is closed or destroyed,
      // if it was on an element inside the content,
      // if it was dragged onto the overlay (#6969),
      // or if this isn't the topmost dialog (#9907)

      return !(this._isDestroyed || !this.isActive || this.$refs.content.contains(target) || this.overlay && target && !this.overlay.$el.contains(target)) && this.activeZIndex >= this.getMaxZIndex();
    },
    hideScroll: function hideScroll() {
      if (this.fullscreen) {
        document.documentElement.classList.add('overflow-y-hidden');
      } else {
        overlayable["a" /* default */].options.methods.hideScroll.call(this);
      }
    },
    show: function show() {
      var _this3 = this;

      !this.fullscreen && !this.hideOverlay && this.genOverlay(); // Double nextTick to wait for lazy content to be generated

      this.$nextTick(function () {
        _this3.$nextTick(function () {
          _this3.previousActiveElement = document.activeElement;

          _this3.$refs.content.focus();

          _this3.bind();
        });
      });
    },
    bind: function bind() {
      window.addEventListener('focusin', this.onFocusin);
    },
    unbind: function unbind() {
      window.removeEventListener('focusin', this.onFocusin);
    },
    onClickOutside: function onClickOutside(e) {
      this.$emit('click:outside', e);

      if (this.persistent) {
        this.noClickAnimation || this.animateClick();
      } else {
        this.isActive = false;
      }
    },
    onKeydown: function onKeydown(e) {
      if (e.keyCode === helpers["x" /* keyCodes */].esc && !this.getOpenDependents().length) {
        if (!this.persistent) {
          this.isActive = false;
          var activator = this.getActivator();
          this.$nextTick(function () {
            return activator && activator.focus();
          });
        } else if (!this.noClickAnimation) {
          this.animateClick();
        }
      }

      this.$emit('keydown', e);
    },
    // On focus change, wrap focus to stay inside the dialog
    // https://github.com/vuetifyjs/vuetify/issues/6892
    onFocusin: function onFocusin(e) {
      if (!e || !this.retainFocus) return;
      var target = e.target;

      if (!!target && // It isn't the document or the dialog body
      ![document, this.$refs.content].includes(target) && // It isn't inside the dialog body
      !this.$refs.content.contains(target) && // We're the topmost dialog
      this.activeZIndex >= this.getMaxZIndex() && // It isn't inside a dependent element (like a menu)
      !this.getOpenDependentElements().some(function (el) {
        return el.contains(target);
      }) // So we must have focused something outside the dialog and its children
      ) {
          // Find and focus the first available element inside the dialog
          var focusable = this.$refs.content.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');

          var el = Object(toConsumableArray["a" /* default */])(focusable).find(function (el) {
            return !el.hasAttribute('disabled');
          });

          el && el.focus();
        }
    },
    genContent: function genContent() {
      var _this4 = this;

      return this.showLazyContent(function () {
        return [_this4.$createElement(VThemeProvider["a" /* default */], {
          props: {
            root: true,
            light: _this4.light,
            dark: _this4.dark
          }
        }, [_this4.$createElement('div', {
          class: _this4.contentClasses,
          attrs: Object(objectSpread2["a" /* default */])({
            role: 'document',
            tabindex: _this4.isActive ? 0 : undefined
          }, _this4.getScopeIdAttrs()),
          on: {
            keydown: _this4.onKeydown
          },
          style: {
            zIndex: _this4.activeZIndex
          },
          ref: 'content'
        }, [_this4.genTransition()])])];
      });
    },
    genTransition: function genTransition() {
      var content = this.genInnerContent();
      if (!this.transition) return content;
      return this.$createElement('transition', {
        props: {
          name: this.transition,
          origin: this.origin,
          appear: true
        }
      }, [content]);
    },
    genInnerContent: function genInnerContent() {
      var data = {
        class: this.classes,
        ref: 'dialog',
        directives: [{
          name: 'click-outside',
          value: {
            handler: this.onClickOutside,
            closeConditional: this.closeConditional,
            include: this.getOpenDependentElements
          }
        }, {
          name: 'show',
          value: this.isActive
        }],
        style: {
          transformOrigin: this.origin
        }
      };

      if (!this.fullscreen) {
        data.style = Object(objectSpread2["a" /* default */])(Object(objectSpread2["a" /* default */])({}, data.style), {}, {
          maxWidth: this.maxWidth === 'none' ? undefined : Object(helpers["g" /* convertToUnit */])(this.maxWidth),
          width: this.width === 'auto' ? undefined : Object(helpers["g" /* convertToUnit */])(this.width)
        });
      }

      return this.$createElement('div', data, this.getContentSlot());
    }
  },
  render: function render(h) {
    return h('div', {
      staticClass: 'v-dialog__container',
      class: {
        'v-dialog__container--attached': this.attach === '' || this.attach === true || this.attach === 'attach'
      },
      attrs: {
        role: 'dialog'
      }
    }, [this.genActivator(), this.genContent()]);
  }
}));
// CONCATENATED MODULE: ./src/components/dialog/PpDialog.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  dialog_PpDialogvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "8d2ba264",
  null
  
)

/* harmony default export */ var PpDialog = __webpack_exports__["default"] = (component.exports);

/* vuetify-loader */






installComponents_default()(component, {VCard: VCard["a" /* default */],VCardActions: components_VCard["a" /* VCardActions */],VCardText: components_VCard["b" /* VCardText */],VCardTitle: components_VCard["c" /* VCardTitle */],VDialog: VDialog_VDialog})


/***/ }),

/***/ "be73":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.i, "@import url(https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css);"]);
exports.push([module.i, "@import url(https://cdn-prd.patientpop.com/pp-icon-font/v1.6.0/pp-icon-font.css);"]);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.pp-card[data-v-34bf26aa]{background:#fff;border-radius:6px;box-shadow:0 1px 2px rgba(130,138,163,.25);overflow:hidden}.pp-card[data-v-34bf26aa]:hover{box-shadow:0 12px 24px rgba(74,84,114,.04),0 6px 12px rgba(74,84,114,.04),0 4px 4px rgba(74,84,114,.04),0 2px 2px rgba(74,84,114,.04);cursor:pointer;transition:all .2s linear}.pp-card__image-container[data-v-34bf26aa]{height:160px;width:100%}.pp-card__image-container--default[data-v-34bf26aa]{background-color:#d6d6d6}.pp-card__image-container--default .pp-card__image[data-v-34bf26aa]{height:50px;width:50px}.pp-card__image[data-v-34bf26aa]{display:block;height:100%;-o-object-fit:cover;object-fit:cover;width:100%}.pp-card__subtitle[data-v-34bf26aa],.pp-card__title[data-v-34bf26aa]{-webkit-box-orient:vertical;display:-webkit-box;-webkit-line-clamp:1;overflow:hidden;text-overflow:ellipsis}.pp-card__title[data-v-34bf26aa]{color:#2b2b2b;margin:0}.pp-card__subtitle-container[data-v-34bf26aa]{height:21px;justify-content:space-between}.pp-card__subtitle[data-v-34bf26aa]{color:#545454;font-size:1rem;margin-bottom:0}.pp-card__status-chip[data-v-34bf26aa]{font-size:.8571428571rem;right:0}.pp-card__avatar-image[data-v-34bf26aa]{align-items:center;border-radius:100%;display:flex;height:28px;justify-content:center;overflow:hidden;width:28px}.pp-card__avatar-image img[data-v-34bf26aa]{height:100%}.pp-card__avatar[data-v-34bf26aa]{position:absolute}.pp-card__avatar__icon[data-v-34bf26aa]{color:#fff;font-size:2.057em}.pp-card__avatar[data-v-34bf26aa]:before{background-blend-mode:soft-light;background-color:#fff;content:\"\";height:100%;left:0;opacity:.2;position:absolute;top:0;width:100%}.pp-card__avatar-name[data-v-34bf26aa]{font-size:1.029em}.pp-card__featured[data-v-34bf26aa]{color:#fcde73;display:flex;font-size:1.714em}.pp-card__drag[data-v-34bf26aa]{align-items:center;cursor:move;display:flex;height:40px;position:absolute}.pp-card__drag-icon[data-v-34bf26aa]{align-items:center;display:flex;flex-direction:column;justify-content:center;width:40px}.pp-card__drag-nibs[data-v-34bf26aa]{display:flex;position:relative}.pp-card__drag-nibs[data-v-34bf26aa]:after,.pp-card__drag-nibs[data-v-34bf26aa]:before{background-color:#fff;border-radius:100%;content:\"\";display:block;height:3px;margin:1px;transition:background-color .2s linear;width:3px}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "bf67":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.i, "@import url(https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css);"]);
exports.push([module.i, "@import url(https://cdn-prd.patientpop.com/pp-icon-font/v1.6.0/pp-icon-font.css);"]);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}[data-v-766f6a8c]::-webkit-scrollbar{background:transparent;height:0;width:0}.pp-scrollable-list[data-v-766f6a8c]{max-height:100%;overflow-y:auto}.pp-scrollable-list--horizontal[data-v-766f6a8c]{display:flex;width:-webkit-fill-available;width:-moz-available;width:stretch}.pp-scrollable-list--horizontal__item-wrapper[data-v-766f6a8c]{flex:none}.pp-scrollable-list .more-button[data-v-766f6a8c]  button,.pp-scrollable-list__item-wrapper[data-v-766f6a8c] >*{width:-webkit-fill-available;width:-moz-available;width:stretch}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "bfb0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c662cfac-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/input/radio-group/PpInputRadioGroup.vue?vue&type=template&id=698620e8&scoped=true&
var PpInputRadioGroupvue_type_template_id_698620e8_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.label)?_c('pp-input-label',{attrs:{"label":_vm.label,"optional":_vm.optional}}):_vm._e(),(_vm.showDescription)?_c('div',{staticClass:"subtitle-1 my-2 pp-input-description"},[_vm._t("description",[_vm._v(" "+_vm._s(_vm.description)+" ")])],2):_vm._e(),_c('v-radio-group',_vm._g(_vm._b({staticClass:"pa-0 mt-2",attrs:{"dense":"","hide-details":"","row":_vm.row}},'v-radio-group',_vm.$attrs,false),_vm.$listeners),_vm._l((_vm.options),function(option){return _c('div',{key:option.value},[_c('v-radio',{staticClass:"ma-0 px-1 px-sm-2 py-4 py-sm-0",attrs:{"value":option.value,"label":option.label,"name":_vm.name,"on-icon":"mdi-radiobox-marked","off-icon":"mdi-radiobox-blank"},on:{"change":function($event){return _vm.handleRadioChange(option.value)}},scopedSlots:_vm._u([{key:"label",fn:function(){return [_vm._t('item.' + option.value)]},proxy:true}],null,true)}),_vm._t('extend-input-control.' + option.value,null,{"option":option})],2)}),0)],1)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/input/radio-group/PpInputRadioGroup.vue?vue&type=template&id=698620e8&scoped=true&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("a4d3");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__("e01a");

// EXTERNAL MODULE: ./src/components/input/label/PpInputLabel.vue + 4 modules
var PpInputLabel = __webpack_require__("8e6c");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/input/radio-group/PpInputRadioGroup.vue?vue&type=script&lang=js&


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * Input Radio group based on Vuetify Input Radio Group.
 * Props will get passed through (eg using "row" will make the group horizontal)
 */

/* harmony default export */ var PpInputRadioGroupvue_type_script_lang_js_ = ({
  name: 'PpInputRadioGroup',
  components: {
    'pp-input-label': PpInputLabel["default"]
  },
  props: {
    /**
     * Name of input
     */
    name: {
      type: String,
      required: true,
      default: ''
    },

    /**
     * Array of options to build out radio group
     * [{ label: 'Yes', value: 'yes' },{ label: 'No', value: 'no' }]
     */
    options: {
      type: Array,
      required: true
    },

    /**
     * Whether the radio group should be horizontal (from vuetify)
     */
    row: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: null
    },
    description: {
      type: String,
      default: ''
    },

    /**
     * If true, display optional label with a different color than the main label
     */
    optional: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    showDescription: function showDescription() {
      return this.description || this.$slots.description;
    }
  },
  methods: {
    handleRadioChange: function handleRadioChange(newValue) {
      this.$emit('input', newValue);
    }
  }
});
// CONCATENATED MODULE: ./src/components/input/radio-group/PpInputRadioGroup.vue?vue&type=script&lang=js&
 /* harmony default export */ var radio_group_PpInputRadioGroupvue_type_script_lang_js_ = (PpInputRadioGroupvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/input/radio-group/PpInputRadioGroup.vue?vue&type=style&index=0&id=698620e8&lang=scss&scoped=true&
var PpInputRadioGroupvue_type_style_index_0_id_698620e8_lang_scss_scoped_true_ = __webpack_require__("3be1");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// EXTERNAL MODULE: ./node_modules/vuetify-loader/lib/runtime/installComponents.js
var installComponents = __webpack_require__("6544");
var installComponents_default = /*#__PURE__*/__webpack_require__.n(installComponents);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("b0c0");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__("5530");

// EXTERNAL MODULE: ./node_modules/vuetify/src/components/VRadioGroup/VRadio.sass
var VRadio = __webpack_require__("2c64");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/components/VLabel/index.js + 1 modules
var VLabel = __webpack_require__("ba87");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/components/VIcon/index.js
var VIcon = __webpack_require__("9d26");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/components/VInput/index.js + 3 modules
var VInput = __webpack_require__("c37a");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/mixins/binds-attrs/index.js
var binds_attrs = __webpack_require__("7e2b");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/mixins/colorable/index.js
var colorable = __webpack_require__("a9ad");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/mixins/groupable/index.js
var groupable = __webpack_require__("4e82");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/mixins/rippleable/index.js
var rippleable = __webpack_require__("5311");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/mixins/themeable/index.js
var themeable = __webpack_require__("7560");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/mixins/selectable/index.js
var selectable = __webpack_require__("fe09");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/util/helpers.js
var helpers = __webpack_require__("80d2");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/util/mixins.js
var mixins = __webpack_require__("58df");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/util/mergeData.js
var mergeData = __webpack_require__("d9f7");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VRadioGroup/VRadio.js


// Styles



 // Mixins






 // Utilities




var baseMixins = Object(mixins["a" /* default */])(binds_attrs["a" /* default */], colorable["a" /* default */], rippleable["a" /* default */], Object(groupable["a" /* factory */])('radioGroup'), themeable["a" /* default */]);
/* @vue/component */

/* harmony default export */ var VRadioGroup_VRadio = (baseMixins.extend().extend({
  name: 'v-radio',
  inheritAttrs: false,
  props: {
    disabled: Boolean,
    id: String,
    label: String,
    name: String,
    offIcon: {
      type: String,
      default: '$radioOff'
    },
    onIcon: {
      type: String,
      default: '$radioOn'
    },
    readonly: Boolean,
    value: {
      default: null
    }
  },
  data: function data() {
    return {
      isFocused: false
    };
  },
  computed: {
    classes: function classes() {
      return Object(objectSpread2["a" /* default */])(Object(objectSpread2["a" /* default */])({
        'v-radio--is-disabled': this.isDisabled,
        'v-radio--is-focused': this.isFocused
      }, this.themeClasses), this.groupClasses);
    },
    computedColor: function computedColor() {
      return selectable["a" /* default */].options.computed.computedColor.call(this);
    },
    computedIcon: function computedIcon() {
      return this.isActive ? this.onIcon : this.offIcon;
    },
    computedId: function computedId() {
      return VInput["a" /* default */].options.computed.computedId.call(this);
    },
    hasLabel: VInput["a" /* default */].options.computed.hasLabel,
    hasState: function hasState() {
      return (this.radioGroup || {}).hasState;
    },
    isDisabled: function isDisabled() {
      return this.disabled || !!this.radioGroup && this.radioGroup.isDisabled;
    },
    isReadonly: function isReadonly() {
      return this.readonly || !!this.radioGroup && this.radioGroup.isReadonly;
    },
    computedName: function computedName() {
      if (this.name || !this.radioGroup) {
        return this.name;
      }

      return this.radioGroup.name || "radio-".concat(this.radioGroup._uid);
    },
    rippleState: function rippleState() {
      return selectable["a" /* default */].options.computed.rippleState.call(this);
    },
    validationState: function validationState() {
      return (this.radioGroup || {}).validationState || this.computedColor;
    }
  },
  methods: {
    genInput: function genInput(args) {
      // We can't actually use the mixin directly because
      // it's made for standalone components, but its
      // genInput method is exactly what we need
      return selectable["a" /* default */].options.methods.genInput.call(this, 'radio', args);
    },
    genLabel: function genLabel() {
      if (!this.hasLabel) return null;
      return this.$createElement(VLabel["a" /* default */], {
        on: {
          // Label shouldn't cause the input to focus
          click: selectable["b" /* prevent */]
        },
        attrs: {
          for: this.computedId
        },
        props: {
          color: this.validationState,
          focused: this.hasState
        }
      }, Object(helpers["s" /* getSlot */])(this, 'label') || this.label);
    },
    genRadio: function genRadio() {
      return this.$createElement('div', {
        staticClass: 'v-input--selection-controls__input'
      }, [this.$createElement(VIcon["a" /* default */], this.setTextColor(this.validationState, {
        props: {
          dense: this.radioGroup && this.radioGroup.dense
        }
      }), this.computedIcon), this.genInput(Object(objectSpread2["a" /* default */])({
        name: this.computedName,
        value: this.value
      }, this.attrs$)), this.genRipple(this.setTextColor(this.rippleState))]);
    },
    onFocus: function onFocus(e) {
      this.isFocused = true;
      this.$emit('focus', e);
    },
    onBlur: function onBlur(e) {
      this.isFocused = false;
      this.$emit('blur', e);
    },
    onChange: function onChange() {
      if (this.isDisabled || this.isReadonly || this.isActive) return;
      this.toggle();
    },
    onKeydown: function onKeydown() {}
  },
  render: function render(h) {
    var data = {
      staticClass: 'v-radio',
      class: this.classes,
      on: Object(mergeData["c" /* mergeListeners */])({
        click: this.onChange
      }, this.listeners$)
    };
    return h('div', data, [this.genRadio(), this.genLabel()]);
  }
}));
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__("a9e3");

// EXTERNAL MODULE: ./node_modules/vuetify/src/styles/components/_selection-controls.sass
var _selection_controls = __webpack_require__("ec29");

// EXTERNAL MODULE: ./node_modules/vuetify/src/components/VRadioGroup/VRadioGroup.sass
var VRadioGroup = __webpack_require__("3d86");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/components/VItemGroup/VItemGroup.js
var VItemGroup = __webpack_require__("604c");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/mixins/comparable/index.js
var comparable = __webpack_require__("8547");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VRadioGroup/VRadioGroup.js


// Styles

 // Extensions


 // Mixins

 // Types


var VRadioGroup_baseMixins = Object(mixins["a" /* default */])(comparable["a" /* default */], VItemGroup["a" /* BaseItemGroup */], VInput["a" /* default */]);
/* @vue/component */

/* harmony default export */ var VRadioGroup_VRadioGroup = (VRadioGroup_baseMixins.extend({
  name: 'v-radio-group',
  provide: function provide() {
    return {
      radioGroup: this
    };
  },
  props: {
    column: {
      type: Boolean,
      default: true
    },
    height: {
      type: [Number, String],
      default: 'auto'
    },
    name: String,
    row: Boolean,
    // If no value set on VRadio
    // will match valueComparator
    // force default to null
    value: null
  },
  computed: {
    classes: function classes() {
      return Object(objectSpread2["a" /* default */])(Object(objectSpread2["a" /* default */])({}, VInput["a" /* default */].options.computed.classes.call(this)), {}, {
        'v-input--selection-controls v-input--radio-group': true,
        'v-input--radio-group--column': this.column && !this.row,
        'v-input--radio-group--row': this.row
      });
    }
  },
  methods: {
    genDefaultSlot: function genDefaultSlot() {
      return this.$createElement('div', {
        staticClass: 'v-input--radio-group__input',
        attrs: {
          id: this.id,
          role: 'radiogroup',
          'aria-labelledby': this.computedId
        }
      }, VInput["a" /* default */].options.methods.genDefaultSlot.call(this));
    },
    genInputSlot: function genInputSlot() {
      var render = VInput["a" /* default */].options.methods.genInputSlot.call(this);
      delete render.data.on.click;
      return render;
    },
    genLabel: function genLabel() {
      var label = VInput["a" /* default */].options.methods.genLabel.call(this);
      if (!label) return null;
      label.data.attrs.id = this.computedId; // WAI considers this an orphaned label

      delete label.data.attrs.for;
      label.tag = 'legend';
      return label;
    },
    onClick: VItemGroup["a" /* BaseItemGroup */].options.methods.onClick
  }
}));
// CONCATENATED MODULE: ./src/components/input/radio-group/PpInputRadioGroup.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  radio_group_PpInputRadioGroupvue_type_script_lang_js_,
  PpInputRadioGroupvue_type_template_id_698620e8_scoped_true_render,
  staticRenderFns,
  false,
  null,
  "698620e8",
  null
  
)

/* harmony default export */ var PpInputRadioGroup = __webpack_exports__["default"] = (component.exports);

/* vuetify-loader */



installComponents_default()(component, {VRadio: VRadioGroup_VRadio,VRadioGroup: VRadioGroup_VRadioGroup})


/***/ }),

/***/ "bfe6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c662cfac-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/avatar-info/PpAvatarInfo.vue?vue&type=template&id=b0984a4c&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pp-avatar-info"},[_c('v-row',{staticClass:"flex-nowrap"},[_c('v-col',{staticClass:"pp-avatar-info__image pl-1 pr-6",attrs:{"cols":"auto"}},[_c('pp-avatar-icon',{attrs:{"name":_vm.name,"image":_vm.image,"size":_vm.size,"show-one-initial":false,"disabled":_vm.disabled,"is-practice":_vm.isPractice}})],1),_c('v-col',{staticClass:"pp-avatar-info__content pl-0 d-flex flex-column",class:{'justify-center' : _vm.justifyCenter}},[_vm._t("name",[_c('div',{staticClass:"pp-avatar-info__name font-weight-bold text-truncate text-h5 grey--text",class:_vm.disabled ? _vm.disabledStyleClass : 'text--darken-3'},[_vm._v(" "+_vm._s(_vm.name)+" ")])]),_vm._t("content",[(_vm.specialty)?_c('div',{staticClass:"pp-avatar-info__specialty font-weight-medium text-truncate text-body-2 grey--text",class:_vm.disabled ? _vm.disabledStyleClass : 'text--darken-4'},[_vm._v(" "+_vm._s(_vm.specialty)+" ")]):_vm._e(),(_vm.address)?_c('div',{staticClass:"pp-avatar-info__contact d-flex align-center grey--text",class:_vm.disabled ? _vm.disabledStyleClass : 'text--darken-2'},[(_vm.virtualVisit)?[_c('div',{staticClass:"virtual-visit-address d-inline-flex align-center px-2 py-2 rounded"},[_c('i',{staticClass:"pp-icon-video d-flex text-h4"}),_c('span',{staticClass:"ml-1 virtual-visit-tag__text font-weight-bold"},[_vm._v("Virtual visit")])])]:[_c('span',{staticClass:"text-body-2"},[(_vm.address.address1)?[_vm._v(" "+_vm._s(_vm.address.address1)),_c('br')]:_vm._e(),(_vm.address.address2)?[_vm._v(" "+_vm._s(_vm.address.address2)),_c('br')]:_vm._e(),_vm._v(" "+_vm._s(_vm.cityStateZip)+" ")],2)]],2):_vm._e()])],2)],1)],1)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/avatar-info/PpAvatarInfo.vue?vue&type=template&id=b0984a4c&scoped=true&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.index-of.js
var es_array_index_of = __webpack_require__("c975");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("b64b");

// EXTERNAL MODULE: ./src/components/avatar-icon/PpAvatarIcon.vue + 4 modules
var PpAvatarIcon = __webpack_require__("020a");

// EXTERNAL MODULE: ./src/components/avatar-icon/constants.js
var constants = __webpack_require__("2ee3");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/avatar-info/PpAvatarInfo.vue?vue&type=script&lang=js&


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/**
 * Create a display provider to display Doctor's information
 */

/* harmony default export */ var PpAvatarInfovue_type_script_lang_js_ = ({
  name: 'PpAvatarInfo',
  components: {
    'pp-avatar-icon': PpAvatarIcon["default"]
  },
  props: {
    /**
     * Doctor's name
     */
    name: {
      type: String,
      required: true
    },

    /**
     * Doctor's avatar
     */
    image: {
      type: String,
      default: ''
    },

    /**
     * Doctor's specialty
     */
    specialty: {
      type: String,
      default: ''
    },

    /**
     * Doctor's address
     */
    address: {
      type: Object,
      default: null
    },

    /**
     * Is Doctor able to make a video call or provide virtual visit
     */
    virtualVisit: {
      type: Boolean,
      default: false
    },

    /**
     * Breakpoint size class for avatar icon & text initials.
     * Must be one of these: xxs, xs, sm, md, lg xl, xxl
     */
    size: {
      type: String,
      default: 'lg',
      validator: function validator(value) {
        if (!value) {
          return true;
        }

        return Object.keys(constants["a" /* SIZES */]).indexOf(value) !== -1;
      }
    },
    justifyCenter: {
      type: Boolean,
      default: false
    },

    /**
     * If image present will make the image greyscale
     */
    disabled: {
      type: Boolean,
      default: false
    },

    /**
     * Adjusts the background of the avatar icon to teal
     */
    isPractice: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      disabledStyleClass: 'text--darken-1'
    };
  },
  computed: {
    cityStateZip: function cityStateZip() {
      var result = "".concat(this.address.city);
      this.showStateOrZip && (result += ', ');
      this.address.state && (result += this.address.state);
      this.address.zip && (result += " ".concat(this.address.zip));
      return result;
    },
    showStateOrZip: function showStateOrZip() {
      return this.address.state || this.address.zip;
    }
  }
});
// CONCATENATED MODULE: ./src/components/avatar-info/PpAvatarInfo.vue?vue&type=script&lang=js&
 /* harmony default export */ var avatar_info_PpAvatarInfovue_type_script_lang_js_ = (PpAvatarInfovue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/avatar-info/PpAvatarInfo.vue?vue&type=style&index=0&id=b0984a4c&lang=scss&scoped=true&
var PpAvatarInfovue_type_style_index_0_id_b0984a4c_lang_scss_scoped_true_ = __webpack_require__("8e46");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// EXTERNAL MODULE: ./node_modules/vuetify-loader/lib/runtime/installComponents.js
var installComponents = __webpack_require__("6544");
var installComponents_default = /*#__PURE__*/__webpack_require__.n(installComponents);

// EXTERNAL MODULE: ./node_modules/vuetify/lib/components/VGrid/VCol.js
var VCol = __webpack_require__("62ad");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/components/VGrid/VContainer.js
var VContainer = __webpack_require__("a523");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/components/VGrid/VRow.js
var VRow = __webpack_require__("0fd9");

// CONCATENATED MODULE: ./src/components/avatar-info/PpAvatarInfo.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  avatar_info_PpAvatarInfovue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "b0984a4c",
  null
  
)

/* harmony default export */ var PpAvatarInfo = __webpack_exports__["default"] = (component.exports);

/* vuetify-loader */




installComponents_default()(component, {VCol: VCol["a" /* default */],VContainer: VContainer["a" /* default */],VRow: VRow["a" /* default */]})


/***/ }),

/***/ "c04e":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (input, PREFERRED_STRING) {
  if (!isObject(input)) return input;
  var fn, val;
  if (PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
  if (typeof (fn = input.valueOf) == 'function' && !isObject(val = fn.call(input))) return val;
  if (!PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "c074":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><rect x=\"8\" y=\"3\" width=\"8\" height=\"5\" fill=\"#DFE4E5\"></rect><rect x=\"8\" y=\"16\" width=\"8\" height=\"5\" fill=\"#DFE4E5\"></rect><rect x=\"4\" y=\"9\" width=\"16\" height=\"8\" fill=\"white\"></rect><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8 7V4H16V7H8ZM6 7V2H18V7H20C21.1046 7 22 7.89543 22 9V17C22 18.1046 21.1046 19 20 19H17V17H20V9H4V17H7V19H4C2.89543 19 2 18.1046 2 17V9C2 7.89543 2.89543 7 4 7H6ZM18 10C18.5523 10 19 10.4477 19 11C19 11.5523 18.5523 12 18 12C17.4477 12 17 11.5523 17 11C17 10.4477 17.4477 10 18 10ZM16 11C16 10.4477 15.5523 10 15 10C14.4477 10 14 10.4477 14 11C14 11.5523 14.4477 12 15 12C15.5523 12 16 11.5523 16 11Z\" fill=\"#1F3A3E\"></path><path d=\"M7 16H17V19C17 20.1046 16.1046 21 15 21H7V16Z\" fill=\"#DFE4E5\" stroke=\"#1F3A3E\" stroke-width=\"2\"></path></svg>";

/***/ }),

/***/ "c0bb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpMessage_vue_vue_type_style_index_0_id_683c2c2f_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("79c7");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpMessage_vue_vue_type_style_index_0_id_683c2c2f_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpMessage_vue_vue_type_style_index_0_id_683c2c2f_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "c20a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c662cfac-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/expansion-panels/PpExpansionPanels.vue?vue&type=template&id=5928e846&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-expansion-panels',_vm._g(_vm._b({},'v-expansion-panels',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/expansion-panels/PpExpansionPanels.vue?vue&type=template&id=5928e846&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/expansion-panels/PpExpansionPanels.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//

/**
 * Expansion Panel from vuetify requires them to be wrapped in expansion panels
 */
/* harmony default export */ var PpExpansionPanelsvue_type_script_lang_js_ = ({
  name: 'PpExpansionPanels',
  components: {},
  model: {
    prop: 'value',
    event: 'change'
  }
});
// CONCATENATED MODULE: ./src/components/expansion-panels/PpExpansionPanels.vue?vue&type=script&lang=js&
 /* harmony default export */ var expansion_panels_PpExpansionPanelsvue_type_script_lang_js_ = (PpExpansionPanelsvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// EXTERNAL MODULE: ./node_modules/vuetify-loader/lib/runtime/installComponents.js
var installComponents = __webpack_require__("6544");
var installComponents_default = /*#__PURE__*/__webpack_require__.n(installComponents);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.flat.js
var es_array_flat = __webpack_require__("0481");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.unscopables.flat.js
var es_array_unscopables_flat = __webpack_require__("4069");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__("5530");

// EXTERNAL MODULE: ./node_modules/vuetify/src/components/VExpansionPanel/VExpansionPanel.sass
var VExpansionPanel = __webpack_require__("210b");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/components/VItemGroup/VItemGroup.js
var VItemGroup = __webpack_require__("604c");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/util/console.js + 32 modules
var console = __webpack_require__("d9bd");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VExpansionPanel/VExpansionPanels.js



// Styles
 // Components

 // Utilities


/* @vue/component */

/* harmony default export */ var VExpansionPanels = (VItemGroup["a" /* BaseItemGroup */].extend({
  name: 'v-expansion-panels',
  provide: function provide() {
    return {
      expansionPanels: this
    };
  },
  props: {
    accordion: Boolean,
    disabled: Boolean,
    flat: Boolean,
    hover: Boolean,
    focusable: Boolean,
    inset: Boolean,
    popout: Boolean,
    readonly: Boolean,
    tile: Boolean
  },
  computed: {
    classes: function classes() {
      return Object(objectSpread2["a" /* default */])(Object(objectSpread2["a" /* default */])({}, VItemGroup["a" /* BaseItemGroup */].options.computed.classes.call(this)), {}, {
        'v-expansion-panels': true,
        'v-expansion-panels--accordion': this.accordion,
        'v-expansion-panels--flat': this.flat,
        'v-expansion-panels--hover': this.hover,
        'v-expansion-panels--focusable': this.focusable,
        'v-expansion-panels--inset': this.inset,
        'v-expansion-panels--popout': this.popout,
        'v-expansion-panels--tile': this.tile
      });
    }
  },
  created: function created() {
    /* istanbul ignore next */
    if (this.$attrs.hasOwnProperty('expand')) {
      Object(console["a" /* breaking */])('expand', 'multiple', this);
    }
    /* istanbul ignore next */


    if (Array.isArray(this.value) && this.value.length > 0 && typeof this.value[0] === 'boolean') {
      Object(console["a" /* breaking */])(':value="[true, false, true]"', ':value="[0, 2]"', this);
    }
  },
  methods: {
    updateItem: function updateItem(item, index) {
      var value = this.getValue(item, index);
      var nextValue = this.getValue(item, index + 1);
      item.isActive = this.toggleMethod(value);
      item.nextIsActive = this.toggleMethod(nextValue);
    }
  }
}));
// CONCATENATED MODULE: ./src/components/expansion-panels/PpExpansionPanels.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  expansion_panels_PpExpansionPanelsvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var PpExpansionPanels = __webpack_exports__["default"] = (component.exports);

/* vuetify-loader */


installComponents_default()(component, {VExpansionPanels: VExpansionPanels})


/***/ }),

/***/ "c2b5":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("c8d5")

/**
 * @category Weekday Helpers
 * @summary Get the day of the week of the given date.
 *
 * @description
 * Get the day of the week of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the day of week
 *
 * @example
 * // Which day of the week is 29 February 2012?
 * var result = getDay(new Date(2012, 1, 29))
 * //=> 3
 */
function getDay (dirtyDate) {
  var date = parse(dirtyDate)
  var day = date.getDay()
  return day
}

module.exports = getDay


/***/ }),

/***/ "c302":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.i, "@import url(https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css);"]);
exports.push([module.i, "@import url(https://cdn-prd.patientpop.com/pp-icon-font/v1.6.0/pp-icon-font.css);"]);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.upload-file__learn-more[data-v-6d3d1270],.upload-file__template[data-v-6d3d1270]{color:#067889;cursor:pointer}.upload-file__learn-more[data-v-6d3d1270]:hover,.upload-file__template[data-v-6d3d1270]:hover{text-decoration:underline}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "c37a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// UNUSED EXPORTS: VInput

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("99af");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("4de4");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("d81d");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__("a9e3");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__("ac1f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.split.js
var es_string_split = __webpack_require__("1276");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__("5530");

// EXTERNAL MODULE: ./node_modules/vuetify/src/components/VInput/VInput.sass
var VInput = __webpack_require__("d191");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/components/VIcon/index.js
var VIcon = __webpack_require__("9d26");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/components/VLabel/index.js + 1 modules
var VLabel = __webpack_require__("ba87");

// EXTERNAL MODULE: ./node_modules/vuetify/src/components/VMessages/VMessages.sass
var VMessages = __webpack_require__("8ff2");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/mixins/colorable/index.js
var colorable = __webpack_require__("a9ad");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/mixins/themeable/index.js
var themeable = __webpack_require__("7560");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/util/mixins.js
var mixins = __webpack_require__("58df");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/util/helpers.js
var helpers = __webpack_require__("80d2");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VMessages/VMessages.js

// Styles
 // Mixins



 // Utilities


/* @vue/component */

/* harmony default export */ var VMessages_VMessages = (Object(mixins["a" /* default */])(colorable["a" /* default */], themeable["a" /* default */]).extend({
  name: 'v-messages',
  props: {
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  methods: {
    genChildren: function genChildren() {
      return this.$createElement('transition-group', {
        staticClass: 'v-messages__wrapper',
        attrs: {
          name: 'message-transition',
          tag: 'div'
        }
      }, this.value.map(this.genMessage));
    },
    genMessage: function genMessage(message, key) {
      return this.$createElement('div', {
        staticClass: 'v-messages__message',
        key: key
      }, Object(helpers["s" /* getSlot */])(this, 'default', {
        message: message,
        key: key
      }) || [message]);
    }
  },
  render: function render(h) {
    return h('div', this.setTextColor(this.color, {
      staticClass: 'v-messages',
      class: this.themeClasses
    }), [this.genChildren()]);
  }
}));
// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VMessages/index.js


/* harmony default export */ var components_VMessages = (VMessages_VMessages);
// EXTERNAL MODULE: ./node_modules/vuetify/lib/mixins/binds-attrs/index.js
var binds_attrs = __webpack_require__("7e2b");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/mixins/validatable/index.js
var validatable = __webpack_require__("38cb");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/util/mergeData.js
var mergeData = __webpack_require__("d9f7");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VInput/VInput.js







// Styles
 // Components



 // Mixins


 // Utilities




var baseMixins = Object(mixins["a" /* default */])(binds_attrs["a" /* default */], validatable["a" /* default */]);
/* @vue/component */

/* harmony default export */ var VInput_VInput = (baseMixins.extend().extend({
  name: 'v-input',
  inheritAttrs: false,
  props: {
    appendIcon: String,
    backgroundColor: {
      type: String,
      default: ''
    },
    dense: Boolean,
    height: [Number, String],
    hideDetails: [Boolean, String],
    hint: String,
    id: String,
    label: String,
    loading: Boolean,
    persistentHint: Boolean,
    prependIcon: String,
    value: null
  },
  data: function data() {
    return {
      lazyValue: this.value,
      hasMouseDown: false
    };
  },
  computed: {
    classes: function classes() {
      return Object(objectSpread2["a" /* default */])({
        'v-input--has-state': this.hasState,
        'v-input--hide-details': !this.showDetails,
        'v-input--is-label-active': this.isLabelActive,
        'v-input--is-dirty': this.isDirty,
        'v-input--is-disabled': this.isDisabled,
        'v-input--is-focused': this.isFocused,
        // <v-switch loading>.loading === '' so we can't just cast to boolean
        'v-input--is-loading': this.loading !== false && this.loading != null,
        'v-input--is-readonly': this.isReadonly,
        'v-input--dense': this.dense
      }, this.themeClasses);
    },
    computedId: function computedId() {
      return this.id || "input-".concat(this._uid);
    },
    hasDetails: function hasDetails() {
      return this.messagesToDisplay.length > 0;
    },
    hasHint: function hasHint() {
      return !this.hasMessages && !!this.hint && (this.persistentHint || this.isFocused);
    },
    hasLabel: function hasLabel() {
      return !!(this.$slots.label || this.label);
    },
    // Proxy for `lazyValue`
    // This allows an input
    // to function without
    // a provided model
    internalValue: {
      get: function get() {
        return this.lazyValue;
      },
      set: function set(val) {
        this.lazyValue = val;
        this.$emit(this.$_modelEvent, val);
      }
    },
    isDirty: function isDirty() {
      return !!this.lazyValue;
    },
    isLabelActive: function isLabelActive() {
      return this.isDirty;
    },
    messagesToDisplay: function messagesToDisplay() {
      var _this = this;

      if (this.hasHint) return [this.hint];
      if (!this.hasMessages) return [];
      return this.validations.map(function (validation) {
        if (typeof validation === 'string') return validation;
        var validationResult = validation(_this.internalValue);
        return typeof validationResult === 'string' ? validationResult : '';
      }).filter(function (message) {
        return message !== '';
      });
    },
    showDetails: function showDetails() {
      return this.hideDetails === false || this.hideDetails === 'auto' && this.hasDetails;
    }
  },
  watch: {
    value: function value(val) {
      this.lazyValue = val;
    }
  },
  beforeCreate: function beforeCreate() {
    // v-radio-group needs to emit a different event
    // https://github.com/vuetifyjs/vuetify/issues/4752
    this.$_modelEvent = this.$options.model && this.$options.model.event || 'input';
  },
  methods: {
    genContent: function genContent() {
      return [this.genPrependSlot(), this.genControl(), this.genAppendSlot()];
    },
    genControl: function genControl() {
      return this.$createElement('div', {
        staticClass: 'v-input__control'
      }, [this.genInputSlot(), this.genMessages()]);
    },
    genDefaultSlot: function genDefaultSlot() {
      return [this.genLabel(), this.$slots.default];
    },
    genIcon: function genIcon(type, cb) {
      var _this2 = this;

      var extraData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var icon = this["".concat(type, "Icon")];
      var eventName = "click:".concat(Object(helpers["w" /* kebabCase */])(type));
      var hasListener = !!(this.listeners$[eventName] || cb);
      var data = Object(mergeData["a" /* default */])({
        attrs: {
          'aria-label': hasListener ? Object(helpers["w" /* kebabCase */])(type).split('-')[0] + ' icon' : undefined,
          color: this.validationState,
          dark: this.dark,
          disabled: this.isDisabled,
          light: this.light
        },
        on: !hasListener ? undefined : {
          click: function click(e) {
            e.preventDefault();
            e.stopPropagation();

            _this2.$emit(eventName, e);

            cb && cb(e);
          },
          // Container has g event that will
          // trigger menu open if enclosed
          mouseup: function mouseup(e) {
            e.preventDefault();
            e.stopPropagation();
          }
        }
      }, extraData);
      return this.$createElement('div', {
        staticClass: "v-input__icon",
        class: type ? "v-input__icon--".concat(Object(helpers["w" /* kebabCase */])(type)) : undefined
      }, [this.$createElement(VIcon["a" /* default */], data, icon)]);
    },
    genInputSlot: function genInputSlot() {
      return this.$createElement('div', this.setBackgroundColor(this.backgroundColor, {
        staticClass: 'v-input__slot',
        style: {
          height: Object(helpers["g" /* convertToUnit */])(this.height)
        },
        on: {
          click: this.onClick,
          mousedown: this.onMouseDown,
          mouseup: this.onMouseUp
        },
        ref: 'input-slot'
      }), [this.genDefaultSlot()]);
    },
    genLabel: function genLabel() {
      if (!this.hasLabel) return null;
      return this.$createElement(VLabel["a" /* default */], {
        props: {
          color: this.validationState,
          dark: this.dark,
          disabled: this.isDisabled,
          focused: this.hasState,
          for: this.computedId,
          light: this.light
        }
      }, this.$slots.label || this.label);
    },
    genMessages: function genMessages() {
      var _this3 = this;

      if (!this.showDetails) return null;
      return this.$createElement(components_VMessages, {
        props: {
          color: this.hasHint ? '' : this.validationState,
          dark: this.dark,
          light: this.light,
          value: this.messagesToDisplay
        },
        attrs: {
          role: this.hasMessages ? 'alert' : null
        },
        scopedSlots: {
          default: function _default(props) {
            return Object(helpers["s" /* getSlot */])(_this3, 'message', props);
          }
        }
      });
    },
    genSlot: function genSlot(type, location, slot) {
      if (!slot.length) return null;
      var ref = "".concat(type, "-").concat(location);
      return this.$createElement('div', {
        staticClass: "v-input__".concat(ref),
        ref: ref
      }, slot);
    },
    genPrependSlot: function genPrependSlot() {
      var slot = [];

      if (this.$slots.prepend) {
        slot.push(this.$slots.prepend);
      } else if (this.prependIcon) {
        slot.push(this.genIcon('prepend'));
      }

      return this.genSlot('prepend', 'outer', slot);
    },
    genAppendSlot: function genAppendSlot() {
      var slot = []; // Append icon for text field was really
      // an appended inner icon, v-text-field
      // will overwrite this method in order to obtain
      // backwards compat

      if (this.$slots.append) {
        slot.push(this.$slots.append);
      } else if (this.appendIcon) {
        slot.push(this.genIcon('append'));
      }

      return this.genSlot('append', 'outer', slot);
    },
    onClick: function onClick(e) {
      this.$emit('click', e);
    },
    onMouseDown: function onMouseDown(e) {
      this.hasMouseDown = true;
      this.$emit('mousedown', e);
    },
    onMouseUp: function onMouseUp(e) {
      this.hasMouseDown = false;
      this.$emit('mouseup', e);
    }
  },
  render: function render(h) {
    return h('div', this.setTextColor(this.validationState, {
      staticClass: 'v-input',
      class: this.classes
    }), this.genContent());
  }
}));
// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VInput/index.js


/* harmony default export */ var components_VInput = __webpack_exports__["a"] = (VInput_VInput);

/***/ }),

/***/ "c3f0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Touch */
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("4160");
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("cca6");
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("159b");
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("80d2");





var handleGesture = function handleGesture(wrapper) {
  var touchstartX = wrapper.touchstartX,
      touchendX = wrapper.touchendX,
      touchstartY = wrapper.touchstartY,
      touchendY = wrapper.touchendY;
  var dirRatio = 0.5;
  var minDistance = 16;
  wrapper.offsetX = touchendX - touchstartX;
  wrapper.offsetY = touchendY - touchstartY;

  if (Math.abs(wrapper.offsetY) < dirRatio * Math.abs(wrapper.offsetX)) {
    wrapper.left && touchendX < touchstartX - minDistance && wrapper.left(wrapper);
    wrapper.right && touchendX > touchstartX + minDistance && wrapper.right(wrapper);
  }

  if (Math.abs(wrapper.offsetX) < dirRatio * Math.abs(wrapper.offsetY)) {
    wrapper.up && touchendY < touchstartY - minDistance && wrapper.up(wrapper);
    wrapper.down && touchendY > touchstartY + minDistance && wrapper.down(wrapper);
  }
};

function _touchstart(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchstartX = touch.clientX;
  wrapper.touchstartY = touch.clientY;
  wrapper.start && wrapper.start(Object.assign(event, wrapper));
}

function _touchend(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchendX = touch.clientX;
  wrapper.touchendY = touch.clientY;
  wrapper.end && wrapper.end(Object.assign(event, wrapper));
  handleGesture(wrapper);
}

function _touchmove(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchmoveX = touch.clientX;
  wrapper.touchmoveY = touch.clientY;
  wrapper.move && wrapper.move(Object.assign(event, wrapper));
}

function createHandlers(value) {
  var wrapper = {
    touchstartX: 0,
    touchstartY: 0,
    touchendX: 0,
    touchendY: 0,
    touchmoveX: 0,
    touchmoveY: 0,
    offsetX: 0,
    offsetY: 0,
    left: value.left,
    right: value.right,
    up: value.up,
    down: value.down,
    start: value.start,
    move: value.move,
    end: value.end
  };
  return {
    touchstart: function touchstart(e) {
      return _touchstart(e, wrapper);
    },
    touchend: function touchend(e) {
      return _touchend(e, wrapper);
    },
    touchmove: function touchmove(e) {
      return _touchmove(e, wrapper);
    }
  };
}

function inserted(el, binding, vnode) {
  var value = binding.value;
  var target = value.parent ? el.parentElement : el;
  var options = value.options || {
    passive: true
  }; // Needed to pass unit tests

  if (!target) return;
  var handlers = createHandlers(binding.value);
  target._touchHandlers = Object(target._touchHandlers);
  target._touchHandlers[vnode.context._uid] = handlers;
  Object(_util_helpers__WEBPACK_IMPORTED_MODULE_3__[/* keys */ "y"])(handlers).forEach(function (eventName) {
    target.addEventListener(eventName, handlers[eventName], options);
  });
}

function unbind(el, binding, vnode) {
  var target = binding.value.parent ? el.parentElement : el;
  if (!target || !target._touchHandlers) return;
  var handlers = target._touchHandlers[vnode.context._uid];
  Object(_util_helpers__WEBPACK_IMPORTED_MODULE_3__[/* keys */ "y"])(handlers).forEach(function (eventName) {
    target.removeEventListener(eventName, handlers[eventName]);
  });
  delete target._touchHandlers[vnode.context._uid];
}

var Touch = {
  inserted: inserted,
  unbind: unbind
};
/* harmony default export */ __webpack_exports__["a"] = (Touch);

/***/ }),

/***/ "c430":
/***/ (function(module, exports) {

module.exports = false;


/***/ }),

/***/ "c4a9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getTinymce; });
/**
 * Copyright (c) 2018-present, Ephox, Inc.
 *
 * This source code is licensed under the Apache 2 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
var getGlobal = function () { return (typeof window !== 'undefined' ? window : global); };
var getTinymce = function () {
    var global = getGlobal();
    return global && global.tinymce ? global.tinymce : null;
};


/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba")))

/***/ }),

/***/ "c4c2":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("c8d5")

/**
 * @category Day Helpers
 * @summary Return the array of dates within the specified range.
 *
 * @description
 * Return the array of dates within the specified range.
 *
 * @param {Date|String|Number} startDate - the first date
 * @param {Date|String|Number} endDate - the last date
 * @param {Number} [step=1] - the step between each day
 * @returns {Date[]} the array with starts of days from the day of startDate to the day of endDate
 * @throws {Error} startDate cannot be after endDate
 *
 * @example
 * // Each day between 6 October 2014 and 10 October 2014:
 * var result = eachDay(
 *   new Date(2014, 9, 6),
 *   new Date(2014, 9, 10)
 * )
 * //=> [
 * //   Mon Oct 06 2014 00:00:00,
 * //   Tue Oct 07 2014 00:00:00,
 * //   Wed Oct 08 2014 00:00:00,
 * //   Thu Oct 09 2014 00:00:00,
 * //   Fri Oct 10 2014 00:00:00
 * // ]
 */
function eachDay (dirtyStartDate, dirtyEndDate, dirtyStep) {
  var startDate = parse(dirtyStartDate)
  var endDate = parse(dirtyEndDate)
  var step = dirtyStep !== undefined ? dirtyStep : 1

  var endTime = endDate.getTime()

  if (startDate.getTime() > endTime) {
    throw new Error('The first date cannot be after the second date')
  }

  var dates = []

  var currentDate = startDate
  currentDate.setHours(0, 0, 0, 0)

  while (currentDate.getTime() <= endTime) {
    dates.push(parse(currentDate))
    currentDate.setDate(currentDate.getDate() + step)
  }

  return dates
}

module.exports = eachDay


/***/ }),

/***/ "c4f9":
/***/ (function(module, exports, __webpack_require__) {

var startOfDay = __webpack_require__("0978")

/**
 * @category Day Helpers
 * @summary Is the given date yesterday?
 *
 * @description
 * Is the given date yesterday?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is yesterday
 *
 * @example
 * // If today is 6 October 2014, is 5 October 14:00:00 yesterday?
 * var result = isYesterday(new Date(2014, 9, 5, 14, 0))
 * //=> true
 */
function isYesterday (dirtyDate) {
  var yesterday = new Date()
  yesterday.setDate(yesterday.getDate() - 1)
  return startOfDay(dirtyDate).getTime() === startOfDay(yesterday).getTime()
}

module.exports = isYesterday


/***/ }),

/***/ "c580":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><rect x=\"4\" y=\"5\" width=\"16\" height=\"3\" fill=\"#DFE4E5\"></rect><rect x=\"4\" y=\"10\" width=\"16\" height=\"10\" fill=\"white\"></rect><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8 5C8 5.55228 7.55228 6 7 6C6.44772 6 6 5.55228 6 5H4V8H20V5H18C18 5.55228 17.5523 6 17 6C16.4477 6 16 5.55228 16 5H8ZM20 10H4V20H20V10ZM18 3C18 2.44772 17.5523 2 17 2C16.4477 2 16 2.44772 16 3H8C8 2.44772 7.55228 2 7 2C6.44772 2 6 2.44772 6 3H4C2.89543 3 2 3.89543 2 5V20C2 21.1046 2.89543 22 4 22H20C21.1046 22 22 21.1046 22 20V5C22 3.89543 21.1046 3 20 3H18ZM7 14V12H9V14H7ZM11 14H13V12H11V14ZM15 14V12H17V14H15ZM7 16V18H9V16H7ZM13 18H11V16H13V18Z\" fill=\"#688083\"></path></svg>";

/***/ }),

/***/ "c589":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("c8d5")

/**
 * @category Minute Helpers
 * @summary Get the minutes of the given date.
 *
 * @description
 * Get the minutes of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the minutes
 *
 * @example
 * // Get the minutes of 29 February 2012 11:45:05:
 * var result = getMinutes(new Date(2012, 1, 29, 11, 45, 5))
 * //=> 45
 */
function getMinutes (dirtyDate) {
  var date = parse(dirtyDate)
  var minutes = date.getMinutes()
  return minutes
}

module.exports = getMinutes


/***/ }),

/***/ "c624":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_167_0)\"><path d=\"M18.4998 1C20.9851 1 22.9998 3.01472 22.9998 5.5C22.9998 7.46681 21.738 9.13891 19.9798 9.75097L19.9999 9.74391L19.9998 14.6961C19.9998 15.4415 20.6838 16.0541 21.4254 16.1235L21.565 16.1301C22.357 16.1301 23 16.7731 23 17.5651C23 18.3115 22.4304 18.924 21.7031 18.9935L21.565 19.0001H15.999L15.9949 19.1996C15.8909 21.316 14.142 23 11.9998 23C9.791 23 8.00034 21.2097 7.9998 19.001L2.435 19.0001C1.642 19.0001 1 18.3581 1 17.5651C1 16.8197 1.56869 16.2063 2.29673 16.1367L2.435 16.1301C3.183 16.1301 3.93108 15.5575 4.01189 14.8266L4.01909 14.6961V9.1301C4.01909 5.4321 6.867 2.4351 10.565 2.4351C10.565 1.6421 11.207 1.0001 12 1.0001C12.792 1.0001 13.435 1.6421 13.435 2.4351C13.9894 2.4351 14.5251 2.50246 15.0353 2.62943L15.1154 2.53415C15.9402 1.59373 17.1506 1 18.4998 1ZM13.999 19.0001H9.999L10.0053 19.1493C10.0816 20.1841 10.9454 21 11.9998 21C13.0542 21 13.918 20.1841 13.9943 19.1493L13.999 19.0001Z\" fill=\"white\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12 1.00012C12.792 1.00012 13.435 1.64212 13.435 2.43512C13.9768 2.43512 14.5007 2.49945 15.0004 2.62089C12.0936 3.32833 10.0191 5.97391 10.0191 9.13012L10.019 16.9991L15.9998 17V19C15.9998 21.2092 14.2089 23 11.9998 23C9.79133 23 8.00089 21.2102 7.9998 19.002L2.435 19.0001C1.642 19.0001 1 18.3581 1 17.5651C1 16.7731 1.642 16.1301 2.435 16.1301C3.183 16.1301 3.93108 15.5575 4.01189 14.8266L4.01909 14.6961V9.13012C4.01909 5.43212 6.867 2.43512 10.565 2.43512C10.565 1.64212 11.207 1.00012 12 1.00012Z\" fill=\"#DFE4E5\"></path><path d=\"M18.4998 1C20.9851 1 22.9998 3.01472 22.9998 5.5C22.9998 7.46681 21.738 9.13891 19.9798 9.75097L19.9999 9.74391L19.9998 14.6961C19.9998 15.4415 20.6838 16.0541 21.4254 16.1235L21.565 16.1301C22.357 16.1301 23 16.7731 23 17.5651C23 18.3115 22.4304 18.924 21.7031 18.9935L21.565 19.0001H15.999L15.9949 19.1996C15.8909 21.316 14.142 23 11.9998 23C9.791 23 8.00034 21.2097 7.9998 19.001L2.435 19.0001C1.642 19.0001 1 18.3581 1 17.5651C1 16.8197 1.56869 16.2063 2.29673 16.1367L2.435 16.1301C3.183 16.1301 3.93108 15.5575 4.01189 14.8266L4.01909 14.6961V9.1301C4.01909 5.4321 6.867 2.4351 10.565 2.4351C10.565 1.6421 11.207 1.0001 12 1.0001C12.792 1.0001 13.435 1.6421 13.435 2.4351C13.9894 2.4351 14.5251 2.50246 15.0353 2.62943L15.1154 2.53415C15.9402 1.59373 17.1506 1 18.4998 1ZM13.999 19.0001H9.999L10.0053 19.1493C10.0816 20.1841 10.9454 21 11.9998 21C13.0542 21 13.918 20.1841 13.9943 19.1493L13.999 19.0001ZM13.435 4.4351H10.565C8.08509 4.4351 6.13036 6.38081 6.02367 8.91176L6.01909 9.1301V14.6961C6.01909 15.5351 5.69715 16.2918 5.18016 16.88L5.068 17H18.942L18.8301 16.8778C18.357 16.3345 18.0498 15.6482 18.0054 14.8877L17.9998 14.6961L17.9991 9.97246L18.0373 9.97652C15.7693 9.74498 13.9998 7.82913 13.9998 5.5C13.9998 5.21597 14.0261 4.93808 14.0764 4.66865L14.1147 4.4851C13.9615 4.46208 13.8053 4.44697 13.6467 4.43985L13.435 4.4351ZM18.4998 3C17.1191 3 15.9998 4.11929 15.9998 5.5C15.9998 6.88071 17.1191 8 18.4998 8C19.8805 8 20.9998 6.88071 20.9998 5.5C20.9998 4.11929 19.8805 3 18.4998 3Z\" fill=\"#1F3A3E\"></path></g><defs><clipPath id=\"clip0_167_0\"><rect width=\"24\" height=\"24\" fill=\"white\"></rect></clipPath></defs></svg>";

/***/ }),

/***/ "c637":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpPageContainerHeader_vue_vue_type_style_index_0_id_7db3db16_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ca1e");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpPageContainerHeader_vue_vue_type_style_index_0_id_7db3db16_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpPageContainerHeader_vue_vue_type_style_index_0_id_7db3db16_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "c67e":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_167_177)\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M17.9809 15.7078L18.8527 13.6256L21 12.4139V11.6103L18.8534 10.3906L17.9941 8.30696L18.6558 5.93166L18.087 5.36362L15.7044 6.0192L13.6245 5.1471L12.4129 3H11.6093L10.3895 5.14655L8.30576 6.00595L5.93001 5.34321L5.36375 5.90947L6.0192 8.29155L5.1471 10.3715L3 11.583V12.3876L5.14482 13.6101L6.00385 15.693L5.34203 18.0688L5.90947 18.6362L8.29155 17.9808L10.3714 18.8529L11.5829 20.999H12.3873L13.609 18.8542L15.692 17.9951L18.0678 18.657L18.6362 18.0886L17.9809 15.7078Z\" fill=\"white\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M20.8733 18.6798L18.6562 20.897L15.8183 20.1065L15.0067 20.4412L13.5498 22.999H10.4153L8.96644 20.4325L8.15567 20.0925L5.31809 20.8733L3.10197 18.6572L3.89252 15.8193L3.55774 15.0076L1 13.5496V10.4151L3.56758 8.96634L3.90748 8.15567L3.1267 5.31809L5.34198 3.10281L8.17985 3.89446L8.99072 3.56004L10.4454 1H13.5808L15.0296 3.56758L15.8403 3.90748L18.6774 3.12683L20.8961 5.34235L20.1055 8.18067L20.44 8.99173L23 10.4464V13.5818L20.4327 15.0305L20.0925 15.843L20.8733 18.6798ZM17.9809 15.7078L18.8527 13.6256L21 12.4139V11.6103L18.8534 10.3906L17.9941 8.30696L18.6558 5.93166L18.087 5.36362L15.7044 6.0192L13.6245 5.1471L12.4129 3H11.6093L10.3895 5.14655L8.30576 6.00595L5.93001 5.34321L5.36375 5.90947L6.0192 8.29155L5.1471 10.3715L3 11.583V12.3876L5.14482 13.6101L6.00385 15.693L5.34203 18.0688L5.90947 18.6362L8.29155 17.9808L10.3714 18.8529L11.5829 20.999H12.3873L13.609 18.8542L15.692 17.9951L18.0678 18.657L18.6362 18.0886L17.9809 15.7078Z\" fill=\"#079CB2\"></path><circle cx=\"12\" cy=\"12\" r=\"3\" fill=\"#D5EAFD\" stroke=\"#079CB2\" stroke-width=\"2\"></circle></g><defs><clipPath id=\"clip0_167_177\"><rect width=\"24\" height=\"24\" fill=\"white\"></rect></clipPath></defs></svg>";

/***/ }),

/***/ "c67f":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.i, "@import url(https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css);"]);
exports.push([module.i, "@import url(https://cdn-prd.patientpop.com/pp-icon-font/v1.6.0/pp-icon-font.css);"]);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.pp-info-card[data-v-16df49b6]{background:#fff;box-shadow:0 1px 2px rgba(130,138,163,.25);transition:box-shadow .25s}@media screen{.pp-info-card[data-v-16df49b6]{-moz-column-break-inside:avoid;break-inside:avoid}}.pp-info-card--with-status[data-v-16df49b6]{position:relative}.pp-info-card--with-status[data-v-16df49b6]:before{background:var(--status-color);content:\"\";display:block;height:100%;left:0;position:absolute;top:0;width:5px}.pp-info-card[data-v-16df49b6]:hover{box-shadow:0 12px 24px rgba(74,84,114,.04),0 6px 12px rgba(74,84,114,.04),0 4px 4px rgba(74,84,114,.04),0 2px 2px rgba(74,84,114,.04)}@media print{.pp-info-card[data-v-16df49b6]{border:1px solid #d6d6d6;box-shadow:none}}.pp-info-card__header[data-v-16df49b6]{border-bottom:1px solid #d6d6d6}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "c696":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M17.9809 15.7078L18.8527 13.6256L21 12.4139V11.6103L18.8534 10.3906L17.9941 8.30696L18.6558 5.93166L18.087 5.36362L15.7044 6.0192L13.6245 5.1471L12.4129 3H11.6093L10.3895 5.14655L8.30576 6.00595L5.93001 5.34321L5.36375 5.90947L6.0192 8.29155L5.1471 10.3715L3 11.583V12.3876L5.14482 13.6101L6.00385 15.693L5.34203 18.0688L5.90947 18.6362L8.29155 17.9808L10.3714 18.8529L11.5829 20.999H12.3873L13.609 18.8542L15.692 17.9951L18.0678 18.657L18.6362 18.0886L17.9809 15.7078Z\" fill=\"white\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M20.8733 18.6798L18.6562 20.897L15.8183 20.1065L15.0067 20.4412L13.5498 22.999H10.4153L8.96644 20.4325L8.15567 20.0925L5.31809 20.8733L3.10197 18.6572L3.89252 15.8193L3.55774 15.0076L1 13.5496V10.4151L3.56758 8.96634L3.90748 8.15567L3.1267 5.31809L5.34198 3.10281L8.17985 3.89446L8.99072 3.56004L10.4454 1H13.5808L15.0296 3.56758L15.8403 3.90748L18.6774 3.12683L20.8961 5.34235L20.1055 8.18067L20.44 8.99173L23 10.4464V13.5818L20.4327 15.0305L20.0925 15.843L20.8733 18.6798ZM17.9809 15.7078L18.8527 13.6256L21 12.4139V11.6103L18.8534 10.3906L17.9941 8.30696L18.6558 5.93166L18.087 5.36362L15.7044 6.0192L13.6245 5.1471L12.4129 3H11.6093L10.3895 5.14655L8.30576 6.00595L5.93001 5.34321L5.36375 5.90947L6.0192 8.29155L5.1471 10.3715L3 11.583V12.3876L5.14482 13.6101L6.00385 15.693L5.34203 18.0688L5.90947 18.6362L8.29155 17.9808L10.3714 18.8529L11.5829 20.999H12.3873L13.609 18.8542L15.692 17.9951L18.0678 18.657L18.6362 18.0886L17.9809 15.7078Z\" fill=\"#688083\"></path><circle cx=\"12\" cy=\"12\" r=\"3\" fill=\"#DFE4E5\" stroke=\"#688083\" stroke-width=\"2\"></circle></svg>";

/***/ }),

/***/ "c6a6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("4de4");
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("7db0");
/* harmony import */ var core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_index_of_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("c975");
/* harmony import */ var core_js_modules_es_array_index_of_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("d81d");
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_some_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("45fc");
/* harmony import */ var core_js_modules_es_array_some_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_string_trim_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("498a");
/* harmony import */ var core_js_modules_es_string_trim_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_trim_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("5530");
/* harmony import */ var _src_components_VAutocomplete_VAutocomplete_sass__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("2bfd");
/* harmony import */ var _src_components_VAutocomplete_VAutocomplete_sass__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_src_components_VAutocomplete_VAutocomplete_sass__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _VSelect_VSelect__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("b974");
/* harmony import */ var _VTextField_VTextField__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("8654");
/* harmony import */ var _util_mergeData__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("d9f7");
/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("80d2");







// Styles
 // Extensions


 // Utilities




var defaultMenuProps = Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])(Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])({}, _VSelect_VSelect__WEBPACK_IMPORTED_MODULE_8__[/* defaultMenuProps */ "b"]), {}, {
  offsetY: true,
  offsetOverflow: true,
  transition: false
});
/* @vue/component */


/* harmony default export */ __webpack_exports__["a"] = (_VSelect_VSelect__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"].extend({
  name: 'v-autocomplete',
  props: {
    allowOverflow: {
      type: Boolean,
      default: true
    },
    autoSelectFirst: {
      type: Boolean,
      default: false
    },
    filter: {
      type: Function,
      default: function _default(item, queryText, itemText) {
        return itemText.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1;
      }
    },
    hideNoData: Boolean,
    menuProps: {
      type: _VSelect_VSelect__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"].options.props.menuProps.type,
      default: function _default() {
        return defaultMenuProps;
      }
    },
    noFilter: Boolean,
    searchInput: {
      type: String
    }
  },
  data: function data() {
    return {
      lazySearch: this.searchInput
    };
  },
  computed: {
    classes: function classes() {
      return Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])(Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])({}, _VSelect_VSelect__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"].options.computed.classes.call(this)), {}, {
        'v-autocomplete': true,
        'v-autocomplete--is-selecting-index': this.selectedIndex > -1
      });
    },
    computedItems: function computedItems() {
      return this.filteredItems;
    },
    selectedValues: function selectedValues() {
      var _this = this;

      return this.selectedItems.map(function (item) {
        return _this.getValue(item);
      });
    },
    hasDisplayedItems: function hasDisplayedItems() {
      var _this2 = this;

      return this.hideSelected ? this.filteredItems.some(function (item) {
        return !_this2.hasItem(item);
      }) : this.filteredItems.length > 0;
    },
    currentRange: function currentRange() {
      if (this.selectedItem == null) return 0;
      return String(this.getText(this.selectedItem)).length;
    },
    filteredItems: function filteredItems() {
      var _this3 = this;

      if (!this.isSearching || this.noFilter || this.internalSearch == null) return this.allItems;
      return this.allItems.filter(function (item) {
        var value = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_11__[/* getPropertyFromItem */ "r"])(item, _this3.itemText);
        var text = value != null ? String(value) : '';
        return _this3.filter(item, String(_this3.internalSearch), text);
      });
    },
    internalSearch: {
      get: function get() {
        return this.lazySearch;
      },
      set: function set(val) {
        this.lazySearch = val;
        this.$emit('update:search-input', val);
      }
    },
    isAnyValueAllowed: function isAnyValueAllowed() {
      return false;
    },
    isDirty: function isDirty() {
      return this.searchIsDirty || this.selectedItems.length > 0;
    },
    isSearching: function isSearching() {
      return this.multiple && this.searchIsDirty || this.searchIsDirty && this.internalSearch !== this.getText(this.selectedItem);
    },
    menuCanShow: function menuCanShow() {
      if (!this.isFocused) return false;
      return this.hasDisplayedItems || !this.hideNoData;
    },
    $_menuProps: function $_menuProps() {
      var props = _VSelect_VSelect__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"].options.computed.$_menuProps.call(this);
      props.contentClass = "v-autocomplete__content ".concat(props.contentClass || '').trim();
      return Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])(Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])({}, defaultMenuProps), props);
    },
    searchIsDirty: function searchIsDirty() {
      return this.internalSearch != null;
    },
    selectedItem: function selectedItem() {
      var _this4 = this;

      if (this.multiple) return null;
      return this.selectedItems.find(function (i) {
        return _this4.valueComparator(_this4.getValue(i), _this4.getValue(_this4.internalValue));
      });
    },
    listData: function listData() {
      var data = _VSelect_VSelect__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"].options.computed.listData.call(this);
      data.props = Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])(Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])({}, data.props), {}, {
        items: this.virtualizedItems,
        noFilter: this.noFilter || !this.isSearching || !this.filteredItems.length,
        searchInput: this.internalSearch
      });
      return data;
    }
  },
  watch: {
    filteredItems: 'onFilteredItemsChanged',
    internalValue: 'setSearch',
    isFocused: function isFocused(val) {
      if (val) {
        document.addEventListener('copy', this.onCopy);
        this.$refs.input && this.$refs.input.select();
      } else {
        document.removeEventListener('copy', this.onCopy);
        this.updateSelf();
      }
    },
    isMenuActive: function isMenuActive(val) {
      if (val || !this.hasSlot) return;
      this.lazySearch = null;
    },
    items: function items(val, oldVal) {
      // If we are focused, the menu
      // is not active, hide no data is enabled,
      // and items change
      // User is probably async loading
      // items, try to activate the menu
      if (!(oldVal && oldVal.length) && this.hideNoData && this.isFocused && !this.isMenuActive && val.length) this.activateMenu();
    },
    searchInput: function searchInput(val) {
      this.lazySearch = val;
    },
    internalSearch: 'onInternalSearchChanged',
    itemText: 'updateSelf'
  },
  created: function created() {
    this.setSearch();
  },
  destroyed: function destroyed() {
    document.removeEventListener('copy', this.onCopy);
  },
  methods: {
    onFilteredItemsChanged: function onFilteredItemsChanged(val, oldVal) {
      var _this5 = this;

      // TODO: How is the watcher triggered
      // for duplicate items? no idea
      if (val === oldVal) return;
      this.setMenuIndex(-1);
      this.$nextTick(function () {
        if (!_this5.internalSearch || val.length !== 1 && !_this5.autoSelectFirst) return;

        _this5.$refs.menu.getTiles();

        _this5.setMenuIndex(0);
      });
    },
    onInternalSearchChanged: function onInternalSearchChanged() {
      this.updateMenuDimensions();
    },
    updateMenuDimensions: function updateMenuDimensions() {
      // Type from menuable is not making it through
      this.isMenuActive && this.$refs.menu && this.$refs.menu.updateDimensions();
    },
    changeSelectedIndex: function changeSelectedIndex(keyCode) {
      // Do not allow changing of selectedIndex
      // when search is dirty
      if (this.searchIsDirty) return;

      if (this.multiple && keyCode === _util_helpers__WEBPACK_IMPORTED_MODULE_11__[/* keyCodes */ "x"].left) {
        if (this.selectedIndex === -1) {
          this.selectedIndex = this.selectedItems.length - 1;
        } else {
          this.selectedIndex--;
        }
      } else if (this.multiple && keyCode === _util_helpers__WEBPACK_IMPORTED_MODULE_11__[/* keyCodes */ "x"].right) {
        if (this.selectedIndex >= this.selectedItems.length - 1) {
          this.selectedIndex = -1;
        } else {
          this.selectedIndex++;
        }
      } else if (keyCode === _util_helpers__WEBPACK_IMPORTED_MODULE_11__[/* keyCodes */ "x"].backspace || keyCode === _util_helpers__WEBPACK_IMPORTED_MODULE_11__[/* keyCodes */ "x"].delete) {
        this.deleteCurrentItem();
      }
    },
    deleteCurrentItem: function deleteCurrentItem() {
      var curIndex = this.selectedIndex;
      var curItem = this.selectedItems[curIndex]; // Do nothing if input or item is disabled

      if (!this.isInteractive || this.getDisabled(curItem)) return;
      var lastIndex = this.selectedItems.length - 1; // Select the last item if
      // there is no selection

      if (this.selectedIndex === -1 && lastIndex !== 0) {
        this.selectedIndex = lastIndex;
        return;
      }

      var length = this.selectedItems.length;
      var nextIndex = curIndex !== length - 1 ? curIndex : curIndex - 1;
      var nextItem = this.selectedItems[nextIndex];

      if (!nextItem) {
        this.setValue(this.multiple ? [] : null);
      } else {
        this.selectItem(curItem);
      }

      this.selectedIndex = nextIndex;
    },
    clearableCallback: function clearableCallback() {
      this.internalSearch = null;
      _VSelect_VSelect__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"].options.methods.clearableCallback.call(this);
    },
    genInput: function genInput() {
      var input = _VTextField_VTextField__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"].options.methods.genInput.call(this);
      input.data = Object(_util_mergeData__WEBPACK_IMPORTED_MODULE_10__[/* default */ "a"])(input.data, {
        attrs: {
          'aria-activedescendant': Object(_util_helpers__WEBPACK_IMPORTED_MODULE_11__[/* getObjectValueByPath */ "p"])(this.$refs.menu, 'activeTile.id'),
          autocomplete: Object(_util_helpers__WEBPACK_IMPORTED_MODULE_11__[/* getObjectValueByPath */ "p"])(input.data, 'attrs.autocomplete', 'off')
        },
        domProps: {
          value: this.internalSearch
        }
      });
      return input;
    },
    genInputSlot: function genInputSlot() {
      var slot = _VSelect_VSelect__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"].options.methods.genInputSlot.call(this);
      slot.data.attrs.role = 'combobox';
      return slot;
    },
    genSelections: function genSelections() {
      return this.hasSlot || this.multiple ? _VSelect_VSelect__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"].options.methods.genSelections.call(this) : [];
    },
    onClick: function onClick(e) {
      if (!this.isInteractive) return;
      this.selectedIndex > -1 ? this.selectedIndex = -1 : this.onFocus();
      if (!this.isAppendInner(e.target)) this.activateMenu();
    },
    onInput: function onInput(e) {
      if (this.selectedIndex > -1 || !e.target) return;
      var target = e.target;
      var value = target.value; // If typing and menu is not currently active

      if (target.value) this.activateMenu();
      this.internalSearch = value;
      this.badInput = target.validity && target.validity.badInput;
    },
    onKeyDown: function onKeyDown(e) {
      var keyCode = e.keyCode;
      _VSelect_VSelect__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"].options.methods.onKeyDown.call(this, e); // The ordering is important here
      // allows new value to be updated
      // and then moves the index to the
      // proper location

      this.changeSelectedIndex(keyCode);
    },
    onSpaceDown: function onSpaceDown(e) {},
    onTabDown: function onTabDown(e) {
      _VSelect_VSelect__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"].options.methods.onTabDown.call(this, e);
      this.updateSelf();
    },
    onUpDown: function onUpDown(e) {
      // Prevent screen from scrolling
      e.preventDefault(); // For autocomplete / combobox, cycling
      // interfers with native up/down behavior
      // instead activate the menu

      this.activateMenu();
    },
    selectItem: function selectItem(item) {
      _VSelect_VSelect__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"].options.methods.selectItem.call(this, item);
      this.setSearch();
    },
    setSelectedItems: function setSelectedItems() {
      _VSelect_VSelect__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"].options.methods.setSelectedItems.call(this); // #4273 Don't replace if searching
      // #4403 Don't replace if focused

      if (!this.isFocused) this.setSearch();
    },
    setSearch: function setSearch() {
      var _this6 = this;

      // Wait for nextTick so selectedItem
      // has had time to update
      this.$nextTick(function () {
        if (!_this6.multiple || !_this6.internalSearch || !_this6.isMenuActive) {
          _this6.internalSearch = !_this6.selectedItems.length || _this6.multiple || _this6.hasSlot ? null : _this6.getText(_this6.selectedItem);
        }
      });
    },
    updateSelf: function updateSelf() {
      if (!this.searchIsDirty && !this.internalValue) return;

      if (!this.valueComparator(this.internalSearch, this.getValue(this.internalValue))) {
        this.setSearch();
      }
    },
    hasItem: function hasItem(item) {
      return this.selectedValues.indexOf(this.getValue(item)) > -1;
    },
    onCopy: function onCopy(event) {
      var _event$clipboardData, _event$clipboardData2;

      if (this.selectedIndex === -1) return;
      var currentItem = this.selectedItems[this.selectedIndex];
      var currentItemText = this.getText(currentItem);
      (_event$clipboardData = event.clipboardData) == null ? void 0 : _event$clipboardData.setData('text/plain', currentItemText);
      (_event$clipboardData2 = event.clipboardData) == null ? void 0 : _event$clipboardData2.setData('text/vnd.vuetify.autocomplete.item+plain', currentItemText);
      event.preventDefault();
    }
  }
}));

/***/ }),

/***/ "c6ae":
/***/ (function(module, exports, __webpack_require__) {

var startOfSecond = __webpack_require__("2299")

/**
 * @category Second Helpers
 * @summary Are the given dates in the same second?
 *
 * @description
 * Are the given dates in the same second?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same second
 *
 * @example
 * // Are 4 September 2014 06:30:15.000 and 4 September 2014 06:30.15.500
 * // in the same second?
 * var result = isSameSecond(
 *   new Date(2014, 8, 4, 6, 30, 15),
 *   new Date(2014, 8, 4, 6, 30, 15, 500)
 * )
 * //=> true
 */
function isSameSecond (dirtyDateLeft, dirtyDateRight) {
  var dateLeftStartOfSecond = startOfSecond(dirtyDateLeft)
  var dateRightStartOfSecond = startOfSecond(dirtyDateRight)

  return dateLeftStartOfSecond.getTime() === dateRightStartOfSecond.getTime()
}

module.exports = isSameSecond


/***/ }),

/***/ "c6b6":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),

/***/ "c6cd":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var setGlobal = __webpack_require__("ce4e");

var SHARED = '__core-js_shared__';
var store = global[SHARED] || setGlobal(SHARED, {});

module.exports = store;


/***/ }),

/***/ "c6e8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpScrollableList_vue_vue_type_style_index_0_id_766f6a8c_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("9b7d");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpScrollableList_vue_vue_type_style_index_0_id_766f6a8c_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpScrollableList_vue_vue_type_style_index_0_id_766f6a8c_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "c6f2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpNotification_vue_vue_type_style_index_0_id_b4d17398_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1a9d");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpNotification_vue_vue_type_style_index_0_id_b4d17398_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpNotification_vue_vue_type_style_index_0_id_b4d17398_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "c740":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $findIndex = __webpack_require__("b727").findIndex;
var addToUnscopables = __webpack_require__("44d2");
var arrayMethodUsesToLength = __webpack_require__("ae40");

var FIND_INDEX = 'findIndex';
var SKIPS_HOLES = true;

var USES_TO_LENGTH = arrayMethodUsesToLength(FIND_INDEX);

// Shouldn't skip holes
if (FIND_INDEX in []) Array(1)[FIND_INDEX](function () { SKIPS_HOLES = false; });

// `Array.prototype.findIndex` method
// https://tc39.es/ecma262/#sec-array.prototype.findindex
$({ target: 'Array', proto: true, forced: SKIPS_HOLES || !USES_TO_LENGTH }, {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $findIndex(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables(FIND_INDEX);


/***/ }),

/***/ "c7a1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpChartHorizontalSlide_vue_vue_type_style_index_0_id_624fcc47_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("6695");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpChartHorizontalSlide_vue_vue_type_style_index_0_id_624fcc47_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpChartHorizontalSlide_vue_vue_type_style_index_0_id_624fcc47_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "c7cd":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var createHTML = __webpack_require__("857a");
var forcedStringHTMLMethod = __webpack_require__("af03");

// `String.prototype.fixed` method
// https://tc39.es/ecma262/#sec-string.prototype.fixed
$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('fixed') }, {
  fixed: function fixed() {
    return createHTML(this, 'tt', '', '');
  }
});


/***/ }),

/***/ "c7ce":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("c8d5")

/**
 * @category Week Helpers
 * @summary Return the start of a week for the given date.
 *
 * @description
 * Return the start of a week for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @param {Object} [options] - the object with options
 * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the start of a week
 *
 * @example
 * // The start of a week for 2 September 2014 11:55:00:
 * var result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
 * var result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), {weekStartsOn: 1})
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfWeek (dirtyDate, dirtyOptions) {
  var weekStartsOn = dirtyOptions ? (Number(dirtyOptions.weekStartsOn) || 0) : 0

  var date = parse(dirtyDate)
  var day = date.getDay()
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn

  date.setDate(date.getDate() - diff)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = startOfWeek


/***/ }),

/***/ "c7e5":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.v-responsive{position:relative;overflow:hidden;flex:1 0 auto;max-width:100%;display:flex}.v-responsive__content{flex:1 0 0px;max-width:100%}.v-application--is-ltr .v-responsive__sizer~.v-responsive__content{margin-left:-100%}.v-application--is-rtl .v-responsive__sizer~.v-responsive__content{margin-right:-100%}.v-responsive__sizer{transition:padding-bottom .2s cubic-bezier(.25,.8,.5,1);flex:1 0 0px}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "c7fb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c662cfac-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/portal/PpPortal.vue?vue&type=template&id=e6e0eea4&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pp-app',{staticClass:"container-fluid",class:{'pp-app--white-bg': _vm.whiteBackground}},[_c('aside',{staticClass:"portal-side",class:{'portal-side--with-pendo': _vm.withPendo}},[_c('pp-side-nav',_vm._g({attrs:{"nav-tree":_vm.navTree},on:{"navigate":_vm.handleNavigate},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('div',{staticClass:"px-7 py-3 mt-n3 practice-header"},[_c('img',{staticClass:"hidden-sm-and-down practice-header__logo mb-2",attrs:{"src":"https://ui-cdn.patientpop.com/assets/img/tebra-brand/tebra-logo-white.svg","alt":"Tebra company logo"}}),_c('div',{staticClass:"text-h5 text-truncate white--text",class:{ 'practice-header__switch-practice': _vm.isInternalUser },on:{"click":function($event){$event.stopPropagation();return _vm.toggleSwitchPractice($event)}}},[_vm._v(" "+_vm._s(_vm.practiceName)+" "),(_vm.isInternalUser)?_c('i',{staticClass:"pp-icon-chevron-down ml-2"}):_vm._e()]),(_vm.showSwitchPractice)?_c('div',{staticClass:"portal-side__switch-practice elevation-9 rounded pa-5 ma-2 ml-n5"},[_c('pp-input-search',{attrs:{"items":_vm.practices,"loading":_vm.isSearching,"placeholder":"Search Practices","item-text":"name","item-value":"uuid","no-data-icon":"practice","no-filter":false},on:{"query":_vm.executeSearch,"clear-search":_vm.clearSearch},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var item = ref.item;
return [(item)?_c('div',{staticClass:"result-item__content",on:{"click":function($event){return _vm.switchPractice(item)}}},[_c('i',{staticClass:"pp-icon-practice mr-2"}),_c('span',{staticClass:"text-truncate"},[_vm._v(_vm._s(item.name))])]):_vm._e()]}}],null,false,1343616428)})],1):_vm._e()])]},proxy:true}])},_vm.$listeners))],1),_c('main',{staticClass:"container pt-0",class:{'container--fluid': _vm.fullWidth}},[_c('pp-portal-user-menu',_vm._g({attrs:{"image":_vm.userImage,"name":_vm.userName}},_vm.$listeners)),_vm._t("content")],2),_c('pp-notification',{attrs:{"notification":_vm.notification}}),(_vm.timeOutConfiguration.maxTime)?_c('pp-idle-time',_vm._g({attrs:{"session-inactivity-timeout":_vm.timeOutConfiguration.sessionInactivityTimeout,"heart-beat-time":_vm.timeOutConfiguration.heartBeatTime,"max-time":_vm.timeOutConfiguration.maxTime,"warning-time":_vm.timeOutConfiguration.warningTime}},_vm.$listeners)):_vm._e()],1)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/portal/PpPortal.vue?vue&type=template&id=e6e0eea4&scoped=true&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("caad");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__("ac1f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("2532");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.replace.js
var es_string_replace = __webpack_require__("5319");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.trim.js
var es_string_trim = __webpack_require__("498a");

// EXTERNAL MODULE: ./src/components/app/PpApp.vue + 4 modules
var PpApp = __webpack_require__("f4b7");

// EXTERNAL MODULE: ./src/components/side-nav/PpSideNav.vue + 4 modules
var PpSideNav = __webpack_require__("d123");

// EXTERNAL MODULE: ./src/components/notification/PpNotification.vue + 4 modules
var PpNotification = __webpack_require__("2093");

// EXTERNAL MODULE: ./src/components/portal/user-menu/PpPortalUserMenu.vue + 5 modules
var PpPortalUserMenu = __webpack_require__("830a");

// EXTERNAL MODULE: ./src/components/idle-time/PpIdleTime.vue + 5 modules
var PpIdleTime = __webpack_require__("5b74");

// EXTERNAL MODULE: ./src/components/input/search/PpInputSearch.vue + 4 modules
var PpInputSearch = __webpack_require__("52af");

// EXTERNAL MODULE: ./src/components/portal/constants.js
var constants = __webpack_require__("463f");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/portal/PpPortal.vue?vue&type=script&lang=js&





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * Portal app set up with nav, top bar, notification and idle timeout
 */







/* harmony default export */ var PpPortalvue_type_script_lang_js_ = ({
  name: 'PpPortal',
  components: {
    'pp-app': PpApp["default"],
    'pp-side-nav': PpSideNav["default"],
    'pp-notification': PpNotification["default"],
    'pp-portal-user-menu': PpPortalUserMenu["default"],
    'pp-idle-time': PpIdleTime["default"],
    'pp-input-search': PpInputSearch["default"]
  },
  props: {
    practiceName: {
      type: String,
      required: true
    },
    notification: {
      type: Object,
      default: function _default() {
        return {
          message: 'Error',
          status: 'error',
          duration: 3500
        };
      }
    },
    navTree: {
      type: Array,
      required: true
    },
    timeOutConfiguration: {
      type: Object,
      required: true
    },
    userImage: {
      type: String,
      default: ''
    },
    userName: {
      type: String,
      required: true
    },
    isInternalUser: {
      type: Boolean,
      default: false
    },

    /**
     * List of the practice are found
    */
    practices: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    isSearching: {
      type: Boolean,
      default: false
    },
    whiteBackground: {
      type: Boolean,
      default: false
    },

    /**
     * if full width container is being used
     */
    fullWidth: {
      type: Boolean,
      default: false
    },

    /**
     * Adds space in left nav for the pendo badge
     */
    withPendo: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      showSwitchPractice: false
    };
  },
  mounted: function mounted() {
    var locationHash = window.location.hash.substr(1);

    if (locationHash.includes('settings/')) {
      this.openSettings(locationHash.replace('settings/', ''));
    }
  },
  methods: {
    handleNavigate: function handleNavigate(obj) {
      if (obj.id === 'settings') {
        this.openSettings();
      }
    },
    openSettings: function openSettings() {
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      document.dispatchEvent(new CustomEvent(constants["a" /* PORTAL_SETTINGS_OPEN */], {
        detail: {
          page: page
        }
      }));
    },
    toggleSwitchPractice: function toggleSwitchPractice() {
      if (!this.isInternalUser) {
        return;
      }

      this.showSwitchPractice = !this.showSwitchPractice;
      this.clearSearch();
    },
    executeSearch: function executeSearch(query) {
      if (query && query.trim()) {
        this.$emit('query', query);
      }
    },
    clearSearch: function clearSearch() {
      this.$emit('clear-search');
    },
    onFocus: function onFocus() {
      this.$emit('focused');
    },
    switchPractice: function switchPractice(practice) {
      this.$emit('switch-practice', practice);
    }
  }
});
// CONCATENATED MODULE: ./src/components/portal/PpPortal.vue?vue&type=script&lang=js&
 /* harmony default export */ var portal_PpPortalvue_type_script_lang_js_ = (PpPortalvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/portal/PpPortal.vue?vue&type=style&index=0&id=e6e0eea4&lang=scss&scoped=true&
var PpPortalvue_type_style_index_0_id_e6e0eea4_lang_scss_scoped_true_ = __webpack_require__("74c8");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/portal/PpPortal.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  portal_PpPortalvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "e6e0eea4",
  null
  
)

/* harmony default export */ var PpPortal = __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "c873":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("c8d5")

/**
 * @category Common Helpers
 * @summary Compare the two dates reverse chronologically and return -1, 0 or 1.
 *
 * @description
 * Compare the two dates and return -1 if the first date is after the second,
 * 1 if the first date is before the second or 0 if dates are equal.
 *
 * @param {Date|String|Number} dateLeft - the first date to compare
 * @param {Date|String|Number} dateRight - the second date to compare
 * @returns {Number} the result of the comparison
 *
 * @example
 * // Compare 11 February 1987 and 10 July 1989 reverse chronologically:
 * var result = compareDesc(
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * )
 * //=> 1
 *
 * @example
 * // Sort the array of dates in reverse chronological order:
 * var result = [
 *   new Date(1995, 6, 2),
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * ].sort(compareDesc)
 * //=> [
 * //   Sun Jul 02 1995 00:00:00,
 * //   Mon Jul 10 1989 00:00:00,
 * //   Wed Feb 11 1987 00:00:00
 * // ]
 */
function compareDesc (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var timeLeft = dateLeft.getTime()
  var dateRight = parse(dirtyDateRight)
  var timeRight = dateRight.getTime()

  if (timeLeft > timeRight) {
    return -1
  } else if (timeLeft < timeRight) {
    return 1
  } else {
    return 0
  }
}

module.exports = compareDesc


/***/ }),

/***/ "c8ba":
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "c8d2":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");
var whitespaces = __webpack_require__("5899");

var non = '\u200B\u0085\u180E';

// check that a method works with the correct list
// of whitespaces and has a correct name
module.exports = function (METHOD_NAME) {
  return fails(function () {
    return !!whitespaces[METHOD_NAME]() || non[METHOD_NAME]() != non || whitespaces[METHOD_NAME].name !== METHOD_NAME;
  });
};


/***/ }),

/***/ "c8d5":
/***/ (function(module, exports, __webpack_require__) {

var getTimezoneOffsetInMilliseconds = __webpack_require__("5465")
var isDate = __webpack_require__("a735")

var MILLISECONDS_IN_HOUR = 3600000
var MILLISECONDS_IN_MINUTE = 60000
var DEFAULT_ADDITIONAL_DIGITS = 2

var parseTokenDateTimeDelimeter = /[T ]/
var parseTokenPlainTime = /:/

// year tokens
var parseTokenYY = /^(\d{2})$/
var parseTokensYYY = [
  /^([+-]\d{2})$/, // 0 additional digits
  /^([+-]\d{3})$/, // 1 additional digit
  /^([+-]\d{4})$/ // 2 additional digits
]

var parseTokenYYYY = /^(\d{4})/
var parseTokensYYYYY = [
  /^([+-]\d{4})/, // 0 additional digits
  /^([+-]\d{5})/, // 1 additional digit
  /^([+-]\d{6})/ // 2 additional digits
]

// date tokens
var parseTokenMM = /^-(\d{2})$/
var parseTokenDDD = /^-?(\d{3})$/
var parseTokenMMDD = /^-?(\d{2})-?(\d{2})$/
var parseTokenWww = /^-?W(\d{2})$/
var parseTokenWwwD = /^-?W(\d{2})-?(\d{1})$/

// time tokens
var parseTokenHH = /^(\d{2}([.,]\d*)?)$/
var parseTokenHHMM = /^(\d{2}):?(\d{2}([.,]\d*)?)$/
var parseTokenHHMMSS = /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/

// timezone tokens
var parseTokenTimezone = /([Z+-].*)$/
var parseTokenTimezoneZ = /^(Z)$/
var parseTokenTimezoneHH = /^([+-])(\d{2})$/
var parseTokenTimezoneHHMM = /^([+-])(\d{2}):?(\d{2})$/

/**
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If an argument is a string, the function tries to parse it.
 * Function accepts complete ISO 8601 formats as well as partial implementations.
 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
 *
 * If all above fails, the function passes the given argument to Date constructor.
 *
 * @param {Date|String|Number} argument - the value to convert
 * @param {Object} [options] - the object with options
 * @param {0 | 1 | 2} [options.additionalDigits=2] - the additional number of digits in the extended year format
 * @returns {Date} the parsed date in the local time zone
 *
 * @example
 * // Convert string '2014-02-11T11:30:30' to date:
 * var result = parse('2014-02-11T11:30:30')
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Parse string '+02014101',
 * // if the additional number of digits in the extended year format is 1:
 * var result = parse('+02014101', {additionalDigits: 1})
 * //=> Fri Apr 11 2014 00:00:00
 */
function parse (argument, dirtyOptions) {
  if (isDate(argument)) {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime())
  } else if (typeof argument !== 'string') {
    return new Date(argument)
  }

  var options = dirtyOptions || {}
  var additionalDigits = options.additionalDigits
  if (additionalDigits == null) {
    additionalDigits = DEFAULT_ADDITIONAL_DIGITS
  } else {
    additionalDigits = Number(additionalDigits)
  }

  var dateStrings = splitDateString(argument)

  var parseYearResult = parseYear(dateStrings.date, additionalDigits)
  var year = parseYearResult.year
  var restDateString = parseYearResult.restDateString

  var date = parseDate(restDateString, year)

  if (date) {
    var timestamp = date.getTime()
    var time = 0
    var offset

    if (dateStrings.time) {
      time = parseTime(dateStrings.time)
    }

    if (dateStrings.timezone) {
      offset = parseTimezone(dateStrings.timezone) * MILLISECONDS_IN_MINUTE
    } else {
      var fullTime = timestamp + time
      var fullTimeDate = new Date(fullTime)

      offset = getTimezoneOffsetInMilliseconds(fullTimeDate)

      // Adjust time when it's coming from DST
      var fullTimeDateNextDay = new Date(fullTime)
      fullTimeDateNextDay.setDate(fullTimeDate.getDate() + 1)
      var offsetDiff =
        getTimezoneOffsetInMilliseconds(fullTimeDateNextDay) -
        getTimezoneOffsetInMilliseconds(fullTimeDate)
      if (offsetDiff > 0) {
        offset += offsetDiff
      }
    }

    return new Date(timestamp + time + offset)
  } else {
    return new Date(argument)
  }
}

function splitDateString (dateString) {
  var dateStrings = {}
  var array = dateString.split(parseTokenDateTimeDelimeter)
  var timeString

  if (parseTokenPlainTime.test(array[0])) {
    dateStrings.date = null
    timeString = array[0]
  } else {
    dateStrings.date = array[0]
    timeString = array[1]
  }

  if (timeString) {
    var token = parseTokenTimezone.exec(timeString)
    if (token) {
      dateStrings.time = timeString.replace(token[1], '')
      dateStrings.timezone = token[1]
    } else {
      dateStrings.time = timeString
    }
  }

  return dateStrings
}

function parseYear (dateString, additionalDigits) {
  var parseTokenYYY = parseTokensYYY[additionalDigits]
  var parseTokenYYYYY = parseTokensYYYYY[additionalDigits]

  var token

  // YYYY or ±YYYYY
  token = parseTokenYYYY.exec(dateString) || parseTokenYYYYY.exec(dateString)
  if (token) {
    var yearString = token[1]
    return {
      year: parseInt(yearString, 10),
      restDateString: dateString.slice(yearString.length)
    }
  }

  // YY or ±YYY
  token = parseTokenYY.exec(dateString) || parseTokenYYY.exec(dateString)
  if (token) {
    var centuryString = token[1]
    return {
      year: parseInt(centuryString, 10) * 100,
      restDateString: dateString.slice(centuryString.length)
    }
  }

  // Invalid ISO-formatted year
  return {
    year: null
  }
}

function parseDate (dateString, year) {
  // Invalid ISO-formatted year
  if (year === null) {
    return null
  }

  var token
  var date
  var month
  var week

  // YYYY
  if (dateString.length === 0) {
    date = new Date(0)
    date.setUTCFullYear(year)
    return date
  }

  // YYYY-MM
  token = parseTokenMM.exec(dateString)
  if (token) {
    date = new Date(0)
    month = parseInt(token[1], 10) - 1
    date.setUTCFullYear(year, month)
    return date
  }

  // YYYY-DDD or YYYYDDD
  token = parseTokenDDD.exec(dateString)
  if (token) {
    date = new Date(0)
    var dayOfYear = parseInt(token[1], 10)
    date.setUTCFullYear(year, 0, dayOfYear)
    return date
  }

  // YYYY-MM-DD or YYYYMMDD
  token = parseTokenMMDD.exec(dateString)
  if (token) {
    date = new Date(0)
    month = parseInt(token[1], 10) - 1
    var day = parseInt(token[2], 10)
    date.setUTCFullYear(year, month, day)
    return date
  }

  // YYYY-Www or YYYYWww
  token = parseTokenWww.exec(dateString)
  if (token) {
    week = parseInt(token[1], 10) - 1
    return dayOfISOYear(year, week)
  }

  // YYYY-Www-D or YYYYWwwD
  token = parseTokenWwwD.exec(dateString)
  if (token) {
    week = parseInt(token[1], 10) - 1
    var dayOfWeek = parseInt(token[2], 10) - 1
    return dayOfISOYear(year, week, dayOfWeek)
  }

  // Invalid ISO-formatted date
  return null
}

function parseTime (timeString) {
  var token
  var hours
  var minutes

  // hh
  token = parseTokenHH.exec(timeString)
  if (token) {
    hours = parseFloat(token[1].replace(',', '.'))
    return (hours % 24) * MILLISECONDS_IN_HOUR
  }

  // hh:mm or hhmm
  token = parseTokenHHMM.exec(timeString)
  if (token) {
    hours = parseInt(token[1], 10)
    minutes = parseFloat(token[2].replace(',', '.'))
    return (hours % 24) * MILLISECONDS_IN_HOUR +
      minutes * MILLISECONDS_IN_MINUTE
  }

  // hh:mm:ss or hhmmss
  token = parseTokenHHMMSS.exec(timeString)
  if (token) {
    hours = parseInt(token[1], 10)
    minutes = parseInt(token[2], 10)
    var seconds = parseFloat(token[3].replace(',', '.'))
    return (hours % 24) * MILLISECONDS_IN_HOUR +
      minutes * MILLISECONDS_IN_MINUTE +
      seconds * 1000
  }

  // Invalid ISO-formatted time
  return null
}

function parseTimezone (timezoneString) {
  var token
  var absoluteOffset

  // Z
  token = parseTokenTimezoneZ.exec(timezoneString)
  if (token) {
    return 0
  }

  // ±hh
  token = parseTokenTimezoneHH.exec(timezoneString)
  if (token) {
    absoluteOffset = parseInt(token[2], 10) * 60
    return (token[1] === '+') ? -absoluteOffset : absoluteOffset
  }

  // ±hh:mm or ±hhmm
  token = parseTokenTimezoneHHMM.exec(timezoneString)
  if (token) {
    absoluteOffset = parseInt(token[2], 10) * 60 + parseInt(token[3], 10)
    return (token[1] === '+') ? -absoluteOffset : absoluteOffset
  }

  return 0
}

function dayOfISOYear (isoYear, week, day) {
  week = week || 0
  day = day || 0
  var date = new Date(0)
  date.setUTCFullYear(isoYear, 0, 4)
  var fourthOfJanuaryDay = date.getUTCDay() || 7
  var diff = week * 7 + day + 1 - fourthOfJanuaryDay
  date.setUTCDate(date.getUTCDate() + diff)
  return date
}

module.exports = parse


/***/ }),

/***/ "c91f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpInputSwitch_vue_vue_type_style_index_0_id_25e1e7cd_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1e7c");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpInputSwitch_vue_vue_type_style_index_0_id_25e1e7cd_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpInputSwitch_vue_vue_type_style_index_0_id_25e1e7cd_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "c96a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var createHTML = __webpack_require__("857a");
var forcedStringHTMLMethod = __webpack_require__("af03");

// `String.prototype.small` method
// https://tc39.es/ecma262/#sec-string.prototype.small
$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('small') }, {
  small: function small() {
    return createHTML(this, 'small', '', '');
  }
});


/***/ }),

/***/ "c975":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $indexOf = __webpack_require__("4d64").indexOf;
var arrayMethodIsStrict = __webpack_require__("a640");
var arrayMethodUsesToLength = __webpack_require__("ae40");

var nativeIndexOf = [].indexOf;

var NEGATIVE_ZERO = !!nativeIndexOf && 1 / [1].indexOf(1, -0) < 0;
var STRICT_METHOD = arrayMethodIsStrict('indexOf');
var USES_TO_LENGTH = arrayMethodUsesToLength('indexOf', { ACCESSORS: true, 1: 0 });

// `Array.prototype.indexOf` method
// https://tc39.es/ecma262/#sec-array.prototype.indexof
$({ target: 'Array', proto: true, forced: NEGATIVE_ZERO || !STRICT_METHOD || !USES_TO_LENGTH }, {
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? nativeIndexOf.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "c980":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("c8d5")

/**
 * @category Weekday Helpers
 * @summary Is the given date Wednesday?
 *
 * @description
 * Is the given date Wednesday?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is Wednesday
 *
 * @example
 * // Is 24 September 2014 Wednesday?
 * var result = isWednesday(new Date(2014, 8, 24))
 * //=> true
 */
function isWednesday (dirtyDate) {
  return parse(dirtyDate).getDay() === 3
}

module.exports = isWednesday


/***/ }),

/***/ "c982":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("1403");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("0736a3ed", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "c995":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("a9e3");
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ade3");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("8bbf");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_2__);



/* harmony default export */ __webpack_exports__["a"] = (vue__WEBPACK_IMPORTED_MODULE_2___default.a.extend({
  name: 'elevatable',
  props: {
    elevation: [Number, String]
  },
  computed: {
    computedElevation: function computedElevation() {
      return this.elevation;
    },
    elevationClasses: function elevationClasses() {
      var elevation = this.computedElevation;
      if (elevation == null) return {};
      if (isNaN(parseInt(elevation))) return {};
      return Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])({}, "elevation-".concat(this.elevation), true);
    }
  }
}));

/***/ }),

/***/ "c9d6":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.i, "@import url(https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css);"]);
exports.push([module.i, "@import url(https://cdn-prd.patientpop.com/pp-icon-font/v1.6.0/pp-icon-font.css);"]);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.pp-input-date-native[data-v-196abf97]{border:1px solid var(--date-native-border,#d6d6d6);color:#2b2b2b;display:block;width:100%}.pp-input-date-native[data-v-196abf97]:focus,.pp-input-date-native[data-v-196abf97]:focus-visible{outline:none}.pp-input-date-native[data-v-196abf97]:not(.pp-input-date-native--error):focus,.pp-input-date-native[data-v-196abf97]:not(.pp-input-date-native--error):focus-visible{--date-native-border:#079cb2}.pp-input-date-native--error[data-v-196abf97]{--date-native-border:#d83b4d}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "ca1e":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("da7a");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("f5dac20a", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "ca68":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M11.9996 18.1543L17.2921 20.9337C17.6596 21.1267 18.0888 20.8146 18.0186 20.4055L17.008 14.5196L21.2886 10.3516C21.5861 10.0619 21.4221 9.55679 21.0111 9.49714L15.0949 8.63842L12.4486 3.28234C12.2648 2.91036 11.7344 2.91036 11.5506 3.28234L8.90425 8.63842L2.98804 9.49714C2.57707 9.55679 2.41305 10.0619 2.71059 10.3516L6.99122 14.5196L5.98058 20.4055C5.91034 20.8146 6.33959 21.1267 6.70705 20.9337L11.9996 18.1543Z\" fill=\"white\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M11.9993 18.1543L6.70673 20.9337C6.33927 21.1266 5.91002 20.8146 5.98026 20.4055L6.9909 14.5196L2.71027 10.3516C2.41273 10.0619 2.57675 9.55678 2.98772 9.49713L8.90392 8.63841L11.5502 3.28233C11.734 2.91035 12.2645 2.91035 12.4483 3.28233L15.0946 8.63841L21.0108 9.49713C21.4218 9.55678 21.5858 10.0619 21.2883 10.3516L17.0076 14.5196L18.0183 20.4055C18.0885 20.8146 17.6593 21.1266 17.2918 20.9337L11.9993 18.1543ZM19.1605 15.2195L19.9927 20.0665C20.3439 22.1118 18.1977 23.6722 16.3604 22.7073L11.9993 20.4171L7.63816 22.7073C5.80086 23.6722 3.65461 22.1118 4.0058 20.0665L4.83805 15.2195L1.3127 11.787C-0.174971 10.3384 0.645106 7.81281 2.69995 7.51456L7.57422 6.80707L9.75416 2.39493C10.6731 0.53502 13.3254 0.535028 14.2444 2.39493L16.4243 6.80707L21.2986 7.51456C23.3534 7.81281 24.1735 10.3384 22.6858 11.787L19.1605 15.2195Z\" fill=\"#079CB2\"></path><path d=\"M11.9996 15.6793L15.0334 17.2801C15.2167 17.3768 15.4314 17.2212 15.3965 17.0169L14.8169 13.625L17.273 11.222C17.421 11.0773 17.3391 10.8258 17.1343 10.7959L13.7408 10.301L12.224 7.21637C12.1324 7.03013 11.8669 7.03012 11.7753 7.21637L10.2585 10.301L6.865 10.7959C6.66023 10.8258 6.57833 11.0773 6.72625 11.222L9.18244 13.625L8.60281 17.0169C8.56789 17.2212 8.78256 17.3768 8.96591 17.2801L11.9996 15.6793Z\" fill=\"#D5EAFD\"></path></svg>";

/***/ }),

/***/ "ca71":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("3e2c");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("d6373d44", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "ca84":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("5135");
var toIndexedObject = __webpack_require__("fc6a");
var indexOf = __webpack_require__("4d64").indexOf;
var hiddenKeys = __webpack_require__("d012");

module.exports = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !has(hiddenKeys, key) && has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~indexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),

/***/ "ca91":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.i, "@import url(https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css);"]);
exports.push([module.i, "@import url(https://cdn-prd.patientpop.com/pp-icon-font/v1.6.0/pp-icon-font.css);"]);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.pp-form-message{background:var(--pp-message-backgound);border:1px solid var(--pp-message-border-color)}.pp-form-message--error{--pp-message-backgound:#fceeee;--pp-message-border-color:#fbcbd1}.pp-form-message--alert{--pp-message-backgound:#f6f3eb;--pp-message-border-color:#ffe9e3}.pp-form-message--warning{--pp-message-backgound:#fef5d5;--pp-message-border-color:#fef5d5}.pp-form-message--success{--pp-message-backgound:#f0faf2;--pp-message-border-color:#6fc691}.pp-form-message__icon{font-size:1.4285714286rem;height:1.25em}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "caad":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $includes = __webpack_require__("4d64").includes;
var addToUnscopables = __webpack_require__("44d2");
var arrayMethodUsesToLength = __webpack_require__("ae40");

var USES_TO_LENGTH = arrayMethodUsesToLength('indexOf', { ACCESSORS: true, 1: 0 });

// `Array.prototype.includes` method
// https://tc39.es/ecma262/#sec-array.prototype.includes
$({ target: 'Array', proto: true, forced: !USES_TO_LENGTH }, {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('includes');


/***/ }),

/***/ "cb29":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var fill = __webpack_require__("81d5");
var addToUnscopables = __webpack_require__("44d2");

// `Array.prototype.fill` method
// https://tc39.es/ecma262/#sec-array.prototype.fill
$({ target: 'Array', proto: true }, {
  fill: fill
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('fill');


/***/ }),

/***/ "cb72":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c662cfac-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/nav-list/PpNavList.vue?vue&type=template&id=6a452a5c&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('pp-nav-item',{attrs:{"id":_vm.navList.id,"active":_vm.isTopLevelActive,"chip-count":_vm.topLevelChipCount,"external":_vm.navList.external,"icon":_vm.navList.icon,"nav-icon":_vm.navList.navIcon,"path":_vm.topLevelRoute,"show-activate":_vm.navList.showActivate,"show-alert":_vm.topLevelShowAlert,"show-trial":_vm.navList.showTrial,"free-upgrade":_vm.navList.freeUpgrade,"text":_vm.navList.title},on:{"navigate":_vm.navClicked}}),(_vm.hasChildren)?_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.isSubMenuOpen),expression:"isSubMenuOpen"}],staticClass:"pl-2"},_vm._l((_vm.navList.children),function(item,i){return _c('pp-nav-item',{key:i,attrs:{"active":_vm.isActive(item),"chip-count":item.chipCount,"external":item.external,"path":item.path,"text":item.title,"show-alert":item.showAlert,"sub":""},on:{"navigate":_vm.navClicked}})}),1):_vm._e()],1)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/nav-list/PpNavList.vue?vue&type=template&id=6a452a5c&scoped=true&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("4de4");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__("7db0");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("4160");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("caad");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("2532");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.sub.js
var es_string_sub = __webpack_require__("4c53");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("159b");

// EXTERNAL MODULE: ./src/components/nav-item/PpNavItem.vue + 4 modules
var PpNavItem = __webpack_require__("d10b");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/nav-list/PpNavList.vue?vue&type=script&lang=js&







//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var PpNavListvue_type_script_lang_js_ = ({
  name: 'PpNavList',
  components: {
    'pp-nav-item': PpNavItem["default"]
  },
  props: {
    navList: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      isSubMenuOpen: false
    };
  },
  computed: {
    hasChildren: function hasChildren() {
      var _this$navList, _this$navList$childre;

      return ((_this$navList = this.navList) === null || _this$navList === void 0 ? void 0 : (_this$navList$childre = _this$navList.children) === null || _this$navList$childre === void 0 ? void 0 : _this$navList$childre.length) > 0;
    },
    topLevelChipCount: function topLevelChipCount() {
      if (this.isSubMenuOpen || this.topLevelShowAlert) {
        return null;
      } else if (this.hasChildren) {
        var finalCount = 0;
        this.navList.children.forEach(function (child) {
          if (child.chipCount) {
            finalCount += child.chipCount;
          }
        });
        return finalCount;
      } else if (this.navList.chipCount) {
        return this.navList.chipCount;
      } else {
        return null;
      }
    },

    /**
     * When the sub nav has showAlert, make sure showAlert is shown on top nav item when collapsed
     * @returns {boolean}
     */
    topLevelShowAlert: function topLevelShowAlert() {
      if (this.isSubMenuOpen) {
        return false;
      } else if (this.hasChildren) {
        var anyChildHaveShowAlert = this.navList.children.filter(function (child) {
          return child.showAlert === true;
        });
        return anyChildHaveShowAlert.length > 0;
      } else if (this.navList.showAlert) {
        return this.navList.showAlert;
      } else {
        return false;
      }
    },

    /**
     If there is children items then set the route for top level to be null
     */
    topLevelRoute: function topLevelRoute() {
      return this.hasChildren ? null : this.navList.path;
    },
    isChildActive: function isChildActive() {
      var _this = this;

      // if there are no children return false
      if (!this.hasChildren) {
        return false;
      } // check if child path includes current path


      return !!this.navList.children.find(function (child) {
        return _this.isActive(child);
      });
    },
    isTopLevelActive: function isTopLevelActive() {
      return this.isChildActive || this.navList.active || this.isActive(this.navList);
    }
  },
  watch: {
    isChildActive: function isChildActive() {
      this.openNavIfChildActive();
    }
  },
  mounted: function mounted() {
    this.openNavIfChildActive();
  },
  methods: {
    openNavIfChildActive: function openNavIfChildActive() {
      if (this.isTopLevelActive || this.navList.expand) {
        this.isSubMenuOpen = true;
      }
    },
    navClicked: function navClicked(obj) {
      this.$emit('navigate', obj); // if its a top level item and has children then expand

      if (!obj.sub && this.navList.children) {
        this.isSubMenuOpen = !this.isSubMenuOpen;
      } else {
        // else handle the click
        this.handleRoute(obj);
      }
    },
    handleRoute: function handleRoute(obj) {
      // if its the active item, don't do anything
      if (obj.active) {
        return;
      } // if there is a route


      if (obj.path) {
        // if its external open url
        if (obj.external) {
          // if it starts with http then open in new window
          var pattern = /^((http|https):\/\/)/;

          if (pattern.test(obj.path)) {
            window.open(obj.path);
          } else {
            window.location.href = obj.path;
          }
        } else {
          // if its an internal route and not the current route then push the route
          if (this.$route.fullPath !== obj.path) {
            this.$router.push(obj.path);
            this.$emit('route-changed', obj);
          }
        }
      }
    },
    isActive: function isActive(item) {
      return this.$route.fullPath.includes(item.path);
    }
  }
});
// CONCATENATED MODULE: ./src/components/nav-list/PpNavList.vue?vue&type=script&lang=js&
 /* harmony default export */ var nav_list_PpNavListvue_type_script_lang_js_ = (PpNavListvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/nav-list/PpNavList.vue?vue&type=style&index=0&id=6a452a5c&lang=scss&scoped=true&
var PpNavListvue_type_style_index_0_id_6a452a5c_lang_scss_scoped_true_ = __webpack_require__("146f");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/nav-list/PpNavList.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  nav_list_PpNavListvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "6a452a5c",
  null
  
)

/* harmony default export */ var PpNavList = __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "cb96":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("c8d5")

/**
 * @category Week Helpers
 * @summary Return the last day of a week for the given date.
 *
 * @description
 * Return the last day of a week for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @param {Object} [options] - the object with options
 * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the last day of a week
 *
 * @example
 * // The last day of a week for 2 September 2014 11:55:00:
 * var result = lastDayOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sat Sep 06 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the last day of the week for 2 September 2014 11:55:00:
 * var result = lastDayOfWeek(new Date(2014, 8, 2, 11, 55, 0), {weekStartsOn: 1})
 * //=> Sun Sep 07 2014 00:00:00
 */
function lastDayOfWeek (dirtyDate, dirtyOptions) {
  var weekStartsOn = dirtyOptions ? (Number(dirtyOptions.weekStartsOn) || 0) : 0

  var date = parse(dirtyDate)
  var day = date.getDay()
  var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn)

  date.setHours(0, 0, 0, 0)
  date.setDate(date.getDate() + diff)
  return date
}

module.exports = lastDayOfWeek


/***/ }),

/***/ "cbf9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpLoader_vue_vue_type_style_index_0_id_6a597e20_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("9aae");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpLoader_vue_vue_type_style_index_0_id_6a597e20_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpLoader_vue_vue_type_style_index_0_id_6a597e20_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "cc12":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var isObject = __webpack_require__("861d");

var document = global.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);

module.exports = function (it) {
  return EXISTS ? document.createElement(it) : {};
};


/***/ }),

/***/ "cc20":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("4de4");
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("4160");
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("3835");
/* harmony import */ var _home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("5530");
/* harmony import */ var _src_components_VChip_VChip_sass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("8adc");
/* harmony import */ var _src_components_VChip_VChip_sass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_src_components_VChip_VChip_sass__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("58df");
/* harmony import */ var _transitions__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("0789");
/* harmony import */ var _VIcon__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("9d26");
/* harmony import */ var _mixins_colorable__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("a9ad");
/* harmony import */ var _mixins_groupable__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("4e82");
/* harmony import */ var _mixins_themeable__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("7560");
/* harmony import */ var _mixins_toggleable__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("f2e7");
/* harmony import */ var _mixins_routable__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("1c87");
/* harmony import */ var _mixins_sizeable__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("af2b");
/* harmony import */ var _util_console__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("d9bd");




// Styles

 // Components


 // Mixins






 // Utilities


/* @vue/component */

/* harmony default export */ __webpack_exports__["a"] = (Object(_util_mixins__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(_mixins_colorable__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"], _mixins_sizeable__WEBPACK_IMPORTED_MODULE_13__[/* default */ "a"], _mixins_routable__WEBPACK_IMPORTED_MODULE_12__[/* default */ "a"], _mixins_themeable__WEBPACK_IMPORTED_MODULE_10__[/* default */ "a"], Object(_mixins_groupable__WEBPACK_IMPORTED_MODULE_9__[/* factory */ "a"])('chipGroup'), Object(_mixins_toggleable__WEBPACK_IMPORTED_MODULE_11__[/* factory */ "b"])('inputValue')).extend({
  name: 'v-chip',
  props: {
    active: {
      type: Boolean,
      default: true
    },
    activeClass: {
      type: String,
      default: function _default() {
        if (!this.chipGroup) return '';
        return this.chipGroup.activeClass;
      }
    },
    close: Boolean,
    closeIcon: {
      type: String,
      default: '$delete'
    },
    closeLabel: {
      type: String,
      default: '$vuetify.close'
    },
    disabled: Boolean,
    draggable: Boolean,
    filter: Boolean,
    filterIcon: {
      type: String,
      default: '$complete'
    },
    label: Boolean,
    link: Boolean,
    outlined: Boolean,
    pill: Boolean,
    tag: {
      type: String,
      default: 'span'
    },
    textColor: String,
    value: null
  },
  data: function data() {
    return {
      proxyClass: 'v-chip--active'
    };
  },
  computed: {
    classes: function classes() {
      return Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])({
        'v-chip': true
      }, _mixins_routable__WEBPACK_IMPORTED_MODULE_12__[/* default */ "a"].options.computed.classes.call(this)), {}, {
        'v-chip--clickable': this.isClickable,
        'v-chip--disabled': this.disabled,
        'v-chip--draggable': this.draggable,
        'v-chip--label': this.label,
        'v-chip--link': this.isLink,
        'v-chip--no-color': !this.color,
        'v-chip--outlined': this.outlined,
        'v-chip--pill': this.pill,
        'v-chip--removable': this.hasClose
      }, this.themeClasses), this.sizeableClasses), this.groupClasses);
    },
    hasClose: function hasClose() {
      return Boolean(this.close);
    },
    isClickable: function isClickable() {
      return Boolean(_mixins_routable__WEBPACK_IMPORTED_MODULE_12__[/* default */ "a"].options.computed.isClickable.call(this) || this.chipGroup);
    }
  },
  created: function created() {
    var _this = this;

    var breakingProps = [['outline', 'outlined'], ['selected', 'input-value'], ['value', 'active'], ['@input', '@active.sync']];
    /* istanbul ignore next */

    breakingProps.forEach(function (_ref) {
      var _ref2 = Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(_ref, 2),
          original = _ref2[0],
          replacement = _ref2[1];

      if (_this.$attrs.hasOwnProperty(original)) Object(_util_console__WEBPACK_IMPORTED_MODULE_14__[/* breaking */ "a"])(original, replacement, _this);
    });
  },
  methods: {
    click: function click(e) {
      this.$emit('click', e);
      this.chipGroup && this.toggle();
    },
    genFilter: function genFilter() {
      var children = [];

      if (this.isActive) {
        children.push(this.$createElement(_VIcon__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"], {
          staticClass: 'v-chip__filter',
          props: {
            left: true
          }
        }, this.filterIcon));
      }

      return this.$createElement(_transitions__WEBPACK_IMPORTED_MODULE_6__[/* VExpandXTransition */ "b"], children);
    },
    genClose: function genClose() {
      var _this2 = this;

      return this.$createElement(_VIcon__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"], {
        staticClass: 'v-chip__close',
        props: {
          right: true,
          size: 18
        },
        attrs: {
          'aria-label': this.$vuetify.lang.t(this.closeLabel)
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            e.preventDefault();

            _this2.$emit('click:close');

            _this2.$emit('update:active', false);
          }
        }
      }, this.closeIcon);
    },
    genContent: function genContent() {
      return this.$createElement('span', {
        staticClass: 'v-chip__content'
      }, [this.filter && this.genFilter(), this.$slots.default, this.hasClose && this.genClose()]);
    }
  },
  render: function render(h) {
    var children = [this.genContent()];

    var _this$generateRouteLi = this.generateRouteLink(),
        tag = _this$generateRouteLi.tag,
        data = _this$generateRouteLi.data;

    data.attrs = Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])({}, data.attrs), {}, {
      draggable: this.draggable ? 'true' : undefined,
      tabindex: this.chipGroup && !this.disabled ? 0 : data.attrs.tabindex
    });
    data.directives.push({
      name: 'show',
      value: this.active
    });
    data = this.setBackgroundColor(this.color, data);
    var color = this.textColor || this.outlined && this.color;
    return h(tag, this.setTextColor(color, data), children);
  }
}));

/***/ }),

/***/ "cc40":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("11a8");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("792958da", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "cc64":
/***/ (function(module, exports, __webpack_require__) {

var isSameISOWeek = __webpack_require__("ccce")

/**
 * @category ISO Week Helpers
 * @summary Is the given date in the same ISO week as the current date?
 *
 * @description
 * Is the given date in the same ISO week as the current date?
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in this ISO week
 *
 * @example
 * // If today is 25 September 2014, is 22 September 2014 in this ISO week?
 * var result = isThisISOWeek(new Date(2014, 8, 22))
 * //=> true
 */
function isThisISOWeek (dirtyDate) {
  return isSameISOWeek(new Date(), dirtyDate)
}

module.exports = isThisISOWeek


/***/ }),

/***/ "cca6":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var assign = __webpack_require__("60da");

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
$({ target: 'Object', stat: true, forced: Object.assign !== assign }, {
  assign: assign
});


/***/ }),

/***/ "ccce":
/***/ (function(module, exports, __webpack_require__) {

var isSameWeek = __webpack_require__("1baf")

/**
 * @category ISO Week Helpers
 * @summary Are the given dates in the same ISO week?
 *
 * @description
 * Are the given dates in the same ISO week?
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same ISO week
 *
 * @example
 * // Are 1 September 2014 and 7 September 2014 in the same ISO week?
 * var result = isSameISOWeek(
 *   new Date(2014, 8, 1),
 *   new Date(2014, 8, 7)
 * )
 * //=> true
 */
function isSameISOWeek (dirtyDateLeft, dirtyDateRight) {
  return isSameWeek(dirtyDateLeft, dirtyDateRight, {weekStartsOn: 1})
}

module.exports = isSameISOWeek


/***/ }),

/***/ "cdf9":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("825a");
var isObject = __webpack_require__("861d");
var newPromiseCapability = __webpack_require__("f069");

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),

/***/ "ce3d":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("c8d5")

/**
 * @category Quarter Helpers
 * @summary Return the last day of a year quarter for the given date.
 *
 * @description
 * Return the last day of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the last day of a quarter
 *
 * @example
 * // The last day of a quarter for 2 September 2014 11:55:00:
 * var result = lastDayOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 00:00:00
 */
function lastDayOfQuarter (dirtyDate) {
  var date = parse(dirtyDate)
  var currentMonth = date.getMonth()
  var month = currentMonth - currentMonth % 3 + 3
  date.setMonth(month, 0)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = lastDayOfQuarter


/***/ }),

/***/ "ce4e":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var createNonEnumerableProperty = __webpack_require__("9112");

module.exports = function (key, value) {
  try {
    createNonEnumerableProperty(global, key, value);
  } catch (error) {
    global[key] = value;
  } return value;
};


/***/ }),

/***/ "ce7e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("5530");
/* harmony import */ var _src_components_VDivider_VDivider_sass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("8ce9");
/* harmony import */ var _src_components_VDivider_VDivider_sass__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_src_components_VDivider_VDivider_sass__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _mixins_themeable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("7560");

// Styles
 // Mixins


/* harmony default export */ __webpack_exports__["a"] = (_mixins_themeable__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].extend({
  name: 'v-divider',
  props: {
    inset: Boolean,
    vertical: Boolean
  },
  render: function render(h) {
    // WAI-ARIA attributes
    var orientation;

    if (!this.$attrs.role || this.$attrs.role === 'separator') {
      orientation = this.vertical ? 'vertical' : 'horizontal';
    }

    return h('hr', {
      class: Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({
        'v-divider': true,
        'v-divider--inset': this.inset,
        'v-divider--vertical': this.vertical
      }, this.themeClasses),
      attrs: Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({
        role: 'separator',
        'aria-orientation': orientation
      }, this.$attrs),
      on: this.$listeners
    });
  }
}));

/***/ }),

/***/ "ceca":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.theme--light.v-sheet{background-color:var(--cards-color,#fff);border-color:var(--cards-color,#fff);color:var(--pp-text-primary,#2b2b2b)}.theme--light.v-sheet--outlined{border:thin solid #d6d6d6}.theme--dark.v-sheet{background-color:#1e1e1e;border-color:#1e1e1e;color:var(--pp-primary-button-text-color,#004852)}.theme--dark.v-sheet--outlined{border:thin solid hsla(0,0%,100%,.12)}.v-sheet{border-radius:0}.v-sheet:not(.v-sheet--outlined){box-shadow:0 0 0 0 transparent,0 0 0 0 transparent,0 0 0 0 rgba(0,0,0,.12)}.v-sheet.v-sheet--shaped{border-radius:20px 0}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "cecd":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.i, "@import url(https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css);"]);
exports.push([module.i, "@import url(https://cdn-prd.patientpop.com/pp-icon-font/v1.6.0/pp-icon-font.css);"]);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}nav[data-v-6534d2f9]{position:sticky;top:0}@media print{nav[data-v-6534d2f9]{display:none!important}}@media(min-width:960px){nav[data-v-6534d2f9]{background-color:#004852;height:100vh;max-height:100vh;overflow:auto}}@media(max-width:960px){nav[data-v-6534d2f9]{height:0;overflow:hidden;z-index:4}nav.open[data-v-6534d2f9]{overflow-y:hidden}nav.open[data-v-6534d2f9],nav.open[data-v-6534d2f9]:after{height:100vh;position:fixed;top:64px;width:100vw}nav.open[data-v-6534d2f9]:after{background:#545454;content:\"\";display:block;left:0;opacity:.5;z-index:-10}}.pp-button[data-v-6534d2f9]{font-size:1.337rem;left:0;position:fixed;top:14px;z-index:20}@media(max-width:960px){.pp-side-nav[data-v-6534d2f9]{height:calc(100vh - 64px);left:-960px;position:absolute;transition:all .25s}.open .pp-side-nav[data-v-6534d2f9]{background:#004852;left:0;overflow:scroll;overflow-x:hidden;width:18.8571428571rem;z-index:0}}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "cf36":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("9864");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("5e73de20", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "cfdb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c662cfac-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/display-error/PpDisplayError.vue?vue&type=template&id=74bed18a&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pp-display-error align-center d-flex",attrs:{"aria-live":"assertive","role":"alert"}},[_c('i',{staticClass:"error--text align-center d-flex mr-3",class:("pp-icon-" + _vm.icon),attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm.message)+" ")])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/display-error/PpDisplayError.vue?vue&type=template&id=74bed18a&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/display-error/PpDisplayError.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var PpDisplayErrorvue_type_script_lang_js_ = ({
  name: 'PpDisplayError',
  props: {
    /**
     * Sets the error message
     */
    message: {
      type: String,
      required: true
    },

    /**
     * Sets the icon
     */
    icon: {
      type: String,
      default: 'alert'
    }
  }
});
// CONCATENATED MODULE: ./src/components/display-error/PpDisplayError.vue?vue&type=script&lang=js&
 /* harmony default export */ var display_error_PpDisplayErrorvue_type_script_lang_js_ = (PpDisplayErrorvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/display-error/PpDisplayError.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  display_error_PpDisplayErrorvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var PpDisplayError = __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "d012":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "d039":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};


/***/ }),

/***/ "d04a":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><rect x=\"3\" y=\"3\" width=\"14\" height=\"13\" fill=\"#DFE4E5\"></rect><path d=\"M15 3H5C3.89543 3 3 3.80589 3 4.8V19.2C3 20.1941 3.89543 21 5 21H15C16.1046 21 17 20.1941 17 19.2V4.8C17 3.80589 16.1046 3 15 3Z\" stroke=\"#688083\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M10 18H10.01\" stroke=\"#688083\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M21 13C21 14.1046 20.1046 15 19 15H10V9C10 7.89543 10.8954 7 12 7H21V13Z\" fill=\"white\" stroke=\"#688083\" stroke-width=\"2\"></path><rect x=\"13\" y=\"10\" width=\"5\" height=\"2\" fill=\"#688083\"></rect></svg>";

/***/ }),

/***/ "d052":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.i, "@import url(https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css);"]);
exports.push([module.i, "@import url(https://cdn-prd.patientpop.com/pp-icon-font/v1.6.0/pp-icon-font.css);"]);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.pp-drop-down-button__secondary-button[data-v-128b2aa0]{border-bottom-right-radius:4px;border-left:1px solid #067889;border-top-right-radius:4px;cursor:pointer;display:flex;font-size:.5714285714rem;height:100%;width:39px}.pp-drop-down-button__menu-item[data-v-128b2aa0]{border:none;border-radius:0}.pp-drop-down-button__menu-item--divider[data-v-128b2aa0]{border-top:1px solid #d6d6d6}.pp-drop-down-button__menu-list[data-v-128b2aa0]{min-height:36px}.pp-drop-down-button__menu-list[data-v-128b2aa0]:hover:before{opacity:0}[data-v-128b2aa0] .v-list{padding:0}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "d066":
/***/ (function(module, exports, __webpack_require__) {

var path = __webpack_require__("428f");
var global = __webpack_require__("da84");

var aFunction = function (variable) {
  return typeof variable == 'function' ? variable : undefined;
};

module.exports = function (namespace, method) {
  return arguments.length < 2 ? aFunction(path[namespace]) || aFunction(global[namespace])
    : path[namespace] && path[namespace][method] || global[namespace] && global[namespace][method];
};


/***/ }),

/***/ "d0d7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c662cfac-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/PpMap.vue?vue&type=template&id=fee8366c&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isStaticMap)?_c('img',{attrs:{"src":_vm.staticMapUrl,"title":"map"}}):(_vm.isEmbedMap)?_c('iframe',{attrs:{"width":"100%","height":_vm.height,"frameborder":"0","src":_vm.embedMapUrl,"allowfullscreen":"","title":"map"}}):_vm._e()])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/map/PpMap.vue?vue&type=template&id=fee8366c&scoped=true&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("99af");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.index-of.js
var es_array_index_of = __webpack_require__("c975");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__("a9e3");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__("ac1f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.replace.js
var es_string_replace = __webpack_require__("5319");

// CONCATENATED MODULE: ./src/components/map/constants.js
var STATIC_MAP = 'static';
var EMBED_MAP = 'embed';
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/PpMap.vue?vue&type=script&lang=js&





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var PpMapvue_type_script_lang_js_ = ({
  name: 'PpMap',
  props: {
    /**
     * Practice address
     */
    address: {
      type: String,
      required: true
    },

    /**
     * Type of button: [static, embed]
     */
    type: {
      type: String,
      validator: function validator(value) {
        return [STATIC_MAP, EMBED_MAP].indexOf(value) !== -1;
      },
      default: STATIC_MAP
    },

    /**
     * Height of the component in pixel, default to 300
     */
    height: {
      type: Number,
      default: 300
    },

    /**
     * Width of the component in pixel, default to 500.  embed option will stretch to 100% width
     */
    width: {
      type: Number,
      default: 500
    },

    /**
     * API Key to contact with Google Maps API
     */
    apiKey: {
      type: String,
      default: 'AIzaSyBTrEWffjhmTPG-klbCTRDbPosy78KisA8'
    }
  },
  computed: {
    isStaticMap: function isStaticMap() {
      return this.type === STATIC_MAP;
    },
    isEmbedMap: function isEmbedMap() {
      return this.type === EMBED_MAP;
    },
    staticMapUrl: function staticMapUrl() {
      return "https://maps.googleapis.com/maps/api/staticmap?\n        center=".concat(this.address, "\n        &markers=").concat(this.address, "\n        &zoom=15\n        &size=").concat(this.width, "x").concat(this.height, "\n        &key=").concat(this.apiKey).replace(/\s|\n/g, '');
    },
    embedMapUrl: function embedMapUrl() {
      return "https://www.google.com/maps/embed/v1/place?key=".concat(this.apiKey, "&q=").concat(this.address);
    }
  },
  created: function created() {
    var _this = this;

    if (this.isEmbedMap) {
      var Http = new XMLHttpRequest();
      Http.open('GET', this.embedMapUrl);
      Http.send();

      Http.onreadystatechange = function () {
        if (Http.readyState === 4 && Http.status !== 200) {
          // let parent component know that map was loaded with an error
          _this.$emit('map-error');
        }
      };
    }
  }
});
// CONCATENATED MODULE: ./src/components/map/PpMap.vue?vue&type=script&lang=js&
 /* harmony default export */ var map_PpMapvue_type_script_lang_js_ = (PpMapvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/map/PpMap.vue?vue&type=style&index=0&id=fee8366c&lang=scss&scoped=true&
var PpMapvue_type_style_index_0_id_fee8366c_lang_scss_scoped_true_ = __webpack_require__("debc");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/map/PpMap.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  map_PpMapvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "fee8366c",
  null
  
)

/* harmony default export */ var PpMap = __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "d10b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c662cfac-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/nav-item/PpNavItem.vue?vue&type=template&id=14cd72c3&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.htmlTag,{tag:"component",staticClass:"nav-item align-center",class:{'nav-item--active': _vm.active, 'nav-item--sub py-2': _vm.sub, 'py-2': !_vm.sub && _vm.text, 'd-flex flex-wrap px-3': _vm.text, 'nav-item--large': _vm.large},style:(_vm.iconCssVars),attrs:{"aria-label":!_vm.text ? _vm.icon : null},on:{"click":_vm.itemClicked}},[(!_vm.navIcon)?_c('i',{staticClass:"d-flex mr-2",class:("pp-icon-" + _vm.icon),attrs:{"aria-hidden":"true"}}):_vm._e(),_vm._v(" "+_vm._s(_vm.text)+" "),(_vm.chipValue || _vm.showAlert)?_c('div',{staticClass:"d-flex ml-auto"},[(_vm.showAlert)?_c('i',{staticClass:"pp-icon-alert d-flex"}):_c('v-chip',{staticClass:"nav-chip text-uppercase font-weight-bold px-2",class:{
        'nav-chip--activate': _vm.showActivate,
        'nav-chip--trial': _vm.showTrial,
        'nav-chip--free-upgrade': _vm.freeUpgrade
      },attrs:{"color":_vm.chipColor}},[_vm._v(" "+_vm._s(_vm.chipValue)+" ")])],1):_vm._e()])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/nav-item/PpNavItem.vue?vue&type=template&id=14cd72c3&scoped=true&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("99af");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__("a9e3");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.sub.js
var es_string_sub = __webpack_require__("4c53");

// EXTERNAL MODULE: ./src/styles/colors.scss
var colors = __webpack_require__("1c98");
var colors_default = /*#__PURE__*/__webpack_require__.n(colors);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/nav-item/PpNavItem.vue?vue&type=script&lang=js&



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var PpNavItemvue_type_script_lang_js_ = ({
  name: 'PpNavItem',
  props: {
    /**
     * ID name for navigation item
     */
    id: {
      type: String,
      default: null
    },

    /**
     * Icon used for navigation (top level items)
     */
    icon: {
      type: String,
      default: null
    },

    /**
     * If nav icon or flat icon
     */
    navIcon: {
      type: Boolean,
      default: true
    },

    /**
     * Sub menu item
     */
    sub: {
      type: Boolean,
      default: false
    },
    active: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      default: null
    },

    /**
     * If present will show count next to nav item
     */
    chipCount: {
      type: Number,
      default: null
    },

    /**
     * Path of nav item
     */
    path: {
      type: String,
      default: null
    },

    /**
     * If external will not do a router push
     */
    external: {
      type: Boolean,
      default: false
    },

    /**
     * Show Trial chip next to menu item
     */
    showTrial: {
      type: Boolean,
      default: false
    },

    /**
     * Show Activate chip next to menu item
     */
    showActivate: {
      type: Boolean,
      default: false
    },

    /**
     * Show Alert Icon next to menu item
     */
    showAlert: {
      type: Boolean,
      default: false
    },

    /**
     * Change icon size if its a setting's icon
     */
    large: {
      type: Boolean,
      default: false
    },

    /**
     * Show free upgrade chip
     */
    freeUpgrade: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    htmlTag: function htmlTag() {
      // if no text then treat as button
      if (!this.text) {
        return 'button';
      } // otherwise change tag dependent on if this is a sub item or top level item


      return this.sub ? 'li' : 'div';
    },
    iconCssVars: function iconCssVars() {
      // if there is no nav icon, or its a sub item then there is no icon to show
      if (!this.navIcon || this.sub) {
        return '';
      } // set up icon names for hover and active


      var icon = this.icon;
      var iconHover = "".concat(this.icon, "--hover");
      var iconActive = "".concat(this.icon, "--active"); // get the svg content as url content

      var iconSvg = "url(\"data:image/svg+xml, ".concat(encodeURIComponent(this.getIcon(icon)), "\")");
      var iconSvgHover = "url(\"data:image/svg+xml, ".concat(encodeURIComponent(this.getIcon(iconHover)), "\")");
      var iconSvgActive = "url(\"data:image/svg+xml, ".concat(encodeURIComponent(this.getIcon(iconActive)), "\")");
      return "--icon: ".concat(iconSvg, ";--icon--hover: ").concat(iconSvgHover, ";--icon--active: ").concat(iconSvgActive, ";");
    },
    chipColor: function chipColor() {
      if (this.showActivate || this.freeUpgrade) {
        return colors_default.a.asana;
      } else if (this.showTrial) {
        return colors_default.a.synapse4;
      } else if (this.chipCount) {
        return colors_default.a.vitality2;
      } else {
        return null;
      }
    },
    chipValue: function chipValue() {
      if (this.showActivate) {
        return 'Activate';
      } else if (this.freeUpgrade) {
        return 'Free Upgrade';
      } else if (this.showTrial) {
        return 'Trial';
      } else if (this.chipCount) {
        return this.chipCount > 99 ? '99+' : this.chipCount;
      }

      return null;
    }
  },
  methods: {
    getIcon: function getIcon(name) {
      return __webpack_require__("8016")("./".concat(name, ".svg"));
    },
    itemClicked: function itemClicked() {
      this.$emit('navigate', {
        sub: this.sub,
        path: this.path,
        external: this.external,
        active: this.active,
        freeUpgrade: this.freeUpgrade,
        text: this.text,
        id: this.id
      });
    }
  }
});
// CONCATENATED MODULE: ./src/components/nav-item/PpNavItem.vue?vue&type=script&lang=js&
 /* harmony default export */ var nav_item_PpNavItemvue_type_script_lang_js_ = (PpNavItemvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/nav-item/PpNavItem.vue?vue&type=style&index=0&id=14cd72c3&lang=scss&scoped=true&
var PpNavItemvue_type_style_index_0_id_14cd72c3_lang_scss_scoped_true_ = __webpack_require__("6e9b");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// EXTERNAL MODULE: ./node_modules/vuetify-loader/lib/runtime/installComponents.js
var installComponents = __webpack_require__("6544");
var installComponents_default = /*#__PURE__*/__webpack_require__.n(installComponents);

// EXTERNAL MODULE: ./node_modules/vuetify/lib/components/VChip/VChip.js
var VChip = __webpack_require__("cc20");

// CONCATENATED MODULE: ./src/components/nav-item/PpNavItem.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  nav_item_PpNavItemvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "14cd72c3",
  null
  
)

/* harmony default export */ var PpNavItem = __webpack_exports__["default"] = (component.exports);

/* vuetify-loader */


installComponents_default()(component, {VChip: VChip["a" /* default */]})


/***/ }),

/***/ "d123":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c662cfac-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/side-nav/PpSideNav.vue?vue&type=template&id=6534d2f9&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{class:{'open':_vm.mobileLeftNavOpen}},[_c('pp-button',{staticClass:"ml-2 d-md-none",attrs:{"icon":"list","type":"icon"},on:{"click":_vm.openMenu}}),_c('div',{staticClass:"pp-side-nav pt-3 pb-md-3"},[_vm._t("header"),_c('ul',{staticClass:"px-4"},_vm._l((_vm.navTree),function(item,i){return _c('pp-nav-list',{key:i,attrs:{"nav-list":item},on:{"navigate":_vm.navClicked,"route-changed":function($event){_vm.mobileLeftNavOpen = false}}})}),1),_vm._t("footer")],2)],1)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/side-nav/PpSideNav.vue?vue&type=template&id=6534d2f9&scoped=true&

// EXTERNAL MODULE: ./src/components/nav-list/PpNavList.vue + 4 modules
var PpNavList = __webpack_require__("cb72");

// EXTERNAL MODULE: ./src/components/button/PpButton.vue + 5 modules
var PpButton = __webpack_require__("251c");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/side-nav/PpSideNav.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var PpSideNavvue_type_script_lang_js_ = ({
  name: 'PpSideNav',
  components: {
    'pp-nav-list': PpNavList["default"],
    'pp-button': PpButton["default"]
  },
  props: {
    navTree: {
      type: Array,
      required: true
    }
  },
  data: function data() {
    return {
      mobileLeftNavOpen: false
    };
  },
  methods: {
    openMenu: function openMenu() {
      this.mobileLeftNavOpen = !this.mobileLeftNavOpen;
      this.$emit('toggle-menu-button', this.mobileLeftNavOpen);
    },
    navClicked: function navClicked(obj) {
      this.$emit('navigate', obj);
    }
  }
});
// CONCATENATED MODULE: ./src/components/side-nav/PpSideNav.vue?vue&type=script&lang=js&
 /* harmony default export */ var side_nav_PpSideNavvue_type_script_lang_js_ = (PpSideNavvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/side-nav/PpSideNav.vue?vue&type=style&index=0&id=6534d2f9&lang=scss&scoped=true&
var PpSideNavvue_type_style_index_0_id_6534d2f9_lang_scss_scoped_true_ = __webpack_require__("0d59");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/side-nav/PpSideNav.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  side_nav_PpSideNavvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "6534d2f9",
  null
  
)

/* harmony default export */ var PpSideNav = __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "d191":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("89c8");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("1387d54a", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "d1e1":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("7022");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("334e86f3", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "d1e7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var nativePropertyIsEnumerable = {}.propertyIsEnumerable;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !nativePropertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : nativePropertyIsEnumerable;


/***/ }),

/***/ "d28b":
/***/ (function(module, exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__("746f");

// `Symbol.iterator` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.iterator
defineWellKnownSymbol('iterator');


/***/ }),

/***/ "d2bb":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("825a");
var aPossiblePrototype = __webpack_require__("3bbe");

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    setter = Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set;
    setter.call(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter.call(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);


/***/ }),

/***/ "d2ed":
/***/ (function(module, exports, __webpack_require__) {

var differenceInMilliseconds = __webpack_require__("e785")

var MILLISECONDS_IN_HOUR = 3600000

/**
 * @category Hour Helpers
 * @summary Get the number of hours between the given dates.
 *
 * @description
 * Get the number of hours between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of hours
 *
 * @example
 * // How many hours are between 2 July 2014 06:50:00 and 2 July 2014 19:00:00?
 * var result = differenceInHours(
 *   new Date(2014, 6, 2, 19, 0),
 *   new Date(2014, 6, 2, 6, 50)
 * )
 * //=> 12
 */
function differenceInHours (dirtyDateLeft, dirtyDateRight) {
  var diff = differenceInMilliseconds(dirtyDateLeft, dirtyDateRight) / MILLISECONDS_IN_HOUR
  return diff > 0 ? Math.floor(diff) : Math.ceil(diff)
}

module.exports = differenceInHours


/***/ }),

/***/ "d3b7":
/***/ (function(module, exports, __webpack_require__) {

var TO_STRING_TAG_SUPPORT = __webpack_require__("00ee");
var redefine = __webpack_require__("6eeb");
var toString = __webpack_require__("b0415");

// `Object.prototype.toString` method
// https://tc39.es/ecma262/#sec-object.prototype.tostring
if (!TO_STRING_TAG_SUPPORT) {
  redefine(Object.prototype, 'toString', toString, { unsafe: true });
}


/***/ }),

/***/ "d420":
/***/ (function(module, exports, __webpack_require__) {

var startOfDay = __webpack_require__("0978")

var MILLISECONDS_IN_MINUTE = 60000
var MILLISECONDS_IN_DAY = 86400000

/**
 * @category Day Helpers
 * @summary Get the number of calendar days between the given dates.
 *
 * @description
 * Get the number of calendar days between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar days
 *
 * @example
 * // How many calendar days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * var result = differenceInCalendarDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 366
 */
function differenceInCalendarDays (dirtyDateLeft, dirtyDateRight) {
  var startOfDayLeft = startOfDay(dirtyDateLeft)
  var startOfDayRight = startOfDay(dirtyDateRight)

  var timestampLeft = startOfDayLeft.getTime() -
    startOfDayLeft.getTimezoneOffset() * MILLISECONDS_IN_MINUTE
  var timestampRight = startOfDayRight.getTime() -
    startOfDayRight.getTimezoneOffset() * MILLISECONDS_IN_MINUTE

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a day is not constant
  // (e.g. it's different in the day of the daylight saving time clock shift)
  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY)
}

module.exports = differenceInCalendarDays


/***/ }),

/***/ "d44e":
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__("9bf2").f;
var has = __webpack_require__("5135");
var wellKnownSymbol = __webpack_require__("b622");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');

module.exports = function (it, TAG, STATIC) {
  if (it && !has(it = STATIC ? it : it.prototype, TO_STRING_TAG)) {
    defineProperty(it, TO_STRING_TAG, { configurable: true, value: TAG });
  }
};


/***/ }),

/***/ "d473":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("c8d5")

/**
 * @category Millisecond Helpers
 * @summary Set the milliseconds to the given date.
 *
 * @description
 * Set the milliseconds to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} milliseconds - the milliseconds of the new date
 * @returns {Date} the new date with the milliseconds setted
 *
 * @example
 * // Set 300 milliseconds to 1 September 2014 11:30:40.500:
 * var result = setMilliseconds(new Date(2014, 8, 1, 11, 30, 40, 500), 300)
 * //=> Mon Sep 01 2014 11:30:40.300
 */
function setMilliseconds (dirtyDate, dirtyMilliseconds) {
  var date = parse(dirtyDate)
  var milliseconds = Number(dirtyMilliseconds)
  date.setMilliseconds(milliseconds)
  return date
}

module.exports = setMilliseconds


/***/ }),

/***/ "d4ae":
/***/ (function(module, exports, __webpack_require__) {

var addQuarters = __webpack_require__("f5dd")

/**
 * @category Quarter Helpers
 * @summary Subtract the specified number of year quarters from the given date.
 *
 * @description
 * Subtract the specified number of year quarters from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of quarters to be subtracted
 * @returns {Date} the new date with the quarters subtracted
 *
 * @example
 * // Subtract 3 quarters from 1 September 2014:
 * var result = subQuarters(new Date(2014, 8, 1), 3)
 * //=> Sun Dec 01 2013 00:00:00
 */
function subQuarters (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addQuarters(dirtyDate, -amount)
}

module.exports = subQuarters


/***/ }),

/***/ "d512":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("a4d1");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("51d03e0b", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "d58f":
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__("1c0b");
var toObject = __webpack_require__("7b0b");
var IndexedObject = __webpack_require__("44ad");
var toLength = __webpack_require__("50c4");

// `Array.prototype.{ reduce, reduceRight }` methods implementation
var createMethod = function (IS_RIGHT) {
  return function (that, callbackfn, argumentsLength, memo) {
    aFunction(callbackfn);
    var O = toObject(that);
    var self = IndexedObject(O);
    var length = toLength(O.length);
    var index = IS_RIGHT ? length - 1 : 0;
    var i = IS_RIGHT ? -1 : 1;
    if (argumentsLength < 2) while (true) {
      if (index in self) {
        memo = self[index];
        index += i;
        break;
      }
      index += i;
      if (IS_RIGHT ? index < 0 : length <= index) {
        throw TypeError('Reduce of empty array with no initial value');
      }
    }
    for (;IS_RIGHT ? index >= 0 : length > index; index += i) if (index in self) {
      memo = callbackfn(memo, self[index], index, O);
    }
    return memo;
  };
};

module.exports = {
  // `Array.prototype.reduce` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduce
  left: createMethod(false),
  // `Array.prototype.reduceRight` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduceright
  right: createMethod(true)
};


/***/ }),

/***/ "d59f":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("0830");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("3de9027c", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "d5af":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("5d23d");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("651f38dd", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "d65d":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.theme--light.v-input--selection-controls.v-input--is-disabled:not(.v-input--indeterminate) .v-icon{color:#d6d6d6!important}.theme--dark.v-input--selection-controls.v-input--is-disabled:not(.v-input--indeterminate) .v-icon{color:hsla(0,0%,100%,.3)!important}.v-input--selection-controls{margin-top:16px;padding-top:4px}.v-input--selection-controls>.v-input__append-outer,.v-input--selection-controls>.v-input__prepend-outer{margin-top:0;margin-bottom:0}.v-input--selection-controls:not(.v-input--hide-details)>.v-input__slot{margin-bottom:12px}.v-input--selection-controls .v-input__slot,.v-input--selection-controls .v-radio{cursor:pointer}.v-input--selection-controls .v-input__slot>.v-label,.v-input--selection-controls .v-radio>.v-label{align-items:center;display:inline-flex;flex:1 1 auto;height:auto}.v-input--selection-controls__input{color:inherit;display:inline-flex;flex:0 0 auto;height:24px;position:relative;transition:.3s cubic-bezier(.25,.8,.5,1);transition-property:transform;width:24px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.v-input--selection-controls__input .v-icon{width:100%}.v-application--is-ltr .v-input--selection-controls__input{margin-right:8px}.v-application--is-rtl .v-input--selection-controls__input{margin-left:8px}.v-input--selection-controls__input input[role=checkbox],.v-input--selection-controls__input input[role=radio],.v-input--selection-controls__input input[role=switch]{position:absolute;opacity:0;width:100%;height:100%;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.v-input--selection-controls__input+.v-label{cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.v-input--selection-controls__ripple{border-radius:50%;cursor:pointer;height:34px;position:absolute;transition:inherit;width:34px;left:-12px;top:calc(50% - 24px);margin:7px}.v-input--selection-controls__ripple:before{border-radius:inherit;bottom:0;content:\"\";position:absolute;opacity:.2;left:0;right:0;top:0;transform-origin:center center;transform:scale(.2);transition:inherit}.v-input--selection-controls__ripple>.v-ripple__container{transform:scale(1.2)}.v-input--selection-controls.v-input--dense .v-input--selection-controls__ripple{width:28px;height:28px;left:-9px}.v-input--selection-controls.v-input--dense:not(.v-input--switch) .v-input--selection-controls__ripple{top:calc(50% - 21px)}.v-input--selection-controls.v-input{flex:0 1 auto}.v-input--selection-controls.v-input--is-focused .v-input--selection-controls__ripple:before,.v-input--selection-controls .v-radio--is-focused .v-input--selection-controls__ripple:before{background:currentColor;transform:scale(1.2)}.v-input--selection-controls .v-input--selection-controls__input:hover .v-input--selection-controls__ripple:before{background:currentColor;transform:scale(1.2);transition:none}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "d696":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c662cfac-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/input/textarea/PpInputTextarea.vue?vue&type=template&id=62f2f138&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.label)?_c('pp-input-label',{attrs:{"label":_vm.label,"optional":_vm.optional,"input-id":_vm.inputId}}):_vm._e(),(_vm.showDescription)?_c('div',{staticClass:"subtitle-1 my-2 pp-input-description"},[_vm._t("description",[_vm._v(" "+_vm._s(_vm.description)+" ")])],2):_vm._e(),_c('v-textarea',_vm._g(_vm._b({ref:"inputTextarea",attrs:{"value":_vm.value,"error-messages":_vm.errorMessages,"hide-details":_vm.hideDetails,"outlined":"","filled":""}},'v-textarea',_vm.$attrs,false),_vm.$listeners))],1)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/input/textarea/PpInputTextarea.vue?vue&type=template&id=62f2f138&scoped=true&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("a4d3");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__("e01a");

// EXTERNAL MODULE: ./src/components/input/label/PpInputLabel.vue + 4 modules
var PpInputLabel = __webpack_require__("8e6c");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/input/textarea/PpInputTextarea.vue?vue&type=script&lang=js&


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var PpInputTextareavue_type_script_lang_js_ = ({
  name: 'PpInputTextarea',
  components: {
    'pp-input-label': PpInputLabel["default"]
  },
  props: {
    /**
     * Value of textarea
     */
    value: {
      type: String,
      default: null
    },

    /**
     * Label to be shown above textarea
     */
    label: {
      type: String,
      default: null
    },

    /**
     * If true, display optional label with a different color than the main label
     */
    optional: {
      type: Boolean,
      default: false
    },

    /**
     * Any error messages such as required, validation, etc...
     */
    errorMessages: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    hideDetails: {
      type: [String, Boolean],
      default: false
    },
    description: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      inputId: null
    };
  },
  computed: {
    showDescription: function showDescription() {
      return this.description || this.$slots.description;
    }
  },
  mounted: function mounted() {
    var _this$$refs, _this$$refs$inputText, _this$$refs$inputText2, _this$$refs$inputText3;

    this.inputId = (_this$$refs = this.$refs) === null || _this$$refs === void 0 ? void 0 : (_this$$refs$inputText = _this$$refs.inputTextarea) === null || _this$$refs$inputText === void 0 ? void 0 : (_this$$refs$inputText2 = _this$$refs$inputText.$refs) === null || _this$$refs$inputText2 === void 0 ? void 0 : (_this$$refs$inputText3 = _this$$refs$inputText2.input) === null || _this$$refs$inputText3 === void 0 ? void 0 : _this$$refs$inputText3.id;
  }
});
// CONCATENATED MODULE: ./src/components/input/textarea/PpInputTextarea.vue?vue&type=script&lang=js&
 /* harmony default export */ var textarea_PpInputTextareavue_type_script_lang_js_ = (PpInputTextareavue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/input/textarea/PpInputTextarea.vue?vue&type=style&index=0&id=62f2f138&lang=scss&scoped=true&
var PpInputTextareavue_type_style_index_0_id_62f2f138_lang_scss_scoped_true_ = __webpack_require__("24e5");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// EXTERNAL MODULE: ./node_modules/vuetify-loader/lib/runtime/installComponents.js
var installComponents = __webpack_require__("6544");
var installComponents_default = /*#__PURE__*/__webpack_require__.n(installComponents);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__("a9e3");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__("5530");

// EXTERNAL MODULE: ./node_modules/vuetify/src/components/VTextarea/VTextarea.sass
var VTextarea = __webpack_require__("1681");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/components/VTextField/VTextField.js + 2 modules
var VTextField = __webpack_require__("8654");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/util/mixins.js
var mixins = __webpack_require__("58df");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VTextarea/VTextarea.js


// Styles
 // Extensions

 // Utilities


var baseMixins = Object(mixins["a" /* default */])(VTextField["a" /* default */]);
/* @vue/component */

/* harmony default export */ var VTextarea_VTextarea = (baseMixins.extend({
  name: 'v-textarea',
  props: {
    autoGrow: Boolean,
    noResize: Boolean,
    rowHeight: {
      type: [Number, String],
      default: 24,
      validator: function validator(v) {
        return !isNaN(parseFloat(v));
      }
    },
    rows: {
      type: [Number, String],
      default: 5,
      validator: function validator(v) {
        return !isNaN(parseInt(v, 10));
      }
    }
  },
  computed: {
    classes: function classes() {
      return Object(objectSpread2["a" /* default */])({
        'v-textarea': true,
        'v-textarea--auto-grow': this.autoGrow,
        'v-textarea--no-resize': this.noResizeHandle
      }, VTextField["a" /* default */].options.computed.classes.call(this));
    },
    noResizeHandle: function noResizeHandle() {
      return this.noResize || this.autoGrow;
    }
  },
  watch: {
    lazyValue: function lazyValue() {
      this.autoGrow && this.$nextTick(this.calculateInputHeight);
    },
    rowHeight: function rowHeight() {
      this.autoGrow && this.$nextTick(this.calculateInputHeight);
    }
  },
  mounted: function mounted() {
    var _this = this;

    setTimeout(function () {
      _this.autoGrow && _this.calculateInputHeight();
    }, 0);
  },
  methods: {
    calculateInputHeight: function calculateInputHeight() {
      var input = this.$refs.input;
      if (!input) return;
      input.style.height = '0';
      var height = input.scrollHeight;
      var minHeight = parseInt(this.rows, 10) * parseFloat(this.rowHeight); // This has to be done ASAP, waiting for Vue
      // to update the DOM causes ugly layout jumping

      input.style.height = Math.max(minHeight, height) + 'px';
    },
    genInput: function genInput() {
      var input = VTextField["a" /* default */].options.methods.genInput.call(this);
      input.tag = 'textarea';
      delete input.data.attrs.type;
      input.data.attrs.rows = this.rows;
      return input;
    },
    onInput: function onInput(e) {
      VTextField["a" /* default */].options.methods.onInput.call(this, e);
      this.autoGrow && this.calculateInputHeight();
    },
    onKeyDown: function onKeyDown(e) {
      // Prevents closing of a
      // dialog when pressing
      // enter
      if (this.isFocused && e.keyCode === 13) {
        e.stopPropagation();
      }

      this.$emit('keydown', e);
    }
  }
}));
// CONCATENATED MODULE: ./src/components/input/textarea/PpInputTextarea.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  textarea_PpInputTextareavue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "62f2f138",
  null
  
)

/* harmony default export */ var PpInputTextarea = __webpack_exports__["default"] = (component.exports);

/* vuetify-loader */


installComponents_default()(component, {VTextarea: VTextarea_VTextarea})


/***/ }),

/***/ "d6d2":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.i, "@import url(https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css);"]);
exports.push([module.i, "@import url(https://cdn-prd.patientpop.com/pp-icon-font/v1.6.0/pp-icon-font.css);"]);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:Open Sans;font-style:normal;font-weight:400;src:url(https://sa1s3.patientpop.com/assets/fonts/provider/OpenSans-Regular-webfont.eot);src:url(https://sa1s3.patientpop.com/assets/fonts/provider/OpenSans-Regular-webfont.eot#iefix) format(\"embedded-opentype\"),url(https://sa1s3.patientpop.com/assets/fonts/provider/OpenSans-Regular-webfont.woff) format(\"woff\"),url(https://sa1s3.patientpop.com/assets/fonts/provider/OpenSans-Regular-webfont.ttf) format(\"truetype\"),url(https://sa1s3.patientpop.com/assets/fonts/provider/OpenSans-Regular-webfont.svg#open_sansregular) format(\"svg\")}@font-face{font-display:swap;font-family:Open Sans;font-style:normal;font-weight:300;src:url(https://sa1s3.patientpop.com/assets/fonts/provider/OpenSans-Light-webfont.eot);src:url(https://sa1s3.patientpop.com/assets/fonts/provider/OpenSans-Light-webfont.eot#iefix) format(\"embedded-opentype\"),url(https://sa1s3.patientpop.com/assets/fonts/provider/OpenSans-Light-webfont.woff) format(\"woff\"),url(https://sa1s3.patientpop.com/assets/fonts/provider/OpenSans-Light-webfont.ttf) format(\"truetype\"),url(https://sa1s3.patientpop.com/assets/fonts/provider/OpenSans-Light-webfont.svg#open_sanslight) format(\"svg\")}@font-face{font-display:swap;font-family:Open Sans;font-style:normal;font-weight:700;src:url(https://sa1s3.patientpop.com/assets/fonts/provider/OpenSans-Bold-webfont.eot);src:url(https://sa1s3.patientpop.com/assets/fonts/provider/OpenSans-Bold-webfont.eot#iefix) format(\"embedded-opentype\"),url(https://sa1s3.patientpop.com/assets/fonts/provider/OpenSans-Bold-webfont.woff) format(\"woff\"),url(https://sa1s3.patientpop.com/assets/fonts/provider/OpenSans-Bold-webfont.ttf) format(\"truetype\"),url(https://sa1s3.patientpop.com/assets/fonts/provider/OpenSans-Bold-webfont.svg#open_sansbold) format(\"svg\")}@font-face{font-display:swap;font-family:Open Sans;font-style:normal;font-weight:600;src:url(https://sa1s3.patientpop.com/assets/fonts/provider/OpenSans-Semibold-webfont.eot);src:url(https://sa1s3.patientpop.com/assets/fonts/provider/OpenSans-Semibold-webfont.eot#iefix) format(\"embedded-opentype\"),url(https://sa1s3.patientpop.com/assets/fonts/provider/OpenSans-Semibold-webfont.woff) format(\"woff\"),url(https://sa1s3.patientpop.com/assets/fonts/provider/OpenSans-Semibold-webfont.ttf) format(\"truetype\"),url(https://sa1s3.patientpop.com/assets/fonts/provider/OpenSans-Semibold-webfont.svg#open_sanssemibold) format(\"svg\")}[data-v-233fd1d2].rich-text-editor .tox-tinymce{border:0;border-radius:5px}[data-v-233fd1d2].rich-text-editor .tox-edit-area{background:#f6f6f6;border:1px solid transparent;border-radius:0 0 5px 5px}[data-v-233fd1d2].rich-text-editor .tox-edit-area__iframe{background:#e9efee;transition:background .2s}[data-v-233fd1d2].rich-text-editor .tox-edit-area__iframe:hover{background:#eef7f9}[data-v-233fd1d2].rich-text-editor .tox-sidebar-wrap{border:1px solid #d6d6d6;border-radius:0 0 5px 5px}[data-v-233fd1d2].rich-text-editor--focus .tox-edit-area{border:0}[data-v-233fd1d2].rich-text-editor--focus .tox-edit-area__iframe{background:#fff!important}[data-v-233fd1d2].rich-text-editor--focus .tox-sidebar-wrap{border:2px solid #079cb2}[data-v-233fd1d2].rich-text-editor--error .tox-edit-area,[data-v-233fd1d2].rich-text-editor--error .tox-edit-area__iframe{background:#fceeee}[data-v-233fd1d2].rich-text-editor .tox-tbtn--select{background-color:#fff;border:1px solid #d6d6d6;border-radius:5px;color:#545454}[data-v-233fd1d2].rich-text-editor .tox-tbtn--select+.tox-tbtn--select{margin-left:10px}[data-v-233fd1d2].rich-text-editor .tox-tbtn svg{fill:#545454}[data-v-233fd1d2].rich-text-editor .tox-toolbar__primary{background-color:#fff;background-image:none;border:1px solid #d6d6d6;padding:5px}[data-v-233fd1d2].rich-text-editor-error--text{color:#b51a2c;font-size:.8571428571rem}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "d6f8":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("c8d5")

/**
 * @category Month Helpers
 * @summary Return the end of a month for the given date.
 *
 * @description
 * Return the end of a month for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of a month
 *
 * @example
 * // The end of a month for 2 September 2014 11:55:00:
 * var result = endOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 23:59:59.999
 */
function endOfMonth (dirtyDate) {
  var date = parse(dirtyDate)
  var month = date.getMonth()
  date.setFullYear(date.getFullYear(), month + 1, 0)
  date.setHours(23, 59, 59, 999)
  return date
}

module.exports = endOfMonth


/***/ }),

/***/ "d784":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// TODO: Remove from `core-js@4` since it's moved to entry points
__webpack_require__("ac1f");
var redefine = __webpack_require__("6eeb");
var fails = __webpack_require__("d039");
var wellKnownSymbol = __webpack_require__("b622");
var regexpExec = __webpack_require__("9263");
var createNonEnumerableProperty = __webpack_require__("9112");

var SPECIES = wellKnownSymbol('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

// IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
var REPLACE_KEEPS_$0 = (function () {
  return 'a'.replace(/./, '$0') === '$0';
})();

var REPLACE = wellKnownSymbol('replace');
// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = (function () {
  if (/./[REPLACE]) {
    return /./[REPLACE]('a', '$0') === '';
  }
  return false;
})();

// Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
// Weex JS has frozen built-in prototypes, so use try / catch wrapper
var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !fails(function () {
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length !== 2 || result[0] !== 'a' || result[1] !== 'b';
});

module.exports = function (KEY, length, exec, sham) {
  var SYMBOL = wellKnownSymbol(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;

    if (KEY === 'split') {
      // We can't use real regex here since it causes deoptimization
      // and serious performance degradation in V8
      // https://github.com/zloirock/core-js/issues/306
      re = {};
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
      re.flags = '';
      re[SYMBOL] = /./[SYMBOL];
    }

    re.exec = function () { execCalled = true; return null; };

    re[SYMBOL]('');
    return !execCalled;
  });

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !(
      REPLACE_SUPPORTS_NAMED_GROUPS &&
      REPLACE_KEEPS_$0 &&
      !REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE
    )) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
      if (regexp.exec === regexpExec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
        }
        return { done: true, value: nativeMethod.call(str, regexp, arg2) };
      }
      return { done: false };
    }, {
      REPLACE_KEEPS_$0: REPLACE_KEEPS_$0,
      REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE: REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE
    });
    var stringMethod = methods[0];
    var regexMethod = methods[1];

    redefine(String.prototype, KEY, stringMethod);
    redefine(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return regexMethod.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return regexMethod.call(string, this); }
    );
  }

  if (sham) createNonEnumerableProperty(RegExp.prototype[SYMBOL], 'sham', true);
};


/***/ }),

/***/ "d813":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpPagination_vue_vue_type_style_index_0_id_435e27ea_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("3d8d");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpPagination_vue_vue_type_style_index_0_id_435e27ea_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpPagination_vue_vue_type_style_index_0_id_435e27ea_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "d81d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $map = __webpack_require__("b727").map;
var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");
var arrayMethodUsesToLength = __webpack_require__("ae40");

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('map');
// FF49- issue
var USES_TO_LENGTH = arrayMethodUsesToLength('map');

// `Array.prototype.map` method
// https://tc39.es/ecma262/#sec-array.prototype.map
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT || !USES_TO_LENGTH }, {
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "d880":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.v-list-item-group .v-list-item--active{color:inherit}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "d888":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c662cfac-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/loader/PpLoader.vue?vue&type=template&id=6a597e20&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-progress-circular',{staticClass:"pp-loader",style:(("--pp-loader-size:" + _vm.size + "px")),attrs:{"size":_vm.size,"color":_vm.color,"width":_vm.width,"value":_vm.value,"indeterminate":_vm.indeterminate}})}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/loader/PpLoader.vue?vue&type=template&id=6a597e20&scoped=true&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__("a9e3");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/loader/PpLoader.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var PpLoadervue_type_script_lang_js_ = ({
  name: 'PpLoader',
  props: {
    size: {
      type: Number,
      default: 50
    },
    width: {
      type: Number,
      default: 5
    },
    color: {
      type: String,
      default: 'primary'
    },
    // If true will be circling without stop (spinner)
    indeterminate: {
      type: Boolean,
      default: true
    },
    // Set the filled value of the ring
    value: {
      type: Number,
      default: 100
    }
  }
});
// CONCATENATED MODULE: ./src/components/loader/PpLoader.vue?vue&type=script&lang=js&
 /* harmony default export */ var loader_PpLoadervue_type_script_lang_js_ = (PpLoadervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/loader/PpLoader.vue?vue&type=style&index=0&id=6a597e20&lang=scss&scoped=true&
var PpLoadervue_type_style_index_0_id_6a597e20_lang_scss_scoped_true_ = __webpack_require__("cbf9");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// EXTERNAL MODULE: ./node_modules/vuetify-loader/lib/runtime/installComponents.js
var installComponents = __webpack_require__("6544");
var installComponents_default = /*#__PURE__*/__webpack_require__.n(installComponents);

// EXTERNAL MODULE: ./node_modules/vuetify/lib/components/VProgressCircular/VProgressCircular.js
var VProgressCircular = __webpack_require__("490a");

// CONCATENATED MODULE: ./src/components/loader/PpLoader.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  loader_PpLoadervue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "6a597e20",
  null
  
)

/* harmony default export */ var PpLoader = __webpack_exports__["default"] = (component.exports);

/* vuetify-loader */


installComponents_default()(component, {VProgressCircular: VProgressCircular["a" /* default */]})


/***/ }),

/***/ "d951":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("32cd");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("fd11034e", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "d975":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("c8d5")

/**
 * @category Year Helpers
 * @summary Return the end of a year for the given date.
 *
 * @description
 * Return the end of a year for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of a year
 *
 * @example
 * // The end of a year for 2 September 2014 11:55:00:
 * var result = endOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Dec 31 2014 23:59:59.999
 */
function endOfYear (dirtyDate) {
  var date = parse(dirtyDate)
  var year = date.getFullYear()
  date.setFullYear(year + 1, 0, 0)
  date.setHours(23, 59, 59, 999)
  return date
}

module.exports = endOfYear


/***/ }),

/***/ "d985":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.i, "@import url(https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css);"]);
exports.push([module.i, "@import url(https://cdn-prd.patientpop.com/pp-icon-font/v1.6.0/pp-icon-font.css);"]);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.pp-button[data-v-c5417a2a]{--pp-text-primary:#004852;--pp-primary-button-text-color:#fff}.pp-button[data-v-c5417a2a]:before{background:transparent;opacity:1}.pp-button[data-v-c5417a2a]:hover:before{background:var(--pp-button-hover-bg,#f6f6f6)}.pp-button[data-v-c5417a2a]:focus{outline:3px solid #004852!important}.pp-button--primary[data-v-c5417a2a]{--pp-button-hover-bg:var(--pp-primary-button-hover-bg,#ffaf95);--pp-disabled-button-bg:var(--pp-primary-disabled-button-bg,#ffe9e3);--pp-disabled-button-color:var(--pp-primary-disabled-button-color,#8cb2b6);--pp-primary-button-text-color:var(--pp-primary-button-text-custom-color,#004852)}.pp-button--tertiary[data-v-c5417a2a]{--pp-button-hover-bg:#d6d6d6;--pp-disabled-button-color:#545454;--pp-disabled-button-bg:#fff;background:var(--pp-button-tertiary-bg,#f6f6f6)}.pp-button--secondary[data-v-c5417a2a]{--pp-button-hover-bg:#f6f6f6;--pp-disabled-button-color:#545454;--pp-disabled-button-bg:#f6f6f6;border-color:#d6d6d6}.pp-button--caution[data-v-c5417a2a]{--pp-button-hover-bg:#b51a2c;--pp-disabled-button-color:#fff;--pp-disabled-button-bg:#fceeee}.pp-button--positive[data-v-c5417a2a]{--pp-button-hover-bg:#1d6b45}.pp-button--warning[data-v-c5417a2a]{--pp-button-hover-bg:#f2ba2a}.pp-button--plain[data-v-c5417a2a]{opacity:1;--pp-disabled-button-color:#067889;--pp-disabled-button-bg:transparent}.pp-button--plain.v-btn--plain[data-v-c5417a2a]:not(.v-btn--disabled):not(:focus):not(:hover)  .v-btn__content{opacity:1}.pp-button[data-v-c5417a2a]  .v-btn__content{line-height:1}.pp-button__embed-icon[data-v-c5417a2a]{font-size:1em}.pp-button--hover.v-btn[data-v-c5417a2a]{--pp-button-hover-bg:#079cb2;background-color:#fff;border-color:#d6d6d6;color:#079cb2}.pp-button--hover.v-btn[data-v-c5417a2a]:hover{color:#fff}.pp-button--icon i[data-v-c5417a2a]{font-size:1.15em}.pp-button--icon--outlined[data-v-c5417a2a]{border-color:#d6d6d6}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "d9bd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "c", function() { return /* binding */ consoleWarn; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* binding */ consoleError; });
__webpack_require__.d(__webpack_exports__, "d", function() { return /* binding */ deprecate; });
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ breaking; });
__webpack_require__.d(__webpack_exports__, "e", function() { return /* binding */ removed; });

// UNUSED EXPORTS: consoleInfo

// NAMESPACE OBJECT: ./node_modules/vuetify/lib/services/goto/easing-patterns.js
var easing_patterns_namespaceObject = {};
__webpack_require__.r(easing_patterns_namespaceObject);
__webpack_require__.d(easing_patterns_namespaceObject, "linear", function() { return linear; });
__webpack_require__.d(easing_patterns_namespaceObject, "easeInQuad", function() { return easeInQuad; });
__webpack_require__.d(easing_patterns_namespaceObject, "easeOutQuad", function() { return easeOutQuad; });
__webpack_require__.d(easing_patterns_namespaceObject, "easeInOutQuad", function() { return easeInOutQuad; });
__webpack_require__.d(easing_patterns_namespaceObject, "easeInCubic", function() { return easeInCubic; });
__webpack_require__.d(easing_patterns_namespaceObject, "easeOutCubic", function() { return easeOutCubic; });
__webpack_require__.d(easing_patterns_namespaceObject, "easeInOutCubic", function() { return easeInOutCubic; });
__webpack_require__.d(easing_patterns_namespaceObject, "easeInQuart", function() { return easeInQuart; });
__webpack_require__.d(easing_patterns_namespaceObject, "easeOutQuart", function() { return easeOutQuart; });
__webpack_require__.d(easing_patterns_namespaceObject, "easeInOutQuart", function() { return easeInOutQuart; });
__webpack_require__.d(easing_patterns_namespaceObject, "easeInQuint", function() { return easeInQuint; });
__webpack_require__.d(easing_patterns_namespaceObject, "easeOutQuint", function() { return easeOutQuint; });
__webpack_require__.d(easing_patterns_namespaceObject, "easeInOutQuint", function() { return easeInOutQuint; });

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("99af");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("caad");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__("a15b");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("d81d");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("b0c0");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__("ac1f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("2532");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.match.js
var es_string_match = __webpack_require__("466d");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.repeat.js
var es_string_repeat = __webpack_require__("38cf");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.replace.js
var es_string_replace = __webpack_require__("5319");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("4160");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("159b");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/classCallCheck.js
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/createClass.js
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
// EXTERNAL MODULE: external {"commonjs":"vue","commonjs2":"vue","root":"Vue"}
var external_commonjs_vue_commonjs2_vue_root_Vue_ = __webpack_require__("8bbf");
var external_commonjs_vue_commonjs2_vue_root_Vue_default = /*#__PURE__*/__webpack_require__.n(external_commonjs_vue_commonjs2_vue_root_Vue_);

// CONCATENATED MODULE: ./node_modules/vuetify/lib/install.js


function install(Vue) {
  var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (install.installed) return;
  install.installed = true;

  if (external_commonjs_vue_commonjs2_vue_root_Vue_default.a !== Vue) {
    consoleError("Multiple instances of Vue detected\nSee https://github.com/vuetifyjs/vuetify/issues/4068\n\nIf you're seeing \"$attrs is readonly\", it's caused by this");
  }

  var components = args.components || {};
  var directives = args.directives || {};

  for (var name in directives) {
    var directive = directives[name];
    Vue.directive(name, directive);
  }

  (function registerComponents(components) {
    if (components) {
      for (var key in components) {
        var component = components[key];

        if (component && !registerComponents(component.$_vuetify_subcomponents)) {
          Vue.component(key, component);
        }
      }

      return true;
    }

    return false;
  })(components); // Used to avoid multiple mixins being setup
  // when in dev mode and hot module reload
  // https://github.com/vuejs/vue/issues/5089#issuecomment-284260111


  if (Vue.$_vuetify_installed) return;
  Vue.$_vuetify_installed = true;
  Vue.mixin({
    beforeCreate: function beforeCreate() {
      var options = this.$options;

      if (options.vuetify) {
        options.vuetify.init(this, this.$ssrContext);
        this.$vuetify = Vue.observable(options.vuetify.framework);
      } else {
        this.$vuetify = options.parent && options.parent.$vuetify || this;
      }
    },
    beforeMount: function beforeMount() {
      // @ts-ignore
      if (this.$options.vuetify && this.$el && this.$el.hasAttribute('data-server-rendered')) {
        // @ts-ignore
        this.$vuetify.isHydrating = true; // @ts-ignore

        this.$vuetify.breakpoint.update(true);
      }
    },
    mounted: function mounted() {
      // @ts-ignore
      if (this.$options.vuetify && this.$vuetify.isHydrating) {
        // @ts-ignore
        this.$vuetify.isHydrating = false; // @ts-ignore

        this.$vuetify.breakpoint.update();
      }
    }
  });
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__("15fd");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/inherits.js

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.reflect.construct.js
var es_reflect_construct = __webpack_require__("4ae1");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-prototype-of.js
var es_object_get_prototype_of = __webpack_require__("3410");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("d3b7");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("25f0");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/isNativeReflectConstruct.js



function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__("53ca");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js


function _possibleConstructorReturn(self, call) {
  if (call && (Object(esm_typeof["a" /* default */])(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/createSuper.js




function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}
// EXTERNAL MODULE: ./node_modules/vuetify/src/styles/main.sass
var main = __webpack_require__("95ed");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/locale/en.js
/* harmony default export */ var en = ({
  badge: 'Badge',
  close: 'Close',
  dataIterator: {
    noResultsText: 'No matching records found',
    loadingText: 'Loading items...'
  },
  dataTable: {
    itemsPerPageText: 'Rows per page:',
    ariaLabel: {
      sortDescending: 'Sorted descending.',
      sortAscending: 'Sorted ascending.',
      sortNone: 'Not sorted.',
      activateNone: 'Activate to remove sorting.',
      activateDescending: 'Activate to sort descending.',
      activateAscending: 'Activate to sort ascending.'
    },
    sortBy: 'Sort by'
  },
  dataFooter: {
    itemsPerPageText: 'Items per page:',
    itemsPerPageAll: 'All',
    nextPage: 'Next page',
    prevPage: 'Previous page',
    firstPage: 'First page',
    lastPage: 'Last page',
    pageText: '{0}-{1} of {2}'
  },
  datePicker: {
    itemsSelected: '{0} selected',
    nextMonthAriaLabel: 'Next month',
    nextYearAriaLabel: 'Next year',
    prevMonthAriaLabel: 'Previous month',
    prevYearAriaLabel: 'Previous year'
  },
  noDataText: 'No data available',
  carousel: {
    prev: 'Previous visual',
    next: 'Next visual',
    ariaLabel: {
      delimiter: 'Carousel slide {0} of {1}'
    }
  },
  calendar: {
    moreEvents: '{0} more'
  },
  fileInput: {
    counter: '{0} files',
    counterSize: '{0} files ({1} in total)'
  },
  timePicker: {
    am: 'AM',
    pm: 'PM'
  },
  pagination: {
    ariaLabel: {
      wrapper: 'Pagination Navigation',
      next: 'Next page',
      previous: 'Previous page',
      page: 'Goto Page {0}',
      currentPage: 'Current Page, Page {0}'
    }
  },
  rating: {
    ariaLabel: {
      icon: 'Rating {0} of {1}'
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vuetify/lib/presets/default/index.js
// Styles
 // Locale


var default_preset = {
  breakpoint: {
    // TODO: update to MD2 spec in v3 - 1280
    mobileBreakpoint: 1264,
    scrollBarWidth: 16,
    thresholds: {
      xs: 600,
      sm: 960,
      md: 1280,
      lg: 1920
    }
  },
  icons: {
    // TODO: remove v3
    iconfont: 'mdi',
    values: {}
  },
  lang: {
    current: 'en',
    locales: {
      en: en
    },
    // Default translator exists in lang service
    t: undefined
  },
  rtl: false,
  theme: {
    dark: false,
    default: 'light',
    disable: false,
    options: {
      cspNonce: undefined,
      customProperties: undefined,
      minifyTheme: undefined,
      themeCache: undefined,
      variations: true
    },
    themes: {
      light: {
        primary: '#1976D2',
        secondary: '#424242',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FB8C00'
      },
      dark: {
        primary: '#2196F3',
        secondary: '#424242',
        accent: '#FF4081',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FB8C00'
      }
    }
  }
};
// EXTERNAL MODULE: ./node_modules/vuetify/lib/util/helpers.js
var helpers = __webpack_require__("80d2");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/services/service/index.js


var service_Service = /*#__PURE__*/function () {
  function Service() {
    _classCallCheck(this, Service);

    this.framework = {};
  }

  _createClass(Service, [{
    key: "init",
    value: function init(root, ssrContext) {}
  }]);

  return Service;
}();
// CONCATENATED MODULE: ./node_modules/vuetify/lib/services/presets/index.js




// Preset
 // Utilities




var presets_Presets = /*#__PURE__*/function (_Service) {
  _inherits(Presets, _Service);

  var _super = _createSuper(Presets);

  function Presets(parentPreset, parent) {
    var _this;

    _classCallCheck(this, Presets);

    _this = _super.call(this); // The default preset

    var defaultPreset = Object(helpers["z" /* mergeDeep */])({}, default_preset); // The user provided preset

    var userPreset = parent.userPreset; // The user provided global preset

    var _userPreset$preset = userPreset.preset,
        globalPreset = _userPreset$preset === void 0 ? {} : _userPreset$preset,
        preset = Object(objectWithoutProperties["a" /* default */])(userPreset, ["preset"]);

    if (globalPreset.preset != null) {
      consoleWarn('Global presets do not support the **preset** option, it can be safely omitted');
    }

    parent.preset = Object(helpers["z" /* mergeDeep */])(Object(helpers["z" /* mergeDeep */])(defaultPreset, globalPreset), preset);
    return _this;
  }

  return Presets;
}(service_Service);
presets_Presets.property = 'presets';
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.reduce.js
var es_array_reduce = __webpack_require__("13d5");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.values.js
var es_object_values = __webpack_require__("07ac");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("ade3");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/services/application/index.js







// Extensions

var application_Application = /*#__PURE__*/function (_Service) {
  _inherits(Application, _Service);

  var _super = _createSuper(Application);

  function Application() {
    var _this;

    _classCallCheck(this, Application);

    _this = _super.apply(this, arguments);
    _this.bar = 0;
    _this.top = 0;
    _this.left = 0;
    _this.insetFooter = 0;
    _this.right = 0;
    _this.bottom = 0;
    _this.footer = 0;
    _this.application = {
      bar: {},
      top: {},
      left: {},
      insetFooter: {},
      right: {},
      bottom: {},
      footer: {}
    };
    return _this;
  }

  _createClass(Application, [{
    key: "register",
    value: function register(uid, location, size) {
      this.application[location] = Object(defineProperty["a" /* default */])({}, uid, size);
      this.update(location);
    }
  }, {
    key: "unregister",
    value: function unregister(uid, location) {
      if (this.application[location][uid] == null) return;
      delete this.application[location][uid];
      this.update(location);
    }
  }, {
    key: "update",
    value: function update(location) {
      this[location] = Object.values(this.application[location]).reduce(function (acc, cur) {
        return acc + cur;
      }, 0);
    }
  }]);

  return Application;
}(service_Service);
application_Application.property = 'application';
// CONCATENATED MODULE: ./node_modules/vuetify/lib/services/breakpoint/index.js





// Extensions

var breakpoint_Breakpoint = /*#__PURE__*/function (_Service) {
  _inherits(Breakpoint, _Service);

  var _super = _createSuper(Breakpoint);

  function Breakpoint(preset) {
    var _this;

    _classCallCheck(this, Breakpoint);

    _this = _super.call(this); // Public

    _this.xs = false;
    _this.sm = false;
    _this.md = false;
    _this.lg = false;
    _this.xl = false;
    _this.xsOnly = false;
    _this.smOnly = false;
    _this.smAndDown = false;
    _this.smAndUp = false;
    _this.mdOnly = false;
    _this.mdAndDown = false;
    _this.mdAndUp = false;
    _this.lgOnly = false;
    _this.lgAndDown = false;
    _this.lgAndUp = false;
    _this.xlOnly = false; // Value is xs to match v2.x functionality

    _this.name = 'xs';
    _this.height = 0;
    _this.width = 0; // TODO: Add functionality to detect this dynamically in v3
    // Value is true to match v2.x functionality

    _this.mobile = true;
    _this.resizeTimeout = 0;
    var _preset$Breakpoint$pr = preset[Breakpoint.property],
        mobileBreakpoint = _preset$Breakpoint$pr.mobileBreakpoint,
        scrollBarWidth = _preset$Breakpoint$pr.scrollBarWidth,
        thresholds = _preset$Breakpoint$pr.thresholds;
    _this.mobileBreakpoint = mobileBreakpoint;
    _this.scrollBarWidth = scrollBarWidth;
    _this.thresholds = thresholds;
    return _this;
  }

  _createClass(Breakpoint, [{
    key: "init",
    value: function init() {
      this.update();
      /* istanbul ignore if */

      if (typeof window === 'undefined') return;
      window.addEventListener('resize', this.onResize.bind(this), {
        passive: true
      });
    }
    /* eslint-disable-next-line max-statements */

  }, {
    key: "update",
    value: function update() {
      var ssr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var height = ssr ? 0 : this.getClientHeight();
      var width = ssr ? 0 : this.getClientWidth();
      var xs = width < this.thresholds.xs;
      var sm = width < this.thresholds.sm && !xs;
      var md = width < this.thresholds.md - this.scrollBarWidth && !(sm || xs);
      var lg = width < this.thresholds.lg - this.scrollBarWidth && !(md || sm || xs);
      var xl = width >= this.thresholds.lg - this.scrollBarWidth;
      this.height = height;
      this.width = width;
      this.xs = xs;
      this.sm = sm;
      this.md = md;
      this.lg = lg;
      this.xl = xl;
      this.xsOnly = xs;
      this.smOnly = sm;
      this.smAndDown = (xs || sm) && !(md || lg || xl);
      this.smAndUp = !xs && (sm || md || lg || xl);
      this.mdOnly = md;
      this.mdAndDown = (xs || sm || md) && !(lg || xl);
      this.mdAndUp = !(xs || sm) && (md || lg || xl);
      this.lgOnly = lg;
      this.lgAndDown = (xs || sm || md || lg) && !xl;
      this.lgAndUp = !(xs || sm || md) && (lg || xl);
      this.xlOnly = xl;

      switch (true) {
        case xs:
          this.name = 'xs';
          break;

        case sm:
          this.name = 'sm';
          break;

        case md:
          this.name = 'md';
          break;

        case lg:
          this.name = 'lg';
          break;

        default:
          this.name = 'xl';
          break;
      }

      if (typeof this.mobileBreakpoint === 'number') {
        this.mobile = width < parseInt(this.mobileBreakpoint, 10);
        return;
      }

      var breakpoints = {
        xs: 0,
        sm: 1,
        md: 2,
        lg: 3,
        xl: 4
      };
      var current = breakpoints[this.name];
      var max = breakpoints[this.mobileBreakpoint];
      this.mobile = current <= max;
    }
  }, {
    key: "onResize",
    value: function onResize() {
      clearTimeout(this.resizeTimeout); // Added debounce to match what
      // v-resize used to do but was
      // removed due to a memory leak
      // https://github.com/vuetifyjs/vuetify/pull/2997

      this.resizeTimeout = window.setTimeout(this.update.bind(this), 200);
    } // Cross-browser support as described in:
    // https://stackoverflow.com/questions/1248081

  }, {
    key: "getClientWidth",
    value: function getClientWidth() {
      /* istanbul ignore if */
      if (typeof document === 'undefined') return 0; // SSR

      return Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
  }, {
    key: "getClientHeight",
    value: function getClientHeight() {
      /* istanbul ignore if */
      if (typeof document === 'undefined') return 0; // SSR

      return Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    }
  }]);

  return Breakpoint;
}(service_Service);
breakpoint_Breakpoint.property = 'breakpoint';
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.promise.js
var es_promise = __webpack_require__("e6cf");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__("5530");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/services/goto/easing-patterns.js
// linear
var linear = function linear(t) {
  return t;
}; // accelerating from zero velocity

var easeInQuad = function easeInQuad(t) {
  return Math.pow(t, 2);
}; // decelerating to zero velocity

var easeOutQuad = function easeOutQuad(t) {
  return t * (2 - t);
}; // acceleration until halfway, then deceleration

var easeInOutQuad = function easeInOutQuad(t) {
  return t < 0.5 ? 2 * Math.pow(t, 2) : -1 + (4 - 2 * t) * t;
}; // accelerating from zero velocity

var easeInCubic = function easeInCubic(t) {
  return Math.pow(t, 3);
}; // decelerating to zero velocity

var easeOutCubic = function easeOutCubic(t) {
  return Math.pow(--t, 3) + 1;
}; // acceleration until halfway, then deceleration

var easeInOutCubic = function easeInOutCubic(t) {
  return t < 0.5 ? 4 * Math.pow(t, 3) : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
}; // accelerating from zero velocity

var easeInQuart = function easeInQuart(t) {
  return Math.pow(t, 4);
}; // decelerating to zero velocity

var easeOutQuart = function easeOutQuart(t) {
  return 1 - Math.pow(--t, 4);
}; // acceleration until halfway, then deceleration

var easeInOutQuart = function easeInOutQuart(t) {
  return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
}; // accelerating from zero velocity

var easeInQuint = function easeInQuint(t) {
  return Math.pow(t, 5);
}; // decelerating to zero velocity

var easeOutQuint = function easeOutQuint(t) {
  return 1 + Math.pow(--t, 5);
}; // acceleration until halfway, then deceleration

var easeInOutQuint = function easeInOutQuint(t) {
  return t < 0.5 ? 16 * Math.pow(t, 5) : 1 + 16 * Math.pow(--t, 5);
};
// CONCATENATED MODULE: ./node_modules/vuetify/lib/services/goto/util.js

// Return target's cumulative offset from the top
function getOffset(target) {
  if (typeof target === 'number') {
    return target;
  }

  var el = $(target);

  if (!el) {
    throw typeof target === 'string' ? new Error("Target element \"".concat(target, "\" not found.")) : new TypeError("Target must be a Number/Selector/HTMLElement/VueComponent, received ".concat(util_type(target), " instead."));
  }

  var totalOffset = 0;

  while (el) {
    totalOffset += el.offsetTop;
    el = el.offsetParent;
  }

  return totalOffset;
}
function getContainer(container) {
  var el = $(container);
  if (el) return el;
  throw typeof container === 'string' ? new Error("Container element \"".concat(container, "\" not found.")) : new TypeError("Container must be a Selector/HTMLElement/VueComponent, received ".concat(util_type(container), " instead."));
}

function util_type(el) {
  return el == null ? el : el.constructor.name;
}

function $(el) {
  if (typeof el === 'string') {
    return document.querySelector(el);
  } else if (el && el._isVue) {
    return el.$el;
  } else if (el instanceof HTMLElement) {
    return el;
  } else {
    return null;
  }
}
// CONCATENATED MODULE: ./node_modules/vuetify/lib/services/goto/index.js







// Extensions
 // Utilities



function goTo(_target) {
  var _settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var settings = Object(objectSpread2["a" /* default */])({
    container: document.scrollingElement || document.body || document.documentElement,
    duration: 500,
    offset: 0,
    easing: 'easeInOutCubic',
    appOffset: true
  }, _settings);

  var container = getContainer(settings.container);
  /* istanbul ignore else */

  if (settings.appOffset && goTo.framework.application) {
    var isDrawer = container.classList.contains('v-navigation-drawer');
    var isClipped = container.classList.contains('v-navigation-drawer--clipped');
    var _goTo$framework$appli = goTo.framework.application,
        bar = _goTo$framework$appli.bar,
        top = _goTo$framework$appli.top;
    settings.offset += bar;
    /* istanbul ignore else */

    if (!isDrawer || isClipped) settings.offset += top;
  }

  var startTime = performance.now();
  var targetLocation;

  if (typeof _target === 'number') {
    targetLocation = getOffset(_target) - settings.offset;
  } else {
    targetLocation = getOffset(_target) - getOffset(container) - settings.offset;
  }

  var startLocation = container.scrollTop;
  if (targetLocation === startLocation) return Promise.resolve(targetLocation);
  var ease = typeof settings.easing === 'function' ? settings.easing : easing_patterns_namespaceObject[settings.easing];
  /* istanbul ignore else */

  if (!ease) throw new TypeError("Easing function \"".concat(settings.easing, "\" not found.")); // Cannot be tested properly in jsdom

  /* istanbul ignore next */

  return new Promise(function (resolve) {
    return requestAnimationFrame(function step(currentTime) {
      var timeElapsed = currentTime - startTime;
      var progress = Math.abs(settings.duration ? Math.min(timeElapsed / settings.duration, 1) : 1);
      container.scrollTop = Math.floor(startLocation + (targetLocation - startLocation) * ease(progress));
      var clientHeight = container === document.body ? document.documentElement.clientHeight : container.clientHeight;

      if (progress === 1 || clientHeight + container.scrollTop === container.scrollHeight) {
        return resolve(targetLocation);
      }

      requestAnimationFrame(step);
    });
  });
}
goTo.framework = {};

goTo.init = function () {};

var goto_Goto = /*#__PURE__*/function (_Service) {
  _inherits(Goto, _Service);

  var _super = _createSuper(Goto);

  function Goto() {
    var _this;

    _classCallCheck(this, Goto);

    _this = _super.call(this);
    return _possibleConstructorReturn(_this, goTo);
  }

  return Goto;
}(service_Service);
goto_Goto.property = 'goTo';
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__("e260");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__("ddb0");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.freeze.js
var es_object_freeze = __webpack_require__("dca8");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/services/icons/presets/mdi-svg.js
var icons = {
  complete: 'M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z',
  cancel: 'M12,2C17.53,2 22,6.47 22,12C22,17.53 17.53,22 12,22C6.47,22 2,17.53 2,12C2,6.47 6.47,2 12,2M15.59,7L12,10.59L8.41,7L7,8.41L10.59,12L7,15.59L8.41,17L12,13.41L15.59,17L17,15.59L13.41,12L17,8.41L15.59,7Z',
  close: 'M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z',
  delete: 'M12,2C17.53,2 22,6.47 22,12C22,17.53 17.53,22 12,22C6.47,22 2,17.53 2,12C2,6.47 6.47,2 12,2M15.59,7L12,10.59L8.41,7L7,8.41L10.59,12L7,15.59L8.41,17L12,13.41L15.59,17L17,15.59L13.41,12L17,8.41L15.59,7Z',
  clear: 'M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z',
  success: 'M12,2C17.52,2 22,6.48 22,12C22,17.52 17.52,22 12,22C6.48,22 2,17.52 2,12C2,6.48 6.48,2 12,2M11,16.5L18,9.5L16.59,8.09L11,13.67L7.91,10.59L6.5,12L11,16.5Z',
  info: 'M13,9H11V7H13M13,17H11V11H13M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2Z',
  warning: 'M11,4.5H13V15.5H11V4.5M13,17.5V19.5H11V17.5H13Z',
  error: 'M13,14H11V10H13M13,18H11V16H13M1,21H23L12,2L1,21Z',
  prev: 'M15.41,16.58L10.83,12L15.41,7.41L14,6L8,12L14,18L15.41,16.58Z',
  next: 'M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z',
  checkboxOn: 'M10,17L5,12L6.41,10.58L10,14.17L17.59,6.58L19,8M19,3H5C3.89,3 3,3.89 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.89 20.1,3 19,3Z',
  checkboxOff: 'M19,3H5C3.89,3 3,3.89 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.89 20.1,3 19,3M19,5V19H5V5H19Z',
  checkboxIndeterminate: 'M17,13H7V11H17M19,3H5C3.89,3 3,3.89 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.89 20.1,3 19,3Z',
  delimiter: 'M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2Z',
  sort: 'M13,20H11V8L5.5,13.5L4.08,12.08L12,4.16L19.92,12.08L18.5,13.5L13,8V20Z',
  expand: 'M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z',
  menu: 'M3,6H21V8H3V6M3,11H21V13H3V11M3,16H21V18H3V16Z',
  subgroup: 'M7,10L12,15L17,10H7Z',
  dropdown: 'M7,10L12,15L17,10H7Z',
  radioOn: 'M12,20C7.58,20 4,16.42 4,12C4,7.58 7.58,4 12,4C16.42,4 20,7.58 20,12C20,16.42 16.42,20 12,20M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2M12,7C9.24,7 7,9.24 7,12C7,14.76 9.24,17 12,17C14.76,17 17,14.76 17,12C17,9.24 14.76,7 12,7Z',
  radioOff: 'M12,20C7.58,20 4,16.42 4,12C4,7.58 7.58,4 12,4C16.42,4 20,7.58 20,12C20,16.42 16.42,20 12,20M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2Z',
  edit: 'M20.71,7.04C21.1,6.65 21.1,6 20.71,5.63L18.37,3.29C18,2.9 17.35,2.9 16.96,3.29L15.12,5.12L18.87,8.87M3,17.25V21H6.75L17.81,9.93L14.06,6.18L3,17.25Z',
  ratingEmpty: 'M12,15.39L8.24,17.66L9.23,13.38L5.91,10.5L10.29,10.13L12,6.09L13.71,10.13L18.09,10.5L14.77,13.38L15.76,17.66M22,9.24L14.81,8.63L12,2L9.19,8.63L2,9.24L7.45,13.97L5.82,21L12,17.27L18.18,21L16.54,13.97L22,9.24Z',
  ratingFull: 'M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z',
  ratingHalf: 'M12,15.4V6.1L13.71,10.13L18.09,10.5L14.77,13.39L15.76,17.67M22,9.24L14.81,8.63L12,2L9.19,8.63L2,9.24L7.45,13.97L5.82,21L12,17.27L18.18,21L16.54,13.97L22,9.24Z',
  loading: 'M19,8L15,12H18C18,15.31 15.31,18 12,18C11,18 10.03,17.75 9.2,17.3L7.74,18.76C8.97,19.54 10.43,20 12,20C16.42,20 20,16.42 20,12H23M6,12C6,8.69 8.69,6 12,6C13,6 13.97,6.25 14.8,6.7L16.26,5.24C15.03,4.46 13.57,4 12,4C7.58,4 4,7.58 4,12H1L5,16L9,12',
  first: 'M18.41,16.59L13.82,12L18.41,7.41L17,6L11,12L17,18L18.41,16.59M6,6H8V18H6V6Z',
  last: 'M5.59,7.41L10.18,12L5.59,16.59L7,18L13,12L7,6L5.59,7.41M16,6H18V18H16V6Z',
  unfold: 'M12,18.17L8.83,15L7.42,16.41L12,21L16.59,16.41L15.17,15M12,5.83L15.17,9L16.58,7.59L12,3L7.41,7.59L8.83,9L12,5.83Z',
  file: 'M16.5,6V17.5C16.5,19.71 14.71,21.5 12.5,21.5C10.29,21.5 8.5,19.71 8.5,17.5V5C8.5,3.62 9.62,2.5 11,2.5C12.38,2.5 13.5,3.62 13.5,5V15.5C13.5,16.05 13.05,16.5 12.5,16.5C11.95,16.5 11.5,16.05 11.5,15.5V6H10V15.5C10,16.88 11.12,18 12.5,18C13.88,18 15,16.88 15,15.5V5C15,2.79 13.21,1 11,1C8.79,1 7,2.79 7,5V17.5C7,20.54 9.46,23 12.5,23C15.54,23 18,20.54 18,17.5V6H16.5Z',
  plus: 'M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z',
  minus: 'M19,13H5V11H19V13Z'
};
/* harmony default export */ var mdi_svg = (icons);
// CONCATENATED MODULE: ./node_modules/vuetify/lib/services/icons/presets/md.js
var md_icons = {
  complete: 'check',
  cancel: 'cancel',
  close: 'close',
  delete: 'cancel',
  clear: 'clear',
  success: 'check_circle',
  info: 'info',
  warning: 'priority_high',
  error: 'warning',
  prev: 'chevron_left',
  next: 'chevron_right',
  checkboxOn: 'check_box',
  checkboxOff: 'check_box_outline_blank',
  checkboxIndeterminate: 'indeterminate_check_box',
  delimiter: 'fiber_manual_record',
  sort: 'arrow_upward',
  expand: 'keyboard_arrow_down',
  menu: 'menu',
  subgroup: 'arrow_drop_down',
  dropdown: 'arrow_drop_down',
  radioOn: 'radio_button_checked',
  radioOff: 'radio_button_unchecked',
  edit: 'edit',
  ratingEmpty: 'star_border',
  ratingFull: 'star',
  ratingHalf: 'star_half',
  loading: 'cached',
  first: 'first_page',
  last: 'last_page',
  unfold: 'unfold_more',
  file: 'attach_file',
  plus: 'add',
  minus: 'remove'
};
/* harmony default export */ var md = (md_icons);
// CONCATENATED MODULE: ./node_modules/vuetify/lib/services/icons/presets/mdi.js
var mdi_icons = {
  complete: 'mdi-check',
  cancel: 'mdi-close-circle',
  close: 'mdi-close',
  delete: 'mdi-close-circle',
  clear: 'mdi-close',
  success: 'mdi-check-circle',
  info: 'mdi-information',
  warning: 'mdi-exclamation',
  error: 'mdi-alert',
  prev: 'mdi-chevron-left',
  next: 'mdi-chevron-right',
  checkboxOn: 'mdi-checkbox-marked',
  checkboxOff: 'mdi-checkbox-blank-outline',
  checkboxIndeterminate: 'mdi-minus-box',
  delimiter: 'mdi-circle',
  sort: 'mdi-arrow-up',
  expand: 'mdi-chevron-down',
  menu: 'mdi-menu',
  subgroup: 'mdi-menu-down',
  dropdown: 'mdi-menu-down',
  radioOn: 'mdi-radiobox-marked',
  radioOff: 'mdi-radiobox-blank',
  edit: 'mdi-pencil',
  ratingEmpty: 'mdi-star-outline',
  ratingFull: 'mdi-star',
  ratingHalf: 'mdi-star-half-full',
  loading: 'mdi-cached',
  first: 'mdi-page-first',
  last: 'mdi-page-last',
  unfold: 'mdi-unfold-more-horizontal',
  file: 'mdi-paperclip',
  plus: 'mdi-plus',
  minus: 'mdi-minus'
};
/* harmony default export */ var mdi = (mdi_icons);
// CONCATENATED MODULE: ./node_modules/vuetify/lib/services/icons/presets/fa.js
var fa_icons = {
  complete: 'fas fa-check',
  cancel: 'fas fa-times-circle',
  close: 'fas fa-times',
  delete: 'fas fa-times-circle',
  clear: 'fas fa-times-circle',
  success: 'fas fa-check-circle',
  info: 'fas fa-info-circle',
  warning: 'fas fa-exclamation',
  error: 'fas fa-exclamation-triangle',
  prev: 'fas fa-chevron-left',
  next: 'fas fa-chevron-right',
  checkboxOn: 'fas fa-check-square',
  checkboxOff: 'far fa-square',
  checkboxIndeterminate: 'fas fa-minus-square',
  delimiter: 'fas fa-circle',
  sort: 'fas fa-sort-up',
  expand: 'fas fa-chevron-down',
  menu: 'fas fa-bars',
  subgroup: 'fas fa-caret-down',
  dropdown: 'fas fa-caret-down',
  radioOn: 'far fa-dot-circle',
  radioOff: 'far fa-circle',
  edit: 'fas fa-edit',
  ratingEmpty: 'far fa-star',
  ratingFull: 'fas fa-star',
  ratingHalf: 'fas fa-star-half',
  loading: 'fas fa-sync',
  first: 'fas fa-step-backward',
  last: 'fas fa-step-forward',
  unfold: 'fas fa-arrows-alt-v',
  file: 'fas fa-paperclip',
  plus: 'fas fa-plus',
  minus: 'fas fa-minus'
};
/* harmony default export */ var fa = (fa_icons);
// CONCATENATED MODULE: ./node_modules/vuetify/lib/services/icons/presets/fa4.js
var fa4_icons = {
  complete: 'fa fa-check',
  cancel: 'fa fa-times-circle',
  close: 'fa fa-times',
  delete: 'fa fa-times-circle',
  clear: 'fa fa-times-circle',
  success: 'fa fa-check-circle',
  info: 'fa fa-info-circle',
  warning: 'fa fa-exclamation',
  error: 'fa fa-exclamation-triangle',
  prev: 'fa fa-chevron-left',
  next: 'fa fa-chevron-right',
  checkboxOn: 'fa fa-check-square',
  checkboxOff: 'fa fa-square-o',
  checkboxIndeterminate: 'fa fa-minus-square',
  delimiter: 'fa fa-circle',
  sort: 'fa fa-sort-up',
  expand: 'fa fa-chevron-down',
  menu: 'fa fa-bars',
  subgroup: 'fa fa-caret-down',
  dropdown: 'fa fa-caret-down',
  radioOn: 'fa fa-dot-circle-o',
  radioOff: 'fa fa-circle-o',
  edit: 'fa fa-pencil',
  ratingEmpty: 'fa fa-star-o',
  ratingFull: 'fa fa-star',
  ratingHalf: 'fa fa-star-half-o',
  loading: 'fa fa-refresh',
  first: 'fa fa-step-backward',
  last: 'fa fa-step-forward',
  unfold: 'fa fa-angle-double-down',
  file: 'fa fa-paperclip',
  plus: 'fa fa-plus',
  minus: 'fa fa-minus'
};
/* harmony default export */ var fa4 = (fa4_icons);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.split.js
var es_string_split = __webpack_require__("1276");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/services/icons/presets/fa-svg.js



function convertToComponentDeclarations(component, iconSet) {
  var result = {};

  for (var key in iconSet) {
    result[key] = {
      component: component,
      props: {
        icon: iconSet[key].split(' fa-')
      }
    };
  }

  return result;
}
/* harmony default export */ var fa_svg = (convertToComponentDeclarations('font-awesome-icon', fa));
// CONCATENATED MODULE: ./node_modules/vuetify/lib/services/icons/presets/index.js







/* harmony default export */ var presets = (Object.freeze({
  mdiSvg: mdi_svg,
  md: md,
  mdi: mdi,
  fa: fa,
  fa4: fa4,
  faSvg: fa_svg
}));
// CONCATENATED MODULE: ./node_modules/vuetify/lib/services/icons/index.js






// Extensions
 // Utilities

 // Presets


var icons_Icons = /*#__PURE__*/function (_Service) {
  _inherits(Icons, _Service);

  var _super = _createSuper(Icons);

  function Icons(preset) {
    var _this;

    _classCallCheck(this, Icons);

    _this = _super.call(this);
    var _preset$Icons$propert = preset[Icons.property],
        iconfont = _preset$Icons$propert.iconfont,
        values = _preset$Icons$propert.values,
        component = _preset$Icons$propert.component;
    _this.component = component;
    _this.iconfont = iconfont;
    _this.values = Object(helpers["z" /* mergeDeep */])(presets[iconfont], values);
    return _this;
  }

  return Icons;
}(service_Service);
icons_Icons.property = 'icons';
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("a4d3");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__("e01a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.starts-with.js
var es_string_starts_with = __webpack_require__("2ca0");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/services/lang/index.js











// Extensions
 // Utilities



var LANG_PREFIX = '$vuetify.';
var fallback = Symbol('Lang fallback');

function getTranslation(locale, key) {
  var usingDefault = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var defaultLocale = arguments.length > 3 ? arguments[3] : undefined;
  var shortKey = key.replace(LANG_PREFIX, '');
  var translation = Object(helpers["p" /* getObjectValueByPath */])(locale, shortKey, fallback);

  if (translation === fallback) {
    if (usingDefault) {
      consoleError("Translation key \"".concat(shortKey, "\" not found in fallback"));
      translation = key;
    } else {
      consoleWarn("Translation key \"".concat(shortKey, "\" not found, falling back to default"));
      translation = getTranslation(defaultLocale, key, true, defaultLocale);
    }
  }

  return translation;
}

var lang_Lang = /*#__PURE__*/function (_Service) {
  _inherits(Lang, _Service);

  var _super = _createSuper(Lang);

  function Lang(preset) {
    var _this;

    _classCallCheck(this, Lang);

    _this = _super.call(this);
    _this.defaultLocale = 'en';
    var _preset$Lang$property = preset[Lang.property],
        current = _preset$Lang$property.current,
        locales = _preset$Lang$property.locales,
        t = _preset$Lang$property.t;
    _this.current = current;
    _this.locales = locales;
    _this.translator = t || _this.defaultTranslator;
    return _this;
  }

  _createClass(Lang, [{
    key: "currentLocale",
    value: function currentLocale(key) {
      var translation = this.locales[this.current];
      var defaultLocale = this.locales[this.defaultLocale];
      return getTranslation(translation, key, false, defaultLocale);
    }
  }, {
    key: "t",
    value: function t(key) {
      for (var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        params[_key - 1] = arguments[_key];
      }

      if (!key.startsWith(LANG_PREFIX)) return this.replace(key, params);
      return this.translator.apply(this, [key].concat(params));
    }
  }, {
    key: "defaultTranslator",
    value: function defaultTranslator(key) {
      for (var _len2 = arguments.length, params = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        params[_key2 - 1] = arguments[_key2];
      }

      return this.replace(this.currentLocale(key), params);
    }
  }, {
    key: "replace",
    value: function replace(str, params) {
      return str.replace(/\{(\d+)\}/g, function (match, index) {
        /* istanbul ignore next */
        return String(params[+index]);
      });
    }
  }]);

  return Lang;
}(service_Service);
lang_Lang.property = 'lang';
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__("7db0");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.assign.js
var es_object_assign = __webpack_require__("cca6");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("b64b");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.anchor.js
var es_string_anchor = __webpack_require__("18a5");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__("3835");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/util/colorUtils.js
var colorUtils = __webpack_require__("7bc6");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/util/color/transformSRGB.js
var transformSRGB = __webpack_require__("8da5");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.math.cbrt.js
var es_math_cbrt = __webpack_require__("3ea3");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/util/color/transformCIELAB.js

var delta = 0.20689655172413793; // 6÷29

var cielabForwardTransform = function cielabForwardTransform(t) {
  return t > Math.pow(delta, 3) ? Math.cbrt(t) : t / (3 * Math.pow(delta, 2)) + 4 / 29;
};

var cielabReverseTransform = function cielabReverseTransform(t) {
  return t > delta ? Math.pow(t, 3) : 3 * Math.pow(delta, 2) * (t - 4 / 29);
};

function fromXYZ(xyz) {
  var transform = cielabForwardTransform;
  var transformedY = transform(xyz[1]);
  return [116 * transformedY - 16, 500 * (transform(xyz[0] / 0.95047) - transformedY), 200 * (transformedY - transform(xyz[2] / 1.08883))];
}
function toXYZ(lab) {
  var transform = cielabReverseTransform;
  var Ln = (lab[0] + 16) / 116;
  return [transform(Ln + lab[1] / 500) * 0.95047, transform(Ln), transform(Ln - lab[2] / 200) * 1.08883];
}
// CONCATENATED MODULE: ./node_modules/vuetify/lib/services/theme/utils.js













function parse(theme) {
  var isItem = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var variations = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  var anchor = theme.anchor,
      variant = Object(objectWithoutProperties["a" /* default */])(theme, ["anchor"]);

  var colors = Object.keys(variant);
  var parsedTheme = {};

  for (var i = 0; i < colors.length; ++i) {
    var name = colors[i];
    var value = theme[name];
    if (value == null) continue;

    if (!variations) {
      parsedTheme[name] = {
        base: Object(colorUtils["m" /* intToHex */])(Object(colorUtils["k" /* colorToInt */])(value))
      };
    } else if (isItem) {
      /* istanbul ignore else */
      if (name === 'base' || name.startsWith('lighten') || name.startsWith('darken')) {
        parsedTheme[name] = Object(colorUtils["j" /* colorToHex */])(value);
      }
    } else if (Object(esm_typeof["a" /* default */])(value) === 'object') {
      parsedTheme[name] = parse(value, true, variations);
    } else {
      parsedTheme[name] = genVariations(name, Object(colorUtils["k" /* colorToInt */])(value));
    }
  }

  if (!isItem) {
    parsedTheme.anchor = anchor || parsedTheme.base || parsedTheme.primary.base;
  }

  return parsedTheme;
}
/**
 * Generate the CSS for a base color (.primary)
 */

var genBaseColor = function genBaseColor(name, value) {
  return "\n.v-application .".concat(name, " {\n  background-color: ").concat(value, " !important;\n  border-color: ").concat(value, " !important;\n}\n.v-application .").concat(name, "--text {\n  color: ").concat(value, " !important;\n  caret-color: ").concat(value, " !important;\n}");
};
/**
 * Generate the CSS for a variant color (.primary.darken-2)
 */


var utils_genVariantColor = function genVariantColor(name, variant, value) {
  var _variant$split = variant.split(/(\d)/, 2),
      _variant$split2 = Object(slicedToArray["a" /* default */])(_variant$split, 2),
      type = _variant$split2[0],
      n = _variant$split2[1];

  return "\n.v-application .".concat(name, ".").concat(type, "-").concat(n, " {\n  background-color: ").concat(value, " !important;\n  border-color: ").concat(value, " !important;\n}\n.v-application .").concat(name, "--text.text--").concat(type, "-").concat(n, " {\n  color: ").concat(value, " !important;\n  caret-color: ").concat(value, " !important;\n}");
};

var genColorVariableName = function genColorVariableName(name) {
  var variant = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'base';
  return "--v-".concat(name, "-").concat(variant);
};

var genColorVariable = function genColorVariable(name) {
  var variant = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'base';
  return "var(".concat(genColorVariableName(name, variant), ")");
};

function genStyles(theme) {
  var cssVar = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var anchor = theme.anchor,
      variant = Object(objectWithoutProperties["a" /* default */])(theme, ["anchor"]);

  var colors = Object.keys(variant);
  if (!colors.length) return '';
  var variablesCss = '';
  var css = '';
  var aColor = cssVar ? genColorVariable('anchor') : anchor;
  css += ".v-application a { color: ".concat(aColor, "; }");
  cssVar && (variablesCss += "  ".concat(genColorVariableName('anchor'), ": ").concat(anchor, ";\n"));

  for (var i = 0; i < colors.length; ++i) {
    var name = colors[i];
    var value = theme[name];
    css += genBaseColor(name, cssVar ? genColorVariable(name) : value.base);
    cssVar && (variablesCss += "  ".concat(genColorVariableName(name), ": ").concat(value.base, ";\n"));
    var variants = Object(helpers["y" /* keys */])(value);

    for (var _i = 0; _i < variants.length; ++_i) {
      var _variant = variants[_i];
      var variantValue = value[_variant];
      if (_variant === 'base') continue;
      css += utils_genVariantColor(name, _variant, cssVar ? genColorVariable(name, _variant) : variantValue);
      cssVar && (variablesCss += "  ".concat(genColorVariableName(name, _variant), ": ").concat(variantValue, ";\n"));
    }
  }

  if (cssVar) {
    variablesCss = ":root {\n".concat(variablesCss, "}\n\n");
  }

  return variablesCss + css;
}
function genVariations(name, value) {
  var values = {
    base: Object(colorUtils["m" /* intToHex */])(value)
  };

  for (var i = 5; i > 0; --i) {
    values["lighten".concat(i)] = Object(colorUtils["m" /* intToHex */])(lighten(value, i));
  }

  for (var _i2 = 1; _i2 <= 4; ++_i2) {
    values["darken".concat(_i2)] = Object(colorUtils["m" /* intToHex */])(darken(value, _i2));
  }

  return values;
}
function lighten(value, amount) {
  var lab = fromXYZ(transformSRGB["b" /* toXYZ */](value));
  lab[0] = lab[0] + amount * 10;
  return transformSRGB["a" /* fromXYZ */](toXYZ(lab));
}
function darken(value, amount) {
  var lab = fromXYZ(transformSRGB["b" /* toXYZ */](value));
  lab[0] = lab[0] - amount * 10;
  return transformSRGB["a" /* fromXYZ */](toXYZ(lab));
}
// CONCATENATED MODULE: ./node_modules/vuetify/lib/services/theme/index.js









/* eslint-disable no-multi-spaces */
// Extensions
 // Utilities


 // Types


var theme_Theme = /*#__PURE__*/function (_Service) {
  _inherits(Theme, _Service);

  var _super = _createSuper(Theme);

  function Theme(preset) {
    var _this;

    _classCallCheck(this, Theme);

    _this = _super.call(this);
    _this.disabled = false;
    _this.isDark = null;
    _this.unwatch = null;
    _this.vueMeta = null;
    var _preset$Theme$propert = preset[Theme.property],
        dark = _preset$Theme$propert.dark,
        disable = _preset$Theme$propert.disable,
        options = _preset$Theme$propert.options,
        themes = _preset$Theme$propert.themes;
    _this.dark = Boolean(dark);
    _this.defaults = _this.themes = themes;
    _this.options = options;

    if (disable) {
      _this.disabled = true;
      return _possibleConstructorReturn(_this);
    }

    _this.themes = {
      dark: _this.fillVariant(themes.dark, true),
      light: _this.fillVariant(themes.light, false)
    };
    return _this;
  } // When setting css, check for element and apply new values

  /* eslint-disable-next-line accessor-pairs */


  _createClass(Theme, [{
    key: "css",
    set: function set(val) {
      if (this.vueMeta) {
        if (this.isVueMeta23) {
          this.applyVueMeta23();
        }

        return;
      }

      this.checkOrCreateStyleElement() && (this.styleEl.innerHTML = val);
    }
  }, {
    key: "dark",
    get: function get() {
      return Boolean(this.isDark);
    } // Apply current theme default
    // only called on client side
    ,
    set: function set(val) {
      var oldDark = this.isDark;
      this.isDark = val; // Only apply theme after dark
      // has already been set before

      oldDark != null && this.applyTheme();
    }
  }, {
    key: "applyTheme",
    value: function applyTheme() {
      if (this.disabled) return this.clearCss();
      this.css = this.generatedStyles;
    }
  }, {
    key: "clearCss",
    value: function clearCss() {
      this.css = '';
    } // Initialize theme for SSR and SPA
    // Attach to ssrContext head or
    // apply new theme to document

  }, {
    key: "init",
    value: function init(root, ssrContext) {
      if (this.disabled) return;
      /* istanbul ignore else */

      if (root.$meta) {
        this.initVueMeta(root);
      } else if (ssrContext) {
        this.initSSR(ssrContext);
      }

      this.initTheme(root);
    } // Allows for you to set target theme

  }, {
    key: "setTheme",
    value: function setTheme(theme, value) {
      this.themes[theme] = Object.assign(this.themes[theme], value);
      this.applyTheme();
    } // Reset theme defaults

  }, {
    key: "resetThemes",
    value: function resetThemes() {
      this.themes.light = Object.assign({}, this.defaults.light);
      this.themes.dark = Object.assign({}, this.defaults.dark);
      this.applyTheme();
    } // Check for existence of style element

  }, {
    key: "checkOrCreateStyleElement",
    value: function checkOrCreateStyleElement() {
      this.styleEl = document.getElementById('vuetify-theme-stylesheet');
      /* istanbul ignore next */

      if (this.styleEl) return true;
      this.genStyleElement(); // If doesn't have it, create it

      return Boolean(this.styleEl);
    }
  }, {
    key: "fillVariant",
    value: function fillVariant() {
      var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var dark = arguments.length > 1 ? arguments[1] : undefined;
      var defaultTheme = this.themes[dark ? 'dark' : 'light'];
      return Object.assign({}, defaultTheme, theme);
    } // Generate the style element
    // if applicable

  }, {
    key: "genStyleElement",
    value: function genStyleElement() {
      /* istanbul ignore if */
      if (typeof document === 'undefined') return;
      /* istanbul ignore next */

      this.styleEl = document.createElement('style');
      this.styleEl.type = 'text/css';
      this.styleEl.id = 'vuetify-theme-stylesheet';

      if (this.options.cspNonce) {
        this.styleEl.setAttribute('nonce', this.options.cspNonce);
      }

      document.head.appendChild(this.styleEl);
    }
  }, {
    key: "initVueMeta",
    value: function initVueMeta(root) {
      var _this2 = this;

      this.vueMeta = root.$meta();

      if (this.isVueMeta23) {
        // vue-meta needs to apply after mounted()
        root.$nextTick(function () {
          _this2.applyVueMeta23();
        });
        return;
      }

      var metaKeyName = typeof this.vueMeta.getOptions === 'function' ? this.vueMeta.getOptions().keyName : 'metaInfo';
      var metaInfo = root.$options[metaKeyName] || {};

      root.$options[metaKeyName] = function () {
        metaInfo.style = metaInfo.style || [];
        var vuetifyStylesheet = metaInfo.style.find(function (s) {
          return s.id === 'vuetify-theme-stylesheet';
        });

        if (!vuetifyStylesheet) {
          metaInfo.style.push({
            cssText: _this2.generatedStyles,
            type: 'text/css',
            id: 'vuetify-theme-stylesheet',
            nonce: (_this2.options || {}).cspNonce
          });
        } else {
          vuetifyStylesheet.cssText = _this2.generatedStyles;
        }

        return metaInfo;
      };
    }
  }, {
    key: "applyVueMeta23",
    value: function applyVueMeta23() {
      var _this$vueMeta$addApp = this.vueMeta.addApp('vuetify'),
          set = _this$vueMeta$addApp.set;

      set({
        style: [{
          cssText: this.generatedStyles,
          type: 'text/css',
          id: 'vuetify-theme-stylesheet',
          nonce: this.options.cspNonce
        }]
      });
    }
  }, {
    key: "initSSR",
    value: function initSSR(ssrContext) {
      // SSR
      var nonce = this.options.cspNonce ? " nonce=\"".concat(this.options.cspNonce, "\"") : '';
      ssrContext.head = ssrContext.head || '';
      ssrContext.head += "<style type=\"text/css\" id=\"vuetify-theme-stylesheet\"".concat(nonce, ">").concat(this.generatedStyles, "</style>");
    }
  }, {
    key: "initTheme",
    value: function initTheme(root) {
      var _this3 = this;

      // Only watch for reactivity on client side
      if (typeof document === 'undefined') return; // If we get here somehow, ensure
      // existing instance is removed

      if (this.unwatch) {
        this.unwatch();
        this.unwatch = null;
      } // TODO: Update to use RFC if merged
      // https://github.com/vuejs/rfcs/blob/advanced-reactivity-api/active-rfcs/0000-advanced-reactivity-api.md


      root.$once('hook:created', function () {
        var obs = external_commonjs_vue_commonjs2_vue_root_Vue_default.a.observable({
          themes: _this3.themes
        });
        _this3.unwatch = root.$watch(function () {
          return obs.themes;
        }, function () {
          return _this3.applyTheme();
        }, {
          deep: true
        });
      });
      this.applyTheme();
    }
  }, {
    key: "currentTheme",
    get: function get() {
      var target = this.dark ? 'dark' : 'light';
      return this.themes[target];
    }
  }, {
    key: "generatedStyles",
    get: function get() {
      var theme = this.parsedTheme;
      /* istanbul ignore next */

      var options = this.options || {};
      var css;

      if (options.themeCache != null) {
        css = options.themeCache.get(theme);
        /* istanbul ignore if */

        if (css != null) return css;
      }

      css = genStyles(theme, options.customProperties);

      if (options.minifyTheme != null) {
        css = options.minifyTheme(css);
      }

      if (options.themeCache != null) {
        options.themeCache.set(theme, css);
      }

      return css;
    }
  }, {
    key: "parsedTheme",
    get: function get() {
      return parse(this.currentTheme || {}, undefined, Object(helpers["o" /* getNestedValue */])(this.options, ['variations'], true));
    } // Is using v2.3 of vue-meta
    // https://github.com/nuxt/vue-meta/releases/tag/v2.3.0

  }, {
    key: "isVueMeta23",
    get: function get() {
      return typeof this.vueMeta.addApp === 'function';
    }
  }]);

  return Theme;
}(service_Service);
theme_Theme.property = 'theme';
// CONCATENATED MODULE: ./node_modules/vuetify/lib/framework.js






 // Services



var framework_Vuetify = /*#__PURE__*/function () {
  function Vuetify() {
    var userPreset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Vuetify);

    this.framework = {
      isHydrating: false
    };
    this.installed = [];
    this.preset = {};
    this.userPreset = {};
    this.userPreset = userPreset;
    this.use(presets_Presets);
    this.use(application_Application);
    this.use(breakpoint_Breakpoint);
    this.use(goto_Goto);
    this.use(icons_Icons);
    this.use(lang_Lang);
    this.use(theme_Theme);
  } // Called on the new vuetify instance
  // bootstrap in install beforeCreate
  // Exposes ssrContext if available


  _createClass(Vuetify, [{
    key: "init",
    value: function init(root, ssrContext) {
      var _this = this;

      this.installed.forEach(function (property) {
        var service = _this.framework[property];
        service.framework = _this.framework;
        service.init(root, ssrContext);
      }); // rtl is not installed and
      // will never be called by
      // the init process

      this.framework.rtl = Boolean(this.preset.rtl);
    } // Instantiate a VuetifyService

  }, {
    key: "use",
    value: function use(Service) {
      var property = Service.property;
      if (this.installed.includes(property)) return; // TODO maybe a specific type for arg 2?

      this.framework[property] = new Service(this.preset, this);
      this.installed.push(property);
    }
  }]);

  return Vuetify;
}();


framework_Vuetify.install = install;
framework_Vuetify.installed = false;
framework_Vuetify.version = "2.4.4";
framework_Vuetify.config = {
  silent: false
};
// CONCATENATED MODULE: ./node_modules/vuetify/lib/util/console.js












function createMessage(message, vm, parent) {
  if (framework_Vuetify.config.silent) return;

  if (parent) {
    vm = {
      _isVue: true,
      $parent: parent,
      $options: vm
    };
  }

  if (vm) {
    // Only show each message once per instance
    vm.$_alreadyWarned = vm.$_alreadyWarned || [];
    if (vm.$_alreadyWarned.includes(message)) return;
    vm.$_alreadyWarned.push(message);
  }

  return "[Vuetify] ".concat(message) + (vm ? generateComponentTrace(vm) : '');
}

function consoleInfo(message, vm, parent) {
  var newMessage = createMessage(message, vm, parent);
  newMessage != null && console.info(newMessage);
}
function consoleWarn(message, vm, parent) {
  var newMessage = createMessage(message, vm, parent);
  newMessage != null && console.warn(newMessage);
}
function consoleError(message, vm, parent) {
  var newMessage = createMessage(message, vm, parent);
  newMessage != null && console.error(newMessage);
}
function deprecate(original, replacement, vm, parent) {
  consoleWarn("[UPGRADE] '".concat(original, "' is deprecated, use '").concat(replacement, "' instead."), vm, parent);
}
function breaking(original, replacement, vm, parent) {
  consoleError("[BREAKING] '".concat(original, "' has been removed, use '").concat(replacement, "' instead. For more information, see the upgrade guide https://github.com/vuetifyjs/vuetify/releases/tag/v2.0.0#user-content-upgrade-guide"), vm, parent);
}
function removed(original, vm, parent) {
  consoleWarn("[REMOVED] '".concat(original, "' has been removed. You can safely omit it."), vm, parent);
}
/**
 * Shamelessly stolen from vuejs/vue/blob/dev/src/core/util/debug.js
 */

var classifyRE = /(?:^|[-_])(\w)/g;

var classify = function classify(str) {
  return str.replace(classifyRE, function (c) {
    return c.toUpperCase();
  }).replace(/[-_]/g, '');
};

function formatComponentName(vm, includeFile) {
  if (vm.$root === vm) {
    return '<Root>';
  }

  var options = typeof vm === 'function' && vm.cid != null ? vm.options : vm._isVue ? vm.$options || vm.constructor.options : vm || {};
  var name = options.name || options._componentTag;
  var file = options.__file;

  if (!name && file) {
    var match = file.match(/([^/\\]+)\.vue$/);
    name = match && match[1];
  }

  return (name ? "<".concat(classify(name), ">") : "<Anonymous>") + (file && includeFile !== false ? " at ".concat(file) : '');
}

function generateComponentTrace(vm) {
  if (vm._isVue && vm.$parent) {
    var tree = [];
    var currentRecursiveSequence = 0;

    while (vm) {
      if (tree.length > 0) {
        var last = tree[tree.length - 1];

        if (last.constructor === vm.constructor) {
          currentRecursiveSequence++;
          vm = vm.$parent;
          continue;
        } else if (currentRecursiveSequence > 0) {
          tree[tree.length - 1] = [last, currentRecursiveSequence];
          currentRecursiveSequence = 0;
        }
      }

      tree.push(vm);
      vm = vm.$parent;
    }

    return '\n\nfound in\n\n' + tree.map(function (vm, i) {
      return "".concat(i === 0 ? '---> ' : ' '.repeat(5 + i * 2)).concat(Array.isArray(vm) ? "".concat(formatComponentName(vm[0]), "... (").concat(vm[1], " recursive calls)") : formatComponentName(vm));
    }).join('\n');
  } else {
    return "\n\n(found in ".concat(formatComponentName(vm), ")");
  }
}

/***/ }),

/***/ "d9f0":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.i, "@import url(https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css);"]);
exports.push([module.i, "@import url(https://cdn-prd.patientpop.com/pp-icon-font/v1.6.0/pp-icon-font.css);"]);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.pp-input-image-upload--dragging .pp-input-image-upload__action-icon--add[data-v-7bed88e3],.pp-input-image-upload:focus-within .pp-input-image-upload__action-icon--add[data-v-7bed88e3],.pp-input-image-upload:focus-within .pp-input-image-upload__label[data-v-7bed88e3],.pp-input-image-upload:hover .pp-input-image-upload__action-icon--add[data-v-7bed88e3],.pp-input-image-upload:hover .pp-input-image-upload__label[data-v-7bed88e3],.pp-input-image-upload__wrapper[data-v-7bed88e3],.pp-input-image-upload__wrapper[data-v-7bed88e3]:hover{transition:all .2s linear}.pp-input-image-upload__container[data-v-7bed88e3]{height:120px}.pp-input-image-upload__wrapper[data-v-7bed88e3]{background-color:var(--img-upload-bg,#f6f6f6);height:100%;position:relative}.pp-input-image-upload__wrapper[data-v-7bed88e3]:hover{background-color:var(--img-upload-bg,#d6d6d6)}.pp-input-image-upload .pp-icon-add-img[data-v-7bed88e3]{color:#545454}.pp-input-image-upload--dragging .pp-input-image-upload__action-icon--add[data-v-7bed88e3],.pp-input-image-upload:focus-within .pp-input-image-upload__action-icon--add[data-v-7bed88e3],.pp-input-image-upload:hover .pp-input-image-upload__action-icon--add[data-v-7bed88e3]{color:var(--add-btn-color,#2b2b2b)}.pp-input-image-upload__action-icon--alert[data-v-7bed88e3]{color:#d83b4d}.pp-input-image-upload--error[data-v-7bed88e3]{--img-upload-bg:#fceeee;--img-upload-border:#d83b4d}.pp-input-image-upload--error[data-v-7bed88e3]:hover{--img-upload-border:#d83b4d}.pp-input-image-upload--error[data-v-7bed88e3]:focus-within{--img-upload-border:#d83b4d}.pp-input-image-upload--image-error[data-v-7bed88e3]{--img-upload-bg:#fceeee}.pp-input-image-upload__label[data-v-7bed88e3]{color:#545454;cursor:pointer;font-size:.875rem;height:100%;position:relative;width:100%}.pp-input-image-upload:focus-within .pp-input-image-upload__label[data-v-7bed88e3],.pp-input-image-upload:hover .pp-input-image-upload__label[data-v-7bed88e3]{color:var(--add-btn-color,#2b2b2b)}.pp-input-image-upload__input[data-v-7bed88e3]{cursor:pointer;height:100%;opacity:0;position:absolute;width:100%}.pp-input-image-upload__image[data-v-7bed88e3]{background-position:50% 50%;background-repeat:no-repeat;background-size:cover;height:100%;-o-object-fit:cover;object-fit:cover;position:absolute;width:100%}.pp-input-image-upload__delete-overlay[data-v-7bed88e3]{align-items:center;background-color:rgba(43,43,43,.5);display:flex;flex-direction:column;height:100%;justify-content:center;position:absolute;width:100%}.pp-input-image-upload--thumbnail[data-v-7bed88e3]{border:none}.pp-input-image-upload__delete-button[data-v-7bed88e3]{border:none;color:#fff}.pp-input-image-upload__specs[data-v-7bed88e3]{color:#2b2b2b;font-size:.857rem;line-height:15px}.pp-input-image-upload__description[data-v-7bed88e3]{color:#2b2b2b;font-size:.875rem}.pp-input-image-upload__helper-text[data-v-7bed88e3]{color:#545454;font-size:.75rem;margin-top:-1em}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "d9f7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mergeData; });
/* unused harmony export mergeStyles */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return mergeClasses; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return mergeListeners; });
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("99af");
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("b64b");
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ac1f");
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_string_split_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("1276");
/* harmony import */ var core_js_modules_es_string_split_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_string_trim_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("498a");
/* harmony import */ var core_js_modules_es_string_trim_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_trim_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("5530");
/* harmony import */ var _home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("3835");
/* harmony import */ var _home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_createForOfIteratorHelper__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("b85c");
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("80d2");









var pattern = {
  styleList: /;(?![^(]*\))/g,
  styleProp: /:(.*)/
};

function parseStyle(style) {
  var styleMap = {};

  var _iterator = Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_createForOfIteratorHelper__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(style.split(pattern.styleList)),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var s = _step.value;

      var _s$split = s.split(pattern.styleProp),
          _s$split2 = Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])(_s$split, 2),
          key = _s$split2[0],
          val = _s$split2[1];

      key = key.trim();

      if (!key) {
        continue;
      } // May be undefined if the `key: value` pair is incomplete.


      if (typeof val === 'string') {
        val = val.trim();
      }

      styleMap[Object(_helpers__WEBPACK_IMPORTED_MODULE_8__[/* camelize */ "c"])(key)] = val;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return styleMap;
}

function mergeData() {
  var mergeTarget = {};
  var i = arguments.length;
  var prop; // Allow for variadic argument length.

  while (i--) {
    // Iterate through the data properties and execute merge strategies
    // Object.keys eliminates need for hasOwnProperty call
    for (var _i = 0, _Object$keys = Object.keys(arguments[i]); _i < _Object$keys.length; _i++) {
      prop = _Object$keys[_i];

      switch (prop) {
        // Array merge strategy (array concatenation)
        case 'class':
        case 'directives':
          if (arguments[i][prop]) {
            mergeTarget[prop] = mergeClasses(mergeTarget[prop], arguments[i][prop]);
          }

          break;

        case 'style':
          if (arguments[i][prop]) {
            mergeTarget[prop] = mergeStyles(mergeTarget[prop], arguments[i][prop]);
          }

          break;
        // Space delimited string concatenation strategy

        case 'staticClass':
          if (!arguments[i][prop]) {
            break;
          }

          if (mergeTarget[prop] === undefined) {
            mergeTarget[prop] = '';
          }

          if (mergeTarget[prop]) {
            // Not an empty string, so concatenate
            mergeTarget[prop] += ' ';
          }

          mergeTarget[prop] += arguments[i][prop].trim();
          break;
        // Object, the properties of which to merge via array merge strategy (array concatenation).
        // Callback merge strategy merges callbacks to the beginning of the array,
        // so that the last defined callback will be invoked first.
        // This is done since to mimic how Object.assign merging
        // uses the last given value to assign.

        case 'on':
        case 'nativeOn':
          if (arguments[i][prop]) {
            mergeTarget[prop] = mergeListeners(mergeTarget[prop], arguments[i][prop]);
          }

          break;
        // Object merge strategy

        case 'attrs':
        case 'props':
        case 'domProps':
        case 'scopedSlots':
        case 'staticStyle':
        case 'hook':
        case 'transition':
          if (!arguments[i][prop]) {
            break;
          }

          if (!mergeTarget[prop]) {
            mergeTarget[prop] = {};
          }

          mergeTarget[prop] = Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])({}, arguments[i][prop]), mergeTarget[prop]);
          break;
        // Reassignment strategy (no merge)

        default:
          // slot, key, ref, tag, show, keepAlive
          if (!mergeTarget[prop]) {
            mergeTarget[prop] = arguments[i][prop];
          }

      }
    }
  }

  return mergeTarget;
}
function mergeStyles(target, source) {
  if (!target) return source;
  if (!source) return target;
  target = Object(_helpers__WEBPACK_IMPORTED_MODULE_8__[/* wrapInArray */ "H"])(typeof target === 'string' ? parseStyle(target) : target);
  return target.concat(typeof source === 'string' ? parseStyle(source) : source);
}
function mergeClasses(target, source) {
  if (!source) return target;
  if (!target) return source;
  return target ? Object(_helpers__WEBPACK_IMPORTED_MODULE_8__[/* wrapInArray */ "H"])(target).concat(source) : source;
}
function mergeListeners() {
  if (!(arguments.length <= 0 ? undefined : arguments[0])) return arguments.length <= 1 ? undefined : arguments[1];
  if (!(arguments.length <= 1 ? undefined : arguments[1])) return arguments.length <= 0 ? undefined : arguments[0];
  var dest = {};

  for (var i = 2; i--;) {
    var arg = i < 0 || arguments.length <= i ? undefined : arguments[i];

    for (var event in arg) {
      if (!arg[event]) continue;

      if (dest[event]) {
        // Merge current listeners before (because we are iterating backwards).
        // Note that neither "target" or "source" must be altered.
        dest[event] = [].concat(arg[event], dest[event]);
      } else {
        // Straight assign.
        dest[event] = arg[event];
      }
    }
  }

  return dest;
}

/***/ }),

/***/ "da13":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("5530");
/* harmony import */ var _src_components_VList_VListItem_sass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("61d2");
/* harmony import */ var _src_components_VList_VListItem_sass__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_src_components_VList_VListItem_sass__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _mixins_colorable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("a9ad");
/* harmony import */ var _mixins_routable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("1c87");
/* harmony import */ var _mixins_groupable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("4e82");
/* harmony import */ var _mixins_themeable__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("7560");
/* harmony import */ var _mixins_toggleable__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("f2e7");
/* harmony import */ var _directives_ripple__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("5607");
/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("80d2");
/* harmony import */ var _util_console__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("d9bd");
/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("58df");

// Styles
 // Mixins





 // Directives

 // Utilities


 // Types


var baseMixins = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_10__[/* default */ "a"])(_mixins_colorable__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"], _mixins_routable__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"], _mixins_themeable__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"], Object(_mixins_groupable__WEBPACK_IMPORTED_MODULE_4__[/* factory */ "a"])('listItemGroup'), Object(_mixins_toggleable__WEBPACK_IMPORTED_MODULE_6__[/* factory */ "b"])('inputValue'));
/* @vue/component */

/* harmony default export */ __webpack_exports__["a"] = (baseMixins.extend().extend({
  name: 'v-list-item',
  directives: {
    Ripple: _directives_ripple__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"]
  },
  inject: {
    isInGroup: {
      default: false
    },
    isInList: {
      default: false
    },
    isInMenu: {
      default: false
    },
    isInNav: {
      default: false
    }
  },
  inheritAttrs: false,
  props: {
    activeClass: {
      type: String,
      default: function _default() {
        if (!this.listItemGroup) return '';
        return this.listItemGroup.activeClass;
      }
    },
    dense: Boolean,
    inactive: Boolean,
    link: Boolean,
    selectable: {
      type: Boolean
    },
    tag: {
      type: String,
      default: 'div'
    },
    threeLine: Boolean,
    twoLine: Boolean,
    value: null
  },
  data: function data() {
    return {
      proxyClass: 'v-list-item--active'
    };
  },
  computed: {
    classes: function classes() {
      return Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({
        'v-list-item': true
      }, _mixins_routable__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].options.computed.classes.call(this)), {}, {
        'v-list-item--dense': this.dense,
        'v-list-item--disabled': this.disabled,
        'v-list-item--link': this.isClickable && !this.inactive,
        'v-list-item--selectable': this.selectable,
        'v-list-item--three-line': this.threeLine,
        'v-list-item--two-line': this.twoLine
      }, this.themeClasses);
    },
    isClickable: function isClickable() {
      return Boolean(_mixins_routable__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].options.computed.isClickable.call(this) || this.listItemGroup);
    }
  },
  created: function created() {
    /* istanbul ignore next */
    if (this.$attrs.hasOwnProperty('avatar')) {
      Object(_util_console__WEBPACK_IMPORTED_MODULE_9__[/* removed */ "e"])('avatar', this);
    }
  },
  methods: {
    click: function click(e) {
      if (e.detail) this.$el.blur();
      this.$emit('click', e);
      this.to || this.toggle();
    },
    genAttrs: function genAttrs() {
      var attrs = Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({
        'aria-disabled': this.disabled ? true : undefined,
        tabindex: this.isClickable && !this.disabled ? 0 : -1
      }, this.$attrs);

      if (this.$attrs.hasOwnProperty('role')) {// do nothing, role already provided
      } else if (this.isInNav) {// do nothing, role is inherit
      } else if (this.isInGroup) {
        attrs.role = 'listitem';
        attrs['aria-selected'] = String(this.isActive);
      } else if (this.isInMenu) {
        attrs.role = this.isClickable ? 'menuitem' : undefined;
        attrs.id = attrs.id || "list-item-".concat(this._uid);
      } else if (this.isInList) {
        attrs.role = 'listitem';
      }

      return attrs;
    }
  },
  render: function render(h) {
    var _this = this;

    var _this$generateRouteLi = this.generateRouteLink(),
        tag = _this$generateRouteLi.tag,
        data = _this$generateRouteLi.data;

    data.attrs = Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({}, data.attrs), this.genAttrs());
    data[this.to ? 'nativeOn' : 'on'] = Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({}, data[this.to ? 'nativeOn' : 'on']), {}, {
      keydown: function keydown(e) {
        /* istanbul ignore else */
        if (e.keyCode === _util_helpers__WEBPACK_IMPORTED_MODULE_8__[/* keyCodes */ "x"].enter) _this.click(e);

        _this.$emit('keydown', e);
      }
    });
    if (this.inactive) tag = 'div';

    if (this.inactive && this.to) {
      data.on = data.nativeOn;
      delete data.nativeOn;
    }

    var children = this.$scopedSlots.default ? this.$scopedSlots.default({
      active: this.isActive,
      toggle: this.toggle
    }) : this.$slots.default;
    return h(tag, this.setTextColor(this.color, data), children);
  }
}));

/***/ }),

/***/ "da7a":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.i, "@import url(https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css);"]);
exports.push([module.i, "@import url(https://cdn-prd.patientpop.com/pp-icon-font/v1.6.0/pp-icon-font.css);"]);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}header[data-v-7db3db16]{background:#fff;height:58px;position:sticky;top:0;z-index:5}@media(max-width:960px){header[data-v-7db3db16]{height:auto}}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "da84":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports =
  // eslint-disable-next-line no-undef
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  check(typeof self == 'object' && self) ||
  check(typeof global == 'object' && global) ||
  // eslint-disable-next-line no-new-func
  (function () { return this; })() || Function('return this')();

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba")))

/***/ }),

/***/ "db42":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("3eac");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("6b638751", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "dbb4":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var DESCRIPTORS = __webpack_require__("83ab");
var ownKeys = __webpack_require__("56ef");
var toIndexedObject = __webpack_require__("fc6a");
var getOwnPropertyDescriptorModule = __webpack_require__("06cf");
var createProperty = __webpack_require__("8418");

// `Object.getOwnPropertyDescriptors` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
$({ target: 'Object', stat: true, sham: !DESCRIPTORS }, {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIndexedObject(object);
    var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
    var keys = ownKeys(O);
    var result = {};
    var index = 0;
    var key, descriptor;
    while (keys.length > index) {
      descriptor = getOwnPropertyDescriptor(O, key = keys[index++]);
      if (descriptor !== undefined) createProperty(result, key, descriptor);
    }
    return result;
  }
});


/***/ }),

/***/ "dc22":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Resize */
function inserted(el, binding) {
  var callback = binding.value;
  var options = binding.options || {
    passive: true
  };
  window.addEventListener('resize', callback, options);
  el._onResize = {
    callback: callback,
    options: options
  };

  if (!binding.modifiers || !binding.modifiers.quiet) {
    callback();
  }
}

function unbind(el) {
  if (!el._onResize) return;
  var _el$_onResize = el._onResize,
      callback = _el$_onResize.callback,
      options = _el$_onResize.options;
  window.removeEventListener('resize', callback, options);
  delete el._onResize;
}

var Resize = {
  inserted: inserted,
  unbind: unbind
};
/* harmony default export */ __webpack_exports__["a"] = (Resize);

/***/ }),

/***/ "dc56":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpPaymentForm_vue_vue_type_style_index_0_id_7636e91e_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("25ba");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpPaymentForm_vue_vue_type_style_index_0_id_7636e91e_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpPaymentForm_vue_vue_type_style_index_0_id_7636e91e_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "dca8":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var FREEZING = __webpack_require__("bb2f");
var fails = __webpack_require__("d039");
var isObject = __webpack_require__("861d");
var onFreeze = __webpack_require__("f183").onFreeze;

var nativeFreeze = Object.freeze;
var FAILS_ON_PRIMITIVES = fails(function () { nativeFreeze(1); });

// `Object.freeze` method
// https://tc39.es/ecma262/#sec-object.freeze
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES, sham: !FREEZING }, {
  freeze: function freeze(it) {
    return nativeFreeze && isObject(it) ? nativeFreeze(onFreeze(it)) : it;
  }
});


/***/ }),

/***/ "dd48":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.i, "@import url(https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css);"]);
exports.push([module.i, "@import url(https://cdn-prd.patientpop.com/pp-icon-font/v1.6.0/pp-icon-font.css);"]);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.v-application .primary{background-color:var(--pp-theme-color-bg,var(--pp-theme-color,#ff8d6e))!important;border-color:var(--pp-theme-color-bg,var(--pp-theme-color,#ff8d6e))!important}.v-application .primary--text{caret-color:var(--pp-theme-color,#004852)!important;color:var(--pp-theme-color,#004852)!important}.v-application .primary--text--with-hover:hover{caret-color:var(--pp-theme-color-hover,#ffaf95)!important;color:var(--pp-theme-color-hover,#ffaf95)!important}.v-application .success{background-color:#f0faf2!important;border-color:#f0faf2!important}.v-application .success--text{caret-color:#3fa266!important;color:#3fa266!important}.v-application .success--text--with-hover:hover{caret-color:#1d6b45!important;color:#1d6b45!important}.v-application .warning{background-color:#fef5d5!important;border-color:#fef5d5!important}.v-application .warning--text{caret-color:#fcde73!important;color:#fcde73!important}.v-application .warning--text--with-hover:hover{caret-color:#f2ba2a!important;color:#f2ba2a!important}.v-application .alert{background-color:#ffe9e3!important;border-color:#ffe9e3!important}.v-application .alert--text,.v-application .alert--text--with-hover:hover{caret-color:#ff8d6e!important;color:#ff8d6e!important}.v-application .error{background-color:#fceeee!important;border-color:#fceeee!important}.v-application .error--text,.v-application .error--text--with-hover:hover{caret-color:#b51a2c!important;color:#b51a2c!important}.v-application .info{background-color:#e7d8ff!important;border-color:#e7d8ff!important}.v-application .info--text,.v-application .info--text--with-hover:hover{caret-color:#8657ac!important;color:#8657ac!important}.v-application .pending{background-color:#e6f5f7!important;border-color:#e6f5f7!important}.v-application .pending--text{caret-color:#079cb2!important;color:#079cb2!important}.v-application .pending--text--with-hover:hover{caret-color:#067889!important;color:#067889!important}.v-application .inactive{background-color:#f6f6f6!important;border-color:#f6f6f6!important}.v-application .inactive--text,.v-application .inactive--text--with-hover:hover{caret-color:#545454!important;color:#545454!important}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "ddb0":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var DOMIterables = __webpack_require__("fdbc");
var ArrayIteratorMethods = __webpack_require__("e260");
var createNonEnumerableProperty = __webpack_require__("9112");
var wellKnownSymbol = __webpack_require__("b622");

var ITERATOR = wellKnownSymbol('iterator');
var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var ArrayValues = ArrayIteratorMethods.values;

for (var COLLECTION_NAME in DOMIterables) {
  var Collection = global[COLLECTION_NAME];
  var CollectionPrototype = Collection && Collection.prototype;
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR] !== ArrayValues) try {
      createNonEnumerableProperty(CollectionPrototype, ITERATOR, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR] = ArrayValues;
    }
    if (!CollectionPrototype[TO_STRING_TAG]) {
      createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG, COLLECTION_NAME);
    }
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
}


/***/ }),

/***/ "dddf":
/***/ (function(module, exports, __webpack_require__) {

var isLeapYear = __webpack_require__("acc4")

/**
 * @category Year Helpers
 * @summary Get the number of days in a year of the given date.
 *
 * @description
 * Get the number of days in a year of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the number of days in a year
 *
 * @example
 * // How many days are in 2012?
 * var result = getDaysInYear(new Date(2012, 0, 1))
 * //=> 366
 */
function getDaysInYear (dirtyDate) {
  return isLeapYear(dirtyDate) ? 366 : 365
}

module.exports = getDaysInYear


/***/ }),

/***/ "de13":
/***/ (function(module, exports, __webpack_require__) {

var getISOYear = __webpack_require__("8964")
var startOfISOWeek = __webpack_require__("b4c7")

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the last day of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the last day of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of an ISO week-numbering year
 *
 * @example
 * // The last day of an ISO week-numbering year for 2 July 2005:
 * var result = lastDayOfISOYear(new Date(2005, 6, 2))
 * //=> Sun Jan 01 2006 00:00:00
 */
function lastDayOfISOYear (dirtyDate) {
  var year = getISOYear(dirtyDate)
  var fourthOfJanuary = new Date(0)
  fourthOfJanuary.setFullYear(year + 1, 0, 4)
  fourthOfJanuary.setHours(0, 0, 0, 0)
  var date = startOfISOWeek(fourthOfJanuary)
  date.setDate(date.getDate() - 1)
  return date
}

module.exports = lastDayOfISOYear


/***/ }),

/***/ "de2c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return intersectable; });
/* harmony import */ var _directives_intersect__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("90a2");
/* harmony import */ var _util_console__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("d9bd");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("8bbf");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_2__);
// Directives
 // Utilities

 // Types


function intersectable(options) {
  if (typeof window === 'undefined' || !('IntersectionObserver' in window)) {
    // do nothing because intersection observer is not available
    return vue__WEBPACK_IMPORTED_MODULE_2___default.a.extend({
      name: 'intersectable'
    });
  }

  return vue__WEBPACK_IMPORTED_MODULE_2___default.a.extend({
    name: 'intersectable',
    mounted: function mounted() {
      _directives_intersect__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].inserted(this.$el, {
        name: 'intersect',
        value: this.onObserve
      });
    },
    destroyed: function destroyed() {
      _directives_intersect__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].unbind(this.$el);
    },
    methods: {
      onObserve: function onObserve(entries, observer, isIntersecting) {
        if (!isIntersecting) return;

        for (var i = 0, length = options.onVisible.length; i < length; i++) {
          var callback = this[options.onVisible[i]];

          if (typeof callback === 'function') {
            callback();
            continue;
          }

          Object(_util_console__WEBPACK_IMPORTED_MODULE_1__[/* consoleWarn */ "c"])(options.onVisible[i] + ' method is not available on the instance but referenced in intersectable mixin options');
        }
      }
    }
  });
}

/***/ }),

/***/ "deba":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c662cfac-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/input/switch/PpInputSwitch.vue?vue&type=template&id=25e1e7cd&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-switch',{staticClass:"mt-0 pp-input-switch",class:[
    _vm.small ? 'pp-input-switch--small' : ''
  ],attrs:{"disabled":_vm.disabled,"label":_vm.value ? _vm.trueLabel : _vm.falseLabel,"ripple":false,"hide-details":"auto","inset":""},model:{value:(_vm.isOn),callback:function ($$v) {_vm.isOn=$$v},expression:"isOn"}})}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/input/switch/PpInputSwitch.vue?vue&type=template&id=25e1e7cd&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/input/switch/PpInputSwitch.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var PpInputSwitchvue_type_script_lang_js_ = ({
  name: 'PpInputSwitch',
  props: {
    value: {
      type: Boolean,
      required: true
    },
    trueLabel: {
      type: String,
      default: null
    },
    falseLabel: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isOn: {
      get: function get() {
        return this.value;
      },
      set: function set(newValue) {
        this.handleChange(newValue);
      }
    }
  },
  methods: {
    handleChange: function handleChange(event) {
      this.$emit('change', !!event);
      this.$emit('input', !!event);
    }
  }
});
// CONCATENATED MODULE: ./src/components/input/switch/PpInputSwitch.vue?vue&type=script&lang=js&
 /* harmony default export */ var switch_PpInputSwitchvue_type_script_lang_js_ = (PpInputSwitchvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/input/switch/PpInputSwitch.vue?vue&type=style&index=0&id=25e1e7cd&lang=scss&scoped=true&
var PpInputSwitchvue_type_style_index_0_id_25e1e7cd_lang_scss_scoped_true_ = __webpack_require__("c91f");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// EXTERNAL MODULE: ./node_modules/vuetify-loader/lib/runtime/installComponents.js
var installComponents = __webpack_require__("6544");
var installComponents_default = /*#__PURE__*/__webpack_require__.n(installComponents);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.flat.js
var es_array_flat = __webpack_require__("0481");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.unscopables.flat.js
var es_array_unscopables_flat = __webpack_require__("4069");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__("5530");

// EXTERNAL MODULE: ./node_modules/vuetify/src/styles/components/_selection-controls.sass
var _selection_controls = __webpack_require__("ec29");

// EXTERNAL MODULE: ./node_modules/vuetify/src/components/VSwitch/VSwitch.sass
var VSwitch = __webpack_require__("9d01");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/mixins/selectable/index.js
var selectable = __webpack_require__("fe09");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/components/VInput/index.js + 3 modules
var VInput = __webpack_require__("c37a");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/directives/touch/index.js
var touch = __webpack_require__("c3f0");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/components/transitions/index.js + 2 modules
var transitions = __webpack_require__("0789");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/components/VProgressCircular/VProgressCircular.js
var VProgressCircular = __webpack_require__("490a");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/util/helpers.js
var helpers = __webpack_require__("80d2");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VSwitch/VSwitch.js



// Styles

 // Mixins


 // Directives

 // Components


 // Helpers


/* @vue/component */

/* harmony default export */ var VSwitch_VSwitch = (selectable["a" /* default */].extend({
  name: 'v-switch',
  directives: {
    Touch: touch["a" /* default */]
  },
  props: {
    inset: Boolean,
    loading: {
      type: [Boolean, String],
      default: false
    },
    flat: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classes: function classes() {
      return Object(objectSpread2["a" /* default */])(Object(objectSpread2["a" /* default */])({}, VInput["a" /* default */].options.computed.classes.call(this)), {}, {
        'v-input--selection-controls v-input--switch': true,
        'v-input--switch--flat': this.flat,
        'v-input--switch--inset': this.inset
      });
    },
    attrs: function attrs() {
      return {
        'aria-checked': String(this.isActive),
        'aria-disabled': String(this.isDisabled),
        role: 'switch'
      };
    },
    // Do not return undefined if disabled,
    // according to spec, should still show
    // a color when disabled and active
    validationState: function validationState() {
      if (this.hasError && this.shouldValidate) return 'error';
      if (this.hasSuccess) return 'success';
      if (this.hasColor !== null) return this.computedColor;
      return undefined;
    },
    switchData: function switchData() {
      return this.setTextColor(this.loading ? undefined : this.validationState, {
        class: this.themeClasses
      });
    }
  },
  methods: {
    genDefaultSlot: function genDefaultSlot() {
      return [this.genSwitch(), this.genLabel()];
    },
    genSwitch: function genSwitch() {
      return this.$createElement('div', {
        staticClass: 'v-input--selection-controls__input'
      }, [this.genInput('checkbox', Object(objectSpread2["a" /* default */])(Object(objectSpread2["a" /* default */])({}, this.attrs), this.attrs$)), this.genRipple(this.setTextColor(this.validationState, {
        directives: [{
          name: 'touch',
          value: {
            left: this.onSwipeLeft,
            right: this.onSwipeRight
          }
        }]
      })), this.$createElement('div', Object(objectSpread2["a" /* default */])({
        staticClass: 'v-input--switch__track'
      }, this.switchData)), this.$createElement('div', Object(objectSpread2["a" /* default */])({
        staticClass: 'v-input--switch__thumb'
      }, this.switchData), [this.genProgress()])]);
    },
    genProgress: function genProgress() {
      return this.$createElement(transitions["c" /* VFabTransition */], {}, [this.loading === false ? null : this.$slots.progress || this.$createElement(VProgressCircular["a" /* default */], {
        props: {
          color: this.loading === true || this.loading === '' ? this.color || 'primary' : this.loading,
          size: 16,
          width: 2,
          indeterminate: true
        }
      })]);
    },
    onSwipeLeft: function onSwipeLeft() {
      if (this.isActive) this.onChange();
    },
    onSwipeRight: function onSwipeRight() {
      if (!this.isActive) this.onChange();
    },
    onKeydown: function onKeydown(e) {
      if (e.keyCode === helpers["x" /* keyCodes */].left && this.isActive || e.keyCode === helpers["x" /* keyCodes */].right && !this.isActive) this.onChange();
    }
  }
}));
// CONCATENATED MODULE: ./src/components/input/switch/PpInputSwitch.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  switch_PpInputSwitchvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "25e1e7cd",
  null
  
)

/* harmony default export */ var PpInputSwitch = __webpack_exports__["default"] = (component.exports);

/* vuetify-loader */


installComponents_default()(component, {VSwitch: VSwitch_VSwitch})


/***/ }),

/***/ "debc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpMap_vue_vue_type_style_index_0_id_fee8366c_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("b4a1");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpMap_vue_vue_type_style_index_0_id_fee8366c_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpMap_vue_vue_type_style_index_0_id_fee8366c_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "df35":
/***/ (function(module, exports, __webpack_require__) {

var addISOYears = __webpack_require__("27a1")

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Subtract the specified number of ISO week-numbering years from the given date.
 *
 * @description
 * Subtract the specified number of ISO week-numbering years from the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of ISO week-numbering years to be subtracted
 * @returns {Date} the new date with the ISO week-numbering years subtracted
 *
 * @example
 * // Subtract 5 ISO week-numbering years from 1 September 2014:
 * var result = subISOYears(new Date(2014, 8, 1), 5)
 * //=> Mon Aug 31 2009 00:00:00
 */
function subISOYears (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addISOYears(dirtyDate, -amount)
}

module.exports = subISOYears


/***/ }),

/***/ "df75":
/***/ (function(module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__("ca84");
var enumBugKeys = __webpack_require__("7839");

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
module.exports = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys);
};


/***/ }),

/***/ "e01a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// `Symbol.prototype.description` getter
// https://tc39.es/ecma262/#sec-symbol.prototype.description

var $ = __webpack_require__("23e7");
var DESCRIPTORS = __webpack_require__("83ab");
var global = __webpack_require__("da84");
var has = __webpack_require__("5135");
var isObject = __webpack_require__("861d");
var defineProperty = __webpack_require__("9bf2").f;
var copyConstructorProperties = __webpack_require__("e893");

var NativeSymbol = global.Symbol;

if (DESCRIPTORS && typeof NativeSymbol == 'function' && (!('description' in NativeSymbol.prototype) ||
  // Safari 12 bug
  NativeSymbol().description !== undefined
)) {
  var EmptyStringDescriptionStore = {};
  // wrap Symbol constructor for correct work with undefined description
  var SymbolWrapper = function Symbol() {
    var description = arguments.length < 1 || arguments[0] === undefined ? undefined : String(arguments[0]);
    var result = this instanceof SymbolWrapper
      ? new NativeSymbol(description)
      // in Edge 13, String(Symbol(undefined)) === 'Symbol(undefined)'
      : description === undefined ? NativeSymbol() : NativeSymbol(description);
    if (description === '') EmptyStringDescriptionStore[result] = true;
    return result;
  };
  copyConstructorProperties(SymbolWrapper, NativeSymbol);
  var symbolPrototype = SymbolWrapper.prototype = NativeSymbol.prototype;
  symbolPrototype.constructor = SymbolWrapper;

  var symbolToString = symbolPrototype.toString;
  var native = String(NativeSymbol('test')) == 'Symbol(test)';
  var regexp = /^Symbol\((.*)\)[^)]+$/;
  defineProperty(symbolPrototype, 'description', {
    configurable: true,
    get: function description() {
      var symbol = isObject(this) ? this.valueOf() : this;
      var string = symbolToString.call(symbol);
      if (has(EmptyStringDescriptionStore, symbol)) return '';
      var desc = native ? string.slice(7, -1) : string.replace(regexp, '$1');
      return desc === '' ? undefined : desc;
    }
  });

  $({ global: true, forced: true }, {
    Symbol: SymbolWrapper
  });
}


/***/ }),

/***/ "e076":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.i, "@import url(https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css);"]);
exports.push([module.i, "@import url(https://cdn-prd.patientpop.com/pp-icon-font/v1.6.0/pp-icon-font.css);"]);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.snack-bar[data-v-171d6108]{bottom:2px;left:0;min-height:3.5em;position:fixed;text-align:center;width:100%;z-index:200}.snack-bar__close[data-v-171d6108]{bottom:0;right:3em;top:calc(1.75em - 16px)}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "e13a":
/***/ (function(module, exports, __webpack_require__) {

var differenceInMilliseconds = __webpack_require__("e785")

/**
 * @category Second Helpers
 * @summary Get the number of seconds between the given dates.
 *
 * @description
 * Get the number of seconds between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of seconds
 *
 * @example
 * // How many seconds are between
 * // 2 July 2014 12:30:07.999 and 2 July 2014 12:30:20.000?
 * var result = differenceInSeconds(
 *   new Date(2014, 6, 2, 12, 30, 20, 0),
 *   new Date(2014, 6, 2, 12, 30, 7, 999)
 * )
 * //=> 12
 */
function differenceInSeconds (dirtyDateLeft, dirtyDateRight) {
  var diff = differenceInMilliseconds(dirtyDateLeft, dirtyDateRight) / 1000
  return diff > 0 ? Math.floor(diff) : Math.ceil(diff)
}

module.exports = differenceInSeconds


/***/ }),

/***/ "e163":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("5135");
var toObject = __webpack_require__("7b0b");
var sharedKey = __webpack_require__("f772");
var CORRECT_PROTOTYPE_GETTER = __webpack_require__("e177");

var IE_PROTO = sharedKey('IE_PROTO');
var ObjectPrototype = Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
module.exports = CORRECT_PROTOTYPE_GETTER ? Object.getPrototypeOf : function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectPrototype : null;
};


/***/ }),

/***/ "e177":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");

module.exports = !fails(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  return Object.getPrototypeOf(new F()) !== F.prototype;
});


/***/ }),

/***/ "e1c8":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.i, "@import url(https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css);"]);
exports.push([module.i, "@import url(https://cdn-prd.patientpop.com/pp-icon-font/v1.6.0/pp-icon-font.css);"]);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.pp-image[data-v-29196306]{position:relative;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content}.pp-image__img[data-v-29196306]{box-shadow:0 .1em .1em #545454;max-width:100%}.pp-image__overlay[data-v-29196306]{background:hsla(0,0%,100%,.9);border-top:1px solid #d6d6d6;bottom:0;position:absolute;transition:opacity .2s;width:100%}@media(min-width:960px){.pp-image__overlay[data-v-29196306]{opacity:0}.pp-image:hover .pp-image__overlay[data-v-29196306]{opacity:1}}@media print{.pp-image__overlay[data-v-29196306]{display:none!important}}.image-zoom-area[data-v-29196306]{overflow:hidden}.image-zoom-area__img[data-v-29196306]{max-height:calc(90vh - 4em);max-width:100%;transform:scale(var(--zoom-level,1),var(--zoom-level,1));transition:transform .2s}.image-zoom-slider[data-v-29196306]{max-width:25em}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "e1ca":
/***/ (function(module, exports, __webpack_require__) {

var addWeeks = __webpack_require__("7a83")

/**
 * @category Week Helpers
 * @summary Subtract the specified number of weeks from the given date.
 *
 * @description
 * Subtract the specified number of weeks from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of weeks to be subtracted
 * @returns {Date} the new date with the weeks subtracted
 *
 * @example
 * // Subtract 4 weeks from 1 September 2014:
 * var result = subWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Aug 04 2014 00:00:00
 */
function subWeeks (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addWeeks(dirtyDate, -amount)
}

module.exports = subWeeks


/***/ }),

/***/ "e260":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toIndexedObject = __webpack_require__("fc6a");
var addToUnscopables = __webpack_require__("44d2");
var Iterators = __webpack_require__("3f8c");
var InternalStateModule = __webpack_require__("69f3");
var defineIterator = __webpack_require__("7dd0");

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
module.exports = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return { value: undefined, done: true };
  }
  if (kind == 'keys') return { value: index, done: false };
  if (kind == 'values') return { value: target[index], done: false };
  return { value: [index, target[index]], done: false };
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
Iterators.Arguments = Iterators.Array;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),

/***/ "e2cc":
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__("6eeb");

module.exports = function (target, src, options) {
  for (var key in src) redefine(target, key, src[key], options);
  return target;
};


/***/ }),

/***/ "e2ff":
/***/ (function(module, exports, __webpack_require__) {

var addDays = __webpack_require__("8946")

/**
 * @category Day Helpers
 * @summary Subtract the specified number of days from the given date.
 *
 * @description
 * Subtract the specified number of days from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be subtracted
 * @returns {Date} the new date with the days subtracted
 *
 * @example
 * // Subtract 10 days from 1 September 2014:
 * var result = subDays(new Date(2014, 8, 1), 10)
 * //=> Fri Aug 22 2014 00:00:00
 */
function subDays (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addDays(dirtyDate, -amount)
}

module.exports = subDays


/***/ }),

/***/ "e334":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpAudioPlayer_vue_vue_type_style_index_0_id_060f210a_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("b1f3");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpAudioPlayer_vue_vue_type_style_index_0_id_060f210a_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpAudioPlayer_vue_vue_type_style_index_0_id_060f210a_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "e439":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var fails = __webpack_require__("d039");
var toIndexedObject = __webpack_require__("fc6a");
var nativeGetOwnPropertyDescriptor = __webpack_require__("06cf").f;
var DESCRIPTORS = __webpack_require__("83ab");

var FAILS_ON_PRIMITIVES = fails(function () { nativeGetOwnPropertyDescriptor(1); });
var FORCED = !DESCRIPTORS || FAILS_ON_PRIMITIVES;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
$({ target: 'Object', stat: true, forced: FORCED, sham: !DESCRIPTORS }, {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(it, key) {
    return nativeGetOwnPropertyDescriptor(toIndexedObject(it), key);
  }
});


/***/ }),

/***/ "e449":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("99af");
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("7db0");
/* harmony import */ var core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("a630");
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("caad");
/* harmony import */ var core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_index_of_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("c975");
/* harmony import */ var core_js_modules_es_array_index_of_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("a9e3");
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("2532");
/* harmony import */ var core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("3ca3");
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_string_trim_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("498a");
/* harmony import */ var core_js_modules_es_string_trim_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_trim_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("ade3");
/* harmony import */ var _home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("2909");
/* harmony import */ var _home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("5530");
/* harmony import */ var _src_components_VMenu_VMenu_sass__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("ee6f");
/* harmony import */ var _src_components_VMenu_VMenu_sass__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_src_components_VMenu_VMenu_sass__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _VThemeProvider__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("480e");
/* harmony import */ var _mixins_activatable__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("4ad4");
/* harmony import */ var _mixins_delayable__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("16b7");
/* harmony import */ var _mixins_dependent__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("b848");
/* harmony import */ var _mixins_detachable__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("75eb");
/* harmony import */ var _mixins_menuable__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("f573");
/* harmony import */ var _mixins_returnable__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("e4d3");
/* harmony import */ var _mixins_roundable__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("a236");
/* harmony import */ var _mixins_toggleable__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__("f2e7");
/* harmony import */ var _mixins_themeable__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__("7560");
/* harmony import */ var _directives_click_outside__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__("a293");
/* harmony import */ var _directives_resize__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__("dc22");
/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__("58df");
/* harmony import */ var _util_console__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__("d9bd");
/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__("80d2");












// Styles
 // Components

 // Mixins









 // Directives


 // Utilities




var baseMixins = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_25__[/* default */ "a"])(_mixins_dependent__WEBPACK_IMPORTED_MODULE_16__[/* default */ "a"], _mixins_delayable__WEBPACK_IMPORTED_MODULE_15__[/* default */ "a"], _mixins_detachable__WEBPACK_IMPORTED_MODULE_17__[/* default */ "a"], _mixins_menuable__WEBPACK_IMPORTED_MODULE_18__[/* default */ "a"], _mixins_returnable__WEBPACK_IMPORTED_MODULE_19__[/* default */ "a"], _mixins_roundable__WEBPACK_IMPORTED_MODULE_20__[/* default */ "a"], _mixins_toggleable__WEBPACK_IMPORTED_MODULE_21__[/* default */ "a"], _mixins_themeable__WEBPACK_IMPORTED_MODULE_22__[/* default */ "a"]);
/* @vue/component */

/* harmony default export */ __webpack_exports__["a"] = (baseMixins.extend({
  name: 'v-menu',
  directives: {
    ClickOutside: _directives_click_outside__WEBPACK_IMPORTED_MODULE_23__[/* default */ "a"],
    Resize: _directives_resize__WEBPACK_IMPORTED_MODULE_24__[/* default */ "a"]
  },
  provide: function provide() {
    return {
      isInMenu: true,
      // Pass theme through to default slot
      theme: this.theme
    };
  },
  props: {
    auto: Boolean,
    closeOnClick: {
      type: Boolean,
      default: true
    },
    closeOnContentClick: {
      type: Boolean,
      default: true
    },
    disabled: Boolean,
    disableKeys: Boolean,
    maxHeight: {
      type: [Number, String],
      default: 'auto'
    },
    offsetX: Boolean,
    offsetY: Boolean,
    openOnClick: {
      type: Boolean,
      default: true
    },
    openOnHover: Boolean,
    origin: {
      type: String,
      default: 'top left'
    },
    transition: {
      type: [Boolean, String],
      default: 'v-menu-transition'
    }
  },
  data: function data() {
    return {
      calculatedTopAuto: 0,
      defaultOffset: 8,
      hasJustFocused: false,
      listIndex: -1,
      resizeTimeout: 0,
      selectedIndex: null,
      tiles: []
    };
  },
  computed: {
    activeTile: function activeTile() {
      return this.tiles[this.listIndex];
    },
    calculatedLeft: function calculatedLeft() {
      var menuWidth = Math.max(this.dimensions.content.width, parseFloat(this.calculatedMinWidth));
      if (!this.auto) return this.calcLeft(menuWidth) || '0';
      return Object(_util_helpers__WEBPACK_IMPORTED_MODULE_27__[/* convertToUnit */ "g"])(this.calcXOverflow(this.calcLeftAuto(), menuWidth)) || '0';
    },
    calculatedMaxHeight: function calculatedMaxHeight() {
      var height = this.auto ? '200px' : Object(_util_helpers__WEBPACK_IMPORTED_MODULE_27__[/* convertToUnit */ "g"])(this.maxHeight);
      return height || '0';
    },
    calculatedMaxWidth: function calculatedMaxWidth() {
      return Object(_util_helpers__WEBPACK_IMPORTED_MODULE_27__[/* convertToUnit */ "g"])(this.maxWidth) || '0';
    },
    calculatedMinWidth: function calculatedMinWidth() {
      if (this.minWidth) {
        return Object(_util_helpers__WEBPACK_IMPORTED_MODULE_27__[/* convertToUnit */ "g"])(this.minWidth) || '0';
      }

      var minWidth = Math.min(this.dimensions.activator.width + Number(this.nudgeWidth) + (this.auto ? 16 : 0), Math.max(this.pageWidth - 24, 0));
      var calculatedMaxWidth = isNaN(parseInt(this.calculatedMaxWidth)) ? minWidth : parseInt(this.calculatedMaxWidth);
      return Object(_util_helpers__WEBPACK_IMPORTED_MODULE_27__[/* convertToUnit */ "g"])(Math.min(calculatedMaxWidth, minWidth)) || '0';
    },
    calculatedTop: function calculatedTop() {
      var top = !this.auto ? this.calcTop() : Object(_util_helpers__WEBPACK_IMPORTED_MODULE_27__[/* convertToUnit */ "g"])(this.calcYOverflow(this.calculatedTopAuto));
      return top || '0';
    },
    hasClickableTiles: function hasClickableTiles() {
      return Boolean(this.tiles.find(function (tile) {
        return tile.tabIndex > -1;
      }));
    },
    styles: function styles() {
      return {
        maxHeight: this.calculatedMaxHeight,
        minWidth: this.calculatedMinWidth,
        maxWidth: this.calculatedMaxWidth,
        top: this.calculatedTop,
        left: this.calculatedLeft,
        transformOrigin: this.origin,
        zIndex: this.zIndex || this.activeZIndex
      };
    }
  },
  watch: {
    isActive: function isActive(val) {
      if (!val) this.listIndex = -1;
    },
    isContentActive: function isContentActive(val) {
      this.hasJustFocused = val;
    },
    listIndex: function listIndex(next, prev) {
      if (next in this.tiles) {
        var tile = this.tiles[next];
        tile.classList.add('v-list-item--highlighted');
        this.$refs.content.scrollTop = tile.offsetTop - tile.clientHeight;
      }

      prev in this.tiles && this.tiles[prev].classList.remove('v-list-item--highlighted');
    }
  },
  created: function created() {
    /* istanbul ignore next */
    if (this.$attrs.hasOwnProperty('full-width')) {
      Object(_util_console__WEBPACK_IMPORTED_MODULE_26__[/* removed */ "e"])('full-width', this);
    }
  },
  mounted: function mounted() {
    this.isActive && this.callActivate();
  },
  methods: {
    activate: function activate() {
      var _this = this;

      // Update coordinates and dimensions of menu
      // and its activator
      this.updateDimensions(); // Start the transition

      requestAnimationFrame(function () {
        // Once transitioning, calculate scroll and top position
        _this.startTransition().then(function () {
          if (_this.$refs.content) {
            _this.calculatedTopAuto = _this.calcTopAuto();
            _this.auto && (_this.$refs.content.scrollTop = _this.calcScrollPosition());
          }
        });
      });
    },
    calcScrollPosition: function calcScrollPosition() {
      var $el = this.$refs.content;
      var activeTile = $el.querySelector('.v-list-item--active');
      var maxScrollTop = $el.scrollHeight - $el.offsetHeight;
      return activeTile ? Math.min(maxScrollTop, Math.max(0, activeTile.offsetTop - $el.offsetHeight / 2 + activeTile.offsetHeight / 2)) : $el.scrollTop;
    },
    calcLeftAuto: function calcLeftAuto() {
      return parseInt(this.dimensions.activator.left - this.defaultOffset * 2);
    },
    calcTopAuto: function calcTopAuto() {
      var $el = this.$refs.content;
      var activeTile = $el.querySelector('.v-list-item--active');

      if (!activeTile) {
        this.selectedIndex = null;
      }

      if (this.offsetY || !activeTile) {
        return this.computedTop;
      }

      this.selectedIndex = Array.from(this.tiles).indexOf(activeTile);
      var tileDistanceFromMenuTop = activeTile.offsetTop - this.calcScrollPosition();
      var firstTileOffsetTop = $el.querySelector('.v-list-item').offsetTop;
      return this.computedTop - tileDistanceFromMenuTop - firstTileOffsetTop - 1;
    },
    changeListIndex: function changeListIndex(e) {
      // For infinite scroll and autocomplete, re-evaluate children
      this.getTiles();

      if (!this.isActive || !this.hasClickableTiles) {
        return;
      } else if (e.keyCode === _util_helpers__WEBPACK_IMPORTED_MODULE_27__[/* keyCodes */ "x"].tab) {
        this.isActive = false;
        return;
      } else if (e.keyCode === _util_helpers__WEBPACK_IMPORTED_MODULE_27__[/* keyCodes */ "x"].down) {
        this.nextTile();
      } else if (e.keyCode === _util_helpers__WEBPACK_IMPORTED_MODULE_27__[/* keyCodes */ "x"].up) {
        this.prevTile();
      } else if (e.keyCode === _util_helpers__WEBPACK_IMPORTED_MODULE_27__[/* keyCodes */ "x"].end) {
        this.lastTile();
      } else if (e.keyCode === _util_helpers__WEBPACK_IMPORTED_MODULE_27__[/* keyCodes */ "x"].home) {
        this.firstTile();
      } else if (e.keyCode === _util_helpers__WEBPACK_IMPORTED_MODULE_27__[/* keyCodes */ "x"].enter && this.listIndex !== -1) {
        this.tiles[this.listIndex].click();
      } else {
        return;
      } // One of the conditions was met, prevent default action (#2988)


      e.preventDefault();
    },
    closeConditional: function closeConditional(e) {
      var target = e.target;
      return this.isActive && !this._isDestroyed && this.closeOnClick && !this.$refs.content.contains(target);
    },
    genActivatorAttributes: function genActivatorAttributes() {
      var attributes = _mixins_activatable__WEBPACK_IMPORTED_MODULE_14__[/* default */ "a"].options.methods.genActivatorAttributes.call(this);

      if (this.activeTile && this.activeTile.id) {
        return Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_11__[/* default */ "a"])(Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_11__[/* default */ "a"])({}, attributes), {}, {
          'aria-activedescendant': this.activeTile.id
        });
      }

      return attributes;
    },
    genActivatorListeners: function genActivatorListeners() {
      var listeners = _mixins_menuable__WEBPACK_IMPORTED_MODULE_18__[/* default */ "a"].options.methods.genActivatorListeners.call(this);

      if (!this.disableKeys) {
        listeners.keydown = this.onKeyDown;
      }

      return listeners;
    },
    genTransition: function genTransition() {
      var content = this.genContent();
      if (!this.transition) return content;
      return this.$createElement('transition', {
        props: {
          name: this.transition
        }
      }, [content]);
    },
    genDirectives: function genDirectives() {
      var _this2 = this;

      var directives = [{
        name: 'show',
        value: this.isContentActive
      }]; // Do not add click outside for hover menu

      if (!this.openOnHover && this.closeOnClick) {
        directives.push({
          name: 'click-outside',
          value: {
            handler: function handler() {
              _this2.isActive = false;
            },
            closeConditional: this.closeConditional,
            include: function include() {
              return [_this2.$el].concat(Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_10__[/* default */ "a"])(_this2.getOpenDependentElements()));
            }
          }
        });
      }

      return directives;
    },
    genContent: function genContent() {
      var _this3 = this;

      var options = {
        attrs: Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_11__[/* default */ "a"])(Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_11__[/* default */ "a"])({}, this.getScopeIdAttrs()), {}, {
          role: 'role' in this.$attrs ? this.$attrs.role : 'menu'
        }),
        staticClass: 'v-menu__content',
        class: Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_11__[/* default */ "a"])(Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_11__[/* default */ "a"])(Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_11__[/* default */ "a"])({}, this.rootThemeClasses), this.roundedClasses), {}, Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])({
          'v-menu__content--auto': this.auto,
          'v-menu__content--fixed': this.activatorFixed,
          menuable__content__active: this.isActive
        }, this.contentClass.trim(), true)),
        style: this.styles,
        directives: this.genDirectives(),
        ref: 'content',
        on: {
          click: function click(e) {
            var target = e.target;
            if (target.getAttribute('disabled')) return;
            if (_this3.closeOnContentClick) _this3.isActive = false;
          },
          keydown: this.onKeyDown
        }
      };

      if (this.$listeners.scroll) {
        options.on = options.on || {};
        options.on.scroll = this.$listeners.scroll;
      }

      if (!this.disabled && this.openOnHover) {
        options.on = options.on || {};
        options.on.mouseenter = this.mouseEnterHandler;
      }

      if (this.openOnHover) {
        options.on = options.on || {};
        options.on.mouseleave = this.mouseLeaveHandler;
      }

      return this.$createElement('div', options, this.getContentSlot());
    },
    getTiles: function getTiles() {
      if (!this.$refs.content) return;
      this.tiles = Array.from(this.$refs.content.querySelectorAll('.v-list-item'));
    },
    mouseEnterHandler: function mouseEnterHandler() {
      var _this4 = this;

      this.runDelay('open', function () {
        if (_this4.hasJustFocused) return;
        _this4.hasJustFocused = true;
      });
    },
    mouseLeaveHandler: function mouseLeaveHandler(e) {
      var _this5 = this;

      // Prevent accidental re-activation
      this.runDelay('close', function () {
        if (_this5.$refs.content.contains(e.relatedTarget)) return;
        requestAnimationFrame(function () {
          _this5.isActive = false;

          _this5.callDeactivate();
        });
      });
    },
    nextTile: function nextTile() {
      var tile = this.tiles[this.listIndex + 1];

      if (!tile) {
        if (!this.tiles.length) return;
        this.listIndex = -1;
        this.nextTile();
        return;
      }

      this.listIndex++;
      if (tile.tabIndex === -1) this.nextTile();
    },
    prevTile: function prevTile() {
      var tile = this.tiles[this.listIndex - 1];

      if (!tile) {
        if (!this.tiles.length) return;
        this.listIndex = this.tiles.length;
        this.prevTile();
        return;
      }

      this.listIndex--;
      if (tile.tabIndex === -1) this.prevTile();
    },
    lastTile: function lastTile() {
      var tile = this.tiles[this.tiles.length - 1];
      if (!tile) return;
      this.listIndex = this.tiles.length - 1;
      if (tile.tabIndex === -1) this.prevTile();
    },
    firstTile: function firstTile() {
      var tile = this.tiles[0];
      if (!tile) return;
      this.listIndex = 0;
      if (tile.tabIndex === -1) this.nextTile();
    },
    onKeyDown: function onKeyDown(e) {
      var _this6 = this;

      if (e.keyCode === _util_helpers__WEBPACK_IMPORTED_MODULE_27__[/* keyCodes */ "x"].esc) {
        // Wait for dependent elements to close first
        setTimeout(function () {
          _this6.isActive = false;
        });
        var activator = this.getActivator();
        this.$nextTick(function () {
          return activator && activator.focus();
        });
      } else if (!this.isActive && [_util_helpers__WEBPACK_IMPORTED_MODULE_27__[/* keyCodes */ "x"].up, _util_helpers__WEBPACK_IMPORTED_MODULE_27__[/* keyCodes */ "x"].down].includes(e.keyCode)) {
        this.isActive = true;
      } // Allow for isActive watcher to generate tile list


      this.$nextTick(function () {
        return _this6.changeListIndex(e);
      });
    },
    onResize: function onResize() {
      if (!this.isActive) return; // Account for screen resize
      // and orientation change
      // eslint-disable-next-line no-unused-expressions

      this.$refs.content.offsetWidth;
      this.updateDimensions(); // When resizing to a smaller width
      // content width is evaluated before
      // the new activator width has been
      // set, causing it to not size properly
      // hacky but will revisit in the future

      clearTimeout(this.resizeTimeout);
      this.resizeTimeout = window.setTimeout(this.updateDimensions, 100);
    }
  },
  render: function render(h) {
    var _this7 = this;

    var data = {
      staticClass: 'v-menu',
      class: {
        'v-menu--attached': this.attach === '' || this.attach === true || this.attach === 'attach'
      },
      directives: [{
        arg: '500',
        name: 'resize',
        value: this.onResize
      }]
    };
    return h('div', data, [!this.activator && this.genActivator(), this.showLazyContent(function () {
      return [_this7.$createElement(_VThemeProvider__WEBPACK_IMPORTED_MODULE_13__[/* default */ "a"], {
        props: {
          root: true,
          light: _this7.light,
          dark: _this7.dark
        }
      }, [_this7.genTransition()])];
    })]);
  }
}));

/***/ }),

/***/ "e462":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.i, "@import url(https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css);"]);
exports.push([module.i, "@import url(https://cdn-prd.patientpop.com/pp-icon-font/v1.6.0/pp-icon-font.css);"]);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.pp-pagination[data-v-435e27ea] .v-pagination{justify-content:left}.pp-pagination[data-v-435e27ea] .v-pagination li{color:#9a9a9a}.pp-pagination[data-v-435e27ea] .v-pagination button{box-shadow:none;color:#9a9a9a;font-size:1rem;margin:.1rem}.pp-pagination[data-v-435e27ea] .v-pagination button .v-icon{color:inherit;font-size:.8rem}.pp-pagination[data-v-435e27ea] .v-pagination button:hover{color:#067889;font-weight:700;-webkit-text-decoration-line:underline;text-decoration-line:underline}.pp-pagination[data-v-435e27ea] .v-pagination__item--active.transparent{background:#000;color:#2b2b2b;font-weight:700}.pp-pagination[data-v-435e27ea] .v-pagination__navigation--disabled{visibility:hidden}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "e4a8":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("7686");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("c321ef54", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "e4cd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("caad");
/* harmony import */ var core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("b0c0");
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("a9e3");
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _util_console__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("d9bd");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("8bbf");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_4__);





/* @vue/component */

/* harmony default export */ __webpack_exports__["a"] = (vue__WEBPACK_IMPORTED_MODULE_4___default.a.extend({
  name: 'mobile',
  props: {
    mobileBreakpoint: {
      type: [Number, String],
      default: function _default() {
        // Avoid destroying unit
        // tests for users
        return this.$vuetify ? this.$vuetify.breakpoint.mobileBreakpoint : undefined;
      },
      validator: function validator(v) {
        return !isNaN(Number(v)) || ['xs', 'sm', 'md', 'lg', 'xl'].includes(String(v));
      }
    }
  },
  computed: {
    isMobile: function isMobile() {
      var _this$$vuetify$breakp = this.$vuetify.breakpoint,
          mobile = _this$$vuetify$breakp.mobile,
          width = _this$$vuetify$breakp.width,
          name = _this$$vuetify$breakp.name,
          mobileBreakpoint = _this$$vuetify$breakp.mobileBreakpoint; // Check if local mobileBreakpoint matches
      // the application's mobileBreakpoint

      if (mobileBreakpoint === this.mobileBreakpoint) return mobile;
      var mobileWidth = parseInt(this.mobileBreakpoint, 10);
      var isNumber = !isNaN(mobileWidth);
      return isNumber ? width < mobileWidth : name === this.mobileBreakpoint;
    }
  },
  created: function created() {
    /* istanbul ignore next */
    if (this.$attrs.hasOwnProperty('mobile-break-point')) {
      Object(_util_console__WEBPACK_IMPORTED_MODULE_3__[/* deprecate */ "d"])('mobile-break-point', 'mobile-breakpoint', this);
    }
  }
}));

/***/ }),

/***/ "e4d3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("8bbf");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);

/* @vue/component */

/* harmony default export */ __webpack_exports__["a"] = (vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend({
  name: 'returnable',
  props: {
    returnValue: null
  },
  data: function data() {
    return {
      isActive: false,
      originalValue: null
    };
  },
  watch: {
    isActive: function isActive(val) {
      if (val) {
        this.originalValue = this.returnValue;
      } else {
        this.$emit('update:return-value', this.originalValue);
      }
    }
  },
  methods: {
    save: function save(value) {
      var _this = this;

      this.originalValue = value;
      setTimeout(function () {
        _this.isActive = false;
      });
    }
  }
}));

/***/ }),

/***/ "e51d":
/***/ (function(module, exports) {

/**
 * @category Day Helpers
 * @summary Return the end of yesterday.
 *
 * @description
 * Return the end of yesterday.
 *
 * @returns {Date} the end of yesterday
 *
 * @example
 * // If today is 6 October 2014:
 * var result = endOfYesterday()
 * //=> Sun Oct 5 2014 23:59:59.999
 */
function endOfYesterday () {
  var now = new Date()
  var year = now.getFullYear()
  var month = now.getMonth()
  var day = now.getDate()

  var date = new Date(0)
  date.setFullYear(year, month, day - 1)
  date.setHours(23, 59, 59, 999)
  return date
}

module.exports = endOfYesterday


/***/ }),

/***/ "e538":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");

exports.f = wellKnownSymbol;


/***/ }),

/***/ "e53c":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("5f54");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("0534bbd6", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "e554":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpInputAvatar_vue_vue_type_style_index_0_id_1cb9db2c_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("b1e0");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpInputAvatar_vue_vue_type_style_index_0_id_1cb9db2c_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpInputAvatar_vue_vue_type_style_index_0_id_1cb9db2c_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "e55c":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M21.1608 18.0894C20.1079 19.6733 18.6622 20.9572 16.965 21.8157C15.2678 22.6742 13.377 23.078 11.4772 22.9876C9.57739 22.8972 7.73346 22.3157 6.12543 21.3C4.51741 20.2842 3.20023 18.8689 2.30248 17.1921C1.40473 15.5153 0.95708 13.6345 1.00324 11.733C1.0494 9.83162 1.58779 7.97467 2.56584 6.34344C3.5439 4.71221 4.92821 3.36245 6.58363 2.42592C8.23905 1.4894 10.109 0.998105 12.011 1.00001L12 12L21.1608 18.0894Z\" fill=\"white\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19Z\" fill=\"#DFE4E5\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M14.293 15.707L11.293 12.707C11.105 12.519 11 12.265 11 12V7H13V11.586L15.707 14.293L14.293 15.707Z\" fill=\"#688083\"></path><path d=\"M21.1462 18.1113C21.453 17.6521 21.3295 17.0311 20.8703 16.7242C20.4111 16.4174 19.7901 16.5409 19.4832 17.0001L21.1462 18.1113ZM4.92894 19.0711L5.63604 18.364L4.92894 19.0711ZM2.76121 8.17317L1.83733 7.79048H1.83733L2.76121 8.17317ZM19.4832 17.0001C18.4943 18.4802 17.0887 19.6337 15.4442 20.3149L16.2095 22.1627C18.2195 21.3301 19.9375 19.9202 21.1462 18.1113L19.4832 17.0001ZM15.4442 20.3149C13.7996 20.9961 11.99 21.1743 10.2442 20.8271L9.85401 22.7886C11.9878 23.2131 14.1995 22.9952 16.2095 22.1627L15.4442 20.3149ZM10.2442 20.8271C8.49836 20.4798 6.89472 19.6226 5.63604 18.364L4.22183 19.7782C5.76021 21.3166 7.72022 22.3642 9.85401 22.7886L10.2442 20.8271ZM5.63604 18.364C4.37737 17.1053 3.5202 15.5016 3.17294 13.7558L1.21137 14.146C1.6358 16.2798 2.68345 18.2398 4.22183 19.7782L5.63604 18.364ZM3.17294 13.7558C2.82567 12.01 3.0039 10.2004 3.68509 8.55585L1.83733 7.79048C1.00477 9.80047 0.786929 12.0122 1.21137 14.146L3.17294 13.7558ZM3.68509 8.55585C4.36628 6.91131 5.51983 5.50571 6.99987 4.51677L5.88873 2.85383C4.07979 4.06253 2.66989 5.7805 1.83733 7.79048L3.68509 8.55585ZM6.99987 4.51677C8.47992 3.52784 10.22 3 12 3V1C9.82441 1 7.69767 1.64514 5.88873 2.85383L6.99987 4.51677Z\" fill=\"#688083\"></path><circle cx=\"12\" cy=\"2\" r=\"1\" fill=\"#688083\"></circle><circle cx=\"17.0254\" cy=\"3.35254\" r=\"1\" fill=\"#688083\"></circle><circle cx=\"22\" cy=\"12\" r=\"1\" fill=\"#688083\"></circle><circle cx=\"20.6035\" cy=\"6.87402\" r=\"1\" fill=\"#688083\"></circle></svg>";

/***/ }),

/***/ "e5ea":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpInputDateRange_vue_vue_type_style_index_0_id_5da7e4ca_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("e67a");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpInputDateRange_vue_vue_type_style_index_0_id_5da7e4ca_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpInputDateRange_vue_vue_type_style_index_0_id_5da7e4ca_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "e60d":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.i, "@import url(https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css);"]);
exports.push([module.i, "@import url(https://cdn-prd.patientpop.com/pp-icon-font/v1.6.0/pp-icon-font.css);"]);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.idle-time[data-v-7f0189c6]{font-size:5.714em;line-height:normal}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "e620":
/***/ (function(module, exports, __webpack_require__) {

var isSameSecond = __webpack_require__("c6ae")

/**
 * @category Second Helpers
 * @summary Is the given date in the same second as the current date?
 *
 * @description
 * Is the given date in the same second as the current date?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in this second
 *
 * @example
 * // If now is 25 September 2014 18:30:15.500,
 * // is 25 September 2014 18:30:15.000 in this second?
 * var result = isThisSecond(new Date(2014, 8, 25, 18, 30, 15))
 * //=> true
 */
function isThisSecond (dirtyDate) {
  return isSameSecond(new Date(), dirtyDate)
}

module.exports = isThisSecond


/***/ }),

/***/ "e667":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { error: false, value: exec() };
  } catch (error) {
    return { error: true, value: error };
  }
};


/***/ }),

/***/ "e67a":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("f140");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("33d9df97", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "e6cf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var IS_PURE = __webpack_require__("c430");
var global = __webpack_require__("da84");
var getBuiltIn = __webpack_require__("d066");
var NativePromise = __webpack_require__("fea9");
var redefine = __webpack_require__("6eeb");
var redefineAll = __webpack_require__("e2cc");
var setToStringTag = __webpack_require__("d44e");
var setSpecies = __webpack_require__("2626");
var isObject = __webpack_require__("861d");
var aFunction = __webpack_require__("1c0b");
var anInstance = __webpack_require__("19aa");
var inspectSource = __webpack_require__("8925");
var iterate = __webpack_require__("2266");
var checkCorrectnessOfIteration = __webpack_require__("1c7e");
var speciesConstructor = __webpack_require__("4840");
var task = __webpack_require__("2cf4").set;
var microtask = __webpack_require__("b575");
var promiseResolve = __webpack_require__("cdf9");
var hostReportErrors = __webpack_require__("44de");
var newPromiseCapabilityModule = __webpack_require__("f069");
var perform = __webpack_require__("e667");
var InternalStateModule = __webpack_require__("69f3");
var isForced = __webpack_require__("94ca");
var wellKnownSymbol = __webpack_require__("b622");
var IS_NODE = __webpack_require__("605d");
var V8_VERSION = __webpack_require__("2d00");

var SPECIES = wellKnownSymbol('species');
var PROMISE = 'Promise';
var getInternalState = InternalStateModule.get;
var setInternalState = InternalStateModule.set;
var getInternalPromiseState = InternalStateModule.getterFor(PROMISE);
var PromiseConstructor = NativePromise;
var TypeError = global.TypeError;
var document = global.document;
var process = global.process;
var $fetch = getBuiltIn('fetch');
var newPromiseCapability = newPromiseCapabilityModule.f;
var newGenericPromiseCapability = newPromiseCapability;
var DISPATCH_EVENT = !!(document && document.createEvent && global.dispatchEvent);
var NATIVE_REJECTION_EVENT = typeof PromiseRejectionEvent == 'function';
var UNHANDLED_REJECTION = 'unhandledrejection';
var REJECTION_HANDLED = 'rejectionhandled';
var PENDING = 0;
var FULFILLED = 1;
var REJECTED = 2;
var HANDLED = 1;
var UNHANDLED = 2;
var Internal, OwnPromiseCapability, PromiseWrapper, nativeThen;

var FORCED = isForced(PROMISE, function () {
  var GLOBAL_CORE_JS_PROMISE = inspectSource(PromiseConstructor) !== String(PromiseConstructor);
  if (!GLOBAL_CORE_JS_PROMISE) {
    // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
    // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
    // We can't detect it synchronously, so just check versions
    if (V8_VERSION === 66) return true;
    // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    if (!IS_NODE && !NATIVE_REJECTION_EVENT) return true;
  }
  // We need Promise#finally in the pure version for preventing prototype pollution
  if (IS_PURE && !PromiseConstructor.prototype['finally']) return true;
  // We can't use @@species feature detection in V8 since it causes
  // deoptimization and performance degradation
  // https://github.com/zloirock/core-js/issues/679
  if (V8_VERSION >= 51 && /native code/.test(PromiseConstructor)) return false;
  // Detect correctness of subclassing with @@species support
  var promise = PromiseConstructor.resolve(1);
  var FakePromise = function (exec) {
    exec(function () { /* empty */ }, function () { /* empty */ });
  };
  var constructor = promise.constructor = {};
  constructor[SPECIES] = FakePromise;
  return !(promise.then(function () { /* empty */ }) instanceof FakePromise);
});

var INCORRECT_ITERATION = FORCED || !checkCorrectnessOfIteration(function (iterable) {
  PromiseConstructor.all(iterable)['catch'](function () { /* empty */ });
});

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};

var notify = function (state, isReject) {
  if (state.notified) return;
  state.notified = true;
  var chain = state.reactions;
  microtask(function () {
    var value = state.value;
    var ok = state.state == FULFILLED;
    var index = 0;
    // variable length - can't use forEach
    while (chain.length > index) {
      var reaction = chain[index++];
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (state.rejection === UNHANDLED) onHandleUnhandled(state);
            state.rejection = HANDLED;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // can throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (error) {
        if (domain && !exited) domain.exit();
        reject(error);
      }
    }
    state.reactions = [];
    state.notified = false;
    if (isReject && !state.rejection) onUnhandled(state);
  });
};

var dispatchEvent = function (name, promise, reason) {
  var event, handler;
  if (DISPATCH_EVENT) {
    event = document.createEvent('Event');
    event.promise = promise;
    event.reason = reason;
    event.initEvent(name, false, true);
    global.dispatchEvent(event);
  } else event = { promise: promise, reason: reason };
  if (!NATIVE_REJECTION_EVENT && (handler = global['on' + name])) handler(event);
  else if (name === UNHANDLED_REJECTION) hostReportErrors('Unhandled promise rejection', reason);
};

var onUnhandled = function (state) {
  task.call(global, function () {
    var promise = state.facade;
    var value = state.value;
    var IS_UNHANDLED = isUnhandled(state);
    var result;
    if (IS_UNHANDLED) {
      result = perform(function () {
        if (IS_NODE) {
          process.emit('unhandledRejection', value, promise);
        } else dispatchEvent(UNHANDLED_REJECTION, promise, value);
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      state.rejection = IS_NODE || isUnhandled(state) ? UNHANDLED : HANDLED;
      if (result.error) throw result.value;
    }
  });
};

var isUnhandled = function (state) {
  return state.rejection !== HANDLED && !state.parent;
};

var onHandleUnhandled = function (state) {
  task.call(global, function () {
    var promise = state.facade;
    if (IS_NODE) {
      process.emit('rejectionHandled', promise);
    } else dispatchEvent(REJECTION_HANDLED, promise, state.value);
  });
};

var bind = function (fn, state, unwrap) {
  return function (value) {
    fn(state, value, unwrap);
  };
};

var internalReject = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  state.value = value;
  state.state = REJECTED;
  notify(state, true);
};

var internalResolve = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  try {
    if (state.facade === value) throw TypeError("Promise can't be resolved itself");
    var then = isThenable(value);
    if (then) {
      microtask(function () {
        var wrapper = { done: false };
        try {
          then.call(value,
            bind(internalResolve, wrapper, state),
            bind(internalReject, wrapper, state)
          );
        } catch (error) {
          internalReject(wrapper, error, state);
        }
      });
    } else {
      state.value = value;
      state.state = FULFILLED;
      notify(state, false);
    }
  } catch (error) {
    internalReject({ done: false }, error, state);
  }
};

// constructor polyfill
if (FORCED) {
  // 25.4.3.1 Promise(executor)
  PromiseConstructor = function Promise(executor) {
    anInstance(this, PromiseConstructor, PROMISE);
    aFunction(executor);
    Internal.call(this);
    var state = getInternalState(this);
    try {
      executor(bind(internalResolve, state), bind(internalReject, state));
    } catch (error) {
      internalReject(state, error);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    setInternalState(this, {
      type: PROMISE,
      done: false,
      notified: false,
      parent: false,
      reactions: [],
      rejection: false,
      state: PENDING,
      value: undefined
    });
  };
  Internal.prototype = redefineAll(PromiseConstructor.prototype, {
    // `Promise.prototype.then` method
    // https://tc39.es/ecma262/#sec-promise.prototype.then
    then: function then(onFulfilled, onRejected) {
      var state = getInternalPromiseState(this);
      var reaction = newPromiseCapability(speciesConstructor(this, PromiseConstructor));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = IS_NODE ? process.domain : undefined;
      state.parent = true;
      state.reactions.push(reaction);
      if (state.state != PENDING) notify(state, false);
      return reaction.promise;
    },
    // `Promise.prototype.catch` method
    // https://tc39.es/ecma262/#sec-promise.prototype.catch
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    var state = getInternalState(promise);
    this.promise = promise;
    this.resolve = bind(internalResolve, state);
    this.reject = bind(internalReject, state);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === PromiseConstructor || C === PromiseWrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };

  if (!IS_PURE && typeof NativePromise == 'function') {
    nativeThen = NativePromise.prototype.then;

    // wrap native Promise#then for native async functions
    redefine(NativePromise.prototype, 'then', function then(onFulfilled, onRejected) {
      var that = this;
      return new PromiseConstructor(function (resolve, reject) {
        nativeThen.call(that, resolve, reject);
      }).then(onFulfilled, onRejected);
    // https://github.com/zloirock/core-js/issues/640
    }, { unsafe: true });

    // wrap fetch result
    if (typeof $fetch == 'function') $({ global: true, enumerable: true, forced: true }, {
      // eslint-disable-next-line no-unused-vars
      fetch: function fetch(input /* , init */) {
        return promiseResolve(PromiseConstructor, $fetch.apply(global, arguments));
      }
    });
  }
}

$({ global: true, wrap: true, forced: FORCED }, {
  Promise: PromiseConstructor
});

setToStringTag(PromiseConstructor, PROMISE, false, true);
setSpecies(PROMISE);

PromiseWrapper = getBuiltIn(PROMISE);

// statics
$({ target: PROMISE, stat: true, forced: FORCED }, {
  // `Promise.reject` method
  // https://tc39.es/ecma262/#sec-promise.reject
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    capability.reject.call(undefined, r);
    return capability.promise;
  }
});

$({ target: PROMISE, stat: true, forced: IS_PURE || FORCED }, {
  // `Promise.resolve` method
  // https://tc39.es/ecma262/#sec-promise.resolve
  resolve: function resolve(x) {
    return promiseResolve(IS_PURE && this === PromiseWrapper ? PromiseConstructor : this, x);
  }
});

$({ target: PROMISE, stat: true, forced: INCORRECT_ITERATION }, {
  // `Promise.all` method
  // https://tc39.es/ecma262/#sec-promise.all
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aFunction(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        $promiseResolve.call(C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  },
  // `Promise.race` method
  // https://tc39.es/ecma262/#sec-promise.race
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aFunction(C.resolve);
      iterate(iterable, function (promise) {
        $promiseResolve.call(C, promise).then(capability.resolve, reject);
      });
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});


/***/ }),

/***/ "e707":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("caad");
/* harmony import */ var core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("a9e3");
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("2532");
/* harmony import */ var core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_VOverlay__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("1abc");
/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("80d2");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("8bbf");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_5__);



// Components
 // Utilities

 // Types


/* @vue/component */

/* harmony default export */ __webpack_exports__["a"] = (vue__WEBPACK_IMPORTED_MODULE_5___default.a.extend().extend({
  name: 'overlayable',
  props: {
    hideOverlay: Boolean,
    overlayColor: String,
    overlayOpacity: [Number, String]
  },
  data: function data() {
    return {
      animationFrame: 0,
      overlay: null
    };
  },
  watch: {
    hideOverlay: function hideOverlay(value) {
      if (!this.isActive) return;
      if (value) this.removeOverlay();else this.genOverlay();
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.removeOverlay();
  },
  methods: {
    createOverlay: function createOverlay() {
      var overlay = new _components_VOverlay__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"]({
        propsData: {
          absolute: this.absolute,
          value: false,
          color: this.overlayColor,
          opacity: this.overlayOpacity
        }
      });
      overlay.$mount();
      var parent = this.absolute ? this.$el.parentNode : document.querySelector('[data-app]');
      parent && parent.insertBefore(overlay.$el, parent.firstChild);
      this.overlay = overlay;
    },
    genOverlay: function genOverlay() {
      var _this = this;

      this.hideScroll();
      if (this.hideOverlay) return;
      if (!this.overlay) this.createOverlay();
      this.animationFrame = requestAnimationFrame(function () {
        if (!_this.overlay) return;

        if (_this.activeZIndex !== undefined) {
          _this.overlay.zIndex = String(_this.activeZIndex - 1);
        } else if (_this.$el) {
          _this.overlay.zIndex = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_4__[/* getZIndex */ "u"])(_this.$el);
        }

        _this.overlay.value = true;
      });
      return true;
    },

    /** removeOverlay(false) will not restore the scollbar afterwards */
    removeOverlay: function removeOverlay() {
      var _this2 = this;

      var showScroll = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (this.overlay) {
        Object(_util_helpers__WEBPACK_IMPORTED_MODULE_4__[/* addOnceEventListener */ "a"])(this.overlay.$el, 'transitionend', function () {
          if (!_this2.overlay || !_this2.overlay.$el || !_this2.overlay.$el.parentNode || _this2.overlay.value) return;

          _this2.overlay.$el.parentNode.removeChild(_this2.overlay.$el);

          _this2.overlay.$destroy();

          _this2.overlay = null;
        }); // Cancel animation frame in case
        // overlay is removed before it
        // has finished its animation

        cancelAnimationFrame(this.animationFrame);
        this.overlay.value = false;
      }

      showScroll && this.showScroll();
    },
    scrollListener: function scrollListener(e) {
      if (e.type === 'keydown') {
        if (['INPUT', 'TEXTAREA', 'SELECT'].includes(e.target.tagName) || // https://github.com/vuetifyjs/vuetify/issues/4715
        e.target.isContentEditable) return;
        var up = [_util_helpers__WEBPACK_IMPORTED_MODULE_4__[/* keyCodes */ "x"].up, _util_helpers__WEBPACK_IMPORTED_MODULE_4__[/* keyCodes */ "x"].pageup];
        var down = [_util_helpers__WEBPACK_IMPORTED_MODULE_4__[/* keyCodes */ "x"].down, _util_helpers__WEBPACK_IMPORTED_MODULE_4__[/* keyCodes */ "x"].pagedown];

        if (up.includes(e.keyCode)) {
          e.deltaY = -1;
        } else if (down.includes(e.keyCode)) {
          e.deltaY = 1;
        } else {
          return;
        }
      }

      if (e.target === this.overlay || e.type !== 'keydown' && e.target === document.body || this.checkPath(e)) e.preventDefault();
    },
    hasScrollbar: function hasScrollbar(el) {
      if (!el || el.nodeType !== Node.ELEMENT_NODE) return false;
      var style = window.getComputedStyle(el);
      return ['auto', 'scroll'].includes(style.overflowY) && el.scrollHeight > el.clientHeight;
    },
    shouldScroll: function shouldScroll(el, delta) {
      if (el.scrollTop === 0 && delta < 0) return true;
      return el.scrollTop + el.clientHeight === el.scrollHeight && delta > 0;
    },
    isInside: function isInside(el, parent) {
      if (el === parent) {
        return true;
      } else if (el === null || el === document.body) {
        return false;
      } else {
        return this.isInside(el.parentNode, parent);
      }
    },
    checkPath: function checkPath(e) {
      var path = e.path || this.composedPath(e);
      var delta = e.deltaY;

      if (e.type === 'keydown' && path[0] === document.body) {
        var dialog = this.$refs.dialog; // getSelection returns null in firefox in some edge cases, can be ignored

        var selected = window.getSelection().anchorNode;

        if (dialog && this.hasScrollbar(dialog) && this.isInside(selected, dialog)) {
          return this.shouldScroll(dialog, delta);
        }

        return true;
      }

      for (var index = 0; index < path.length; index++) {
        var el = path[index];
        if (el === document) return true;
        if (el === document.documentElement) return true;
        if (el === this.$refs.content) return true;
        if (this.hasScrollbar(el)) return this.shouldScroll(el, delta);
      }

      return true;
    },

    /**
     * Polyfill for Event.prototype.composedPath
     */
    composedPath: function composedPath(e) {
      if (e.composedPath) return e.composedPath();
      var path = [];
      var el = e.target;

      while (el) {
        path.push(el);

        if (el.tagName === 'HTML') {
          path.push(document);
          path.push(window);
          return path;
        }

        el = el.parentElement;
      }

      return path;
    },
    hideScroll: function hideScroll() {
      if (this.$vuetify.breakpoint.smAndDown) {
        document.documentElement.classList.add('overflow-y-hidden');
      } else {
        Object(_util_helpers__WEBPACK_IMPORTED_MODULE_4__[/* addPassiveEventListener */ "b"])(window, 'wheel', this.scrollListener, {
          passive: false
        });
        window.addEventListener('keydown', this.scrollListener);
      }
    },
    showScroll: function showScroll() {
      document.documentElement.classList.remove('overflow-y-hidden');
      window.removeEventListener('wheel', this.scrollListener);
      window.removeEventListener('keydown', this.scrollListener);
    }
  }
}));

/***/ }),

/***/ "e73d":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("c8d5")
var getISOWeek = __webpack_require__("81fc")

/**
 * @category ISO Week Helpers
 * @summary Set the ISO week to the given date.
 *
 * @description
 * Set the ISO week to the given date, saving the weekday number.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} isoWeek - the ISO week of the new date
 * @returns {Date} the new date with the ISO week setted
 *
 * @example
 * // Set the 53rd ISO week to 7 August 2004:
 * var result = setISOWeek(new Date(2004, 7, 7), 53)
 * //=> Sat Jan 01 2005 00:00:00
 */
function setISOWeek (dirtyDate, dirtyISOWeek) {
  var date = parse(dirtyDate)
  var isoWeek = Number(dirtyISOWeek)
  var diff = getISOWeek(date) - isoWeek
  date.setDate(date.getDate() - diff * 7)
  return date
}

module.exports = setISOWeek


/***/ }),

/***/ "e785":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("c8d5")

/**
 * @category Millisecond Helpers
 * @summary Get the number of milliseconds between the given dates.
 *
 * @description
 * Get the number of milliseconds between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of milliseconds
 *
 * @example
 * // How many milliseconds are between
 * // 2 July 2014 12:30:20.600 and 2 July 2014 12:30:21.700?
 * var result = differenceInMilliseconds(
 *   new Date(2014, 6, 2, 12, 30, 21, 700),
 *   new Date(2014, 6, 2, 12, 30, 20, 600)
 * )
 * //=> 1100
 */
function differenceInMilliseconds (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)
  return dateLeft.getTime() - dateRight.getTime()
}

module.exports = differenceInMilliseconds


/***/ }),

/***/ "e7e2":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><rect x=\"3\" y=\"3\" width=\"18\" height=\"14\" fill=\"white\"></rect><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M13.4274 12C15.3757 12 17.0407 13.4038 17.3699 15.3241L18 19H6L6.63015 15.3241C6.95935 13.4038 8.62428 12 10.5726 12H13.4274ZM12 5C13.933 5 15.5 6.567 15.5 8.5C15.5 10.433 13.933 12 12 12C10.067 12 8.5 10.433 8.5 8.5C8.5 6.567 10.067 5 12 5Z\" fill=\"#DFE4E5\"></path><path d=\"M16 21C16.5523 21 17 21.4477 17 22C17 22.5523 16.5523 23 16 23H8C7.44772 23 7 22.5523 7 22C7 21.4477 7.44772 21 8 21H16ZM4 19C2.34315 19 1 17.6569 1 16V4C1 2.34315 2.34315 1 4 1H20C21.6569 1 23 2.34315 23 4V16C23 17.6569 21.6569 19 20 19H4ZM20 3H4C3.48716 3 3.06449 3.38604 3.00673 3.88338L3 4V16C3 16.5128 3.38604 16.9355 3.88338 16.9933L4 17H6.343L6.63015 15.3241C6.95935 13.4038 8.62428 12 10.5726 12H13.4274C15.3757 12 17.0407 13.4038 17.3699 15.3241L17.657 17H20C20.5128 17 20.9355 16.614 20.9933 16.1166L21 16V4C21 3.48716 20.614 3.06449 20.1166 3.00673L20 3ZM13.4274 14H10.5726C9.65258 14 8.85893 14.6261 8.63492 15.5045L8.60139 15.6621L8.372 17H15.627L15.3986 15.6621C15.2432 14.7552 14.492 14.0788 13.5883 14.0064L13.4274 14ZM12 5C13.933 5 15.5 6.567 15.5 8.5C15.5 10.433 13.933 12 12 12C10.067 12 8.5 10.433 8.5 8.5C8.5 6.567 10.067 5 12 5ZM12 7C11.1716 7 10.5 7.67157 10.5 8.5C10.5 9.32843 11.1716 10 12 10C12.8284 10 13.5 9.32843 13.5 8.5C13.5 7.67157 12.8284 7 12 7Z\" fill=\"#1F3A3E\"></path></svg>";

/***/ }),

/***/ "e80a":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><rect x=\"3\" y=\"3\" width=\"14\" height=\"13\" fill=\"#D5EAFD\"></rect><path d=\"M15 3H5C3.89543 3 3 3.80589 3 4.8V19.2C3 20.1941 3.89543 21 5 21H15C16.1046 21 17 20.1941 17 19.2V4.8C17 3.80589 16.1046 3 15 3Z\" stroke=\"#079CB2\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M10 18H10.01\" stroke=\"#079CB2\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M21 13C21 14.1046 20.1046 15 19 15H10V9C10 7.89543 10.8954 7 12 7H21V13Z\" fill=\"white\" stroke=\"#079CB2\" stroke-width=\"2\"></path><rect x=\"13\" y=\"10\" width=\"5\" height=\"2\" fill=\"#079CB2\"></rect></svg>";

/***/ }),

/***/ "e830":
/***/ (function(module, exports, __webpack_require__) {

var buildFormattingTokensRegExp = __webpack_require__("90e5")

function buildFormatLocale () {
  // Note: in English, the names of days of the week and months are capitalized.
  // If you are making a new locale based on this one, check if the same is true for the language you're working on.
  // Generally, formatted dates should look like they are in the middle of a sentence,
  // e.g. in Spanish language the weekdays and months should be in the lowercase.
  var months3char = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
  var monthsFull = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
  var weekdays2char = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa']
  var weekdays3char = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
  var weekdaysFull = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
  var meridiemUppercase = ['AM', 'PM']
  var meridiemLowercase = ['am', 'pm']
  var meridiemFull = ['a.m.', 'p.m.']

  var formatters = {
    // Month: Jan, Feb, ..., Dec
    'MMM': function (date) {
      return months3char[date.getMonth()]
    },

    // Month: January, February, ..., December
    'MMMM': function (date) {
      return monthsFull[date.getMonth()]
    },

    // Day of week: Su, Mo, ..., Sa
    'dd': function (date) {
      return weekdays2char[date.getDay()]
    },

    // Day of week: Sun, Mon, ..., Sat
    'ddd': function (date) {
      return weekdays3char[date.getDay()]
    },

    // Day of week: Sunday, Monday, ..., Saturday
    'dddd': function (date) {
      return weekdaysFull[date.getDay()]
    },

    // AM, PM
    'A': function (date) {
      return (date.getHours() / 12) >= 1 ? meridiemUppercase[1] : meridiemUppercase[0]
    },

    // am, pm
    'a': function (date) {
      return (date.getHours() / 12) >= 1 ? meridiemLowercase[1] : meridiemLowercase[0]
    },

    // a.m., p.m.
    'aa': function (date) {
      return (date.getHours() / 12) >= 1 ? meridiemFull[1] : meridiemFull[0]
    }
  }

  // Generate ordinal version of formatters: M -> Mo, D -> Do, etc.
  var ordinalFormatters = ['M', 'D', 'DDD', 'd', 'Q', 'W']
  ordinalFormatters.forEach(function (formatterToken) {
    formatters[formatterToken + 'o'] = function (date, formatters) {
      return ordinal(formatters[formatterToken](date))
    }
  })

  return {
    formatters: formatters,
    formattingTokensRegExp: buildFormattingTokensRegExp(formatters)
  }
}

function ordinal (number) {
  var rem100 = number % 100
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st'
      case 2:
        return number + 'nd'
      case 3:
        return number + 'rd'
    }
  }
  return number + 'th'
}

module.exports = buildFormatLocale


/***/ }),

/***/ "e890":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpInputDate_vue_vue_type_style_index_0_id_196abf97_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("fc68");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpInputDate_vue_vue_type_style_index_0_id_196abf97_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpInputDate_vue_vue_type_style_index_0_id_196abf97_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "e893":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("5135");
var ownKeys = __webpack_require__("56ef");
var getOwnPropertyDescriptorModule = __webpack_require__("06cf");
var definePropertyModule = __webpack_require__("9bf2");

module.exports = function (target, source) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!has(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
  }
};


/***/ }),

/***/ "e8b5":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("c6b6");

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
module.exports = Array.isArray || function isArray(arg) {
  return classof(arg) == 'Array';
};


/***/ }),

/***/ "e8f2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VGrid; });
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("99af");
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("4de4");
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_join_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("a15b");
/* harmony import */ var core_js_modules_es_array_join_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("b64b");
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_string_starts_with_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("2ca0");
/* harmony import */ var core_js_modules_es_string_starts_with_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_starts_with_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_string_trim_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("498a");
/* harmony import */ var core_js_modules_es_string_trim_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_trim_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("8bbf");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_6__);






// Types

function VGrid(name) {
  /* @vue/component */
  return vue__WEBPACK_IMPORTED_MODULE_6___default.a.extend({
    name: "v-".concat(name),
    functional: true,
    props: {
      id: String,
      tag: {
        type: String,
        default: 'div'
      }
    },
    render: function render(h, _ref) {
      var props = _ref.props,
          data = _ref.data,
          children = _ref.children;
      data.staticClass = "".concat(name, " ").concat(data.staticClass || '').trim();
      var attrs = data.attrs;

      if (attrs) {
        // reset attrs to extract utility clases like pa-3
        data.attrs = {};
        var classes = Object.keys(attrs).filter(function (key) {
          // TODO: Remove once resolved
          // https://github.com/vuejs/vue/issues/7841
          if (key === 'slot') return false;
          var value = attrs[key]; // add back data attributes like data-test="foo" but do not
          // add them as classes

          if (key.startsWith('data-')) {
            data.attrs[key] = value;
            return false;
          }

          return value || typeof value === 'string';
        });
        if (classes.length) data.staticClass += " ".concat(classes.join(' '));
      }

      if (props.id) {
        data.domProps = data.domProps || {};
        data.domProps.id = props.id;
      }

      return h(props.tag, data, children);
    }
  });
}

/***/ }),

/***/ "e921":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c662cfac-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/statusChip/PpStatusChip.vue?vue&type=template&id=edf4fc24&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"pp-status-chip  d-flex",class:(_vm.textClass + " " + _vm.smallClass)},[(_vm.simple)?[_vm._v(" "+_vm._s(_vm.text)+" ")]:[_c('b',[_vm._v(_vm._s(_vm.text))]),(_vm.subText)?_c('span',{staticClass:"pp-status-chip__sub-text d-flex",class:[
        _vm.showDot ? 'pp-status-chip__sub-text--with-dot' : '' ]},[_vm._v(_vm._s(_vm.subText))]):_vm._e()]],2)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/statusChip/PpStatusChip.vue?vue&type=template&id=edf4fc24&scoped=true&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("99af");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.small.js
var es_string_small = __webpack_require__("c96a");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/statusChip/PpStatusChip.vue?vue&type=script&lang=js&


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var PpStatusChipvue_type_script_lang_js_ = ({
  name: 'PpStatusChip',
  props: {
    status: {
      type: String,
      required: false,
      default: 'inactive'
    },
    small: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      required: true
    },

    /**
     * If sub text exists, then a dot will be shown before the sub text
     * The subtext isnt supported up on the simple format
     */
    subText: {
      type: String,
      required: false,
      default: ''
    },
    simple: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    showDot: function showDot() {
      return Boolean(this.text && this.subText);
    },
    textClass: function textClass() {
      return this.simple ? "pp-status-chip--simple  pp-status-chip--simple--".concat(this.status) : "".concat(this.status, " ").concat(this.status, "--text");
    },
    smallClass: function smallClass() {
      if (!this.simple && !this.small) {
        return 'px-2';
      }

      return this.small ? 'pp-status-chip--small text-subtitle-1' : '';
    }
  }
});
// CONCATENATED MODULE: ./src/components/statusChip/PpStatusChip.vue?vue&type=script&lang=js&
 /* harmony default export */ var statusChip_PpStatusChipvue_type_script_lang_js_ = (PpStatusChipvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/statusChip/PpStatusChip.vue?vue&type=style&index=0&id=edf4fc24&lang=scss&scoped=true&
var PpStatusChipvue_type_style_index_0_id_edf4fc24_lang_scss_scoped_true_ = __webpack_require__("8b51");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/statusChip/PpStatusChip.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  statusChip_PpStatusChipvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "edf4fc24",
  null
  
)

/* harmony default export */ var PpStatusChip = __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "e95a":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");
var Iterators = __webpack_require__("3f8c");

var ITERATOR = wellKnownSymbol('iterator');
var ArrayPrototype = Array.prototype;

// check on default Array iterator
module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
};


/***/ }),

/***/ "e96b":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("c8d5")

/**
 * @category Minute Helpers
 * @summary Return the start of a minute for the given date.
 *
 * @description
 * Return the start of a minute for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of a minute
 *
 * @example
 * // The start of a minute for 1 December 2014 22:15:45.400:
 * var result = startOfMinute(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:00
 */
function startOfMinute (dirtyDate) {
  var date = parse(dirtyDate)
  date.setSeconds(0, 0)
  return date
}

module.exports = startOfMinute


/***/ }),

/***/ "e9b1":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("45a3");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("4eb72d8d", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "e9ca":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("e076");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("0b0337a3", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "eaa5":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("c8d5")

/**
 * @category Range Helpers
 * @summary Is the given date range overlapping with another date range?
 *
 * @description
 * Is the given date range overlapping with another date range?
 *
 * @param {Date|String|Number} initialRangeStartDate - the start of the initial range
 * @param {Date|String|Number} initialRangeEndDate - the end of the initial range
 * @param {Date|String|Number} comparedRangeStartDate - the start of the range to compare it with
 * @param {Date|String|Number} comparedRangeEndDate - the end of the range to compare it with
 * @returns {Boolean} whether the date ranges are overlapping
 * @throws {Error} startDate of a date range cannot be after its endDate
 *
 * @example
 * // For overlapping date ranges:
 * areRangesOverlapping(
 *   new Date(2014, 0, 10), new Date(2014, 0, 20), new Date(2014, 0, 17), new Date(2014, 0, 21)
 * )
 * //=> true
 *
 * @example
 * // For non-overlapping date ranges:
 * areRangesOverlapping(
 *   new Date(2014, 0, 10), new Date(2014, 0, 20), new Date(2014, 0, 21), new Date(2014, 0, 22)
 * )
 * //=> false
 */
function areRangesOverlapping (dirtyInitialRangeStartDate, dirtyInitialRangeEndDate, dirtyComparedRangeStartDate, dirtyComparedRangeEndDate) {
  var initialStartTime = parse(dirtyInitialRangeStartDate).getTime()
  var initialEndTime = parse(dirtyInitialRangeEndDate).getTime()
  var comparedStartTime = parse(dirtyComparedRangeStartDate).getTime()
  var comparedEndTime = parse(dirtyComparedRangeEndDate).getTime()

  if (initialStartTime > initialEndTime || comparedStartTime > comparedEndTime) {
    throw new Error('The start of the range cannot be after the end of the range')
  }

  return initialStartTime < comparedEndTime && comparedStartTime < initialEndTime
}

module.exports = areRangesOverlapping


/***/ }),

/***/ "eb69":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.v-tooltip{display:none}.v-tooltip--attached{display:inline}.v-tooltip__content{background:#2b2b2b;color:#fff;border-radius:5px;font-size:14px;line-height:22px;display:inline-block;padding:4px 12px;position:absolute;text-transform:none;width:auto;opacity:1;pointer-events:none}.v-tooltip__content--fixed{position:fixed}.v-tooltip__content[class*=-active]{transition-timing-function:cubic-bezier(0,0,.2,1)}.v-tooltip__content[class*=enter-active]{transition-duration:.15s}.v-tooltip__content[class*=leave-active]{transition-duration:75ms}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "ec07":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.v-btn:not(.v-btn--outlined).accent,.v-btn:not(.v-btn--outlined).error,.v-btn:not(.v-btn--outlined).info,.v-btn:not(.v-btn--outlined).primary,.v-btn:not(.v-btn--outlined).secondary,.v-btn:not(.v-btn--outlined).success,.v-btn:not(.v-btn--outlined).warning{color:var(--pp-primary-button-text-color,#004852)}.theme--light.v-btn{color:var(--pp-text-primary,#2b2b2b)}.theme--light.v-btn.v-btn--disabled,.theme--light.v-btn.v-btn--disabled .v-btn__loading,.theme--light.v-btn.v-btn--disabled .v-icon{color:var(--pp-disabled-button-color,#fff)!important}.theme--light.v-btn.v-btn--disabled.v-btn--has-bg{background-color:var(--pp-disabled-button-bg,#e6f5f7)!important}.theme--light.v-btn.v-btn--has-bg{background-color:#f6f6f6}.theme--light.v-btn.v-btn--outlined.v-btn--text{border-color:#d6d6d6}.theme--light.v-btn.v-btn--icon{color:var(--active-icon,#2b2b2b)}.theme--light.v-btn:hover:before{opacity:1}.theme--light.v-btn:focus:before{opacity:.24}.theme--light.v-btn--active:before,.theme--light.v-btn--active:hover:before{opacity:0}.theme--light.v-btn--active:focus:before{opacity:.16}.theme--dark.v-btn{color:var(--pp-primary-button-text-color,#004852)}.theme--dark.v-btn.v-btn--disabled,.theme--dark.v-btn.v-btn--disabled .v-btn__loading,.theme--dark.v-btn.v-btn--disabled .v-icon{color:var(--pp-disabled-button-color,#fff)!important}.theme--dark.v-btn.v-btn--disabled.v-btn--has-bg{background-color:var(--pp-disabled-button-bg,#e6f5f7)!important}.theme--dark.v-btn.v-btn--has-bg{background-color:#272727}.theme--dark.v-btn.v-btn--outlined.v-btn--text{border-color:hsla(0,0%,100%,.12)}.theme--dark.v-btn.v-btn--icon{color:#fff}.theme--dark.v-btn:hover:before{opacity:1}.theme--dark.v-btn:focus:before{opacity:.24}.theme--dark.v-btn--active:before,.theme--dark.v-btn--active:hover:before{opacity:0}.theme--dark.v-btn--active:focus:before{opacity:.32}.v-btn{align-items:center;border-radius:20px;display:inline-flex;flex:0 0 auto;font-weight:400;letter-spacing:normal;justify-content:center;outline:0;position:relative;text-decoration:none;text-indent:normal;text-transform:none;transition-duration:.28s;transition-property:box-shadow,transform,opacity;transition-timing-function:cubic-bezier(.4,0,.2,1);-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;vertical-align:middle;white-space:nowrap}.v-btn.v-size--x-small{font-size:.625rem}.v-btn.v-size--small{font-size:.75rem}.v-btn.v-size--default{font-size:1rem}.v-btn.v-size--large{font-size:1.875rem}.v-btn.v-size--x-large{font-size:10rem}.v-btn:before{background-color:currentColor;border-radius:inherit;bottom:0;color:inherit;content:\"\";left:0;opacity:0;pointer-events:none;position:absolute;right:0;top:0;transition:background-color .2s}.v-btn:not(.v-btn--disabled){will-change:box-shadow}.v-btn:not(.v-btn--round).v-size--x-small{height:20px;min-width:36px;padding:0 8.8888888889px}.v-btn:not(.v-btn--round).v-size--small{height:28px;min-width:50px;padding:0 12.4444444444px}.v-btn:not(.v-btn--round).v-size--default{height:36px;min-width:64px;padding:0 16px}.v-btn:not(.v-btn--round).v-size--large{height:50px;min-width:89px;padding:0 22.2222222222px}.v-btn:not(.v-btn--round).v-size--x-large{height:52px;min-width:92px;padding:0 23.1111111111px}.v-btn>.v-btn__content .v-icon{color:inherit}.v-btn__content{align-items:center;color:inherit;display:flex;flex:1 0 auto;justify-content:inherit;line-height:normal;position:relative;transition:inherit;transition-property:opacity}.v-btn__content .v-icon--left,.v-btn__content .v-icon--right{font-size:18px;height:18px;width:18px}.v-application--is-ltr .v-btn__content .v-icon--left{margin-left:-4px;margin-right:8px}.v-application--is-ltr .v-btn__content .v-icon--right,.v-application--is-rtl .v-btn__content .v-icon--left{margin-left:8px;margin-right:-4px}.v-application--is-rtl .v-btn__content .v-icon--right{margin-left:-4px;margin-right:8px}.v-btn__loader{align-items:center;display:flex;height:100%;justify-content:center;left:0;position:absolute;top:0;width:100%}.v-btn--absolute.v-btn--right,.v-btn--fixed.v-btn--right{right:16px}.v-btn--absolute.v-btn--left,.v-btn--fixed.v-btn--left{left:16px}.v-btn--absolute.v-btn--top,.v-btn--fixed.v-btn--top{top:16px}.v-btn--absolute.v-btn--bottom,.v-btn--fixed.v-btn--bottom{bottom:16px}.v-btn--absolute{position:absolute}.v-btn--fixed{position:fixed}.v-btn--block{display:flex;flex:1 0 auto;min-width:100%!important;max-width:auto}.v-btn--is-elevated{box-shadow:0 3px 1px -2px transparent,0 2px 2px 0 transparent,0 1px 5px 0 rgba(0,0,0,.12)}.v-btn--is-elevated:after{box-shadow:0 2px 4px -1px transparent,0 4px 5px 0 transparent,0 1px 10px 0 rgba(0,0,0,.12)}.v-btn--is-elevated:active{box-shadow:0 5px 5px -3px transparent,0 8px 10px 1px transparent,0 3px 14px 2px rgba(0,0,0,.12)}.v-btn--is-elevated.v-btn--fab{box-shadow:0 3px 5px -1px transparent,0 6px 10px 0 transparent,0 1px 18px 0 rgba(0,0,0,.12)}.v-btn--is-elevated.v-btn--fab:after{box-shadow:0 5px 5px -3px transparent,0 8px 10px 1px transparent,0 3px 14px 2px rgba(0,0,0,.12)}.v-btn--is-elevated.v-btn--fab:active{box-shadow:0 7px 8px -4px transparent,0 12px 17px 2px transparent,0 5px 22px 4px rgba(0,0,0,.12)}.v-btn--disabled{pointer-events:none}.v-btn--fab,.v-btn--icon{min-height:0;min-width:0;padding:0}.v-btn--fab.v-size--x-small .v-icon,.v-btn--icon.v-size--x-small .v-icon{height:18px;font-size:18px;width:18px}.v-btn--fab.v-size--default .v-icon,.v-btn--fab.v-size--small .v-icon,.v-btn--icon.v-size--default .v-icon,.v-btn--icon.v-size--small .v-icon{height:24px;font-size:24px;width:24px}.v-btn--fab.v-size--large .v-icon,.v-btn--icon.v-size--large .v-icon{height:28px;font-size:28px;width:28px}.v-btn--fab.v-size--x-large .v-icon,.v-btn--icon.v-size--x-large .v-icon{height:32px;font-size:32px;width:32px}.v-btn--icon.v-size--x-small{height:20px;width:20px}.v-btn--icon.v-size--small{height:28px;width:28px}.v-btn--icon.v-size--default{height:36px;width:36px}.v-btn--icon.v-size--large{height:50px;width:50px}.v-btn--icon.v-size--x-large{height:52px;width:52px}.v-btn--fab.v-btn--absolute,.v-btn--fab.v-btn--fixed{z-index:4}.v-btn--fab.v-size--x-small{height:20px;width:20px}.v-btn--fab.v-size--x-small.v-btn--absolute.v-btn--bottom{bottom:-10px}.v-btn--fab.v-size--x-small.v-btn--absolute.v-btn--top{top:-10px}.v-btn--fab.v-size--small{height:32px;width:32px}.v-btn--fab.v-size--small.v-btn--absolute.v-btn--bottom{bottom:-16px}.v-btn--fab.v-size--small.v-btn--absolute.v-btn--top{top:-16px}.v-btn--fab.v-size--default{height:36px;width:36px}.v-btn--fab.v-size--default.v-btn--absolute.v-btn--bottom{bottom:-18px}.v-btn--fab.v-size--default.v-btn--absolute.v-btn--top{top:-18px}.v-btn--fab.v-size--large{height:50px;width:50px}.v-btn--fab.v-size--large.v-btn--absolute.v-btn--bottom{bottom:-25px}.v-btn--fab.v-size--large.v-btn--absolute.v-btn--top{top:-25px}.v-btn--fab.v-size--x-large{height:52px;width:52px}.v-btn--fab.v-size--x-large.v-btn--absolute.v-btn--bottom{bottom:-26px}.v-btn--fab.v-size--x-large.v-btn--absolute.v-btn--top{top:-26px}.v-btn--loading{pointer-events:none;transition:none}.v-btn--loading .v-btn__content{opacity:0}.v-btn--outlined{border:1px solid currentColor}.v-btn--plain:before{display:none}.v-btn--plain:not(.v-btn--active):not(.v-btn--loading):not(:focus):not(:hover) .v-btn__content{opacity:.62}.v-btn--round{border-radius:50%}.v-btn--rounded{border-radius:28px}.v-btn--tile{border-radius:0}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "ec1f":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("c8d5")

/**
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added
 * @returns {Date} the new date with the milliseconds added
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * var result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */
function addMilliseconds (dirtyDate, dirtyAmount) {
  var timestamp = parse(dirtyDate).getTime()
  var amount = Number(dirtyAmount)
  return new Date(timestamp + amount)
}

module.exports = addMilliseconds


/***/ }),

/***/ "ec29":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("d65d");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("af899772", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "ec3f":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("6074");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("18784d8a", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "ec96":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpSnackBar_vue_vue_type_style_index_0_id_171d6108_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("e9ca");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpSnackBar_vue_vue_type_style_index_0_id_171d6108_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpSnackBar_vue_vue_type_style_index_0_id_171d6108_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "eca2":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("c8d5")

/**
 * @category Month Helpers
 * @summary Return the last day of a month for the given date.
 *
 * @description
 * Return the last day of a month for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the last day of a month
 *
 * @example
 * // The last day of a month for 2 September 2014 11:55:00:
 * var result = lastDayOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 00:00:00
 */
function lastDayOfMonth (dirtyDate) {
  var date = parse(dirtyDate)
  var month = date.getMonth()
  date.setFullYear(date.getFullYear(), month + 1, 0)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = lastDayOfMonth


/***/ }),

/***/ "ed6b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpPageContainer_vue_vue_type_style_index_0_id_3662bbc0_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("7bd2");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpPageContainer_vue_vue_type_style_index_0_id_3662bbc0_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpPageContainer_vue_vue_type_style_index_0_id_3662bbc0_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "ee6f":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("09f6");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("dff37bf8", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "ee70":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("f26a");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("2858ad50", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "ee91":
/***/ (function(module, exports, __webpack_require__) {

var differenceInDays = __webpack_require__("3bc7")

/**
 * @category Week Helpers
 * @summary Get the number of full weeks between the given dates.
 *
 * @description
 * Get the number of full weeks between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of full weeks
 *
 * @example
 * // How many full weeks are between 5 July 2014 and 20 July 2014?
 * var result = differenceInWeeks(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 6, 5)
 * )
 * //=> 2
 */
function differenceInWeeks (dirtyDateLeft, dirtyDateRight) {
  var diff = differenceInDays(dirtyDateLeft, dirtyDateRight) / 7
  return diff > 0 ? Math.floor(diff) : Math.ceil(diff)
}

module.exports = differenceInWeeks


/***/ }),

/***/ "eeac":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c662cfac-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/row/PpRow.vue?vue&type=template&id=075b4dc0&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',_vm._g(_vm._b({},'v-row',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/row/PpRow.vue?vue&type=template&id=075b4dc0&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/row/PpRow.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
/* harmony default export */ var PpRowvue_type_script_lang_js_ = ({
  name: 'PpRow'
});
// CONCATENATED MODULE: ./src/components/row/PpRow.vue?vue&type=script&lang=js&
 /* harmony default export */ var row_PpRowvue_type_script_lang_js_ = (PpRowvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// EXTERNAL MODULE: ./node_modules/vuetify-loader/lib/runtime/installComponents.js
var installComponents = __webpack_require__("6544");
var installComponents_default = /*#__PURE__*/__webpack_require__.n(installComponents);

// EXTERNAL MODULE: ./node_modules/vuetify/lib/components/VGrid/VRow.js
var VRow = __webpack_require__("0fd9");

// CONCATENATED MODULE: ./src/components/row/PpRow.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  row_PpRowvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var PpRow = __webpack_exports__["default"] = (component.exports);

/* vuetify-loader */


installComponents_default()(component, {VRow: VRow["a" /* default */]})


/***/ }),

/***/ "ef3c":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.theme--light.v-input--switch .v-input--switch__thumb{color:#fff}.theme--light.v-input--switch .v-input--switch__track{color:#d6d6d6}.theme--light.v-input--switch.v-input--is-disabled:not(.v-input--is-dirty) .v-input--switch__thumb{color:#fafafa!important}.theme--light.v-input--switch.v-input--is-disabled:not(.v-input--is-dirty) .v-input--switch__track{color:rgba(0,0,0,.12)!important}.theme--dark.v-input--switch .v-input--switch__thumb{color:#9a9a9a}.theme--dark.v-input--switch .v-input--switch__track{color:hsla(0,0%,100%,.3)}.theme--dark.v-input--switch.v-input--is-disabled:not(.v-input--is-dirty) .v-input--switch__thumb{color:#2b2b2b!important}.theme--dark.v-input--switch.v-input--is-disabled:not(.v-input--is-dirty) .v-input--switch__track{color:hsla(0,0%,100%,.1)!important}.v-input--switch__thumb,.v-input--switch__track{background-color:currentColor;pointer-events:none;transition:inherit}.v-input--switch__track{border-radius:8px;width:36px;height:14px;left:var(--pp-switch-track-x,2px);position:absolute;opacity:.6;right:var(--pp-switch-track-x,2px);top:calc(50% - 7px)}.v-input--switch__thumb{border-radius:50%;top:var(--pp-switch-thumb-top,calc(50% - 10px));height:var(--pp-switch-thumb-height,20px);position:relative;width:var(--pp-switch-thumb-width,20px);display:flex;justify-content:center;align-items:center;transition:.3s cubic-bezier(.25,.8,.5,1)}.v-input--switch .v-input--selection-controls__input{width:38px}.v-input--switch .v-input--selection-controls__ripple{top:calc(50% - 24px)}.v-input--switch.v-input--dense .v-input--switch__thumb{width:18px;height:18px}.v-input--switch.v-input--dense .v-input--switch__track{height:12px;width:32px}.v-input--switch.v-input--dense.v-input--switch--inset .v-input--switch__track{height:22px;width:44px;top:calc(50% - 12px);left:-3px}.v-input--switch.v-input--dense .v-input--selection-controls__ripple{top:calc(50% - 22px)}.v-input--switch.v-input--is-dirty.v-input--is-disabled{opacity:1}.v-application--is-ltr .v-input--switch .v-input--selection-controls__ripple{left:-14px}.v-application--is-ltr .v-input--switch.v-input--dense .v-input--selection-controls__ripple{left:-12px}.v-application--is-ltr .v-input--switch.v-input--is-dirty .v-input--selection-controls__ripple,.v-application--is-ltr .v-input--switch.v-input--is-dirty .v-input--switch__thumb{transform:translate(20px)}.v-application--is-rtl .v-input--switch .v-input--selection-controls__ripple{right:-14px}.v-application--is-rtl .v-input--switch.v-input--dense .v-input--selection-controls__ripple{right:-12px}.v-application--is-rtl .v-input--switch.v-input--is-dirty .v-input--selection-controls__ripple,.v-application--is-rtl .v-input--switch.v-input--is-dirty .v-input--switch__thumb{transform:translate(-20px)}.v-input--switch:not(.v-input--switch--flat):not(.v-input--switch--inset) .v-input--switch__thumb{box-shadow:0 2px 4px -1px transparent,0 4px 5px 0 transparent,0 1px 10px 0 rgba(0,0,0,.12)}.v-input--switch--inset .v-input--selection-controls__input,.v-input--switch--inset .v-input--switch__track{width:var(--pp-switch-track-width,48px)}.v-input--switch--inset .v-input--switch__track{border-radius:14px;height:var(--pp-switch-track-height,28px);left:-4px;opacity:1;top:calc(50% - var(--pp-switch-track-height, 28px)/2)}.v-application--is-ltr .v-input--switch--inset .v-input--selection-controls__ripple,.v-application--is-ltr .v-input--switch--inset .v-input--switch__thumb{transform:translate(0)!important}.v-application--is-rtl .v-input--switch--inset .v-input--selection-controls__ripple,.v-application--is-rtl .v-input--switch--inset .v-input--switch__thumb{transform:translate(-6px)!important}.v-application--is-ltr .v-input--switch--inset.v-input--is-dirty .v-input--selection-controls__ripple,.v-application--is-ltr .v-input--switch--inset.v-input--is-dirty .v-input--switch__thumb{transform:translate(20px)!important}.v-application--is-rtl .v-input--switch--inset.v-input--is-dirty .v-input--selection-controls__ripple,.v-application--is-rtl .v-input--switch--inset.v-input--is-dirty .v-input--switch__thumb{transform:translate(-26px)!important}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "efbd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c662cfac-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/loading-icon/PpLoadingIcon.vue?vue&type=template&id=18424fb7&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{staticClass:"pp-loading-icon"},[_c('img',{attrs:{"alt":"loading","height":"100%","src":"https://ui-cdn.patientpop.com/assets/animation/tebra-logo.svg","width":"100%"}})])])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/loading-icon/PpLoadingIcon.vue?vue&type=template&id=18424fb7&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/loading-icon/PpLoadingIcon.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * Tebra Loading icon
 */
/* harmony default export */ var PpLoadingIconvue_type_script_lang_js_ = ({
  name: 'PpLoadingIcon'
});
// CONCATENATED MODULE: ./src/components/loading-icon/PpLoadingIcon.vue?vue&type=script&lang=js&
 /* harmony default export */ var loading_icon_PpLoadingIconvue_type_script_lang_js_ = (PpLoadingIconvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/loading-icon/PpLoadingIcon.vue?vue&type=style&index=0&id=18424fb7&lang=scss&scoped=true&
var PpLoadingIconvue_type_style_index_0_id_18424fb7_lang_scss_scoped_true_ = __webpack_require__("110d0");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/loading-icon/PpLoadingIcon.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  loading_icon_PpLoadingIconvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "18424fb7",
  null
  
)

/* harmony default export */ var PpLoadingIcon = __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "f069":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__("1c0b");

var PromiseCapability = function (C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
};

// 25.4.1.5 NewPromiseCapability(C)
module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),

/***/ "f110":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M21.1608 18.0894C20.1079 19.6733 18.6622 20.9572 16.965 21.8157C15.2678 22.6742 13.377 23.078 11.4772 22.9876C9.57739 22.8972 7.73346 22.3157 6.12543 21.3C4.51741 20.2842 3.20023 18.8689 2.30248 17.1921C1.40473 15.5153 0.95708 13.6345 1.00324 11.733C1.0494 9.83162 1.58779 7.97467 2.56584 6.34344C3.5439 4.71221 4.92821 3.36245 6.58363 2.42592C8.23905 1.4894 10.109 0.998105 12.011 1.00001L12 12L21.1608 18.0894Z\" fill=\"white\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19Z\" fill=\"#DFE4E5\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M14.293 15.707L11.293 12.707C11.105 12.519 11 12.265 11 12V7H13V11.586L15.707 14.293L14.293 15.707Z\" fill=\"#1F3A3E\"></path><path d=\"M21.1462 18.1113C21.453 17.6521 21.3295 17.0311 20.8703 16.7242C20.4111 16.4174 19.7901 16.5409 19.4832 17.0001L21.1462 18.1113ZM4.92894 19.0711L5.63604 18.364L4.92894 19.0711ZM2.76121 8.17317L1.83733 7.79048H1.83733L2.76121 8.17317ZM19.4832 17.0001C18.4943 18.4802 17.0887 19.6337 15.4442 20.3149L16.2095 22.1627C18.2195 21.3301 19.9375 19.9202 21.1462 18.1113L19.4832 17.0001ZM15.4442 20.3149C13.7996 20.9961 11.99 21.1743 10.2442 20.8271L9.85401 22.7886C11.9878 23.2131 14.1995 22.9952 16.2095 22.1627L15.4442 20.3149ZM10.2442 20.8271C8.49836 20.4798 6.89472 19.6226 5.63604 18.364L4.22183 19.7782C5.76021 21.3166 7.72022 22.3642 9.85401 22.7886L10.2442 20.8271ZM5.63604 18.364C4.37737 17.1053 3.5202 15.5016 3.17294 13.7558L1.21137 14.146C1.6358 16.2798 2.68345 18.2398 4.22183 19.7782L5.63604 18.364ZM3.17294 13.7558C2.82567 12.01 3.0039 10.2004 3.68509 8.55585L1.83733 7.79048C1.00477 9.80047 0.786929 12.0122 1.21137 14.146L3.17294 13.7558ZM3.68509 8.55585C4.36628 6.91131 5.51983 5.50571 6.99987 4.51677L5.88873 2.85383C4.07979 4.06253 2.66989 5.7805 1.83733 7.79048L3.68509 8.55585ZM6.99987 4.51677C8.47992 3.52784 10.22 3 12 3V1C9.82441 1 7.69767 1.64514 5.88873 2.85383L6.99987 4.51677Z\" fill=\"#1F3A3E\"></path><circle cx=\"12\" cy=\"2\" r=\"1\" fill=\"#1F3A3E\"></circle><circle cx=\"17.0254\" cy=\"3.35254\" r=\"1\" fill=\"#1F3A3E\"></circle><circle cx=\"22\" cy=\"12\" r=\"1\" fill=\"#1F3A3E\"></circle><circle cx=\"20.6035\" cy=\"6.87402\" r=\"1\" fill=\"#1F3A3E\"></circle></svg>";

/***/ }),

/***/ "f140":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.i, "@import url(https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css);"]);
exports.push([module.i, "@import url(https://cdn-prd.patientpop.com/pp-icon-font/v1.6.0/pp-icon-font.css);"]);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.main-button--placerholder[data-v-5da7e4ca]{color:#545454;font-style:italic;font-weight:400}.main-button[data-v-5da7e4ca]  .pp-icon-chevron-down{margin-top:2px;transition:.2s ease-in-out}.main-button[data-v-5da7e4ca]  .pp-icon-chevron-down:before{font-weight:700!important}.main-button[data-v-5da7e4ca]  .pp-icon-schedule{font-size:1rem;margin-top:1px}.main-button--open[data-v-5da7e4ca]{background:none;border:2px solid #079cb2}.main-button--open[data-v-5da7e4ca]  .pp-icon-chevron-down{margin-top:0;transform:rotate(180deg)}.main-button--open[data-v-5da7e4ca]  .pp-icon-schedule{color:#067889}.date-range[data-v-5da7e4ca]{position:relative}.calendar[data-v-5da7e4ca]{background:#fff;border-radius:4px;box-shadow:0 5px 5px -3px rgba(0,0,0,.2),0 3px 14px 2px rgba(0,0,0,.12),0 8px 10px 1px rgba(0,0,0,.14);display:block;font-size:.8571428571rem;position:absolute;top:44px;width:52.1428571429rem;z-index:9}.calendar--open-left[data-v-5da7e4ca]{right:0}@media(max-width:670px){.calendar[data-v-5da7e4ca]{width:19.2857142857rem}.calendar--open-left[data-v-5da7e4ca]{right:auto}}.calendar__icon[data-v-5da7e4ca]{font-size:1rem;margin-top:1px}.border--right[data-v-5da7e4ca]{border-right:1px solid #d6d6d6}.border--bottom[data-v-5da7e4ca]{border-bottom:1px solid #d6d6d6}.border--top[data-v-5da7e4ca]{border-top:1px solid #d6d6d6}.clear[data-v-5da7e4ca]{background-color:#f6f6f6;border-radius:100%;cursor:pointer;font-size:.7142857143rem;height:1.4285714286rem;padding:0;position:relative;transform:none;width:1.4285714286rem}.clear[data-v-5da7e4ca]:hover{background-color:#d6d6d6}.presets[data-v-5da7e4ca]{list-style-type:none;padding:10px 0}.presets li[data-v-5da7e4ca]{border-radius:1.3571428571rem;cursor:pointer;font-size:.9285714286rem;font-weight:700;height:2.5rem;line-height:2.5rem}.presets .active[data-v-5da7e4ca]{background:#83cdd9;color:#067889}.presets .icon[data-v-5da7e4ca]{font-size:.8571428571rem;padding-top:.1428571429rem}.date--inline[data-v-5da7e4ca]{color:#2b2b2b;font-weight:700}.date--placeholder span[data-v-5da7e4ca]{color:#545454;font-style:italic;font-weight:400}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "f141":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M11 8L22 3V21L11 16V8Z\" fill=\"#DFE4E5\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M21 2C20.4477 2 20 2.44772 20 3V3.90909L11 8H5C3.34315 8 2 9.34315 2 11V13C2 14.6569 3.34315 16 5 16H5.25L5.78101 20.2481C5.90612 21.2489 6.75692 22 7.76556 22H9.43845C9.60197 22 9.76488 21.9799 9.92352 21.9403C10.9951 21.6724 11.6466 20.5865 11.3787 19.5149L10.5 16H11L20 20.0909V21C20 21.5523 20.4477 22 21 22C21.5523 22 22 21.5523 22 21V3C22 2.44772 21.5523 2 21 2ZM20 17.894V6.105L13 9.287V14.712L20 17.894Z\" fill=\"#688083\"></path><path d=\"M11 14V10H5C4.48716 10 4.06449 10.386 4.00673 10.8834L4 11V13C4 13.5128 4.38604 13.9355 4.88338 13.9933L5 14H11Z\" fill=\"white\"></path><path d=\"M8.43862 16H7.26562L7.76619 20H9.43907L8.43862 16Z\" fill=\"white\"></path></svg>";

/***/ }),

/***/ "f183":
/***/ (function(module, exports, __webpack_require__) {

var hiddenKeys = __webpack_require__("d012");
var isObject = __webpack_require__("861d");
var has = __webpack_require__("5135");
var defineProperty = __webpack_require__("9bf2").f;
var uid = __webpack_require__("90e3");
var FREEZING = __webpack_require__("bb2f");

var METADATA = uid('meta');
var id = 0;

var isExtensible = Object.isExtensible || function () {
  return true;
};

var setMetadata = function (it) {
  defineProperty(it, METADATA, { value: {
    objectID: 'O' + ++id, // object ID
    weakData: {}          // weak collections IDs
  } });
};

var fastKey = function (it, create) {
  // return a primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, METADATA)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMetadata(it);
  // return object ID
  } return it[METADATA].objectID;
};

var getWeakData = function (it, create) {
  if (!has(it, METADATA)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMetadata(it);
  // return the store of weak collections IDs
  } return it[METADATA].weakData;
};

// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZING && meta.REQUIRED && isExtensible(it) && !has(it, METADATA)) setMetadata(it);
  return it;
};

var meta = module.exports = {
  REQUIRED: false,
  fastKey: fastKey,
  getWeakData: getWeakData,
  onFreeze: onFreeze
};

hiddenKeys[METADATA] = true;


/***/ }),

/***/ "f1e0":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.i, "@import url(https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css);"]);
exports.push([module.i, "@import url(https://cdn-prd.patientpop.com/pp-icon-font/v1.6.0/pp-icon-font.css);"]);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.close-button[data-v-8d2ba264]{--active-icon:#545454;font-size:1.5rem;right:1.125rem;top:1.25rem}.display-dialog-content__title[data-v-8d2ba264]{border-bottom:1px solid #d6d6d6}.display-dialog-content__body[data-v-8d2ba264]{--pp-text-secondary:#2b2b2b}.display-dialog-content__actions[data-v-8d2ba264]{background:#fff;border-top:none;bottom:0;position:sticky}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "f24b":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("9373");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("5f10c692", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "f26a":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, "html{overflow-y:auto!important}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "f2e7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return factory; });
/* harmony import */ var _home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ade3");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("8bbf");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_1__);


function factory() {
  var _watch;

  var prop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'value';
  var event = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'input';
  return vue__WEBPACK_IMPORTED_MODULE_1___default.a.extend({
    name: 'toggleable',
    model: {
      prop: prop,
      event: event
    },
    props: Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({}, prop, {
      required: false
    }),
    data: function data() {
      return {
        isActive: !!this[prop]
      };
    },
    watch: (_watch = {}, Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_watch, prop, function (val) {
      this.isActive = !!val;
    }), Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_watch, "isActive", function isActive(val) {
      !!val !== this[prop] && this.$emit(event, val);
    }), _watch)
  });
}
/* eslint-disable-next-line @typescript-eslint/no-redeclare */

var Toggleable = factory();
/* harmony default export */ __webpack_exports__["a"] = (Toggleable);

/***/ }),

/***/ "f44b":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.theme--light.v-skeleton-loader .v-skeleton-loader__bone:after{background:linear-gradient(90deg,hsla(0,0%,100%,0),hsla(0,0%,100%,.3),hsla(0,0%,100%,0))}.theme--light.v-skeleton-loader .v-skeleton-loader__avatar,.theme--light.v-skeleton-loader .v-skeleton-loader__button,.theme--light.v-skeleton-loader .v-skeleton-loader__chip,.theme--light.v-skeleton-loader .v-skeleton-loader__divider,.theme--light.v-skeleton-loader .v-skeleton-loader__heading,.theme--light.v-skeleton-loader .v-skeleton-loader__image,.theme--light.v-skeleton-loader .v-skeleton-loader__text{background:#d6d6d6}.theme--light.v-skeleton-loader .v-skeleton-loader__actions,.theme--light.v-skeleton-loader .v-skeleton-loader__article,.theme--light.v-skeleton-loader .v-skeleton-loader__card-heading,.theme--light.v-skeleton-loader .v-skeleton-loader__card-text,.theme--light.v-skeleton-loader .v-skeleton-loader__date-picker,.theme--light.v-skeleton-loader .v-skeleton-loader__list-item,.theme--light.v-skeleton-loader .v-skeleton-loader__list-item-avatar,.theme--light.v-skeleton-loader .v-skeleton-loader__list-item-avatar-three-line,.theme--light.v-skeleton-loader .v-skeleton-loader__list-item-avatar-two-line,.theme--light.v-skeleton-loader .v-skeleton-loader__list-item-text,.theme--light.v-skeleton-loader .v-skeleton-loader__list-item-three-line,.theme--light.v-skeleton-loader .v-skeleton-loader__list-item-two-line,.theme--light.v-skeleton-loader .v-skeleton-loader__table-heading,.theme--light.v-skeleton-loader .v-skeleton-loader__table-tbody,.theme--light.v-skeleton-loader .v-skeleton-loader__table-tfoot,.theme--light.v-skeleton-loader .v-skeleton-loader__table-thead{background:var(--cards-color,#fff)}.theme--dark.v-skeleton-loader .v-skeleton-loader__bone:after{background:linear-gradient(90deg,hsla(0,0%,100%,0),hsla(0,0%,100%,.05),hsla(0,0%,100%,0))}.theme--dark.v-skeleton-loader .v-skeleton-loader__avatar,.theme--dark.v-skeleton-loader .v-skeleton-loader__button,.theme--dark.v-skeleton-loader .v-skeleton-loader__chip,.theme--dark.v-skeleton-loader .v-skeleton-loader__divider,.theme--dark.v-skeleton-loader .v-skeleton-loader__heading,.theme--dark.v-skeleton-loader .v-skeleton-loader__image,.theme--dark.v-skeleton-loader .v-skeleton-loader__text{background:hsla(0,0%,100%,.12)}.theme--dark.v-skeleton-loader .v-skeleton-loader__actions,.theme--dark.v-skeleton-loader .v-skeleton-loader__article,.theme--dark.v-skeleton-loader .v-skeleton-loader__card-heading,.theme--dark.v-skeleton-loader .v-skeleton-loader__card-text,.theme--dark.v-skeleton-loader .v-skeleton-loader__date-picker,.theme--dark.v-skeleton-loader .v-skeleton-loader__list-item,.theme--dark.v-skeleton-loader .v-skeleton-loader__list-item-avatar,.theme--dark.v-skeleton-loader .v-skeleton-loader__list-item-avatar-three-line,.theme--dark.v-skeleton-loader .v-skeleton-loader__list-item-avatar-two-line,.theme--dark.v-skeleton-loader .v-skeleton-loader__list-item-text,.theme--dark.v-skeleton-loader .v-skeleton-loader__list-item-three-line,.theme--dark.v-skeleton-loader .v-skeleton-loader__list-item-two-line,.theme--dark.v-skeleton-loader .v-skeleton-loader__table-heading,.theme--dark.v-skeleton-loader .v-skeleton-loader__table-tbody,.theme--dark.v-skeleton-loader .v-skeleton-loader__table-tfoot,.theme--dark.v-skeleton-loader .v-skeleton-loader__table-thead{background:#1e1e1e}.v-skeleton-loader{border-radius:5px;position:relative;vertical-align:top}.v-skeleton-loader__actions{padding:16px 16px 8px;text-align:right}.v-skeleton-loader__actions .v-skeleton-loader__button{display:inline-block}.v-application--is-ltr .v-skeleton-loader__actions .v-skeleton-loader__button:first-child{margin-right:12px}.v-application--is-rtl .v-skeleton-loader__actions .v-skeleton-loader__button:first-child{margin-left:12px}.v-skeleton-loader .v-skeleton-loader__list-item,.v-skeleton-loader .v-skeleton-loader__list-item-avatar,.v-skeleton-loader .v-skeleton-loader__list-item-avatar-three-line,.v-skeleton-loader .v-skeleton-loader__list-item-avatar-two-line,.v-skeleton-loader .v-skeleton-loader__list-item-text,.v-skeleton-loader .v-skeleton-loader__list-item-three-line,.v-skeleton-loader .v-skeleton-loader__list-item-two-line{border-radius:5px}.v-skeleton-loader .v-skeleton-loader__actions:after,.v-skeleton-loader .v-skeleton-loader__article:after,.v-skeleton-loader .v-skeleton-loader__card-avatar:after,.v-skeleton-loader .v-skeleton-loader__card-heading:after,.v-skeleton-loader .v-skeleton-loader__card-text:after,.v-skeleton-loader .v-skeleton-loader__card:after,.v-skeleton-loader .v-skeleton-loader__date-picker-days:after,.v-skeleton-loader .v-skeleton-loader__date-picker-options:after,.v-skeleton-loader .v-skeleton-loader__date-picker:after,.v-skeleton-loader .v-skeleton-loader__list-item-avatar-three-line:after,.v-skeleton-loader .v-skeleton-loader__list-item-avatar-two-line:after,.v-skeleton-loader .v-skeleton-loader__list-item-avatar:after,.v-skeleton-loader .v-skeleton-loader__list-item-text:after,.v-skeleton-loader .v-skeleton-loader__list-item-three-line:after,.v-skeleton-loader .v-skeleton-loader__list-item-two-line:after,.v-skeleton-loader .v-skeleton-loader__list-item:after,.v-skeleton-loader .v-skeleton-loader__paragraph:after,.v-skeleton-loader .v-skeleton-loader__sentences:after,.v-skeleton-loader .v-skeleton-loader__table-cell:after,.v-skeleton-loader .v-skeleton-loader__table-heading:after,.v-skeleton-loader .v-skeleton-loader__table-row-divider:after,.v-skeleton-loader .v-skeleton-loader__table-row:after,.v-skeleton-loader .v-skeleton-loader__table-tbody:after,.v-skeleton-loader .v-skeleton-loader__table-tfoot:after,.v-skeleton-loader .v-skeleton-loader__table-thead:after,.v-skeleton-loader .v-skeleton-loader__table:after{display:none}.v-application--is-ltr .v-skeleton-loader__article .v-skeleton-loader__heading{margin:16px 0 16px 16px}.v-application--is-rtl .v-skeleton-loader__article .v-skeleton-loader__heading{margin:16px 16px 0 16px}.v-skeleton-loader__article .v-skeleton-loader__paragraph{padding:16px}.v-skeleton-loader__bone{border-radius:inherit;overflow:hidden;position:relative}.v-skeleton-loader__bone:after{-webkit-animation:loading 1.5s infinite;animation:loading 1.5s infinite;content:\"\";height:100%;left:0;position:absolute;right:0;top:0;transform:translateX(-100%);z-index:1}.v-skeleton-loader__avatar{border-radius:50%;height:48px;width:48px}.v-skeleton-loader__button{border-radius:5px;height:36px;width:64px}.v-skeleton-loader__card .v-skeleton-loader__image{border-radius:0}.v-skeleton-loader__card-heading .v-skeleton-loader__heading{margin:16px}.v-skeleton-loader__card-text{padding:16px}.v-skeleton-loader__chip{border-radius:16px;height:32px;width:96px}.v-skeleton-loader__date-picker{border-radius:inherit}.v-skeleton-loader__date-picker .v-skeleton-loader__list-item:first-child .v-skeleton-loader__text{max-width:88px;width:20%}.v-skeleton-loader__date-picker .v-skeleton-loader__heading{max-width:256px;width:40%}.v-skeleton-loader__date-picker-days{display:flex;flex-wrap:wrap;padding:0 12px;margin:0 auto}.v-skeleton-loader__date-picker-days .v-skeleton-loader__avatar{border-radius:5px;flex:1 1 auto;margin:4px;height:40px;width:40px}.v-skeleton-loader__date-picker-options{align-items:center;display:flex;padding:16px}.v-skeleton-loader__date-picker-options .v-skeleton-loader__avatar{height:40px;width:40px}.v-skeleton-loader__date-picker-options .v-skeleton-loader__avatar:nth-child(2){margin-left:auto}.v-application--is-ltr .v-skeleton-loader__date-picker-options .v-skeleton-loader__avatar:nth-child(2){margin-right:8px}.v-application--is-rtl .v-skeleton-loader__date-picker-options .v-skeleton-loader__avatar:nth-child(2){margin-left:8px}.v-skeleton-loader__date-picker-options .v-skeleton-loader__text.v-skeleton-loader__bone:first-child{margin-bottom:0;max-width:50%;width:456px}.v-skeleton-loader__divider{border-radius:1px;height:2px}.v-skeleton-loader__heading{border-radius:12px;height:24px;width:45%}.v-skeleton-loader__image{height:200px;border-radius:0}.v-skeleton-loader__image~.v-skeleton-loader__card-heading{border-radius:0}.v-skeleton-loader__image::first-child,.v-skeleton-loader__image::last-child{border-radius:inherit}.v-skeleton-loader__list-item{height:48px}.v-skeleton-loader__list-item-three-line{flex-wrap:wrap}.v-skeleton-loader__list-item-three-line>*{flex:1 0 100%;width:100%}.v-skeleton-loader__list-item-avatar-three-line .v-skeleton-loader__avatar,.v-skeleton-loader__list-item-avatar-two-line .v-skeleton-loader__avatar,.v-skeleton-loader__list-item-avatar .v-skeleton-loader__avatar{height:40px;width:40px}.v-skeleton-loader__list-item-avatar{height:48px}.v-skeleton-loader__list-item-avatar-two-line,.v-skeleton-loader__list-item-two-line{height:72px}.v-skeleton-loader__list-item-avatar-three-line,.v-skeleton-loader__list-item-three-line{height:88px}.v-skeleton-loader__list-item-avatar-three-line .v-skeleton-loader__avatar{align-self:flex-start}.v-skeleton-loader__list-item,.v-skeleton-loader__list-item-avatar,.v-skeleton-loader__list-item-avatar-three-line,.v-skeleton-loader__list-item-avatar-two-line,.v-skeleton-loader__list-item-three-line,.v-skeleton-loader__list-item-two-line{align-content:center;align-items:center;display:flex;flex-wrap:wrap;padding:0 16px}.v-application--is-ltr .v-skeleton-loader__list-item-avatar-three-line .v-skeleton-loader__avatar,.v-application--is-ltr .v-skeleton-loader__list-item-avatar-two-line .v-skeleton-loader__avatar,.v-application--is-ltr .v-skeleton-loader__list-item-avatar .v-skeleton-loader__avatar,.v-application--is-ltr .v-skeleton-loader__list-item-three-line .v-skeleton-loader__avatar,.v-application--is-ltr .v-skeleton-loader__list-item-two-line .v-skeleton-loader__avatar,.v-application--is-ltr .v-skeleton-loader__list-item .v-skeleton-loader__avatar{margin-right:16px}.v-application--is-rtl .v-skeleton-loader__list-item-avatar-three-line .v-skeleton-loader__avatar,.v-application--is-rtl .v-skeleton-loader__list-item-avatar-two-line .v-skeleton-loader__avatar,.v-application--is-rtl .v-skeleton-loader__list-item-avatar .v-skeleton-loader__avatar,.v-application--is-rtl .v-skeleton-loader__list-item-three-line .v-skeleton-loader__avatar,.v-application--is-rtl .v-skeleton-loader__list-item-two-line .v-skeleton-loader__avatar,.v-application--is-rtl .v-skeleton-loader__list-item .v-skeleton-loader__avatar{margin-left:16px}.v-skeleton-loader__list-item-avatar-three-line .v-skeleton-loader__text:last-child,.v-skeleton-loader__list-item-avatar-three-line .v-skeleton-loader__text:only-child,.v-skeleton-loader__list-item-avatar-two-line .v-skeleton-loader__text:last-child,.v-skeleton-loader__list-item-avatar-two-line .v-skeleton-loader__text:only-child,.v-skeleton-loader__list-item-avatar .v-skeleton-loader__text:last-child,.v-skeleton-loader__list-item-avatar .v-skeleton-loader__text:only-child,.v-skeleton-loader__list-item-three-line .v-skeleton-loader__text:last-child,.v-skeleton-loader__list-item-three-line .v-skeleton-loader__text:only-child,.v-skeleton-loader__list-item-two-line .v-skeleton-loader__text:last-child,.v-skeleton-loader__list-item-two-line .v-skeleton-loader__text:only-child,.v-skeleton-loader__list-item .v-skeleton-loader__text:last-child,.v-skeleton-loader__list-item .v-skeleton-loader__text:only-child{margin-bottom:0}.v-skeleton-loader__paragraph,.v-skeleton-loader__sentences{flex:1 0 auto}.v-skeleton-loader__paragraph:not(:last-child){margin-bottom:6px}.v-skeleton-loader__paragraph .v-skeleton-loader__text:first-child{max-width:100%}.v-skeleton-loader__paragraph .v-skeleton-loader__text:nth-child(2){max-width:50%}.v-skeleton-loader__paragraph .v-skeleton-loader__text:nth-child(3),.v-skeleton-loader__sentences .v-skeleton-loader__text:nth-child(2){max-width:70%}.v-skeleton-loader__sentences:not(:last-child){margin-bottom:6px}.v-skeleton-loader__table-heading{align-items:center;display:flex;justify-content:space-between;padding:16px}.v-skeleton-loader__table-heading .v-skeleton-loader__heading{max-width:15%}.v-skeleton-loader__table-heading .v-skeleton-loader__text{max-width:40%}.v-skeleton-loader__table-thead{display:flex;justify-content:space-between;padding:16px}.v-skeleton-loader__table-thead .v-skeleton-loader__heading{max-width:5%}.v-skeleton-loader__table-tbody{padding:16px 16px 0}.v-skeleton-loader__table-tfoot{align-items:center;display:flex;justify-content:flex-end;padding:16px}.v-application--is-ltr .v-skeleton-loader__table-tfoot>*{margin-left:8px}.v-application--is-rtl .v-skeleton-loader__table-tfoot>*{margin-right:8px}.v-skeleton-loader__table-tfoot .v-skeleton-loader__avatar{height:40px;width:40px}.v-skeleton-loader__table-tfoot .v-skeleton-loader__text{margin-bottom:0}.v-skeleton-loader__table-tfoot .v-skeleton-loader__text:first-child{max-width:128px}.v-skeleton-loader__table-tfoot .v-skeleton-loader__text:nth-child(2){max-width:64px}.v-skeleton-loader__table-row{display:flex;justify-content:space-between}.v-skeleton-loader__table-cell{align-items:center;display:flex;height:48px;width:88px}.v-skeleton-loader__table-cell .v-skeleton-loader__text{margin-bottom:0}.v-skeleton-loader__text{border-radius:6px;flex:1 0 auto;height:12px;margin-bottom:6px}.v-skeleton-loader--boilerplate .v-skeleton-loader__bone:after{display:none}.v-skeleton-loader--is-loading{overflow:hidden}.v-skeleton-loader--tile,.v-skeleton-loader--tile .v-skeleton-loader__bone{border-radius:0}@-webkit-keyframes loading{to{transform:translateX(100%)}}@keyframes loading{to{transform:translateX(100%)}}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "f498":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c662cfac-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/avatar-location/PpAvatarLocation.vue?vue&type=template&id=48cb5300&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pp-avatar-location d-flex align-center"},[_c('v-avatar',{staticClass:"mr-3",attrs:{"color":_vm.AVATAR_COLOR,"size":48,"rounded":""}},[_c('span',{staticClass:"grey--text text--darken-2 text-uppercase font-weight-bold"},[_vm._v(" "+_vm._s(_vm.initials)+" ")])]),(_vm.address)?_c('div',{staticClass:"pp-avatar-location__address text-truncate"},[_c('h6',{staticClass:"text-h6 font-weight-bold text-truncate"},[_vm._v(" "+_vm._s(_vm.name)+" ")]),_c('p',{staticClass:"mb-0 text-h6 text-truncate"},[_vm._v(" "+_vm._s(_vm.address)+" ")])]):_vm._e()],1)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/avatar-location/PpAvatarLocation.vue?vue&type=template&id=48cb5300&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("b0c0");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__("ac1f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.split.js
var es_string_split = __webpack_require__("1276");

// EXTERNAL MODULE: ./src/styles/colors.scss
var colors = __webpack_require__("1c98");
var colors_default = /*#__PURE__*/__webpack_require__.n(colors);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/avatar-location/PpAvatarLocation.vue?vue&type=script&lang=js&



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var PpAvatarLocationvue_type_script_lang_js_ = ({
  name: 'PpAvatarLocation',
  props: {
    name: {
      type: String,
      required: true
    },
    address: {
      type: String,
      default: ''
    }
  },
  computed: {
    initials: function initials() {
      var nameArray = this.name.split(' ');
      return nameArray[1] ? nameArray[0].charAt(0) + nameArray[1].charAt(0) : nameArray[0].charAt(0);
    }
  },
  created: function created() {
    this.AVATAR_COLOR = colors_default.a.avatarDefault;
  }
});
// CONCATENATED MODULE: ./src/components/avatar-location/PpAvatarLocation.vue?vue&type=script&lang=js&
 /* harmony default export */ var avatar_location_PpAvatarLocationvue_type_script_lang_js_ = (PpAvatarLocationvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// EXTERNAL MODULE: ./node_modules/vuetify-loader/lib/runtime/installComponents.js
var installComponents = __webpack_require__("6544");
var installComponents_default = /*#__PURE__*/__webpack_require__.n(installComponents);

// EXTERNAL MODULE: ./node_modules/vuetify/lib/components/VAvatar/VAvatar.js
var VAvatar = __webpack_require__("8212");

// CONCATENATED MODULE: ./src/components/avatar-location/PpAvatarLocation.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  avatar_location_PpAvatarLocationvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var PpAvatarLocation = __webpack_exports__["default"] = (component.exports);

/* vuetify-loader */


installComponents_default()(component, {VAvatar: VAvatar["a" /* default */]})


/***/ }),

/***/ "f4b7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c662cfac-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/app/PpApp.vue?vue&type=template&id=7ccadf14&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-application v-application--is-ltr theme--light pp-app",class:{'pp-app--full-height' : _vm.fullHeight},attrs:{"id":"app","data-app":"true"}},[_vm._t("default")],2)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/app/PpApp.vue?vue&type=template&id=7ccadf14&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/app/PpApp.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var PpAppvue_type_script_lang_js_ = ({
  name: 'PpApp',
  props: {
    /* For some layouts, need to force height 100% */
    fullHeight: {
      type: Boolean,
      default: false
    }
  }
});
// CONCATENATED MODULE: ./src/components/app/PpApp.vue?vue&type=script&lang=js&
 /* harmony default export */ var app_PpAppvue_type_script_lang_js_ = (PpAppvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/app/PpApp.vue?vue&type=style&index=0&lang=css&
var PpAppvue_type_style_index_0_lang_css_ = __webpack_require__("f5f8");

// EXTERNAL MODULE: ./src/components/app/PpApp.vue?vue&type=style&index=1&lang=scss&
var PpAppvue_type_style_index_1_lang_scss_ = __webpack_require__("3f61");

// EXTERNAL MODULE: ./src/components/app/PpApp.vue?vue&type=style&index=2&id=7ccadf14&lang=scss&scoped=true&
var PpAppvue_type_style_index_2_id_7ccadf14_lang_scss_scoped_true_ = __webpack_require__("8a01");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/app/PpApp.vue








/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  app_PpAppvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "7ccadf14",
  null
  
)

/* harmony default export */ var PpApp = __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "f507":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.i, "@import url(https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css);"]);
exports.push([module.i, "@import url(https://cdn-prd.patientpop.com/pp-icon-font/v1.6.0/pp-icon-font.css);"]);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.pp-input-avatar__wrapper[data-v-1cb9db2c]{transition:all .2s linear}.pp-input-avatar[data-v-1cb9db2c]{height:156px}.pp-input-avatar__delete-icon[data-v-1cb9db2c]{color:#fff}.pp-input-avatar__delete-label[data-v-1cb9db2c]{color:#fff;font-size:.875rem}.pp-input-avatar__delete-overlay[data-v-1cb9db2c]{background-color:rgba(43,43,43,.6);border-radius:50%;cursor:pointer;height:100%;position:absolute;width:100%}.pp-input-avatar__input[data-v-1cb9db2c]{display:none}.pp-input-avatar__upload-button[data-v-1cb9db2c]{font-size:.875rem;width:156px}.pp-input-avatar__wrapper[data-v-1cb9db2c]{background-color:#f6f6f6;border-radius:50%;height:100%;position:relative}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "f564":
/***/ (function(module, exports, __webpack_require__) {

var startOfMinute = __webpack_require__("e96b")

/**
 * @category Minute Helpers
 * @summary Are the given dates in the same minute?
 *
 * @description
 * Are the given dates in the same minute?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same minute
 *
 * @example
 * // Are 4 September 2014 06:30:00 and 4 September 2014 06:30:15
 * // in the same minute?
 * var result = isSameMinute(
 *   new Date(2014, 8, 4, 6, 30),
 *   new Date(2014, 8, 4, 6, 30, 15)
 * )
 * //=> true
 */
function isSameMinute (dirtyDateLeft, dirtyDateRight) {
  var dateLeftStartOfMinute = startOfMinute(dirtyDateLeft)
  var dateRightStartOfMinute = startOfMinute(dirtyDateRight)

  return dateLeftStartOfMinute.getTime() === dateRightStartOfMinute.getTime()
}

module.exports = isSameMinute


/***/ }),

/***/ "f56a":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("c8d5")

/**
 * @category Range Helpers
 * @summary Is the given date within the range?
 *
 * @description
 * Is the given date within the range?
 *
 * @param {Date|String|Number} date - the date to check
 * @param {Date|String|Number} startDate - the start of range
 * @param {Date|String|Number} endDate - the end of range
 * @returns {Boolean} the date is within the range
 * @throws {Error} startDate cannot be after endDate
 *
 * @example
 * // For the date within the range:
 * isWithinRange(
 *   new Date(2014, 0, 3), new Date(2014, 0, 1), new Date(2014, 0, 7)
 * )
 * //=> true
 *
 * @example
 * // For the date outside of the range:
 * isWithinRange(
 *   new Date(2014, 0, 10), new Date(2014, 0, 1), new Date(2014, 0, 7)
 * )
 * //=> false
 */
function isWithinRange (dirtyDate, dirtyStartDate, dirtyEndDate) {
  var time = parse(dirtyDate).getTime()
  var startTime = parse(dirtyStartDate).getTime()
  var endTime = parse(dirtyEndDate).getTime()

  if (startTime > endTime) {
    throw new Error('The start of the range cannot be after the end of the range')
  }

  return time >= startTime && time <= endTime
}

module.exports = isWithinRange


/***/ }),

/***/ "f573":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("a9e3");
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("d3b7");
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("e6cf");
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("5530");
/* harmony import */ var _positionable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("fe6c");
/* harmony import */ var _stackable__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("21be");
/* harmony import */ var _activatable__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("4ad4");
/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("58df");
/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("80d2");




// Mixins


 // Utilities


 // Types

var baseMixins = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(_stackable__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"], _positionable__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"], _activatable__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"]);
/* @vue/component */

/* harmony default export */ __webpack_exports__["a"] = (baseMixins.extend().extend({
  name: 'menuable',
  props: {
    allowOverflow: Boolean,
    light: Boolean,
    dark: Boolean,
    maxWidth: {
      type: [Number, String],
      default: 'auto'
    },
    minWidth: [Number, String],
    nudgeBottom: {
      type: [Number, String],
      default: 0
    },
    nudgeLeft: {
      type: [Number, String],
      default: 0
    },
    nudgeRight: {
      type: [Number, String],
      default: 0
    },
    nudgeTop: {
      type: [Number, String],
      default: 0
    },
    nudgeWidth: {
      type: [Number, String],
      default: 0
    },
    offsetOverflow: Boolean,
    openOnClick: Boolean,
    positionX: {
      type: Number,
      default: null
    },
    positionY: {
      type: Number,
      default: null
    },
    zIndex: {
      type: [Number, String],
      default: null
    }
  },
  data: function data() {
    return {
      absoluteX: 0,
      absoluteY: 0,
      activatedBy: null,
      activatorFixed: false,
      dimensions: {
        activator: {
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          width: 0,
          height: 0,
          offsetTop: 0,
          scrollHeight: 0,
          offsetLeft: 0
        },
        content: {
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          width: 0,
          height: 0,
          offsetTop: 0,
          scrollHeight: 0
        }
      },
      hasJustFocused: false,
      hasWindow: false,
      inputActivator: false,
      isContentActive: false,
      pageWidth: 0,
      pageYOffset: 0,
      stackClass: 'v-menu__content--active',
      stackMinZIndex: 6
    };
  },
  computed: {
    computedLeft: function computedLeft() {
      var a = this.dimensions.activator;
      var c = this.dimensions.content;
      var activatorLeft = (this.attach !== false ? a.offsetLeft : a.left) || 0;
      var minWidth = Math.max(a.width, c.width);
      var left = 0;
      left += this.left ? activatorLeft - (minWidth - a.width) : activatorLeft;

      if (this.offsetX) {
        var maxWidth = isNaN(Number(this.maxWidth)) ? a.width : Math.min(a.width, Number(this.maxWidth));
        left += this.left ? -maxWidth : a.width;
      }

      if (this.nudgeLeft) left -= parseInt(this.nudgeLeft);
      if (this.nudgeRight) left += parseInt(this.nudgeRight);
      return left;
    },
    computedTop: function computedTop() {
      var a = this.dimensions.activator;
      var c = this.dimensions.content;
      var top = 0;
      if (this.top) top += a.height - c.height;
      if (this.attach !== false) top += a.offsetTop;else top += a.top + this.pageYOffset;
      if (this.offsetY) top += this.top ? -a.height : a.height;
      if (this.nudgeTop) top -= parseInt(this.nudgeTop);
      if (this.nudgeBottom) top += parseInt(this.nudgeBottom);
      return top;
    },
    hasActivator: function hasActivator() {
      return !!this.$slots.activator || !!this.$scopedSlots.activator || !!this.activator || !!this.inputActivator;
    }
  },
  watch: {
    disabled: function disabled(val) {
      val && this.callDeactivate();
    },
    isActive: function isActive(val) {
      if (this.disabled) return;
      val ? this.callActivate() : this.callDeactivate();
    },
    positionX: 'updateDimensions',
    positionY: 'updateDimensions'
  },
  beforeMount: function beforeMount() {
    this.hasWindow = typeof window !== 'undefined';
  },
  methods: {
    absolutePosition: function absolutePosition() {
      return {
        offsetTop: 0,
        offsetLeft: 0,
        scrollHeight: 0,
        top: this.positionY || this.absoluteY,
        bottom: this.positionY || this.absoluteY,
        left: this.positionX || this.absoluteX,
        right: this.positionX || this.absoluteX,
        height: 0,
        width: 0
      };
    },
    activate: function activate() {},
    calcLeft: function calcLeft(menuWidth) {
      return Object(_util_helpers__WEBPACK_IMPORTED_MODULE_8__[/* convertToUnit */ "g"])(this.attach !== false ? this.computedLeft : this.calcXOverflow(this.computedLeft, menuWidth));
    },
    calcTop: function calcTop() {
      return Object(_util_helpers__WEBPACK_IMPORTED_MODULE_8__[/* convertToUnit */ "g"])(this.attach !== false ? this.computedTop : this.calcYOverflow(this.computedTop));
    },
    calcXOverflow: function calcXOverflow(left, menuWidth) {
      var xOverflow = left + menuWidth - this.pageWidth + 12;

      if ((!this.left || this.right) && xOverflow > 0) {
        left = Math.max(left - xOverflow, 0);
      } else {
        left = Math.max(left, 12);
      }

      return left + this.getOffsetLeft();
    },
    calcYOverflow: function calcYOverflow(top) {
      var documentHeight = this.getInnerHeight();
      var toTop = this.pageYOffset + documentHeight;
      var activator = this.dimensions.activator;
      var contentHeight = this.dimensions.content.height;
      var totalHeight = top + contentHeight;
      var isOverflowing = toTop < totalHeight; // If overflowing bottom and offset
      // TODO: set 'bottom' position instead of 'top'

      if (isOverflowing && this.offsetOverflow && // If we don't have enough room to offset
      // the overflow, don't offset
      activator.top > contentHeight) {
        top = this.pageYOffset + (activator.top - contentHeight); // If overflowing bottom
      } else if (isOverflowing && !this.allowOverflow) {
        top = toTop - contentHeight - 12; // If overflowing top
      } else if (top < this.pageYOffset && !this.allowOverflow) {
        top = this.pageYOffset + 12;
      }

      return top < 12 ? 12 : top;
    },
    callActivate: function callActivate() {
      if (!this.hasWindow) return;
      this.activate();
    },
    callDeactivate: function callDeactivate() {
      this.isContentActive = false;
      this.deactivate();
    },
    checkForPageYOffset: function checkForPageYOffset() {
      if (this.hasWindow) {
        this.pageYOffset = this.activatorFixed ? 0 : this.getOffsetTop();
      }
    },
    checkActivatorFixed: function checkActivatorFixed() {
      if (this.attach !== false) return;
      var el = this.getActivator();

      while (el) {
        if (window.getComputedStyle(el).position === 'fixed') {
          this.activatorFixed = true;
          return;
        }

        el = el.offsetParent;
      }

      this.activatorFixed = false;
    },
    deactivate: function deactivate() {},
    genActivatorListeners: function genActivatorListeners() {
      var _this = this;

      var listeners = _activatable__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"].options.methods.genActivatorListeners.call(this);
      var onClick = listeners.click;

      listeners.click = function (e) {
        if (_this.openOnClick) {
          onClick && onClick(e);
        }

        _this.absoluteX = e.clientX;
        _this.absoluteY = e.clientY;
      };

      return listeners;
    },
    getInnerHeight: function getInnerHeight() {
      if (!this.hasWindow) return 0;
      return window.innerHeight || document.documentElement.clientHeight;
    },
    getOffsetLeft: function getOffsetLeft() {
      if (!this.hasWindow) return 0;
      return window.pageXOffset || document.documentElement.scrollLeft;
    },
    getOffsetTop: function getOffsetTop() {
      if (!this.hasWindow) return 0;
      return window.pageYOffset || document.documentElement.scrollTop;
    },
    getRoundedBoundedClientRect: function getRoundedBoundedClientRect(el) {
      var rect = el.getBoundingClientRect();
      return {
        top: Math.round(rect.top),
        left: Math.round(rect.left),
        bottom: Math.round(rect.bottom),
        right: Math.round(rect.right),
        width: Math.round(rect.width),
        height: Math.round(rect.height)
      };
    },
    measure: function measure(el) {
      if (!el || !this.hasWindow) return null;
      var rect = this.getRoundedBoundedClientRect(el); // Account for activator margin

      if (this.attach !== false) {
        var style = window.getComputedStyle(el);
        rect.left = parseInt(style.marginLeft);
        rect.top = parseInt(style.marginTop);
      }

      return rect;
    },
    sneakPeek: function sneakPeek(cb) {
      var _this2 = this;

      requestAnimationFrame(function () {
        var el = _this2.$refs.content;

        if (!el || el.style.display !== 'none') {
          cb();
          return;
        }

        el.style.display = 'inline-block';
        cb();
        el.style.display = 'none';
      });
    },
    startTransition: function startTransition() {
      var _this3 = this;

      return new Promise(function (resolve) {
        return requestAnimationFrame(function () {
          _this3.isContentActive = _this3.hasJustFocused = _this3.isActive;
          resolve();
        });
      });
    },
    updateDimensions: function updateDimensions() {
      var _this4 = this;

      this.hasWindow = typeof window !== 'undefined';
      this.checkActivatorFixed();
      this.checkForPageYOffset();
      this.pageWidth = document.documentElement.clientWidth;
      var dimensions = {
        activator: Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])({}, this.dimensions.activator),
        content: Object(_home_ec2_user_workspace_PatientPop_pp_vue_library_master_node_modules_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])({}, this.dimensions.content)
      }; // Activator should already be shown

      if (!this.hasActivator || this.absolute) {
        dimensions.activator = this.absolutePosition();
      } else {
        var activator = this.getActivator();
        if (!activator) return;
        dimensions.activator = this.measure(activator);
        dimensions.activator.offsetLeft = activator.offsetLeft;

        if (this.attach !== false) {
          // account for css padding causing things to not line up
          // this is mostly for v-autocomplete, hopefully it won't break anything
          dimensions.activator.offsetTop = activator.offsetTop;
        } else {
          dimensions.activator.offsetTop = 0;
        }
      } // Display and hide to get dimensions


      this.sneakPeek(function () {
        _this4.$refs.content && (dimensions.content = _this4.measure(_this4.$refs.content));
        _this4.dimensions = dimensions;
      });
    }
  }
}));

/***/ }),

/***/ "f5dd":
/***/ (function(module, exports, __webpack_require__) {

var addMonths = __webpack_require__("6665")

/**
 * @category Quarter Helpers
 * @summary Add the specified number of year quarters to the given date.
 *
 * @description
 * Add the specified number of year quarters to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of quarters to be added
 * @returns {Date} the new date with the quarters added
 *
 * @example
 * // Add 1 quarter to 1 September 2014:
 * var result = addQuarters(new Date(2014, 8, 1), 1)
 * //=> Mon Dec 01 2014 00:00:00
 */
function addQuarters (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  var months = amount * 3
  return addMonths(dirtyDate, months)
}

module.exports = addQuarters


/***/ }),

/***/ "f5df":
/***/ (function(module, exports, __webpack_require__) {

var TO_STRING_TAG_SUPPORT = __webpack_require__("00ee");
var classofRaw = __webpack_require__("c6b6");
var wellKnownSymbol = __webpack_require__("b622");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : result;
};


/***/ }),

/***/ "f5ec":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c662cfac-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/input/toggle-group/PpInputToggleGroup.vue?vue&type=template&id=1de99991&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pp-input-toggle-group d-flex align-center justify-start ma-0 pa-0 flex-wrap"},[(_vm.hasLabel)?_c('pp-input-label',{staticClass:"text-h5 mb-2",attrs:{"id":("input-toggle-group-" + _vm._uid),"label":_vm.label,"optional":_vm.optional}}):_vm._e(),_c('v-btn-toggle',{staticClass:"pp-input-toggle-group__list d-flex flex-wrap",attrs:{"mandatory":_vm.mandatory,"active-class":"white blue--text","dense":"","role":"radiogroup","aria-labelledby":("input-toggle-group-" + _vm._uid)},on:{"change":_vm.handleToggleChange},model:{value:(_vm.selectedValue),callback:function ($$v) {_vm.selectedValue=$$v},expression:"selectedValue"}},_vm._l((_vm.options),function(option,index){return _c('pp-button',{key:option.value,staticClass:"pp-input-toggle-group__list__item flex-grow-1 rounded-sm",attrs:{"ripple":false,"text":option.label,"disabled":option.disabled,"type":"secondary","role":"radio","aria-checked":_vm.selectedValue == index}})}),1)],1)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/input/toggle-group/PpInputToggleGroup.vue?vue&type=template&id=1de99991&scoped=true&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.find-index.js
var es_array_find_index = __webpack_require__("c740");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("caad");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__("53ca");

// EXTERNAL MODULE: ./src/components/button/PpButton.vue + 5 modules
var PpButton = __webpack_require__("251c");

// EXTERNAL MODULE: ./src/components/input/label/PpInputLabel.vue + 4 modules
var PpInputLabel = __webpack_require__("8e6c");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/input/toggle-group/PpInputToggleGroup.vue?vue&type=script&lang=js&



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/**
 * Input Toggle group based on Vuetify Button  Group.
 * Props will get passed through
 */

/* harmony default export */ var PpInputToggleGroupvue_type_script_lang_js_ = ({
  name: 'PpInputToggleGroup',
  components: {
    'pp-button': PpButton["default"],
    'pp-input-label': PpInputLabel["default"]
  },
  props: {
    /**
     * Array of options to build out radio group
     * [{ label: 'Yes', value: 'yes', disabled: false },{ label: 'No', value: 'no', disabled: true }]
     */
    options: {
      type: Array,
      required: true
    },
    label: {
      type: String,
      default: ''
    },

    /**
     * If true, display optional label with a different color than the main label
     */
    optional: {
      type: Boolean,
      default: false
    },
    mandatory: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      selectedValue: ''
    };
  },
  computed: {
    hasLabel: function hasLabel() {
      return !!this.label && this.label !== '';
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (['number', 'string', 'boolean'].includes(Object(esm_typeof["a" /* default */])(this.$attrs.value))) {
      this.selectedValue = this.options.findIndex(function (option) {
        return option.value === _this.$attrs.value;
      });
    }
  },
  methods: {
    handleToggleChange: function handleToggleChange() {
      if (typeof this.selectedValue === 'number') {
        this.$emit('input', this.options[this.selectedValue].value);
      } else {
        this.$emit('input', '');
      }
    }
  }
});
// CONCATENATED MODULE: ./src/components/input/toggle-group/PpInputToggleGroup.vue?vue&type=script&lang=js&
 /* harmony default export */ var toggle_group_PpInputToggleGroupvue_type_script_lang_js_ = (PpInputToggleGroupvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/input/toggle-group/PpInputToggleGroup.vue?vue&type=style&index=0&id=1de99991&lang=scss&scoped=true&
var PpInputToggleGroupvue_type_style_index_0_id_1de99991_lang_scss_scoped_true_ = __webpack_require__("3bb7");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// EXTERNAL MODULE: ./node_modules/vuetify-loader/lib/runtime/installComponents.js
var installComponents = __webpack_require__("6544");
var installComponents_default = /*#__PURE__*/__webpack_require__.n(installComponents);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__("5530");

// EXTERNAL MODULE: ./node_modules/vuetify/src/components/VBtnToggle/VBtnToggle.sass
var VBtnToggle = __webpack_require__("7e58");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/components/VItemGroup/VItemGroup.js
var VItemGroup = __webpack_require__("604c");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/mixins/button-group/index.js
// Extensions

/* @vue/component */

/* harmony default export */ var button_group = (VItemGroup["a" /* BaseItemGroup */].extend({
  name: 'button-group',
  provide: function provide() {
    return {
      btnToggle: this
    };
  },
  computed: {
    classes: function classes() {
      return VItemGroup["a" /* BaseItemGroup */].options.computed.classes.call(this);
    }
  },
  methods: {
    // Isn't being passed down through types
    genData: VItemGroup["a" /* BaseItemGroup */].options.methods.genData
  }
}));
// EXTERNAL MODULE: ./node_modules/vuetify/lib/mixins/colorable/index.js
var colorable = __webpack_require__("a9ad");

// EXTERNAL MODULE: ./node_modules/vuetify/lib/util/mixins.js
var mixins = __webpack_require__("58df");

// CONCATENATED MODULE: ./node_modules/vuetify/lib/components/VBtnToggle/VBtnToggle.js

// Styles
 // Mixins


 // Utilities


/* @vue/component */

/* harmony default export */ var VBtnToggle_VBtnToggle = (Object(mixins["a" /* default */])(button_group, colorable["a" /* default */]).extend({
  name: 'v-btn-toggle',
  props: {
    backgroundColor: String,
    borderless: Boolean,
    dense: Boolean,
    group: Boolean,
    rounded: Boolean,
    shaped: Boolean,
    tile: Boolean
  },
  computed: {
    classes: function classes() {
      return Object(objectSpread2["a" /* default */])(Object(objectSpread2["a" /* default */])({}, button_group.options.computed.classes.call(this)), {}, {
        'v-btn-toggle': true,
        'v-btn-toggle--borderless': this.borderless,
        'v-btn-toggle--dense': this.dense,
        'v-btn-toggle--group': this.group,
        'v-btn-toggle--rounded': this.rounded,
        'v-btn-toggle--shaped': this.shaped,
        'v-btn-toggle--tile': this.tile
      }, this.themeClasses);
    }
  },
  methods: {
    genData: function genData() {
      var data = this.setTextColor(this.color, Object(objectSpread2["a" /* default */])({}, button_group.options.methods.genData.call(this)));
      if (this.group) return data;
      return this.setBackgroundColor(this.backgroundColor, data);
    }
  }
}));
// CONCATENATED MODULE: ./src/components/input/toggle-group/PpInputToggleGroup.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  toggle_group_PpInputToggleGroupvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "1de99991",
  null
  
)

/* harmony default export */ var PpInputToggleGroup = __webpack_exports__["default"] = (component.exports);

/* vuetify-loader */


installComponents_default()(component, {VBtnToggle: VBtnToggle_VBtnToggle})


/***/ }),

/***/ "f5f8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpApp_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ee70");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpApp_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpApp_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "f663":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M16 10H20C21.1046 10 22 10.8954 22 12V19C22 20.1046 21.1046 21 20 21H18C16.8954 21 16 20.1046 16 19V10Z\" fill=\"#D5EAFD\" stroke=\"#079CB2\" stroke-width=\"2\"></path><path d=\"M1 5C1 3.34315 2.34315 2 4 2H15C16.6569 2 18 3.34315 18 5V22H4C2.34315 22 1 20.6569 1 19V5Z\" fill=\"white\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M15 4H4C3.44771 4 3 4.44772 3 5V19C3 19.5523 3.44772 20 4 20H16.3125C16.3125 20 16 19.7266 16 19C16 18.2734 16 5 16 5C16 4.44772 15.5523 4 15 4ZM4 2C2.34315 2 1 3.34315 1 5V19C1 20.6569 2.34315 22 4 22H18V20V19V5C18 3.34315 16.6569 2 15 2H4Z\" fill=\"#079CB2\"></path><rect x=\"5\" y=\"15\" width=\"9\" height=\"2\" rx=\"1\" fill=\"#079CB2\"></rect><path d=\"M18 20H19C18.2738 20 18 19.6199 18 19V19.4709V19.7751V20Z\" fill=\"#079CB2\"></path><path d=\"M6 7H12.75C12.8881 7 13 7.11193 13 7.25V12H6.25C6.11193 12 6 11.8881 6 11.75V7Z\" fill=\"#D5EAFD\" stroke=\"#079CB2\" stroke-width=\"2\"></path></svg>";

/***/ }),

/***/ "f66d":
/***/ (function(module, exports, __webpack_require__) {

var isSameYear = __webpack_require__("26d5")

/**
 * @category Year Helpers
 * @summary Is the given date in the same year as the current date?
 *
 * @description
 * Is the given date in the same year as the current date?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in this year
 *
 * @example
 * // If today is 25 September 2014, is 2 July 2014 in this year?
 * var result = isThisYear(new Date(2014, 6, 2))
 * //=> true
 */
function isThisYear (dirtyDate) {
  return isSameYear(new Date(), dirtyDate)
}

module.exports = isThisYear


/***/ }),

/***/ "f6a8":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.theme--light.v-image{color:var(--pp-text-primary,#2b2b2b)}.theme--dark.v-image{color:var(--pp-primary-button-text-color,#004852)}.v-image{z-index:0}.v-image__image,.v-image__placeholder{z-index:-1;position:absolute;top:0;left:0;width:100%;height:100%}.v-image__image{background-repeat:no-repeat}.v-image__image--preload{filter:blur(2px)}.v-image__image--contain{background-size:contain}.v-image__image--cover{background-size:cover}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "f709":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><circle cx=\"12\" cy=\"12\" r=\"9\" fill=\"white\"></circle><circle cx=\"12\" cy=\"12\" r=\"7\" fill=\"#DFE4E5\"></circle><path d=\"M12 23C5.925 23 1 18.075 1 12C1 5.925 5.925 1 12 1C18.075 1 23 5.925 23 12C23 18.075 18.075 23 12 23ZM12 21C16.9705 21 21 16.9705 21 12C21 7.0295 16.9705 3 12 3C7.0295 3 3 7.0295 3 12C3 16.9705 7.0295 21 12 21ZM13 17.376V18.5C13 18.7652 12.8946 19.0196 12.7071 19.2071C12.5196 19.3946 12.2652 19.5 12 19.5C11.7348 19.5 11.4804 19.3946 11.2929 19.2071C11.1054 19.0196 11 18.7652 11 18.5V17.3855C10.5159 17.2704 10.0542 17.0762 9.6335 16.8105C9.2205 16.5525 8.9245 16.287 8.747 16.084C8.57411 15.8841 8.48741 15.6238 8.50586 15.3601C8.5243 15.0965 8.64638 14.8508 8.84541 14.6769C9.04444 14.503 9.30424 14.4149 9.568 14.432C9.83177 14.4491 10.078 14.5699 10.253 14.768C10.31 14.8335 10.4635 14.971 10.694 15.115C11.081 15.357 11.5165 15.5 11.9955 15.5C12.9355 15.5 13.5495 14.943 13.497 14.461C13.4475 14.009 13.0305 13.661 11.699 12.9705L11.5395 12.8875C11.5336 12.8846 11.5278 12.8816 11.522 12.8785L11.3805 12.805C9.439 11.7985 8.6675 11.155 8.515 9.7565C8.3545 8.2875 9.4535 7.0155 11 6.624V5.5C11 5.23478 11.1054 4.98043 11.2929 4.79289C11.4804 4.60536 11.7348 4.5 12 4.5C12.2652 4.5 12.5196 4.60536 12.7071 4.79289C12.8946 4.98043 13 5.23478 13 5.5V6.6145C13.4841 6.72956 13.9458 6.92385 14.3665 7.1895C14.7795 7.4475 15.0755 7.713 15.253 7.916C15.4259 8.11593 15.5126 8.37618 15.4941 8.63986C15.4757 8.90353 15.3536 9.14917 15.1546 9.3231C14.9556 9.49702 14.6958 9.58507 14.432 9.568C14.1682 9.55093 13.922 9.43013 13.747 9.232C13.69 9.1665 13.5365 9.029 13.306 8.885C12.919 8.643 12.4835 8.5 12.0045 8.5C11.0645 8.5 10.4505 9.057 10.503 9.539C10.5525 9.991 10.9695 10.339 12.301 11.0295C12.4072 11.0845 12.5133 11.1395 12.6195 11.1945C14.561 12.2015 15.3325 12.8455 15.485 14.2435C15.6455 15.7125 14.5465 16.9845 13 17.376Z\" fill=\"#688083\"></path></svg>";

/***/ }),

/***/ "f748":
/***/ (function(module, exports) {

// `Math.sign` method implementation
// https://tc39.es/ecma262/#sec-math.sign
module.exports = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};


/***/ }),

/***/ "f772":
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__("5692");
var uid = __webpack_require__("90e3");

var keys = shared('keys');

module.exports = function (key) {
  return keys[key] || (keys[key] = uid(key));
};


/***/ }),

/***/ "f823":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("4f87");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("5ee4d975", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "f892":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c662cfac-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/input/multiselect/PpInputMultiselect.vue?vue&type=template&id=3a33170c&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pp-input-select',_vm._g(_vm._b({ref:"select",attrs:{"menu-props":_vm.menuProps,"chips":"","clear-icon":"mdi-close","deletable-chips":"","multiple":"","outlined":""},scopedSlots:_vm._u([_vm._l((_vm.$slots),function(_,name){return {key:name,fn:function(){return [_vm._t(name)]},proxy:true}})],null,true)},'pp-input-select',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/input/multiselect/PpInputMultiselect.vue?vue&type=template&id=3a33170c&scoped=true&

// EXTERNAL MODULE: ./src/components/input/select/PpInputSelect.vue + 4 modules
var PpInputSelect = __webpack_require__("b8f2");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/input/multiselect/PpInputMultiselect.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var PpInputMultiselectvue_type_script_lang_js_ = ({
  name: 'PpInputMultiselect',
  components: {
    'pp-input-select': PpInputSelect["default"]
  },
  props: {
    /**
     * Sets options on the menu dropdown.
     * Details can be found here: https://vuetifyjs.com/en/api/v-select/#props
     */
    menuProps: {
      type: Object,
      default: function _default() {
        return {
          closeOnContentClick: true
        };
      }
    }
  }
});
// CONCATENATED MODULE: ./src/components/input/multiselect/PpInputMultiselect.vue?vue&type=script&lang=js&
 /* harmony default export */ var multiselect_PpInputMultiselectvue_type_script_lang_js_ = (PpInputMultiselectvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/input/multiselect/PpInputMultiselect.vue?vue&type=style&index=0&id=3a33170c&lang=scss&scoped=true&
var PpInputMultiselectvue_type_style_index_0_id_3a33170c_lang_scss_scoped_true_ = __webpack_require__("448d");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/input/multiselect/PpInputMultiselect.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  multiselect_PpInputMultiselectvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "3a33170c",
  null
  
)

/* harmony default export */ var PpInputMultiselect = __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "f9f8":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.theme--light.v-data-table .v-row-group__header,.theme--light.v-data-table .v-row-group__summary,.theme--light.v-data-table tbody tr.v-data-table__selected{background:#f6f6f6}.theme--light.v-data-table .v-data-footer{border-top:thin solid #d6d6d6}.theme--light.v-data-table .v-data-table__empty-wrapper{color:var(--pp-text-disabled,#f6f6f6)}.theme--dark.v-data-table tbody tr.v-data-table__selected{background:#505050}.theme--dark.v-data-table .v-row-group__header,.theme--dark.v-data-table .v-row-group__summary{background:#545454}.theme--dark.v-data-table .v-data-footer{border-top:thin solid hsla(0,0%,100%,.12)}.theme--dark.v-data-table .v-data-table__empty-wrapper{color:hsla(0,0%,100%,.5)}.v-data-table{border-radius:5px}.v-data-table>.v-data-table__wrapper tbody tr.v-data-table__expanded{border-bottom:0}.v-data-table>.v-data-table__wrapper tbody tr.v-data-table__expanded__content{box-shadow:inset 0 4px 8px -5px rgba(50,50,50,.75),inset 0 -4px 8px -5px rgba(50,50,50,.75)}.v-data-table>.v-data-table__wrapper tbody tr:first-child:hover td:first-child{border-top-left-radius:5px}.v-data-table>.v-data-table__wrapper tbody tr:first-child:hover td:last-child{border-top-right-radius:5px}.v-data-table>.v-data-table__wrapper tbody tr:last-child:hover td:first-child{border-bottom-left-radius:5px}.v-data-table>.v-data-table__wrapper tbody tr:last-child:hover td:last-child{border-bottom-right-radius:5px}.v-data-table>.v-data-table__wrapper .v-data-table__mobile-table-row{display:initial}.v-data-table>.v-data-table__wrapper .v-data-table__mobile-row{height:auto;min-height:48px}.v-data-table__empty-wrapper{text-align:center}.v-data-table__mobile-row{align-items:center;display:flex;justify-content:space-between}.v-data-table__mobile-row__header{font-weight:600}.v-application--is-ltr .v-data-table__mobile-row__header{padding-right:16px}.v-application--is-rtl .v-data-table__mobile-row__header{padding-left:16px}.v-application--is-ltr .v-data-table__mobile-row__cell{text-align:right}.v-application--is-rtl .v-data-table__mobile-row__cell{text-align:left}.v-row-group__header td,.v-row-group__summary td{height:35px}.v-data-table__expand-icon{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:pointer}.v-data-table__expand-icon--active{transform:rotate(-180deg)}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "f9ff":
/***/ (function(module, exports, __webpack_require__) {

var getISOYear = __webpack_require__("8964")

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the number of calendar ISO week-numbering years between the given dates.
 *
 * @description
 * Get the number of calendar ISO week-numbering years between the given dates.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar ISO week-numbering years
 *
 * @example
 * // How many calendar ISO week-numbering years are 1 January 2010 and 1 January 2012?
 * var result = differenceInCalendarISOYears(
 *   new Date(2012, 0, 1),
 *   new Date(2010, 0, 1)
 * )
 * //=> 2
 */
function differenceInCalendarISOYears (dirtyDateLeft, dirtyDateRight) {
  return getISOYear(dirtyDateLeft) - getISOYear(dirtyDateRight)
}

module.exports = differenceInCalendarISOYears


/***/ }),

/***/ "fa76":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("c8d5")
var addDays = __webpack_require__("8946")
var getISODay = __webpack_require__("84b9")

/**
 * @category Weekday Helpers
 * @summary Set the day of the ISO week to the given date.
 *
 * @description
 * Set the day of the ISO week to the given date.
 * ISO week starts with Monday.
 * 7 is the index of Sunday, 1 is the index of Monday etc.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} day - the day of the ISO week of the new date
 * @returns {Date} the new date with the day of the ISO week setted
 *
 * @example
 * // Set Sunday to 1 September 2014:
 * var result = setISODay(new Date(2014, 8, 1), 7)
 * //=> Sun Sep 07 2014 00:00:00
 */
function setISODay (dirtyDate, dirtyDay) {
  var date = parse(dirtyDate)
  var day = Number(dirtyDay)
  var currentDay = getISODay(date)
  var diff = day - currentDay
  return addDays(date, diff)
}

module.exports = setISODay


/***/ }),

/***/ "fa7d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c662cfac-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/input/date-range/PpInputDateRange.vue?vue&type=template&id=5da7e4ca&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"date-range"},[_c('pp-button',{ref:"main-button",staticClass:"main-button",class:_vm.mainButtonClasses,attrs:{"data-test":"main-button","disabled":!_vm.isValidDateRage,"type":"tertiary","prepend-icon":"schedule","append-icon":"chevron-down","text":_vm.currentSelectionToString},on:{"click":_vm.toggleCalendar}}),(_vm.isOpen)?_c('pp-container',{staticClass:"calendar",class:_vm.openPosition,attrs:{"data-test":"calendar"}},[_c('pp-row',[(!_vm.isMobile)?_c('pp-col',{staticClass:"border border--right",attrs:{"cols":"3"}},[_c('ul',{staticClass:"presets"},_vm._l((_vm.finalPresetRanges),function(preset){return _c('li',{key:preset.label,staticClass:"px-4 d-flex justify-space-between align-center",class:_vm.activePresetClass(preset.label),attrs:{"data-test":"preset-item"},on:{"click":function($event){return _vm.updatePreset(preset)}}},[_c('span',[_vm._v(_vm._s(preset.label))]),(_vm.presetActive === preset.label)?_c('i',{staticClass:"icon pp-icon-check"}):_vm._e()])}),0)]):_vm._e(),_c('pp-col',{attrs:{"cols":_vm.isMobile? 12 : 9}},[(_vm.isMobile)?_c('pp-row',{staticClass:"border border--bottom justify-center py-4"},[_c('pp-input-select',{attrs:{"data-test":"mobile-select","placeholder":"Select a preset","value":_vm.finalPresetRanges.findIndex(function (preset) { return _vm.presetActive === preset.label; }),"items":_vm.finalPresetRanges.map(function (preset, index) { return ({ text: preset.label, value: index }); })},on:{"change":_vm.updatePreset}})],1):_vm._e(),(_vm.$slots['prepend-inner'])?_c('pp-row',[_vm._t("prepend-inner")],2):_vm._e(),_c('pp-row',[_c('pp-input-date-range-month-layout',{staticClass:"calendar-month-left",class:_vm.isMobile ? 'px-0' : '',attrs:{"calendar-key":"left","style-classes":_vm.styleClasses,"arrow-classes":"left-arrow-icon pp-icon-caret--left","arrow-action":_vm.goPrevMonth,"show-month-arrow":_vm.shouldShowPreviousMonthArrow,"secondary-arrow":_vm.isMobile && _vm.shouldShowNextMonthArrow,"secondary-arrow-action":_vm.goNextMonth,"on-day-click":_vm.selectDayOnLeftCalendar,"get-calendar-cell-classes":_vm.getCalendarCellClasses,"month-title":((_vm.monthLabels[_vm.activeMonthStart]) + " " + _vm.activeYearStart),"start-date":_vm.startMonthDay,"end-date":_vm.endMonthDate,"number-of-weeks":_vm.weekCount(_vm.activeYearStart, _vm.activeMonthStart)}}),(!_vm.isMobile)?_c('pp-input-date-range-month-layout',{staticClass:"calendar-month-right",attrs:{"calendar-key":"right","arrow-classes":"right-arrow-icon pp-icon-caret--right","style-classes":_vm.styleClasses,"show-month-arrow":_vm.shouldShowNextMonthArrow,"arrow-action":_vm.goNextMonth,"on-day-click":_vm.selectDayOnRightCalendar,"get-calendar-cell-classes":_vm.getCalendarCellClasses,"month-title":((_vm.monthLabels[_vm.nextActiveMonth]) + " " + _vm.activeYearEnd),"start-date":_vm.startNextMonthDay,"end-date":_vm.endNextMonthDate,"number-of-weeks":_vm.weekCount(_vm.activeYearEnd, _vm.nextActiveMonth)}}):_vm._e()],1),_c('pp-row',{staticClass:"border border--top",class:_vm.isMobile ? 'flex-column' : 'px-3'},[_c('pp-col',{staticClass:"d-flex align-center",class:_vm.isMobile ? 'border-bottom justify-space-between px-5' : ''},[_c('div',{staticClass:"d-flex align-center date date--inline",class:_vm.isPlaceholderMessage ? 'date--placeholder': ''},[_c('i',{staticClass:"calendar__icon pp-icon-schedule mr-2"}),_c('span',{staticClass:"mr-2"},[_vm._v(_vm._s(_vm.currentSelectionToString))])]),_c('span',{staticClass:"clear d-flex align-center justify-center",on:{"click":_vm.clearDateRange}},[_c('i',{staticClass:"pp-icon-close"})])]),_c('pp-col',{staticClass:"d-flex justify-end",class:_vm.isMobile ? 'justify-space-between px-4' : 'justify-end'},[_c('pp-button',{staticClass:"close mr-2",attrs:{"data-test":"cancel","type":"secondary","text":"Cancel"},on:{"click":_vm.cancelAction}}),_c('pp-button',{staticClass:"calendar-btn-apply",attrs:{"disabled":!_vm.isValidDateRage,"type":"primary","text":"Apply"},on:{"click":_vm.setDateValue}})],1)],1)],1)],1)],1):_vm._e()],1)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/input/date-range/PpInputDateRange.vue?vue&type=template&id=5da7e4ca&scoped=true&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("99af");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.every.js
var es_array_every = __webpack_require__("a623");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__("7db0");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("d81d");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__("a9e3");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.assign.js
var es_object_assign = __webpack_require__("cca6");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("ade3");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__("53ca");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__("2909");

// EXTERNAL MODULE: ./node_modules/date-fns/index.js
var date_fns = __webpack_require__("340b");

// EXTERNAL MODULE: ./src/components/input/select/PpInputSelect.vue + 4 modules
var PpInputSelect = __webpack_require__("b8f2");

// EXTERNAL MODULE: ./src/components/button/PpButton.vue + 5 modules
var PpButton = __webpack_require__("251c");

// EXTERNAL MODULE: ./src/components/container/PpContainer.vue + 4 modules
var PpContainer = __webpack_require__("3d51");

// EXTERNAL MODULE: ./src/components/row/PpRow.vue + 4 modules
var PpRow = __webpack_require__("eeac");

// EXTERNAL MODULE: ./src/components/col/PpCol.vue + 4 modules
var PpCol = __webpack_require__("8ecc");

// EXTERNAL MODULE: ./src/components/input/date-range/month-layout/PpInputDateRangeMonthLayout.vue + 4 modules
var PpInputDateRangeMonthLayout = __webpack_require__("5a59");

// EXTERNAL MODULE: ./src/components/input/date-range/constants.js
var constants = __webpack_require__("9ede");

// EXTERNAL MODULE: ./src/components/input/date-range/functions.js
var functions = __webpack_require__("21dd");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/input/date-range/PpInputDateRange.vue?vue&type=script&lang=js&









//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ var PpInputDateRangevue_type_script_lang_js_ = ({
  name: 'PpInputDateRange',
  components: {
    'pp-button': PpButton["default"],
    'pp-input-select': PpInputSelect["default"],
    'pp-container': PpContainer["default"],
    'pp-row': PpRow["default"],
    'pp-col': PpCol["default"],
    'pp-input-date-range-month-layout': PpInputDateRangeMonthLayout["default"]
  },
  props: {
    min: {
      type: String,
      default: null
    },
    max: {
      type: String,
      default: null
    },

    /**
     * Placeholder message for the input and the clear button
     */
    placeholder: {
      type: String,
      default: 'Select a date range'
    },

    /**
     * List of class names to overwrite the default names
     * DEFAULT_STYLE_CLASSES = {
     *    daysWeeks: 'calendar-weeks',
     *    days: 'calendar-days',
     *    daysSelected: 'calendar-days-selected',
     *    daysInRange: 'calendar-days-in-range',
     *    firstDate: 'calendar-month-left',
     *    secondDate: 'calendar-month-right',
     *    presetRanges: 'calendar-preset-button',
     *    dateDisabled: 'calendar-days--disabled'
     * }
     */
    customStylesClasses: {
      type: Object,
      default: function _default() {}
    },

    /**
     * initial date range
     * DEFAULT_STYLE_CLASSES = {
     *    start: '1989-05-09',
     *    end: '1989-05-15'
     * }
     */
    initRange: {
      type: Object,
      default: function _default() {
        return {
          start: null,
          end: null
        };
      },
      validator: function validator(value) {
        if (!value.start && !value.end) {
          return true;
        }

        return Object(functions["d" /* isValidISO8601 */])(value.start) && Object(functions["d" /* isValidISO8601 */])(value.end);
      }
    },
    initialActiveMonth: {
      type: Number,
      default: new Date().getMonth()
    },
    initialActiveYear: {
      type: Number,
      default: new Date().getFullYear()
    },

    /**
     * Date preset list
     * customPreset: [
     *  {
     *    label: 'All time',
     *    dateRange: {
     *        start: '1989-05-09',
     *        end: '1989-05-09'
     *    }
     *  },
     * ]
     */
    customPreset: {
      type: Array,
      default: function _default() {
        return [];
      },
      validator: function validator(value) {
        if (value.length === 0) {
          return true;
        }

        var propValidation = value.every(function (prop) {
          var isValidLabel = typeof prop.label === 'string';

          if (!prop.dateRange.start && !prop.dateRange.end) {
            return true;
          }

          return isValidLabel && Object(functions["d" /* isValidISO8601 */])(prop.dateRange.start) && Object(functions["d" /* isValidISO8601 */])(prop.dateRange.end);
        });
        return propValidation;
      }
    }
  },
  data: function data() {
    return {
      NUM_OF_DAYS: constants["h" /* NUM_OF_DAYS */],
      activeMonthStart: this.initialActiveMonth,
      activeYearEnd: this.initialActiveYear,
      activeYearStart: this.initialActiveYear,
      dateRange: {
        start: null,
        end: null
      },
      isFirstChoice: true,
      isMobile: true,
      isOpen: false,
      presetActive: constants["a" /* CUSTOM_RANGE */],
      monthLabels: constants["g" /* MONTH_LONG_NAMES */],
      selectedDate: null,
      calendarClicked: 'left'
    };
  },
  computed: {
    initRangeDate: function initRangeDate() {
      return {
        start: this.initRange.start ? Object(functions["e" /* isoStringToDate */])(this.initRange.start) : null,
        end: this.initRange.end ? Object(functions["e" /* isoStringToDate */])(this.initRange.end) : null
      };
    },
    minDate: function minDate() {
      return this.min ? Object(functions["e" /* isoStringToDate */])(this.min) : null;
    },
    maxDate: function maxDate() {
      return this.max ? Object(functions["e" /* isoStringToDate */])(this.max) : null;
    },
    openPosition: function openPosition() {
      var $buttonOpen = this.$refs['main-button'].$el;
      var buttonBounding = $buttonOpen.getBoundingClientRect();
      var windowDimensions = Object(functions["f" /* viewport */])();
      var remainingSpace = windowDimensions.width - buttonBounding.right;

      if (this.isOpen && remainingSpace < constants["d" /* DESKTOP_CALENDAR_WIDTH */]) {
        return 'calendar--open-left';
      }

      return '';
    },
    isPlaceholderMessage: function isPlaceholderMessage() {
      return this.currentSelectionToString === this.placeholder;
    },
    mainButtonClasses: function mainButtonClasses() {
      return "".concat(this.isOpen ? 'main-button--open' : '', " ").concat(this.isPlaceholderMessage ? 'main-button--placerholder' : '');
    },
    styleClasses: function styleClasses() {
      return Object.assign({}, constants["c" /* DEFAULT_STYLE_CLASSES */], this.customStylesClasses);
    },
    startMonthDay: function startMonthDay() {
      return new Date(this.activeYearStart, this.activeMonthStart, 1).getDay();
    },
    startNextMonthDay: function startNextMonthDay() {
      return new Date(this.activeYearStart, this.nextActiveMonth, 1).getDay();
    },
    endMonthDate: function endMonthDate() {
      return new Date(this.activeYearEnd, this.nextActiveMonth, 0).getDate();
    },
    endNextMonthDate: function endNextMonthDate() {
      return new Date(this.activeYearEnd, this.activeMonthStart + 2, 0).getDate();
    },
    lastDayNextMonthDate: function lastDayNextMonthDate() {
      return new Date(this.activeYearEnd, this.nextActiveMonth, this.endNextMonthDate);
    },
    nextActiveMonthStart: function nextActiveMonthStart() {
      return this.isMobile ? this.activeMonthStart : this.activeMonthStart + 1;
    },
    nextActiveMonth: function nextActiveMonth() {
      return this.activeMonthStart >= 11 ? 0 : this.nextActiveMonthStart;
    },
    customPresetDate: function customPresetDate() {
      return this.customPreset.map(function (preset) {
        return {
          label: preset.label,
          dateRange: {
            start: Object(functions["e" /* isoStringToDate */])(preset.dateRange.start),
            end: Object(functions["e" /* isoStringToDate */])(preset.dateRange.end)
          }
        };
      });
    },
    finalPresetRanges: function finalPresetRanges() {
      if (this.customPresetDate.length > 0) {
        return [].concat(Object(toConsumableArray["a" /* default */])(this.customPresetDate), [{
          label: constants["a" /* CUSTOM_RANGE */],
          dateRange: {
            start: null,
            end: null
          }
        }]);
      }

      return this.defaultPresets();
    },
    isValidDateRage: function isValidDateRage() {
      var _this$dateRange = this.dateRange,
          start = _this$dateRange.start,
          end = _this$dateRange.end;

      if (!start && !end) {
        return true;
      }

      return Object(date_fns["isValid"])(start) && Object(date_fns["isValid"])(end);
    },
    currentSelectionToString: function currentSelectionToString() {
      if (this.dateRange.start) {
        var startYear = Object(date_fns["getYear"])(this.dateRange.start);
        var endYear = Object(date_fns["getYear"])(this.dateRange.end);

        if (startYear !== endYear) {
          return "".concat(Object(date_fns["format"])(this.dateRange.start, constants["e" /* DISPLAY_FORMAT */]), " - ").concat(Object(date_fns["format"])(this.dateRange.end, constants["e" /* DISPLAY_FORMAT */]));
        }

        return "".concat(Object(date_fns["format"])(this.dateRange.start, 'MMM D'), " - ").concat(Object(date_fns["format"])(this.dateRange.end, constants["e" /* DISPLAY_FORMAT */]));
      }

      return this.placeholder;
    },
    shouldShowPreviousMonthArrow: function shouldShowPreviousMonthArrow() {
      if (!this.minDate) {
        return true;
      }

      var endOfMonth = new Date(this.activeYearStart, this.activeMonthStart, 0);
      var isSameYear = Object(date_fns["getYear"])(this.minDate) === this.activeYearStart;
      var isSameMonth = Object(date_fns["getMonth"])(this.minDate) === this.activeMonthStart;
      return !(isSameYear && isSameMonth) || Object(date_fns["isAfter"])(endOfMonth, this.minDate);
    },
    shouldShowNextMonthArrow: function shouldShowNextMonthArrow() {
      if (!this.maxDate) {
        return true;
      }

      return Object(date_fns["isBefore"])(this.lastDayNextMonthDate, this.maxDate);
    }
  },
  watch: {
    nextActiveMonth: function nextActiveMonth(value) {
      if (value === 0) this.activeYearEnd = this.activeYearStart + 1;
    },
    dateRange: function dateRange() {
      this.updateMonthAndYears();
    },
    initRangeDate: function initRangeDate() {
      this.handleInitRangeChange();
    }
  },
  created: function created() {
    window.addEventListener('resize', this.resizeEvent);
    this.resizeEvent();
  },
  destroyed: function destroyed() {
    window.removeEventListener('resize', this.resizeEvent);
  },
  mounted: function mounted() {
    this.initDateRange();
    this.updateMonthAndYears();
    this.setActivePreset(this.initRangeDate);
  },
  methods: {
    resizeEvent: function resizeEvent() {
      var windowDimensions = Object(functions["f" /* viewport */])();

      if (windowDimensions.width < constants["d" /* DESKTOP_CALENDAR_WIDTH */]) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }
    },
    cancelAction: function cancelAction() {
      if (this.initRangeDate && !this.selectedDate) {
        this.handleInitRangeChange();
        this.setActivePreset(this.initRangeDate);
      }

      if (this.selectedDate) {
        this.dateRange = this.selectedDate;
        this.setActivePreset(this.selectedDate);
      }

      this.toggleCalendar();
    },
    clearDateRange: function clearDateRange() {
      this.isFirstChoice = true;
      this.updatePreset(this.finalPresetRanges[this.finalPresetRanges.length - 1]);
    },
    initDateRange: function initDateRange() {
      var startDate = null;
      var endDate = null;

      if (this.initRangeDate) {
        startDate = this.initRangeDate.start || startDate;
        endDate = this.initRangeDate.end || endDate;
      }

      this.dateRange.start = this.dateRange.start || startDate;
      this.dateRange.end = this.dateRange.end || endDate;
    },
    toggleCalendar: function toggleCalendar() {
      if (!this.isOpen) {
        this.updateMonthAndYears();
      }

      this.isOpen = !this.isOpen;
      this.calendarClicked = 'left';
    },
    activePresetClass: function activePresetClass(label) {
      if (this.presetActive === label) {
        return 'active';
      }

      return '';
    },
    weekCount: functions["g" /* weekCount */],
    getDayIndexInMonth: functions["b" /* getDayIndexInMonth */],
    getDayCell: functions["a" /* getDayCell */],
    getNewDateRange: function getNewDateRange(result, activeMonth, activeYear) {
      var newData = {};
      var key = 'start';

      if (!this.isFirstChoice) {
        key = 'end';
      } else {
        newData.end = null;
      }

      var resultDate = new Date(activeYear, activeMonth, result);

      if (!this.isFirstChoice && resultDate < this.dateRange.start) {
        this.isFirstChoice = false;
        return {
          start: resultDate
        };
      }

      this.isFirstChoice = !this.isFirstChoice;
      newData[key] = resultDate;
      return newData;
    },
    selectDay: function selectDay(week, day, startMonthDay, activeMonth, activeYear) {
      var dayIndexInMonth = this.getDayIndexInMonth(week, day, startMonthDay);
      this.dateRange = Object.assign({}, this.dateRange, this.getNewDateRange(dayIndexInMonth, activeMonth, activeYear));

      if (this.dateRange.start && this.dateRange.end) {
        this.setActivePreset(this.dateRange);
      }

      this.checkDateFormat();
    },
    selectDayOnLeftCalendar: function selectDayOnLeftCalendar(week, day) {
      this.calendarClicked = 'left';
      this.selectDay(week, day, this.startMonthDay, this.activeMonthStart, this.activeYearStart);
    },
    selectDayOnRightCalendar: function selectDayOnRightCalendar(week, day) {
      this.calendarClicked = 'right';
      this.selectDay(week, day, this.startNextMonthDay, this.nextActiveMonth, this.activeYearEnd);
    },
    isDateSelected: function isDateSelected(currentDate) {
      if (!currentDate) {
        return false;
      }

      return Object(date_fns["isSameDay"])(this.dateRange.start, currentDate) || Object(date_fns["isSameDay"])(this.dateRange.end, currentDate);
    },
    getSelectedDateClass: function getSelectedDateClass(currentDate) {
      if (!currentDate) {
        return '';
      }

      if (Object(date_fns["isSameDay"])(this.dateRange.start, currentDate)) {
        if (Object(date_fns["isAfter"])(this.dateRange.end, this.dateRange.start)) {
          return 'first-date-selected';
        } else {
          return 'first-date-selected same-end-date';
        }
      }

      if (Object(date_fns["isSameDay"])(this.dateRange.end, currentDate)) {
        return 'second-date-selected';
      }

      return '';
    },
    isDateInRange: function isDateInRange(currentDate) {
      if (!currentDate) {
        return false;
      }

      return Object(date_fns["isBefore"])(this.dateRange.start, currentDate) && Object(date_fns["isAfter"])(this.dateRange.end, currentDate);
    },
    currDateFromCalendarLoop: function currDateFromCalendarLoop(week, day, key, startMonthDay, endMonthDate) {
      var result = this.getDayIndexInMonth(week, day, startMonthDay);

      if (result < 1 || result > endMonthDate) {
        return false;
      }

      return this.getCurrentDate(key, result);
    },
    isDateOutsideValidRange: function isDateOutsideValidRange(currentDate) {
      if (currentDate) {
        if (Object(date_fns["isBefore"])(currentDate, this.dateRange.start)) {
          return true;
        }

        var start = Object(functions["c" /* getISO8601String */])(this.dateRange.start);
        var end = Object(functions["c" /* getISO8601String */])(this.dateRange.end);

        if (start !== end) {
          return Object(date_fns["isBefore"])(currentDate, this.dateRange.start) || Object(date_fns["isAfter"])(currentDate, this.dateRange.end);
        }

        if (this.minDate !== null || this.maxDate !== null) {
          return Object(date_fns["isBefore"])(currentDate, this.minDate) || Object(date_fns["isAfter"])(currentDate, this.maxDate);
        }
      }

      return false;
    },
    isYearAndMonthOutsideValidRange: function isYearAndMonthOutsideValidRange(year, month) {
      var yearMonthDate = new Date(year, month, 1);
      var minFirstDate = this.minDate && Object(date_fns["isValid"])(this.minDate) ? Object(date_fns["startOfMonth"])(this.minDate) : null;
      var maxLastDate = this.maxDate && Object(date_fns["isValid"])(this.maxDate) ? Object(date_fns["endOfMonth"])(this.maxDate) : null;
      return minFirstDate !== null && Object(date_fns["isBefore"])(yearMonthDate, minFirstDate) || maxLastDate !== null && Object(date_fns["isAfter"])(yearMonthDate, maxLastDate);
    },
    isDateDisabled: function isDateDisabled(currentDate) {
      return !currentDate || this.isDateOutsideValidRange(currentDate);
    },
    goPrevMonth: function goPrevMonth() {
      var prevMonth = new Date(this.activeYearStart, this.activeMonthStart, 0);
      this.activeMonthStart = prevMonth.getMonth();
      this.activeYearStart = prevMonth.getFullYear();
      this.activeYearEnd = prevMonth.getFullYear();
    },
    goNextMonth: function goNextMonth() {
      var nextMonth = new Date(this.activeYearEnd, this.isMobile ? this.nextActiveMonth + 1 : this.nextActiveMonth, 1);
      this.activeMonthStart = nextMonth.getMonth();
      this.activeYearStart = nextMonth.getFullYear();
      this.activeYearEnd = nextMonth.getFullYear();
    },
    updatePreset: function updatePreset(item) {
      if (typeof item === 'number') {
        var _item = this.finalPresetRanges[item];
        this.presetActive = _item.label;
        this.dateRange = _item.dateRange;
      } else if (Object(esm_typeof["a" /* default */])(item) === 'object') {
        this.presetActive = item.label;
        this.dateRange = item.dateRange;
      } else {
        this.presetActive = '';
        this.dateRange = {
          start: null,
          end: null
        };
      }
    },
    checkDateFormat: function checkDateFormat() {
      if (this.dateRange.start && Object(date_fns["isValid"])(this.dateRange.start) && !this.dateRange.end) {
        this.dateRange.end = this.dateRange.start;
      }

      if (!this.dateRange.start && this.dateRange.end && Object(date_fns["isValid"])(this.dateRange.end)) {
        this.dateRange.start = this.dateRange.end;
      }

      this.updateMonthAndYears();
    },
    setActivePreset: function setActivePreset(comparationDate) {
      var preset = this.customPreset.find(function (preset) {
        var presetStart = preset.dateRange.start;
        var presetEnd = preset.dateRange.end;
        var start = Object(functions["c" /* getISO8601String */])(comparationDate.start);
        var end = Object(functions["c" /* getISO8601String */])(comparationDate.end);
        return presetStart === start && presetEnd === end;
      });

      if (preset) {
        this.presetActive = preset.label;
      } else {
        this.presetActive = constants["a" /* CUSTOM_RANGE */];
      }
    },
    handleInitRangeChange: function handleInitRangeChange() {
      this.dateRange = {
        start: this.initRangeDate.start,
        end: this.initRangeDate.end
      };
    },
    updateMonthAndYears: function updateMonthAndYears() {
      var startDate = this.dateRange.start;
      var endDate = this.dateRange.end;
      var startMonth = startDate && Object(date_fns["isValid"])(startDate) && Object(date_fns["getMonth"])(startDate);
      var startYear = startDate && Object(date_fns["isValid"])(startDate) && Object(date_fns["getYear"])(startDate);

      if (!startDate) {
        var month = Object(date_fns["getMonth"])(this.maxDate);
        this.activeMonthStart = month === 0 ? 0 : month - 1;
        this.activeYearStart = Object(date_fns["getYear"])(this.maxDate);
      }

      if (!Object(date_fns["isEqual"])(startDate, endDate)) {
        this.activeMonthStart = this.calendarClicked === 'left' ? startMonth : this.activeMonthStart;
        this.activeYearStart = this.calendarClicked === 'left' ? startYear : this.activeYearStart;
      }

      if (startMonth && startYear && this.isYearAndMonthOutsideValidRange(startYear, startMonth)) {
        var validDate = this.maxDate && Object(date_fns["isValid"])(this.maxDate) ? this.maxDate : this.minDate;
        this.activeMonthStart = Object(date_fns["getMonth"])(validDate);
        this.activeYearStart = Object(date_fns["getYear"])(validDate);
      }

      this.activeYearEnd = this.activeYearStart;

      if (this.activeMonthStart === 11) {
        this.activeYearEnd++;
      }
    },
    getCurrentDate: function getCurrentDate(key, result) {
      if (key === 'left') {
        return new Date(this.activeYearStart, this.activeMonthStart, result);
      }

      return new Date(this.activeYearEnd, this.nextActiveMonth, result);
    },
    setDateValue: function setDateValue() {
      // We need to reset the first choice to avoid the user only selecting the start date and then press the applied button.
      // It's will cause an error the next time when selecting
      this.isFirstChoice = true;
      this.selectedDate = this.dateRange;
      this.$emit('selected', {
        start: Object(functions["c" /* getISO8601String */])(this.dateRange.start),
        end: Object(functions["c" /* getISO8601String */])(this.dateRange.end)
      });
      this.toggleCalendar();
    },
    getCalendarCellClasses: function getCalendarCellClasses(week, day, calendar, startMonthDay, endMonthDate) {
      var _ref;

      var currentDate = this.currDateFromCalendarLoop(week, day, calendar, startMonthDay, endMonthDate);
      var additionalSelectedClass = this.getSelectedDateClass(currentDate);
      return [(_ref = {}, Object(defineProperty["a" /* default */])(_ref, this.styleClasses.daysSelected + ' ' + additionalSelectedClass, this.isDateSelected(currentDate)), Object(defineProperty["a" /* default */])(_ref, this.styleClasses.daysInRange, this.isDateInRange(currentDate)), Object(defineProperty["a" /* default */])(_ref, this.styleClasses.dateDisabled, this.isDateDisabled(currentDate)), _ref)];
    },
    defaultPresets: function defaultPresets() {
      return [{
        label: 'Last 7 Days',
        dateRange: {
          start: Object(date_fns["subDays"])(new Date(), 7),
          end: new Date()
        }
      }, {
        label: 'Last 30 Days',
        dateRange: {
          start: Object(date_fns["subDays"])(new Date(), 30),
          end: new Date()
        }
      }, {
        label: 'Last 90 Days',
        dateRange: {
          start: Object(date_fns["subDays"])(new Date(), 90),
          end: new Date()
        }
      }, {
        label: constants["a" /* CUSTOM_RANGE */],
        dateRange: {
          start: null,
          end: null
        }
      }];
    }
  }
});
// CONCATENATED MODULE: ./src/components/input/date-range/PpInputDateRange.vue?vue&type=script&lang=js&
 /* harmony default export */ var date_range_PpInputDateRangevue_type_script_lang_js_ = (PpInputDateRangevue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/input/date-range/PpInputDateRange.vue?vue&type=style&index=0&id=5da7e4ca&lang=scss&scoped=true&
var PpInputDateRangevue_type_style_index_0_id_5da7e4ca_lang_scss_scoped_true_ = __webpack_require__("e5ea");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/input/date-range/PpInputDateRange.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  date_range_PpInputDateRangevue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "5da7e4ca",
  null
  
)

/* harmony default export */ var PpInputDateRange = __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "fa98":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c662cfac-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/input/time-range/PpInputTimeRange.vue?vue&type=template&id=3acf988e&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"time-range"},[_c('div',{staticClass:"time-range__time pr-2"},[(_vm.showLabel)?_c('pp-input-label',{attrs:{"label":"Start Time"}}):_vm._e(),_c('pp-input-time',{staticClass:"input-time input-time--start",attrs:{"error":_vm.error,"placeholder":"Select","interval":_vm.interval,"min-time":_vm.minTime,"max-time":_vm.selectedEndTime},on:{"input":_vm.handleInputEvent},model:{value:(_vm.selectedStartTime),callback:function ($$v) {_vm.selectedStartTime=$$v},expression:"selectedStartTime"}})],1),_c('div',{staticClass:"time-range__time pl-2"},[(_vm.showLabel)?_c('pp-input-label',{attrs:{"label":"End Time"}}):_vm._e(),_c('pp-input-time',{staticClass:"input-time input-time--end",attrs:{"error":_vm.error,"placeholder":"Select","interval":_vm.interval,"min-time":_vm.selectedStartTime,"max-time":_vm.maxTime},on:{"input":_vm.handleInputEvent},model:{value:(_vm.selectedEndTime),callback:function ($$v) {_vm.selectedEndTime=$$v},expression:"selectedEndTime"}})],1)])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/input/time-range/PpInputTimeRange.vue?vue&type=template&id=3acf988e&scoped=true&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__("a9e3");

// EXTERNAL MODULE: ./src/components/input/time/PpInputTime.vue + 5 modules
var PpInputTime = __webpack_require__("b376");

// EXTERNAL MODULE: ./src/components/input/label/PpInputLabel.vue + 4 modules
var PpInputLabel = __webpack_require__("8e6c");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/input/time-range/PpInputTimeRange.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var DEFAULT_START_TIME = '12:00 AM';
var DEFAULT_END_TIME = '11:59 PM';
/* harmony default export */ var PpInputTimeRangevue_type_script_lang_js_ = ({
  name: 'PpInputTimeRange',
  components: {
    'pp-input-time': PpInputTime["default"],
    'pp-input-label': PpInputLabel["default"]
  },
  props: {
    showLabel: {
      type: Boolean,
      default: false
    },
    start: {
      type: String,
      default: null
    },
    end: {
      type: String,
      default: null
    },
    minTime: {
      type: String,
      default: '12:00 AM'
    },
    maxTime: {
      type: String,
      default: '11:59 PM'
    },
    error: {
      type: Boolean,
      default: false
    },
    interval: {
      type: Number,
      default: 5
    }
  },
  data: function data() {
    return {
      selectedStartTime: DEFAULT_START_TIME,
      selectedEndTime: DEFAULT_END_TIME
    };
  },
  watch: {
    start: {
      immediate: true,
      handler: function handler() {
        this.selectedStartTime = this.start ? this.start.toUpperCase() : null;
      }
    },
    end: {
      immediate: true,
      handler: function handler() {
        this.selectedEndTime = this.end ? this.end.toUpperCase() : null;
      }
    }
  },
  methods: {
    handleInputEvent: function handleInputEvent(event) {
      this.$emit('change', {
        start: this.selectedStartTime,
        end: this.selectedEndTime
      });
    }
  }
});
// CONCATENATED MODULE: ./src/components/input/time-range/PpInputTimeRange.vue?vue&type=script&lang=js&
 /* harmony default export */ var time_range_PpInputTimeRangevue_type_script_lang_js_ = (PpInputTimeRangevue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/input/time-range/PpInputTimeRange.vue?vue&type=style&index=0&id=3acf988e&lang=scss&scoped=true&
var PpInputTimeRangevue_type_style_index_0_id_3acf988e_lang_scss_scoped_true_ = __webpack_require__("1de1");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/input/time-range/PpInputTimeRange.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  time_range_PpInputTimeRangevue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "3acf988e",
  null
  
)

/* harmony default export */ var PpInputTimeRange = __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "fabf":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_167_176)\"><path d=\"M18.4998 1C20.9851 1 22.9998 3.01472 22.9998 5.5C22.9998 7.46681 21.738 9.13891 19.9798 9.75097L19.9999 9.74391L19.9998 14.6961C19.9998 15.4415 20.6838 16.0541 21.4254 16.1235L21.565 16.1301C22.357 16.1301 23 16.7731 23 17.5651C23 18.3115 22.4304 18.924 21.7031 18.9935L21.565 19.0001H15.999L15.9949 19.1996C15.8909 21.316 14.142 23 11.9998 23C9.791 23 8.00034 21.2097 7.9998 19.001L2.435 19.0001C1.642 19.0001 1 18.3581 1 17.5651C1 16.8197 1.56869 16.2063 2.29673 16.1367L2.435 16.1301C3.183 16.1301 3.93108 15.5575 4.01189 14.8266L4.01909 14.6961V9.1301C4.01909 5.4321 6.867 2.4351 10.565 2.4351C10.565 1.6421 11.207 1.0001 12 1.0001C12.792 1.0001 13.435 1.6421 13.435 2.4351C13.9894 2.4351 14.5251 2.50246 15.0353 2.62943L15.1154 2.53415C15.9402 1.59373 17.1506 1 18.4998 1ZM13.999 19.0001H9.999L10.0053 19.1493C10.0816 20.1841 10.9454 21 11.9998 21C13.0542 21 13.918 20.1841 13.9943 19.1493L13.999 19.0001Z\" fill=\"white\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12 1.00012C12.792 1.00012 13.435 1.64212 13.435 2.43512C13.9768 2.43512 14.5007 2.49945 15.0004 2.62089C12.0936 3.32833 10.0191 5.97391 10.0191 9.13012L10.019 16.9991L15.9998 17V19C15.9998 21.2092 14.2089 23 11.9998 23C9.79133 23 8.00089 21.2102 7.9998 19.002L2.435 19.0001C1.642 19.0001 1 18.3581 1 17.5651C1 16.7731 1.642 16.1301 2.435 16.1301C3.183 16.1301 3.93108 15.5575 4.01189 14.8266L4.01909 14.6961V9.13012C4.01909 5.43212 6.867 2.43512 10.565 2.43512C10.565 1.64212 11.207 1.00012 12 1.00012Z\" fill=\"#D5EAFD\"></path><path d=\"M18.4998 1C20.9851 1 22.9998 3.01472 22.9998 5.5C22.9998 7.46681 21.738 9.13891 19.9798 9.75097L19.9999 9.74391L19.9998 14.6961C19.9998 15.4415 20.6838 16.0541 21.4254 16.1235L21.565 16.1301C22.357 16.1301 23 16.7731 23 17.5651C23 18.3115 22.4304 18.924 21.7031 18.9935L21.565 19.0001H15.999L15.9949 19.1996C15.8909 21.316 14.142 23 11.9998 23C9.791 23 8.00034 21.2097 7.9998 19.001L2.435 19.0001C1.642 19.0001 1 18.3581 1 17.5651C1 16.8197 1.56869 16.2063 2.29673 16.1367L2.435 16.1301C3.183 16.1301 3.93108 15.5575 4.01189 14.8266L4.01909 14.6961V9.1301C4.01909 5.4321 6.867 2.4351 10.565 2.4351C10.565 1.6421 11.207 1.0001 12 1.0001C12.792 1.0001 13.435 1.6421 13.435 2.4351C13.9894 2.4351 14.5251 2.50246 15.0353 2.62943L15.1154 2.53415C15.9402 1.59373 17.1506 1 18.4998 1ZM13.999 19.0001H9.999L10.0053 19.1493C10.0816 20.1841 10.9454 21 11.9998 21C13.0542 21 13.918 20.1841 13.9943 19.1493L13.999 19.0001ZM13.435 4.4351H10.565C8.08509 4.4351 6.13036 6.38081 6.02367 8.91176L6.01909 9.1301V14.6961C6.01909 15.5351 5.69715 16.2918 5.18016 16.88L5.068 17H18.942L18.8301 16.8778C18.357 16.3345 18.0498 15.6482 18.0054 14.8877L17.9998 14.6961L17.9991 9.97246L18.0373 9.97652C15.7693 9.74498 13.9998 7.82913 13.9998 5.5C13.9998 5.21597 14.0261 4.93808 14.0764 4.66865L14.1147 4.4851C13.9615 4.46208 13.8053 4.44697 13.6467 4.43985L13.435 4.4351ZM18.4998 3C17.1191 3 15.9998 4.11929 15.9998 5.5C15.9998 6.88071 17.1191 8 18.4998 8C19.8805 8 20.9998 6.88071 20.9998 5.5C20.9998 4.11929 19.8805 3 18.4998 3Z\" fill=\"#079CB2\"></path></g><defs><clipPath id=\"clip0_167_176\"><rect width=\"24\" height=\"24\" fill=\"white\"></rect></clipPath></defs></svg>";

/***/ }),

/***/ "fb01":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M5 20C4.44772 20 4 19.5523 4 19L4 4C4 3.44771 4.44772 3 5 3L8 3L8 20L5 20Z\" fill=\"#DFE4E5\"></path><path d=\"M8 20L8 3L20 3L20 20L8 20Z\" fill=\"white\"></path><path d=\"M5 3H19C20.1046 3 21 3.89543 21 5V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V5C3 3.89543 3.89543 3 5 3Z\" stroke=\"#1F3A3E\" stroke-width=\"2\"></path><path d=\"M13.6626 14.7182L17.7206 10.6413C17.9624 10.3987 18.0571 10.0449 17.9689 9.7131C17.8806 9.38135 17.623 9.12208 17.2929 9.03296C16.9628 8.94384 16.6104 9.0384 16.3686 9.28104L12.9876 12.6798L11.6336 11.3195C11.2597 10.9441 10.6537 10.9443 10.2801 11.32C9.90645 11.6956 9.90667 12.3044 10.2806 12.6798L12.3096 14.7182C12.4889 14.8986 12.7323 15 12.9861 15C13.2399 15 13.4832 14.8986 13.6626 14.7182Z\" fill=\"#1F3A3E\"></path><rect width=\"17\" height=\"2\" transform=\"matrix(1.19249e-08 -1 -1 -1.19249e-08 8 20)\" fill=\"#1F3A3E\"></rect></svg>";

/***/ }),

/***/ "fb15":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "components", function() { return /* reexport */ src_plugin["a" /* components */]; });

// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (true) {
    var getCurrentScript = __webpack_require__("8875")
    currentScript = getCurrentScript()

    // for backward compatibility, because previously we directly included the polyfill
    if (!('currentScript' in document)) {
      Object.defineProperty(document, 'currentScript', { get: getCurrentScript })
    }
  }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __webpack_require__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

// EXTERNAL MODULE: ./src/plugin.js
var src_plugin = __webpack_require__("fe83");

// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib.js


/* harmony default export */ var entry_lib = __webpack_exports__["default"] = (src_plugin["b" /* default */]);



/***/ }),

/***/ "fb36":
/***/ (function(module, exports, __webpack_require__) {

var getQuarter = __webpack_require__("b8f9")
var parse = __webpack_require__("c8d5")

/**
 * @category Quarter Helpers
 * @summary Get the number of calendar quarters between the given dates.
 *
 * @description
 * Get the number of calendar quarters between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar quarters
 *
 * @example
 * // How many calendar quarters are between 31 December 2013 and 2 July 2014?
 * var result = differenceInCalendarQuarters(
 *   new Date(2014, 6, 2),
 *   new Date(2013, 11, 31)
 * )
 * //=> 3
 */
function differenceInCalendarQuarters (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)

  var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear()
  var quarterDiff = getQuarter(dateLeft) - getQuarter(dateRight)

  return yearDiff * 4 + quarterDiff
}

module.exports = differenceInCalendarQuarters


/***/ }),

/***/ "fb3b":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><mask id=\"path-1-inside-1_167_19\" fill=\"white\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5 1C2.79086 1 1 2.79086 1 5V16C1 18.2091 2.79086 20 5 20H8.68629L11.2929 22.6066C11.6834 22.9971 12.3166 22.9971 12.7071 22.6066L15.3137 20H19C21.2091 20 23 18.2091 23 16V5C23 2.79086 21.2091 1 19 1H5Z\"></path></mask><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5 1C2.79086 1 1 2.79086 1 5V16C1 18.2091 2.79086 20 5 20H8.68629L11.2929 22.6066C11.6834 22.9971 12.3166 22.9971 12.7071 22.6066L15.3137 20H19C21.2091 20 23 18.2091 23 16V5C23 2.79086 21.2091 1 19 1H5Z\" fill=\"white\"></path><path d=\"M8.68629 20L10.1005 18.5858L9.51472 18H8.68629V20ZM11.2929 22.6066L12.7071 21.1924L11.2929 22.6066ZM12.7071 22.6066L11.2929 21.1924L12.7071 22.6066ZM15.3137 20V18H14.4853L13.8995 18.5858L15.3137 20ZM3 5C3 3.89543 3.89543 3 5 3V-1C1.68629 -1 -1 1.68629 -1 5H3ZM3 16V5H-1V16H3ZM5 18C3.89543 18 3 17.1046 3 16H-1C-1 19.3137 1.68629 22 5 22V18ZM8.68629 18H5V22H8.68629V18ZM12.7071 21.1924L10.1005 18.5858L7.27208 21.4142L9.87868 24.0208L12.7071 21.1924ZM11.2929 21.1924C11.6834 20.8019 12.3166 20.8019 12.7071 21.1924L9.87868 24.0208C11.0503 25.1924 12.9497 25.1924 14.1213 24.0208L11.2929 21.1924ZM13.8995 18.5858L11.2929 21.1924L14.1213 24.0208L16.7279 21.4142L13.8995 18.5858ZM19 18H15.3137V22H19V18ZM21 16C21 17.1046 20.1046 18 19 18V22C22.3137 22 25 19.3137 25 16H21ZM21 5V16H25V5H21ZM19 3C20.1046 3 21 3.89543 21 5H25C25 1.68629 22.3137 -1 19 -1V3ZM5 3H19V-1H5V3Z\" fill=\"#1F3A3E\" mask=\"url(#path-1-inside-1_167_19)\"></path><path d=\"M12.8517 7.71186L12.8518 7.7117C13.8007 6.76277 15.3393 6.76275 16.2883 7.71172L16.2883 7.71173C17.1655 8.58893 17.2411 9.98617 16.4635 10.953C15.5441 12.096 14.9149 12.7252 13.7718 13.6446L13.7717 13.6446L12 15.0697L10.2282 13.6446C10.2282 13.6446 10.2282 13.6446 10.2282 13.6446C9.08516 12.7252 8.45595 12.096 7.53653 10.9529C6.75893 9.98618 6.83449 8.58896 7.71176 7.71173L7.71177 7.71172C8.66073 6.76276 10.1992 6.76276 11.1482 7.71172L11.2929 7.85639L11.9998 8.56335L12.7069 7.85653L12.8517 7.71186Z\" fill=\"#DFE4E5\" stroke=\"#1F3A3E\" stroke-width=\"2\"></path></svg>";

/***/ }),

/***/ "fb6a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var isObject = __webpack_require__("861d");
var isArray = __webpack_require__("e8b5");
var toAbsoluteIndex = __webpack_require__("23cb");
var toLength = __webpack_require__("50c4");
var toIndexedObject = __webpack_require__("fc6a");
var createProperty = __webpack_require__("8418");
var wellKnownSymbol = __webpack_require__("b622");
var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");
var arrayMethodUsesToLength = __webpack_require__("ae40");

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('slice');
var USES_TO_LENGTH = arrayMethodUsesToLength('slice', { ACCESSORS: true, 0: 0, 1: 2 });

var SPECIES = wellKnownSymbol('species');
var nativeSlice = [].slice;
var max = Math.max;

// `Array.prototype.slice` method
// https://tc39.es/ecma262/#sec-array.prototype.slice
// fallback for not array-like ES3 strings and DOM objects
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT || !USES_TO_LENGTH }, {
  slice: function slice(start, end) {
    var O = toIndexedObject(this);
    var length = toLength(O.length);
    var k = toAbsoluteIndex(start, length);
    var fin = toAbsoluteIndex(end === undefined ? length : end, length);
    // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible
    var Constructor, result, n;
    if (isArray(O)) {
      Constructor = O.constructor;
      // cross-realm fallback
      if (typeof Constructor == 'function' && (Constructor === Array || isArray(Constructor.prototype))) {
        Constructor = undefined;
      } else if (isObject(Constructor)) {
        Constructor = Constructor[SPECIES];
        if (Constructor === null) Constructor = undefined;
      }
      if (Constructor === Array || Constructor === undefined) {
        return nativeSlice.call(O, k, fin);
      }
    }
    result = new (Constructor === undefined ? Array : Constructor)(max(fin - k, 0));
    for (n = 0; k < fin; k++, n++) if (k in O) createProperty(result, n, O[k]);
    result.length = n;
    return result;
  }
});


/***/ }),

/***/ "fb98":
/***/ (function(module, exports, __webpack_require__) {

var addHours = __webpack_require__("1cc6")

/**
 * @category Hour Helpers
 * @summary Subtract the specified number of hours from the given date.
 *
 * @description
 * Subtract the specified number of hours from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of hours to be subtracted
 * @returns {Date} the new date with the hours subtracted
 *
 * @example
 * // Subtract 2 hours from 11 July 2014 01:00:00:
 * var result = subHours(new Date(2014, 6, 11, 1, 0), 2)
 * //=> Thu Jul 10 2014 23:00:00
 */
function subHours (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addHours(dirtyDate, -amount)
}

module.exports = subHours


/***/ }),

/***/ "fbaf":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("c8d5")

/**
 * @category Hour Helpers
 * @summary Return the start of an hour for the given date.
 *
 * @description
 * Return the start of an hour for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of an hour
 *
 * @example
 * // The start of an hour for 2 September 2014 11:55:00:
 * var result = startOfHour(new Date(2014, 8, 2, 11, 55))
 * //=> Tue Sep 02 2014 11:00:00
 */
function startOfHour (dirtyDate) {
  var date = parse(dirtyDate)
  date.setMinutes(0, 0, 0)
  return date
}

module.exports = startOfHour


/***/ }),

/***/ "fc18":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("0d24");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("b2e3fa3a", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "fc68":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("c9d6");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("b8cbc740", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "fc6a":
/***/ (function(module, exports, __webpack_require__) {

// toObject with fallback for non-array-like ES3 strings
var IndexedObject = __webpack_require__("44ad");
var requireObjectCoercible = __webpack_require__("1d80");

module.exports = function (it) {
  return IndexedObject(requireObjectCoercible(it));
};


/***/ }),

/***/ "fc89":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c662cfac-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/chart/PpSingleStackBarChart.vue?vue&type=template&id=4e37b43b&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex pp-single-stack-bar-chart"},_vm._l((_vm.items),function(item,index){return _c('div',{key:index,style:({'background-color': item.color, flex: item.value}),attrs:{"title":item.text}})}),0)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/chart/PpSingleStackBarChart.vue?vue&type=template&id=4e37b43b&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/chart/PpSingleStackBarChart.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var PpSingleStackBarChartvue_type_script_lang_js_ = ({
  name: 'PpSingleStackBarChart',
  props: {
    /** Items that will be displayed on the chart.
    * Items: [{ text: 'Online scheduling', value: 85, color: 'red' }, { text: 'Phone calls', value: 10, color: 'blue' }].
    * With colors we can use our scss variables for colors like: blue10, green20, grey30...etc.
    */
    items: {
      type: Array,
      required: true
    }
  }
});
// CONCATENATED MODULE: ./src/components/chart/PpSingleStackBarChart.vue?vue&type=script&lang=js&
 /* harmony default export */ var chart_PpSingleStackBarChartvue_type_script_lang_js_ = (PpSingleStackBarChartvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/chart/PpSingleStackBarChart.vue?vue&type=style&index=0&id=4e37b43b&scoped=true&lang=scss&
var PpSingleStackBarChartvue_type_style_index_0_id_4e37b43b_scoped_true_lang_scss_ = __webpack_require__("01cc");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/chart/PpSingleStackBarChart.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  chart_PpSingleStackBarChartvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "4e37b43b",
  null
  
)

/* harmony default export */ var PpSingleStackBarChart = __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "fcb3":
/***/ (function(module, exports, __webpack_require__) {

var addMonths = __webpack_require__("6665")

/**
 * @category Year Helpers
 * @summary Add the specified number of years to the given date.
 *
 * @description
 * Add the specified number of years to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of years to be added
 * @returns {Date} the new date with the years added
 *
 * @example
 * // Add 5 years to 1 September 2014:
 * var result = addYears(new Date(2014, 8, 1), 5)
 * //=> Sun Sep 01 2019 00:00:00
 */
function addYears (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addMonths(dirtyDate, amount * 12)
}

module.exports = addYears


/***/ }),

/***/ "fcdc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpImage_vue_vue_type_style_index_0_id_29196306_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("5981");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpImage_vue_vue_type_style_index_0_id_29196306_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PpImage_vue_vue_type_style_index_0_id_29196306_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "fd39":
/***/ (function(module, exports, __webpack_require__) {

var startOfDay = __webpack_require__("0978")

/**
 * @category Day Helpers
 * @summary Are the given dates in the same day?
 *
 * @description
 * Are the given dates in the same day?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same day
 *
 * @example
 * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
 * var result = isSameDay(
 *   new Date(2014, 8, 4, 6, 0),
 *   new Date(2014, 8, 4, 18, 0)
 * )
 * //=> true
 */
function isSameDay (dirtyDateLeft, dirtyDateRight) {
  var dateLeftStartOfDay = startOfDay(dirtyDateLeft)
  var dateRightStartOfDay = startOfDay(dirtyDateRight)

  return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime()
}

module.exports = isSameDay


/***/ }),

/***/ "fdbc":
/***/ (function(module, exports) {

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
module.exports = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};


/***/ }),

/***/ "fdbf":
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_SYMBOL = __webpack_require__("4930");

module.exports = NATIVE_SYMBOL
  // eslint-disable-next-line no-undef
  && !Symbol.sham
  // eslint-disable-next-line no-undef
  && typeof Symbol.iterator == 'symbol';


/***/ }),

/***/ "fdc0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"c662cfac-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/message/PpMessage.vue?vue&type=template&id=683c2c2f&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"pp-message mb-5"},[_c('div',{staticClass:"pp-message__status subtitle-1 d-flex align-center"},[_vm._v(" "+_vm._s(_vm.timestampDisplayText)+" ")]),_c('pp-avatar-icon',{attrs:{"name":_vm.name,"size":"md","is-practice":_vm.isFromPractice}}),(_vm.text)?_c('div',{staticClass:"pp-message__message text-h6 rounded-xl rounded-tl-0 pa-4",class:{
      'pp-message__message--practice':_vm.isFromPractice,
      'mb-1':_vm.attachmentUuid
    }},[_vm._v(" "+_vm._s(_vm.text)+" "),(_vm.fromWebToText)?_c('div',{staticClass:"mt-4 mx-n4 py-2 px-4 mb-n4 pp-message__message__source"},[_vm._v(" Message received from Web to Text ")]):_vm._e()]):_vm._e(),(_vm.attachmentUuid)?_c('div',{staticClass:"pp-message__attachments"},[_vm._l((_vm.attachments),function(attachment,i){return [(!_vm.getAttachmentById(attachment))?_c('div',{key:i,staticClass:"d-flex align-center pp-message__message text-h6 rounded-xl rounded-tl-0 pa-4 pp-message__attachment-loading"},[_c('pp-loader',{attrs:{"indeterminate":true,"size":10,"width":1,"color":"secondary"}}),_vm._v(" Attachment loading... ")],1):_c('pp-image',{key:i,attrs:{"name":_vm.getAttachmentById(attachment).name,"source":_vm.getAttachmentById(attachment).source}})]})],2):_vm._e(),(false)?undefined:_vm._e()],1)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/message/PpMessage.vue?vue&type=template&id=683c2c2f&scoped=true&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__("7db0");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__("a9e3");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__("ac1f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.split.js
var es_string_split = __webpack_require__("1276");

// EXTERNAL MODULE: ./src/components/image/PpImage.vue + 4 modules
var PpImage = __webpack_require__("05cb");

// EXTERNAL MODULE: ./src/components/avatar-icon/PpAvatarIcon.vue + 4 modules
var PpAvatarIcon = __webpack_require__("020a");

// EXTERNAL MODULE: ./src/components/loader/PpLoader.vue + 4 modules
var PpLoader = __webpack_require__("d888");

// CONCATENATED MODULE: ./src/components/message/constants.js
var STATUS = {
  SENDING: 'sending'
};
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/message/PpMessage.vue?vue&type=script&lang=js&




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var PpMessagevue_type_script_lang_js_ = ({
  name: 'PpMessage',
  components: {
    'pp-loader': PpLoader["default"],
    'pp-image': PpImage["default"],
    'pp-avatar-icon': PpAvatarIcon["default"]
  },
  props: {
    /** The name used for the avatar */
    name: {
      type: String,
      required: true
    },

    /** The content of the message */
    text: {
      type: String,
      default: ''
    },

    /** Timestamp of the message */
    timestamp: {
      type: Number,
      default: null
    },

    /** Status of message */
    status: {
      type: String,
      required: true
    },

    /** Message sent from practice */
    isFromPractice: {
      type: Boolean,
      default: false
    },

    /** Array of each attachment info */
    attachmentData: {
      type: Array,
      default: function _default() {
        return [];
      }
    },

    /** Source of the message, will show note below message */
    source: {
      type: String,
      default: ''
    },

    /** Comma separated string of uuids */
    attachmentUuid: {
      type: String,
      default: ''
    }
  },
  computed: {
    timestampDisplayText: function timestampDisplayText() {
      if (this.status === STATUS.SENDING) {
        return 'Sending...';
      }

      var formatOptions = {
        hour: 'numeric',
        minute: 'numeric',
        hour12: true
      };
      var now = new Date(Date.now());
      var inPreviousYear = false; // add year if its in a previous year

      if (new Date(this.timestamp).getFullYear() < now.getFullYear()) {
        formatOptions.year = 'numeric';
        inPreviousYear = true;
      } // add day and month if its earlier than today


      if (new Date(Date.now()) - new Date(this.timestamp) >= 86400000 || new Date(this.timestamp).getMonth() < now.getMonth() || inPreviousYear) {
        formatOptions.weekday = 'short';
        formatOptions.month = 'short';
        formatOptions.day = 'numeric';
      }

      return new Intl.DateTimeFormat('en-US', formatOptions).format(this.timestamp);
    },
    fromWebToText: function fromWebToText() {
      return this.source === 'WEBTOTEXT' || this.source === 'WEB_TO_TEXT';
    },
    attachments: function attachments() {
      return this.attachmentUuid ? this.attachmentUuid.split(',') : [];
    }
  },
  methods: {
    // Get specific attachment object from the attachmentData by id
    getAttachmentById: function getAttachmentById(attachmentUuid) {
      return this.attachmentData.find(function (attachment) {
        return attachment.id === attachmentUuid;
      });
    }
  }
});
// CONCATENATED MODULE: ./src/components/message/PpMessage.vue?vue&type=script&lang=js&
 /* harmony default export */ var message_PpMessagevue_type_script_lang_js_ = (PpMessagevue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/message/PpMessage.vue?vue&type=style&index=0&id=683c2c2f&lang=scss&scoped=true&
var PpMessagevue_type_style_index_0_id_683c2c2f_lang_scss_scoped_true_ = __webpack_require__("c0bb");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/message/PpMessage.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  message_PpMessagevue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "683c2c2f",
  null
  
)

/* harmony default export */ var PpMessage = __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "fdc2":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.theme--light.v-text-field>.v-input__control>.v-input__slot:before{border-color:rgba(0,0,0,.42)}.theme--light.v-text-field:not(.v-input--has-state):hover>.v-input__control>.v-input__slot:before{border-color:var(--pp-text-primary,#2b2b2b)}.theme--light.v-text-field.v-input--is-disabled .v-input__slot:before{-o-border-image:repeating-linear-gradient(90deg,var(--pp-text-disabled,#f6f6f6) 0,var(--pp-text-disabled,#f6f6f6) 2px,transparent 0,transparent 4px) 1 repeat;border-image:repeating-linear-gradient(90deg,var(--pp-text-disabled,#f6f6f6) 0,var(--pp-text-disabled,#f6f6f6) 2px,transparent 0,transparent 4px) 1 repeat}.theme--light.v-text-field--filled>.v-input__control>.v-input__slot{background:var(--pp-text-field-fill,#e9efee)}.theme--light.v-text-field--filled:not(.v-input--is-focused):not(.v-input--has-state)>.v-input__control>.v-input__slot:hover{background:var(--pp-text-field-fill-on-hover,#eef7f9)}.theme--light.v-text-field--solo>.v-input__control>.v-input__slot{background:var(--cards-color,#fff)}.theme--light.v-text-field--solo-inverted>.v-input__control>.v-input__slot{background:rgba(0,0,0,.06)}.theme--light.v-text-field--solo-inverted.v-input--is-focused>.v-input__control>.v-input__slot{background:#2b2b2b}.theme--light.v-text-field--solo-inverted.v-input--is-focused>.v-input__control>.v-input__slot input{color:#fff}.theme--light.v-text-field--solo-inverted.v-input--is-focused>.v-input__control>.v-input__slot input::-moz-placeholder{color:hsla(0,0%,100%,.5)}.theme--light.v-text-field--solo-inverted.v-input--is-focused>.v-input__control>.v-input__slot input:-ms-input-placeholder{color:hsla(0,0%,100%,.5)}.theme--light.v-text-field--solo-inverted.v-input--is-focused>.v-input__control>.v-input__slot input::placeholder{color:hsla(0,0%,100%,.5)}.theme--light.v-text-field--solo-inverted.v-input--is-focused>.v-input__control>.v-input__slot .v-label{color:hsla(0,0%,100%,.7)}.theme--light.v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state):not(.v-input--is-disabled)>.v-input__control>.v-input__slot:hover fieldset,.theme--light.v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state)>.v-input__control>.v-input__slot fieldset{color:#d6d6d6}.theme--light.v-text-field--outlined:not(.v-input--is-focused).v-input--is-disabled>.v-input__control>.v-input__slot fieldset{color:rgba(0,0,0,.26)}.theme--dark.v-text-field>.v-input__control>.v-input__slot:before{border-color:hsla(0,0%,100%,.7)}.theme--dark.v-text-field:not(.v-input--has-state):hover>.v-input__control>.v-input__slot:before{border-color:var(--pp-primary-button-text-color,#004852)}.theme--dark.v-text-field.v-input--is-disabled .v-input__slot:before{-o-border-image:repeating-linear-gradient(90deg,hsla(0,0%,100%,.5) 0,hsla(0,0%,100%,.5) 2px,transparent 0,transparent 4px) 1 repeat;border-image:repeating-linear-gradient(90deg,hsla(0,0%,100%,.5) 0,hsla(0,0%,100%,.5) 2px,transparent 0,transparent 4px) 1 repeat}.theme--dark.v-text-field--filled>.v-input__control>.v-input__slot{background:hsla(0,0%,100%,.08)}.theme--dark.v-text-field--filled:not(.v-input--is-focused):not(.v-input--has-state)>.v-input__control>.v-input__slot:hover{background:hsla(0,0%,100%,.16)}.theme--dark.v-text-field--solo>.v-input__control>.v-input__slot{background:#1e1e1e}.theme--dark.v-text-field--solo-inverted>.v-input__control>.v-input__slot{background:hsla(0,0%,100%,.16)}.theme--dark.v-text-field--solo-inverted.v-input--is-focused>.v-input__control>.v-input__slot{background:#fff}.theme--dark.v-text-field--solo-inverted.v-input--is-focused>.v-input__control>.v-input__slot input{color:rgba(0,0,0,.87)}.theme--dark.v-text-field--solo-inverted.v-input--is-focused>.v-input__control>.v-input__slot input::-moz-placeholder{color:rgba(0,0,0,.38)}.theme--dark.v-text-field--solo-inverted.v-input--is-focused>.v-input__control>.v-input__slot input:-ms-input-placeholder{color:rgba(0,0,0,.38)}.theme--dark.v-text-field--solo-inverted.v-input--is-focused>.v-input__control>.v-input__slot input::placeholder{color:rgba(0,0,0,.38)}.theme--dark.v-text-field--solo-inverted.v-input--is-focused>.v-input__control>.v-input__slot .v-label{color:rgba(0,0,0,.6)}.theme--dark.v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state)>.v-input__control>.v-input__slot fieldset{color:hsla(0,0%,100%,.24)}.theme--dark.v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state):not(.v-input--is-disabled)>.v-input__control>.v-input__slot:hover fieldset{color:#fff}.theme--dark.v-text-field--outlined:not(.v-input--is-focused).v-input--is-disabled>.v-input__control>.v-input__slot fieldset{color:hsla(0,0%,100%,.16)}.v-text-field{padding-top:12px;margin-top:4px}.v-text-field__prefix,.v-text-field__suffix{line-height:20px}.v-text-field input{flex:1 1 auto;line-height:20px;padding:8px 0 8px;max-width:100%;min-width:0;width:100%}.v-text-field .v-input__control,.v-text-field .v-input__slot,.v-text-field fieldset{border-radius:inherit}.v-text-field.v-input--has-state .v-input__control>.v-text-field__details>.v-counter,.v-text-field.v-input--is-disabled .v-input__control>.v-text-field__details>.v-counter,.v-text-field.v-input--is-disabled .v-input__control>.v-text-field__details>.v-messages,.v-text-field .v-input__control,.v-text-field fieldset{color:inherit}.v-text-field.v-input--dense{padding-top:0}.v-text-field.v-input--dense .v-label{top:4px}.v-text-field.v-input--dense:not(.v-text-field--outlined) .v-text-field__prefix,.v-text-field.v-input--dense:not(.v-text-field--outlined) .v-text-field__suffix,.v-text-field.v-input--dense:not(.v-text-field--outlined) input{padding:4px 0 2px}.v-text-field.v-input--dense:not(.v-text-field--outlined) .v-text-field__prefix{padding-right:4px}.v-text-field.v-input--dense:not(.v-text-field--outlined) .v-text-field__suffix{padding-left:4px}.v-text-field.v-input--dense[type=text]::-ms-clear{display:none}.v-text-field.v-input--dense .v-input__append-inner,.v-text-field.v-input--dense .v-input__prepend-inner{margin-top:0}.v-text-field .v-input__append-inner,.v-text-field .v-input__prepend-inner{align-self:flex-start;display:inline-flex;margin-top:4px;line-height:1;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.v-application--is-ltr .v-text-field .v-input__prepend-inner{margin-right:auto;padding-right:4px}.v-application--is-ltr .v-text-field .v-input__append-inner,.v-application--is-rtl .v-text-field .v-input__prepend-inner{margin-left:auto;padding-left:4px}.v-application--is-rtl .v-text-field .v-input__append-inner{margin-right:auto;padding-right:4px}.v-text-field .v-counter{white-space:nowrap}.v-application--is-ltr .v-text-field .v-counter{margin-left:8px}.v-application--is-rtl .v-text-field .v-counter{margin-right:8px}.v-text-field .v-label{max-width:90%;overflow:hidden;text-overflow:ellipsis;top:6px;white-space:nowrap;pointer-events:none}.v-application--is-ltr .v-text-field .v-label{transform-origin:top left}.v-application--is-rtl .v-text-field .v-label{transform-origin:top right}.v-text-field .v-label--active{max-width:133%;transform:translateY(-18px) scale(.75)}.v-text-field>.v-input__control>.v-input__slot{cursor:text}.v-text-field>.v-input__control>.v-input__slot:after,.v-text-field>.v-input__control>.v-input__slot:before{bottom:-1px;content:\"\";left:0;position:absolute;transition:.3s cubic-bezier(.25,.8,.5,1);width:100%}.v-text-field>.v-input__control>.v-input__slot:before{border-color:inherit;border-style:solid;border-width:thin 0 0 0}.v-text-field>.v-input__control>.v-input__slot:after{background-color:currentColor;border-color:currentColor;border-style:solid;border-width:thin 0 thin 0;transform:scaleX(0)}.v-text-field__details{display:flex;flex:1 0 auto;max-width:100%;min-height:8px;overflow:hidden}.v-text-field__prefix,.v-text-field__suffix{align-self:center;cursor:default;transition:color .3s cubic-bezier(.25,.8,.5,1);white-space:nowrap}.v-application--is-ltr .v-text-field__prefix{text-align:right;padding-right:4px}.v-application--is-rtl .v-text-field__prefix{text-align:left;padding-left:4px}.v-text-field__suffix{white-space:nowrap}.v-application--is-ltr .v-text-field__suffix{padding-left:4px}.v-application--is-rtl .v-text-field__suffix{padding-right:4px}.v-application--is-ltr .v-text-field--reverse .v-text-field__prefix{text-align:left;padding-right:0;padding-left:4px}.v-application--is-rtl .v-text-field--reverse .v-text-field__prefix{text-align:right;padding-right:4px;padding-left:0}.v-application--is-ltr .v-text-field--reverse .v-text-field__suffix{padding-left:0;padding-right:4px}.v-application--is-rtl .v-text-field--reverse .v-text-field__suffix{padding-left:4px;padding-right:0}.v-text-field>.v-input__control>.v-input__slot>.v-text-field__slot{display:flex;flex:1 1 auto;position:relative}.v-text-field:not(.v-text-field--is-booted) .v-label,.v-text-field:not(.v-text-field--is-booted) legend{transition:none}.v-text-field--filled,.v-text-field--full-width,.v-text-field--outlined{position:relative}.v-text-field--filled>.v-input__control>.v-input__slot,.v-text-field--full-width>.v-input__control>.v-input__slot,.v-text-field--outlined>.v-input__control>.v-input__slot{align-items:stretch;min-height:var(--pp-text-field-min-height,36px)}.v-text-field--filled.v-input--dense>.v-input__control>.v-input__slot,.v-text-field--full-width.v-input--dense>.v-input__control>.v-input__slot,.v-text-field--outlined.v-input--dense>.v-input__control>.v-input__slot{min-height:52px}.v-text-field--filled.v-input--dense.v-text-field--outlined.v-text-field--filled>.v-input__control>.v-input__slot,.v-text-field--filled.v-input--dense.v-text-field--outlined>.v-input__control>.v-input__slot,.v-text-field--filled.v-input--dense.v-text-field--single-line>.v-input__control>.v-input__slot,.v-text-field--full-width.v-input--dense.v-text-field--outlined.v-text-field--filled>.v-input__control>.v-input__slot,.v-text-field--full-width.v-input--dense.v-text-field--outlined>.v-input__control>.v-input__slot,.v-text-field--full-width.v-input--dense.v-text-field--single-line>.v-input__control>.v-input__slot,.v-text-field--outlined.v-input--dense.v-text-field--outlined.v-text-field--filled>.v-input__control>.v-input__slot,.v-text-field--outlined.v-input--dense.v-text-field--outlined>.v-input__control>.v-input__slot,.v-text-field--outlined.v-input--dense.v-text-field--single-line>.v-input__control>.v-input__slot{min-height:40px}.v-text-field--outlined{border-radius:5px}.v-text-field--enclosed .v-input__append-inner,.v-text-field--enclosed .v-input__append-outer,.v-text-field--enclosed .v-input__prepend-inner,.v-text-field--enclosed .v-input__prepend-outer,.v-text-field--full-width .v-input__append-inner,.v-text-field--full-width .v-input__append-outer,.v-text-field--full-width .v-input__prepend-inner,.v-text-field--full-width .v-input__prepend-outer{margin-top:12px}.v-text-field--enclosed.v-input--dense:not(.v-text-field--solo) .v-input__append-inner,.v-text-field--enclosed.v-input--dense:not(.v-text-field--solo) .v-input__append-outer,.v-text-field--enclosed.v-input--dense:not(.v-text-field--solo) .v-input__prepend-inner,.v-text-field--enclosed.v-input--dense:not(.v-text-field--solo) .v-input__prepend-outer,.v-text-field--full-width.v-input--dense:not(.v-text-field--solo) .v-input__append-inner,.v-text-field--full-width.v-input--dense:not(.v-text-field--solo) .v-input__append-outer,.v-text-field--full-width.v-input--dense:not(.v-text-field--solo) .v-input__prepend-inner,.v-text-field--full-width.v-input--dense:not(.v-text-field--solo) .v-input__prepend-outer{margin-top:14px}.v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--single-line .v-input__append-inner,.v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--single-line .v-input__append-outer,.v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--single-line .v-input__prepend-inner,.v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--single-line .v-input__prepend-outer,.v-text-field--full-width.v-input--dense:not(.v-text-field--solo).v-text-field--single-line .v-input__append-inner,.v-text-field--full-width.v-input--dense:not(.v-text-field--solo).v-text-field--single-line .v-input__append-outer,.v-text-field--full-width.v-input--dense:not(.v-text-field--solo).v-text-field--single-line .v-input__prepend-inner,.v-text-field--full-width.v-input--dense:not(.v-text-field--solo).v-text-field--single-line .v-input__prepend-outer{margin-top:9px}.v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__append-inner,.v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__append-outer,.v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__prepend-inner,.v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__prepend-outer,.v-text-field--full-width.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__append-inner,.v-text-field--full-width.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__append-outer,.v-text-field--full-width.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__prepend-inner,.v-text-field--full-width.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__prepend-outer{margin-top:8px}.v-text-field--filled .v-label,.v-text-field--full-width .v-label{top:18px}.v-text-field--filled .v-label--active,.v-text-field--full-width .v-label--active{transform:translateY(-6px) scale(.75)}.v-text-field--filled.v-input--dense .v-label,.v-text-field--full-width.v-input--dense .v-label{top:17px}.v-text-field--filled.v-input--dense .v-label--active,.v-text-field--full-width.v-input--dense .v-label--active{transform:translateY(-10px) scale(.75)}.v-text-field--filled.v-input--dense.v-text-field--single-line .v-label,.v-text-field--full-width.v-input--dense.v-text-field--single-line .v-label{top:11px}.v-text-field--filled{border-radius:5px 5px 0 0}.v-text-field--filled:not(.v-text-field--single-line) input{margin-top:22px}.v-text-field--filled.v-input--dense:not(.v-text-field--single-line).v-text-field--outlined input{margin-top:0}.v-text-field--filled .v-text-field__prefix,.v-text-field--filled .v-text-field__suffix{max-height:32px;margin-top:20px}.v-text-field--full-width{border-radius:0}.v-text-field--outlined .v-text-field__slot,.v-text-field--single-line .v-text-field__slot{align-items:center}.v-text-field.v-text-field--enclosed{margin:0;padding:0}.v-text-field.v-text-field--enclosed.v-text-field--single-line .v-text-field__prefix,.v-text-field.v-text-field--enclosed.v-text-field--single-line .v-text-field__suffix{margin-top:0}.v-text-field.v-text-field--enclosed:not(.v-text-field--filled) .v-progress-linear__background{display:none}.v-text-field.v-text-field--enclosed .v-text-field__details,.v-text-field.v-text-field--enclosed:not(.v-text-field--rounded)>.v-input__control>.v-input__slot{padding:0 12px}.v-text-field.v-text-field--enclosed .v-text-field__details{padding-top:0;margin-bottom:5px}.v-application--is-ltr .v-text-field--reverse input{text-align:right}.v-application--is-rtl .v-text-field--reverse input{text-align:left}.v-application--is-ltr .v-text-field--reverse .v-label{transform-origin:top right}.v-application--is-rtl .v-text-field--reverse .v-label{transform-origin:top left}.v-text-field--reverse .v-text-field__slot,.v-text-field--reverse>.v-input__control>.v-input__slot{flex-direction:row-reverse}.v-text-field--outlined>.v-input__control>.v-input__slot:after,.v-text-field--outlined>.v-input__control>.v-input__slot:before,.v-text-field--rounded>.v-input__control>.v-input__slot:after,.v-text-field--rounded>.v-input__control>.v-input__slot:before,.v-text-field--solo>.v-input__control>.v-input__slot:after,.v-text-field--solo>.v-input__control>.v-input__slot:before{display:none}.v-text-field--outlined,.v-text-field--solo{border-radius:5px}.v-text-field--outlined{margin-bottom:16px;transition:border .3s cubic-bezier(.25,.8,.5,1)}.v-text-field--outlined .v-label{top:18px}.v-text-field--outlined .v-label--active{transform:translateY(-24px) scale(.75)}.v-text-field--outlined.v-input--dense .v-label{top:10px}.v-text-field--outlined.v-input--dense .v-label--active{transform:translateY(-16px) scale(.75)}.v-text-field--outlined fieldset{border-collapse:collapse;border-color:currentColor;border-style:solid;border-width:var(--pp-text-field-border-width,2px);bottom:0;left:0;pointer-events:none;position:absolute;right:0;top:-5px;transition-duration:.3s;transition-property:color,border-width;transition-timing-function:cubic-bezier(.25,.8,.25,1)}.v-application--is-ltr .v-text-field--outlined fieldset{padding-left:8px}.v-application--is-ltr .v-text-field--outlined.v-text-field--reverse fieldset,.v-application--is-rtl .v-text-field--outlined fieldset{padding-right:8px}.v-application--is-rtl .v-text-field--outlined.v-text-field--reverse fieldset{padding-left:8px}.v-text-field--outlined legend{line-height:11px;padding:0;transition:width .3s cubic-bezier(.25,.8,.5,1)}.v-application--is-ltr .v-text-field--outlined legend{text-align:left}.v-application--is-rtl .v-text-field--outlined legend{text-align:right}.v-application--is-ltr .v-text-field--outlined.v-text-field--reverse legend{margin-left:auto}.v-application--is-rtl .v-text-field--outlined.v-text-field--reverse legend{margin-right:auto}.v-application--is-ltr .v-text-field--outlined.v-text-field--rounded legend{margin-left:12px}.v-application--is-rtl .v-text-field--outlined.v-text-field--rounded legend{margin-right:12px}.v-text-field--outlined>.v-input__control>.v-input__slot{background:transparent}.v-text-field--outlined .v-text-field__prefix{max-height:32px}.v-text-field--outlined .v-input__append-outer,.v-text-field--outlined .v-input__prepend-outer{margin-top:18px}.v-text-field--outlined.v-input--has-state fieldset,.v-text-field--outlined.v-input--is-focused fieldset{border:var(--pp-text-field-border-width,2px) solid currentColor}.v-text-field--rounded{border-radius:28px}.v-text-field--rounded>.v-input__control>.v-input__slot{padding:0 24px}.v-text-field--shaped{border-radius:16px 16px 0 0}.v-text-field.v-text-field--solo .v-label{top:calc(50% - 9px)}.v-text-field.v-text-field--solo .v-input__control{min-height:48px;padding:0}.v-text-field.v-text-field--solo .v-input__control input{caret-color:auto}.v-text-field.v-text-field--solo.v-input--dense>.v-input__control{min-height:38px}.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)>.v-input__control>.v-input__slot{box-shadow:0 3px 1px -2px transparent,0 2px 2px 0 transparent,0 1px 5px 0 rgba(0,0,0,.12)}.v-text-field.v-text-field--solo .v-input__append-inner,.v-text-field.v-text-field--solo .v-input__prepend-inner{align-self:center;margin-top:0}.v-text-field.v-text-field--solo .v-input__append-outer,.v-text-field.v-text-field--solo .v-input__prepend-outer{margin-top:12px}.v-text-field.v-text-field--solo.v-input--dense .v-input__append-outer,.v-text-field.v-text-field--solo.v-input--dense .v-input__prepend-outer{margin-top:7px}.v-text-field.v-input--is-focused>.v-input__control>.v-input__slot:after{transform:scaleX(1)}.v-text-field.v-input--has-state>.v-input__control>.v-input__slot:before{border-color:currentColor}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "fdcd":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.theme--light.v-overlay{color:var(--pp-text-primary,#2b2b2b)}.theme--dark.v-overlay{color:var(--pp-primary-button-text-color,#004852)}.v-overlay{align-items:center;border-radius:inherit;display:flex;justify-content:center;position:fixed;top:0;left:0;right:0;bottom:0;pointer-events:none;transition:.3s cubic-bezier(.25,.8,.5,1),z-index 1ms}.v-overlay__content{position:relative}.v-overlay__scrim{border-radius:inherit;bottom:0;height:100%;left:0;position:absolute;right:0;top:0;transition:inherit;width:100%;will-change:opacity}.v-overlay--absolute{position:absolute}.v-overlay--active{pointer-events:auto}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "fdcf":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("6801");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("76e6d3e8", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "fe09":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return prevent; });
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("4de4");
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_some_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("45fc");
/* harmony import */ var core_js_modules_es_array_some_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("cca6");
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("d3b7");
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("25f0");
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _components_VInput__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("c37a");
/* harmony import */ var _rippleable__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("5311");
/* harmony import */ var _comparable__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("8547");
/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("58df");





// Components
 // Mixins


 // Utilities


function prevent(e) {
  e.preventDefault();
}
/* @vue/component */

/* harmony default export */ __webpack_exports__["a"] = (Object(_util_mixins__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"])(_components_VInput__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"], _rippleable__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"], _comparable__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"]).extend({
  name: 'selectable',
  model: {
    prop: 'inputValue',
    event: 'change'
  },
  props: {
    id: String,
    inputValue: null,
    falseValue: null,
    trueValue: null,
    multiple: {
      type: Boolean,
      default: null
    },
    label: String
  },
  data: function data() {
    return {
      hasColor: this.inputValue,
      lazyValue: this.inputValue
    };
  },
  computed: {
    computedColor: function computedColor() {
      if (!this.isActive) return undefined;
      if (this.color) return this.color;
      if (this.isDark && !this.appIsDark) return 'white';
      return 'primary';
    },
    isMultiple: function isMultiple() {
      return this.multiple === true || this.multiple === null && Array.isArray(this.internalValue);
    },
    isActive: function isActive() {
      var _this = this;

      var value = this.value;
      var input = this.internalValue;

      if (this.isMultiple) {
        if (!Array.isArray(input)) return false;
        return input.some(function (item) {
          return _this.valueComparator(item, value);
        });
      }

      if (this.trueValue === undefined || this.falseValue === undefined) {
        return value ? this.valueComparator(value, input) : Boolean(input);
      }

      return this.valueComparator(input, this.trueValue);
    },
    isDirty: function isDirty() {
      return this.isActive;
    },
    rippleState: function rippleState() {
      return !this.isDisabled && !this.validationState ? undefined : this.validationState;
    }
  },
  watch: {
    inputValue: function inputValue(val) {
      this.lazyValue = val;
      this.hasColor = val;
    }
  },
  methods: {
    genLabel: function genLabel() {
      var label = _components_VInput__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"].options.methods.genLabel.call(this);
      if (!label) return label;
      label.data.on = {
        // Label shouldn't cause the input to focus
        click: prevent
      };
      return label;
    },
    genInput: function genInput(type, attrs) {
      return this.$createElement('input', {
        attrs: Object.assign({
          'aria-checked': this.isActive.toString(),
          disabled: this.isDisabled,
          id: this.computedId,
          role: type,
          type: type
        }, attrs),
        domProps: {
          value: this.value,
          checked: this.isActive
        },
        on: {
          blur: this.onBlur,
          change: this.onChange,
          focus: this.onFocus,
          keydown: this.onKeydown,
          click: prevent
        },
        ref: 'input'
      });
    },
    onBlur: function onBlur() {
      this.isFocused = false;
    },
    onClick: function onClick(e) {
      this.onChange();
      this.$emit('click', e);
    },
    onChange: function onChange() {
      var _this2 = this;

      if (!this.isInteractive) return;
      var value = this.value;
      var input = this.internalValue;

      if (this.isMultiple) {
        if (!Array.isArray(input)) {
          input = [];
        }

        var length = input.length;
        input = input.filter(function (item) {
          return !_this2.valueComparator(item, value);
        });

        if (input.length === length) {
          input.push(value);
        }
      } else if (this.trueValue !== undefined && this.falseValue !== undefined) {
        input = this.valueComparator(input, this.trueValue) ? this.falseValue : this.trueValue;
      } else if (value) {
        input = this.valueComparator(input, value) ? null : value;
      } else {
        input = !input;
      }

      this.validate(true, input);
      this.internalValue = input;
      this.hasColor = input;
    },
    onFocus: function onFocus() {
      this.isFocused = true;
    },

    /** @abstract */
    onKeydown: function onKeydown(e) {}
  }
}));

/***/ }),

/***/ "fe6c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return factory; });
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("8bbf");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("80d2");


var availableProps = {
  absolute: Boolean,
  bottom: Boolean,
  fixed: Boolean,
  left: Boolean,
  right: Boolean,
  top: Boolean
};
function factory() {
  var selected = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend({
    name: 'positionable',
    props: selected.length ? Object(_util_helpers__WEBPACK_IMPORTED_MODULE_1__[/* filterObjectOnKeys */ "n"])(availableProps, selected) : availableProps
  });
}
/* harmony default export */ __webpack_exports__["a"] = (factory()); // Add a `*` before the second `/`

/* Tests /
let single = factory(['top']).extend({
  created () {
    this.top
    this.bottom
    this.absolute
  }
})

let some = factory(['top', 'bottom']).extend({
  created () {
    this.top
    this.bottom
    this.absolute
  }
})

let all = factory().extend({
  created () {
    this.top
    this.bottom
    this.absolute
    this.foobar
  }
})
/**/

/***/ }),

/***/ "fe83":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return components; });
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("4160");
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("e260");
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("d3b7");
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("ac1f");
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("5319");
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_string_split_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("1276");
/* harmony import */ var core_js_modules_es_string_split_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("159b");
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("ddb0");
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_7__);








var components = {}; // install function executed by Vue.use()

function install(Vue) {
  if (install.installed) return;
  install.installed = true; // For each matching file name...

  requireComponent.keys().forEach(function (fileName) {
    // Get the component config
    var componentConfig = requireComponent(fileName); // Get the PascalCase version of the component name

    var componentName = fileName.split('/').pop().replace(/\.\w+$/, '');
    components[componentName] = componentConfig.default || componentConfig; // Globally register the component

    Vue.component(componentName, componentConfig.default || componentConfig);
  });
} // Create module definition for Vue.use()


var plugin = {
  install: install
}; // To auto-install when vue is found

var GlobalVue = null;

if (typeof window !== 'undefined') {
  GlobalVue = window.Vue;
} else if (typeof global !== 'undefined') {
  GlobalVue = global.Vue;
}

if (GlobalVue) {
  GlobalVue.use(plugin);
}

var requireComponent = __webpack_require__("4daf"); // Default export is library as a whole, registered via Vue.use()


/* harmony default export */ __webpack_exports__["b"] = (plugin); // To allow individual component use, export components
// each can be registered via Vue.component()
// console.log({ components })


/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba")))

/***/ }),

/***/ "fea9":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");

module.exports = global.Promise;


/***/ }),

/***/ "fecb":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.v-input--radio-group legend.v-label{cursor:text;font-size:14px;height:auto}.v-input--radio-group__input{border:none;cursor:default;display:flex;width:100%}.v-input--radio-group--column .v-input--radio-group__input>.v-label{padding-bottom:8px}.v-input--radio-group--row .v-input--radio-group__input>.v-label{padding-right:8px}.v-input--radio-group--row legend{align-self:center;display:inline-block}.v-input--radio-group--row .v-input--radio-group__input{flex-direction:row;flex-wrap:wrap}.v-input--radio-group--column legend{padding-bottom:8px}.v-input--radio-group--column .v-radio:not(:last-child):not(:only-child){margin-bottom:8px}.v-input--radio-group--column .v-input--radio-group__input{flex-direction:column}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "ff00":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M10.4762 1C5.22476 1 0.952381 5.037 0.952381 10C0.952381 11.735 1.46762 13.392 2.45048 14.836L0.443483 18.2464C0.247329 18.5797 0.487651 19 0.874401 19H10.4762C15.7276 19 20 14.963 20 10C20 5.037 15.7276 1 10.4762 1Z\" fill=\"#D5EAFD\"></path><path d=\"M3.31231 15.3432L3.63367 14.7971L3.27715 14.2733C2.40576 12.9931 1.95238 11.5317 1.95238 10C1.95238 5.64186 5.72296 2 10.4762 2C15.2294 2 19 5.64186 19 10C19 14.3581 15.2294 18 10.4762 18H1.7488L3.31231 15.3432Z\" stroke=\"#079CB2\" stroke-width=\"2\"></path><path d=\"M15.0952 7C19.559 7 23.1905 10.5884 23.1905 15C23.1905 16.5422 22.7525 18.0151 21.9171 19.2987L24 23H15.0952C10.6315 23 7 19.4116 7 15C7 10.5884 10.6315 7 15.0952 7Z\" fill=\"white\"></path><path d=\"M21.0456 19.7891L20.7484 19.261L21.079 18.7532C21.8086 17.6322 22.1905 16.3489 22.1905 15C22.1905 11.1519 19.0179 8 15.0952 8C11.1726 8 8 11.1519 8 15C8 18.8481 11.1726 22 15.0952 22H22.2898L21.0456 19.7891Z\" stroke=\"#079CB2\" stroke-width=\"2\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M17 15C17 15.5523 17.4477 16 18 16C18.5523 16 19 15.5523 19 15C19 14.4477 18.5523 14 18 14C17.4477 14 17 14.4477 17 15ZM14 15C14 15.5523 14.4477 16 15 16C15.5523 16 16 15.5523 16 15C16 14.4477 15.5523 14 15 14C14.4477 14 14 14.4477 14 15ZM12 16C11.4477 16 11 15.5523 11 15C11 14.4477 11.4477 14 12 14C12.5523 14 13 14.4477 13 15C13 15.5523 12.5523 16 12 16Z\" fill=\"#079CB2\"></path></svg>";

/***/ }),

/***/ "ff93":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("a9ee");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("527e6a36", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "ff95":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M3 3H21V15H17L15 16L12 18.5L9 16L6.5 15H3V3Z\" fill=\"#D5EAFD\"></path><path d=\"M8 15H4L3 16V20L4 21H20L21 20V16L20 15H16L14 17L12 18L10 17L8 15Z\" fill=\"white\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2 4.82C2 3.2615 3.12 2 4.5035 2H19.4965C20.878 2 22 3.265 22 4.82V19.18C22 20.7385 20.88 22 19.4965 22H4.5035C3.122 22 2 20.735 2 19.18V4.82ZM16.4985 16C16.1015 16 15.6005 16.361 15.475 16.737L15.4225 16.8955C15.0245 18.0885 13.7595 19 12.5015 19H11.4985C10.2405 19 8.9755 18.0885 8.5775 16.895L8.525 16.737C8.3995 16.361 7.899 16 7.5015 16H4V19.4985C4 19.776 4.225 20 4.5035 20H19.4965C19.776 20 20 19.776 20 19.4985V16H16.4985ZM20 14V4.5C20 4.2265 19.7735 4 19.4965 4H4.5035C4.43755 3.99954 4.37215 4.01213 4.31108 4.03705C4.25002 4.06197 4.19448 4.09873 4.14768 4.1452C4.10088 4.19168 4.06374 4.24695 4.03839 4.30785C4.01305 4.36874 4 4.43404 4 4.5V14H7.5015C8.7595 14 10.0245 14.9115 10.4225 16.105L10.475 16.263C10.6005 16.639 11.1015 17 11.4985 17H12.5015C12.899 17 13.3995 16.639 13.525 16.263L13.5775 16.1045C13.9755 14.9115 15.2405 14 16.4985 14H20ZM8.5 8.5C8.23478 8.5 7.98043 8.39464 7.79289 8.20711C7.60536 8.01957 7.5 7.76522 7.5 7.5C7.5 7.23478 7.60536 6.98043 7.79289 6.79289C7.98043 6.60536 8.23478 6.5 8.5 6.5H15.5C15.7652 6.5 16.0196 6.60536 16.2071 6.79289C16.3946 6.98043 16.5 7.23478 16.5 7.5C16.5 7.76522 16.3946 8.01957 16.2071 8.20711C16.0196 8.39464 15.7652 8.5 15.5 8.5H8.5ZM8.5 11.5C8.23478 11.5 7.98043 11.3946 7.79289 11.2071C7.60536 11.0196 7.5 10.7652 7.5 10.5C7.5 10.2348 7.60536 9.98043 7.79289 9.79289C7.98043 9.60536 8.23478 9.5 8.5 9.5H15.5C15.7652 9.5 16.0196 9.60536 16.2071 9.79289C16.3946 9.98043 16.5 10.2348 16.5 10.5C16.5 10.7652 16.3946 11.0196 16.2071 11.2071C16.0196 11.3946 15.7652 11.5 15.5 11.5H8.5Z\" fill=\"#079CB2\"></path></svg>";

/***/ }),

/***/ "ffb7":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M3 2C1.897 2 1 2.99556 1 4.22222V19.7778C1 21.0033 1.897 22 3 22H21C22.103 22 23 21.0033 23 19.7778V4.22222C23 2.99556 22.103 2 21 2H3Z\" fill=\"#079CB2\"></path><rect x=\"3\" y=\"6\" width=\"18\" height=\"14\" fill=\"#D5EAFD\"></rect><rect width=\"9\" height=\"14\" transform=\"matrix(-1 0 0 1 12 6)\" fill=\"white\"></rect><path d=\"M13.7262 13.0758L16.3421 15.7438C18.8103 18.2592 20.3477 20.5127 19.9325 20.9318C19.5157 21.3509 17.2789 19.802 14.7821 17.3162C14.0686 16.6067 13.3948 15.936 12.7955 15.3395C12.5611 15.1061 12.3381 14.8841 12.1285 14.6755C11.9808 14.5282 12.02 14.3498 12.2024 14.2496C12.6658 13.9937 13.0479 13.6118 13.3019 13.1494C13.4022 12.9657 13.58 12.927 13.7262 13.0758Z\" fill=\"#079CB2\"></path><path d=\"M11.2631 10.1998C11.9926 10.3737 12.5209 11.0722 12.5209 11.8231C12.5209 12.7084 11.7703 13.4661 10.8441 13.4661C9.28854 13.4661 8.2372 10.7836 8.01488 9.41775C7.94328 8.98043 8.13395 8.8802 8.50399 9.1467C9.27218 9.69813 10.2663 9.94836 11.0189 10.1378C11.1036 10.1591 11.1852 10.1797 11.2631 10.1998Z\" fill=\"#079CB2\"></path></svg>";

/***/ }),

/***/ "ffc4":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, "@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Thin.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:100;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-ThinItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:200;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-LightItalic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:400;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Italic.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:normal;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:AkkuratLL;font-style:italic;font-weight:700;src:url(https://ui-cdn.patientpop.com/assets/fonts/akkurat-ll/AkkuratLL-BoldItalic.woff2) format(\"woff2\")}.theme--light.v-data-table{background-color:var(--cards-color,#fff);color:var(--pp-text-primary,#2b2b2b)}.theme--light.v-data-table .v-data-table__divider{border-right:thin solid #d6d6d6}.theme--light.v-data-table.v-data-table--fixed-header thead th{background:var(--cards-color,#fff);box-shadow:inset 0 -1px 0 #d6d6d6}.theme--light.v-data-table>.v-data-table__wrapper>table>thead>tr>th{color:var(--pp-text-secondary,#2b2b2b)}.theme--light.v-data-table>.v-data-table__wrapper>table>tbody>tr:not(:last-child)>td:last-child,.theme--light.v-data-table>.v-data-table__wrapper>table>tbody>tr:not(:last-child)>td:not(.v-data-table__mobile-row),.theme--light.v-data-table>.v-data-table__wrapper>table>tbody>tr:not(:last-child)>th:last-child,.theme--light.v-data-table>.v-data-table__wrapper>table>tbody>tr:not(:last-child)>th:not(.v-data-table__mobile-row),.theme--light.v-data-table>.v-data-table__wrapper>table>thead>tr:last-child>th{border-bottom:thin solid #d6d6d6}.theme--light.v-data-table>.v-data-table__wrapper>table>tbody>tr.active{background:#f6f6f6}.theme--light.v-data-table>.v-data-table__wrapper>table>tbody>tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper){background:#e6f5f7}.theme--dark.v-data-table{background-color:#1e1e1e;color:var(--pp-primary-button-text-color,#004852)}.theme--dark.v-data-table .v-data-table__divider{border-right:thin solid hsla(0,0%,100%,.12)}.theme--dark.v-data-table.v-data-table--fixed-header thead th{background:#1e1e1e;box-shadow:inset 0 -1px 0 hsla(0,0%,100%,.12)}.theme--dark.v-data-table>.v-data-table__wrapper>table>thead>tr>th{color:hsla(0,0%,100%,.7)}.theme--dark.v-data-table>.v-data-table__wrapper>table>tbody>tr:not(:last-child)>td:last-child,.theme--dark.v-data-table>.v-data-table__wrapper>table>tbody>tr:not(:last-child)>td:not(.v-data-table__mobile-row),.theme--dark.v-data-table>.v-data-table__wrapper>table>tbody>tr:not(:last-child)>th:last-child,.theme--dark.v-data-table>.v-data-table__wrapper>table>tbody>tr:not(:last-child)>th:not(.v-data-table__mobile-row),.theme--dark.v-data-table>.v-data-table__wrapper>table>thead>tr:last-child>th{border-bottom:thin solid hsla(0,0%,100%,.12)}.theme--dark.v-data-table>.v-data-table__wrapper>table>tbody>tr.active{background:#505050}.theme--dark.v-data-table>.v-data-table__wrapper>table>tbody>tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper){background:#545454}.v-data-table{line-height:1.5;max-width:100%}.v-data-table>.v-data-table__wrapper>table{width:100%;border-spacing:0}.v-data-table>.v-data-table__wrapper>table>tbody>tr>td,.v-data-table>.v-data-table__wrapper>table>tbody>tr>th,.v-data-table>.v-data-table__wrapper>table>tfoot>tr>td,.v-data-table>.v-data-table__wrapper>table>tfoot>tr>th,.v-data-table>.v-data-table__wrapper>table>thead>tr>td,.v-data-table>.v-data-table__wrapper>table>thead>tr>th{padding:0 16px;transition:height .2s cubic-bezier(.4,0,.6,1)}.v-data-table>.v-data-table__wrapper>table>tbody>tr>th,.v-data-table>.v-data-table__wrapper>table>tfoot>tr>th,.v-data-table>.v-data-table__wrapper>table>thead>tr>th{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;font-size:.857rem;height:32px}.v-application--is-ltr .v-data-table>.v-data-table__wrapper>table>tbody>tr>th,.v-application--is-ltr .v-data-table>.v-data-table__wrapper>table>tfoot>tr>th,.v-application--is-ltr .v-data-table>.v-data-table__wrapper>table>thead>tr>th{text-align:left}.v-application--is-rtl .v-data-table>.v-data-table__wrapper>table>tbody>tr>th,.v-application--is-rtl .v-data-table>.v-data-table__wrapper>table>tfoot>tr>th,.v-application--is-rtl .v-data-table>.v-data-table__wrapper>table>thead>tr>th{text-align:right}.v-data-table>.v-data-table__wrapper>table>tbody>tr>td,.v-data-table>.v-data-table__wrapper>table>tfoot>tr>td,.v-data-table>.v-data-table__wrapper>table>thead>tr>td{font-size:1rem;height:48px}.v-data-table__wrapper{overflow-x:auto;overflow-y:hidden}.v-data-table__progress{height:auto!important}.v-data-table__progress th{height:auto!important;border:none!important;padding:0;position:relative}.v-data-table--dense>.v-data-table__wrapper>table>tbody>tr>td,.v-data-table--dense>.v-data-table__wrapper>table>tbody>tr>th,.v-data-table--dense>.v-data-table__wrapper>table>tfoot>tr>td,.v-data-table--dense>.v-data-table__wrapper>table>tfoot>tr>th,.v-data-table--dense>.v-data-table__wrapper>table>thead>tr>td,.v-data-table--dense>.v-data-table__wrapper>table>thead>tr>th{height:32px}.v-data-table--has-top>.v-data-table__wrapper>table>tbody>tr:first-child:hover>td:first-child{border-top-left-radius:0}.v-data-table--has-top>.v-data-table__wrapper>table>tbody>tr:first-child:hover>td:last-child{border-top-right-radius:0}.v-data-table--has-bottom>.v-data-table__wrapper>table>tbody>tr:last-child:hover>td:first-child{border-bottom-left-radius:0}.v-data-table--has-bottom>.v-data-table__wrapper>table>tbody>tr:last-child:hover>td:last-child{border-bottom-right-radius:0}.v-data-table--fixed-header>.v-data-table__wrapper,.v-data-table--fixed-height .v-data-table__wrapper{overflow-y:auto}.v-data-table--fixed-header>.v-data-table__wrapper>table>thead>tr>th{border-bottom:0!important;position:sticky;top:0;z-index:2}.v-data-table--fixed-header>.v-data-table__wrapper>table>thead>tr:nth-child(2)>th{top:32px}.v-application--is-ltr .v-data-table--fixed-header .v-data-footer{margin-right:17px}.v-application--is-rtl .v-data-table--fixed-header .v-data-footer{margin-left:17px}.v-data-table--fixed-header.v-data-table--dense>.v-data-table__wrapper>table>thead>tr:nth-child(2)>th{top:32px}", ""]);
// Exports
module.exports = exports;


/***/ })

/******/ });
//# sourceMappingURL=pp-vue-library.common.js.map